(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 20579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ sprinkles; }
/* harmony export */ });
/* unused harmony export lisaResponsiveProperties */
/* harmony import */ var src_design_lib_style_theme_sprinkles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_design_lib_style_theme_sprinkles_css_ts_vanilla_css_source_H4sIAAAAAAAAA6WZ227jSBJE3_srCCwW8ADtBlm8e19GN37EviwoibrYkihTlCV7MP_sKXqVkVGimxMdz_MoE4WmRUhkcr48b9gGp_2xve9v7553sfjejevzk_e8f_z7e9vP_xqCKuBs5rAqnFWc1gNndUZrEbO6gJWY2d1DauJs7qB1dRZrWE1c1abr9W2KXeHRd1sn7xdvasc4ojE139uyrb674P_h4OeEW3qtmyrhyDz59XSZQNfgXPChuo9hPMH_7v_HW4kuAjV1KfHZbl_8vz92V3P3fUoQ2DmAkmEwMIFMnGJtQvkCQIbFyiPbe0CtQsYcQ_NCwTiEkfYQdzkGbqAdePDFQwCoQuEAgAlsAcDSoj6ixCzenPc7riYZiEQoadZC0ZIajaCEaqaWjBCWNMIRmhrjoIR8pqzYITCoS_3wXsOQ9kXIom8FCoR5oIRaodSLewqlGqJXS5iTevz42FVzuvTk_d7yf78dUSe7zXLaflg8u_f_9Lv_o_Q_fCHG1Ju9ufPrntU16T687qfZ9_jvCHlwf7s9bv1W1scnjz3_RKe3VX3_RL51ys386p5nNWbunny_lUURTzJXTDk4DgZuE_dKOHgMEvcG4tyDuZ5ULjgjIGTJBsEIxdccHAymgxdcM3AfDgMhu6DPdowMA7SNHWfxFHNQD8JxyGcY0PBOAzMxAWPtJm8yAv3QR6dGTjIJsl44IAx1TpJxtHQPfCYam3iUTBw3RNTrYNJPshcrWOq9Tgp4gIuTbUukiIp3JeqmGpdfP1xQap1EX_dUGq9ST7_OuCVOtxNI7GcDxU62E4DIdwPFTrNEzDFECqdWxiE8M7J9U6GAfjwP0oJFTrwARZ4Pox4Z9rv8gnAFKtB9E4z10_JlTrLB6NU_czk1Ctk3Tkx_5ba0K1jseDcQT3yD_XJh9E7ocroVoXRZFP3O_ehGpdFOM8g0tTrYtiNE6ga6p1UYz8yLVZSrWeJINx6N5jSrUejfJB6Hadcq3HkwlonfLv8DAfgNYp_w4v0hy0Tvl3_DBOQeuUaj2OoglonVKth6MoAa1TTWv8SkkdrZtyvj4e5DtLemQUvkSlZ0aJV7bMZ5h4_8tChrnPtMwRt633j816uWrVPrL8Po8dZbP7vOxtcb9Adrm_XwD9OvpP67att10t150louums0Q2fuyskb2fO2vc9nMfD2tTLfTW8_Aujm3nwkwOLlrOhZkcXrSbCzM5PLS6IGdzv9t1V4VomLmpo2fmpo62mZvudX5x0rY8P66qTzM8eYHv_9tlLs7Zrne3zNvKgUr_J3Raz9vVk7ferdt1uXGpECn3dsoE12O4mTJHQtxveZG_3pezdfsuLrFwV93Xn_Ki62JTff6iata7F1G_kQTsUUvCfRsrLyodD1XzeKg21awlk7DyKCHxy768aLNYbzZki6l_szo7Nk21a78eTy51EWVR79rH0y_BXSaRjEEml0yIzEwyETILycTIrCWTILORTIpMLZkMmYta9VvVLDb16fH9lw5_bqv5uvQOs6aqdl65m3sPN85Mk2x_uOr_NcM7Ot_YSLseX_fMpFgAsGkgjGCKQUTCmYumEgwS8HEgnkWTCKYrWBSwewFkwnmcGXEHBm4N8nBNBkK3mUBzpShIgjUklypiO7c1c18Gcus4O6UGakSqctsErE5YpfxJGJLxDJ60WfELkNKxLaIXT5FiO0RM_TeDogF9KJvYjfawrvolFAmENc0DIsQCykmFGV9GqEo3csKKibXCC4JSD1inglJbWK2hKROMXtCUrOYAyGpX8wbIallzDshqWvCgO3JOgoj1jsDU3ZxpmVYEpI6KGSqs85Dpjrd0Yr_W9Nw3GRLN7k_E8c99nSPjsk4bnKgm9yfj_Merr0uU3Jk3pGRz9ko_HkvdGKOeKThl7k54qmGX6bniJcafpmhIz7nuJ2kI77U8Ms8HfFnjtupOuJbjtvZOuJ7jtsJO_IHBb_O2RF_U1q9TtsRf_e4nbkDHiuesZN3xBXP2Pk74opn7BQeccUzdhaPuOIZO5FHXPGMHaIhrnjGTucRVzxjZ_SIK56xk3rEFc_YeT3iimfs1B5xxTN2dg94onjGTvARVzxj5_iIa98z12k_4opn7EwfccUzdrKPuOIZO99HXPGMnfIjrn3PXGf9iCuesRN_xBXP2Lk_4opn7PQfccUzNgPA35KKZ2wSgLjiGZsHIK555poKIK49m67ZAOLas_maECCuPZuuOQHiimdsWoC44hmbGSCue4Z96aXgGWc2iewbZ9mrafrOWfpqnAUcpm_cWcRh_VTPwCRKuoBVZVcV6zebd1XxzpddZfwMnrvKyGmAj_TsAQv3PQrpmRx6FPJjeetRyU_mvUelPJw8kAcqZ_VYFHUUsUPJiSnJxB6riCnJ0B6riClxbo8lS3p_3Wfx3F1Hj4O7sseJcFf2OBTuyq5zsY6UqQaS1oEk28BZanCDYsKBbCRZeZtlKqmY3GRZSo52U1oL3SYfyCyRka_QpfUHpiDIbRlH9tszjoyrrdokF0H0jaF0PlRajW8zEmCmgcO4SQmyVlyZlyCZMtIwsmRkyMg5IyNGLhkZM_KZkQkjt4xMGblnZMZIq7rMVz7Jrowl8D_OSBkMdct74UssWCkczPBSNdOBSNfsCvByEHFSjDyd_yLYORL5U4w8rX2VTDyR3B7ZbpClpPk7ocsH7KgK2QxaokWssR37upOyGIFvx_yTJHiIUuFGA9ZVojxkOUFMR6y7BDjIcsrYjxkaRHjIctJ7EZb_BCdsim9EdekiUeMGA9ZhKI0GRCK0r2soJ0hy4qAPGR5ISQPWXaE5CHLKyF5yNISkocsJ0LykOWDkDxkMWxPGrLErHcGZuziNOiYEpKHLEx1GrIw1emOVvR_FLLs6Ca_F7K80j1_M2Rp6Sa_F7K49uIhywcyJGQxP_lV8gSazgPWTIN5yHLVMN5yFJxXAtZVhrOQ5YXjmshy47jWsjyynEtZGkVXAlZTkqrSsjywXEtZFE8o4Usime0kEXxjBayKJ7RQhbFM1rIonhGC1kUz2ghi_IZLWRRPKOFLIpntJBF8YwWsiie0UIWxTNayKJ4RgtZtO8ZJWRRPKOFLIpntJBF8YwWsiie0UIW7XtGCVkUz2ghi_IZLWRRPKOFLIpntJBF8YwWsiie0UIWzTNKyKI9m5SQRXs2KSGL9mxSQhbFM1rIonhGC1l0z9CQBTxzN2Q5cZaGLB_c5TN1w2E_Ro85TGIFMEnPkGXaVUUDhaqrine_6irjZ_DSVUZOA3zUP2R57VFIz6TtUciP5dSjkp_MR49KMkM38kC7g4W4o4imCsSUPSIFYsoeeQIxZVeYsKLn130WL9119Di4K3ucCHdlj0Phruw6F_vI7pDFOrBHyGJu0K6QJZYsySgySdGQZSo5HrJYC90LWVbIkFDE_qMrZNkxjuz3yjgSsli1e4QsJ4bykMVqfC9kMQ5zP2Sx4naHLBkjacgyZSQNWSpG0pBlxUgasrwwkoYsO0bSkOWVkTRksaorIcv_Adh7hk_vSAAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1851);
/* harmony import */ var src_design_lib_style_theme_sprinkles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_design_lib_style_theme_sprinkles_css_ts_vanilla_css_source_H4sIAAAAAAAAA6WZ227jSBJE3_srCCwW8ADtBlm8e19GN37EviwoibrYkihTlCV7MP_sKXqVkVGimxMdz_MoE4WmRUhkcr48b9gGp_2xve9v7553sfjejevzk_e8f_z7e9vP_xqCKuBs5rAqnFWc1gNndUZrEbO6gJWY2d1DauJs7qB1dRZrWE1c1abr9W2KXeHRd1sn7xdvasc4ojE139uyrb674P_h4OeEW3qtmyrhyDz59XSZQNfgXPChuo9hPMH_7v_HW4kuAjV1KfHZbl_8vz92V3P3fUoQ2DmAkmEwMIFMnGJtQvkCQIbFyiPbe0CtQsYcQ_NCwTiEkfYQdzkGbqAdePDFQwCoQuEAgAlsAcDSoj6ixCzenPc7riYZiEQoadZC0ZIajaCEaqaWjBCWNMIRmhrjoIR8pqzYITCoS_3wXsOQ9kXIom8FCoR5oIRaodSLewqlGqJXS5iTevz42FVzuvTk_d7yf78dUSe7zXLaflg8u_f_9Lv_o_Q_fCHG1Ju9ufPrntU16T687qfZ9_jvCHlwf7s9bv1W1scnjz3_RKe3VX3_RL51ys386p5nNWbunny_lUURTzJXTDk4DgZuE_dKOHgMEvcG4tyDuZ5ULjgjIGTJBsEIxdccHAymgxdcM3AfDgMhu6DPdowMA7SNHWfxFHNQD8JxyGcY0PBOAzMxAWPtJm8yAv3QR6dGTjIJsl44IAx1TpJxtHQPfCYam3iUTBw3RNTrYNJPshcrWOq9Tgp4gIuTbUukiIp3JeqmGpdfP1xQap1EX_dUGq9ST7_OuCVOtxNI7GcDxU62E4DIdwPFTrNEzDFECqdWxiE8M7J9U6GAfjwP0oJFTrwARZ4Pox4Z9rv8gnAFKtB9E4z10_JlTrLB6NU_czk1Ctk3Tkx_5ba0K1jseDcQT3yD_XJh9E7ocroVoXRZFP3O_ehGpdFOM8g0tTrYtiNE6ga6p1UYz8yLVZSrWeJINx6N5jSrUejfJB6Hadcq3HkwlonfLv8DAfgNYp_w4v0hy0Tvl3_DBOQeuUaj2OoglonVKth6MoAa1TTWv8SkkdrZtyvj4e5DtLemQUvkSlZ0aJV7bMZ5h4_8tChrnPtMwRt633j816uWrVPrL8Po8dZbP7vOxtcb9Adrm_XwD9OvpP67att10t150louums0Q2fuyskb2fO2vc9nMfD2tTLfTW8_Aujm3nwkwOLlrOhZkcXrSbCzM5PLS6IGdzv9t1V4VomLmpo2fmpo62mZvudX5x0rY8P66qTzM8eYHv_9tlLs7Zrne3zNvKgUr_J3Raz9vVk7ferdt1uXGpECn3dsoE12O4mTJHQtxveZG_3pezdfsuLrFwV93Xn_Ki62JTff6iata7F1G_kQTsUUvCfRsrLyodD1XzeKg21awlk7DyKCHxy768aLNYbzZki6l_szo7Nk21a78eTy51EWVR79rH0y_BXSaRjEEml0yIzEwyETILycTIrCWTILORTIpMLZkMmYta9VvVLDb16fH9lw5_bqv5uvQOs6aqdl65m3sPN85Mk2x_uOr_NcM7Ot_YSLseX_fMpFgAsGkgjGCKQUTCmYumEgwS8HEgnkWTCKYrWBSwewFkwnmcGXEHBm4N8nBNBkK3mUBzpShIgjUklypiO7c1c18Gcus4O6UGakSqctsErE5YpfxJGJLxDJ60WfELkNKxLaIXT5FiO0RM_TeDogF9KJvYjfawrvolFAmENc0DIsQCykmFGV9GqEo3csKKibXCC4JSD1inglJbWK2hKROMXtCUrOYAyGpX8wbIallzDshqWvCgO3JOgoj1jsDU3ZxpmVYEpI6KGSqs85Dpjrd0Yr_W9Nw3GRLN7k_E8c99nSPjsk4bnKgm9yfj_Merr0uU3Jk3pGRz9ko_HkvdGKOeKThl7k54qmGX6bniJcafpmhIz7nuJ2kI77U8Ms8HfFnjtupOuJbjtvZOuJ7jtsJO_IHBb_O2RF_U1q9TtsRf_e4nbkDHiuesZN3xBXP2Pk74opn7BQeccUzdhaPuOIZO5FHXPGMHaIhrnjGTucRVzxjZ_SIK56xk3rEFc_YeT3iimfs1B5xxTN2dg94onjGTvARVzxj5_iIa98z12k_4opn7EwfccUzdrKPuOIZO99HXPGMnfIjrn3PXGf9iCuesRN_xBXP2Lk_4opn7PQfccUzNgPA35KKZ2wSgLjiGZsHIK555poKIK49m67ZAOLas_maECCuPZuuOQHiimdsWoC44hmbGSCue4Z96aXgGWc2iewbZ9mrafrOWfpqnAUcpm_cWcRh_VTPwCRKuoBVZVcV6zebd1XxzpddZfwMnrvKyGmAj_TsAQv3PQrpmRx6FPJjeetRyU_mvUelPJw8kAcqZ_VYFHUUsUPJiSnJxB6riCnJ0B6riClxbo8lS3p_3Wfx3F1Hj4O7sseJcFf2OBTuyq5zsY6UqQaS1oEk28BZanCDYsKBbCRZeZtlKqmY3GRZSo52U1oL3SYfyCyRka_QpfUHpiDIbRlH9tszjoyrrdokF0H0jaF0PlRajW8zEmCmgcO4SQmyVlyZlyCZMtIwsmRkyMg5IyNGLhkZM_KZkQkjt4xMGblnZMZIq7rMVz7Jrowl8D_OSBkMdct74UssWCkczPBSNdOBSNfsCvByEHFSjDyd_yLYORL5U4w8rX2VTDyR3B7ZbpClpPk7ocsH7KgK2QxaokWssR37upOyGIFvx_yTJHiIUuFGA9ZVojxkOUFMR6y7BDjIcsrYjxkaRHjIctJ7EZb_BCdsim9EdekiUeMGA9ZhKI0GRCK0r2soJ0hy4qAPGR5ISQPWXaE5CHLKyF5yNISkocsJ0LykOWDkDxkMWxPGrLErHcGZuziNOiYEpKHLEx1GrIw1emOVvR_FLLs6Ca_F7K80j1_M2Rp6Sa_F7K49uIhywcyJGQxP_lV8gSazgPWTIN5yHLVMN5yFJxXAtZVhrOQ5YXjmshy47jWsjyynEtZGkVXAlZTkqrSsjywXEtZFE8o4Usime0kEXxjBayKJ7RQhbFM1rIonhGC1kUz2ghi_IZLWRRPKOFLIpntJBF8YwWsiie0UIWxTNayKJ4RgtZtO8ZJWRRPKOFLIpntJBF8YwWsiie0UIW7XtGCVkUz2ghi_IZLWRRPKOFLIpntJBF8YwWsiie0UIWzTNKyKI9m5SQRXs2KSGL9mxSQhbFM1rIonhGC1l0z9CQBTxzN2Q5cZaGLB_c5TN1w2E_Ro85TGIFMEnPkGXaVUUDhaqrine_6irjZ_DSVUZOA3zUP2R57VFIz6TtUciP5dSjkp_MR49KMkM38kC7g4W4o4imCsSUPSIFYsoeeQIxZVeYsKLn130WL9119Di4K3ucCHdlj0Phruw6F_vI7pDFOrBHyGJu0K6QJZYsySgySdGQZSo5HrJYC90LWVbIkFDE_qMrZNkxjuz3yjgSsli1e4QsJ4bykMVqfC9kMQ5zP2Sx4naHLBkjacgyZSQNWSpG0pBlxUgasrwwkoYsO0bSkOWVkTRksaorIcv_Adh7hk_vSAAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(src_design_lib_style_theme_sprinkles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_design_lib_style_theme_sprinkles_css_ts_vanilla_css_source_H4sIAAAAAAAAA6WZ227jSBJE3_srCCwW8ADtBlm8e19GN37EviwoibrYkihTlCV7MP_sKXqVkVGimxMdz_MoE4WmRUhkcr48b9gGp_2xve9v7553sfjejevzk_e8f_z7e9vP_xqCKuBs5rAqnFWc1gNndUZrEbO6gJWY2d1DauJs7qB1dRZrWE1c1abr9W2KXeHRd1sn7xdvasc4ojE139uyrb674P_h4OeEW3qtmyrhyDz59XSZQNfgXPChuo9hPMH_7v_HW4kuAjV1KfHZbl_8vz92V3P3fUoQ2DmAkmEwMIFMnGJtQvkCQIbFyiPbe0CtQsYcQ_NCwTiEkfYQdzkGbqAdePDFQwCoQuEAgAlsAcDSoj6ixCzenPc7riYZiEQoadZC0ZIajaCEaqaWjBCWNMIRmhrjoIR8pqzYITCoS_3wXsOQ9kXIom8FCoR5oIRaodSLewqlGqJXS5iTevz42FVzuvTk_d7yf78dUSe7zXLaflg8u_f_9Lv_o_Q_fCHG1Ju9ufPrntU16T687qfZ9_jvCHlwf7s9bv1W1scnjz3_RKe3VX3_RL51ys386p5nNWbunny_lUURTzJXTDk4DgZuE_dKOHgMEvcG4tyDuZ5ULjgjIGTJBsEIxdccHAymgxdcM3AfDgMhu6DPdowMA7SNHWfxFHNQD8JxyGcY0PBOAzMxAWPtJm8yAv3QR6dGTjIJsl44IAx1TpJxtHQPfCYam3iUTBw3RNTrYNJPshcrWOq9Tgp4gIuTbUukiIp3JeqmGpdfP1xQap1EX_dUGq9ST7_OuCVOtxNI7GcDxU62E4DIdwPFTrNEzDFECqdWxiE8M7J9U6GAfjwP0oJFTrwARZ4Pox4Z9rv8gnAFKtB9E4z10_JlTrLB6NU_czk1Ctk3Tkx_5ba0K1jseDcQT3yD_XJh9E7ocroVoXRZFP3O_ehGpdFOM8g0tTrYtiNE6ga6p1UYz8yLVZSrWeJINx6N5jSrUejfJB6Hadcq3HkwlonfLv8DAfgNYp_w4v0hy0Tvl3_DBOQeuUaj2OoglonVKth6MoAa1TTWv8SkkdrZtyvj4e5DtLemQUvkSlZ0aJV7bMZ5h4_8tChrnPtMwRt633j816uWrVPrL8Po8dZbP7vOxtcb9Adrm_XwD9OvpP67att10t150louums0Q2fuyskb2fO2vc9nMfD2tTLfTW8_Aujm3nwkwOLlrOhZkcXrSbCzM5PLS6IGdzv9t1V4VomLmpo2fmpo62mZvudX5x0rY8P66qTzM8eYHv_9tlLs7Zrne3zNvKgUr_J3Raz9vVk7ferdt1uXGpECn3dsoE12O4mTJHQtxveZG_3pezdfsuLrFwV93Xn_Ki62JTff6iata7F1G_kQTsUUvCfRsrLyodD1XzeKg21awlk7DyKCHxy768aLNYbzZki6l_szo7Nk21a78eTy51EWVR79rH0y_BXSaRjEEml0yIzEwyETILycTIrCWTILORTIpMLZkMmYta9VvVLDb16fH9lw5_bqv5uvQOs6aqdl65m3sPN85Mk2x_uOr_NcM7Ot_YSLseX_fMpFgAsGkgjGCKQUTCmYumEgwS8HEgnkWTCKYrWBSwewFkwnmcGXEHBm4N8nBNBkK3mUBzpShIgjUklypiO7c1c18Gcus4O6UGakSqctsErE5YpfxJGJLxDJ60WfELkNKxLaIXT5FiO0RM_TeDogF9KJvYjfawrvolFAmENc0DIsQCykmFGV9GqEo3csKKibXCC4JSD1inglJbWK2hKROMXtCUrOYAyGpX8wbIallzDshqWvCgO3JOgoj1jsDU3ZxpmVYEpI6KGSqs85Dpjrd0Yr_W9Nw3GRLN7k_E8c99nSPjsk4bnKgm9yfj_Merr0uU3Jk3pGRz9ko_HkvdGKOeKThl7k54qmGX6bniJcafpmhIz7nuJ2kI77U8Ms8HfFnjtupOuJbjtvZOuJ7jtsJO_IHBb_O2RF_U1q9TtsRf_e4nbkDHiuesZN3xBXP2Pk74opn7BQeccUzdhaPuOIZO5FHXPGMHaIhrnjGTucRVzxjZ_SIK56xk3rEFc_YeT3iimfs1B5xxTN2dg94onjGTvARVzxj5_iIa98z12k_4opn7EwfccUzdrKPuOIZO99HXPGMnfIjrn3PXGf9iCuesRN_xBXP2Lk_4opn7PQfccUzNgPA35KKZ2wSgLjiGZsHIK555poKIK49m67ZAOLas_maECCuPZuuOQHiimdsWoC44hmbGSCue4Z96aXgGWc2iewbZ9mrafrOWfpqnAUcpm_cWcRh_VTPwCRKuoBVZVcV6zebd1XxzpddZfwMnrvKyGmAj_TsAQv3PQrpmRx6FPJjeetRyU_mvUelPJw8kAcqZ_VYFHUUsUPJiSnJxB6riCnJ0B6riClxbo8lS3p_3Wfx3F1Hj4O7sseJcFf2OBTuyq5zsY6UqQaS1oEk28BZanCDYsKBbCRZeZtlKqmY3GRZSo52U1oL3SYfyCyRka_QpfUHpiDIbRlH9tszjoyrrdokF0H0jaF0PlRajW8zEmCmgcO4SQmyVlyZlyCZMtIwsmRkyMg5IyNGLhkZM_KZkQkjt4xMGblnZMZIq7rMVz7Jrowl8D_OSBkMdct74UssWCkczPBSNdOBSNfsCvByEHFSjDyd_yLYORL5U4w8rX2VTDyR3B7ZbpClpPk7ocsH7KgK2QxaokWssR37upOyGIFvx_yTJHiIUuFGA9ZVojxkOUFMR6y7BDjIcsrYjxkaRHjIctJ7EZb_BCdsim9EdekiUeMGA9ZhKI0GRCK0r2soJ0hy4qAPGR5ISQPWXaE5CHLKyF5yNISkocsJ0LykOWDkDxkMWxPGrLErHcGZuziNOiYEpKHLEx1GrIw1emOVvR_FLLs6Ca_F7K80j1_M2Rp6Sa_F7K49uIhywcyJGQxP_lV8gSazgPWTIN5yHLVMN5yFJxXAtZVhrOQ5YXjmshy47jWsjyynEtZGkVXAlZTkqrSsjywXEtZFE8o4Usime0kEXxjBayKJ7RQhbFM1rIonhGC1kUz2ghi_IZLWRRPKOFLIpntJBF8YwWsiie0UIWxTNayKJ4RgtZtO8ZJWRRPKOFLIpntJBF8YwWsiie0UIW7XtGCVkUz2ghi_IZLWRRPKOFLIpntJBF8YwWsiie0UIWzTNKyKI9m5SQRXs2KSGL9mxSQhbFM1rIonhGC1l0z9CQBTxzN2Q5cZaGLB_c5TN1w2E_Ro85TGIFMEnPkGXaVUUDhaqrine_6irjZ_DSVUZOA3zUP2R57VFIz6TtUciP5dSjkp_MR49KMkM38kC7g4W4o4imCsSUPSIFYsoeeQIxZVeYsKLn130WL9119Di4K3ucCHdlj0Phruw6F_vI7pDFOrBHyGJu0K6QJZYsySgySdGQZSo5HrJYC90LWVbIkFDE_qMrZNkxjuz3yjgSsli1e4QsJ4bykMVqfC9kMQ5zP2Sx4naHLBkjacgyZSQNWSpG0pBlxUgasrwwkoYsO0bSkOWVkTRksaorIcv_Adh7hk_vSAAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vanilla_extract_sprinkles_createRuntimeSprinkles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27861);


var lisaResponsiveProperties = {conditions:{defaultCondition:'mobile',conditionNames:['mobile','tablet','desktop'],responsiveArray:undefined},styles:{zIndex:{values:{'20':{conditions:{mobile:'_1b5wm200',tablet:'_1b5wm201',desktop:'_1b5wm202'},defaultClass:'_1b5wm200'},'21':{conditions:{mobile:'_1b5wm203',tablet:'_1b5wm204',desktop:'_1b5wm205'},defaultClass:'_1b5wm203'},'22':{conditions:{mobile:'_1b5wm206',tablet:'_1b5wm207',desktop:'_1b5wm208'},defaultClass:'_1b5wm206'},'23':{conditions:{mobile:'_1b5wm209',tablet:'_1b5wm20a',desktop:'_1b5wm20b'},defaultClass:'_1b5wm209'},'24':{conditions:{mobile:'_1b5wm20c',tablet:'_1b5wm20d',desktop:'_1b5wm20e'},defaultClass:'_1b5wm20c'},'25':{conditions:{mobile:'_1b5wm20f',tablet:'_1b5wm20g',desktop:'_1b5wm20h'},defaultClass:'_1b5wm20f'},'26':{conditions:{mobile:'_1b5wm20i',tablet:'_1b5wm20j',desktop:'_1b5wm20k'},defaultClass:'_1b5wm20i'},'27':{conditions:{mobile:'_1b5wm20l',tablet:'_1b5wm20m',desktop:'_1b5wm20n'},defaultClass:'_1b5wm20l'},'28':{conditions:{mobile:'_1b5wm20o',tablet:'_1b5wm20p',desktop:'_1b5wm20q'},defaultClass:'_1b5wm20o'}}},transform:{values:{none:{conditions:{mobile:'_1b5wm20r',tablet:'_1b5wm20s',desktop:'_1b5wm20t'},defaultClass:'_1b5wm20r'},'translateZ(0)':{conditions:{mobile:'_1b5wm20u',tablet:'_1b5wm20v',desktop:'_1b5wm20w'},defaultClass:'_1b5wm20u'},'rotate(180deg)':{conditions:{mobile:'_1b5wm20x',tablet:'_1b5wm20y',desktop:'_1b5wm20z'},defaultClass:'_1b5wm20x'},'rotate(90deg)':{conditions:{mobile:'_1b5wm2010',tablet:'_1b5wm2011',desktop:'_1b5wm2012'},defaultClass:'_1b5wm2010'},'translate3d(0,0,0)':{conditions:{mobile:'_1b5wm2013',tablet:'_1b5wm2014',desktop:'_1b5wm2015'},defaultClass:'_1b5wm2013'}}},rowGap:{values:{'0':{conditions:{mobile:'_1b5wm2016',tablet:'_1b5wm2017',desktop:'_1b5wm2018'},defaultClass:'_1b5wm2016'},'2xl':{conditions:{mobile:'_1b5wm2019',tablet:'_1b5wm201a',desktop:'_1b5wm201b'},defaultClass:'_1b5wm2019'},'3xl':{conditions:{mobile:'_1b5wm201c',tablet:'_1b5wm201d',desktop:'_1b5wm201e'},defaultClass:'_1b5wm201c'},'4xl':{conditions:{mobile:'_1b5wm201f',tablet:'_1b5wm201g',desktop:'_1b5wm201h'},defaultClass:'_1b5wm201f'},'5xl':{conditions:{mobile:'_1b5wm201i',tablet:'_1b5wm201j',desktop:'_1b5wm201k'},defaultClass:'_1b5wm201i'},auto:{conditions:{mobile:'_1b5wm201l',tablet:'_1b5wm201m',desktop:'_1b5wm201n'},defaultClass:'_1b5wm201l'},l:{conditions:{mobile:'_1b5wm201o',tablet:'_1b5wm201p',desktop:'_1b5wm201q'},defaultClass:'_1b5wm201o'},m:{conditions:{mobile:'_1b5wm201r',tablet:'_1b5wm201s',desktop:'_1b5wm201t'},defaultClass:'_1b5wm201r'},'m-l':{conditions:{mobile:'_1b5wm201u',tablet:'_1b5wm201v',desktop:'_1b5wm201w'},defaultClass:'_1b5wm201u'},s:{conditions:{mobile:'_1b5wm201x',tablet:'_1b5wm201y',desktop:'_1b5wm201z'},defaultClass:'_1b5wm201x'},'s-m':{conditions:{mobile:'_1b5wm2020',tablet:'_1b5wm2021',desktop:'_1b5wm2022'},defaultClass:'_1b5wm2020'},xl:{conditions:{mobile:'_1b5wm2023',tablet:'_1b5wm2024',desktop:'_1b5wm2025'},defaultClass:'_1b5wm2023'},xs:{conditions:{mobile:'_1b5wm2026',tablet:'_1b5wm2027',desktop:'_1b5wm2028'},defaultClass:'_1b5wm2026'},xxs:{conditions:{mobile:'_1b5wm2029',tablet:'_1b5wm202a',desktop:'_1b5wm202b'},defaultClass:'_1b5wm2029'}}},columnGap:{values:{'0':{conditions:{mobile:'_1b5wm202c',tablet:'_1b5wm202d',desktop:'_1b5wm202e'},defaultClass:'_1b5wm202c'},'2xl':{conditions:{mobile:'_1b5wm202f',tablet:'_1b5wm202g',desktop:'_1b5wm202h'},defaultClass:'_1b5wm202f'},'3xl':{conditions:{mobile:'_1b5wm202i',tablet:'_1b5wm202j',desktop:'_1b5wm202k'},defaultClass:'_1b5wm202i'},'4xl':{conditions:{mobile:'_1b5wm202l',tablet:'_1b5wm202m',desktop:'_1b5wm202n'},defaultClass:'_1b5wm202l'},'5xl':{conditions:{mobile:'_1b5wm202o',tablet:'_1b5wm202p',desktop:'_1b5wm202q'},defaultClass:'_1b5wm202o'},auto:{conditions:{mobile:'_1b5wm202r',tablet:'_1b5wm202s',desktop:'_1b5wm202t'},defaultClass:'_1b5wm202r'},l:{conditions:{mobile:'_1b5wm202u',tablet:'_1b5wm202v',desktop:'_1b5wm202w'},defaultClass:'_1b5wm202u'},m:{conditions:{mobile:'_1b5wm202x',tablet:'_1b5wm202y',desktop:'_1b5wm202z'},defaultClass:'_1b5wm202x'},'m-l':{conditions:{mobile:'_1b5wm2030',tablet:'_1b5wm2031',desktop:'_1b5wm2032'},defaultClass:'_1b5wm2030'},s:{conditions:{mobile:'_1b5wm2033',tablet:'_1b5wm2034',desktop:'_1b5wm2035'},defaultClass:'_1b5wm2033'},'s-m':{conditions:{mobile:'_1b5wm2036',tablet:'_1b5wm2037',desktop:'_1b5wm2038'},defaultClass:'_1b5wm2036'},xl:{conditions:{mobile:'_1b5wm2039',tablet:'_1b5wm203a',desktop:'_1b5wm203b'},defaultClass:'_1b5wm2039'},xs:{conditions:{mobile:'_1b5wm203c',tablet:'_1b5wm203d',desktop:'_1b5wm203e'},defaultClass:'_1b5wm203c'},xxs:{conditions:{mobile:'_1b5wm203f',tablet:'_1b5wm203g',desktop:'_1b5wm203h'},defaultClass:'_1b5wm203f'}}},boxShadow:{values:{floating:{conditions:{mobile:'_1b5wm203i',tablet:'_1b5wm203j',desktop:'_1b5wm203k'},defaultClass:'_1b5wm203i'},lifted:{conditions:{mobile:'_1b5wm203l',tablet:'_1b5wm203m',desktop:'_1b5wm203n'},defaultClass:'_1b5wm203l'},raised:{conditions:{mobile:'_1b5wm203o',tablet:'_1b5wm203p',desktop:'_1b5wm203q'},defaultClass:'_1b5wm203o'},soft:{conditions:{mobile:'_1b5wm203r',tablet:'_1b5wm203s',desktop:'_1b5wm203t'},defaultClass:'_1b5wm203r'}}},columns:{values:{'2':{conditions:{mobile:'_1b5wm203u',tablet:'_1b5wm203v',desktop:'_1b5wm203w'},defaultClass:'_1b5wm203u'},'3':{conditions:{mobile:'_1b5wm203x',tablet:'_1b5wm203y',desktop:'_1b5wm203z'},defaultClass:'_1b5wm203x'}}},borderColor:{values:{orange100:{conditions:{mobile:'_1b5wm2040',tablet:'_1b5wm2041',desktop:'_1b5wm2042'},defaultClass:'_1b5wm2040'},orange400:{conditions:{mobile:'_1b5wm2043',tablet:'_1b5wm2044',desktop:'_1b5wm2045'},defaultClass:'_1b5wm2043'},orange500:{conditions:{mobile:'_1b5wm2046',tablet:'_1b5wm2047',desktop:'_1b5wm2048'},defaultClass:'_1b5wm2046'},orange600:{conditions:{mobile:'_1b5wm2049',tablet:'_1b5wm204a',desktop:'_1b5wm204b'},defaultClass:'_1b5wm2049'},orange700:{conditions:{mobile:'_1b5wm204c',tablet:'_1b5wm204d',desktop:'_1b5wm204e'},defaultClass:'_1b5wm204c'},deepGreen100:{conditions:{mobile:'_1b5wm204f',tablet:'_1b5wm204g',desktop:'_1b5wm204h'},defaultClass:'_1b5wm204f'},deepGreen400:{conditions:{mobile:'_1b5wm204i',tablet:'_1b5wm204j',desktop:'_1b5wm204k'},defaultClass:'_1b5wm204i'},deepGreen500:{conditions:{mobile:'_1b5wm204l',tablet:'_1b5wm204m',desktop:'_1b5wm204n'},defaultClass:'_1b5wm204l'},deepGreen600:{conditions:{mobile:'_1b5wm204o',tablet:'_1b5wm204p',desktop:'_1b5wm204q'},defaultClass:'_1b5wm204o'},deepGreen700:{conditions:{mobile:'_1b5wm204r',tablet:'_1b5wm204s',desktop:'_1b5wm204t'},defaultClass:'_1b5wm204r'},green100:{conditions:{mobile:'_1b5wm204u',tablet:'_1b5wm204v',desktop:'_1b5wm204w'},defaultClass:'_1b5wm204u'},green400:{conditions:{mobile:'_1b5wm204x',tablet:'_1b5wm204y',desktop:'_1b5wm204z'},defaultClass:'_1b5wm204x'},green500:{conditions:{mobile:'_1b5wm2050',tablet:'_1b5wm2051',desktop:'_1b5wm2052'},defaultClass:'_1b5wm2050'},green600:{conditions:{mobile:'_1b5wm2053',tablet:'_1b5wm2054',desktop:'_1b5wm2055'},defaultClass:'_1b5wm2053'},green700:{conditions:{mobile:'_1b5wm2056',tablet:'_1b5wm2057',desktop:'_1b5wm2058'},defaultClass:'_1b5wm2056'},lightBlue:{conditions:{mobile:'_1b5wm2059',tablet:'_1b5wm205a',desktop:'_1b5wm205b'},defaultClass:'_1b5wm2059'},offWhite:{conditions:{mobile:'_1b5wm205c',tablet:'_1b5wm205d',desktop:'_1b5wm205e'},defaultClass:'_1b5wm205c'},greyscale0:{conditions:{mobile:'_1b5wm205f',tablet:'_1b5wm205g',desktop:'_1b5wm205h'},defaultClass:'_1b5wm205f'},greyscale50:{conditions:{mobile:'_1b5wm205i',tablet:'_1b5wm205j',desktop:'_1b5wm205k'},defaultClass:'_1b5wm205i'},greyscale100:{conditions:{mobile:'_1b5wm205l',tablet:'_1b5wm205m',desktop:'_1b5wm205n'},defaultClass:'_1b5wm205l'},greyscale200:{conditions:{mobile:'_1b5wm205o',tablet:'_1b5wm205p',desktop:'_1b5wm205q'},defaultClass:'_1b5wm205o'},greyscale300:{conditions:{mobile:'_1b5wm205r',tablet:'_1b5wm205s',desktop:'_1b5wm205t'},defaultClass:'_1b5wm205r'},greyscale400:{conditions:{mobile:'_1b5wm205u',tablet:'_1b5wm205v',desktop:'_1b5wm205w'},defaultClass:'_1b5wm205u'},greyscale500:{conditions:{mobile:'_1b5wm205x',tablet:'_1b5wm205y',desktop:'_1b5wm205z'},defaultClass:'_1b5wm205x'},greyscale600:{conditions:{mobile:'_1b5wm2060',tablet:'_1b5wm2061',desktop:'_1b5wm2062'},defaultClass:'_1b5wm2060'},greyscale900:{conditions:{mobile:'_1b5wm2063',tablet:'_1b5wm2064',desktop:'_1b5wm2065'},defaultClass:'_1b5wm2063'},success100:{conditions:{mobile:'_1b5wm2066',tablet:'_1b5wm2067',desktop:'_1b5wm2068'},defaultClass:'_1b5wm2066'},success400:{conditions:{mobile:'_1b5wm2069',tablet:'_1b5wm206a',desktop:'_1b5wm206b'},defaultClass:'_1b5wm2069'},success500:{conditions:{mobile:'_1b5wm206c',tablet:'_1b5wm206d',desktop:'_1b5wm206e'},defaultClass:'_1b5wm206c'},success600:{conditions:{mobile:'_1b5wm206f',tablet:'_1b5wm206g',desktop:'_1b5wm206h'},defaultClass:'_1b5wm206f'},success700:{conditions:{mobile:'_1b5wm206i',tablet:'_1b5wm206j',desktop:'_1b5wm206k'},defaultClass:'_1b5wm206i'},success800:{conditions:{mobile:'_1b5wm206l',tablet:'_1b5wm206m',desktop:'_1b5wm206n'},defaultClass:'_1b5wm206l'},warning100:{conditions:{mobile:'_1b5wm206o',tablet:'_1b5wm206p',desktop:'_1b5wm206q'},defaultClass:'_1b5wm206o'},warning400:{conditions:{mobile:'_1b5wm206r',tablet:'_1b5wm206s',desktop:'_1b5wm206t'},defaultClass:'_1b5wm206r'},warning500:{conditions:{mobile:'_1b5wm206u',tablet:'_1b5wm206v',desktop:'_1b5wm206w'},defaultClass:'_1b5wm206u'},warning600:{conditions:{mobile:'_1b5wm206x',tablet:'_1b5wm206y',desktop:'_1b5wm206z'},defaultClass:'_1b5wm206x'},warning700:{conditions:{mobile:'_1b5wm2070',tablet:'_1b5wm2071',desktop:'_1b5wm2072'},defaultClass:'_1b5wm2070'},warning800:{conditions:{mobile:'_1b5wm2073',tablet:'_1b5wm2074',desktop:'_1b5wm2075'},defaultClass:'_1b5wm2073'},error100:{conditions:{mobile:'_1b5wm2076',tablet:'_1b5wm2077',desktop:'_1b5wm2078'},defaultClass:'_1b5wm2076'},error400:{conditions:{mobile:'_1b5wm2079',tablet:'_1b5wm207a',desktop:'_1b5wm207b'},defaultClass:'_1b5wm2079'},error500:{conditions:{mobile:'_1b5wm207c',tablet:'_1b5wm207d',desktop:'_1b5wm207e'},defaultClass:'_1b5wm207c'},error600:{conditions:{mobile:'_1b5wm207f',tablet:'_1b5wm207g',desktop:'_1b5wm207h'},defaultClass:'_1b5wm207f'},error700:{conditions:{mobile:'_1b5wm207i',tablet:'_1b5wm207j',desktop:'_1b5wm207k'},defaultClass:'_1b5wm207i'},error800:{conditions:{mobile:'_1b5wm207l',tablet:'_1b5wm207m',desktop:'_1b5wm207n'},defaultClass:'_1b5wm207l'},white:{conditions:{mobile:'_1b5wm207o',tablet:'_1b5wm207p',desktop:'_1b5wm207q'},defaultClass:'_1b5wm207o'}}},borderRadius:{values:{'0':{conditions:{mobile:'_1b5wm2083',tablet:'_1b5wm2084',desktop:'_1b5wm2085'},defaultClass:'_1b5wm2083'},'4':{conditions:{mobile:'_1b5wm207r',tablet:'_1b5wm207s',desktop:'_1b5wm207t'},defaultClass:'_1b5wm207r'},'8':{conditions:{mobile:'_1b5wm207u',tablet:'_1b5wm207v',desktop:'_1b5wm207w'},defaultClass:'_1b5wm207u'},'16':{conditions:{mobile:'_1b5wm207x',tablet:'_1b5wm207y',desktop:'_1b5wm207z'},defaultClass:'_1b5wm207x'},'24':{conditions:{mobile:'_1b5wm2080',tablet:'_1b5wm2081',desktop:'_1b5wm2082'},defaultClass:'_1b5wm2080'}}},borderTopRightRadius:{values:{'0':{conditions:{mobile:'_1b5wm208i',tablet:'_1b5wm208j',desktop:'_1b5wm208k'},defaultClass:'_1b5wm208i'},'4':{conditions:{mobile:'_1b5wm2086',tablet:'_1b5wm2087',desktop:'_1b5wm2088'},defaultClass:'_1b5wm2086'},'8':{conditions:{mobile:'_1b5wm2089',tablet:'_1b5wm208a',desktop:'_1b5wm208b'},defaultClass:'_1b5wm2089'},'16':{conditions:{mobile:'_1b5wm208c',tablet:'_1b5wm208d',desktop:'_1b5wm208e'},defaultClass:'_1b5wm208c'},'24':{conditions:{mobile:'_1b5wm208f',tablet:'_1b5wm208g',desktop:'_1b5wm208h'},defaultClass:'_1b5wm208f'}}},borderBottomRightRadius:{values:{'0':{conditions:{mobile:'_1b5wm208x',tablet:'_1b5wm208y',desktop:'_1b5wm208z'},defaultClass:'_1b5wm208x'},'4':{conditions:{mobile:'_1b5wm208l',tablet:'_1b5wm208m',desktop:'_1b5wm208n'},defaultClass:'_1b5wm208l'},'8':{conditions:{mobile:'_1b5wm208o',tablet:'_1b5wm208p',desktop:'_1b5wm208q'},defaultClass:'_1b5wm208o'},'16':{conditions:{mobile:'_1b5wm208r',tablet:'_1b5wm208s',desktop:'_1b5wm208t'},defaultClass:'_1b5wm208r'},'24':{conditions:{mobile:'_1b5wm208u',tablet:'_1b5wm208v',desktop:'_1b5wm208w'},defaultClass:'_1b5wm208u'}}},borderTopLeftRadius:{values:{'0':{conditions:{mobile:'_1b5wm209c',tablet:'_1b5wm209d',desktop:'_1b5wm209e'},defaultClass:'_1b5wm209c'},'4':{conditions:{mobile:'_1b5wm2090',tablet:'_1b5wm2091',desktop:'_1b5wm2092'},defaultClass:'_1b5wm2090'},'8':{conditions:{mobile:'_1b5wm2093',tablet:'_1b5wm2094',desktop:'_1b5wm2095'},defaultClass:'_1b5wm2093'},'16':{conditions:{mobile:'_1b5wm2096',tablet:'_1b5wm2097',desktop:'_1b5wm2098'},defaultClass:'_1b5wm2096'},'24':{conditions:{mobile:'_1b5wm2099',tablet:'_1b5wm209a',desktop:'_1b5wm209b'},defaultClass:'_1b5wm2099'}}},borderBottomLeftRadius:{values:{'0':{conditions:{mobile:'_1b5wm209r',tablet:'_1b5wm209s',desktop:'_1b5wm209t'},defaultClass:'_1b5wm209r'},'4':{conditions:{mobile:'_1b5wm209f',tablet:'_1b5wm209g',desktop:'_1b5wm209h'},defaultClass:'_1b5wm209f'},'8':{conditions:{mobile:'_1b5wm209i',tablet:'_1b5wm209j',desktop:'_1b5wm209k'},defaultClass:'_1b5wm209i'},'16':{conditions:{mobile:'_1b5wm209l',tablet:'_1b5wm209m',desktop:'_1b5wm209n'},defaultClass:'_1b5wm209l'},'24':{conditions:{mobile:'_1b5wm209o',tablet:'_1b5wm209p',desktop:'_1b5wm209q'},defaultClass:'_1b5wm209o'}}},maxHeight:{values:{'100%':{conditions:{mobile:'_1b5wm209u',tablet:'_1b5wm209v',desktop:'_1b5wm209w'},defaultClass:'_1b5wm209u'}}},minHeight:{values:{'100vh':{conditions:{mobile:'_1b5wm209x',tablet:'_1b5wm209y',desktop:'_1b5wm209z'},defaultClass:'_1b5wm209x'}}},minWidth:{values:{'0':{conditions:{mobile:'_1b5wm20a3',tablet:'_1b5wm20a4',desktop:'_1b5wm20a5'},defaultClass:'_1b5wm20a3'},initial:{conditions:{mobile:'_1b5wm20a0',tablet:'_1b5wm20a1',desktop:'_1b5wm20a2'},defaultClass:'_1b5wm20a0'},'50%':{conditions:{mobile:'_1b5wm20a6',tablet:'_1b5wm20a7',desktop:'_1b5wm20a8'},defaultClass:'_1b5wm20a6'},'100%':{conditions:{mobile:'_1b5wm20a9',tablet:'_1b5wm20aa',desktop:'_1b5wm20ab'},defaultClass:'_1b5wm20a9'}}},opacity:{values:{'0':{conditions:{mobile:'_1b5wm20ac',tablet:'_1b5wm20ad',desktop:'_1b5wm20ae'},defaultClass:'_1b5wm20ac'},'1':{conditions:{mobile:'_1b5wm20af',tablet:'_1b5wm20ag',desktop:'_1b5wm20ah'},defaultClass:'_1b5wm20af'}}},flexShrink:{values:{'0':{conditions:{mobile:'_1b5wm20ai',tablet:'_1b5wm20aj',desktop:'_1b5wm20ak'},defaultClass:'_1b5wm20ai'},'1':{conditions:{mobile:'_1b5wm20al',tablet:'_1b5wm20am',desktop:'_1b5wm20an'},defaultClass:'_1b5wm20al'},'2':{conditions:{mobile:'_1b5wm20ao',tablet:'_1b5wm20ap',desktop:'_1b5wm20aq'},defaultClass:'_1b5wm20ao'}}},userSelect:{values:{none:{conditions:{mobile:'_1b5wm20ar',tablet:'_1b5wm20as',desktop:'_1b5wm20at'},defaultClass:'_1b5wm20ar'},auto:{conditions:{mobile:'_1b5wm20au',tablet:'_1b5wm20av',desktop:'_1b5wm20aw'},defaultClass:'_1b5wm20au'}}},fill:{values:{none:{conditions:{mobile:'_1b5wm20ax',tablet:'_1b5wm20ay',desktop:'_1b5wm20az'},defaultClass:'_1b5wm20ax'},currentcolor:{conditions:{mobile:'_1b5wm20b0',tablet:'_1b5wm20b1',desktop:'_1b5wm20b2'},defaultClass:'_1b5wm20b0'}}},fontWeight:{values:{'100':{conditions:{mobile:'_1b5wm20b3',tablet:'_1b5wm20b4',desktop:'_1b5wm20b5'},defaultClass:'_1b5wm20b3'},'200':{conditions:{mobile:'_1b5wm20b6',tablet:'_1b5wm20b7',desktop:'_1b5wm20b8'},defaultClass:'_1b5wm20b6'},'300':{conditions:{mobile:'_1b5wm20b9',tablet:'_1b5wm20ba',desktop:'_1b5wm20bb'},defaultClass:'_1b5wm20b9'},'400':{conditions:{mobile:'_1b5wm20bc',tablet:'_1b5wm20bd',desktop:'_1b5wm20be'},defaultClass:'_1b5wm20bc'},'500':{conditions:{mobile:'_1b5wm20bf',tablet:'_1b5wm20bg',desktop:'_1b5wm20bh'},defaultClass:'_1b5wm20bf'},'600':{conditions:{mobile:'_1b5wm20bi',tablet:'_1b5wm20bj',desktop:'_1b5wm20bk'},defaultClass:'_1b5wm20bi'},'700':{conditions:{mobile:'_1b5wm20bl',tablet:'_1b5wm20bm',desktop:'_1b5wm20bn'},defaultClass:'_1b5wm20bl'},'800':{conditions:{mobile:'_1b5wm20bo',tablet:'_1b5wm20bp',desktop:'_1b5wm20bq'},defaultClass:'_1b5wm20bo'}}},overflowY:{values:{auto:{conditions:{mobile:'_1b5wm20br',tablet:'_1b5wm20bs',desktop:'_1b5wm20bt'},defaultClass:'_1b5wm20br'}}}}};
var sprinkles = (0,_vanilla_extract_sprinkles_createRuntimeSprinkles__WEBPACK_IMPORTED_MODULE_1__/* .createSprinkles */ .$)({conditions:{defaultCondition:'mobile',conditionNames:['mobile','tablet','desktop'],responsiveArray:undefined},styles:{margin:{values:{'0 auto':{conditions:{mobile:'tfghjgbr',tablet:'tfghjgbs',desktop:'tfghjgbt'},defaultClass:'tfghjgbr'},auto:{conditions:{mobile:'tfghjgbu',tablet:'tfghjgbv',desktop:'tfghjgbw'},defaultClass:'tfghjgbu'}}},padding:{mappings:['paddingTop','paddingBottom','paddingLeft','paddingRight']},marginX:{mappings:['marginLeft','marginRight']},marginY:{mappings:['marginTop','marginBottom']},paddingX:{mappings:['paddingLeft','paddingRight']},paddingY:{mappings:['paddingTop','paddingBottom']},alignItems:{values:{'flex-start':{conditions:{mobile:'tfghjg0',tablet:'tfghjg1',desktop:'tfghjg2'},defaultClass:'tfghjg0'},'flex-end':{conditions:{mobile:'tfghjg3',tablet:'tfghjg4',desktop:'tfghjg5'},defaultClass:'tfghjg3'},center:{conditions:{mobile:'tfghjg6',tablet:'tfghjg7',desktop:'tfghjg8'},defaultClass:'tfghjg6'}}},alignSelf:{values:{'flex-start':{conditions:{mobile:'tfghjg9',tablet:'tfghjga',desktop:'tfghjgb'},defaultClass:'tfghjg9'},'flex-end':{conditions:{mobile:'tfghjgc',tablet:'tfghjgd',desktop:'tfghjge'},defaultClass:'tfghjgc'},center:{conditions:{mobile:'tfghjgf',tablet:'tfghjgg',desktop:'tfghjgh'},defaultClass:'tfghjgf'}}},border:{values:{'0':{conditions:{mobile:'tfghjgi',tablet:'tfghjgj',desktop:'tfghjgk'},defaultClass:'tfghjgi'}}},borderRadius:{values:{'0':{conditions:{mobile:'tfghjgl',tablet:'tfghjgm',desktop:'tfghjgn'},defaultClass:'tfghjgl'},'4':{conditions:{mobile:'tfghjgo',tablet:'tfghjgp',desktop:'tfghjgq'},defaultClass:'tfghjgo'},'8':{conditions:{mobile:'tfghjgr',tablet:'tfghjgs',desktop:'tfghjgt'},defaultClass:'tfghjgr'},'16':{conditions:{mobile:'tfghjgu',tablet:'tfghjgv',desktop:'tfghjgw'},defaultClass:'tfghjgu'},'24':{conditions:{mobile:'tfghjgx',tablet:'tfghjgy',desktop:'tfghjgz'},defaultClass:'tfghjgx'}}},borderBottomLeftRadius:{values:{'4':{conditions:{mobile:'tfghjg10',tablet:'tfghjg11',desktop:'tfghjg12'},defaultClass:'tfghjg10'},'8':{conditions:{mobile:'tfghjg13',tablet:'tfghjg14',desktop:'tfghjg15'},defaultClass:'tfghjg13'},'16':{conditions:{mobile:'tfghjg16',tablet:'tfghjg17',desktop:'tfghjg18'},defaultClass:'tfghjg16'},'24':{conditions:{mobile:'tfghjg19',tablet:'tfghjg1a',desktop:'tfghjg1b'},defaultClass:'tfghjg19'}}},borderTopRightRadius:{values:{'0':{conditions:{mobile:'tfghjg1c',tablet:'tfghjg1d',desktop:'tfghjg1e'},defaultClass:'tfghjg1c'},'4':{conditions:{mobile:'tfghjg1f',tablet:'tfghjg1g',desktop:'tfghjg1h'},defaultClass:'tfghjg1f'},'8':{conditions:{mobile:'tfghjg1i',tablet:'tfghjg1j',desktop:'tfghjg1k'},defaultClass:'tfghjg1i'},'16':{conditions:{mobile:'tfghjg1l',tablet:'tfghjg1m',desktop:'tfghjg1n'},defaultClass:'tfghjg1l'},'24':{conditions:{mobile:'tfghjg1o',tablet:'tfghjg1p',desktop:'tfghjg1q'},defaultClass:'tfghjg1o'}}},display:{values:{none:{conditions:{mobile:'tfghjg1r',tablet:'tfghjg1s',desktop:'tfghjg1t'},defaultClass:'tfghjg1r'},flex:{conditions:{mobile:'tfghjg1u',tablet:'tfghjg1v',desktop:'tfghjg1w'},defaultClass:'tfghjg1u'},grid:{conditions:{mobile:'tfghjg1x',tablet:'tfghjg1y',desktop:'tfghjg1z'},defaultClass:'tfghjg1x'},block:{conditions:{mobile:'tfghjg20',tablet:'tfghjg21',desktop:'tfghjg22'},defaultClass:'tfghjg20'},'inline-block':{conditions:{mobile:'tfghjg23',tablet:'tfghjg24',desktop:'tfghjg25'},defaultClass:'tfghjg23'}}},position:{values:{'static':{conditions:{mobile:'tfghjg26',tablet:'tfghjg27',desktop:'tfghjg28'},defaultClass:'tfghjg26'},absolute:{conditions:{mobile:'tfghjg29',tablet:'tfghjg2a',desktop:'tfghjg2b'},defaultClass:'tfghjg29'},relative:{conditions:{mobile:'tfghjg2c',tablet:'tfghjg2d',desktop:'tfghjg2e'},defaultClass:'tfghjg2c'}}},top:{values:{'0':{conditions:{mobile:'tfghjg2f',tablet:'tfghjg2g',desktop:'tfghjg2h'},defaultClass:'tfghjg2f'},'2xl':{conditions:{mobile:'tfghjg2i',tablet:'tfghjg2j',desktop:'tfghjg2k'},defaultClass:'tfghjg2i'},'3xl':{conditions:{mobile:'tfghjg2l',tablet:'tfghjg2m',desktop:'tfghjg2n'},defaultClass:'tfghjg2l'},'4xl':{conditions:{mobile:'tfghjg2o',tablet:'tfghjg2p',desktop:'tfghjg2q'},defaultClass:'tfghjg2o'},'5xl':{conditions:{mobile:'tfghjg2r',tablet:'tfghjg2s',desktop:'tfghjg2t'},defaultClass:'tfghjg2r'},auto:{conditions:{mobile:'tfghjg2u',tablet:'tfghjg2v',desktop:'tfghjg2w'},defaultClass:'tfghjg2u'},l:{conditions:{mobile:'tfghjg2x',tablet:'tfghjg2y',desktop:'tfghjg2z'},defaultClass:'tfghjg2x'},m:{conditions:{mobile:'tfghjg30',tablet:'tfghjg31',desktop:'tfghjg32'},defaultClass:'tfghjg30'},'m-l':{conditions:{mobile:'tfghjg33',tablet:'tfghjg34',desktop:'tfghjg35'},defaultClass:'tfghjg33'},s:{conditions:{mobile:'tfghjg36',tablet:'tfghjg37',desktop:'tfghjg38'},defaultClass:'tfghjg36'},'s-m':{conditions:{mobile:'tfghjg39',tablet:'tfghjg3a',desktop:'tfghjg3b'},defaultClass:'tfghjg39'},xl:{conditions:{mobile:'tfghjg3c',tablet:'tfghjg3d',desktop:'tfghjg3e'},defaultClass:'tfghjg3c'},xs:{conditions:{mobile:'tfghjg3f',tablet:'tfghjg3g',desktop:'tfghjg3h'},defaultClass:'tfghjg3f'},xxs:{conditions:{mobile:'tfghjg3i',tablet:'tfghjg3j',desktop:'tfghjg3k'},defaultClass:'tfghjg3i'}}},right:{values:{'0':{conditions:{mobile:'tfghjg3l',tablet:'tfghjg3m',desktop:'tfghjg3n'},defaultClass:'tfghjg3l'},'2xl':{conditions:{mobile:'tfghjg3o',tablet:'tfghjg3p',desktop:'tfghjg3q'},defaultClass:'tfghjg3o'},'3xl':{conditions:{mobile:'tfghjg3r',tablet:'tfghjg3s',desktop:'tfghjg3t'},defaultClass:'tfghjg3r'},'4xl':{conditions:{mobile:'tfghjg3u',tablet:'tfghjg3v',desktop:'tfghjg3w'},defaultClass:'tfghjg3u'},'5xl':{conditions:{mobile:'tfghjg3x',tablet:'tfghjg3y',desktop:'tfghjg3z'},defaultClass:'tfghjg3x'},auto:{conditions:{mobile:'tfghjg40',tablet:'tfghjg41',desktop:'tfghjg42'},defaultClass:'tfghjg40'},l:{conditions:{mobile:'tfghjg43',tablet:'tfghjg44',desktop:'tfghjg45'},defaultClass:'tfghjg43'},m:{conditions:{mobile:'tfghjg46',tablet:'tfghjg47',desktop:'tfghjg48'},defaultClass:'tfghjg46'},'m-l':{conditions:{mobile:'tfghjg49',tablet:'tfghjg4a',desktop:'tfghjg4b'},defaultClass:'tfghjg49'},s:{conditions:{mobile:'tfghjg4c',tablet:'tfghjg4d',desktop:'tfghjg4e'},defaultClass:'tfghjg4c'},'s-m':{conditions:{mobile:'tfghjg4f',tablet:'tfghjg4g',desktop:'tfghjg4h'},defaultClass:'tfghjg4f'},xl:{conditions:{mobile:'tfghjg4i',tablet:'tfghjg4j',desktop:'tfghjg4k'},defaultClass:'tfghjg4i'},xs:{conditions:{mobile:'tfghjg4l',tablet:'tfghjg4m',desktop:'tfghjg4n'},defaultClass:'tfghjg4l'},xxs:{conditions:{mobile:'tfghjg4o',tablet:'tfghjg4p',desktop:'tfghjg4q'},defaultClass:'tfghjg4o'}}},bottom:{values:{'0':{conditions:{mobile:'tfghjg4r',tablet:'tfghjg4s',desktop:'tfghjg4t'},defaultClass:'tfghjg4r'},'2xl':{conditions:{mobile:'tfghjg4u',tablet:'tfghjg4v',desktop:'tfghjg4w'},defaultClass:'tfghjg4u'},'3xl':{conditions:{mobile:'tfghjg4x',tablet:'tfghjg4y',desktop:'tfghjg4z'},defaultClass:'tfghjg4x'},'4xl':{conditions:{mobile:'tfghjg50',tablet:'tfghjg51',desktop:'tfghjg52'},defaultClass:'tfghjg50'},'5xl':{conditions:{mobile:'tfghjg53',tablet:'tfghjg54',desktop:'tfghjg55'},defaultClass:'tfghjg53'},auto:{conditions:{mobile:'tfghjg56',tablet:'tfghjg57',desktop:'tfghjg58'},defaultClass:'tfghjg56'},l:{conditions:{mobile:'tfghjg59',tablet:'tfghjg5a',desktop:'tfghjg5b'},defaultClass:'tfghjg59'},m:{conditions:{mobile:'tfghjg5c',tablet:'tfghjg5d',desktop:'tfghjg5e'},defaultClass:'tfghjg5c'},'m-l':{conditions:{mobile:'tfghjg5f',tablet:'tfghjg5g',desktop:'tfghjg5h'},defaultClass:'tfghjg5f'},s:{conditions:{mobile:'tfghjg5i',tablet:'tfghjg5j',desktop:'tfghjg5k'},defaultClass:'tfghjg5i'},'s-m':{conditions:{mobile:'tfghjg5l',tablet:'tfghjg5m',desktop:'tfghjg5n'},defaultClass:'tfghjg5l'},xl:{conditions:{mobile:'tfghjg5o',tablet:'tfghjg5p',desktop:'tfghjg5q'},defaultClass:'tfghjg5o'},xs:{conditions:{mobile:'tfghjg5r',tablet:'tfghjg5s',desktop:'tfghjg5t'},defaultClass:'tfghjg5r'},xxs:{conditions:{mobile:'tfghjg5u',tablet:'tfghjg5v',desktop:'tfghjg5w'},defaultClass:'tfghjg5u'}}},left:{values:{'0':{conditions:{mobile:'tfghjg5x',tablet:'tfghjg5y',desktop:'tfghjg5z'},defaultClass:'tfghjg5x'},'2xl':{conditions:{mobile:'tfghjg60',tablet:'tfghjg61',desktop:'tfghjg62'},defaultClass:'tfghjg60'},'3xl':{conditions:{mobile:'tfghjg63',tablet:'tfghjg64',desktop:'tfghjg65'},defaultClass:'tfghjg63'},'4xl':{conditions:{mobile:'tfghjg66',tablet:'tfghjg67',desktop:'tfghjg68'},defaultClass:'tfghjg66'},'5xl':{conditions:{mobile:'tfghjg69',tablet:'tfghjg6a',desktop:'tfghjg6b'},defaultClass:'tfghjg69'},auto:{conditions:{mobile:'tfghjg6c',tablet:'tfghjg6d',desktop:'tfghjg6e'},defaultClass:'tfghjg6c'},l:{conditions:{mobile:'tfghjg6f',tablet:'tfghjg6g',desktop:'tfghjg6h'},defaultClass:'tfghjg6f'},m:{conditions:{mobile:'tfghjg6i',tablet:'tfghjg6j',desktop:'tfghjg6k'},defaultClass:'tfghjg6i'},'m-l':{conditions:{mobile:'tfghjg6l',tablet:'tfghjg6m',desktop:'tfghjg6n'},defaultClass:'tfghjg6l'},s:{conditions:{mobile:'tfghjg6o',tablet:'tfghjg6p',desktop:'tfghjg6q'},defaultClass:'tfghjg6o'},'s-m':{conditions:{mobile:'tfghjg6r',tablet:'tfghjg6s',desktop:'tfghjg6t'},defaultClass:'tfghjg6r'},xl:{conditions:{mobile:'tfghjg6u',tablet:'tfghjg6v',desktop:'tfghjg6w'},defaultClass:'tfghjg6u'},xs:{conditions:{mobile:'tfghjg6x',tablet:'tfghjg6y',desktop:'tfghjg6z'},defaultClass:'tfghjg6x'},xxs:{conditions:{mobile:'tfghjg70',tablet:'tfghjg71',desktop:'tfghjg72'},defaultClass:'tfghjg70'}}},flex:{values:{'1':{conditions:{mobile:'tfghjg73',tablet:'tfghjg74',desktop:'tfghjg75'},defaultClass:'tfghjg73'}}},flexBasis:{values:{'100%':{conditions:{mobile:'tfghjg76',tablet:'tfghjg77',desktop:'tfghjg78'},defaultClass:'tfghjg76'},'50%':{conditions:{mobile:'tfghjg79',tablet:'tfghjg7a',desktop:'tfghjg7b'},defaultClass:'tfghjg79'},unset:{conditions:{mobile:'tfghjg7c',tablet:'tfghjg7d',desktop:'tfghjg7e'},defaultClass:'tfghjg7c'}}},flexDirection:{values:{'row-reverse':{conditions:{mobile:'tfghjg7f',tablet:'tfghjg7g',desktop:'tfghjg7h'},defaultClass:'tfghjg7f'},row:{conditions:{mobile:'tfghjg7i',tablet:'tfghjg7j',desktop:'tfghjg7k'},defaultClass:'tfghjg7i'},column:{conditions:{mobile:'tfghjg7l',tablet:'tfghjg7m',desktop:'tfghjg7n'},defaultClass:'tfghjg7l'}}},flexGrow:{values:{'0':{conditions:{mobile:'tfghjg7r',tablet:'tfghjg7s',desktop:'tfghjg7t'},defaultClass:'tfghjg7r'},'1':{conditions:{mobile:'tfghjg7o',tablet:'tfghjg7p',desktop:'tfghjg7q'},defaultClass:'tfghjg7o'}}},flexShrink:{values:{'0':{conditions:{mobile:'tfghjg7x',tablet:'tfghjg7y',desktop:'tfghjg7z'},defaultClass:'tfghjg7x'},'1':{conditions:{mobile:'tfghjg7u',tablet:'tfghjg7v',desktop:'tfghjg7w'},defaultClass:'tfghjg7u'}}},flexWrap:{values:{wrap:{conditions:{mobile:'tfghjg80',tablet:'tfghjg81',desktop:'tfghjg82'},defaultClass:'tfghjg80'},nowrap:{conditions:{mobile:'tfghjg83',tablet:'tfghjg84',desktop:'tfghjg85'},defaultClass:'tfghjg83'}}},fontWeight:{values:{'300':{conditions:{mobile:'tfghjg86',tablet:'tfghjg87',desktop:'tfghjg88'},defaultClass:'tfghjg86'},'400':{conditions:{mobile:'tfghjg89',tablet:'tfghjg8a',desktop:'tfghjg8b'},defaultClass:'tfghjg89'},'600':{conditions:{mobile:'tfghjg8c',tablet:'tfghjg8d',desktop:'tfghjg8e'},defaultClass:'tfghjg8c'}}},cursor:{values:{pointer:{conditions:{mobile:'tfghjg8f',tablet:'tfghjg8g',desktop:'tfghjg8h'},defaultClass:'tfghjg8f'},'not-allowed':{conditions:{mobile:'tfghjg8i',tablet:'tfghjg8j',desktop:'tfghjg8k'},defaultClass:'tfghjg8i'}}},textDecoration:{values:{underline:{conditions:{mobile:'tfghjg8l',tablet:'tfghjg8m',desktop:'tfghjg8n'},defaultClass:'tfghjg8l'}}},verticalAlign:{values:{baseline:{conditions:{mobile:'tfghjg8o',tablet:'tfghjg8p',desktop:'tfghjg8q'},defaultClass:'tfghjg8o'},center:{conditions:{mobile:'tfghjg8r',tablet:'tfghjg8s',desktop:'tfghjg8t'},defaultClass:'tfghjg8r'}}},gap:{values:{'0':{conditions:{mobile:'tfghjg8u',tablet:'tfghjg8v',desktop:'tfghjg8w'},defaultClass:'tfghjg8u'},'2xl':{conditions:{mobile:'tfghjg8x',tablet:'tfghjg8y',desktop:'tfghjg8z'},defaultClass:'tfghjg8x'},'3xl':{conditions:{mobile:'tfghjg90',tablet:'tfghjg91',desktop:'tfghjg92'},defaultClass:'tfghjg90'},'4xl':{conditions:{mobile:'tfghjg93',tablet:'tfghjg94',desktop:'tfghjg95'},defaultClass:'tfghjg93'},'5xl':{conditions:{mobile:'tfghjg96',tablet:'tfghjg97',desktop:'tfghjg98'},defaultClass:'tfghjg96'},auto:{conditions:{mobile:'tfghjg99',tablet:'tfghjg9a',desktop:'tfghjg9b'},defaultClass:'tfghjg99'},l:{conditions:{mobile:'tfghjg9c',tablet:'tfghjg9d',desktop:'tfghjg9e'},defaultClass:'tfghjg9c'},m:{conditions:{mobile:'tfghjg9f',tablet:'tfghjg9g',desktop:'tfghjg9h'},defaultClass:'tfghjg9f'},'m-l':{conditions:{mobile:'tfghjg9i',tablet:'tfghjg9j',desktop:'tfghjg9k'},defaultClass:'tfghjg9i'},s:{conditions:{mobile:'tfghjg9l',tablet:'tfghjg9m',desktop:'tfghjg9n'},defaultClass:'tfghjg9l'},'s-m':{conditions:{mobile:'tfghjg9o',tablet:'tfghjg9p',desktop:'tfghjg9q'},defaultClass:'tfghjg9o'},xl:{conditions:{mobile:'tfghjg9r',tablet:'tfghjg9s',desktop:'tfghjg9t'},defaultClass:'tfghjg9r'},xs:{conditions:{mobile:'tfghjg9u',tablet:'tfghjg9v',desktop:'tfghjg9w'},defaultClass:'tfghjg9u'},xxs:{conditions:{mobile:'tfghjg9x',tablet:'tfghjg9y',desktop:'tfghjg9z'},defaultClass:'tfghjg9x'}}},height:{values:{'100vh':{conditions:{mobile:'tfghjga0',tablet:'tfghjga1',desktop:'tfghjga2'},defaultClass:'tfghjga0'},'100%':{conditions:{mobile:'tfghjga3',tablet:'tfghjga4',desktop:'tfghjga5'},defaultClass:'tfghjga3'}}},justifyContent:{values:{'space-between':{conditions:{mobile:'tfghjga6',tablet:'tfghjga7',desktop:'tfghjga8'},defaultClass:'tfghjga6'},'space-around':{conditions:{mobile:'tfghjga9',tablet:'tfghjgaa',desktop:'tfghjgab'},defaultClass:'tfghjga9'},center:{conditions:{mobile:'tfghjgac',tablet:'tfghjgad',desktop:'tfghjgae'},defaultClass:'tfghjgac'},'flex-end':{conditions:{mobile:'tfghjgaf',tablet:'tfghjgag',desktop:'tfghjgah'},defaultClass:'tfghjgaf'},'flex-start':{conditions:{mobile:'tfghjgai',tablet:'tfghjgaj',desktop:'tfghjgak'},defaultClass:'tfghjgai'}}},marginBottom:{values:{'0':{conditions:{mobile:'tfghjgal',tablet:'tfghjgam',desktop:'tfghjgan'},defaultClass:'tfghjgal'},'2xl':{conditions:{mobile:'tfghjgao',tablet:'tfghjgap',desktop:'tfghjgaq'},defaultClass:'tfghjgao'},'3xl':{conditions:{mobile:'tfghjgar',tablet:'tfghjgas',desktop:'tfghjgat'},defaultClass:'tfghjgar'},'4xl':{conditions:{mobile:'tfghjgau',tablet:'tfghjgav',desktop:'tfghjgaw'},defaultClass:'tfghjgau'},'5xl':{conditions:{mobile:'tfghjgax',tablet:'tfghjgay',desktop:'tfghjgaz'},defaultClass:'tfghjgax'},auto:{conditions:{mobile:'tfghjgb0',tablet:'tfghjgb1',desktop:'tfghjgb2'},defaultClass:'tfghjgb0'},l:{conditions:{mobile:'tfghjgb3',tablet:'tfghjgb4',desktop:'tfghjgb5'},defaultClass:'tfghjgb3'},m:{conditions:{mobile:'tfghjgb6',tablet:'tfghjgb7',desktop:'tfghjgb8'},defaultClass:'tfghjgb6'},'m-l':{conditions:{mobile:'tfghjgb9',tablet:'tfghjgba',desktop:'tfghjgbb'},defaultClass:'tfghjgb9'},s:{conditions:{mobile:'tfghjgbc',tablet:'tfghjgbd',desktop:'tfghjgbe'},defaultClass:'tfghjgbc'},'s-m':{conditions:{mobile:'tfghjgbf',tablet:'tfghjgbg',desktop:'tfghjgbh'},defaultClass:'tfghjgbf'},xl:{conditions:{mobile:'tfghjgbi',tablet:'tfghjgbj',desktop:'tfghjgbk'},defaultClass:'tfghjgbi'},xs:{conditions:{mobile:'tfghjgbl',tablet:'tfghjgbm',desktop:'tfghjgbn'},defaultClass:'tfghjgbl'},xxs:{conditions:{mobile:'tfghjgbo',tablet:'tfghjgbp',desktop:'tfghjgbq'},defaultClass:'tfghjgbo'}}},marginLeft:{values:{'0':{conditions:{mobile:'tfghjgbx',tablet:'tfghjgby',desktop:'tfghjgbz'},defaultClass:'tfghjgbx'},'2xl':{conditions:{mobile:'tfghjgc0',tablet:'tfghjgc1',desktop:'tfghjgc2'},defaultClass:'tfghjgc0'},'3xl':{conditions:{mobile:'tfghjgc3',tablet:'tfghjgc4',desktop:'tfghjgc5'},defaultClass:'tfghjgc3'},'4xl':{conditions:{mobile:'tfghjgc6',tablet:'tfghjgc7',desktop:'tfghjgc8'},defaultClass:'tfghjgc6'},'5xl':{conditions:{mobile:'tfghjgc9',tablet:'tfghjgca',desktop:'tfghjgcb'},defaultClass:'tfghjgc9'},auto:{conditions:{mobile:'tfghjgcc',tablet:'tfghjgcd',desktop:'tfghjgce'},defaultClass:'tfghjgcc'},l:{conditions:{mobile:'tfghjgcf',tablet:'tfghjgcg',desktop:'tfghjgch'},defaultClass:'tfghjgcf'},m:{conditions:{mobile:'tfghjgci',tablet:'tfghjgcj',desktop:'tfghjgck'},defaultClass:'tfghjgci'},'m-l':{conditions:{mobile:'tfghjgcl',tablet:'tfghjgcm',desktop:'tfghjgcn'},defaultClass:'tfghjgcl'},s:{conditions:{mobile:'tfghjgco',tablet:'tfghjgcp',desktop:'tfghjgcq'},defaultClass:'tfghjgco'},'s-m':{conditions:{mobile:'tfghjgcr',tablet:'tfghjgcs',desktop:'tfghjgct'},defaultClass:'tfghjgcr'},xl:{conditions:{mobile:'tfghjgcu',tablet:'tfghjgcv',desktop:'tfghjgcw'},defaultClass:'tfghjgcu'},xs:{conditions:{mobile:'tfghjgcx',tablet:'tfghjgcy',desktop:'tfghjgcz'},defaultClass:'tfghjgcx'},xxs:{conditions:{mobile:'tfghjgd0',tablet:'tfghjgd1',desktop:'tfghjgd2'},defaultClass:'tfghjgd0'}}},marginRight:{values:{'0':{conditions:{mobile:'tfghjgd3',tablet:'tfghjgd4',desktop:'tfghjgd5'},defaultClass:'tfghjgd3'},'2xl':{conditions:{mobile:'tfghjgd6',tablet:'tfghjgd7',desktop:'tfghjgd8'},defaultClass:'tfghjgd6'},'3xl':{conditions:{mobile:'tfghjgd9',tablet:'tfghjgda',desktop:'tfghjgdb'},defaultClass:'tfghjgd9'},'4xl':{conditions:{mobile:'tfghjgdc',tablet:'tfghjgdd',desktop:'tfghjgde'},defaultClass:'tfghjgdc'},'5xl':{conditions:{mobile:'tfghjgdf',tablet:'tfghjgdg',desktop:'tfghjgdh'},defaultClass:'tfghjgdf'},auto:{conditions:{mobile:'tfghjgdi',tablet:'tfghjgdj',desktop:'tfghjgdk'},defaultClass:'tfghjgdi'},l:{conditions:{mobile:'tfghjgdl',tablet:'tfghjgdm',desktop:'tfghjgdn'},defaultClass:'tfghjgdl'},m:{conditions:{mobile:'tfghjgdo',tablet:'tfghjgdp',desktop:'tfghjgdq'},defaultClass:'tfghjgdo'},'m-l':{conditions:{mobile:'tfghjgdr',tablet:'tfghjgds',desktop:'tfghjgdt'},defaultClass:'tfghjgdr'},s:{conditions:{mobile:'tfghjgdu',tablet:'tfghjgdv',desktop:'tfghjgdw'},defaultClass:'tfghjgdu'},'s-m':{conditions:{mobile:'tfghjgdx',tablet:'tfghjgdy',desktop:'tfghjgdz'},defaultClass:'tfghjgdx'},xl:{conditions:{mobile:'tfghjge0',tablet:'tfghjge1',desktop:'tfghjge2'},defaultClass:'tfghjge0'},xs:{conditions:{mobile:'tfghjge3',tablet:'tfghjge4',desktop:'tfghjge5'},defaultClass:'tfghjge3'},xxs:{conditions:{mobile:'tfghjge6',tablet:'tfghjge7',desktop:'tfghjge8'},defaultClass:'tfghjge6'}}},marginTop:{values:{'0':{conditions:{mobile:'tfghjge9',tablet:'tfghjgea',desktop:'tfghjgeb'},defaultClass:'tfghjge9'},'2xl':{conditions:{mobile:'tfghjgec',tablet:'tfghjged',desktop:'tfghjgee'},defaultClass:'tfghjgec'},'3xl':{conditions:{mobile:'tfghjgef',tablet:'tfghjgeg',desktop:'tfghjgeh'},defaultClass:'tfghjgef'},'4xl':{conditions:{mobile:'tfghjgei',tablet:'tfghjgej',desktop:'tfghjgek'},defaultClass:'tfghjgei'},'5xl':{conditions:{mobile:'tfghjgel',tablet:'tfghjgem',desktop:'tfghjgen'},defaultClass:'tfghjgel'},auto:{conditions:{mobile:'tfghjgeo',tablet:'tfghjgep',desktop:'tfghjgeq'},defaultClass:'tfghjgeo'},l:{conditions:{mobile:'tfghjger',tablet:'tfghjges',desktop:'tfghjget'},defaultClass:'tfghjger'},m:{conditions:{mobile:'tfghjgeu',tablet:'tfghjgev',desktop:'tfghjgew'},defaultClass:'tfghjgeu'},'m-l':{conditions:{mobile:'tfghjgex',tablet:'tfghjgey',desktop:'tfghjgez'},defaultClass:'tfghjgex'},s:{conditions:{mobile:'tfghjgf0',tablet:'tfghjgf1',desktop:'tfghjgf2'},defaultClass:'tfghjgf0'},'s-m':{conditions:{mobile:'tfghjgf3',tablet:'tfghjgf4',desktop:'tfghjgf5'},defaultClass:'tfghjgf3'},xl:{conditions:{mobile:'tfghjgf6',tablet:'tfghjgf7',desktop:'tfghjgf8'},defaultClass:'tfghjgf6'},xs:{conditions:{mobile:'tfghjgf9',tablet:'tfghjgfa',desktop:'tfghjgfb'},defaultClass:'tfghjgf9'},xxs:{conditions:{mobile:'tfghjgfc',tablet:'tfghjgfd',desktop:'tfghjgfe'},defaultClass:'tfghjgfc'}}},overflow:{values:{hidden:{conditions:{mobile:'tfghjgff',tablet:'tfghjgfg',desktop:'tfghjgfh'},defaultClass:'tfghjgff'},auto:{conditions:{mobile:'tfghjgfi',tablet:'tfghjgfj',desktop:'tfghjgfk'},defaultClass:'tfghjgfi'}}},overflowX:{values:{hidden:{conditions:{mobile:'tfghjgfl',tablet:'tfghjgfm',desktop:'tfghjgfn'},defaultClass:'tfghjgfl'},auto:{conditions:{mobile:'tfghjgfo',tablet:'tfghjgfp',desktop:'tfghjgfq'},defaultClass:'tfghjgfo'}}},paddingBottom:{values:{'0':{conditions:{mobile:'tfghjgfr',tablet:'tfghjgfs',desktop:'tfghjgft'},defaultClass:'tfghjgfr'},'2xl':{conditions:{mobile:'tfghjgfu',tablet:'tfghjgfv',desktop:'tfghjgfw'},defaultClass:'tfghjgfu'},'3xl':{conditions:{mobile:'tfghjgfx',tablet:'tfghjgfy',desktop:'tfghjgfz'},defaultClass:'tfghjgfx'},'4xl':{conditions:{mobile:'tfghjgg0',tablet:'tfghjgg1',desktop:'tfghjgg2'},defaultClass:'tfghjgg0'},'5xl':{conditions:{mobile:'tfghjgg3',tablet:'tfghjgg4',desktop:'tfghjgg5'},defaultClass:'tfghjgg3'},auto:{conditions:{mobile:'tfghjgg6',tablet:'tfghjgg7',desktop:'tfghjgg8'},defaultClass:'tfghjgg6'},l:{conditions:{mobile:'tfghjgg9',tablet:'tfghjgga',desktop:'tfghjggb'},defaultClass:'tfghjgg9'},m:{conditions:{mobile:'tfghjggc',tablet:'tfghjggd',desktop:'tfghjgge'},defaultClass:'tfghjggc'},'m-l':{conditions:{mobile:'tfghjggf',tablet:'tfghjggg',desktop:'tfghjggh'},defaultClass:'tfghjggf'},s:{conditions:{mobile:'tfghjggi',tablet:'tfghjggj',desktop:'tfghjggk'},defaultClass:'tfghjggi'},'s-m':{conditions:{mobile:'tfghjggl',tablet:'tfghjggm',desktop:'tfghjggn'},defaultClass:'tfghjggl'},xl:{conditions:{mobile:'tfghjggo',tablet:'tfghjggp',desktop:'tfghjggq'},defaultClass:'tfghjggo'},xs:{conditions:{mobile:'tfghjggr',tablet:'tfghjggs',desktop:'tfghjggt'},defaultClass:'tfghjggr'},xxs:{conditions:{mobile:'tfghjggu',tablet:'tfghjggv',desktop:'tfghjggw'},defaultClass:'tfghjggu'}}},paddingLeft:{values:{'0':{conditions:{mobile:'tfghjggx',tablet:'tfghjggy',desktop:'tfghjggz'},defaultClass:'tfghjggx'},'2xl':{conditions:{mobile:'tfghjgh0',tablet:'tfghjgh1',desktop:'tfghjgh2'},defaultClass:'tfghjgh0'},'3xl':{conditions:{mobile:'tfghjgh3',tablet:'tfghjgh4',desktop:'tfghjgh5'},defaultClass:'tfghjgh3'},'4xl':{conditions:{mobile:'tfghjgh6',tablet:'tfghjgh7',desktop:'tfghjgh8'},defaultClass:'tfghjgh6'},'5xl':{conditions:{mobile:'tfghjgh9',tablet:'tfghjgha',desktop:'tfghjghb'},defaultClass:'tfghjgh9'},auto:{conditions:{mobile:'tfghjghc',tablet:'tfghjghd',desktop:'tfghjghe'},defaultClass:'tfghjghc'},l:{conditions:{mobile:'tfghjghf',tablet:'tfghjghg',desktop:'tfghjghh'},defaultClass:'tfghjghf'},m:{conditions:{mobile:'tfghjghi',tablet:'tfghjghj',desktop:'tfghjghk'},defaultClass:'tfghjghi'},'m-l':{conditions:{mobile:'tfghjghl',tablet:'tfghjghm',desktop:'tfghjghn'},defaultClass:'tfghjghl'},s:{conditions:{mobile:'tfghjgho',tablet:'tfghjghp',desktop:'tfghjghq'},defaultClass:'tfghjgho'},'s-m':{conditions:{mobile:'tfghjghr',tablet:'tfghjghs',desktop:'tfghjght'},defaultClass:'tfghjghr'},xl:{conditions:{mobile:'tfghjghu',tablet:'tfghjghv',desktop:'tfghjghw'},defaultClass:'tfghjghu'},xs:{conditions:{mobile:'tfghjghx',tablet:'tfghjghy',desktop:'tfghjghz'},defaultClass:'tfghjghx'},xxs:{conditions:{mobile:'tfghjgi0',tablet:'tfghjgi1',desktop:'tfghjgi2'},defaultClass:'tfghjgi0'}}},paddingRight:{values:{'0':{conditions:{mobile:'tfghjgi3',tablet:'tfghjgi4',desktop:'tfghjgi5'},defaultClass:'tfghjgi3'},'2xl':{conditions:{mobile:'tfghjgi6',tablet:'tfghjgi7',desktop:'tfghjgi8'},defaultClass:'tfghjgi6'},'3xl':{conditions:{mobile:'tfghjgi9',tablet:'tfghjgia',desktop:'tfghjgib'},defaultClass:'tfghjgi9'},'4xl':{conditions:{mobile:'tfghjgic',tablet:'tfghjgid',desktop:'tfghjgie'},defaultClass:'tfghjgic'},'5xl':{conditions:{mobile:'tfghjgif',tablet:'tfghjgig',desktop:'tfghjgih'},defaultClass:'tfghjgif'},auto:{conditions:{mobile:'tfghjgii',tablet:'tfghjgij',desktop:'tfghjgik'},defaultClass:'tfghjgii'},l:{conditions:{mobile:'tfghjgil',tablet:'tfghjgim',desktop:'tfghjgin'},defaultClass:'tfghjgil'},m:{conditions:{mobile:'tfghjgio',tablet:'tfghjgip',desktop:'tfghjgiq'},defaultClass:'tfghjgio'},'m-l':{conditions:{mobile:'tfghjgir',tablet:'tfghjgis',desktop:'tfghjgit'},defaultClass:'tfghjgir'},s:{conditions:{mobile:'tfghjgiu',tablet:'tfghjgiv',desktop:'tfghjgiw'},defaultClass:'tfghjgiu'},'s-m':{conditions:{mobile:'tfghjgix',tablet:'tfghjgiy',desktop:'tfghjgiz'},defaultClass:'tfghjgix'},xl:{conditions:{mobile:'tfghjgj0',tablet:'tfghjgj1',desktop:'tfghjgj2'},defaultClass:'tfghjgj0'},xs:{conditions:{mobile:'tfghjgj3',tablet:'tfghjgj4',desktop:'tfghjgj5'},defaultClass:'tfghjgj3'},xxs:{conditions:{mobile:'tfghjgj6',tablet:'tfghjgj7',desktop:'tfghjgj8'},defaultClass:'tfghjgj6'}}},paddingTop:{values:{'0':{conditions:{mobile:'tfghjgj9',tablet:'tfghjgja',desktop:'tfghjgjb'},defaultClass:'tfghjgj9'},'2xl':{conditions:{mobile:'tfghjgjc',tablet:'tfghjgjd',desktop:'tfghjgje'},defaultClass:'tfghjgjc'},'3xl':{conditions:{mobile:'tfghjgjf',tablet:'tfghjgjg',desktop:'tfghjgjh'},defaultClass:'tfghjgjf'},'4xl':{conditions:{mobile:'tfghjgji',tablet:'tfghjgjj',desktop:'tfghjgjk'},defaultClass:'tfghjgji'},'5xl':{conditions:{mobile:'tfghjgjl',tablet:'tfghjgjm',desktop:'tfghjgjn'},defaultClass:'tfghjgjl'},auto:{conditions:{mobile:'tfghjgjo',tablet:'tfghjgjp',desktop:'tfghjgjq'},defaultClass:'tfghjgjo'},l:{conditions:{mobile:'tfghjgjr',tablet:'tfghjgjs',desktop:'tfghjgjt'},defaultClass:'tfghjgjr'},m:{conditions:{mobile:'tfghjgju',tablet:'tfghjgjv',desktop:'tfghjgjw'},defaultClass:'tfghjgju'},'m-l':{conditions:{mobile:'tfghjgjx',tablet:'tfghjgjy',desktop:'tfghjgjz'},defaultClass:'tfghjgjx'},s:{conditions:{mobile:'tfghjgk0',tablet:'tfghjgk1',desktop:'tfghjgk2'},defaultClass:'tfghjgk0'},'s-m':{conditions:{mobile:'tfghjgk3',tablet:'tfghjgk4',desktop:'tfghjgk5'},defaultClass:'tfghjgk3'},xl:{conditions:{mobile:'tfghjgk6',tablet:'tfghjgk7',desktop:'tfghjgk8'},defaultClass:'tfghjgk6'},xs:{conditions:{mobile:'tfghjgk9',tablet:'tfghjgka',desktop:'tfghjgkb'},defaultClass:'tfghjgk9'},xxs:{conditions:{mobile:'tfghjgkc',tablet:'tfghjgkd',desktop:'tfghjgke'},defaultClass:'tfghjgkc'}}},textAlign:{values:{inherit:{conditions:{mobile:'tfghjgkf',tablet:'tfghjgkg',desktop:'tfghjgkh'},defaultClass:'tfghjgkf'},left:{conditions:{mobile:'tfghjgki',tablet:'tfghjgkj',desktop:'tfghjgkk'},defaultClass:'tfghjgki'},right:{conditions:{mobile:'tfghjgkl',tablet:'tfghjgkm',desktop:'tfghjgkn'},defaultClass:'tfghjgkl'},center:{conditions:{mobile:'tfghjgko',tablet:'tfghjgkp',desktop:'tfghjgkq'},defaultClass:'tfghjgko'}}},textTransform:{values:{capitalize:{conditions:{mobile:'tfghjgkr',tablet:'tfghjgks',desktop:'tfghjgkt'},defaultClass:'tfghjgkr'},lowercase:{conditions:{mobile:'tfghjgku',tablet:'tfghjgkv',desktop:'tfghjgkw'},defaultClass:'tfghjgku'},uppercase:{conditions:{mobile:'tfghjgkx',tablet:'tfghjgky',desktop:'tfghjgkz'},defaultClass:'tfghjgkx'}}},textOverflow:{values:{ellipsis:{conditions:{mobile:'tfghjgl0',tablet:'tfghjgl1',desktop:'tfghjgl2'},defaultClass:'tfghjgl0'}}},width:{values:{'100vw':{conditions:{mobile:'tfghjgl3',tablet:'tfghjgl4',desktop:'tfghjgl5'},defaultClass:'tfghjgl3'},'100%':{conditions:{mobile:'tfghjgl6',tablet:'tfghjgl7',desktop:'tfghjgl8'},defaultClass:'tfghjgl6'},'100px':{conditions:{mobile:'tfghjgl9',tablet:'tfghjgla',desktop:'tfghjglb'},defaultClass:'tfghjgl9'},'170px':{conditions:{mobile:'tfghjglc',tablet:'tfghjgld',desktop:'tfghjgle'},defaultClass:'tfghjglc'}}},maxWidth:{values:{'100%':{conditions:{mobile:'tfghjglf',tablet:'tfghjglg',desktop:'tfghjglh'},defaultClass:'tfghjglf'}}},objectFit:{values:{contain:{conditions:{mobile:'tfghjgli',tablet:'tfghjglj',desktop:'tfghjglk'},defaultClass:'tfghjgli'}}},whiteSpace:{values:{nowrap:{conditions:{mobile:'tfghjgll',tablet:'tfghjglm',desktop:'tfghjgln'},defaultClass:'tfghjgll'},'pre-wrap':{conditions:{mobile:'tfghjglo',tablet:'tfghjglp',desktop:'tfghjglq'},defaultClass:'tfghjglo'}}},fontFamily:{values:{'Bagoss Condensed':{conditions:{mobile:'tfghjglr',tablet:'tfghjgls',desktop:'tfghjglt'},defaultClass:'tfghjglr'}}},visibility:{values:{visible:{conditions:{mobile:'tfghjglu',tablet:'tfghjglv',desktop:'tfghjglw'},defaultClass:'tfghjglu'},hidden:{conditions:{mobile:'tfghjglx',tablet:'tfghjgly',desktop:'tfghjglz'},defaultClass:'tfghjglx'},inherit:{conditions:{mobile:'tfghjgm0',tablet:'tfghjgm1',desktop:'tfghjgm2'},defaultClass:'tfghjgm0'}}}}},{conditions:{defaultCondition:'mobile',conditionNames:['mobile','tablet','desktop'],responsiveArray:undefined},styles:{zIndex:{values:{'20':{conditions:{mobile:'_1b5wm200',tablet:'_1b5wm201',desktop:'_1b5wm202'},defaultClass:'_1b5wm200'},'21':{conditions:{mobile:'_1b5wm203',tablet:'_1b5wm204',desktop:'_1b5wm205'},defaultClass:'_1b5wm203'},'22':{conditions:{mobile:'_1b5wm206',tablet:'_1b5wm207',desktop:'_1b5wm208'},defaultClass:'_1b5wm206'},'23':{conditions:{mobile:'_1b5wm209',tablet:'_1b5wm20a',desktop:'_1b5wm20b'},defaultClass:'_1b5wm209'},'24':{conditions:{mobile:'_1b5wm20c',tablet:'_1b5wm20d',desktop:'_1b5wm20e'},defaultClass:'_1b5wm20c'},'25':{conditions:{mobile:'_1b5wm20f',tablet:'_1b5wm20g',desktop:'_1b5wm20h'},defaultClass:'_1b5wm20f'},'26':{conditions:{mobile:'_1b5wm20i',tablet:'_1b5wm20j',desktop:'_1b5wm20k'},defaultClass:'_1b5wm20i'},'27':{conditions:{mobile:'_1b5wm20l',tablet:'_1b5wm20m',desktop:'_1b5wm20n'},defaultClass:'_1b5wm20l'},'28':{conditions:{mobile:'_1b5wm20o',tablet:'_1b5wm20p',desktop:'_1b5wm20q'},defaultClass:'_1b5wm20o'}}},transform:{values:{none:{conditions:{mobile:'_1b5wm20r',tablet:'_1b5wm20s',desktop:'_1b5wm20t'},defaultClass:'_1b5wm20r'},'translateZ(0)':{conditions:{mobile:'_1b5wm20u',tablet:'_1b5wm20v',desktop:'_1b5wm20w'},defaultClass:'_1b5wm20u'},'rotate(180deg)':{conditions:{mobile:'_1b5wm20x',tablet:'_1b5wm20y',desktop:'_1b5wm20z'},defaultClass:'_1b5wm20x'},'rotate(90deg)':{conditions:{mobile:'_1b5wm2010',tablet:'_1b5wm2011',desktop:'_1b5wm2012'},defaultClass:'_1b5wm2010'},'translate3d(0,0,0)':{conditions:{mobile:'_1b5wm2013',tablet:'_1b5wm2014',desktop:'_1b5wm2015'},defaultClass:'_1b5wm2013'}}},rowGap:{values:{'0':{conditions:{mobile:'_1b5wm2016',tablet:'_1b5wm2017',desktop:'_1b5wm2018'},defaultClass:'_1b5wm2016'},'2xl':{conditions:{mobile:'_1b5wm2019',tablet:'_1b5wm201a',desktop:'_1b5wm201b'},defaultClass:'_1b5wm2019'},'3xl':{conditions:{mobile:'_1b5wm201c',tablet:'_1b5wm201d',desktop:'_1b5wm201e'},defaultClass:'_1b5wm201c'},'4xl':{conditions:{mobile:'_1b5wm201f',tablet:'_1b5wm201g',desktop:'_1b5wm201h'},defaultClass:'_1b5wm201f'},'5xl':{conditions:{mobile:'_1b5wm201i',tablet:'_1b5wm201j',desktop:'_1b5wm201k'},defaultClass:'_1b5wm201i'},auto:{conditions:{mobile:'_1b5wm201l',tablet:'_1b5wm201m',desktop:'_1b5wm201n'},defaultClass:'_1b5wm201l'},l:{conditions:{mobile:'_1b5wm201o',tablet:'_1b5wm201p',desktop:'_1b5wm201q'},defaultClass:'_1b5wm201o'},m:{conditions:{mobile:'_1b5wm201r',tablet:'_1b5wm201s',desktop:'_1b5wm201t'},defaultClass:'_1b5wm201r'},'m-l':{conditions:{mobile:'_1b5wm201u',tablet:'_1b5wm201v',desktop:'_1b5wm201w'},defaultClass:'_1b5wm201u'},s:{conditions:{mobile:'_1b5wm201x',tablet:'_1b5wm201y',desktop:'_1b5wm201z'},defaultClass:'_1b5wm201x'},'s-m':{conditions:{mobile:'_1b5wm2020',tablet:'_1b5wm2021',desktop:'_1b5wm2022'},defaultClass:'_1b5wm2020'},xl:{conditions:{mobile:'_1b5wm2023',tablet:'_1b5wm2024',desktop:'_1b5wm2025'},defaultClass:'_1b5wm2023'},xs:{conditions:{mobile:'_1b5wm2026',tablet:'_1b5wm2027',desktop:'_1b5wm2028'},defaultClass:'_1b5wm2026'},xxs:{conditions:{mobile:'_1b5wm2029',tablet:'_1b5wm202a',desktop:'_1b5wm202b'},defaultClass:'_1b5wm2029'}}},columnGap:{values:{'0':{conditions:{mobile:'_1b5wm202c',tablet:'_1b5wm202d',desktop:'_1b5wm202e'},defaultClass:'_1b5wm202c'},'2xl':{conditions:{mobile:'_1b5wm202f',tablet:'_1b5wm202g',desktop:'_1b5wm202h'},defaultClass:'_1b5wm202f'},'3xl':{conditions:{mobile:'_1b5wm202i',tablet:'_1b5wm202j',desktop:'_1b5wm202k'},defaultClass:'_1b5wm202i'},'4xl':{conditions:{mobile:'_1b5wm202l',tablet:'_1b5wm202m',desktop:'_1b5wm202n'},defaultClass:'_1b5wm202l'},'5xl':{conditions:{mobile:'_1b5wm202o',tablet:'_1b5wm202p',desktop:'_1b5wm202q'},defaultClass:'_1b5wm202o'},auto:{conditions:{mobile:'_1b5wm202r',tablet:'_1b5wm202s',desktop:'_1b5wm202t'},defaultClass:'_1b5wm202r'},l:{conditions:{mobile:'_1b5wm202u',tablet:'_1b5wm202v',desktop:'_1b5wm202w'},defaultClass:'_1b5wm202u'},m:{conditions:{mobile:'_1b5wm202x',tablet:'_1b5wm202y',desktop:'_1b5wm202z'},defaultClass:'_1b5wm202x'},'m-l':{conditions:{mobile:'_1b5wm2030',tablet:'_1b5wm2031',desktop:'_1b5wm2032'},defaultClass:'_1b5wm2030'},s:{conditions:{mobile:'_1b5wm2033',tablet:'_1b5wm2034',desktop:'_1b5wm2035'},defaultClass:'_1b5wm2033'},'s-m':{conditions:{mobile:'_1b5wm2036',tablet:'_1b5wm2037',desktop:'_1b5wm2038'},defaultClass:'_1b5wm2036'},xl:{conditions:{mobile:'_1b5wm2039',tablet:'_1b5wm203a',desktop:'_1b5wm203b'},defaultClass:'_1b5wm2039'},xs:{conditions:{mobile:'_1b5wm203c',tablet:'_1b5wm203d',desktop:'_1b5wm203e'},defaultClass:'_1b5wm203c'},xxs:{conditions:{mobile:'_1b5wm203f',tablet:'_1b5wm203g',desktop:'_1b5wm203h'},defaultClass:'_1b5wm203f'}}},boxShadow:{values:{floating:{conditions:{mobile:'_1b5wm203i',tablet:'_1b5wm203j',desktop:'_1b5wm203k'},defaultClass:'_1b5wm203i'},lifted:{conditions:{mobile:'_1b5wm203l',tablet:'_1b5wm203m',desktop:'_1b5wm203n'},defaultClass:'_1b5wm203l'},raised:{conditions:{mobile:'_1b5wm203o',tablet:'_1b5wm203p',desktop:'_1b5wm203q'},defaultClass:'_1b5wm203o'},soft:{conditions:{mobile:'_1b5wm203r',tablet:'_1b5wm203s',desktop:'_1b5wm203t'},defaultClass:'_1b5wm203r'}}},columns:{values:{'2':{conditions:{mobile:'_1b5wm203u',tablet:'_1b5wm203v',desktop:'_1b5wm203w'},defaultClass:'_1b5wm203u'},'3':{conditions:{mobile:'_1b5wm203x',tablet:'_1b5wm203y',desktop:'_1b5wm203z'},defaultClass:'_1b5wm203x'}}},borderColor:{values:{orange100:{conditions:{mobile:'_1b5wm2040',tablet:'_1b5wm2041',desktop:'_1b5wm2042'},defaultClass:'_1b5wm2040'},orange400:{conditions:{mobile:'_1b5wm2043',tablet:'_1b5wm2044',desktop:'_1b5wm2045'},defaultClass:'_1b5wm2043'},orange500:{conditions:{mobile:'_1b5wm2046',tablet:'_1b5wm2047',desktop:'_1b5wm2048'},defaultClass:'_1b5wm2046'},orange600:{conditions:{mobile:'_1b5wm2049',tablet:'_1b5wm204a',desktop:'_1b5wm204b'},defaultClass:'_1b5wm2049'},orange700:{conditions:{mobile:'_1b5wm204c',tablet:'_1b5wm204d',desktop:'_1b5wm204e'},defaultClass:'_1b5wm204c'},deepGreen100:{conditions:{mobile:'_1b5wm204f',tablet:'_1b5wm204g',desktop:'_1b5wm204h'},defaultClass:'_1b5wm204f'},deepGreen400:{conditions:{mobile:'_1b5wm204i',tablet:'_1b5wm204j',desktop:'_1b5wm204k'},defaultClass:'_1b5wm204i'},deepGreen500:{conditions:{mobile:'_1b5wm204l',tablet:'_1b5wm204m',desktop:'_1b5wm204n'},defaultClass:'_1b5wm204l'},deepGreen600:{conditions:{mobile:'_1b5wm204o',tablet:'_1b5wm204p',desktop:'_1b5wm204q'},defaultClass:'_1b5wm204o'},deepGreen700:{conditions:{mobile:'_1b5wm204r',tablet:'_1b5wm204s',desktop:'_1b5wm204t'},defaultClass:'_1b5wm204r'},green100:{conditions:{mobile:'_1b5wm204u',tablet:'_1b5wm204v',desktop:'_1b5wm204w'},defaultClass:'_1b5wm204u'},green400:{conditions:{mobile:'_1b5wm204x',tablet:'_1b5wm204y',desktop:'_1b5wm204z'},defaultClass:'_1b5wm204x'},green500:{conditions:{mobile:'_1b5wm2050',tablet:'_1b5wm2051',desktop:'_1b5wm2052'},defaultClass:'_1b5wm2050'},green600:{conditions:{mobile:'_1b5wm2053',tablet:'_1b5wm2054',desktop:'_1b5wm2055'},defaultClass:'_1b5wm2053'},green700:{conditions:{mobile:'_1b5wm2056',tablet:'_1b5wm2057',desktop:'_1b5wm2058'},defaultClass:'_1b5wm2056'},lightBlue:{conditions:{mobile:'_1b5wm2059',tablet:'_1b5wm205a',desktop:'_1b5wm205b'},defaultClass:'_1b5wm2059'},offWhite:{conditions:{mobile:'_1b5wm205c',tablet:'_1b5wm205d',desktop:'_1b5wm205e'},defaultClass:'_1b5wm205c'},greyscale0:{conditions:{mobile:'_1b5wm205f',tablet:'_1b5wm205g',desktop:'_1b5wm205h'},defaultClass:'_1b5wm205f'},greyscale50:{conditions:{mobile:'_1b5wm205i',tablet:'_1b5wm205j',desktop:'_1b5wm205k'},defaultClass:'_1b5wm205i'},greyscale100:{conditions:{mobile:'_1b5wm205l',tablet:'_1b5wm205m',desktop:'_1b5wm205n'},defaultClass:'_1b5wm205l'},greyscale200:{conditions:{mobile:'_1b5wm205o',tablet:'_1b5wm205p',desktop:'_1b5wm205q'},defaultClass:'_1b5wm205o'},greyscale300:{conditions:{mobile:'_1b5wm205r',tablet:'_1b5wm205s',desktop:'_1b5wm205t'},defaultClass:'_1b5wm205r'},greyscale400:{conditions:{mobile:'_1b5wm205u',tablet:'_1b5wm205v',desktop:'_1b5wm205w'},defaultClass:'_1b5wm205u'},greyscale500:{conditions:{mobile:'_1b5wm205x',tablet:'_1b5wm205y',desktop:'_1b5wm205z'},defaultClass:'_1b5wm205x'},greyscale600:{conditions:{mobile:'_1b5wm2060',tablet:'_1b5wm2061',desktop:'_1b5wm2062'},defaultClass:'_1b5wm2060'},greyscale900:{conditions:{mobile:'_1b5wm2063',tablet:'_1b5wm2064',desktop:'_1b5wm2065'},defaultClass:'_1b5wm2063'},success100:{conditions:{mobile:'_1b5wm2066',tablet:'_1b5wm2067',desktop:'_1b5wm2068'},defaultClass:'_1b5wm2066'},success400:{conditions:{mobile:'_1b5wm2069',tablet:'_1b5wm206a',desktop:'_1b5wm206b'},defaultClass:'_1b5wm2069'},success500:{conditions:{mobile:'_1b5wm206c',tablet:'_1b5wm206d',desktop:'_1b5wm206e'},defaultClass:'_1b5wm206c'},success600:{conditions:{mobile:'_1b5wm206f',tablet:'_1b5wm206g',desktop:'_1b5wm206h'},defaultClass:'_1b5wm206f'},success700:{conditions:{mobile:'_1b5wm206i',tablet:'_1b5wm206j',desktop:'_1b5wm206k'},defaultClass:'_1b5wm206i'},success800:{conditions:{mobile:'_1b5wm206l',tablet:'_1b5wm206m',desktop:'_1b5wm206n'},defaultClass:'_1b5wm206l'},warning100:{conditions:{mobile:'_1b5wm206o',tablet:'_1b5wm206p',desktop:'_1b5wm206q'},defaultClass:'_1b5wm206o'},warning400:{conditions:{mobile:'_1b5wm206r',tablet:'_1b5wm206s',desktop:'_1b5wm206t'},defaultClass:'_1b5wm206r'},warning500:{conditions:{mobile:'_1b5wm206u',tablet:'_1b5wm206v',desktop:'_1b5wm206w'},defaultClass:'_1b5wm206u'},warning600:{conditions:{mobile:'_1b5wm206x',tablet:'_1b5wm206y',desktop:'_1b5wm206z'},defaultClass:'_1b5wm206x'},warning700:{conditions:{mobile:'_1b5wm2070',tablet:'_1b5wm2071',desktop:'_1b5wm2072'},defaultClass:'_1b5wm2070'},warning800:{conditions:{mobile:'_1b5wm2073',tablet:'_1b5wm2074',desktop:'_1b5wm2075'},defaultClass:'_1b5wm2073'},error100:{conditions:{mobile:'_1b5wm2076',tablet:'_1b5wm2077',desktop:'_1b5wm2078'},defaultClass:'_1b5wm2076'},error400:{conditions:{mobile:'_1b5wm2079',tablet:'_1b5wm207a',desktop:'_1b5wm207b'},defaultClass:'_1b5wm2079'},error500:{conditions:{mobile:'_1b5wm207c',tablet:'_1b5wm207d',desktop:'_1b5wm207e'},defaultClass:'_1b5wm207c'},error600:{conditions:{mobile:'_1b5wm207f',tablet:'_1b5wm207g',desktop:'_1b5wm207h'},defaultClass:'_1b5wm207f'},error700:{conditions:{mobile:'_1b5wm207i',tablet:'_1b5wm207j',desktop:'_1b5wm207k'},defaultClass:'_1b5wm207i'},error800:{conditions:{mobile:'_1b5wm207l',tablet:'_1b5wm207m',desktop:'_1b5wm207n'},defaultClass:'_1b5wm207l'},white:{conditions:{mobile:'_1b5wm207o',tablet:'_1b5wm207p',desktop:'_1b5wm207q'},defaultClass:'_1b5wm207o'}}},borderRadius:{values:{'0':{conditions:{mobile:'_1b5wm2083',tablet:'_1b5wm2084',desktop:'_1b5wm2085'},defaultClass:'_1b5wm2083'},'4':{conditions:{mobile:'_1b5wm207r',tablet:'_1b5wm207s',desktop:'_1b5wm207t'},defaultClass:'_1b5wm207r'},'8':{conditions:{mobile:'_1b5wm207u',tablet:'_1b5wm207v',desktop:'_1b5wm207w'},defaultClass:'_1b5wm207u'},'16':{conditions:{mobile:'_1b5wm207x',tablet:'_1b5wm207y',desktop:'_1b5wm207z'},defaultClass:'_1b5wm207x'},'24':{conditions:{mobile:'_1b5wm2080',tablet:'_1b5wm2081',desktop:'_1b5wm2082'},defaultClass:'_1b5wm2080'}}},borderTopRightRadius:{values:{'0':{conditions:{mobile:'_1b5wm208i',tablet:'_1b5wm208j',desktop:'_1b5wm208k'},defaultClass:'_1b5wm208i'},'4':{conditions:{mobile:'_1b5wm2086',tablet:'_1b5wm2087',desktop:'_1b5wm2088'},defaultClass:'_1b5wm2086'},'8':{conditions:{mobile:'_1b5wm2089',tablet:'_1b5wm208a',desktop:'_1b5wm208b'},defaultClass:'_1b5wm2089'},'16':{conditions:{mobile:'_1b5wm208c',tablet:'_1b5wm208d',desktop:'_1b5wm208e'},defaultClass:'_1b5wm208c'},'24':{conditions:{mobile:'_1b5wm208f',tablet:'_1b5wm208g',desktop:'_1b5wm208h'},defaultClass:'_1b5wm208f'}}},borderBottomRightRadius:{values:{'0':{conditions:{mobile:'_1b5wm208x',tablet:'_1b5wm208y',desktop:'_1b5wm208z'},defaultClass:'_1b5wm208x'},'4':{conditions:{mobile:'_1b5wm208l',tablet:'_1b5wm208m',desktop:'_1b5wm208n'},defaultClass:'_1b5wm208l'},'8':{conditions:{mobile:'_1b5wm208o',tablet:'_1b5wm208p',desktop:'_1b5wm208q'},defaultClass:'_1b5wm208o'},'16':{conditions:{mobile:'_1b5wm208r',tablet:'_1b5wm208s',desktop:'_1b5wm208t'},defaultClass:'_1b5wm208r'},'24':{conditions:{mobile:'_1b5wm208u',tablet:'_1b5wm208v',desktop:'_1b5wm208w'},defaultClass:'_1b5wm208u'}}},borderTopLeftRadius:{values:{'0':{conditions:{mobile:'_1b5wm209c',tablet:'_1b5wm209d',desktop:'_1b5wm209e'},defaultClass:'_1b5wm209c'},'4':{conditions:{mobile:'_1b5wm2090',tablet:'_1b5wm2091',desktop:'_1b5wm2092'},defaultClass:'_1b5wm2090'},'8':{conditions:{mobile:'_1b5wm2093',tablet:'_1b5wm2094',desktop:'_1b5wm2095'},defaultClass:'_1b5wm2093'},'16':{conditions:{mobile:'_1b5wm2096',tablet:'_1b5wm2097',desktop:'_1b5wm2098'},defaultClass:'_1b5wm2096'},'24':{conditions:{mobile:'_1b5wm2099',tablet:'_1b5wm209a',desktop:'_1b5wm209b'},defaultClass:'_1b5wm2099'}}},borderBottomLeftRadius:{values:{'0':{conditions:{mobile:'_1b5wm209r',tablet:'_1b5wm209s',desktop:'_1b5wm209t'},defaultClass:'_1b5wm209r'},'4':{conditions:{mobile:'_1b5wm209f',tablet:'_1b5wm209g',desktop:'_1b5wm209h'},defaultClass:'_1b5wm209f'},'8':{conditions:{mobile:'_1b5wm209i',tablet:'_1b5wm209j',desktop:'_1b5wm209k'},defaultClass:'_1b5wm209i'},'16':{conditions:{mobile:'_1b5wm209l',tablet:'_1b5wm209m',desktop:'_1b5wm209n'},defaultClass:'_1b5wm209l'},'24':{conditions:{mobile:'_1b5wm209o',tablet:'_1b5wm209p',desktop:'_1b5wm209q'},defaultClass:'_1b5wm209o'}}},maxHeight:{values:{'100%':{conditions:{mobile:'_1b5wm209u',tablet:'_1b5wm209v',desktop:'_1b5wm209w'},defaultClass:'_1b5wm209u'}}},minHeight:{values:{'100vh':{conditions:{mobile:'_1b5wm209x',tablet:'_1b5wm209y',desktop:'_1b5wm209z'},defaultClass:'_1b5wm209x'}}},minWidth:{values:{'0':{conditions:{mobile:'_1b5wm20a3',tablet:'_1b5wm20a4',desktop:'_1b5wm20a5'},defaultClass:'_1b5wm20a3'},initial:{conditions:{mobile:'_1b5wm20a0',tablet:'_1b5wm20a1',desktop:'_1b5wm20a2'},defaultClass:'_1b5wm20a0'},'50%':{conditions:{mobile:'_1b5wm20a6',tablet:'_1b5wm20a7',desktop:'_1b5wm20a8'},defaultClass:'_1b5wm20a6'},'100%':{conditions:{mobile:'_1b5wm20a9',tablet:'_1b5wm20aa',desktop:'_1b5wm20ab'},defaultClass:'_1b5wm20a9'}}},opacity:{values:{'0':{conditions:{mobile:'_1b5wm20ac',tablet:'_1b5wm20ad',desktop:'_1b5wm20ae'},defaultClass:'_1b5wm20ac'},'1':{conditions:{mobile:'_1b5wm20af',tablet:'_1b5wm20ag',desktop:'_1b5wm20ah'},defaultClass:'_1b5wm20af'}}},flexShrink:{values:{'0':{conditions:{mobile:'_1b5wm20ai',tablet:'_1b5wm20aj',desktop:'_1b5wm20ak'},defaultClass:'_1b5wm20ai'},'1':{conditions:{mobile:'_1b5wm20al',tablet:'_1b5wm20am',desktop:'_1b5wm20an'},defaultClass:'_1b5wm20al'},'2':{conditions:{mobile:'_1b5wm20ao',tablet:'_1b5wm20ap',desktop:'_1b5wm20aq'},defaultClass:'_1b5wm20ao'}}},userSelect:{values:{none:{conditions:{mobile:'_1b5wm20ar',tablet:'_1b5wm20as',desktop:'_1b5wm20at'},defaultClass:'_1b5wm20ar'},auto:{conditions:{mobile:'_1b5wm20au',tablet:'_1b5wm20av',desktop:'_1b5wm20aw'},defaultClass:'_1b5wm20au'}}},fill:{values:{none:{conditions:{mobile:'_1b5wm20ax',tablet:'_1b5wm20ay',desktop:'_1b5wm20az'},defaultClass:'_1b5wm20ax'},currentcolor:{conditions:{mobile:'_1b5wm20b0',tablet:'_1b5wm20b1',desktop:'_1b5wm20b2'},defaultClass:'_1b5wm20b0'}}},fontWeight:{values:{'100':{conditions:{mobile:'_1b5wm20b3',tablet:'_1b5wm20b4',desktop:'_1b5wm20b5'},defaultClass:'_1b5wm20b3'},'200':{conditions:{mobile:'_1b5wm20b6',tablet:'_1b5wm20b7',desktop:'_1b5wm20b8'},defaultClass:'_1b5wm20b6'},'300':{conditions:{mobile:'_1b5wm20b9',tablet:'_1b5wm20ba',desktop:'_1b5wm20bb'},defaultClass:'_1b5wm20b9'},'400':{conditions:{mobile:'_1b5wm20bc',tablet:'_1b5wm20bd',desktop:'_1b5wm20be'},defaultClass:'_1b5wm20bc'},'500':{conditions:{mobile:'_1b5wm20bf',tablet:'_1b5wm20bg',desktop:'_1b5wm20bh'},defaultClass:'_1b5wm20bf'},'600':{conditions:{mobile:'_1b5wm20bi',tablet:'_1b5wm20bj',desktop:'_1b5wm20bk'},defaultClass:'_1b5wm20bi'},'700':{conditions:{mobile:'_1b5wm20bl',tablet:'_1b5wm20bm',desktop:'_1b5wm20bn'},defaultClass:'_1b5wm20bl'},'800':{conditions:{mobile:'_1b5wm20bo',tablet:'_1b5wm20bp',desktop:'_1b5wm20bq'},defaultClass:'_1b5wm20bo'}}},overflowY:{values:{auto:{conditions:{mobile:'_1b5wm20br',tablet:'_1b5wm20bs',desktop:'_1b5wm20bt'},defaultClass:'_1b5wm20br'}}}}});

/***/ }),

/***/ 29070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ color; },
/* harmony export */   "CA": function() { return /* binding */ sticky; },
/* harmony export */   "Cz": function() { return /* binding */ backgroundColor; },
/* harmony export */   "E9": function() { return /* binding */ marginTop; },
/* harmony export */   "Et": function() { return /* binding */ paddingBottom; },
/* harmony export */   "LH": function() { return /* binding */ ellipsis; },
/* harmony export */   "OY": function() { return /* binding */ noShrink; },
/* harmony export */   "SG": function() { return /* binding */ gap; },
/* harmony export */   "_7": function() { return /* binding */ flexCenter; },
/* harmony export */   "c2": function() { return /* binding */ absoluteCenterPositioning; },
/* harmony export */   "h8": function() { return /* binding */ flexBetween; },
/* harmony export */   "hh": function() { return /* binding */ flexColumnSpaceBetween; },
/* harmony export */   "i3": function() { return /* binding */ flexColumn; },
/* harmony export */   "m9": function() { return /* binding */ gridCenter; },
/* harmony export */   "o3": function() { return /* binding */ padding; },
/* harmony export */   "oI": function() { return /* binding */ marginLeft; },
/* harmony export */   "od": function() { return /* binding */ paddingTop; },
/* harmony export */   "wK": function() { return /* binding */ rotate90; },
/* harmony export */   "wx": function() { return /* binding */ pointShapeDivider; },
/* harmony export */   "wz": function() { return /* binding */ marginRight; },
/* harmony export */   "yl": function() { return /* binding */ marginBottom; },
/* harmony export */   "zu": function() { return /* binding */ outlineStyle; }
/* harmony export */ });
/* unused harmony exports alignCenter, margin, paddingLeft, paddingRight, rotate45deg */
/* harmony import */ var src_design_lib_style_theme_sprinkles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_design_lib_style_theme_sprinkles_css_ts_vanilla_css_source_H4sIAAAAAAAAA6WZ227jSBJE3_srCCwW8ADtBlm8e19GN37EviwoibrYkihTlCV7MP_sKXqVkVGimxMdz_MoE4WmRUhkcr48b9gGp_2xve9v7553sfjejevzk_e8f_z7e9vP_xqCKuBs5rAqnFWc1gNndUZrEbO6gJWY2d1DauJs7qB1dRZrWE1c1abr9W2KXeHRd1sn7xdvasc4ojE139uyrb674P_h4OeEW3qtmyrhyDz59XSZQNfgXPChuo9hPMH_7v_HW4kuAjV1KfHZbl_8vz92V3P3fUoQ2DmAkmEwMIFMnGJtQvkCQIbFyiPbe0CtQsYcQ_NCwTiEkfYQdzkGbqAdePDFQwCoQuEAgAlsAcDSoj6ixCzenPc7riYZiEQoadZC0ZIajaCEaqaWjBCWNMIRmhrjoIR8pqzYITCoS_3wXsOQ9kXIom8FCoR5oIRaodSLewqlGqJXS5iTevz42FVzuvTk_d7yf78dUSe7zXLaflg8u_f_9Lv_o_Q_fCHG1Ju9ufPrntU16T687qfZ9_jvCHlwf7s9bv1W1scnjz3_RKe3VX3_RL51ys386p5nNWbunny_lUURTzJXTDk4DgZuE_dKOHgMEvcG4tyDuZ5ULjgjIGTJBsEIxdccHAymgxdcM3AfDgMhu6DPdowMA7SNHWfxFHNQD8JxyGcY0PBOAzMxAWPtJm8yAv3QR6dGTjIJsl44IAx1TpJxtHQPfCYam3iUTBw3RNTrYNJPshcrWOq9Tgp4gIuTbUukiIp3JeqmGpdfP1xQap1EX_dUGq9ST7_OuCVOtxNI7GcDxU62E4DIdwPFTrNEzDFECqdWxiE8M7J9U6GAfjwP0oJFTrwARZ4Pox4Z9rv8gnAFKtB9E4z10_JlTrLB6NU_czk1Ctk3Tkx_5ba0K1jseDcQT3yD_XJh9E7ocroVoXRZFP3O_ehGpdFOM8g0tTrYtiNE6ga6p1UYz8yLVZSrWeJINx6N5jSrUejfJB6Hadcq3HkwlonfLv8DAfgNYp_w4v0hy0Tvl3_DBOQeuUaj2OoglonVKth6MoAa1TTWv8SkkdrZtyvj4e5DtLemQUvkSlZ0aJV7bMZ5h4_8tChrnPtMwRt633j816uWrVPrL8Po8dZbP7vOxtcb9Adrm_XwD9OvpP67att10t150louums0Q2fuyskb2fO2vc9nMfD2tTLfTW8_Aujm3nwkwOLlrOhZkcXrSbCzM5PLS6IGdzv9t1V4VomLmpo2fmpo62mZvudX5x0rY8P66qTzM8eYHv_9tlLs7Zrne3zNvKgUr_J3Raz9vVk7ferdt1uXGpECn3dsoE12O4mTJHQtxveZG_3pezdfsuLrFwV93Xn_Ki62JTff6iata7F1G_kQTsUUvCfRsrLyodD1XzeKg21awlk7DyKCHxy768aLNYbzZki6l_szo7Nk21a78eTy51EWVR79rH0y_BXSaRjEEml0yIzEwyETILycTIrCWTILORTIpMLZkMmYta9VvVLDb16fH9lw5_bqv5uvQOs6aqdl65m3sPN85Mk2x_uOr_NcM7Ot_YSLseX_fMpFgAsGkgjGCKQUTCmYumEgwS8HEgnkWTCKYrWBSwewFkwnmcGXEHBm4N8nBNBkK3mUBzpShIgjUklypiO7c1c18Gcus4O6UGakSqctsErE5YpfxJGJLxDJ60WfELkNKxLaIXT5FiO0RM_TeDogF9KJvYjfawrvolFAmENc0DIsQCykmFGV9GqEo3csKKibXCC4JSD1inglJbWK2hKROMXtCUrOYAyGpX8wbIallzDshqWvCgO3JOgoj1jsDU3ZxpmVYEpI6KGSqs85Dpjrd0Yr_W9Nw3GRLN7k_E8c99nSPjsk4bnKgm9yfj_Merr0uU3Jk3pGRz9ko_HkvdGKOeKThl7k54qmGX6bniJcafpmhIz7nuJ2kI77U8Ms8HfFnjtupOuJbjtvZOuJ7jtsJO_IHBb_O2RF_U1q9TtsRf_e4nbkDHiuesZN3xBXP2Pk74opn7BQeccUzdhaPuOIZO5FHXPGMHaIhrnjGTucRVzxjZ_SIK56xk3rEFc_YeT3iimfs1B5xxTN2dg94onjGTvARVzxj5_iIa98z12k_4opn7EwfccUzdrKPuOIZO99HXPGMnfIjrn3PXGf9iCuesRN_xBXP2Lk_4opn7PQfccUzNgPA35KKZ2wSgLjiGZsHIK555poKIK49m67ZAOLas_maECCuPZuuOQHiimdsWoC44hmbGSCue4Z96aXgGWc2iewbZ9mrafrOWfpqnAUcpm_cWcRh_VTPwCRKuoBVZVcV6zebd1XxzpddZfwMnrvKyGmAj_TsAQv3PQrpmRx6FPJjeetRyU_mvUelPJw8kAcqZ_VYFHUUsUPJiSnJxB6riCnJ0B6riClxbo8lS3p_3Wfx3F1Hj4O7sseJcFf2OBTuyq5zsY6UqQaS1oEk28BZanCDYsKBbCRZeZtlKqmY3GRZSo52U1oL3SYfyCyRka_QpfUHpiDIbRlH9tszjoyrrdokF0H0jaF0PlRajW8zEmCmgcO4SQmyVlyZlyCZMtIwsmRkyMg5IyNGLhkZM_KZkQkjt4xMGblnZMZIq7rMVz7Jrowl8D_OSBkMdct74UssWCkczPBSNdOBSNfsCvByEHFSjDyd_yLYORL5U4w8rX2VTDyR3B7ZbpClpPk7ocsH7KgK2QxaokWssR37upOyGIFvx_yTJHiIUuFGA9ZVojxkOUFMR6y7BDjIcsrYjxkaRHjIctJ7EZb_BCdsim9EdekiUeMGA9ZhKI0GRCK0r2soJ0hy4qAPGR5ISQPWXaE5CHLKyF5yNISkocsJ0LykOWDkDxkMWxPGrLErHcGZuziNOiYEpKHLEx1GrIw1emOVvR_FLLs6Ca_F7K80j1_M2Rp6Sa_F7K49uIhywcyJGQxP_lV8gSazgPWTIN5yHLVMN5yFJxXAtZVhrOQ5YXjmshy47jWsjyynEtZGkVXAlZTkqrSsjywXEtZFE8o4Usime0kEXxjBayKJ7RQhbFM1rIonhGC1kUz2ghi_IZLWRRPKOFLIpntJBF8YwWsiie0UIWxTNayKJ4RgtZtO8ZJWRRPKOFLIpntJBF8YwWsiie0UIW7XtGCVkUz2ghi_IZLWRRPKOFLIpntJBF8YwWsiie0UIWzTNKyKI9m5SQRXs2KSGL9mxSQhbFM1rIonhGC1l0z9CQBTxzN2Q5cZaGLB_c5TN1w2E_Ro85TGIFMEnPkGXaVUUDhaqrine_6irjZ_DSVUZOA3zUP2R57VFIz6TtUciP5dSjkp_MR49KMkM38kC7g4W4o4imCsSUPSIFYsoeeQIxZVeYsKLn130WL9119Di4K3ucCHdlj0Phruw6F_vI7pDFOrBHyGJu0K6QJZYsySgySdGQZSo5HrJYC90LWVbIkFDE_qMrZNkxjuz3yjgSsli1e4QsJ4bykMVqfC9kMQ5zP2Sx4naHLBkjacgyZSQNWSpG0pBlxUgasrwwkoYsO0bSkOWVkTRksaorIcv_Adh7hk_vSAAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1851);
/* harmony import */ var src_design_lib_style_theme_sprinkles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_design_lib_style_theme_sprinkles_css_ts_vanilla_css_source_H4sIAAAAAAAAA6WZ227jSBJE3_srCCwW8ADtBlm8e19GN37EviwoibrYkihTlCV7MP_sKXqVkVGimxMdz_MoE4WmRUhkcr48b9gGp_2xve9v7553sfjejevzk_e8f_z7e9vP_xqCKuBs5rAqnFWc1gNndUZrEbO6gJWY2d1DauJs7qB1dRZrWE1c1abr9W2KXeHRd1sn7xdvasc4ojE139uyrb674P_h4OeEW3qtmyrhyDz59XSZQNfgXPChuo9hPMH_7v_HW4kuAjV1KfHZbl_8vz92V3P3fUoQ2DmAkmEwMIFMnGJtQvkCQIbFyiPbe0CtQsYcQ_NCwTiEkfYQdzkGbqAdePDFQwCoQuEAgAlsAcDSoj6ixCzenPc7riYZiEQoadZC0ZIajaCEaqaWjBCWNMIRmhrjoIR8pqzYITCoS_3wXsOQ9kXIom8FCoR5oIRaodSLewqlGqJXS5iTevz42FVzuvTk_d7yf78dUSe7zXLaflg8u_f_9Lv_o_Q_fCHG1Ju9ufPrntU16T687qfZ9_jvCHlwf7s9bv1W1scnjz3_RKe3VX3_RL51ys386p5nNWbunny_lUURTzJXTDk4DgZuE_dKOHgMEvcG4tyDuZ5ULjgjIGTJBsEIxdccHAymgxdcM3AfDgMhu6DPdowMA7SNHWfxFHNQD8JxyGcY0PBOAzMxAWPtJm8yAv3QR6dGTjIJsl44IAx1TpJxtHQPfCYam3iUTBw3RNTrYNJPshcrWOq9Tgp4gIuTbUukiIp3JeqmGpdfP1xQap1EX_dUGq9ST7_OuCVOtxNI7GcDxU62E4DIdwPFTrNEzDFECqdWxiE8M7J9U6GAfjwP0oJFTrwARZ4Pox4Z9rv8gnAFKtB9E4z10_JlTrLB6NU_czk1Ctk3Tkx_5ba0K1jseDcQT3yD_XJh9E7ocroVoXRZFP3O_ehGpdFOM8g0tTrYtiNE6ga6p1UYz8yLVZSrWeJINx6N5jSrUejfJB6Hadcq3HkwlonfLv8DAfgNYp_w4v0hy0Tvl3_DBOQeuUaj2OoglonVKth6MoAa1TTWv8SkkdrZtyvj4e5DtLemQUvkSlZ0aJV7bMZ5h4_8tChrnPtMwRt633j816uWrVPrL8Po8dZbP7vOxtcb9Adrm_XwD9OvpP67att10t150louums0Q2fuyskb2fO2vc9nMfD2tTLfTW8_Aujm3nwkwOLlrOhZkcXrSbCzM5PLS6IGdzv9t1V4VomLmpo2fmpo62mZvudX5x0rY8P66qTzM8eYHv_9tlLs7Zrne3zNvKgUr_J3Raz9vVk7ferdt1uXGpECn3dsoE12O4mTJHQtxveZG_3pezdfsuLrFwV93Xn_Ki62JTff6iata7F1G_kQTsUUvCfRsrLyodD1XzeKg21awlk7DyKCHxy768aLNYbzZki6l_szo7Nk21a78eTy51EWVR79rH0y_BXSaRjEEml0yIzEwyETILycTIrCWTILORTIpMLZkMmYta9VvVLDb16fH9lw5_bqv5uvQOs6aqdl65m3sPN85Mk2x_uOr_NcM7Ot_YSLseX_fMpFgAsGkgjGCKQUTCmYumEgwS8HEgnkWTCKYrWBSwewFkwnmcGXEHBm4N8nBNBkK3mUBzpShIgjUklypiO7c1c18Gcus4O6UGakSqctsErE5YpfxJGJLxDJ60WfELkNKxLaIXT5FiO0RM_TeDogF9KJvYjfawrvolFAmENc0DIsQCykmFGV9GqEo3csKKibXCC4JSD1inglJbWK2hKROMXtCUrOYAyGpX8wbIallzDshqWvCgO3JOgoj1jsDU3ZxpmVYEpI6KGSqs85Dpjrd0Yr_W9Nw3GRLN7k_E8c99nSPjsk4bnKgm9yfj_Merr0uU3Jk3pGRz9ko_HkvdGKOeKThl7k54qmGX6bniJcafpmhIz7nuJ2kI77U8Ms8HfFnjtupOuJbjtvZOuJ7jtsJO_IHBb_O2RF_U1q9TtsRf_e4nbkDHiuesZN3xBXP2Pk74opn7BQeccUzdhaPuOIZO5FHXPGMHaIhrnjGTucRVzxjZ_SIK56xk3rEFc_YeT3iimfs1B5xxTN2dg94onjGTvARVzxj5_iIa98z12k_4opn7EwfccUzdrKPuOIZO99HXPGMnfIjrn3PXGf9iCuesRN_xBXP2Lk_4opn7PQfccUzNgPA35KKZ2wSgLjiGZsHIK555poKIK49m67ZAOLas_maECCuPZuuOQHiimdsWoC44hmbGSCue4Z96aXgGWc2iewbZ9mrafrOWfpqnAUcpm_cWcRh_VTPwCRKuoBVZVcV6zebd1XxzpddZfwMnrvKyGmAj_TsAQv3PQrpmRx6FPJjeetRyU_mvUelPJw8kAcqZ_VYFHUUsUPJiSnJxB6riCnJ0B6riClxbo8lS3p_3Wfx3F1Hj4O7sseJcFf2OBTuyq5zsY6UqQaS1oEk28BZanCDYsKBbCRZeZtlKqmY3GRZSo52U1oL3SYfyCyRka_QpfUHpiDIbRlH9tszjoyrrdokF0H0jaF0PlRajW8zEmCmgcO4SQmyVlyZlyCZMtIwsmRkyMg5IyNGLhkZM_KZkQkjt4xMGblnZMZIq7rMVz7Jrowl8D_OSBkMdct74UssWCkczPBSNdOBSNfsCvByEHFSjDyd_yLYORL5U4w8rX2VTDyR3B7ZbpClpPk7ocsH7KgK2QxaokWssR37upOyGIFvx_yTJHiIUuFGA9ZVojxkOUFMR6y7BDjIcsrYjxkaRHjIctJ7EZb_BCdsim9EdekiUeMGA9ZhKI0GRCK0r2soJ0hy4qAPGR5ISQPWXaE5CHLKyF5yNISkocsJ0LykOWDkDxkMWxPGrLErHcGZuziNOiYEpKHLEx1GrIw1emOVvR_FLLs6Ca_F7K80j1_M2Rp6Sa_F7K49uIhywcyJGQxP_lV8gSazgPWTIN5yHLVMN5yFJxXAtZVhrOQ5YXjmshy47jWsjyynEtZGkVXAlZTkqrSsjywXEtZFE8o4Usime0kEXxjBayKJ7RQhbFM1rIonhGC1kUz2ghi_IZLWRRPKOFLIpntJBF8YwWsiie0UIWxTNayKJ4RgtZtO8ZJWRRPKOFLIpntJBF8YwWsiie0UIW7XtGCVkUz2ghi_IZLWRRPKOFLIpntJBF8YwWsiie0UIWzTNKyKI9m5SQRXs2KSGL9mxSQhbFM1rIonhGC1l0z9CQBTxzN2Q5cZaGLB_c5TN1w2E_Ro85TGIFMEnPkGXaVUUDhaqrine_6irjZ_DSVUZOA3zUP2R57VFIz6TtUciP5dSjkp_MR49KMkM38kC7g4W4o4imCsSUPSIFYsoeeQIxZVeYsKLn130WL9119Di4K3ucCHdlj0Phruw6F_vI7pDFOrBHyGJu0K6QJZYsySgySdGQZSo5HrJYC90LWVbIkFDE_qMrZNkxjuz3yjgSsli1e4QsJ4bykMVqfC9kMQ5zP2Sx4naHLBkjacgyZSQNWSpG0pBlxUgasrwwkoYsO0bSkOWVkTRksaorIcv_Adh7hk_vSAAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(src_design_lib_style_theme_sprinkles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_design_lib_style_theme_sprinkles_css_ts_vanilla_css_source_H4sIAAAAAAAAA6WZ227jSBJE3_srCCwW8ADtBlm8e19GN37EviwoibrYkihTlCV7MP_sKXqVkVGimxMdz_MoE4WmRUhkcr48b9gGp_2xve9v7553sfjejevzk_e8f_z7e9vP_xqCKuBs5rAqnFWc1gNndUZrEbO6gJWY2d1DauJs7qB1dRZrWE1c1abr9W2KXeHRd1sn7xdvasc4ojE139uyrb674P_h4OeEW3qtmyrhyDz59XSZQNfgXPChuo9hPMH_7v_HW4kuAjV1KfHZbl_8vz92V3P3fUoQ2DmAkmEwMIFMnGJtQvkCQIbFyiPbe0CtQsYcQ_NCwTiEkfYQdzkGbqAdePDFQwCoQuEAgAlsAcDSoj6ixCzenPc7riYZiEQoadZC0ZIajaCEaqaWjBCWNMIRmhrjoIR8pqzYITCoS_3wXsOQ9kXIom8FCoR5oIRaodSLewqlGqJXS5iTevz42FVzuvTk_d7yf78dUSe7zXLaflg8u_f_9Lv_o_Q_fCHG1Ju9ufPrntU16T687qfZ9_jvCHlwf7s9bv1W1scnjz3_RKe3VX3_RL51ys386p5nNWbunny_lUURTzJXTDk4DgZuE_dKOHgMEvcG4tyDuZ5ULjgjIGTJBsEIxdccHAymgxdcM3AfDgMhu6DPdowMA7SNHWfxFHNQD8JxyGcY0PBOAzMxAWPtJm8yAv3QR6dGTjIJsl44IAx1TpJxtHQPfCYam3iUTBw3RNTrYNJPshcrWOq9Tgp4gIuTbUukiIp3JeqmGpdfP1xQap1EX_dUGq9ST7_OuCVOtxNI7GcDxU62E4DIdwPFTrNEzDFECqdWxiE8M7J9U6GAfjwP0oJFTrwARZ4Pox4Z9rv8gnAFKtB9E4z10_JlTrLB6NU_czk1Ctk3Tkx_5ba0K1jseDcQT3yD_XJh9E7ocroVoXRZFP3O_ehGpdFOM8g0tTrYtiNE6ga6p1UYz8yLVZSrWeJINx6N5jSrUejfJB6Hadcq3HkwlonfLv8DAfgNYp_w4v0hy0Tvl3_DBOQeuUaj2OoglonVKth6MoAa1TTWv8SkkdrZtyvj4e5DtLemQUvkSlZ0aJV7bMZ5h4_8tChrnPtMwRt633j816uWrVPrL8Po8dZbP7vOxtcb9Adrm_XwD9OvpP67att10t150louums0Q2fuyskb2fO2vc9nMfD2tTLfTW8_Aujm3nwkwOLlrOhZkcXrSbCzM5PLS6IGdzv9t1V4VomLmpo2fmpo62mZvudX5x0rY8P66qTzM8eYHv_9tlLs7Zrne3zNvKgUr_J3Raz9vVk7ferdt1uXGpECn3dsoE12O4mTJHQtxveZG_3pezdfsuLrFwV93Xn_Ki62JTff6iata7F1G_kQTsUUvCfRsrLyodD1XzeKg21awlk7DyKCHxy768aLNYbzZki6l_szo7Nk21a78eTy51EWVR79rH0y_BXSaRjEEml0yIzEwyETILycTIrCWTILORTIpMLZkMmYta9VvVLDb16fH9lw5_bqv5uvQOs6aqdl65m3sPN85Mk2x_uOr_NcM7Ot_YSLseX_fMpFgAsGkgjGCKQUTCmYumEgwS8HEgnkWTCKYrWBSwewFkwnmcGXEHBm4N8nBNBkK3mUBzpShIgjUklypiO7c1c18Gcus4O6UGakSqctsErE5YpfxJGJLxDJ60WfELkNKxLaIXT5FiO0RM_TeDogF9KJvYjfawrvolFAmENc0DIsQCykmFGV9GqEo3csKKibXCC4JSD1inglJbWK2hKROMXtCUrOYAyGpX8wbIallzDshqWvCgO3JOgoj1jsDU3ZxpmVYEpI6KGSqs85Dpjrd0Yr_W9Nw3GRLN7k_E8c99nSPjsk4bnKgm9yfj_Merr0uU3Jk3pGRz9ko_HkvdGKOeKThl7k54qmGX6bniJcafpmhIz7nuJ2kI77U8Ms8HfFnjtupOuJbjtvZOuJ7jtsJO_IHBb_O2RF_U1q9TtsRf_e4nbkDHiuesZN3xBXP2Pk74opn7BQeccUzdhaPuOIZO5FHXPGMHaIhrnjGTucRVzxjZ_SIK56xk3rEFc_YeT3iimfs1B5xxTN2dg94onjGTvARVzxj5_iIa98z12k_4opn7EwfccUzdrKPuOIZO99HXPGMnfIjrn3PXGf9iCuesRN_xBXP2Lk_4opn7PQfccUzNgPA35KKZ2wSgLjiGZsHIK555poKIK49m67ZAOLas_maECCuPZuuOQHiimdsWoC44hmbGSCue4Z96aXgGWc2iewbZ9mrafrOWfpqnAUcpm_cWcRh_VTPwCRKuoBVZVcV6zebd1XxzpddZfwMnrvKyGmAj_TsAQv3PQrpmRx6FPJjeetRyU_mvUelPJw8kAcqZ_VYFHUUsUPJiSnJxB6riCnJ0B6riClxbo8lS3p_3Wfx3F1Hj4O7sseJcFf2OBTuyq5zsY6UqQaS1oEk28BZanCDYsKBbCRZeZtlKqmY3GRZSo52U1oL3SYfyCyRka_QpfUHpiDIbRlH9tszjoyrrdokF0H0jaF0PlRajW8zEmCmgcO4SQmyVlyZlyCZMtIwsmRkyMg5IyNGLhkZM_KZkQkjt4xMGblnZMZIq7rMVz7Jrowl8D_OSBkMdct74UssWCkczPBSNdOBSNfsCvByEHFSjDyd_yLYORL5U4w8rX2VTDyR3B7ZbpClpPk7ocsH7KgK2QxaokWssR37upOyGIFvx_yTJHiIUuFGA9ZVojxkOUFMR6y7BDjIcsrYjxkaRHjIctJ7EZb_BCdsim9EdekiUeMGA9ZhKI0GRCK0r2soJ0hy4qAPGR5ISQPWXaE5CHLKyF5yNISkocsJ0LykOWDkDxkMWxPGrLErHcGZuziNOiYEpKHLEx1GrIw1emOVvR_FLLs6Ca_F7K80j1_M2Rp6Sa_F7K49uIhywcyJGQxP_lV8gSazgPWTIN5yHLVMN5yFJxXAtZVhrOQ5YXjmshy47jWsjyynEtZGkVXAlZTkqrSsjywXEtZFE8o4Usime0kEXxjBayKJ7RQhbFM1rIonhGC1kUz2ghi_IZLWRRPKOFLIpntJBF8YwWsiie0UIWxTNayKJ4RgtZtO8ZJWRRPKOFLIpntJBF8YwWsiie0UIW7XtGCVkUz2ghi_IZLWRRPKOFLIpntJBF8YwWsiie0UIWzTNKyKI9m5SQRXs2KSGL9mxSQhbFM1rIonhGC1l0z9CQBTxzN2Q5cZaGLB_c5TN1w2E_Ro85TGIFMEnPkGXaVUUDhaqrine_6irjZ_DSVUZOA3zUP2R57VFIz6TtUciP5dSjkp_MR49KMkM38kC7g4W4o4imCsSUPSIFYsoeeQIxZVeYsKLn130WL9119Di4K3ucCHdlj0Phruw6F_vI7pDFOrBHyGJu0K6QJZYsySgySdGQZSo5HrJYC90LWVbIkFDE_qMrZNkxjuz3yjgSsli1e4QsJ4bykMVqfC9kMQ5zP2Sx4naHLBkjacgyZSQNWSpG0pBlxUgasrwwkoYsO0bSkOWVkTRksaorIcv_Adh7hk_vSAAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_design_lib_style_theme_theme_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_design_lib_style_theme_theme_css_ts_vanilla_css_source_H4sIAAAAAAAAA42UyW6cQBCG73mKkrgkkomo3rtyAhpeI5rxvg4ez9jYUd49KkY5dLWRLDh91PL331XQfrc7wJ9vAHX9Gx_PN_HpviGoxnG0Q_yVcVx4cq3NuVp4F5zKuV54jDjm3BBUgwst9jm3Cx_6ocu5I6hi12HX5NwTVBa99ybngaBqnE5a6I_MrUY15HzDfeMYR5fzLUHVhsGlNufnBJVzyXTiXBcElbI9tjrnlwQVDrENwp8rgiq50Y6izjX75kY3Ys5vTvcyyvhb5pafnN_xuQI_Ob_nviaZJHQ_EFSd7nQndD4SVF577QV_Yv_VVVbo3PF5EyYU9zgxVxhQ_P_M_psxDoLv2X_TYhT_vxBUwfbJi_s98L34vrE_50fWmdpkRP3XRX9sjbj3t5PPcRDzOZ_mPwZR533hfXJCz8eJN0b4jM0y6G3SogHyhvV9bLVQhMuKpWGQFuGyYzq20iNclmz0UZqEy5Z11kuX0C1jYQZpE_Kedb1x0icMKwOJce0Psln5JeB2LeN8ZZjwYmVL8HIt42pljvF67cPNyoTj7VqPu5VZxvuVIcQHggbcNIMy0wwN7K_3m_8qnvHrz5qf_odIeOQENc0Qvhb_xPFcG93XEnacgNMMXxQ0ETTTLOAzQW1CgfcEtTMFfiGoQ1nkQFBHV_AjQa3KIq8ENZbRbxxd1p65ZUHfuYYq8AdBrQusGj5kQZEbFlQRlH4oTVDaoQxB6YayBKUZyhFsjoedoJ6gdEgFgtIgFQlKf9SGoJS7JSjdUecEn5hzQVAquCQoI6_y_r7Dy2XybuPCAAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19636);
/* harmony import */ var src_design_lib_style_theme_theme_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_design_lib_style_theme_theme_css_ts_vanilla_css_source_H4sIAAAAAAAAA42UyW6cQBCG73mKkrgkkomo3rtyAhpeI5rxvg4ez9jYUd49KkY5dLWRLDh91PL331XQfrc7wJ9vAHX9Gx_PN_HpviGoxnG0Q_yVcVx4cq3NuVp4F5zKuV54jDjm3BBUgwst9jm3Cx_6ocu5I6hi12HX5NwTVBa99ybngaBqnE5a6I_MrUY15HzDfeMYR5fzLUHVhsGlNufnBJVzyXTiXBcElbI9tjrnlwQVDrENwp8rgiq50Y6izjX75kY3Ys5vTvcyyvhb5pafnN_xuQI_Ob_nviaZJHQ_EFSd7nQndD4SVF577QV_Yv_VVVbo3PF5EyYU9zgxVxhQ_P_M_psxDoLv2X_TYhT_vxBUwfbJi_s98L34vrE_50fWmdpkRP3XRX9sjbj3t5PPcRDzOZ_mPwZR533hfXJCz8eJN0b4jM0y6G3SogHyhvV9bLVQhMuKpWGQFuGyYzq20iNclmz0UZqEy5Z11kuX0C1jYQZpE_Kedb1x0icMKwOJce0Psln5JeB2LeN8ZZjwYmVL8HIt42pljvF67cPNyoTj7VqPu5VZxvuVIcQHggbcNIMy0wwN7K_3m_8qnvHrz5qf_odIeOQENc0Qvhb_xPFcG93XEnacgNMMXxQ0ETTTLOAzQW1CgfcEtTMFfiGoQ1nkQFBHV_AjQa3KIq8ENZbRbxxd1p65ZUHfuYYq8AdBrQusGj5kQZEbFlQRlH4oTVDaoQxB6YayBKUZyhFsjoedoJ6gdEgFgtIgFQlKf9SGoJS7JSjdUecEn5hzQVAquCQoI6_y_r7Dy2XybuPCAAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(src_design_lib_style_theme_theme_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_design_lib_style_theme_theme_css_ts_vanilla_css_source_H4sIAAAAAAAAA42UyW6cQBCG73mKkrgkkomo3rtyAhpeI5rxvg4ez9jYUd49KkY5dLWRLDh91PL331XQfrc7wJ9vAHX9Gx_PN_HpviGoxnG0Q_yVcVx4cq3NuVp4F5zKuV54jDjm3BBUgwst9jm3Cx_6ocu5I6hi12HX5NwTVBa99ybngaBqnE5a6I_MrUY15HzDfeMYR5fzLUHVhsGlNufnBJVzyXTiXBcElbI9tjrnlwQVDrENwp8rgiq50Y6izjX75kY3Ys5vTvcyyvhb5pafnN_xuQI_Ob_nviaZJHQ_EFSd7nQndD4SVF577QV_Yv_VVVbo3PF5EyYU9zgxVxhQ_P_M_psxDoLv2X_TYhT_vxBUwfbJi_s98L34vrE_50fWmdpkRP3XRX9sjbj3t5PPcRDzOZ_mPwZR533hfXJCz8eJN0b4jM0y6G3SogHyhvV9bLVQhMuKpWGQFuGyYzq20iNclmz0UZqEy5Z11kuX0C1jYQZpE_Kedb1x0icMKwOJce0Psln5JeB2LeN8ZZjwYmVL8HIt42pljvF67cPNyoTj7VqPu5VZxvuVIcQHggbcNIMy0wwN7K_3m_8qnvHrz5qf_odIeOQENc0Qvhb_xPFcG93XEnacgNMMXxQ0ETTTLOAzQW1CgfcEtTMFfiGoQ1nkQFBHV_AjQa3KIq8ENZbRbxxd1p65ZUHfuYYq8AdBrQusGj5kQZEbFlQRlH4oTVDaoQxB6YayBKUZyhFsjoedoJ6gdEgFgtIgFQlKf9SGoJS7JSjdUecEn5hzQVAquCQoI6_y_r7Dy2XybuPCAAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_shared_styles_styles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_shared_styles_styles_css_ts_vanilla_css_source_H4sIAAAAAAAAA42c3XLaShZG7_MU3JyqnKrhFN36dx7mVAsJEAgJJPE7Ne8_hcmZWCvTvfdNyonXMnZsra8LDH_9bbb5PS5Oq8W_vy0WpVsftkN_6arlum_74WNxdcP35fJvc7zs8u6w_vPHt_98_sfyagkM5esSrJzKVJJ0VyKVVI8lxKVlMylVCWlcylTSdlcylVSPpcKlVTMJaeS3FwqVVI5l9YqaT2XKpVUzaVaJdVzaaOSNnNpq5K2c2mnknZzqVFJzVzaq6T9XDqopMNcalVSO5eOKuk4lzqV1M2lXiX1c_mkkk5z6aySznNpUEnDXBpV0jiXJpU0zaWLSrrMpatKus6lm0q6zaW7SrrPpYdKesylp0p6Yj51o2u4usrZxe4a3fAaLK_RTa_B9hrd_Bqsr9HNr8H_Gt0AGyyw0U2wwQYb3QgbrLDRzbDBDhvdEBsssdFNscEWG90YG6yx0c2xwR4b3SAbLLLRTbLBJhvdKBusstHNssEuG90wGyyz0U2zwTYb3TgbrLN5z7PqsH_0o0xN50eZl96PMiknP8qMnP0o0zH4UeZi9KNMxORHmYWLH2UKrn6Ul_Nj_KSv_tRXuYPP8pL_lHcTnblR_FJWyNH8Vla60fxaVqIz_Ky9PGfhSXpE38KC5Dm_pRHI1t5kdxILa5H8Ux2BZ_FIdf6_wojry29KM46Nq1H8Xx1lZ_FIdaW_tRHGXtxo_iAGu3fhTHVrvzozis2saP4ohq934UB1N78KM4jtrAFvAMakNjwDt8AmvA06YNzAGPmDawBzxX2sAg8DBpA4vAE6QNTAKPjTawCTwr2sAo8IBoA6vAU6ENzAKPgjawCzz_2cAw8NBnA8vAk14UmAYe76LANvBMFwXGgQe5KLAOPL1FgXngkS0K7APPadF7IE6uqppu_xuN7kZZkEZ6ozxIo75REaQR4MgFaTQ4KoM0MhytgzRKHFVBGjGO6iCNHkebII0kR9sgjSpHuxBt0eWoCdIoc7QP0rwP_hCkUeeoDdLoc3QM0ih01AVpNDrqgzQqHZ2CNDodnYM0Sh0NQRqtjsYgjVpHU5BGr6NLkEaxo2uQZrNvX_nl1J_EXt1Fg816iAa79RQNtCteiQb6FRvRQMNiKxroWByJBloWx6KBnsWJaKBpcSoa6FqcSQbbFueigb7FhWigcbETDT7IWIoGWhevRQO9iyvRQPPiWjTQvXgjGmhfvBUN9C_eiQYaGDeigQ7Ge9FAC_ODaKCHcSsaaGI827fl0Gx3k1TFuFM46GLcKxyUMT4pHLbxrHBYx0HhsI_jwmEhJ4XDRl4UDit5VTjs5E3hsJR32fmtlQ_Fw1o_FQ56mawUDoqZGIXD38qwCgfVTCKFg24mscJBOZNE4aCdSapwUM8kUzjoZ5IrHBQ0KRQOGpo4hYOKJqXCQUeT_XaW_TT1RymkSaWRUNKk1khIabLRSGhpstVIiGmy00ioadJoJOQ02Wsk9DQ5aCQENWk1EoqaHDUSkpp0ColNTXqNhKgmJ43Eqp41ErM6aCR2ddRIDOukkVjWi0ZiWq8aiW29aSTG9a6RWNeHRmJenxoJfU1XGgmBTY1GQmHT_dK29UY8qKaRrKCuaSwraGuayArKmqaygq6mmaygqmkuK2hqWsgKipo6WUFP01JWUNN0LStoaVqJCkua1rKCjqYbWUFF062soKHpTlZQ0LSRFf628F5WUM_0ICtoZ9rKCsqZHmUF3Uw7WUE1015W0Mz0JCss5llW2MtBVljL934e3bBtOrGTUwhmIS8hmG28hmBW8RaC2cN7CGYJHyGYDXyGYNQvW4VgdC8zIRjFy2wIRuuyKACzclkcgtG3LAnBKFuWhmA0LctCMGqW5SEYHcuKEMxnO7gQjHZlZQhGtbJ1CEavsioEo1RZHYLRqGwTglGnbBuC0aVsF4JRpKz5AmsefMn2koAyZQdJQJ2yVhJQqOwoCahU1kkCSpX1koBaZSdJYLHOksBqDZLAco2SwHpNgvBbwS6SwIpdJYElu0kCa3aXBBbtIQms2lMSULZ8JQl8DpeRBBQut5KAyuWRJKB0eSwJqF2eSAKKl6eSgOrlmSSgfPnX7dI9xJIXsoL65U5W0L_8lBUUMF_LChqYV7KCCua1rKCD_UZWUMJ8KytoYb6TFdQwb2QFPcz3osIi5gdZQRPzVlZQxfwoK_hi3skKypj3soI25idZYR3PssI_DrLCQo6ywkZOssJKXmSFnbzKCkt5kxW28i4rrOVsF3UPpORPhYNeFiuFg2AWRuGgmIVVOEhmESkcNLOIFQ6iWSQKB9UsUoWDbBaZwkE3i1zhIJxFITssZ_EUDtJZlAoH7SzWCgfxLCqFg3oWtcJBPouNwkE_i63CQUCLncLhawQ0CgcJLfYKBw0tDgoHES1ahYOKFkeFg4wWncJBR4vZimoeLilOosGGnkWDBR1Eg_0cRYP1nESD7byIBst5FQ128yYarOZdNNjMh2iwmE_JYC_dSjRQS2dEA610VjRQSheJBjrpYtFAJV0iGmikS0UDhXSZaKCPLhcNvoBKIRpoo3OigTK6UjTQRbcWDVTRVaKBJrr3Nm6deOej23hJNNBtvSTa53ZeEs1zjZdE69zeS6Jx7uAl0TbXekk0zR29JFrmOi_JhrneS6Jd7uQjf2vW2UuyVYOXZKNGL8k2TV6STbp4Sbbo6iXZoJuXZHvuXpLNeXhJtubpJfkKTSsvibaUxkuiKaX1kmhJGXlJNKR870Z_rYdN298_Frumqurux7fFYqrv0_LXO_q2bU5jM77edds1U70cT25dfyy6_ja40_yjvru_HZpqOdXHU_um_vVKCZdjN34szGZYuMvUv96Ya_47y_j1Gwey3XfTXU3fSw_b2hZ1tOtfn9qVTOeWvf4WGza_j7_EO81eP37smqGej01ffexeN_2oL5n4fPLdm2zfWl1N9X4HMtfNzDuhqY7fCxWc_Kd_mlw3bjph_PHYugnN9Xf46Sq8QTJsvKwxep3VvdyHK_nkS8WZT9U9bAcXNVcxo9Fsvpj9sU3Xdt09bJs_Xh9Y5d_b4zIz7df4Qft1ssrvUwNWvX_vOfdGyqqq0_fyyaatr9_CBfP_H3pvSX6fNG_81mrP_SP_CNE_RL3_Gkk_Nu_v8jg168Pj82f3dT82vi0NaFeOfXuZ6v_xP_T3tP78y9fvjOfb75_kr8vk9Uf_1q8_nx9Qv8FSNKFzd1PAAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2848);
/* harmony import */ var src_shared_styles_styles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_shared_styles_styles_css_ts_vanilla_css_source_H4sIAAAAAAAAA42c3XLaShZG7_MU3JyqnKrhFN36dx7mVAsJEAgJJPE7Ne8_hcmZWCvTvfdNyonXMnZsra8LDH_9bbb5PS5Oq8W_vy0WpVsftkN_6arlum_74WNxdcP35fJvc7zs8u6w_vPHt_98_sfyagkM5esSrJzKVJJ0VyKVVI8lxKVlMylVCWlcylTSdlcylVSPpcKlVTMJaeS3FwqVVI5l9YqaT2XKpVUzaVaJdVzaaOSNnNpq5K2c2mnknZzqVFJzVzaq6T9XDqopMNcalVSO5eOKuk4lzqV1M2lXiX1c_mkkk5z6aySznNpUEnDXBpV0jiXJpU0zaWLSrrMpatKus6lm0q6zaW7SrrPpYdKesylp0p6Yj51o2u4usrZxe4a3fAaLK_RTa_B9hrd_Bqsr9HNr8H_Gt0AGyyw0U2wwQYb3QgbrLDRzbDBDhvdEBsssdFNscEWG90YG6yx0c2xwR4b3SAbLLLRTbLBJhvdKBusstHNssEuG90wGyyz0U2zwTYb3TgbrLN5z7PqsH_0o0xN50eZl96PMiknP8qMnP0o0zH4UeZi9KNMxORHmYWLH2UKrn6Ul_Nj_KSv_tRXuYPP8pL_lHcTnblR_FJWyNH8Vla60fxaVqIz_Ky9PGfhSXpE38KC5Dm_pRHI1t5kdxILa5H8Ux2BZ_FIdf6_wojry29KM46Nq1H8Xx1lZ_FIdaW_tRHGXtxo_iAGu3fhTHVrvzozis2saP4ohq934UB1N78KM4jtrAFvAMakNjwDt8AmvA06YNzAGPmDawBzxX2sAg8DBpA4vAE6QNTAKPjTawCTwr2sAo8IBoA6vAU6ENzAKPgjawCzz_2cAw8NBnA8vAk14UmAYe76LANvBMFwXGgQe5KLAOPL1FgXngkS0K7APPadF7IE6uqppu_xuN7kZZkEZ6ozxIo75REaQR4MgFaTQ4KoM0MhytgzRKHFVBGjGO6iCNHkebII0kR9sgjSpHuxBt0eWoCdIoc7QP0rwP_hCkUeeoDdLoc3QM0ih01AVpNDrqgzQqHZ2CNDodnYM0Sh0NQRqtjsYgjVpHU5BGr6NLkEaxo2uQZrNvX_nl1J_EXt1Fg816iAa79RQNtCteiQb6FRvRQMNiKxroWByJBloWx6KBnsWJaKBpcSoa6FqcSQbbFueigb7FhWigcbETDT7IWIoGWhevRQO9iyvRQPPiWjTQvXgjGmhfvBUN9C_eiQYaGDeigQ7Ge9FAC_ODaKCHcSsaaGI827fl0Gx3k1TFuFM46GLcKxyUMT4pHLbxrHBYx0HhsI_jwmEhJ4XDRl4UDit5VTjs5E3hsJR32fmtlQ_Fw1o_FQ56mawUDoqZGIXD38qwCgfVTCKFg24mscJBOZNE4aCdSapwUM8kUzjoZ5IrHBQ0KRQOGpo4hYOKJqXCQUeT_XaW_TT1RymkSaWRUNKk1khIabLRSGhpstVIiGmy00ioadJoJOQ02Wsk9DQ5aCQENWk1EoqaHDUSkpp0ColNTXqNhKgmJ43Eqp41ErM6aCR2ddRIDOukkVjWi0ZiWq8aiW29aSTG9a6RWNeHRmJenxoJfU1XGgmBTY1GQmHT_dK29UY8qKaRrKCuaSwraGuayArKmqaygq6mmaygqmkuK2hqWsgKipo6WUFP01JWUNN0LStoaVqJCkua1rKCjqYbWUFF062soKHpTlZQ0LSRFf628F5WUM_0ICtoZ9rKCsqZHmUF3Uw7WUE1015W0Mz0JCss5llW2MtBVljL934e3bBtOrGTUwhmIS8hmG28hmBW8RaC2cN7CGYJHyGYDXyGYNQvW4VgdC8zIRjFy2wIRuuyKACzclkcgtG3LAnBKFuWhmA0LctCMGqW5SEYHcuKEMxnO7gQjHZlZQhGtbJ1CEavsioEo1RZHYLRqGwTglGnbBuC0aVsF4JRpKz5AmsefMn2koAyZQdJQJ2yVhJQqOwoCahU1kkCSpX1koBaZSdJYLHOksBqDZLAco2SwHpNgvBbwS6SwIpdJYElu0kCa3aXBBbtIQms2lMSULZ8JQl8DpeRBBQut5KAyuWRJKB0eSwJqF2eSAKKl6eSgOrlmSSgfPnX7dI9xJIXsoL65U5W0L_8lBUUMF_LChqYV7KCCua1rKCD_UZWUMJ8KytoYb6TFdQwb2QFPcz3osIi5gdZQRPzVlZQxfwoK_hi3skKypj3soI25idZYR3PssI_DrLCQo6ywkZOssJKXmSFnbzKCkt5kxW28i4rrOVsF3UPpORPhYNeFiuFg2AWRuGgmIVVOEhmESkcNLOIFQ6iWSQKB9UsUoWDbBaZwkE3i1zhIJxFITssZ_EUDtJZlAoH7SzWCgfxLCqFg3oWtcJBPouNwkE_i63CQUCLncLhawQ0CgcJLfYKBw0tDgoHES1ahYOKFkeFg4wWncJBR4vZimoeLilOosGGnkWDBR1Eg_0cRYP1nESD7byIBst5FQ128yYarOZdNNjMh2iwmE_JYC_dSjRQS2dEA610VjRQSheJBjrpYtFAJV0iGmikS0UDhXSZaKCPLhcNvoBKIRpoo3OigTK6UjTQRbcWDVTRVaKBJrr3Nm6deOej23hJNNBtvSTa53ZeEs1zjZdE69zeS6Jx7uAl0TbXekk0zR29JFrmOi_JhrneS6Jd7uQjf2vW2UuyVYOXZKNGL8k2TV6STbp4Sbbo6iXZoJuXZHvuXpLNeXhJtubpJfkKTSsvibaUxkuiKaX1kmhJGXlJNKR870Z_rYdN298_Frumqurux7fFYqrv0_LXO_q2bU5jM77edds1U70cT25dfyy6_ja40_yjvru_HZpqOdXHU_um_vVKCZdjN34szGZYuMvUv96Ya_47y_j1Gwey3XfTXU3fSw_b2hZ1tOtfn9qVTOeWvf4WGza_j7_EO81eP37smqGej01ffexeN_2oL5n4fPLdm2zfWl1N9X4HMtfNzDuhqY7fCxWc_Kd_mlw3bjph_PHYugnN9Xf46Sq8QTJsvKwxep3VvdyHK_nkS8WZT9U9bAcXNVcxo9Fsvpj9sU3Xdt09bJs_Xh9Y5d_b4zIz7df4Qft1ssrvUwNWvX_vOfdGyqqq0_fyyaatr9_CBfP_H3pvSX6fNG_81mrP_SP_CNE_RL3_Gkk_Nu_v8jg168Pj82f3dT82vi0NaFeOfXuZ6v_xP_T3tP78y9fvjOfb75_kr8vk9Uf_1q8_nx9Qv8FSNKFzd1PAAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(src_shared_styles_styles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_shared_styles_styles_css_ts_vanilla_css_source_H4sIAAAAAAAAA42c3XLaShZG7_MU3JyqnKrhFN36dx7mVAsJEAgJJPE7Ne8_hcmZWCvTvfdNyonXMnZsra8LDH_9bbb5PS5Oq8W_vy0WpVsftkN_6arlum_74WNxdcP35fJvc7zs8u6w_vPHt_98_sfyagkM5esSrJzKVJJ0VyKVVI8lxKVlMylVCWlcylTSdlcylVSPpcKlVTMJaeS3FwqVVI5l9YqaT2XKpVUzaVaJdVzaaOSNnNpq5K2c2mnknZzqVFJzVzaq6T9XDqopMNcalVSO5eOKuk4lzqV1M2lXiX1c_mkkk5z6aySznNpUEnDXBpV0jiXJpU0zaWLSrrMpatKus6lm0q6zaW7SrrPpYdKesylp0p6Yj51o2u4usrZxe4a3fAaLK_RTa_B9hrd_Bqsr9HNr8H_Gt0AGyyw0U2wwQYb3QgbrLDRzbDBDhvdEBsssdFNscEWG90YG6yx0c2xwR4b3SAbLLLRTbLBJhvdKBusstHNssEuG90wGyyz0U2zwTYb3TgbrLN5z7PqsH_0o0xN50eZl96PMiknP8qMnP0o0zH4UeZi9KNMxORHmYWLH2UKrn6Ul_Nj_KSv_tRXuYPP8pL_lHcTnblR_FJWyNH8Vla60fxaVqIz_Ky9PGfhSXpE38KC5Dm_pRHI1t5kdxILa5H8Ux2BZ_FIdf6_wojry29KM46Nq1H8Xx1lZ_FIdaW_tRHGXtxo_iAGu3fhTHVrvzozis2saP4ohq934UB1N78KM4jtrAFvAMakNjwDt8AmvA06YNzAGPmDawBzxX2sAg8DBpA4vAE6QNTAKPjTawCTwr2sAo8IBoA6vAU6ENzAKPgjawCzz_2cAw8NBnA8vAk14UmAYe76LANvBMFwXGgQe5KLAOPL1FgXngkS0K7APPadF7IE6uqppu_xuN7kZZkEZ6ozxIo75REaQR4MgFaTQ4KoM0MhytgzRKHFVBGjGO6iCNHkebII0kR9sgjSpHuxBt0eWoCdIoc7QP0rwP_hCkUeeoDdLoc3QM0ih01AVpNDrqgzQqHZ2CNDodnYM0Sh0NQRqtjsYgjVpHU5BGr6NLkEaxo2uQZrNvX_nl1J_EXt1Fg816iAa79RQNtCteiQb6FRvRQMNiKxroWByJBloWx6KBnsWJaKBpcSoa6FqcSQbbFueigb7FhWigcbETDT7IWIoGWhevRQO9iyvRQPPiWjTQvXgjGmhfvBUN9C_eiQYaGDeigQ7Ge9FAC_ODaKCHcSsaaGI827fl0Gx3k1TFuFM46GLcKxyUMT4pHLbxrHBYx0HhsI_jwmEhJ4XDRl4UDit5VTjs5E3hsJR32fmtlQ_Fw1o_FQ56mawUDoqZGIXD38qwCgfVTCKFg24mscJBOZNE4aCdSapwUM8kUzjoZ5IrHBQ0KRQOGpo4hYOKJqXCQUeT_XaW_TT1RymkSaWRUNKk1khIabLRSGhpstVIiGmy00ioadJoJOQ02Wsk9DQ5aCQENWk1EoqaHDUSkpp0ColNTXqNhKgmJ43Eqp41ErM6aCR2ddRIDOukkVjWi0ZiWq8aiW29aSTG9a6RWNeHRmJenxoJfU1XGgmBTY1GQmHT_dK29UY8qKaRrKCuaSwraGuayArKmqaygq6mmaygqmkuK2hqWsgKipo6WUFP01JWUNN0LStoaVqJCkua1rKCjqYbWUFF062soKHpTlZQ0LSRFf628F5WUM_0ICtoZ9rKCsqZHmUF3Uw7WUE1015W0Mz0JCss5llW2MtBVljL934e3bBtOrGTUwhmIS8hmG28hmBW8RaC2cN7CGYJHyGYDXyGYNQvW4VgdC8zIRjFy2wIRuuyKACzclkcgtG3LAnBKFuWhmA0LctCMGqW5SEYHcuKEMxnO7gQjHZlZQhGtbJ1CEavsioEo1RZHYLRqGwTglGnbBuC0aVsF4JRpKz5AmsefMn2koAyZQdJQJ2yVhJQqOwoCahU1kkCSpX1koBaZSdJYLHOksBqDZLAco2SwHpNgvBbwS6SwIpdJYElu0kCa3aXBBbtIQms2lMSULZ8JQl8DpeRBBQut5KAyuWRJKB0eSwJqF2eSAKKl6eSgOrlmSSgfPnX7dI9xJIXsoL65U5W0L_8lBUUMF_LChqYV7KCCua1rKCD_UZWUMJ8KytoYb6TFdQwb2QFPcz3osIi5gdZQRPzVlZQxfwoK_hi3skKypj3soI25idZYR3PssI_DrLCQo6ywkZOssJKXmSFnbzKCkt5kxW28i4rrOVsF3UPpORPhYNeFiuFg2AWRuGgmIVVOEhmESkcNLOIFQ6iWSQKB9UsUoWDbBaZwkE3i1zhIJxFITssZ_EUDtJZlAoH7SzWCgfxLCqFg3oWtcJBPouNwkE_i63CQUCLncLhawQ0CgcJLfYKBw0tDgoHES1ahYOKFkeFg4wWncJBR4vZimoeLilOosGGnkWDBR1Eg_0cRYP1nESD7byIBst5FQ128yYarOZdNNjMh2iwmE_JYC_dSjRQS2dEA610VjRQSheJBjrpYtFAJV0iGmikS0UDhXSZaKCPLhcNvoBKIRpoo3OigTK6UjTQRbcWDVTRVaKBJrr3Nm6deOej23hJNNBtvSTa53ZeEs1zjZdE69zeS6Jx7uAl0TbXekk0zR29JFrmOi_JhrneS6Jd7uQjf2vW2UuyVYOXZKNGL8k2TV6STbp4Sbbo6iXZoJuXZHvuXpLNeXhJtubpJfkKTSsvibaUxkuiKaX1kmhJGXlJNKR870Z_rYdN298_Frumqurux7fFYqrv0_LXO_q2bU5jM77edds1U70cT25dfyy6_ja40_yjvru_HZpqOdXHU_um_vVKCZdjN34szGZYuMvUv96Ya_47y_j1Gwey3XfTXU3fSw_b2hZ1tOtfn9qVTOeWvf4WGza_j7_EO81eP37smqGej01ffexeN_2oL5n4fPLdm2zfWl1N9X4HMtfNzDuhqY7fCxWc_Kd_mlw3bjph_PHYugnN9Xf46Sq8QTJsvKwxep3VvdyHK_nkS8WZT9U9bAcXNVcxo9Fsvpj9sU3Xdt09bJs_Xh9Y5d_b4zIz7df4Qft1ssrvUwNWvX_vOfdGyqqq0_fyyaatr9_CBfP_H3pvSX6fNG_81mrP_SP_CNE_RL3_Gkk_Nu_v8jg168Pj82f3dT82vi0NaFeOfXuZ6v_xP_T3tP78y9fvjOfb75_kr8vk9Uf_1q8_nx9Qv8FSNKFzd1PAAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_2__);



var absoluteCenterPositioning = '_1g8x49pbi';
var alignCenter = '_1g8x49pba';
var backgroundColor = {orange100:'_1g8x49p0',orange400:'_1g8x49p1',orange500:'_1g8x49p2',orange600:'_1g8x49p3',orange700:'_1g8x49p4',deepGreen100:'_1g8x49p5',deepGreen400:'_1g8x49p6',deepGreen500:'_1g8x49p7',deepGreen600:'_1g8x49p8',deepGreen700:'_1g8x49p9',green100:'_1g8x49pa',green400:'_1g8x49pb',green500:'_1g8x49pc',green600:'_1g8x49pd',green700:'_1g8x49pe',lightBlue:'_1g8x49pf',offWhite:'_1g8x49pg',greyscale0:'_1g8x49ph',greyscale50:'_1g8x49pi',greyscale100:'_1g8x49pj',greyscale200:'_1g8x49pk',greyscale300:'_1g8x49pl',greyscale400:'_1g8x49pm',greyscale500:'_1g8x49pn',greyscale600:'_1g8x49po',greyscale900:'_1g8x49pp',success100:'_1g8x49pq',success400:'_1g8x49pr',success500:'_1g8x49ps',success600:'_1g8x49pt',success700:'_1g8x49pu',success800:'_1g8x49pv',warning100:'_1g8x49pw',warning400:'_1g8x49px',warning500:'_1g8x49py',warning600:'_1g8x49pz',warning700:'_1g8x49p10',warning800:'_1g8x49p11',error100:'_1g8x49p12',error400:'_1g8x49p13',error500:'_1g8x49p14',error600:'_1g8x49p15',error700:'_1g8x49p16',error800:'_1g8x49p17',white:'_1g8x49p18',brandedBackground:'_1g8x49p19',brandedBadgeBackground:'_1g8x49p1a',brandedGalleryBackground:'_1g8x49p1b',brandedBadgeText:'_1g8x49p1c',brandedModalBackground:'_1g8x49p1d',brandedButtonBackground:'_1g8x49p1e',brandedButtonFocusBackground:'_1g8x49p1f',brandedButtonHoverBackground:'_1g8x49p1g',brandedButtonActiveBackground:'_1g8x49p1h',brandedModalTabsBackground:'_1g8x49p1i',brandedVisitBookedBannerBackground:'_1g8x49p1j',brandedVisitBookedBannerColor:'_1g8x49p1k'};
var color = {orange100:'_1g8x49p1l',orange400:'_1g8x49p1m',orange500:'_1g8x49p1n',orange600:'_1g8x49p1o',orange700:'_1g8x49p1p',deepGreen100:'_1g8x49p1q',deepGreen400:'_1g8x49p1r',deepGreen500:'_1g8x49p1s',deepGreen600:'_1g8x49p1t',deepGreen700:'_1g8x49p1u',green100:'_1g8x49p1v',green400:'_1g8x49p1w',green500:'_1g8x49p1x',green600:'_1g8x49p1y',green700:'_1g8x49p1z',lightBlue:'_1g8x49p20',offWhite:'_1g8x49p21',greyscale0:'_1g8x49p22',greyscale50:'_1g8x49p23',greyscale100:'_1g8x49p24',greyscale200:'_1g8x49p25',greyscale300:'_1g8x49p26',greyscale400:'_1g8x49p27',greyscale500:'_1g8x49p28',greyscale600:'_1g8x49p29',greyscale900:'_1g8x49p2a',success100:'_1g8x49p2b',success400:'_1g8x49p2c',success500:'_1g8x49p2d',success600:'_1g8x49p2e',success700:'_1g8x49p2f',success800:'_1g8x49p2g',warning100:'_1g8x49p2h',warning400:'_1g8x49p2i',warning500:'_1g8x49p2j',warning600:'_1g8x49p2k',warning700:'_1g8x49p2l',warning800:'_1g8x49p2m',error100:'_1g8x49p2n',error400:'_1g8x49p2o',error500:'_1g8x49p2p',error600:'_1g8x49p2q',error700:'_1g8x49p2r',error800:'_1g8x49p2s',white:'_1g8x49p2t',brandedBackground:'_1g8x49p2u',brandedBadgeBackground:'_1g8x49p2v',brandedGalleryBackground:'_1g8x49p2w',brandedBadgeText:'_1g8x49p2x',brandedModalBackground:'_1g8x49p2y',brandedButtonBackground:'_1g8x49p2z',brandedButtonFocusBackground:'_1g8x49p30',brandedButtonHoverBackground:'_1g8x49p31',brandedButtonActiveBackground:'_1g8x49p32',brandedModalTabsBackground:'_1g8x49p33',brandedVisitBookedBannerBackground:'_1g8x49p34',brandedVisitBookedBannerColor:'_1g8x49p35'};
var ellipsis = '_1g8x49pb4';
var flexBetween = '_1g8x49pb8';
var flexCenter = 'tfghjg6 tfghjg1u';
var flexColumn = '_1g8x49pb9';
var flexColumnSpaceBetween = 'tfghjg1u tfghjg7l tfghjga3 tfghjga6';
var gap = {'0':'_1g8x49pae','-2xl':'_1g8x49paf','-3xl':'_1g8x49pag','-4xl':'_1g8x49pah','-5xl':'_1g8x49pai','-l':'_1g8x49paj','-m':'_1g8x49pak','-m-l':'_1g8x49pal','-s':'_1g8x49pam','-s-m':'_1g8x49pan','-xl':'_1g8x49pao','-xs':'_1g8x49pap','-xxs':'_1g8x49paq','2xl':'_1g8x49par','3xl':'_1g8x49pas','4xl':'_1g8x49pat','5xl':'_1g8x49pau',auto:'_1g8x49pav',l:'_1g8x49paw',m:'_1g8x49pax','m-l':'_1g8x49pay',s:'_1g8x49paz','s-m':'_1g8x49pb0',xl:'_1g8x49pb1',xs:'_1g8x49pb2',xxs:'_1g8x49pb3'};
var gridCenter = '_1g8x49pb7 tfghjg1x tfghjg6';
var margin = {'0':'_1g8x49p6s','-2xl':'_1g8x49p6t','-3xl':'_1g8x49p6u','-4xl':'_1g8x49p6v','-5xl':'_1g8x49p6w','-l':'_1g8x49p6x','-m':'_1g8x49p6y','-m-l':'_1g8x49p6z','-s':'_1g8x49p70','-s-m':'_1g8x49p71','-xl':'_1g8x49p72','-xs':'_1g8x49p73','-xxs':'_1g8x49p74','2xl':'_1g8x49p75','3xl':'_1g8x49p76','4xl':'_1g8x49p77','5xl':'_1g8x49p78',auto:'_1g8x49p79',l:'_1g8x49p7a',m:'_1g8x49p7b','m-l':'_1g8x49p7c',s:'_1g8x49p7d','s-m':'_1g8x49p7e',xl:'_1g8x49p7f',xs:'_1g8x49p7g',xxs:'_1g8x49p7h'};
var marginBottom = {'0':'_1g8x49p8y','-2xl':'_1g8x49p8z','-3xl':'_1g8x49p90','-4xl':'_1g8x49p91','-5xl':'_1g8x49p92','-l':'_1g8x49p93','-m':'_1g8x49p94','-m-l':'_1g8x49p95','-s':'_1g8x49p96','-s-m':'_1g8x49p97','-xl':'_1g8x49p98','-xs':'_1g8x49p99','-xxs':'_1g8x49p9a','2xl':'_1g8x49p9b','3xl':'_1g8x49p9c','4xl':'_1g8x49p9d','5xl':'_1g8x49p9e',auto:'_1g8x49p9f',l:'_1g8x49p9g',m:'_1g8x49p9h','m-l':'_1g8x49p9i',s:'_1g8x49p9j','s-m':'_1g8x49p9k',xl:'_1g8x49p9l',xs:'_1g8x49p9m',xxs:'_1g8x49p9n'};
var marginLeft = {'0':'_1g8x49p9o','-2xl':'_1g8x49p9p','-3xl':'_1g8x49p9q','-4xl':'_1g8x49p9r','-5xl':'_1g8x49p9s','-l':'_1g8x49p9t','-m':'_1g8x49p9u','-m-l':'_1g8x49p9v','-s':'_1g8x49p9w','-s-m':'_1g8x49p9x','-xl':'_1g8x49p9y','-xs':'_1g8x49p9z','-xxs':'_1g8x49pa0','2xl':'_1g8x49pa1','3xl':'_1g8x49pa2','4xl':'_1g8x49pa3','5xl':'_1g8x49pa4',auto:'_1g8x49pa5',l:'_1g8x49pa6',m:'_1g8x49pa7','m-l':'_1g8x49pa8',s:'_1g8x49pa9','s-m':'_1g8x49paa',xl:'_1g8x49pab',xs:'_1g8x49pac',xxs:'_1g8x49pad'};
var marginRight = {'0':'_1g8x49p88','-2xl':'_1g8x49p89','-3xl':'_1g8x49p8a','-4xl':'_1g8x49p8b','-5xl':'_1g8x49p8c','-l':'_1g8x49p8d','-m':'_1g8x49p8e','-m-l':'_1g8x49p8f','-s':'_1g8x49p8g','-s-m':'_1g8x49p8h','-xl':'_1g8x49p8i','-xs':'_1g8x49p8j','-xxs':'_1g8x49p8k','2xl':'_1g8x49p8l','3xl':'_1g8x49p8m','4xl':'_1g8x49p8n','5xl':'_1g8x49p8o',auto:'_1g8x49p8p',l:'_1g8x49p8q',m:'_1g8x49p8r','m-l':'_1g8x49p8s',s:'_1g8x49p8t','s-m':'_1g8x49p8u',xl:'_1g8x49p8v',xs:'_1g8x49p8w',xxs:'_1g8x49p8x'};
var marginTop = {'0':'_1g8x49p7i','-2xl':'_1g8x49p7j','-3xl':'_1g8x49p7k','-4xl':'_1g8x49p7l','-5xl':'_1g8x49p7m','-l':'_1g8x49p7n','-m':'_1g8x49p7o','-m-l':'_1g8x49p7p','-s':'_1g8x49p7q','-s-m':'_1g8x49p7r','-xl':'_1g8x49p7s','-xs':'_1g8x49p7t','-xxs':'_1g8x49p7u','2xl':'_1g8x49p7v','3xl':'_1g8x49p7w','4xl':'_1g8x49p7x','5xl':'_1g8x49p7y',auto:'_1g8x49p7z',l:'_1g8x49p80',m:'_1g8x49p81','m-l':'_1g8x49p82',s:'_1g8x49p83','s-m':'_1g8x49p84',xl:'_1g8x49p85',xs:'_1g8x49p86',xxs:'_1g8x49p87'};
var noShrink = '_1g8x49pbb';
var outlineStyle = '_1g8x49pbg';
var padding = {'0':'_1g8x49p36','-2xl':'_1g8x49p37','-3xl':'_1g8x49p38','-4xl':'_1g8x49p39','-5xl':'_1g8x49p3a','-l':'_1g8x49p3b','-m':'_1g8x49p3c','-m-l':'_1g8x49p3d','-s':'_1g8x49p3e','-s-m':'_1g8x49p3f','-xl':'_1g8x49p3g','-xs':'_1g8x49p3h','-xxs':'_1g8x49p3i','2xl':'_1g8x49p3j','3xl':'_1g8x49p3k','4xl':'_1g8x49p3l','5xl':'_1g8x49p3m',auto:'_1g8x49p3n',l:'_1g8x49p3o',m:'_1g8x49p3p','m-l':'_1g8x49p3q',s:'_1g8x49p3r','s-m':'_1g8x49p3s',xl:'_1g8x49p3t',xs:'_1g8x49p3u',xxs:'_1g8x49p3v'};
var paddingBottom = {'0':'_1g8x49p5c','-2xl':'_1g8x49p5d','-3xl':'_1g8x49p5e','-4xl':'_1g8x49p5f','-5xl':'_1g8x49p5g','-l':'_1g8x49p5h','-m':'_1g8x49p5i','-m-l':'_1g8x49p5j','-s':'_1g8x49p5k','-s-m':'_1g8x49p5l','-xl':'_1g8x49p5m','-xs':'_1g8x49p5n','-xxs':'_1g8x49p5o','2xl':'_1g8x49p5p','3xl':'_1g8x49p5q','4xl':'_1g8x49p5r','5xl':'_1g8x49p5s',auto:'_1g8x49p5t',l:'_1g8x49p5u',m:'_1g8x49p5v','m-l':'_1g8x49p5w',s:'_1g8x49p5x','s-m':'_1g8x49p5y',xl:'_1g8x49p5z',xs:'_1g8x49p60',xxs:'_1g8x49p61'};
var paddingLeft = {'0':'_1g8x49p62','-2xl':'_1g8x49p63','-3xl':'_1g8x49p64','-4xl':'_1g8x49p65','-5xl':'_1g8x49p66','-l':'_1g8x49p67','-m':'_1g8x49p68','-m-l':'_1g8x49p69','-s':'_1g8x49p6a','-s-m':'_1g8x49p6b','-xl':'_1g8x49p6c','-xs':'_1g8x49p6d','-xxs':'_1g8x49p6e','2xl':'_1g8x49p6f','3xl':'_1g8x49p6g','4xl':'_1g8x49p6h','5xl':'_1g8x49p6i',auto:'_1g8x49p6j',l:'_1g8x49p6k',m:'_1g8x49p6l','m-l':'_1g8x49p6m',s:'_1g8x49p6n','s-m':'_1g8x49p6o',xl:'_1g8x49p6p',xs:'_1g8x49p6q',xxs:'_1g8x49p6r'};
var paddingRight = {'0':'_1g8x49p4m','-2xl':'_1g8x49p4n','-3xl':'_1g8x49p4o','-4xl':'_1g8x49p4p','-5xl':'_1g8x49p4q','-l':'_1g8x49p4r','-m':'_1g8x49p4s','-m-l':'_1g8x49p4t','-s':'_1g8x49p4u','-s-m':'_1g8x49p4v','-xl':'_1g8x49p4w','-xs':'_1g8x49p4x','-xxs':'_1g8x49p4y','2xl':'_1g8x49p4z','3xl':'_1g8x49p50','4xl':'_1g8x49p51','5xl':'_1g8x49p52',auto:'_1g8x49p53',l:'_1g8x49p54',m:'_1g8x49p55','m-l':'_1g8x49p56',s:'_1g8x49p57','s-m':'_1g8x49p58',xl:'_1g8x49p59',xs:'_1g8x49p5a',xxs:'_1g8x49p5b'};
var paddingTop = {'0':'_1g8x49p3w','-2xl':'_1g8x49p3x','-3xl':'_1g8x49p3y','-4xl':'_1g8x49p3z','-5xl':'_1g8x49p40','-l':'_1g8x49p41','-m':'_1g8x49p42','-m-l':'_1g8x49p43','-s':'_1g8x49p44','-s-m':'_1g8x49p45','-xl':'_1g8x49p46','-xs':'_1g8x49p47','-xxs':'_1g8x49p48','2xl':'_1g8x49p49','3xl':'_1g8x49p4a','4xl':'_1g8x49p4b','5xl':'_1g8x49p4c',auto:'_1g8x49p4d',l:'_1g8x49p4e',m:'_1g8x49p4f','m-l':'_1g8x49p4g',s:'_1g8x49p4h','s-m':'_1g8x49p4i',xl:'_1g8x49p4j',xs:'_1g8x49p4k',xxs:'_1g8x49p4l'};
var pointShapeDivider = '_1g8x49pbf';
var rotate45deg = '_1g8x49pbc';
var rotate90 = '_1g8x49pbd';
var sticky = '_1g8x49pbh';

/***/ }),

/***/ 25406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ is_prop_valid_browser_esm; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize_browser_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var is_prop_valid_browser_esm = (index);


/***/ }),

/***/ 24733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DEFAULT_ENVIRONMENT; }
/* harmony export */ });
const DEFAULT_ENVIRONMENT = 'production';


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 92694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 21440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RP": function() { return /* binding */ notifyEventProcessors; },
/* harmony export */   "cc": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "fH": function() { return /* binding */ getGlobalEventProcessors; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97193);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47287);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25853);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34336);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92694);



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */
function addGlobalEventProcessor(callback) {
  // eslint-disable-next-line deprecation/deprecation
  getGlobalEventProcessors().push(callback);
}

/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */
function notifyEventProcessors(
  processors,
  event,
  hint,
  index = 0,
) {
  return new _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .SyncPromise */ .cW((resolve, reject) => {
    const processor = processors[index];
    if (event === null || typeof processor !== 'function') {
      resolve(event);
    } else {
      const result = processor({ ...event }, hint) ;

      _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && processor.id && result === null && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

      if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isThenable */ .J8)(result)) {
        void result
          .then(final => notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
          .then(null, reject);
      } else {
        void notifyEventProcessors(processors, result, hint, index + 1)
          .then(resolve)
          .then(null, reject);
      }
    }
  });
}


//# sourceMappingURL=eventProcessors.js.map


/***/ }),

/***/ 3607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "cg": function() { return /* binding */ captureSession; },
/* harmony export */   "eN": function() { return /* binding */ captureEvent; },
/* harmony export */   "nZ": function() { return /* binding */ getCurrentScope; },
/* harmony export */   "n_": function() { return /* binding */ addBreadcrumb; },
/* harmony export */   "s3": function() { return /* binding */ getClient; },
/* harmony export */   "yj": function() { return /* binding */ startSession; },
/* harmony export */   "yl": function() { return /* binding */ flush; }
/* harmony export */ });
/* unused harmony exports captureCheckIn, captureMessage, close, configureScope, endSession, isInitialized, lastEventId, setContext, setExtra, setExtras, setTag, setTags, setUser, startTransaction, withActiveSpan, withIsolationScope, withMonitor */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25853);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97193);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24733);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92694);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95091);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97353);
/* harmony import */ var _utils_prepareEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4831);







/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */
function captureException(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  exception,
  hint,
) {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, (0,_utils_prepareEvent_js__WEBPACK_IMPORTED_MODULE_1__/* .parseEventHintOrCaptureContext */ .U0)(hint));
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */
function captureMessage(
  message,
  // eslint-disable-next-line deprecation/deprecation
  captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  // eslint-disable-next-line deprecation/deprecation
  return getCurrentHub().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */
function captureEvent(event, hint) {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */
// eslint-disable-next-line deprecation/deprecation
function configureScope(callback) {
  // eslint-disable-next-line deprecation/deprecation
  getCurrentHub().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
// eslint-disable-next-line deprecation/deprecation
function addBreadcrumb(breadcrumb, hint) {
  // eslint-disable-next-line deprecation/deprecation
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().addBreadcrumb(breadcrumb, hint);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function setContext(name, context) {
  // eslint-disable-next-line deprecation/deprecation
  getCurrentHub().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
// eslint-disable-next-line deprecation/deprecation
function setExtras(extras) {
  // eslint-disable-next-line deprecation/deprecation
  getCurrentHub().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line deprecation/deprecation
function setExtra(key, extra) {
  // eslint-disable-next-line deprecation/deprecation
  getCurrentHub().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
// eslint-disable-next-line deprecation/deprecation
function setTags(tags) {
  // eslint-disable-next-line deprecation/deprecation
  getCurrentHub().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
// eslint-disable-next-line deprecation/deprecation
function setTag(key, value) {
  // eslint-disable-next-line deprecation/deprecation
  getCurrentHub().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
// eslint-disable-next-line deprecation/deprecation
function setUser(user) {
  // eslint-disable-next-line deprecation/deprecation
  getCurrentHub().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */

/**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */
function withScope(
  ...rest
) {
  // eslint-disable-next-line deprecation/deprecation
  const hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();

  // If a scope is defined, we want to make this the active scope instead of the default one
  if (rest.length === 2) {
    const [scope, callback] = rest;
    if (!scope) {
      // eslint-disable-next-line deprecation/deprecation
      return hub.withScope(callback);
    }

    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(() => {
      // eslint-disable-next-line deprecation/deprecation
      hub.getStackTop().scope = scope ;
      return callback(scope );
    });
  }

  // eslint-disable-next-line deprecation/deprecation
  return hub.withScope(rest[0]);
}

/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */
function withIsolationScope(callback) {
  return runWithAsyncContext(() => {
    return callback(getIsolationScope());
  });
}

/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */
function withActiveSpan(span, callback) {
  return withScope(scope => {
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    return callback(scope);
  });
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */
function startTransaction(
  context,
  customSamplingContext,
  // eslint-disable-next-line deprecation/deprecation
) {
  // eslint-disable-next-line deprecation/deprecation
  return getCurrentHub().startTransaction({ ...context }, customSamplingContext);
}

/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function captureCheckIn(checkIn, upsertMonitorConfig) {
  const scope = getCurrentScope();
  const client = getClient();
  if (!client) {
    DEBUG_BUILD && logger.warn('Cannot capture check-in. No client defined.');
  } else if (!client.captureCheckIn) {
    DEBUG_BUILD && logger.warn('Cannot capture check-in. Client does not support sending check-ins.');
  } else {
    return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
  }

  return uuid4();
}

/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function withMonitor(
  monitorSlug,
  callback,
  upsertMonitorConfig,
) {
  const checkInId = captureCheckIn({ monitorSlug, status: 'in_progress' }, upsertMonitorConfig);
  const now = timestampInSeconds();

  function finishCheckIn(status) {
    captureCheckIn({ monitorSlug, status, checkInId, duration: timestampInSeconds() - now });
  }

  let maybePromiseResult;
  try {
    maybePromiseResult = callback();
  } catch (e) {
    finishCheckIn('error');
    throw e;
  }

  if (isThenable(maybePromiseResult)) {
    Promise.resolve(maybePromiseResult).then(
      () => {
        finishCheckIn('ok');
      },
      () => {
        finishCheckIn('error');
      },
    );
  } else {
    finishCheckIn('ok');
  }

  return maybePromiseResult;
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
async function flush(timeout) {
  const client = getClient();
  if (client) {
    return client.flush(timeout);
  }
  _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn('Cannot flush events. No client defined.');
  return Promise.resolve(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
async function close(timeout) {
  const client = getClient();
  if (client) {
    return client.close(timeout);
  }
  DEBUG_BUILD && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return Promise.resolve(false);
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  // eslint-disable-next-line deprecation/deprecation
  return getCurrentHub().lastEventId();
}

/**
 * Get the currently active client.
 */
function getClient() {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
}

/**
 * Returns true if Sentry has been properly initialized.
 */
function isInitialized() {
  return !!getClient();
}

/**
 * Get the currently active scope.
 */
function getCurrentScope() {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getScope();
}

/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */
function startSession(context) {
  const client = getClient();
  const isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
  const currentScope = getCurrentScope();

  const { release, environment = _constants_js__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_ENVIRONMENT */ .J } = (client && client.getOptions()) || {};

  // Will fetch userAgent if called from browser sdk
  const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

  const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_6__/* .makeSession */ .Hv)({
    release,
    environment,
    user: currentScope.getUser() || isolationScope.getUser(),
    ...(userAgent && { userAgent }),
    ...context,
  });

  // End existing session if there's one
  const currentSession = isolationScope.getSession();
  if (currentSession && currentSession.status === 'ok') {
    (0,_session_js__WEBPACK_IMPORTED_MODULE_6__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
  }

  endSession();

  // Afterwards we set the new session on the scope
  isolationScope.setSession(session);

  // TODO (v8): Remove this and only use the isolation scope(?).
  // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
  currentScope.setSession(session);

  return session;
}

/**
 * End the session on the current isolation scope.
 */
function endSession() {
  const isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
  const currentScope = getCurrentScope();

  const session = currentScope.getSession() || isolationScope.getSession();
  if (session) {
    (0,_session_js__WEBPACK_IMPORTED_MODULE_6__/* .closeSession */ .RJ)(session);
  }
  _sendSessionUpdate();

  // the session is over; take it off of the scope
  isolationScope.setSession();

  // TODO (v8): Remove this and only use the isolation scope(?).
  // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
  currentScope.setSession();
}

/**
 * Sends the current Session on the scope
 */
function _sendSessionUpdate() {
  const isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
  const currentScope = getCurrentScope();
  const client = getClient();
  // TODO (v8): Remove currentScope and only use the isolation scope(?).
  // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
  const session = currentScope.getSession() || isolationScope.getSession();
  if (session && client && client.captureSession) {
    client.captureSession(session);
  }
}

/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */
function captureSession(end = false) {
  // both send the update and pull the session from the scope
  if (end) {
    endSession();
    return;
  }

  // only send the update
  _sendSessionUpdate();
}


//# sourceMappingURL=exports.js.map


/***/ }),

/***/ 95091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "Ok": function() { return /* binding */ runWithAsyncContext; },
/* harmony export */   "aF": function() { return /* binding */ getIsolationScope; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, Hub, ensureHubOnCarrier, getHubFromCarrier, makeMain, setAsyncContextStrategy, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34336);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50437);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45939);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25853);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97193);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24733);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92694);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79318);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97353);
/* harmony import */ var _version_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30919);







/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = parseFloat(_version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .J);

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */
// eslint-disable-next-line deprecation/deprecation
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */
   constructor(
    client,
    scope,
    isolationScope,
      _version = API_VERSION,
  ) {this._version = _version;
    let assignedScope;
    if (!scope) {
      assignedScope = new _scope_js__WEBPACK_IMPORTED_MODULE_1__/* .Scope */ .sX();
      assignedScope.setClient(client);
    } else {
      assignedScope = scope;
    }

    let assignedIsolationScope;
    if (!isolationScope) {
      assignedIsolationScope = new _scope_js__WEBPACK_IMPORTED_MODULE_1__/* .Scope */ .sX();
      assignedIsolationScope.setClient(client);
    } else {
      assignedIsolationScope = isolationScope;
    }

    this._stack = [{ scope: assignedScope }];

    if (client) {
      // eslint-disable-next-line deprecation/deprecation
      this.bindClient(client);
    }

    this._isolationScope = assignedIsolationScope;
  }

  /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */
   bindClient(client) {
    // eslint-disable-next-line deprecation/deprecation
    const top = this.getStackTop();
    top.client = client;
    top.scope.setClient(client);
    // eslint-disable-next-line deprecation/deprecation
    if (client && client.setupIntegrations) {
      // eslint-disable-next-line deprecation/deprecation
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
   pushScope() {
    // We want to clone the content of prev scope
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope().clone();
    // eslint-disable-next-line deprecation/deprecation
    this.getStack().push({
      // eslint-disable-next-line deprecation/deprecation
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
   popScope() {
    // eslint-disable-next-line deprecation/deprecation
    if (this.getStack().length <= 1) return false;
    // eslint-disable-next-line deprecation/deprecation
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */
   withScope(callback) {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.pushScope();

    let maybePromiseResult;
    try {
      maybePromiseResult = callback(scope);
    } catch (e) {
      // eslint-disable-next-line deprecation/deprecation
      this.popScope();
      throw e;
    }

    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isThenable */ .J8)(maybePromiseResult)) {
      // @ts-expect-error - isThenable returns the wrong type
      return maybePromiseResult.then(
        res => {
          // eslint-disable-next-line deprecation/deprecation
          this.popScope();
          return res;
        },
        e => {
          // eslint-disable-next-line deprecation/deprecation
          this.popScope();
          throw e;
        },
      );
    }

    // eslint-disable-next-line deprecation/deprecation
    this.popScope();
    return maybePromiseResult;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */
   getClient() {
    // eslint-disable-next-line deprecation/deprecation
    return this.getStackTop().client ;
  }

  /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */
   getScope() {
    // eslint-disable-next-line deprecation/deprecation
    return this.getStackTop().scope;
  }

  /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */
   getIsolationScope() {
    return this._isolationScope;
  }

  /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */
   getStack() {
    return this._stack;
  }

  /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .uuid4 */ .DM)());
    const syntheticException = new Error('Sentry syntheticException');
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().captureException(exception, {
      originalException: exception,
      syntheticException,
      ...hint,
      event_id: eventId,
    });

    return eventId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .uuid4 */ .DM)());
    const syntheticException = new Error(message);
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().captureMessage(message, level, {
      originalException: message,
      syntheticException,
      ...hint,
      event_id: eventId,
    });

    return eventId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .uuid4 */ .DM)();
    if (!event.type) {
      this._lastEventId = eventId;
    }
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().captureEvent(event, { ...hint, event_id: eventId });
    return eventId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */
   addBreadcrumb(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    const { scope, client } = this.getStackTop();

    if (!client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dateTimestampInSeconds */ .yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    if (client.emit) {
      client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    }

    // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
    // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
    // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
    // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
    // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
    // the event processing pipeline.
    // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */
   setUser(user) {
    // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setUser(user);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setUser(user);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */
   setTags(tags) {
    // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setTags(tags);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setTags(tags);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */
   setExtras(extras) {
    // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setExtras(extras);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setExtras(extras);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */
   setTag(key, value) {
    // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setTag(key, value);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setTag(key, value);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */
   setExtra(key, extra) {
    // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setExtra(key, extra);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setExtra(key, extra);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setContext(name, context);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setContext(name, context);
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */
   configureScope(callback) {
    // eslint-disable-next-line deprecation/deprecation
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
   run(callback) {
    // eslint-disable-next-line deprecation/deprecation
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      // eslint-disable-next-line deprecation/deprecation
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */
   getIntegration(integration) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    if (!client) return null;
    try {
      // eslint-disable-next-line deprecation/deprecation
      return client.getIntegration(integration);
    } catch (_oO) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */
   startTransaction(context, customSamplingContext) {
    const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);

    if (_debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && !result) {
      // eslint-disable-next-line deprecation/deprecation
      const client = this.getClient();
      if (!client) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn(
          "Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'",
        );
      } else {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
      }
    }

    return result;
  }

  /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      // eslint-disable-next-line deprecation/deprecation
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */
   endSession() {
    // eslint-disable-next-line deprecation/deprecation
    const layer = this.getStackTop();
    const scope = layer.scope;
    const session = scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_7__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    scope.setSession();
  }

  /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */
   startSession(context) {
    // eslint-disable-next-line deprecation/deprecation
    const { scope, client } = this.getStackTop();
    const { release, environment = _constants_js__WEBPACK_IMPORTED_MODULE_8__/* .DEFAULT_ENVIRONMENT */ .J } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

    const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_7__/* .makeSession */ .Hv)({
      release,
      environment,
      user: scope.getUser(),
      ...(userAgent && { userAgent }),
      ...context,
    });

    // End existing session if there's one
    const currentSession = scope.getSession && scope.getSession();
    if (currentSession && currentSession.status === 'ok') {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_7__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
    }
    // eslint-disable-next-line deprecation/deprecation
    this.endSession();

    // Afterwards we set the new session on the scope
    scope.setSession(session);

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */
   shouldSendDefaultPii() {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    // eslint-disable-next-line deprecation/deprecation
    const { scope, client } = this.getStackTop();

    const session = scope.getSession();
    if (session && client && client.captureSession) {
      client.captureSession(session);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    _debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ = _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .GLOBAL_OBJ */ .n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */
// eslint-disable-next-line deprecation/deprecation
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    const hub = registry.__SENTRY__.acs.getCurrentHub();

    if (hub) {
      return hub;
    }
  }

  // Return hub that lives on a global object
  return getGlobalHub(registry);
}

/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */
function getIsolationScope() {
  // eslint-disable-next-line deprecation/deprecation
  return getCurrentHub().getIsolationScope();
}

// eslint-disable-next-line deprecation/deprecation
function getGlobalHub(registry = getMainCarrier()) {
  // If there's no hub, or its an old API, assign a new one

  if (
    !hasHubOnCarrier(registry) ||
    // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(registry).isOlderThan(API_VERSION)
  ) {
    // eslint-disable-next-line deprecation/deprecation
    setHubOnCarrier(registry, new Hub());
  }

  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */
// eslint-disable-next-line deprecation/deprecation
function ensureHubOnCarrier(carrier, parent = getGlobalHub()) {
  // If there's no hub on current domain, or it's an old API, assign a new one
  if (
    !hasHubOnCarrier(carrier) ||
    // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(carrier).isOlderThan(API_VERSION)
  ) {
    // eslint-disable-next-line deprecation/deprecation
    const client = parent.getClient();
    // eslint-disable-next-line deprecation/deprecation
    const scope = parent.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const isolationScope = parent.getIsolationScope();
    // eslint-disable-next-line deprecation/deprecation
    setHubOnCarrier(carrier, new Hub(client, scope.clone(), isolationScope.clone()));
  }
}

/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */
function setAsyncContextStrategy(strategy) {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();
  registry.__SENTRY__ = registry.__SENTRY__ || {};
  registry.__SENTRY__.acs = strategy;
}

/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */
function runWithAsyncContext(callback, options = {}) {
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
  }

  // if there was no strategy, fallback to just calling the callback
  return callback();
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
// eslint-disable-next-line deprecation/deprecation
function getHubFromCarrier(carrier) {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .getGlobalSingleton */ .YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
// eslint-disable-next-line deprecation/deprecation
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 79318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lW": function() { return /* binding */ getGlobalScope; },
/* harmony export */   "sX": function() { return /* binding */ Scope; }
/* harmony export */ });
/* unused harmony export setGlobalScope */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34336);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45939);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50437);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25853);
/* harmony import */ var _eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21440);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97353);
/* harmony import */ var _utils_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91182);





/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */
let globalScope;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /** Propagation Context for distributed tracing */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /**
   * Transaction Name
   */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  /** The client on this scope */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
    this._propagationContext = generatePropagationContext();
  }

  /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */
   static clone(scope) {
    return scope ? scope.clone() : new Scope();
  }

  /**
   * Clone this scope instance.
   */
   clone() {
    const newScope = new Scope();
    newScope._breadcrumbs = [...this._breadcrumbs];
    newScope._tags = { ...this._tags };
    newScope._extra = { ...this._extra };
    newScope._contexts = { ...this._contexts };
    newScope._user = this._user;
    newScope._level = this._level;
    newScope._span = this._span;
    newScope._session = this._session;
    newScope._transactionName = this._transactionName;
    newScope._fingerprint = this._fingerprint;
    newScope._eventProcessors = [...this._eventProcessors];
    newScope._requestSession = this._requestSession;
    newScope._attachments = [...this._attachments];
    newScope._sdkProcessingMetadata = { ...this._sdkProcessingMetadata };
    newScope._propagationContext = { ...this._propagationContext };
    newScope._client = this._client;

    return newScope;
  }

  /** Update the client on the scope. */
   setClient(client) {
    this._client = client;
  }

  /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */
   getClient() {
    return this._client;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    // If null is passed we want to unset everything, but still define keys,
    // so that later down in the pipeline any existing values are cleared.
    this._user = user || {
      email: undefined,
      id: undefined,
      ip_address: undefined,
      segment: undefined,
      username: undefined,
    };

    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * Sets the transaction name on the scope for future events.
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */
   getSpan() {
    return this._span;
  }

  /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this._span;
    // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
    // Also, this method will be removed anyway.
    // eslint-disable-next-line deprecation/deprecation
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;

    if (scopeToMerge instanceof Scope) {
      const scopeData = scopeToMerge.getScopeData();

      this._tags = { ...this._tags, ...scopeData.tags };
      this._extra = { ...this._extra, ...scopeData.extra };
      this._contexts = { ...this._contexts, ...scopeData.contexts };
      if (scopeData.user && Object.keys(scopeData.user).length) {
        this._user = scopeData.user;
      }
      if (scopeData.level) {
        this._level = scopeData.level;
      }
      if (scopeData.fingerprint.length) {
        this._fingerprint = scopeData.fingerprint;
      }
      if (scopeToMerge.getRequestSession()) {
        this._requestSession = scopeToMerge.getRequestSession();
      }
      if (scopeData.propagationContext) {
        this._propagationContext = scopeData.propagationContext;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(scopeToMerge)) {
      const scopeContext = captureContext ;
      this._tags = { ...this._tags, ...scopeContext.tags };
      this._extra = { ...this._extra, ...scopeContext.extra };
      this._contexts = { ...this._contexts, ...scopeContext.contexts };
      if (scopeContext.user) {
        this._user = scopeContext.user;
      }
      if (scopeContext.level) {
        this._level = scopeContext.level;
      }
      if (scopeContext.fingerprint) {
        this._fingerprint = scopeContext.fingerprint;
      }
      if (scopeContext.requestSession) {
        this._requestSession = scopeContext.requestSession;
      }
      if (scopeContext.propagationContext) {
        this._propagationContext = scopeContext.propagationContext;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    this._propagationContext = generatePropagationContext();
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };

    const breadcrumbs = this._breadcrumbs;
    breadcrumbs.push(mergedBreadcrumb);
    this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;

    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */
   getAttachments() {
    const data = this.getScopeData();

    return data.attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /** @inheritDoc */
   getScopeData() {
    const {
      _breadcrumbs,
      _attachments,
      _contexts,
      _tags,
      _extra,
      _user,
      _level,
      _fingerprint,
      _eventProcessors,
      _propagationContext,
      _sdkProcessingMetadata,
      _transactionName,
      _span,
    } = this;

    return {
      breadcrumbs: _breadcrumbs,
      attachments: _attachments,
      contexts: _contexts,
      tags: _tags,
      extra: _extra,
      user: _user,
      level: _level,
      fingerprint: _fingerprint || [],
      eventProcessors: _eventProcessors,
      propagationContext: _propagationContext,
      sdkProcessingMetadata: _sdkProcessingMetadata,
      transactionName: _transactionName,
      span: _span,
    };
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */
   applyToEvent(
    event,
    hint = {},
    additionalEventProcessors = [],
  ) {
    (0,_utils_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__/* .applyScopeDataToEvent */ .gi)(event, this.getScopeData());

    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
      ...additionalEventProcessors,
      // eslint-disable-next-line deprecation/deprecation
      ...(0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__/* .getGlobalEventProcessors */ .fH)(),
      ...this._eventProcessors,
    ];

    return (0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__/* .notifyEventProcessors */ .RP)(eventProcessors, event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * @inheritDoc
   */
   setPropagationContext(context) {
    this._propagationContext = context;
    return this;
  }

  /**
   * @inheritDoc
   */
   getPropagationContext() {
    return this._propagationContext;
  }

  /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */
   captureException(exception, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();

    if (!this._client) {
      _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.warn */ .kg.warn('No client configured on scope - will not capture exception!');
      return eventId;
    }

    const syntheticException = new Error('Sentry syntheticException');

    this._client.captureException(
      exception,
      {
        originalException: exception,
        syntheticException,
        ...hint,
        event_id: eventId,
      },
      this,
    );

    return eventId;
  }

  /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */
   captureMessage(message, level, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();

    if (!this._client) {
      _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.warn */ .kg.warn('No client configured on scope - will not capture message!');
      return eventId;
    }

    const syntheticException = new Error(message);

    this._client.captureMessage(
      message,
      level,
      {
        originalException: message,
        syntheticException,
        ...hint,
        event_id: eventId,
      },
      this,
    );

    return eventId;
  }

  /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();

    if (!this._client) {
      _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.warn */ .kg.warn('No client configured on scope - will not capture event!');
      return eventId;
    }

    this._client.captureEvent(event, { ...hint, event_id: eventId }, this);

    return eventId;
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }
}

/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */
function getGlobalScope() {
  if (!globalScope) {
    globalScope = new Scope();
  }

  return globalScope;
}

/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */
function setGlobalScope(scope) {
  globalScope = scope;
}

function generatePropagationContext() {
  return {
    traceId: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)(),
    spanId: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)().substring(16),
  };
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 97353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45939);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50437);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7052);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  const session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.abnormal_mechanism) {
    session.abnormal_mechanism = context.abnormal_mechanism;
  }

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    abnormal_mechanism: session.abnormal_mechanism,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 60292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getDynamicSamplingContextFromClient; },
/* harmony export */   "j": function() { return /* binding */ getDynamicSamplingContextFromSpan; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7052);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24733);
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3607);
/* harmony import */ var _utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52310);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56524);






/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */
function getDynamicSamplingContextFromClient(
  trace_id,
  client,
  scope,
) {
  const options = client.getOptions();

  const { publicKey: public_key } = client.getDsn() || {};
  // TODO(v8): Remove segment from User
  // eslint-disable-next-line deprecation/deprecation
  const { segment: user_segment } = (scope && scope.getUser()) || {};

  const dsc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
    environment: options.environment || _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_ENVIRONMENT */ .J,
    release: options.release,
    user_segment,
    public_key,
    trace_id,
  }) ;

  client.emit && client.emit('createDsc', dsc);

  return dsc;
}

/**
 * A Span with a frozen dynamic sampling context.
 */

/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */
function getDynamicSamplingContextFromSpan(span) {
  const client = (0,_exports_js__WEBPACK_IMPORTED_MODULE_2__/* .getClient */ .s3)();
  if (!client) {
    return {};
  }

  // passing emit=false here to only emit later once the DSC is actually populated
  const dsc = getDynamicSamplingContextFromClient((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(span).trace_id || '', client, (0,_exports_js__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentScope */ .nZ)());

  // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
  const txn = (0,_utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__/* .getRootSpan */ .G)(span) ;
  if (!txn) {
    return dsc;
  }

  // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
  // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
  // @see Transaction class constructor
  const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
  if (v7FrozenDsc) {
    return v7FrozenDsc;
  }

  // TODO (v8): Replace txn.metadata with txn.attributes[]
  // We can't do this yet because attributes aren't always set yet.
  // eslint-disable-next-line deprecation/deprecation
  const { sampleRate: maybeSampleRate, source } = txn.metadata;
  if (maybeSampleRate != null) {
    dsc.sample_rate = `${maybeSampleRate}`;
  }

  // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
  const jsonSpan = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(txn);

  // after JSON conversion, txn.name becomes jsonSpan.description
  if (source && source !== 'url') {
    dsc.transaction = jsonSpan.description;
  }

  dsc.sampled = String((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanIsSampled */ .Tt)(txn));

  client.emit && client.emit('createDsc', dsc);

  return dsc;
}


//# sourceMappingURL=dynamicSamplingContext.js.map


/***/ }),

/***/ 24839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HN": function() { return /* binding */ getActiveSpan; },
  "I1": function() { return /* binding */ getCapturedScopesOnSpan; },
  "qp": function() { return /* binding */ startInactiveSpan; },
  "GK": function() { return /* binding */ startSpan; }
});

// UNUSED EXPORTS: continueTrace, startActiveSpan, startSpanManual, trace

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(7052);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(95091);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(56524);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js
var dynamicSamplingContext = __webpack_require__(60292);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(3607);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(34336);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/utils/handleCallbackErrors.js


/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */
function handleCallbackErrors_handleCallbackErrors

(
  fn,
  onError,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onFinally = () => {},
) {
  let maybePromiseResult;
  try {
    maybePromiseResult = fn();
  } catch (e) {
    onError(e);
    onFinally();
    throw e;
  }

  return maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}

/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */
function maybeHandlePromiseRejection(
  value,
  onError,
  onFinally,
) {
  if ((0,is/* isThenable */.J8)(value)) {
    // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then(
      res => {
        onFinally();
        return res;
      },
      e => {
        onError(e);
        onFinally();
        throw e;
      },
    );
  }

  onFinally();
  return value;
}


//# sourceMappingURL=handleCallbackErrors.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/hasTracingEnabled.js
var hasTracingEnabled = __webpack_require__(23572);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/trace.js











/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */
function trace(
  context,
  callback,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onError = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  afterFinish = () => {},
) {
  // eslint-disable-next-line deprecation/deprecation
  const hub = getCurrentHub();
  const scope = getCurrentScope();
  // eslint-disable-next-line deprecation/deprecation
  const parentSpan = scope.getSpan();

  const spanContext = normalizeContext(context);
  const activeSpan = createChildSpanOrTransaction(hub, {
    parentSpan,
    spanContext,
    forceTransaction: false,
    scope,
  });

  // eslint-disable-next-line deprecation/deprecation
  scope.setSpan(activeSpan);

  return handleCallbackErrors(
    () => callback(activeSpan),
    error => {
      activeSpan && activeSpan.setStatus('internal_error');
      onError(error, activeSpan);
    },
    () => {
      activeSpan && activeSpan.end();
      // eslint-disable-next-line deprecation/deprecation
      scope.setSpan(parentSpan);
      afterFinish();
    },
  );
}

/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */
function startSpan(context, callback) {
  const spanContext = normalizeContext(context);

  return (0,esm_hub/* runWithAsyncContext */.Ok)(() => {
    return (0,esm_exports/* withScope */.$e)(context.scope, scope => {
      // eslint-disable-next-line deprecation/deprecation
      const hub = (0,esm_hub/* getCurrentHub */.Gd)();
      // eslint-disable-next-line deprecation/deprecation
      const parentSpan = scope.getSpan();

      const shouldSkipSpan = context.onlyIfParent && !parentSpan;
      const activeSpan = shouldSkipSpan
        ? undefined
        : createChildSpanOrTransaction(hub, {
            parentSpan,
            spanContext,
            forceTransaction: context.forceTransaction,
            scope,
          });

      return handleCallbackErrors_handleCallbackErrors(
        () => callback(activeSpan),
        () => {
          // Only update the span status if it hasn't been changed yet
          if (activeSpan) {
            const { status } = (0,spanUtils/* spanToJSON */.XU)(activeSpan);
            if (!status || status === 'ok') {
              activeSpan.setStatus('internal_error');
            }
          }
        },
        () => activeSpan && activeSpan.end(),
      );
    });
  });
}

/**
 * @deprecated Use {@link startSpan} instead.
 */
const startActiveSpan = (/* unused pure expression or super */ null && (startSpan));

/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */
function startSpanManual(
  context,
  callback,
) {
  const spanContext = normalizeContext(context);

  return runWithAsyncContext(() => {
    return withScope(context.scope, scope => {
      // eslint-disable-next-line deprecation/deprecation
      const hub = getCurrentHub();
      // eslint-disable-next-line deprecation/deprecation
      const parentSpan = scope.getSpan();

      const shouldSkipSpan = context.onlyIfParent && !parentSpan;
      const activeSpan = shouldSkipSpan
        ? undefined
        : createChildSpanOrTransaction(hub, {
            parentSpan,
            spanContext,
            forceTransaction: context.forceTransaction,
            scope,
          });

      function finishAndSetSpan() {
        activeSpan && activeSpan.end();
      }

      return handleCallbackErrors(
        () => callback(activeSpan, finishAndSetSpan),
        () => {
          // Only update the span status if it hasn't been changed yet, and the span is not yet finished
          if (activeSpan && activeSpan.isRecording()) {
            const { status } = spanToJSON(activeSpan);
            if (!status || status === 'ok') {
              activeSpan.setStatus('internal_error');
            }
          }
        },
      );
    });
  });
}

/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */
function startInactiveSpan(context) {
  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)()) {
    return undefined;
  }

  const spanContext = normalizeContext(context);
  // eslint-disable-next-line deprecation/deprecation
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const parentSpan = context.scope
    ? // eslint-disable-next-line deprecation/deprecation
      context.scope.getSpan()
    : getActiveSpan();

  const shouldSkipSpan = context.onlyIfParent && !parentSpan;

  if (shouldSkipSpan) {
    return undefined;
  }

  const scope = context.scope || (0,esm_exports/* getCurrentScope */.nZ)();

  // Even though we don't actually want to make this span active on the current scope,
  // we need to make it active on a temporary scope that we use for event processing
  // as otherwise, it won't pick the correct span for the event when processing it
  const temporaryScope = (scope ).clone();

  return createChildSpanOrTransaction(hub, {
    parentSpan,
    spanContext,
    forceTransaction: context.forceTransaction,
    scope: temporaryScope,
  });
}

/**
 * Returns the currently active span.
 */
function getActiveSpan() {
  // eslint-disable-next-line deprecation/deprecation
  return (0,esm_exports/* getCurrentScope */.nZ)().getSpan();
}

const continueTrace = (
  {
    sentryTrace,
    baggage,
  }

,
  callback,
) => {
  // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
  /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */

  const currentScope = getCurrentScope();

  // eslint-disable-next-line deprecation/deprecation
  const { traceparentData, dynamicSamplingContext, propagationContext } = tracingContextFromHeaders(
    sentryTrace,
    baggage,
  );

  currentScope.setPropagationContext(propagationContext);

  if (DEBUG_BUILD && traceparentData) {
    logger.log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
  }

  const transactionContext = {
    ...traceparentData,
    metadata: dropUndefinedKeys({
      dynamicSamplingContext,
    }),
  };

  if (!callback) {
    return transactionContext;
  }

  return runWithAsyncContext(() => {
    return callback(transactionContext);
  });
};

function createChildSpanOrTransaction(
  // eslint-disable-next-line deprecation/deprecation
  hub,
  {
    parentSpan,
    spanContext,
    forceTransaction,
    scope,
  }

,
) {
  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)()) {
    return undefined;
  }

  const isolationScope = (0,esm_hub/* getIsolationScope */.aF)();

  let span;
  if (parentSpan && !forceTransaction) {
    // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
  } else if (parentSpan) {
    // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
    const dsc = (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(parentSpan);
    const { traceId, spanId: parentSpanId } = parentSpan.spanContext();
    const sampled = (0,spanUtils/* spanIsSampled */.Tt)(parentSpan);

    // eslint-disable-next-line deprecation/deprecation
    span = hub.startTransaction({
      traceId,
      parentSpanId,
      parentSampled: sampled,
      ...spanContext,
      metadata: {
        dynamicSamplingContext: dsc,
        // eslint-disable-next-line deprecation/deprecation
        ...spanContext.metadata,
      },
    });
  } else {
    const { traceId, dsc, parentSpanId, sampled } = {
      ...isolationScope.getPropagationContext(),
      ...scope.getPropagationContext(),
    };

    // eslint-disable-next-line deprecation/deprecation
    span = hub.startTransaction({
      traceId,
      parentSpanId,
      parentSampled: sampled,
      ...spanContext,
      metadata: {
        dynamicSamplingContext: dsc,
        // eslint-disable-next-line deprecation/deprecation
        ...spanContext.metadata,
      },
    });
  }

  // We always set this as active span on the scope
  // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
  // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
  // eslint-disable-next-line deprecation/deprecation
  scope.setSpan(span);

  setCapturedScopesOnSpan(span, scope, isolationScope);

  return span;
}

/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */
function normalizeContext(context) {
  if (context.startTime) {
    const ctx = { ...context };
    ctx.startTimestamp = (0,spanUtils/* spanTimeInputToSeconds */.$k)(context.startTime);
    delete ctx.startTime;
    return ctx;
  }

  return context;
}

const SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';

function setCapturedScopesOnSpan(span, scope, isolationScope) {
  if (span) {
    (0,object/* addNonEnumerableProperty */.xp)(span, ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
    (0,object/* addNonEnumerableProperty */.xp)(span, SCOPE_ON_START_SPAN_FIELD, scope);
  }
}

/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */
function getCapturedScopesOnSpan(span) {
  return {
    scope: (span )[SCOPE_ON_START_SPAN_FIELD],
    isolationScope: (span )[ISOLATION_SCOPE_ON_START_SPAN_FIELD],
  };
}


//# sourceMappingURL=trace.js.map


/***/ }),

/***/ 91182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gi": function() { return /* binding */ applyScopeDataToEvent; },
/* harmony export */   "yo": function() { return /* binding */ mergeScopeData; }
/* harmony export */ });
/* unused harmony export mergeAndOverwriteScopeData */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7052);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50437);
/* harmony import */ var _tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60292);
/* harmony import */ var _getRootSpan_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52310);
/* harmony import */ var _spanUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56524);





/**
 * Applies data from the scope to the event and runs all event processors on it.
 */
function applyScopeDataToEvent(event, data) {
  const { fingerprint, span, breadcrumbs, sdkProcessingMetadata } = data;

  // Apply general data
  applyDataToEvent(event, data);

  // We want to set the trace context for normal events only if there isn't already
  // a trace context on the event. There is a product feature in place where we link
  // errors with transaction and it relies on that.
  if (span) {
    applySpanToEvent(event, span);
  }

  applyFingerprintToEvent(event, fingerprint);
  applyBreadcrumbsToEvent(event, breadcrumbs);
  applySdkMetadataToEvent(event, sdkProcessingMetadata);
}

/** Merge data of two scopes together. */
function mergeScopeData(data, mergeData) {
  const {
    extra,
    tags,
    user,
    contexts,
    level,
    sdkProcessingMetadata,
    breadcrumbs,
    fingerprint,
    eventProcessors,
    attachments,
    propagationContext,
    // eslint-disable-next-line deprecation/deprecation
    transactionName,
    span,
  } = mergeData;

  mergeAndOverwriteScopeData(data, 'extra', extra);
  mergeAndOverwriteScopeData(data, 'tags', tags);
  mergeAndOverwriteScopeData(data, 'user', user);
  mergeAndOverwriteScopeData(data, 'contexts', contexts);
  mergeAndOverwriteScopeData(data, 'sdkProcessingMetadata', sdkProcessingMetadata);

  if (level) {
    data.level = level;
  }

  if (transactionName) {
    // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
  }

  if (span) {
    data.span = span;
  }

  if (breadcrumbs.length) {
    data.breadcrumbs = [...data.breadcrumbs, ...breadcrumbs];
  }

  if (fingerprint.length) {
    data.fingerprint = [...data.fingerprint, ...fingerprint];
  }

  if (eventProcessors.length) {
    data.eventProcessors = [...data.eventProcessors, ...eventProcessors];
  }

  if (attachments.length) {
    data.attachments = [...data.attachments, ...attachments];
  }

  data.propagationContext = { ...data.propagationContext, ...propagationContext };
}

/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */
function mergeAndOverwriteScopeData

(data, prop, mergeVal) {
  if (mergeVal && Object.keys(mergeVal).length) {
    // Clone object
    data[prop] = { ...data[prop] };
    for (const key in mergeVal) {
      if (Object.prototype.hasOwnProperty.call(mergeVal, key)) {
        data[prop][key] = mergeVal[key];
      }
    }
  }
}

function applyDataToEvent(event, data) {
  const {
    extra,
    tags,
    user,
    contexts,
    level,
    // eslint-disable-next-line deprecation/deprecation
    transactionName,
  } = data;

  const cleanedExtra = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(extra);
  if (cleanedExtra && Object.keys(cleanedExtra).length) {
    event.extra = { ...cleanedExtra, ...event.extra };
  }

  const cleanedTags = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(tags);
  if (cleanedTags && Object.keys(cleanedTags).length) {
    event.tags = { ...cleanedTags, ...event.tags };
  }

  const cleanedUser = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(user);
  if (cleanedUser && Object.keys(cleanedUser).length) {
    event.user = { ...cleanedUser, ...event.user };
  }

  const cleanedContexts = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(contexts);
  if (cleanedContexts && Object.keys(cleanedContexts).length) {
    event.contexts = { ...cleanedContexts, ...event.contexts };
  }

  if (level) {
    event.level = level;
  }

  if (transactionName) {
    event.transaction = transactionName;
  }
}

function applyBreadcrumbsToEvent(event, breadcrumbs) {
  const mergedBreadcrumbs = [...(event.breadcrumbs || []), ...breadcrumbs];
  event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}

function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
  event.sdkProcessingMetadata = {
    ...event.sdkProcessingMetadata,
    ...sdkProcessingMetadata,
  };
}

function applySpanToEvent(event, span) {
  event.contexts = { trace: (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .spanToTraceContext */ .wy)(span), ...event.contexts };
  const rootSpan = (0,_getRootSpan_js__WEBPACK_IMPORTED_MODULE_2__/* .getRootSpan */ .G)(span);
  if (rootSpan) {
    event.sdkProcessingMetadata = {
      dynamicSamplingContext: (0,_tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_3__/* .getDynamicSamplingContextFromSpan */ .j)(span),
      ...event.sdkProcessingMetadata,
    };
    const transactionName = (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .spanToJSON */ .XU)(rootSpan).description;
    if (transactionName) {
      event.tags = { transaction: transactionName, ...event.tags };
    }
  }
}

/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */
function applyFingerprintToEvent(event, fingerprint) {
  // Make sure it's an array first and we actually have something in place
  event.fingerprint = event.fingerprint ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .arrayify */ .lE)(event.fingerprint) : [];

  // If we have something on the scope, then merge it with event
  if (fingerprint) {
    event.fingerprint = event.fingerprint.concat(fingerprint);
  }

  // If we have no data at all, remove empty array default
  if (event.fingerprint && !event.fingerprint.length) {
    delete event.fingerprint;
  }
}


//# sourceMappingURL=applyScopeDataToEvent.js.map


/***/ }),

/***/ 52310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getRootSpan; }
/* harmony export */ });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */
function getRootSpan(span) {
  // TODO (v8): Remove this check and just return span
  // eslint-disable-next-line deprecation/deprecation
  return span.transaction;
}


//# sourceMappingURL=getRootSpan.js.map


/***/ }),

/***/ 23572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3607);


// Treeshakable guard to remove all code related to tracing

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) {
    return false;
  }

  const client = (0,_exports_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .s3)();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


//# sourceMappingURL=hasTracingEnabled.js.map


/***/ }),

/***/ 4831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ prepareEvent; },
/* harmony export */   "U0": function() { return /* binding */ parseEventHintOrCaptureContext; }
/* harmony export */ });
/* unused harmony exports applyDebugIds, applyDebugMeta */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50437);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45939);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80109);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97193);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33386);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24733);
/* harmony import */ var _eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21440);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79318);
/* harmony import */ var _applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91182);
/* harmony import */ var _spanUtils_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56524);







/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */

/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */
function prepareEvent(
  options,
  event,
  hint,
  scope,
  client,
  isolationScope,
) {
  const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)(),
    timestamp: event.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dateTimestampInSeconds */ .yW)(),
  };
  const integrations = hint.integrations || options.integrations.map(i => i.name);

  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(prepared, integrations);

  // Only put debug IDs onto frames for error events.
  if (event.type === undefined) {
    applyDebugIds(prepared, options.stackParser);
  }

  // If we have scope given to us, use it as the base for further modifications.
  // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
  const finalScope = getFinalScope(scope, hint.captureContext);

  if (hint.mechanism) {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addExceptionMechanism */ .EG)(prepared, hint.mechanism);
  }

  const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];

  // This should be the last thing called, since we want that
  // {@link Hub.addEventProcessor} gets the finished prepared event.
  // Merge scope data together
  const data = (0,_scope_js__WEBPACK_IMPORTED_MODULE_2__/* .getGlobalScope */ .lW)().getScopeData();

  if (isolationScope) {
    const isolationData = isolationScope.getScopeData();
    (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__/* .mergeScopeData */ .yo)(data, isolationData);
  }

  if (finalScope) {
    const finalScopeData = finalScope.getScopeData();
    (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__/* .mergeScopeData */ .yo)(data, finalScopeData);
  }

  const attachments = [...(hint.attachments || []), ...data.attachments];
  if (attachments.length) {
    hint.attachments = attachments;
  }

  (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__/* .applyScopeDataToEvent */ .gi)(prepared, data);

  // TODO (v8): Update this order to be: Global > Client > Scope
  const eventProcessors = [
    ...clientEventProcessors,
    // eslint-disable-next-line deprecation/deprecation
    ...(0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__/* .getGlobalEventProcessors */ .fH)(),
    // Run scope event processors _after_ all other processors
    ...data.eventProcessors,
  ];

  const result = (0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__/* .notifyEventProcessors */ .RP)(eventProcessors, prepared, hint);

  return result.then(evt => {
    if (evt) {
      // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
      // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
      // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
      // any new data
      applyDebugMeta(evt);
    }

    if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}

/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */
function applyClientOptions(event, options) {
  const { environment, release, dist, maxValueLength = 250 } = options;

  if (!('environment' in event)) {
    event.environment = 'environment' in options ? environment : _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_ENVIRONMENT */ .J;
  }

  if (event.release === undefined && release !== undefined) {
    event.release = release;
  }

  if (event.dist === undefined && dist !== undefined) {
    event.dist = dist;
  }

  if (event.message) {
    event.message = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .truncate */ .$G)(event.message, maxValueLength);
  }

  const exception = event.exception && event.exception.values && event.exception.values[0];
  if (exception && exception.value) {
    exception.value = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .truncate */ .$G)(exception.value, maxValueLength);
  }

  const request = event.request;
  if (request && request.url) {
    request.url = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .truncate */ .$G)(request.url, maxValueLength);
  }
}

const debugIdStackParserCache = new WeakMap();

/**
 * Puts debug IDs into the stack frames of an error event.
 */
function applyDebugIds(event, stackParser) {
  const debugIdMap = _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .GLOBAL_OBJ._sentryDebugIds */ .n2._sentryDebugIds;

  if (!debugIdMap) {
    return;
  }

  let debugIdStackFramesCache;
  const cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
  if (cachedDebugIdStackFrameCache) {
    debugIdStackFramesCache = cachedDebugIdStackFrameCache;
  } else {
    debugIdStackFramesCache = new Map();
    debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
  }

  // Build a map of filename -> debug_id
  const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace) => {
    let parsedStack;
    const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
    if (cachedParsedStack) {
      parsedStack = cachedParsedStack;
    } else {
      parsedStack = stackParser(debugIdStackTrace);
      debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
    }

    for (let i = parsedStack.length - 1; i >= 0; i--) {
      const stackFrame = parsedStack[i];
      if (stackFrame.filename) {
        acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
        break;
      }
    }
    return acc;
  }, {});

  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.filename) {
          frame.debug_id = filenameDebugIdMap[frame.filename];
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }
}

/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */
function applyDebugMeta(event) {
  // Extract debug IDs and filenames from the stack frames on the event.
  const filenameDebugIdMap = {};
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.debug_id) {
          if (frame.abs_path) {
            filenameDebugIdMap[frame.abs_path] = frame.debug_id;
          } else if (frame.filename) {
            filenameDebugIdMap[frame.filename] = frame.debug_id;
          }
          delete frame.debug_id;
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }

  if (Object.keys(filenameDebugIdMap).length === 0) {
    return;
  }

  // Fill debug_meta information
  event.debug_meta = event.debug_meta || {};
  event.debug_meta.images = event.debug_meta.images || [];
  const images = event.debug_meta.images;
  Object.keys(filenameDebugIdMap).forEach(filename => {
    images.push({
      type: 'sourcemap',
      code_file: filename,
      debug_id: filenameDebugIdMap[filename],
    });
  });
}

/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationNames];
  }
}

/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */
function normalizeEvent(event, depth, maxBreadth) {
  if (!event) {
    return null;
  }

  const normalized = {
    ...event,
    ...(event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map(b => ({
        ...b,
        ...(b.data && {
          data: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(b.data, depth, maxBreadth),
        }),
      })),
    }),
    ...(event.user && {
      user: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(event.user, depth, maxBreadth),
    }),
    ...(event.contexts && {
      contexts: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(event.contexts, depth, maxBreadth),
    }),
    ...(event.extra && {
      extra: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(event.extra, depth, maxBreadth),
    }),
  };

  // event.contexts.trace stores information about a Transaction. Similarly,
  // event.spans[] stores information about child Spans. Given that a
  // Transaction is conceptually a Span, normalization should apply to both
  // Transactions and Spans consistently.
  // For now the decision is to skip normalization of Transactions and Spans,
  // so this block overwrites the normalized event to add back the original
  // Transaction information prior to normalization.
  if (event.contexts && event.contexts.trace && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;

    // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(event.contexts.trace.data, depth, maxBreadth);
    }
  }

  // event.spans[].data may contain circular/dangerous data so we need to normalize it
  if (event.spans) {
    normalized.spans = event.spans.map(span => {
      const data = (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_9__/* .spanToJSON */ .XU)(span).data;

      if (data) {
        // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(data, depth, maxBreadth);
      }

      return span;
    });
  }

  return normalized;
}

function getFinalScope(scope, captureContext) {
  if (!captureContext) {
    return scope;
  }

  const finalScope = scope ? scope.clone() : new _scope_js__WEBPACK_IMPORTED_MODULE_2__/* .Scope */ .sX();
  finalScope.update(captureContext);
  return finalScope;
}

/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */
function parseEventHintOrCaptureContext(
  hint,
) {
  if (!hint) {
    return undefined;
  }

  // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
  if (hintIsScopeOrFunction(hint)) {
    return { captureContext: hint };
  }

  if (hintIsScopeContext(hint)) {
    return {
      captureContext: hint,
    };
  }

  return hint;
}

function hintIsScopeOrFunction(
  hint,
) {
  return hint instanceof _scope_js__WEBPACK_IMPORTED_MODULE_2__/* .Scope */ .sX || typeof hint === 'function';
}

const captureContextKeys = [
  'user',
  'level',
  'extra',
  'contexts',
  'tags',
  'fingerprint',
  'requestSession',
  'propagationContext',
] ;

function hintIsScopeContext(hint) {
  return Object.keys(hint).some(key => captureContextKeys.includes(key ));
}


//# sourceMappingURL=prepareEvent.js.map


/***/ }),

/***/ 56524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$k": function() { return /* binding */ spanTimeInputToSeconds; },
/* harmony export */   "Hb": function() { return /* binding */ spanToTraceHeader; },
/* harmony export */   "Tt": function() { return /* binding */ spanIsSampled; },
/* harmony export */   "XU": function() { return /* binding */ spanToJSON; },
/* harmony export */   "i0": function() { return /* binding */ TRACE_FLAG_SAMPLED; },
/* harmony export */   "ve": function() { return /* binding */ TRACE_FLAG_NONE; },
/* harmony export */   "wy": function() { return /* binding */ spanToTraceContext; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7052);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32216);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45939);


// These are aligned with OpenTelemetry trace flags
const TRACE_FLAG_NONE = 0x0;
const TRACE_FLAG_SAMPLED = 0x1;

/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */
function spanToTraceContext(span) {
  const { spanId: span_id, traceId: trace_id } = span.spanContext();
  const { data, op, parent_span_id, status, tags, origin } = spanToJSON(span);

  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
    data,
    op,
    parent_span_id,
    span_id,
    status,
    tags,
    trace_id,
    origin,
  });
}

/**
 * Convert a Span to a Sentry trace header.
 */
function spanToTraceHeader(span) {
  const { traceId, spanId } = span.spanContext();
  const sampled = spanIsSampled(span);
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateSentryTraceHeader */ .$p)(traceId, spanId, sampled);
}

/**
 * Convert a span time input intp a timestamp in seconds.
 */
function spanTimeInputToSeconds(input) {
  if (typeof input === 'number') {
    return ensureTimestampInSeconds(input);
  }

  if (Array.isArray(input)) {
    // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
  }

  if (input instanceof Date) {
    return ensureTimestampInSeconds(input.getTime());
  }

  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .timestampInSeconds */ .ph)();
}

/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */
function ensureTimestampInSeconds(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp / 1000 : timestamp;
}

/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */
function spanToJSON(span) {
  if (spanIsSpanClass(span)) {
    return span.getSpanJSON();
  }

  // Fallback: We also check for `.toJSON()` here...
  // eslint-disable-next-line deprecation/deprecation
  if (typeof span.toJSON === 'function') {
    // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
  }

  return {};
}

/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */
function spanIsSpanClass(span) {
  return typeof (span ).getSpanJSON === 'function';
}

/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */
function spanIsSampled(span) {
  // We align our trace flags with the ones OpenTelemetry use
  // So we also check for sampled the same way they do.
  const { traceFlags } = span.spanContext();
  // eslint-disable-next-line no-bitwise
  return Boolean(traceFlags & TRACE_FLAG_SAMPLED);
}


//# sourceMappingURL=spanUtils.js.map


/***/ }),

/***/ 30919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SDK_VERSION; }
/* harmony export */ });
const SDK_VERSION = '7.120.0';


//# sourceMappingURL=version.js.map


/***/ }),

/***/ 63124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 19494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EN": function() { return /* binding */ baggageHeaderToDynamicSamplingContext; },
/* harmony export */   "IQ": function() { return /* binding */ dynamicSamplingContextToSentryBaggageHeader; },
/* harmony export */   "bU": function() { return /* binding */ BAGGAGE_HEADER_NAME; }
/* harmony export */ });
/* unused harmony exports MAX_BAGGAGE_STRING_LENGTH, SENTRY_BAGGAGE_KEY_PREFIX, SENTRY_BAGGAGE_KEY_PREFIX_REGEX */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78027);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34336);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25853);




const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      for (const key of Object.keys(currBaggageObject)) {
        acc[key] = currBaggageObject[key];
      }
      return acc;
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  if (!dynamicSamplingContext) {
    return undefined;
  }

  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X &&
        _logger_js__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map


/***/ }),

/***/ 51737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "iY": function() { return /* binding */ getComponentName; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34336);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97193);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

const DEFAULT_MAX_STRING_LENGTH = 80;

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(
  elem,
  options = {},
) {
  if (!elem) {
    return '<unknown>';
  }

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = (!Array.isArray(options) && options.maxStringLength) || DEFAULT_MAX_STRING_LENGTH;

    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds maxStringLength
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  // @ts-expect-error WINDOW has HTMLElement
  if (WINDOW.HTMLElement) {
    // If using the component name annotation plugin, this value may be available on the DOM node
    if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) {
      return elem.dataset['sentryComponent'];
    }
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['aria-label', 'type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (WINDOW.document && WINDOW.document.querySelector) {
    return WINDOW.document.querySelector(selector) ;
  }
  return null;
}

/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */
function getComponentName(elem) {
  // @ts-expect-error WINDOW has HTMLElement
  if (!WINDOW.HTMLElement) {
    return null;
  }

  let currentElem = elem ;
  const MAX_TRAVERSE_HEIGHT = 5;
  for (let i = 0; i < MAX_TRAVERSE_HEIGHT; i++) {
    if (!currentElem) {
      return null;
    }

    if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) {
      return currentElem.dataset['sentryComponent'];
    }

    currentElem = currentElem.parentNode;
  }

  return null;
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 78027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 34336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "Le": function() { return /* binding */ isParameterizedString; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; },
/* harmony export */   "y1": function() { return /* binding */ isVueViewModel; }
/* harmony export */ });
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isParameterizedString(wat) {
  return (
    typeof wat === 'object' &&
    wat !== null &&
    '__sentry_template_string__' in wat &&
    '__sentry_template_values__' in wat
  );
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || isParameterizedString(wat) || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}

/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isVueViewModel(wat) {
  // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
  return !!(typeof wat === 'object' && wat !== null && ((wat ).__isVue || (wat )._isVue));
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 25853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "LD": function() { return /* binding */ originalConsoleMethods; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78027);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97193);



/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = [
  'debug',
  'info',
  'warn',
  'error',
  'log',
  'assert',
  'trace',
] ;

/** This may be mutated by the console instrumentation. */
const originalConsoleMethods

 = {};

/** JSDoc */

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
    return callback();
  }

  const console = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console ;
  const wrappedFuncs = {};

  const wrappedLevels = Object.keys(originalConsoleMethods) ;

  // Restore all wrapped console methods
  wrappedLevels.forEach(level => {
    const originalConsoleMethod = originalConsoleMethods[level] ;
    wrappedFuncs[level] = console[level] ;
    console[level] = originalConsoleMethod;
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    wrappedLevels.forEach(level => {
      console[level] = wrappedFuncs[level] ;
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
    isEnabled: () => enabled,
  };

  if (_debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

const logger = makeLogger();


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 50437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7052);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97193);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  let getRandomByte = () => Math.random() * 16;
  try {
    if (crypto && crypto.randomUUID) {
      return crypto.randomUUID().replace(/-/g, '');
    }
    if (crypto && crypto.getRandomValues) {
      getRandomByte = () => {
        // crypto.getRandomValues might return undefined instead of the typed array
        // in old Chromium versions (e.g. 23.0.1235.0 (151422))
        // However, `typedArray` is still filled in-place.
        // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
        const typedArray = new Uint8Array(1);
        crypto.getRandomValues(typedArray);
        return typedArray[0];
      };
    }
  } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
  }

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 33386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fv": function() { return /* binding */ normalize; },
  "Qy": function() { return /* binding */ normalizeToSize; }
});

// UNUSED EXPORTS: normalizeUrlToBase, walk

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(34336);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(7052);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(12452);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = 100, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  const normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (
    value == null || // this matches null and undefined -> eqeq not eqeqeq
    (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))
  ) {
    return value ;
  }

  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
  // We keep a certain amount of depth.
  // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
  const remainingDepth =
    typeof (value )['__sentry_override_normalization_depth__'] === 'number'
      ? ((value )['__sentry_override_normalization_depth__'] )
      : depth;

  // We're also done if we've reached the max depth
  if (remainingDepth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);

    numAdded++;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/* eslint-disable complexity */
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    if ((0,is/* isVueViewModel */.y1)(value)) {
      return '[VueViewModel]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    const objName = getConstructorName(value);

    // Handle HTML Elements
    if (/^HTML(\w*)Element$/.test(objName)) {
      return `[HTMLElement: ${objName}]`;
    }

    return `[object ${objName}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}
/* eslint-enable complexity */

function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);

  return prototype ? prototype.constructor.name : 'null prototype';
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */
function normalizeUrlToBase(url, basePath) {
  const escapedBase = basePath
    // Backslash to forward
    .replace(/\\/g, '/')
    // Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');

  let newUrl = url;
  try {
    newUrl = decodeURI(url);
  } catch (_Oo) {
    // Sometime this breaks
  }
  return (
    newUrl
      .replace(/\\/g, '/')
      .replace(/webpack:\/?/g, '') // Remove intermediate base path
      // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
      .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///')
  );
}


//# sourceMappingURL=normalize.js.map


/***/ }),

/***/ 7052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51737);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78027);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34336);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25853);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80109);






/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    markFunctionWrapped(wrapped, original);
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  try {
    Object.defineProperty(obj, name, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: value,
      writable: true,
      configurable: true,
    });
  } catch (o_O) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.log */ .kg.log(`Failed to add non-enumerable property "${name}" to object`, obj);
  }
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  try {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
  } catch (o_O) {} // eslint-disable-line no-empty
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(
  value,
)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isEvent */ .cO)(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_3__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_4__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_4__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if (isPojo(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

function isPojo(input) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isPlainObject */ .PO)(input)) {
    return false;
  }

  try {
    const name = (Object.getPrototypeOf(input) ).constructor.name;
    return !name || name === 'Object';
  } catch (e) {
    return true;
  }
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 12452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */



const STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const STRIP_FRAME_REGEXP = /captureMessage|captureException/;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];
    const lines = stack.split('\n');

    for (let i = skipFirst; i < lines.length; i++) {
      const line = lines[i];
      // Ignore lines over 1kb as they are unlikely to be stack frames.
      // Many of the regular expressions use backtracking which results in run time that increases exponentially with
      // input size. Huge strings can result in hangs/Denial of Service:
      // https://github.com/getsentry/sentry-javascript/issues/2286
      if (line.length > 1024) {
        continue;
      }

      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, '$1') : line;

      // https://github.com/getsentry/sentry-javascript/issues/7813
      // Skip Error: lines
      if (cleanedLine.match(/\S*Error: /)) {
        continue;
      }

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }

      if (frames.length >= STACKTRACE_FRAME_LIMIT) {
        break;
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  const localStack = Array.from(stack);

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) {
    localStack.pop();
  }

  // Reversing in the middle of the procedure allows us to just pop the values off the stack
  localStack.reverse();

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
    localStack.pop();

    // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
    // is produced within the hub itself, making it:
    //
    //   Sentry.captureException()
    //   getCurrentHub().captureException()
    //
    // instead of just the top `Sentry` call itself.
    // This forces us to possibly strip an additional frame in the exact same was as above.
    if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
      localStack.pop();
    }
  }

  return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map(frame => ({
    ...frame,
    filename: frame.filename || localStack[localStack.length - 1].filename,
    function: frame.function || '?',
  }));
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 80109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "U0": function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; }
/* harmony export */ });
/* unused harmony exports isMatchingPattern, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34336);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
      // console warnings. This happens when a Vue template is rendered with
      // an undeclared variable, which we try to stringify, ultimately causing
      // Vue to issue another warning which repeats indefinitely.
      // see: https://github.com/getsentry/sentry-javascript/pull/8981
      if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isVueViewModel */ .y1)(value)) {
        output.push('[VueViewModel]');
      } else {
        output.push(String(value));
      }
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function isMatchingPattern(
  value,
  pattern,
  requireExactStringMatch = false,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }

  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function stringMatchesSomePattern(
  testString,
  patterns = [],
  requireExactStringMatch = false,
) {
  return patterns.some(pattern => isMatchingPattern(testString, pattern, requireExactStringMatch));
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 47287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34336);


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {

   constructor(
    executor,
  ) {SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);
    this._state = States.PENDING;
    this._handlers = [];

    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init2() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init3() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init4() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 45939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, timestampWithMs */
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97193);


const ONE_SECOND_IN_MS = 1000;

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */
function dateTimestampInSeconds() {
  return Date.now() / ONE_SECOND_IN_MS;
}

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function createUnixTimestampInSecondsFunc() {
  const { performance } = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  if (!performance || !performance.now) {
    return dateTimestampInSeconds;
  }

  // Some browser and environments don't have a timeOrigin, so we fallback to
  // using Date.now() to compute the starting time.
  const approxStartingTimeOrigin = Date.now() - performance.now();
  const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;

  // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
  // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
  //
  // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
  // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
  // correct for this.
  // See: https://github.com/getsentry/sentry-javascript/issues/2590
  // See: https://github.com/mdn/content/issues/4713
  // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
  return () => {
    return (timeOrigin + performance.now()) / ONE_SECOND_IN_MS;
  };
}

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = createUnixTimestampInSecondsFunc();

/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */
const timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 32216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ generateSentryTraceHeader; },
/* harmony export */   "KA": function() { return /* binding */ tracingContextFromHeaders; },
/* harmony export */   "pT": function() { return /* binding */ propagationContextFromHeaders; }
/* harmony export */ });
/* unused harmony exports TRACEPARENT_REGEXP, extractTraceparentData */
/* harmony import */ var _baggage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19494);
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50437);



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  if (!traceparent) {
    return undefined;
  }

  const matches = traceparent.match(TRACEPARENT_REGEXP);
  if (!matches) {
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}

/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */
// TODO(v8): Remove this function
function tracingContextFromHeaders(
  sentryTrace,
  baggage,
)

 {
  const traceparentData = extractTraceparentData(sentryTrace);
  const dynamicSamplingContext = (0,_baggage_js__WEBPACK_IMPORTED_MODULE_0__/* .baggageHeaderToDynamicSamplingContext */ .EN)(baggage);

  const { traceId, parentSpanId, parentSampled } = traceparentData || {};

  if (!traceparentData) {
    return {
      traceparentData,
      dynamicSamplingContext: undefined,
      propagationContext: {
        traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
        spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
      },
    };
  } else {
    return {
      traceparentData,
      dynamicSamplingContext: dynamicSamplingContext || {}, // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
      propagationContext: {
        traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
        parentSpanId: parentSpanId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
        spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}, // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
      },
    };
  }
}

/**
 * Create a propagation context from incoming headers.
 */
function propagationContextFromHeaders(
  sentryTrace,
  baggage,
) {
  const traceparentData = extractTraceparentData(sentryTrace);
  const dynamicSamplingContext = (0,_baggage_js__WEBPACK_IMPORTED_MODULE_0__/* .baggageHeaderToDynamicSamplingContext */ .EN)(baggage);

  const { traceId, parentSpanId, parentSampled } = traceparentData || {};

  if (!traceparentData) {
    return {
      traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
      spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
    };
  } else {
    return {
      traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
      parentSpanId: parentSpanId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
      spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
      sampled: parentSampled,
      dsc: dynamicSamplingContext || {}, // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
    };
  }
}

/**
 * Create sentry-trace header from span context values.
 */
function generateSentryTraceHeader(
  traceId = (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
  spanId = (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
  sampled,
) {
  let sampledString = '';
  if (sampled !== undefined) {
    sampledString = sampled ? '-1' : '-0';
  }
  return `${traceId}-${spanId}${sampledString}`;
}


//# sourceMappingURL=tracing.js.map


/***/ }),

/***/ 97193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 87664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var v1 = __webpack_require__(79441);
var v4 = __webpack_require__(68250);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),

/***/ 31619:
/***/ (function(module) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),

/***/ 10142:
/***/ (function(module) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),

/***/ 79441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var rng = __webpack_require__(10142);
var bytesToUuid = __webpack_require__(31619);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),

/***/ 68250:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var rng = __webpack_require__(10142);
var bytesToUuid = __webpack_require__(31619);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),

/***/ 61774:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var v1 = __webpack_require__(38039);
var v4 = __webpack_require__(12164);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),

/***/ 4589:
/***/ (function(module) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),

/***/ 17375:
/***/ (function(module) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),

/***/ 38039:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var rng = __webpack_require__(17375);
var bytesToUuid = __webpack_require__(4589);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),

/***/ 12164:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var rng = __webpack_require__(17375);
var bytesToUuid = __webpack_require__(4589);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),

/***/ 27861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ createSprinkles; }
});

// UNUSED EXPORTS: createAtomsFn

;// CONCATENATED MODULE: ./node_modules/@vanilla-extract/sprinkles/dist/createSprinkles-c150330f.esm.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var createSprinkles_c150330f_esm_createSprinkles = composeStyles => function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var sprinklesStyles = Object.assign({}, ...args.map(a => a.styles));
  var sprinklesKeys = Object.keys(sprinklesStyles);
  var shorthandNames = sprinklesKeys.filter(property => 'mappings' in sprinklesStyles[property]);

  var sprinklesFn = props => {
    var classNames = [];
    var shorthands = {};

    var nonShorthands = _objectSpread2({}, props);

    var hasShorthands = false;

    for (var shorthand of shorthandNames) {
      var value = props[shorthand];

      if (value != null) {
        var sprinkle = sprinklesStyles[shorthand];
        hasShorthands = true;

        for (var propMapping of sprinkle.mappings) {
          shorthands[propMapping] = value;

          if (nonShorthands[propMapping] == null) {
            delete nonShorthands[propMapping];
          }
        }
      }
    }

    var finalProps = hasShorthands ? _objectSpread2(_objectSpread2({}, shorthands), nonShorthands) : props;

    for (var prop in finalProps) {
      var propValue = finalProps[prop];
      var _sprinkle = sprinklesStyles[prop];

      try {
        if (_sprinkle.mappings) {
          // Skip shorthands
          continue;
        }

        if (typeof propValue === 'string' || typeof propValue === 'number') {
          if (false) {}

          classNames.push(_sprinkle.values[propValue].defaultClass);
        } else if (Array.isArray(propValue)) {
          for (var responsiveIndex = 0; responsiveIndex < propValue.length; responsiveIndex++) {
            var responsiveValue = propValue[responsiveIndex];

            if (responsiveValue != null) {
              var conditionName = _sprinkle.responsiveArray[responsiveIndex];

              if (false) {}

              classNames.push(_sprinkle.values[responsiveValue].conditions[conditionName]);
            }
          }
        } else {
          for (var _conditionName in propValue) {
            // Conditional style
            var _value = propValue[_conditionName];

            if (_value != null) {
              if (false) {}

              classNames.push(_sprinkle.values[_value].conditions[_conditionName]);
            }
          }
        }
      } catch (e) {
        if (false) {}

        throw e;
      }
    }

    return composeStyles(classNames.join(' '));
  };

  return Object.assign(sprinklesFn, {
    properties: new Set(sprinklesKeys)
  });
};



;// CONCATENATED MODULE: ./node_modules/@vanilla-extract/sprinkles/createRuntimeSprinkles/dist/vanilla-extract-sprinkles-createRuntimeSprinkles.esm.js


var composeStyles = classList => classList;

var createSprinkles = function createSprinkles() {
  return createSprinkles_c150330f_esm_createSprinkles(composeStyles)(...arguments);
};
/** @deprecated - Use `createSprinkles` */

var createAtomsFn = (/* unused pure expression or super */ null && (createSprinkles));




/***/ }),

/***/ 83975:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 20122:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(83975)
var ieee754 = __webpack_require__(3229)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

var K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 50791:
/***/ (function(module) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),

/***/ 32852:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 66449:
/***/ (function(module) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),

/***/ 65690:
/***/ (function(module) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ 99788:
/***/ (function(module) {

"use strict";

module.exports = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};


/***/ }),

/***/ 70527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ isKeyframesTarget; }
/* harmony export */ });
var isKeyframesTarget = function (v) {
    return Array.isArray(v);
};




/***/ }),

/***/ 38090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ev": function() { return /* binding */ getValueTransition; },
  "b8": function() { return /* binding */ startAnimation; }
});

// UNUSED EXPORTS: convertTransitionToAnimationOptions, getDelayFromTransition, getPopmotionAnimationOptions, getZeroUnit, hydrateKeyframes, isTransitionDefined, isZero

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50879);
// EXTERNAL MODULE: ./node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(162);
// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/clamp.js
var clamp = __webpack_require__(76846);
;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/utils/find-spring.js



var safeMin = 0.001;
var minDuration = 0.01;
var maxDuration = 10.0;
var minDamping = 0.05;
var maxDamping = 1;
function findSpring(_a) {
    var _b = _a.duration, duration = _b === void 0 ? 800 : _b, _c = _a.bounce, bounce = _c === void 0 ? 0.25 : _c, _d = _a.velocity, velocity = _d === void 0 ? 0 : _d, _e = _a.mass, mass = _e === void 0 ? 1 : _e;
    var envelope;
    var derivative;
    (0,hey_listen_es/* warning */.K)(duration <= maxDuration * 1000, "Spring duration must be 10 seconds or less");
    var dampingRatio = 1 - bounce;
    dampingRatio = (0,clamp/* clamp */.u)(minDamping, maxDamping, dampingRatio);
    duration = (0,clamp/* clamp */.u)(minDuration, maxDuration, duration / 1000);
    if (dampingRatio < 1) {
        envelope = function (undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var a = exponentialDecay - velocity;
            var b = calcAngularFreq(undampedFreq, dampingRatio);
            var c = Math.exp(-delta);
            return safeMin - (a / b) * c;
        };
        derivative = function (undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var d = delta * velocity + velocity;
            var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            var f = Math.exp(-delta);
            var g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            var factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return (factor * ((d - e) * f)) / g;
        };
    }
    else {
        envelope = function (undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = function (undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    var initialGuess = 5 / duration;
    var undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) {
        return {
            stiffness: 100,
            damping: 10,
            duration: duration,
        };
    }
    else {
        var stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration,
        };
    }
}
var rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    var result = initialGuess;
    for (var i = 1; i < rootIterations; i++) {
        result = result - envelope(result) / derivative(result);
    }
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/generators/spring.js



var durationKeys = ["duration", "bounce"];
var physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
    return keys.some(function (key) { return options[key] !== undefined; });
}
function getSpringOptions(options) {
    var springOptions = (0,tslib_es6.__assign)({ velocity: 0.0, stiffness: 100, damping: 10, mass: 1.0, isResolvedFromDuration: false }, options);
    if (!isSpringType(options, physicsKeys) &&
        isSpringType(options, durationKeys)) {
        var derived = findSpring(options);
        springOptions = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, springOptions), derived), { velocity: 0.0, mass: 1.0 });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function spring(_a) {
    var _b = _a.from, from = _b === void 0 ? 0.0 : _b, _c = _a.to, to = _c === void 0 ? 1.0 : _c, _d = _a.restSpeed, restSpeed = _d === void 0 ? 2 : _d, restDelta = _a.restDelta, options = (0,tslib_es6.__rest)(_a, ["from", "to", "restSpeed", "restDelta"]);
    var state = { done: false, value: from };
    var _e = getSpringOptions(options), stiffness = _e.stiffness, damping = _e.damping, mass = _e.mass, velocity = _e.velocity, duration = _e.duration, isResolvedFromDuration = _e.isResolvedFromDuration;
    var resolveSpring = zero;
    var resolveVelocity = zero;
    function createSpring() {
        var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        var initialDelta = to - from;
        var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        var undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        restDelta !== null && restDelta !== void 0 ? restDelta : (restDelta = Math.abs(to - from) <= 1 ? 0.01 : 0.4);
        if (dampingRatio < 1) {
            var angularFreq_1 = calcAngularFreq(undampedAngularFreq, dampingRatio);
            resolveSpring = function (t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return (to -
                    envelope *
                        (((initialVelocity +
                            dampingRatio * undampedAngularFreq * initialDelta) /
                            angularFreq_1) *
                            Math.sin(angularFreq_1 * t) +
                            initialDelta * Math.cos(angularFreq_1 * t)));
            };
            resolveVelocity = function (t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return (dampingRatio *
                    undampedAngularFreq *
                    envelope *
                    ((Math.sin(angularFreq_1 * t) *
                        (initialVelocity +
                            dampingRatio *
                                undampedAngularFreq *
                                initialDelta)) /
                        angularFreq_1 +
                        initialDelta * Math.cos(angularFreq_1 * t)) -
                    envelope *
                        (Math.cos(angularFreq_1 * t) *
                            (initialVelocity +
                                dampingRatio *
                                    undampedAngularFreq *
                                    initialDelta) -
                            angularFreq_1 *
                                initialDelta *
                                Math.sin(angularFreq_1 * t)));
            };
        }
        else if (dampingRatio === 1) {
            resolveSpring = function (t) {
                return to -
                    Math.exp(-undampedAngularFreq * t) *
                        (initialDelta +
                            (initialVelocity + undampedAngularFreq * initialDelta) *
                                t);
            };
        }
        else {
            var dampedAngularFreq_1 = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = function (t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                var freqForT = Math.min(dampedAngularFreq_1 * t, 300);
                return (to -
                    (envelope *
                        ((initialVelocity +
                            dampingRatio * undampedAngularFreq * initialDelta) *
                            Math.sinh(freqForT) +
                            dampedAngularFreq_1 *
                                initialDelta *
                                Math.cosh(freqForT))) /
                        dampedAngularFreq_1);
            };
        }
    }
    createSpring();
    return {
        next: function (t) {
            var current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                var currentVelocity = resolveVelocity(t) * 1000;
                var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                var isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done =
                    isBelowVelocityThreshold && isBelowDisplacementThreshold;
            }
            else {
                state.done = t >= duration;
            }
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: function () {
            var _a;
            velocity = -velocity;
            _a = [to, from], from = _a[0], to = _a[1];
            createSpring();
        },
    };
}
spring.needsInterpolation = function (a, b) {
    return typeof a === "string" || typeof b === "string";
};
var zero = function (_t) { return 0; };



// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/progress.js
var progress = __webpack_require__(17027);
// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/mix.js
var mix = __webpack_require__(41410);
// EXTERNAL MODULE: ./node_modules/style-value-types/dist/es/color/hex.js
var hex = __webpack_require__(91660);
// EXTERNAL MODULE: ./node_modules/style-value-types/dist/es/color/rgba.js
var rgba = __webpack_require__(8619);
// EXTERNAL MODULE: ./node_modules/style-value-types/dist/es/color/hsla.js
var hsla = __webpack_require__(10197);
;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/mix-color.js





var mixLinearColor = function (from, to, v) {
    var fromExpo = from * from;
    var toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
var colorTypes = [hex/* hex */.$, rgba/* rgba */.m, hsla/* hsla */.J];
var getColorType = function (v) {
    return colorTypes.find(function (type) { return type.test(v); });
};
var notAnimatable = function (color) {
    return "'" + color + "' is not an animatable color. Use the equivalent color code instead.";
};
var mixColor = function (from, to) {
    var fromColorType = getColorType(from);
    var toColorType = getColorType(to);
    (0,hey_listen_es/* invariant */.k)(!!fromColorType, notAnimatable(from));
    (0,hey_listen_es/* invariant */.k)(!!toColorType, notAnimatable(to));
    (0,hey_listen_es/* invariant */.k)(fromColorType.transform === toColorType.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");
    var fromColor = fromColorType.parse(from);
    var toColor = toColorType.parse(to);
    var blended = (0,tslib_es6.__assign)({}, fromColor);
    var mixFunc = fromColorType === hsla/* hsla */.J ? mix/* mix */.C : mixLinearColor;
    return function (v) {
        for (var key in blended) {
            if (key !== "alpha") {
                blended[key] = mixFunc(fromColor[key], toColor[key], v);
            }
        }
        blended.alpha = (0,mix/* mix */.C)(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};



// EXTERNAL MODULE: ./node_modules/style-value-types/dist/es/color/index.js
var color = __webpack_require__(32672);
// EXTERNAL MODULE: ./node_modules/style-value-types/dist/es/complex/index.js
var complex = __webpack_require__(8384);
// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/inc.js
var inc = __webpack_require__(71022);
// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/pipe.js
var pipe = __webpack_require__(8813);
;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/mix-complex.js








function getMixer(origin, target) {
    if ((0,inc/* isNum */.e)(origin)) {
        return function (v) { return (0,mix/* mix */.C)(origin, target, v); };
    }
    else if (color/* color.test */.$.test(origin)) {
        return mixColor(origin, target);
    }
    else {
        return mixComplex(origin, target);
    }
}
var mixArray = function (from, to) {
    var output = (0,tslib_es6.__spreadArray)([], from);
    var numValues = output.length;
    var blendValue = from.map(function (fromThis, i) { return getMixer(fromThis, to[i]); });
    return function (v) {
        for (var i = 0; i < numValues; i++) {
            output[i] = blendValue[i](v);
        }
        return output;
    };
};
var mixObject = function (origin, target) {
    var output = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, origin), target);
    var blendValue = {};
    for (var key in output) {
        if (origin[key] !== undefined && target[key] !== undefined) {
            blendValue[key] = getMixer(origin[key], target[key]);
        }
    }
    return function (v) {
        for (var key in blendValue) {
            output[key] = blendValue[key](v);
        }
        return output;
    };
};
function analyse(value) {
    var parsed = complex/* complex.parse */.P.parse(value);
    var numValues = parsed.length;
    var numNumbers = 0;
    var numRGB = 0;
    var numHSL = 0;
    for (var i = 0; i < numValues; i++) {
        if (numNumbers || typeof parsed[i] === "number") {
            numNumbers++;
        }
        else {
            if (parsed[i].hue !== undefined) {
                numHSL++;
            }
            else {
                numRGB++;
            }
        }
    }
    return { parsed: parsed, numNumbers: numNumbers, numRGB: numRGB, numHSL: numHSL };
}
var mixComplex = function (origin, target) {
    var template = complex/* complex.createTransformer */.P.createTransformer(target);
    var originStats = analyse(origin);
    var targetStats = analyse(target);
    (0,hey_listen_es/* invariant */.k)(originStats.numHSL === targetStats.numHSL &&
        originStats.numRGB === targetStats.numRGB &&
        originStats.numNumbers >= targetStats.numNumbers, "Complex values '" + origin + "' and '" + target + "' too different to mix. Ensure all colors are of the same type.");
    return (0,pipe/* pipe */.z)(mixArray(originStats.parsed, targetStats.parsed), template);
};



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/interpolate.js









var mixNumber = function (from, to) { return function (p) { return (0,mix/* mix */.C)(from, to, p); }; };
function detectMixerFactory(v) {
    if (typeof v === 'number') {
        return mixNumber;
    }
    else if (typeof v === 'string') {
        if (color/* color.test */.$.test(v)) {
            return mixColor;
        }
        else {
            return mixComplex;
        }
    }
    else if (Array.isArray(v)) {
        return mixArray;
    }
    else if (typeof v === 'object') {
        return mixObject;
    }
}
function createMixers(output, ease, customMixer) {
    var mixers = [];
    var mixerFactory = customMixer || detectMixerFactory(output[0]);
    var numMixers = output.length - 1;
    for (var i = 0; i < numMixers; i++) {
        var mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0,pipe/* pipe */.z)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function fastInterpolate(_a, _b) {
    var from = _a[0], to = _a[1];
    var mixer = _b[0];
    return function (v) { return mixer((0,progress/* progress */.Y)(from, to, v)); };
}
function slowInterpolate(input, mixers) {
    var inputLength = input.length;
    var lastInputIndex = inputLength - 1;
    return function (v) {
        var mixerIndex = 0;
        var foundMixerIndex = false;
        if (v <= input[0]) {
            foundMixerIndex = true;
        }
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            var i = 1;
            for (; i < inputLength; i++) {
                if (input[i] > v || i === lastInputIndex) {
                    break;
                }
            }
            mixerIndex = i - 1;
        }
        var progressInRange = (0,progress/* progress */.Y)(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function interpolate(input, output, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.clamp, isClamp = _c === void 0 ? true : _c, ease = _b.ease, mixer = _b.mixer;
    var inputLength = input.length;
    (0,hey_listen_es/* invariant */.k)(inputLength === output.length, 'Both input and output ranges must be the same length');
    (0,hey_listen_es/* invariant */.k)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, 'Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.');
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    var mixers = createMixers(output, ease, mixer);
    var interpolator = inputLength === 2
        ? fastInterpolate(input, mixers)
        : slowInterpolate(input, mixers);
    return isClamp
        ? function (v) { return interpolator((0,clamp/* clamp */.u)(input[0], input[inputLength - 1], v)); }
        : interpolator;
}



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/easing/utils.js
var reverseEasing = function (easing) { return function (p) { return 1 - easing(1 - p); }; };
var mirrorEasing = function (easing) { return function (p) {
    return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
}; };
var createExpoIn = function (power) { return function (p) { return Math.pow(p, power); }; };
var createBackIn = function (power) { return function (p) {
    return p * p * ((power + 1) * p - power);
}; };
var createAnticipate = function (power) {
    var backEasing = createBackIn(power);
    return function (p) {
        return (p *= 2) < 1
            ? 0.5 * backEasing(p)
            : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
    };
};



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/easing/index.js


var DEFAULT_OVERSHOOT_STRENGTH = 1.525;
var BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
var BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
var BOUNCE_THIRD_THRESHOLD = 9.0 / 10.0;
var linear = function (p) { return p; };
var easeIn = createExpoIn(2);
var easeOut = reverseEasing(easeIn);
var easeInOut = mirrorEasing(easeIn);
var circIn = function (p) { return 1 - Math.sin(Math.acos(p)); };
var circOut = reverseEasing(circIn);
var circInOut = mirrorEasing(circOut);
var backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
var backOut = reverseEasing(backIn);
var backInOut = mirrorEasing(backIn);
var anticipate = createAnticipate(DEFAULT_OVERSHOOT_STRENGTH);
var ca = 4356.0 / 361.0;
var cb = 35442.0 / 1805.0;
var cc = 16061.0 / 1805.0;
var bounceOut = function (p) {
    if (p === 1 || p === 0)
        return p;
    var p2 = p * p;
    return p < BOUNCE_FIRST_THRESHOLD
        ? 7.5625 * p2
        : p < BOUNCE_SECOND_THRESHOLD
            ? 9.075 * p2 - 9.9 * p + 3.4
            : p < BOUNCE_THIRD_THRESHOLD
                ? ca * p2 - cb * p + cc
                : 10.8 * p * p - 20.52 * p + 10.72;
};
var bounceIn = reverseEasing(bounceOut);
var bounceInOut = function (p) {
    return p < 0.5
        ? 0.5 * (1.0 - bounceOut(1.0 - p * 2.0))
        : 0.5 * bounceOut(p * 2.0 - 1.0) + 0.5;
};



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/generators/keyframes.js



function defaultEasing(values, easing) {
    return values.map(function () { return easing || easeInOut; }).splice(0, values.length - 1);
}
function defaultOffset(values) {
    var numValues = values.length;
    return values.map(function (_value, i) {
        return i !== 0 ? i / (numValues - 1) : 0;
    });
}
function convertOffsetToTimes(offset, duration) {
    return offset.map(function (o) { return o * duration; });
}
function keyframes(_a) {
    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.to, to = _c === void 0 ? 1 : _c, ease = _a.ease, offset = _a.offset, _d = _a.duration, duration = _d === void 0 ? 300 : _d;
    var state = { done: false, value: from };
    var values = Array.isArray(to) ? to : [from, to];
    var times = convertOffsetToTimes(offset && offset.length === values.length
        ? offset
        : defaultOffset(values), duration);
    function createInterpolator() {
        return interpolate(times, values, {
            ease: Array.isArray(ease) ? ease : defaultEasing(values, ease),
        });
    }
    var interpolator = createInterpolator();
    return {
        next: function (t) {
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: function () {
            values.reverse();
            interpolator = createInterpolator();
        },
    };
}



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/generators/decay.js
function decay(_a) {
    var _b = _a.velocity, velocity = _b === void 0 ? 0 : _b, _c = _a.from, from = _c === void 0 ? 0 : _c, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 350 : _e, _f = _a.restDelta, restDelta = _f === void 0 ? 0.5 : _f, modifyTarget = _a.modifyTarget;
    var state = { done: false, value: from };
    var amplitude = power * velocity;
    var ideal = from + amplitude;
    var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal)
        amplitude = target - from;
    return {
        next: function (t) {
            var delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: function () { },
    };
}



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/utils/detect-animation-from-options.js




var types = { keyframes: keyframes, spring: spring, decay: decay };
function detectAnimationFromOptions(config) {
    if (Array.isArray(config.to)) {
        return keyframes;
    }
    else if (types[config.type]) {
        return types[config.type];
    }
    var keys = new Set(Object.keys(config));
    if (keys.has("ease") ||
        (keys.has("duration") && !keys.has("dampingRatio"))) {
        return keyframes;
    }
    else if (keys.has("dampingRatio") ||
        keys.has("stiffness") ||
        keys.has("mass") ||
        keys.has("damping") ||
        keys.has("restSpeed") ||
        keys.has("restDelta")) {
        return spring;
    }
    return keyframes;
}



// EXTERNAL MODULE: ./node_modules/framesync/dist/es/index.js + 2 modules
var es = __webpack_require__(42835);
;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/utils/elapsed.js
function loopElapsed(elapsed, duration, delay) {
    if (delay === void 0) { delay = 0; }
    return elapsed - duration - delay;
}
function reverseElapsed(elapsed, duration, delay, isForwardPlayback) {
    if (delay === void 0) { delay = 0; }
    if (isForwardPlayback === void 0) { isForwardPlayback = true; }
    return isForwardPlayback
        ? loopElapsed(duration + -elapsed, duration, delay)
        : duration - (elapsed - duration) + delay;
}
function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/index.js






var framesync = function (update) {
    var passTimestamp = function (_a) {
        var delta = _a.delta;
        return update(delta);
    };
    return {
        start: function () { return es/* default.update */.ZP.update(passTimestamp, true); },
        stop: function () { return es/* cancelSync.update */.qY.update(passTimestamp); },
    };
};
function animate(_a) {
    var _b, _c;
    var from = _a.from, _d = _a.autoplay, autoplay = _d === void 0 ? true : _d, _e = _a.driver, driver = _e === void 0 ? framesync : _e, _f = _a.elapsed, elapsed = _f === void 0 ? 0 : _f, _g = _a.repeat, repeatMax = _g === void 0 ? 0 : _g, _h = _a.repeatType, repeatType = _h === void 0 ? "loop" : _h, _j = _a.repeatDelay, repeatDelay = _j === void 0 ? 0 : _j, onPlay = _a.onPlay, onStop = _a.onStop, onComplete = _a.onComplete, onRepeat = _a.onRepeat, onUpdate = _a.onUpdate, options = (0,tslib_es6.__rest)(_a, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
    var to = options.to;
    var driverControls;
    var repeatCount = 0;
    var computedDuration = options.duration;
    var latest;
    var isComplete = false;
    var isForwardPlayback = true;
    var interpolateFromNumber;
    var animator = detectAnimationFromOptions(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = interpolate([0, 100], [from, to], {
            clamp: false,
        });
        from = 0;
        to = 100;
    }
    var animation = animator((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { from: from, to: to }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        }
        else {
            elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror")
                animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback)
            delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            var state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber)
                latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0)
                computedDuration !== null && computedDuration !== void 0 ? computedDuration : (computedDuration = elapsed);
            if (repeatCount < repeatMax) {
                hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            }
            else {
                complete();
            }
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 ? void 0 : onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: function () {
            onStop === null || onStop === void 0 ? void 0 : onStop();
            driverControls.stop();
        },
    };
}



// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/velocity-per-second.js
var velocity_per_second = __webpack_require__(93222);
;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/animations/inertia.js





function inertia(_a) {
    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.velocity, velocity = _c === void 0 ? 0 : _c, min = _a.min, max = _a.max, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 750 : _e, _f = _a.bounceStiffness, bounceStiffness = _f === void 0 ? 500 : _f, _g = _a.bounceDamping, bounceDamping = _g === void 0 ? 10 : _g, _h = _a.restDelta, restDelta = _h === void 0 ? 1 : _h, modifyTarget = _a.modifyTarget, driver = _a.driver, onUpdate = _a.onUpdate, onComplete = _a.onComplete;
    var currentAnimation;
    function isOutOfBounds(v) {
        return (min !== undefined && v < min) || (max !== undefined && v > max);
    }
    function boundaryNearest(v) {
        if (min === undefined)
            return max;
        if (max === undefined)
            return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
        currentAnimation = animate((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { driver: driver, onUpdate: function (v) {
                var _a;
                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, v);
            }, onComplete: onComplete }));
    }
    function startSpring(options) {
        startAnimation((0,tslib_es6.__assign)({ type: "spring", stiffness: bounceStiffness, damping: bounceDamping, restDelta: restDelta }, options));
    }
    if (isOutOfBounds(from)) {
        startSpring({ from: from, velocity: velocity, to: boundaryNearest(from) });
    }
    else {
        var target = power * velocity + from;
        if (typeof modifyTarget !== "undefined")
            target = modifyTarget(target);
        var boundary_1 = boundaryNearest(target);
        var heading_1 = boundary_1 === min ? -1 : 1;
        var prev_1;
        var current_1;
        var checkBoundary = function (v) {
            prev_1 = current_1;
            current_1 = v;
            velocity = (0,velocity_per_second/* velocityPerSecond */.R)(v - prev_1, (0,es/* getFrameData */.$B)().delta);
            if ((heading_1 === 1 && v > boundary_1) ||
                (heading_1 === -1 && v < boundary_1)) {
                startSpring({ from: v, to: boundary_1, velocity: velocity });
            }
        };
        startAnimation({
            type: "decay",
            from: from,
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined,
        });
    }
    return {
        stop: function () { return currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop(); },
    };
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/time-conversion.js
var time_conversion = __webpack_require__(49580);
;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/easing/cubic-bezier.js


var a = function (a1, a2) { return 1.0 - 3.0 * a2 + 3.0 * a1; };
var b = function (a1, a2) { return 3.0 * a2 - 6.0 * a1; };
var c = function (a1) { return 3.0 * a1; };
var calcBezier = function (t, a1, a2) {
    return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
};
var getSlope = function (t, a1, a2) {
    return 3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1);
};
var subdivisionPrecision = 0.0000001;
var subdivisionMaxIterations = 10;
function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX;
    var currentT;
    var i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) {
            aB = currentT;
        }
        else {
            aA = currentT;
        }
    } while (Math.abs(currentX) > subdivisionPrecision &&
        ++i < subdivisionMaxIterations);
    return currentT;
}
var newtonIterations = 8;
var newtonMinSlope = 0.001;
function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < newtonIterations; ++i) {
        var currentSlope = getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) {
            return aGuessT;
        }
        var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
function cubicBezier(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2)
        return linear;
    var sampleValues = new Float32Array(kSplineTableSize);
    for (var i = 0; i < kSplineTableSize; ++i) {
        sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
    function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = kSplineTableSize - 1;
        for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
            intervalStart += kSampleStepSize;
        }
        --currentSample;
        var dist = (aX - sampleValues[currentSample]) /
            (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * kSampleStepSize;
        var initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= newtonMinSlope) {
            return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        }
        else if (initialSlope === 0.0) {
            return guessForT;
        }
        else {
            return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
        }
    }
    return function (t) {
        return t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
    };
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/utils/easing.js




var easingLookup = {
    linear: linear,
    easeIn: easeIn,
    easeInOut: easeInOut,
    easeOut: easeOut,
    circIn: circIn,
    circInOut: circInOut,
    circOut: circOut,
    backIn: backIn,
    backInOut: backInOut,
    backOut: backOut,
    anticipate: anticipate,
    bounceIn: bounceIn,
    bounceInOut: bounceInOut,
    bounceOut: bounceOut,
};
var easingDefinitionToFunction = function (definition) {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0,hey_listen_es/* invariant */.k)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = (0,tslib_es6.__read)(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return cubicBezier(x1, y1, x2, y2);
    }
    else if (typeof definition === "string") {
        // Else lookup from table
        (0,hey_listen_es/* invariant */.k)(easingLookup[definition] !== undefined, "Invalid easing type '" + definition + "'");
        return easingLookup[definition];
    }
    return definition;
};
var isEasingArray = function (ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/utils/is-animatable.js


/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */
var isAnimatable = function (key, value) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex")
        return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value))
        return true;
    if (typeof value === "string" && // It's animatable if we have a string
        complex/* complex.test */.P.test(value) && // And it contains numbers and/or colors
        !value.startsWith("url(") // Unless it starts with "url("
    ) {
        return true;
    }
    return false;
};



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/animation/utils/is-keyframes-target.js
var is_keyframes_target = __webpack_require__(70527);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/utils/default-transitions.js



var underDampedSpring = function () { return ({
    type: "spring",
    stiffness: 500,
    damping: 25,
    restDelta: 0.5,
    restSpeed: 10,
}); };
var criticallyDampedSpring = function (to) { return ({
    type: "spring",
    stiffness: 550,
    damping: to === 0 ? 2 * Math.sqrt(550) : 30,
    restDelta: 0.01,
    restSpeed: 10,
}); };
var linearTween = function () { return ({
    type: "keyframes",
    ease: "linear",
    duration: 0.3,
}); };
var default_transitions_keyframes = function (values) { return ({
    type: "keyframes",
    duration: 0.8,
    values: values,
}); };
var defaultTransitions = {
    x: underDampedSpring,
    y: underDampedSpring,
    z: underDampedSpring,
    rotate: underDampedSpring,
    rotateX: underDampedSpring,
    rotateY: underDampedSpring,
    rotateZ: underDampedSpring,
    scaleX: criticallyDampedSpring,
    scaleY: criticallyDampedSpring,
    scale: criticallyDampedSpring,
    opacity: linearTween,
    backgroundColor: linearTween,
    color: linearTween,
    default: criticallyDampedSpring,
};
var getDefaultTransition = function (valueKey, to) {
    var transitionFactory;
    if ((0,is_keyframes_target/* isKeyframesTarget */.C)(to)) {
        transitionFactory = default_transitions_keyframes;
    }
    else {
        transitionFactory =
            defaultTransitions[valueKey] || defaultTransitions.default;
    }
    return (0,tslib_es6.__assign)({ to: to }, transitionFactory(to));
};



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/animatable-none.js
var animatable_none = __webpack_require__(44183);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/utils/transitions.js









/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */
function isTransitionDefined(_a) {
    _a.when; _a.delay; _a.delayChildren; _a.staggerChildren; _a.staggerDirection; _a.repeat; _a.repeatType; _a.repeatDelay; _a.from; var transition = (0,tslib_es6.__rest)(_a, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
    return !!Object.keys(transition).length;
}
var legacyRepeatWarning = false;
/**
 * Convert Framer Motion's Transition type into Popmotion-compatible options.
 */
function convertTransitionToAnimationOptions(_a) {
    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = (0,tslib_es6.__rest)(_a, ["ease", "times", "yoyo", "flip", "loop"]);
    var options = (0,tslib_es6.__assign)({}, transition);
    if (times)
        options["offset"] = times;
    /**
     * Convert any existing durations from seconds to milliseconds
     */
    if (transition.duration)
        options["duration"] = (0,time_conversion/* secondsToMilliseconds */.w)(transition.duration);
    if (transition.repeatDelay)
        options.repeatDelay = (0,time_conversion/* secondsToMilliseconds */.w)(transition.repeatDelay);
    /**
     * Map easing names to Popmotion's easing functions
     */
    if (ease) {
        options["ease"] = isEasingArray(ease)
            ? ease.map(easingDefinitionToFunction)
            : easingDefinitionToFunction(ease);
    }
    /**
     * Support legacy transition API
     */
    if (transition.type === "tween")
        options.type = "keyframes";
    /**
     * TODO: These options are officially removed from the API.
     */
    if (yoyo || loop || flip) {
        (0,hey_listen_es/* warning */.K)(!legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        legacyRepeatWarning = true;
        if (yoyo) {
            options.repeatType = "reverse";
        }
        else if (loop) {
            options.repeatType = "loop";
        }
        else if (flip) {
            options.repeatType = "mirror";
        }
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    /**
     * TODO: Popmotion 9 has the ability to automatically detect whether to use
     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
     * It'd be good to introduce a similar thing here.
     */
    if (transition.type !== "spring")
        options.type = "keyframes";
    return options;
}
/**
 * Get the delay for a value by checking Transition with decreasing specificity.
 */
function getDelayFromTransition(transition, key) {
    var _a;
    var valueTransition = getValueTransition(transition, key) || {};
    return (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : 0;
}
function hydrateKeyframes(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = (0,tslib_es6.__spreadArray)([], (0,tslib_es6.__read)(options.to));
        options.to[0] = options.from;
    }
    return options;
}
function getPopmotionAnimationOptions(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) {
        (_a = transition.duration) !== null && _a !== void 0 ? _a : (transition.duration = 0.8);
    }
    hydrateKeyframes(options);
    /**
     * Get a default transition if none is determined to be defined.
     */
    if (!isTransitionDefined(transition)) {
        transition = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, transition), getDefaultTransition(key, options.to));
    }
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), convertTransitionToAnimationOptions(transition));
}
/**
 *
 */
function getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = getValueTransition(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = isAnimatable(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") {
        /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */
        origin = (0,animatable_none/* getAnimatableNone */.T)(key, target);
    }
    else if (isZero(origin) && typeof target === "string") {
        origin = getZeroUnit(target);
    }
    else if (!Array.isArray(target) &&
        isZero(target) &&
        typeof origin === "string") {
        target = getZeroUnit(origin);
    }
    var isOriginAnimatable = isAnimatable(key, origin);
    (0,hey_listen_es/* warning */.K)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate " + key + " from \"" + origin + "\" to \"" + target + "\". " + origin + " is not an animatable value - to enable this animation set " + origin + " to a value animatable to " + target + " via the `style` property.");
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function (v) { return value.set(v); },
        };
        return valueTransition.type === "inertia" ||
            valueTransition.type === "decay"
            ? inertia((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), valueTransition))
            : animate((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, getPopmotionAnimationOptions(valueTransition, options, key)), { onUpdate: function (v) {
                    var _a;
                    options.onUpdate(v);
                    (_a = valueTransition.onUpdate) === null || _a === void 0 ? void 0 : _a.call(valueTransition, v);
                }, onComplete: function () {
                    var _a;
                    options.onComplete();
                    (_a = valueTransition.onComplete) === null || _a === void 0 ? void 0 : _a.call(valueTransition);
                } }));
    }
    function set() {
        var _a;
        value.set(target);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _a === void 0 ? void 0 : _a.call(valueTransition);
        return { stop: function () { } };
    }
    return !isOriginAnimatable ||
        !isTargetAnimatable ||
        valueTransition.type === false
        ? set
        : start;
}
function isZero(value) {
    return (value === 0 ||
        (typeof value === "string" &&
            parseFloat(value) === 0 &&
            value.indexOf(" ") === -1));
}
function getZeroUnit(potentialUnitType) {
    return typeof potentialUnitType === "number"
        ? 0
        : (0,animatable_none/* getAnimatableNone */.T)("", potentialUnitType);
}
function getValueTransition(transition, key) {
    return transition[key] || transition["default"] || transition;
}
/**
 * Start animation on a MotionValue. This function is an interface between
 * Framer Motion and Popmotion
 *
 * @internal
 */
function startAnimation(key, value, target, transition) {
    if (transition === void 0) { transition = {}; }
    return value.start(function (onComplete) {
        var delayTimer;
        var controls;
        var animation = getAnimation(key, value, target, transition, onComplete);
        var delay = getDelayFromTransition(transition, key);
        var start = function () { return (controls = animation()); };
        if (delay) {
            delayTimer = setTimeout(start, (0,time_conversion/* secondsToMilliseconds */.w)(delay));
        }
        else {
            start();
        }
        return function () {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 ? void 0 : controls.stop();
        };
    });
}




/***/ }),

/***/ 62978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ AnimatePresence; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50879);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-unmount-effect.js
var use_unmount_effect = __webpack_require__(81715);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-force-update.js




function useForceUpdate() {
    var unloadingRef = (0,react.useRef)(false);
    var _a = (0,tslib_es6.__read)((0,react.useState)(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    (0,use_unmount_effect/* useUnmountEffect */.z)(function () { return (unloadingRef.current = true); });
    return (0,react.useCallback)(function () {
        !unloadingRef.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [forcedRenderCount]);
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/PresenceContext.js
var PresenceContext = __webpack_require__(79785);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.js
var use_constant = __webpack_require__(50024);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/PresenceChild.js





var presenceId = 0;
function getPresenceId() {
    var id = presenceId;
    presenceId++;
    return id;
}
var PresenceChild = function (_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = (0,use_constant/* useConstant */.h)(newChildrenMap);
    var id = (0,use_constant/* useConstant */.h)(getPresenceId);
    var context = (0,react.useMemo)(function () { return ({
        id: id,
        initial: initial,
        isPresent: isPresent,
        custom: custom,
        onExitComplete: function (childId) {
            presenceChildren.set(childId, true);
            var allComplete = true;
            presenceChildren.forEach(function (isComplete) {
                if (!isComplete)
                    allComplete = false;
            });
            allComplete && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
        },
        register: function (childId) {
            presenceChildren.set(childId, false);
            return function () { return presenceChildren.delete(childId); };
        },
    }); }, 
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    presenceAffectsLayout ? undefined : [isPresent]);
    (0,react.useMemo)(function () {
        presenceChildren.forEach(function (_, key) { return presenceChildren.set(key, false); });
    }, [isPresent]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */
    react.useEffect(function () {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
    }, [isPresent]);
    return (react.createElement(PresenceContext/* PresenceContext.Provider */.O.Provider, { value: context }, children));
};
function newChildrenMap() {
    return new Map();
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/SharedLayoutContext.js + 1 modules
var SharedLayoutContext = __webpack_require__(63138);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.js







function getChildKey(child) {
    return child.key || "";
}
function updateChildLookup(children, allChildren) {
    var seenChildren =  false ? 0 : null;
    children.forEach(function (child) {
        var key = getChildKey(child);
        if (false) {}
        allChildren.set(key, child);
    });
}
function onlyElements(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    react.Children.forEach(children, function (child) {
        if ((0,react.isValidElement)(child))
            filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * @library
 *
 * Any `Frame` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { Frame, AnimatePresence } from 'framer'
 *
 * // As items are added and removed from `items`
 * export function Items({ items }) {
 *   return (
 *     <AnimatePresence>
 *       {items.map(item => (
 *         <Frame
 *           key={item.id}
 *           initial={{ opacity: 0 }}
 *           animate={{ opacity: 1 }}
 *           exit={{ opacity: 0 }}
 *         />
 *       ))}
 *     </AnimatePresence>
 *   )
 * }
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * @motion
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */
var AnimatePresence = function (_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    var forceRender = useForceUpdate();
    var layoutContext = (0,react.useContext)(SharedLayoutContext/* SharedLayoutContext */.WH);
    if ((0,SharedLayoutContext/* isSharedLayout */.Md)(layoutContext)) {
        forceRender = layoutContext.forceUpdate;
    }
    var isInitialRender = (0,react.useRef)(true);
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    var filteredChildren = onlyElements(children);
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    var presentChildren = (0,react.useRef)(filteredChildren);
    // A lookup table to quickly reference components by key
    var allChildren = (0,react.useRef)(new Map())
        .current;
    // A living record of all currently exiting components.
    var exiting = (0,react.useRef)(new Set()).current;
    updateChildLookup(filteredChildren, allChildren);
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    if (isInitialRender.current) {
        isInitialRender.current = false;
        return (react.createElement(react.Fragment, null, filteredChildren.map(function (child) { return (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? undefined : false, presenceAffectsLayout: presenceAffectsLayout }, child)); })));
    }
    // If this is a subsequent render, deal with entering and exiting children
    var childrenToRender = (0,tslib_es6.__spreadArray)([], (0,tslib_es6.__read)(filteredChildren));
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    var presentKeys = presentChildren.current.map(getChildKey);
    var targetKeys = filteredChildren.map(getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    var numPresent = presentKeys.length;
    for (var i = 0; i < numPresent; i++) {
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) {
            exiting.add(key);
        }
        else {
            // In case this key has re-entered, remove from the exiting list
            exiting.delete(key);
        }
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (exitBeforeEnter && exiting.size) {
        childrenToRender = [];
    }
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach(function (key) {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1)
            return;
        var child = allChildren.get(key);
        if (!child)
            return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function () {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            var removeIndex = presentChildren.current.findIndex(function (presentChild) { return presentChild.key === key; });
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, react.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom: custom, presenceAffectsLayout: presenceAffectsLayout }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map(function (child) {
        var key = child.key;
        return exiting.has(key) ? (child) : (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout: presenceAffectsLayout }, child));
    });
    presentChildren.current = childrenToRender;
    if (false) {}
    return (react.createElement(react.Fragment, null, exiting.size
        ? childrenToRender
        : childrenToRender.map(function (child) { return (0,react.cloneElement)(child); })));
};




/***/ }),

/***/ 39507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ VisibilityAction; },
/* harmony export */   "z": function() { return /* binding */ Presence; }
/* harmony export */ });
/**
 * @public
 */
var Presence;
(function (Presence) {
    Presence[Presence["Entering"] = 0] = "Entering";
    Presence[Presence["Present"] = 1] = "Present";
    Presence[Presence["Exiting"] = 2] = "Exiting";
})(Presence || (Presence = {}));
/**
 * @public
 */
var VisibilityAction;
(function (VisibilityAction) {
    VisibilityAction[VisibilityAction["Hide"] = 0] = "Hide";
    VisibilityAction[VisibilityAction["Show"] = 1] = "Show";
})(VisibilityAction || (VisibilityAction = {}));




/***/ }),

/***/ 97951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ MotionConfigContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);


/**
 * @public
 */
var MotionConfigContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    transformPagePoint: function (p) { return p; },
    isStatic: false,
});




/***/ }),

/***/ 79785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ PresenceContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);


/**
 * @public
 */
var PresenceContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);




/***/ }),

/***/ 63138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bg": function() { return /* binding */ FramerTreeLayoutContext; },
  "WH": function() { return /* binding */ SharedLayoutContext; },
  "Md": function() { return /* binding */ isSharedLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50879);
// EXTERNAL MODULE: ./node_modules/framesync/dist/es/index.js + 2 modules
var es = __webpack_require__(42835);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/projection/utils.js
var utils = __webpack_require__(35446);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/batch-layout.js
var batch_layout = __webpack_require__(94874);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/compare-by-depth.js
var compare_by_depth = __webpack_require__(66691);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimateSharedLayout/types.js
var types = __webpack_require__(39507);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimateSharedLayout/utils/batcher.js







/**
 * Default handlers for batching VisualElements
 */
var defaultHandler = {
    layoutReady: function (child) { return child.notifyLayoutReady(); },
};
/**
 * Create a batcher to process VisualElements
 */
function createBatcher() {
    var queue = new Set();
    return {
        add: function (child) { return queue.add(child); },
        flush: function (_a) {
            var _b = _a === void 0 ? defaultHandler : _a, layoutReady = _b.layoutReady, parent = _b.parent;
            (0,batch_layout/* batchLayout */.U)(function (read, write) {
                var order = Array.from(queue).sort(compare_by_depth/* compareByDepth */._);
                var ancestors = parent
                    ? (0,utils/* collectProjectingAncestors */.kv)(parent)
                    : [];
                write(function () {
                    var allElements = (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([], (0,tslib_es6.__read)(ancestors)), (0,tslib_es6.__read)(order));
                    allElements.forEach(function (element) { return element.resetTransform(); });
                });
                read(function () {
                    order.forEach(utils/* updateLayoutMeasurement */.de);
                });
                write(function () {
                    ancestors.forEach(function (element) { return element.restoreTransform(); });
                    order.forEach(layoutReady);
                });
                read(function () {
                    /**
                     * After all children have started animating, ensure any Entering components are set to Present.
                     * If we add deferred animations (set up all animations and then start them in two loops) this
                     * could be moved to the start loop. But it needs to happen after all the animations configs
                     * are generated in AnimateSharedLayout as this relies on presence data
                     */
                    order.forEach(function (child) {
                        if (child.isPresent)
                            child.presence = types/* Presence.Present */.z.Present;
                    });
                });
                write(function () {
                    /**
                     * Starting these animations will have queued jobs on the frame loop. In some situations,
                     * like when removing an element, these will be processed too late after the DOM is manipulated,
                     * leaving a flash of incorrectly-projected content. By manually flushing these jobs
                     * we ensure there's no flash.
                     */
                    es/* flushSync.preRender */.iW.preRender();
                    es/* flushSync.render */.iW.render();
                });
                read(function () {
                    /**
                     * Schedule a callback at the end of the following frame to assign the latest projection
                     * box to the prevViewportBox snapshot. Once global batching is in place this could be run
                     * synchronously. But for now it ensures that if any nested `AnimateSharedLayout` top-level
                     * child attempts to calculate its previous relative position against a prevViewportBox
                     * it will be against its latest projection box instead, as the snapshot is useless beyond this
                     * render.
                     */
                    es/* default.postRender */.ZP.postRender(function () {
                        return order.forEach(assignProjectionToSnapshot);
                    });
                    queue.clear();
                });
            });
            // TODO: Need to find a layout-synchronous way of flushing this
            (0,batch_layout/* flushLayout */.R)();
        },
    };
}
function assignProjectionToSnapshot(child) {
    child.prevViewportBox = child.projection.target;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/SharedLayoutContext.js



var SharedLayoutContext = (0,react.createContext)(createBatcher());
/**
 * @internal
 */
var FramerTreeLayoutContext = (0,react.createContext)(createBatcher());
function isSharedLayout(context) {
    return !!context.forceUpdate;
}




/***/ }),

/***/ 38494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ motion; }
});

// UNUSED EXPORTS: createDomMotionComponent

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50879);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/definitions.js
var createDefinition = function (propNames) { return ({
    isEnabled: function (props) { return propNames.some(function (name) { return !!props[name]; }); },
}); };
var featureDefinitions = {
    measureLayout: createDefinition([
        "layout",
        "layoutId",
        "drag",
        "_layoutResetTransform",
    ]),
    animation: createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
    ]),
    exit: createDefinition(["exit"]),
    drag: createDefinition(["drag", "dragControls"]),
    focus: createDefinition(["whileFocus"]),
    hover: createDefinition(["whileHover", "onHoverStart", "onHoverEnd"]),
    tap: createDefinition(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
    pan: createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd",
    ]),
    layoutAnimation: createDefinition(["layout", "layoutId"]),
};
function loadFeatures(features) {
    for (var key in features) {
        var Component = features[key];
        if (Component !== null)
            featureDefinitions[key].Component = Component;
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/LazyContext.js


var LazyContext = (0,react.createContext)({ strict: false });



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/use-features.js







var featureNames = Object.keys(featureDefinitions);
var numFeatures = featureNames.length;
/**
 * Load features via renderless components based on the provided MotionProps.
 */
function useFeatures(props, visualElement, preloadedFeatures) {
    var features = [];
    var lazyContext = (0,react.useContext)(LazyContext);
    if (!visualElement)
        return null;
    /**
     * If we're in development mode, check to make sure we're not rendering a motion component
     * as a child of LazyMotion, as this will break the file-size benefits of using it.
     */
    if (false) {}
    for (var i = 0; i < numFeatures; i++) {
        var name_1 = featureNames[i];
        var _a = featureDefinitions[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
        /**
         * It might be possible in the future to use this moment to
         * dynamically request functionality. In initial tests this
         * was producing a lot of duplication amongst bundles.
         */
        if (isEnabled(props) && Component) {
            features.push(react.createElement(Component, (0,tslib_es6.__assign)({ key: name_1 }, props, { visualElement: visualElement })));
        }
    }
    return features;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/MotionConfigContext.js
var MotionConfigContext = __webpack_require__(97951);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/MotionContext/index.js


var MotionContext = (0,react.createContext)({});
function useVisualElementContext() {
    return (0,react.useContext)(MotionContext).visualElement;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/PresenceContext.js
var context_PresenceContext = __webpack_require__(79785);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.js
var use_constant = __webpack_require__(50024);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.js




/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */
function usePresence() {
    var context = (0,react.useContext)(context_PresenceContext/* PresenceContext */.O);
    if (context === null)
        return [true, null];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useOpaqueId when released in React
    var id = useUniqueId();
    (0,react.useEffect)(function () { return register(id); }, []);
    var safeToRemove = function () { return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id); };
    return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */
function useIsPresent() {
    return isPresent(useContext(PresenceContext));
}
function isPresent(context) {
    return context === null ? true : context.isPresent;
}
var counter = 0;
var incrementId = function () { return counter++; };
var useUniqueId = function () { return (0,use_constant/* useConstant */.h)(incrementId); };



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/LayoutGroupContext.js


/**
 * @internal
 */
var LayoutGroupContext = (0,react.createContext)(null);



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/is-browser.js
var isBrowser = typeof window !== "undefined";



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.js



var useIsomorphicLayoutEffect = isBrowser ? react.useLayoutEffect : react.useEffect;



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/utils/use-visual-element.js










function useLayoutId(_a) {
    var layoutId = _a.layoutId;
    var layoutGroupId = (0,react.useContext)(LayoutGroupContext);
    return layoutGroupId && layoutId !== undefined
        ? layoutGroupId + "-" + layoutId
        : layoutId;
}
function useVisualElement(Component, visualState, props, createVisualElement) {
    var config = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._);
    var lazyContext = (0,react.useContext)(LazyContext);
    var parent = useVisualElementContext();
    var presenceContext = (0,react.useContext)(context_PresenceContext/* PresenceContext */.O);
    var layoutId = useLayoutId(props);
    var visualElementRef = (0,react.useRef)(undefined);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */
    if (!createVisualElement)
        createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState: visualState,
            parent: parent,
            props: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, props), { layoutId: layoutId }),
            presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
            blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false,
        });
    }
    var visualElement = visualElementRef.current;
    useIsomorphicLayoutEffect(function () {
        if (!visualElement)
            return;
        visualElement.setProps((0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, config), props), { layoutId: layoutId }));
        visualElement.isPresent = isPresent(presenceContext);
        visualElement.isPresenceRoot =
            !parent || parent.presenceId !== (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id);
        /**
         * Fire a render to ensure the latest state is reflected on-screen.
         */
        visualElement.syncRender();
    });
    (0,react.useEffect)(function () {
        var _a;
        if (!visualElement)
            return;
        /**
         * In a future refactor we can replace the features-as-components and
         * have this loop through them all firing "effect" listeners
         */
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.animateChanges();
    });
    useIsomorphicLayoutEffect(function () { return function () { return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount(); }; }, []);
    return visualElement;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/is-ref-object.js
function isRefObject(ref) {
    return (typeof ref === "object" &&
        Object.prototype.hasOwnProperty.call(ref, "current"));
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/utils/use-motion-ref.js



/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */
function useMotionRef(visualState, visualElement, externalRef) {
    return (0,react.useCallback)(function (instance) {
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 ? void 0 : _a.call(visualState, instance));
        if (visualElement) {
            instance
                ? visualElement.mount(instance)
                : visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") {
                externalRef(instance);
            }
            else if (isRefObject(externalRef)) {
                externalRef.current = instance;
            }
        }
    }, 
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement]);
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/variants.js
var variants = __webpack_require__(43796);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/MotionContext/utils.js


function getCurrentTreeVariants(props, context) {
    if ((0,variants/* checkIfControllingVariants */.O6)(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || (0,variants/* isVariantLabel */.$L)(initial)
                ? initial
                : undefined,
            animate: (0,variants/* isVariantLabel */.$L)(animate) ? animate : undefined,
        };
    }
    return props.inherit !== false ? context : {};
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/context/MotionContext/create.js




function useCreateMotionContext(props, isStatic) {
    var _a = getCurrentTreeVariants(props, (0,react.useContext)(MotionContext)), initial = _a.initial, animate = _a.animate;
    return (0,react.useMemo)(function () { return ({ initial: initial, animate: animate }); }, 
    /**
     * Only break memoisation in static mode
     */
    isStatic
        ? [
            variantLabelsAsDependency(initial),
            variantLabelsAsDependency(animate),
        ]
        : []);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/index.js











/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 *
 * @internal
 */
function motion_createMotionComponent(_a) {
    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
    preloadedFeatures && loadFeatures(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we're rendering in a static environment, we only visually update the component
         * as a result of a React-rerender rather than interactions or animations. This
         * means we don't need to load additional memory structures like VisualElement,
         * or any gesture/animation features.
         */
        var isStatic = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._).isStatic;
        var features = null;
        /**
         * Create the tree context. This is memoized and will only trigger renders
         * when the current tree variant changes in static mode.
         */
        var context = useCreateMotionContext(props, isStatic);
        /**
         *
         */
        var visualState = useVisualState(props, isStatic);
        if (!isStatic && isBrowser) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */
            context.visualElement = useVisualElement(Component, visualState, props, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             *
             * TODO: The intention is to move these away from a React-centric to a
             * VisualElement-centric lifecycle scheme.
             */
            features = useFeatures(props, context.visualElement, preloadedFeatures);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */
        return (react.createElement(react.Fragment, null,
            react.createElement(MotionContext.Provider, { value: context }, useRender(Component, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic)),
            features));
    }
    return (0,react.forwardRef)(MotionComponent);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-proxy.js


/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */
function createMotionProxy(createConfig) {
    function custom(Component, customMotionComponentConfig) {
        if (customMotionComponentConfig === void 0) { customMotionComponentConfig = {}; }
        return motion_createMotionComponent(createConfig(Component, customMotionComponentConfig));
    }
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */
    var componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */
        get: function (_target, key) {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */
            if (!componentCache.has(key)) {
                componentCache.set(key, custom(key));
            }
            return componentCache.get(key);
        },
    });
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/lowercase-elements.js
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */
var lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view",
];



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/is-svg-component.js


function isSVGComponent(Component) {
    if (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component !== "string" ||
        /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */
        Component.includes("-")) {
        return false;
    }
    else if (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    lowercaseSVGElements.indexOf(Component) > -1 ||
        /**
         * If it contains a capital letter, it's an SVG component
         */
        /[A-Z]/.test(Component)) {
        return true;
    }
    return false;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/projection/scale-correction.js
var valueScaleCorrection = {};
/**
 * @internal
 */
function addScaleCorrection(correctors) {
    for (var key in correctors) {
        valueScaleCorrection[key] = correctors[key];
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/utils/transform.js
/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */
var transformAxes = ["", "X", "Y", "Z"];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */
var order = ["translate", "scale", "rotate", "skew"];
/**
 * Generate a list of every possible transform key.
 */
var transformProps = ["transformPerspective", "x", "y", "z"];
order.forEach(function (operationKey) {
    return transformAxes.forEach(function (axesKey) {
        return transformProps.push(operationKey + axesKey);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */
function sortTransformProps(a, b) {
    return transformProps.indexOf(a) - transformProps.indexOf(b);
}
/**
 * A quick lookup for transform props.
 */
var transformPropSet = new Set(transformProps);
function isTransformProp(key) {
    return transformPropSet.has(key);
}
/**
 * A quick lookup for transform origin props
 */
var transformOriginProps = new Set(["originX", "originY", "originZ"]);
function isTransformOriginProp(key) {
    return transformOriginProps.has(key);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/utils/is-forced-motion-value.js



function isForcedMotionValue(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (isTransformProp(key) ||
        isTransformOriginProp(key) ||
        ((layout || layoutId !== undefined) &&
            (!!valueScaleCorrection[key] || key === "opacity")));
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/utils/is-motion-value.js
var isMotionValue = function (value) {
    return value !== null && typeof value === "object" && value.getVelocity;
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/utils/build-transform.js


var translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
};
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */
function buildTransform(_a, _b, transformIsDefault, transformTemplate) {
    var transform = _a.transform, transformKeys = _a.transformKeys;
    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
    // The transform string we're going to build into.
    var transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort(sortTransformProps);
    // Track whether the defined transform has a defined z so we don't add a
    // second to enable hardware acceleration
    var transformHasZ = false;
    // Loop over each transform and build them into transformString
    var numTransformKeys = transformKeys.length;
    for (var i = 0; i < numTransformKeys; i++) {
        var key = transformKeys[i];
        transformString += (translateAlias[key] || key) + "(" + transform[key] + ") ";
        if (key === "z")
            transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) {
        transformString += "translateZ(0)";
    }
    else {
        transformString = transformString.trim();
    }
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) {
        transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    }
    else if (allowTransformNone && transformIsDefault) {
        transformString = "none";
    }
    return transformString;
}
/**
 * Build a transformOrigin style. Uses the same defaults as the browser for
 * undefined origins.
 */
function buildTransformOrigin(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return originX + " " + originY + " " + originZ;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/is-css-variable.js
/**
 * Returns true if the provided key is a CSS variable
 */
function isCSSVariable(key) {
    return key.startsWith("--");
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/get-as-type.js
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */
var getValueAsType = function (value, type) {
    return type && typeof value === "number"
        ? type.transform(value)
        : value;
};



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/number.js + 1 modules
var number = __webpack_require__(85644);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/utils/build-styles.js







function buildHTMLStyles(state, latestValues, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
    var _a;
    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
    // Empty the transformKeys array. As we're throwing out refs to its items
    // this might not be as cheap as suspected. Maybe using the array as a buffer
    // with a manual incrementation would be better.
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    var transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */
    for (var key in latestValues) {
        var value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */
        if (isCSSVariable(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        var valueType = number/* numberValueTypes */.j[key];
        var valueAsType = getValueAsType(value, valueType);
        if (isTransformProp(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone)
                continue;
            // Otherwise check to see if this is a default transform
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0))
                transformIsNone = false;
        }
        else if (isTransformOriginProp(key)) {
            transformOrigin[key] = valueAsType;
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
        }
        else {
            /**
             * If layout projection is on, and we need to perform scale correction for this
             * value type, perform it.
             */
            if ((projection === null || projection === void 0 ? void 0 : projection.isHydrated) &&
                (layoutState === null || layoutState === void 0 ? void 0 : layoutState.isHydrated) &&
                valueScaleCorrection[key]) {
                var correctedValue = valueScaleCorrection[key].process(value, layoutState, projection);
                /**
                 * Scale-correctable values can define a number of other values to break
                 * down into. For instance borderRadius needs applying to borderBottomLeftRadius etc
                 */
                var applyTo = valueScaleCorrection[key].applyTo;
                if (applyTo) {
                    var num = applyTo.length;
                    for (var i = 0; i < num; i++) {
                        style[applyTo[i]] = correctedValue;
                    }
                }
                else {
                    style[key] = correctedValue;
                }
            }
            else {
                style[key] = valueAsType;
            }
        }
    }
    if (layoutState &&
        projection &&
        buildProjectionTransform &&
        buildProjectionTransformOrigin) {
        style.transform = buildProjectionTransform(layoutState.deltaFinal, layoutState.treeScale, hasTransform ? transform : undefined);
        if (transformTemplate) {
            style.transform = transformTemplate(transform, style.transform);
        }
        style.transformOrigin = buildProjectionTransformOrigin(layoutState);
    }
    else {
        if (hasTransform) {
            style.transform = buildTransform(state, options, transformIsNone, transformTemplate);
        }
        if (hasTransformOrigin) {
            style.transformOrigin = buildTransformOrigin(transformOrigin);
        }
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/utils/create-render-state.js
var createHtmlRenderState = function () { return ({
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {},
}); };



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/use-props.js







function copyRawValuesOnly(target, source, props) {
    for (var key in source) {
        if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
            target[key] = source[key];
        }
    }
}
function useInitialMotionValues(_a, visualState, isStatic) {
    var transformTemplate = _a.transformTemplate;
    return (0,react.useMemo)(function () {
        var state = createHtmlRenderState();
        buildHTMLStyles(state, visualState, undefined, undefined, { enableHardwareAcceleration: !isStatic }, transformTemplate);
        var vars = state.vars, style = state.style;
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, vars), style);
    }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */
    copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) {
        style = props.transformValues(style);
    }
    return style;
}
function useHTMLProps(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = useStyle(props, visualState, isStatic);
    if (Boolean(props.drag)) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout =
            "none";
        // Disable scrolling on the draggable direction
        style.touchAction =
            props.drag === true
                ? "none"
                : "pan-" + (props.drag === "x" ? "y" : "x");
    }
    htmlProps.style = style;
    return htmlProps;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/utils/valid-prop.js
/**
 * A list of all valid MotionProps.
 *
 * @internalremarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */
var validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "_layoutResetTransform",
    "onLayoutAnimationComplete",
    "onViewportBoxUpdate",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover",
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */
function isValidMotionProp(key) {
    return validMotionProps.has(key);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/filter-props.js


var shouldForward = function (key) { return !isValidMotionProp(key); };
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */
try {
    var emotionIsPropValid_1 = (__webpack_require__(25406)/* ["default"] */ .Z);
    shouldForward = function (key) {
        // Handle events explicitly as Emotion validates them all as true
        if (key.startsWith("on")) {
            return !isValidMotionProp(key);
        }
        else {
            return emotionIsPropValid_1(key);
        }
    };
}
catch (_a) {
    // We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for (var key in props) {
        if (shouldForward(key) ||
            (forwardMotionProps === true && isValidMotionProp(key)) ||
            (!isDom && !isValidMotionProp(key))) {
            filteredProps[key] = props[key];
        }
    }
    return filteredProps;
}



// EXTERNAL MODULE: ./node_modules/style-value-types/dist/es/numbers/units.js
var units = __webpack_require__(31386);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/utils/transform-origin.js


function calcOrigin(origin, offset, size) {
    return typeof origin === "string"
        ? origin
        : units.px.transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */
function calcSVGTransformOrigin(dimensions, originX, originY) {
    var pxOriginX = calcOrigin(originX, dimensions.x, dimensions.width);
    var pxOriginY = calcOrigin(originY, dimensions.y, dimensions.height);
    return pxOriginX + " " + pxOriginY;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/utils/path.js


// Convert a progress 0-1 to a pixels value based on the provided length
var progressToPixels = function (progress, length) {
    return units.px.transform(progress * length);
};
var dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray",
};
var camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray",
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */
function buildSVGPath(attrs, totalLength, length, spacing, offset, useDashCase) {
    if (spacing === void 0) { spacing = 1; }
    if (offset === void 0) { offset = 0; }
    if (useDashCase === void 0) { useDashCase = true; }
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? dashKeys : camelKeys;
    // Build the dash offset
    attrs[keys.offset] = progressToPixels(-offset, totalLength);
    // Build the dash array
    var pathLength = progressToPixels(length, totalLength);
    var pathSpacing = progressToPixels(spacing, totalLength);
    attrs[keys.array] = pathLength + " " + pathSpacing;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/utils/build-attrs.js





/**
 * Build SVG visual attrbutes, like cx and style.transform
 */
function buildSVGAttrs(state, _a, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, 
    // This is object creation, which we try to avoid per-frame.
    latest = (0,tslib_es6.__rest)(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
    buildHTMLStyles(state, latest, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin);
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions, totalPathLength = state.totalPathLength;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */
    if (attrs.transform) {
        if (dimensions)
            style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions &&
        (originX !== undefined || originY !== undefined || style.transform)) {
        style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    }
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined)
        attrs.x = attrX;
    if (attrY !== undefined)
        attrs.y = attrY;
    // Build SVG path if one has been measured
    if (totalPathLength !== undefined && pathLength !== undefined) {
        buildSVGPath(attrs, totalPathLength, pathLength, pathSpacing, pathOffset, false);
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/utils/create-render-state.js



var createSvgRenderState = function () { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, createHtmlRenderState()), { attrs: {} })); };



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/use-props.js






function useSVGProps(props, visualState) {
    var visualProps = (0,react.useMemo)(function () {
        var state = createSvgRenderState();
        buildSVGAttrs(state, visualState, undefined, undefined, { enableHardwareAcceleration: false }, props.transformTemplate);
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, state.attrs), { style: (0,tslib_es6.__assign)({}, state.style) });
    }, [visualState]);
    if (props.style) {
        var rawStyles = {};
        copyRawValuesOnly(rawStyles, props.style, props);
        visualProps.style = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, rawStyles), visualProps.style);
    }
    return visualProps;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/use-render.js







function createUseRender(forwardMotionProps) {
    if (forwardMotionProps === void 0) { forwardMotionProps = false; }
    var useRender = function (Component, props, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = isSVGComponent(Component)
            ? useSVGProps
            : useHTMLProps;
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
        var elementProps = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, filteredProps), visualProps), { ref: ref });
        return (0,react.createElement)(Component, elementProps);
    };
    return useRender;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/camel-to-dash.js
var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var REPLACE_TEMPLATE = "$1-$2";
/**
 * Convert camelCase to dash-case properties.
 */
var camelToDash = function (str) {
    return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/utils/render.js
function renderHTML(element, _a) {
    var style = _a.style, vars = _a.vars;
    // Directly assign style into the Element's style prop. In tests Object.assign is the
    // fastest way to assign styles.
    Object.assign(element.style, style);
    // Loop over any CSS variables and assign those.
    for (var key in vars) {
        element.style.setProperty(key, vars[key]);
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/utils/camel-case-attrs.js
/**
 * A set of attribute names that are always read/written as camel case.
 */
var camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
]);



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/utils/render.js




function renderSVG(element, renderState) {
    renderHTML(element, renderState);
    for (var key in renderState.attrs) {
        element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/utils/scrape-motion-values.js



function scrapeMotionValuesFromProps(props) {
    var style = props.style;
    var newValues = {};
    for (var key in style) {
        if (isMotionValue(style[key]) || isForcedMotionValue(key, props)) {
            newValues[key] = style[key];
        }
    }
    return newValues;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/utils/scrape-motion-values.js



function scrape_motion_values_scrapeMotionValuesFromProps(props) {
    var newValues = scrapeMotionValuesFromProps(props);
    for (var key in props) {
        if (isMotionValue(props[key])) {
            var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
            newValues[targetKey] = props[key];
        }
    }
    return newValues;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/utils/is-animation-controls.js
function isAnimationControls(v) {
    return typeof v === "object" && typeof v.start === "function";
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/resolve-value.js
var resolve_value = __webpack_require__(25452);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/utils/resolve-motion-value.js



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 *
 * @internal
 */
function resolveMotionValue(value) {
    var unwrappedValue = isMotionValue(value) ? value.get() : value;
    return (0,resolve_value/* isCustomValue */.p)(unwrappedValue)
        ? unwrappedValue.toValue()
        : unwrappedValue;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/utils/use-visual-state.js









function makeState(_a, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
    var state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState(),
    };
    if (onMount) {
        state.mount = function (instance) { return onMount(props, instance, state); };
    }
    return state;
}
var makeUseVisualState = function (config) { return function (props, isStatic) {
    var context = (0,react.useContext)(MotionContext);
    var presenceContext = (0,react.useContext)(context_PresenceContext/* PresenceContext */.O);
    return isStatic
        ? makeState(config, props, context, presenceContext)
        : (0,use_constant/* useConstant */.h)(function () { return makeState(config, props, context, presenceContext); });
}; };
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    var motionValues = scrapeMotionValues(props);
    for (var key in motionValues) {
        values[key] = resolveMotionValue(motionValues[key]);
    }
    var initial = props.initial, animate = props.animate;
    var isControllingVariants = (0,variants/* checkIfControllingVariants */.O6)(props);
    var isVariantNode = (0,variants/* checkIfVariantNode */.e8)(props);
    if (context &&
        isVariantNode &&
        !isControllingVariants &&
        props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : (initial = context.initial);
        animate !== null && animate !== void 0 ? animate : (animate = context.animate);
    }
    var variantToSet = blockInitialAnimation || initial === false ? animate : initial;
    if (variantToSet &&
        typeof variantToSet !== "boolean" &&
        !isAnimationControls(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
        list.forEach(function (definition) {
            var resolved = (0,variants/* resolveVariantFromProps */.oQ)(props, definition);
            if (!resolved)
                return;
            var transitionEnd = resolved.transitionEnd; resolved.transition; var target = (0,tslib_es6.__rest)(resolved, ["transitionEnd", "transition"]);
            for (var key in target)
                values[key] = target[key];
            for (var key in transitionEnd)
                values[key] = transitionEnd[key];
        });
    }
    return values;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/config-motion.js






var svgMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrape_motion_values_scrapeMotionValuesFromProps,
        createRenderState: createSvgRenderState,
        onMount: function (props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions =
                    typeof instance.getBBox ===
                        "function"
                        ? instance.getBBox()
                        : instance.getBoundingClientRect();
            }
            catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                };
            }
            if (isPath(instance)) {
                renderState.totalPathLength = instance.getTotalLength();
            }
            buildSVGAttrs(renderState, latestValues, undefined, undefined, { enableHardwareAcceleration: false }, props.transformTemplate);
            // TODO: Replace with direct assignment
            renderSVG(instance, renderState);
        },
    }),
};
function isPath(element) {
    return element.tagName === "path";
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/config-motion.js




var htmlMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
        createRenderState: createHtmlRenderState,
    }),
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/create-config.js






function create_config_createDomMotionConfig(Component, _a, preloadedFeatures, createVisualElement) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = isSVGComponent(Component)
        ? svgMotionConfig
        : htmlMotionConfig;
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, baseConfig), { preloadedFeatures: preloadedFeatures, useRender: createUseRender(forwardMotionProps), createVisualElement: createVisualElement,
        Component: Component });
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/types.js
var AnimationType;
(function (AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["Exit"] = "exit";
})(AnimationType || (AnimationType = {}));



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/events/use-dom-event.js


function addDomEvent(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function () { return target.removeEventListener(eventName, handler, options); };
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */
function useDomEvent(ref, eventName, handler, options) {
    (0,react.useEffect)(function () {
        var element = ref.current;
        if (handler && element) {
            return addDomEvent(element, eventName, handler, options);
        }
    }, [ref, eventName, handler, options]);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/use-focus-gesture.js



/**
 *
 * @param props
 * @param ref
 * @internal
 */
function useFocusGesture(_a) {
    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
    var onFocus = function () {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Focus, true);
    };
    var onBlur = function () {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Focus, false);
    };
    useDomEvent(visualElement, "focus", whileFocus ? onFocus : undefined);
    useDomEvent(visualElement, "blur", whileFocus ? onBlur : undefined);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/utils/event-type.js
function isMouseEvent(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
        return !!(event.pointerType === "mouse");
    }
    return event instanceof MouseEvent;
}
function isTouchEvent(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/events/event-info.js


/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */
function filterPrimaryPointer(eventHandler) {
    return function (event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent ||
            (isMouseEvent && event.button === 0);
        if (isPrimaryPointer) {
            eventHandler(event);
        }
    };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(e, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function pointFromMouse(point, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function extractEventInfo(event, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    return {
        point: isTouchEvent(event)
            ? pointFromTouch(event, pointType)
            : pointFromMouse(event, pointType),
    };
}
function getViewportPointFromEvent(event) {
    return extractEventInfo(event, "client");
}
var wrapHandler = function (handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) { shouldFilterPrimaryPointer = false; }
    var listener = function (event) {
        return handler(event, extractEventInfo(event));
    };
    return shouldFilterPrimaryPointer
        ? filterPrimaryPointer(listener)
        : listener;
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/events/utils.js


// We check for event support via functions in case they've been mocked by a testing suite.
var supportsPointerEvents = function () {
    return isBrowser && window.onpointerdown === null;
};
var supportsTouchEvents = function () {
    return isBrowser && window.ontouchstart === null;
};
var supportsMouseEvents = function () {
    return isBrowser && window.onmousedown === null;
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/events/use-pointer-event.js




var mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave",
};
var touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel",
};
function getPointerEventName(name) {
    if (supportsPointerEvents()) {
        return name;
    }
    else if (supportsTouchEvents()) {
        return touchEventNames[name];
    }
    else if (supportsMouseEvents()) {
        return mouseEventNames[name];
    }
    return name;
}
function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
}
function usePointerEvent(ref, eventName, handler, options) {
    return useDomEvent(ref, getPointerEventName(eventName), handler && wrapHandler(handler, eventName === "pointerdown"), options);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/drag/utils/lock.js
function createLock(name) {
    var lock = null;
    return function () {
        var openLock = function () {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var globalHorizontalLock = createLock("dragHorizontal");
var globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag) {
    var lock = false;
    if (drag === "y") {
        lock = globalVerticalLock();
    }
    else if (drag === "x") {
        lock = globalHorizontalLock();
    }
    else {
        var openHorizontal_1 = globalHorizontalLock();
        var openVertical_1 = globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) {
            lock = function () {
                openHorizontal_1();
                openVertical_1();
            };
        }
        else {
            // Release the locks because we don't use them
            if (openHorizontal_1)
                openHorizontal_1();
            if (openVertical_1)
                openVertical_1();
        }
    }
    return lock;
}
function isDragActive() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    var openGestureLock = getGlobalLock(true);
    if (!openGestureLock)
        return true;
    openGestureLock();
    return false;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/use-hover-gesture.js





function createHoverEvent(visualElement, isActive, callback) {
    return function (event, info) {
        var _a;
        if (!isMouseEvent(event) || isDragActive())
            return;
        callback === null || callback === void 0 ? void 0 : callback(event, info);
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Hover, isActive);
    };
}
function useHoverGesture(_a) {
    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
    usePointerEvent(visualElement, "pointerenter", onHoverStart || whileHover
        ? createHoverEvent(visualElement, true, onHoverStart)
        : undefined);
    usePointerEvent(visualElement, "pointerleave", onHoverEnd || whileHover
        ? createHoverEvent(visualElement, false, onHoverEnd)
        : undefined);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/utils/is-node-or-child.js
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */
var isNodeOrChild = function (parent, child) {
    if (!child) {
        return false;
    }
    else if (parent === child) {
        return true;
    }
    else {
        return isNodeOrChild(parent, child.parentElement);
    }
};



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-unmount-effect.js
var use_unmount_effect = __webpack_require__(81715);
// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/pipe.js
var pipe = __webpack_require__(8813);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/use-tap-gesture.js








/**
 * @param handlers -
 * @internal
 */
function useTapGesture(_a) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isPressing = (0,react.useRef)(false);
    var cancelPointerEndListeners = (0,react.useRef)(null);
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 ? void 0 : _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Tap, false);
        return !isDragActive();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd())
            return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */
        !isNodeOrChild(visualElement.getInstance(), event.target)
            ? onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info)
            : onTap === null || onTap === void 0 ? void 0 : onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd())
            return;
        onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current)
            return;
        isPressing.current = true;
        cancelPointerEndListeners.current = (0,pipe/* pipe */.z)(addPointerEvent(window, "pointerup", onPointerUp), addPointerEvent(window, "pointercancel", onPointerCancel));
        onTapStart === null || onTapStart === void 0 ? void 0 : onTapStart(event, info);
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Tap, true);
    }
    usePointerEvent(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined);
    (0,use_unmount_effect/* useUnmountEffect */.z)(removePointerEndListener);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/utils/make-renderless-component.js
var makeRenderlessComponent = function (hook) { return function (props) {
    hook(props);
    return null;
}; };



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/gestures.js





var gestureAnimations = {
    tap: makeRenderlessComponent(useTapGesture),
    focus: makeRenderlessComponent(useFocusGesture),
    hover: makeRenderlessComponent(useHoverGesture),
};



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/animation/utils/is-keyframes-target.js
var is_keyframes_target = __webpack_require__(70527);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/shallow-compare.js
function shallowCompare(next, prev) {
    if (!Array.isArray(prev))
        return false;
    var prevLength = prev.length;
    if (prevLength !== next.length)
        return false;
    for (var i = 0; i < prevLength; i++) {
        if (prev[i] !== next[i])
            return false;
    }
    return true;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/animation.js
var utils_animation = __webpack_require__(77787);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/animation-state.js








var variantPriorityOrder = [
    AnimationType.Animate,
    AnimationType.Hover,
    AnimationType.Tap,
    AnimationType.Drag,
    AnimationType.Focus,
    AnimationType.Exit,
];
var reversePriorityOrder = (0,tslib_es6.__spreadArray)([], (0,tslib_es6.__read)(variantPriorityOrder)).reverse();
var numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
    return function (animations) {
        return Promise.all(animations.map(function (_a) {
            var animation = _a.animation, options = _a.options;
            return (0,utils_animation/* animateVisualElement */.d5)(visualElement, animation, options);
        }));
    };
}
function createAnimationState(visualElement) {
    var animate = animateList(visualElement);
    var state = createState();
    var allAnimatedKeys = {};
    var isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */
    var buildResolvedTypeValues = function (acc, definition) {
        var resolved = (0,variants/* resolveVariant */.x5)(visualElement, definition);
        if (resolved) {
            resolved.transition; var transitionEnd = resolved.transitionEnd, target = (0,tslib_es6.__rest)(resolved, ["transition", "transitionEnd"]);
            acc = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, acc), target), transitionEnd);
        }
        return acc;
    };
    function isAnimated(key) {
        return allAnimatedKeys[key] !== undefined;
    }
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */
    function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */
    function animateChanges(options, changedActiveType) {
        var _a;
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */
        var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */
        var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */
        var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */
        var removedVariantIndex = Infinity;
        var _loop_1 = function (i) {
            var type = reversePriorityOrder[i];
            var typeState = state[type];
            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            var propIsVariant = (0,variants/* isVariantLabel */.$L)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */
            var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false)
                removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */
            var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */
            if (isInherited &&
                isInitialRender &&
                visualElement.manuallyAnimateOnMount) {
                isInherited = false;
            }
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */
            typeState.protectedKeys = (0,tslib_es6.__assign)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (
            // If it isn't active and hasn't *just* been set as inactive
            (!typeState.isActive && activeDelta === null) ||
                // If we didn't and don't have any defined prop for this animation type
                (!prop && !typeState.prevProp) ||
                // Or if the prop doesn't define an animation
                isAnimationControls(prop) ||
                typeof prop === "boolean") {
                return "continue";
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */
            var shouldAnimateType = variantsHaveChanged(typeState.prevProp, prop) ||
                // If we're making this variant active, we want to always make it active
                (type === changedActiveType &&
                    typeState.isActive &&
                    !isInherited &&
                    propIsVariant) ||
                // If we removed a higher-priority variant (i is in reverse order)
                (i > removedVariantIndex && propIsVariant);
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */
            var definitionList = Array.isArray(prop) ? prop : [prop];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */
            var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false)
                resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */
            var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
            var allKeys = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, prevResolvedValues), resolvedValues);
            var markToAnimate = function (key) {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for (var key in allKeys) {
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key))
                    continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */
                if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */
                    if ((0,is_keyframes_target/* isKeyframesTarget */.C)(next) && (0,is_keyframes_target/* isKeyframesTarget */.C)(prev)) {
                        if (!shallowCompare(next, prev)) {
                            markToAnimate(key);
                        }
                        else {
                            /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */
                            typeState.protectedKeys[key] = true;
                        }
                    }
                    else if (next !== undefined) {
                        // If next is defined and doesn't equal prev, it needs animating
                        markToAnimate(key);
                    }
                    else {
                        // If it's undefined, it's been removed.
                        removedKeys.add(key);
                    }
                }
                else if (next !== undefined && removedKeys.has(key)) {
                    /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */
                    markToAnimate(key);
                }
                else {
                    /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */
                    typeState.protectedKeys[key] = true;
                }
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */
            typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */
            if (typeState.isActive) {
                encounteredKeys = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, encounteredKeys), resolvedValues);
            }
            if (isInitialRender && visualElement.blockInitialAnimation) {
                shouldAnimateType = false;
            }
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */
            if (shouldAnimateType && !isInherited) {
                animations.push.apply(animations, (0,tslib_es6.__spreadArray)([], (0,tslib_es6.__read)(definitionList.map(function (animation) { return ({
                    animation: animation,
                    options: (0,tslib_es6.__assign)({ type: type }, options),
                }); }))));
            }
        };
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */
        for (var i = 0; i < numAnimationTypes; i++) {
            _loop_1(i);
        }
        allAnimatedKeys = (0,tslib_es6.__assign)({}, encounteredKeys);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */
        if (removedKeys.size) {
            var fallbackAnimation_1 = {};
            removedKeys.forEach(function (key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) {
                    fallbackAnimation_1[key] = fallbackTarget;
                }
            });
            animations.push({ animation: fallbackAnimation_1 });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender &&
            props.initial === false &&
            !visualElement.manuallyAnimateOnMount) {
            shouldAnimate = false;
        }
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */
    function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive)
            return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function (child) { var _a; return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive); });
        state[type].isActive = isActive;
        return animateChanges(options, type);
    }
    return {
        isAnimated: isAnimated,
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function () { return state; },
    };
}
function variantsHaveChanged(prev, next) {
    if (typeof next === "string") {
        return next !== prev;
    }
    else if ((0,variants/* isVariantLabels */.A0)(next)) {
        return !shallowCompare(next, prev);
    }
    return false;
}
function createTypeState(isActive) {
    if (isActive === void 0) { isActive = false; }
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {},
    };
}
function createState() {
    var _a;
    return _a = {},
        _a[AnimationType.Animate] = createTypeState(true),
        _a[AnimationType.Hover] = createTypeState(),
        _a[AnimationType.Tap] = createTypeState(),
        _a[AnimationType.Drag] = createTypeState(),
        _a[AnimationType.Focus] = createTypeState(),
        _a[AnimationType.Exit] = createTypeState(),
        _a;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/animations.js









var animations = {
    animation: makeRenderlessComponent(function (_a) {
        var visualElement = _a.visualElement, animate = _a.animate;
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */
        visualElement.animationState || (visualElement.animationState = createAnimationState(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */
        if (isAnimationControls(animate)) {
            (0,react.useEffect)(function () { return animate.subscribe(visualElement); }, [animate]);
        }
    }),
    exit: makeRenderlessComponent(function (props) {
        var custom = props.custom, visualElement = props.visualElement;
        var _a = (0,tslib_es6.__read)(usePresence(), 2), isPresent = _a[0], onExitComplete = _a[1];
        var presenceContext = (0,react.useContext)(context_PresenceContext/* PresenceContext */.O);
        (0,react.useEffect)(function () {
            var _a, _b;
            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Exit, !isPresent, { custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom });
            !isPresent && (animation === null || animation === void 0 ? void 0 : animation.then(onExitComplete));
        }, [isPresent]);
    }),
};



// EXTERNAL MODULE: ./node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(162);
// EXTERNAL MODULE: ./node_modules/framesync/dist/es/index.js + 2 modules
var es = __webpack_require__(42835);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/time-conversion.js
var time_conversion = __webpack_require__(49580);
;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/is-point.js
var isPoint = function (point) {
    return point.hasOwnProperty('x') && point.hasOwnProperty('y');
};



;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/is-point-3d.js


var isPoint3D = function (point) {
    return isPoint(point) && point.hasOwnProperty('z');
};



// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/inc.js
var inc = __webpack_require__(71022);
;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/distance.js




var distance1D = function (a, b) { return Math.abs(a - b); };
function distance(a, b) {
    if ((0,inc/* isNum */.e)(a) && (0,inc/* isNum */.e)(b)) {
        return distance1D(a, b);
    }
    else if (isPoint(a) && isPoint(b)) {
        var xDelta = distance1D(a.x, b.x);
        var yDelta = distance1D(a.y, b.y);
        var zDelta = isPoint3D(a) && isPoint3D(b) ? distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/PanSession.js








/**
 * @internal
 */
var PanSession = /** @class */ (function () {
    function PanSession(event, handlers, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
        /**
         * @internal
         */
        this.startEvent = null;
        /**
         * @internal
         */
        this.lastMoveEvent = null;
        /**
         * @internal
         */
        this.lastMoveEventInfo = null;
        /**
         * @internal
         */
        this.handlers = {};
        this.updatePoint = function () {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo))
                return;
            var info = getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            var isDistancePastThreshold = distance(info.offset, { x: 0, y: 0 }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold)
                return;
            var point = info.point;
            var timestamp = (0,es/* getFrameData */.$B)().timestamp;
            _this.history.push((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, point), { timestamp: timestamp }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function (event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = transformPoint(info, _this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if (isMouseEvent(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            es/* default.update */.ZP.update(_this.updatePoint, true);
        };
        this.handlePointerUp = function (event, info) {
            _this.end();
            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
            var panInfo = getPanInfo(transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) {
                onEnd(event, panInfo);
            }
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (isTouchEvent(event) && event.touches.length > 1)
            return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = extractEventInfo(event);
        var initialInfo = transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0,es/* getFrameData */.$B)().timestamp;
        this.history = [(0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, point), { timestamp: timestamp })];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart &&
            onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = (0,pipe/* pipe */.z)(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function (handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function () {
        this.removeListeners && this.removeListeners();
        es/* cancelSync.update */.qY.update(this.updatePoint);
    };
    return PanSession;
}());
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a, b) {
    return { x: a.x - b.x, y: a.y - b.y };
}
function getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: getVelocity(history, 0.1),
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
    if (history.length < 2) {
        return { x: 0, y: 0 };
    }
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = lastDevicePoint(history);
    while (i >= 0) {
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp >
            (0,time_conversion/* secondsToMilliseconds */.w)(timeDelta)) {
            break;
        }
        i--;
    }
    if (!timestampedPoint) {
        return { x: 0, y: 0 };
    }
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) {
        return { x: 0, y: 0 };
    }
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time,
    };
    if (currentVelocity.x === Infinity) {
        currentVelocity.x = 0;
    }
    if (currentVelocity.y === Infinity) {
        currentVelocity.y = 0;
    }
    return currentVelocity;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/geometry/index.js + 1 modules
var geometry = __webpack_require__(97013);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/each-axis.js
// Call a handler once for each axis
function eachAxis(handler) {
    return [handler("x"), handler("y")];
}



// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/mix.js
var mix = __webpack_require__(41410);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/drag/utils/constraints.js



/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */
function applyConstraints(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) {
        // If we have a min point defined, and this is outside of that, constrain
        point = elastic ? (0,mix/* mix */.C)(min, point, elastic.min) : Math.max(point, min);
    }
    else if (max !== undefined && point > max) {
        // If we have a max point defined, and this is outside of that, constrain
        point = elastic ? (0,mix/* mix */.C)(max, point, elastic.max) : Math.min(point, max);
    }
    return point;
}
/**
 * Calculates a min projection point based on a pointer, pointer progress
 * within the drag target, and constraints.
 *
 * For instance if an element was 100px width, we were dragging from 0.25
 * along this axis, the pointer is at 200px, and there were no constraints,
 * we would calculate a min projection point of 175px.
 */
function calcConstrainedMinPoint(point, length, progress, constraints, elastic) {
    // Calculate a min point for this axis and apply it to the current pointer
    var min = point - length * progress;
    return constraints ? applyConstraints(min, constraints, elastic) : min;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */
function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined
            ? axis.max + max - (axis.max - axis.min)
            : undefined,
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */
function calcRelativeConstraints(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom),
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min <
        layoutAxis.max - layoutAxis.min) {
        _a = (0,tslib_es6.__read)([max, min], 2), min = _a[0], max = _a[1];
    }
    return {
        min: layoutAxis.min + min,
        max: layoutAxis.min + max,
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */
function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y),
    };
}
/**
 * Calculate the an axis position based on two axes and a progress value.
 */
function calcPositionFromProgress(axis, constraints, progress) {
    var axisLength = axis.max - axis.min;
    var min = (0,mix/* mix */.C)(constraints.min, constraints.max - axisLength, progress);
    return { min: min, max: min + axisLength };
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */
function rebaseAxisConstraints(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) {
        relativeConstraints.min = constraints.min - layout.min;
    }
    if (constraints.max !== undefined) {
        relativeConstraints.max = constraints.max - layout.min;
    }
    return relativeConstraints;
}
var defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */
function resolveDragElastic(dragElastic) {
    if (dragElastic === false) {
        dragElastic = 0;
    }
    else if (dragElastic === true) {
        dragElastic = defaultElastic;
    }
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom"),
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel),
    };
}
function resolvePointElastic(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number"
        ? dragElastic
        : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/projection/measure.js


/**
 * Measure and return the element bounding box.
 *
 * We convert the box into an AxisBox2D to make it easier to work with each axis
 * individually and programmatically.
 *
 * This function optionally accepts a transformPagePoint function which allows us to compensate
 * for, for instance, measuring the element within a scaled plane like a Framer devivce preview component.
 */
function getBoundingBox(element, transformPagePoint) {
    var box = element.getBoundingClientRect();
    return (0,geometry/* convertBoundingBoxToAxisBox */.RX)((0,geometry/* transformBoundingBox */.dV)(box, transformPagePoint));
}



// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/clamp.js
var clamp = __webpack_require__(76846);
// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/progress.js
var progress = __webpack_require__(17027);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/geometry/delta-calc.js


var clampProgress = function (v) { return (0,clamp/* clamp */.u)(0, 1, v); };
/**
 * Returns true if the provided value is within maxDistance of the provided target
 */
function isNear(value, target, maxDistance) {
    if (target === void 0) { target = 0; }
    if (maxDistance === void 0) { maxDistance = 0.01; }
    return distance(value, target) < maxDistance;
}
function calcLength(axis) {
    return axis.max - axis.min;
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */
function delta_calc_calcOrigin(source, target) {
    var origin = 0.5;
    var sourceLength = calcLength(source);
    var targetLength = calcLength(target);
    if (targetLength > sourceLength) {
        origin = (0,progress/* progress */.Y)(target.min, target.max - sourceLength, source.min);
    }
    else if (sourceLength > targetLength) {
        origin = (0,progress/* progress */.Y)(source.min, source.max - targetLength, target.min);
    }
    return clampProgress(origin);
}
/**
 * Update the AxisDelta with a transform that projects source into target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */
function updateAxisDelta(delta, source, target, origin) {
    if (origin === void 0) { origin = 0.5; }
    delta.origin = origin;
    delta.originPoint = (0,mix/* mix */.C)(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    if (isNear(delta.scale, 1, 0.0001))
        delta.scale = 1;
    delta.translate =
        (0,mix/* mix */.C)(target.min, target.max, delta.origin) - delta.originPoint;
    if (isNear(delta.translate))
        delta.translate = 0;
}
/**
 * Update the BoxDelta with a transform that projects the source into the target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */
function updateBoxDelta(delta, source, target, origin) {
    updateAxisDelta(delta.x, source.x, target.x, defaultOrigin(origin.originX));
    updateAxisDelta(delta.y, source.y, target.y, defaultOrigin(origin.originY));
}
/**
 * Currently this only accepts numerical origins, measured as 0-1, but could
 * accept pixel values by comparing to the target axis.
 */
function defaultOrigin(origin) {
    return typeof origin === "number" ? origin : 0.5;
}
function calcRelativeAxis(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(projection, parentProjection) {
    calcRelativeAxis(projection.target.x, projection.relativeTarget.x, parentProjection.target.x);
    calcRelativeAxis(projection.target.y, projection.relativeTarget.y, parentProjection.target.y);
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/animation/utils/transitions.js + 17 modules
var transitions = __webpack_require__(38090);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/projection/utils.js
var utils = __webpack_require__(35446);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/layout/utils.js


function tweenAxis(target, prev, next, p) {
    target.min = (0,mix/* mix */.C)(prev.min, next.min, p);
    target.max = (0,mix/* mix */.C)(prev.max, next.max, p);
}
function calcRelativeOffsetAxis(parent, child) {
    return {
        min: child.min - parent.min,
        max: child.max - parent.min,
    };
}
function calcRelativeOffset(parent, child) {
    return {
        x: calcRelativeOffsetAxis(parent.x, child.x),
        y: calcRelativeOffsetAxis(parent.y, child.y),
    };
}
function checkIfParentHasChanged(prev, next) {
    var prevId = prev.getLayoutId();
    var nextId = next.getLayoutId();
    return prevId !== nextId || (nextId === undefined && prev !== next);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/is-draggable.js
function isDraggable(visualElement) {
    var _a = visualElement.getProps(), drag = _a.drag, _dragX = _a._dragX;
    return drag && !_dragX;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/geometry/delta-apply.js




/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */
function resetAxis(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */
function resetBox(box, originBox) {
    resetAxis(box.x, originBox.x);
    resetAxis(box.y, originBox.y);
}
/**
 * Scales a point based on a factor and an originPoint
 */
function scalePoint(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */
function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) {
        point = scalePoint(point, boxScale, originPoint);
    }
    return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */
function applyAxisDelta(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) { translate = 0; }
    if (scale === void 0) { scale = 1; }
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */
function applyBoxDelta(box, _a) {
    var x = _a.x, y = _a.y;
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */
function applyAxisTransforms(final, axis, transforms, _a) {
    var _b = (0,tslib_es6.__read)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    // Copy the current axis to the final axis before mutation
    final.min = axis.min;
    final.max = axis.max;
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = (0,mix/* mix */.C)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    applyAxisDelta(final, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
var xKeys = ["x", "scaleX", "originX"];
var yKeys = ["y", "scaleY", "originY"];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */
function applyBoxTransforms(finalBox, box, transforms) {
    applyAxisTransforms(finalBox.x, box.x, transforms, xKeys);
    applyAxisTransforms(finalBox.y, box.y, transforms, yKeys);
}
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */
function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = scalePoint(point, 1 / scale, originPoint);
    if (boxScale !== undefined) {
        point = scalePoint(point, 1 / boxScale, originPoint);
    }
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */
function removeAxisDelta(axis, translate, scale, origin, boxScale) {
    if (translate === void 0) { translate = 0; }
    if (scale === void 0) { scale = 1; }
    if (origin === void 0) { origin = 0.5; }
    var originPoint = (0,mix/* mix */.C)(axis.min, axis.max, origin) - translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeAxisTransforms(axis, transforms, _a) {
    var _b = (0,tslib_es6.__read)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale);
}
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeBoxTransforms(box, transforms) {
    removeAxisTransforms(box.x, transforms, xKeys);
    removeAxisTransforms(box.y, transforms, yKeys);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */
function applyTreeDeltas(box, treeScale, treePath) {
    var treeLength = treePath.length;
    if (!treeLength)
        return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for (var i = 0; i < treeLength; i++) {
        node = treePath[i];
        delta = node.getLayoutState().delta;
        // Incoporate each ancestor's scale into a culmulative treeScale for this component
        treeScale.x *= delta.x.scale;
        treeScale.y *= delta.y.scale;
        // Apply each ancestor's calculated delta into this component's recorded layout box
        applyBoxDelta(box, delta);
        // If this is a draggable ancestor, also incorporate the node's transform to the layout box
        if (isDraggable(node)) {
            applyBoxTransforms(box, box, node.getLatestValues());
        }
    }
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/projection/convert-to-relative.js




/**
 * Returns a boolean stating whether or not we converted the projection
 * to relative projection.
 */
function convertToRelativeProjection(visualElement, isLayoutDrag) {
    if (isLayoutDrag === void 0) { isLayoutDrag = true; }
    var projectionParent = visualElement.getProjectionParent();
    if (!projectionParent)
        return false;
    var offset;
    if (isLayoutDrag) {
        offset = calcRelativeOffset(projectionParent.projection.target, visualElement.projection.target);
        removeBoxTransforms(offset, projectionParent.getLatestValues());
    }
    else {
        offset = calcRelativeOffset(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
    }
    eachAxis(function (axis) {
        return visualElement.setProjectionTargetAxis(axis, offset[axis].min, offset[axis].max, true);
    });
    return true;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/batch-layout.js
var batch_layout = __webpack_require__(94874);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/drag/VisualElementDragControls.js






















var elementDragControls = new WeakMap();
/**
 *
 */
var lastPointerEvent;
var VisualElementDragControls = /** @class */ (function () {
    function VisualElementDragControls(_a) {
        var visualElement = _a.visualElement;
        /**
         * Track whether we're currently dragging.
         *
         * @internal
         */
        this.isDragging = false;
        /**
         * The current direction of drag, or `null` if both.
         *
         * @internal
         */
        this.currentDirection = null;
        /**
         * The permitted boundaries of travel, in pixels.
         *
         * @internal
         */
        this.constraints = false;
        /**
         * The per-axis resolved elastic values.
         *
         * @internal
         */
        this.elastic = (0,geometry/* axisBox */.VZ)();
        /**
         * A reference to the host component's latest props.
         *
         * @internal
         */
        this.props = {};
        /**
         * @internal
         */
        this.hasMutatedConstraints = false;
        /**
         * Track the initial position of the cursor relative to the dragging element
         * when dragging starts as a value of 0-1 on each axis. We then use this to calculate
         * an ideal bounding box for the VisualElement renderer to project into every frame.
         *
         * @internal
         */
        this.cursorProgress = {
            x: 0.5,
            y: 0.5,
        };
        // When updating _dragX, or _dragY instead of the VisualElement,
        // persist their values between drag gestures.
        this.originPoint = {};
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        /**
         * @internal
         */
        this.panSession = null;
        this.visualElement = visualElement;
        this.visualElement.enableLayoutProjection();
        elementDragControls.set(visualElement, this);
    }
    /**
     * Instantiate a PanSession for the drag gesture
     *
     * @public
     */
    VisualElementDragControls.prototype.start = function (originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c, cursorProgress = _b.cursorProgress;
        var onSessionStart = function (event) {
            var _a;
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            _this.stopMotion();
            /**
             * Save the initial point. We'll use this to calculate the pointer's position rather
             * than the one we receive when the gesture actually starts. By then, the pointer will
             * have already moved, and the perception will be of the pointer "slipping" across the element
             */
            var initialPoint = getViewportPointFromEvent(event).point;
            (_a = _this.cancelLayout) === null || _a === void 0 ? void 0 : _a.call(_this);
            _this.cancelLayout = (0,batch_layout/* batchLayout */.U)(function (read, write) {
                var ancestors = (0,utils/* collectProjectingAncestors */.kv)(_this.visualElement);
                var children = (0,utils/* collectProjectingChildren */.e3)(_this.visualElement);
                var tree = (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([], (0,tslib_es6.__read)(ancestors)), (0,tslib_es6.__read)(children));
                var hasManuallySetCursorOrigin = false;
                /**
                 * Apply a simple lock to the projection target. This ensures no animations
                 * can run on the projection box while this lock is active.
                 */
                _this.isLayoutDrag() && _this.visualElement.lockProjectionTarget();
                write(function () {
                    tree.forEach(function (element) { return element.resetTransform(); });
                });
                read(function () {
                    (0,utils/* updateLayoutMeasurement */.de)(_this.visualElement);
                    children.forEach(utils/* updateLayoutMeasurement */.de);
                });
                write(function () {
                    tree.forEach(function (element) { return element.restoreTransform(); });
                    if (snapToCursor) {
                        hasManuallySetCursorOrigin = _this.snapToCursor(initialPoint);
                    }
                });
                read(function () {
                    var isRelativeDrag = Boolean(_this.getAxisMotionValue("x") && !_this.isExternalDrag());
                    if (!isRelativeDrag) {
                        _this.visualElement.rebaseProjectionTarget(true, _this.visualElement.measureViewportBox(false));
                    }
                    _this.visualElement.scheduleUpdateLayoutProjection();
                    /**
                     * When dragging starts, we want to find where the cursor is relative to the bounding box
                     * of the element. Every frame, we calculate a new bounding box using this relative position
                     * and let the visualElement renderer figure out how to reproject the element into this bounding
                     * box.
                     *
                     * By doing it this way, rather than applying an x/y transform directly to the element,
                     * we can ensure the component always visually sticks to the cursor as we'd expect, even
                     * if the DOM element itself changes layout as a result of React updates the user might
                     * make based on the drag position.
                     */
                    var projection = _this.visualElement.projection;
                    eachAxis(function (axis) {
                        if (!hasManuallySetCursorOrigin) {
                            var _a = projection.target[axis], min = _a.min, max = _a.max;
                            _this.cursorProgress[axis] = cursorProgress
                                ? cursorProgress[axis]
                                : (0,progress/* progress */.Y)(min, max, initialPoint[axis]);
                        }
                        /**
                         * If we have external drag MotionValues, record their origin point. On pointermove
                         * we'll apply the pan gesture offset directly to this value.
                         */
                        var axisValue = _this.getAxisMotionValue(axis);
                        if (axisValue) {
                            _this.originPoint[axis] = axisValue.get();
                        }
                    });
                });
                write(function () {
                    es/* flushSync.update */.iW.update();
                    es/* flushSync.preRender */.iW.preRender();
                    es/* flushSync.render */.iW.render();
                    es/* flushSync.postRender */.iW.postRender();
                });
                read(function () { return _this.resolveDragConstraints(); });
            });
        };
        var onStart = function (event, info) {
            var _a, _b, _c;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            var _d = _this.props, drag = _d.drag, dragPropagation = _d.dragPropagation;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock)
                    _this.openGlobalLock();
                _this.openGlobalLock = getGlobalLock(drag);
                // If we don 't have the lock, don't start dragging
                if (!_this.openGlobalLock)
                    return;
            }
            (0,batch_layout/* flushLayout */.R)();
            // Set current drag status
            _this.isDragging = true;
            _this.currentDirection = null;
            // Fire onDragStart event
            (_b = (_a = _this.props).onDragStart) === null || _b === void 0 ? void 0 : _b.call(_a, event, info);
            (_c = _this.visualElement.animationState) === null || _c === void 0 ? void 0 : _c.setActive(AnimationType.Drag, true);
        };
        var onMove = function (event, info) {
            var _a, _b, _c, _d;
            var _e = _this.props, dragPropagation = _e.dragPropagation, dragDirectionLock = _e.dragDirectionLock;
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !_this.openGlobalLock)
                return;
            var offset = info.offset;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (_this.currentDirection !== null) {
                    (_b = (_a = _this.props).onDirectionLock) === null || _b === void 0 ? void 0 : _b.call(_a, _this.currentDirection);
                }
                return;
            }
            // Update each point with the latest position
            _this.updateAxis("x", info.point, offset);
            _this.updateAxis("y", info.point, offset);
            // Fire onDrag event
            (_d = (_c = _this.props).onDrag) === null || _d === void 0 ? void 0 : _d.call(_c, event, info);
            // Update the last pointer event
            lastPointerEvent = event;
        };
        var onSessionEnd = function (event, info) {
            return _this.stop(event, info);
        };
        var transformPagePoint = this.props.transformPagePoint;
        this.panSession = new PanSession(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
        }, { transformPagePoint: transformPagePoint });
    };
    VisualElementDragControls.prototype.resolveDragConstraints = function () {
        var _this = this;
        var _a = this.props, dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
        var layout = this.visualElement.getLayoutState().layoutCorrected;
        if (dragConstraints) {
            this.constraints = isRefObject(dragConstraints)
                ? this.resolveRefConstraints(layout, dragConstraints)
                : calcRelativeConstraints(layout, dragConstraints);
        }
        else {
            this.constraints = false;
        }
        this.elastic = resolveDragElastic(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */
        if (this.constraints && !this.hasMutatedConstraints) {
            eachAxis(function (axis) {
                if (_this.getAxisMotionValue(axis)) {
                    _this.constraints[axis] = rebaseAxisConstraints(layout[axis], _this.constraints[axis]);
                }
            });
        }
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function (layoutBox, constraints) {
        var _a = this.props, onMeasureDragConstraints = _a.onMeasureDragConstraints, transformPagePoint = _a.transformPagePoint;
        var constraintsElement = constraints.current;
        (0,hey_listen_es/* invariant */.k)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        this.constraintsBox = getBoundingBox(constraintsElement, transformPagePoint);
        var measuredConstraints = calcViewportConstraints(layoutBox, this.constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */
        if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints((0,geometry/* convertAxisBoxToBoundingBox */._6)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) {
                measuredConstraints = (0,geometry/* convertBoundingBoxToAxisBox */.RX)(userConstraints);
            }
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.cancelDrag = function () {
        var _a, _b;
        this.visualElement.unlockProjectionTarget();
        (_a = this.cancelLayout) === null || _a === void 0 ? void 0 : _a.call(this);
        this.isDragging = false;
        this.panSession && this.panSession.end();
        this.panSession = null;
        if (!this.props.dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 ? void 0 : _b.setActive(AnimationType.Drag, false);
    };
    VisualElementDragControls.prototype.stop = function (event, info) {
        var _a, _b, _c;
        (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
        this.panSession = null;
        var isDragging = this.isDragging;
        this.cancelDrag();
        if (!isDragging)
            return;
        var velocity = info.velocity;
        this.animateDragEnd(velocity);
        (_c = (_b = this.props).onDragEnd) === null || _c === void 0 ? void 0 : _c.call(_b, event, info);
    };
    VisualElementDragControls.prototype.snapToCursor = function (point) {
        var _this = this;
        return eachAxis(function (axis) {
            var drag = _this.props.drag;
            // If we're not dragging this axis, do an early return.
            if (!shouldDrag(axis, drag, _this.currentDirection))
                return;
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
                var box = _this.visualElement.getLayoutState().layout;
                var length_1 = box[axis].max - box[axis].min;
                var center = box[axis].min + length_1 / 2;
                var offset = point[axis] - center;
                _this.originPoint[axis] = point[axis];
                axisValue.set(offset);
            }
            else {
                _this.cursorProgress[axis] = 0.5;
                return true;
            }
        }).includes(true);
    };
    /**
     * Update the specified axis with the latest pointer information.
     */
    VisualElementDragControls.prototype.updateAxis = function (axis, point, offset) {
        var drag = this.props.drag;
        // If we're not dragging this axis, do an early return.
        if (!shouldDrag(axis, drag, this.currentDirection))
            return;
        return this.getAxisMotionValue(axis)
            ? this.updateAxisMotionValue(axis, offset)
            : this.updateVisualElementAxis(axis, point);
    };
    VisualElementDragControls.prototype.updateAxisMotionValue = function (axis, offset) {
        var axisValue = this.getAxisMotionValue(axis);
        if (!offset || !axisValue)
            return;
        var nextValue = this.originPoint[axis] + offset[axis];
        var update = this.constraints
            ? applyConstraints(nextValue, this.constraints[axis], this.elastic[axis])
            : nextValue;
        axisValue.set(update);
    };
    VisualElementDragControls.prototype.updateVisualElementAxis = function (axis, point) {
        var _a;
        // Get the actual layout bounding box of the element
        var axisLayout = this.visualElement.getLayoutState().layout[axis];
        // Calculate its current length. In the future we might want to lerp this to animate
        // between lengths if the layout changes as we change the DOM
        var axisLength = axisLayout.max - axisLayout.min;
        // Get the initial progress that the pointer sat on this axis on gesture start.
        var axisProgress = this.cursorProgress[axis];
        // Calculate a new min point based on the latest pointer position, constraints and elastic
        var min = calcConstrainedMinPoint(point[axis], axisLength, axisProgress, (_a = this.constraints) === null || _a === void 0 ? void 0 : _a[axis], this.elastic[axis]);
        // Update the axis viewport target with this new min and the length
        this.visualElement.setProjectionTargetAxis(axis, min, min + axisLength);
    };
    VisualElementDragControls.prototype.setProps = function (_a) {
        var _b = _a.drag, drag = _b === void 0 ? false : _b, _c = _a.dragDirectionLock, dragDirectionLock = _c === void 0 ? false : _c, _d = _a.dragPropagation, dragPropagation = _d === void 0 ? false : _d, _e = _a.dragConstraints, dragConstraints = _e === void 0 ? false : _e, _f = _a.dragElastic, dragElastic = _f === void 0 ? defaultElastic : _f, _g = _a.dragMomentum, dragMomentum = _g === void 0 ? true : _g, remainingProps = (0,tslib_es6.__rest)(_a, ["drag", "dragDirectionLock", "dragPropagation", "dragConstraints", "dragElastic", "dragMomentum"]);
        this.props = (0,tslib_es6.__assign)({ drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum }, remainingProps);
    };
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - If the component will perform layout animations, we output the gesture to the component's
     *      visual bounding box
     * - Otherwise, we apply the delta to the x/y motion values.
     */
    VisualElementDragControls.prototype.getAxisMotionValue = function (axis) {
        var _a = this.props, layout = _a.layout, layoutId = _a.layoutId;
        var dragKey = "_drag" + axis.toUpperCase();
        if (this.props[dragKey]) {
            return this.props[dragKey];
        }
        else if (!layout && layoutId === undefined) {
            return this.visualElement.getValue(axis, 0);
        }
    };
    VisualElementDragControls.prototype.isLayoutDrag = function () {
        return !this.getAxisMotionValue("x");
    };
    VisualElementDragControls.prototype.isExternalDrag = function () {
        var _a = this.props, _dragX = _a._dragX, _dragY = _a._dragY;
        return _dragX || _dragY;
    };
    VisualElementDragControls.prototype.animateDragEnd = function (velocity) {
        var _this = this;
        var _a = this.props, drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition;
        /**
         * Everything beyond the drag gesture should be performed with
         * relative projection so children stay in sync with their parent element.
         */
        var isRelative = convertToRelativeProjection(this.visualElement, this.isLayoutDrag() && !this.isExternalDrag());
        /**
         * If we had previously resolved constraints relative to the viewport,
         * we need to also convert those to a relative coordinate space for the animation
         */
        var constraints = this.constraints || {};
        if (isRelative &&
            Object.keys(constraints).length &&
            this.isLayoutDrag()) {
            var projectionParent = this.visualElement.getProjectionParent();
            if (projectionParent) {
                var relativeConstraints_1 = calcRelativeOffset(projectionParent.projection.targetFinal, constraints);
                eachAxis(function (axis) {
                    var _a = relativeConstraints_1[axis], min = _a.min, max = _a.max;
                    constraints[axis] = {
                        min: isNaN(min) ? undefined : min,
                        max: isNaN(max) ? undefined : max,
                    };
                });
            }
        }
        var momentumAnimations = eachAxis(function (axis) {
            var _a;
            if (!shouldDrag(axis, drag, _this.currentDirection)) {
                return;
            }
            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */
            var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({ type: "inertia", velocity: dragMomentum ? velocity[axis] : 0, bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping, timeConstant: 750, restDelta: 1, restSpeed: 10 }, dragTransition), transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return _this.getAxisMotionValue(axis)
                ? _this.startAxisValueAnimation(axis, inertia)
                : _this.visualElement.startLayoutAnimation(axis, inertia, isRelative);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(function () {
            var _a, _b;
            (_b = (_a = _this.props).onDragTransitionEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
    };
    VisualElementDragControls.prototype.stopMotion = function () {
        var _this = this;
        eachAxis(function (axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            axisValue
                ? axisValue.stop()
                : _this.visualElement.stopLayoutAnimation();
        });
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function (axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        if (!axisValue)
            return;
        var currentValue = axisValue.get();
        axisValue.set(currentValue);
        axisValue.set(currentValue); // Set twice to hard-reset velocity
        return (0,transitions/* startAnimation */.b8)(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.scalePoint = function () {
        var _this = this;
        var _a = this.props, drag = _a.drag, dragConstraints = _a.dragConstraints;
        if (!isRefObject(dragConstraints) || !this.constraintsBox)
            return;
        // Stop any current animations as there can be some visual glitching if we resize mid animation
        this.stopMotion();
        // Record the relative progress of the targetBox relative to the constraintsBox
        var boxProgress = { x: 0, y: 0 };
        eachAxis(function (axis) {
            boxProgress[axis] = delta_calc_calcOrigin(_this.visualElement.projection.target[axis], _this.constraintsBox[axis]);
        });
        /**
         * For each axis, calculate the current progress of the layout axis within the constraints.
         * Then, using the latest layout and constraints measurements, reposition the new layout axis
         * proportionally within the constraints.
         */
        this.updateConstraints(function () {
            eachAxis(function (axis) {
                if (!shouldDrag(axis, drag, null))
                    return;
                // Calculate the position of the targetBox relative to the constraintsBox using the
                // previously calculated progress
                var _a = calcPositionFromProgress(_this.visualElement.projection.target[axis], _this.constraintsBox[axis], boxProgress[axis]), min = _a.min, max = _a.max;
                _this.visualElement.setProjectionTargetAxis(axis, min, max);
            });
        });
        /**
         * If any other draggable components are queuing the same tasks synchronously
         * this will wait until they've all been scheduled before flushing.
         */
        setTimeout(batch_layout/* flushLayout */.R, 1);
    };
    VisualElementDragControls.prototype.updateConstraints = function (onReady) {
        var _this = this;
        this.cancelLayout = (0,batch_layout/* batchLayout */.U)(function (read, write) {
            var ancestors = (0,utils/* collectProjectingAncestors */.kv)(_this.visualElement);
            write(function () {
                return ancestors.forEach(function (element) { return element.resetTransform(); });
            });
            read(function () { return (0,utils/* updateLayoutMeasurement */.de)(_this.visualElement); });
            write(function () {
                return ancestors.forEach(function (element) { return element.restoreTransform(); });
            });
            read(function () {
                _this.resolveDragConstraints();
            });
            if (onReady)
                write(onReady);
        });
    };
    VisualElementDragControls.prototype.mount = function (visualElement) {
        var _this = this;
        var element = visualElement.getInstance();
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */
        var stopPointerListener = addPointerEvent(element, "pointerdown", function (event) {
            var _a = _this.props, drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */
        var stopResizeListener = addDomEvent(window, "resize", function () {
            _this.scalePoint();
        });
        /**
         * Ensure drag constraints are resolved correctly relative to the dragging element
         * whenever its layout changes.
         */
        var stopLayoutUpdateListener = visualElement.onLayoutUpdate(function () {
            if (_this.isDragging) {
                _this.resolveDragConstraints();
            }
        });
        /**
         * If the previous component with this same layoutId was dragging at the time
         * it was unmounted, we want to continue the same gesture on this component.
         */
        var prevDragCursor = visualElement.prevDragCursor;
        if (prevDragCursor) {
            this.start(lastPointerEvent, { cursorProgress: prevDragCursor });
        }
        /**
         * Return a function that will teardown the drag gesture
         */
        return function () {
            stopPointerListener === null || stopPointerListener === void 0 ? void 0 : stopPointerListener();
            stopResizeListener === null || stopResizeListener === void 0 ? void 0 : stopResizeListener();
            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 ? void 0 : stopLayoutUpdateListener();
            _this.cancelDrag();
        };
    };
    return VisualElementDragControls;
}());
function shouldDrag(direction, drag, currentDirection) {
    return ((drag === true || drag === direction) &&
        (currentDirection === null || currentDirection === direction));
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */
function getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) { lockThreshold = 10; }
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) {
        direction = "y";
    }
    else if (Math.abs(offset.x) > lockThreshold) {
        direction = "x";
    }
    return direction;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/drag/use-drag.js






/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */
function useDrag(props) {
    var groupDragControls = props.dragControls, visualElement = props.visualElement;
    var transformPagePoint = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._).transformPagePoint;
    var dragControls = (0,use_constant/* useConstant */.h)(function () {
        return new VisualElementDragControls({
            visualElement: visualElement,
        });
    });
    dragControls.setProps((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, props), { transformPagePoint: transformPagePoint }));
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0,react.useEffect)(function () { return groupDragControls && groupDragControls.subscribe(dragControls); }, [dragControls]);
    // Mount the drag controls with the visualElement
    (0,react.useEffect)(function () { return dragControls.mount(visualElement); }, []);
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/gestures/use-pan-gesture.js






/**
 *
 * @param handlers -
 * @param ref -
 *
 * @internalremarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */
function usePanGesture(_a) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = (0,react.useRef)(null);
    var transformPagePoint = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function (event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        },
    };
    (0,react.useEffect)(function () {
        if (panSession.current !== null) {
            panSession.current.updateHandlers(handlers);
        }
    });
    function onPointerDown(event) {
        panSession.current = new PanSession(event, handlers, {
            transformPagePoint: transformPagePoint,
        });
    }
    usePointerEvent(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0,use_unmount_effect/* useUnmountEffect */.z)(function () { return panSession.current && panSession.current.end(); });
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/drag.js




var drag = {
    pan: makeRenderlessComponent(usePanGesture),
    drag: makeRenderlessComponent(useDrag),
};



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimateSharedLayout/types.js
var types = __webpack_require__(39507);
// EXTERNAL MODULE: ./node_modules/style-value-types/dist/es/complex/index.js
var complex = __webpack_require__(8384);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/css-variables-conversion.js



function css_variables_conversion_isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
    var match = cssVariableRegex.exec(current);
    if (!match)
        return [,];
    var _a = (0,tslib_es6.__read)(match, 3), token = _a[1], fallback = _a[2];
    return [token, fallback];
}
var maxDepth = 4;
function getVariableValue(current, element, depth) {
    if (depth === void 0) { depth = 1; }
    (0,hey_listen_es/* invariant */.k)(depth <= maxDepth, "Max CSS variable fallback depth detected in property \"" + current + "\". This may indicate a circular fallback dependency.");
    var _a = (0,tslib_es6.__read)(parseCSSVariable(current), 2), token = _a[0], fallback = _a[1];
    // No CSS variable detected
    if (!token)
        return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        return resolved.trim();
    }
    else if (css_variables_conversion_isCSSVariable(fallback)) {
        // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
        return getVariableValue(fallback, element, depth + 1);
    }
    else {
        return fallback;
    }
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */
function resolveCSSVariables(visualElement, _a, transitionEnd) {
    var _b;
    var target = (0,tslib_es6.__rest)(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof HTMLElement))
        return { target: target, transitionEnd: transitionEnd };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) {
        transitionEnd = (0,tslib_es6.__assign)({}, transitionEnd);
    }
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.forEachValue(function (value) {
        var current = value.get();
        if (!css_variables_conversion_isCSSVariable(current))
            return;
        var resolved = getVariableValue(current, element);
        if (resolved)
            value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for (var key in target) {
        var current = target[key];
        if (!css_variables_conversion_isCSSVariable(current))
            continue;
        var resolved = getVariableValue(current, element);
        if (!resolved)
            continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd)
            (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : (transitionEnd[key] = current);
    }
    return { target: target, transitionEnd: transitionEnd };
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/projection/default-scale-correctors.js





function pixelsToPercent(pixels, axis) {
    return (pixels / (axis.max - axis.min)) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */
function correctBorderRadius(latest, _layoutState, _a) {
    var target = _a.target;
    /**
     * If latest is a string, if it's a percentage we can return immediately as it's
     * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
     */
    if (typeof latest === "string") {
        if (units.px.test(latest)) {
            latest = parseFloat(latest);
        }
        else {
            return latest;
        }
    }
    /**
     * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
     * pixel value as a percentage of each axis
     */
    var x = pixelsToPercent(latest, target.x);
    var y = pixelsToPercent(latest, target.y);
    return x + "% " + y + "%";
}
var varToken = "_$css";
function correctBoxShadow(latest, _a) {
    var delta = _a.delta, treeScale = _a.treeScale;
    var original = latest;
    /**
     * We need to first strip and store CSS variables from the string.
     */
    var containsCSSVariables = latest.includes("var(");
    var cssVariables = [];
    if (containsCSSVariables) {
        latest = latest.replace(cssVariableRegex, function (match) {
            cssVariables.push(match);
            return varToken;
        });
    }
    var shadow = complex/* complex.parse */.P.parse(latest);
    // TODO: Doesn't support multiple shadows
    if (shadow.length > 5)
        return original;
    var template = complex/* complex.createTransformer */.P.createTransformer(latest);
    var offset = typeof shadow[0] !== "number" ? 1 : 0;
    // Calculate the overall context scale
    var xScale = delta.x.scale * treeScale.x;
    var yScale = delta.y.scale * treeScale.y;
    shadow[0 + offset] /= xScale;
    shadow[1 + offset] /= yScale;
    /**
     * Ideally we'd correct x and y scales individually, but because blur and
     * spread apply to both we have to take a scale average and apply that instead.
     * We could potentially improve the outcome of this by incorporating the ratio between
     * the two scales.
     */
    var averageScale = (0,mix/* mix */.C)(xScale, yScale, 0.5);
    // Blur
    if (typeof shadow[2 + offset] === "number")
        shadow[2 + offset] /= averageScale;
    // Spread
    if (typeof shadow[3 + offset] === "number")
        shadow[3 + offset] /= averageScale;
    var output = template(shadow);
    if (containsCSSVariables) {
        var i_1 = 0;
        output = output.replace(varToken, function () {
            var cssVariable = cssVariables[i_1];
            i_1++;
            return cssVariable;
        });
    }
    return output;
}
var borderCorrectionDefinition = {
    process: correctBorderRadius,
};
var defaultScaleCorrectors = {
    borderRadius: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, borderCorrectionDefinition), { applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
        ] }),
    borderTopLeftRadius: borderCorrectionDefinition,
    borderTopRightRadius: borderCorrectionDefinition,
    borderBottomLeftRadius: borderCorrectionDefinition,
    borderBottomRightRadius: borderCorrectionDefinition,
    boxShadow: {
        process: correctBoxShadow,
    },
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/layout/Animate.js











var progressTarget = 1000;
var Animate = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(Animate, _super);
    function Animate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * A mutable object that tracks the target viewport box
         * for the current animation frame.
         */
        _this.frameTarget = (0,geometry/* axisBox */.VZ)();
        /**
         * The current animation target, we use this to check whether to start
         * a new animation or continue the existing one.
         */
        _this.currentAnimationTarget = (0,geometry/* axisBox */.VZ)();
        /**
         * Track whether we're animating this axis.
         */
        _this.isAnimating = {
            x: false,
            y: false,
        };
        _this.stopAxisAnimation = {
            x: undefined,
            y: undefined,
        };
        _this.isAnimatingTree = false;
        _this.animate = function (target, origin, _a) {
            if (_a === void 0) { _a = {}; }
            var originBox = _a.originBox, targetBox = _a.targetBox, visibilityAction = _a.visibilityAction, shouldStackAnimate = _a.shouldStackAnimate, onComplete = _a.onComplete, prevParent = _a.prevParent, config = (0,tslib_es6.__rest)(_a, ["originBox", "targetBox", "visibilityAction", "shouldStackAnimate", "onComplete", "prevParent"]);
            var _b = _this.props, visualElement = _b.visualElement, layout = _b.layout;
            /**
             * Early return if we've been instructed not to animate this render.
             */
            if (shouldStackAnimate === false) {
                _this.isAnimatingTree = false;
                return _this.safeToRemove();
            }
            /**
             * Prioritise tree animations
             */
            if (_this.isAnimatingTree && shouldStackAnimate !== true) {
                return;
            }
            else if (shouldStackAnimate) {
                _this.isAnimatingTree = true;
            }
            /**
             * Allow the measured origin (prev bounding box) and target (actual layout) to be
             * overridden by the provided config.
             */
            origin = originBox || origin;
            target = targetBox || target;
            /**
             * If this element has a projecting parent, there's an opportunity to animate
             * it relatively to that parent rather than relatively to the viewport. This
             * allows us to add orchestrated animations.
             */
            var isRelative = false;
            var projectionParent = visualElement.getProjectionParent();
            if (projectionParent) {
                var prevParentViewportBox = projectionParent.prevViewportBox;
                var parentLayout = projectionParent.getLayoutState().layout;
                /**
                 * If we're being provided a previous parent VisualElement by AnimateSharedLayout
                 */
                if (prevParent) {
                    /**
                     * If we've been provided an explicit target box it means we're animating back
                     * to this previous parent. So we can make a relative box by comparing to the previous
                     * parent's layout
                     */
                    if (targetBox) {
                        parentLayout = prevParent.getLayoutState().layout;
                    }
                    /**
                     * Likewise if we've been provided an explicit origin box it means we're
                     * animating out from a different element. So we should figure out where that was
                     * on screen relative to the new parent element.
                     */
                    if (originBox &&
                        !checkIfParentHasChanged(prevParent, projectionParent) &&
                        prevParent.prevViewportBox) {
                        prevParentViewportBox = prevParent.prevViewportBox;
                    }
                }
                if (prevParentViewportBox &&
                    isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox)) {
                    isRelative = true;
                    origin = calcRelativeOffset(prevParentViewportBox, origin);
                    target = calcRelativeOffset(parentLayout, target);
                }
            }
            var boxHasMoved = hasMoved(origin, target);
            var animations = eachAxis(function (axis) {
                var _a, _b;
                /**
                 * If layout is set to "position", we can resize the origin box based on the target
                 * box and only animate its position.
                 */
                if (layout === "position") {
                    var targetLength = target[axis].max - target[axis].min;
                    origin[axis].max = origin[axis].min + targetLength;
                }
                if (visualElement.projection.isTargetLocked) {
                    return;
                }
                else if (visibilityAction !== undefined) {
                    visualElement.setVisibility(visibilityAction === types/* VisibilityAction.Show */.c.Show);
                }
                else if (boxHasMoved) {
                    // If the box has moved, animate between it's current visual state and its
                    // final state
                    return _this.animateAxis(axis, target[axis], origin[axis], (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, config), { isRelative: isRelative }));
                }
                else {
                    (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 ? void 0 : _b.call(_a);
                    // If the box has remained in the same place, immediately set the axis target
                    // to the final desired state
                    return visualElement.setProjectionTargetAxis(axis, target[axis].min, target[axis].max, isRelative);
                }
            });
            // Force a render to ensure there's no flash of uncorrected bounding box.
            visualElement.syncRender();
            /**
             * If this visualElement isn't present (ie it's been removed from the tree by the user but
             * kept in by the tree by AnimatePresence) then call safeToRemove when all axis animations
             * have successfully finished.
             */
            return Promise.all(animations).then(function () {
                _this.isAnimatingTree = false;
                onComplete && onComplete();
                visualElement.notifyLayoutAnimationComplete();
            });
        };
        return _this;
    }
    Animate.prototype.componentDidMount = function () {
        var _this = this;
        var visualElement = this.props.visualElement;
        visualElement.animateMotionValue = transitions/* startAnimation */.b8;
        visualElement.enableLayoutProjection();
        this.unsubLayoutReady = visualElement.onLayoutUpdate(this.animate);
        visualElement.layoutSafeToRemove = function () { return _this.safeToRemove(); };
        addScaleCorrection(defaultScaleCorrectors);
    };
    Animate.prototype.componentWillUnmount = function () {
        var _this = this;
        this.unsubLayoutReady();
        eachAxis(function (axis) { var _a, _b; return (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 ? void 0 : _b.call(_a); });
    };
    /**
     * TODO: This manually performs animations on the visualElement's layout progress
     * values. It'd be preferable to amend the startLayoutAxisAnimation
     * API to accept more custom animations like this.
     */
    Animate.prototype.animateAxis = function (axis, target, origin, _a) {
        var _this = this;
        var _b, _c;
        var _d = _a === void 0 ? {} : _a, transition = _d.transition, isRelative = _d.isRelative;
        /**
         * If we're not animating to a new target, don't run this animation
         */
        if (this.isAnimating[axis] &&
            axisIsEqual(target, this.currentAnimationTarget[axis])) {
            return;
        }
        (_c = (_b = this.stopAxisAnimation)[axis]) === null || _c === void 0 ? void 0 : _c.call(_b);
        this.isAnimating[axis] = true;
        var visualElement = this.props.visualElement;
        var frameTarget = this.frameTarget[axis];
        var layoutProgress = visualElement.getProjectionAnimationProgress()[axis];
        /**
         * Set layout progress back to 0. We set it twice to hard-reset any velocity that might
         * be re-incoporated into a subsequent spring animation.
         */
        layoutProgress.clearListeners();
        layoutProgress.set(0);
        layoutProgress.set(0);
        /**
         * Create an animation function to run once per frame. This will tween the visual bounding box from
         * origin to target using the latest progress value.
         */
        var frame = function () {
            // Convert the latest layoutProgress, which is a value from 0-1000, into a 0-1 progress
            var p = layoutProgress.get() / progressTarget;
            // Tween the axis and update the visualElement with the latest values
            tweenAxis(frameTarget, origin, target, p);
            visualElement.setProjectionTargetAxis(axis, frameTarget.min, frameTarget.max, isRelative);
        };
        // Synchronously run a frame to ensure there's no flash of the uncorrected bounding box.
        frame();
        // Create a function to stop animation on this specific axis
        var unsubscribeProgress = layoutProgress.onChange(frame);
        this.stopAxisAnimation[axis] = function () {
            _this.isAnimating[axis] = false;
            layoutProgress.stop();
            unsubscribeProgress();
        };
        this.currentAnimationTarget[axis] = target;
        var layoutTransition = transition ||
            visualElement.getDefaultTransition() ||
            defaultLayoutTransition;
        // Start the animation on this axis
        var animation = (0,transitions/* startAnimation */.b8)(axis === "x" ? "layoutX" : "layoutY", layoutProgress, progressTarget, layoutTransition && (0,transitions/* getValueTransition */.ev)(layoutTransition, "layout")).then(this.stopAxisAnimation[axis]);
        return animation;
    };
    Animate.prototype.safeToRemove = function () {
        var _a, _b;
        (_b = (_a = this.props).safeToRemove) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    Animate.prototype.render = function () {
        return null;
    };
    return Animate;
}(react.Component));
function AnimateLayoutContextProvider(props) {
    var _a = (0,tslib_es6.__read)(usePresence(), 2), safeToRemove = _a[1];
    return react.createElement(Animate, (0,tslib_es6.__assign)({}, props, { safeToRemove: safeToRemove }));
}
function hasMoved(a, b) {
    return (!isZeroBox(a) &&
        !isZeroBox(b) &&
        (!axisIsEqual(a.x, b.x) || !axisIsEqual(a.y, b.y)));
}
var zeroAxis = { min: 0, max: 0 };
function isZeroBox(a) {
    return axisIsEqual(a.x, zeroAxis) && axisIsEqual(a.y, zeroAxis);
}
function axisIsEqual(a, b) {
    return a.min === b.min && a.max === b.max;
}
var defaultLayoutTransition = {
    duration: 0.45,
    ease: [0.4, 0, 0.1, 1],
};
function isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox) {
    return prevParent || (!prevParent && !(originBox || targetBox));
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/SharedLayoutContext.js + 1 modules
var SharedLayoutContext = __webpack_require__(63138);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/layout/Measure.js





/**
 * This component is responsible for scheduling the measuring of the motion component
 */
var Measure = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(Measure, _super);
    function Measure() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * If this is a child of a SyncContext, register the VisualElement with it on mount.
     */
    Measure.prototype.componentDidMount = function () {
        var _a = this.props, syncLayout = _a.syncLayout, framerSyncLayout = _a.framerSyncLayout, visualElement = _a.visualElement;
        (0,SharedLayoutContext/* isSharedLayout */.Md)(syncLayout) && syncLayout.register(visualElement);
        (0,SharedLayoutContext/* isSharedLayout */.Md)(framerSyncLayout) &&
            framerSyncLayout.register(visualElement);
        visualElement.onUnmount(function () {
            if ((0,SharedLayoutContext/* isSharedLayout */.Md)(syncLayout)) {
                syncLayout.remove(visualElement);
            }
            if ((0,SharedLayoutContext/* isSharedLayout */.Md)(framerSyncLayout)) {
                framerSyncLayout.remove(visualElement);
            }
        });
    };
    /**
     * If this is a child of a SyncContext, notify it that it needs to re-render. It will then
     * handle the snapshotting.
     *
     * If it is stand-alone component, add it to the batcher.
     */
    Measure.prototype.getSnapshotBeforeUpdate = function () {
        var _a = this.props, syncLayout = _a.syncLayout, visualElement = _a.visualElement;
        if ((0,SharedLayoutContext/* isSharedLayout */.Md)(syncLayout)) {
            syncLayout.syncUpdate();
        }
        else {
            (0,utils/* snapshotViewportBox */.x7)(visualElement);
            syncLayout.add(visualElement);
        }
        return null;
    };
    Measure.prototype.componentDidUpdate = function () {
        var syncLayout = this.props.syncLayout;
        if (!(0,SharedLayoutContext/* isSharedLayout */.Md)(syncLayout))
            syncLayout.flush();
    };
    Measure.prototype.render = function () {
        return null;
    };
    return Measure;
}(react.Component));
function MeasureContextProvider(props) {
    var syncLayout = (0,react.useContext)(SharedLayoutContext/* SharedLayoutContext */.WH);
    var framerSyncLayout = (0,react.useContext)(SharedLayoutContext/* FramerTreeLayoutContext */.bg);
    return (react.createElement(Measure, (0,tslib_es6.__assign)({}, props, { syncLayout: syncLayout, framerSyncLayout: framerSyncLayout })));
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/motion/features/layout/index.js



var layoutAnimations = {
    measureLayout: MeasureContextProvider,
    layoutAnimation: AnimateLayoutContextProvider,
};



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/index.js
var es_value = __webpack_require__(9985);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/state.js


var createProjectionState = function () { return ({
    isEnabled: false,
    isHydrated: false,
    isTargetLocked: false,
    target: (0,geometry/* axisBox */.VZ)(),
    targetFinal: (0,geometry/* axisBox */.VZ)(),
}); };
function createLayoutState() {
    return {
        isHydrated: false,
        layout: (0,geometry/* axisBox */.VZ)(),
        layoutCorrected: (0,geometry/* axisBox */.VZ)(),
        treeScale: { x: 1, y: 1 },
        delta: (0,geometry/* delta */.pY)(),
        deltaFinal: (0,geometry/* delta */.pY)(),
        deltaTransform: "",
    };
}
var zeroLayout = createLayoutState();



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/utils/build-projection-transform.js


/**
 * Build a transform style that takes a calculated delta between the element's current
 * space on screen and projects it into the desired space.
 */
function buildLayoutProjectionTransform(_a, treeScale, latestTransform) {
    var x = _a.x, y = _a.y;
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */
    var xTranslate = x.translate / treeScale.x;
    var yTranslate = y.translate / treeScale.y;
    var transform = "translate3d(" + xTranslate + "px, " + yTranslate + "px, 0) ";
    if (latestTransform) {
        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
        if (rotate)
            transform += "rotate(" + rotate + ") ";
        if (rotateX)
            transform += "rotateX(" + rotateX + ") ";
        if (rotateY)
            transform += "rotateY(" + rotateY + ") ";
    }
    transform += "scale(" + x.scale + ", " + y.scale + ")";
    return !latestTransform && transform === identityProjection ? "" : transform;
}
/**
 * Take the calculated delta origin and apply it as a transform string.
 */
function buildLayoutProjectionTransformOrigin(_a) {
    var deltaFinal = _a.deltaFinal;
    return deltaFinal.x.origin * 100 + "% " + deltaFinal.y.origin * 100 + "% 0";
}
var identityProjection = buildLayoutProjectionTransform(zeroLayout.delta, zeroLayout.treeScale, { x: 1, y: 1 });



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/subscription-manager.js
var subscription_manager = __webpack_require__(49387);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/lifecycles.js



var names = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "SetAxisTarget",
    "Unmount",
];
function createLifecycles() {
    var managers = names.map(function () { return new subscription_manager/* SubscriptionManager */.L(); });
    var propSubscriptions = {};
    var lifecycles = {
        clearAllListeners: function () { return managers.forEach(function (manager) { return manager.clear(); }); },
        updatePropListeners: function (props) {
            return names.forEach(function (name) {
                var _a;
                (_a = propSubscriptions[name]) === null || _a === void 0 ? void 0 : _a.call(propSubscriptions);
                var on = "on" + name;
                var propListener = props[on];
                if (propListener) {
                    propSubscriptions[name] = lifecycles[on](propListener);
                }
            });
        },
    };
    managers.forEach(function (manager, i) {
        lifecycles["on" + names[i]] = function (handler) { return manager.add(handler); };
        lifecycles["notify" + names[i]] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return manager.notify.apply(manager, (0,tslib_es6.__spreadArray)([], (0,tslib_es6.__read)(args)));
        };
    });
    return lifecycles;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/motion-values.js



function updateMotionValuesFromProps(element, next, prev) {
    var _a;
    for (var key in next) {
        var nextValue = next[key];
        var prevValue = prev[key];
        if (isMotionValue(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */
            element.addValue(key, nextValue);
        }
        else if (isMotionValue(prevValue)) {
            /**
             * If we're swapping to a new motion value, create a new motion value
             * from that
             */
            element.addValue(key, (0,es_value/* motionValue */.B)(nextValue));
        }
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */
            if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            }
            else {
                element.addValue(key, (0,es_value/* motionValue */.B)((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
            }
        }
    }
    // Handle removed values
    for (var key in prev) {
        if (next[key] === undefined)
            element.removeValue(key);
    }
    return next;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/projection.js



function updateLayoutDeltas(_a, _b, treePath, transformOrigin) {
    var delta = _a.delta, layout = _a.layout, layoutCorrected = _a.layoutCorrected, treeScale = _a.treeScale;
    var target = _b.target;
    /**
     * Reset the corrected box with the latest values from box, as we're then going
     * to perform mutative operations on it.
     */
    resetBox(layoutCorrected, layout);
    /**
     * Apply all the parent deltas to this box to produce the corrected box. This
     * is the layout box, as it will appear on screen as a result of the transforms of its parents.
     */
    applyTreeDeltas(layoutCorrected, treeScale, treePath);
    /**
     * Update the delta between the corrected box and the target box before user-set transforms were applied.
     * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
     * for our layout reprojection, but still allow them to be scaled correctly by the user.
     * It might be that to simplify this we may want to accept that user-set scale is also corrected
     * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
     * to allow people to choose whether these styles are corrected based on just the
     * layout reprojection or the final bounding box.
     */
    updateBoxDelta(delta, layoutCorrected, target, transformOrigin);
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/array.js
var array = __webpack_require__(80759);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/compare-by-depth.js
var compare_by_depth = __webpack_require__(66691);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/flat-tree.js



var FlatTree = /** @class */ (function () {
    function FlatTree() {
        this.children = [];
        this.isDirty = false;
    }
    FlatTree.prototype.add = function (child) {
        (0,array/* addUniqueItem */.y)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.remove = function (child) {
        (0,array/* removeItem */.c)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.forEach = function (callback) {
        this.isDirty && this.children.sort(compare_by_depth/* compareByDepth */._);
        this.isDirty = false;
        this.children.forEach(callback);
    };
    return FlatTree;
}());



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/projection/relative-set.js



function setCurrentViewportBox(visualElement) {
    var projectionParent = visualElement.getProjectionParent();
    if (!projectionParent) {
        visualElement.rebaseProjectionTarget();
        return;
    }
    var relativeOffset = calcRelativeOffset(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
    eachAxis(function (axis) {
        visualElement.setProjectionTargetAxis(axis, relativeOffset[axis].min, relativeOffset[axis].max, true);
    });
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/index.js





















var visualElement = function (_a) {
    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, resetTransform = _a.resetTransform, restoreTransform = _a.restoreTransform, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
    return function (_a, options) {
        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState;
        if (options === void 0) { options = {}; }
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        /**
         * The instance of the render-specific node that will be hydrated by the
         * exposed React ref. So for example, this visual element can host a
         * HTMLElement, plain object, or Three.js object. The functions provided
         * in VisualElementConfig allow us to interface with this instance.
         */
        var instance;
        /**
         * Manages the subscriptions for a visual element's lifecycle, for instance
         * onRender and onViewportBoxUpdate.
         */
        var lifecycles = createLifecycles();
        /**
         *
         */
        var projection = createProjectionState();
        /**
         * A reference to the nearest projecting parent. This is either
         * undefined if we haven't looked for the nearest projecting parent,
         * false if there is no parent performing layout projection, or a reference
         * to the projecting parent.
         */
        var projectionParent;
        /**
         * This is a reference to the visual state of the "lead" visual element.
         * Usually, this will be this visual element. But if it shares a layoutId
         * with other visual elements, only one of them will be designated lead by
         * AnimateSharedLayout. All the other visual elements will take on the visual
         * appearance of the lead while they crossfade to it.
         */
        var leadProjection = projection;
        var leadLatestValues = latestValues;
        var unsubscribeFromLeadVisualElement;
        /**
         * The latest layout measurements and calculated projections. This
         * is seperate from the target projection data in visualState as
         * many visual elements might point to the same piece of visualState as
         * a target, whereas they might each have different layouts and thus
         * projection calculations needed to project into the same viewport box.
         */
        var layoutState = createLayoutState();
        /**
         *
         */
        var crossfader;
        /**
         * Keep track of whether the viewport box has been updated since the
         * last time the layout projection was re-calculated.
         */
        var hasViewportBoxUpdated = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */
        var values = new Map();
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */
        var valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */
        var prevMotionValues = {};
        /**
         * x/y motion values that track the progress of initiated layout
         * animations.
         *
         * TODO: Target for removal
         */
        var projectionTargetProgress;
        /**
         * When values are removed from all animation props we need to search
         * for a fallback value to animate to. These values are tracked in baseTarget.
         */
        var baseTarget = (0,tslib_es6.__assign)({}, latestValues);
        // Internal methods ========================
        /**
         * On mount, this will be hydrated with a callback to disconnect
         * this visual element from its parent on unmount.
         */
        var removeFromVariantTree;
        /**
         *
         */
        function render() {
            if (!instance)
                return;
            if (element.isProjectionReady()) {
                /**
                 * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
                 * This is the final box that we will then project into by calculating a transform delta and
                 * applying it to the corrected box.
                 */
                applyBoxTransforms(leadProjection.targetFinal, leadProjection.target, leadLatestValues);
                /**
                 * Update the delta between the corrected box and the final target box, after
                 * user-set transforms are applied to it. This will be used by the renderer to
                 * create a transform style that will reproject the element from its actual layout
                 * into the desired bounding box.
                 */
                updateBoxDelta(layoutState.deltaFinal, layoutState.layoutCorrected, leadProjection.targetFinal, latestValues);
            }
            triggerBuild();
            renderInstance(instance, renderState);
        }
        function triggerBuild() {
            var valuesToRender = latestValues;
            if (crossfader && crossfader.isActive()) {
                var crossfadedValues = crossfader.getCrossfadeState(element);
                if (crossfadedValues)
                    valuesToRender = crossfadedValues;
            }
            build(element, renderState, valuesToRender, leadProjection, layoutState, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        function updateLayoutProjection() {
            if (!element.isProjectionReady())
                return;
            var delta = layoutState.delta, treeScale = layoutState.treeScale;
            var prevTreeScaleX = treeScale.x;
            var prevTreeScaleY = treeScale.y;
            var prevDeltaTransform = layoutState.deltaTransform;
            updateLayoutDeltas(layoutState, leadProjection, element.path, latestValues);
            hasViewportBoxUpdated &&
                element.notifyViewportBoxUpdate(leadProjection.target, delta);
            hasViewportBoxUpdated = false;
            var deltaTransform = buildLayoutProjectionTransform(delta, treeScale);
            if (deltaTransform !== prevDeltaTransform ||
                // Also compare calculated treeScale, for values that rely on this only for scale correction
                prevTreeScaleX !== treeScale.x ||
                prevTreeScaleY !== treeScale.y) {
                element.scheduleRender();
            }
            layoutState.deltaTransform = deltaTransform;
        }
        function updateTreeLayoutProjection() {
            element.layoutTree.forEach(fireUpdateLayoutProjection);
        }
        /**
         *
         */
        function bindToMotionValue(key, value) {
            var removeOnChange = value.onChange(function (latestValue) {
                latestValues[key] = latestValue;
                props.onUpdate && es/* default.update */.ZP.update(update, false, true);
            });
            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, function () {
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */
        var initialMotionValues = scrapeMotionValuesFromProps(props);
        for (var key in initialMotionValues) {
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && isMotionValue(value)) {
                value.set(latestValues[key], false);
            }
        }
        /**
         * Determine what role this visual element should take in the variant tree.
         */
        var isControllingVariants = (0,variants/* checkIfControllingVariants */.O6)(props);
        var isVariantNode = (0,variants/* checkIfVariantNode */.e8)(props);
        var element = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({ treeType: treeType, 
            /**
             * This is a mirror of the internal instance prop, which keeps
             * VisualElement type-compatible with React's RefObject.
             */
            current: null, 
            /**
             * The depth of this visual element within the visual element tree.
             */
            depth: parent ? parent.depth + 1 : 0, parent: parent, children: new Set(), 
            /**
             * An ancestor path back to the root visual element. This is used
             * by layout projection to quickly recurse back up the tree.
             */
            path: parent ? (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([], (0,tslib_es6.__read)(parent.path)), [parent]) : [], layoutTree: parent ? parent.layoutTree : new FlatTree(), 
            /**
             *
             */
            presenceId: presenceId,
            projection: projection, 
            /**
             * If this component is part of the variant tree, it should track
             * any children that are also part of the tree. This is essentially
             * a shadow tree to simplify logic around how to stagger over children.
             */
            variantChildren: isVariantNode ? new Set() : undefined, 
            /**
             * Whether this instance is visible. This can be changed imperatively
             * by AnimateSharedLayout, is analogous to CSS's visibility in that
             * hidden elements should take up layout, and needs enacting by the configured
             * render function.
             */
            isVisible: undefined, 
            /**
             * Normally, if a component is controlled by a parent's variants, it can
             * rely on that ancestor to trigger animations further down the tree.
             * However, if a component is created after its parent is mounted, the parent
             * won't trigger that mount animation so the child needs to.
             *
             * TODO: This might be better replaced with a method isParentMounted
             */
            manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()), 
            /**
             * This can be set by AnimatePresence to force components that mount
             * at the same time as it to mount as if they have initial={false} set.
             */
            blockInitialAnimation: blockInitialAnimation, 
            /**
             * Determine whether this component has mounted yet. This is mostly used
             * by variant children to determine whether they need to trigger their
             * own animations on mount.
             */
            isMounted: function () { return Boolean(instance); }, mount: function (newInstance) {
                instance = element.current = newInstance;
                element.pointTo(element);
                if (isVariantNode && parent && !isControllingVariants) {
                    removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                }
                parent === null || parent === void 0 ? void 0 : parent.children.add(element);
            },
            /**
             *
             */
            unmount: function () {
                es/* cancelSync.update */.qY.update(update);
                es/* cancelSync.render */.qY.render(render);
                es/* cancelSync.preRender */.qY.preRender(element.updateLayoutProjection);
                valueSubscriptions.forEach(function (remove) { return remove(); });
                element.stopLayoutAnimation();
                element.layoutTree.remove(element);
                removeFromVariantTree === null || removeFromVariantTree === void 0 ? void 0 : removeFromVariantTree();
                parent === null || parent === void 0 ? void 0 : parent.children.delete(element);
                unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 ? void 0 : unsubscribeFromLeadVisualElement();
                lifecycles.clearAllListeners();
            },
            /**
             * Add a child visual element to our set of children.
             */
            addVariantChild: function (child) {
                var _a;
                var closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 ? void 0 : _a.add(child);
                    return function () { return closestVariantNode.variantChildren.delete(child); };
                }
            },
            sortNodePosition: function (other) {
                /**
                 * If these nodes aren't even of the same type we can't compare their depth.
                 */
                if (!sortNodePosition || treeType !== other.treeType)
                    return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            }, 
            /**
             * Returns the closest variant node in the tree starting from
             * this visual element.
             */
            getClosestVariantNode: function () {
                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
            }, 
            /**
             * A method that schedules an update to layout projections throughout
             * the tree. We inherit from the parent so there's only ever one
             * job scheduled on the next frame - that of the root visual element.
             */
            scheduleUpdateLayoutProjection: parent
                ? parent.scheduleUpdateLayoutProjection
                : function () {
                    return es/* default.preRender */.ZP.preRender(element.updateTreeLayoutProjection, false, true);
                }, 
            /**
             * Expose the latest layoutId prop.
             */
            getLayoutId: function () { return props.layoutId; }, 
            /**
             * Returns the current instance.
             */
            getInstance: function () { return instance; }, 
            /**
             * Get/set the latest static values.
             */
            getStaticValue: function (key) { return latestValues[key]; }, setStaticValue: function (key, value) { return (latestValues[key] = value); }, 
            /**
             * Returns the latest motion value state. Currently only used to take
             * a snapshot of the visual element - perhaps this can return the whole
             * visual state
             */
            getLatestValues: function () { return latestValues; }, 
            /**
             * Set the visiblity of the visual element. If it's changed, schedule
             * a render to reflect these changes.
             */
            setVisibility: function (visibility) {
                if (element.isVisible === visibility)
                    return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            /**
             * Make a target animatable by Popmotion. For instance, if we're
             * trying to animate width from 100px to 100vw we need to measure 100vw
             * in pixels to determine what we really need to animate to. This is also
             * pluggable to support Framer's custom value types like Color,
             * and CSS variables.
             */
            makeTargetAnimatable: function (target, canMutate) {
                if (canMutate === void 0) { canMutate = true; }
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            // Motion values ========================
            /**
             * Add a motion value and bind it to this visual element.
             */
            addValue: function (key, value) {
                // Remove existing value if it exists
                if (element.hasValue(key))
                    element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            /**
             * Remove a motion value and unbind any active subscriptions.
             */
            removeValue: function (key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 ? void 0 : _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            }, 
            /**
             * Check whether we have a motion value for this key
             */
            hasValue: function (key) { return values.has(key); }, 
            /**
             * Get a motion value for this key. If called with a default
             * value, we'll create one if none exists.
             */
            getValue: function (key, defaultValue) {
                var value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0,es_value/* motionValue */.B)(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            }, 
            /**
             * Iterate over our motion values.
             */
            forEachValue: function (callback) { return values.forEach(callback); }, 
            /**
             * If we're trying to animate to a previously unencountered value,
             * we need to check for it in our state and as a last resort read it
             * directly from the instance (which might have performance implications).
             */
            readValue: function (key) { var _a; return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options); }, 
            /**
             * Set the base target to later animate back to. This is currently
             * only hydrated on creation and when we first read a value.
             */
            setBaseTarget: function (key, value) {
                baseTarget[key] = value;
            },
            /**
             * Find the base target for a value thats been removed from all animation
             * props.
             */
            getBaseTarget: function (key) {
                if (getBaseTarget) {
                    var target = getBaseTarget(props, key);
                    if (target !== undefined && !isMotionValue(target))
                        return target;
                }
                return baseTarget[key];
            } }, lifecycles), { 
            /**
             * Build the renderer state based on the latest visual state.
             */
            build: function () {
                triggerBuild();
                return renderState;
            },
            /**
             * Schedule a render on the next animation frame.
             */
            scheduleRender: function () {
                es/* default.render */.ZP.render(render, false, true);
            }, 
            /**
             * Synchronously fire render. It's prefered that we batch renders but
             * in many circumstances, like layout measurement, we need to run this
             * synchronously. However in those instances other measures should be taken
             * to batch reads/writes.
             */
            syncRender: render, 
            /**
             * Update the provided props. Ensure any newly-added motion values are
             * added to our map, old ones removed, and listeners updated.
             */
            setProps: function (newProps) {
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = updateMotionValuesFromProps(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            }, getProps: function () { return props; }, 
            // Variants ==============================
            /**
             * Returns the variant definition with a given name.
             */
            getVariant: function (name) { var _a; return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name]; }, 
            /**
             * Returns the defined default transition on this component.
             */
            getDefaultTransition: function () { return props.transition; }, 
            /**
             * Used by child variant nodes to get the closest ancestor variant props.
             */
            getVariantContext: function (startAtParent) {
                if (startAtParent === void 0) { startAtParent = false; }
                if (startAtParent)
                    return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) {
                        context_1.initial = props.initial;
                    }
                    return context_1;
                }
                var context = {};
                for (var i = 0; i < numVariantProps; i++) {
                    var name_1 = variantProps[i];
                    var prop = props[name_1];
                    if ((0,variants/* isVariantLabel */.$L)(prop) || prop === false) {
                        context[name_1] = prop;
                    }
                }
                return context;
            },
            // Layout projection ==============================
            /**
             * Enable layout projection for this visual element. Won't actually
             * occur until we also have hydrated layout measurements.
             */
            enableLayoutProjection: function () {
                projection.isEnabled = true;
                element.layoutTree.add(element);
            },
            /**
             * Lock the projection target, for instance when dragging, so
             * nothing else can try and animate it.
             */
            lockProjectionTarget: function () {
                projection.isTargetLocked = true;
            },
            unlockProjectionTarget: function () {
                element.stopLayoutAnimation();
                projection.isTargetLocked = false;
            }, getLayoutState: function () { return layoutState; }, setCrossfader: function (newCrossfader) {
                crossfader = newCrossfader;
            }, isProjectionReady: function () {
                return projection.isEnabled &&
                    projection.isHydrated &&
                    layoutState.isHydrated;
            }, 
            /**
             * Start a layout animation on a given axis.
             */
            startLayoutAnimation: function (axis, transition, isRelative) {
                if (isRelative === void 0) { isRelative = false; }
                var progress = element.getProjectionAnimationProgress()[axis];
                var _a = isRelative
                    ? projection.relativeTarget[axis]
                    : projection.target[axis], min = _a.min, max = _a.max;
                var length = max - min;
                progress.clearListeners();
                progress.set(min);
                progress.set(min); // Set twice to hard-reset velocity
                progress.onChange(function (v) {
                    element.setProjectionTargetAxis(axis, v, v + length, isRelative);
                });
                return element.animateMotionValue(axis, progress, 0, transition);
            },
            /**
             * Stop layout animations.
             */
            stopLayoutAnimation: function () {
                eachAxis(function (axis) {
                    return element.getProjectionAnimationProgress()[axis].stop();
                });
            },
            /**
             * Measure the current viewport box with or without transforms.
             * Only measures axis-aligned boxes, rotate and skew must be manually
             * removed with a re-render to work.
             */
            measureViewportBox: function (withTransform) {
                if (withTransform === void 0) { withTransform = true; }
                var viewportBox = measureViewportBox(instance, options);
                if (!withTransform)
                    removeBoxTransforms(viewportBox, latestValues);
                return viewportBox;
            },
            /**
             * Get the motion values tracking the layout animations on each
             * axis. Lazy init if not already created.
             */
            getProjectionAnimationProgress: function () {
                projectionTargetProgress || (projectionTargetProgress = {
                    x: (0,es_value/* motionValue */.B)(0),
                    y: (0,es_value/* motionValue */.B)(0),
                });
                return projectionTargetProgress;
            },
            /**
             * Update the projection of a single axis. Schedule an update to
             * the tree layout projection.
             */
            setProjectionTargetAxis: function (axis, min, max, isRelative) {
                if (isRelative === void 0) { isRelative = false; }
                var target;
                if (isRelative) {
                    if (!projection.relativeTarget) {
                        projection.relativeTarget = (0,geometry/* axisBox */.VZ)();
                    }
                    target = projection.relativeTarget[axis];
                }
                else {
                    projection.relativeTarget = undefined;
                    target = projection.target[axis];
                }
                projection.isHydrated = true;
                target.min = min;
                target.max = max;
                // Flag that we want to fire the onViewportBoxUpdate event handler
                hasViewportBoxUpdated = true;
                lifecycles.notifySetAxisTarget();
            },
            /**
             * Rebase the projection target on top of the provided viewport box
             * or the measured layout. This ensures that non-animating elements
             * don't fall out of sync differences in measurements vs projections
             * after a page scroll or other relayout.
             */
            rebaseProjectionTarget: function (force, box) {
                if (box === void 0) { box = layoutState.layout; }
                var _a = element.getProjectionAnimationProgress(), x = _a.x, y = _a.y;
                var shouldRebase = !projection.relativeTarget &&
                    !projection.isTargetLocked &&
                    !x.isAnimating() &&
                    !y.isAnimating();
                if (force || shouldRebase) {
                    eachAxis(function (axis) {
                        var _a = box[axis], min = _a.min, max = _a.max;
                        element.setProjectionTargetAxis(axis, min, max);
                    });
                }
            },
            /**
             * Notify the visual element that its layout is up-to-date.
             * Currently Animate.tsx uses this to check whether a layout animation
             * needs to be performed.
             */
            notifyLayoutReady: function (config) {
                setCurrentViewportBox(element);
                element.notifyLayoutUpdate(layoutState.layout, element.prevViewportBox || layoutState.layout, config);
            }, 
            /**
             * Temporarily reset the transform of the instance.
             */
            resetTransform: function () { return resetTransform(element, instance, props); }, restoreTransform: function () { return restoreTransform(instance, renderState); }, updateLayoutProjection: updateLayoutProjection,
            updateTreeLayoutProjection: function () {
                element.layoutTree.forEach(fireResolveRelativeTargetBox);
                /**
                 * Schedule the projection updates at the end of the current preRender
                 * step. This will ensure that all layout trees will first resolve
                 * relative projection boxes into viewport boxes, and *then*
                 * update projections.
                 */
                es/* default.preRender */.ZP.preRender(updateTreeLayoutProjection, false, true);
                // sync.postRender(() => element.scheduleUpdateLayoutProjection())
            },
            getProjectionParent: function () {
                if (projectionParent === undefined) {
                    var foundParent = false;
                    // Search backwards through the tree path
                    for (var i = element.path.length - 1; i >= 0; i--) {
                        var ancestor = element.path[i];
                        if (ancestor.projection.isEnabled) {
                            foundParent = ancestor;
                            break;
                        }
                    }
                    projectionParent = foundParent;
                }
                return projectionParent;
            },
            resolveRelativeTargetBox: function () {
                var relativeParent = element.getProjectionParent();
                if (!projection.relativeTarget || !relativeParent)
                    return;
                calcRelativeBox(projection, relativeParent.projection);
                if (isDraggable(relativeParent)) {
                    var target = projection.target;
                    applyBoxTransforms(target, target, relativeParent.getLatestValues());
                }
            },
            shouldResetTransform: function () {
                return Boolean(props._layoutResetTransform);
            },
            /**
             *
             */
            pointTo: function (newLead) {
                leadProjection = newLead.projection;
                leadLatestValues = newLead.getLatestValues();
                /**
                 * Subscribe to lead component's layout animations
                 */
                unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 ? void 0 : unsubscribeFromLeadVisualElement();
                unsubscribeFromLeadVisualElement = (0,pipe/* pipe */.z)(newLead.onSetAxisTarget(element.scheduleUpdateLayoutProjection), newLead.onLayoutAnimationComplete(function () {
                    var _a;
                    if (element.isPresent) {
                        element.presence = types/* Presence.Present */.z.Present;
                    }
                    else {
                        (_a = element.layoutSafeToRemove) === null || _a === void 0 ? void 0 : _a.call(element);
                    }
                }));
            }, 
            // TODO: Clean this up
            isPresent: true, presence: types/* Presence.Entering */.z.Entering });
        return element;
    };
};
function fireResolveRelativeTargetBox(child) {
    child.resolveRelativeTargetBox();
}
function fireUpdateLayoutProjection(child) {
    child.updateLayoutProjection();
}
var variantProps = (0,tslib_es6.__spreadArray)(["initial"], (0,tslib_es6.__read)(variantPriorityOrder));
var numVariantProps = variantProps.length;



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/setters.js + 2 modules
var setters = __webpack_require__(33565);
// EXTERNAL MODULE: ./node_modules/style-value-types/dist/es/numbers/index.js
var numbers = __webpack_require__(42429);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/dimensions.js + 1 modules
var dimensions = __webpack_require__(36883);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/unit-conversion.js







var positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
]);
var isPositionalKey = function (key) { return positionalKeys.has(key); };
var hasPositionalKey = function (target) {
    return Object.keys(target).some(isPositionalKey);
};
var setAndResetVelocity = function (value, to) {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
var isNumOrPxType = function (v) {
    return v === numbers/* number */.Rx || v === units.px;
};
var BoundingBoxDimension;
(function (BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
var getPosFromMatrix = function (matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var getTranslateFromMatrix = function (pos2, pos3) { return function (_bbox, _a) {
    var transform = _a.transform;
    if (transform === "none" || !transform)
        return 0;
    var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
        return getPosFromMatrix(matrix3d[1], pos3);
    }
    else {
        var matrix = transform.match(/^matrix\((.+)\)$/);
        if (matrix) {
            return getPosFromMatrix(matrix[1], pos2);
        }
        else {
            return 0;
        }
    }
}; };
var transformKeys = new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformProps.filter(function (key) { return !transformKeys.has(key); });
function removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    nonTranslationalTransformKeys.forEach(function (key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([key, value.get()]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length)
        visualElement.syncRender();
    return removedTransforms;
}
var positionalValues = {
    // Dimensions
    width: function (_a) {
        var x = _a.x;
        return x.max - x.min;
    },
    height: function (_a) {
        var y = _a.y;
        return y.max - y.min;
    },
    top: function (_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function (_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function (_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function (_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: getTranslateFromMatrix(4, 13),
    y: getTranslateFromMatrix(5, 14),
};
var convertChangedValueTypes = function (target, visualElement, changedKeys) {
    var originBbox = visualElement.measureViewportBox();
    var element = visualElement.getInstance();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display, top = elementComputedStyle.top, left = elementComputedStyle.left, bottom = elementComputedStyle.bottom, right = elementComputedStyle.right, transform = elementComputedStyle.transform;
    var originComputedStyle = { top: top, left: left, bottom: bottom, right: right, transform: transform };
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") {
        visualElement.setStaticValue("display", target.display || "block");
    }
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.syncRender();
    var targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach(function (key) {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        var value = visualElement.getValue(key);
        setAndResetVelocity(value, positionalValues[key](originBbox, originComputedStyle));
        target[key] = positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var checkAndConvertChangedValueTypes = function (visualElement, target, origin, transitionEnd) {
    if (origin === void 0) { origin = {}; }
    if (transitionEnd === void 0) { transitionEnd = {}; }
    target = (0,tslib_es6.__assign)({}, target);
    transitionEnd = (0,tslib_es6.__assign)({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function (key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key))
            return;
        var from = origin[key];
        var to = target[key];
        var fromType = (0,dimensions/* findDimensionValueType */.C)(from);
        var toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0,is_keyframes_target/* isKeyframesTarget */.C)(to)) {
            var numKeyframes = to.length;
            for (var i = to[0] === null ? 1 : 0; i < numKeyframes; i++) {
                if (!toType) {
                    toType = (0,dimensions/* findDimensionValueType */.C)(to[i]);
                    (0,hey_listen_es/* invariant */.k)(toType === fromType ||
                        (isNumOrPxType(fromType) && isNumOrPxType(toType)), "Keyframes must be of the same dimension as the current value");
                }
                else {
                    (0,hey_listen_es/* invariant */.k)((0,dimensions/* findDimensionValueType */.C)(to[i]) === toType, "All keyframes must be of the same type");
                }
            }
        }
        else {
            toType = (0,dimensions/* findDimensionValueType */.C)(to);
        }
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") {
                    value.set(parseFloat(current));
                }
                if (typeof to === "string") {
                    target[key] = parseFloat(to);
                }
                else if (Array.isArray(to) && toType === units.px) {
                    target[key] = to.map(parseFloat);
                }
            }
            else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) &&
                (toType === null || toType === void 0 ? void 0 : toType.transform) &&
                (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) {
                    value.set(toType.transform(from));
                }
                else {
                    target[key] = fromType.transform(to);
                }
            }
            else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] =
                    transitionEnd[key] !== undefined
                        ? transitionEnd[key]
                        : target[key];
                setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) {
            removedTransformValues.forEach(function (_a) {
                var _b = (0,tslib_es6.__read)(_a, 2), key = _b[0], value = _b[1];
                visualElement.getValue(key).set(value);
            });
        }
        // Reapply original values
        visualElement.syncRender();
        return { target: convertedTarget, transitionEnd: transitionEnd };
    }
    else {
        return { target: target, transitionEnd: transitionEnd };
    }
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */
function unitConversion(visualElement, target, origin, transitionEnd) {
    return hasPositionalKey(target)
        ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd)
        : { target: target, transitionEnd: transitionEnd };
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/parse-dom-variant.js



/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */
var parseDomVariant = function (visualElement, target, origin, transitionEnd) {
    var resolved = resolveCSSVariables(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return unitConversion(visualElement, target, origin, transitionEnd);
};



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/defaults.js
var defaults = __webpack_require__(45176);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/html/visual-element.js













function visual_element_getComputedStyle(element) {
    return window.getComputedStyle(element);
}
var htmlConfig = {
    treeType: "dom",
    readValueFromInstance: function (domElement, key) {
        if (isTransformProp(key)) {
            var defaultType = (0,defaults/* getDefaultValueType */.A)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        else {
            var computedStyle = visual_element_getComputedStyle(domElement);
            return ((isCSSVariable(key)
                ? computedStyle.getPropertyValue(key)
                : computedStyle[key]) || 0);
        }
    },
    sortNodePosition: function (a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */
        return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget: function (props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox: function (element, _a) {
        var transformPagePoint = _a.transformPagePoint;
        return getBoundingBox(element, transformPagePoint);
    },
    /**
     * Reset the transform on the current Element. This is called as part
     * of a batched process across the entire layout tree. To remove this write
     * cycle it'd be interesting to see if it's possible to "undo" all the current
     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
     * works
     */
    resetTransform: function (element, domElement, props) {
        var transformTemplate = props.transformTemplate;
        domElement.style.transform = transformTemplate
            ? transformTemplate({}, "")
            : "none";
        // Ensure that whatever happens next, we restore our transform on the next frame
        element.scheduleRender();
    },
    restoreTransform: function (instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState: function (key, _a) {
        var vars = _a.vars, style = _a.style;
        delete vars[key];
        delete style[key];
    },
    /**
     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
     * can be animated by Motion.
     */
    makeTargetAnimatable: function (element, _a, _b, isMounted) {
        var transformValues = _b.transformValues;
        if (isMounted === void 0) { isMounted = true; }
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = (0,tslib_es6.__rest)(_a, ["transition", "transitionEnd"]);
        var origin = (0,setters/* getOrigin */.P$)(target, transition || {}, element);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */
        if (transformValues) {
            if (transitionEnd)
                transitionEnd = transformValues(transitionEnd);
            if (target)
                target = transformValues(target);
            if (origin)
                origin = transformValues(origin);
        }
        if (isMounted) {
            (0,setters/* checkTargetForNewValues */.GJ)(element, target, origin);
            var parsed = parseDomVariant(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return (0,tslib_es6.__assign)({ transition: transition,
            transitionEnd: transitionEnd }, target);
    },
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
    build: function (element, renderState, latestValues, projection, layoutState, options, props) {
        if (element.isVisible !== undefined) {
            renderState.style.visibility = element.isVisible
                ? "visible"
                : "hidden";
        }
        var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
        buildHTMLStyles(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? buildLayoutProjectionTransform : undefined, isProjectionTranform
            ? buildLayoutProjectionTransformOrigin
            : undefined);
    },
    render: renderHTML,
};
var htmlVisualElement = visualElement(htmlConfig);



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/svg/visual-element.js












var svgVisualElement = visualElement((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, htmlConfig), { getBaseTarget: function (props, key) {
        return props[key];
    },
    readValueFromInstance: function (domElement, key) {
        var _a;
        if (isTransformProp(key)) {
            return ((_a = (0,defaults/* getDefaultValueType */.A)(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        }
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        return domElement.getAttribute(key);
    },
    scrapeMotionValuesFromProps: scrape_motion_values_scrapeMotionValuesFromProps,
    build: function (_element, renderState, latestValues, projection, layoutState, options, props) {
        var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
        buildSVGAttrs(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? buildLayoutProjectionTransform : undefined, isProjectionTranform
            ? buildLayoutProjectionTransformOrigin
            : undefined);
    }, render: renderSVG }));



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/create-visual-element.js




var create_visual_element_createDomVisualElement = function (Component, options) {
    return isSVGComponent(Component)
        ? svgVisualElement(options, { enableHardwareAcceleration: false })
        : htmlVisualElement(options, { enableHardwareAcceleration: true });
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js










var featureBundle = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, animations), gestureAnimations), drag), layoutAnimations);
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */
var motion = /*@__PURE__*/ createMotionProxy(function (Component, config) {
    return create_config_createDomMotionConfig(Component, config, featureBundle, create_visual_element_createDomVisualElement);
});
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */
function createDomMotionComponent(key) {
    return createMotionComponent(createDomMotionConfig(key, { forwardMotionProps: false }, featureBundle, createDomVisualElement));
}




/***/ }),

/***/ 35446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "de": function() { return /* binding */ updateLayoutMeasurement; },
/* harmony export */   "e3": function() { return /* binding */ collectProjectingChildren; },
/* harmony export */   "kv": function() { return /* binding */ collectProjectingAncestors; },
/* harmony export */   "x7": function() { return /* binding */ snapshotViewportBox; }
/* harmony export */ });
/* harmony import */ var framesync__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42835);
/* harmony import */ var _utils_geometry_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97013);
/* harmony import */ var _utils_compare_by_depth_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66691);




function isProjecting(visualElement) {
    var isEnabled = visualElement.projection.isEnabled;
    return isEnabled || visualElement.shouldResetTransform();
}
function collectProjectingAncestors(visualElement, ancestors) {
    if (ancestors === void 0) { ancestors = []; }
    var parent = visualElement.parent;
    if (parent)
        collectProjectingAncestors(parent, ancestors);
    if (isProjecting(visualElement))
        ancestors.push(visualElement);
    return ancestors;
}
function collectProjectingChildren(visualElement) {
    var children = [];
    var addChild = function (child) {
        if (isProjecting(child))
            children.push(child);
        child.children.forEach(addChild);
    };
    visualElement.children.forEach(addChild);
    return children.sort(_utils_compare_by_depth_js__WEBPACK_IMPORTED_MODULE_1__/* .compareByDepth */ ._);
}
/**
 * Update the layoutState by measuring the DOM layout. This
 * should be called after resetting any layout-affecting transforms.
 */
function updateLayoutMeasurement(visualElement) {
    if (visualElement.shouldResetTransform())
        return;
    var layoutState = visualElement.getLayoutState();
    visualElement.notifyBeforeLayoutMeasure(layoutState.layout);
    layoutState.isHydrated = true;
    layoutState.layout = visualElement.measureViewportBox();
    layoutState.layoutCorrected = (0,_utils_geometry_index_js__WEBPACK_IMPORTED_MODULE_2__/* .copyAxisBox */ .nP)(layoutState.layout);
    visualElement.notifyLayoutMeasure(layoutState.layout, visualElement.prevViewportBox || layoutState.layout);
    framesync__WEBPACK_IMPORTED_MODULE_0__/* ["default"].update */ .ZP.update(function () { return visualElement.rebaseProjectionTarget(); });
}
/**
 * Record the viewport box as it was before an expected mutation/re-render
 */
function snapshotViewportBox(visualElement) {
    if (visualElement.shouldResetTransform())
        return;
    visualElement.prevViewportBox = visualElement.measureViewportBox(false);
    /**
     * Update targetBox to match the prevViewportBox. This is just to ensure
     * that targetBox is affected by scroll in the same way as the measured box
     */
    visualElement.rebaseProjectionTarget(false, visualElement.prevViewportBox);
}




/***/ }),

/***/ 94874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ flushLayout; },
/* harmony export */   "U": function() { return /* binding */ batchLayout; }
/* harmony export */ });
var unresolvedJobs = new Set();
function pushJob(stack, job, pointer) {
    if (!stack[pointer])
        stack[pointer] = [];
    stack[pointer].push(job);
}
function batchLayout(callback) {
    unresolvedJobs.add(callback);
    return function () { return unresolvedJobs.delete(callback); };
}
function flushLayout() {
    if (!unresolvedJobs.size)
        return;
    var pointer = 0;
    var reads = [[]];
    var writes = [];
    var setRead = function (job) { return pushJob(reads, job, pointer); };
    var setWrite = function (job) {
        pushJob(writes, job, pointer);
        pointer++;
    };
    /**
     * Resolve jobs into their array stacks
     */
    unresolvedJobs.forEach(function (callback) {
        callback(setRead, setWrite);
        pointer = 0;
    });
    unresolvedJobs.clear();
    /**
     * Execute jobs
     */
    var numStacks = writes.length;
    for (var i = 0; i <= numStacks; i++) {
        reads[i] && reads[i].forEach(executeJob);
        writes[i] && writes[i].forEach(executeJob);
    }
}
var executeJob = function (job) { return job(); };




/***/ }),

/***/ 44183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getAnimatableNone; }
/* harmony export */ });
/* harmony import */ var style_value_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80776);
/* harmony import */ var style_value_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8384);
/* harmony import */ var _defaults_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45176);



function getAnimatableNone(key, value) {
    var _a;
    var defaultValueType = (0,_defaults_js__WEBPACK_IMPORTED_MODULE_0__/* .getDefaultValueType */ .A)(key);
    if (defaultValueType !== style_value_types__WEBPACK_IMPORTED_MODULE_1__/* .filter */ .h)
        defaultValueType = style_value_types__WEBPACK_IMPORTED_MODULE_2__/* .complex */ .P;
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}




/***/ }),

/***/ 45176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getDefaultValueType; }
/* harmony export */ });
/* unused harmony export defaultValueTypes */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50879);
/* harmony import */ var style_value_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32672);
/* harmony import */ var style_value_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80776);
/* harmony import */ var _number_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85644);




/**
 * A map of default value types for common values
 */
var defaultValueTypes = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, _number_js__WEBPACK_IMPORTED_MODULE_1__/* .numberValueTypes */ .j), { 
    // Color props
    color: style_value_types__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$, backgroundColor: style_value_types__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$, outlineColor: style_value_types__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$, fill: style_value_types__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$, stroke: style_value_types__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$, 
    // Border props
    borderColor: style_value_types__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$, borderTopColor: style_value_types__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$, borderRightColor: style_value_types__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$, borderBottomColor: style_value_types__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$, borderLeftColor: style_value_types__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$, filter: style_value_types__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .h, WebkitFilter: style_value_types__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .h });
/**
 * Gets the default ValueType for the provided value key
 */
var getDefaultValueType = function (key) { return defaultValueTypes[key]; };




/***/ }),

/***/ 36883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ dimensionValueTypes; },
  "C": function() { return /* binding */ findDimensionValueType; }
});

// EXTERNAL MODULE: ./node_modules/style-value-types/dist/es/numbers/index.js
var numbers = __webpack_require__(42429);
// EXTERNAL MODULE: ./node_modules/style-value-types/dist/es/numbers/units.js
var units = __webpack_require__(31386);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/test.js
var test = __webpack_require__(70968);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/type-auto.js
/**
 * ValueType for "auto"
 */
var auto = {
    test: function (v) { return v === "auto"; },
    parse: function (v) { return v; },
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/dimensions.js




/**
 * A list of value types commonly used for dimensions
 */
var dimensionValueTypes = [numbers/* number */.Rx, units.px, units/* percent */.aQ, units/* degrees */.RW, units.vw, units.vh, auto];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
var findDimensionValueType = function (v) {
    return dimensionValueTypes.find((0,test/* testValueType */.l)(v));
};




/***/ }),

/***/ 85644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ numberValueTypes; }
});

// EXTERNAL MODULE: ./node_modules/style-value-types/dist/es/numbers/units.js
var units = __webpack_require__(31386);
// EXTERNAL MODULE: ./node_modules/style-value-types/dist/es/numbers/index.js
var numbers = __webpack_require__(42429);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50879);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/type-int.js



var type_int_int = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, numbers/* number */.Rx), { transform: Math.round });



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/number.js



var numberValueTypes = {
    // Border props
    borderWidth: units.px,
    borderTopWidth: units.px,
    borderRightWidth: units.px,
    borderBottomWidth: units.px,
    borderLeftWidth: units.px,
    borderRadius: units.px,
    radius: units.px,
    borderTopLeftRadius: units.px,
    borderTopRightRadius: units.px,
    borderBottomRightRadius: units.px,
    borderBottomLeftRadius: units.px,
    // Positioning props
    width: units.px,
    maxWidth: units.px,
    height: units.px,
    maxHeight: units.px,
    size: units.px,
    top: units.px,
    right: units.px,
    bottom: units.px,
    left: units.px,
    // Spacing props
    padding: units.px,
    paddingTop: units.px,
    paddingRight: units.px,
    paddingBottom: units.px,
    paddingLeft: units.px,
    margin: units.px,
    marginTop: units.px,
    marginRight: units.px,
    marginBottom: units.px,
    marginLeft: units.px,
    // Transform props
    rotate: units/* degrees */.RW,
    rotateX: units/* degrees */.RW,
    rotateY: units/* degrees */.RW,
    rotateZ: units/* degrees */.RW,
    scale: numbers/* scale */.bA,
    scaleX: numbers/* scale */.bA,
    scaleY: numbers/* scale */.bA,
    scaleZ: numbers/* scale */.bA,
    skew: units/* degrees */.RW,
    skewX: units/* degrees */.RW,
    skewY: units/* degrees */.RW,
    distance: units.px,
    translateX: units.px,
    translateY: units.px,
    translateZ: units.px,
    x: units.px,
    y: units.px,
    z: units.px,
    perspective: units.px,
    transformPerspective: units.px,
    opacity: numbers/* alpha */.Fq,
    originX: units/* progressPercentage */.$C,
    originY: units/* progressPercentage */.$C,
    originZ: units.px,
    // Misc
    zIndex: type_int_int,
    // SVG
    fillOpacity: numbers/* alpha */.Fq,
    strokeOpacity: numbers/* alpha */.Fq,
    numOctaves: type_int_int,
};




/***/ }),

/***/ 70968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ testValueType; }
/* harmony export */ });
/**
 * Tests a provided value against a ValueType
 */
var testValueType = function (v) { return function (type) { return type.test(v); }; };




/***/ }),

/***/ 77787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d5": function() { return /* binding */ animateVisualElement; },
/* harmony export */   "p_": function() { return /* binding */ stopAnimation; }
/* harmony export */ });
/* unused harmony export sortByTreeOrder */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50879);
/* harmony import */ var _animation_utils_transitions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38090);
/* harmony import */ var _setters_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33565);
/* harmony import */ var _variants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43796);





/**
 * @internal
 */
function animateVisualElement(visualElement, definition, options) {
    if (options === void 0) { options = {}; }
    visualElement.notifyAnimationStart();
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function (variant) {
            return animateVariant(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    }
    else if (typeof definition === "string") {
        animation = animateVariant(visualElement, definition, options);
    }
    else {
        var resolvedDefinition = typeof definition === "function"
            ? (0,_variants_js__WEBPACK_IMPORTED_MODULE_0__/* .resolveVariant */ .x5)(visualElement, definition, options.custom)
            : definition;
        animation = animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(function () {
        return visualElement.notifyAnimationComplete(definition);
    });
}
function animateVariant(visualElement, variant, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var resolved = (0,_variants_js__WEBPACK_IMPORTED_MODULE_0__/* .resolveVariant */ .x5)(visualElement, variant, options.custom);
    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
    if (options.transitionOverride) {
        transition = options.transitionOverride;
    }
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    var getAnimation = resolved
        ? function () { return animateTarget(visualElement, resolved, options); }
        : function () { return Promise.resolve(); };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size)
        ? function (forwardDelay) {
            if (forwardDelay === void 0) { forwardDelay = 0; }
            var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
            return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
        }
        : function () { return Promise.resolve(); };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */
    var when = transition.when;
    if (when) {
        var _c = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__read)(when === "beforeChildren"
            ? [getAnimation, getChildAnimations]
            : [getChildAnimations, getAnimation], 2), first = _c[0], last = _c[1];
        return first().then(last);
    }
    else {
        return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
    }
}
/**
 * @internal
 */
function animateTarget(visualElement, definition, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__rest)(_e, ["transition", "transitionEnd"]);
    if (transitionOverride)
        transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
    for (var key in target) {
        var value = visualElement.getValue(key);
        var valueTarget = target[key];
        if (!value ||
            valueTarget === undefined ||
            (animationTypeState &&
                shouldBlockAnimation(animationTypeState, key))) {
            continue;
        }
        var animation = (0,_animation_utils_transitions_js__WEBPACK_IMPORTED_MODULE_2__/* .startAnimation */ .b8)(key, value, valueTarget, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({ delay: delay }, transition));
        animations.push(animation);
    }
    return Promise.all(animations).then(function () {
        transitionEnd && (0,_setters_js__WEBPACK_IMPORTED_MODULE_3__/* .setTarget */ .CD)(visualElement, transitionEnd);
    });
}
function animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
    if (delayChildren === void 0) { delayChildren = 0; }
    if (staggerChildren === void 0) { staggerChildren = 0; }
    if (staggerDirection === void 0) { staggerDirection = 1; }
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1
        ? function (i) {
            if (i === void 0) { i = 0; }
            return i * staggerChildren;
        }
        : function (i) {
            if (i === void 0) { i = 0; }
            return maxStaggerDuration - i * staggerChildren;
        };
    Array.from(visualElement.variantChildren)
        .sort(sortByTreeOrder)
        .forEach(function (child, i) {
        animations.push(animateVariant(child, variant, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({}, options), { delay: delayChildren + generateStaggerDuration(i) })).then(function () { return child.notifyAnimationComplete(variant); }));
    });
    return Promise.all(animations);
}
function stopAnimation(visualElement) {
    visualElement.forEachValue(function (value) { return value.stop(); });
}
function sortByTreeOrder(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */
function shouldBlockAnimation(_a, key) {
    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}




/***/ }),

/***/ 66691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ compareByDepth; }
/* harmony export */ });
var compareByDepth = function (a, b) {
    return a.depth - b.depth;
};




/***/ }),

/***/ 33565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GJ": function() { return /* binding */ checkTargetForNewValues; },
  "P$": function() { return /* binding */ getOrigin; },
  "CD": function() { return /* binding */ setTarget; },
  "gg": function() { return /* binding */ setValues; }
});

// UNUSED EXPORTS: getOriginFromTransition

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50879);
// EXTERNAL MODULE: ./node_modules/style-value-types/dist/es/complex/index.js
var complex = __webpack_require__(8384);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/is-numerical-string.js
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
var isNumericalString = function (v) { return /^\-?\d*\.?\d+$/.test(v); };



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/resolve-value.js
var resolve_value = __webpack_require__(25452);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/index.js
var es_value = __webpack_require__(9985);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/animatable-none.js
var animatable_none = __webpack_require__(44183);
// EXTERNAL MODULE: ./node_modules/style-value-types/dist/es/color/index.js
var color = __webpack_require__(32672);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/dimensions.js + 1 modules
var dimensions = __webpack_require__(36883);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/test.js
var test = __webpack_require__(70968);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/value-types/find.js





/**
 * A list of all ValueTypes
 */
var valueTypes = (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([], (0,tslib_es6.__read)(dimensions/* dimensionValueTypes */.$)), [color/* color */.$, complex/* complex */.P]);
/**
 * Tests a value against the list of ValueTypes
 */
var findValueType = function (v) { return valueTypes.find((0,test/* testValueType */.l)(v)); };



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/variants.js
var variants = __webpack_require__(43796);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/utils/setters.js









/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */
function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) {
        visualElement.getValue(key).set(value);
    }
    else {
        visualElement.addValue(key, (0,es_value/* motionValue */.B)(value));
    }
}
function setTarget(visualElement, definition) {
    var resolved = (0,variants/* resolveVariant */.x5)(visualElement, definition);
    var _a = resolved
        ? visualElement.makeTargetAnimatable(resolved, false)
        : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b; _a.transition; var target = (0,tslib_es6.__rest)(_a, ["transitionEnd", "transition"]);
    target = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, target), transitionEnd);
    for (var key in target) {
        var value = (0,resolve_value/* resolveFinalValueInKeyframes */.Y)(target[key]);
        setMotionValue(visualElement, key, value);
    }
}
function setVariants(visualElement, variantLabels) {
    var reversedLabels = (0,tslib_es6.__spreadArray)([], (0,tslib_es6.__read)(variantLabels)).reverse();
    reversedLabels.forEach(function (key) {
        var _a;
        var variant = visualElement.getVariant(key);
        variant && setTarget(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
            setVariants(child, variantLabels);
        });
    });
}
function setValues(visualElement, definition) {
    if (Array.isArray(definition)) {
        return setVariants(visualElement, definition);
    }
    else if (typeof definition === "string") {
        return setVariants(visualElement, [definition]);
    }
    else {
        setTarget(visualElement, definition);
    }
}
function checkTargetForNewValues(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    var newValueKeys = Object.keys(target).filter(function (key) { return !visualElement.hasValue(key); });
    var numNewValues = newValueKeys.length;
    if (!numNewValues)
        return;
    for (var i = 0; i < numNewValues; i++) {
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */
        if (Array.isArray(targetValue)) {
            value = targetValue[0];
        }
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */
        if (value === null) {
            value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        }
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */
        if (value === undefined || value === null)
            continue;
        if (typeof value === "string" && isNumericalString(value)) {
            // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
        }
        else if (!findValueType(value) && complex/* complex.test */.P.test(targetValue)) {
            value = (0,animatable_none/* getAnimatableNone */.T)(key, targetValue);
        }
        visualElement.addValue(key, (0,es_value/* motionValue */.B)(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : (_d[key] = value);
        visualElement.setBaseTarget(key, value);
    }
}
function getOriginFromTransition(key, transition) {
    if (!transition)
        return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for (var key in target) {
        origin[key] =
            (_a = getOriginFromTransition(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    }
    return origin;
}




/***/ }),

/***/ 43796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$L": function() { return /* binding */ isVariantLabel; },
/* harmony export */   "A0": function() { return /* binding */ isVariantLabels; },
/* harmony export */   "O6": function() { return /* binding */ checkIfControllingVariants; },
/* harmony export */   "e8": function() { return /* binding */ checkIfVariantNode; },
/* harmony export */   "oQ": function() { return /* binding */ resolveVariantFromProps; },
/* harmony export */   "x5": function() { return /* binding */ resolveVariant; }
/* harmony export */ });
/**
 * Decides if the supplied variable is an array of variant labels
 */
function isVariantLabels(v) {
    return Array.isArray(v);
}
/**
 * Decides if the supplied variable is variant label
 */
function isVariantLabel(v) {
    return typeof v === "string" || isVariantLabels(v);
}
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */
function getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function (value, key) { return (current[key] = value.get()); });
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */
function getVelocity(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function (value, key) { return (velocity[key] = value.getVelocity()); });
    return velocity;
}
function resolveVariantFromProps(props, definition, custom, currentValues, currentVelocity) {
    var _a;
    if (currentValues === void 0) { currentValues = {}; }
    if (currentVelocity === void 0) { currentVelocity = {}; }
    if (typeof definition === "string") {
        definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    }
    return typeof definition === "function"
        ? definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity)
        : definition;
}
function resolveVariant(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return resolveVariantFromProps(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, getCurrent(visualElement), getVelocity(visualElement));
}
function checkIfControllingVariants(props) {
    var _a;
    return (typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" ||
        isVariantLabel(props.initial) ||
        isVariantLabel(props.animate) ||
        isVariantLabel(props.whileHover) ||
        isVariantLabel(props.whileDrag) ||
        isVariantLabel(props.whileTap) ||
        isVariantLabel(props.whileFocus) ||
        isVariantLabel(props.exit));
}
function checkIfVariantNode(props) {
    return Boolean(checkIfControllingVariants(props) || props.variants);
}




/***/ }),

/***/ 80759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ removeItem; },
/* harmony export */   "y": function() { return /* binding */ addUniqueItem; }
/* harmony export */ });
function addUniqueItem(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function removeItem(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}




/***/ }),

/***/ 97013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VZ": function() { return /* binding */ axisBox; },
  "_6": function() { return /* binding */ convertAxisBoxToBoundingBox; },
  "RX": function() { return /* binding */ convertBoundingBoxToAxisBox; },
  "nP": function() { return /* binding */ copyAxisBox; },
  "pY": function() { return /* binding */ delta; },
  "dV": function() { return /* binding */ transformBoundingBox; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50879);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/noop.js
function noop(any) {
    return any;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/geometry/index.js



/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */
function convertBoundingBoxToAxisBox(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: { min: left, max: right },
        y: { min: top, max: bottom },
    };
}
function convertAxisBoxToBoundingBox(_a) {
    var x = _a.x, y = _a.y;
    return {
        top: y.min,
        bottom: y.max,
        left: x.min,
        right: x.max,
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */
function transformBoundingBox(_a, transformPoint) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    if (transformPoint === void 0) { transformPoint = noop; }
    var topLeft = transformPoint({ x: left, y: top });
    var bottomRight = transformPoint({ x: right, y: bottom });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x,
    };
}
/**
 * Create an empty axis box of zero size
 */
function axisBox() {
    return { x: { min: 0, max: 1 }, y: { min: 0, max: 1 } };
}
function copyAxisBox(box) {
    return {
        x: (0,tslib_es6.__assign)({}, box.x),
        y: (0,tslib_es6.__assign)({}, box.y),
    };
}
/**
 * Create an empty box delta
 */
var zeroDelta = {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0,
};
function delta() {
    return {
        x: (0,tslib_es6.__assign)({}, zeroDelta),
        y: (0,tslib_es6.__assign)({}, zeroDelta),
    };
}




/***/ }),

/***/ 25452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ resolveFinalValueInKeyframes; },
/* harmony export */   "p": function() { return /* binding */ isCustomValue; }
/* harmony export */ });
/* harmony import */ var _animation_utils_is_keyframes_target_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70527);


var isCustomValue = function (v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var resolveFinalValueInKeyframes = function (v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0,_animation_utils_is_keyframes_target_js__WEBPACK_IMPORTED_MODULE_0__/* .isKeyframesTarget */ .C)(v) ? v[v.length - 1] || 0 : v;
};




/***/ }),

/***/ 49387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ SubscriptionManager; }
/* harmony export */ });
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80759);


var SubscriptionManager = /** @class */ (function () {
    function SubscriptionManager() {
        this.subscriptions = [];
    }
    SubscriptionManager.prototype.add = function (handler) {
        var _this = this;
        (0,_array_js__WEBPACK_IMPORTED_MODULE_0__/* .addUniqueItem */ .y)(this.subscriptions, handler);
        return function () { return (0,_array_js__WEBPACK_IMPORTED_MODULE_0__/* .removeItem */ .c)(_this.subscriptions, handler); };
    };
    SubscriptionManager.prototype.notify = function (a, b, c) {
        var numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions)
            return;
        if (numSubscriptions === 1) {
            /**
             * If there's only a single handler we can just call it without invoking a loop.
             */
            this.subscriptions[0](a, b, c);
        }
        else {
            for (var i = 0; i < numSubscriptions; i++) {
                /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */
                var handler = this.subscriptions[i];
                handler && handler(a, b, c);
            }
        }
    };
    SubscriptionManager.prototype.getSize = function () {
        return this.subscriptions.length;
    };
    SubscriptionManager.prototype.clear = function () {
        this.subscriptions.length = 0;
    };
    return SubscriptionManager;
}());




/***/ }),

/***/ 49580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ secondsToMilliseconds; }
/* harmony export */ });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
var secondsToMilliseconds = function (seconds) { return seconds * 1000; };




/***/ }),

/***/ 50024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useConstant; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);


/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */
function useConstant(init) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    if (ref.current === null) {
        ref.current = init();
    }
    return ref.current;
}




/***/ }),

/***/ 81715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useUnmountEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);


function useUnmountEffect(callback) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () { return function () { return callback(); }; }, []);
}




/***/ }),

/***/ 9985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ motionValue; }
/* harmony export */ });
/* unused harmony export MotionValue */
/* harmony import */ var framesync__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42835);
/* harmony import */ var popmotion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93222);
/* harmony import */ var _utils_subscription_manager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49387);




var isFloat = function (value) {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */
var MotionValue = /** @class */ (function () {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */
    function MotionValue(init) {
        var _this = this;
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */
        this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */
        this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */
        this.updateSubscribers = new _utils_subscription_manager_js__WEBPACK_IMPORTED_MODULE_1__/* .SubscriptionManager */ .L();
        /**
         * Functions to notify when the velocity updates.
         *
         * @internal
         */
        this.velocityUpdateSubscribers = new _utils_subscription_manager_js__WEBPACK_IMPORTED_MODULE_1__/* .SubscriptionManager */ .L();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */
        this.renderSubscribers = new _utils_subscription_manager_js__WEBPACK_IMPORTED_MODULE_1__/* .SubscriptionManager */ .L();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */
        this.canTrackVelocity = false;
        this.updateAndNotify = function (v, render) {
            if (render === void 0) { render = true; }
            _this.prev = _this.current;
            _this.current = v;
            // Update timestamp
            var _a = (0,framesync__WEBPACK_IMPORTED_MODULE_0__/* .getFrameData */ .$B)(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                framesync__WEBPACK_IMPORTED_MODULE_0__/* ["default"].postRender */ .ZP.postRender(_this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (_this.prev !== _this.current) {
                _this.updateSubscribers.notify(_this.current);
            }
            // Update velocity subscribers
            if (_this.velocityUpdateSubscribers.getSize()) {
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
            // Update render subscribers
            if (render) {
                _this.renderSubscribers.notify(_this.current);
            }
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.scheduleVelocityCheck = function () { return framesync__WEBPACK_IMPORTED_MODULE_0__/* ["default"].postRender */ .ZP.postRender(_this.velocityCheck); };
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.velocityCheck = function (_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * @library
     *
     * ```jsx
     * function MyComponent() {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <Frame x={x} />
     * }
     * ```
     *
     * @motion
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @internalremarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */
    MotionValue.prototype.onChange = function (subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function () {
        this.updateSubscribers.clear();
    };
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */
    MotionValue.prototype.onRenderRequest = function (subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */
    MotionValue.prototype.attach = function (passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */
    MotionValue.prototype.set = function (v, render) {
        if (render === void 0) { render = true; }
        if (!render || !this.passiveEffect) {
            this.updateAndNotify(v, render);
        }
        else {
            this.passiveEffect(v, this.updateAndNotify);
        }
    };
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */
    MotionValue.prototype.get = function () {
        return this.current;
    };
    /**
     * @public
     */
    MotionValue.prototype.getPrevious = function () {
        return this.prev;
    };
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */
    MotionValue.prototype.getVelocity = function () {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity
            ? // These casts could be avoided if parseFloat would be typed better
                (0,popmotion__WEBPACK_IMPORTED_MODULE_2__/* .velocityPerSecond */ .R)(parseFloat(this.current) -
                    parseFloat(this.prev), this.timeDelta)
            : 0;
    };
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */
    MotionValue.prototype.start = function (animation) {
        var _this = this;
        this.stop();
        return new Promise(function (resolve) {
            _this.hasAnimated = true;
            _this.stopAnimation = animation(resolve);
        }).then(function () { return _this.clearAnimation(); });
    };
    /**
     * Stop the currently active animation.
     *
     * @public
     */
    MotionValue.prototype.stop = function () {
        if (this.stopAnimation)
            this.stopAnimation();
        this.clearAnimation();
    };
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */
    MotionValue.prototype.isAnimating = function () {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function () {
        this.stopAnimation = null;
    };
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */
    MotionValue.prototype.destroy = function () {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}());
/**
 * @internal
 */
function motionValue(init) {
    return new MotionValue(init);
}




/***/ }),

/***/ 42835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qY": function() { return /* binding */ cancelSync; },
  "ZP": function() { return /* binding */ es; },
  "iW": function() { return /* binding */ flushSync; },
  "$B": function() { return /* binding */ getFrameData; }
});

;// CONCATENATED MODULE: ./node_modules/framesync/dist/es/on-next-frame.js
var defaultTimestep = (1 / 60) * 1000;
var getCurrentTime = typeof performance !== "undefined"
    ? function () { return performance.now(); }
    : function () { return Date.now(); };
var onNextFrame = typeof window !== "undefined"
    ? function (callback) {
        return window.requestAnimationFrame(callback);
    }
    : function (callback) {
        return setTimeout(function () { return callback(getCurrentTime()); }, defaultTimestep);
    };



;// CONCATENATED MODULE: ./node_modules/framesync/dist/es/create-render-step.js
function createRenderStep(runNextFrame) {
    var toRun = [];
    var toRunNextFrame = [];
    var numToRun = 0;
    var isProcessing = false;
    var toKeepAlive = new WeakSet();
    var step = {
        schedule: function (callback, keepAlive, immediate) {
            if (keepAlive === void 0) { keepAlive = false; }
            if (immediate === void 0) { immediate = false; }
            var addToCurrentFrame = immediate && isProcessing;
            var buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive)
                toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing)
                    numToRun = toRun.length;
            }
            return callback;
        },
        cancel: function (callback) {
            var index = toRunNextFrame.indexOf(callback);
            if (index !== -1)
                toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: function (frameData) {
            var _a;
            isProcessing = true;
            _a = [toRunNextFrame, toRun], toRun = _a[0], toRunNextFrame = _a[1];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) {
                for (var i = 0; i < numToRun; i++) {
                    var callback = toRun[i];
                    callback(frameData);
                    if (toKeepAlive.has(callback)) {
                        step.schedule(callback);
                        runNextFrame();
                    }
                }
            }
            isProcessing = false;
        },
    };
    return step;
}



;// CONCATENATED MODULE: ./node_modules/framesync/dist/es/index.js



var maxElapsed = 40;
var useDefaultElapsed = true;
var runNextFrame = false;
var isProcessing = false;
var es_frame = {
    delta: 0,
    timestamp: 0
};
var stepsOrder = ["read", "update", "preRender", "render", "postRender"];
var steps = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    acc[key] = createRenderStep(function () {
        return runNextFrame = true;
    });
    return acc;
}, {});
var sync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    var step = steps[key];
    acc[key] = function (process, keepAlive, immediate) {
        if (keepAlive === void 0) {
            keepAlive = false;
        }
        if (immediate === void 0) {
            immediate = false;
        }
        if (!runNextFrame) startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
var cancelSync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    acc[key] = steps[key].cancel;
    return acc;
}, {});
var flushSync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    acc[key] = function () {
        return steps[key].process(es_frame);
    };
    return acc;
}, {});
var processStep = function (stepId) {
    return steps[stepId].process(es_frame);
};
var processFrame = function (timestamp) {
    runNextFrame = false;
    es_frame.delta = useDefaultElapsed ? defaultTimestep : Math.max(Math.min(timestamp - es_frame.timestamp, maxElapsed), 1);
    es_frame.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (runNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
var startLoop = function () {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing) onNextFrame(processFrame);
};
var getFrameData = function () {
    return es_frame;
};

/* harmony default export */ var es = (sync);



/***/ }),

/***/ 162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ warning; },
/* harmony export */   "k": function() { return /* binding */ invariant; }
/* harmony export */ });
var warning = function () { };
var invariant = function () { };
if (false) {}




/***/ }),

/***/ 3229:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 43000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _ = (__webpack_require__(17073).runInContext)();
module.exports = __webpack_require__(83811)(_, _);


/***/ }),

/***/ 83811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapping = __webpack_require__(80644),
    fallbackHolder = __webpack_require__(89585);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var defaultHolder = isLib ? func : fallbackHolder,
      forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func, placeholder) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    result.placeholder = func.placeholder = placeholder;

    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func, defaultHolder);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func, _)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  _.placeholder = _;

  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),

/***/ 80644:
/***/ (function(__unused_webpack_module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),

/***/ 89585:
/***/ (function(module) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),

/***/ 61978:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 17073:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(){function n(n,t,r){switch(r.length){case 0:return n.call(t);case 1:return n.call(t,r[0]);case 2:return n.call(t,r[0],r[1]);case 3:return n.call(t,r[0],r[1],r[2])}return n.apply(t,r)}function t(n,t,r,e){for(var u=-1,i=null==n?0:n.length;++u<i;){var o=n[u];t(e,o,r(o),n)}return e}function r(n,t){for(var r=-1,e=null==n?0:n.length;++r<e&&t(n[r],r,n)!==!1;);return n}function e(n,t){for(var r=null==n?0:n.length;r--&&t(n[r],r,n)!==!1;);return n}function u(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(!t(n[r],r,n))return!1;
return!0}function i(n,t){for(var r=-1,e=null==n?0:n.length,u=0,i=[];++r<e;){var o=n[r];t(o,r,n)&&(i[u++]=o)}return i}function o(n,t){return!!(null==n?0:n.length)&&y(n,t,0)>-1}function f(n,t,r){for(var e=-1,u=null==n?0:n.length;++e<u;)if(r(t,n[e]))return!0;return!1}function c(n,t){for(var r=-1,e=null==n?0:n.length,u=Array(e);++r<e;)u[r]=t(n[r],r,n);return u}function a(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function l(n,t,r,e){var u=-1,i=null==n?0:n.length;for(e&&i&&(r=n[++u]);++u<i;)r=t(r,n[u],u,n);
return r}function s(n,t,r,e){var u=null==n?0:n.length;for(e&&u&&(r=n[--u]);u--;)r=t(r,n[u],u,n);return r}function h(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(t(n[r],r,n))return!0;return!1}function p(n){return n.split("")}function _(n){return n.match($t)||[]}function v(n,t,r){var e;return r(n,function(n,r,u){if(t(n,r,u))return e=r,!1}),e}function g(n,t,r,e){for(var u=n.length,i=r+(e?1:-1);e?i--:++i<u;)if(t(n[i],i,n))return i;return-1}function y(n,t,r){return t===t?Z(n,t,r):g(n,b,r)}function d(n,t,r,e){
for(var u=r-1,i=n.length;++u<i;)if(e(n[u],t))return u;return-1}function b(n){return n!==n}function w(n,t){var r=null==n?0:n.length;return r?k(n,t)/r:Cn}function m(n){return function(t){return null==t?X:t[n]}}function x(n){return function(t){return null==n?X:n[t]}}function j(n,t,r,e,u){return u(n,function(n,u,i){r=e?(e=!1,n):t(r,n,u,i)}),r}function A(n,t){var r=n.length;for(n.sort(t);r--;)n[r]=n[r].value;return n}function k(n,t){for(var r,e=-1,u=n.length;++e<u;){var i=t(n[e]);i!==X&&(r=r===X?i:r+i);
}return r}function O(n,t){for(var r=-1,e=Array(n);++r<n;)e[r]=t(r);return e}function I(n,t){return c(t,function(t){return[t,n[t]]})}function R(n){return n?n.slice(0,H(n)+1).replace(Lt,""):n}function z(n){return function(t){return n(t)}}function E(n,t){return c(t,function(t){return n[t]})}function S(n,t){return n.has(t)}function W(n,t){for(var r=-1,e=n.length;++r<e&&y(t,n[r],0)>-1;);return r}function L(n,t){for(var r=n.length;r--&&y(t,n[r],0)>-1;);return r}function C(n,t){for(var r=n.length,e=0;r--;)n[r]===t&&++e;
return e}function U(n){return"\\"+Yr[n]}function B(n,t){return null==n?X:n[t]}function T(n){return Nr.test(n)}function $(n){return Pr.test(n)}function D(n){for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r}function M(n){var t=-1,r=Array(n.size);return n.forEach(function(n,e){r[++t]=[e,n]}),r}function F(n,t){return function(r){return n(t(r))}}function N(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r];o!==t&&o!==cn||(n[r]=cn,i[u++]=r)}return i}function P(n){var t=-1,r=Array(n.size);
return n.forEach(function(n){r[++t]=n}),r}function q(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=[n,n]}),r}function Z(n,t,r){for(var e=r-1,u=n.length;++e<u;)if(n[e]===t)return e;return-1}function K(n,t,r){for(var e=r+1;e--;)if(n[e]===t)return e;return e}function V(n){return T(n)?J(n):_e(n)}function G(n){return T(n)?Y(n):p(n)}function H(n){for(var t=n.length;t--&&Ct.test(n.charAt(t)););return t}function J(n){for(var t=Mr.lastIndex=0;Mr.test(n);)++t;return t}function Y(n){return n.match(Mr)||[];
}function Q(n){return n.match(Fr)||[]}var X,nn="4.17.21",tn=200,rn="Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",en="Expected a function",un="Invalid `variable` option passed into `_.template`",on="__lodash_hash_undefined__",fn=500,cn="__lodash_placeholder__",an=1,ln=2,sn=4,hn=1,pn=2,_n=1,vn=2,gn=4,yn=8,dn=16,bn=32,wn=64,mn=128,xn=256,jn=512,An=30,kn="...",On=800,In=16,Rn=1,zn=2,En=3,Sn=1/0,Wn=9007199254740991,Ln=1.7976931348623157e308,Cn=NaN,Un=4294967295,Bn=Un-1,Tn=Un>>>1,$n=[["ary",mn],["bind",_n],["bindKey",vn],["curry",yn],["curryRight",dn],["flip",jn],["partial",bn],["partialRight",wn],["rearg",xn]],Dn="[object Arguments]",Mn="[object Array]",Fn="[object AsyncFunction]",Nn="[object Boolean]",Pn="[object Date]",qn="[object DOMException]",Zn="[object Error]",Kn="[object Function]",Vn="[object GeneratorFunction]",Gn="[object Map]",Hn="[object Number]",Jn="[object Null]",Yn="[object Object]",Qn="[object Promise]",Xn="[object Proxy]",nt="[object RegExp]",tt="[object Set]",rt="[object String]",et="[object Symbol]",ut="[object Undefined]",it="[object WeakMap]",ot="[object WeakSet]",ft="[object ArrayBuffer]",ct="[object DataView]",at="[object Float32Array]",lt="[object Float64Array]",st="[object Int8Array]",ht="[object Int16Array]",pt="[object Int32Array]",_t="[object Uint8Array]",vt="[object Uint8ClampedArray]",gt="[object Uint16Array]",yt="[object Uint32Array]",dt=/\b__p \+= '';/g,bt=/\b(__p \+=) '' \+/g,wt=/(__e\(.*?\)|\b__t\)) \+\n'';/g,mt=/&(?:amp|lt|gt|quot|#39);/g,xt=/[&<>"']/g,jt=RegExp(mt.source),At=RegExp(xt.source),kt=/<%-([\s\S]+?)%>/g,Ot=/<%([\s\S]+?)%>/g,It=/<%=([\s\S]+?)%>/g,Rt=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,zt=/^\w*$/,Et=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,St=/[\\^$.*+?()[\]{}|]/g,Wt=RegExp(St.source),Lt=/^\s+/,Ct=/\s/,Ut=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,Bt=/\{\n\/\* \[wrapped with (.+)\] \*/,Tt=/,? & /,$t=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,Dt=/[()=,{}\[\]\/\s]/,Mt=/\\(\\)?/g,Ft=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,Nt=/\w*$/,Pt=/^[-+]0x[0-9a-f]+$/i,qt=/^0b[01]+$/i,Zt=/^\[object .+?Constructor\]$/,Kt=/^0o[0-7]+$/i,Vt=/^(?:0|[1-9]\d*)$/,Gt=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,Ht=/($^)/,Jt=/['\n\r\u2028\u2029\\]/g,Yt="\\ud800-\\udfff",Qt="\\u0300-\\u036f",Xt="\\ufe20-\\ufe2f",nr="\\u20d0-\\u20ff",tr=Qt+Xt+nr,rr="\\u2700-\\u27bf",er="a-z\\xdf-\\xf6\\xf8-\\xff",ur="\\xac\\xb1\\xd7\\xf7",ir="\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",or="\\u2000-\\u206f",fr=" \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",cr="A-Z\\xc0-\\xd6\\xd8-\\xde",ar="\\ufe0e\\ufe0f",lr=ur+ir+or+fr,sr="['\u2019]",hr="["+Yt+"]",pr="["+lr+"]",_r="["+tr+"]",vr="\\d+",gr="["+rr+"]",yr="["+er+"]",dr="[^"+Yt+lr+vr+rr+er+cr+"]",br="\\ud83c[\\udffb-\\udfff]",wr="(?:"+_r+"|"+br+")",mr="[^"+Yt+"]",xr="(?:\\ud83c[\\udde6-\\uddff]){2}",jr="[\\ud800-\\udbff][\\udc00-\\udfff]",Ar="["+cr+"]",kr="\\u200d",Or="(?:"+yr+"|"+dr+")",Ir="(?:"+Ar+"|"+dr+")",Rr="(?:"+sr+"(?:d|ll|m|re|s|t|ve))?",zr="(?:"+sr+"(?:D|LL|M|RE|S|T|VE))?",Er=wr+"?",Sr="["+ar+"]?",Wr="(?:"+kr+"(?:"+[mr,xr,jr].join("|")+")"+Sr+Er+")*",Lr="\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",Cr="\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",Ur=Sr+Er+Wr,Br="(?:"+[gr,xr,jr].join("|")+")"+Ur,Tr="(?:"+[mr+_r+"?",_r,xr,jr,hr].join("|")+")",$r=RegExp(sr,"g"),Dr=RegExp(_r,"g"),Mr=RegExp(br+"(?="+br+")|"+Tr+Ur,"g"),Fr=RegExp([Ar+"?"+yr+"+"+Rr+"(?="+[pr,Ar,"$"].join("|")+")",Ir+"+"+zr+"(?="+[pr,Ar+Or,"$"].join("|")+")",Ar+"?"+Or+"+"+Rr,Ar+"+"+zr,Cr,Lr,vr,Br].join("|"),"g"),Nr=RegExp("["+kr+Yt+tr+ar+"]"),Pr=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,qr=["Array","Buffer","DataView","Date","Error","Float32Array","Float64Array","Function","Int8Array","Int16Array","Int32Array","Map","Math","Object","Promise","RegExp","Set","String","Symbol","TypeError","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","WeakMap","_","clearTimeout","isFinite","parseInt","setTimeout"],Zr=-1,Kr={};
Kr[at]=Kr[lt]=Kr[st]=Kr[ht]=Kr[pt]=Kr[_t]=Kr[vt]=Kr[gt]=Kr[yt]=!0,Kr[Dn]=Kr[Mn]=Kr[ft]=Kr[Nn]=Kr[ct]=Kr[Pn]=Kr[Zn]=Kr[Kn]=Kr[Gn]=Kr[Hn]=Kr[Yn]=Kr[nt]=Kr[tt]=Kr[rt]=Kr[it]=!1;var Vr={};Vr[Dn]=Vr[Mn]=Vr[ft]=Vr[ct]=Vr[Nn]=Vr[Pn]=Vr[at]=Vr[lt]=Vr[st]=Vr[ht]=Vr[pt]=Vr[Gn]=Vr[Hn]=Vr[Yn]=Vr[nt]=Vr[tt]=Vr[rt]=Vr[et]=Vr[_t]=Vr[vt]=Vr[gt]=Vr[yt]=!0,Vr[Zn]=Vr[Kn]=Vr[it]=!1;var Gr={"\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a",
"\xc7":"C","\xe7":"c","\xd0":"D","\xf0":"d","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xd1":"N","\xf1":"n","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xdd":"Y","\xfd":"y","\xff":"y","\xc6":"Ae",
"\xe6":"ae","\xde":"Th","\xfe":"th","\xdf":"ss","\u0100":"A","\u0102":"A","\u0104":"A","\u0101":"a","\u0103":"a","\u0105":"a","\u0106":"C","\u0108":"C","\u010a":"C","\u010c":"C","\u0107":"c","\u0109":"c","\u010b":"c","\u010d":"c","\u010e":"D","\u0110":"D","\u010f":"d","\u0111":"d","\u0112":"E","\u0114":"E","\u0116":"E","\u0118":"E","\u011a":"E","\u0113":"e","\u0115":"e","\u0117":"e","\u0119":"e","\u011b":"e","\u011c":"G","\u011e":"G","\u0120":"G","\u0122":"G","\u011d":"g","\u011f":"g","\u0121":"g",
"\u0123":"g","\u0124":"H","\u0126":"H","\u0125":"h","\u0127":"h","\u0128":"I","\u012a":"I","\u012c":"I","\u012e":"I","\u0130":"I","\u0129":"i","\u012b":"i","\u012d":"i","\u012f":"i","\u0131":"i","\u0134":"J","\u0135":"j","\u0136":"K","\u0137":"k","\u0138":"k","\u0139":"L","\u013b":"L","\u013d":"L","\u013f":"L","\u0141":"L","\u013a":"l","\u013c":"l","\u013e":"l","\u0140":"l","\u0142":"l","\u0143":"N","\u0145":"N","\u0147":"N","\u014a":"N","\u0144":"n","\u0146":"n","\u0148":"n","\u014b":"n","\u014c":"O",
"\u014e":"O","\u0150":"O","\u014d":"o","\u014f":"o","\u0151":"o","\u0154":"R","\u0156":"R","\u0158":"R","\u0155":"r","\u0157":"r","\u0159":"r","\u015a":"S","\u015c":"S","\u015e":"S","\u0160":"S","\u015b":"s","\u015d":"s","\u015f":"s","\u0161":"s","\u0162":"T","\u0164":"T","\u0166":"T","\u0163":"t","\u0165":"t","\u0167":"t","\u0168":"U","\u016a":"U","\u016c":"U","\u016e":"U","\u0170":"U","\u0172":"U","\u0169":"u","\u016b":"u","\u016d":"u","\u016f":"u","\u0171":"u","\u0173":"u","\u0174":"W","\u0175":"w",
"\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017b":"Z","\u017d":"Z","\u017a":"z","\u017c":"z","\u017e":"z","\u0132":"IJ","\u0133":"ij","\u0152":"Oe","\u0153":"oe","\u0149":"'n","\u017f":"s"},Hr={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"},Jr={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"},Yr={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Qr=parseFloat,Xr=parseInt,ne="object"==typeof __webpack_require__.g&&__webpack_require__.g&&__webpack_require__.g.Object===Object&&__webpack_require__.g,te="object"==typeof self&&self&&self.Object===Object&&self,re=ne||te||Function("return this")(),ee= true&&exports&&!exports.nodeType&&exports,ue=ee&&"object"=="object"&&module&&!module.nodeType&&module,ie=ue&&ue.exports===ee,oe=ie&&ne.process,fe=function(){
try{var n=ue&&ue.require&&ue.require("util").types;return n?n:oe&&oe.binding&&oe.binding("util")}catch(n){}}(),ce=fe&&fe.isArrayBuffer,ae=fe&&fe.isDate,le=fe&&fe.isMap,se=fe&&fe.isRegExp,he=fe&&fe.isSet,pe=fe&&fe.isTypedArray,_e=m("length"),ve=x(Gr),ge=x(Hr),ye=x(Jr),de=function p(x){function Z(n){if(cc(n)&&!bh(n)&&!(n instanceof Ct)){if(n instanceof Y)return n;if(bl.call(n,"__wrapped__"))return eo(n)}return new Y(n)}function J(){}function Y(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,
this.__index__=0,this.__values__=X}function Ct(n){this.__wrapped__=n,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=Un,this.__views__=[]}function $t(){var n=new Ct(this.__wrapped__);return n.__actions__=Tu(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=Tu(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=Tu(this.__views__),n}function Yt(){if(this.__filtered__){var n=new Ct(this);n.__dir__=-1,
n.__filtered__=!0}else n=this.clone(),n.__dir__*=-1;return n}function Qt(){var n=this.__wrapped__.value(),t=this.__dir__,r=bh(n),e=t<0,u=r?n.length:0,i=Oi(0,u,this.__views__),o=i.start,f=i.end,c=f-o,a=e?f:o-1,l=this.__iteratees__,s=l.length,h=0,p=Hl(c,this.__takeCount__);if(!r||!e&&u==c&&p==c)return wu(n,this.__actions__);var _=[];n:for(;c--&&h<p;){a+=t;for(var v=-1,g=n[a];++v<s;){var y=l[v],d=y.iteratee,b=y.type,w=d(g);if(b==zn)g=w;else if(!w){if(b==Rn)continue n;break n}}_[h++]=g}return _}function Xt(n){
var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function nr(){this.__data__=is?is(null):{},this.size=0}function tr(n){var t=this.has(n)&&delete this.__data__[n];return this.size-=t?1:0,t}function rr(n){var t=this.__data__;if(is){var r=t[n];return r===on?X:r}return bl.call(t,n)?t[n]:X}function er(n){var t=this.__data__;return is?t[n]!==X:bl.call(t,n)}function ur(n,t){var r=this.__data__;return this.size+=this.has(n)?0:1,r[n]=is&&t===X?on:t,this}function ir(n){
var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function or(){this.__data__=[],this.size=0}function fr(n){var t=this.__data__,r=Wr(t,n);return!(r<0)&&(r==t.length-1?t.pop():Ll.call(t,r,1),--this.size,!0)}function cr(n){var t=this.__data__,r=Wr(t,n);return r<0?X:t[r][1]}function ar(n){return Wr(this.__data__,n)>-1}function lr(n,t){var r=this.__data__,e=Wr(r,n);return e<0?(++this.size,r.push([n,t])):r[e][1]=t,this}function sr(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){
var e=n[t];this.set(e[0],e[1])}}function hr(){this.size=0,this.__data__={hash:new Xt,map:new(ts||ir),string:new Xt}}function pr(n){var t=xi(this,n).delete(n);return this.size-=t?1:0,t}function _r(n){return xi(this,n).get(n)}function vr(n){return xi(this,n).has(n)}function gr(n,t){var r=xi(this,n),e=r.size;return r.set(n,t),this.size+=r.size==e?0:1,this}function yr(n){var t=-1,r=null==n?0:n.length;for(this.__data__=new sr;++t<r;)this.add(n[t])}function dr(n){return this.__data__.set(n,on),this}function br(n){
return this.__data__.has(n)}function wr(n){this.size=(this.__data__=new ir(n)).size}function mr(){this.__data__=new ir,this.size=0}function xr(n){var t=this.__data__,r=t.delete(n);return this.size=t.size,r}function jr(n){return this.__data__.get(n)}function Ar(n){return this.__data__.has(n)}function kr(n,t){var r=this.__data__;if(r instanceof ir){var e=r.__data__;if(!ts||e.length<tn-1)return e.push([n,t]),this.size=++r.size,this;r=this.__data__=new sr(e)}return r.set(n,t),this.size=r.size,this}function Or(n,t){
var r=bh(n),e=!r&&dh(n),u=!r&&!e&&mh(n),i=!r&&!e&&!u&&Oh(n),o=r||e||u||i,f=o?O(n.length,hl):[],c=f.length;for(var a in n)!t&&!bl.call(n,a)||o&&("length"==a||u&&("offset"==a||"parent"==a)||i&&("buffer"==a||"byteLength"==a||"byteOffset"==a)||Ci(a,c))||f.push(a);return f}function Ir(n){var t=n.length;return t?n[tu(0,t-1)]:X}function Rr(n,t){return Xi(Tu(n),Mr(t,0,n.length))}function zr(n){return Xi(Tu(n))}function Er(n,t,r){(r===X||Gf(n[t],r))&&(r!==X||t in n)||Br(n,t,r)}function Sr(n,t,r){var e=n[t];
bl.call(n,t)&&Gf(e,r)&&(r!==X||t in n)||Br(n,t,r)}function Wr(n,t){for(var r=n.length;r--;)if(Gf(n[r][0],t))return r;return-1}function Lr(n,t,r,e){return ys(n,function(n,u,i){t(e,n,r(n),i)}),e}function Cr(n,t){return n&&$u(t,Pc(t),n)}function Ur(n,t){return n&&$u(t,qc(t),n)}function Br(n,t,r){"__proto__"==t&&Tl?Tl(n,t,{configurable:!0,enumerable:!0,value:r,writable:!0}):n[t]=r}function Tr(n,t){for(var r=-1,e=t.length,u=il(e),i=null==n;++r<e;)u[r]=i?X:Mc(n,t[r]);return u}function Mr(n,t,r){return n===n&&(r!==X&&(n=n<=r?n:r),
t!==X&&(n=n>=t?n:t)),n}function Fr(n,t,e,u,i,o){var f,c=t&an,a=t&ln,l=t&sn;if(e&&(f=i?e(n,u,i,o):e(n)),f!==X)return f;if(!fc(n))return n;var s=bh(n);if(s){if(f=zi(n),!c)return Tu(n,f)}else{var h=zs(n),p=h==Kn||h==Vn;if(mh(n))return Iu(n,c);if(h==Yn||h==Dn||p&&!i){if(f=a||p?{}:Ei(n),!c)return a?Mu(n,Ur(f,n)):Du(n,Cr(f,n))}else{if(!Vr[h])return i?n:{};f=Si(n,h,c)}}o||(o=new wr);var _=o.get(n);if(_)return _;o.set(n,f),kh(n)?n.forEach(function(r){f.add(Fr(r,t,e,r,n,o))}):jh(n)&&n.forEach(function(r,u){
f.set(u,Fr(r,t,e,u,n,o))});var v=l?a?di:yi:a?qc:Pc,g=s?X:v(n);return r(g||n,function(r,u){g&&(u=r,r=n[u]),Sr(f,u,Fr(r,t,e,u,n,o))}),f}function Nr(n){var t=Pc(n);return function(r){return Pr(r,n,t)}}function Pr(n,t,r){var e=r.length;if(null==n)return!e;for(n=ll(n);e--;){var u=r[e],i=t[u],o=n[u];if(o===X&&!(u in n)||!i(o))return!1}return!0}function Gr(n,t,r){if("function"!=typeof n)throw new pl(en);return Ws(function(){n.apply(X,r)},t)}function Hr(n,t,r,e){var u=-1,i=o,a=!0,l=n.length,s=[],h=t.length;
if(!l)return s;r&&(t=c(t,z(r))),e?(i=f,a=!1):t.length>=tn&&(i=S,a=!1,t=new yr(t));n:for(;++u<l;){var p=n[u],_=null==r?p:r(p);if(p=e||0!==p?p:0,a&&_===_){for(var v=h;v--;)if(t[v]===_)continue n;s.push(p)}else i(t,_,e)||s.push(p)}return s}function Jr(n,t){var r=!0;return ys(n,function(n,e,u){return r=!!t(n,e,u)}),r}function Yr(n,t,r){for(var e=-1,u=n.length;++e<u;){var i=n[e],o=t(i);if(null!=o&&(f===X?o===o&&!bc(o):r(o,f)))var f=o,c=i}return c}function ne(n,t,r,e){var u=n.length;for(r=kc(r),r<0&&(r=-r>u?0:u+r),
e=e===X||e>u?u:kc(e),e<0&&(e+=u),e=r>e?0:Oc(e);r<e;)n[r++]=t;return n}function te(n,t){var r=[];return ys(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function ee(n,t,r,e,u){var i=-1,o=n.length;for(r||(r=Li),u||(u=[]);++i<o;){var f=n[i];t>0&&r(f)?t>1?ee(f,t-1,r,e,u):a(u,f):e||(u[u.length]=f)}return u}function ue(n,t){return n&&bs(n,t,Pc)}function oe(n,t){return n&&ws(n,t,Pc)}function fe(n,t){return i(t,function(t){return uc(n[t])})}function _e(n,t){t=ku(t,n);for(var r=0,e=t.length;null!=n&&r<e;)n=n[no(t[r++])];
return r&&r==e?n:X}function de(n,t,r){var e=t(n);return bh(n)?e:a(e,r(n))}function we(n){return null==n?n===X?ut:Jn:Bl&&Bl in ll(n)?ki(n):Ki(n)}function me(n,t){return n>t}function xe(n,t){return null!=n&&bl.call(n,t)}function je(n,t){return null!=n&&t in ll(n)}function Ae(n,t,r){return n>=Hl(t,r)&&n<Gl(t,r)}function ke(n,t,r){for(var e=r?f:o,u=n[0].length,i=n.length,a=i,l=il(i),s=1/0,h=[];a--;){var p=n[a];a&&t&&(p=c(p,z(t))),s=Hl(p.length,s),l[a]=!r&&(t||u>=120&&p.length>=120)?new yr(a&&p):X}p=n[0];
var _=-1,v=l[0];n:for(;++_<u&&h.length<s;){var g=p[_],y=t?t(g):g;if(g=r||0!==g?g:0,!(v?S(v,y):e(h,y,r))){for(a=i;--a;){var d=l[a];if(!(d?S(d,y):e(n[a],y,r)))continue n}v&&v.push(y),h.push(g)}}return h}function Oe(n,t,r,e){return ue(n,function(n,u,i){t(e,r(n),u,i)}),e}function Ie(t,r,e){r=ku(r,t),t=Gi(t,r);var u=null==t?t:t[no(jo(r))];return null==u?X:n(u,t,e)}function Re(n){return cc(n)&&we(n)==Dn}function ze(n){return cc(n)&&we(n)==ft}function Ee(n){return cc(n)&&we(n)==Pn}function Se(n,t,r,e,u){
return n===t||(null==n||null==t||!cc(n)&&!cc(t)?n!==n&&t!==t:We(n,t,r,e,Se,u))}function We(n,t,r,e,u,i){var o=bh(n),f=bh(t),c=o?Mn:zs(n),a=f?Mn:zs(t);c=c==Dn?Yn:c,a=a==Dn?Yn:a;var l=c==Yn,s=a==Yn,h=c==a;if(h&&mh(n)){if(!mh(t))return!1;o=!0,l=!1}if(h&&!l)return i||(i=new wr),o||Oh(n)?pi(n,t,r,e,u,i):_i(n,t,c,r,e,u,i);if(!(r&hn)){var p=l&&bl.call(n,"__wrapped__"),_=s&&bl.call(t,"__wrapped__");if(p||_){var v=p?n.value():n,g=_?t.value():t;return i||(i=new wr),u(v,g,r,e,i)}}return!!h&&(i||(i=new wr),vi(n,t,r,e,u,i));
}function Le(n){return cc(n)&&zs(n)==Gn}function Ce(n,t,r,e){var u=r.length,i=u,o=!e;if(null==n)return!i;for(n=ll(n);u--;){var f=r[u];if(o&&f[2]?f[1]!==n[f[0]]:!(f[0]in n))return!1}for(;++u<i;){f=r[u];var c=f[0],a=n[c],l=f[1];if(o&&f[2]){if(a===X&&!(c in n))return!1}else{var s=new wr;if(e)var h=e(a,l,c,n,t,s);if(!(h===X?Se(l,a,hn|pn,e,s):h))return!1}}return!0}function Ue(n){return!(!fc(n)||Di(n))&&(uc(n)?kl:Zt).test(to(n))}function Be(n){return cc(n)&&we(n)==nt}function Te(n){return cc(n)&&zs(n)==tt;
}function $e(n){return cc(n)&&oc(n.length)&&!!Kr[we(n)]}function De(n){return"function"==typeof n?n:null==n?La:"object"==typeof n?bh(n)?Ze(n[0],n[1]):qe(n):Fa(n)}function Me(n){if(!Mi(n))return Vl(n);var t=[];for(var r in ll(n))bl.call(n,r)&&"constructor"!=r&&t.push(r);return t}function Fe(n){if(!fc(n))return Zi(n);var t=Mi(n),r=[];for(var e in n)("constructor"!=e||!t&&bl.call(n,e))&&r.push(e);return r}function Ne(n,t){return n<t}function Pe(n,t){var r=-1,e=Hf(n)?il(n.length):[];return ys(n,function(n,u,i){
e[++r]=t(n,u,i)}),e}function qe(n){var t=ji(n);return 1==t.length&&t[0][2]?Ni(t[0][0],t[0][1]):function(r){return r===n||Ce(r,n,t)}}function Ze(n,t){return Bi(n)&&Fi(t)?Ni(no(n),t):function(r){var e=Mc(r,n);return e===X&&e===t?Nc(r,n):Se(t,e,hn|pn)}}function Ke(n,t,r,e,u){n!==t&&bs(t,function(i,o){if(u||(u=new wr),fc(i))Ve(n,t,o,r,Ke,e,u);else{var f=e?e(Ji(n,o),i,o+"",n,t,u):X;f===X&&(f=i),Er(n,o,f)}},qc)}function Ve(n,t,r,e,u,i,o){var f=Ji(n,r),c=Ji(t,r),a=o.get(c);if(a)return Er(n,r,a),X;var l=i?i(f,c,r+"",n,t,o):X,s=l===X;
if(s){var h=bh(c),p=!h&&mh(c),_=!h&&!p&&Oh(c);l=c,h||p||_?bh(f)?l=f:Jf(f)?l=Tu(f):p?(s=!1,l=Iu(c,!0)):_?(s=!1,l=Wu(c,!0)):l=[]:gc(c)||dh(c)?(l=f,dh(f)?l=Rc(f):fc(f)&&!uc(f)||(l=Ei(c))):s=!1}s&&(o.set(c,l),u(l,c,e,i,o),o.delete(c)),Er(n,r,l)}function Ge(n,t){var r=n.length;if(r)return t+=t<0?r:0,Ci(t,r)?n[t]:X}function He(n,t,r){t=t.length?c(t,function(n){return bh(n)?function(t){return _e(t,1===n.length?n[0]:n)}:n}):[La];var e=-1;return t=c(t,z(mi())),A(Pe(n,function(n,r,u){return{criteria:c(t,function(t){
return t(n)}),index:++e,value:n}}),function(n,t){return Cu(n,t,r)})}function Je(n,t){return Ye(n,t,function(t,r){return Nc(n,r)})}function Ye(n,t,r){for(var e=-1,u=t.length,i={};++e<u;){var o=t[e],f=_e(n,o);r(f,o)&&fu(i,ku(o,n),f)}return i}function Qe(n){return function(t){return _e(t,n)}}function Xe(n,t,r,e){var u=e?d:y,i=-1,o=t.length,f=n;for(n===t&&(t=Tu(t)),r&&(f=c(n,z(r)));++i<o;)for(var a=0,l=t[i],s=r?r(l):l;(a=u(f,s,a,e))>-1;)f!==n&&Ll.call(f,a,1),Ll.call(n,a,1);return n}function nu(n,t){for(var r=n?t.length:0,e=r-1;r--;){
var u=t[r];if(r==e||u!==i){var i=u;Ci(u)?Ll.call(n,u,1):yu(n,u)}}return n}function tu(n,t){return n+Nl(Ql()*(t-n+1))}function ru(n,t,r,e){for(var u=-1,i=Gl(Fl((t-n)/(r||1)),0),o=il(i);i--;)o[e?i:++u]=n,n+=r;return o}function eu(n,t){var r="";if(!n||t<1||t>Wn)return r;do t%2&&(r+=n),t=Nl(t/2),t&&(n+=n);while(t);return r}function uu(n,t){return Ls(Vi(n,t,La),n+"")}function iu(n){return Ir(ra(n))}function ou(n,t){var r=ra(n);return Xi(r,Mr(t,0,r.length))}function fu(n,t,r,e){if(!fc(n))return n;t=ku(t,n);
for(var u=-1,i=t.length,o=i-1,f=n;null!=f&&++u<i;){var c=no(t[u]),a=r;if("__proto__"===c||"constructor"===c||"prototype"===c)return n;if(u!=o){var l=f[c];a=e?e(l,c,f):X,a===X&&(a=fc(l)?l:Ci(t[u+1])?[]:{})}Sr(f,c,a),f=f[c]}return n}function cu(n){return Xi(ra(n))}function au(n,t,r){var e=-1,u=n.length;t<0&&(t=-t>u?0:u+t),r=r>u?u:r,r<0&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0;for(var i=il(u);++e<u;)i[e]=n[e+t];return i}function lu(n,t){var r;return ys(n,function(n,e,u){return r=t(n,e,u),!r}),!!r}function su(n,t,r){
var e=0,u=null==n?e:n.length;if("number"==typeof t&&t===t&&u<=Tn){for(;e<u;){var i=e+u>>>1,o=n[i];null!==o&&!bc(o)&&(r?o<=t:o<t)?e=i+1:u=i}return u}return hu(n,t,La,r)}function hu(n,t,r,e){var u=0,i=null==n?0:n.length;if(0===i)return 0;t=r(t);for(var o=t!==t,f=null===t,c=bc(t),a=t===X;u<i;){var l=Nl((u+i)/2),s=r(n[l]),h=s!==X,p=null===s,_=s===s,v=bc(s);if(o)var g=e||_;else g=a?_&&(e||h):f?_&&h&&(e||!p):c?_&&h&&!p&&(e||!v):!p&&!v&&(e?s<=t:s<t);g?u=l+1:i=l}return Hl(i,Bn)}function pu(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){
var o=n[r],f=t?t(o):o;if(!r||!Gf(f,c)){var c=f;i[u++]=0===o?0:o}}return i}function _u(n){return"number"==typeof n?n:bc(n)?Cn:+n}function vu(n){if("string"==typeof n)return n;if(bh(n))return c(n,vu)+"";if(bc(n))return vs?vs.call(n):"";var t=n+"";return"0"==t&&1/n==-Sn?"-0":t}function gu(n,t,r){var e=-1,u=o,i=n.length,c=!0,a=[],l=a;if(r)c=!1,u=f;else if(i>=tn){var s=t?null:ks(n);if(s)return P(s);c=!1,u=S,l=new yr}else l=t?[]:a;n:for(;++e<i;){var h=n[e],p=t?t(h):h;if(h=r||0!==h?h:0,c&&p===p){for(var _=l.length;_--;)if(l[_]===p)continue n;
t&&l.push(p),a.push(h)}else u(l,p,r)||(l!==a&&l.push(p),a.push(h))}return a}function yu(n,t){return t=ku(t,n),n=Gi(n,t),null==n||delete n[no(jo(t))]}function du(n,t,r,e){return fu(n,t,r(_e(n,t)),e)}function bu(n,t,r,e){for(var u=n.length,i=e?u:-1;(e?i--:++i<u)&&t(n[i],i,n););return r?au(n,e?0:i,e?i+1:u):au(n,e?i+1:0,e?u:i)}function wu(n,t){var r=n;return r instanceof Ct&&(r=r.value()),l(t,function(n,t){return t.func.apply(t.thisArg,a([n],t.args))},r)}function mu(n,t,r){var e=n.length;if(e<2)return e?gu(n[0]):[];
for(var u=-1,i=il(e);++u<e;)for(var o=n[u],f=-1;++f<e;)f!=u&&(i[u]=Hr(i[u]||o,n[f],t,r));return gu(ee(i,1),t,r)}function xu(n,t,r){for(var e=-1,u=n.length,i=t.length,o={};++e<u;){r(o,n[e],e<i?t[e]:X)}return o}function ju(n){return Jf(n)?n:[]}function Au(n){return"function"==typeof n?n:La}function ku(n,t){return bh(n)?n:Bi(n,t)?[n]:Cs(Ec(n))}function Ou(n,t,r){var e=n.length;return r=r===X?e:r,!t&&r>=e?n:au(n,t,r)}function Iu(n,t){if(t)return n.slice();var r=n.length,e=zl?zl(r):new n.constructor(r);
return n.copy(e),e}function Ru(n){var t=new n.constructor(n.byteLength);return new Rl(t).set(new Rl(n)),t}function zu(n,t){return new n.constructor(t?Ru(n.buffer):n.buffer,n.byteOffset,n.byteLength)}function Eu(n){var t=new n.constructor(n.source,Nt.exec(n));return t.lastIndex=n.lastIndex,t}function Su(n){return _s?ll(_s.call(n)):{}}function Wu(n,t){return new n.constructor(t?Ru(n.buffer):n.buffer,n.byteOffset,n.length)}function Lu(n,t){if(n!==t){var r=n!==X,e=null===n,u=n===n,i=bc(n),o=t!==X,f=null===t,c=t===t,a=bc(t);
if(!f&&!a&&!i&&n>t||i&&o&&c&&!f&&!a||e&&o&&c||!r&&c||!u)return 1;if(!e&&!i&&!a&&n<t||a&&r&&u&&!e&&!i||f&&r&&u||!o&&u||!c)return-1}return 0}function Cu(n,t,r){for(var e=-1,u=n.criteria,i=t.criteria,o=u.length,f=r.length;++e<o;){var c=Lu(u[e],i[e]);if(c){if(e>=f)return c;return c*("desc"==r[e]?-1:1)}}return n.index-t.index}function Uu(n,t,r,e){for(var u=-1,i=n.length,o=r.length,f=-1,c=t.length,a=Gl(i-o,0),l=il(c+a),s=!e;++f<c;)l[f]=t[f];for(;++u<o;)(s||u<i)&&(l[r[u]]=n[u]);for(;a--;)l[f++]=n[u++];return l;
}function Bu(n,t,r,e){for(var u=-1,i=n.length,o=-1,f=r.length,c=-1,a=t.length,l=Gl(i-f,0),s=il(l+a),h=!e;++u<l;)s[u]=n[u];for(var p=u;++c<a;)s[p+c]=t[c];for(;++o<f;)(h||u<i)&&(s[p+r[o]]=n[u++]);return s}function Tu(n,t){var r=-1,e=n.length;for(t||(t=il(e));++r<e;)t[r]=n[r];return t}function $u(n,t,r,e){var u=!r;r||(r={});for(var i=-1,o=t.length;++i<o;){var f=t[i],c=e?e(r[f],n[f],f,r,n):X;c===X&&(c=n[f]),u?Br(r,f,c):Sr(r,f,c)}return r}function Du(n,t){return $u(n,Is(n),t)}function Mu(n,t){return $u(n,Rs(n),t);
}function Fu(n,r){return function(e,u){var i=bh(e)?t:Lr,o=r?r():{};return i(e,n,mi(u,2),o)}}function Nu(n){return uu(function(t,r){var e=-1,u=r.length,i=u>1?r[u-1]:X,o=u>2?r[2]:X;for(i=n.length>3&&"function"==typeof i?(u--,i):X,o&&Ui(r[0],r[1],o)&&(i=u<3?X:i,u=1),t=ll(t);++e<u;){var f=r[e];f&&n(t,f,e,i)}return t})}function Pu(n,t){return function(r,e){if(null==r)return r;if(!Hf(r))return n(r,e);for(var u=r.length,i=t?u:-1,o=ll(r);(t?i--:++i<u)&&e(o[i],i,o)!==!1;);return r}}function qu(n){return function(t,r,e){
for(var u=-1,i=ll(t),o=e(t),f=o.length;f--;){var c=o[n?f:++u];if(r(i[c],c,i)===!1)break}return t}}function Zu(n,t,r){function e(){return(this&&this!==re&&this instanceof e?i:n).apply(u?r:this,arguments)}var u=t&_n,i=Gu(n);return e}function Ku(n){return function(t){t=Ec(t);var r=T(t)?G(t):X,e=r?r[0]:t.charAt(0),u=r?Ou(r,1).join(""):t.slice(1);return e[n]()+u}}function Vu(n){return function(t){return l(Ra(ca(t).replace($r,"")),n,"")}}function Gu(n){return function(){var t=arguments;switch(t.length){
case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var r=gs(n.prototype),e=n.apply(r,t);return fc(e)?e:r}}function Hu(t,r,e){function u(){for(var o=arguments.length,f=il(o),c=o,a=wi(u);c--;)f[c]=arguments[c];var l=o<3&&f[0]!==a&&f[o-1]!==a?[]:N(f,a);
return o-=l.length,o<e?oi(t,r,Qu,u.placeholder,X,f,l,X,X,e-o):n(this&&this!==re&&this instanceof u?i:t,this,f)}var i=Gu(t);return u}function Ju(n){return function(t,r,e){var u=ll(t);if(!Hf(t)){var i=mi(r,3);t=Pc(t),r=function(n){return i(u[n],n,u)}}var o=n(t,r,e);return o>-1?u[i?t[o]:o]:X}}function Yu(n){return gi(function(t){var r=t.length,e=r,u=Y.prototype.thru;for(n&&t.reverse();e--;){var i=t[e];if("function"!=typeof i)throw new pl(en);if(u&&!o&&"wrapper"==bi(i))var o=new Y([],!0)}for(e=o?e:r;++e<r;){
i=t[e];var f=bi(i),c="wrapper"==f?Os(i):X;o=c&&$i(c[0])&&c[1]==(mn|yn|bn|xn)&&!c[4].length&&1==c[9]?o[bi(c[0])].apply(o,c[3]):1==i.length&&$i(i)?o[f]():o.thru(i)}return function(){var n=arguments,e=n[0];if(o&&1==n.length&&bh(e))return o.plant(e).value();for(var u=0,i=r?t[u].apply(this,n):e;++u<r;)i=t[u].call(this,i);return i}})}function Qu(n,t,r,e,u,i,o,f,c,a){function l(){for(var y=arguments.length,d=il(y),b=y;b--;)d[b]=arguments[b];if(_)var w=wi(l),m=C(d,w);if(e&&(d=Uu(d,e,u,_)),i&&(d=Bu(d,i,o,_)),
y-=m,_&&y<a){return oi(n,t,Qu,l.placeholder,r,d,N(d,w),f,c,a-y)}var x=h?r:this,j=p?x[n]:n;return y=d.length,f?d=Hi(d,f):v&&y>1&&d.reverse(),s&&c<y&&(d.length=c),this&&this!==re&&this instanceof l&&(j=g||Gu(j)),j.apply(x,d)}var s=t&mn,h=t&_n,p=t&vn,_=t&(yn|dn),v=t&jn,g=p?X:Gu(n);return l}function Xu(n,t){return function(r,e){return Oe(r,n,t(e),{})}}function ni(n,t){return function(r,e){var u;if(r===X&&e===X)return t;if(r!==X&&(u=r),e!==X){if(u===X)return e;"string"==typeof r||"string"==typeof e?(r=vu(r),
e=vu(e)):(r=_u(r),e=_u(e)),u=n(r,e)}return u}}function ti(t){return gi(function(r){return r=c(r,z(mi())),uu(function(e){var u=this;return t(r,function(t){return n(t,u,e)})})})}function ri(n,t){t=t===X?" ":vu(t);var r=t.length;if(r<2)return r?eu(t,n):t;var e=eu(t,Fl(n/V(t)));return T(t)?Ou(G(e),0,n).join(""):e.slice(0,n)}function ei(t,r,e,u){function i(){for(var r=-1,c=arguments.length,a=-1,l=u.length,s=il(l+c),h=this&&this!==re&&this instanceof i?f:t;++a<l;)s[a]=u[a];for(;c--;)s[a++]=arguments[++r];
return n(h,o?e:this,s)}var o=r&_n,f=Gu(t);return i}function ui(n){return function(t,r,e){return e&&"number"!=typeof e&&Ui(t,r,e)&&(r=e=X),t=Ac(t),r===X?(r=t,t=0):r=Ac(r),e=e===X?t<r?1:-1:Ac(e),ru(t,r,e,n)}}function ii(n){return function(t,r){return"string"==typeof t&&"string"==typeof r||(t=Ic(t),r=Ic(r)),n(t,r)}}function oi(n,t,r,e,u,i,o,f,c,a){var l=t&yn,s=l?o:X,h=l?X:o,p=l?i:X,_=l?X:i;t|=l?bn:wn,t&=~(l?wn:bn),t&gn||(t&=~(_n|vn));var v=[n,t,u,p,s,_,h,f,c,a],g=r.apply(X,v);return $i(n)&&Ss(g,v),g.placeholder=e,
Yi(g,n,t)}function fi(n){var t=al[n];return function(n,r){if(n=Ic(n),r=null==r?0:Hl(kc(r),292),r&&Zl(n)){var e=(Ec(n)+"e").split("e");return e=(Ec(t(e[0]+"e"+(+e[1]+r)))+"e").split("e"),+(e[0]+"e"+(+e[1]-r))}return t(n)}}function ci(n){return function(t){var r=zs(t);return r==Gn?M(t):r==tt?q(t):I(t,n(t))}}function ai(n,t,r,e,u,i,o,f){var c=t&vn;if(!c&&"function"!=typeof n)throw new pl(en);var a=e?e.length:0;if(a||(t&=~(bn|wn),e=u=X),o=o===X?o:Gl(kc(o),0),f=f===X?f:kc(f),a-=u?u.length:0,t&wn){var l=e,s=u;
e=u=X}var h=c?X:Os(n),p=[n,t,r,e,u,l,s,i,o,f];if(h&&qi(p,h),n=p[0],t=p[1],r=p[2],e=p[3],u=p[4],f=p[9]=p[9]===X?c?0:n.length:Gl(p[9]-a,0),!f&&t&(yn|dn)&&(t&=~(yn|dn)),t&&t!=_n)_=t==yn||t==dn?Hu(n,t,f):t!=bn&&t!=(_n|bn)||u.length?Qu.apply(X,p):ei(n,t,r,e);else var _=Zu(n,t,r);return Yi((h?ms:Ss)(_,p),n,t)}function li(n,t,r,e){return n===X||Gf(n,gl[r])&&!bl.call(e,r)?t:n}function si(n,t,r,e,u,i){return fc(n)&&fc(t)&&(i.set(t,n),Ke(n,t,X,si,i),i.delete(t)),n}function hi(n){return gc(n)?X:n}function pi(n,t,r,e,u,i){
var o=r&hn,f=n.length,c=t.length;if(f!=c&&!(o&&c>f))return!1;var a=i.get(n),l=i.get(t);if(a&&l)return a==t&&l==n;var s=-1,p=!0,_=r&pn?new yr:X;for(i.set(n,t),i.set(t,n);++s<f;){var v=n[s],g=t[s];if(e)var y=o?e(g,v,s,t,n,i):e(v,g,s,n,t,i);if(y!==X){if(y)continue;p=!1;break}if(_){if(!h(t,function(n,t){if(!S(_,t)&&(v===n||u(v,n,r,e,i)))return _.push(t)})){p=!1;break}}else if(v!==g&&!u(v,g,r,e,i)){p=!1;break}}return i.delete(n),i.delete(t),p}function _i(n,t,r,e,u,i,o){switch(r){case ct:if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)return!1;
n=n.buffer,t=t.buffer;case ft:return!(n.byteLength!=t.byteLength||!i(new Rl(n),new Rl(t)));case Nn:case Pn:case Hn:return Gf(+n,+t);case Zn:return n.name==t.name&&n.message==t.message;case nt:case rt:return n==t+"";case Gn:var f=M;case tt:var c=e&hn;if(f||(f=P),n.size!=t.size&&!c)return!1;var a=o.get(n);if(a)return a==t;e|=pn,o.set(n,t);var l=pi(f(n),f(t),e,u,i,o);return o.delete(n),l;case et:if(_s)return _s.call(n)==_s.call(t)}return!1}function vi(n,t,r,e,u,i){var o=r&hn,f=yi(n),c=f.length;if(c!=yi(t).length&&!o)return!1;
for(var a=c;a--;){var l=f[a];if(!(o?l in t:bl.call(t,l)))return!1}var s=i.get(n),h=i.get(t);if(s&&h)return s==t&&h==n;var p=!0;i.set(n,t),i.set(t,n);for(var _=o;++a<c;){l=f[a];var v=n[l],g=t[l];if(e)var y=o?e(g,v,l,t,n,i):e(v,g,l,n,t,i);if(!(y===X?v===g||u(v,g,r,e,i):y)){p=!1;break}_||(_="constructor"==l)}if(p&&!_){var d=n.constructor,b=t.constructor;d!=b&&"constructor"in n&&"constructor"in t&&!("function"==typeof d&&d instanceof d&&"function"==typeof b&&b instanceof b)&&(p=!1)}return i.delete(n),
i.delete(t),p}function gi(n){return Ls(Vi(n,X,_o),n+"")}function yi(n){return de(n,Pc,Is)}function di(n){return de(n,qc,Rs)}function bi(n){for(var t=n.name+"",r=fs[t],e=bl.call(fs,t)?r.length:0;e--;){var u=r[e],i=u.func;if(null==i||i==n)return u.name}return t}function wi(n){return(bl.call(Z,"placeholder")?Z:n).placeholder}function mi(){var n=Z.iteratee||Ca;return n=n===Ca?De:n,arguments.length?n(arguments[0],arguments[1]):n}function xi(n,t){var r=n.__data__;return Ti(t)?r["string"==typeof t?"string":"hash"]:r.map;
}function ji(n){for(var t=Pc(n),r=t.length;r--;){var e=t[r],u=n[e];t[r]=[e,u,Fi(u)]}return t}function Ai(n,t){var r=B(n,t);return Ue(r)?r:X}function ki(n){var t=bl.call(n,Bl),r=n[Bl];try{n[Bl]=X;var e=!0}catch(n){}var u=xl.call(n);return e&&(t?n[Bl]=r:delete n[Bl]),u}function Oi(n,t,r){for(var e=-1,u=r.length;++e<u;){var i=r[e],o=i.size;switch(i.type){case"drop":n+=o;break;case"dropRight":t-=o;break;case"take":t=Hl(t,n+o);break;case"takeRight":n=Gl(n,t-o)}}return{start:n,end:t}}function Ii(n){var t=n.match(Bt);
return t?t[1].split(Tt):[]}function Ri(n,t,r){t=ku(t,n);for(var e=-1,u=t.length,i=!1;++e<u;){var o=no(t[e]);if(!(i=null!=n&&r(n,o)))break;n=n[o]}return i||++e!=u?i:(u=null==n?0:n.length,!!u&&oc(u)&&Ci(o,u)&&(bh(n)||dh(n)))}function zi(n){var t=n.length,r=new n.constructor(t);return t&&"string"==typeof n[0]&&bl.call(n,"index")&&(r.index=n.index,r.input=n.input),r}function Ei(n){return"function"!=typeof n.constructor||Mi(n)?{}:gs(El(n))}function Si(n,t,r){var e=n.constructor;switch(t){case ft:return Ru(n);
case Nn:case Pn:return new e(+n);case ct:return zu(n,r);case at:case lt:case st:case ht:case pt:case _t:case vt:case gt:case yt:return Wu(n,r);case Gn:return new e;case Hn:case rt:return new e(n);case nt:return Eu(n);case tt:return new e;case et:return Su(n)}}function Wi(n,t){var r=t.length;if(!r)return n;var e=r-1;return t[e]=(r>1?"& ":"")+t[e],t=t.join(r>2?", ":" "),n.replace(Ut,"{\n/* [wrapped with "+t+"] */\n")}function Li(n){return bh(n)||dh(n)||!!(Cl&&n&&n[Cl])}function Ci(n,t){var r=typeof n;
return t=null==t?Wn:t,!!t&&("number"==r||"symbol"!=r&&Vt.test(n))&&n>-1&&n%1==0&&n<t}function Ui(n,t,r){if(!fc(r))return!1;var e=typeof t;return!!("number"==e?Hf(r)&&Ci(t,r.length):"string"==e&&t in r)&&Gf(r[t],n)}function Bi(n,t){if(bh(n))return!1;var r=typeof n;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=n&&!bc(n))||(zt.test(n)||!Rt.test(n)||null!=t&&n in ll(t))}function Ti(n){var t=typeof n;return"string"==t||"number"==t||"symbol"==t||"boolean"==t?"__proto__"!==n:null===n}function $i(n){
var t=bi(n),r=Z[t];if("function"!=typeof r||!(t in Ct.prototype))return!1;if(n===r)return!0;var e=Os(r);return!!e&&n===e[0]}function Di(n){return!!ml&&ml in n}function Mi(n){var t=n&&n.constructor;return n===("function"==typeof t&&t.prototype||gl)}function Fi(n){return n===n&&!fc(n)}function Ni(n,t){return function(r){return null!=r&&(r[n]===t&&(t!==X||n in ll(r)))}}function Pi(n){var t=Cf(n,function(n){return r.size===fn&&r.clear(),n}),r=t.cache;return t}function qi(n,t){var r=n[1],e=t[1],u=r|e,i=u<(_n|vn|mn),o=e==mn&&r==yn||e==mn&&r==xn&&n[7].length<=t[8]||e==(mn|xn)&&t[7].length<=t[8]&&r==yn;
if(!i&&!o)return n;e&_n&&(n[2]=t[2],u|=r&_n?0:gn);var f=t[3];if(f){var c=n[3];n[3]=c?Uu(c,f,t[4]):f,n[4]=c?N(n[3],cn):t[4]}return f=t[5],f&&(c=n[5],n[5]=c?Bu(c,f,t[6]):f,n[6]=c?N(n[5],cn):t[6]),f=t[7],f&&(n[7]=f),e&mn&&(n[8]=null==n[8]?t[8]:Hl(n[8],t[8])),null==n[9]&&(n[9]=t[9]),n[0]=t[0],n[1]=u,n}function Zi(n){var t=[];if(null!=n)for(var r in ll(n))t.push(r);return t}function Ki(n){return xl.call(n)}function Vi(t,r,e){return r=Gl(r===X?t.length-1:r,0),function(){for(var u=arguments,i=-1,o=Gl(u.length-r,0),f=il(o);++i<o;)f[i]=u[r+i];
i=-1;for(var c=il(r+1);++i<r;)c[i]=u[i];return c[r]=e(f),n(t,this,c)}}function Gi(n,t){return t.length<2?n:_e(n,au(t,0,-1))}function Hi(n,t){for(var r=n.length,e=Hl(t.length,r),u=Tu(n);e--;){var i=t[e];n[e]=Ci(i,r)?u[i]:X}return n}function Ji(n,t){if(("constructor"!==t||"function"!=typeof n[t])&&"__proto__"!=t)return n[t]}function Yi(n,t,r){var e=t+"";return Ls(n,Wi(e,ro(Ii(e),r)))}function Qi(n){var t=0,r=0;return function(){var e=Jl(),u=In-(e-r);if(r=e,u>0){if(++t>=On)return arguments[0]}else t=0;
return n.apply(X,arguments)}}function Xi(n,t){var r=-1,e=n.length,u=e-1;for(t=t===X?e:t;++r<t;){var i=tu(r,u),o=n[i];n[i]=n[r],n[r]=o}return n.length=t,n}function no(n){if("string"==typeof n||bc(n))return n;var t=n+"";return"0"==t&&1/n==-Sn?"-0":t}function to(n){if(null!=n){try{return dl.call(n)}catch(n){}try{return n+""}catch(n){}}return""}function ro(n,t){return r($n,function(r){var e="_."+r[0];t&r[1]&&!o(n,e)&&n.push(e)}),n.sort()}function eo(n){if(n instanceof Ct)return n.clone();var t=new Y(n.__wrapped__,n.__chain__);
return t.__actions__=Tu(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function uo(n,t,r){t=(r?Ui(n,t,r):t===X)?1:Gl(kc(t),0);var e=null==n?0:n.length;if(!e||t<1)return[];for(var u=0,i=0,o=il(Fl(e/t));u<e;)o[i++]=au(n,u,u+=t);return o}function io(n){for(var t=-1,r=null==n?0:n.length,e=0,u=[];++t<r;){var i=n[t];i&&(u[e++]=i)}return u}function oo(){var n=arguments.length;if(!n)return[];for(var t=il(n-1),r=arguments[0],e=n;e--;)t[e-1]=arguments[e];return a(bh(r)?Tu(r):[r],ee(t,1));
}function fo(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===X?1:kc(t),au(n,t<0?0:t,e)):[]}function co(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===X?1:kc(t),t=e-t,au(n,0,t<0?0:t)):[]}function ao(n,t){return n&&n.length?bu(n,mi(t,3),!0,!0):[]}function lo(n,t){return n&&n.length?bu(n,mi(t,3),!0):[]}function so(n,t,r,e){var u=null==n?0:n.length;return u?(r&&"number"!=typeof r&&Ui(n,t,r)&&(r=0,e=u),ne(n,t,r,e)):[]}function ho(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=null==r?0:kc(r);
return u<0&&(u=Gl(e+u,0)),g(n,mi(t,3),u)}function po(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e-1;return r!==X&&(u=kc(r),u=r<0?Gl(e+u,0):Hl(u,e-1)),g(n,mi(t,3),u,!0)}function _o(n){return(null==n?0:n.length)?ee(n,1):[]}function vo(n){return(null==n?0:n.length)?ee(n,Sn):[]}function go(n,t){return(null==n?0:n.length)?(t=t===X?1:kc(t),ee(n,t)):[]}function yo(n){for(var t=-1,r=null==n?0:n.length,e={};++t<r;){var u=n[t];e[u[0]]=u[1]}return e}function bo(n){return n&&n.length?n[0]:X}function wo(n,t,r){
var e=null==n?0:n.length;if(!e)return-1;var u=null==r?0:kc(r);return u<0&&(u=Gl(e+u,0)),y(n,t,u)}function mo(n){return(null==n?0:n.length)?au(n,0,-1):[]}function xo(n,t){return null==n?"":Kl.call(n,t)}function jo(n){var t=null==n?0:n.length;return t?n[t-1]:X}function Ao(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e;return r!==X&&(u=kc(r),u=u<0?Gl(e+u,0):Hl(u,e-1)),t===t?K(n,t,u):g(n,b,u,!0)}function ko(n,t){return n&&n.length?Ge(n,kc(t)):X}function Oo(n,t){return n&&n.length&&t&&t.length?Xe(n,t):n;
}function Io(n,t,r){return n&&n.length&&t&&t.length?Xe(n,t,mi(r,2)):n}function Ro(n,t,r){return n&&n.length&&t&&t.length?Xe(n,t,X,r):n}function zo(n,t){var r=[];if(!n||!n.length)return r;var e=-1,u=[],i=n.length;for(t=mi(t,3);++e<i;){var o=n[e];t(o,e,n)&&(r.push(o),u.push(e))}return nu(n,u),r}function Eo(n){return null==n?n:Xl.call(n)}function So(n,t,r){var e=null==n?0:n.length;return e?(r&&"number"!=typeof r&&Ui(n,t,r)?(t=0,r=e):(t=null==t?0:kc(t),r=r===X?e:kc(r)),au(n,t,r)):[]}function Wo(n,t){
return su(n,t)}function Lo(n,t,r){return hu(n,t,mi(r,2))}function Co(n,t){var r=null==n?0:n.length;if(r){var e=su(n,t);if(e<r&&Gf(n[e],t))return e}return-1}function Uo(n,t){return su(n,t,!0)}function Bo(n,t,r){return hu(n,t,mi(r,2),!0)}function To(n,t){if(null==n?0:n.length){var r=su(n,t,!0)-1;if(Gf(n[r],t))return r}return-1}function $o(n){return n&&n.length?pu(n):[]}function Do(n,t){return n&&n.length?pu(n,mi(t,2)):[]}function Mo(n){var t=null==n?0:n.length;return t?au(n,1,t):[]}function Fo(n,t,r){
return n&&n.length?(t=r||t===X?1:kc(t),au(n,0,t<0?0:t)):[]}function No(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===X?1:kc(t),t=e-t,au(n,t<0?0:t,e)):[]}function Po(n,t){return n&&n.length?bu(n,mi(t,3),!1,!0):[]}function qo(n,t){return n&&n.length?bu(n,mi(t,3)):[]}function Zo(n){return n&&n.length?gu(n):[]}function Ko(n,t){return n&&n.length?gu(n,mi(t,2)):[]}function Vo(n,t){return t="function"==typeof t?t:X,n&&n.length?gu(n,X,t):[]}function Go(n){if(!n||!n.length)return[];var t=0;return n=i(n,function(n){
if(Jf(n))return t=Gl(n.length,t),!0}),O(t,function(t){return c(n,m(t))})}function Ho(t,r){if(!t||!t.length)return[];var e=Go(t);return null==r?e:c(e,function(t){return n(r,X,t)})}function Jo(n,t){return xu(n||[],t||[],Sr)}function Yo(n,t){return xu(n||[],t||[],fu)}function Qo(n){var t=Z(n);return t.__chain__=!0,t}function Xo(n,t){return t(n),n}function nf(n,t){return t(n)}function tf(){return Qo(this)}function rf(){return new Y(this.value(),this.__chain__)}function ef(){this.__values__===X&&(this.__values__=jc(this.value()));
var n=this.__index__>=this.__values__.length;return{done:n,value:n?X:this.__values__[this.__index__++]}}function uf(){return this}function of(n){for(var t,r=this;r instanceof J;){var e=eo(r);e.__index__=0,e.__values__=X,t?u.__wrapped__=e:t=e;var u=e;r=r.__wrapped__}return u.__wrapped__=n,t}function ff(){var n=this.__wrapped__;if(n instanceof Ct){var t=n;return this.__actions__.length&&(t=new Ct(this)),t=t.reverse(),t.__actions__.push({func:nf,args:[Eo],thisArg:X}),new Y(t,this.__chain__)}return this.thru(Eo);
}function cf(){return wu(this.__wrapped__,this.__actions__)}function af(n,t,r){var e=bh(n)?u:Jr;return r&&Ui(n,t,r)&&(t=X),e(n,mi(t,3))}function lf(n,t){return(bh(n)?i:te)(n,mi(t,3))}function sf(n,t){return ee(yf(n,t),1)}function hf(n,t){return ee(yf(n,t),Sn)}function pf(n,t,r){return r=r===X?1:kc(r),ee(yf(n,t),r)}function _f(n,t){return(bh(n)?r:ys)(n,mi(t,3))}function vf(n,t){return(bh(n)?e:ds)(n,mi(t,3))}function gf(n,t,r,e){n=Hf(n)?n:ra(n),r=r&&!e?kc(r):0;var u=n.length;return r<0&&(r=Gl(u+r,0)),
dc(n)?r<=u&&n.indexOf(t,r)>-1:!!u&&y(n,t,r)>-1}function yf(n,t){return(bh(n)?c:Pe)(n,mi(t,3))}function df(n,t,r,e){return null==n?[]:(bh(t)||(t=null==t?[]:[t]),r=e?X:r,bh(r)||(r=null==r?[]:[r]),He(n,t,r))}function bf(n,t,r){var e=bh(n)?l:j,u=arguments.length<3;return e(n,mi(t,4),r,u,ys)}function wf(n,t,r){var e=bh(n)?s:j,u=arguments.length<3;return e(n,mi(t,4),r,u,ds)}function mf(n,t){return(bh(n)?i:te)(n,Uf(mi(t,3)))}function xf(n){return(bh(n)?Ir:iu)(n)}function jf(n,t,r){return t=(r?Ui(n,t,r):t===X)?1:kc(t),
(bh(n)?Rr:ou)(n,t)}function Af(n){return(bh(n)?zr:cu)(n)}function kf(n){if(null==n)return 0;if(Hf(n))return dc(n)?V(n):n.length;var t=zs(n);return t==Gn||t==tt?n.size:Me(n).length}function Of(n,t,r){var e=bh(n)?h:lu;return r&&Ui(n,t,r)&&(t=X),e(n,mi(t,3))}function If(n,t){if("function"!=typeof t)throw new pl(en);return n=kc(n),function(){if(--n<1)return t.apply(this,arguments)}}function Rf(n,t,r){return t=r?X:t,t=n&&null==t?n.length:t,ai(n,mn,X,X,X,X,t)}function zf(n,t){var r;if("function"!=typeof t)throw new pl(en);
return n=kc(n),function(){return--n>0&&(r=t.apply(this,arguments)),n<=1&&(t=X),r}}function Ef(n,t,r){t=r?X:t;var e=ai(n,yn,X,X,X,X,X,t);return e.placeholder=Ef.placeholder,e}function Sf(n,t,r){t=r?X:t;var e=ai(n,dn,X,X,X,X,X,t);return e.placeholder=Sf.placeholder,e}function Wf(n,t,r){function e(t){var r=h,e=p;return h=p=X,d=t,v=n.apply(e,r)}function u(n){return d=n,g=Ws(f,t),b?e(n):v}function i(n){var r=n-y,e=n-d,u=t-r;return w?Hl(u,_-e):u}function o(n){var r=n-y,e=n-d;return y===X||r>=t||r<0||w&&e>=_;
}function f(){var n=fh();return o(n)?c(n):(g=Ws(f,i(n)),X)}function c(n){return g=X,m&&h?e(n):(h=p=X,v)}function a(){g!==X&&As(g),d=0,h=y=p=g=X}function l(){return g===X?v:c(fh())}function s(){var n=fh(),r=o(n);if(h=arguments,p=this,y=n,r){if(g===X)return u(y);if(w)return As(g),g=Ws(f,t),e(y)}return g===X&&(g=Ws(f,t)),v}var h,p,_,v,g,y,d=0,b=!1,w=!1,m=!0;if("function"!=typeof n)throw new pl(en);return t=Ic(t)||0,fc(r)&&(b=!!r.leading,w="maxWait"in r,_=w?Gl(Ic(r.maxWait)||0,t):_,m="trailing"in r?!!r.trailing:m),
s.cancel=a,s.flush=l,s}function Lf(n){return ai(n,jn)}function Cf(n,t){if("function"!=typeof n||null!=t&&"function"!=typeof t)throw new pl(en);var r=function(){var e=arguments,u=t?t.apply(this,e):e[0],i=r.cache;if(i.has(u))return i.get(u);var o=n.apply(this,e);return r.cache=i.set(u,o)||i,o};return r.cache=new(Cf.Cache||sr),r}function Uf(n){if("function"!=typeof n)throw new pl(en);return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:
return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function Bf(n){return zf(2,n)}function Tf(n,t){if("function"!=typeof n)throw new pl(en);return t=t===X?t:kc(t),uu(n,t)}function $f(t,r){if("function"!=typeof t)throw new pl(en);return r=null==r?0:Gl(kc(r),0),uu(function(e){var u=e[r],i=Ou(e,0,r);return u&&a(i,u),n(t,this,i)})}function Df(n,t,r){var e=!0,u=!0;if("function"!=typeof n)throw new pl(en);return fc(r)&&(e="leading"in r?!!r.leading:e,u="trailing"in r?!!r.trailing:u),
Wf(n,t,{leading:e,maxWait:t,trailing:u})}function Mf(n){return Rf(n,1)}function Ff(n,t){return ph(Au(t),n)}function Nf(){if(!arguments.length)return[];var n=arguments[0];return bh(n)?n:[n]}function Pf(n){return Fr(n,sn)}function qf(n,t){return t="function"==typeof t?t:X,Fr(n,sn,t)}function Zf(n){return Fr(n,an|sn)}function Kf(n,t){return t="function"==typeof t?t:X,Fr(n,an|sn,t)}function Vf(n,t){return null==t||Pr(n,t,Pc(t))}function Gf(n,t){return n===t||n!==n&&t!==t}function Hf(n){return null!=n&&oc(n.length)&&!uc(n);
}function Jf(n){return cc(n)&&Hf(n)}function Yf(n){return n===!0||n===!1||cc(n)&&we(n)==Nn}function Qf(n){return cc(n)&&1===n.nodeType&&!gc(n)}function Xf(n){if(null==n)return!0;if(Hf(n)&&(bh(n)||"string"==typeof n||"function"==typeof n.splice||mh(n)||Oh(n)||dh(n)))return!n.length;var t=zs(n);if(t==Gn||t==tt)return!n.size;if(Mi(n))return!Me(n).length;for(var r in n)if(bl.call(n,r))return!1;return!0}function nc(n,t){return Se(n,t)}function tc(n,t,r){r="function"==typeof r?r:X;var e=r?r(n,t):X;return e===X?Se(n,t,X,r):!!e;
}function rc(n){if(!cc(n))return!1;var t=we(n);return t==Zn||t==qn||"string"==typeof n.message&&"string"==typeof n.name&&!gc(n)}function ec(n){return"number"==typeof n&&Zl(n)}function uc(n){if(!fc(n))return!1;var t=we(n);return t==Kn||t==Vn||t==Fn||t==Xn}function ic(n){return"number"==typeof n&&n==kc(n)}function oc(n){return"number"==typeof n&&n>-1&&n%1==0&&n<=Wn}function fc(n){var t=typeof n;return null!=n&&("object"==t||"function"==t)}function cc(n){return null!=n&&"object"==typeof n}function ac(n,t){
return n===t||Ce(n,t,ji(t))}function lc(n,t,r){return r="function"==typeof r?r:X,Ce(n,t,ji(t),r)}function sc(n){return vc(n)&&n!=+n}function hc(n){if(Es(n))throw new fl(rn);return Ue(n)}function pc(n){return null===n}function _c(n){return null==n}function vc(n){return"number"==typeof n||cc(n)&&we(n)==Hn}function gc(n){if(!cc(n)||we(n)!=Yn)return!1;var t=El(n);if(null===t)return!0;var r=bl.call(t,"constructor")&&t.constructor;return"function"==typeof r&&r instanceof r&&dl.call(r)==jl}function yc(n){
return ic(n)&&n>=-Wn&&n<=Wn}function dc(n){return"string"==typeof n||!bh(n)&&cc(n)&&we(n)==rt}function bc(n){return"symbol"==typeof n||cc(n)&&we(n)==et}function wc(n){return n===X}function mc(n){return cc(n)&&zs(n)==it}function xc(n){return cc(n)&&we(n)==ot}function jc(n){if(!n)return[];if(Hf(n))return dc(n)?G(n):Tu(n);if(Ul&&n[Ul])return D(n[Ul]());var t=zs(n);return(t==Gn?M:t==tt?P:ra)(n)}function Ac(n){if(!n)return 0===n?n:0;if(n=Ic(n),n===Sn||n===-Sn){return(n<0?-1:1)*Ln}return n===n?n:0}function kc(n){
var t=Ac(n),r=t%1;return t===t?r?t-r:t:0}function Oc(n){return n?Mr(kc(n),0,Un):0}function Ic(n){if("number"==typeof n)return n;if(bc(n))return Cn;if(fc(n)){var t="function"==typeof n.valueOf?n.valueOf():n;n=fc(t)?t+"":t}if("string"!=typeof n)return 0===n?n:+n;n=R(n);var r=qt.test(n);return r||Kt.test(n)?Xr(n.slice(2),r?2:8):Pt.test(n)?Cn:+n}function Rc(n){return $u(n,qc(n))}function zc(n){return n?Mr(kc(n),-Wn,Wn):0===n?n:0}function Ec(n){return null==n?"":vu(n)}function Sc(n,t){var r=gs(n);return null==t?r:Cr(r,t);
}function Wc(n,t){return v(n,mi(t,3),ue)}function Lc(n,t){return v(n,mi(t,3),oe)}function Cc(n,t){return null==n?n:bs(n,mi(t,3),qc)}function Uc(n,t){return null==n?n:ws(n,mi(t,3),qc)}function Bc(n,t){return n&&ue(n,mi(t,3))}function Tc(n,t){return n&&oe(n,mi(t,3))}function $c(n){return null==n?[]:fe(n,Pc(n))}function Dc(n){return null==n?[]:fe(n,qc(n))}function Mc(n,t,r){var e=null==n?X:_e(n,t);return e===X?r:e}function Fc(n,t){return null!=n&&Ri(n,t,xe)}function Nc(n,t){return null!=n&&Ri(n,t,je);
}function Pc(n){return Hf(n)?Or(n):Me(n)}function qc(n){return Hf(n)?Or(n,!0):Fe(n)}function Zc(n,t){var r={};return t=mi(t,3),ue(n,function(n,e,u){Br(r,t(n,e,u),n)}),r}function Kc(n,t){var r={};return t=mi(t,3),ue(n,function(n,e,u){Br(r,e,t(n,e,u))}),r}function Vc(n,t){return Gc(n,Uf(mi(t)))}function Gc(n,t){if(null==n)return{};var r=c(di(n),function(n){return[n]});return t=mi(t),Ye(n,r,function(n,r){return t(n,r[0])})}function Hc(n,t,r){t=ku(t,n);var e=-1,u=t.length;for(u||(u=1,n=X);++e<u;){var i=null==n?X:n[no(t[e])];
i===X&&(e=u,i=r),n=uc(i)?i.call(n):i}return n}function Jc(n,t,r){return null==n?n:fu(n,t,r)}function Yc(n,t,r,e){return e="function"==typeof e?e:X,null==n?n:fu(n,t,r,e)}function Qc(n,t,e){var u=bh(n),i=u||mh(n)||Oh(n);if(t=mi(t,4),null==e){var o=n&&n.constructor;e=i?u?new o:[]:fc(n)&&uc(o)?gs(El(n)):{}}return(i?r:ue)(n,function(n,r,u){return t(e,n,r,u)}),e}function Xc(n,t){return null==n||yu(n,t)}function na(n,t,r){return null==n?n:du(n,t,Au(r))}function ta(n,t,r,e){return e="function"==typeof e?e:X,
null==n?n:du(n,t,Au(r),e)}function ra(n){return null==n?[]:E(n,Pc(n))}function ea(n){return null==n?[]:E(n,qc(n))}function ua(n,t,r){return r===X&&(r=t,t=X),r!==X&&(r=Ic(r),r=r===r?r:0),t!==X&&(t=Ic(t),t=t===t?t:0),Mr(Ic(n),t,r)}function ia(n,t,r){return t=Ac(t),r===X?(r=t,t=0):r=Ac(r),n=Ic(n),Ae(n,t,r)}function oa(n,t,r){if(r&&"boolean"!=typeof r&&Ui(n,t,r)&&(t=r=X),r===X&&("boolean"==typeof t?(r=t,t=X):"boolean"==typeof n&&(r=n,n=X)),n===X&&t===X?(n=0,t=1):(n=Ac(n),t===X?(t=n,n=0):t=Ac(t)),n>t){
var e=n;n=t,t=e}if(r||n%1||t%1){var u=Ql();return Hl(n+u*(t-n+Qr("1e-"+((u+"").length-1))),t)}return tu(n,t)}function fa(n){return Qh(Ec(n).toLowerCase())}function ca(n){return n=Ec(n),n&&n.replace(Gt,ve).replace(Dr,"")}function aa(n,t,r){n=Ec(n),t=vu(t);var e=n.length;r=r===X?e:Mr(kc(r),0,e);var u=r;return r-=t.length,r>=0&&n.slice(r,u)==t}function la(n){return n=Ec(n),n&&At.test(n)?n.replace(xt,ge):n}function sa(n){return n=Ec(n),n&&Wt.test(n)?n.replace(St,"\\$&"):n}function ha(n,t,r){n=Ec(n),t=kc(t);
var e=t?V(n):0;if(!t||e>=t)return n;var u=(t-e)/2;return ri(Nl(u),r)+n+ri(Fl(u),r)}function pa(n,t,r){n=Ec(n),t=kc(t);var e=t?V(n):0;return t&&e<t?n+ri(t-e,r):n}function _a(n,t,r){n=Ec(n),t=kc(t);var e=t?V(n):0;return t&&e<t?ri(t-e,r)+n:n}function va(n,t,r){return r||null==t?t=0:t&&(t=+t),Yl(Ec(n).replace(Lt,""),t||0)}function ga(n,t,r){return t=(r?Ui(n,t,r):t===X)?1:kc(t),eu(Ec(n),t)}function ya(){var n=arguments,t=Ec(n[0]);return n.length<3?t:t.replace(n[1],n[2])}function da(n,t,r){return r&&"number"!=typeof r&&Ui(n,t,r)&&(t=r=X),
(r=r===X?Un:r>>>0)?(n=Ec(n),n&&("string"==typeof t||null!=t&&!Ah(t))&&(t=vu(t),!t&&T(n))?Ou(G(n),0,r):n.split(t,r)):[]}function ba(n,t,r){return n=Ec(n),r=null==r?0:Mr(kc(r),0,n.length),t=vu(t),n.slice(r,r+t.length)==t}function wa(n,t,r){var e=Z.templateSettings;r&&Ui(n,t,r)&&(t=X),n=Ec(n),t=Sh({},t,e,li);var u,i,o=Sh({},t.imports,e.imports,li),f=Pc(o),c=E(o,f),a=0,l=t.interpolate||Ht,s="__p += '",h=sl((t.escape||Ht).source+"|"+l.source+"|"+(l===It?Ft:Ht).source+"|"+(t.evaluate||Ht).source+"|$","g"),p="//# sourceURL="+(bl.call(t,"sourceURL")?(t.sourceURL+"").replace(/\s/g," "):"lodash.templateSources["+ ++Zr+"]")+"\n";
n.replace(h,function(t,r,e,o,f,c){return e||(e=o),s+=n.slice(a,c).replace(Jt,U),r&&(u=!0,s+="' +\n__e("+r+") +\n'"),f&&(i=!0,s+="';\n"+f+";\n__p += '"),e&&(s+="' +\n((__t = ("+e+")) == null ? '' : __t) +\n'"),a=c+t.length,t}),s+="';\n";var _=bl.call(t,"variable")&&t.variable;if(_){if(Dt.test(_))throw new fl(un)}else s="with (obj) {\n"+s+"\n}\n";s=(i?s.replace(dt,""):s).replace(bt,"$1").replace(wt,"$1;"),s="function("+(_||"obj")+") {\n"+(_?"":"obj || (obj = {});\n")+"var __t, __p = ''"+(u?", __e = _.escape":"")+(i?", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n":";\n")+s+"return __p\n}";
var v=Xh(function(){return cl(f,p+"return "+s).apply(X,c)});if(v.source=s,rc(v))throw v;return v}function ma(n){return Ec(n).toLowerCase()}function xa(n){return Ec(n).toUpperCase()}function ja(n,t,r){if(n=Ec(n),n&&(r||t===X))return R(n);if(!n||!(t=vu(t)))return n;var e=G(n),u=G(t);return Ou(e,W(e,u),L(e,u)+1).join("")}function Aa(n,t,r){if(n=Ec(n),n&&(r||t===X))return n.slice(0,H(n)+1);if(!n||!(t=vu(t)))return n;var e=G(n);return Ou(e,0,L(e,G(t))+1).join("")}function ka(n,t,r){if(n=Ec(n),n&&(r||t===X))return n.replace(Lt,"");
if(!n||!(t=vu(t)))return n;var e=G(n);return Ou(e,W(e,G(t))).join("")}function Oa(n,t){var r=An,e=kn;if(fc(t)){var u="separator"in t?t.separator:u;r="length"in t?kc(t.length):r,e="omission"in t?vu(t.omission):e}n=Ec(n);var i=n.length;if(T(n)){var o=G(n);i=o.length}if(r>=i)return n;var f=r-V(e);if(f<1)return e;var c=o?Ou(o,0,f).join(""):n.slice(0,f);if(u===X)return c+e;if(o&&(f+=c.length-f),Ah(u)){if(n.slice(f).search(u)){var a,l=c;for(u.global||(u=sl(u.source,Ec(Nt.exec(u))+"g")),u.lastIndex=0;a=u.exec(l);)var s=a.index;
c=c.slice(0,s===X?f:s)}}else if(n.indexOf(vu(u),f)!=f){var h=c.lastIndexOf(u);h>-1&&(c=c.slice(0,h))}return c+e}function Ia(n){return n=Ec(n),n&&jt.test(n)?n.replace(mt,ye):n}function Ra(n,t,r){return n=Ec(n),t=r?X:t,t===X?$(n)?Q(n):_(n):n.match(t)||[]}function za(t){var r=null==t?0:t.length,e=mi();return t=r?c(t,function(n){if("function"!=typeof n[1])throw new pl(en);return[e(n[0]),n[1]]}):[],uu(function(e){for(var u=-1;++u<r;){var i=t[u];if(n(i[0],this,e))return n(i[1],this,e)}})}function Ea(n){
return Nr(Fr(n,an))}function Sa(n){return function(){return n}}function Wa(n,t){return null==n||n!==n?t:n}function La(n){return n}function Ca(n){return De("function"==typeof n?n:Fr(n,an))}function Ua(n){return qe(Fr(n,an))}function Ba(n,t){return Ze(n,Fr(t,an))}function Ta(n,t,e){var u=Pc(t),i=fe(t,u);null!=e||fc(t)&&(i.length||!u.length)||(e=t,t=n,n=this,i=fe(t,Pc(t)));var o=!(fc(e)&&"chain"in e&&!e.chain),f=uc(n);return r(i,function(r){var e=t[r];n[r]=e,f&&(n.prototype[r]=function(){var t=this.__chain__;
if(o||t){var r=n(this.__wrapped__);return(r.__actions__=Tu(this.__actions__)).push({func:e,args:arguments,thisArg:n}),r.__chain__=t,r}return e.apply(n,a([this.value()],arguments))})}),n}function $a(){return re._===this&&(re._=Al),this}function Da(){}function Ma(n){return n=kc(n),uu(function(t){return Ge(t,n)})}function Fa(n){return Bi(n)?m(no(n)):Qe(n)}function Na(n){return function(t){return null==n?X:_e(n,t)}}function Pa(){return[]}function qa(){return!1}function Za(){return{}}function Ka(){return"";
}function Va(){return!0}function Ga(n,t){if(n=kc(n),n<1||n>Wn)return[];var r=Un,e=Hl(n,Un);t=mi(t),n-=Un;for(var u=O(e,t);++r<n;)t(r);return u}function Ha(n){return bh(n)?c(n,no):bc(n)?[n]:Tu(Cs(Ec(n)))}function Ja(n){var t=++wl;return Ec(n)+t}function Ya(n){return n&&n.length?Yr(n,La,me):X}function Qa(n,t){return n&&n.length?Yr(n,mi(t,2),me):X}function Xa(n){return w(n,La)}function nl(n,t){return w(n,mi(t,2))}function tl(n){return n&&n.length?Yr(n,La,Ne):X}function rl(n,t){return n&&n.length?Yr(n,mi(t,2),Ne):X;
}function el(n){return n&&n.length?k(n,La):0}function ul(n,t){return n&&n.length?k(n,mi(t,2)):0}x=null==x?re:be.defaults(re.Object(),x,be.pick(re,qr));var il=x.Array,ol=x.Date,fl=x.Error,cl=x.Function,al=x.Math,ll=x.Object,sl=x.RegExp,hl=x.String,pl=x.TypeError,_l=il.prototype,vl=cl.prototype,gl=ll.prototype,yl=x["__core-js_shared__"],dl=vl.toString,bl=gl.hasOwnProperty,wl=0,ml=function(){var n=/[^.]+$/.exec(yl&&yl.keys&&yl.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),xl=gl.toString,jl=dl.call(ll),Al=re._,kl=sl("^"+dl.call(bl).replace(St,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Ol=ie?x.Buffer:X,Il=x.Symbol,Rl=x.Uint8Array,zl=Ol?Ol.allocUnsafe:X,El=F(ll.getPrototypeOf,ll),Sl=ll.create,Wl=gl.propertyIsEnumerable,Ll=_l.splice,Cl=Il?Il.isConcatSpreadable:X,Ul=Il?Il.iterator:X,Bl=Il?Il.toStringTag:X,Tl=function(){
try{var n=Ai(ll,"defineProperty");return n({},"",{}),n}catch(n){}}(),$l=x.clearTimeout!==re.clearTimeout&&x.clearTimeout,Dl=ol&&ol.now!==re.Date.now&&ol.now,Ml=x.setTimeout!==re.setTimeout&&x.setTimeout,Fl=al.ceil,Nl=al.floor,Pl=ll.getOwnPropertySymbols,ql=Ol?Ol.isBuffer:X,Zl=x.isFinite,Kl=_l.join,Vl=F(ll.keys,ll),Gl=al.max,Hl=al.min,Jl=ol.now,Yl=x.parseInt,Ql=al.random,Xl=_l.reverse,ns=Ai(x,"DataView"),ts=Ai(x,"Map"),rs=Ai(x,"Promise"),es=Ai(x,"Set"),us=Ai(x,"WeakMap"),is=Ai(ll,"create"),os=us&&new us,fs={},cs=to(ns),as=to(ts),ls=to(rs),ss=to(es),hs=to(us),ps=Il?Il.prototype:X,_s=ps?ps.valueOf:X,vs=ps?ps.toString:X,gs=function(){
function n(){}return function(t){if(!fc(t))return{};if(Sl)return Sl(t);n.prototype=t;var r=new n;return n.prototype=X,r}}();Z.templateSettings={escape:kt,evaluate:Ot,interpolate:It,variable:"",imports:{_:Z}},Z.prototype=J.prototype,Z.prototype.constructor=Z,Y.prototype=gs(J.prototype),Y.prototype.constructor=Y,Ct.prototype=gs(J.prototype),Ct.prototype.constructor=Ct,Xt.prototype.clear=nr,Xt.prototype.delete=tr,Xt.prototype.get=rr,Xt.prototype.has=er,Xt.prototype.set=ur,ir.prototype.clear=or,ir.prototype.delete=fr,
ir.prototype.get=cr,ir.prototype.has=ar,ir.prototype.set=lr,sr.prototype.clear=hr,sr.prototype.delete=pr,sr.prototype.get=_r,sr.prototype.has=vr,sr.prototype.set=gr,yr.prototype.add=yr.prototype.push=dr,yr.prototype.has=br,wr.prototype.clear=mr,wr.prototype.delete=xr,wr.prototype.get=jr,wr.prototype.has=Ar,wr.prototype.set=kr;var ys=Pu(ue),ds=Pu(oe,!0),bs=qu(),ws=qu(!0),ms=os?function(n,t){return os.set(n,t),n}:La,xs=Tl?function(n,t){return Tl(n,"toString",{configurable:!0,enumerable:!1,value:Sa(t),
writable:!0})}:La,js=uu,As=$l||function(n){return re.clearTimeout(n)},ks=es&&1/P(new es([,-0]))[1]==Sn?function(n){return new es(n)}:Da,Os=os?function(n){return os.get(n)}:Da,Is=Pl?function(n){return null==n?[]:(n=ll(n),i(Pl(n),function(t){return Wl.call(n,t)}))}:Pa,Rs=Pl?function(n){for(var t=[];n;)a(t,Is(n)),n=El(n);return t}:Pa,zs=we;(ns&&zs(new ns(new ArrayBuffer(1)))!=ct||ts&&zs(new ts)!=Gn||rs&&zs(rs.resolve())!=Qn||es&&zs(new es)!=tt||us&&zs(new us)!=it)&&(zs=function(n){var t=we(n),r=t==Yn?n.constructor:X,e=r?to(r):"";
if(e)switch(e){case cs:return ct;case as:return Gn;case ls:return Qn;case ss:return tt;case hs:return it}return t});var Es=yl?uc:qa,Ss=Qi(ms),Ws=Ml||function(n,t){return re.setTimeout(n,t)},Ls=Qi(xs),Cs=Pi(function(n){var t=[];return 46===n.charCodeAt(0)&&t.push(""),n.replace(Et,function(n,r,e,u){t.push(e?u.replace(Mt,"$1"):r||n)}),t}),Us=uu(function(n,t){return Jf(n)?Hr(n,ee(t,1,Jf,!0)):[]}),Bs=uu(function(n,t){var r=jo(t);return Jf(r)&&(r=X),Jf(n)?Hr(n,ee(t,1,Jf,!0),mi(r,2)):[]}),Ts=uu(function(n,t){
var r=jo(t);return Jf(r)&&(r=X),Jf(n)?Hr(n,ee(t,1,Jf,!0),X,r):[]}),$s=uu(function(n){var t=c(n,ju);return t.length&&t[0]===n[0]?ke(t):[]}),Ds=uu(function(n){var t=jo(n),r=c(n,ju);return t===jo(r)?t=X:r.pop(),r.length&&r[0]===n[0]?ke(r,mi(t,2)):[]}),Ms=uu(function(n){var t=jo(n),r=c(n,ju);return t="function"==typeof t?t:X,t&&r.pop(),r.length&&r[0]===n[0]?ke(r,X,t):[]}),Fs=uu(Oo),Ns=gi(function(n,t){var r=null==n?0:n.length,e=Tr(n,t);return nu(n,c(t,function(n){return Ci(n,r)?+n:n}).sort(Lu)),e}),Ps=uu(function(n){
return gu(ee(n,1,Jf,!0))}),qs=uu(function(n){var t=jo(n);return Jf(t)&&(t=X),gu(ee(n,1,Jf,!0),mi(t,2))}),Zs=uu(function(n){var t=jo(n);return t="function"==typeof t?t:X,gu(ee(n,1,Jf,!0),X,t)}),Ks=uu(function(n,t){return Jf(n)?Hr(n,t):[]}),Vs=uu(function(n){return mu(i(n,Jf))}),Gs=uu(function(n){var t=jo(n);return Jf(t)&&(t=X),mu(i(n,Jf),mi(t,2))}),Hs=uu(function(n){var t=jo(n);return t="function"==typeof t?t:X,mu(i(n,Jf),X,t)}),Js=uu(Go),Ys=uu(function(n){var t=n.length,r=t>1?n[t-1]:X;return r="function"==typeof r?(n.pop(),
r):X,Ho(n,r)}),Qs=gi(function(n){var t=n.length,r=t?n[0]:0,e=this.__wrapped__,u=function(t){return Tr(t,n)};return!(t>1||this.__actions__.length)&&e instanceof Ct&&Ci(r)?(e=e.slice(r,+r+(t?1:0)),e.__actions__.push({func:nf,args:[u],thisArg:X}),new Y(e,this.__chain__).thru(function(n){return t&&!n.length&&n.push(X),n})):this.thru(u)}),Xs=Fu(function(n,t,r){bl.call(n,r)?++n[r]:Br(n,r,1)}),nh=Ju(ho),th=Ju(po),rh=Fu(function(n,t,r){bl.call(n,r)?n[r].push(t):Br(n,r,[t])}),eh=uu(function(t,r,e){var u=-1,i="function"==typeof r,o=Hf(t)?il(t.length):[];
return ys(t,function(t){o[++u]=i?n(r,t,e):Ie(t,r,e)}),o}),uh=Fu(function(n,t,r){Br(n,r,t)}),ih=Fu(function(n,t,r){n[r?0:1].push(t)},function(){return[[],[]]}),oh=uu(function(n,t){if(null==n)return[];var r=t.length;return r>1&&Ui(n,t[0],t[1])?t=[]:r>2&&Ui(t[0],t[1],t[2])&&(t=[t[0]]),He(n,ee(t,1),[])}),fh=Dl||function(){return re.Date.now()},ch=uu(function(n,t,r){var e=_n;if(r.length){var u=N(r,wi(ch));e|=bn}return ai(n,e,t,r,u)}),ah=uu(function(n,t,r){var e=_n|vn;if(r.length){var u=N(r,wi(ah));e|=bn;
}return ai(t,e,n,r,u)}),lh=uu(function(n,t){return Gr(n,1,t)}),sh=uu(function(n,t,r){return Gr(n,Ic(t)||0,r)});Cf.Cache=sr;var hh=js(function(t,r){r=1==r.length&&bh(r[0])?c(r[0],z(mi())):c(ee(r,1),z(mi()));var e=r.length;return uu(function(u){for(var i=-1,o=Hl(u.length,e);++i<o;)u[i]=r[i].call(this,u[i]);return n(t,this,u)})}),ph=uu(function(n,t){return ai(n,bn,X,t,N(t,wi(ph)))}),_h=uu(function(n,t){return ai(n,wn,X,t,N(t,wi(_h)))}),vh=gi(function(n,t){return ai(n,xn,X,X,X,t)}),gh=ii(me),yh=ii(function(n,t){
return n>=t}),dh=Re(function(){return arguments}())?Re:function(n){return cc(n)&&bl.call(n,"callee")&&!Wl.call(n,"callee")},bh=il.isArray,wh=ce?z(ce):ze,mh=ql||qa,xh=ae?z(ae):Ee,jh=le?z(le):Le,Ah=se?z(se):Be,kh=he?z(he):Te,Oh=pe?z(pe):$e,Ih=ii(Ne),Rh=ii(function(n,t){return n<=t}),zh=Nu(function(n,t){if(Mi(t)||Hf(t))return $u(t,Pc(t),n),X;for(var r in t)bl.call(t,r)&&Sr(n,r,t[r])}),Eh=Nu(function(n,t){$u(t,qc(t),n)}),Sh=Nu(function(n,t,r,e){$u(t,qc(t),n,e)}),Wh=Nu(function(n,t,r,e){$u(t,Pc(t),n,e);
}),Lh=gi(Tr),Ch=uu(function(n,t){n=ll(n);var r=-1,e=t.length,u=e>2?t[2]:X;for(u&&Ui(t[0],t[1],u)&&(e=1);++r<e;)for(var i=t[r],o=qc(i),f=-1,c=o.length;++f<c;){var a=o[f],l=n[a];(l===X||Gf(l,gl[a])&&!bl.call(n,a))&&(n[a]=i[a])}return n}),Uh=uu(function(t){return t.push(X,si),n(Mh,X,t)}),Bh=Xu(function(n,t,r){null!=t&&"function"!=typeof t.toString&&(t=xl.call(t)),n[t]=r},Sa(La)),Th=Xu(function(n,t,r){null!=t&&"function"!=typeof t.toString&&(t=xl.call(t)),bl.call(n,t)?n[t].push(r):n[t]=[r]},mi),$h=uu(Ie),Dh=Nu(function(n,t,r){
Ke(n,t,r)}),Mh=Nu(function(n,t,r,e){Ke(n,t,r,e)}),Fh=gi(function(n,t){var r={};if(null==n)return r;var e=!1;t=c(t,function(t){return t=ku(t,n),e||(e=t.length>1),t}),$u(n,di(n),r),e&&(r=Fr(r,an|ln|sn,hi));for(var u=t.length;u--;)yu(r,t[u]);return r}),Nh=gi(function(n,t){return null==n?{}:Je(n,t)}),Ph=ci(Pc),qh=ci(qc),Zh=Vu(function(n,t,r){return t=t.toLowerCase(),n+(r?fa(t):t)}),Kh=Vu(function(n,t,r){return n+(r?"-":"")+t.toLowerCase()}),Vh=Vu(function(n,t,r){return n+(r?" ":"")+t.toLowerCase()}),Gh=Ku("toLowerCase"),Hh=Vu(function(n,t,r){
return n+(r?"_":"")+t.toLowerCase()}),Jh=Vu(function(n,t,r){return n+(r?" ":"")+Qh(t)}),Yh=Vu(function(n,t,r){return n+(r?" ":"")+t.toUpperCase()}),Qh=Ku("toUpperCase"),Xh=uu(function(t,r){try{return n(t,X,r)}catch(n){return rc(n)?n:new fl(n)}}),np=gi(function(n,t){return r(t,function(t){t=no(t),Br(n,t,ch(n[t],n))}),n}),tp=Yu(),rp=Yu(!0),ep=uu(function(n,t){return function(r){return Ie(r,n,t)}}),up=uu(function(n,t){return function(r){return Ie(n,r,t)}}),ip=ti(c),op=ti(u),fp=ti(h),cp=ui(),ap=ui(!0),lp=ni(function(n,t){
return n+t},0),sp=fi("ceil"),hp=ni(function(n,t){return n/t},1),pp=fi("floor"),_p=ni(function(n,t){return n*t},1),vp=fi("round"),gp=ni(function(n,t){return n-t},0);return Z.after=If,Z.ary=Rf,Z.assign=zh,Z.assignIn=Eh,Z.assignInWith=Sh,Z.assignWith=Wh,Z.at=Lh,Z.before=zf,Z.bind=ch,Z.bindAll=np,Z.bindKey=ah,Z.castArray=Nf,Z.chain=Qo,Z.chunk=uo,Z.compact=io,Z.concat=oo,Z.cond=za,Z.conforms=Ea,Z.constant=Sa,Z.countBy=Xs,Z.create=Sc,Z.curry=Ef,Z.curryRight=Sf,Z.debounce=Wf,Z.defaults=Ch,Z.defaultsDeep=Uh,
Z.defer=lh,Z.delay=sh,Z.difference=Us,Z.differenceBy=Bs,Z.differenceWith=Ts,Z.drop=fo,Z.dropRight=co,Z.dropRightWhile=ao,Z.dropWhile=lo,Z.fill=so,Z.filter=lf,Z.flatMap=sf,Z.flatMapDeep=hf,Z.flatMapDepth=pf,Z.flatten=_o,Z.flattenDeep=vo,Z.flattenDepth=go,Z.flip=Lf,Z.flow=tp,Z.flowRight=rp,Z.fromPairs=yo,Z.functions=$c,Z.functionsIn=Dc,Z.groupBy=rh,Z.initial=mo,Z.intersection=$s,Z.intersectionBy=Ds,Z.intersectionWith=Ms,Z.invert=Bh,Z.invertBy=Th,Z.invokeMap=eh,Z.iteratee=Ca,Z.keyBy=uh,Z.keys=Pc,Z.keysIn=qc,
Z.map=yf,Z.mapKeys=Zc,Z.mapValues=Kc,Z.matches=Ua,Z.matchesProperty=Ba,Z.memoize=Cf,Z.merge=Dh,Z.mergeWith=Mh,Z.method=ep,Z.methodOf=up,Z.mixin=Ta,Z.negate=Uf,Z.nthArg=Ma,Z.omit=Fh,Z.omitBy=Vc,Z.once=Bf,Z.orderBy=df,Z.over=ip,Z.overArgs=hh,Z.overEvery=op,Z.overSome=fp,Z.partial=ph,Z.partialRight=_h,Z.partition=ih,Z.pick=Nh,Z.pickBy=Gc,Z.property=Fa,Z.propertyOf=Na,Z.pull=Fs,Z.pullAll=Oo,Z.pullAllBy=Io,Z.pullAllWith=Ro,Z.pullAt=Ns,Z.range=cp,Z.rangeRight=ap,Z.rearg=vh,Z.reject=mf,Z.remove=zo,Z.rest=Tf,
Z.reverse=Eo,Z.sampleSize=jf,Z.set=Jc,Z.setWith=Yc,Z.shuffle=Af,Z.slice=So,Z.sortBy=oh,Z.sortedUniq=$o,Z.sortedUniqBy=Do,Z.split=da,Z.spread=$f,Z.tail=Mo,Z.take=Fo,Z.takeRight=No,Z.takeRightWhile=Po,Z.takeWhile=qo,Z.tap=Xo,Z.throttle=Df,Z.thru=nf,Z.toArray=jc,Z.toPairs=Ph,Z.toPairsIn=qh,Z.toPath=Ha,Z.toPlainObject=Rc,Z.transform=Qc,Z.unary=Mf,Z.union=Ps,Z.unionBy=qs,Z.unionWith=Zs,Z.uniq=Zo,Z.uniqBy=Ko,Z.uniqWith=Vo,Z.unset=Xc,Z.unzip=Go,Z.unzipWith=Ho,Z.update=na,Z.updateWith=ta,Z.values=ra,Z.valuesIn=ea,
Z.without=Ks,Z.words=Ra,Z.wrap=Ff,Z.xor=Vs,Z.xorBy=Gs,Z.xorWith=Hs,Z.zip=Js,Z.zipObject=Jo,Z.zipObjectDeep=Yo,Z.zipWith=Ys,Z.entries=Ph,Z.entriesIn=qh,Z.extend=Eh,Z.extendWith=Sh,Ta(Z,Z),Z.add=lp,Z.attempt=Xh,Z.camelCase=Zh,Z.capitalize=fa,Z.ceil=sp,Z.clamp=ua,Z.clone=Pf,Z.cloneDeep=Zf,Z.cloneDeepWith=Kf,Z.cloneWith=qf,Z.conformsTo=Vf,Z.deburr=ca,Z.defaultTo=Wa,Z.divide=hp,Z.endsWith=aa,Z.eq=Gf,Z.escape=la,Z.escapeRegExp=sa,Z.every=af,Z.find=nh,Z.findIndex=ho,Z.findKey=Wc,Z.findLast=th,Z.findLastIndex=po,
Z.findLastKey=Lc,Z.floor=pp,Z.forEach=_f,Z.forEachRight=vf,Z.forIn=Cc,Z.forInRight=Uc,Z.forOwn=Bc,Z.forOwnRight=Tc,Z.get=Mc,Z.gt=gh,Z.gte=yh,Z.has=Fc,Z.hasIn=Nc,Z.head=bo,Z.identity=La,Z.includes=gf,Z.indexOf=wo,Z.inRange=ia,Z.invoke=$h,Z.isArguments=dh,Z.isArray=bh,Z.isArrayBuffer=wh,Z.isArrayLike=Hf,Z.isArrayLikeObject=Jf,Z.isBoolean=Yf,Z.isBuffer=mh,Z.isDate=xh,Z.isElement=Qf,Z.isEmpty=Xf,Z.isEqual=nc,Z.isEqualWith=tc,Z.isError=rc,Z.isFinite=ec,Z.isFunction=uc,Z.isInteger=ic,Z.isLength=oc,Z.isMap=jh,
Z.isMatch=ac,Z.isMatchWith=lc,Z.isNaN=sc,Z.isNative=hc,Z.isNil=_c,Z.isNull=pc,Z.isNumber=vc,Z.isObject=fc,Z.isObjectLike=cc,Z.isPlainObject=gc,Z.isRegExp=Ah,Z.isSafeInteger=yc,Z.isSet=kh,Z.isString=dc,Z.isSymbol=bc,Z.isTypedArray=Oh,Z.isUndefined=wc,Z.isWeakMap=mc,Z.isWeakSet=xc,Z.join=xo,Z.kebabCase=Kh,Z.last=jo,Z.lastIndexOf=Ao,Z.lowerCase=Vh,Z.lowerFirst=Gh,Z.lt=Ih,Z.lte=Rh,Z.max=Ya,Z.maxBy=Qa,Z.mean=Xa,Z.meanBy=nl,Z.min=tl,Z.minBy=rl,Z.stubArray=Pa,Z.stubFalse=qa,Z.stubObject=Za,Z.stubString=Ka,
Z.stubTrue=Va,Z.multiply=_p,Z.nth=ko,Z.noConflict=$a,Z.noop=Da,Z.now=fh,Z.pad=ha,Z.padEnd=pa,Z.padStart=_a,Z.parseInt=va,Z.random=oa,Z.reduce=bf,Z.reduceRight=wf,Z.repeat=ga,Z.replace=ya,Z.result=Hc,Z.round=vp,Z.runInContext=p,Z.sample=xf,Z.size=kf,Z.snakeCase=Hh,Z.some=Of,Z.sortedIndex=Wo,Z.sortedIndexBy=Lo,Z.sortedIndexOf=Co,Z.sortedLastIndex=Uo,Z.sortedLastIndexBy=Bo,Z.sortedLastIndexOf=To,Z.startCase=Jh,Z.startsWith=ba,Z.subtract=gp,Z.sum=el,Z.sumBy=ul,Z.template=wa,Z.times=Ga,Z.toFinite=Ac,Z.toInteger=kc,
Z.toLength=Oc,Z.toLower=ma,Z.toNumber=Ic,Z.toSafeInteger=zc,Z.toString=Ec,Z.toUpper=xa,Z.trim=ja,Z.trimEnd=Aa,Z.trimStart=ka,Z.truncate=Oa,Z.unescape=Ia,Z.uniqueId=Ja,Z.upperCase=Yh,Z.upperFirst=Qh,Z.each=_f,Z.eachRight=vf,Z.first=bo,Ta(Z,function(){var n={};return ue(Z,function(t,r){bl.call(Z.prototype,r)||(n[r]=t)}),n}(),{chain:!1}),Z.VERSION=nn,r(["bind","bindKey","curry","curryRight","partial","partialRight"],function(n){Z[n].placeholder=Z}),r(["drop","take"],function(n,t){Ct.prototype[n]=function(r){
r=r===X?1:Gl(kc(r),0);var e=this.__filtered__&&!t?new Ct(this):this.clone();return e.__filtered__?e.__takeCount__=Hl(r,e.__takeCount__):e.__views__.push({size:Hl(r,Un),type:n+(e.__dir__<0?"Right":"")}),e},Ct.prototype[n+"Right"]=function(t){return this.reverse()[n](t).reverse()}}),r(["filter","map","takeWhile"],function(n,t){var r=t+1,e=r==Rn||r==En;Ct.prototype[n]=function(n){var t=this.clone();return t.__iteratees__.push({iteratee:mi(n,3),type:r}),t.__filtered__=t.__filtered__||e,t}}),r(["head","last"],function(n,t){
var r="take"+(t?"Right":"");Ct.prototype[n]=function(){return this[r](1).value()[0]}}),r(["initial","tail"],function(n,t){var r="drop"+(t?"":"Right");Ct.prototype[n]=function(){return this.__filtered__?new Ct(this):this[r](1)}}),Ct.prototype.compact=function(){return this.filter(La)},Ct.prototype.find=function(n){return this.filter(n).head()},Ct.prototype.findLast=function(n){return this.reverse().find(n)},Ct.prototype.invokeMap=uu(function(n,t){return"function"==typeof n?new Ct(this):this.map(function(r){
return Ie(r,n,t)})}),Ct.prototype.reject=function(n){return this.filter(Uf(mi(n)))},Ct.prototype.slice=function(n,t){n=kc(n);var r=this;return r.__filtered__&&(n>0||t<0)?new Ct(r):(n<0?r=r.takeRight(-n):n&&(r=r.drop(n)),t!==X&&(t=kc(t),r=t<0?r.dropRight(-t):r.take(t-n)),r)},Ct.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},Ct.prototype.toArray=function(){return this.take(Un)},ue(Ct.prototype,function(n,t){var r=/^(?:filter|find|map|reject)|While$/.test(t),e=/^(?:head|last)$/.test(t),u=Z[e?"take"+("last"==t?"Right":""):t],i=e||/^find/.test(t);
u&&(Z.prototype[t]=function(){var t=this.__wrapped__,o=e?[1]:arguments,f=t instanceof Ct,c=o[0],l=f||bh(t),s=function(n){var t=u.apply(Z,a([n],o));return e&&h?t[0]:t};l&&r&&"function"==typeof c&&1!=c.length&&(f=l=!1);var h=this.__chain__,p=!!this.__actions__.length,_=i&&!h,v=f&&!p;if(!i&&l){t=v?t:new Ct(this);var g=n.apply(t,o);return g.__actions__.push({func:nf,args:[s],thisArg:X}),new Y(g,h)}return _&&v?n.apply(this,o):(g=this.thru(s),_?e?g.value()[0]:g.value():g)})}),r(["pop","push","shift","sort","splice","unshift"],function(n){
var t=_l[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|shift)$/.test(n);Z.prototype[n]=function(){var n=arguments;if(e&&!this.__chain__){var u=this.value();return t.apply(bh(u)?u:[],n)}return this[r](function(r){return t.apply(bh(r)?r:[],n)})}}),ue(Ct.prototype,function(n,t){var r=Z[t];if(r){var e=r.name+"";bl.call(fs,e)||(fs[e]=[]),fs[e].push({name:t,func:r})}}),fs[Qu(X,vn).name]=[{name:"wrapper",func:X}],Ct.prototype.clone=$t,Ct.prototype.reverse=Yt,Ct.prototype.value=Qt,Z.prototype.at=Qs,
Z.prototype.chain=tf,Z.prototype.commit=rf,Z.prototype.next=ef,Z.prototype.plant=of,Z.prototype.reverse=ff,Z.prototype.toJSON=Z.prototype.valueOf=Z.prototype.value=cf,Z.prototype.first=Z.prototype.head,Ul&&(Z.prototype[Ul]=uf),Z},be=de(); true?(re._=be,!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return be}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))):0}).call(this);

/***/ }),

/***/ 46580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);

/* harmony default export */ __webpack_exports__["Z"] = ((0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    t: function (k) { return (Array.isArray(k) ? k[0] : k); },
    lang: '',
}));


/***/ }),

/***/ 68378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ appWithI18n; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(21395);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/_context.js
var _context = __webpack_require__(46580);
;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/transCore.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function splitNsKey(key, nsSeparator) {
    if (!nsSeparator)
        return { i18nKey: key };
    var i = key.indexOf(nsSeparator);
    if (i < 0)
        return { i18nKey: key };
    return {
        namespace: key.slice(0, i),
        i18nKey: key.slice(i + nsSeparator.length),
    };
}
function transCore(_a) {
    var config = _a.config, allNamespaces = _a.allNamespaces, pluralRules = _a.pluralRules, lang = _a.lang;
    var _b = config.logger, logger = _b === void 0 ? missingKeyLogger : _b;
    var t = function (key, query, options) {
        var _a;
        if (key === void 0) { key = ''; }
        var k = Array.isArray(key) ? key[0] : key;
        var _b = config.nsSeparator, nsSeparator = _b === void 0 ? ':' : _b, _c = config.loggerEnvironment, loggerEnvironment = _c === void 0 ? 'browser' : _c;
        var _d = splitNsKey(k, nsSeparator), i18nKey = _d.i18nKey, _e = _d.namespace, namespace = _e === void 0 ? (_a = options === null || options === void 0 ? void 0 : options.ns) !== null && _a !== void 0 ? _a : config.defaultNS : _e;
        var dic = (namespace && allNamespaces[namespace]) || {};
        var keyWithPlural = plural(pluralRules, dic, i18nKey, config, query);
        var value = getDicValue(dic, keyWithPlural, config, options);
        var empty = typeof value === 'undefined' ||
            (typeof value === 'object' && !Object.keys(value).length);
        var fallbacks = typeof (options === null || options === void 0 ? void 0 : options.fallback) === 'string'
            ? [options.fallback]
            : (options === null || options === void 0 ? void 0 : options.fallback) || [];
        if (empty &&
            (loggerEnvironment === 'both' ||
                loggerEnvironment ===
                    (typeof window === 'undefined' ? 'node' : 'browser'))) {
            logger({ namespace: namespace, i18nKey: i18nKey });
        }
        if (empty && Array.isArray(fallbacks) && fallbacks.length) {
            var firstFallback = fallbacks[0], restFallbacks = fallbacks.slice(1);
            if (typeof firstFallback === 'string') {
                return t(firstFallback, query, __assign(__assign({}, options), { fallback: restFallbacks }));
            }
        }
        if (empty && (options === null || options === void 0 ? void 0 : options.default) && (fallbacks === null || fallbacks === void 0 ? void 0 : fallbacks.length) == 0) {
            return interpolation({ text: options === null || options === void 0 ? void 0 : options.default, query: query, config: config, lang: lang });
        }
        if (empty) {
            return k;
        }
        if (value instanceof Object) {
            return objectInterpolation({
                obj: value,
                query: query,
                config: config,
                lang: lang,
            });
        }
        return interpolation({ text: value, query: query, config: config, lang: lang });
    };
    return t;
}
function getDicValue(dic, key, config, options) {
    if (key === void 0) { key = ''; }
    if (options === void 0) { options = {
        returnObjects: false,
    }; }
    var _a = (config || {}).keySeparator, keySeparator = _a === void 0 ? '.' : _a;
    var keyParts = keySeparator ? key.split(keySeparator) : [key];
    var value = keyParts.reduce(function (val, key) {
        if (typeof val === 'string') {
            return {};
        }
        var res = val[key];
        return res || (typeof res === 'string' ? res : {});
    }, dic);
    if (typeof value === 'string' ||
        (value instanceof Object && options.returnObjects)) {
        return value;
    }
    return undefined;
}
function plural(pluralRules, dic, key, config, query) {
    if (!query || typeof query.count !== 'number')
        return key;
    var numKey = "".concat(key, "_").concat(query.count);
    if (getDicValue(dic, numKey, config) !== undefined)
        return numKey;
    var pluralKey = "".concat(key, "_").concat(pluralRules.select(query.count));
    if (getDicValue(dic, pluralKey, config) !== undefined) {
        return pluralKey;
    }
    var nestedNumKey = "".concat(key, ".").concat(query.count);
    if (getDicValue(dic, nestedNumKey, config) !== undefined)
        return nestedNumKey;
    var nestedKey = "".concat(key, ".").concat(pluralRules.select(query.count));
    if (getDicValue(dic, nestedKey, config) !== undefined)
        return nestedKey;
    return key;
}
function interpolation(_a) {
    var text = _a.text, query = _a.query, config = _a.config, lang = _a.lang;
    if (!text || !query)
        return text || '';
    var escapeRegex = function (str) {
        return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    };
    var _b = config.interpolation || {}, _c = _b.format, format = _c === void 0 ? null : _c, _d = _b.prefix, prefix = _d === void 0 ? '{{' : _d, _e = _b.suffix, suffix = _e === void 0 ? '}}' : _e;
    var regexEnd = suffix === '' ? '' : "(?:[\\s,]+([\\w-]*))?\\s*".concat(escapeRegex(suffix));
    return Object.keys(query).reduce(function (all, varKey) {
        var regex = new RegExp("".concat(escapeRegex(prefix), "\\s*").concat(varKey).concat(regexEnd), 'gm');
        return all.replace(regex, function (_match, $1) {
            return $1 && format
                ? format(query[varKey], $1, lang)
                : query[varKey];
        });
    }, text);
}
function objectInterpolation(_a) {
    var obj = _a.obj, query = _a.query, config = _a.config, lang = _a.lang;
    if (!query || Object.keys(query).length === 0)
        return obj;
    Object.keys(obj).forEach(function (key) {
        if (obj[key] instanceof Object)
            objectInterpolation({
                obj: obj[key],
                query: query,
                config: config,
                lang: lang,
            });
        if (typeof obj[key] === 'string')
            obj[key] = interpolation({
                text: obj[key],
                query: query,
                config: config,
                lang: lang,
            });
    });
    return obj;
}
function missingKeyLogger(_a) {
    var namespace = _a.namespace, i18nKey = _a.i18nKey;
    if (true)
        return;
    if (!namespace) {
        console.warn("[next-translate] The text \"".concat(i18nKey, "\" has no namespace in front of it."));
        return;
    }
    console.warn("[next-translate] \"".concat(namespace, ":").concat(i18nKey, "\" is missing in current namespace configuration. Try adding \"").concat(i18nKey, "\" to the namespace \"").concat(namespace, "\"."));
}

// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/I18nProvider.js
var I18nProvider_assign = (undefined && undefined.__assign) || function () {
    I18nProvider_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return I18nProvider_assign.apply(this, arguments);
};





var InternalContext = (0,react.createContext)({ ns: {}, config: {} });
function I18nProvider(_a) {
    var lng = _a.lang, _b = _a.namespaces, namespaces = _b === void 0 ? {} : _b, children = _a.children, _c = _a.config, newConfig = _c === void 0 ? {} : _c;
    var parentLang = (0,useTranslation/* default */.Z)().lang;
    var _d = (0,router.useRouter)() || {}, locale = _d.locale, defaultLocale = _d.defaultLocale;
    var internal = (0,react.useContext)(InternalContext);
    var allNamespaces = I18nProvider_assign(I18nProvider_assign({}, internal.ns), namespaces);
    var lang = lng || parentLang || locale || defaultLocale || '';
    var config = I18nProvider_assign(I18nProvider_assign({}, internal.config), newConfig);
    var localesToIgnore = config.localesToIgnore || ['default'];
    var ignoreLang = localesToIgnore.includes(lang);
    var pluralRules = new Intl.PluralRules(ignoreLang ? undefined : lang);
    var t = transCore({ config: config, allNamespaces: allNamespaces, pluralRules: pluralRules, lang: lang });
    return (react.createElement(_context/* default.Provider */.Z.Provider, { value: { lang: lang, t: t } },
        react.createElement(InternalContext.Provider, { value: { ns: allNamespaces, config: config } }, children)));
}

;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/getConfig.js
function getConfig() {
    var g = typeof window === 'undefined' ? __webpack_require__.g : window;
    return g.i18nConfig;
}

;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/getPageNamespaces.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function flat(a) {
    return a.reduce(function (b, c) { return b.concat(c); }, []);
}
function getPageNamespaces(_a, page, ctx) {
    var _b = _a.pages, pages = _b === void 0 ? {} : _b;
    return __awaiter(this, void 0, void 0, function () {
        var rgx, getNs, rgxs, _c, _d, _e, _f;
        var _this = this;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    rgx = 'rgx:';
                    getNs = function (ns) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2, typeof ns === 'function' ? ns(ctx) : ns || []];
                    }); }); };
                    rgxs = Object.keys(pages).reduce(function (arr, p) {
                        if (p.substring(0, rgx.length) === rgx &&
                            new RegExp(p.replace(rgx, '')).test(page)) {
                            arr.push(getNs(pages[p]));
                        }
                        return arr;
                    }, []);
                    _c = [[]];
                    return [4, getNs(pages['*'])];
                case 1:
                    _d = [__spreadArray.apply(void 0, _c.concat([(_g.sent()), true]))];
                    return [4, getNs(pages[page])];
                case 2:
                    _e = [__spreadArray.apply(void 0, _d.concat([(_g.sent()), true]))];
                    _f = flat;
                    return [4, Promise.all(rgxs)];
                case 3: return [2, __spreadArray.apply(void 0, _e.concat([_f.apply(void 0, [_g.sent()]), true]))];
            }
        });
    });
}

;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/loadNamespaces.js
/* provided dependency */ var process = __webpack_require__(47859);
var loadNamespaces_assign = (undefined && undefined.__assign) || function () {
    loadNamespaces_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return loadNamespaces_assign.apply(this, arguments);
};
var loadNamespaces_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var loadNamespaces_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var colorEnabled = process.env.NODE_DISABLE_COLORS == null &&
    process.env.NO_COLOR == null &&
    process.env.TERM !== 'dumb' &&
    process.env.FORCE_COLOR !== '0';
function loadNamespaces(config) {
    var _a, _b;
    if (config === void 0) { config = {}; }
    return loadNamespaces_awaiter(this, void 0, void 0, function () {
        var conf, localesToIgnore, __lang, page, namespaces, defaultLoader, pageNamespaces, color;
        return loadNamespaces_generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    conf = loadNamespaces_assign(loadNamespaces_assign({}, getConfig()), config);
                    localesToIgnore = conf.localesToIgnore || ['default'];
                    __lang = ((_a = conf.req) === null || _a === void 0 ? void 0 : _a.locale) ||
                        conf.locale ||
                        ((_b = conf.router) === null || _b === void 0 ? void 0 : _b.locale) ||
                        conf.defaultLocale ||
                        '';
                    if (!conf.pathname) {
                        console.warn('🚨 [next-translate] You forgot to pass the "pathname" inside "loadNamespaces" configuration');
                        return [2, { __lang: __lang }];
                    }
                    if (localesToIgnore.includes(__lang))
                        return [2, { __lang: __lang }];
                    if (!conf.loaderName && conf.loader !== false) {
                        console.warn('🚨 [next-translate] You can remove the "loadNamespaces" helper, unless you set "loader: false" in your i18n config file.');
                    }
                    page = removeTrailingSlash(conf.pathname.replace(/\/index$/, '')) || '/';
                    return [4, getPageNamespaces(conf, page, conf)];
                case 1:
                    namespaces = _c.sent();
                    defaultLoader = function () { return Promise.resolve({}); };
                    return [4, Promise.all(namespaces.map(function (ns) {
                            return typeof conf.loadLocaleFrom === 'function'
                                ? conf.loadLocaleFrom(__lang, ns)
                                : defaultLoader(__lang, ns);
                        })).catch(function () { })];
                case 2:
                    pageNamespaces = (_c.sent()) || [];
                    if (conf.logBuild !== false && typeof window === 'undefined') {
                        color = function (c) { return (colorEnabled ? "\u001B[36m".concat(c, "\u001B[0m") : c); };
                        console.log(color('next-translate'), "- compiled page:", color(page), '- locale:', color(__lang), '- namespaces:', color(namespaces.join(', ')), '- used loader:', color(conf.loaderName || '-'));
                    }
                    return [2, {
                            __lang: __lang,
                            __namespaces: namespaces.reduce(function (obj, ns, i) {
                                obj[ns] = pageNamespaces[i] || null;
                                return obj;
                            }, {}),
                        }];
            }
        });
    });
}
function removeTrailingSlash(path) {
    if (path === void 0) { path = ''; }
    return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
}

;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/appWithI18n.js
var appWithI18n_assign = (undefined && undefined.__assign) || function () {
    appWithI18n_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return appWithI18n_assign.apply(this, arguments);
};
var appWithI18n_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var appWithI18n_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function appWithI18n(AppToTranslate, config) {
    var _this = this;
    if (config === void 0) { config = {}; }
    if (!config.isLoader && config.loader !== false) {
        console.warn('🚨 [next-translate] You can remove the "appWithI18n" HoC on the _app.js, unless you set "loader: false" in your i18n config file.');
    }
    function AppWithTranslations(props) {
        var _a, _b;
        var defaultLocale = config.defaultLocale;
        return (react.createElement(I18nProvider, { lang: ((_a = props.pageProps) === null || _a === void 0 ? void 0 : _a.__lang) || props.__lang || defaultLocale, namespaces: ((_b = props.pageProps) === null || _b === void 0 ? void 0 : _b.__namespaces) || props.__namespaces, config: config },
            react.createElement(AppToTranslate, appWithI18n_assign({}, props))));
    }
    if (typeof config.staticsHoc === 'function') {
        config.staticsHoc(AppWithTranslations, AppToTranslate);
    }
    if (typeof window === 'undefined')
        __webpack_require__.g.i18nConfig = config;
    else
        window.i18nConfig = config;
    if (config.skipInitialProps)
        return AppWithTranslations;
    AppWithTranslations.getInitialProps = function (appCtx) { return appWithI18n_awaiter(_this, void 0, void 0, function () {
        var ctx, appProps, _a;
        return appWithI18n_generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ctx = appWithI18n_assign(appWithI18n_assign({}, (appCtx.ctx || {})), (appCtx || {}));
                    appProps = { pageProps: {} };
                    if (!AppToTranslate.getInitialProps) return [3, 2];
                    return [4, AppToTranslate.getInitialProps(appCtx)];
                case 1:
                    appProps = (_b.sent()) || {};
                    _b.label = 2;
                case 2:
                    _a = [appWithI18n_assign({}, appProps)];
                    return [4, loadNamespaces(appWithI18n_assign(appWithI18n_assign(appWithI18n_assign({}, ctx), config), { loaderName: 'getInitialProps' }))];
                case 3: return [2, appWithI18n_assign.apply(void 0, _a.concat([(_b.sent())]))];
            }
        });
    }); };
    return AppWithTranslations;
}


/***/ }),

/***/ 88082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useTranslation; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/wrapTWithDefaultNs.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function wrapTWithDefaultNs(oldT, ns) {
    if (typeof ns !== 'string')
        return oldT;
    var t = function (key, query, options) {
        return oldT(key, query, __assign({ ns: ns }, options));
    };
    return t;
}

// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/_context.js
var _context = __webpack_require__(46580);
;// CONCATENATED MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js
var useTranslation_assign = (undefined && undefined.__assign) || function () {
    useTranslation_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return useTranslation_assign.apply(this, arguments);
};



function useTranslation(defaultNS) {
    var ctx = (0,react.useContext)(_context/* default */.Z);
    return (0,react.useMemo)(function () { return (useTranslation_assign(useTranslation_assign({}, ctx), { t: wrapTWithDefaultNs(ctx.t, defaultNS) })); }, [ctx.lang, defaultNS]);
}


/***/ }),

/***/ 89847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(32136)


/***/ }),

/***/ 93089:
/***/ (function(module) {

"use strict";

/* globals self */ var fetch = self.fetch.bind(self);
module.exports = fetch;
module.exports["default"] = module.exports;

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 44926:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20856)


/***/ }),

/***/ 21395:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(15241)


/***/ }),

/***/ 67320:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(97943)


/***/ }),

/***/ 76846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ clamp; }
/* harmony export */ });
var clamp = function (min, max, v) {
    return Math.min(Math.max(v, min), max);
};




/***/ }),

/***/ 71022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ isNum; }
/* harmony export */ });
/* unused harmony export zeroPoint */
var zeroPoint = {
    x: 0,
    y: 0,
    z: 0
};
var isNum = function (v) { return typeof v === 'number'; };




/***/ }),

/***/ 41410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ mix; }
/* harmony export */ });
var mix = function (from, to, progress) {
    return -progress * from + progress * to + from;
};




/***/ }),

/***/ 8813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ pipe; }
/* harmony export */ });
var combineFunctions = function (a, b) { return function (v) { return b(a(v)); }; };
var pipe = function () {
    var transformers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        transformers[_i] = arguments[_i];
    }
    return transformers.reduce(combineFunctions);
};




/***/ }),

/***/ 17027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ progress; }
/* harmony export */ });
var progress = function (from, to, value) {
    var toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};




/***/ }),

/***/ 93222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ velocityPerSecond; }
/* harmony export */ });
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}




/***/ }),

/***/ 47859:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 50063:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

const strictUriEncode = __webpack_require__(94000);
const decodeComponent = __webpack_require__(65690);
const splitOnFirst = __webpack_require__(63182);
const filterObject = __webpack_require__(99788);

const isNullOrUndefined = value => value === null || value === undefined;

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
			return key => (result, value) => {
				if (value === null || value === undefined || value.length === 0) {
					return result;
				}

				if (result.length === 0) {
					return [[encode(key, options), '=', encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${encode(object.fragmentIdentifier, options)}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObject(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};


/***/ }),

/***/ 39031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61370);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82076);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66477);




var FocusManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FocusManager, _Subscribable);

  function FocusManager() {
    return _Subscribable.apply(this, arguments) || this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.removeEventListener) {
      this.setDefaultEventListener();
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this = this;

    if (this.removeEventListener) {
      this.removeEventListener();
    }

    this.removeEventListener = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this.setFocused(focused);
      } else {
        _this.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  _proto.setDefaultEventListener = function setDefaultEventListener() {
    var _window;

    if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
      this.setEventListener(function (onFocus) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      });
    }
  };

  return FocusManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);

var focusManager = new FocusManager();

/***/ }),

/***/ 97833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _queryClient__WEBPACK_IMPORTED_MODULE_0__.S; }
/* harmony export */ });
/* harmony import */ var _queryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36467);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1292);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "Hydrate")) __webpack_require__.d(__webpack_exports__, { "Hydrate": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.Hydrate; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQuery; } });














 // Types



/***/ }),

/***/ 41412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ setLogger; },
/* harmony export */   "j": function() { return /* binding */ getLogger; }
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66477);
 // TYPES

// FUNCTIONS
var logger = console || {
  error: _utils__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .ZT,
  warn: _utils__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .ZT,
  log: _utils__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .ZT
};
function getLogger() {
  return logger;
}
function setLogger(newLogger) {
  logger = newLogger;
}

/***/ }),

/***/ 74586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66477);
 // TYPES

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    this.transactions++;
    var result = callback();
    this.transactions--;

    if (!this.transactions) {
      this.flush();
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON


var notifyManager = new NotifyManager();

/***/ }),

/***/ 66796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61370);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82076);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66477);




var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OnlineManager, _Subscribable);

  function OnlineManager() {
    return _Subscribable.apply(this, arguments) || this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.removeEventListener) {
      this.setDefaultEventListener();
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this = this;

    if (this.removeEventListener) {
      this.removeEventListener();
    }

    this.removeEventListener = setup(function (online) {
      if (typeof online === 'boolean') {
        _this.setOnline(online);
      } else {
        _this.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  _proto.setDefaultEventListener = function setDefaultEventListener() {
    var _window;

    if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
      this.setEventListener(function (onOnline) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      });
    }
  };

  return OnlineManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);

var onlineManager = new OnlineManager();

/***/ }),

/***/ 36467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ QueryClient; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(13659);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(66477);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(61370);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(74586);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(41412);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(52438);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/query.js




 // TYPES

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = (0,esm_extends/* default */.Z)({}, this.defaultOptions, options); // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if ((0,utils/* isValidTimeout */.PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    clearTimeout(this.gcTimeout);
    this.gcTimeout = undefined;
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length && !this.state.isFetching) {
      this.cache.remove(this);
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = (0,utils/* functionalUpdate */.SE)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = (0,utils/* replaceEqualDeep */.Q$)(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer); // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };

  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        // Return current promise if we are already fetching
        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    var queryKey = (0,utils/* ensureQueryKeyArray */.mc)(this.queryKey); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined
    }; // Create fetch function

    var fetchFn = function fetchFn() {
      return _this2.options.queryFn ? _this2.options.queryFn(queryFnContext) : Promise.reject('Missing queryFn');
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new retryer/* Retryer */.m4({
      fn: context.fetchFn,
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback


        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!(0,retryer/* isCancelledError */.DV)(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          (0,logger/* getLogger */.j)().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: true
        });

      case 'continue':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: false
        });

      case 'fetch':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false,
          status: !state.dataUpdatedAt ? 'loading' : state.status
        });

      case 'success':
        return (0,esm_extends/* default */.Z)({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
          return (0,esm_extends/* default */.Z)({}, this.revertState);
        }

        return (0,esm_extends/* default */.Z)({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return (0,esm_extends/* default */.Z)({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return (0,esm_extends/* default */.Z)({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}();
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(82076);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryCache.js





// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey)
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return filters ? this.queries.filter(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(event) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(subscribable/* Subscribable */.l);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutation.js




 // TYPES

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = (0,esm_extends/* default */.Z)({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      (0,logger/* getLogger */.j)().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new retryer/* Retryer */.m4({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'failed':
      return (0,esm_extends/* default */.Z)({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return (0,esm_extends/* default */.Z)({}, state, {
        isPaused: true
      });

    case 'continue':
      return (0,esm_extends/* default */.Z)({}, state, {
        isPaused: false
      });

    case 'loading':
      return (0,esm_extends/* default */.Z)({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return (0,esm_extends/* default */.Z)({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return (0,esm_extends/* default */.Z)({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return (0,esm_extends/* default */.Z)({}, state, action.state);

    default:
      return state;
  }
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutationCache.js




 // TYPES

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new Mutation({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(utils/* noop */.ZT);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(39031);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/onlineManager.js
var onlineManager = __webpack_require__(66796);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/infiniteQueryBehavior.js

function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };

        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            pageParam: param
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });

          if ((0,retryer/* isCancelable */.LE)(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
            var manual = typeof pageParam !== 'undefined';
            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
            promise = fetchPage(oldPages, manual, param);
          } // Fetch previous page?
          else if (isFetchingPreviousPage) {
              var _manual = typeof pageParam !== 'undefined';

              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

              promise = fetchPage(oldPages, _manual, _param, true);
            } // Refetch pages
            else {
                (function () {
                  newPageParams = [];
                  var manual = typeof context.options.getNextPageParam === 'undefined';
                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

                  var _loop = function _loop(i) {
                    promise = promise.then(function (pages) {
                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

                      if (shouldFetchNextPage) {
                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);

                        return fetchPage(pages, manual, _param2);
                      }

                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                  };

                  for (var i = 1; i < oldPages.length; i++) {
                    _loop(i);
                  }
                })();
              }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;

          if ((0,retryer/* isCancelable */.LE)(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    var nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    var previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryClient.js







 // TYPES

// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll((0,esm_extends/* default */.Z)({}, filters, {
      fetching: true
    })).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
          state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs3 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      active: true
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;

    var _parseFilterArgs4 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
        _filters$refetchActiv,
        _filters$refetchInact,
        _this5 = this;

    var _parseFilterArgs5 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this5.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;

    var _parseFilterArgs6 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        });
      });
    });
    var promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = infiniteQueryBehavior();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = (0,esm_extends/* default */.Z)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return (0,esm_extends/* default */.Z)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();

/***/ }),

/***/ 52438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "LE": function() { return /* binding */ isCancelable; },
/* harmony export */   "m4": function() { return /* binding */ Retryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39031);
/* harmony import */ var _onlineManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66796);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66477);


 // TYPES

function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions)); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!_focusManager__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || !_onlineManager__WEBPACK_IMPORTED_MODULE_2__/* .onlineManager.isOnline */ .N.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
};

/***/ }),

/***/ 82076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();

/***/ }),

/***/ 1292:
/***/ (function() {



/***/ }),

/***/ 66477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Q$": function() { return /* binding */ replaceEqualDeep; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "mc": function() { return /* binding */ ensureQueryKeyArray; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports difference, replaceAt, parseMutationArgs, parseMutationFilterArgs, mapQueryStatusFilter, stableValueHash, partialDeepEqual, isPlainObject, isQueryKey, isError */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13659);

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function difference(array1, array2) {
  return array1.filter(function (x) {
    return array2.indexOf(x) === -1;
  });
}
function replaceAt(array, index, value) {
  var copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  });
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return _extends({}, arg3, {
        mutationKey: arg1,
        mutationFn: arg2
      });
    }

    return _extends({}, arg2, {
      mutationKey: arg1
    });
  }

  if (typeof arg1 === 'function') {
    return _extends({}, arg2, {
      mutationFn: arg1
    });
  }

  return _extends({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2) {
  return isQueryKey(arg1) ? _extends({}, arg2, {
    mutationKey: arg1
  }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var queryStatusFilter = mapQueryStatusFilter(active, inactive);

  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();

    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }

    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
      fetching = filters.fetching,
      predicate = filters.predicate,
      mutationKey = filters.mutationKey;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}

/***/ }),

/***/ 82783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hydrate": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.Hydrate; },
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _core__WEBPACK_IMPORTED_MODULE_0__.QueryClient; },
/* harmony export */   "QueryClientProvider": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; },
/* harmony export */   "useQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQuery; }
/* harmony export */ });
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97833);
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "Hydrate")) __webpack_require__.d(__webpack_exports__, { "Hydrate": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.Hydrate; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQuery; } });
/* harmony import */ var _react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86126);



/***/ }),

/***/ 86126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Hydrate": function() { return /* reexport */ Hydrate; },
  "QueryClientProvider": function() { return /* reexport */ QueryClientProvider; },
  "useQuery": function() { return /* reexport */ useQuery; }
});

// UNUSED EXPORTS: QueryErrorResetBoundary, useHydrate, useInfiniteQuery, useIsFetching, useIsMutating, useMutation, useQueries, useQueryClient, useQueryErrorResetBoundary

// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(74586);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(29515);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/reactBatchedUpdates.js

var unstable_batchedUpdates = react_dom.unstable_batchedUpdates;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setBatchUpdatesFn.js


notifyManager/* notifyManager.setBatchNotifyFunction */.V.setBatchNotifyFunction(unstable_batchedUpdates);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(41412);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/logger.js
var logger_logger = console;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setLogger.js



if (logger_logger) {
  (0,logger/* setLogger */.E)(logger_logger);
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/QueryClientProvider.js

var defaultContext = /*#__PURE__*/react.createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/react.createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(contextSharing) {
  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

var useQueryClient = function useQueryClient() {
  var queryClient = react.useContext(getQueryClientContext(react.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
      _ref$contextSharing = _ref.contextSharing,
      contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing,
      children = _ref.children;
  react.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext(contextSharing);
  return /*#__PURE__*/react.createElement(QueryClientSharingContext.Provider, {
    value: contextSharing
  }, /*#__PURE__*/react.createElement(Context.Provider, {
    value: client
  }, children));
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(13659);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(61370);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(66477);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(39031);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(82076);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(52438);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryObserver.js








var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryObserver, _Subscribable);

  function QueryObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];
    _this.previousSelectError = null;

    _this.bindMethods();

    _this.setOptions(options);

    return _this;
  }

  var _proto = QueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };

  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return _shouldFetchOnReconnect(this.currentQuery, this.options);
  };

  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return _shouldFetchOnWindowFocus(this.currentQuery, this.options);
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.trackResult = function trackResult(result) {
    var _this2 = this;

    var trackedResult = {};
    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          var typedKey = key;

          if (!_this2.trackedProps.includes(typedKey)) {
            _this2.trackedProps.push(typedKey);
          }

          return result[typedKey];
        }
      });
    });
    return trackedResult;
  };

  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();

          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };

  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };

  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };

  _proto.refetch = function refetch(options) {
    return this.fetch((0,esm_extends/* default */.Z)({}, options, {
      meta: {
        refetchPage: options == null ? void 0 : options.refetchPage
      }
    }));
  };

  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;

    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };

  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;

    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();

      return _this5.currentResult;
    });
  };

  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;

    this.clearStaleTimeout();

    if (utils/* isServer */.sk || this.currentResult.isStale || !(0,utils/* isValidTimeout */.PN)(this.options.staleTime)) {
      return;
    }

    var time = (0,utils/* timeUntilStale */.Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };

  _proto.computeRefetchInterval = function computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  };

  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
    var _this7 = this;

    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (utils/* isServer */.sk || this.options.enabled === false || !(0,utils/* isValidTimeout */.PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || focusManager/* focusManager.isFocused */.j.isFocused()) {
        _this7.executeFetch();
      }
    }, this.currentRefetchInterval);
  };

  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  };

  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };

  _proto.clearStaleTimeout = function clearStaleTimeout() {
    clearTimeout(this.staleTimeoutId);
    this.staleTimeoutId = undefined;
  };

  _proto.clearRefetchInterval = function clearRefetchInterval() {
    clearInterval(this.refetchIntervalId);
    this.refetchIntervalId = undefined;
  };

  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
        error = state.error,
        errorUpdatedAt = state.errorUpdatedAt,
        isFetching = state.isFetching,
        status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        isFetching = true;

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
        // Memoize select result
        if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (prevResultOptions == null ? void 0 : prevResultOptions.select) && !this.previousSelectError) {
          data = prevResult.data;
        } else {
          try {
            data = options.select(state.data);

            if (options.structuralSharing !== false) {
              data = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, data);
            }

            this.previousSelectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            error = selectError;
            this.previousSelectError = selectError;
            errorUpdatedAt = Date.now();
            status = 'error';
          }
        }
      } // Use query data
      else {
          data = state.data;
        } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);

            if (options.structuralSharing !== false) {
              placeholderData = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, placeholderData);
            }

            this.previousSelectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            error = selectError;
            this.previousSelectError = selectError;
            errorUpdatedAt = Date.now();
            status = 'error';
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }

    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isRefetching: isFetching && status !== 'loading',
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };

  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }

    if (result === prevResult) {
      return false;
    }

    var _this$options = this.options,
        notifyOnChangeProps = _this$options.notifyOnChangeProps,
        notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;

    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }

    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }

    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };

  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if ((0,utils/* shallowEqualObjects */.VS)(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger


    var defaultNotifyOptions = {
      cache: true
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify((0,esm_extends/* default */.Z)({}, defaultNotifyOptions, notifyOptions));
  };

  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };

  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error' && !(0,retryer/* isCancelledError */.DV)(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  };

  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify({
          query: _this8.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  };

  return QueryObserver;
}(subscribable/* Subscribable */.l);

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldRefetchOnMount(query, options) {
  return options.enabled !== false && query.state.dataUpdatedAt > 0 && (options.refetchOnMount === 'always' || options.refetchOnMount !== false && isStale(query, options));
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || shouldRefetchOnMount(query, options);
}

function _shouldFetchOnReconnect(query, options) {
  return options.enabled !== false && (options.refetchOnReconnect === 'always' || options.refetchOnReconnect !== false && isStale(query, options));
}

function _shouldFetchOnWindowFocus(query, options) {
  return options.enabled !== false && (options.refetchOnWindowFocus === 'always' || options.refetchOnWindowFocus !== false && isStale(query, options));
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error' || prevOptions.enabled === false) && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/QueryErrorResetBoundary.js
 // CONTEXT

function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}

var QueryErrorResetBoundaryContext = /*#__PURE__*/react.createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return react.useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT

var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
  var children = _ref.children;
  var value = React.useMemo(function () {
    return createValue();
  }, []);
  return /*#__PURE__*/React.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/utils.js
function shouldThrowError(suspense, _useErrorBoundary, error) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary(error);
  } // Allow useErrorBoundary to override suspense's throwing behaviour


  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors

  return !!suspense;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useBaseQuery.js





function useBaseQuery(options, Observer) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = useQueryClient();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var _React$useState2 = react.useState(function () {
    return new Observer(queryClient, defaultedOptions);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedOptions);
  react.useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary, observer]);
  react.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary


  if (result.isError && !result.isFetching && shouldThrowError(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, result.error)) {
    throw result.error;
  } // Handle result property usage tracking


  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = observer.trackResult(result);
  }

  return result;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useQuery.js


 // HOOK

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/hydration.js


// TYPES
// FUNCTIONS
function dehydrateMutation(mutation) {
  return {
    mutationKey: mutation.options.mutationKey,
    state: mutation.state
  };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.


function dehydrateQuery(query) {
  return {
    state: query.state,
    queryKey: query.queryKey,
    queryHash: query.queryHash
  };
}

function defaultShouldDehydrateMutation(mutation) {
  return mutation.state.isPaused;
}

function defaultShouldDehydrateQuery(query) {
  return query.state.status === 'success';
}

function dehydrate(client, options) {
  var _options, _options2;

  options = options || {};
  var mutations = [];
  var queries = [];

  if (((_options = options) == null ? void 0 : _options.dehydrateMutations) !== false) {
    var shouldDehydrateMutation = options.shouldDehydrateMutation || defaultShouldDehydrateMutation;
    client.getMutationCache().getAll().forEach(function (mutation) {
      if (shouldDehydrateMutation(mutation)) {
        mutations.push(dehydrateMutation(mutation));
      }
    });
  }

  if (((_options2 = options) == null ? void 0 : _options2.dehydrateQueries) !== false) {
    var shouldDehydrateQuery = options.shouldDehydrateQuery || defaultShouldDehydrateQuery;
    client.getQueryCache().getAll().forEach(function (query) {
      if (shouldDehydrateQuery(query)) {
        queries.push(dehydrateQuery(query));
      }
    });
  }

  return {
    mutations: mutations,
    queries: queries
  };
}
function hydrate(client, dehydratedState, options) {
  if (typeof dehydratedState !== 'object' || dehydratedState === null) {
    return;
  }

  var mutationCache = client.getMutationCache();
  var queryCache = client.getQueryCache();
  var mutations = dehydratedState.mutations || [];
  var queries = dehydratedState.queries || [];
  mutations.forEach(function (dehydratedMutation) {
    var _options$defaultOptio;

    mutationCache.build(client, (0,esm_extends/* default */.Z)({}, options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations, {
      mutationKey: dehydratedMutation.mutationKey
    }), dehydratedMutation.state);
  });
  queries.forEach(function (dehydratedQuery) {
    var _options$defaultOptio2;

    var query = queryCache.get(dehydratedQuery.queryHash); // Do not hydrate if an existing query exists with newer data

    if (query) {
      if (query.state.dataUpdatedAt < dehydratedQuery.state.dataUpdatedAt) {
        query.setState(dehydratedQuery.state);
      }

      return;
    } // Restore query


    queryCache.build(client, (0,esm_extends/* default */.Z)({}, options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries, {
      queryKey: dehydratedQuery.queryKey,
      queryHash: dehydratedQuery.queryHash
    }), dehydratedQuery.state);
  });
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/Hydrate.js



function useHydrate(state, options) {
  var queryClient = useQueryClient();
  var optionsRef = react.useRef(options);
  optionsRef.current = options; // Running hydrate again with the same queries is safe,
  // it wont overwrite or initialize existing queries,
  // relying on useMemo here is only a performance optimization.
  // hydrate can and should be run *during* render here for SSR to work properly

  react.useMemo(function () {
    if (state) {
      hydrate(queryClient, state, optionsRef.current);
    }
  }, [queryClient, state]);
}
var Hydrate = function Hydrate(_ref) {
  var children = _ref.children,
      options = _ref.options,
      state = _ref.state;
  useHydrate(state, options);
  return children;
};
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/index.js
// Side effects










 // Types



/***/ }),

/***/ 45904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(20122)["lW"];
(function() {
  var crypt = __webpack_require__(66449),
      utf8 = (__webpack_require__(50791).utf8),
      bin = (__webpack_require__(50791).bin),

  // The core
  sha1 = function (message) {
    // Convert to byte array
    if (message.constructor == String)
      message = utf8.stringToBytes(message);
    else if (typeof Buffer !== 'undefined' && typeof Buffer.isBuffer == 'function' && Buffer.isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();

    // otherwise assume byte array

    var m  = crypt.bytesToWords(message),
        l  = message.length * 8,
        w  = [],
        H0 =  1732584193,
        H1 = -271733879,
        H2 = -1732584194,
        H3 =  271733878,
        H4 = -1009589776;

    // Padding
    m[l >> 5] |= 0x80 << (24 - l % 32);
    m[((l + 64 >>> 9) << 4) + 15] = l;

    for (var i = 0; i < m.length; i += 16) {
      var a = H0,
          b = H1,
          c = H2,
          d = H3,
          e = H4;

      for (var j = 0; j < 80; j++) {

        if (j < 16)
          w[j] = m[i + j];
        else {
          var n = w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16];
          w[j] = (n << 1) | (n >>> 31);
        }

        var t = ((H0 << 5) | (H0 >>> 27)) + H4 + (w[j] >>> 0) + (
                j < 20 ? (H1 & H2 | ~H1 & H3) + 1518500249 :
                j < 40 ? (H1 ^ H2 ^ H3) + 1859775393 :
                j < 60 ? (H1 & H2 | H1 & H3 | H2 & H3) - 1894007588 :
                         (H1 ^ H2 ^ H3) - 899497514);

        H4 = H3;
        H3 = H2;
        H2 = (H1 << 30) | (H1 >>> 2);
        H1 = H0;
        H0 = t;
      }

      H0 += a;
      H1 += b;
      H2 += c;
      H3 += d;
      H4 += e;
    }

    return [H0, H1, H2, H3, H4];
  },

  // Public API
  api = function (message, options) {
    var digestbytes = crypt.wordsToBytes(sha1(message));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

  api._blocksize = 16;
  api._digestsize = 20;

  module.exports = api;
})();


/***/ }),

/***/ 6702:
/***/ (function(module) {

/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {}

}());


/***/ }),

/***/ 63182:
/***/ (function(module) {

"use strict";


module.exports = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};


/***/ }),

/***/ 94000:
/***/ (function(module) {

"use strict";

module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);


/***/ }),

/***/ 91660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ hex; }
/* harmony export */ });
/* harmony import */ var _rgba_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8619);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49511);



function parseHex(v) {
    var r = '';
    var g = '';
    var b = '';
    var a = '';
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    }
    else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1,
    };
}
var hex = {
    test: (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isColorString */ .i)('#'),
    parse: parseHex,
    transform: _rgba_js__WEBPACK_IMPORTED_MODULE_1__/* .rgba.transform */ .m.transform,
};




/***/ }),

/***/ 10197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ hsla; }
/* harmony export */ });
/* harmony import */ var _numbers_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42429);
/* harmony import */ var _numbers_units_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31386);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73146);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49511);





var hsla = {
    test: (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isColorString */ .i)('hsl', 'hue'),
    parse: (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .splitColor */ .d)('hue', 'saturation', 'lightness'),
    transform: function (_a) {
        var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return ('hsla(' +
            Math.round(hue) +
            ', ' +
            _numbers_units_js__WEBPACK_IMPORTED_MODULE_1__/* .percent.transform */ .aQ.transform((0,_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .sanitize */ .Nw)(saturation)) +
            ', ' +
            _numbers_units_js__WEBPACK_IMPORTED_MODULE_1__/* .percent.transform */ .aQ.transform((0,_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .sanitize */ .Nw)(lightness)) +
            ', ' +
            (0,_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .sanitize */ .Nw)(_numbers_index_js__WEBPACK_IMPORTED_MODULE_3__/* .alpha.transform */ .Fq.transform(alpha$1)) +
            ')');
    },
};




/***/ }),

/***/ 32672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ color; }
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73146);
/* harmony import */ var _hex_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91660);
/* harmony import */ var _hsla_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10197);
/* harmony import */ var _rgba_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8619);





var color = {
    test: function (v) { return _rgba_js__WEBPACK_IMPORTED_MODULE_0__/* .rgba.test */ .m.test(v) || _hex_js__WEBPACK_IMPORTED_MODULE_1__/* .hex.test */ .$.test(v) || _hsla_js__WEBPACK_IMPORTED_MODULE_2__/* .hsla.test */ .J.test(v); },
    parse: function (v) {
        if (_rgba_js__WEBPACK_IMPORTED_MODULE_0__/* .rgba.test */ .m.test(v)) {
            return _rgba_js__WEBPACK_IMPORTED_MODULE_0__/* .rgba.parse */ .m.parse(v);
        }
        else if (_hsla_js__WEBPACK_IMPORTED_MODULE_2__/* .hsla.test */ .J.test(v)) {
            return _hsla_js__WEBPACK_IMPORTED_MODULE_2__/* .hsla.parse */ .J.parse(v);
        }
        else {
            return _hex_js__WEBPACK_IMPORTED_MODULE_1__/* .hex.parse */ .$.parse(v);
        }
    },
    transform: function (v) {
        return (0,_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(v)
            ? v
            : v.hasOwnProperty('red')
                ? _rgba_js__WEBPACK_IMPORTED_MODULE_0__/* .rgba.transform */ .m.transform(v)
                : _hsla_js__WEBPACK_IMPORTED_MODULE_2__/* .hsla.transform */ .J.transform(v);
    },
};




/***/ }),

/***/ 8619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ rgba; }
/* harmony export */ });
/* unused harmony export rgbUnit */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50879);
/* harmony import */ var _numbers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42429);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73146);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49511);





var clampRgbUnit = (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .clamp */ .uZ)(0, 255);
var rgbUnit = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({}, _numbers_index_js__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx), { transform: function (v) { return Math.round(clampRgbUnit(v)); } });
var rgba = {
    test: (0,_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .isColorString */ .i)('rgb', 'red'),
    parse: (0,_utils_js__WEBPACK_IMPORTED_MODULE_3__/* .splitColor */ .d)('red', 'green', 'blue'),
    transform: function (_a) {
        var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return 'rgba(' +
            rgbUnit.transform(red) +
            ', ' +
            rgbUnit.transform(green) +
            ', ' +
            rgbUnit.transform(blue) +
            ', ' +
            (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .sanitize */ .Nw)(_numbers_index_js__WEBPACK_IMPORTED_MODULE_2__/* .alpha.transform */ .Fq.transform(alpha$1)) +
            ')';
    },
};




/***/ }),

/***/ 49511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ splitColor; },
/* harmony export */   "i": function() { return /* binding */ isColorString; }
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73146);


var isColorString = function (type, testProp) { return function (v) {
    return Boolean(((0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(v) && _utils_js__WEBPACK_IMPORTED_MODULE_0__/* .singleColorRegex.test */ .mj.test(v) && v.startsWith(type)) ||
        (testProp && Object.prototype.hasOwnProperty.call(v, testProp)));
}; };
var splitColor = function (aName, bName, cName) { return function (v) {
    var _a;
    if (!(0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(v))
        return v;
    var _b = v.match(_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .floatRegex */ .KP), a = _b[0], b = _b[1], c = _b[2], alpha = _b[3];
    return _a = {},
        _a[aName] = parseFloat(a),
        _a[bName] = parseFloat(b),
        _a[cName] = parseFloat(c),
        _a.alpha = alpha !== undefined ? parseFloat(alpha) : 1,
        _a;
}; };




/***/ }),

/***/ 80776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ filter; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50879);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8384);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73146);




var maxDefaults = new Set(['brightness', 'contrast', 'saturate', 'opacity']);
function applyDefaultFilter(v) {
    var _a = v.slice(0, -1).split('('), name = _a[0], value = _a[1];
    if (name === 'drop-shadow')
        return v;
    var number = (value.match(_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .floatRegex */ .KP) || [])[0];
    if (!number)
        return v;
    var unit = value.replace(number, '');
    var defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value)
        defaultValue *= 100;
    return name + '(' + defaultValue + unit + ')';
}
var functionRegex = /([a-z-]*)\(.*?\)/g;
var filter = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({}, _index_js__WEBPACK_IMPORTED_MODULE_2__/* .complex */ .P), { getAnimatableNone: function (v) {
        var functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(' ') : v;
    } });




/***/ }),

/***/ 8384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ complex; }
/* harmony export */ });
/* harmony import */ var _color_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32672);
/* harmony import */ var _numbers_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42429);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73146);




var colorToken = '${c}';
var numberToken = '${n}';
function test(v) {
    var _a, _b, _c, _d;
    return (isNaN(v) &&
        (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(v) &&
        ((_b = (_a = v.match(_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .floatRegex */ .KP)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match(_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .colorRegex */ .dA)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0);
}
function analyse(v) {
    var values = [];
    var numColors = 0;
    var colors = v.match(_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .colorRegex */ .dA);
    if (colors) {
        numColors = colors.length;
        v = v.replace(_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .colorRegex */ .dA, colorToken);
        values.push.apply(values, colors.map(_color_index_js__WEBPACK_IMPORTED_MODULE_1__/* .color.parse */ .$.parse));
    }
    var numbers = v.match(_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .floatRegex */ .KP);
    if (numbers) {
        v = v.replace(_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .floatRegex */ .KP, numberToken);
        values.push.apply(values, numbers.map(_numbers_index_js__WEBPACK_IMPORTED_MODULE_2__/* .number.parse */ .Rx.parse));
    }
    return { values: values, numColors: numColors, tokenised: v };
}
function parse(v) {
    return analyse(v).values;
}
function createTransformer(v) {
    var _a = analyse(v), values = _a.values, numColors = _a.numColors, tokenised = _a.tokenised;
    var numValues = values.length;
    return function (v) {
        var output = tokenised;
        for (var i = 0; i < numValues; i++) {
            output = output.replace(i < numColors ? colorToken : numberToken, i < numColors ? _color_index_js__WEBPACK_IMPORTED_MODULE_1__/* .color.transform */ .$.transform(v[i]) : (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .sanitize */ .Nw)(v[i]));
        }
        return output;
    };
}
var convertNumbersToZero = function (v) {
    return typeof v === 'number' ? 0 : v;
};
function getAnimatableNone(v) {
    var parsed = parse(v);
    var transformer = createTransformer(v);
    return transformer(parsed.map(convertNumbersToZero));
}
var complex = { test: test, parse: parse, createTransformer: createTransformer, getAnimatableNone: getAnimatableNone };




/***/ }),

/***/ 42429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fq": function() { return /* binding */ alpha; },
/* harmony export */   "Rx": function() { return /* binding */ number; },
/* harmony export */   "bA": function() { return /* binding */ scale; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50879);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73146);



var number = {
    test: function (v) { return typeof v === 'number'; },
    parse: parseFloat,
    transform: function (v) { return v; },
};
var alpha = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, number), { transform: (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .clamp */ .uZ)(0, 1) });
var scale = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, number), { default: 1 });




/***/ }),

/***/ 31386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$C": function() { return /* binding */ progressPercentage; },
/* harmony export */   "RW": function() { return /* binding */ degrees; },
/* harmony export */   "aQ": function() { return /* binding */ percent; },
/* harmony export */   "px": function() { return /* binding */ px; },
/* harmony export */   "vh": function() { return /* binding */ vh; },
/* harmony export */   "vw": function() { return /* binding */ vw; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50879);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73146);



var createUnitType = function (unit) { return ({
    test: function (v) {
        return (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(v) && v.endsWith(unit) && v.split(' ').length === 1;
    },
    parse: parseFloat,
    transform: function (v) { return "" + v + unit; },
}); };
var degrees = createUnitType('deg');
var percent = createUnitType('%');
var px = createUnitType('px');
var vh = createUnitType('vh');
var vw = createUnitType('vw');
var progressPercentage = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({}, percent), { parse: function (v) { return percent.parse(v) / 100; }, transform: function (v) { return percent.transform(v * 100); } });




/***/ }),

/***/ 73146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "KP": function() { return /* binding */ floatRegex; },
/* harmony export */   "Nw": function() { return /* binding */ sanitize; },
/* harmony export */   "dA": function() { return /* binding */ colorRegex; },
/* harmony export */   "mj": function() { return /* binding */ singleColorRegex; },
/* harmony export */   "uZ": function() { return /* binding */ clamp; }
/* harmony export */ });
var clamp = function (min, max) { return function (v) {
    return Math.max(Math.min(v, max), min);
}; };
var sanitize = function (v) { return (v % 1 ? Number(v.toFixed(5)) : v); };
var floatRegex = /(-)?([\d]*\.?[\d])+/g;
var colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
var singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function isString(v) {
    return typeof v === 'string';
}




/***/ }),

/***/ 8300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V3": function() { return /* reexport */ ArrayParam; },
  "dJ": function() { return /* reexport */ BooleanParam; },
  "yz": function() { return /* reexport */ NumberParam; },
  "_c": function() { return /* reexport */ NumericObjectParam; },
  "A9": function() { return /* reexport */ ObjectParam; },
  "Fz": function() { return /* reexport */ QueryParamProvider; },
  "b4": function() { return /* reexport */ encodeQueryParams; },
  "Kx": function() { return /* reexport */ useQueryParams_useQueryParams; }
});

// UNUSED EXPORTS: DateParam, DateTimeParam, DelimitedArrayParam, DelimitedNumericArrayParam, JsonParam, NumericArrayParam, QueryParams, StringParam, createEnumParam, decodeArray, decodeBoolean, decodeDate, decodeDelimitedArray, decodeDelimitedNumericArray, decodeEnum, decodeJson, decodeNumber, decodeNumericArray, decodeNumericObject, decodeObject, decodeQueryParams, decodeString, encodeArray, encodeBoolean, encodeDate, encodeDelimitedArray, encodeDelimitedNumericArray, encodeJson, encodeNumber, encodeNumericArray, encodeNumericObject, encodeObject, encodeString, transformSearchStringJsonSafe, updateInLocation, updateLocation, useQueryParam, withDefault, withQueryParams, withQueryParamsMapped

;// CONCATENATED MODULE: ./node_modules/serialize-query-params/esm/withDefault.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function withDefault(param, defaultValue, includeNull) {
    if (includeNull === void 0) { includeNull = true; }
    var decodeWithDefault = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var decodedValue = param.decode.apply(param, args);
        if (decodedValue === undefined) {
            return defaultValue;
        }
        if (includeNull) {
            if (decodedValue === null) {
                return defaultValue;
            }
            else {
                return decodedValue;
            }
        }
        return decodedValue;
    };
    return __assign(__assign({}, param), { decode: decodeWithDefault });
}
/* harmony default export */ var esm_withDefault = ((/* unused pure expression or super */ null && (withDefault)));

;// CONCATENATED MODULE: ./node_modules/serialize-query-params/esm/serialize.js
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
/**
 * Interprets an encoded string and returns either the string or null/undefined if not available.
 * Ignores array inputs (takes just first element in array)
 * @param input encoded string
 */
function getEncodedValue(input, allowEmptyString) {
    if (input == null) {
        return input;
    }
    // '' or []
    if (input.length === 0 &&
        (!allowEmptyString || (allowEmptyString && input !== ''))) {
        return null;
    }
    var str = input instanceof Array ? input[0] : input;
    if (str == null) {
        return str;
    }
    if (!allowEmptyString && str === '') {
        return null;
    }
    return str;
}
/**
 * Interprets an encoded string and return null/undefined or an array with
 * the encoded string contents
 * @param input encoded string
 */
function getEncodedValueArray(input) {
    if (input == null) {
        return input;
    }
    return input instanceof Array ? input : input === '' ? [] : [input];
}
/**
 * Encodes a date as a string in YYYY-MM-DD format.
 *
 * @param {Date} date
 * @return {String} the encoded date
 */
function encodeDate(date) {
    if (date == null) {
        return date;
    }
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    return year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
}
/**
 * Converts a date in the format 'YYYY-mm-dd...' into a proper date, because
 * new Date() does not do that correctly. The date can be as complete or incomplete
 * as necessary (aka, '2015', '2015-10', '2015-10-01').
 * It will not work for dates that have times included in them.
 *
 * If an array is provided, only the first entry is used.
 *
 * @param  {String} input String date form like '2015-10-01'
 * @return {Date} parsed date
 */
function decodeDate(input) {
    var dateString = getEncodedValue(input);
    if (dateString == null)
        return dateString;
    var parts = dateString.split('-');
    // may only be a year so won't even have a month
    if (parts[1] != null) {
        parts[1] -= 1; // Note: months are 0-based
    }
    else {
        // just a year, set the month and day to the first
        parts[1] = 0;
        parts[2] = 1;
    }
    var decoded = new (Date.bind.apply(Date, __spreadArray([void 0], parts)))();
    if (isNaN(decoded.getTime())) {
        return null;
    }
    return decoded;
}
/**
 * Encodes a date as a string in ISO 8601 ("2019-05-28T10:58:40Z") format.
 *
 * @param {Date} date
 * @return {String} the encoded date
 */
function encodeDateTime(date) {
    if (date == null) {
        return date;
    }
    return date.toISOString();
}
/**
 * Converts a date in the https://en.wikipedia.org/wiki/ISO_8601 format.
 * For allowed inputs see specs:
 *  - https://tools.ietf.org/html/rfc2822#page-14
 *  - http://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.15
 *
 * If an array is provided, only the first entry is used.
 *
 * @param  {String} input String date form like '1995-12-17T03:24:00'
 * @return {Date} parsed date
 */
function decodeDateTime(input) {
    var dateString = getEncodedValue(input);
    if (dateString == null)
        return dateString;
    var decoded = new Date(dateString);
    if (isNaN(decoded.getTime())) {
        return null;
    }
    return decoded;
}
/**
 * Encodes a boolean as a string. true -> "1", false -> "0".
 *
 * @param {Boolean} bool
 * @return {String} the encoded boolean
 */
function encodeBoolean(bool) {
    if (bool == null) {
        return bool;
    }
    return bool ? '1' : '0';
}
/**
 * Decodes a boolean from a string. "1" -> true, "0" -> false.
 * Everything else maps to undefined.
 *
 * If an array is provided, only the first entry is used.
 *
 * @param {String} input the encoded boolean string
 * @return {Boolean} the boolean value
 */
function decodeBoolean(input) {
    var boolStr = getEncodedValue(input);
    if (boolStr == null)
        return boolStr;
    if (boolStr === '1') {
        return true;
    }
    else if (boolStr === '0') {
        return false;
    }
    return null;
}
/**
 * Encodes a number as a string.
 *
 * @param {Number} num
 * @return {String} the encoded number
 */
function encodeNumber(num) {
    if (num == null) {
        return num;
    }
    return String(num);
}
/**
 * Decodes a number from a string. If the number is invalid,
 * it returns undefined.
 *
 * If an array is provided, only the first entry is used.
 *
 * @param {String} input the encoded number string
 * @return {Number} the number value
 */
function decodeNumber(input) {
    var numStr = getEncodedValue(input);
    if (numStr == null)
        return numStr;
    if (numStr === '')
        return null;
    var result = +numStr;
    return result;
}
/**
 * Encodes a string while safely handling null and undefined values.
 *
 * @param {String} str a string to encode
 * @return {String} the encoded string
 */
function encodeString(str) {
    if (str == null) {
        return str;
    }
    return String(str);
}
/**
 * Decodes a string while safely handling null and undefined values.
 *
 * If an array is provided, only the first entry is used.
 *
 * @param {String} input the encoded string
 * @return {String} the string value
 */
function decodeString(input) {
    var str = getEncodedValue(input, true);
    if (str == null)
        return str;
    return String(str);
}
/**
 * Decodes an enum value while safely handling null and undefined values.
 *
 * If an array is provided, only the first entry is used.
 *
 * @param {String} input the encoded string
 * @param {String[]} enumValues allowed enum values
 * @return {String} the string value from enumValues
 */
function decodeEnum(input, enumValues) {
    var str = decodeString(input);
    if (str == null)
        return str;
    return enumValues.includes(str) ? str : undefined;
}
/**
 * Encodes anything as a JSON string.
 *
 * @param {Any} any The thing to be encoded
 * @return {String} The JSON string representation of any
 */
function encodeJson(any) {
    if (any == null) {
        return any;
    }
    return JSON.stringify(any);
}
/**
 * Decodes a JSON string into javascript
 *
 * If an array is provided, only the first entry is used.
 *
 * @param {String} input The JSON string representation
 * @return {Any} The javascript representation
 */
function decodeJson(input) {
    var jsonStr = getEncodedValue(input);
    if (jsonStr == null)
        return jsonStr;
    var result = null;
    try {
        result = JSON.parse(jsonStr);
    }
    catch (e) {
        /* ignore errors, returning undefined */
    }
    return result;
}
/**
 * Encodes an array as a JSON string.
 *
 * @param {Array} array The array to be encoded
 * @return {String[]} The array of strings to be put in the URL
 * as repeated query parameters
 */
function encodeArray(array) {
    if (array == null) {
        return array;
    }
    return array;
}
/**
 * Decodes an array or singular value and returns it as an array
 * or undefined if falsy. Filters out undefined values.
 *
 * @param {String | Array} input The input value
 * @return {Array} The javascript representation
 */
function decodeArray(input) {
    var arr = getEncodedValueArray(input);
    if (arr == null)
        return arr;
    return arr;
}
/**
 * Encodes a numeric array as a JSON string.
 *
 * @param {Array} array The array to be encoded
 * @return {String[]} The array of strings to be put in the URL
 * as repeated query parameters
 */
function encodeNumericArray(array) {
    if (array == null) {
        return array;
    }
    return array.map(String);
}
/**
 * Decodes an array or singular value and returns it as an array
 * or undefined if falsy. Filters out undefined and NaN values.
 *
 * @param {String | Array} input The input value
 * @return {Array} The javascript representation
 */
function decodeNumericArray(input) {
    var arr = decodeArray(input);
    if (arr == null)
        return arr;
    return arr.map(function (d) { return (d === '' || d == null ? null : +d); });
}
/**
 * Encodes an array as a delimited string. For example,
 * ['a', 'b'] -> 'a_b' with entrySeparator='_'
 *
 * @param array The array to be encoded
 * @param entrySeparator The string used to delimit entries
 * @return The array as a string with elements joined by the
 * entry separator
 */
function encodeDelimitedArray(array, entrySeparator) {
    if (entrySeparator === void 0) { entrySeparator = '_'; }
    if (array == null) {
        return array;
    }
    return array.join(entrySeparator);
}
/**
 * Decodes a delimited string into javascript array. For example,
 * 'a_b' -> ['a', 'b'] with entrySeparator='_'
 *
 * If an array is provided as input, only the first entry is used.
 *
 * @param {String} input The JSON string representation
 * @param entrySeparator The array as a string with elements joined by the
 * entry separator
 * @return {Array} The javascript representation
 */
function decodeDelimitedArray(input, entrySeparator) {
    if (entrySeparator === void 0) { entrySeparator = '_'; }
    var arrayStr = getEncodedValue(input, true);
    if (arrayStr == null)
        return arrayStr;
    if (arrayStr === '')
        return [];
    return arrayStr.split(entrySeparator);
}
/**
 * Encodes a numeric array as a delimited string. (alias of encodeDelimitedArray)
 * For example, [1, 2] -> '1_2' with entrySeparator='_'
 *
 * @param {Array} array The array to be encoded
 * @return {String} The JSON string representation of array
 */
var encodeDelimitedNumericArray = encodeDelimitedArray;
/**
 * Decodes a delimited string into javascript array where all entries are numbers
 * For example, '1_2' -> [1, 2] with entrySeparator='_'
 *
 * If an array is provided as input, only the first entry is used.
 *
 * @param {String} jsonStr The JSON string representation
 * @return {Array} The javascript representation
 */
function decodeDelimitedNumericArray(arrayStr, entrySeparator) {
    if (entrySeparator === void 0) { entrySeparator = '_'; }
    var decoded = decodeDelimitedArray(arrayStr, entrySeparator);
    if (decoded == null)
        return decoded;
    return decoded.map(function (d) { return (d === '' || d == null ? null : +d); });
}
/**
 * Encode simple objects as readable strings. Works only for simple,
 * flat objects where values are numbers, strings.
 *
 * For example { foo: bar, boo: baz } -> "foo-bar_boo-baz"
 *
 * @param {Object} object The object to encode
 * @param {String} keyValSeparator="-" The separator between keys and values
 * @param {String} entrySeparator="_" The separator between entries
 * @return {String} The encoded object
 */
function encodeObject(obj, keyValSeparator, entrySeparator) {
    if (keyValSeparator === void 0) { keyValSeparator = '-'; }
    if (entrySeparator === void 0) { entrySeparator = '_'; }
    if (obj == null)
        return obj; // null or undefined
    if (!Object.keys(obj).length)
        return ''; // {} case
    return Object.keys(obj)
        .map(function (key) { return "" + key + keyValSeparator + obj[key]; })
        .join(entrySeparator);
}
/**
 * Decodes a simple object to javascript. Currently works only for simple,
 * flat objects where values are strings.
 *
 * For example "foo-bar_boo-baz" -> { foo: bar, boo: baz }
 *
 * If an array is provided as input, only the first entry is used.
 *
 * @param {String} input The object string to decode
 * @param {String} keyValSeparator="-" The separator between keys and values
 * @param {String} entrySeparator="_" The separator between entries
 * @return {Object} The javascript object
 */
function decodeObject(input, keyValSeparator, entrySeparator) {
    if (keyValSeparator === void 0) { keyValSeparator = '-'; }
    if (entrySeparator === void 0) { entrySeparator = '_'; }
    var objStr = getEncodedValue(input, true);
    if (objStr == null)
        return objStr;
    if (objStr === '')
        return {};
    var obj = {};
    var keyValSeparatorRegExp = new RegExp(keyValSeparator + "(.*)");
    objStr.split(entrySeparator).forEach(function (entryStr) {
        var _a = entryStr.split(keyValSeparatorRegExp), key = _a[0], value = _a[1];
        obj[key] = value;
    });
    return obj;
}
/**
 * Encode simple objects as readable strings. Alias of encodeObject.
 *
 * For example { foo: 123, boo: 521 } -> "foo-123_boo-521"
 *
 * @param {Object} object The object to encode
 * @param {String} keyValSeparator="-" The separator between keys and values
 * @param {String} entrySeparator="_" The separator between entries
 * @return {String} The encoded object
 */
var encodeNumericObject = encodeObject;
/**
 * Decodes a simple object to javascript where all values are numbers.
 * Currently works only for simple, flat objects.
 *
 * For example "foo-123_boo-521" -> { foo: 123, boo: 521 }
 *
 * If an array is provided as input, only the first entry is used.
 *
 * @param {String} input The object string to decode
 * @param {String} keyValSeparator="-" The separator between keys and values
 * @param {String} entrySeparator="_" The separator between entries
 * @return {Object} The javascript object
 */
function decodeNumericObject(input, keyValSeparator, entrySeparator) {
    if (keyValSeparator === void 0) { keyValSeparator = '-'; }
    if (entrySeparator === void 0) { entrySeparator = '_'; }
    var decoded = decodeObject(input, keyValSeparator, entrySeparator);
    if (decoded == null)
        return decoded;
    // convert to numbers
    var decodedNumberObj = {};
    for (var _i = 0, _a = Object.keys(decoded); _i < _a.length; _i++) {
        var key = _a[_i];
        decodedNumberObj[key] = decodeNumber(decoded[key]);
    }
    return decodedNumberObj;
}

;// CONCATENATED MODULE: ./node_modules/serialize-query-params/esm/params.js

/**
 * String values
 */
var params_StringParam = {
    encode: encodeString,
    decode: decodeString,
};
/**
 * String enum
 */
var createEnumParam = function (enumValues) { return ({
    encode: Serialize.encodeString,
    decode: function (input) { return Serialize.decodeEnum(input, enumValues); },
}); };
/**
 * Numbers (integers or floats)
 */
var NumberParam = {
    encode: encodeNumber,
    decode: decodeNumber,
};
/**
 * For flat objects where values are strings
 */
var ObjectParam = {
    encode: encodeObject,
    decode: decodeObject,
};
/**
 * For flat arrays of strings, filters out undefined values during decode
 */
var ArrayParam = {
    encode: encodeArray,
    decode: decodeArray,
};
/**
 * For flat arrays of strings, filters out undefined values during decode
 */
var NumericArrayParam = {
    encode: encodeNumericArray,
    decode: decodeNumericArray,
};
/**
 * For any type of data, encoded via JSON.stringify
 */
var JsonParam = {
    encode: encodeJson,
    decode: decodeJson,
};
/**
 * For simple dates (YYYY-MM-DD)
 */
var DateParam = {
    encode: encodeDate,
    decode: decodeDate,
    equals: function (valueA, valueB) {
        if (valueA === valueB)
            return true;
        if (valueA == null || valueB == null)
            return valueA === valueB;
        // ignore time of day
        return (valueA.getFullYear() === valueB.getFullYear() &&
            valueA.getMonth() === valueB.getMonth() &&
            valueA.getDate() === valueB.getDate());
    },
};
/**
 * For dates in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ or ±YYYYYY-MM-DDTHH:mm:ss.sssZ)
 */
var DateTimeParam = {
    encode: encodeDateTime,
    decode: decodeDateTime,
    equals: function (valueA, valueB) {
        if (valueA === valueB)
            return true;
        if (valueA == null || valueB == null)
            return valueA === valueB;
        return valueA.valueOf() === valueB.valueOf();
    },
};
/**
 * For boolean values: 1 = true, 0 = false
 */
var BooleanParam = {
    encode: encodeBoolean,
    decode: decodeBoolean,
};
/**
 * For flat objects where the values are numbers
 */
var NumericObjectParam = {
    encode: encodeNumericObject,
    decode: decodeNumericObject,
};
/**
 * For flat arrays of strings, filters out undefined values during decode
 */
var DelimitedArrayParam = {
    encode: encodeDelimitedArray,
    decode: decodeDelimitedArray,
};
/**
 * For flat arrays where the values are numbers, filters out undefined values during decode
 */
var DelimitedNumericArrayParam = {
    encode: encodeDelimitedNumericArray,
    decode: decodeDelimitedNumericArray,
};

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(50063);
;// CONCATENATED MODULE: ./node_modules/serialize-query-params/esm/updateLocation.js
var updateLocation_assign = (undefined && undefined.__assign) || function () {
    updateLocation_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return updateLocation_assign.apply(this, arguments);
};

/**
 * An example of a transformSearchString function that undoes encoding of
 * common JSON characters that are technically allowed in URLs.
 */
var JSON_SAFE_CHARS = "{}[],\":"
    .split('')
    .map(function (d) { return [d, encodeURIComponent(d)]; });
function transformSearchStringJsonSafe(searchString) {
    var str = searchString;
    for (var _i = 0, JSON_SAFE_CHARS_1 = JSON_SAFE_CHARS; _i < JSON_SAFE_CHARS_1.length; _i++) {
        var _a = JSON_SAFE_CHARS_1[_i], char = _a[0], code = _a[1];
        str = str.replace(new RegExp('\\' + code, 'g'), char);
    }
    return str;
}
/**
 * Update a location, wiping out parameters not included in encodedQuery
 * If a param is set to undefined it will be removed from the URL.
 */
function updateLocation(encodedQuery, location, stringifyOptions) {
    var encodedSearchString = (0,query_string.stringify)(encodedQuery, stringifyOptions);
    if (stringifyOptions && stringifyOptions.transformSearchString) {
        encodedSearchString = stringifyOptions.transformSearchString(encodedSearchString);
    }
    var search = encodedSearchString.length ? "?" + encodedSearchString : '';
    var href = (0,query_string.parseUrl)(location.href || '').url + search;
    var newLocation = updateLocation_assign(updateLocation_assign({}, location), { key: "" + Date.now(), // needed for some routers (e.g. react-router)
        href: href,
        search: search, query: encodedQuery });
    return newLocation;
}
/**
 * Update a location while retaining existing parameters.
 * If a param is set to undefined it will be removed from the URL.
 */
function updateInLocation(encodedQueryReplacements, location, stringifyOptions) {
    // explicitly avoid parsing numbers to ensure the
    // return type has the same shape as EncodeQuery
    var currQuery = (0,query_string.parse)(location.search, { parseNumbers: false });
    var newQuery = updateLocation_assign(updateLocation_assign({}, currQuery), encodedQueryReplacements);
    return updateLocation(newQuery, location, stringifyOptions);
}

;// CONCATENATED MODULE: ./node_modules/serialize-query-params/esm/encodeQueryParams.js
/**
 * Convert the values in query to strings via the encode functions configured
 * in paramConfigMap
 *
 * @param paramConfigMap Map from query name to { encode, decode } config
 * @param query Query updates mapping param name to decoded value
 */
function encodeQueryParams(paramConfigMap, query) {
    var encodedQuery = {};
    var paramNames = Object.keys(query);
    for (var _i = 0, paramNames_1 = paramNames; _i < paramNames_1.length; _i++) {
        var paramName = paramNames_1[_i];
        var decodedValue = query[paramName];
        if (!paramConfigMap[paramName]) {
            if (false) {}
            // NOTE: we could just not encode it, but it is probably convenient to have
            // it be included by default as a string type.
            encodedQuery[paramName] =
                decodedValue == null ? decodedValue : String(decodedValue);
        }
        else {
            encodedQuery[paramName] = paramConfigMap[paramName].encode(query[paramName]);
        }
    }
    return encodedQuery;
}
/* harmony default export */ var esm_encodeQueryParams = ((/* unused pure expression or super */ null && (encodeQueryParams)));

;// CONCATENATED MODULE: ./node_modules/serialize-query-params/esm/index.js







// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
;// CONCATENATED MODULE: ./node_modules/use-query-params/esm/shallowEqual.js
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license at
 * https://github.com/facebook/fbjs/blob/master/LICENSE
 */
/*eslint-disable no-self-compare */
var shallowEqual_hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
    // SameValue algorithm
    if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        // Added the nonzero y check to make Flow happy, but it is redundant
        return x !== 0 || y !== 0 || 1 / x === 1 / y;
    }
    else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
}
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.

 * @pbeshai modification of shallowEqual to take into consideration a map providing
 * equals functions
 */
function shallowEqual_shallowEqual(objA, objB, equalMap) {
    var _a, _b;
    if (is(objA, objB)) {
        return true;
    }
    if (typeof objA !== 'object' ||
        objA === null ||
        typeof objB !== 'object' ||
        objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    // Test for A's keys different from B.
    for (var i = 0; i < keysA.length; i++) {
        var isEqual = (_b = (_a = equalMap === null || equalMap === void 0 ? void 0 : equalMap[keysA[i]]) === null || _a === void 0 ? void 0 : _a.equals) !== null && _b !== void 0 ? _b : is;
        if (!shallowEqual_hasOwnProperty.call(objB, keysA[i]) ||
            !isEqual(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}

;// CONCATENATED MODULE: ./node_modules/use-query-params/esm/helpers.js



function helpers_useUpdateRefIfShallowNew(ref, newValue, isEqual) {
    if (isEqual === void 0) { isEqual = shallowEqual_shallowEqual; }
    var hasNew = ((ref.current == null || newValue == null) && ref.current === newValue) ||
        !isEqual(ref.current, newValue);
    react.useEffect(function () {
        if (hasNew) {
            ref.current = newValue;
        }
    }, [ref, newValue, hasNew]);
}
function helpers_getSSRSafeSearchString(location) {
    // handle checking SSR (#13)
    if (typeof location === 'object') {
        // in browser
        if (typeof window !== 'undefined') {
            return location.search;
        }
        else {
            return (0,query_string.extract)("" + location.pathname + (location.search ? location.search : ''));
        }
    }
    return '';
}

;// CONCATENATED MODULE: ./node_modules/use-query-params/esm/updateUrlQuery.js

/**
 * Creates a new location object containing the specified query changes.
 * If replaceIn or pushIn are used as the updateType, then parameters
 * not specified in queryReplacements are retained. If replace or push
 * are used, only the values in queryReplacements will be available.
 * The default is pushIn.
 */
function createLocationWithChanges(queryReplacements, location, updateType, stringifyOptions) {
    if (updateType === void 0) { updateType = 'pushIn'; }
    switch (updateType) {
        case 'replace':
        case 'push':
            return updateLocation(queryReplacements, location, stringifyOptions);
        case 'replaceIn':
        case 'pushIn':
        default:
            return updateInLocation(queryReplacements, location, stringifyOptions);
    }
}
/**
 * Updates the URL to the new location.
 */
function updateUrlQuery(history, location, updateType) {
    if (updateType === void 0) { updateType = 'pushIn'; }
    switch (updateType) {
        case 'pushIn':
        case 'push':
            history.push(location);
            break;
        case 'replaceIn':
        case 'replace':
        default:
            history.replace(location);
            break;
    }
}

;// CONCATENATED MODULE: ./node_modules/use-query-params/esm/LocationProvider.js


var providerlessContextValue = {
    location: {},
    getLocation: function () { return ({}); },
    setLocation: function () { },
};
var LocationContext = react.createContext(providerlessContextValue);
function LocationProvider_useLocationContext() {
    var context = react.useContext(LocationContext);
    if (false) {}
    return context;
}
/**
 * An internal-only context provider which provides down the most
 * recent location object and a callback to update the history.
 */
function LocationProvider(_a) {
    var history = _a.history, location = _a.location, children = _a.children, stringifyOptions = _a.stringifyOptions;
    var locationRef = react.useRef(location);
    react.useEffect(function () {
        locationRef.current = location;
    }, [location]);
    // TODO: we can probably simplify this now that we are reading location from history
    var getLocation = react.useCallback(function () { return locationRef.current; }, [
        locationRef,
    ]);
    var setLocation = react.useCallback(function (queryReplacements, updateType) {
        // A ref is needed here to stop setLocation updating constantly (see #46)
        locationRef.current = createLocationWithChanges(queryReplacements, history == null || history.location == null
            ? locationRef.current
            : history.location, updateType, stringifyOptions);
        if (history) {
            updateUrlQuery(history, locationRef.current, updateType);
        }
    }, [history, stringifyOptions]);
    return (react.createElement(LocationContext.Provider, { value: { location: location, getLocation: getLocation, setLocation: setLocation } }, children));
}

;// CONCATENATED MODULE: ./node_modules/use-query-params/esm/memoizedQueryParser.js

var makeMemoizedQueryParser = function (initialSearchString) {
    var cachedSearchString = initialSearchString;
    var cachedParsedQuery = (0,query_string.parse)(cachedSearchString || '');
    return function (newSearchString) {
        if (cachedSearchString !== newSearchString) {
            cachedSearchString = newSearchString;
            cachedParsedQuery = (0,query_string.parse)(cachedSearchString);
        }
        return cachedParsedQuery;
    };
};
var memoizedQueryParser_sharedMemoizedQueryParser = makeMemoizedQueryParser();

;// CONCATENATED MODULE: ./node_modules/use-query-params/esm/useQueryParam.js






/**
 * Helper to get the latest decoded value with smart caching.
 * Abstracted into its own function to allow re-use in a functional setter (#26)
 */
function getLatestDecodedValue(location, name, paramConfig, paramConfigRef, encodedValueCacheRef, decodedValueCacheRef) {
    var _a;
    // check if we have a new param config
    var hasNewParamConfig = !shallowEqual(paramConfigRef.current, paramConfig);
    var isValueEqual = (_a = paramConfig.equals) !== null && _a !== void 0 ? _a : shallowEqual;
    // read in the parsed query
    var parsedQuery = sharedMemoizedQueryParser(getSSRSafeSearchString(location) // get the latest location object
    );
    // read in the encoded string value (we have to check cache if available because
    // sometimes the query string changes so we get a new parsedQuery but this value
    // didn't change, so we should avoid generating a new array or whatever value)
    var hasNewEncodedValue = !shallowEqual(encodedValueCacheRef.current, parsedQuery[name]);
    var encodedValue = hasNewEncodedValue
        ? parsedQuery[name]
        : encodedValueCacheRef.current;
    // only decode if we have changes to encoded value or the config.
    // check for undefined to handle initial case
    if (!hasNewEncodedValue &&
        !hasNewParamConfig &&
        decodedValueCacheRef.current !== undefined) {
        return decodedValueCacheRef.current;
    }
    var newDecodedValue = paramConfig.decode(encodedValue);
    var hasNewDecodedValue = ((decodedValueCacheRef.current == null || newDecodedValue == null) &&
        decodedValueCacheRef.current === newDecodedValue) ||
        !isValueEqual(decodedValueCacheRef.current, newDecodedValue);
    // if we have a new decoded value use it, otherwise use cached
    return hasNewDecodedValue
        ? newDecodedValue
        : decodedValueCacheRef.current;
}
/**
 * Given a query param name and query parameter configuration ({ encode, decode })
 * return the decoded value and a setter for updating it.
 *
 * The setter takes two arguments (newValue, updateType) where updateType
 * is one of 'replace' | 'replaceIn' | 'push' | 'pushIn', defaulting to
 * 'pushIn'.
 *
 * You may optionally pass in a rawQuery object, otherwise the query is derived
 * from the location available in the context.
 *
 * D = decoded type
 * D2 = return value from decode (typically same as D)
 */
var useQueryParam = function (name, paramConfig) {
    if (paramConfig === void 0) { paramConfig = StringParam; }
    var _a = useLocationContext(), location = _a.location, getLocation = _a.getLocation, setLocation = _a.setLocation;
    // read in the raw query
    var parsedQuery = sharedMemoizedQueryParser(getSSRSafeSearchString(location));
    // make caches
    var encodedValueCacheRef = React.useRef();
    var paramConfigRef = React.useRef(paramConfig);
    var decodedValueCacheRef = React.useRef();
    var decodedValue = getLatestDecodedValue(location, name, paramConfig, paramConfigRef, encodedValueCacheRef, decodedValueCacheRef);
    // update cached values in a useEffect
    useUpdateRefIfShallowNew(encodedValueCacheRef, parsedQuery[name]);
    useUpdateRefIfShallowNew(paramConfigRef, paramConfig);
    useUpdateRefIfShallowNew(decodedValueCacheRef, decodedValue, paramConfig.equals);
    // create the setter, memoizing via useCallback
    var setValueDeps = {
        paramConfig: paramConfig,
        name: name,
        setLocation: setLocation,
        getLocation: getLocation,
    };
    var setValueDepsRef = React.useRef(setValueDeps);
    setValueDepsRef.current = setValueDeps;
    var setValue = React.useCallback(function setValueCallback(newValue, updateType) {
        var _a;
        var deps = setValueDepsRef.current;
        var newEncodedValue;
        // allow functional updates #26
        if (typeof newValue === 'function') {
            // get latest decoded value to pass as a fresh arg to the setter fn
            var latestValue = getLatestDecodedValue(deps.getLocation(), deps.name, deps.paramConfig, paramConfigRef, encodedValueCacheRef, decodedValueCacheRef);
            decodedValueCacheRef.current = latestValue; // keep cache in sync
            newEncodedValue = deps.paramConfig.encode(newValue(latestValue));
        }
        else {
            newEncodedValue = deps.paramConfig.encode(newValue);
        }
        // update the URL
        deps.setLocation((_a = {}, _a[deps.name] = newEncodedValue, _a), updateType);
    }, []);
    return [decodedValue, setValue];
};

;// CONCATENATED MODULE: ./node_modules/use-query-params/esm/useQueryParams.js






/**
 * Helper to get the latest decoded values with smart caching.
 * Abstracted into its own function to allow re-use in a functional setter (#26)
 */
function getLatestDecodedValues(location, paramConfigMap, paramConfigMapRef, parsedQueryRef, encodedValuesCacheRef, decodedValuesCacheRef) {
    // check if we have a new param config
    var hasNewParamConfigMap = !shallowEqual_shallowEqual(paramConfigMapRef.current, paramConfigMap);
    // read in the parsed query
    var parsedQuery = memoizedQueryParser_sharedMemoizedQueryParser(helpers_getSSRSafeSearchString(location) // get the latest location object
    );
    // check if new encoded values are around (new parsed query).
    // can use triple equals since we already cache this value
    var hasNewParsedQuery = parsedQueryRef.current !== parsedQuery;
    // if nothing has changed, use existing.. so long as we have existing.
    if (!hasNewParsedQuery &&
        !hasNewParamConfigMap &&
        encodedValuesCacheRef.current !== undefined) {
        return {
            encodedValues: encodedValuesCacheRef.current,
            decodedValues: decodedValuesCacheRef.current,
        };
    }
    var encodedValuesCache = encodedValuesCacheRef.current || {};
    var decodedValuesCache = decodedValuesCacheRef.current || {};
    var encodedValues = {};
    // we have new encoded values, so let's get new decoded values.
    // recompute new values but only for those that changed
    var paramNames = Object.keys(paramConfigMap);
    var decodedValues = {};
    for (var _i = 0, paramNames_1 = paramNames; _i < paramNames_1.length; _i++) {
        var paramName = paramNames_1[_i];
        // do we have a new encoded value?
        var paramConfig = paramConfigMap[paramName];
        var hasNewEncodedValue = !shallowEqual_shallowEqual(encodedValuesCache[paramName], parsedQuery[paramName]);
        // if we have a new encoded value, re-decode. otherwise reuse cache
        var encodedValue = void 0;
        var decodedValue = void 0;
        if (hasNewEncodedValue ||
            (encodedValuesCache[paramName] === undefined &&
                decodedValuesCache[paramName] === undefined)) {
            encodedValue = parsedQuery[paramName];
            decodedValue = paramConfig.decode(encodedValue);
        }
        else {
            encodedValue = encodedValuesCache[paramName];
            decodedValue = decodedValuesCache[paramName];
        }
        encodedValues[paramName] = encodedValue;
        decodedValues[paramName] = decodedValue;
    }
    // keep referential equality for decoded valus if we didn't actually change anything
    var hasNewDecodedValues = !shallowEqual_shallowEqual(decodedValuesCacheRef.current, decodedValues, paramConfigMap);
    return {
        encodedValues: encodedValues,
        decodedValues: hasNewDecodedValues
            ? decodedValues
            : decodedValuesCacheRef.current,
    };
}
/**
 * Given a query parameter configuration (mapping query param name to { encode, decode }),
 * return an object with the decoded values and a setter for updating them.
 */
var useQueryParams_useQueryParams = function (paramConfigMap) {
    var _a = LocationProvider_useLocationContext(), location = _a.location, getLocation = _a.getLocation, setLocation = _a.setLocation;
    // read in the raw query
    var parsedQuery = memoizedQueryParser_sharedMemoizedQueryParser(helpers_getSSRSafeSearchString(location));
    // make caches
    var paramConfigMapRef = react.useRef(paramConfigMap);
    var parsedQueryRef = react.useRef(parsedQuery);
    var encodedValuesCacheRef = react.useRef(undefined); // undefined for initial check
    var decodedValuesCacheRef = react.useRef({});
    // memoize paramConfigMap to make the API nicer for consumers.
    // otherwise we'd have to useQueryParams(useMemo(() => { foo: NumberParam }, []))
    paramConfigMap = shallowEqual_shallowEqual(paramConfigMap, paramConfigMapRef.current)
        ? paramConfigMapRef.current
        : paramConfigMap;
    // decode all the values if we have changes
    var _b = getLatestDecodedValues(location, paramConfigMap, paramConfigMapRef, parsedQueryRef, encodedValuesCacheRef, decodedValuesCacheRef), encodedValues = _b.encodedValues, decodedValues = _b.decodedValues;
    // update cached values in useEffects
    helpers_useUpdateRefIfShallowNew(parsedQueryRef, parsedQuery);
    helpers_useUpdateRefIfShallowNew(paramConfigMapRef, paramConfigMap);
    helpers_useUpdateRefIfShallowNew(encodedValuesCacheRef, encodedValues);
    helpers_useUpdateRefIfShallowNew(decodedValuesCacheRef, decodedValues, function (a, b) {
        return shallowEqual_shallowEqual(a, b, paramConfigMap);
    });
    // create a setter for updating multiple query params at once
    var setQueryDeps = {
        paramConfigMap: paramConfigMap,
        setLocation: setLocation,
        getLocation: getLocation,
    };
    var setQueryDepsRef = react.useRef(setQueryDeps);
    setQueryDepsRef.current = setQueryDeps;
    var setQuery = react.useCallback(function (changes, updateType) {
        var deps = setQueryDepsRef.current;
        var encodedChanges;
        if (typeof changes === 'function') {
            // get latest decoded value to pass as a fresh arg to the setter fn
            var latestValues = getLatestDecodedValues(deps.getLocation(), deps.paramConfigMap, paramConfigMapRef, parsedQueryRef, encodedValuesCacheRef, decodedValuesCacheRef).decodedValues;
            decodedValuesCacheRef.current = latestValues; // keep cache in sync
            encodedChanges = encodeQueryParams(deps.paramConfigMap, changes(latestValues));
        }
        else {
            // encode as strings for the URL
            encodedChanges = encodeQueryParams(deps.paramConfigMap, changes);
        }
        // update the URL
        deps.setLocation(encodedChanges, updateType);
    }, []);
    // no longer Partial
    return [decodedValues, setQuery];
};
/* harmony default export */ var esm_useQueryParams = ((/* unused pure expression or super */ null && (useQueryParams_useQueryParams)));

;// CONCATENATED MODULE: ./node_modules/use-query-params/esm/withQueryParams.js
var withQueryParams_assign = (undefined && undefined.__assign) || function () {
    withQueryParams_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return withQueryParams_assign.apply(this, arguments);
};


/**
 * HOC to provide query parameters via props `query` and `setQuery`
 * NOTE: I couldn't get type to automatically infer generic when
 * using the format withQueryParams(config)(component), so I switched
 * to withQueryParams(config, component).
 * See: https://github.com/microsoft/TypeScript/issues/30134
 */
function withQueryParams(paramConfigMap, WrappedComponent) {
    // return a FC that takes props excluding query and setQuery
    var Component = function (props) {
        var _a = useQueryParams(paramConfigMap), query = _a[0], setQuery = _a[1];
        // see https://github.com/microsoft/TypeScript/issues/28938#issuecomment-450636046 for why `...props as P`
        return (React.createElement(WrappedComponent, withQueryParams_assign({ query: query, setQuery: setQuery }, props)));
    };
    Component.displayName = "withQueryParams(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")";
    return Component;
}
/* harmony default export */ var esm_withQueryParams = ((/* unused pure expression or super */ null && (withQueryParams)));
/**
 * HOC to provide query parameters via props mapToProps (similar to
 * react-redux connect style mapStateToProps)
 * NOTE: I couldn't get type to automatically infer generic when
 * using the format withQueryParams(config)(component), so I switched
 * to withQueryParams(config, component).
 * See: https://github.com/microsoft/TypeScript/issues/30134
 */
function withQueryParamsMapped(paramConfigMap, mapToProps, WrappedComponent) {
    // return a FC that takes props excluding query and setQuery
    var Component = function (props) {
        var _a = useQueryParams(paramConfigMap), query = _a[0], setQuery = _a[1];
        var propsToAdd = mapToProps(query, setQuery, props);
        // see https://github.com/microsoft/TypeScript/issues/28938#issuecomment-450636046 for why `...props as P`
        return React.createElement(WrappedComponent, withQueryParams_assign({}, propsToAdd, props));
    };
    Component.displayName = "withQueryParams(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")";
    return Component;
}

;// CONCATENATED MODULE: ./node_modules/use-query-params/esm/QueryParams.js

var QueryParams = function (_a) {
    var config = _a.config, children = _a.children;
    var _b = useQueryParams(config), query = _b[0], setQuery = _b[1];
    return children({ query: query, setQuery: setQuery });
};
/* harmony default export */ var esm_QueryParams = ((/* unused pure expression or super */ null && (QueryParams)));

;// CONCATENATED MODULE: ./node_modules/use-query-params/esm/QueryParamProvider.js
var QueryParamProvider_assign = (undefined && undefined.__assign) || function () {
    QueryParamProvider_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return QueryParamProvider_assign.apply(this, arguments);
};



// we use a lazy caching solution to prevent #46 from happening
var cachedWindowHistory;
var cachedAdaptedWindowHistory;
/**
 * Adapts standard DOM window history to work with our
 * { replace, push } interface.
 *
 * @param history Standard history provided by DOM
 */
function adaptWindowHistory(history) {
    if (history === cachedWindowHistory && cachedAdaptedWindowHistory != null) {
        return cachedAdaptedWindowHistory;
    }
    var adaptedWindowHistory = {
        replace: function (location) {
            history.replaceState(location.state, '', location.protocol + "//" + location.host + location.pathname + location.search);
        },
        push: function (location) {
            history.pushState(location.state, '', location.protocol + "//" + location.host + location.pathname + location.search);
        },
        get location() {
            return window.location;
        },
    };
    cachedWindowHistory = history;
    cachedAdaptedWindowHistory = adaptedWindowHistory;
    return adaptedWindowHistory;
}
// we use a lazy caching solution to prevent #46 from happening
var cachedReachHistory;
var cachedAdaptedReachHistory;
/**
 * Adapts @reach/router history to work with our
 * { replace, push } interface.
 *
 * @param history globalHistory from @reach/router
 */
function adaptReachHistory(history) {
    if (history === cachedReachHistory && cachedAdaptedReachHistory != null) {
        return cachedAdaptedReachHistory;
    }
    var adaptedReachHistory = {
        replace: function (location) {
            history.navigate(location.protocol + "//" + location.host + location.pathname + location.search, { replace: true });
        },
        push: function (location) {
            history.navigate(location.protocol + "//" + location.host + location.pathname + location.search, { replace: false });
        },
        get location() {
            return history.location;
        },
    };
    cachedReachHistory = history;
    cachedAdaptedReachHistory = adaptedReachHistory;
    return adaptedReachHistory;
}
/**
 * Helper to produce the context value falling back to
 * window history and location if not provided.
 */
function getLocationProps(_a) {
    var _b = _a === void 0 ? {} : _a, history = _b.history, location = _b.location;
    var hasWindow = typeof window !== 'undefined';
    if (hasWindow) {
        if (!history) {
            history = adaptWindowHistory(window.history);
        }
        if (!location) {
            location = window.location;
        }
    }
    if (!location) {
        throw new Error("\n        Could not read the location. Is the router wired up correctly?\n      ");
    }
    return { history: history, location: location };
}
/**
 * Context provider for query params to have access to the
 * active routing system, enabling updates to the URL.
 */
function QueryParamProvider(_a) {
    var children = _a.children, ReactRouterRoute = _a.ReactRouterRoute, reachHistory = _a.reachHistory, history = _a.history, location = _a.location, stringifyOptions = _a.stringifyOptions;
    // cache the stringify options object so we users can just do
    // <QueryParamProvider stringifyOptions={{ encode: false }} />
    var stringifyOptionsRef = react.useRef(stringifyOptions);
    var hasNewStringifyOptions = !shallowEqual_shallowEqual(stringifyOptionsRef.current, stringifyOptions);
    var stringifyOptionsCached = hasNewStringifyOptions
        ? stringifyOptions
        : stringifyOptionsRef.current;
    react.useEffect(function () {
        stringifyOptionsRef.current = stringifyOptionsCached;
    }, [stringifyOptionsCached]);
    // if we have React Router, use it to get the context value
    if (ReactRouterRoute) {
        return (react.createElement(ReactRouterRoute, null, function (routeProps) {
            return (react.createElement(LocationProvider, QueryParamProvider_assign({ stringifyOptions: stringifyOptionsCached }, getLocationProps(routeProps)), children));
        }));
    }
    // if we are using reach router, use its history
    if (reachHistory) {
        return (react.createElement(LocationProvider, QueryParamProvider_assign({ stringifyOptions: stringifyOptionsCached }, getLocationProps({
            history: adaptReachHistory(reachHistory),
            location: location,
        })), children));
    }
    // neither reach nor react-router, so allow manual overrides
    return (react.createElement(LocationProvider, QueryParamProvider_assign({ stringifyOptions: stringifyOptionsCached }, getLocationProps({ history: history, location: location })), children));
}
/* harmony default export */ var esm_QueryParamProvider = ((/* unused pure expression or super */ null && (QueryParamProvider)));

;// CONCATENATED MODULE: ./node_modules/use-query-params/esm/index.js









/***/ }),

/***/ 10201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(10007);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29589:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// eslint-disable-next-line no-undef

module.exports = {
    defaultLocale: "en",
    // loadLocaleFrom: (lang, ns) => import(`./src/locales/${lang}/${ns}.json`).then((m) => m.default),
    loadLocaleFrom: function(lang, ns) {
        if (ns === "zone-text") {
            return __webpack_require__(70456)("./".concat(lang, "/zone-text.json"));
        }
        return __webpack_require__(19259)("./".concat(lang, "/").concat(ns, ".json"));
    },
    locales: [
        "it",
        "en",
        "fr"
    ],
    logBuild: false,
    pages: {
        "*": [
            "common",
            "header-menu",
            "auth-area",
            "privacy",
            "action-bar"
        ],
        "/[home]": [
            "houses-for-sale",
            "zones",
            "casavo-properties-banner"
        ],
        "/[home]/[city]": [
            "filter",
            "zones",
            "save-search",
            "canonical-filters",
            "favourites",
            "contact-form",
            "buyer-interest-flow",
            "priority",
            "suggested", 
        ],
        "/[home]/[city]/[...params]": [
            "filter",
            "zones",
            "save-search",
            "listing-detail",
            "furniture",
            "contact-form",
            "casavo-properties-banner",
            "canonical-filters",
            "zone-text",
            "favourites",
            "PropertyAdvantages",
            "buyer-interest-flow",
            "affordability",
            "priority",
            "suggested", 
        ],
        "/[home]/annonces/[uuid]": [
            "filter",
            "zones",
            "save-search",
            "listing-detail",
            "furniture",
            "contact-form",
            "casavo-properties-banner",
            "canonical-filters",
            "zone-text",
            "favourites",
            "PropertyAdvantages",
            "buyer-interest-flow",
            "affordability",
            "suggested",
            "priority", 
        ],
        "/[home]/annunci/[uuid]": [
            "filter",
            "zones",
            "save-search",
            "listing-detail",
            "furniture",
            "contact-form",
            "casavo-properties-banner",
            "canonical-filters",
            "zone-text",
            "favourites",
            "PropertyAdvantages",
            "buyer-interest-flow",
            "affordability",
            "suggested",
            "priority", 
        ],
        "/[home]/property/[uuid]": [
            "filter",
            "zones",
            "save-search",
            "listing-detail",
            "furniture",
            "contact-form",
            "casavo-properties-banner",
            "canonical-filters",
            "zone-text",
            "favourites",
            "PropertyAdvantages",
            "buyer-interest-flow",
            "affordability",
            "suggested",
            "priority", 
        ],
        "/affordability": [
            "affordability",
            "contact-form"
        ],
        "/almost-there": [
            "suggested",
            "common",
            "auth-area"
        ],
        "/i-wish/[city]": [
            "buyer-interest-flow",
            "contact-form",
            "zones"
        ],
        "/listings/[uuid]": [
            "listing-detail"
        ],
        "/priority": [
            "priority"
        ],
        "/priority/[slug]": [
            "priority",
            "listing-detail",
            "PropertyAdvantages",
            "auth-area",
            "contact-form",
            "suggested",
            "unicredit", 
        ],
        "/priority/[slug]/thankyou": [
            "priority"
        ],
        "/profile/favorites": [
            "favourites",
            "common"
        ],
        "/profile/suggested": [
            "suggested",
            "common",
            "zones",
            "main-search",
            "priority"
        ],
        "/profile/suggested/settings": [
            "buyer-interest-flow",
            "suggested",
            "common",
            "zones",
            "main-search"
        ],
        "/suggested": [
            "suggested"
        ],
        "/suggested/onboarding": [
            "suggested",
            "common",
            "main-search"
        ],
        "/suggested/onboarding/[city]": [
            "buyer-interest-flow",
            "zones",
            "suggested"
        ],
        "/unsubscribe": [
            "unsubscribe",
            "common",
            "priority"
        ]
    }
};


/***/ }),

/***/ 80378:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// NAMESPACE OBJECT: ./node_modules/@sentry/core/esm/integrations/index.js
var integrations_namespaceObject = {};
__webpack_require__.r(integrations_namespaceObject);
__webpack_require__.d(integrations_namespaceObject, {
  "FunctionToString": function() { return FunctionToString; },
  "InboundFilters": function() { return InboundFilters; },
  "LinkedErrors": function() { return LinkedErrors; }
});

// NAMESPACE OBJECT: ./node_modules/@sentry/browser/esm/integrations/index.js
var esm_integrations_namespaceObject = {};
__webpack_require__.r(esm_integrations_namespaceObject);
__webpack_require__.d(esm_integrations_namespaceObject, {
  "Breadcrumbs": function() { return Breadcrumbs; },
  "Dedupe": function() { return Dedupe; },
  "GlobalHandlers": function() { return GlobalHandlers; },
  "HttpContext": function() { return HttpContext; },
  "LinkedErrors": function() { return linkederrors_LinkedErrors; },
  "TryCatch": function() { return TryCatch; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(30919);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/utils/sdkMetadata.js


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */
function applySdkMetadata(options, name, names = [name], source = 'npm') {
  const metadata = options._metadata || {};

  if (!metadata.sdk) {
    metadata.sdk = {
      name: `sentry.javascript.${name}`,
      packages: names.map(name => ({
        name: `${source}:@sentry/${name}`,
        version: version/* SDK_VERSION */.J,
      })),
      version: version/* SDK_VERSION */.J,
    };
  }

  options._metadata = metadata;
}


//# sourceMappingURL=sdkMetadata.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/hasTracingEnabled.js
var hasTracingEnabled = __webpack_require__(23572);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(7052);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(3607);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(50437);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(25853);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/debug-build.js
var debug_build = __webpack_require__(92694);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/eventProcessors.js
var eventProcessors = __webpack_require__(21440);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(95091);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integration.js






const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};

  integrations.forEach(currentInstance => {
    const { name } = currentInstance;

    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });

  return Object.keys(integrationsByName).map(k => integrationsByName[k]);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });

  let integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    integrations = (0,misc/* arrayify */.lE)(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = findIndex(finalIntegrations, integration => integration.name === 'Debug');
  if (debugIndex !== -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(client, integrations) {
  const integrationIndex = {};

  integrations.forEach(integration => {
    // guard against empty provided integrations
    if (integration) {
      setupIntegration(client, integration, integrationIndex);
    }
  });

  return integrationIndex;
}

/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */
function afterSetupIntegrations(client, integrations) {
  for (const integration of integrations) {
    // guard against empty provided integrations
    if (integration && integration.afterAllSetup) {
      integration.afterAllSetup(client);
    }
  }
}

/** Setup a single integration.  */
function setupIntegration(client, integration, integrationIndex) {
  if (integrationIndex[integration.name]) {
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`Integration skipped because it was already installed: ${integration.name}`);
    return;
  }
  integrationIndex[integration.name] = integration;

  // `setupOnce` is only called the first time
  if (installedIntegrations.indexOf(integration.name) === -1) {
    // eslint-disable-next-line deprecation/deprecation
    integration.setupOnce(eventProcessors/* addGlobalEventProcessor */.cc, esm_hub/* getCurrentHub */.Gd);
    installedIntegrations.push(integration.name);
  }

  // `setup` is run for each client
  if (integration.setup && typeof integration.setup === 'function') {
    integration.setup(client);
  }

  if (client.on && typeof integration.preprocessEvent === 'function') {
    const callback = integration.preprocessEvent.bind(integration) ;
    client.on('preprocessEvent', (event, hint) => callback(event, hint, client));
  }

  if (client.addEventProcessor && typeof integration.processEvent === 'function') {
    const callback = integration.processEvent.bind(integration) ;

    const processor = Object.assign((event, hint) => callback(event, hint, client), {
      id: integration.name,
    });

    client.addEventProcessor(processor);
  }

  debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`Integration installed: ${integration.name}`);
}

/** Add an integration to the current hub's client. */
function addIntegration(integration) {
  const client = getClient();

  if (!client || !client.addIntegration) {
    DEBUG_BUILD && logger.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
    return;
  }

  client.addIntegration(integration);
}

// Polyfill for Array.findIndex(), which is not supported in ES5
function findIndex(arr, callback) {
  for (let i = 0; i < arr.length; i++) {
    if (callback(arr[i]) === true) {
      return i;
    }
  }

  return -1;
}

/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */
function convertIntegrationFnToClass(
  name,
  fn,
) {
  return Object.assign(
    function ConvertedIntegration(...args) {
      return fn(...args);
    },
    { id: name },
  ) ;
}

/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */
function defineIntegration(fn) {
  return fn;
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js




let originalFunctionToString;

const INTEGRATION_NAME = 'FunctionToString';

const SETUP_CLIENTS = new WeakMap();

const _functionToStringIntegration = (() => {
  return {
    name: INTEGRATION_NAME,
    setupOnce() {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      originalFunctionToString = Function.prototype.toString;

      // intrinsics (like Function.prototype) might be immutable in some environments
      // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function ( ...args) {
          const originalFunction = (0,object/* getOriginalFunction */.HK)(this);
          const context =
            SETUP_CLIENTS.has((0,esm_exports/* getClient */.s3)() ) && originalFunction !== undefined ? originalFunction : this;
          return originalFunctionToString.apply(context, args);
        };
      } catch (e) {
        // ignore errors here, just don't patch this
      }
    },
    setup(client) {
      SETUP_CLIENTS.set(client, true);
    },
  };
}) ;

/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */
const functionToStringIntegration = defineIntegration(_functionToStringIntegration);

/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const FunctionToString = convertIntegrationFnToClass(
  INTEGRATION_NAME,
  functionToStringIntegration,
) ;

// eslint-disable-next-line deprecation/deprecation


//# sourceMappingURL=functiontostring.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(80109);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  /^Cannot redefine property: googletag$/,
];

const DEFAULT_IGNORE_TRANSACTIONS = [
  /^.*\/healthcheck$/,
  /^.*\/healthy$/,
  /^.*\/live$/,
  /^.*\/ready$/,
  /^.*\/heartbeat$/,
  /^.*\/health$/,
  /^.*\/healthz$/,
];

/** Options for the InboundFilters integration */

const inboundfilters_INTEGRATION_NAME = 'InboundFilters';
const _inboundFiltersIntegration = ((options = {}) => {
  return {
    name: inboundfilters_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(event, _hint, client) {
      const clientOptions = client.getOptions();
      const mergedOptions = _mergeOptions(options, clientOptions);
      return _shouldDropEvent(event, mergedOptions) ? null : event;
    },
  };
}) ;

const inboundFiltersIntegration = defineIntegration(_inboundFiltersIntegration);

/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const InboundFilters = convertIntegrationFnToClass(
  inboundfilters_INTEGRATION_NAME,
  inboundFiltersIntegration,
)

;

function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...(internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS),
    ],
    ignoreTransactions: [
      ...(internalOptions.ignoreTransactions || []),
      ...(clientOptions.ignoreTransactions || []),
      ...(internalOptions.disableTransactionDefaults ? [] : DEFAULT_IGNORE_TRANSACTIONS),
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.warn */.kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  // If event.type, this is not an error
  if (event.type || !ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message => (0,string/* stringMatchesSomePattern */.U0)(message, ignoreErrors));
}

function _isIgnoredTransaction(event, ignoreTransactions) {
  if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) {
    return false;
  }

  const name = event.transaction;
  return name ? (0,string/* stringMatchesSomePattern */.U0)(name, ignoreTransactions) : false;
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : (0,string/* stringMatchesSomePattern */.U0)(url, denyUrls);
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : (0,string/* stringMatchesSomePattern */.U0)(url, allowUrls);
}

function _getPossibleEventMessages(event) {
  const possibleMessages = [];

  if (event.message) {
    possibleMessages.push(event.message);
  }

  let lastException;
  try {
    // @ts-expect-error Try catching to save bundle size
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    lastException = event.exception.values[event.exception.values.length - 1];
  } catch (e) {
    // try catching to save bundle size checking existence of variables
  }

  if (lastException) {
    if (lastException.value) {
      possibleMessages.push(lastException.value);
      if (lastException.type) {
        possibleMessages.push(`${lastException.type}: ${lastException.value}`);
      }
    }
  }

  if (debug_build/* DEBUG_BUILD */.X && possibleMessages.length === 0) {
    esm_logger/* logger.error */.kg.error(`Could not extract message for event ${(0,misc/* getEventDescription */.jH)(event)}`);
  }

  return possibleMessages;
}

function _isSentryError(event) {
  try {
    // @ts-expect-error can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-expect-error we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.error */.kg.error(`Cannot extract url for event ${(0,misc/* getEventDescription */.jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(34336);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/aggregate-errors.js



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */
function applyAggregateErrorsToEvent(
  exceptionFromErrorImplementation,
  parser,
  maxValueLimit = 250,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
    return;
  }

  // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
  const originalException =
    event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;

  // We only create exception grouping if there is an exception in the event.
  if (originalException) {
    event.exception.values = truncateAggregateExceptions(
      aggregateExceptionsFromError(
        exceptionFromErrorImplementation,
        parser,
        limit,
        hint.originalException ,
        key,
        event.exception.values,
        originalException,
        0,
      ),
      maxValueLimit,
    );
  }
}

function aggregateExceptionsFromError(
  exceptionFromErrorImplementation,
  parser,
  limit,
  error,
  key,
  prevExceptions,
  exception,
  exceptionId,
) {
  if (prevExceptions.length >= limit + 1) {
    return prevExceptions;
  }

  let newExceptions = [...prevExceptions];

  // Recursively call this function in order to walk down a chain of errors
  if ((0,is/* isInstanceOf */.V9)(error[key], Error)) {
    applyExceptionGroupFieldsForParentException(exception, exceptionId);
    const newException = exceptionFromErrorImplementation(parser, error[key]);
    const newExceptionId = newExceptions.length;
    applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
    newExceptions = aggregateExceptionsFromError(
      exceptionFromErrorImplementation,
      parser,
      limit,
      error[key],
      key,
      [newException, ...newExceptions],
      newException,
      newExceptionId,
    );
  }

  // This will create exception grouping for AggregateErrors
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
  if (Array.isArray(error.errors)) {
    error.errors.forEach((childError, i) => {
      if ((0,is/* isInstanceOf */.V9)(childError, Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, childError);
        const newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(
          exceptionFromErrorImplementation,
          parser,
          limit,
          childError,
          key,
          [newException, ...newExceptions],
          newException,
          newExceptionId,
        );
      }
    });
  }

  return newExceptions;
}

function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || { type: 'generic', handled: true };

  exception.mechanism = {
    ...exception.mechanism,
    ...(exception.type === 'AggregateError' && { is_exception_group: true }),
    exception_id: exceptionId,
  };
}

function applyExceptionGroupFieldsForChildException(
  exception,
  source,
  exceptionId,
  parentId,
) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || { type: 'generic', handled: true };

  exception.mechanism = {
    ...exception.mechanism,
    type: 'chained',
    source,
    exception_id: exceptionId,
    parent_id: parentId,
  };
}

/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */
function truncateAggregateExceptions(exceptions, maxValueLength) {
  return exceptions.map(exception => {
    if (exception.value) {
      exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
    }
    return exception;
  });
}


//# sourceMappingURL=aggregate-errors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/eventbuilder.js





/**
 * Extracts stack frames from the error.stack string
 */
function parseStackFrames(stackParser, error) {
  return stackParser(error.stack || '', 1);
}

/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */
function exceptionFromError(stackParser, error) {
  const exception = {
    type: error.name || error.constructor.name,
    value: error.message,
  };

  const frames = parseStackFrames(stackParser, error);
  if (frames.length) {
    exception.stacktrace = { frames };
  }

  return exception;
}

function getMessageForObject(exception) {
  if ('name' in exception && typeof exception.name === 'string') {
    let message = `'${exception.name}' captured as exception`;

    if ('message' in exception && typeof exception.message === 'string') {
      message += ` with message '${exception.message}'`;
    }

    return message;
  } else if ('message' in exception && typeof exception.message === 'string') {
    return exception.message;
  } else {
    // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${extractExceptionKeysForMessage(
      exception ,
    )}`;
  }
}

/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */
function eventFromUnknownInput(
  // eslint-disable-next-line deprecation/deprecation
  getHubOrClient,
  stackParser,
  exception,
  hint,
) {
  const client =
    typeof getHubOrClient === 'function'
      ? // eslint-disable-next-line deprecation/deprecation
        getHubOrClient().getClient()
      : getHubOrClient;

  let ex = exception;
  const providedMechanism =
    hint && hint.data && (hint.data ).mechanism;
  const mechanism = providedMechanism || {
    handled: true,
    type: 'generic',
  };

  let extras;

  if (!isError(exception)) {
    if (isPlainObject(exception)) {
      const normalizeDepth = client && client.getOptions().normalizeDepth;
      extras = { ['__serialized__']: normalizeToSize(exception , normalizeDepth) };

      const message = getMessageForObject(exception);
      ex = (hint && hint.syntheticException) || new Error(message);
      (ex ).message = message;
    } else {
      // This handles when someone does: `throw "something awesome";`
      // We use synthesized Error here so we can extract a (rough) stack trace.
      ex = (hint && hint.syntheticException) || new Error(exception );
      (ex ).message = exception ;
    }
    mechanism.synthetic = true;
  }

  const event = {
    exception: {
      values: [exceptionFromError(stackParser, ex )],
    },
  };

  if (extras) {
    event.extra = extras;
  }

  addExceptionTypeValue(event, undefined, undefined);
  addExceptionMechanism(event, mechanism);

  return {
    ...event,
    event_id: hint && hint.event_id,
  };
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const event = {
    event_id: hint && hint.event_id,
    level,
  };

  if (attachStacktrace && hint && hint.syntheticException) {
    const frames = parseStackFrames(stackParser, hint.syntheticException);
    if (frames.length) {
      event.exception = {
        values: [
          {
            value: message,
            stacktrace: { frames },
          },
        ],
      };
    }
  }

  if (isParameterizedString(message)) {
    const { __sentry_template_string__, __sentry_template_values__ } = message;

    event.logentry = {
      message: __sentry_template_string__,
      params: __sentry_template_values__,
    };
    return event;
  }

  event.message = message;
  return event;
}


//# sourceMappingURL=eventbuilder.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/linkederrors.js



const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

const linkederrors_INTEGRATION_NAME = 'LinkedErrors';

const _linkedErrorsIntegration = ((options = {}) => {
  const limit = options.limit || DEFAULT_LIMIT;
  const key = options.key || DEFAULT_KEY;

  return {
    name: linkederrors_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent(event, hint, client) {
      const options = client.getOptions();

      applyAggregateErrorsToEvent(
        exceptionFromError,
        options.stackParser,
        options.maxValueLength,
        key,
        limit,
        event,
        hint,
      );
    },
  };
}) ;

const linkedErrorsIntegration = defineIntegration(_linkedErrorsIntegration);

/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const LinkedErrors = convertIntegrationFnToClass(linkederrors_INTEGRATION_NAME, linkedErrorsIntegration)

;


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/index.js




/* eslint-disable deprecation/deprecation */
//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/index.js















































/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */
const Integrations = integrations_namespaceObject;


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(97193);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/helpers.js




const helpers_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      if (typeof wrapper === 'function') {
        return wrapper;
      } else {
        // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
        // that something messed with it. In that case we want to return the originally passed function.
        return fn;
      }
    }

    // We don't wanna wrap it twice
    if ((0,object/* getOriginalFunction */.HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  /* eslint-disable prefer-rest-params */
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function () {
    const args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      const wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      (0,esm_exports/* withScope */.$e)(scope => {
        scope.addEventProcessor(event => {
          if (options.mechanism) {
            (0,misc/* addExceptionTypeValue */.Db)(event, undefined, undefined);
            (0,misc/* addExceptionMechanism */.EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        (0,esm_exports/* captureException */.Tb)(ex);
      });

      throw ex;
    }
  };
  /* eslint-enable prefer-rest-params */

  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} // eslint-disable-line no-empty

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,object/* markFunctionWrapped */.$Q)(sentryWrapped, fn);

  (0,object/* addNonEnumerableProperty */.xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
    // eslint-disable-next-line no-empty
  } catch (_oO) {}

  return sentryWrapped;
}


//# sourceMappingURL=helpers.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/debug-build.js
var esm_debug_build = __webpack_require__(78027);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(12452);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/_handlers.js




// We keep the handlers globally
const handlers = {};
const instrumented = {};

/** Add a handler function. */
function addHandler(type, handler) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(handler);
}

/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */
function resetInstrumentationHandlers() {
  Object.keys(handlers).forEach(key => {
    handlers[key ] = undefined;
  });
}

/** Maybe run an instrumentation function, unless it was already called. */
function maybeInstrument(type, instrumentFn) {
  if (!instrumented[type]) {
    instrumentFn();
    instrumented[type] = true;
  }
}

/** Trigger handlers for a given instrumentation type. */
function triggerHandlers(type, data) {
  const typeHandlers = type && handlers[type];
  if (!typeHandlers) {
    return;
  }

  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      esm_debug_build/* DEBUG_BUILD */.X &&
        esm_logger/* logger.error */.kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,stacktrace/* getFunctionName */.$P)(handler)}\nError:`,
          e,
        );
    }
  }
}


//# sourceMappingURL=_handlers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/globalError.js



let _oldOnErrorHandler = null;

/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addGlobalErrorInstrumentationHandler(handler) {
  const type = 'error';
  addHandler(type, handler);
  maybeInstrument(type, instrumentError);
}

function instrumentError() {
  _oldOnErrorHandler = worldwide/* GLOBAL_OBJ.onerror */.n2.onerror;

  worldwide/* GLOBAL_OBJ.onerror */.n2.onerror = function (
    msg,
    url,
    line,
    column,
    error,
  ) {
    const handlerData = {
      column,
      error,
      line,
      msg,
      url,
    };
    triggerHandlers('error', handlerData);

    if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };

  worldwide/* GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ */.n2.onerror.__SENTRY_INSTRUMENTED__ = true;
}


//# sourceMappingURL=globalError.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/globalUnhandledRejection.js



let _oldOnUnhandledRejectionHandler = null;

/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addGlobalUnhandledRejectionInstrumentationHandler(
  handler,
) {
  const type = 'unhandledrejection';
  addHandler(type, handler);
  maybeInstrument(type, instrumentUnhandledRejection);
}

function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = worldwide/* GLOBAL_OBJ.onunhandledrejection */.n2.onunhandledrejection;

  worldwide/* GLOBAL_OBJ.onunhandledrejection */.n2.onunhandledrejection = function (e) {
    const handlerData = e;
    triggerHandlers('unhandledrejection', handlerData);

    if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };

  worldwide/* GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ */.n2.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}


//# sourceMappingURL=globalUnhandledRejection.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(51737);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/debug-build.js
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const debug_build_DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/normalize.js + 1 modules
var normalize = __webpack_require__(33386);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(47287);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js



/**
 * This function creates an exception from a JavaScript Error
 */
function eventbuilder_exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = eventbuilder_parseStackFrames(stackParser, ex);

  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  const client = (0,esm_exports/* getClient */.s3)();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  const event = {
    exception: {
      values: [
        {
          type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: getNonErrorObjectExceptionValue(exception, { isUnhandledRejection }),
        },
      ],
    },
    extra: {
      __serialized__: (0,normalize/* normalizeToSize */.Qy)(exception, normalizeDepth),
    },
  };

  if (syntheticException) {
    const frames = eventbuilder_parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [eventbuilder_exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function eventbuilder_parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';

  const popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventbuilder_eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventbuilder_eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * @hidden
 */
function eventbuilder_eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,is/* isErrorEvent */.VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,is/* isDOMError */.TX)(exception) || (0,is/* isDOMException */.fm)(exception )) {
    const domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      const name = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,misc/* addExceptionTypeValue */.Db)(event, message);
    }
    if ('code' in domException) {
      // eslint-disable-next-line deprecation/deprecation
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,is/* isError */.VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,misc/* addExceptionMechanism */.EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,misc/* addExceptionTypeValue */.Db)(event, `${exception}`, undefined);
  (0,misc/* addExceptionMechanism */.EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  message,
  syntheticException,
  attachStacktrace,
) {
  const event = {};

  if (attachStacktrace && syntheticException) {
    const frames = eventbuilder_parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: message, stacktrace: { frames } }],
      };
    }
  }

  if ((0,is/* isParameterizedString */.Le)(message)) {
    const { __sentry_template_string__, __sentry_template_values__ } = message;

    event.logentry = {
      message: __sentry_template_string__,
      params: __sentry_template_values__,
    };
    return event;
  }

  event.message = message;
  return event;
}

function getNonErrorObjectExceptionValue(
  exception,
  { isUnhandledRejection },
) {
  const keys = (0,object/* extractExceptionKeysForMessage */.zf)(exception);
  const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';

  // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
  // We still want to try to get a decent message for these cases
  if ((0,is/* isErrorEvent */.VW)(exception)) {
    return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
  }

  if ((0,is/* isEvent */.cO)(exception)) {
    const className = getObjectClassName(exception);
    return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
  }

  return `Object captured as ${captureType} with keys: ${keys}`;
}

function getObjectClassName(obj) {
  try {
    const prototype = Object.getPrototypeOf(obj);
    return prototype ? prototype.constructor.name : undefined;
  } catch (e) {
    // ignore errors here
  }
}


//# sourceMappingURL=eventbuilder.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js






/* eslint-disable @typescript-eslint/no-unsafe-member-access */

const globalhandlers_INTEGRATION_NAME = 'GlobalHandlers';

const _globalHandlersIntegration = ((options = {}) => {
  const _options = {
    onerror: true,
    onunhandledrejection: true,
    ...options,
  };

  return {
    name: globalhandlers_INTEGRATION_NAME,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(client) {
      if (_options.onerror) {
        _installGlobalOnErrorHandler(client);
        globalHandlerLog('onerror');
      }
      if (_options.onunhandledrejection) {
        _installGlobalOnUnhandledRejectionHandler(client);
        globalHandlerLog('onunhandledrejection');
      }
    },
  };
}) ;

const globalHandlersIntegration = defineIntegration(_globalHandlersIntegration);

/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const GlobalHandlers = convertIntegrationFnToClass(
  globalhandlers_INTEGRATION_NAME,
  globalHandlersIntegration,
)

;

function _installGlobalOnErrorHandler(client) {
  addGlobalErrorInstrumentationHandler(data => {
    const { stackParser, attachStacktrace } = getOptions();

    if ((0,esm_exports/* getClient */.s3)() !== client || shouldIgnoreOnError()) {
      return;
    }

    const { msg, url, line, column, error } = data;

    const event =
      error === undefined && (0,is/* isString */.HD)(msg)
        ? _eventFromIncompleteOnError(msg, url, line, column)
        : _enhanceEventWithInitialFrame(
            eventbuilder_eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false),
            url,
            line,
            column,
          );

    event.level = 'error';

    (0,esm_exports/* captureEvent */.eN)(event, {
      originalException: error,
      mechanism: {
        handled: false,
        type: 'onerror',
      },
    });
  });
}

function _installGlobalOnUnhandledRejectionHandler(client) {
  addGlobalUnhandledRejectionInstrumentationHandler(e => {
    const { stackParser, attachStacktrace } = getOptions();

    if ((0,esm_exports/* getClient */.s3)() !== client || shouldIgnoreOnError()) {
      return;
    }

    const error = _getUnhandledRejectionError(e );

    const event = (0,is/* isPrimitive */.pt)(error)
      ? _eventFromRejectionWithPrimitive(error)
      : eventbuilder_eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);

    event.level = 'error';

    (0,esm_exports/* captureEvent */.eN)(event, {
      originalException: error,
      mechanism: {
        handled: false,
        type: 'onunhandledrejection',
      },
    });
  });
}

function _getUnhandledRejectionError(error) {
  if ((0,is/* isPrimitive */.pt)(error)) {
    return error;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const e = error ;

  // dig the object of the rejection out of known event types
  try {
    // PromiseRejectionEvents store the object of the rejection under 'reason'
    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
    if ('reason' in e) {
      return e.reason;
    }

    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
    // https://github.com/getsentry/sentry-javascript/issues/2380
    else if ('detail' in e && 'reason' in e.detail) {
      return e.detail.reason;
    }
  } catch (e2) {} // eslint-disable-line no-empty

  return error;
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
  const ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
  let name = 'Error';

  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  const event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = (event.exception = event.exception || {});
  // event.exception.values
  const ev = (e.values = e.values || []);
  // event.exception.values[0]
  const ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  const ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  const ev0sf = (ev0s.frames = ev0s.frames || []);

  const colno = isNaN(parseInt(column, 10)) ? undefined : column;
  const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  const filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l4)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(`Global Handler attached: ${type}`);
}

function getOptions() {
  const client = (0,esm_exports/* getClient */.s3)();
  const options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return options;
}


//# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js




const DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'BroadcastChannel',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'SharedWorker',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

const trycatch_INTEGRATION_NAME = 'TryCatch';

const _browserApiErrorsIntegration = ((options = {}) => {
  const _options = {
    XMLHttpRequest: true,
    eventTarget: true,
    requestAnimationFrame: true,
    setInterval: true,
    setTimeout: true,
    ...options,
  };

  return {
    name: trycatch_INTEGRATION_NAME,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      if (_options.setTimeout) {
        (0,object/* fill */.hl)(helpers_WINDOW, 'setTimeout', _wrapTimeFunction);
      }

      if (_options.setInterval) {
        (0,object/* fill */.hl)(helpers_WINDOW, 'setInterval', _wrapTimeFunction);
      }

      if (_options.requestAnimationFrame) {
        (0,object/* fill */.hl)(helpers_WINDOW, 'requestAnimationFrame', _wrapRAF);
      }

      if (_options.XMLHttpRequest && "XMLHttpRequest" in helpers_WINDOW) {
        (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
      }

      const eventTargetOption = _options.eventTarget;
      if (eventTargetOption) {
        const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
        eventTarget.forEach(_wrapEventTarget);
      }
    },
  };
}) ;

const browserApiErrorsIntegration = defineIntegration(_browserApiErrorsIntegration);

/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const TryCatch = convertIntegrationFnToClass(
  trycatch_INTEGRATION_NAME,
  browserApiErrorsIntegration,
)

;

function _wrapTimeFunction(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    const originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        data: { function: (0,stacktrace/* getFunctionName */.$P)(original) },
        handled: false,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( callback) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: (0,stacktrace/* getFunctionName */.$P)(original),
          },
          handled: false,
          type: 'instrument',
        },
      }),
    ]);
  };
}

function _wrapXHR(originalSend) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,object/* fill */.hl)(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,stacktrace/* getFunctionName */.$P)(original),
              },
              handled: false,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          const originalFunction = (0,object/* getOriginalFunction */.HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,stacktrace/* getFunctionName */.$P)(originalFunction);
          }

          // Otherwise wrap directly
          return wrap(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

function _wrapEventTarget(target) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalObject = helpers_WINDOW ;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const proto = globalObject[target] && globalObject[target].prototype;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,object/* fill */.hl)(proto, 'addEventListener', function (original,)

 {
    return function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,stacktrace/* getFunctionName */.$P)(fn),
                target,
              },
              handled: false,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        wrap(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: (0,stacktrace/* getFunctionName */.$P)(fn),
              target,
            },
            handled: false,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,object/* fill */.hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        const wrappedEventHandler = fn ;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/console.js





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addConsoleInstrumentationHandler(handler) {
  const type = 'console';
  addHandler(type, handler);
  maybeInstrument(type, instrumentConsole);
}

function instrumentConsole() {
  if (!("console" in worldwide/* GLOBAL_OBJ */.n2)) {
    return;
  }

  esm_logger/* CONSOLE_LEVELS.forEach */.RU.forEach(function (level) {
    if (!(level in worldwide/* GLOBAL_OBJ.console */.n2.console)) {
      return;
    }

    (0,object/* fill */.hl)(worldwide/* GLOBAL_OBJ.console */.n2.console, level, function (originalConsoleMethod) {
      esm_logger/* originalConsoleMethods */.LD[level] = originalConsoleMethod;

      return function (...args) {
        const handlerData = { args, level };
        triggerHandlers('console', handlerData);

        const log = esm_logger/* originalConsoleMethods */.LD[level];
        log && log.apply(worldwide/* GLOBAL_OBJ.console */.n2.console, args);
      };
    });
  });
}


//# sourceMappingURL=console.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/dom.js





const dom_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;
const DEBOUNCE_DURATION = 1000;

let debounceTimerID;
let lastCapturedEventType;
let lastCapturedEventTargetId;

/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addClickKeypressInstrumentationHandler(handler) {
  const type = 'dom';
  addHandler(type, handler);
  maybeInstrument(type, instrumentDOM);
}

/** Exported for tests only. */
function instrumentDOM() {
  if (!dom_WINDOW.document) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  dom_WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  dom_WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (dom_WINDOW )[target] && (dom_WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,object/* fill */.hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount++;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,object/* fill */.hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount--;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */
function isSimilarToLastCapturedEvent(event) {
  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (event.type !== lastCapturedEventType) {
    return false;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (!event.target || (event.target )._sentryId !== lastCapturedEventTargetId) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return true;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(eventType, target) {
  // We are only interested in filtering `keypress` events for now.
  if (eventType !== 'keypress') {
    return false;
  }

  if (!target || !target.tagName) {
    return true;
  }

  // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
  // e.g.tabbing through elements, hotkeys, etc.
  if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
    return false;
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 */
function makeDOMEventHandler(
  handler,
  globalListener = false,
) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || event['_sentryCaptured']) {
      return;
    }

    const target = getEventTarget(event);

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event.type, target)) {
      return;
    }

    // Mark event as "seen"
    (0,object/* addNonEnumerableProperty */.xp)(event, '_sentryCaptured', true);

    if (target && !target._sentryId) {
      // Add UUID to event target so we can identify if
      (0,object/* addNonEnumerableProperty */.xp)(target, '_sentryId', (0,misc/* uuid4 */.DM)());
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
    // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    if (!isSimilarToLastCapturedEvent(event)) {
      const handlerData = { event, name, global: globalListener };
      handler(handlerData);
      lastCapturedEventType = event.type;
      lastCapturedEventTargetId = target ? target._sentryId : undefined;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = dom_WINDOW.setTimeout(() => {
      lastCapturedEventTargetId = undefined;
      lastCapturedEventType = undefined;
    }, DEBOUNCE_DURATION);
  };
}

function getEventTarget(event) {
  try {
    return event.target ;
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    return null;
  }
}


//# sourceMappingURL=dom.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/xhr.js





const xhr_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

const SENTRY_XHR_DATA_KEY = '__sentry_xhr_v3__';

/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addXhrInstrumentationHandler(handler) {
  const type = 'xhr';
  addHandler(type, handler);
  maybeInstrument(type, instrumentXHR);
}

/** Exported only for tests. */
function instrumentXHR() {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (!(xhr_WINDOW ).XMLHttpRequest) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  (0,object/* fill */.hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      const startTimestamp = Date.now();

      // open() should always be called with two or more arguments
      // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
      const method = (0,is/* isString */.HD)(args[0]) ? args[0].toUpperCase() : undefined;
      const url = parseUrl(args[1]);

      if (!method || !url) {
        return originalOpen.apply(this, args);
      }

      this[SENTRY_XHR_DATA_KEY] = {
        method,
        url,
        request_headers: {},
      };

      // if Sentry key appears in URL, don't capture it as a request
      if (method === 'POST' && url.match(/sentry_key/)) {
        this.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = () => {
        // For whatever reason, this is not the same instance here as from the outer method
        const xhrInfo = this[SENTRY_XHR_DATA_KEY];

        if (!xhrInfo) {
          return;
        }

        if (this.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = this.status;
          } catch (e) {
            /* do nothing */
          }

          const handlerData = {
            args: [method, url],
            endTimestamp: Date.now(),
            startTimestamp,
            xhr: this,
          };
          triggerHandlers('xhr', handlerData);
        }
      };

      if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') {
        (0,object/* fill */.hl)(this, 'onreadystatechange', function (original) {
          return function ( ...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(this, readyStateArgs);
          };
        });
      } else {
        this.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      // Intercepting `setRequestHeader` to access the request headers of XHR instance.
      // This will only work for user/library defined headers, not for the default/browser-assigned headers.
      // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
      (0,object/* fill */.hl)(this, 'setRequestHeader', function (original) {
        return function ( ...setRequestHeaderArgs) {
          const [header, value] = setRequestHeaderArgs;

          const xhrInfo = this[SENTRY_XHR_DATA_KEY];

          if (xhrInfo && (0,is/* isString */.HD)(header) && (0,is/* isString */.HD)(value)) {
            xhrInfo.request_headers[header.toLowerCase()] = value;
          }

          return original.apply(this, setRequestHeaderArgs);
        };
      });

      return originalOpen.apply(this, args);
    };
  });

  (0,object/* fill */.hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      const sentryXhrData = this[SENTRY_XHR_DATA_KEY];

      if (!sentryXhrData) {
        return originalSend.apply(this, args);
      }

      if (args[0] !== undefined) {
        sentryXhrData.body = args[0];
      }

      const handlerData = {
        args: [sentryXhrData.method, sentryXhrData.url],
        startTimestamp: Date.now(),
        xhr: this,
      };
      triggerHandlers('xhr', handlerData);

      return originalSend.apply(this, args);
    };
  });
}

function parseUrl(url) {
  if ((0,is/* isString */.HD)(url)) {
    return url;
  }

  try {
    // url can be a string or URL
    // but since URL is not available in IE11, we do not check for it,
    // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
    // If that fails, we just return undefined
    return (url ).toString();
  } catch (e2) {} // eslint-disable-line no-empty

  return undefined;
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/supports.js




// eslint-disable-next-line deprecation/deprecation
const supports_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-expect-error It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in supports_WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (typeof EdgeRuntime === 'string') {
    return true;
  }

  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(supports_WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = supports_WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      esm_debug_build/* DEBUG_BUILD */.X &&
        esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in supports_WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}


//# sourceMappingURL=supports.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/fetch.js





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addFetchInstrumentationHandler(handler) {
  const type = 'fetch';
  addHandler(type, handler);
  maybeInstrument(type, instrumentFetch);
}

function instrumentFetch() {
  if (!supportsNativeFetch()) {
    return;
  }

  (0,object/* fill */.hl)(worldwide/* GLOBAL_OBJ */.n2, 'fetch', function (originalFetch) {
    return function (...args) {
      const { method, url } = parseFetchArgs(args);

      const handlerData = {
        args,
        fetchData: {
          method,
          url,
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(worldwide/* GLOBAL_OBJ */.n2, args).then(
        (response) => {
          const finishedHandlerData = {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          };

          triggerHandlers('fetch', finishedHandlerData);
          return response;
        },
        (error) => {
          const erroredHandlerData = {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          };

          triggerHandlers('fetch', erroredHandlerData);
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

function hasProp(obj, prop) {
  return !!obj && typeof obj === 'object' && !!(obj )[prop];
}

function getUrlFromResource(resource) {
  if (typeof resource === 'string') {
    return resource;
  }

  if (!resource) {
    return '';
  }

  if (hasProp(resource, 'url')) {
    return resource.url;
  }

  if (resource.toString) {
    return resource.toString();
  }

  return '';
}

/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */
function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return { method: 'GET', url: '' };
  }

  if (fetchArgs.length === 2) {
    const [url, options] = fetchArgs ;

    return {
      url: getUrlFromResource(url),
      method: hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET',
    };
  }

  const arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg ),
    method: hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET',
  };
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/vendor/supportsHistory.js


// Based on https://github.com/angular/angular.js/pull/13945/files

// eslint-disable-next-line deprecation/deprecation
const supportsHistory_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chromeVar = (supportsHistory_WINDOW ).chrome;
  const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in supportsHistory_WINDOW && !!supportsHistory_WINDOW.history.pushState && !!supportsHistory_WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supportsHistory.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/history.js







const history_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

let lastHref;

/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addHistoryInstrumentationHandler(handler) {
  const type = 'history';
  addHandler(type, handler);
  maybeInstrument(type, instrumentHistory);
}

function instrumentHistory() {
  if (!supportsHistory()) {
    return;
  }

  const oldOnPopState = history_WINDOW.onpopstate;
  history_WINDOW.onpopstate = function ( ...args) {
    const to = history_WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    const handlerData = { from, to };
    triggerHandlers('history', handlerData);
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        const handlerData = { from, to };
        triggerHandlers('history', handlerData);
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,object/* fill */.hl)(history_WINDOW.history, 'pushState', historyReplacementFunction);
  (0,object/* fill */.hl)(history_WINDOW.history, 'replaceState', historyReplacementFunction);
}


//# sourceMappingURL=history.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

const validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/url.js
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function url_parseUrl(url) {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    search: query,
    hash: fragment,
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}

/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */
function getSanitizedUrlString(url) {
  const { protocol, host, path } = url;

  const filteredHost =
    (host &&
      host
        // Always filter out authority
        .replace(/^.*@/, '[filtered]:[filtered]@')
        // Don't show standard :80 (http) and :443 (https) ports to reduce the noise
        // TODO: Use new URL global if it exists
        .replace(/(:80)$/, '')
        .replace(/(:443)$/, '')) ||
    '';

  return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}


//# sourceMappingURL=url.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js





/* eslint-disable max-lines */

/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */
const MAX_ALLOWED_STRING_LENGTH = 1024;

const breadcrumbs_INTEGRATION_NAME = 'Breadcrumbs';

const _breadcrumbsIntegration = ((options = {}) => {
  const _options = {
    console: true,
    dom: true,
    fetch: true,
    history: true,
    sentry: true,
    xhr: true,
    ...options,
  };

  return {
    name: breadcrumbs_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    setup(client) {
      if (_options.console) {
        addConsoleInstrumentationHandler(_getConsoleBreadcrumbHandler(client));
      }
      if (_options.dom) {
        addClickKeypressInstrumentationHandler(_getDomBreadcrumbHandler(client, _options.dom));
      }
      if (_options.xhr) {
        addXhrInstrumentationHandler(_getXhrBreadcrumbHandler(client));
      }
      if (_options.fetch) {
        addFetchInstrumentationHandler(_getFetchBreadcrumbHandler(client));
      }
      if (_options.history) {
        addHistoryInstrumentationHandler(_getHistoryBreadcrumbHandler(client));
      }
      if (_options.sentry && client.on) {
        client.on('beforeSendEvent', _getSentryBreadcrumbHandler(client));
      }
    },
  };
}) ;

const breadcrumbsIntegration = defineIntegration(_breadcrumbsIntegration);

/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const Breadcrumbs = convertIntegrationFnToClass(breadcrumbs_INTEGRATION_NAME, breadcrumbsIntegration)

;

/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */
function _getSentryBreadcrumbHandler(client) {
  return function addSentryBreadcrumb(event) {
    if ((0,esm_exports/* getClient */.s3)() !== client) {
      return;
    }

    (0,esm_exports/* addBreadcrumb */.n_)(
      {
        category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
        event_id: event.event_id,
        level: event.level,
        message: (0,misc/* getEventDescription */.jH)(event),
      },
      {
        event,
      },
    );
  };
}

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
function _getDomBreadcrumbHandler(
  client,
  dom,
) {
  return function _innerDomBreadcrumb(handlerData) {
    if ((0,esm_exports/* getClient */.s3)() !== client) {
      return;
    }

    let target;
    let componentName;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    let maxStringLength =
      typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      debug_build_DEBUG_BUILD &&
        esm_logger/* logger.warn */.kg.warn(
          `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`,
        );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      const event = handlerData.event ;
      const element = _isEvent(event) ? event.target : event;

      target = (0,browser/* htmlTreeAsString */.Rt)(element, { keyAttrs, maxStringLength });
      componentName = (0,browser/* getComponentName */.iY)(element);
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    const breadcrumb = {
      category: `ui.${handlerData.name}`,
      message: target,
    };

    if (componentName) {
      breadcrumb.data = { 'ui.component_name': componentName };
    }

    (0,esm_exports/* addBreadcrumb */.n_)(breadcrumb, {
      event: handlerData.event,
      name: handlerData.name,
      global: handlerData.global,
    });
  };
}

/**
 * Creates breadcrumbs from console API calls
 */
function _getConsoleBreadcrumbHandler(client) {
  return function _consoleBreadcrumb(handlerData) {
    if ((0,esm_exports/* getClient */.s3)() !== client) {
      return;
    }

    const breadcrumb = {
      category: 'console',
      data: {
        arguments: handlerData.args,
        logger: 'console',
      },
      level: severityLevelFromString(handlerData.level),
      message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
    };

    if (handlerData.level === 'assert') {
      if (handlerData.args[0] === false) {
        breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
        breadcrumb.data.arguments = handlerData.args.slice(1);
      } else {
        // Don't capture a breadcrumb for passed assertions
        return;
      }
    }

    (0,esm_exports/* addBreadcrumb */.n_)(breadcrumb, {
      input: handlerData.args,
      level: handlerData.level,
    });
  };
}

/**
 * Creates breadcrumbs from XHR API calls
 */
function _getXhrBreadcrumbHandler(client) {
  return function _xhrBreadcrumb(handlerData) {
    if ((0,esm_exports/* getClient */.s3)() !== client) {
      return;
    }

    const { startTimestamp, endTimestamp } = handlerData;

    const sentryXhrData = handlerData.xhr[SENTRY_XHR_DATA_KEY];

    // We only capture complete, non-sentry requests
    if (!startTimestamp || !endTimestamp || !sentryXhrData) {
      return;
    }

    const { method, url, status_code, body } = sentryXhrData;

    const data = {
      method,
      url,
      status_code,
    };

    const hint = {
      xhr: handlerData.xhr,
      input: body,
      startTimestamp,
      endTimestamp,
    };

    (0,esm_exports/* addBreadcrumb */.n_)(
      {
        category: 'xhr',
        data,
        type: 'http',
      },
      hint,
    );
  };
}

/**
 * Creates breadcrumbs from fetch API calls
 */
function _getFetchBreadcrumbHandler(client) {
  return function _fetchBreadcrumb(handlerData) {
    if ((0,esm_exports/* getClient */.s3)() !== client) {
      return;
    }

    const { startTimestamp, endTimestamp } = handlerData;

    // We only capture complete fetch requests
    if (!endTimestamp) {
      return;
    }

    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
      // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
      return;
    }

    if (handlerData.error) {
      const data = handlerData.fetchData;
      const hint = {
        data: handlerData.error,
        input: handlerData.args,
        startTimestamp,
        endTimestamp,
      };

      (0,esm_exports/* addBreadcrumb */.n_)(
        {
          category: 'fetch',
          data,
          level: 'error',
          type: 'http',
        },
        hint,
      );
    } else {
      const response = handlerData.response ;
      const data = {
        ...handlerData.fetchData,
        status_code: response && response.status,
      };
      const hint = {
        input: handlerData.args,
        response,
        startTimestamp,
        endTimestamp,
      };
      (0,esm_exports/* addBreadcrumb */.n_)(
        {
          category: 'fetch',
          data,
          type: 'http',
        },
        hint,
      );
    }
  };
}

/**
 * Creates breadcrumbs from history API calls
 */
function _getHistoryBreadcrumbHandler(client) {
  return function _historyBreadcrumb(handlerData) {
    if ((0,esm_exports/* getClient */.s3)() !== client) {
      return;
    }

    let from = handlerData.from;
    let to = handlerData.to;
    const parsedLoc = url_parseUrl(helpers_WINDOW.location.href);
    let parsedFrom = from ? url_parseUrl(from) : undefined;
    const parsedTo = url_parseUrl(to);

    // Initial pushState doesn't provide `from` information
    if (!parsedFrom || !parsedFrom.path) {
      parsedFrom = parsedLoc;
    }

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
      to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
      from = parsedFrom.relative;
    }

    (0,esm_exports/* addBreadcrumb */.n_)({
      category: 'navigation',
      data: {
        from,
        to,
      },
    });
  };
}

function _isEvent(event) {
  return !!event && !!(event ).target;
}


//# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js




const linkederrors_DEFAULT_KEY = 'cause';
const linkederrors_DEFAULT_LIMIT = 5;

const integrations_linkederrors_INTEGRATION_NAME = 'LinkedErrors';

const linkederrors_linkedErrorsIntegration = ((options = {}) => {
  const limit = options.limit || linkederrors_DEFAULT_LIMIT;
  const key = options.key || linkederrors_DEFAULT_KEY;

  return {
    name: integrations_linkederrors_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent(event, hint, client) {
      const options = client.getOptions();

      applyAggregateErrorsToEvent(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        eventbuilder_exceptionFromError,
        options.stackParser,
        options.maxValueLength,
        key,
        limit,
        event,
        hint,
      );
    },
  };
}) ;

const integrations_linkederrors_linkedErrorsIntegration = defineIntegration(linkederrors_linkedErrorsIntegration);

/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const linkederrors_LinkedErrors = convertIntegrationFnToClass(integrations_linkederrors_INTEGRATION_NAME, integrations_linkederrors_linkedErrorsIntegration)

;


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/httpcontext.js



const httpcontext_INTEGRATION_NAME = 'HttpContext';

const _httpContextIntegration = (() => {
  return {
    name: httpcontext_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent(event) {
      // if none of the information we want exists, don't bother
      if (!helpers_WINDOW.navigator && !helpers_WINDOW.location && !helpers_WINDOW.document) {
        return;
      }

      // grab as much info as exists and add it to the event
      const url = (event.request && event.request.url) || (helpers_WINDOW.location && helpers_WINDOW.location.href);
      const { referrer } = helpers_WINDOW.document || {};
      const { userAgent } = helpers_WINDOW.navigator || {};

      const headers = {
        ...(event.request && event.request.headers),
        ...(referrer && { Referer: referrer }),
        ...(userAgent && { 'User-Agent': userAgent }),
      };
      const request = { ...event.request, ...(url && { url }), headers };

      event.request = request;
    },
  };
}) ;

const httpContextIntegration = defineIntegration(_httpContextIntegration);

/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const HttpContext = convertIntegrationFnToClass(httpcontext_INTEGRATION_NAME, httpContextIntegration)

;


//# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js




const dedupe_INTEGRATION_NAME = 'Dedupe';

const _dedupeIntegration = (() => {
  let previousEvent;

  return {
    name: dedupe_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(currentEvent) {
      // We want to ignore any non-error type events, e.g. transactions or replays
      // These should never be deduped, and also not be compared against as _previousEvent.
      if (currentEvent.type) {
        return currentEvent;
      }

      // Juuust in case something goes wrong
      try {
        if (dedupe_shouldDropEvent(currentEvent, previousEvent)) {
          debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
          return null;
        }
      } catch (_oO) {} // eslint-disable-line no-empty

      return (previousEvent = currentEvent);
    },
  };
}) ;

const dedupeIntegration = defineIntegration(_dedupeIntegration);

/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const Dedupe = convertIntegrationFnToClass(dedupe_INTEGRATION_NAME, dedupeIntegration)

;

function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-expect-error Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/index.js







/* eslint-disable deprecation/deprecation */
//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/index.js



























let windowIntegrations = {};

// This block is needed to add compatibility with the integrations packages when used with a CDN
if (helpers_WINDOW.Sentry && helpers_WINDOW.Sentry.Integrations) {
  windowIntegrations = helpers_WINDOW.Sentry.Integrations;
}

/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */
const INTEGRATIONS = {
  ...windowIntegrations,
  // eslint-disable-next-line deprecation/deprecation
  ...Integrations,
  ...esm_integrations_namespaceObject,
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/sdk.js





/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if (debug_build/* DEBUG_BUILD */.X) {
      esm_logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      (0,esm_logger/* consoleSandbox */.Cf)(() => {
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
      });
    }
  }
  const scope = (0,esm_exports/* getCurrentScope */.nZ)();
  scope.update(options.initialScope);

  const client = new clientClass(options);
  setCurrentClient(client);
  initializeClient(client);
}

/**
 * Make the given client the current client.
 */
function setCurrentClient(client) {
  // eslint-disable-next-line deprecation/deprecation
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  // eslint-disable-next-line deprecation/deprecation
  const top = hub.getStackTop();
  top.client = client;
  top.scope.setClient(client);
}

/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */
function initializeClient(client) {
  if (client.init) {
    client.init();
    // TODO v8: Remove this fallback
    // eslint-disable-next-line deprecation/deprecation
  } else if (client.setupIntegrations) {
    // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
  }
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/dsn.js



/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsn_dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    // This should be logged to the console
    (0,esm_logger/* consoleSandbox */.Cf)(() => {
      // eslint-disable-next-line no-console
      console.error(`Invalid Sentry Dsn: ${str}`);
    });
    return undefined;
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!esm_debug_build/* DEBUG_BUILD */.X) {
    return true;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  const hasMissingRequiredComponent = requiredComponents.find(component => {
    if (!dsn[component]) {
      esm_logger/* logger.error */.kg.error(`Invalid Sentry Dsn: ${component} missing`);
      return true;
    }
    return false;
  });

  if (hasMissingRequiredComponent) {
    return false;
  }

  if (!projectId.match(/^\d+$/)) {
    esm_logger/* logger.error */.kg.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    return false;
  }

  if (!isValidProtocol(protocol)) {
    esm_logger/* logger.error */.kg.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    return false;
  }

  if (port && isNaN(parseInt(port, 10))) {
    esm_logger/* logger.error */.kg.error(`Invalid Sentry Dsn: Invalid port ${port}`);
    return false;
  }

  return true;
}

/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */
function dsn_makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  if (!components || !validateDsn(components)) {
    return undefined;
  }
  return components;
}


//# sourceMappingURL=dsn.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/envelope.js




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  const envelopeItems = envelope[1];

  for (const envelopeItem of envelopeItems) {
    const envelopeItemType = envelopeItem[0].type;
    const result = callback(envelopeItem, envelopeItemType);

    if (result) {
      return true;
    }
  }

  return false;
}

/**
 * Returns true if the envelope contains any of the given envelope item types
 */
function envelopeContainsItemType(envelope, types) {
  return forEachEnvelopeItem(envelope, (_, type) => types.includes(type));
}

/**
 * Encode a string to UTF8.
 */
function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (const item of items) {
    const [itemHeaders, payload] = item;

    append(`\n${JSON.stringify(itemHeaders)}\n`);

    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify((0,normalize/* normalize */.Fv)(payload));
      }
      append(stringifiedPayload);
    }
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Parses an envelope
 */
function parseEnvelope(
  env,
  textEncoder,
  textDecoder,
) {
  let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;

  function readBinary(length) {
    const bin = buffer.subarray(0, length);
    // Replace the buffer with the remaining data excluding trailing newline
    buffer = buffer.subarray(length + 1);
    return bin;
  }

  function readJson() {
    let i = buffer.indexOf(0xa);
    // If we couldn't find a newline, we must have found the end of the buffer
    if (i < 0) {
      i = buffer.length;
    }

    return JSON.parse(textDecoder.decode(readBinary(i))) ;
  }

  const envelopeHeader = readJson();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const items = [];

  while (buffer.length) {
    const itemHeader = readJson();
    const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;

    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
  }

  return [envelopeHeader, items];
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,object/* dropUndefinedKeys */.Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
  profile: 'profile',
  replay_event: 'replay',
  replay_recording: 'replay',
  check_in: 'monitor',
  feedback: 'feedback',
  span: 'span',
  statsd: 'metric_bucket',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}

/** Extracts the minimal SDK info from the metadata or an events */
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent || !metadataOrEvent.sdk) {
    return;
  }
  const { name, version } = metadataOrEvent.sdk;
  return { name, version };
}

/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */
function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && dsn && { dsn: dsn_dsnToString(dsn) }),
    ...(dynamicSamplingContext && {
      trace: (0,object/* dropUndefinedKeys */.Jr)({ ...dynamicSamplingContext }),
    }),
  };
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;
    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/api.js


const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,object/* urlEncode */._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function api_getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  const dsn = makeDsn(dsnLike);
  if (!dsn) {
    return '';
  }

  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'onClose') {
      continue;
    }

    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/envelope.js


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && dsn && { dsn: dsn_dsnToString(dsn) }),
  };

  const envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session.toJSON()];

  return createEnvelope(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);

  /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */
  const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  const envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  const eventItem = [{ type: eventType }, event];
  return createEnvelope(envelopeHeaders, [eventItem]);
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/metrics/utils.js


/**
 * Generate bucket key from metric properties.
 */
function getBucketKey(
  metricType,
  name,
  unit,
  tags,
) {
  const stringifiedTags = Object.entries(dropUndefinedKeys(tags)).sort((a, b) => a[0].localeCompare(b[0]));
  return `${metricType}${name}${unit}${stringifiedTags}`;
}

/* eslint-disable no-bitwise */
/**
 * Simple hash function for strings.
 */
function simpleHash(s) {
  let rv = 0;
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    rv = (rv << 5) - rv + c;
    rv &= rv;
  }
  return rv >>> 0;
}
/* eslint-enable no-bitwise */

/**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */
function serializeMetricBuckets(metricBucketItems) {
  let out = '';
  for (const item of metricBucketItems) {
    const tagEntries = Object.entries(item.tags);
    const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value]) => `${key}:${value}`).join(',')}` : '';
    out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
  }
  return out;
}

/** Sanitizes units */
function sanitizeUnit(unit) {
  return unit.replace(/[^\w]+/gi, '_');
}

/** Sanitizes metric keys */
function sanitizeMetricKey(key) {
  return key.replace(/[^\w\-.]+/gi, '_');
}

function sanitizeTagKey(key) {
  return key.replace(/[^\w\-./]+/gi, '');
}

const tagValueReplacements = (/* unused pure expression or super */ null && ([
  ['\n', '\\n'],
  ['\r', '\\r'],
  ['\t', '\\t'],
  ['\\', '\\\\'],
  ['|', '\\u{7c}'],
  [',', '\\u{2c}'],
]));

function getCharOrReplacement(input) {
  for (const [search, replacement] of tagValueReplacements) {
    if (input === search) {
      return replacement;
    }
  }

  return input;
}

function sanitizeTagValue(value) {
  return [...value].reduce((acc, char) => acc + getCharOrReplacement(char), '');
}

/**
 * Sanitizes tags.
 */
function sanitizeTags(unsanitizedTags) {
  const tags = {};
  for (const key in unsanitizedTags) {
    if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
      const sanitizedKey = sanitizeTagKey(key);
      tags[sanitizedKey] = sanitizeTagValue(String(unsanitizedTags[key]));
    }
  }
  return tags;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/metrics/envelope.js



/**
 * Create envelope from a metric aggregate.
 */
function createMetricEnvelope(
  metricBucketItems,
  dsn,
  metadata,
  tunnel,
) {
  const headers = {
    sent_at: new Date().toISOString(),
  };

  if (metadata && metadata.sdk) {
    headers.sdk = {
      name: metadata.sdk.name,
      version: metadata.sdk.version,
    };
  }

  if (!!tunnel && dsn) {
    headers.dsn = dsn_dsnToString(dsn);
  }

  const item = createMetricEnvelopeItem(metricBucketItems);
  return createEnvelope(headers, [item]);
}

function createMetricEnvelopeItem(metricBucketItems) {
  const payload = serializeMetricBuckets(metricBucketItems);
  const metricHeaders = {
    type: 'statsd',
    length: payload.length,
  };
  return [metricHeaders, payload];
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/session.js
var esm_session = __webpack_require__(97353);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js
var tracing_dynamicSamplingContext = __webpack_require__(60292);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/prepareEvent.js
var prepareEvent = __webpack_require__(4831);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/baseclient.js












const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */

  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */

  /** Indicates whether this client's integrations have been set up. */

  /** Number of calls being processed */

  /** Holds flushable  */

  // eslint-disable-next-line @typescript-eslint/ban-types

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {
    this._options = options;
    this._integrations = {};
    this._integrationsInitialized = false;
    this._numProcessing = 0;
    this._outcomes = {};
    this._hooks = {};
    this._eventProcessors = [];

    if (options.dsn) {
      this._dsn = dsn_makeDsn(options.dsn);
    } else {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn('No DSN provided, client will not send events.');
    }

    if (this._dsn) {
      const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    const eventMessage = (0,is/* isParameterizedString */.Le)(message) ? message : String(message);

    const promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(eventMessage, level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
    const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;

    this._process(
      this._captureEvent(event, hint, capturedSpanScope || scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!(typeof session.release === 'string')) {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
   getSdkMetadata() {
    return this._options._metadata;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    const transport = this._transport;
    if (transport) {
      if (this.metricsAggregator) {
        this.metricsAggregator.flush();
      }
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      if (this.metricsAggregator) {
        this.metricsAggregator.close();
      }
      return result;
    });
  }

  /** Get all installed event processors. */
   getEventProcessors() {
    return this._eventProcessors;
  }

  /** @inheritDoc */
   addEventProcessor(eventProcessor) {
    this._eventProcessors.push(eventProcessor);
  }

  /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */
   setupIntegrations(forceInitialize) {
    if ((forceInitialize && !this._integrationsInitialized) || (this._isEnabled() && !this._integrationsInitialized)) {
      this._setupIntegrations();
    }
  }

  /** @inheritdoc */
   init() {
    if (this._isEnabled()) {
      this._setupIntegrations();
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */
   getIntegrationById(integrationId) {
    return this.getIntegrationByName(integrationId);
  }

  /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */
   getIntegrationByName(integrationName) {
    return this._integrations[integrationName] ;
  }

  /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   addIntegration(integration) {
    const isAlreadyInstalled = this._integrations[integration.name];

    // This hook takes care of only installing if not already installed
    setupIntegration(this, integration, this._integrations);
    // Here we need to check manually to make sure to not run this multiple times
    if (!isAlreadyInstalled) {
      afterSetupIntegrations(this, [integration]);
    }
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    this.emit('beforeSendEvent', event, hint);

    let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

    for (const attachment of hint.attachments || []) {
      env = addItemToEnvelope(
        env,
        createAttachmentEnvelopeItem(
          attachment,
          this._options.transportOptions && this._options.transportOptions.textEncoder,
        ),
      );
    }

    const promise = this._sendEnvelope(env);
    if (promise) {
      promise.then(sendResponse => this.emit('afterSendEvent', event, sendResponse), null);
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);

    // _sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this._sendEnvelope(env);
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category, eventOrCount) {
    if (this._options.sendClientReports) {
      // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
      // If event is passed as third argument, we assume this is a count of 1
      const count = typeof eventOrCount === 'number' ? eventOrCount : 1;

      // We want to track each category (error, transaction, session, replay_event) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
      this._outcomes[key] = (this._outcomes[key] || 0) + count;
    }
  }

  /**
   * @inheritDoc
   */
   captureAggregateMetrics(metricBucketItems) {
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
    const metricsEnvelope = createMetricEnvelope(
      metricBucketItems,
      this._dsn,
      this._options._metadata,
      this._options.tunnel,
    );

    // _sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this._sendEnvelope(metricsEnvelope);
  }

  // Keep on() & emit() signatures in sync with types' client.ts interface
  /* eslint-disable @typescript-eslint/unified-signatures */

  /** @inheritdoc */

  /** @inheritdoc */
   on(hook, callback) {
    if (!this._hooks[hook]) {
      this._hooks[hook] = [];
    }

    // @ts-expect-error We assue the types are correct
    this._hooks[hook].push(callback);
  }

  /** @inheritdoc */

  /** @inheritdoc */
   emit(hook, ...rest) {
    if (this._hooks[hook]) {
      this._hooks[hook].forEach(callback => callback(...rest));
    }
  }

  /* eslint-enable @typescript-eslint/unified-signatures */

  /** Setup integrations for this client. */
   _setupIntegrations() {
    const { integrations } = this._options;
    this._integrations = setupIntegrations(this, integrations);
    afterSetupIntegrations(this, integrations);

    // TODO v8: We don't need this flag anymore
    this._integrationsInitialized = true;
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    const exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      const tick = 1;

      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a transport is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._transport !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(
    event,
    hint,
    scope,
    isolationScope = (0,esm_hub/* getIsolationScope */.aF)(),
  ) {
    const options = this.getOptions();
    const integrations = Object.keys(this._integrations);
    if (!hint.integrations && integrations.length > 0) {
      hint.integrations = integrations;
    }

    this.emit('preprocessEvent', event, hint);

    return (0,prepareEvent/* prepareEvent */.R)(options, event, hint, scope, this, isolationScope).then(evt => {
      if (evt === null) {
        return evt;
      }

      const propagationContext = {
        ...isolationScope.getPropagationContext(),
        ...(scope ? scope.getPropagationContext() : undefined),
      };

      const trace = evt.contexts && evt.contexts.trace;
      if (!trace && propagationContext) {
        const { traceId: trace_id, spanId, parentSpanId, dsc } = propagationContext;
        evt.contexts = {
          trace: {
            trace_id,
            span_id: spanId,
            parent_span_id: parentSpanId,
          },
          ...evt.contexts,
        };

        const dynamicSamplingContext = dsc ? dsc : (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(trace_id, this, scope);

        evt.sdkProcessingMetadata = {
          dynamicSamplingContext,
          ...evt.sdkProcessingMetadata,
        };
      }
      return evt;
    });
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if (debug_build/* DEBUG_BUILD */.X) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          const sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            esm_logger/* logger.log */.kg.log(sentryError.message);
          } else {
            esm_logger/* logger.warn */.kg.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const options = this.getOptions();
    const { sampleRate } = options;

    const isTransaction = isTransactionEvent(event);
    const isError = isErrorEvent(event);
    const eventType = event.type || 'error';
    const beforeSendLabel = `before send for type \`${eventType}\``;

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error', event);
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new SentryError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;

    const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
    const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;

    return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', dataCategory, event);
          throw new SentryError('An event processor returned `null`, will not send event.', 'log');
        }

        const isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException) {
          return prepared;
        }

        const result = processBeforeSend(options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', dataCategory, event);
          if (isTransaction) {
            const spans = event.spans || [];
            // the transaction itself counts as one span, plus all the child spans that are added
            const spanCount = 1 + spans.length;
            this.recordDroppedEvent('before_send', 'span', spanCount);
          }
          throw new SentryError(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
        }

        const session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        if (isTransaction) {
          const spanCountBefore =
            (processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing) ||
            0;
          const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;

          const droppedSpanCount = spanCountBefore - spanCountAfter;
          if (droppedSpanCount > 0) {
            this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
          }
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        const transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          const source = 'custom';
          processedEvent.transaction_info = {
            ...transactionInfo,
            source,
          };
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof SentryError) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason,
        });
        throw new SentryError(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing++;
    void promise.then(
      value => {
        this._numProcessing--;
        return value;
      },
      reason => {
        this._numProcessing--;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    this.emit('beforeEnvelope', envelope);

    if (this._isEnabled() && this._transport) {
      return this._transport.send(envelope).then(null, reason => {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(
  beforeSendResult,
  beforeSendLabel,
) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if ((0,is/* isThenable */.J8)(beforeSendResult)) {
    return beforeSendResult.then(
      event => {
        if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
          throw new SentryError(invalidValueError);
        }
        return event;
      },
      e => {
        throw new SentryError(`${beforeSendLabel} rejected with ${e}`);
      },
    );
  } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
    throw new SentryError(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(
  options,
  event,
  hint,
) {
  const { beforeSend, beforeSendTransaction } = options;

  if (isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }

  if (isTransactionEvent(event) && beforeSendTransaction) {
    if (event.spans) {
      // We store the # of spans before processing in SDK metadata,
      // so we can compare it afterwards to determine how many spans were dropped
      const spanCountBefore = event.spans.length;
      event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        spanCountBeforeProcessing: spanCountBefore,
      };
    }
    return beforeSendTransaction(event, hint);
  }

  return event;
}

function isErrorEvent(event) {
  return event.type === undefined;
}

function isTransactionEvent(event) {
  return event.type === 'transaction';
}

/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */
function addEventProcessor(callback) {
  const client = getClient();

  if (!client || !client.addEventProcessor) {
    return;
  }

  client.addEventProcessor(callback);
}


//# sourceMappingURL=baseclient.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * Get source of SDK.
 */
function getSDKSource() {
  // @ts-expect-error "npm" is injected by rollup during build process
  return "npm";
}


//# sourceMappingURL=env.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var esm_time = __webpack_require__(45939);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  const clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,esm_time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/userfeedback.js


/**
 * Creates an envelope from a user feedback.
 */
function createUserFeedbackEnvelope(
  feedback,
  {
    metadata,
    tunnel,
    dsn,
  }

,
) {
  const headers = {
    event_id: feedback.event_id,
    sent_at: new Date().toISOString(),
    ...(metadata &&
      metadata.sdk && {
        sdk: {
          name: metadata.sdk.name,
          version: metadata.sdk.version,
        },
      }),
    ...(!!tunnel && !!dsn && { dsn: dsn_dsnToString(dsn) }),
  };
  const item = createUserFeedbackEnvelopeItem(feedback);

  return createEnvelope(headers, [item]);
}

function createUserFeedbackEnvelopeItem(feedback) {
  const feedbackHeaders = {
    type: 'user_report',
  };
  return [feedbackHeaders, feedback];
}


//# sourceMappingURL=userfeedback.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/client.js







/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    const sdkSource = helpers_WINDOW.SENTRY_SDK_SOURCE || getSDKSource();
    applySdkMetadata(options, 'browser', ['browser'], sdkSource);

    super(options);

    if (options.sendClientReports && helpers_WINDOW.document) {
      helpers_WINDOW.document.addEventListener('visibilitychange', () => {
        if (helpers_WINDOW.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level = 'info',
    hint,
  ) {
    return eventbuilder_eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * Sends user feedback to Sentry.
   */
   captureUserFeedback(feedback) {
    if (!this._isEnabled()) {
      debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture user feedback.');
      return;
    }

    const envelope = createUserFeedbackEnvelope(feedback, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel,
    });

    // _sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this._sendEnvelope(envelope);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    const outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    // This is really the only place where we want to check for a DSN and only send outcomes then
    if (!this._dsn) {
      debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsn_dsnToString(this._dsn));

    // _sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this._sendEnvelope(envelope);
  }
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js


// global reference to slice
const UNKNOWN_FUNCTION = '?';

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func,
    in_app: true, // All browser frames are considered in_app
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex =
  /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const chromeStackParserFn = line => {
  const parts = chromeRegex.exec(line);

  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

const chromeStackLineParser = [CHROME_PRIORITY, chromeStackParserFn];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

const gecko = line => {
  const parts = geckoREgex.exec(line);

  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

const geckoStackLineParser = [GECKO_PRIORITY, gecko];

const winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

const winjs = line => {
  const parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

const winjsStackLineParser = [WINJS_PRIORITY, winjs];

const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

const opera10StackLineParser = [OPERA10_PRIORITY, opera10];

const opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

const opera11StackLineParser = [OPERA11_PRIORITY, opera11];

const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

const defaultStackParser = (0,stacktrace/* createStackParser */.pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */
function disabledUntil(limits, dataCategory) {
  return limits[dataCategory] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, dataCategory, now = Date.now()) {
  return disabledUntil(limits, dataCategory) > now;
}

/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  const updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          if (category === 'metric_bucket') {
            // namespaces will be present when category === 'metric_bucket'
            if (!namespaces || namespaces.split(';').includes('custom')) {
              updatedRateLimits[category] = now + delay;
            }
          } else {
            updatedRateLimits[category] = now + delay;
          }
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/base.js



const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(
    options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE,
  ),
) {
  let rateLimits = {};
  const flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    forEachEnvelopeItem(envelope, (item, type) => {
      const dataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, dataCategory)) {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (item, type) => {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type), event);
      });
    };

    const requestTask = () =>
      makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = updateRateLimits(rateLimits, response);
          return response;
        },
        error => {
          recordEnvelopeLoss('network_error');
          throw error;
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof SentryError) {
          debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.error */.kg.error('Skipped sending event because buffer is full.');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  // We use this to identifify if the transport is the base transport
  // TODO (v8): Remove this again as we'll no longer need it
  send.__sentry__baseTransport__ = true;

  return {
    send,
    flush,
  };
}

function getEventForEnvelopeItem(item, type) {
  if (type !== 'event' && type !== 'transaction') {
    return undefined;
  }

  return Array.isArray(item) ? (item )[1] : undefined;
}


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/utils.js




let cachedFetchImpl = undefined;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  /* eslint-disable @typescript-eslint/unbound-method */

  // Fast path to avoid DOM I/O
  if (isNativeFetch(helpers_WINDOW.fetch)) {
    return (cachedFetchImpl = helpers_WINDOW.fetch.bind(helpers_WINDOW));
  }

  const document = helpers_WINDOW.document;
  let fetchImpl = helpers_WINDOW.fetch;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(helpers_WINDOW));
  /* eslint-enable @typescript-eslint/unbound-method */
}

/** Clears cached fetch impl */
function clearCachedFetchImplementation() {
  cachedFetchImpl = undefined;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  let pendingBodySize = 0;
  let pendingCount = 0;

  function makeRequest(request) {
    const requestSize = request.body.length;
    pendingBodySize += requestSize;
    pendingCount++;

    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: pendingBodySize <= 60000 && pendingCount < 15,
      ...options.fetchOptions,
    };

    try {
      return nativeFetch(options.url, requestOptions).then(response => {
        pendingBodySize -= requestSize;
        pendingCount--;
        return {
          statusCode: response.status,
          headers: {
            'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
            'retry-after': response.headers.get('Retry-After'),
          },
        };
      });
    } catch (e) {
      clearCachedFetchImplementation();
      pendingBodySize -= requestSize;
      pendingCount--;
      return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
    }
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
const XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (const header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/sdk.js















/** @deprecated Use `getDefaultIntegrations(options)` instead. */
const defaultIntegrations = [
  inboundFiltersIntegration(),
  functionToStringIntegration(),
  browserApiErrorsIntegration(),
  breadcrumbsIntegration(),
  globalHandlersIntegration(),
  integrations_linkederrors_linkedErrorsIntegration(),
  dedupeIntegration(),
  httpContextIntegration(),
];

/** Get the default integrations for the browser SDK. */
function getDefaultIntegrations(_options) {
  // We return a copy of the defaultIntegrations here to avoid mutating this
  return [
    // eslint-disable-next-line deprecation/deprecation
    ...defaultIntegrations,
  ];
}

/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = getDefaultIntegrations();
  }
  if (options.release === undefined) {
    // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
    if (typeof __SENTRY_RELEASE__ === 'string') {
      options.release = __SENTRY_RELEASE__;
    }

    // This supports the variable that sentry-webpack-plugin injects
    if (helpers_WINDOW.SENTRY_RELEASE && helpers_WINDOW.SENTRY_RELEASE.id) {
      options.release = helpers_WINDOW.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  const clientOptions = {
    ...options,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup(options),
    transport: options.transport || (supportsFetch() ? makeFetchTransport : makeXHRTransport),
  };

  initAndBind(BrowserClient, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

const showReportDialog = (
  // eslint-disable-next-line deprecation/deprecation
  options = {},
  // eslint-disable-next-line deprecation/deprecation
  hub = getCurrentHub(),
) => {
  // doesn't work without a document (React Native)
  if (!WINDOW.document) {
    DEBUG_BUILD && logger.error('Global document not defined in showReportDialog call');
    return;
  }

  // eslint-disable-next-line deprecation/deprecation
  const { client, scope } = hub.getStackTop();
  const dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    DEBUG_BUILD && logger.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
  }

  const script = WINDOW.document.createElement('script');
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.src = getReportDialogEndpoint(dsn, options);

  if (options.onLoad) {
    script.onload = options.onLoad;
  }

  const { onClose } = options;
  if (onClose) {
    const reportDialogClosedMessageHandler = (event) => {
      if (event.data === '__sentry_reportdialog_closed__') {
        try {
          onClose();
        } finally {
          WINDOW.removeEventListener('message', reportDialogClosedMessageHandler);
        }
      }
    };
    WINDOW.addEventListener('message', reportDialogClosedMessageHandler);
  }

  const injectionPoint = WINDOW.document.head || WINDOW.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    DEBUG_BUILD && logger.error('Not injecting report dialog. No injection point found in HTML');
  }
};

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
  return wrap$1(fn)();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  if (typeof helpers_WINDOW.document === 'undefined') {
    debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  (0,esm_exports/* startSession */.yj)({ ignoreDuration: true });
  (0,esm_exports/* captureSession */.cg)();

  // We want to create a session for every navigation as well
  addHistoryInstrumentationHandler(({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (from !== undefined && from !== to) {
      (0,esm_exports/* startSession */.yj)({ ignoreDuration: true });
      (0,esm_exports/* captureSession */.cg)();
    }
  });
}

/**
 * Captures user feedback and sends it to Sentry.
 */
function captureUserFeedback(feedback) {
  const client = getClient();
  if (client) {
    client.captureUserFeedback(feedback);
  }
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/sdk.js



/**
 * Inits the React SDK
 */
function sdk_init(options) {
  const opts = {
    ...options,
  };

  applySdkMetadata(opts, 'react');

  init(opts);
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/getVercelEnv.js
/* provided dependency */ var process = __webpack_require__(47859);
/**
 * Returns an environment setting value determined by Vercel's `VERCEL_ENV` environment variable.
 *
 * @param isClient Flag to indicate whether to use the `NEXT_PUBLIC_` prefixed version of the environment variable.
 */
function getVercelEnv(isClient) {
  const vercelEnvVar = isClient ? process.env.NEXT_PUBLIC_VERCEL_ENV : process.env.VERCEL_ENV;
  return vercelEnvVar ? `vercel-${vercelEnvVar}` : undefined;
}


//# sourceMappingURL=getVercelEnv.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(56524);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/metrics/metric-summary.js






/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */

let SPAN_METRIC_SUMMARY;

function getMetricStorageForSpan(span) {
  return SPAN_METRIC_SUMMARY ? SPAN_METRIC_SUMMARY.get(span) : undefined;
}

/**
 * Fetches the metric summary if it exists for the passed span
 */
function getMetricSummaryJsonForSpan(span) {
  const storage = getMetricStorageForSpan(span);

  if (!storage) {
    return undefined;
  }
  const output = {};

  for (const [, [exportKey, summary]] of storage) {
    if (!output[exportKey]) {
      output[exportKey] = [];
    }

    output[exportKey].push((0,object/* dropUndefinedKeys */.Jr)(summary));
  }

  return output;
}

/**
 * Updates the metric summary on the currently active span
 */
function updateMetricSummaryOnActiveSpan(
  metricType,
  sanitizedName,
  value,
  unit,
  tags,
  bucketKey,
) {
  const span = getActiveSpan();
  if (span) {
    const storage = getMetricStorageForSpan(span) || new Map();

    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);

    if (bucketItem) {
      const [, summary] = bucketItem;
      storage.set(bucketKey, [
        exportKey,
        {
          min: Math.min(summary.min, value),
          max: Math.max(summary.max, value),
          count: (summary.count += 1),
          sum: (summary.sum += value),
          tags: summary.tags,
        },
      ]);
    } else {
      storage.set(bucketKey, [
        exportKey,
        {
          min: value,
          max: value,
          count: 1,
          sum: value,
          tags,
        },
      ]);
    }

    if (!SPAN_METRIC_SUMMARY) {
      SPAN_METRIC_SUMMARY = new WeakMap();
    }

    SPAN_METRIC_SUMMARY.set(span, storage);
  }
}


//# sourceMappingURL=metric-summary.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/semanticAttributes.js
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */
const SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = 'sentry.source';

/**
 * Use this attribute to represent the sample rate used for a span.
 */
const SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = 'sentry.sample_rate';

/**
 * Use this attribute to represent the operation of a span.
 */
const SEMANTIC_ATTRIBUTE_SENTRY_OP = 'sentry.op';

/**
 * Use this attribute to represent the origin of a span.
 */
const SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = 'sentry.origin';

/**
 * The id of the profile that this span occured in.
 */
const SEMANTIC_ATTRIBUTE_PROFILE_ID = 'profile_id';


//# sourceMappingURL=semanticAttributes.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/getRootSpan.js
var getRootSpan = __webpack_require__(52310);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/spanstatus.js
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */
var SpanStatus; (function (SpanStatus) {
  /** The operation completed successfully. */
  const Ok = 'ok'; SpanStatus["Ok"] = Ok;
  /** Deadline expired before operation could complete. */
  const DeadlineExceeded = 'deadline_exceeded'; SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
  /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */
  const Unauthenticated = 'unauthenticated'; SpanStatus["Unauthenticated"] = Unauthenticated;
  /** 403 Forbidden */
  const PermissionDenied = 'permission_denied'; SpanStatus["PermissionDenied"] = PermissionDenied;
  /** 404 Not Found. Some requested entity (file or directory) was not found. */
  const NotFound = 'not_found'; SpanStatus["NotFound"] = NotFound;
  /** 429 Too Many Requests */
  const ResourceExhausted = 'resource_exhausted'; SpanStatus["ResourceExhausted"] = ResourceExhausted;
  /** Client specified an invalid argument. 4xx. */
  const InvalidArgument = 'invalid_argument'; SpanStatus["InvalidArgument"] = InvalidArgument;
  /** 501 Not Implemented */
  const Unimplemented = 'unimplemented'; SpanStatus["Unimplemented"] = Unimplemented;
  /** 503 Service Unavailable */
  const Unavailable = 'unavailable'; SpanStatus["Unavailable"] = Unavailable;
  /** Other/generic 5xx. */
  const InternalError = 'internal_error'; SpanStatus["InternalError"] = InternalError;
  /** Unknown. Any non-standard HTTP status code. */
  const UnknownError = 'unknown_error'; SpanStatus["UnknownError"] = UnknownError;
  /** The operation was cancelled (typically by the user). */
  const Cancelled = 'cancelled'; SpanStatus["Cancelled"] = Cancelled;
  /** Already exists (409) */
  const AlreadyExists = 'already_exists'; SpanStatus["AlreadyExists"] = AlreadyExists;
  /** Operation was rejected because the system is not in a state required for the operation's */
  const FailedPrecondition = 'failed_precondition'; SpanStatus["FailedPrecondition"] = FailedPrecondition;
  /** The operation was aborted, typically due to a concurrency issue. */
  const Aborted = 'aborted'; SpanStatus["Aborted"] = Aborted;
  /** Operation was attempted past the valid range. */
  const OutOfRange = 'out_of_range'; SpanStatus["OutOfRange"] = OutOfRange;
  /** Unrecoverable data loss or corruption */
  const DataLoss = 'data_loss'; SpanStatus["DataLoss"] = DataLoss;
})(SpanStatus || (SpanStatus = {}));

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function getSpanStatusFromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
const spanStatusfromHttpCode = (/* unused pure expression or super */ null && (getSpanStatusFromHttpCode));

/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */
function setHttpStatus(span, httpStatus) {
  // TODO (v8): Remove these calls
  // Relay does not require us to send the status code as a tag
  // For now, just because users might expect it to land as a tag we keep sending it.
  // Same with data.
  // In v8, we replace both, simply with
  // span.setAttribute('http.response.status_code', httpStatus);

  // eslint-disable-next-line deprecation/deprecation
  span.setTag('http.status_code', String(httpStatus));
  // eslint-disable-next-line deprecation/deprecation
  span.setData('http.response.status_code', httpStatus);

  const spanStatus = getSpanStatusFromHttpCode(httpStatus);
  if (spanStatus !== 'unknown_error') {
    span.setStatus(spanStatus);
  }
}


//# sourceMappingURL=spanstatus.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/span.js








/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {

   constructor(maxlen = 1000) {
    this._maxlen = maxlen;
    this.spans = [];
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      // eslint-disable-next-line deprecation/deprecation
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */

  /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */

  /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */

  /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */

  /** Epoch timestamp in seconds when the span started. */

  /** Epoch timestamp in seconds when the span ended. */

  /** Internal keeper of the status */

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext = {}) {
    this._traceId = spanContext.traceId || (0,misc/* uuid4 */.DM)();
    this._spanId = spanContext.spanId || (0,misc/* uuid4 */.DM)().substring(16);
    this._startTime = spanContext.startTimestamp || (0,esm_time/* timestampInSeconds */.ph)();
    // eslint-disable-next-line deprecation/deprecation
    this.tags = spanContext.tags ? { ...spanContext.tags } : {};
    // eslint-disable-next-line deprecation/deprecation
    this.data = spanContext.data ? { ...spanContext.data } : {};
    // eslint-disable-next-line deprecation/deprecation
    this.instrumenter = spanContext.instrumenter || 'sentry';

    this._attributes = {};
    this.setAttributes({
      [SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanContext.origin || 'manual',
      [SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op,
      ...spanContext.attributes,
    });

    // eslint-disable-next-line deprecation/deprecation
    this._name = spanContext.name || spanContext.description;

    if (spanContext.parentSpanId) {
      this._parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this._sampled = spanContext.sampled;
    }
    if (spanContext.status) {
      this._status = spanContext.status;
    }
    if (spanContext.endTimestamp) {
      this._endTime = spanContext.endTimestamp;
    }
    if (spanContext.exclusiveTime !== undefined) {
      this._exclusiveTime = spanContext.exclusiveTime;
    }
    this._measurements = spanContext.measurements ? { ...spanContext.measurements } : {};
  }

  // This rule conflicts with another eslint rule :(
  /* eslint-disable @typescript-eslint/member-ordering */

  /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   get name() {
    return this._name || '';
  }

  /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   set name(name) {
    this.updateName(name);
  }

  /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   get description() {
    return this._name;
  }

  /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   set description(description) {
    this._name = description;
  }

  /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */
   get traceId() {
    return this._traceId;
  }

  /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */
   set traceId(traceId) {
    this._traceId = traceId;
  }

  /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */
   get spanId() {
    return this._spanId;
  }

  /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */
   set spanId(spanId) {
    this._spanId = spanId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */
   set parentSpanId(string) {
    this._parentSpanId = string;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */
   get parentSpanId() {
    return this._parentSpanId;
  }

  /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */
   get sampled() {
    return this._sampled;
  }

  /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */
   set sampled(sampled) {
    this._sampled = sampled;
  }

  /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */
   get attributes() {
    return this._attributes;
  }

  /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */
   set attributes(attributes) {
    this._attributes = attributes;
  }

  /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */
   get startTimestamp() {
    return this._startTime;
  }

  /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */
   set startTimestamp(startTime) {
    this._startTime = startTime;
  }

  /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */
   get endTimestamp() {
    return this._endTime;
  }

  /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */
   set endTimestamp(endTime) {
    this._endTime = endTime;
  }

  /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */
   get status() {
    return this._status;
  }

  /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */
   set status(status) {
    this._status = status;
  }

  /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */
   get op() {
    return this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_OP] ;
  }

  /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */
   set op(op) {
    this.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, op);
  }

  /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */
   get origin() {
    return this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] ;
  }

  /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */
   set origin(origin) {
    this.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, origin);
  }

  /* eslint-enable @typescript-eslint/member-ordering */

  /** @inheritdoc */
   spanContext() {
    const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
    return {
      spanId,
      traceId,
      traceFlags: sampled ? spanUtils/* TRACE_FLAG_SAMPLED */.i0 : spanUtils/* TRACE_FLAG_NONE */.ve,
    };
  }

  /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */
   startChild(
    spanContext,
  ) {
    const childSpan = new Span({
      ...spanContext,
      parentSpanId: this._spanId,
      sampled: this._sampled,
      traceId: this._traceId,
    });

    // eslint-disable-next-line deprecation/deprecation
    childSpan.spanRecorder = this.spanRecorder;
    // eslint-disable-next-line deprecation/deprecation
    if (childSpan.spanRecorder) {
      // eslint-disable-next-line deprecation/deprecation
      childSpan.spanRecorder.add(childSpan);
    }

    const rootSpan = (0,getRootSpan/* getRootSpan */.G)(this);
    // TODO: still set span.transaction here until we have a more permanent solution
    // Probably similarly to the weakmap we hold in node-experimental
    // eslint-disable-next-line deprecation/deprecation
    childSpan.transaction = rootSpan ;

    if (debug_build/* DEBUG_BUILD */.X && rootSpan) {
      const opStr = (spanContext && spanContext.op) || '< unknown op >';
      const nameStr = (0,spanUtils/* spanToJSON */.XU)(childSpan).description || '< unknown name >';
      const idStr = rootSpan.spanContext().spanId;

      const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      esm_logger/* logger.log */.kg.log(logMessage);
      this._logMessage = logMessage;
    }

    return childSpan;
  }

  /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */
   setTag(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setData(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /** @inheritdoc */
   setAttribute(key, value) {
    if (value === undefined) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._attributes[key];
    } else {
      this._attributes[key] = value;
    }
  }

  /** @inheritdoc */
   setAttributes(attributes) {
    Object.keys(attributes).forEach(key => this.setAttribute(key, attributes[key]));
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this._status = value;
    return this;
  }

  /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */
   setHttpStatus(httpStatus) {
    setHttpStatus(this, httpStatus);
    return this;
  }

  /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */
   setName(name) {
    this.updateName(name);
  }

  /**
   * @inheritDoc
   */
   updateName(name) {
    this._name = name;
    return this;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */
   isSuccess() {
    return this._status === 'ok';
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */
   finish(endTimestamp) {
    return this.end(endTimestamp);
  }

  /** @inheritdoc */
   end(endTimestamp) {
    // If already ended, skip
    if (this._endTime) {
      return;
    }
    const rootSpan = (0,getRootSpan/* getRootSpan */.G)(this);
    if (
      debug_build/* DEBUG_BUILD */.X &&
      // Don't call this for transactions
      rootSpan &&
      rootSpan.spanContext().spanId !== this._spanId
    ) {
      const logMessage = this._logMessage;
      if (logMessage) {
        esm_logger/* logger.log */.kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this._endTime = (0,spanUtils/* spanTimeInputToSeconds */.$k)(endTimestamp);
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */
   toTraceparent() {
    return (0,spanUtils/* spanToTraceHeader */.Hb)(this);
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */
   toContext() {
    return (0,object/* dropUndefinedKeys */.Jr)({
      data: this._getData(),
      description: this._name,
      endTimestamp: this._endTime,
      // eslint-disable-next-line deprecation/deprecation
      op: this.op,
      parentSpanId: this._parentSpanId,
      sampled: this._sampled,
      spanId: this._spanId,
      startTimestamp: this._startTime,
      status: this._status,
      // eslint-disable-next-line deprecation/deprecation
      tags: this.tags,
      traceId: this._traceId,
    });
  }

  /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */
   updateWithContext(spanContext) {
    // eslint-disable-next-line deprecation/deprecation
    this.data = spanContext.data || {};
    // eslint-disable-next-line deprecation/deprecation
    this._name = spanContext.name || spanContext.description;
    this._endTime = spanContext.endTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    this.op = spanContext.op;
    this._parentSpanId = spanContext.parentSpanId;
    this._sampled = spanContext.sampled;
    this._spanId = spanContext.spanId || this._spanId;
    this._startTime = spanContext.startTimestamp || this._startTime;
    this._status = spanContext.status;
    // eslint-disable-next-line deprecation/deprecation
    this.tags = spanContext.tags || {};
    this._traceId = spanContext.traceId || this._traceId;

    return this;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */
   getTraceContext() {
    return (0,spanUtils/* spanToTraceContext */.wy)(this);
  }

  /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */
   getSpanJSON() {
    return (0,object/* dropUndefinedKeys */.Jr)({
      data: this._getData(),
      description: this._name,
      op: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_OP] ,
      parent_span_id: this._parentSpanId,
      span_id: this._spanId,
      start_timestamp: this._startTime,
      status: this._status,
      // eslint-disable-next-line deprecation/deprecation
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this._endTime,
      trace_id: this._traceId,
      origin: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] ,
      _metrics_summary: getMetricSummaryJsonForSpan(this),
      profile_id: this._attributes[SEMANTIC_ATTRIBUTE_PROFILE_ID] ,
      exclusive_time: this._exclusiveTime,
      measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined,
    });
  }

  /** @inheritdoc */
   isRecording() {
    return !this._endTime && !!this._sampled;
  }

  /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */
   toJSON() {
    return this.getSpanJSON();
  }

  /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */
   _getData()

 {
    // eslint-disable-next-line deprecation/deprecation
    const { data, _attributes: attributes } = this;

    const hasData = Object.keys(data).length > 0;
    const hasAttributes = Object.keys(attributes).length > 0;

    if (!hasData && !hasAttributes) {
      return undefined;
    }

    if (hasData && hasAttributes) {
      return {
        ...data,
        ...attributes,
      };
    }

    return hasData ? data : attributes;
  }
}


//# sourceMappingURL=span.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/trace.js + 1 modules
var trace = __webpack_require__(24839);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/transaction.js










/** JSDoc */
class Transaction extends Span  {
  /**
   * The reference to the current hub.
   */
  // eslint-disable-next-line deprecation/deprecation

  // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */
  // eslint-disable-next-line deprecation/deprecation
   constructor(transactionContext, hub) {
    super(transactionContext);
    this._contexts = {};

    // eslint-disable-next-line deprecation/deprecation
    this._hub = hub || (0,esm_hub/* getCurrentHub */.Gd)();

    this._name = transactionContext.name || '';

    this._metadata = {
      // eslint-disable-next-line deprecation/deprecation
      ...transactionContext.metadata,
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    // TODO (v8): Replace this with another way to set the root span
    // eslint-disable-next-line deprecation/deprecation
    this.transaction = this;

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      this._frozenDynamicSamplingContext = { ...incomingDynamicSamplingContext };
    }
  }

  // This sadly conflicts with the getter/setter ordering :(
  /* eslint-disable @typescript-eslint/member-ordering */

  /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   get name() {
    return this._name;
  }

  /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */
   set name(newName) {
    // eslint-disable-next-line deprecation/deprecation
    this.setName(newName);
  }

  /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */
   get metadata() {
    // We merge attributes in for backwards compatibility
    return {
      // Defaults
      // eslint-disable-next-line deprecation/deprecation
      source: 'custom',
      spanMetadata: {},

      // Legacy metadata
      ...this._metadata,

      // From attributes
      ...(this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
        source: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ,
      }),
      ...(this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
        sampleRate: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ,
      }),
    };
  }

  /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */
   set metadata(metadata) {
    this._metadata = metadata;
  }

  /* eslint-enable @typescript-eslint/member-ordering */

  /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */
   setName(name, source = 'custom') {
    this._name = name;
    this.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, source);
  }

  /** @inheritdoc */
   updateName(name) {
    this._name = name;
    return this;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    // eslint-disable-next-line deprecation/deprecation
    if (!this.spanRecorder) {
      // eslint-disable-next-line deprecation/deprecation
      this.spanRecorder = new SpanRecorder(maxlen);
    }
    // eslint-disable-next-line deprecation/deprecation
    this.spanRecorder.add(this);
  }

  /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */
   setMetadata(newMetadata) {
    this._metadata = { ...this._metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   end(endTimestamp) {
    const timestampInS = (0,spanUtils/* spanTimeInputToSeconds */.$k)(endTimestamp);
    const transaction = this._finishTransaction(timestampInS);
    if (!transaction) {
      return undefined;
    }
    // eslint-disable-next-line deprecation/deprecation
    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    // eslint-disable-next-line deprecation/deprecation
    const spanContext = super.toContext();

    return (0,object/* dropUndefinedKeys */.Jr)({
      ...spanContext,
      name: this._name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    // eslint-disable-next-line deprecation/deprecation
    super.updateWithContext(transactionContext);

    this._name = transactionContext.name || '';
    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */
   getDynamicSamplingContext() {
    return (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(this);
  }

  /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */
  // eslint-disable-next-line deprecation/deprecation
   setHub(hub) {
    this._hub = hub;
  }

  /**
   * Get the profile id of the transaction.
   */
   getProfileId() {
    if (this._contexts !== undefined && this._contexts['profile'] !== undefined) {
      return this._contexts['profile'].profile_id ;
    }
    return undefined;
  }

  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
   _finishTransaction(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this._endTime !== undefined) {
      return undefined;
    }

    if (!this._name) {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this._name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.end(endTimestamp);

    // eslint-disable-next-line deprecation/deprecation
    const client = this._hub.getClient();
    if (client && client.emit) {
      client.emit('finishTransaction', this);
    }

    if (this._sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    // eslint-disable-next-line deprecation/deprecation
    const finishedSpans = this.spanRecorder
      ? // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.spans.filter(span => span !== this && (0,spanUtils/* spanToJSON */.XU)(span).timestamp)
      : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      const endTimes = finishedSpans.map(span => (0,spanUtils/* spanToJSON */.XU)(span).timestamp).filter(Boolean) ;
      this._endTime = endTimes.reduce((prev, current) => {
        return prev > current ? prev : current;
      });
    }

    const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0,trace/* getCapturedScopesOnSpan */.I1)(this);

    // eslint-disable-next-line deprecation/deprecation
    const { metadata } = this;
    // eslint-disable-next-line deprecation/deprecation
    const { source } = metadata;

    const transaction = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: (0,spanUtils/* spanToTraceContext */.wy)(this),
      },
      // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
      spans: finishedSpans,
      start_timestamp: this._startTime,
      // eslint-disable-next-line deprecation/deprecation
      tags: this.tags,
      timestamp: this._endTime,
      transaction: this._name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        capturedSpanScope,
        capturedSpanIsolationScope,
        ...(0,object/* dropUndefinedKeys */.Jr)({
          dynamicSamplingContext: (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(this),
        }),
      },
      _metrics_summary: getMetricSummaryJsonForSpan(this),
      ...(source && {
        transaction_info: {
          source,
        },
      }),
    };

    const hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      debug_build/* DEBUG_BUILD */.X &&
        esm_logger/* logger.log */.kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    // eslint-disable-next-line deprecation/deprecation
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);

    return transaction;
  }
}


//# sourceMappingURL=transaction.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/idletransaction.js






const TRACING_DEFAULTS = {
  idleTimeout: 1000,
  finalTimeout: 30000,
  heartbeatInterval: 5000,
};

const FINISH_REASON_TAG = 'finishReason';

const IDLE_TRANSACTION_FINISH_REASONS = [
  'heartbeatFailed',
  'idleTimeout',
  'documentHidden',
  'finalTimeout',
  'externalFinish',
  'cancelled',
];

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends SpanRecorder {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanContext().spanId !== this.transactionSpanId) {
      // We patch span.end() to pop an activity after setting an endTimestamp.
      // eslint-disable-next-line @typescript-eslint/unbound-method
      const originalEnd = span.end;
      span.end = (...rest) => {
        this._popActivity(span.spanContext().spanId);
        return originalEnd.apply(span, rest);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if ((0,spanUtils/* spanToJSON */.XU)(span).timestamp === undefined) {
        this._pushActivity(span.spanContext().spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends Transaction {
  // Activities store a list of active spans

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.

  // We should not use heartbeat if we finished a transaction

  // Idle timeout was canceled and we should finish the transaction with the last span end.

  /**
   * Timer that tracks Transaction idleTimeout
   */

  /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */
   constructor(
    transactionContext,
    // eslint-disable-next-line deprecation/deprecation
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = TRACING_DEFAULTS.idleTimeout,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = TRACING_DEFAULTS.finalTimeout,
      _heartbeatInterval = TRACING_DEFAULTS.heartbeatInterval,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
    /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */
    delayAutoFinishUntilSignal = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._heartbeatInterval = _heartbeatInterval;this._onScope = _onScope;
    this.activities = {};
    this._heartbeatCounter = 0;
    this._finished = false;
    this._idleTimeoutCanceledPermanently = false;
    this._beforeFinishCallbacks = [];
    this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[4];
    this._autoFinishAllowed = !delayAutoFinishUntilSignal;

    if (_onScope) {
      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
      // eslint-disable-next-line deprecation/deprecation
      _idleHub.getScope().setSpan(this);
    }

    if (!delayAutoFinishUntilSignal) {
      this._restartIdleTimeout();
    }

    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[3];
        this.end();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   end(endTimestamp) {
    const endTimestampInS = (0,spanUtils/* spanTimeInputToSeconds */.$k)(endTimestamp);

    this._finished = true;
    this.activities = {};

    // eslint-disable-next-line deprecation/deprecation
    if (this.op === 'ui.action.click') {
      this.setAttribute(FINISH_REASON_TAG, this._finishReason);
    }

    // eslint-disable-next-line deprecation/deprecation
    if (this.spanRecorder) {
      debug_build/* DEBUG_BUILD */.X &&
        // eslint-disable-next-line deprecation/deprecation
        esm_logger/* logger.log */.kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);

      for (const callback of this._beforeFinishCallbacks) {
        callback(this, endTimestampInS);
      }

      // eslint-disable-next-line deprecation/deprecation
      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanContext().spanId === this.spanContext().spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!(0,spanUtils/* spanToJSON */.XU)(span).timestamp) {
          span.setStatus('cancelled');
          span.end(endTimestampInS);
          debug_build/* DEBUG_BUILD */.X &&
            esm_logger/* logger.log */.kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        const { start_timestamp: startTime, timestamp: endTime } = (0,spanUtils/* spanToJSON */.XU)(span);
        const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;

        // Add a delta with idle timeout so that we prevent false positives
        const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
        const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;

        if (debug_build/* DEBUG_BUILD */.X) {
          const stringifiedSpan = JSON.stringify(span, undefined, 2);
          if (!spanStartedBeforeTransactionFinish) {
            esm_logger/* logger.log */.kg.log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
          } else if (!spanEndedBeforeFinalTimeout) {
            esm_logger/* logger.log */.kg.log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
          }
        }

        return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
      });

      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('[Tracing] flushing IdleTransaction');
    } else {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      // eslint-disable-next-line deprecation/deprecation
      const scope = this._idleHub.getScope();
      // eslint-disable-next-line deprecation/deprecation
      if (scope.getTransaction() === this) {
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(undefined);
      }
    }

    return super.end(endTimestamp);
  }

  /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    // eslint-disable-next-line deprecation/deprecation
    if (!this.spanRecorder) {
      const pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      const popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      // eslint-disable-next-line deprecation/deprecation
      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanContext().spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    // eslint-disable-next-line deprecation/deprecation
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */
   cancelIdleTimeout(
    endTimestamp,
    {
      restartOnChildSpanChange,
    }

 = {
      restartOnChildSpanChange: true,
    },
  ) {
    this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;

      if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.end(endTimestamp);
      }
    }
  }

  /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */
   setFinishReason(reason) {
    this._finishReason = reason;
  }

  /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */
   sendAutoFinishSignal() {
    if (!this._autoFinishAllowed) {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('[Tracing] Received finish signal for idle transaction.');
      this._restartIdleTimeout();
      this._autoFinishAllowed = true;
    }
  }

  /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */
   _restartIdleTimeout(endTimestamp) {
    this.cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[1];
        this.end(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this.cancelIdleTimeout(undefined, { restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently });
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`[Tracing] popActivity ${spanId}`);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.activities[spanId];
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      const endTimestamp = (0,esm_time/* timestampInSeconds */.ph)();
      if (this._idleTimeoutCanceledPermanently) {
        if (this._autoFinishAllowed) {
          this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
          this.end(endTimestamp);
        }
      } else {
        // We need to add the timeout here to have the real endtimestamp of the transaction
        // Remember timestampInSeconds is in seconds, timeout is in ms
        this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
      }
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    const heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter++;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      if (this._autoFinishAllowed) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
        this.setStatus('deadline_exceeded');
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[0];
        this.end();
      }
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}


//# sourceMappingURL=idletransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/utils.js




/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */
// eslint-disable-next-line deprecation/deprecation
function getActiveTransaction(maybeHub) {
  // eslint-disable-next-line deprecation/deprecation
  const hub = maybeHub || (0,esm_hub/* getCurrentHub */.Gd)();
  // eslint-disable-next-line deprecation/deprecation
  const scope = hub.getScope();
  // eslint-disable-next-line deprecation/deprecation
  return scope.getTransaction() ;
}

/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */
const extractTraceparentData = (/* unused pure expression or super */ null && (extractTraceparentData$1));


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/errors.js




let errorsInstrumented = false;

/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  if (errorsInstrumented) {
    return;
  }

  errorsInstrumented = true;
  addGlobalErrorInstrumentationHandler(errorCallback);
  addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  // eslint-disable-next-line deprecation/deprecation
  const activeTransaction = getActiveTransaction();
  if (activeTransaction) {
    const status = 'internal_error';
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}

// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
errorCallback.tag = 'sentry_tracingErrorCallback';


//# sourceMappingURL=errors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/sampling.js






/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */
function sampleTransaction(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)(options)) {
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  // eslint-disable-next-line deprecation/deprecation
  if (transaction.sampled !== undefined) {
    // eslint-disable-next-line deprecation/deprecation
    transaction.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE, Number(transaction.sampled));
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE, Number(sampleRate));
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
    transaction.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE, Number(sampleRate));
  } else {
    // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    transaction.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE, sampleRate);
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  // eslint-disable-next-line deprecation/deprecation
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  // eslint-disable-next-line deprecation/deprecation
  if (!transaction.sampled) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  debug_build/* DEBUG_BUILD */.X &&
    // eslint-disable-next-line deprecation/deprecation
    esm_logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${(0,spanUtils/* spanToJSON */.XU)(transaction).description}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}


//# sourceMappingURL=sampling.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/hubextensions.js









/** Returns all trace headers that are currently on the top scope. */
// eslint-disable-next-line deprecation/deprecation
function traceHeaders() {
  // eslint-disable-next-line deprecation/deprecation
  const scope = this.getScope();
  // eslint-disable-next-line deprecation/deprecation
  const span = scope.getSpan();

  return span
    ? {
        'sentry-trace': (0,spanUtils/* spanToTraceHeader */.Hb)(span),
      }
    : {};
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(
  // eslint-disable-next-line deprecation/deprecation

  transactionContext,
  customSamplingContext,
) {
  // eslint-disable-next-line deprecation/deprecation
  const client = this.getClient();
  const options = (client && client.getOptions()) || {};

  const configInstrumenter = options.instrumenter || 'sentry';
  const transactionInstrumenter = transactionContext.instrumenter || 'sentry';

  if (configInstrumenter !== transactionInstrumenter) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.error */.kg.error(
        `A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`,
      );

    // eslint-disable-next-line deprecation/deprecation
    transactionContext.sampled = false;
  }

  // eslint-disable-next-line deprecation/deprecation
  let transaction = new Transaction(transactionContext, this);
  transaction = sampleTransaction(transaction, options, {
    name: transactionContext.name,
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    attributes: {
      // eslint-disable-next-line deprecation/deprecation
      ...transactionContext.data,
      ...transactionContext.attributes,
    },
    ...customSamplingContext,
  });
  if (transaction.isRecording()) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  // eslint-disable-next-line deprecation/deprecation
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
  heartbeatInterval,
  delayAutoFinishUntilSignal = false,
) {
  // eslint-disable-next-line deprecation/deprecation
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {};

  // eslint-disable-next-line deprecation/deprecation
  let transaction = new IdleTransaction(
    transactionContext,
    hub,
    idleTimeout,
    finalTimeout,
    heartbeatInterval,
    onScope,
    delayAutoFinishUntilSignal,
  );
  transaction = sampleTransaction(transaction, options, {
    name: transactionContext.name,
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    attributes: {
      // eslint-disable-next-line deprecation/deprecation
      ...transactionContext.data,
      ...transactionContext.attributes,
    },
    ...customSamplingContext,
  });
  if (transaction.isRecording()) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Adds tracing extensions to the global hub.
 */
function addTracingExtensions() {
  const carrier = (0,esm_hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }

  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/tracing.js
var tracing = __webpack_require__(32216);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/common/debug-build.js
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const common_debug_build_DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/types.js


const types_WINDOW = worldwide/* GLOBAL_OBJ */.n2

;


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/backgroundtab.js





/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (types_WINDOW.document) {
    types_WINDOW.document.addEventListener('visibilitychange', () => {
      // eslint-disable-next-line deprecation/deprecation
      const activeTransaction = getActiveTransaction() ;
      if (types_WINDOW.document.hidden && activeTransaction) {
        const statusType = 'cancelled';

        const { op, status } = (0,spanUtils/* spanToJSON */.XU)(activeTransaction);

        common_debug_build_DEBUG_BUILD &&
          esm_logger/* logger.log */.kg.log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!status) {
          activeTransaction.setStatus(statusType);
        }
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.end();
      }
    });
  } else {
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/bindReporter.js
const bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getNavigationEntryFromPerformanceTiming = () => {
  // eslint-disable-next-line deprecation/deprecation
  const timing = types_WINDOW.performance.timing;
  // eslint-disable-next-line deprecation/deprecation
  const type = types_WINDOW.performance.navigation.type;

  const navigationEntry = {
    entryType: 'navigation',
    startTime: 0,
    type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
  };

  for (const key in timing) {
    if (key !== 'navigationStart' && key !== 'toJSON') {
      // eslint-disable-next-line deprecation/deprecation
      navigationEntry[key] = Math.max((timing[key ] ) - timing.navigationStart, 0);
    }
  }
  return navigationEntry ;
};

const getNavigationEntry = () => {
  if (types_WINDOW.__WEB_VITALS_POLYFILL__) {
    return (
      types_WINDOW.performance &&
      ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) ||
        getNavigationEntryFromPerformanceTiming())
    );
  } else {
    return types_WINDOW.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  }
};


//# sourceMappingURL=getNavigationEntry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = getNavigationEntry();
  return (navEntry && navEntry.activationStart) || 0;
};


//# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = getNavigationEntry();
  let navigationType = 'navigate';

  if (navEntry) {
    if ((types_WINDOW.document && types_WINDOW.document.prerendering) || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-') ;
    }
  }

  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good', // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: generateUniqueID(),
    navigationType,
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (
  type,
  callback,
  opts,
) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        callback(list.getEntries() );
      });
      po.observe(
        Object.assign(
          {
            type,
            buffered: true,
          },
          opts || {},
        ) ,
      );
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const onHidden = (cb, once) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || types_WINDOW.document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };

  if (types_WINDOW.document) {
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
  }
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (
  onReport,
  options = {},
) => {
  const metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  // const handleEntries = (entries: Metric['entries']) => {
  const handleEntries = (entries) => {
    entries.forEach(entry => {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        const firstSessionEntry = sessionEntries[0];
        const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

        // If the entry occurred less than 1 second after the previous entry and
        // less than 5 seconds after the first entry in the session, include the
        // entry in the current session. Otherwise, start a new session.
        if (
          sessionValue &&
          sessionEntries.length !== 0 &&
          entry.startTime - lastSessionEntry.startTime < 1000 &&
          entry.startTime - firstSessionEntry.startTime < 5000
        ) {
          sessionValue += entry.value;
          sessionEntries.push(entry);
        } else {
          sessionValue = entry.value;
          sessionEntries = [entry];
        }

        // If the current session value is larger than the current CLS value,
        // update CLS and the entries contributing to it.
        if (sessionValue > metric.value) {
          metric.value = sessionValue;
          metric.entries = sessionEntries;
          if (report) {
            report();
          }
        }
      }
    });
  };

  const po = observe('layout-shift', handleEntries);
  if (po) {
    report = bindReporter(onReport, metric, options.reportAllChanges);

    const stopListening = () => {
      handleEntries(po.takeRecords() );
      report(true);
    };

    onHidden(stopListening);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

const initHiddenTime = () => {
  // If the document is hidden and not prerendering, assume it was always
  // hidden and the page was loaded in the background.
  if (types_WINDOW.document && types_WINDOW.document.visibilityState) {
    firstHiddenTime = types_WINDOW.document.visibilityState === 'hidden' && !types_WINDOW.document.prerendering ? 0 : Infinity;
  }
};

const trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

const getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('FID');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntry = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  const handleEntries = (entries) => {
    (entries ).forEach(handleEntry);
  };

  const po = observe('first-input', handleEntries);
  report = bindReporter(onReport, metric);

  if (po) {
    onHidden(() => {
      handleEntries(po.takeRecords() );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/polyfills/interactionCountPolyfill.js


let interactionCountEstimate = 0;
let minKnownInteractionId = Infinity;
let maxKnownInteractionId = 0;

const updateEstimate = (entries) => {
  (entries ).forEach(e => {
    if (e.interactionId) {
      minKnownInteractionId = Math.min(minKnownInteractionId, e.interactionId);
      maxKnownInteractionId = Math.max(maxKnownInteractionId, e.interactionId);

      interactionCountEstimate = maxKnownInteractionId ? (maxKnownInteractionId - minKnownInteractionId) / 7 + 1 : 0;
    }
  });
};

let po;

/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */
const getInteractionCount = () => {
  return po ? interactionCountEstimate : performance.interactionCount || 0;
};

/**
 * Feature detects native support or initializes the polyfill if needed.
 */
const initInteractionCountPolyfill = () => {
  if ('interactionCount' in performance || po) return;

  po = observe('event', updateEstimate, {
    type: 'event',
    buffered: true,
    durationThreshold: 0,
  } );
};


//# sourceMappingURL=interactionCountPolyfill.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getINP.js






/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */
const getInteractionCountForNavigation = () => {
  return getInteractionCount();
};

// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const MAX_INTERACTIONS_TO_CONSIDER = 10;

// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const longestInteractionList = [];

// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const longestInteractionMap = {};

/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */
const processEntry = (entry) => {
  // The least-long of the 10 longest interactions.
  const minLongestInteraction = longestInteractionList[longestInteractionList.length - 1];

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const existingInteraction = longestInteractionMap[entry.interactionId];

  // Only process the entry if it's possibly one of the ten longest,
  // or if it's part of an existing interaction.
  if (
    existingInteraction ||
    longestInteractionList.length < MAX_INTERACTIONS_TO_CONSIDER ||
    entry.duration > minLongestInteraction.latency
  ) {
    // If the interaction already exists, update it. Otherwise create one.
    if (existingInteraction) {
      existingInteraction.entries.push(entry);
      existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
    } else {
      const interaction = {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        id: entry.interactionId,
        latency: entry.duration,
        entries: [entry],
      };
      longestInteractionMap[interaction.id] = interaction;
      longestInteractionList.push(interaction);
    }

    // Sort the entries by latency (descending) and keep only the top ten.
    longestInteractionList.sort((a, b) => b.latency - a.latency);
    longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER).forEach(i => {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete longestInteractionMap[i.id];
    });
  }
};

/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */
const estimateP98LongestInteraction = () => {
  const candidateInteractionIndex = Math.min(
    longestInteractionList.length - 1,
    Math.floor(getInteractionCountForNavigation() / 50),
  );

  return longestInteractionList[candidateInteractionIndex];
};

/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onINP = (onReport, opts) => {
  // Set defaults
  // eslint-disable-next-line no-param-reassign
  opts = opts || {};

  // https://web.dev/inp/#what's-a-%22good%22-inp-value
  // const thresholds = [200, 500];

  // TODO(philipwalton): remove once the polyfill is no longer needed.
  initInteractionCountPolyfill();

  const metric = initMetric('INP');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntries = (entries) => {
    entries.forEach(entry => {
      if (entry.interactionId) {
        processEntry(entry);
      }

      // Entries of type `first-input` don't currently have an `interactionId`,
      // so to consider them in INP we have to first check that an existing
      // entry doesn't match the `duration` and `startTime`.
      // Note that this logic assumes that `event` entries are dispatched
      // before `first-input` entries. This is true in Chrome but it is not
      // true in Firefox; however, Firefox doesn't support interactionId, so
      // it's not an issue at the moment.
      // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
      if (entry.entryType === 'first-input') {
        const noMatchingEntry = !longestInteractionList.some(interaction => {
          return interaction.entries.some(prevEntry => {
            return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
          });
        });
        if (noMatchingEntry) {
          processEntry(entry);
        }
      }
    });

    const inp = estimateP98LongestInteraction();

    if (inp && inp.latency !== metric.value) {
      metric.value = inp.latency;
      metric.entries = inp.entries;
      report();
    }
  };

  const po = observe('event', handleEntries, {
    // Event Timing entries have their durations rounded to the nearest 8ms,
    // so a duration of 40ms would be any event that spans 2.5 or more frames
    // at 60Hz. This threshold is chosen to strike a balance between usefulness
    // and performance. Running this callback for any interaction that spans
    // just one or two frames is likely not worth the insight that could be
    // gained.
    durationThreshold: opts.durationThreshold || 40,
  } );

  report = bindReporter(onReport, metric, opts.reportAllChanges);

  if (po) {
    // Also observe entries of type `first-input`. This is useful in cases
    // where the first interaction is less than the `durationThreshold`.
    po.observe({ type: 'first-input', buffered: true });

    onHidden(() => {
      handleEntries(po.takeRecords() );

      // If the interaction count shows that there were interactions but
      // none were captured by the PerformanceObserver, report a latency of 0.
      if (metric.value < 0 && getInteractionCountForNavigation() > 0) {
        metric.value = 0;
        metric.entries = [];
      }

      report(true);
    });
  }
};


//# sourceMappingURL=getINP.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getLCP.js








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */
const onLCP = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('LCP');
  let report;

  const handleEntries = (entries) => {
    const lastEntry = entries[entries.length - 1] ;
    if (lastEntry) {
      // The startTime attribute returns the value of the renderTime if it is
      // not 0, and the value of the loadTime otherwise. The activationStart
      // reference is used because LCP should be relative to page activation
      // rather than navigation start if the page was prerendered.
      const value = Math.max(lastEntry.startTime - getActivationStart(), 0);

      // Only report if the page wasn't hidden prior to LCP.
      if (value < visibilityWatcher.firstHiddenTime) {
        metric.value = value;
        metric.entries = [lastEntry];
        report();
      }
    }
  };

  const po = observe('largest-contentful-paint', handleEntries);

  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        handleEntries(po.takeRecords() );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      if (types_WINDOW.document) {
        addEventListener(type, stopListening, { once: true, capture: true });
      }
    });

    onHidden(stopListening, true);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/onTTFB.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */
const whenReady = (callback) => {
  if (!types_WINDOW.document) {
    return;
  }

  if (types_WINDOW.document.prerendering) {
    addEventListener('prerenderingchange', () => whenReady(callback), true);
  } else if (types_WINDOW.document.readyState !== 'complete') {
    addEventListener('load', () => whenReady(callback), true);
  } else {
    // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
  }
};

/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */
const onTTFB = (onReport, opts) => {
  // Set defaults
  // eslint-disable-next-line no-param-reassign
  opts = opts || {};

  // https://web.dev/ttfb/#what-is-a-good-ttfb-score
  // const thresholds = [800, 1800];

  const metric = initMetric('TTFB');
  const report = bindReporter(onReport, metric, opts.reportAllChanges);

  whenReady(() => {
    const navEntry = getNavigationEntry() ;

    if (navEntry) {
      // The activationStart reference is used because TTFB should be
      // relative to page activation rather than navigation start if the
      // page was prerendered. But in cases where `activationStart` occurs
      // after the first byte is received, this time should be clamped at 0.
      metric.value = Math.max(navEntry.responseStart - getActivationStart(), 0);

      // In some cases the value reported is negative or is larger
      // than the current page time. Ignore these cases:
      // https://github.com/GoogleChrome/web-vitals/issues/137
      // https://github.com/GoogleChrome/web-vitals/issues/162
      if (metric.value < 0 || metric.value > performance.now()) return;

      metric.entries = [navEntry];

      report(true);
    }
  });
};


//# sourceMappingURL=onTTFB.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/instrument.js









const instrument_handlers = {};
const instrument_instrumented = {};

let _previousCls;
let _previousFid;
let _previousLcp;
let _previousTtfb;
let _previousInp;

/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */
function addClsInstrumentationHandler(
  callback,
  stopOnCallback = false,
) {
  return addMetricObserver('cls', callback, instrumentCls, _previousCls, stopOnCallback);
}

/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */
function addLcpInstrumentationHandler(
  callback,
  stopOnCallback = false,
) {
  return addMetricObserver('lcp', callback, instrumentLcp, _previousLcp, stopOnCallback);
}

/**
 * Add a callback that will be triggered when a FID metric is available.
 */
function addTtfbInstrumentationHandler(callback) {
  return addMetricObserver('ttfb', callback, instrumentTtfb, _previousTtfb);
}

/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addFidInstrumentationHandler(callback) {
  return addMetricObserver('fid', callback, instrumentFid, _previousFid);
}

/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addInpInstrumentationHandler(
  callback,
) {
  return addMetricObserver('inp', callback, instrumentInp, _previousInp);
}

/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addPerformanceInstrumentationHandler(
  type,
  callback,
) {
  instrument_addHandler(type, callback);

  if (!instrument_instrumented[type]) {
    instrumentPerformanceObserver(type);
    instrument_instrumented[type] = true;
  }

  return getCleanupCallback(type, callback);
}

/** Trigger all handlers of a given type. */
function instrument_triggerHandlers(type, data) {
  const typeHandlers = instrument_handlers[type];

  if (!typeHandlers || !typeHandlers.length) {
    return;
  }

  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      common_debug_build_DEBUG_BUILD &&
        esm_logger/* logger.error */.kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,stacktrace/* getFunctionName */.$P)(handler)}\nError:`,
          e,
        );
    }
  }
}

function instrumentCls() {
  return onCLS(
    metric => {
      instrument_triggerHandlers('cls', {
        metric,
      });
      _previousCls = metric;
    },
    { reportAllChanges: true },
  );
}

function instrumentFid() {
  return onFID(metric => {
    instrument_triggerHandlers('fid', {
      metric,
    });
    _previousFid = metric;
  });
}

function instrumentLcp() {
  return onLCP(metric => {
    instrument_triggerHandlers('lcp', {
      metric,
    });
    _previousLcp = metric;
  });
}

function instrumentTtfb() {
  return onTTFB(metric => {
    instrument_triggerHandlers('ttfb', {
      metric,
    });
    _previousTtfb = metric;
  });
}

function instrumentInp() {
  return onINP(metric => {
    instrument_triggerHandlers('inp', {
      metric,
    });
    _previousInp = metric;
  });
}

function addMetricObserver(
  type,
  callback,
  instrumentFn,
  previousValue,
  stopOnCallback = false,
) {
  instrument_addHandler(type, callback);

  let stopListening;

  if (!instrument_instrumented[type]) {
    stopListening = instrumentFn();
    instrument_instrumented[type] = true;
  }

  if (previousValue) {
    callback({ metric: previousValue });
  }

  return getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}

function instrumentPerformanceObserver(type) {
  const options = {};

  // Special per-type options we want to use
  if (type === 'event') {
    options.durationThreshold = 0;
  }

  observe(
    type,
    entries => {
      instrument_triggerHandlers(type, { entries });
    },
    options,
  );
}

function instrument_addHandler(type, handler) {
  instrument_handlers[type] = instrument_handlers[type] || [];
  (instrument_handlers[type] ).push(handler);
}

// Get a callback which can be called to remove the instrumentation handler
function getCleanupCallback(
  type,
  callback,
  stopListening,
) {
  return () => {
    if (stopListening) {
      stopListening();
    }

    const typeHandlers = instrument_handlers[type];

    if (!typeHandlers) {
      return;
    }

    const index = typeHandlers.indexOf(callback);
    if (index !== -1) {
      typeHandlers.splice(index, 1);
    }
  };
}


//# sourceMappingURL=instrument.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/span.js


/**
 * Create envelope from Span item.
 */
function createSpanEnvelope(spans, dsn) {
  const headers = {
    sent_at: new Date().toISOString(),
  };

  if (dsn) {
    headers.dsn = dsn_dsnToString(dsn);
  }

  const items = spans.map(createSpanItem);
  return createEnvelope(headers, items);
}

function createSpanItem(span) {
  const spanHeaders = {
    type: 'span',
  };
  return [spanHeaders, span];
}


//# sourceMappingURL=span.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/measurement.js


/**
 * Adds a measurement to the current active transaction.
 */
function setMeasurement(name, value, unit) {
  // eslint-disable-next-line deprecation/deprecation
  const transaction = getActiveTransaction();
  if (transaction) {
    // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
  }
}


//# sourceMappingURL=measurement.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  // eslint-disable-next-line deprecation/deprecation
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
  }

  // eslint-disable-next-line deprecation/deprecation
  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/index.js









const MAX_INT_AS_BYTES = 2147483647;

/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

function getBrowserPerformanceAPI() {
  // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
  return types_WINDOW && types_WINDOW.addEventListener && types_WINDOW.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */
function startTrackingWebVitals() {
  const performance = getBrowserPerformanceAPI();
  if (performance && esm_time/* browserPerformanceTimeOrigin */.Z1) {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    if (performance.mark) {
      types_WINDOW.performance.mark('sentry-tracing-init');
    }
    const fidCallback = _trackFID();
    const clsCallback = _trackCLS();
    const lcpCallback = _trackLCP();
    const ttfbCallback = _trackTtfb();

    return () => {
      fidCallback();
      clsCallback();
      lcpCallback();
      ttfbCallback();
    };
  }

  return () => undefined;
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  addPerformanceInstrumentationHandler('longtask', ({ entries }) => {
    for (const entry of entries) {
      // eslint-disable-next-line deprecation/deprecation
      const transaction = getActiveTransaction() ;
      if (!transaction) {
        return;
      }
      const startTime = msToSec((esm_time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
      const duration = msToSec(entry.duration);

      // eslint-disable-next-line deprecation/deprecation
      transaction.startChild({
        description: 'Main UI thread blocked',
        op: 'ui.long-task',
        origin: 'auto.ui.browser.metrics',
        startTimestamp: startTime,
        endTimestamp: startTime + duration,
      });
    }
  });
}

/**
 * Start tracking interaction events.
 */
function startTrackingInteractions() {
  addPerformanceInstrumentationHandler('event', ({ entries }) => {
    for (const entry of entries) {
      // eslint-disable-next-line deprecation/deprecation
      const transaction = getActiveTransaction() ;
      if (!transaction) {
        return;
      }

      if (entry.name === 'click') {
        const startTime = msToSec((esm_time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
        const duration = msToSec(entry.duration);

        const span = {
          description: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
          op: `ui.interaction.${entry.name}`,
          origin: 'auto.ui.browser.metrics',
          startTimestamp: startTime,
          endTimestamp: startTime + duration,
        };

        const componentName = (0,browser/* getComponentName */.iY)(entry.target);
        if (componentName) {
          span.attributes = { 'ui.component_name': componentName };
        }

        // eslint-disable-next-line deprecation/deprecation
        transaction.startChild(span);
      }
    }
  });
}

/**
 * Start tracking INP webvital events.
 */
function startTrackingINP(
  interactionIdtoRouteNameMapping,
  interactionsSampleRate,
) {
  const performance = getBrowserPerformanceAPI();
  if (performance && esm_time/* browserPerformanceTimeOrigin */.Z1) {
    const inpCallback = _trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);

    return () => {
      inpCallback();
    };
  }

  return () => undefined;
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  return addClsInstrumentationHandler(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }

    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  }, true);
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP() {
  return addLcpInstrumentationHandler(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }

    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _lcpEntry = entry ;
  }, true);
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  return addFidInstrumentationHandler(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }

    const timeOrigin = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1 );
    const startTime = msToSec(entry.startTime);
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

function _trackTtfb() {
  return addTtfbInstrumentationHandler(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }

    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
    _measurements['ttfb'] = { value: metric.value, unit: 'millisecond' };
  });
}

const INP_ENTRY_MAP = {
  click: 'click',
  pointerdown: 'click',
  pointerup: 'click',
  mousedown: 'click',
  mouseup: 'click',
  touchstart: 'click',
  touchend: 'click',
  mouseover: 'hover',
  mouseout: 'hover',
  mouseenter: 'hover',
  mouseleave: 'hover',
  pointerover: 'hover',
  pointerout: 'hover',
  pointerenter: 'hover',
  pointerleave: 'hover',
  dragstart: 'drag',
  dragend: 'drag',
  drag: 'drag',
  dragenter: 'drag',
  dragleave: 'drag',
  dragover: 'drag',
  drop: 'drag',
  keydown: 'press',
  keyup: 'press',
  keypress: 'press',
  input: 'press',
};

/** Starts tracking the Interaction to Next Paint on the current page. */
function _trackINP(
  interactionIdToRouteNameMapping,
  interactionsSampleRate,
) {
  return addInpInstrumentationHandler(({ metric }) => {
    if (metric.value === undefined) {
      return;
    }
    const entry = metric.entries.find(
      entry => entry.duration === metric.value && INP_ENTRY_MAP[entry.name] !== undefined,
    );
    const client = (0,esm_exports/* getClient */.s3)();
    if (!entry || !client) {
      return;
    }
    const interactionType = INP_ENTRY_MAP[entry.name];
    const options = client.getOptions();
    /** Build the INP span, create an envelope from the span, and then send the envelope */
    const startTime = msToSec((esm_time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
    const duration = msToSec(metric.value);
    const interaction =
      entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
    if (interaction === undefined) {
      return;
    }
    const { routeName, parentContext, activeTransaction, user, replayId } = interaction;
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    // eslint-disable-next-line deprecation/deprecation
    const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
    const span = new Span({
      startTimestamp: startTime,
      endTimestamp: startTime + duration,
      op: `ui.interaction.${interactionType}`,
      name: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
      attributes: {
        release: options.release,
        environment: options.environment,
        transaction: routeName,
        ...(userDisplay !== undefined && userDisplay !== '' ? { user: userDisplay } : {}),
        ...(profileId !== undefined ? { profile_id: profileId } : {}),
        ...(replayId !== undefined ? { replay_id: replayId } : {}),
      },
      exclusiveTime: metric.value,
      measurements: {
        inp: { value: metric.value, unit: 'millisecond' },
      },
    });

    /** Check to see if the span should be sampled */
    const sampleRate = getSampleRate(parentContext, options, interactionsSampleRate);

    if (!sampleRate) {
      return;
    }

    if (Math.random() < (sampleRate )) {
      const envelope = span ? createSpanEnvelope([span], client.getDsn()) : undefined;
      const transport = client && client.getTransport();
      if (transport && envelope) {
        transport.send(envelope).then(null, reason => {
          common_debug_build_DEBUG_BUILD && esm_logger/* logger.error */.kg.error('Error while sending interaction:', reason);
        });
      }
      return;
    }
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !types_WINDOW.performance.getEntries || !esm_time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  const timeOrigin = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1);

  const performanceEntries = performance.getEntries();

  const { op, start_timestamp: transactionStartTime } = (0,spanUtils/* spanToJSON */.XU)(transaction);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = msToSec(entry.startTime);
    const duration = msToSec(entry.duration);

    // eslint-disable-next-line deprecation/deprecation
    if (transaction.op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        const firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        break;
      }
      case 'resource': {
        _addResourceSpans(transaction, entry, entry.name , startTime, duration, timeOrigin);
        break;
      }
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (op === 'pageload') {
    _addTtfbRequestTimeToMeasurements(_measurements);

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      const oldValue = _measurements[name].value;
      const measurementTimestamp = timeOrigin + msToSec(oldValue);

      // normalizedValue should be in milliseconds
      const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
      const delta = normalizedValue - oldValue;

      common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: fidMark.value + msToSec(_measurements['fid'].value),
        op: 'ui.action',
        origin: 'auto.ui.browser.metrics',
        startTimestamp: fidMark.value,
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      setMeasurement(measurementName, _measurements[measurementName].value, _measurements[measurementName].unit);
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  startTime,
  duration,
  timeOrigin,
) {
  const measureStartTimestamp = timeOrigin + startTime;
  const measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    origin: 'auto.resource.browser.metrics',
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  const end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  const start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    origin: 'auto.browser.browser.metrics',
    description: description || event,
    startTimestamp: timeOrigin + msToSec(start),
    endTimestamp: timeOrigin + msToSec(end),
  });
}

/** Create request and response related spans */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
  if (entry.responseEnd) {
    // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
    // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
    // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
    // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
    _startChild(transaction, {
      op: 'browser',
      origin: 'auto.browser.browser.metrics',
      description: 'request',
      startTimestamp: timeOrigin + msToSec(entry.requestStart ),
      endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
    });

    _startChild(transaction, {
      op: 'browser',
      origin: 'auto.browser.browser.metrics',
      description: 'response',
      startTimestamp: timeOrigin + msToSec(entry.responseStart ),
      endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
    });
  }
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceUrl,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

  const parsedUrl = url_parseUrl(resourceUrl);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = {};
  setResourceEntrySizeData(data, entry, 'transferSize', 'http.response_transfer_size');
  setResourceEntrySizeData(data, entry, 'encodedBodySize', 'http.response_content_length');
  setResourceEntrySizeData(data, entry, 'decodedBodySize', 'http.decoded_response_content_length');

  if ('renderBlockingStatus' in entry) {
    data['resource.render_blocking_status'] = entry.renderBlockingStatus;
  }
  if (parsedUrl.protocol) {
    data['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
  }

  if (parsedUrl.host) {
    data['server.address'] = parsedUrl.host;
  }

  data['url.same_origin'] = resourceUrl.includes(types_WINDOW.location.origin);

  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceUrl.replace(types_WINDOW.location.origin, ''),
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    origin: 'auto.resource.browser.metrics',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  const navigator = types_WINDOW.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.Rt)(source.node)),
    );
  }
}

function setResourceEntrySizeData(
  data,
  entry,
  key,
  dataKey,
) {
  const entryVal = entry[key];
  if (entryVal != null && entryVal < MAX_INT_AS_BYTES) {
    data[dataKey] = entryVal;
  }
}

/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */
function _addTtfbRequestTimeToMeasurements(_measurements) {
  const navEntry = getNavigationEntry();
  if (!navEntry) {
    return;
  }

  const { responseStart, requestStart } = navEntry;

  if (requestStart <= responseStart) {
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding TTFB Request Time');
    _measurements['ttfb.requestTime'] = {
      value: responseStart - requestStart,
      unit: 'millisecond',
    };
  }
}

/** Taken from @sentry/core sampling.ts */
function getSampleRate(
  transactionContext,
  options,
  interactionsSampleRate,
) {
  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)(options)) {
    return false;
  }
  let sampleRate;
  if (transactionContext !== undefined && typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler({
      transactionContext,
      name: transactionContext.name,
      parentSampled: transactionContext.parentSampled,
      attributes: {
        // eslint-disable-next-line deprecation/deprecation
        ...transactionContext.data,
        ...transactionContext.attributes,
      },
      location: types_WINDOW.location,
    });
  } else if (transactionContext !== undefined && transactionContext.sampled !== undefined) {
    sampleRate = transactionContext.sampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
  } else {
    sampleRate = 1;
  }
  if (!isValidSampleRate(sampleRate)) {
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('[Tracing] Discarding interaction span because of invalid sample rate.');
    return false;
  }
  if (sampleRate === true) {
    return interactionsSampleRate;
  } else if (sampleRate === false) {
    return 0;
  }
  return sampleRate * interactionsSampleRate;
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/baggage.js
var baggage = __webpack_require__(19494);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/common/fetch.js



/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */
function instrumentFetchRequest(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
  spanOrigin = 'auto.http.browser',
) {
  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)() || !handlerData.fetchData) {
    return undefined;
  }

  const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);

  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      endSpan(span, handlerData);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return undefined;
  }

  const scope = (0,esm_exports/* getCurrentScope */.nZ)();
  const client = (0,esm_exports/* getClient */.s3)();

  const { method, url } = handlerData.fetchData;

  const fullUrl = getFullURL(url);
  const host = fullUrl ? url_parseUrl(fullUrl).host : undefined;

  const span = shouldCreateSpanResult
    ? (0,trace/* startInactiveSpan */.qp)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
          url,
          type: 'fetch',
          'http.method': method,
          'http.url': fullUrl,
          'server.address': host,
          [SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        },
        op: 'http.client',
      })
    : undefined;

  if (span) {
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
  }

  if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
    const request = handlerData.args[0];

    // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
    handlerData.args[1] = handlerData.args[1] || {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = handlerData.args[1];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
    options.headers = addTracingHeadersToFetchRequest(request, client, scope, options, span);
  }

  return span;
}

/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */
function addTracingHeadersToFetchRequest(
  request, // unknown is actually type Request but we can't export DOM types from this package,
  client,
  scope,
  options

,
  requestSpan,
) {
  // eslint-disable-next-line deprecation/deprecation
  const span = requestSpan || scope.getSpan();

  const isolationScope = (0,esm_hub/* getIsolationScope */.aF)();

  const { traceId, spanId, sampled, dsc } = {
    ...isolationScope.getPropagationContext(),
    ...scope.getPropagationContext(),
  };

  const sentryTraceHeader = span ? (0,spanUtils/* spanToTraceHeader */.Hb)(span) : (0,tracing/* generateSentryTraceHeader */.$p)(traceId, spanId, sampled);

  const sentryBaggageHeader = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(
    dsc ||
      (span ? (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(span) : (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(traceId, client, scope)),
  );

  const headers =
    options.headers ||
    (typeof Request !== 'undefined' && (0,is/* isInstanceOf */.V9)(request, Request) ? (request ).headers : undefined);

  if (!headers) {
    return { 'sentry-trace': sentryTraceHeader, baggage: sentryBaggageHeader };
  } else if (typeof Headers !== 'undefined' && (0,is/* isInstanceOf */.V9)(headers, Headers)) {
    const newHeaders = new Headers(headers );

    newHeaders.append('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // If the same header is appended multiple times the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.append(baggage/* BAGGAGE_HEADER_NAME */.bU, sentryBaggageHeader);
    }

    return newHeaders ;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers, ['sentry-trace', sentryTraceHeader]];

    if (sentryBaggageHeader) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push([baggage/* BAGGAGE_HEADER_NAME */.bU, sentryBaggageHeader]);
    }

    return newHeaders ;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    const newBaggageHeaders = [];

    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders.push(...existingBaggageHeader);
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(existingBaggageHeader);
    }

    if (sentryBaggageHeader) {
      newBaggageHeaders.push(sentryBaggageHeader);
    }

    return {
      ...(headers ),
      'sentry-trace': sentryTraceHeader,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined,
    };
  }
}

function getFullURL(url) {
  try {
    const parsed = new URL(url);
    return parsed.href;
  } catch (e) {
    return undefined;
  }
}

function endSpan(span, handlerData) {
  if (handlerData.response) {
    setHttpStatus(span, handlerData.response.status);

    const contentLength =
      handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');

    if (contentLength) {
      const contentLengthNum = parseInt(contentLength);
      if (contentLengthNum > 0) {
        span.setAttribute('http.response_content_length', contentLengthNum);
      }
    }
  } else if (handlerData.error) {
    span.setStatus('internal_error');
  }
  span.end();
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/request.js






/* eslint-disable max-lines */

const DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\/(?!\/)/];

/** Options for Request Instrumentation */

const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  enableHTTPTimings: true,
  // TODO (v8): Remove this property
  tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
  const {
    traceFetch,
    traceXHR,
    // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets,
    // eslint-disable-next-line deprecation/deprecation
    tracingOrigins,
    shouldCreateSpanForRequest,
    enableHTTPTimings,
  } = {
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR,
    ..._options,
  };

  const shouldCreateSpan =
    typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_) => true;

  // TODO(v8) Remove tracingOrigins here
  // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
  // and we don't want to break the API. We can remove it in v8.
  const shouldAttachHeadersWithTargets = (url) =>
    shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);

  const spans = {};

  if (traceFetch) {
    addFetchInstrumentationHandler(handlerData => {
      const createdSpan = instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
      // We cannot use `window.location` in the generic fetch instrumentation,
      // but we need it for reliable `server.address` attribute.
      // so we extend this in here
      if (createdSpan) {
        const fullUrl = request_getFullURL(handlerData.fetchData.url);
        const host = fullUrl ? url_parseUrl(fullUrl).host : undefined;
        createdSpan.setAttributes({
          'http.url': fullUrl,
          'server.address': host,
        });
      }

      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }

  if (traceXHR) {
    addXhrInstrumentationHandler(handlerData => {
      const createdSpan = xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }
}

function isPerformanceResourceTiming(entry) {
  return (
    entry.entryType === 'resource' &&
    'initiatorType' in entry &&
    typeof (entry ).nextHopProtocol === 'string' &&
    (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest')
  );
}

/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */
function addHTTPTimings(span) {
  const { url } = (0,spanUtils/* spanToJSON */.XU)(span).data || {};

  if (!url || typeof url !== 'string') {
    return;
  }

  const cleanup = addPerformanceInstrumentationHandler('resource', ({ entries }) => {
    entries.forEach(entry => {
      if (isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
        const spanData = resourceTimingEntryToSpanData(entry);
        spanData.forEach(data => span.setAttribute(...data));
        // In the next tick, clean this handler up
        // We have to wait here because otherwise this cleans itself up before it is fully done
        setTimeout(cleanup);
      }
    });
  });
}

/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */
function extractNetworkProtocol(nextHopProtocol) {
  let name = 'unknown';
  let version = 'unknown';
  let _name = '';
  for (const char of nextHopProtocol) {
    // http/1.1 etc.
    if (char === '/') {
      [name, version] = nextHopProtocol.split('/');
      break;
    }
    // h2, h3 etc.
    if (!isNaN(Number(char))) {
      name = _name === 'h' ? 'http' : _name;
      version = nextHopProtocol.split(_name)[1];
      break;
    }
    _name += char;
  }
  if (_name === nextHopProtocol) {
    // webrtc, ftp, etc.
    name = _name;
  }
  return { name, version };
}

function getAbsoluteTime(time = 0) {
  return ((esm_time/* browserPerformanceTimeOrigin */.Z1 || performance.timeOrigin) + time) / 1000;
}

function resourceTimingEntryToSpanData(resourceTiming) {
  const { name, version } = extractNetworkProtocol(resourceTiming.nextHopProtocol);

  const timingSpanData = [];

  timingSpanData.push(['network.protocol.version', version], ['network.protocol.name', name]);

  if (!esm_time/* browserPerformanceTimeOrigin */.Z1) {
    return timingSpanData;
  }
  return [
    ...timingSpanData,
    ['http.request.redirect_start', getAbsoluteTime(resourceTiming.redirectStart)],
    ['http.request.fetch_start', getAbsoluteTime(resourceTiming.fetchStart)],
    ['http.request.domain_lookup_start', getAbsoluteTime(resourceTiming.domainLookupStart)],
    ['http.request.domain_lookup_end', getAbsoluteTime(resourceTiming.domainLookupEnd)],
    ['http.request.connect_start', getAbsoluteTime(resourceTiming.connectStart)],
    ['http.request.secure_connection_start', getAbsoluteTime(resourceTiming.secureConnectionStart)],
    ['http.request.connection_end', getAbsoluteTime(resourceTiming.connectEnd)],
    ['http.request.request_start', getAbsoluteTime(resourceTiming.requestStart)],
    ['http.request.response_start', getAbsoluteTime(resourceTiming.responseStart)],
    ['http.request.response_end', getAbsoluteTime(resourceTiming.responseEnd)],
  ];
}

/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */
function shouldAttachHeaders(url, tracePropagationTargets) {
  return (0,string/* stringMatchesSomePattern */.U0)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}

/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */
// eslint-disable-next-line complexity
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  const xhr = handlerData.xhr;
  const sentryXhrData = xhr && xhr[SENTRY_XHR_DATA_KEY];

  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) {
    return undefined;
  }

  const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    const spanId = xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    const span = spans[spanId];
    if (span && sentryXhrData.status_code !== undefined) {
      setHttpStatus(span, sentryXhrData.status_code);
      span.end();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return undefined;
  }

  const scope = (0,esm_exports/* getCurrentScope */.nZ)();
  const isolationScope = (0,esm_hub/* getIsolationScope */.aF)();

  const fullUrl = request_getFullURL(sentryXhrData.url);
  const host = fullUrl ? url_parseUrl(fullUrl).host : undefined;

  const span = shouldCreateSpanResult
    ? (0,trace/* startInactiveSpan */.qp)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
          type: 'xhr',
          'http.method': sentryXhrData.method,
          'http.url': fullUrl,
          url: sentryXhrData.url,
          'server.address': host,
          [SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.http.browser',
        },
        op: 'http.client',
      })
    : undefined;

  if (span) {
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
  }

  const client = (0,esm_exports/* getClient */.s3)();

  if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
    const { traceId, spanId, sampled, dsc } = {
      ...isolationScope.getPropagationContext(),
      ...scope.getPropagationContext(),
    };

    const sentryTraceHeader = span ? (0,spanUtils/* spanToTraceHeader */.Hb)(span) : (0,tracing/* generateSentryTraceHeader */.$p)(traceId, spanId, sampled);

    const sentryBaggageHeader = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(
      dsc ||
        (span ? (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(span) : (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(traceId, client, scope)),
    );

    setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
  }

  return span;
}

function setHeaderOnXhr(
  xhr,
  sentryTraceHeader,
  sentryBaggageHeader,
) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
    if (sentryBaggageHeader) {
      // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
      // We can therefore simply set a baggage header without checking what was there before
      // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      xhr.setRequestHeader(baggage/* BAGGAGE_HEADER_NAME */.bU, sentryBaggageHeader);
    }
  } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
  }
}

function request_getFullURL(url) {
  try {
    // By adding a base URL to new URL(), this will also work for relative urls
    // If `url` is a full URL, the base URL is ignored anyhow
    const parsed = new URL(url, types_WINDOW.location.origin);
    return parsed.href;
  } catch (e) {
    return undefined;
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/router.js




/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!types_WINDOW || !types_WINDOW.location) {
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = types_WINDOW.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: types_WINDOW.location.pathname,
      // pageload should always start at timeOrigin (and needs to be in s, not ms)
      startTimestamp: esm_time/* browserPerformanceTimeOrigin */.Z1 ? esm_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
      op: 'pageload',
      origin: 'auto.pageload.browser',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    addHistoryInstrumentationHandler(({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.end();
        }
        activeTransaction = customStartTransaction({
          name: types_WINDOW.location.pathname,
          op: 'navigation',
          origin: 'auto.navigation.browser',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js










const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  ...TRACING_DEFAULTS,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  enableLongTask: true,
  enableInp: false,
  interactionsSampleRate: 1,
  _experiments: {},
  ...defaultRequestInstrumentationOptions,
};

/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */
const MAX_INTERACTIONS = 10;

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */
class browsertracing_BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */

  // eslint-disable-next-line deprecation/deprecation

   constructor(_options) {
    this.name = BROWSER_TRACING_INTEGRATION_ID;
    this._hasSetTracePropagationTargets = false;

    addTracingExtensions();

    if (common_debug_build_DEBUG_BUILD) {
      this._hasSetTracePropagationTargets = !!(
        _options &&
        // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins)
      );
    }

    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
    };

    // Special case: enableLongTask can be set in _experiments
    // TODO (v8): Remove this in v8
    if (this.options._experiments.enableLongTask !== undefined) {
      this.options.enableLongTask = this.options._experiments.enableLongTask;
    }

    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
      // eslint-disable-next-line deprecation/deprecation
      this.options.tracePropagationTargets = _options.tracingOrigins;
    }

    this._collectWebVitals = startTrackingWebVitals();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */
    this._interactionIdToRouteNameMapping = {};

    if (this.options.enableInp) {
      startTrackingINP(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
    }
    if (this.options.enableLongTask) {
      startTrackingLongTasks();
    }
    if (this.options._experiments.enableInteractions) {
      startTrackingInteractions();
    }

    this._latestRoute = {
      name: undefined,
      context: undefined,
    };
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;
    const hub = getCurrentHub();
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const clientOptions = client && client.getOptions();

    const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      shouldCreateSpanForRequest,
      enableHTTPTimings,
      _experiments,
    } = this.options;

    const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
    // There are three ways to configure tracePropagationTargets:
    // 1. via top level client option `tracePropagationTargets`
    // 2. via BrowserTracing option `tracePropagationTargets`
    // 3. via BrowserTracing option `tracingOrigins` (deprecated)
    //
    // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
    // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
    // This is done as it minimizes bundle size (we don't have to have undefined checks).
    //
    // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
    // eslint-disable-next-line deprecation/deprecation
    const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
    if (common_debug_build_DEBUG_BUILD && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) {
      esm_logger/* logger.warn */.kg.warn(
        '[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.',
      );
    }

    instrumentRouting(
      (context) => {
        const transaction = this._createRouteTransaction(context);

        this.options._experiments.onStartRouteTransaction &&
          this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);

        return transaction;
      },
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    if (_experiments.enableInteractions) {
      this._registerInteractionListener();
    }

    if (this.options.enableInp) {
      this._registerInpInteractionListener();
    }

    instrumentOutgoingRequests({
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
      enableHTTPTimings,
    });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      common_debug_build_DEBUG_BUILD &&
        esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

    const hub = this._getCurrentHub();

    const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;

    const isPageloadTransaction = context.op === 'pageload';

    let expandedContext;
    if (isPageloadTransaction) {
      const sentryTrace = isPageloadTransaction ? getMetaContent('sentry-trace') : '';
      const baggage = isPageloadTransaction ? getMetaContent('baggage') : undefined;
      const { traceId, dsc, parentSpanId, sampled } = (0,tracing/* propagationContextFromHeaders */.pT)(sentryTrace, baggage);
      expandedContext = {
        traceId,
        parentSpanId,
        parentSampled: sampled,
        ...context,
        metadata: {
          // eslint-disable-next-line deprecation/deprecation
          ...context.metadata,
          dynamicSamplingContext: dsc,
        },
        trimEnd: true,
      };
    } else {
      expandedContext = {
        trimEnd: true,
        ...context,
      };
    }

    const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    const finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    // eslint-disable-next-line deprecation/deprecation
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? // eslint-disable-next-line deprecation/deprecation
          { ...finalContext.metadata, source: 'custom' }
        : // eslint-disable-next-line deprecation/deprecation
          finalContext.metadata;

    this._latestRoute.name = finalContext.name;
    this._latestRoute.context = finalContext;

    // eslint-disable-next-line deprecation/deprecation
    if (finalContext.sampled === false) {
      common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const { location } = types_WINDOW;

    const idleTransaction = startIdleTransaction(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
      isPageloadTransaction, // should wait for finish signal if it's a pageload transaction
    );

    if (isPageloadTransaction) {
      if (types_WINDOW.document) {
        types_WINDOW.document.addEventListener('readystatechange', () => {
          if (['interactive', 'complete'].includes(types_WINDOW.document.readyState)) {
            idleTransaction.sendAutoFinishSignal();
          }
        });

        if (['interactive', 'complete'].includes(types_WINDOW.document.readyState)) {
          idleTransaction.sendAutoFinishSignal();
        }
      }
    }

    idleTransaction.registerBeforeFinishCallback(transaction => {
      this._collectWebVitals();
      addPerformanceEntries(transaction);
    });

    return idleTransaction ;
  }

  /** Start listener for interaction transactions */
   _registerInteractionListener() {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = () => {
      const { idleTimeout, finalTimeout, heartbeatInterval } = this.options;
      const op = 'ui.action.click';

      // eslint-disable-next-line deprecation/deprecation
      const currentTransaction = getActiveTransaction();
      if (currentTransaction && currentTransaction.op && ['navigation', 'pageload'].includes(currentTransaction.op)) {
        common_debug_build_DEBUG_BUILD &&
          esm_logger/* logger.warn */.kg.warn(
            `[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`,
          );
        return undefined;
      }

      if (inflightInteractionTransaction) {
        inflightInteractionTransaction.setFinishReason('interactionInterrupted');
        inflightInteractionTransaction.end();
        inflightInteractionTransaction = undefined;
      }

      if (!this._getCurrentHub) {
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
        return undefined;
      }

      if (!this._latestRoute.name) {
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
        return undefined;
      }

      const hub = this._getCurrentHub();
      const { location } = types_WINDOW;

      const context = {
        name: this._latestRoute.name,
        op,
        trimEnd: true,
        data: {
          [SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: this._latestRoute.context
            ? getSource(this._latestRoute.context)
            : 'url',
        },
      };

      inflightInteractionTransaction = startIdleTransaction(
        hub,
        context,
        idleTimeout,
        finalTimeout,
        true,
        { location }, // for use in the tracesSampler
        heartbeatInterval,
      );
    };

    ['click'].forEach(type => {
      if (types_WINDOW.document) {
        addEventListener(type, registerInteractionTransaction, { once: false, capture: true });
      }
    });
  }

  /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */
   _registerInpInteractionListener() {
    const handleEntries = ({ entries }) => {
      const client = (0,esm_exports/* getClient */.s3)();
      // We need to get the replay, user, and activeTransaction from the current scope
      // so that we can associate replay id, profile id, and a user display to the span
      const replay =
        client !== undefined && client.getIntegrationByName !== undefined
          ? (client.getIntegrationByName('Replay') )
          : undefined;
      const replayId = replay !== undefined ? replay.getReplayId() : undefined;
      // eslint-disable-next-line deprecation/deprecation
      const activeTransaction = getActiveTransaction();
      const currentScope = (0,esm_exports/* getCurrentScope */.nZ)();
      const user = currentScope !== undefined ? currentScope.getUser() : undefined;
      entries.forEach(entry => {
        if (isPerformanceEventTiming(entry)) {
          const interactionId = entry.interactionId;
          if (interactionId === undefined) {
            return;
          }
          const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
          const duration = entry.duration;
          const startTime = entry.startTime;
          const keys = Object.keys(this._interactionIdToRouteNameMapping);
          const minInteractionId =
            keys.length > 0
              ? keys.reduce((a, b) => {
                  return this._interactionIdToRouteNameMapping[a].duration <
                    this._interactionIdToRouteNameMapping[b].duration
                    ? a
                    : b;
                })
              : undefined;
          // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
          // This is also checked in the web-vitals library.
          if (entry.entryType === 'first-input') {
            const matchingEntry = keys
              .map(key => this._interactionIdToRouteNameMapping[key])
              .some(interaction => {
                return interaction.duration === duration && interaction.startTime === startTime;
              });
            if (matchingEntry) {
              return;
            }
          }
          // Interactions with an id of 0 and are not first-input are not valid.
          if (!interactionId) {
            return;
          }
          // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
          if (existingInteraction) {
            existingInteraction.duration = Math.max(existingInteraction.duration, duration);
          } else if (
            keys.length < MAX_INTERACTIONS ||
            minInteractionId === undefined ||
            duration > this._interactionIdToRouteNameMapping[minInteractionId].duration
          ) {
            // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
            const routeName = this._latestRoute.name;
            const parentContext = this._latestRoute.context;
            if (routeName && parentContext) {
              if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= MAX_INTERACTIONS) {
                // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._interactionIdToRouteNameMapping[minInteractionId];
              }
              this._interactionIdToRouteNameMapping[interactionId] = {
                routeName,
                duration,
                parentContext,
                user,
                activeTransaction,
                replayId,
                startTime,
              };
            }
          }
        }
      });
    };
    addPerformanceInstrumentationHandler('event', handleEntries);
    addPerformanceInstrumentationHandler('first-input', handleEntries);
  }
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = (0,browser/* getDomElement */.qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : undefined;
}

function getSource(context) {
  const sourceFromAttributes = context.attributes && context.attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
  // eslint-disable-next-line deprecation/deprecation
  const sourceFromData = context.data && context.data[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
  // eslint-disable-next-line deprecation/deprecation
  const sourceFromMetadata = context.metadata && context.metadata.source;

  return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

function isPerformanceEventTiming(entry) {
  return 'duration' in entry;
}


//# sourceMappingURL=browsertracing.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browserTracingIntegration.js









const browserTracingIntegration_BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const browserTracingIntegration_DEFAULT_BROWSER_TRACING_OPTIONS = {
  ...TRACING_DEFAULTS,
  instrumentNavigation: true,
  instrumentPageLoad: true,
  markBackgroundSpan: true,
  enableLongTask: true,
  enableInp: false,
  interactionsSampleRate: 1,
  _experiments: {},
  ...defaultRequestInstrumentationOptions,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */
const browserTracingIntegration = ((_options = {}) => {
  const _hasSetTracePropagationTargets = common_debug_build_DEBUG_BUILD
    ? !!(
        // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins)
      )
    : false;

  addTracingExtensions();

  // TODO (v8): remove this block after tracingOrigins is removed
  // Set tracePropagationTargets to tracingOrigins if specified by the user
  // In case both are specified, tracePropagationTargets takes precedence
  // eslint-disable-next-line deprecation/deprecation
  if (!_options.tracePropagationTargets && _options.tracingOrigins) {
    // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
  }

  const options = {
    ...browserTracingIntegration_DEFAULT_BROWSER_TRACING_OPTIONS,
    ..._options,
  };

  const _collectWebVitals = startTrackingWebVitals();

  /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */
  const interactionIdToRouteNameMapping = {};
  if (options.enableInp) {
    startTrackingINP(interactionIdToRouteNameMapping, options.interactionsSampleRate);
  }

  if (options.enableLongTask) {
    startTrackingLongTasks();
  }
  if (options._experiments.enableInteractions) {
    startTrackingInteractions();
  }

  const latestRoute

 = {
    name: undefined,
    context: undefined,
  };

  /** Create routing idle transaction. */
  function _createRouteTransaction(context) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0,esm_hub/* getCurrentHub */.Gd)();

    const { beforeStartSpan, idleTimeout, finalTimeout, heartbeatInterval } = options;

    const isPageloadTransaction = context.op === 'pageload';

    let expandedContext;
    if (isPageloadTransaction) {
      const sentryTrace = isPageloadTransaction ? browserTracingIntegration_getMetaContent('sentry-trace') : '';
      const baggage = isPageloadTransaction ? browserTracingIntegration_getMetaContent('baggage') : undefined;
      const { traceId, dsc, parentSpanId, sampled } = (0,tracing/* propagationContextFromHeaders */.pT)(sentryTrace, baggage);
      expandedContext = {
        traceId,
        parentSpanId,
        parentSampled: sampled,
        ...context,
        metadata: {
          // eslint-disable-next-line deprecation/deprecation
          ...context.metadata,
          dynamicSamplingContext: dsc,
        },
        trimEnd: true,
      };
    } else {
      expandedContext = {
        trimEnd: true,
        ...context,
      };
    }

    const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;

    // If `beforeStartSpan` set a custom name, record that fact
    // eslint-disable-next-line deprecation/deprecation
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? // eslint-disable-next-line deprecation/deprecation
          { ...finalContext.metadata, source: 'custom' }
        : // eslint-disable-next-line deprecation/deprecation
          finalContext.metadata;

    latestRoute.name = finalContext.name;
    latestRoute.context = finalContext;

    if (finalContext.sampled === false) {
      common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const { location } = types_WINDOW;

    const idleTransaction = startIdleTransaction(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
      isPageloadTransaction, // should wait for finish signal if it's a pageload transaction
    );

    if (isPageloadTransaction && types_WINDOW.document) {
      types_WINDOW.document.addEventListener('readystatechange', () => {
        if (['interactive', 'complete'].includes(types_WINDOW.document.readyState)) {
          idleTransaction.sendAutoFinishSignal();
        }
      });

      if (['interactive', 'complete'].includes(types_WINDOW.document.readyState)) {
        idleTransaction.sendAutoFinishSignal();
      }
    }

    idleTransaction.registerBeforeFinishCallback(transaction => {
      _collectWebVitals();
      addPerformanceEntries(transaction);
    });

    return idleTransaction ;
  }

  return {
    name: browserTracingIntegration_BROWSER_TRACING_INTEGRATION_ID,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setupOnce: () => {},
    afterAllSetup(client) {
      const clientOptions = client.getOptions();

      const { markBackgroundSpan, traceFetch, traceXHR, shouldCreateSpanForRequest, enableHTTPTimings, _experiments } =
        options;

      const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
      // There are three ways to configure tracePropagationTargets:
      // 1. via top level client option `tracePropagationTargets`
      // 2. via BrowserTracing option `tracePropagationTargets`
      // 3. via BrowserTracing option `tracingOrigins` (deprecated)
      //
      // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
      // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
      // This is done as it minimizes bundle size (we don't have to have undefined checks).
      //
      // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
      // eslint-disable-next-line deprecation/deprecation
      const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
      if (common_debug_build_DEBUG_BUILD && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) {
        esm_logger/* logger.warn */.kg.warn(
          '[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.',
        );
      }

      let activeSpan;
      let startingUrl = types_WINDOW.location && types_WINDOW.location.href;

      if (client.on) {
        client.on('startNavigationSpan', (context) => {
          if (activeSpan) {
            common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${(0,spanUtils/* spanToJSON */.XU)(activeSpan).op}`);
            // If there's an open transaction on the scope, we need to finish it before creating an new one.
            activeSpan.end();
          }
          activeSpan = _createRouteTransaction({
            op: 'navigation',
            ...context,
          });
        });

        client.on('startPageLoadSpan', (context) => {
          if (activeSpan) {
            common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${(0,spanUtils/* spanToJSON */.XU)(activeSpan).op}`);
            // If there's an open transaction on the scope, we need to finish it before creating an new one.
            activeSpan.end();
          }
          activeSpan = _createRouteTransaction({
            op: 'pageload',
            ...context,
          });
        });
      }

      if (options.instrumentPageLoad && client.emit && types_WINDOW.location) {
        const context = {
          name: types_WINDOW.location.pathname,
          // pageload should always start at timeOrigin (and needs to be in s, not ms)
          startTimestamp: esm_time/* browserPerformanceTimeOrigin */.Z1 ? esm_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
          origin: 'auto.pageload.browser',
          attributes: {
            [SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'url',
          },
        };
        startBrowserTracingPageLoadSpan(client, context);
      }

      if (options.instrumentNavigation && client.emit && types_WINDOW.location) {
        addHistoryInstrumentationHandler(({ to, from }) => {
          /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */
          if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
          }

          if (from !== to) {
            startingUrl = undefined;
            const context = {
              name: types_WINDOW.location.pathname,
              origin: 'auto.navigation.browser',
              attributes: {
                [SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'url',
              },
            };

            startBrowserTracingNavigationSpan(client, context);
          }
        });
      }

      if (markBackgroundSpan) {
        registerBackgroundTabDetection();
      }

      if (_experiments.enableInteractions) {
        registerInteractionListener(options, latestRoute);
      }

      if (options.enableInp) {
        registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
      }

      instrumentOutgoingRequests({
        traceFetch,
        traceXHR,
        tracePropagationTargets,
        shouldCreateSpanForRequest,
        enableHTTPTimings,
      });
    },
    // TODO v8: Remove this again
    // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
    options,
  };
}) ;

/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */
function startBrowserTracingPageLoadSpan(client, spanOptions) {
  if (!client.emit) {
    return;
  }

  client.emit('startPageLoadSpan', spanOptions);

  const span = (0,trace/* getActiveSpan */.HN)();
  const op = span && (0,spanUtils/* spanToJSON */.XU)(span).op;
  return op === 'pageload' ? span : undefined;
}

/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */
function startBrowserTracingNavigationSpan(client, spanOptions) {
  if (!client.emit) {
    return;
  }

  client.emit('startNavigationSpan', spanOptions);

  const span = (0,trace/* getActiveSpan */.HN)();
  const op = span && (0,spanUtils/* spanToJSON */.XU)(span).op;
  return op === 'navigation' ? span : undefined;
}

/** Returns the value of a meta tag */
function browserTracingIntegration_getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = (0,browser/* getDomElement */.qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : undefined;
}

/** Start listener for interaction transactions */
function registerInteractionListener(
  options,
  latestRoute

,
) {
  let inflightInteractionTransaction;
  const registerInteractionTransaction = () => {
    const { idleTimeout, finalTimeout, heartbeatInterval } = options;
    const op = 'ui.action.click';

    // eslint-disable-next-line deprecation/deprecation
    const currentTransaction = getActiveTransaction();
    if (currentTransaction && currentTransaction.op && ['navigation', 'pageload'].includes(currentTransaction.op)) {
      common_debug_build_DEBUG_BUILD &&
        esm_logger/* logger.warn */.kg.warn(
          `[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`,
        );
      return undefined;
    }

    if (inflightInteractionTransaction) {
      inflightInteractionTransaction.setFinishReason('interactionInterrupted');
      inflightInteractionTransaction.end();
      inflightInteractionTransaction = undefined;
    }

    if (!latestRoute.name) {
      common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
      return undefined;
    }

    const { location } = types_WINDOW;

    const context = {
      name: latestRoute.name,
      op,
      trimEnd: true,
      data: {
        [SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: latestRoute.context ? browserTracingIntegration_getSource(latestRoute.context) : 'url',
      },
    };

    inflightInteractionTransaction = startIdleTransaction(
      // eslint-disable-next-line deprecation/deprecation
      (0,esm_hub/* getCurrentHub */.Gd)(),
      context,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
    );
  };

  ['click'].forEach(type => {
    if (types_WINDOW.document) {
      addEventListener(type, registerInteractionTransaction, { once: false, capture: true });
    }
  });
}

function browserTracingIntegration_isPerformanceEventTiming(entry) {
  return 'duration' in entry;
}

/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */
const browserTracingIntegration_MAX_INTERACTIONS = 10;

/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */
function registerInpInteractionListener(
  interactionIdToRouteNameMapping,
  latestRoute

,
) {
  const handleEntries = ({ entries }) => {
    const client = (0,esm_exports/* getClient */.s3)();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay =
      client !== undefined && client.getIntegrationByName !== undefined
        ? (client.getIntegrationByName('Replay') )
        : undefined;
    const replayId = replay !== undefined ? replay.getReplayId() : undefined;
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = getActiveTransaction();
    const currentScope = (0,esm_exports/* getCurrentScope */.nZ)();
    const user = currentScope !== undefined ? currentScope.getUser() : undefined;
    entries.forEach(entry => {
      if (browserTracingIntegration_isPerformanceEventTiming(entry)) {
        const interactionId = entry.interactionId;
        if (interactionId === undefined) {
          return;
        }
        const existingInteraction = interactionIdToRouteNameMapping[interactionId];
        const duration = entry.duration;
        const startTime = entry.startTime;
        const keys = Object.keys(interactionIdToRouteNameMapping);
        const minInteractionId =
          keys.length > 0
            ? keys.reduce((a, b) => {
                return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration
                  ? a
                  : b;
              })
            : undefined;
        // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
        // This is also checked in the web-vitals library.
        if (entry.entryType === 'first-input') {
          const matchingEntry = keys
            .map(key => interactionIdToRouteNameMapping[key])
            .some(interaction => {
              return interaction.duration === duration && interaction.startTime === startTime;
            });
          if (matchingEntry) {
            return;
          }
        }
        // Interactions with an id of 0 and are not first-input are not valid.
        if (!interactionId) {
          return;
        }
        // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
        if (existingInteraction) {
          existingInteraction.duration = Math.max(existingInteraction.duration, duration);
        } else if (
          keys.length < browserTracingIntegration_MAX_INTERACTIONS ||
          minInteractionId === undefined ||
          duration > interactionIdToRouteNameMapping[minInteractionId].duration
        ) {
          // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
          const routeName = latestRoute.name;
          const parentContext = latestRoute.context;
          if (routeName && parentContext) {
            if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= browserTracingIntegration_MAX_INTERACTIONS) {
              // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
              delete interactionIdToRouteNameMapping[minInteractionId];
            }
            interactionIdToRouteNameMapping[interactionId] = {
              routeName,
              duration,
              parentContext,
              user,
              activeTransaction,
              replayId,
              startTime,
            };
          }
        }
      }
    });
  };
  addPerformanceInstrumentationHandler('event', handleEntries);
  addPerformanceInstrumentationHandler('first-input', handleEntries);
}

function browserTracingIntegration_getSource(context) {
  const sourceFromAttributes = context.attributes && context.attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
  // eslint-disable-next-line deprecation/deprecation
  const sourceFromData = context.data && context.data[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
  // eslint-disable-next-line deprecation/deprecation
  const sourceFromMetadata = context.metadata && context.metadata.source;

  return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}


//# sourceMappingURL=browserTracingIntegration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/routing/appRouterRoutingInstrumentation.js



const DEFAULT_TAGS = {
  'routing.instrumentation': 'next-app-router',
} ;

/**
 * Instruments the Next.js Client App Router.
 */
// TODO(v8): Clean this function up by splitting into pageload and navigation instrumentation respectively. Also remove startTransactionCb in the process.
function appRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
  startPageloadSpanCallback,
  startNavigationSpanCallback,
) {
  // We keep track of the active transaction so we can finish it when we start a navigation transaction.
  let activeTransaction = undefined;

  // We keep track of the previous location name so we can set the `from` field on navigation transactions.
  // This is either a route or a pathname.
  let prevLocationName = helpers_WINDOW.location.pathname;

  if (startTransactionOnPageLoad) {
    const transactionContext = {
      name: prevLocationName,
      op: 'pageload',
      origin: 'auto.pageload.nextjs.app_router_instrumentation',
      tags: DEFAULT_TAGS,
      // pageload should always start at timeOrigin (and needs to be in s, not ms)
      startTimestamp: esm_time/* browserPerformanceTimeOrigin */.Z1 ? esm_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
      metadata: { source: 'url' },
    } ;
    activeTransaction = startTransactionCb(transactionContext);
    startPageloadSpanCallback(transactionContext);
  }

  if (startTransactionOnLocationChange) {
    addFetchInstrumentationHandler(handlerData => {
      // The instrumentation handler is invoked twice - once for starting a request and once when the req finishes
      // We can use the existence of the end-timestamp to filter out "finishing"-events.
      if (handlerData.endTimestamp !== undefined) {
        return;
      }

      // Only GET requests can be navigating RSC requests
      if (handlerData.fetchData.method !== 'GET') {
        return;
      }

      const parsedNavigatingRscFetchArgs = parseNavigatingRscFetchArgs(handlerData.args);

      if (parsedNavigatingRscFetchArgs === null) {
        return;
      }

      const transactionName = parsedNavigatingRscFetchArgs.targetPathname;
      const tags = {
        ...DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.end();
      }

      const transactionContext = {
        name: transactionName,
        op: 'navigation',
        origin: 'auto.navigation.nextjs.app_router_instrumentation',
        tags,
        metadata: { source: 'url' },
      } ;

      startTransactionCb(transactionContext);
      startNavigationSpanCallback(transactionContext);
    });
  }
}

function parseNavigatingRscFetchArgs(fetchArgs)

 {
  // Make sure the first arg is a URL object
  if (!fetchArgs[0] || typeof fetchArgs[0] !== 'object' || (fetchArgs[0] ).searchParams === undefined) {
    return null;
  }

  // Make sure the second argument is some kind of fetch config obj that contains headers
  if (!fetchArgs[1] || typeof fetchArgs[1] !== 'object' || !('headers' in fetchArgs[1])) {
    return null;
  }

  try {
    const url = fetchArgs[0] ;
    const headers = fetchArgs[1].headers ;

    // Not an RSC request
    if (headers['RSC'] !== '1') {
      return null;
    }

    // Prefetch requests are not navigating RSC requests
    if (headers['Next-Router-Prefetch'] === '1') {
      return null;
    }

    return {
      targetPathname: url.pathname,
    };
  } catch (e) {
    return null;
  }
}


//# sourceMappingURL=appRouterRoutingInstrumentation.js.map

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(21395);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/@sentry/nextjs/esm/common/debug-build.js
var common_debug_build = __webpack_require__(63124);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/routing/pagesRouterRoutingInstrumentation.js






const globalObject = helpers_WINDOW

;

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      common_debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  const nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props && props.pageProps) {
    nextDataTagInfo.sentryTrace = props.pageProps._sentryTraceData;
    nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
  }

  return nextDataTagInfo;
}

const pagesRouterRoutingInstrumentation_DEFAULT_TAGS = {
  'routing.instrumentation': 'next-pages-router',
} ;

// We keep track of the active transaction so we can finish it when we start a navigation transaction.
let activeTransaction = undefined;

// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
let prevLocationName = undefined;

const client = (0,esm_exports/* getClient */.s3)();

/**
 * Instruments the Next.js pages router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function pagesRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
  startPageloadSpanCallback,
  startNavigationSpanCallback,
) {
  const { route, params, sentryTrace, baggage } = extractNextDataTagInformation();
  // eslint-disable-next-line deprecation/deprecation
  const { traceparentData, dynamicSamplingContext, propagationContext } = (0,tracing/* tracingContextFromHeaders */.KA)(
    sentryTrace,
    baggage,
  );

  (0,esm_exports/* getCurrentScope */.nZ)().setPropagationContext(propagationContext);
  prevLocationName = route || globalObject.location.pathname;

  if (startTransactionOnPageLoad) {
    const source = route ? 'route' : 'url';
    const transactionContext = {
      name: prevLocationName,
      op: 'pageload',
      origin: 'auto.pageload.nextjs.pages_router_instrumentation',
      tags: pagesRouterRoutingInstrumentation_DEFAULT_TAGS,
      // pageload should always start at timeOrigin (and needs to be in s, not ms)
      startTimestamp: esm_time/* browserPerformanceTimeOrigin */.Z1 ? esm_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
      ...(params && client && client.getOptions().sendDefaultPii && { data: params }),
      ...traceparentData,
      metadata: {
        source,
        dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
    } ;
    activeTransaction = startTransactionCb(transactionContext);
    startPageloadSpanCallback(transactionContext);
  }

  if (startTransactionOnLocationChange) {
    router_default().events.on('routeChangeStart', (navigationTarget) => {
      const strippedNavigationTarget = stripUrlQueryAndFragment(navigationTarget);
      const matchedRoute = getNextRouteFromPathname(strippedNavigationTarget);

      let transactionName;
      let transactionSource;

      if (matchedRoute) {
        transactionName = matchedRoute;
        transactionSource = 'route';
      } else {
        transactionName = strippedNavigationTarget;
        transactionSource = 'url';
      }

      const tags = {
        ...pagesRouterRoutingInstrumentation_DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.end();
      }

      const transactionContext = {
        name: transactionName,
        op: 'navigation',
        origin: 'auto.navigation.nextjs.pages_router_instrumentation',
        tags,
        metadata: { source: transactionSource },
      } ;
      const navigationTransaction = startTransactionCb(transactionContext);
      startNavigationSpanCallback(transactionContext);

      if (navigationTransaction) {
        // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
        // and `routeChangeComplete` events.
        // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
        // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
        // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
        // eslint-disable-next-line deprecation/deprecation
        const nextRouteChangeSpan = navigationTransaction.startChild({
          op: 'ui.nextjs.route-change',
          origin: 'auto.ui.nextjs.pages_router_instrumentation',
          description: 'Next.js Route Change',
        });

        const finishRouteChangeSpan = () => {
          nextRouteChangeSpan.end();
          router_default().events.off('routeChangeComplete', finishRouteChangeSpan);
        };

        router_default().events.on('routeChangeComplete', finishRouteChangeSpan);
      }
    });
  }
}

function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }

  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');

  let optionalCatchallWildcardRegex = '';
  if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }

  const rejoinedRouteParts = routeParts
    .map(
      routePart =>
        routePart
          .replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
          .replace(/^\[.*\]$/, '([^/]+?)'), // Replace route wildcards with lazy regex wildcards
    )
    .join('/');

  // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- routeParts are from the build manifest, so no raw user input
  return new RegExp(
    `^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`, // optional slash at the end
  );
}


//# sourceMappingURL=pagesRouterRoutingInstrumentation.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/routing/nextRoutingInstrumentation.js




/**
 * Instruments the Next.js Client Router.
 *
 * @deprecated Use `browserTracingIntegration()` as exported from `@sentry/nextjs` instead.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
  startPageloadSpanCallback,
  startNavigationSpanCallback,
) {
  const isAppRouter = !helpers_WINDOW.document.getElementById('__NEXT_DATA__');
  if (isAppRouter) {
    appRouterInstrumentation(
      startTransactionCb,
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
      startPageloadSpanCallback || (() => undefined),
      startNavigationSpanCallback || (() => undefined),
    );
  } else {
    pagesRouterInstrumentation(
      startTransactionCb,
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
      startPageloadSpanCallback || (() => undefined),
      startNavigationSpanCallback || (() => undefined),
    );
  }
}


//# sourceMappingURL=nextRoutingInstrumentation.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/browserTracingIntegration.js



/**
 * A custom BrowserTracing integration for Next.js.
 *
 * @deprecated Use `browserTracingIntegration` instead.
 */
// eslint-disable-next-line deprecation/deprecation
class BrowserTracing extends browsertracing_BrowserTracing {
  // eslint-disable-next-line deprecation/deprecation
   constructor(options) {
    super({
      // eslint-disable-next-line deprecation/deprecation
      tracingOrigins:
         false
          ? 0
          : // eslint-disable-next-line deprecation/deprecation
            [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
      // eslint-disable-next-line deprecation/deprecation
      routingInstrumentation: nextRouterInstrumentation,
      ...options,
    });
  }
}

/**
 * A custom BrowserTracing integration for Next.js.
 */
function browserTracingIntegration_browserTracingIntegration(
  options,
) {
  const browserTracingIntegrationInstance = browserTracingIntegration({
    // eslint-disable-next-line deprecation/deprecation
    tracingOrigins:
       false
        ? 0
        : // eslint-disable-next-line deprecation/deprecation
          [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
    ...options,
    instrumentNavigation: false,
    instrumentPageLoad: false,
  });

  const fullOptions = {
    ...browserTracingIntegrationInstance.options,
    instrumentPageLoad: true,
    instrumentNavigation: true,
    ...options,
  };

  return {
    ...browserTracingIntegrationInstance,
    options: fullOptions,
    afterAllSetup(client) {
      const startPageloadCallback = (startSpanOptions) => {
        startBrowserTracingPageLoadSpan(client, startSpanOptions);
      };

      const startNavigationCallback = (startSpanOptions) => {
        startBrowserTracingNavigationSpan(client, startSpanOptions);
      };

      // We need to run the navigation span instrumentation before the `afterAllSetup` hook on the normal browser
      // tracing integration because we need to ensure the order of execution is as follows:
      // Instrumentation to start span on RSC fetch request runs -> Instrumentation to put tracing headers from active span on fetch runs
      // If it were the other way around, the RSC fetch request would not receive the tracing headers from the navigation transaction.
      // eslint-disable-next-line deprecation/deprecation
      nextRouterInstrumentation(
        () => undefined,
        false,
        fullOptions.instrumentNavigation,
        startPageloadCallback,
        startNavigationCallback,
      );

      browserTracingIntegrationInstance.afterAllSetup(client);

      // eslint-disable-next-line deprecation/deprecation
      nextRouterInstrumentation(
        () => undefined,
        fullOptions.instrumentPageLoad,
        false,
        startPageloadCallback,
        startNavigationCallback,
      );
    },
  };
}


//# sourceMappingURL=browserTracingIntegration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i] ;
    const fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  let up = 0;
  for (let i = parts.length - 1; i >= 0; i--) {
    const last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */
function splitPath(filename) {
  // Truncate files names greater than 1024 characters to avoid regex dos
  // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
  const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
  const parts = splitPathRe.exec(truncated);
  return parts ? parts.slice(1) : [];
}

// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve(...args) {
  let resolvedPath = '';
  let resolvedAbsolute = false;

  for (let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    const path = i >= 0 ? args[i] : '/';

    // Skip empty entries
    if (!path) {
      continue;
    }

    resolvedPath = `${path}/${resolvedPath}`;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(
    resolvedPath.split('/').filter(p => !!p),
    !resolvedAbsolute,
  ).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}

/** JSDoc */
function trim(arr) {
  let start = 0;
  for (; start < arr.length; start++) {
    if (arr[start] !== '') {
      break;
    }
  }

  let end = arr.length - 1;
  for (; end >= 0; end--) {
    if (arr[end] !== '') {
      break;
    }
  }

  if (start > end) {
    return [];
  }
  return arr.slice(start, end - start + 1);
}

// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
  /* eslint-disable no-param-reassign */
  from = resolve(from).slice(1);
  to = resolve(to).slice(1);
  /* eslint-enable no-param-reassign */

  const fromParts = trim(from.split('/'));
  const toParts = trim(to.split('/'));

  const length = Math.min(fromParts.length, toParts.length);
  let samePartsLength = length;
  for (let i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  let outputParts = [];
  for (let i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
}

// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
  const isPathAbsolute = isAbsolute(path);
  const trailingSlash = path.slice(-1) === '/';

  // Normalize the path
  let normalizedPath = normalizeArray(
    path.split('/').filter(p => !!p),
    !isPathAbsolute,
  ).join('/');

  if (!normalizedPath && !isPathAbsolute) {
    normalizedPath = '.';
  }
  if (normalizedPath && trailingSlash) {
    normalizedPath += '/';
  }

  return (isPathAbsolute ? '/' : '') + normalizedPath;
}

// posix version
/** JSDoc */
function isAbsolute(path) {
  return path.charAt(0) === '/';
}

// posix version
/** JSDoc */
function join(...args) {
  return normalizePath(args.join('/'));
}

/** JSDoc */
function dirname(path) {
  const result = splitPath(path);
  const root = result[0];
  let dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
  }

  return root + dir;
}

/** JSDoc */
function basename(path, ext) {
  let f = splitPath(path)[2];
  if (ext && f.slice(ext.length * -1) === ext) {
    f = f.slice(0, f.length - ext.length);
  }
  return f;
}


//# sourceMappingURL=path.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/rewriteframes.js



const rewriteframes_INTEGRATION_NAME = 'RewriteFrames';

const _rewriteFramesIntegration = ((options = {}) => {
  const root = options.root;
  const prefix = options.prefix || 'app:///';

  const iteratee =
    options.iteratee ||
    ((frame) => {
      if (!frame.filename) {
        return frame;
      }
      // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
      const isWindowsFrame =
        /^[a-zA-Z]:\\/.test(frame.filename) ||
        // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        (frame.filename.includes('\\') && !frame.filename.includes('/'));
      // Check if the frame filename begins with `/`
      const startsWithSlash = /^\//.test(frame.filename);
      if (isWindowsFrame || startsWithSlash) {
        const filename = isWindowsFrame
          ? frame.filename
              .replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
              .replace(/\\/g, '/') // replace all `\\` instances with `/`
          : frame.filename;
        const base = root ? relative(root, filename) : basename(filename);
        frame.filename = `${prefix}${base}`;
      }
      return frame;
    });

  /** Process an exception event. */
  function _processExceptionsEvent(event) {
    try {
      return {
        ...event,
        exception: {
          ...event.exception,
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(value => ({
            ...value,
            ...(value.stacktrace && { stacktrace: _processStacktrace(value.stacktrace) }),
          })),
        },
      };
    } catch (_oO) {
      return event;
    }
  }

  /** Process a stack trace. */
  function _processStacktrace(stacktrace) {
    return {
      ...stacktrace,
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(f => iteratee(f)),
    };
  }

  return {
    name: rewriteframes_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(originalEvent) {
      let processedEvent = originalEvent;

      if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
        processedEvent = _processExceptionsEvent(processedEvent);
      }

      return processedEvent;
    },
  };
}) ;

const rewriteFramesIntegration = defineIntegration(_rewriteFramesIntegration);

/**
 * Rewrite event frames paths.
 * @deprecated Use `rewriteFramesIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const RewriteFrames = convertIntegrationFnToClass(
  rewriteframes_INTEGRATION_NAME,
  rewriteFramesIntegration,
)

;


//# sourceMappingURL=rewriteframes.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/rewriteFramesIntegration.js





const globalWithInjectedValues = worldwide/* GLOBAL_OBJ */.n2

;

const customRewriteFramesIntegration = ((options) => {
  // This value is injected at build time, based on the output directory specified in the build config. Though a default
  // is set there, we set it here as well, just in case something has gone wrong with the injection.
  const assetPrefixPath = globalWithInjectedValues.__rewriteFramesAssetPrefixPath__ || '';

  return rewriteFramesIntegration({
    // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
    iteratee: frame => {
      try {
        const { origin } = new URL(frame.filename );
        frame.filename = _optionalChain([frame, 'access', _ => _.filename, 'optionalAccess', _2 => _2.replace, 'call', _3 => _3(origin, 'app://'), 'access', _4 => _4.replace, 'call', _5 => _5(assetPrefixPath, '')]);
      } catch (err) {
        // Filename wasn't a properly formed URL, so there's nothing we can do
      }

      // We need to URI-decode the filename because Next.js has wildcard routes like "/users/[id].js" which show up as "/users/%5id%5.js" in Error stacktraces.
      // The corresponding sources that Next.js generates have proper brackets so we also need proper brackets in the frame so that source map resolving works.
      if (frame.filename && frame.filename.startsWith('app:///_next')) {
        frame.filename = decodeURI(frame.filename);
      }

      if (
        frame.filename &&
        frame.filename.match(
          /^app:\/\/\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/,
        )
      ) {
        // We don't care about these frames. It's Next.js internal code.
        frame.in_app = false;
      }

      return frame;
    },
    ...options,
  });
}) ;

const rewriteFramesIntegration_rewriteFramesIntegration = defineIntegration(customRewriteFramesIntegration);


//# sourceMappingURL=rewriteFramesIntegration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/tunnelRoute.js



const tunnelRoute_globalWithInjectedValues = worldwide/* GLOBAL_OBJ */.n2

;

/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */
function applyTunnelRouteOption(options) {
  const tunnelRouteOption = tunnelRoute_globalWithInjectedValues.__sentryRewritesTunnelPath__;
  if (tunnelRouteOption && options.dsn) {
    const dsnComponents = dsnFromString(options.dsn);
    if (!dsnComponents) {
      return;
    }
    const sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest(?:\.([a-z]{2}))?\.sentry\.io$/);
    if (sentrySaasDsnMatch) {
      const orgId = sentrySaasDsnMatch[1];
      const regionCode = sentrySaasDsnMatch[2];
      let tunnelPath = `${tunnelRouteOption}?o=${orgId}&p=${dsnComponents.projectId}`;
      if (regionCode) {
        tunnelPath += `&r=${regionCode}`;
      }
      options.tunnel = tunnelPath;
      common_debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.info */.kg.info(`Tunneling events to "${tunnelPath}"`);
    } else {
      common_debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn('Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.');
    }
  }
}


//# sourceMappingURL=tunnelRoute.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/index.js


























/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */
const client_Integrations = {
  // eslint-disable-next-line deprecation/deprecation
  ...INTEGRATIONS,
  BrowserTracing: BrowserTracing,
};

// Treeshakable guard to remove all code related to tracing

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function client_init(options) {
  const opts = {
    environment: getVercelEnv(true) || "production",
    defaultIntegrations: client_getDefaultIntegrations(options),
    ...options,
  };

  fixBrowserTracingIntegration(opts);

  applyTunnelRouteOption(opts);
  applySdkMetadata(opts, 'nextjs', ['nextjs', 'react']);

  sdk_init(opts);

  const scope = (0,esm_exports/* getCurrentScope */.nZ)();
  scope.setTag('runtime', 'browser');
  const filterTransactions = event =>
    event.type === 'transaction' && event.transaction === '/404' ? null : event;
  filterTransactions.id = 'NextClient404Filter';
  scope.addEventProcessor(filterTransactions);

  if (false) {}
}

// TODO v8: Remove this again
// We need to handle BrowserTracing passed to `integrations` that comes from `@sentry/tracing`, not `@sentry/nextjs` :(
function fixBrowserTracingIntegration(options) {
  const { integrations } = options;
  if (!integrations) {
    return;
  }

  if (Array.isArray(integrations)) {
    options.integrations = maybeUpdateBrowserTracingIntegration(integrations);
  } else {
    options.integrations = defaultIntegrations => {
      const userFinalIntegrations = integrations(defaultIntegrations);

      return maybeUpdateBrowserTracingIntegration(userFinalIntegrations);
    };
  }
}

function isNewBrowserTracingIntegration(
  integration,
) {
  // eslint-disable-next-line deprecation/deprecation
  return !!integration.afterAllSetup && !!(integration ).options;
}

function maybeUpdateBrowserTracingIntegration(integrations) {
  const browserTracing = integrations.find(integration => integration.name === 'BrowserTracing');

  if (!browserTracing) {
    return integrations;
  }

  // If `browserTracingIntegration()` was added, we need to force-convert it to our custom one
  if (isNewBrowserTracingIntegration(browserTracing)) {
    const { options } = browserTracing;
    // eslint-disable-next-line deprecation/deprecation
    integrations[integrations.indexOf(browserTracing)] = browserTracingIntegration_browserTracingIntegration(options);
  }

  // If BrowserTracing was added, but it is not our forked version,
  // replace it with our forked version with the same options
  // eslint-disable-next-line deprecation/deprecation
  if (!(browserTracing instanceof BrowserTracing)) {
    // eslint-disable-next-line deprecation/deprecation
    const options = (browserTracing ).options;
    // This option is overwritten by the custom integration
    delete options.routingInstrumentation;
    // eslint-disable-next-line deprecation/deprecation
    delete options.tracingOrigins;
    // eslint-disable-next-line deprecation/deprecation
    integrations[integrations.indexOf(browserTracing)] = new BrowserTracing(options);
  }

  return integrations;
}

function client_getDefaultIntegrations(options) {
  const customDefaultIntegrations = [...getDefaultIntegrations(options), rewriteFramesIntegration_rewriteFramesIntegration()];

  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false", in which case everything inside
  // will get treeshaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    if ((0,hasTracingEnabled/* hasTracingEnabled */.z)(options)) {
      customDefaultIntegrations.push(browserTracingIntegration_browserTracingIntegration());
    }
  }

  return customDefaultIntegrations;
}

/**
 * Just a passthrough in case this is imported from the client.
 */
function withSentryConfig(exportedUserNextConfig) {
  return exportedUserNextConfig;
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./sentry.client.config.ts
/* provided dependency */ var sentry_client_config_process = __webpack_require__(47859);
var _sentryCollisionFreeGlobalObject =  true ? window : 0;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
    "id": "v7.38.0"
};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/lisa";

var SENTRY_DSN = sentry_client_config_process.env.SENTRY_DSN || sentry_client_config_process.env.NEXT_PUBLIC_SENTRY_DSN;
var SENTRY_ENVIRONMENT = "production";
client_init({
    debug: false,
    denyUrls: [
        // from HubSpot script, cfr
        //  * https://community.hubspot.com/t5/CMS-Development/Next-js-Project-utilizing-Hubspot-forms-is-throwing-this/td-p/741262
        //  * https://community.hubspot.com/t5/CMS-Development/LeadFlow-Errors/m-p/381841
        /app:\/\/\/leadflows\.js/i, 
    ],
    dsn: SENTRY_DSN || "https://0c6a224a0b83b07bbe6600ecbfd9a2a2@o216259.ingest.us.sentry.io/4507934647386112",
    environment: SENTRY_ENVIRONMENT,
    tracesSampleRate: 0.01
});


/***/ }),

/***/ 4098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Icon_Arrow; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62271);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(3292);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/components/Icon/BaseSvg.tsx
var BaseSvg = __webpack_require__(57586);
// EXTERNAL MODULE: src/components/Icon/Arrow/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/Icon/Arrow/styles.css.ts.vanilla.css","source":"Ll8xc3k4eDBsMCB7CiAgdHJhbnNmb3JtOiByb3RhdGUoMGRlZyk7Cn0KLl8xc3k4eDBsMSB7CiAgdHJhbnNmb3JtOiByb3RhdGUoOTBkZWcpOwp9Ci5fMXN5OHgwbDIgewogIHRyYW5zZm9ybTogcm90YXRlKDE4MGRlZyk7Cn0KLl8xc3k4eDBsMyB7CiAgdHJhbnNmb3JtOiByb3RhdGUoMjcwZGVnKTsKfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(30815);
;// CONCATENATED MODULE: ./src/components/Icon/Arrow/styles.css.ts

var directionRotate = {left:'_1sy8x0l0',top:'_1sy8x0l1',right:'_1sy8x0l2',bottom:'_1sy8x0l3'};
;// CONCATENATED MODULE: ./src/components/Icon/Arrow/index.tsx






var Arrow = function(_param) {
    var _direction = _param.direction, direction = _direction === void 0 ? "left" : _direction, props = (0,_object_without_properties/* default */.Z)(_param, [
        "direction"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: directionRotate[direction]
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            clipRule: "evenodd",
            d: "M7.75577 1.33337L1.33317 8.00004L7.75577 14.6667L8.93428 13.4434L4.52502 8.86495L14.6665 8.86504V7.13504L4.52502 7.13495L8.93428 2.55667L7.75577 1.33337Z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ var Icon_Arrow = (Arrow);


/***/ }),

/***/ 73200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _BaseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57586);




var ArrowUp = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.855 6.687l-5.456 5.332-1.242-1.271 6.698-6.546 6.988 6.829-1.242 1.271z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowUp);


/***/ }),

/***/ 57586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62271);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3292);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _design_lib_style_theme_sprinkles_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20579);





var BaseSvg = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_design_lib_style_theme_sprinkles_css__WEBPACK_IMPORTED_MODULE_1__/* .sprinkles */ .K)({
            fill: "currentcolor"
        }),
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseSvg);


/***/ }),

/***/ 31552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _BaseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57586);




var Calendar = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: props.className
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            clipRule: "evenodd",
            d: "M6 0v1h4V0h2v1h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2V0h2Zm8 6H2v7h12V6Zm-6 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm-3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm6-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM5 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm9-4H2v1h12V3Z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Calendar);


/***/ }),

/***/ 5260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _BaseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57586);




var CasavoLogoSmall = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        height: "16",
        viewBox: "0 0 14 16",
        width: "14"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M0.347251 10.2703C1.26314 13.5306 4.24007 15.9239 7.47717 15.9953C8.44909 16.0297 9.48098 15.8701 10.4447 15.5044C10.5456 15.4662 10.535 15.314 10.4302 15.2902C7.71493 14.6778 5.38099 12.575 4.79796 9.70483C4.26218 7.06696 5.03572 4.3693 6.3835 2.12C6.6046 1.75116 6.82993 1.39454 7.08768 1.04513C7.1843 0.91425 7.24972 0.79402 7.42114 0.833783C7.58227 0.871042 7.59863 1.02133 7.65163 1.26116C8.19407 3.71211 10.475 5.55344 13.001 5.62671C13.087 5.62921 13.1575 5.55626 13.1575 5.46703V0.196939C13.1575 0.088294 13.0724 0 12.967 0H7.7122V0.000939298C4.54204 0.0331885 1.82739 2.03076 0.652849 4.87151C0.652849 4.87151 -0.584083 7.2924 0.347251 10.2703Z",
            fill: "currentColor"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CasavoLogoSmall);


/***/ }),

/***/ 5513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _BaseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57586);




var Check = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: props.className
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            clipRule: "evenodd",
            d: "M14.2778 0.923828L15.3905 3.93038L12.2604 7.06901L12.2516 7.07117L12.2604 7.07248L6.61012 12.7345L6.35707 12.9917L5.45234 13.8954L1.86114 10.2945L0.12793 8.48018L2.15231 6.46422L5.45234 9.77317L14.2778 0.923828Z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Check);


/***/ }),

/***/ 71169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Icon_Chevron; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62271);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(3292);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Icon/BaseSvg.tsx
var BaseSvg = __webpack_require__(57586);
// EXTERNAL MODULE: src/components/Icon/Chevron/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/Icon/Chevron/styles.css.ts.vanilla.css","source":"Ll8xZXhhMmt1MCB7CiAgdHJhbnNmb3JtOiByb3RhdGUoOTBkZWcpOwp9Ci5fMWV4YTJrdTEgewogIHRyYW5zZm9ybTogcm90YXRlKDE4MGRlZyk7Cn0KLl8xZXhhMmt1MiB7CiAgdHJhbnNmb3JtOiByb3RhdGUoMjcwZGVnKTsKfQouXzFleGEya3UzIHsKICB0cmFuc2Zvcm06IHJvdGF0ZSgwZGVnKTsKfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(28752);
;// CONCATENATED MODULE: ./src/components/Icon/Chevron/styles.css.ts

var directionRotate = {left:'_1exa2ku0',top:'_1exa2ku1',right:'_1exa2ku2',bottom:'_1exa2ku3'};
;// CONCATENATED MODULE: ./src/components/Icon/Chevron/index.tsx







var Chevron = function(_param) {
    var className = _param.className, _direction = _param.direction, direction = _direction === void 0 ? "right" : _direction, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "direction"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classnames_default()(directionRotate[direction], className),
        role: "img",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            clipRule: "evenodd",
            d: "M15.5 5.83486L8 13.4395L0.5 5.83486L1.87621 4.43945L8 10.6479L14.1238 4.43945L15.5 5.83486Z",
            fill: props.fillColor || "currentColor",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ var Icon_Chevron = (Chevron);


/***/ }),

/***/ 87411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _BaseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57586);




var Close = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M0 1.41L1.41 0L7 5.59L12.59 0L14 1.41L8.41 7L14 12.59L12.59 14L7 8.41L1.41 14L0 12.59L5.59 7L0 1.41Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Close);


/***/ }),

/***/ 13428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _BaseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57586);




var Delete = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_BaseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        height: "20",
        viewBox: "0 0 18 20",
        width: "18"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.4475 1.35731C12.5041 1.47637 12.5357 1.60957 12.5357 1.75016V3.19064L17.25 3.19064V5.54778H0.75V3.19064L5.46429 3.19064V1.75016C5.46429 1.60957 5.49594 1.47637 5.5525 1.35731C5.69962 1.04761 6.01528 0.833496 6.38095 0.833496H11.619C11.9847 0.833496 12.3004 1.04761 12.4475 1.35731Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2.84524 6.72635V16.6787C2.84524 17.185 3.25564 17.5954 3.76191 17.5954H14.2381C14.7444 17.5954 15.1548 17.185 15.1548 16.6787V6.72635H16.9881V16.6787C16.9881 18.1975 15.7569 19.4287 14.2381 19.4287H3.76191C2.24312 19.4287 1.0119 18.1975 1.0119 16.6787V6.72635H2.84524Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.46429 6.72635H7.82143V14.9764H5.46429V6.72635Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.1786 6.72635H12.5357V14.9764H10.1786V6.72635Z",
                fill: "currentColor"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Delete);


/***/ }),

/***/ 42324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _BaseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57586);




var FavouritesRemoved = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: props.className,
        height: "22",
        viewBox: "0 0 25 22",
        width: "25"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M17.7786 0.000106909C15.6299 0.000106909 13.6187 1.01952 12.2162 2.76979C10.8097 1.01705 8.80119 0.000106909 6.65526 0.000106909C3.34822 0.000106909 0 2.46739 0 7.18284C0 13.8425 11.2127 21.252 11.6902 21.5638L12.2171 21.9088L12.744 21.5642C13.2213 21.2523 24.4341 13.8424 24.4341 7.18322C24.4341 2.46743 21.0859 0 17.7789 0L17.7786 0.000106909ZM1.92489 7.18333C1.92489 3.57083 4.37663 1.92548 6.65492 1.92548C8.47955 1.92548 10.1196 2.91283 11.1832 4.64756L9.35631 11.4879L13.1352 11.7457L11.5734 19.146C8.08777 16.6342 1.92513 11.3333 1.92513 7.18292L1.92489 7.18333ZM13.667 18.5485L15.4761 9.97569L11.8194 9.72601L13.1155 4.87383C13.1383 4.83284 13.1605 4.79186 13.1859 4.74955C14.2396 2.9543 15.9135 1.92464 17.7789 1.92464C20.0572 1.92464 22.5089 3.57 22.5089 7.18249C22.5086 11.0247 17.2171 15.8603 13.667 18.5487L13.667 18.5485Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FavouritesRemoved);


/***/ }),

/***/ 95274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _BaseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57586);




var Filter = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: props.className
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M2 11.3333V12.6667H6V11.3333H2ZM2 3.33333V4.66667H8.66667V3.33333H2ZM8.66667 14V12.6667H14V11.3333H8.66667V10H7.33333V14H8.66667ZM4.66667 6V7.33333H2V8.66667H4.66667V10H6V6H4.66667ZM14 8.66667V7.33333H7.33333V8.66667H14ZM10 6H11.3333V4.66667H14V3.33333H11.3333V2H10V6Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Filter);


/***/ }),

/***/ 97037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _BaseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57586);




var Gallery = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: props.className,
        viewBox: "0 0 17 17"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10.767.944c.699 0 1.31.38 1.636.945h2.708A1.89 1.89 0 0117 3.778V15.11H0V3.778a1.89 1.89 0 011.889-1.89h2.708A1.89 1.89 0 016.233.944h4.534zm-4.534 1.89l-.546.944H1.889v9.444H15.11V3.778h-3.798l-.545-.943-4.535-.002zM8.5 4.721a3.779 3.779 0 11-.001 7.557A3.779 3.779 0 018.5 4.721zm0 1.89a1.888 1.888 0 10-.001 3.779A1.888 1.888 0 008.5 6.61z",
            fill: "currentColor"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Gallery);


/***/ }),

/***/ 66753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _BaseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57586);




var MyLocation = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_BaseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_14003_21904)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.6263 5.83317C7.15297 5.83317 5.95964 7.0265 5.95964 8.49984C5.95964 9.97317 7.15297 11.1665 8.6263 11.1665C10.0996 11.1665 11.293 9.97317 11.293 8.49984C11.293 7.0265 10.0996 5.83317 8.6263 5.83317ZM14.5863 7.83317C14.2796 5.05317 12.073 2.8465 9.29297 2.53984V1.1665H7.95963V2.53984C5.17964 2.8465 2.97297 5.05317 2.6663 7.83317H1.29297V9.1665H2.6663C2.97297 11.9465 5.17964 14.1532 7.95963 14.4598V15.8332H9.29297V14.4598C12.073 14.1532 14.2796 11.9465 14.5863 9.1665H15.9596V7.83317H14.5863ZM8.6263 13.1665C6.0463 13.1665 3.95964 11.0798 3.95964 8.49984C3.95964 5.91984 6.0463 3.83317 8.6263 3.83317C11.2063 3.83317 13.293 5.91984 13.293 8.49984C13.293 11.0798 11.2063 13.1665 8.6263 13.1665Z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_14003_21904",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        height: "16",
                        transform: "translate(0.625 0.5)",
                        width: "16"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (MyLocation);


/***/ }),

/***/ 41800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _BaseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57586);




var Phone = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M2.36 1.33333C2.4 1.92667 2.5 2.50667 2.66 3.06L1.86 3.86C1.58667 3.06 1.41333 2.21333 1.35333 1.33333H2.36ZM8.93333 9.34667C9.5 9.50667 10.08 9.60667 10.6667 9.64667V10.64C9.78667 10.58 8.94 10.4067 8.13333 10.14L8.93333 9.34667ZM3 0H0.666667C0.3 0 0 0.3 0 0.666667C0 6.92667 5.07333 12 11.3333 12C11.7 12 12 11.7 12 11.3333V9.00667C12 8.64 11.7 8.34 11.3333 8.34C10.5067 8.34 9.7 8.20667 8.95333 7.96C8.88667 7.93333 8.81333 7.92667 8.74667 7.92667C8.57333 7.92667 8.40667 7.99333 8.27333 8.12L6.80667 9.58667C4.92 8.62 3.37333 7.08 2.41333 5.19333L3.88 3.72667C4.06667 3.54 4.12 3.28 4.04667 3.04667C3.8 2.3 3.66667 1.5 3.66667 0.666667C3.66667 0.3 3.36667 0 3 0Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Phone);


/***/ }),

/***/ 51100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _BaseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57586);




var Reply = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7 0l9 6.5L7 13V9.02C4.13 9.004 2.304 11.33 1.522 16-1.248 11.342-.338 3.092 7 3.034L7 0zm1.998 3.909v1.109l-1.983.016c-2.576.02-4.242 1.679-4.798 3.894l-.063.277.106-.12c1.168-1.3 2.667-2.012 4.5-2.062l.251-.003L9 7.032v2.057L12.584 6.5 8.998 3.909z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Reply);


/***/ }),

/***/ 26336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _BaseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57586);




var Tap = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: props.className
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            clipRule: "evenodd",
            d: "M6.005 4a1 1 0 0 1 1 1v2.916l.002-.033A1 1 0 0 1 9 8a1 1 0 0 1 2 0v1a1 1 0 1 1 2 0v2.824l.005.176v1a3 3 0 0 1-3 3h-2c-1.32 0-2.318-.838-2.505-1.025l-2.828-2.829a1.5 1.5 0 1 1 2.121-2.12l.211.211L5.005 5a1 1 0 0 1 1-1Zm5.245-2.665a1 1 0 0 1 .366 1.366l-1 1.732a1 1 0 0 1-1.732-1l1-1.732a1 1 0 0 1 1.366-.366ZM2.116 1.7l1 1.732a1 1 0 1 1-1.732 1l-1-1.732a1 1 0 1 1 1.732-1ZM6 0a1 1 0 0 1 1 1v1a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1Z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Tap);


/***/ }),

/***/ 96818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _BaseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57586);




var VirtualTour = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            clipRule: "evenodd",
            d: "M14.375 3.02197V13.9785L12.9531 13.725C9.92491 13.1852 6.8251 13.1852 3.79689 13.725L2.375 13.9785V3.02197L3.79689 3.27544C6.8251 3.81525 9.92491 3.81525 12.9531 3.27544L14.375 3.02197ZM13.3315 4.26762L13.1362 4.30272C10.0769 4.84808 6.94725 4.86367 3.88388 4.34947L3.61376 4.30272L3.41848 4.26788V12.7323L3.61376 12.6977C6.67312 12.1524 9.80275 12.1368 12.8661 12.651L13.1362 12.6977L13.3315 12.7326V4.26762ZM6.94023 6.41325V8.76108L6.15745 7.97805C5.74511 8.21692 5.50545 8.5036 5.50545 8.76108C5.50545 9.33957 6.71521 10.0654 8.37501 10.0654C10.0348 10.0654 11.2446 9.33957 11.2446 8.76108C11.2446 8.18259 10.0348 7.45673 8.37501 7.45673C8.19552 7.45673 8.02129 7.46522 7.85327 7.4811L7.85338 6.43393C8.02403 6.4203 8.19815 6.41325 8.37501 6.41325C10.5361 6.41325 12.2881 7.46441 12.2881 8.76108C12.2881 10.0578 10.5361 11.1089 8.37501 11.1089C6.2139 11.1089 4.46197 10.0578 4.46197 8.76108C4.46197 8.176 4.81866 7.6409 5.4087 7.2298L4.5924 6.41325H6.94023Z",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (VirtualTour);


/***/ }),

/***/ 81016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Icon; }
});

// EXTERNAL MODULE: ./src/components/Icon/Arrow/index.tsx + 1 modules
var Arrow = __webpack_require__(4098);
// EXTERNAL MODULE: ./src/components/Icon/ArrowUp/index.tsx
var ArrowUp = __webpack_require__(73200);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62271);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/components/Icon/BaseSvg.tsx
var BaseSvg = __webpack_require__(57586);
;// CONCATENATED MODULE: ./src/components/Icon/Bathroom/index.tsx




var Bathroom = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12 0c2.21 0 4 1.79 4 4v7.5c0 1.396-.817 2.6-1.999 3.163L14 15c0 .552-.448 1-1 1s-1-.448-1-1H4c0 .552-.448 1-1 1s-1-.448-1-1v-.337c-1.182-.562-2-1.767-2-3.163V9c0-.552.448-1 1-1h13V4c0-1.054-.816-1.918-1.85-1.995L12 2h-1.535c.34.588.535 1.271.535 2v2H3V4c0-2.21 1.79-4 4-4h5zm2 10H2v1.5c0 .78.595 1.42 1.356 1.493L3.5 13h9c.78 0 1.42-.595 1.493-1.356L14 11.5V10zM7 2c-1.054 0-1.918.816-1.995 1.85L5 4h4c0-1.054-.816-1.918-1.85-1.995L7 2z"
        })
    }));
};
/* harmony default export */ var Icon_Bathroom = (Bathroom);

;// CONCATENATED MODULE: ./src/components/Icon/Bedroom/index.tsx




var Bedroom = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13 0c1.105 0 2 .895 2 2v6c.552 0 1 .448 1 1v6h-3c0 .552-.448 1-1 1s-1-.448-1-1H5c0 .552-.448 1-1 1s-1-.448-1-1H0V9c0-.552.448-1 1-1V2c0-1.105.895-2 2-2h10zm1 10H2v3h12v-3zm-1-8H3v6h1.05C4.017 7.84 4 7.671 4 7.5 4 6.12 5.12 5 6.5 5h3C10.88 5 12 6.12 12 7.5c0 .171-.017.339-.05.5H13V2zM9.5 7h-3c-.276 0-.5.224-.5.5 0 .245.177.45.41.492L6.5 8h3c.276 0 .5-.224.5-.5 0-.245-.177-.45-.41-.492L9.5 7z"
        })
    }));
};
/* harmony default export */ var Icon_Bedroom = (Bedroom);

// EXTERNAL MODULE: ./src/components/Icon/Calendar/index.tsx
var Calendar = __webpack_require__(31552);
// EXTERNAL MODULE: ./src/components/Icon/CasavoLogoSmall/index.tsx
var CasavoLogoSmall = __webpack_require__(5260);
// EXTERNAL MODULE: ./src/components/Icon/Check/index.tsx
var Check = __webpack_require__(5513);
// EXTERNAL MODULE: ./src/components/Icon/Chevron/index.tsx + 1 modules
var Chevron = __webpack_require__(71169);
;// CONCATENATED MODULE: ./src/components/Icon/Clock/index.tsx




var Clock = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            clipRule: "evenodd",
            d: "M7 0.333313C10.6819 0.333313 13.6667 3.31808 13.6667 6.99998C13.6667 10.6819 10.6819 13.6666 7 13.6666C3.3181 13.6666 0.333328 10.6819 0.333328 6.99998C0.333328 3.31808 3.3181 0.333313 7 0.333313ZM6.99999 1.99998C4.23857 1.99998 1.99999 4.23856 1.99999 6.99998C1.99999 9.7614 4.23857 12 6.99999 12C9.76142 12 12 9.7614 12 6.99998C12 4.23856 9.76142 1.99998 6.99999 1.99998ZM7.83333 4.49998V6.99998H9.49999V8.66665H6.16666V4.49998H7.83333Z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ var Icon_Clock = (Clock);

// EXTERNAL MODULE: ./src/components/Icon/Close/index.tsx
var Close = __webpack_require__(87411);
;// CONCATENATED MODULE: ./src/components/Icon/DataUsage/index.tsx




var Delete = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        height: "20",
        viewBox: "0 0 18 20",
        width: "18"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_3789_32922)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8.66927 1.90625V3.92625C10.9293 4.25292 12.6693 6.18625 12.6693 8.53958C12.6693 9.13958 12.5493 9.70625 12.3493 10.2329L14.0826 11.2529C14.4559 10.4262 14.6693 9.50625 14.6693 8.53958C14.6693 5.08625 12.0359 2.23958 8.66927 1.90625ZM8.0026 13.2063C5.4226 13.2063 3.33594 11.1196 3.33594 8.53958C3.33594 6.18625 5.07594 4.25292 7.33594 3.92625V1.90625C3.9626 2.23958 1.33594 5.07958 1.33594 8.53958C1.33594 12.2196 4.31594 15.2063 7.99594 15.2063C10.2026 15.2063 12.1559 14.1329 13.3693 12.4796L11.6359 11.4596C10.7826 12.5262 9.47594 13.2063 8.0026 13.2063Z",
                    fill: "#FF991F"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_3789_32922",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "16",
                        transform: "translate(0 0.539062)",
                        width: "16"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var DataUsage = (Delete);

// EXTERNAL MODULE: ./src/components/Icon/Delete/index.tsx
var Icon_Delete = __webpack_require__(13428);
;// CONCATENATED MODULE: ./src/components/Icon/Favourites/index.tsx




var Favourites = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        height: 22,
        viewBox: "0 -1 21 22",
        width: 24,
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.99999 1.83854C11.9262 0.234375 13.9314 -0.166666 16.0156 0.635416C18.6724 1.65786 19.625 4.18653 19.625 6.65103C19.625 10.1949 16.4166 14.2053 9.99999 18.6823C3.58333 14.2053 0.375 10.1949 0.375 6.65103C0.375 4.37928 1.29611 1.69567 3.98437 0.635416C6.01804 -0.166666 8.02324 0.234375 9.99999 1.83854Z"
        })
    }));
};
/* harmony default export */ var Icon_Favourites = (Favourites);

// EXTERNAL MODULE: ./src/components/Icon/FavouritesRemoved/index.tsx
var FavouritesRemoved = __webpack_require__(42324);
// EXTERNAL MODULE: ./src/components/Icon/Filter/index.tsx
var Filter = __webpack_require__(95274);
// EXTERNAL MODULE: ./src/components/Icon/Gallery/index.tsx
var Gallery = __webpack_require__(97037);
;// CONCATENATED MODULE: ./src/components/Icon/Home/index.tsx




var House = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: props.className
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_1756_4404)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.6668 6.2V2.66667H10.6668V4.4L8.00016 2L1.3335 8H3.3335V13.3333H7.3335V9.33333H8.66683V13.3333H12.6668V8H14.6668L12.6668 6.2ZM11.3335 12H10.0002V8H6.00016V12H4.66683V6.79333L8.00016 3.79333L11.3335 6.79333V12Z",
                        fill: "#1D1D1B"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.66699 6.66665H9.33366C9.33366 5.93331 8.73366 5.33331 8.00033 5.33331C7.26699 5.33331 6.66699 5.93331 6.66699 6.66665Z",
                        fill: "#1D1D1B"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1756_4404",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "16",
                        width: "16"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Home = (House);

;// CONCATENATED MODULE: ./src/components/Icon/HouseSmall/index.tsx




var HouseSmall = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16 16H0v-4h1V2.875L8 1l7 1.875V12h1v4zm-3-6H3v4h4v-3h2v3h4v-4zM8 3.07L3 4.409V8h10V4.409L8 3.07zM9 5v2H7V5h2z"
        })
    }));
};
/* harmony default export */ var Icon_HouseSmall = (HouseSmall);

;// CONCATENATED MODULE: ./src/components/Icon/Info/index.tsx




var Info = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: props.className,
        viewBox: "0 0 18 18",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            clipRule: "evenodd",
            d: "M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0Zm0 2.25a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5Zm1.125 6.188v5.624h-2.25V8.439h2.25ZM9 3.938a1.688 1.688 0 1 1 0 3.375 1.688 1.688 0 0 1 0-3.375Z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ var Icon_Info = (Info);

;// CONCATENATED MODULE: ./src/components/Icon/InfoSolid/index.tsx




var InfoSolid = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: props.className,
        viewBox: "0 0 12 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            clipRule: "evenodd",
            d: "M7 0.333313C10.6819 0.333313 13.6667 3.31808 13.6667 6.99998C13.6667 10.6819 10.6819 13.6666 7 13.6666C3.3181 13.6666 0.333336 10.6819 0.333336 6.99998C0.333336 3.31808 3.3181 0.333313 7 0.333313ZM7.83334 6.16665H6.16667V11.1666H7.83334V6.16665ZM7 2.83331C6.30965 2.83331 5.75 3.39296 5.75 4.08331C5.75 4.77367 6.30965 5.33331 7 5.33331C7.69036 5.33331 8.25 4.77367 8.25 4.08331C8.25 3.39296 7.69036 2.83331 7 2.83331Z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ var Icon_InfoSolid = (InfoSolid);

;// CONCATENATED MODULE: ./src/components/Icon/Lock/index.tsx




var Lock = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_23452_18511)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11.9998 5.83335H11.3332V4.50002C11.3332 2.66002 9.83984 1.16669 7.99984 1.16669C6.15984 1.16669 4.6665 2.66002 4.6665 4.50002V5.83335H3.99984C3.2665 5.83335 2.6665 6.43335 2.6665 7.16669V13.8334C2.6665 14.5667 3.2665 15.1667 3.99984 15.1667H11.9998C12.7332 15.1667 13.3332 14.5667 13.3332 13.8334V7.16669C13.3332 6.43335 12.7332 5.83335 11.9998 5.83335ZM5.99984 4.50002C5.99984 3.39335 6.89317 2.50002 7.99984 2.50002C9.1065 2.50002 9.99984 3.39335 9.99984 4.50002V5.83335H5.99984V4.50002ZM11.9998 13.8334H3.99984V7.16669H11.9998V13.8334ZM7.99984 11.8334C8.73317 11.8334 9.33317 11.2334 9.33317 10.5C9.33317 9.76669 8.73317 9.16669 7.99984 9.16669C7.2665 9.16669 6.6665 9.76669 6.6665 10.5C6.6665 11.2334 7.2665 11.8334 7.99984 11.8334Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_23452_18511",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "16",
                        transform: "translate(0 0.5)",
                        width: "16"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Icon_Lock = (Lock);

;// CONCATENATED MODULE: ./src/components/Icon/Minus/index.tsx




var Minus = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            clipRule: "evenodd",
            d: "M3.33594 7.33594H12.6693V8.66927H3.33594V7.33594Z",
            fill: "#334454",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ var Icon_Minus = (Minus);

// EXTERNAL MODULE: ./src/components/Icon/MyLocation/index.tsx
var MyLocation = __webpack_require__(66753);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(3292);
;// CONCATENATED MODULE: ./src/components/Icon/NotificationsOff/index.tsx




var NotificationsOff = function(_param) {
    var _height = _param.height, height = _height === void 0 ? 14 : _height, _width = _param.width, width = _width === void 0 ? 14 : _width, props = (0,_object_without_properties/* default */.Z)(_param, [
        "height",
        "width"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        fill: "none",
        height: height,
        viewBox: "0 0 32 33",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            clipRule: "evenodd",
            d: "M0.000687519 23.6941H3.94902V13.8216C3.94902 8.57052 7.36532 4.1174 12.0965 2.56358C12.657 1.06678 14.1019 0 15.7961 0C17.4896 0 18.9341 1.06604 19.4953 2.56367C21.279 3.14905 22.8759 4.14688 24.1734 5.44444L27.6431 1.97475L30.4355 4.76712L2.79238 32.4102L0 29.6179L1.9744 27.6435L0 27.6431L0.000687519 23.6941ZM7.89803 21.7198L21.3809 8.23692C20.0383 6.89421 18.2144 6.03268 16.1903 5.93319L15.7961 5.92352C11.5663 5.92352 8.1131 9.24854 7.9077 13.4274L7.89803 13.8216V21.7198ZM23.6941 16.6146L27.5923 12.7164C27.6259 13.0803 27.6431 13.4489 27.6431 13.8216V23.6941H31.5914L31.5921 27.6431L21.3819 27.6449C21.047 28.5915 20.4782 29.4276 19.7451 30.0838C18.6971 31.0218 17.3132 31.5921 15.7961 31.5921C14.2789 31.5921 12.895 31.0218 11.847 30.0838C11.5615 29.8283 11.3009 29.5454 11.0693 29.2393L16.6146 23.6941H23.6941V16.6146Z",
            fill: "#1d1d1b",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ var Icon_NotificationsOff = (NotificationsOff);

// EXTERNAL MODULE: ./src/components/Icon/Phone/index.tsx
var Phone = __webpack_require__(41800);
;// CONCATENATED MODULE: ./src/components/Icon/PhoneSolid/index.tsx




var PhoneSolid = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            clipRule: "evenodd",
            d: "M3.24967 0.333313C4.86051 0.333313 6.16634 1.61267 6.16634 3.19084C6.16634 4.38553 4.96913 5.0577 4.02832 5.57974C4.76711 7.67691 6.32925 9.35113 8.29441 10.1901L8.51622 9.77559C9.04308 8.80239 9.65723 7.83331 10.8229 7.83331C12.3933 7.83331 13.6663 9.13915 13.6663 10.75C13.6663 12.2534 12.5574 13.4912 11.1327 13.6495L10.9613 13.6625L10.9618 13.6666L10.7791 13.6662L10.4349 13.6548C4.85127 13.4035 0.451753 9.16997 0.333008 3.49606L0.349319 3.43792C0.3386 3.35498 0.333008 3.27249 0.333008 3.19084C0.333008 1.61267 1.63884 0.333313 3.24967 0.333313Z",
            fill: "#1D1D1B",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ var Icon_PhoneSolid = (PhoneSolid);

;// CONCATENATED MODULE: ./src/components/Icon/Plus/index.tsx




var Plus = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            clipRule: "evenodd",
            d: "M8.83594 1.33594V7.16927H14.6693V8.83594H8.83594V14.6693H7.16927V8.83594H1.33594V7.16927H7.16927V1.33594H8.83594Z",
            fill: "#334454",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ var Icon_Plus = (Plus);

// EXTERNAL MODULE: ./src/components/Icon/Reply/index.tsx
var Reply = __webpack_require__(51100);
;// CONCATENATED MODULE: ./src/components/Icon/Rooms/index.tsx




var Rooms = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M15 14h1v2H0v-2h1V2l7-2 7 2v12zM3 14h4v-2H3v2zm10-2H9v2h4v-2zm0-2V7H9v3h4zM3 10h4V7H3v3zm5-7.92L3 3.508V5h10V3.509L8 2.08z"
        })
    }));
};
/* harmony default export */ var Icon_Rooms = (Rooms);

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(66840);
;// CONCATENATED MODULE: ./src/components/Icon/Star/index.tsx





var Star = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8.00016 11.5133L12.1202 14L11.0268 9.31331L14.6668 6.15998L9.8735 5.75331L8.00016 1.33331L6.12683 5.75331L1.3335 6.15998L4.9735 9.31331L3.88016 14L8.00016 11.5133Z",
            fill: "currentColor"
        })
    }));
};
/* harmony default export */ var Icon_Star = (Star);

;// CONCATENATED MODULE: ./src/components/Icon/Sun/index.tsx




var Sun = function(_param) {
    var _height = _param.height, height = _height === void 0 ? 14 : _height, _width = _param.width, width = _width === void 0 ? 14 : _width, props = (0,_object_without_properties/* default */.Z)(_param, [
        "height",
        "width"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        fill: "currentColor",
        height: height,
        viewBox: "0 0 14 14",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2.37358 7.58333H0V6.41667H2.37358C2.34967 6.608 2.33333 6.80225 2.33333 7C2.33333 7.19775 2.34967 7.392 2.37358 7.58333ZM4.14342 3.318L2.46283 1.63742L1.638 2.46225L3.31858 4.14283C3.55833 3.83425 3.83483 3.55775 4.14342 3.318ZM10.682 4.14283L12.3626 2.46225L11.5377 1.63742L9.85717 3.318C10.1652 3.55775 10.4417 3.83483 10.682 4.14283ZM7 2.33333C7.19775 2.33333 7.392 2.34967 7.58333 2.37358V0H6.41667V2.37358C6.608 2.34967 6.80225 2.33333 7 2.33333ZM7 11.6667C6.80225 11.6667 6.608 11.6503 6.41667 11.6264V14H7.58333V11.6264C7.392 11.6503 7.19775 11.6667 7 11.6667ZM11.6264 6.41667C11.6503 6.608 11.6667 6.80225 11.6667 7C11.6667 7.19775 11.6503 7.392 11.6264 7.58333H14V6.41667H11.6264ZM9.85717 10.682L11.5372 12.362L12.3626 11.5372L10.6826 9.85717C10.4422 10.1652 10.1658 10.4417 9.85717 10.682ZM3.318 9.85658L1.638 11.5366L2.46283 12.3614L4.14283 10.6814C3.83483 10.4417 3.55775 10.1652 3.318 9.85658ZM4.66667 7C4.66667 8.28683 5.71317 9.33333 7 9.33333C8.28683 9.33333 9.33333 8.28683 9.33333 7C9.33333 5.71317 8.28683 4.66667 7 4.66667C5.71317 4.66667 4.66667 5.71317 4.66667 7ZM10.5 7C10.5 8.93317 8.93317 10.5 7 10.5C5.06683 10.5 3.5 8.93317 3.5 7C3.5 5.06683 5.06683 3.5 7 3.5C8.93317 3.5 10.5 5.06683 10.5 7Z"
        })
    }));
};
/* harmony default export */ var Icon_Sun = (Sun);

// EXTERNAL MODULE: ./src/components/Icon/Tap/index.tsx
var Tap = __webpack_require__(26336);
;// CONCATENATED MODULE: ./src/components/Icon/ThumbDownAlt/index.tsx




var ThumbDownAlt = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        height: "12",
        viewBox: "0 0 15 12",
        width: "15"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.99984 0H3.99984C3.4465 0 2.97317 0.333333 2.77317 0.813333L0.759837 5.51333C0.699837 5.66667 0.666504 5.82667 0.666504 6V7.33333C0.666504 8.06667 1.2665 8.66667 1.99984 8.66667H6.2065L5.57317 11.7133L5.55317 11.9267C5.55317 12.2 5.6665 12.4533 5.8465 12.6333L6.55317 13.3333L10.9398 8.94C11.1865 8.7 11.3332 8.36667 11.3332 8V1.33333C11.3332 0.6 10.7332 0 9.99984 0ZM9.99984 8L7.1065 10.8933L7.8465 7.33333H1.99984V6L3.99984 1.33333H9.99984V8ZM12.6665 0H15.3332V8H12.6665V0Z",
            fill: "currentColor"
        })
    }));
};
/* harmony default export */ var Icon_ThumbDownAlt = (ThumbDownAlt);

;// CONCATENATED MODULE: ./src/components/Icon/Tree/index.tsx




var Tree = function(_param) {
    var _height = _param.height, height = _height === void 0 ? 14 : _height, _width = _param.width, width = _width === void 0 ? 12 : _width, props = (0,_object_without_properties/* default */.Z)(_param, [
        "height",
        "width"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        fill: "currentColor",
        height: height,
        viewBox: "0 0 12 14",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            clipRule: "evenodd",
            d: "M6.58342 14H5.41675V11.1831C5.01133 11.0822 4.5925 10.8902 4.27867 10.661C3.987 10.7485 3.68425 10.7922 3.37508 10.7922C1.60583 10.7922 0.166748 9.331 0.166748 7.53492C0.166748 6.7865 0.412331 6.08008 0.864998 5.50667C0.751248 5.21733 0.691748 4.90875 0.691748 4.59375C0.691748 3.4125 1.51016 2.42317 2.61558 2.19042C3.22341 0.86625 4.54116 0 6.00008 0C7.459 0 8.77733 0.86625 9.38517 2.191C10.49 2.42317 11.3084 3.4125 11.3084 4.59375C11.3084 4.90875 11.2489 5.21792 11.1357 5.50667C11.5884 6.08008 11.8334 6.78592 11.8334 7.53492C11.8334 9.331 10.3937 10.7922 8.62508 10.7922C8.31708 10.7922 8.01491 10.7485 7.72383 10.6616C7.42167 10.8873 7.00983 11.0897 6.58342 11.1912V14ZM4.57092 9.28608C5.12392 10.0858 5.849 10.0934 6.03275 10.0934C6.23167 10.0934 6.94683 10.0497 7.42983 9.28608C7.83875 9.52875 9.11625 9.96333 10.0513 9.03058C10.8616 8.21858 10.9934 6.61558 9.69141 5.69042C10.3436 4.98342 10.1598 4.34233 10.0222 4.04308C9.82208 3.60675 9.38925 3.26492 8.54983 3.28883C8.30717 2.13383 7.11367 1.16667 6.00008 1.16667C4.89525 1.16667 3.67492 2.10933 3.45092 3.28883C2.72466 3.2725 2.25391 3.59392 2.06958 3.87625C1.88 4.16792 1.6805 4.93325 2.30875 5.69042C1.03241 6.77658 1.14791 8.22908 1.94941 9.03058C3.03791 10.1179 4.28917 9.40858 4.57092 9.28608Z",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ var Icon_Tree = (Tree);

;// CONCATENATED MODULE: ./src/components/Icon/Verified/index.tsx




var Verified = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: props.className
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1756_1147)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.3333 7.99333L13.7066 6.13333L13.9333 3.67333L11.5266 3.12667L10.2666 1L7.99996 1.97333L5.73329 1L4.47329 3.12667L2.06663 3.66667L2.29329 6.13333L0.666626 7.99333L2.29329 9.85333L2.06663 12.32L4.47329 12.8667L5.73329 15L7.99996 14.02L10.2666 14.9933L11.5266 12.8667L13.9333 12.32L13.7066 9.86L15.3333 7.99333ZM12.7 8.98L12.3266 9.41333L12.38 9.98L12.5 11.28L11.2333 11.5667L10.6733 11.6933L10.38 12.1867L9.71996 13.3067L8.53329 12.7933L7.99996 12.5667L7.47329 12.7933L6.28663 13.3067L5.62663 12.1933L5.33329 11.7L4.77329 11.5733L3.50663 11.2867L3.62663 9.98L3.67996 9.41333L3.30663 8.98L2.44663 8L3.30663 7.01333L3.67996 6.58L3.61996 6.00667L3.49996 4.71333L4.76663 4.42667L5.32663 4.3L5.61996 3.80667L6.27996 2.68667L7.46663 3.2L7.99996 3.42667L8.52663 3.2L9.71329 2.68667L10.3733 3.80667L10.6666 4.3L11.2266 4.42667L12.4933 4.71333L12.3733 6.01333L12.32 6.58L12.6933 7.01333L13.5533 7.99333L12.7 8.98Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.72657 9.1667L5.1799 7.61337L4.19324 8.6067L6.72657 11.1467L11.6199 6.24004L10.6332 5.2467L6.72657 9.1667Z",
                        fill: "currentColor"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1756_1147",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        fill: "white",
                        height: "16",
                        width: "16"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Icon_Verified = (Verified);

// EXTERNAL MODULE: ./src/components/Icon/VirtualTour/index.tsx
var VirtualTour = __webpack_require__(96818);
;// CONCATENATED MODULE: ./src/components/Icon/Warning/index.tsx




var Warning = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSvg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: props.className
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0 19H22L11 0L0 19ZM12 16H10V14H12V16ZM12 12H10V8H12V12Z",
            fill: "#FF991F"
        })
    }));
};
/* harmony default export */ var Icon_Warning = (Warning);

;// CONCATENATED MODULE: ./src/components/Icon/index.tsx





































var ALL_ICONS = (/* unused pure expression or super */ null && ([
    "Arrow",
    "ArrowUp",
    "Bathroom",
    "Bedroom",
    "Bedrooms",
    "Close",
    "Chevron",
    "NotificationsOff",
    "Rooms",
    "Tree",
    "Sun",
    "VirtualTour",
    "Favourites",
    "FavouritesRemoved",
    "Delete",
    "Info",
    "InfoSolid",
    "Tap",
    "Phone",
    "Calendar",
    "Clock",
    "Reply",
    "Filter",
    "Check",
    "Gallery",
    "CasavoLogoSmall",
    "MyLocation",
    "HouseSmall",
    "PhoneSolid",
    "DataUsage",
    "Warning",
    "Plus",
    "Minus",
    "Star",
    "ThumbDownAlt",
    "Lock",
    "House",
    "Verified", 
]));
var Icon = {
    Arrow: Arrow/* default */.Z,
    ArrowUp: ArrowUp/* default */.Z,
    Bathroom: Icon_Bathroom,
    Bedroom: Icon_Bedroom,
    Bedrooms: Icon_Bedroom,
    Calendar: Calendar/* default */.Z,
    CasavoLogoSmall: CasavoLogoSmall/* default */.Z,
    Check: Check/* default */.Z,
    Chevron: Chevron/* default */.Z,
    Clock: Icon_Clock,
    Close: Close/* default */.Z,
    DataUsage: DataUsage,
    Delete: Icon_Delete/* default */.Z,
    Favourites: Icon_Favourites,
    FavouritesRemoved: FavouritesRemoved/* default */.Z,
    Filter: Filter/* default */.Z,
    Gallery: Gallery/* default */.Z,
    House: Home,
    HouseSmall: Icon_HouseSmall,
    Info: Icon_Info,
    InfoSolid: Icon_InfoSolid,
    Lock: Icon_Lock,
    Minus: Icon_Minus,
    MyLocation: MyLocation/* default */.Z,
    NotificationsOff: Icon_NotificationsOff,
    Phone: Phone/* default */.Z,
    PhoneSolid: Icon_PhoneSolid,
    Plus: Icon_Plus,
    Reply: Reply/* default */.Z,
    Rooms: Icon_Rooms,
    Star: Icon_Star,
    Sun: Icon_Sun,
    Tap: Tap/* default */.Z,
    ThumbDownAlt: Icon_ThumbDownAlt,
    Tree: Icon_Tree,
    Verified: Icon_Verified,
    VirtualTour: VirtualTour/* default */.Z,
    Warning: Icon_Warning
};
/* harmony default export */ var components_Icon = (Icon);


/***/ }),

/***/ 13976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ linkBuilder; }
/* harmony export */ });
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43000);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89847);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_cities_mapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1966);
/* harmony import */ var _utils_cities_province_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59522);
/* harmony import */ var _utils_zone_slug_parser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87711);
/* harmony import */ var _i18n_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31693);






var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_1___default()().publicRuntimeConfig;
var linkBuilder = {
    housesForSale: {
        url: function(language) {
            return "/" + (0,_i18n_routes__WEBPACK_IMPORTED_MODULE_4__/* .getHousesForSalesPathSegment */ .yP)(language) + "/";
        }
    },
    housesForSaleCasavoWebsite: {
        url: function(language) {
            return "".concat(publicRuntimeConfig.casavoWebsite, "/").concat(language, "/").concat(_i18n_routes__WEBPACK_IMPORTED_MODULE_4__/* .allListings.find */ .iN.find(function(entry) {
                return entry.locale === language;
            }).path, "/");
        }
    },
    listingByArea: {
        url: function(language, cities, areaValue) {
            if (!_utils_cities_province_utils__WEBPACK_IMPORTED_MODULE_3__/* ["default"].citySupportsProvince */ .Z.citySupportsProvince(areaValue, cities)) {
                return linkBuilder.listingByCity.url(language, cities, areaValue);
            }
            var base = linkBuilder.housesForSale.url(language);
            var currentCity = cities.find(function(city) {
                return city.slug === areaValue;
            });
            var cityString = buildCityName(currentCity, language);
            return "".concat(base).concat((0,_utils_cities_mapper__WEBPACK_IMPORTED_MODULE_2__/* .areaParamEncoder */ .L9)(cityString), "/");
        }
    },
    listingByCity: {
        url: function(language, cities, cityValue, canonicalFilterSlug) {
            var base = linkBuilder.housesForSale.url(language);
            var currentCity = cities.find(function(city) {
                return city.slug === cityValue;
            });
            var cityString = buildCityName(currentCity, language);
            var canonicalFilter = canonicalFilterSlug !== null && canonicalFilterSlug !== void 0 ? canonicalFilterSlug : "";
            return "".concat(base).concat(cityString, "/").concat(canonicalFilter);
        }
    },
    listingByZone: {
        url: function(language, cities, cityValue, zoneSlug) {
            var ref;
            var base = linkBuilder.listingByCity.url(language, cities, cityValue);
            var city = cities.find(function(city) {
                return city.slug === cityValue;
            });
            var isAValidZone = city === null || city === void 0 ? void 0 : (ref = city.city_zones) === null || ref === void 0 ? void 0 : ref.some(function(zone) {
                return zone.slug === zoneSlug;
            });
            if (isAValidZone && zoneSlug && zoneSlug.length > 0) {
                var zone = (0,_utils_zone_slug_parser__WEBPACK_IMPORTED_MODULE_5__/* .parseZoneSlug */ .I)(zoneSlug).zone;
                return "".concat(base).concat(zone.toLowerCase(), "/");
            } else {
                return base;
            }
        }
    },
    listingDetail: {
        url: function(language, propertySlug) {
            return "".concat(linkBuilder.housesForSale.url(language)).concat(linkBuilder.listingDetailSegment.url(language)).concat(propertySlug, "/");
        }
    },
    listingDetailSegment: {
        url: function(language) {
            return (0,_i18n_routes__WEBPACK_IMPORTED_MODULE_4__/* .getListingDetailPathSegment */ .mT)(language) + "/";
        }
    }
};
// FIXME we should not use translatedCityName, it's nullable and SEO/URL stuff should be based on slug
var buildCityName = function(city, locale) {
    if (locale === "en" && city.translations !== undefined && city.translations.length !== 0) {
        return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.kebabCase)(city.translations.find(function(t) {
            return t.language === "it";
        }).value.toLowerCase());
    } else {
        return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.kebabCase)((city === null || city === void 0 ? void 0 : city.translatedCityName) || "");
    }
};


/***/ }),

/***/ 27638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ PriorityBadge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: src/design-lib/style-theme/sprinkles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/sprinkles.css.ts.vanilla.css","source":"#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"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(1851);
// EXTERNAL MODULE: src/design-lib/style-theme/theme.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/theme.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA42UyW6cQBCG73mKkrgkkomo3rtyAhpeI5rxvg4ez9jYUd49KkY5dLWRLDh91PL331XQfrc7wJ9vAHX9Gx+PN+HpviGoxnG0Q/yVcVx4cq3NuVp4F5zKuV54jDjm3BBUgwst9jm3Cx/6ocu5I6hi12HX5NwTVBa99ybngaBqnE5a6I/MrUY15HzDfeMYR5fzLUHVhsGlNufnBJVzyXTiXBcElbI9tjrnlwQVDrENwp8rgiq50Y6izjX75kY3Ys5vTvcyyvhb5pafnN/xuQI/Ob/nviaZJHQ+EFSd7nQndD4SVF577QV/Yv+VVVbo3PF5EyYU9zgxVxhQ+P/M+psxDoLv2X+TYhT+vxBUwfbJi/s98L34vrE+50fWmdpkRP3XRX9sjbj3t5PPcRDzOZ/mPwZR533hfXJCz8eJN0b4jM0y6G3SogHyhvV9bLVQhMuKpWGQFuGyYzq20iNclmz0UZqEy5Z11kuX0C1jYQZpE/Kedb1x0icMKwOJce0Psln5JeB2LeN8ZZjwYmVL8HIt42pljvF67cPNyoTj7VqPu5VZxvuVIcQHggbcNIMy0wwN7K+3m+8qnvHrz5qf+odIeOQENc0Qvhb/xPFcG93XEnacgNMMXxQ0ETTTLOAzQW1CgfcEtTMFfiGoQ1nkQFBHV+AjQa3KIq8ENZbRbxxd1p65ZUHfuYYq8AdBrQusGj5kQZEbFlQRlH4oTVDaoQxB6YayBKUZyhFsjoedoJ6gdEgFgtIgFQlKf9SGoJS7JSjdUecEn5hzQVAquCQoI6/+y/r7Dy2XybuPCAAA"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(19636);
// EXTERNAL MODULE: src/components/PriorityCardBadge/style.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/PriorityCardBadge/style.css.ts.vanilla.css","source":"LnhyeGNhcjEgewogIGJhY2tncm91bmQtY29sb3I6IHZhcigtLV8xbXVoOG5rMWEpOwogIGJvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOiA4cHg7CiAgYm9yZGVyLXRvcC1sZWZ0LXJhZGl1czogOHB4Owp9Ci54cnhjYXIyIHsKICBjb2xvcjogdmFyKC0tXzFtdWg4bmsxYyk7Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(41016);
;// CONCATENATED MODULE: ./src/components/PriorityCardBadge/style.css.ts



var priorityBadge = 'xrxcar1 tfghjgho tfghjgiu tfghjgk9 tfghjggr tfghjg6 _1b5wm2033 tfghjg1u tfghjg5x tfghjg29 tfghjg2f _1b5wm200';
var priorityBadgeText = 'xrxcar2';
;// CONCATENATED MODULE: ./src/components/PriorityCardBadge/index.tsx




var PriorityBadge = function() {
    var t = (0,useTranslation/* default */.Z)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: priorityBadge,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
            className: priorityBadgeText,
            children: t("suggested:PriorityCard_Banner")
        })
    });
};


/***/ }),

/***/ 20635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BX": function() { return /* binding */ fadeInAnimation; },
/* harmony export */   "Sw": function() { return /* binding */ bottomUpAnimation; },
/* harmony export */   "WC": function() { return /* binding */ modalAnimation; },
/* harmony export */   "bn": function() { return /* binding */ MODAL_ANIMATION_TIMING; }
/* harmony export */ });
var MODAL_ANIMATION_TIMING = 300;
var modalAnimation = {
    animate: {
        opacity: 1,
        transition: {
            duration: MODAL_ANIMATION_TIMING / 1000
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: MODAL_ANIMATION_TIMING / 1000
        }
    },
    initial: {
        opacity: 0
    }
};
var fadeInAnimation = {
    animate: {
        opacity: 1,
        transition: {
            duration: 0.5
        }
    },
    exit: {
        opacity: 0
    },
    initial: {
        opacity: 0
    }
};
var bottomUpAnimation = function(delayOnAnimate) {
    return {
        animate: {
            transition: {
                delay: delayOnAnimate,
                duration: 0.4
            },
            y: 0
        },
        exit: {
            transition: {
                duration: 0.4
            },
            y: 200
        },
        initial: {
            y: 200
        }
    };
};


/***/ }),

/***/ 36481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iy": function() { return /* binding */ logoutOnPreviousPage; },
/* harmony export */   "JV": function() { return /* binding */ LogoutActionType; },
/* harmony export */   "mE": function() { return /* binding */ getLogoutAction; }
/* harmony export */ });
var LogoutActionType;
(function(LogoutActionType) {
    LogoutActionType["PREVIUOS_PAGE"] = "PREVIUOS_PAGE";
    LogoutActionType["RELOAD_PAGE"] = "RELOAD_PAGE";
    LogoutActionType["SAME_PAGE"] = "SAME_PAGE";
})(LogoutActionType || (LogoutActionType = {}));
var getLogoutAction = function(type, previousPage) {
    if (type === LogoutActionType.PREVIUOS_PAGE) return {
        previousPage: previousPage,
        type: type
    };
    return {
        type: type
    };
};
var logoutOnPreviousPage = function(previousPage) {
    window.location.href = previousPage;
};


/***/ }),

/***/ 95374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ho": function() { return /* reexport */ AuthProvider; },
  "JL": function() { return /* reexport */ useAuthentication; }
});

// UNUSED EXPORTS: AuthContext

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(88718);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50879);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
;// CONCATENATED MODULE: ./src/hooks/usePageFocus.tsx

var isPageVisible = function() {
    if (typeof document !== "undefined" && typeof document.visibilityState !== "undefined") {
        return document.visibilityState !== "hidden";
    }
    // always assume it's visible
    return true;
};
var usePageFocus = function(handleFocus) {
    var focusHandler = (0,react.useCallback)(function() {
        if (isPageVisible() && handleFocus) {
            handleFocus();
        }
    }, [
        handleFocus
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("visibilitychange", focusHandler, false);
        return function removeFocusHandlers() {
            window.removeEventListener("visibilitychange", focusHandler, false);
        };
    }, [
        focusHandler
    ]);
};

// EXTERNAL MODULE: ./src/utils/auth/auth-client.ts
var auth_client = __webpack_require__(38291);
// EXTERNAL MODULE: ./src/context/SuggestedCriteriaProvider.tsx
var SuggestedCriteriaProvider = __webpack_require__(51701);
// EXTERNAL MODULE: ./src/context/AuthProvider/Logout.ts
var Logout = __webpack_require__(36481);
;// CONCATENATED MODULE: ./src/context/AuthProvider/AuthProvider.tsx








var AuthContext = /*#__PURE__*/ react.createContext({
    isLoading: true,
    loginWithCredentials: null,
    loginWithProvider: null,
    logout: null,
    recoverPassword: {
        recoveringEmail: null,
        start: null,
        update: null,
        verify: null
    },
    registerUser: null,
    user: null
});
var useAuthentication = function() {
    var context = (0,react.useContext)(AuthContext);
    if (!context) {
        throw new Error("useAuthentication must be used within a AuthProvider");
    }
    return context;
};
var pushUserIntoDataLayer = function(user) {
    if (typeof window.dataLayer !== "undefined") {
        window.dataLayer.push({
            event: "casavo.user.id",
            userspaceId: user === null || user === void 0 ? void 0 : user.casavo_user_id
        });
    }
};
var removeUserFromDataLayer = function() {
    if (typeof window.dataLayer !== "undefined") {
        window.dataLayer.push({
            event: "casavo.user.id",
            userspaceId: undefined
        });
    }
};
var AuthProvider = function(param) {
    var children = param.children;
    var authClient = (0,react.useMemo)(function() {
        return (0,auth_client/* createAuthClient */.XL)("https://userspace.casavo.com");
    }, []);
    var ref = (0,react.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react.useState)(null), user = ref1[0], setUser = ref1[1];
    var disableSuggestedCriteria = (0,SuggestedCriteriaProvider/* useSuggestedCriteria */.l0)().disableSuggestedCriteria;
    var fetchCurrentUser = (0,react.useCallback)(function() {
        authClient.fetchCurrentUser().then(function(user) {
            pushUserIntoDataLayer(user);
            setUser(user);
        }).catch(function(error) {
            if (error && error.message.includes("401")) {
                setUser(null);
            }
        }).finally(function() {
            return setIsLoading(false);
        });
    }, [
        user
    ]);
    (0,react.useEffect)(function() {
        fetchCurrentUser();
    }, []);
    usePageFocus(fetchCurrentUser);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthContext.Provider, {
        value: {
            isLoading: isLoading,
            loginWithCredentials: function(data) {
                return authClient.loginWithEmailAndPassword(data).then(function(user) {
                    setUser(user);
                    pushUserIntoDataLayer(user);
                });
            },
            loginWithProvider: authClient.loginWithProvider,
            logout: function(logoutAction) {
                return authClient.logout().then(function() {
                    removeUserFromDataLayer();
                    switch(logoutAction.type){
                        case Logout/* LogoutActionType.PREVIUOS_PAGE */.JV.PREVIUOS_PAGE:
                            return (0,Logout/* logoutOnPreviousPage */.Iy)(logoutAction.previousPage);
                        case Logout/* LogoutActionType.RELOAD_PAGE */.JV.RELOAD_PAGE:
                            window.location.reload();
                            break;
                        case Logout/* LogoutActionType.SAME_PAGE */.JV.SAME_PAGE:
                            setUser(null);
                            disableSuggestedCriteria();
                            break;
                    }
                });
            },
            recoverPassword: {
                recoveringEmail: function() {
                    return authClient.getRecoveringEmail();
                },
                start: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(email) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        authClient.logout().catch(function() {})
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        4,
                                        authClient.recoverPasswordStart(email)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(email) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                update: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(newPassword) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        authClient.recoverPasswordUpdate(newPassword)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        4,
                                        authClient.logout()
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(newPassword) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                verify: authClient.recoverPasswordVerify
            },
            registerUser: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    authClient.logout().catch(function() {})
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    authClient.registerUser(data).then(function(user) {
                                        pushUserIntoDataLayer(user);
                                        setUser(user);
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(data) {
                    return _ref.apply(this, arguments);
                };
            }(),
            user: user
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./src/context/AuthProvider/index.ts



/***/ }),

/***/ 88628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ BottomSheetProvider; },
  "a": function() { return /* binding */ useBottomSheet; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.js + 2 modules
var AnimatePresence = __webpack_require__(62978);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 97 modules
var motion = __webpack_require__(38494);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(21395);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(29515);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 21 modules
var Icon = __webpack_require__(81016);
// EXTERNAL MODULE: ./src/components/PriorityCardBadge/index.tsx + 1 modules
var PriorityCardBadge = __webpack_require__(27638);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./src/shared-styles/styles.css.ts
var styles_css = __webpack_require__(29070);
// EXTERNAL MODULE: ./src/utils/tracking/eventsHandlers.ts + 1 modules
var eventsHandlers = __webpack_require__(88905);
// EXTERNAL MODULE: src/design-lib/components/BottomSheet/style.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/components/BottomSheet/style.css.ts.vanilla.css","source":"Ll8xd202OWJpMCB7CiAgYm90dG9tOiAwOwogIGxlZnQ6IDA7CiAgcG9zaXRpb246IGZpeGVkOwogIHJpZ2h0OiAwOwogIHotaW5kZXg6IDI3Owp9Ci5fMXdtNjliaTEgewogIGJvcmRlci10b3AtbGVmdC1yYWRpdXM6IDEycHg7CiAgYm9yZGVyLXRvcC1yaWdodC1yYWRpdXM6IDEycHg7CiAgYm94LXNoYWRvdzogMHB4IDBweCA2cHggcmdiYSgwLCAwLCAwLCAwLjUpOwogIHBhZGRpbmc6IDE2cHg7CiAgcGFkZGluZy1ib3R0b206IGNhbGMoMTZweCArIGVudihzYWZlLWFyZWEtaW5zZXQtYm90dG9tKSk7Cn0KLl8xd202OWJpMiB7CiAgYmFja2dyb3VuZDogIzUyNTI1MTsKICBib3JkZXItcmFkaXVzOiAzcHg7CiAgaGVpZ2h0OiA1cHg7CiAgbWFyZ2luOiAwIGF1dG87CiAgb3ZlcmZsb3c6IHZpc2libGU7CiAgd2lkdGg6IDgwcHg7Cn0KLl8xd202OWJpMyB7CiAgcG9zaXRpb246IGFic29sdXRlOwogIHJpZ2h0OiA4cHg7CiAgei1pbmRleDogMjc7Cn0KLl8xd202OWJpNCB7CiAgcG9zaXRpb246IGZpeGVkOwogIHRvcDogMDsKICByaWdodDogMDsKICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDAsMCwwLDAuNSk7CiAgaGVpZ2h0OiAxMDAlOwogIGxlZnQ6IDA7CiAgd2lkdGg6IDEwMCU7CiAgei1pbmRleDogMjY7Cn0KLl8xd202OWJpNSB7CiAgYm9yZGVyOiAxcHggc29saWQgI0ZGOTkxRjsKICBib3JkZXItdG9wLXJpZ2h0LXJhZGl1czogMTZweDsKICBib3JkZXItdG9wLWxlZnQtcmFkaXVzOiAxNnB4Owp9"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(7752);
;// CONCATENATED MODULE: ./src/design-lib/components/BottomSheet/style.css.ts

var borderPriorityBottomSheet = '_1wm69bi5';
var bottomSheetCloseButton = '_1wm69bi3';
var bottomSheetContentBody = '_1wm69bi1';
var bottomSheetHandle = '_1wm69bi2';
var bottomSheetOverlay = '_1wm69bi4';
var bottomSheetWrapper = '_1wm69bi0';
;// CONCATENATED MODULE: ./src/design-lib/components/BottomSheet/index.tsx














var BottomSheet = function(param) {
    var _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "lightBlue" : _bgColor, _gtmEventCategory = param.gtmEventCategory, gtmEventCategory = _gtmEventCategory === void 0 ? "BottomSheet" : _gtmEventCategory, isPriority = param.isPriority, minHeight = param.minHeight;
    var ref = useBottomSheet(), bottomSheetContent = ref.bottomSheetContent, closeBottomSheet = ref.closeBottomSheet, isBottomSheetOpen = ref.isBottomSheetOpen;
    var handleDragEnd = function(event, info) {
        var shouldClose = info.offset.y > 200 || info.velocity.y > 500;
        if (shouldClose) {
            closeBottomSheet();
            (0,eventsHandlers/* handleDrag */.xv)(gtmEventCategory, "CloseBottomSheet");
        }
    };
    var animationVariants = {
        exit: {
            transition: {
                damping: 30,
                stiffness: 300,
                type: "spring"
            },
            y: 1000
        },
        hidden: {
            y: 1000
        },
        visible: {
            transition: {
                damping: 30,
                stiffness: 300,
                type: "spring"
            },
            y: 0
        }
    };
    (0,react.useEffect)(function() {
        var handleRouteChange = function() {
            closeBottomSheet();
        };
        router_default().events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router_default().events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        (router_default())
    ]);
    if (true) {
        return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            children: isBottomSheetOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                        animate: {
                            opacity: 1
                        },
                        className: bottomSheetOverlay,
                        exit: {
                            opacity: 0
                        },
                        initial: {
                            opacity: 0
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()(bottomSheetWrapper),
                        "data-testid": "bottomsheet",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            animate: "visible",
                            drag: "y",
                            dragConstraints: {
                                bottom: 0,
                                top: 0
                            },
                            dragElastic: {
                                bottom: 0.5,
                                top: 0.2
                            },
                            dragMomentum: false,
                            exit: "exit",
                            initial: "hidden",
                            variants: animationVariants,
                            onClick: function(e) {
                                e.stopPropagation();
                            },
                            onDragEnd: handleDragEnd,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()(bottomSheetContentBody, styles_css/* backgroundColor */.Cz[bgColor], isPriority && borderPriorityBottomSheet),
                                style: {
                                    touchAction: "none"
                                },
                                children: [
                                    isPriority && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriorityCardBadge/* PriorityBadge */.U, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: bottomSheetHandle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                        ariaLabel: "close dialog",
                                        className: bottomSheetCloseButton,
                                        Icon: function() {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {});
                                        },
                                        shapeVariant: "round",
                                        styleVariant: "tertiary",
                                        onClick: function() {
                                            closeBottomSheet();
                                            (0,eventsHandlers/* handleClick */.qk)(gtmEventCategory, "CloseBottomSheet");
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            display: "flex",
                                            flexDirection: "column"
                                        }),
                                        style: {
                                            minHeight: document.documentElement.clientHeight > minHeight && minHeight
                                        },
                                        children: bottomSheetContent
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        }), document.body);
    }
    return null;
};

;// CONCATENATED MODULE: ./src/context/BottomSheetContext.tsx




var BottomSheetContext = /*#__PURE__*/ (0,react.createContext)({
    bottomSheetContent: null,
    closeBottomSheet: function() {},
    isBottomSheetOpen: false,
    openBottomSheet: function() {
        return null;
    }
});
var BottomSheetProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), isBottomSheetOpen = ref[0], setBottomSheetIsOpen = ref[1];
    var ref1 = (0,react.useState)(), bottomSheetContent = ref1[0], setBottomSheetContent = ref1[1];
    var ref2 = (0,react.useState)({}), bottomSheetOptions = ref2[0], setBottomSheetOptions = ref2[1];
    var openBottomSheet = function(content, options) {
        setBottomSheetIsOpen(true);
        setBottomSheetOptions(options);
        setBottomSheetContent(content);
    };
    var closeBottomSheet = function() {
        setBottomSheetIsOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomSheetContext.Provider, {
        value: {
            bottomSheetContent: bottomSheetContent,
            closeBottomSheet: closeBottomSheet,
            isBottomSheetOpen: isBottomSheetOpen,
            openBottomSheet: openBottomSheet
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet, (0,_object_spread/* default */.Z)({}, bottomSheetOptions)),
            children
        ]
    });
};
var useBottomSheet = function() {
    return (0,react.useContext)(BottomSheetContext);
};


/***/ }),

/***/ 77808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fy": function() { return /* binding */ useDevice; },
/* harmony export */   "Sj": function() { return /* binding */ useViewport; },
/* harmony export */   "Yk": function() { return /* binding */ DeviceProvider; }
/* harmony export */ });
/* unused harmony export DeviceContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _design_lib_media_queries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80595);



var defaultContextValue = {
    device: "mobile",
    height: 0,
    width: 0
};
var DeviceContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(defaultContextValue);
var useDevice = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(DeviceContext);
    if (!context) {
        throw new Error("useDevice must be used within a DeviceProvider");
    }
    return context.device;
};
var useViewport = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(DeviceContext);
    if (!context) {
        throw new Error("useDevice must be used within a DeviceProvider");
    }
    return {
        height: context.height,
        width: context.width
    };
};
var DeviceProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultContextValue), state = ref[0], setState = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var matchMedia = function() {
            return window.matchMedia("(".concat(_design_lib_media_queries__WEBPACK_IMPORTED_MODULE_2__/* .rawMq.desktop */ .N.desktop, ")")).matches ? "desktop" : "mobile";
        };
        var handleWindowResize = function() {
            var device = matchMedia();
            var height = window.innerHeight;
            // Fix instagram window.innerwidth issue
            var width = window.screen.width < window.innerWidth ? window.screen.width : window.innerWidth;
            setState({
                device: device,
                height: height,
                width: width
            });
        };
        handleWindowResize();
        window.addEventListener("resize", handleWindowResize, {
            passive: true
        });
        return function() {
            return window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DeviceContext.Provider, {
        value: state,
        children: children
    });
};


/***/ }),

/***/ 90435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cp": function() { return /* binding */ FavoritesProvider; },
/* harmony export */   "rc": function() { return /* binding */ useFavorites; }
/* harmony export */ });
/* unused harmony export FavoriteContext */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88718);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76131);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50879);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _lib_api_gluglu_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(636);
/* harmony import */ var _utils_isStorageSupported__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17668);
/* harmony import */ var _utils_tracking_eventsHandlers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88905);
/* harmony import */ var _AuthProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95374);









var FavoriteContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    addFavorite: undefined,
    favorites: [],
    isFavorite: function() {
        return false;
    },
    isLoading: true,
    refreshFavourite: undefined,
    removeFavorite: undefined,
    toggleFavorite: undefined
});
var useFavorites = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(FavoriteContext);
};
var FavoritesProvider = function(param) {
    var children = param.children;
    var ref = (0,_AuthProvider__WEBPACK_IMPORTED_MODULE_4__/* .useAuthentication */ .JL)(), isUserLoading = ref.isLoading, user = ref.user;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), favorites = ref2[0], setFavorites = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isUserLoading) {
            setFavorites([]);
            return;
        }
        if (!user) {
            setFavorites([]);
            setIsLoading(false);
            return;
        }
        legacyRetrieveAndSaveLocalStorageFavorites().finally(retrieveFavoritesFromGluglu).finally(completeAddingFavoriteForJustLoggedInUser).finally(function() {
            return setIsLoading(false);
        });
    }, [
        isUserLoading,
        user
    ]);
    var retrieveFavoritesFromGluglu = function() {
        return _lib_api_gluglu_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].allFavorites */ .ZP.allFavorites().then(setFavorites).catch(function() {});
    };
    // to be remove once handleFavouritesLegacy('AddedToGluGlu') is not trigged anymore (check on google analytics)
    var legacyRetrieveAndSaveLocalStorageFavorites = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            var oldSavedFavorites;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!localStorage.getItem("@CASAVO_LISTINGS_FAVOURITES")) return [
                            3,
                            2
                        ];
                        oldSavedFavorites = JSON.parse(localStorage.getItem("@CASAVO_LISTINGS_FAVOURITES"));
                        return [
                            4,
                            Promise.all(oldSavedFavorites.map(function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(oldFavorite) {
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    _lib_api_gluglu_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].addFavorite */ .ZP.addFavorite(oldFavorite.id)
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                });
                                return function(oldFavorite) {
                                    return _ref.apply(this, arguments);
                                };
                            }())).then(function() {
                                (0,_utils_tracking_eventsHandlers__WEBPACK_IMPORTED_MODULE_3__/* .handleFavouritesLegacy */ .po)("AddedFromLocalStorageToGluGlu");
                                localStorage.removeItem("@CASAVO_LISTINGS_FAVOURITES");
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        return [
                            2,
                            Promise.resolve()
                        ];
                }
            });
        });
        return function legacyRetrieveAndSaveLocalStorageFavorites() {
            return _ref.apply(this, arguments);
        };
    }();
    var completeAddingFavoriteForJustLoggedInUser = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            var favoriteData, ref, labelForTracking, listingId;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        favoriteData = (0,_utils_isStorageSupported__WEBPACK_IMPORTED_MODULE_7__/* .isStorageSupported */ .p)(function() {
                            return sessionStorage;
                        }) && sessionStorage.getItem("@CASAVO_LISTINGS_ID_FAVOURITES_TO_BE_ADDED");
                        if (favoriteData === null) return [
                            2
                        ];
                        ref = JSON.parse(favoriteData), labelForTracking = ref.labelForTracking, listingId = ref.listingId;
                        if (!!isFavorite(listingId)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            addFavorite(listingId, labelForTracking)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        (0,_utils_tracking_eventsHandlers__WEBPACK_IMPORTED_MODULE_3__/* .handleFavouritesClick */ .fB)("AddedFrom".concat(labelForTracking, "AfterSocialLogin"));
                        (0,_utils_isStorageSupported__WEBPACK_IMPORTED_MODULE_7__/* .isStorageSupported */ .p)(function() {
                            return sessionStorage;
                        }) && sessionStorage.removeItem("@CASAVO_LISTINGS_ID_FAVOURITES_TO_BE_ADDED");
                        return [
                            2
                        ];
                }
            });
        });
        return function completeAddingFavoriteForJustLoggedInUser() {
            return _ref.apply(this, arguments);
        };
    }();
    var isFavorite = function(listingId) {
        return favorites.some(function(favorite) {
            return favorite.listing_id === listingId;
        });
    };
    var toggleFavorite = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(listingId, labelForTracking) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                if (isLoading) return [
                    2,
                    "Loading"
                ];
                if (isFavorite(listingId)) {
                    return [
                        2,
                        removeFavorite(listingId)
                    ];
                }
                return [
                    2,
                    addFavorite(listingId, labelForTracking)
                ];
            });
        });
        return function toggleFavorite(listingId, labelForTracking) {
            return _ref.apply(this, arguments);
        };
    }();
    var addFavorite = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(listingId, labelForTracking) {
            var addedFavoriteResponse;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!user) {
                            (0,_utils_isStorageSupported__WEBPACK_IMPORTED_MODULE_7__/* .isStorageSupported */ .p)(function() {
                                return sessionStorage;
                            }) && sessionStorage.setItem("@CASAVO_LISTINGS_ID_FAVOURITES_TO_BE_ADDED", JSON.stringify({
                                labelForTracking: labelForTracking,
                                listingId: listingId
                            }));
                            return [
                                2,
                                "Unauthorized"
                            ];
                        }
                        setFavorites(function(prev) {
                            return [
                                {
                                    added_at: new Date().toISOString(),
                                    listing_id: listingId
                                }
                            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(prev));
                        });
                        return [
                            4,
                            _lib_api_gluglu_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].addFavorite */ .ZP.addFavorite(listingId).then(function() {
                                return "Added";
                            }).catch(function() {
                                setFavorites(function(prev) {
                                    return prev.filter(function(f) {
                                        return f.listing_id !== listingId;
                                    });
                                });
                                return "Error";
                            })
                        ];
                    case 1:
                        addedFavoriteResponse = _state.sent();
                        return [
                            2,
                            addedFavoriteResponse
                        ];
                }
            });
        });
        return function addFavorite(listingId, labelForTracking) {
            return _ref.apply(this, arguments);
        };
    }();
    var removeFavorite = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(listingId) {
            var preventFilter, removedFavoriteResponse;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        preventFilter = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                        if (isLoading) return [
                            2,
                            "Loading"
                        ];
                        if (!user) return [
                            2,
                            "Unauthorized"
                        ];
                        !preventFilter && setFavorites(function(prev) {
                            return prev.filter(function(f) {
                                return f.listing_id !== listingId;
                            });
                        });
                        return [
                            4,
                            _lib_api_gluglu_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].removeFavorite */ .ZP.removeFavorite(listingId).then(function() {
                                return "Removed";
                            }).catch(function() {
                                setFavorites(function(prev) {
                                    return [
                                        {
                                            added_at: new Date().toISOString(),
                                            listing_id: listingId
                                        }
                                    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(prev));
                                });
                                return "Error";
                            })
                        ];
                    case 1:
                        removedFavoriteResponse = _state.sent();
                        return [
                            2,
                            removedFavoriteResponse
                        ];
                }
            });
        });
        return function removeFavorite(listingId) {
            return _ref.apply(this, arguments);
        };
    }();
    var removeFavoritePreventFiltering = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(listingId) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                return [
                    2,
                    removeFavorite(listingId, true)
                ];
            });
        });
        return function removeFavoritePreventFiltering(listingId) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FavoriteContext.Provider, {
        value: {
            addFavorite: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(listingId, labelForTracking) {
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        return [
                            2,
                            isLoading ? "Loading" : addFavorite(listingId, labelForTracking)
                        ];
                    });
                });
                return function(listingId, labelForTracking) {
                    return _ref.apply(this, arguments);
                };
            }(),
            favorites: favorites,
            isFavorite: isFavorite,
            isLoading: isLoading,
            refreshFavourite: retrieveFavoritesFromGluglu,
            removeFavorite: removeFavoritePreventFiltering,
            toggleFavorite: toggleFavorite
        },
        children: children
    });
};


/***/ }),

/***/ 53614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F0": function() { return /* binding */ KeydownContextProvider; },
/* harmony export */   "NR": function() { return /* binding */ useKeydown; }
/* harmony export */ });
/* unused harmony export KeydownContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


var KeydownContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isKeydown: false
});
var useKeydown = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(KeydownContext);
    if (!context) {
        throw new Error("useKeydown must be used within a KeydownContextProvider");
    }
    return context;
};
var KeydownContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), state = ref[0], setState = ref[1];
    var handleMouseDown = function() {
        setState(false);
    };
    var handleKeyDown = function() {
        setState(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.addEventListener("mousedown", handleMouseDown);
        document.addEventListener("keydown", handleKeyDown);
        return function() {
            window.removeEventListener("mousedown", handleMouseDown);
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(KeydownContext.Provider, {
        value: {
            isKeydown: state
        },
        children: children
    });
};


/***/ }),

/***/ 32228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dd": function() { return /* binding */ useModal; },
/* harmony export */   "ny": function() { return /* binding */ ModalContextProvider; }
/* harmony export */ });
/* unused harmony export ModalContext */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29559);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _utils_get_scrollbar_width__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2018);
/* harmony import */ var _utils_prevent_page_scroll_on_modal_open__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34958);
/* harmony import */ var _Device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77808);
/* harmony import */ var _KeydownContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53614);







var initialModalOptions = {
    overlay: false
};
var ModalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    closeModal: function() {
        return null;
    },
    isOpen: false,
    modalContent: null,
    modalOptions: {},
    openModal: function() {
        return null;
    },
    setIsOpen: function(_b) {
        return null;
    },
    updateModalContent: function() {
        return null;
    }
});
var ModalContextProvider = function(param) {
    var children = param.children;
    var device = (0,_Device__WEBPACK_IMPORTED_MODULE_3__/* .useDevice */ .Fy)();
    var isKeydown = (0,_KeydownContext__WEBPACK_IMPORTED_MODULE_4__/* .useKeydown */ .NR)().isKeydown;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), modalContent = ref[0], setModalContent = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialModalOptions), modalOptions = ref1[0], setModalOptions = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpen = ref2[0], setIsOpen = ref2[1];
    var focusedElementBeforeModal = null;
    var closeModal = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _resetContent = ref.resetContent, resetContent = _resetContent === void 0 ? true : _resetContent, _shouldBackToInitialScroll = ref.shouldBackToInitialScroll, shouldBackToInitialScroll = _shouldBackToInitialScroll === void 0 ? true : _shouldBackToInitialScroll;
        shouldBackToInitialScroll ? (0,_utils_prevent_page_scroll_on_modal_open__WEBPACK_IMPORTED_MODULE_2__/* .backToInitialScrollOnModalClose */ .A8)() : (0,_utils_prevent_page_scroll_on_modal_open__WEBPACK_IMPORTED_MODULE_2__/* .backToTopOnModalClose */ .q0)();
        setIsOpen(false);
        isKeydown && (focusedElementBeforeModal === null || focusedElementBeforeModal === void 0 ? void 0 : focusedElementBeforeModal.focus());
        if (resetContent) {
            setModalContent(null);
        }
    }, [
        setIsOpen,
        setModalContent,
        device,
        isKeydown
    ]);
    var openModal = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(modalContent) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        focusedElementBeforeModal = isKeydown && document.activeElement;
        setIsOpen(true);
        setModalOptions((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialModalOptions, options));
        setModalContent(modalContent);
        (0,_utils_prevent_page_scroll_on_modal_open__WEBPACK_IMPORTED_MODULE_2__/* .addPositionFixedToBody */ .bG)((0,_utils_get_scrollbar_width__WEBPACK_IMPORTED_MODULE_6__/* .getScrollbarWidth */ .n)());
    }, [
        setIsOpen,
        setModalContent,
        device,
        isKeydown
    ]);
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            closeModal: closeModal,
            isOpen: isOpen,
            modalContent: modalContent,
            modalOptions: modalOptions,
            openModal: openModal,
            setIsOpen: setIsOpen,
            updateModalContent: setModalContent
        };
    }, [
        closeModal,
        isOpen,
        modalContent,
        openModal
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalContext.Provider, {
        value: contextValue,
        children: children
    });
};
var useModal = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ModalContext);
};


/***/ }),

/***/ 51701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GB": function() { return /* binding */ SuggestedCriteriaProvider; },
/* harmony export */   "l0": function() { return /* binding */ useSuggestedCriteria; }
/* harmony export */ });
/* unused harmony export SuggestedCriteriaContext */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88718);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50879);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _lib_api_gluglu_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(636);
/* harmony import */ var _AuthProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95374);






var defaultContextValue = {
    disableSuggestedCriteria: function() {},
    enableSuggestedCriteria: function() {},
    hasSuggestedCriteria: false
};
var SuggestedCriteriaContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(defaultContextValue);
var useSuggestedCriteria = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(SuggestedCriteriaContext);
    if (!context) {
        throw new Error("useSuggestedCriteria must be used within a SuggestedCriteriaContext");
    }
    return context;
};
var SuggestedCriteriaProvider = function(param) {
    var children = param.children;
    var user = (0,_AuthProvider__WEBPACK_IMPORTED_MODULE_3__/* .useAuthentication */ .JL)().user;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hasSuggestedCriteria = ref[0], setHasSuggestedCriteria = ref[1];
    var fetchCriteriaInfo = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
            var res, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _lib_api_gluglu_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getSuggestionCriteria */ .ZP.getSuggestionCriteria()
                        ];
                    case 1:
                        res = _state.sent();
                        setHasSuggestedCriteria(!!res);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error("Error fetching suggestion criteria:", error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchCriteriaInfo() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (user === null || user === void 0 ? void 0 : user.id) && fetchCriteriaInfo();
    }, [
        user === null || user === void 0 ? void 0 : user.id
    ]);
    var enableSuggestedCriteria = function() {
        setHasSuggestedCriteria(true);
    };
    var disableSuggestedCriteria = function() {
        setHasSuggestedCriteria(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SuggestedCriteriaContext.Provider, {
        value: {
            disableSuggestedCriteria: disableSuggestedCriteria,
            enableSuggestedCriteria: enableSuggestedCriteria,
            hasSuggestedCriteria: hasSuggestedCriteria
        },
        children: children
    });
};


/***/ }),

/***/ 71750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tt": function() { return /* binding */ UserNavigationProvider; },
/* harmony export */   "yc": function() { return /* binding */ useUserNavigation; }
/* harmony export */ });
/* unused harmony export UserNavigationContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21395);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var _components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13976);
/* harmony import */ var _utils_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59165);





var defaultContextValue = {
    currentPage: "/",
    isOnCityPage: false,
    isOnFavouritePage: false,
    isOnListingDetailPage: false,
    isOnSuggestedPage: false,
    returnToLastCityPage: function() {},
    setLastCityFromListing: function() {}
};
var UserNavigationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)(defaultContextValue);
var useUserNavigation = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(UserNavigationContext);
    if (!context) {
        throw new Error("useUserNavigation must be used within a UserNavigationContext");
    }
    return context;
};
var UserNavigationProvider = function(param) {
    var children = param.children, pageType = param.pageType;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var previousCityPageUrl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var localeInUrl = router.locale !== "en" ? "/".concat(router.locale) : "";
    var isOnSuggestedPage = pageType === "suggested";
    var isOnFavouritePage = pageType === "favorites";
    var isOnCityPage = pageType === "city" || pageType === "zone" || pageType === "canonical-filter";
    var isOnListingDetailPage = pageType === "detail" || pageType === "not-found";
    if (isOnCityPage) {
        previousCityPageUrl.current = "".concat(localeInUrl).concat(router.asPath);
    } else if (isOnListingDetailPage && !previousCityPageUrl.current) {
        previousCityPageUrl.current = (0,_utils_navigation__WEBPACK_IMPORTED_MODULE_4__/* .cityPageFromUrl */ .Pr)("".concat(localeInUrl).concat(router.asPath));
    }
    var returnToLastCityPage = function() {
        if (previousCityPageUrl.current) {
            router.push(previousCityPageUrl.current, previousCityPageUrl.current, {
                locale: false
            });
        } else {
            window.location.href = _components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_3__/* .linkBuilder.housesForSale.url */ .H.housesForSale.url(router.locale);
        }
    };
    var setLastCityFromListing = function(slug) {
        if (!previousCityPageUrl.current) {
            previousCityPageUrl.current = (0,_utils_navigation__WEBPACK_IMPORTED_MODULE_4__/* .getHousesForSaleUrlPathByCitySlug */ .aF)(slug, router.locale);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserNavigationContext.Provider, {
        value: {
            currentPage: previousCityPageUrl.current,
            isOnCityPage: isOnCityPage,
            isOnFavouritePage: isOnFavouritePage,
            isOnListingDetailPage: isOnListingDetailPage,
            isOnSuggestedPage: isOnSuggestedPage,
            returnToLastCityPage: returnToLastCityPage,
            setLastCityFromListing: setLastCityFromListing
        },
        children: children
    });
};


/***/ }),

/***/ 80595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ rawMq; },
/* harmony export */   "mq": function() { return /* binding */ mq; }
/* harmony export */ });
/* unused harmony export vanillaMq */
var rawMq = {
    desktop: "min-width: 1024px",
    tablet: "min-width: 768px",
    xdesktop: "min-width: 1200px",
    xlarge: "min-width: 992px",
    xxlarge: "min-width: 1440px"
};
var mq = {
    desktop: "@media screen and (".concat(rawMq.desktop, ")"),
    tablet: "@media screen and (".concat(rawMq.tablet, ")"),
    xdesktop: "@media screen and (".concat(rawMq.xdesktop, ")"),
    xlarge: "@media screen and (".concat(rawMq.xlarge, ")"),
    xxlarge: "@media screen and (".concat(rawMq.xxlarge, ")")
};
var vanillaMq = {
    desktop: "screen and (".concat(rawMq.desktop, ")"),
    tablet: "screen and (".concat(rawMq.tablet, ")"),
    xlarge: "screen and (".concat(rawMq.xlarge, ")")
};


/***/ }),

/***/ 31693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FW": function() { return /* binding */ suggestedOnboardingPath; },
/* harmony export */   "J$": function() { return /* binding */ profilePath; },
/* harmony export */   "P7": function() { return /* binding */ footerTermsPath; },
/* harmony export */   "Qv": function() { return /* binding */ loginPath; },
/* harmony export */   "WJ": function() { return /* binding */ buyerInterestFlowPath; },
/* harmony export */   "iN": function() { return /* binding */ allListings; },
/* harmony export */   "i_": function() { return /* binding */ sellersFlowUrlPath; },
/* harmony export */   "jn": function() { return /* binding */ suggestedFeedPath; },
/* harmony export */   "mT": function() { return /* binding */ getListingDetailPathSegment; },
/* harmony export */   "qx": function() { return /* binding */ footerPrivacyPath; },
/* harmony export */   "sA": function() { return /* binding */ getPriorityThankyouPage; },
/* harmony export */   "sU": function() { return /* binding */ suggestedFeedSettingsPathSegment; },
/* harmony export */   "v0": function() { return /* binding */ favoritesPath; },
/* harmony export */   "vW": function() { return /* binding */ affordabilityPath; },
/* harmony export */   "yP": function() { return /* binding */ getHousesForSalesPathSegment; }
/* harmony export */ });
/* unused harmony exports allListingsRecord, listingRedirectPath, isValidSegmentForHome */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65594);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62271);



var allListings = [
    {
        locale: "en",
        path: "houses-for-sale"
    },
    {
        locale: "it",
        path: "case-in-vendita"
    },
    {
        locale: "fr",
        path: "acheter-bien"
    }, 
];
var detailListing = [
    {
        locale: "en",
        path: "property"
    },
    {
        locale: "it",
        path: "annunci"
    },
    {
        locale: "fr",
        path: "annonces"
    }, 
];
var allListingsRecord = allListings.reduce(function(acc, item) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item.locale, item.path));
}, {});
var buyerInterestFlowPath = {
    en: "i-wish",
    fr: "i-wish",
    it: "i-wish"
};
var loginPath = "login";
var profilePath = "profile";
var favoritesPath = "".concat(profilePath, "/favorites");
var suggestedFeedPath = "profile/suggested";
var suggestedOnboardingPath = "suggested/onboarding";
var suggestedFeedSettingsPathSegment = "profile/suggested/settings";
var affordabilityPath = "affordability/";
var listingRedirectPath = "listings";
var getPriorityThankyouPage = function(slug, city) {
    return city ? "".concat(slug, "/thankyou?redirectCity=").concat(city) : "".concat(slug, "/thankyou");
};
var sellersFlowUrlPath = {
    en: "/get-free-offer/",
    fr: "/fr/offre-gratuite/",
    it: "/it/offerta-gratuita/"
};
var footerTermsPath = {
    en: "/terms-and-conditions/",
    fr: "/fr/conditions-generales/",
    it: "/it/termini-e-condizioni/"
};
var footerPrivacyPath = {
    en: "/pdf/privacy-policy-en.pdf/",
    fr: "/pdf/privacy-policy-fr.pdf/",
    it: "/pdf/privacy-policy-it.pdf/"
};
/**
 * produces the base path of "houses for sale" section, without heading and trailing slashes
 * i.e.
 *  - en -> 'house-for-sale'
 *  - it -> 'it/case-in-vendita'
 *  - es -> 'es/casas-en-venta'
 *  - ...
 *
 * @param language
 */ var getHousesForSalesPathSegment = function(language) {
    var urlCountryPrefix = language !== "en" ? "".concat(language, "/") : "";
    var urlSectionPrefix = allListings.filter(function(param) {
        var locale = param.locale;
        return language === locale;
    })[0].path;
    return "".concat(urlCountryPrefix).concat(urlSectionPrefix);
};
var getListingDetailPathSegment = function(language) {
    return detailListing.filter(function(param) {
        var locale = param.locale;
        return language === locale;
    })[0].path;
};
var isValidSegmentForHome = function(locale, segment) {
    return allListingsRecord[locale] === segment;
};


/***/ }),

/***/ 636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mc": function() { return /* binding */ GetPotentialPropertyVisitInterestResponse; },
/* harmony export */   "g8": function() { return /* binding */ initApi; },
/* harmony export */   "oL": function() { return /* binding */ httpQueryFunction; }
/* harmony export */ });
/* unused harmony exports API_BASE_URL, httpRequest */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88718);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50879);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93089);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10201);





var API_BASE_URL = "https://oathk.casavo.com/gluglu";
var getHeaders = function() {
    return {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Request-ID": (0,uuid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)()
    };
};
var httpRequest = function(customHeaders) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(url, method, payload) {
            var mergedHeaders;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                mergedHeaders = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, getHeaders(), customHeaders);
                return [
                    2,
                    isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0___default()(url, {
                        body: JSON.stringify(payload),
                        credentials: "include",
                        headers: mergedHeaders,
                        method: method
                    })
                ];
            });
        });
        return function(url, method, payload) {
            return _ref.apply(this, arguments);
        };
    }();
};
var defaultHttpRequest = httpRequest();
var httpQueryFunction = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var queryKey;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            queryKey = param.queryKey;
            return [
                2,
                isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0___default()(queryKey[0], {
                    credentials: "include",
                    headers: getHeaders(),
                    method: "GET"
                }).then(function(res) {
                    if (!res.ok) {
                        if (res.status === 404) return;
                        throw new Error();
                    }
                    return res.json();
                })
            ];
        });
    });
    return function httpQueryFunction(_) {
        return _ref.apply(this, arguments);
    };
}();
var GetPotentialPropertyVisitInterestResponse;
(function(GetPotentialPropertyVisitInterestResponse) {
    GetPotentialPropertyVisitInterestResponse["INTEREST_ALREADY_EXPRESSED"] = "INTEREST_ALREADY_EXPRESSED";
    GetPotentialPropertyVisitInterestResponse["INTEREST_NOT_EXPRESSED"] = "INTEREST_NOT_EXPRESSED";
})(GetPotentialPropertyVisitInterestResponse || (GetPotentialPropertyVisitInterestResponse = {}));
var initApi = function() {
    var baseURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : API_BASE_URL, httpRequestFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : httpRequest();
    return {
        addFavorite: function addFavorite(listingId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var response, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/listing/").concat(listingId, "/favorite"), "POST")
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.ok) {
                                throw Error("Error while sending the request. Status code ".concat(response.status));
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            console.error(e.message);
                            throw e;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        addSuggestionCriteria: function addSuggestionCriteria(payload) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var response, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/user/suggestion-criteria"), "POST", payload)
                            ];
                        case 1:
                            response = _state.sent();
                            if (response.ok || response.status === 409) {
                                return [
                                    2,
                                    response
                                ];
                            }
                            throw Error("Error while sending the request. Status code ".concat(response.status));
                        case 2:
                            e = _state.sent();
                            console.error(e.message);
                            throw e;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        allFavorites: function allFavorites() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var resp, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/user/favorite-listings"), "GET")
                            ];
                        case 1:
                            resp = _state.sent();
                            if (!resp.ok) {
                                throw new Error(resp.statusText);
                            }
                            return [
                                4,
                                resp.json()
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            e = _state.sent();
                            // eslint-disable-next-line no-console
                            console.error(e.message);
                            throw e;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        bookVisit: function bookVisit(listingId, payload) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var response, data, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/user/listing/").concat(listingId, "/book-visit"), "POST", payload)
                            ];
                        case 1:
                            response = _state.sent();
                            if (!!response.ok) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            throw Error(data.reason === "INVALID_EMAIL" ? data.reason : "Error while sending request visit. Service returned 500.");
                        case 3:
                            return [
                                3,
                                5
                            ];
                        case 4:
                            e = _state.sent();
                            // eslint-disable-next-line no-console
                            console.error(e.message);
                            throw e.message;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        getPotentialPropertyVisitInterest: function getPotentialPropertyVisitInterest(transactionId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var response, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/user/potential-properties/").concat(transactionId, "/express-interest-in-visit"), "GET")
                            ];
                        case 1:
                            response = _state.sent();
                            if (response.status === 204) {
                                return [
                                    2,
                                    GetPotentialPropertyVisitInterestResponse.INTEREST_ALREADY_EXPRESSED
                                ];
                            }
                            if (response.status === 404) {
                                return [
                                    2,
                                    GetPotentialPropertyVisitInterestResponse.INTEREST_NOT_EXPRESSED
                                ];
                            }
                            throw Error("Error during getting visit interest ".concat(response.status, " ").concat(response.statusText));
                        case 2:
                            e = _state.sent();
                            console.error(e.message);
                            throw e.message;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        getSuggestionCriteria: function getSuggestionCriteria() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var response, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/user/suggestion-criteria"), "GET")
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.ok) {
                                if (response.status === 404) {
                                    return [
                                        2
                                    ];
                                }
                                throw Error("Error while sending the request. Status code ".concat(response.status));
                            }
                            return [
                                2,
                                response.json()
                            ];
                        case 2:
                            e = _state.sent();
                            // eslint-disable-next-line no-console
                            console.error(e.message);
                            throw e;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        getSuggestionCriteriaURL: "".concat(baseURL, "/user/suggestion-criteria"),
        isFavorite: function isFavorite(listingId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var response, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/listing/").concat(listingId, "/favorite"), "GET")
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                response.ok
                            ];
                        case 2:
                            e = _state.sent();
                            // eslint-disable-next-line no-console
                            console.error(e.message);
                            throw e;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        performStoreUserValuation: function performStoreUserValuation(payload) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var response, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/user/valuations"), "POST", payload)
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.ok) {
                                throw Error("Error while sending the request. Status code ".concat(response.status));
                            }
                            return [
                                2,
                                response.json()
                            ];
                        case 2:
                            e = _state.sent();
                            console.error(e.message);
                            throw e;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        potentialPropertyVisitInterest: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(transactionId, payload) {
                var response, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/user/potential-properties/").concat(transactionId, "/express-interest-in-visit"), "POST", payload)
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.ok) {
                                throw Error("Error during sending visit interest ".concat(response.status, " ").concat(response.statusText));
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            console.error(e.message);
                            throw e.message;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(transactionId, payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        removeFavorite: function removeFavorite(listingId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var response, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/listing/").concat(listingId, "/favorite"), "DELETE")
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.ok) {
                                throw Error("Error while sending the request. Status code ".concat(response.status));
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            // eslint-disable-next-line no-console
                            console.error(e.message);
                            throw e;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        requestInfoCasavoListing: function requestInfoCasavoListing(listingId, payload) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var response, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/user/listing/").concat(listingId, "/request-info"), "POST", payload)
                            ];
                        case 1:
                            response = _state.sent();
                            if (response.ok) {
                                return [
                                    2,
                                    response
                                ];
                            }
                            throw Error("Error while sending the request. Status code ".concat(response.status));
                        case 2:
                            e = _state.sent();
                            console.log(e.message);
                            throw e;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        scheduleCall: function scheduleCall(listingId, payload) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var response, data, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/user/listing/").concat(listingId, "/schedule-call"), "POST", payload)
                            ];
                        case 1:
                            response = _state.sent();
                            if (!!response.ok) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            throw Error(data.reason === "INVALID_EMAIL" ? data.reason : "Error while sending request visit. Service returned 500.");
                        case 3:
                            return [
                                3,
                                5
                            ];
                        case 4:
                            e = _state.sent();
                            // eslint-disable-next-line no-console
                            console.error(e.message);
                            throw e.message;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        submitUserFavoriteSearch: function submitUserFavoriteSearch(payload) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var response, data;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/user/favorite-searches"), "POST", payload)
                            ];
                        case 1:
                            response = _state.sent();
                            if (!!response.ok) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            if (data.reason === "INVALID_EMAIL") {
                                throw Error(data.reason);
                            }
                            throw new Error(response.status + " response on favorite search submit");
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        updateSuggestedCriteria: function updateSuggestedCriteria(payload) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var response, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/user/suggestion-criteria"), "PUT", payload)
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.ok) {
                                throw Error("Error while sending the request. Status code ".concat(response.status));
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            console.error(e.message);
                            throw e;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        valuationForValuationId: function valuationForValuationId(valuationId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var response, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                httpRequestFn("".concat(baseURL, "/user/valuations/").concat(valuationId), "GET")
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.ok) {
                                throw Error("Error while sending the request. Status code ".concat(response.status));
                            }
                            return [
                                2,
                                response.json()
                            ];
                        case 2:
                            e = _state.sent();
                            console.error(e.message);
                            throw e;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = (initApi());


/***/ }),

/***/ 21530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E8": function() { return /* binding */ TENANT_DOMAIN_ENVIRONMENT_MAPPING; },
/* harmony export */   "jB": function() { return /* binding */ UNICREDIT_DOMAIN; },
/* harmony export */   "rk": function() { return /* binding */ TENANTS; }
/* harmony export */ });
var TENANT_DOMAIN_ENVIRONMENT_MAPPING = {
    unicreditProduction: "unicreditres",
    unicreditStaging: "lisa-ucsc"
};
var TENANTS = {
    casavo: "casavo",
    ucsc: "ucsc"
};
var UNICREDIT_DOMAIN = "https://www.unicreditres.it";


/***/ }),

/***/ 12527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dy": function() { return /* binding */ getTenant; }
/* harmony export */ });
/* unused harmony exports isRunningE2ETests, getTenantWithCasavoFallback, getTenantWithUnicreditFallback */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63796);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21530);
/* provided dependency */ var process = __webpack_require__(47859);


var isRunningE2ETests = function() {
    return(// @ts-ignore
    !!process.env.CYPRESS ||  true && window.Cypress !== undefined);
};
var getTenant = function(host) {
    if ( true && isRunningE2ETests()) {
        var _testForTenant;
        return (_testForTenant = window.testForTenant) !== null && _testForTenant !== void 0 ? _testForTenant : _constants__WEBPACK_IMPORTED_MODULE_0__/* .TENANTS.casavo */ .rk.casavo;
    }
    if (!host && "object" !== "undefined") {
        host = window.location.host;
    }
    if (!host && "object" === "undefined") {}
    if (host === null || host === undefined) {
        throw new Error("Cannot get tenant with nullish host");
    }
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(host.split(":"), 2), domain = ref[0], _port = ref[1];
    var isUcscDomain = domain.split(".").some(function(subdomain) {
        return subdomain.includes(_constants__WEBPACK_IMPORTED_MODULE_0__/* .TENANT_DOMAIN_ENVIRONMENT_MAPPING.unicreditProduction */ .E8.unicreditProduction) || subdomain.includes(_constants__WEBPACK_IMPORTED_MODULE_0__/* .TENANT_DOMAIN_ENVIRONMENT_MAPPING.unicreditStaging */ .E8.unicreditStaging);
    });
    if (isUcscDomain) return _constants__WEBPACK_IMPORTED_MODULE_0__/* .TENANTS.ucsc */ .rk.ucsc;
    return _constants__WEBPACK_IMPORTED_MODULE_0__/* .TENANTS.casavo */ .rk.casavo;
};
var getTenantWithFallback = function(fallbackTenant) {
    return function(host) {
        try {
            return getTenant(host);
        } catch (ex) {
            return fallbackTenant;
        }
    };
};
var getTenantWithCasavoFallback = getTenantWithFallback(_constants__WEBPACK_IMPORTED_MODULE_0__/* .TENANTS.casavo */ .rk.casavo);
var getTenantWithUnicreditFallback = getTenantWithFallback(_constants__WEBPACK_IMPORTED_MODULE_0__/* .TENANTS.ucsc */ .rk.ucsc);


/***/ }),

/***/ 38264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ initSnowplowClientSideTracker; },
  "c": function() { return /* binding */ sendSnowplowClientSideEvent; }
});

;// CONCATENATED MODULE: ./node_modules/@snowplow/tracker-core/node_modules/tslib/tslib.es6.mjs
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
  function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose;
    if (async) {
        if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
        dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
        if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
        dispose = value[Symbol.dispose];
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  function next() {
    while (env.stack.length) {
      var rec = env.stack.pop();
      try {
        var result = rec.dispose && rec.dispose.call(rec.value);
        if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
      }
      catch (e) {
          fail(e);
      }
    }
    if (env.hasError) throw env.error;
  }
  return next();
}

/* harmony default export */ var tslib_es6 = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
});

// EXTERNAL MODULE: ./node_modules/@snowplow/tracker-core/node_modules/uuid/index.js
var uuid = __webpack_require__(61774);
;// CONCATENATED MODULE: ./node_modules/@snowplow/tracker-core/dist/index.module.js
/*!
 * Core functionality for Snowplow JavaScript trackers v3.22.1 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */




var version$1 = "3.22.1";

/*
 * Copyright (c) 2013 Kevin van Zonneveld (http://kvz.io)
 * and Contributors (http://phpjs.org/authors)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
 * of the Software, and to permit persons to whom the Software is furnished to do
 * so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/**
 * Decodes a url safe Base 64 encoded string
 * @remarks See: {@link http://tools.ietf.org/html/rfc4648#page-7}
 * @param data - String to decode
 * @returns The decoded string
 */
function base64urldecode(data) {
    if (!data) {
        return data;
    }
    var padding = 4 - (data.length % 4);
    switch (padding) {
        case 2:
            data += '==';
            break;
        case 3:
            data += '=';
            break;
    }
    var b64Data = data.replace(/-/g, '+').replace(/_/g, '/');
    return base64decode(b64Data);
}
/**
 * Encodes a string into a url safe Base 64 encoded string
 * @remarks See: {@link http://tools.ietf.org/html/rfc4648#page-7}
 * @param data - String to encode
 * @returns The url safe Base 64 string
 */
function base64urlencode(data) {
    if (!data) {
        return data;
    }
    var enc = base64encode(data);
    return enc.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
/**
 * Encode string as base64.
 * Any type can be passed, but will be stringified
 *
 * @param data - string to encode
 * @returns base64-encoded string
 */
function base64encode(data) {
    // discuss at: http://phpjs.org/functions/base64_encode/
    // original by: Tyler Akins (http://rumkin.com)
    // improved by: Bayron Guevara
    // improved by: Thunder.m
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: Rafał Kukawski (http://kukawski.pl)
    // bugfixed by: Pellentesque Malesuada
    // example 1: base64_encode('Kevin van Zonneveld');
    // returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='
    // example 2: base64_encode('a');
    // returns 2: 'YQ=='
    // example 3: base64_encode('✓ à la mode');
    // returns 3: '4pyTIMOgIGxhIG1vZGU='
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0;
    var tmp_arr = [];
    if (!data) {
        return data;
    }
    data = unescape(encodeURIComponent(data));
    do {
        // pack three octets into four hexets
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = (o1 << 16) | (o2 << 8) | o3;
        h1 = (bits >> 18) & 0x3f;
        h2 = (bits >> 12) & 0x3f;
        h3 = (bits >> 6) & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    } while (i < data.length);
    var enc = tmp_arr.join('');
    var r = data.length % 3;
    return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
}
/**
 * Decode base64 to string
 *
 * @param data - base64 to string
 * @returns decoded string
 */
function base64decode(encodedData) {
    //  discuss at: http://locutus.io/php/base64_decode/
    // original by: Tyler Akins (http://rumkin.com)
    // improved by: Thunder.m
    // improved by: Kevin van Zonneveld (http://kvz.io)
    // improved by: Kevin van Zonneveld (http://kvz.io)
    //    input by: Aman Gupta
    //    input by: Brett Zamir (http://brett-zamir.me)
    // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
    // bugfixed by: Pellentesque Malesuada
    // bugfixed by: Kevin van Zonneveld (http://kvz.io)
    // improved by: Indigo744
    //   example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==')
    //   returns 1: 'Kevin van Zonneveld'
    //   example 2: base64_decode('YQ==')
    //   returns 2: 'a'
    //   example 3: base64_decode('4pyTIMOgIGxhIG1vZGU=')
    //   returns 3: '✓ à la mode'
    // decodeUTF8string()
    // Internal function to decode properly UTF8 string
    // Adapted from Solution #1 at https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
    var decodeUTF8string = function (str) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(str
            .split('')
            .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
            .join(''));
    };
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, dec = '';
    var tmpArr = [];
    if (!encodedData) {
        return encodedData;
    }
    encodedData += '';
    do {
        // unpack four hexets into three octets using index points in b64
        h1 = b64.indexOf(encodedData.charAt(i++));
        h2 = b64.indexOf(encodedData.charAt(i++));
        h3 = b64.indexOf(encodedData.charAt(i++));
        h4 = b64.indexOf(encodedData.charAt(i++));
        bits = (h1 << 18) | (h2 << 12) | (h3 << 6) | h4;
        o1 = (bits >> 16) & 0xff;
        o2 = (bits >> 8) & 0xff;
        o3 = bits & 0xff;
        if (h3 === 64) {
            tmpArr[ac++] = String.fromCharCode(o1);
        }
        else if (h4 === 64) {
            tmpArr[ac++] = String.fromCharCode(o1, o2);
        }
        else {
            tmpArr[ac++] = String.fromCharCode(o1, o2, o3);
        }
    } while (i < encodedData.length);
    dec = tmpArr.join('');
    return decodeUTF8string(dec.replace(/\0+$/, ''));
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
function payloadBuilder() {
    var dict = {}, allJson = [], jsonForProcessing = [], contextEntitiesForProcessing = [];
    var processor;
    var add = function (key, value) {
        if (value != null && value !== '') {
            // null also checks undefined
            dict[key] = value;
        }
    };
    var addDict = function (dict) {
        for (var key in dict) {
            if (Object.prototype.hasOwnProperty.call(dict, key)) {
                add(key, dict[key]);
            }
        }
    };
    var addJson = function (keyIfEncoded, keyIfNotEncoded, json) {
        if (json && isNonEmptyJson(json)) {
            var jsonWithKeys = { keyIfEncoded: keyIfEncoded, keyIfNotEncoded: keyIfNotEncoded, json: json };
            jsonForProcessing.push(jsonWithKeys);
            allJson.push(jsonWithKeys);
        }
    };
    var addContextEntity = function (entity) {
        contextEntitiesForProcessing.push(entity);
    };
    return {
        add: add,
        addDict: addDict,
        addJson: addJson,
        addContextEntity: addContextEntity,
        getPayload: function () { return dict; },
        getJson: function () { return allJson; },
        withJsonProcessor: function (jsonProcessor) {
            processor = jsonProcessor;
        },
        build: function () {
            processor === null || processor === void 0 ? void 0 : processor(this, jsonForProcessing, contextEntitiesForProcessing);
            return dict;
        }
    };
}
/**
 * A helper to build a Snowplow request from a set of name-value pairs, provided using the add methods.
 * Will base64 encode JSON, if desired, on build
 *
 * @returns The request builder, with add and build methods
 */
function payloadJsonProcessor(encodeBase64) {
    return function (payloadBuilder, jsonForProcessing, contextEntitiesForProcessing) {
        var add = function (json, keyIfEncoded, keyIfNotEncoded) {
            var str = JSON.stringify(json);
            if (encodeBase64) {
                payloadBuilder.add(keyIfEncoded, base64urlencode(str));
            }
            else {
                payloadBuilder.add(keyIfNotEncoded, str);
            }
        };
        var getContextFromPayload = function () {
            var payload = payloadBuilder.getPayload();
            if (encodeBase64 ? payload.cx : payload.co) {
                return JSON.parse(encodeBase64 ? base64urldecode(payload.cx) : payload.co);
            }
            return undefined;
        };
        var combineContexts = function (originalContext, newContext) {
            var context = originalContext || getContextFromPayload();
            if (context) {
                context.data = context.data.concat(newContext.data);
            }
            else {
                context = newContext;
            }
            return context;
        };
        var context = undefined;
        for (var _i = 0, jsonForProcessing_1 = jsonForProcessing; _i < jsonForProcessing_1.length; _i++) {
            var json = jsonForProcessing_1[_i];
            if (json.keyIfEncoded === 'cx') {
                context = combineContexts(context, json.json);
            }
            else {
                add(json.json, json.keyIfEncoded, json.keyIfNotEncoded);
            }
        }
        jsonForProcessing.length = 0;
        if (contextEntitiesForProcessing.length) {
            var newContext = {
                schema: 'iglu:com.snowplowanalytics.snowplow/contexts/jsonschema/1-0-0',
                data: __spreadArray([], contextEntitiesForProcessing, true)
            };
            context = combineContexts(context, newContext);
            contextEntitiesForProcessing.length = 0;
        }
        if (context) {
            add(context, 'cx', 'co');
        }
    };
}
/**
 * Is property a non-empty JSON?
 * @param property - Checks if object is non-empty json
 */
function isNonEmptyJson(property) {
    if (!isJson(property)) {
        return false;
    }
    for (var key in property) {
        if (Object.prototype.hasOwnProperty.call(property, key)) {
            return true;
        }
    }
    return false;
}
/**
 * Is property a JSON?
 * @param property - Checks if object is json
 */
function isJson(property) {
    return (typeof property !== 'undefined' &&
        property !== null &&
        (property.constructor === {}.constructor || property.constructor === [].constructor));
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var label = 'Snowplow: ';
var LOG_LEVEL;
(function (LOG_LEVEL) {
    LOG_LEVEL[LOG_LEVEL["none"] = 0] = "none";
    LOG_LEVEL[LOG_LEVEL["error"] = 1] = "error";
    LOG_LEVEL[LOG_LEVEL["warn"] = 2] = "warn";
    LOG_LEVEL[LOG_LEVEL["debug"] = 3] = "debug";
    LOG_LEVEL[LOG_LEVEL["info"] = 4] = "info";
})(LOG_LEVEL || (LOG_LEVEL = {}));
var index_module_LOG = logger();
function logger(logLevel) {
    if (logLevel === void 0) { logLevel = LOG_LEVEL.warn; }
    function setLogLevel(level) {
        if (LOG_LEVEL[level]) {
            logLevel = level;
        }
        else {
            logLevel = LOG_LEVEL.warn;
        }
    }
    /**
     * Log errors, with or without error object
     */
    function error(message, error) {
        var extraParams = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            extraParams[_i - 2] = arguments[_i];
        }
        if (logLevel >= LOG_LEVEL.error && typeof console !== 'undefined') {
            var logMsg = label + message + '\n';
            if (error) {
                console.error.apply(console, __spreadArray([logMsg + '\n', error], extraParams, false));
            }
            else {
                console.error.apply(console, __spreadArray([logMsg], extraParams, false));
            }
        }
    }
    /**
     * Log warnings, with or without error object
     */
    function warn(message, error) {
        var extraParams = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            extraParams[_i - 2] = arguments[_i];
        }
        if (logLevel >= LOG_LEVEL.warn && typeof console !== 'undefined') {
            var logMsg = label + message;
            if (error) {
                console.warn.apply(console, __spreadArray([logMsg + '\n', error], extraParams, false));
            }
            else {
                console.warn.apply(console, __spreadArray([logMsg], extraParams, false));
            }
        }
    }
    /**
     * Log debug messages
     */
    function debug(message) {
        var extraParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            extraParams[_i - 1] = arguments[_i];
        }
        if (logLevel >= LOG_LEVEL.debug && typeof console !== 'undefined') {
            console.debug.apply(console, __spreadArray([label + message], extraParams, false));
        }
    }
    /**
     * Log info messages
     */
    function info(message) {
        var extraParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            extraParams[_i - 1] = arguments[_i];
        }
        if (logLevel >= LOG_LEVEL.info && typeof console !== 'undefined') {
            console.info.apply(console, __spreadArray([label + message], extraParams, false));
        }
    }
    return { setLogLevel: setLogLevel, warn: warn, error: error, debug: debug, info: info };
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Contains helper functions to aid in the addition and removal of Global Contexts
 */
function globalContexts() {
    var globalPrimitives = [];
    var conditionalProviders = [];
    /**
     * Returns all applicable global contexts for a specified event
     * @param event - The event to check for applicable global contexts for
     * @returns An array of contexts
     */
    var assembleAllContexts = function (event) {
        var eventSchema = getUsefulSchema(event);
        var eventType = getEventType(event);
        var contexts = [];
        var generatedPrimitives = generatePrimitives(globalPrimitives, event, eventType, eventSchema);
        contexts.push.apply(contexts, generatedPrimitives);
        var generatedConditionals = generateConditionals(conditionalProviders, event, eventType, eventSchema);
        contexts.push.apply(contexts, generatedConditionals);
        return contexts;
    };
    return {
        getGlobalPrimitives: function () {
            return globalPrimitives;
        },
        getConditionalProviders: function () {
            return conditionalProviders;
        },
        addGlobalContexts: function (contexts) {
            var acceptedConditionalContexts = [];
            var acceptedContextPrimitives = [];
            for (var _i = 0, contexts_1 = contexts; _i < contexts_1.length; _i++) {
                var context = contexts_1[_i];
                if (isConditionalContextProvider(context)) {
                    acceptedConditionalContexts.push(context);
                }
                else if (isContextPrimitive(context)) {
                    acceptedContextPrimitives.push(context);
                }
            }
            globalPrimitives = globalPrimitives.concat(acceptedContextPrimitives);
            conditionalProviders = conditionalProviders.concat(acceptedConditionalContexts);
        },
        clearGlobalContexts: function () {
            conditionalProviders = [];
            globalPrimitives = [];
        },
        removeGlobalContexts: function (contexts) {
            var _loop_1 = function (context) {
                if (isConditionalContextProvider(context)) {
                    conditionalProviders = conditionalProviders.filter(function (item) { return JSON.stringify(item) !== JSON.stringify(context); });
                }
                else if (isContextPrimitive(context)) {
                    globalPrimitives = globalPrimitives.filter(function (item) { return JSON.stringify(item) !== JSON.stringify(context); });
                }
            };
            for (var _i = 0, contexts_2 = contexts; _i < contexts_2.length; _i++) {
                var context = contexts_2[_i];
                _loop_1(context);
            }
        },
        getApplicableContexts: function (event) {
            return assembleAllContexts(event);
        }
    };
}
function pluginContexts(plugins) {
    /**
     * Add common contexts to every event
     *
     * @param array - additionalContexts List of user-defined contexts
     * @returns userContexts combined with commonContexts
     */
    return {
        addPluginContexts: function (additionalContexts) {
            var combinedContexts = additionalContexts ? __spreadArray([], additionalContexts, true) : [];
            plugins.forEach(function (plugin) {
                try {
                    if (plugin.contexts) {
                        combinedContexts.push.apply(combinedContexts, plugin.contexts());
                    }
                }
                catch (ex) {
                    index_module_LOG.error('Error adding plugin contexts', ex);
                }
            });
            return combinedContexts;
        }
    };
}
/**
 * Find dynamic context generating functions and return their results to be merged into the static contexts
 * Combine an array of unchanging contexts with the result of a context-creating function
 *
 * @param dynamicOrStaticContexts - Array of custom context Objects or custom context generating functions
 * @param Parameters - to pass to dynamic context callbacks
 * @returns An array of Self Describing JSON context
 */
function resolveDynamicContext(dynamicOrStaticContexts) {
    var _a;
    var extraParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        extraParams[_i - 1] = arguments[_i];
    }
    return ((_a = dynamicOrStaticContexts === null || dynamicOrStaticContexts === void 0 ? void 0 : dynamicOrStaticContexts.map(function (context) {
        if (typeof context === 'function') {
            try {
                return context.apply(void 0, extraParams);
            }
            catch (e) {
                //TODO: provide warning
                return undefined;
            }
        }
        else {
            return context;
        }
    }).filter(Boolean)) !== null && _a !== void 0 ? _a : []);
}
/**
 * Slices a schema into its composite parts. Useful for ruleset filtering.
 * @param input - A schema string
 * @returns The vendor, schema name, major, minor and patch information of a schema string
 */
function getSchemaParts(input) {
    var re = new RegExp('^iglu:([a-zA-Z0-9-_.]+)/([a-zA-Z0-9-_]+)/jsonschema/([1-9][0-9]*)-(0|[1-9][0-9]*)-(0|[1-9][0-9]*)$');
    var matches = re.exec(input);
    if (matches !== null)
        return matches.slice(1, 6);
    return undefined;
}
/**
 * Validates the vendor section of a schema string contains allowed wildcard values
 * @param parts - Array of parts from a schema string
 * @returns Whether the vendor validation parts are a valid combination
 */
function validateVendorParts(parts) {
    if (parts[0] === '*' || parts[1] === '*') {
        return false; // no wildcard in first or second part
    }
    if (parts.slice(2).length > 0) {
        var asterisk = false;
        for (var _i = 0, _a = parts.slice(2); _i < _a.length; _i++) {
            var part = _a[_i];
            if (part === '*')
                // mark when we've found a wildcard
                asterisk = true;
            else if (asterisk)
                // invalid if alpha parts come after wildcard
                return false;
        }
        return true;
    }
    else if (parts.length == 2)
        return true;
    return false;
}
/**
 * Validates the vendor part of a schema string is valid for a rule set
 * @param input - Vendor part of a schema string
 * @returns Whether the vendor validation string is valid
 */
function validateVendor(input) {
    var parts = input.split('.');
    if (parts && parts.length > 1)
        return validateVendorParts(parts);
    return false;
}
/**
 * Checks for validity of input and returns all the sections of a schema string that are used to match rules in a ruleset
 * @param input - A Schema string
 * @returns The sections of a schema string that are used to match rules in a ruleset
 */
function getRuleParts(input) {
    var re = new RegExp('^iglu:((?:(?:[a-zA-Z0-9-_]+|\\*).)+(?:[a-zA-Z0-9-_]+|\\*))/([a-zA-Z0-9-_.]+|\\*)/jsonschema/([1-9][0-9]*|\\*)-(0|[1-9][0-9]*|\\*)-(0|[1-9][0-9]*|\\*)$');
    var matches = re.exec(input);
    if (matches !== null && validateVendor(matches[1]))
        return matches.slice(1, 6);
    return undefined;
}
/**
 * Ensures the rules specified in a schema string of a ruleset are valid
 * @param input - A Schema string
 * @returns if there rule is valid
 */
function isValidRule(input) {
    var ruleParts = getRuleParts(input);
    if (ruleParts) {
        var vendor = ruleParts[0];
        return ruleParts.length === 5 && validateVendor(vendor);
    }
    return false;
}
/**
 * Check if a variable is an Array containing only strings
 * @param input - The variable to validate
 * @returns True if the input is an array containing only strings
 */
function isStringArray(input) {
    return (Array.isArray(input) &&
        input.every(function (x) {
            return typeof x === 'string';
        }));
}
/**
 * Validates whether a rule set is an array of valid ruleset strings
 * @param input - The Array of rule set arguments
 * @returns True is the input is an array of valid rules
 */
function isValidRuleSetArg(input) {
    if (isStringArray(input))
        return input.every(function (x) {
            return isValidRule(x);
        });
    else if (typeof input === 'string')
        return isValidRule(input);
    return false;
}
/**
 * Check if a variable is a valid, non-empty Self Describing JSON
 * @param input - The variable to validate
 * @returns True if a valid Self Describing JSON
 */
function isSelfDescribingJson(input) {
    var sdj = input;
    if (isNonEmptyJson(sdj))
        if ('schema' in sdj && 'data' in sdj)
            return typeof sdj.schema === 'string' && typeof sdj.data === 'object';
    return false;
}
/**
 * Validates if the input object contains the expected properties of a ruleset
 * @param input - The object containing a rule set
 * @returns True if a valid rule set
 */
function isRuleSet(input) {
    var ruleSet = input;
    var ruleCount = 0;
    if (input != null && typeof input === 'object' && !Array.isArray(input)) {
        if (Object.prototype.hasOwnProperty.call(ruleSet, 'accept')) {
            if (isValidRuleSetArg(ruleSet['accept'])) {
                ruleCount += 1;
            }
            else {
                return false;
            }
        }
        if (Object.prototype.hasOwnProperty.call(ruleSet, 'reject')) {
            if (isValidRuleSetArg(ruleSet['reject'])) {
                ruleCount += 1;
            }
            else {
                return false;
            }
        }
        // if either 'reject' or 'accept' or both exists,
        // we have a valid ruleset
        return ruleCount > 0 && ruleCount <= 2;
    }
    return false;
}
/**
 * Validates if the function can be a valid context generator function
 * @param input - The function to be validated
 */
function isContextCallbackFunction(input) {
    return typeof input === 'function' && input.length <= 1;
}
/**
 * Validates if the function can be a valid context primitive function or self describing json
 * @param input - The function or orbject to be validated
 * @returns True if either a Context Generator or Self Describing JSON
 */
function isContextPrimitive(input) {
    return isContextCallbackFunction(input) || isSelfDescribingJson(input);
}
/**
 * Validates if an array is a valid shape to be a Filter Provider
 * @param input - The Array of Context filter callbacks
 */
function isFilterProvider(input) {
    if (Array.isArray(input)) {
        if (input.length === 2) {
            if (Array.isArray(input[1])) {
                return isContextCallbackFunction(input[0]) && input[1].every(isContextPrimitive);
            }
            return isContextCallbackFunction(input[0]) && isContextPrimitive(input[1]);
        }
    }
    return false;
}
/**
 * Validates if an array is a valid shape to be an array of rule sets
 * @param input - The Array of Rule Sets
 */
function isRuleSetProvider(input) {
    if (Array.isArray(input) && input.length === 2) {
        if (!isRuleSet(input[0]))
            return false;
        if (Array.isArray(input[1]))
            return input[1].every(isContextPrimitive);
        return isContextPrimitive(input[1]);
    }
    return false;
}
/**
 * Checks if an input array is either a filter provider or a rule set provider
 * @param input - An array of filter providers or rule set providers
 * @returns Whether the array is a valid {@link ConditionalContextProvider}
 */
function isConditionalContextProvider(input) {
    return isFilterProvider(input) || isRuleSetProvider(input);
}
/**
 * Checks if a given schema matches any rules within the provided rule set
 * @param ruleSet - The rule set containing rules to match schema against
 * @param schema - The schema to be matched against the rule set
 */
function matchSchemaAgainstRuleSet(ruleSet, schema) {
    var rejectCount = 0;
    var acceptCount = 0;
    var acceptRules = ruleSet['accept'];
    if (Array.isArray(acceptRules)) {
        if (ruleSet.accept.some(function (rule) { return matchSchemaAgainstRule(rule, schema); })) {
            acceptCount++;
        }
    }
    else if (typeof acceptRules === 'string') {
        if (matchSchemaAgainstRule(acceptRules, schema)) {
            acceptCount++;
        }
    }
    var rejectRules = ruleSet['reject'];
    if (Array.isArray(rejectRules)) {
        if (ruleSet.reject.some(function (rule) { return matchSchemaAgainstRule(rule, schema); })) {
            rejectCount++;
        }
    }
    else if (typeof rejectRules === 'string') {
        if (matchSchemaAgainstRule(rejectRules, schema)) {
            rejectCount++;
        }
    }
    if (acceptCount > 0 && rejectCount === 0) {
        return true;
    }
    else if (acceptCount === 0 && rejectCount > 0) {
        return false;
    }
    return false;
}
/**
 * Checks if a given schema matches a specific rule from a rule set
 * @param rule - The rule to match schema against
 * @param schema - The schema to be matched against the rule
 */
function matchSchemaAgainstRule(rule, schema) {
    if (!isValidRule(rule))
        return false;
    var ruleParts = getRuleParts(rule);
    var schemaParts = getSchemaParts(schema);
    if (ruleParts && schemaParts) {
        if (!matchVendor(ruleParts[0], schemaParts[0]))
            return false;
        for (var i = 1; i < 5; i++) {
            if (!matchPart(ruleParts[i], schemaParts[i]))
                return false;
        }
        return true; // if it hasn't failed, it passes
    }
    return false;
}
function matchVendor(rule, vendor) {
    // rule and vendor must have same number of elements
    var vendorParts = vendor.split('.');
    var ruleParts = rule.split('.');
    if (vendorParts && ruleParts) {
        if (vendorParts.length !== ruleParts.length)
            return false;
        for (var i = 0; i < ruleParts.length; i++) {
            if (!matchPart(vendorParts[i], ruleParts[i]))
                return false;
        }
        return true;
    }
    return false;
}
function matchPart(rule, schema) {
    // parts should be the string nested between slashes in the URI: /example/
    return (rule && schema && rule === '*') || rule === schema;
}
// Returns the "useful" schema, i.e. what would someone want to use to identify events.
// For some events this is the 'e' property but for unstructured events, this is the
// 'schema' from the 'ue_px' field.
function getUsefulSchema(sb) {
    var eventJson = sb.getJson();
    for (var _i = 0, eventJson_1 = eventJson; _i < eventJson_1.length; _i++) {
        var json = eventJson_1[_i];
        if (json.keyIfEncoded === 'ue_px' && typeof json.json['data'] === 'object') {
            var schema = json.json['data']['schema'];
            if (typeof schema == 'string') {
                return schema;
            }
        }
    }
    return '';
}
function getEventType(payloadBuilder) {
    var eventType = payloadBuilder.getPayload()['e'];
    return typeof eventType === 'string' ? eventType : '';
}
function buildGenerator(generator, event, eventType, eventSchema) {
    var contextGeneratorResult = undefined;
    try {
        // try to evaluate context generator
        var args = {
            event: event.getPayload(),
            eventType: eventType,
            eventSchema: eventSchema
        };
        contextGeneratorResult = generator(args);
        // determine if the produced result is a valid SDJ
        if (Array.isArray(contextGeneratorResult) && contextGeneratorResult.every(isSelfDescribingJson)) {
            return contextGeneratorResult;
        }
        else if (isSelfDescribingJson(contextGeneratorResult)) {
            return contextGeneratorResult;
        }
        else {
            return undefined;
        }
    }
    catch (error) {
        contextGeneratorResult = undefined;
    }
    return contextGeneratorResult;
}
function normalizeToArray(input) {
    if (Array.isArray(input)) {
        return input;
    }
    return Array.of(input);
}
function generatePrimitives(contextPrimitives, event, eventType, eventSchema) {
    var _a;
    var normalizedInputs = normalizeToArray(contextPrimitives);
    var partialEvaluate = function (primitive) {
        var result = evaluatePrimitive(primitive, event, eventType, eventSchema);
        if (result && result.length !== 0) {
            return result;
        }
        return undefined;
    };
    var generatedContexts = normalizedInputs.map(partialEvaluate);
    return (_a = []).concat.apply(_a, generatedContexts.filter(function (c) { return c != null && c.filter(Boolean); }));
}
function evaluatePrimitive(contextPrimitive, event, eventType, eventSchema) {
    if (isSelfDescribingJson(contextPrimitive)) {
        return [contextPrimitive];
    }
    else if (isContextCallbackFunction(contextPrimitive)) {
        var generatorOutput = buildGenerator(contextPrimitive, event, eventType, eventSchema);
        if (isSelfDescribingJson(generatorOutput)) {
            return [generatorOutput];
        }
        else if (Array.isArray(generatorOutput)) {
            return generatorOutput;
        }
    }
    return undefined;
}
function evaluateProvider(provider, event, eventType, eventSchema) {
    if (isFilterProvider(provider)) {
        var filter = provider[0];
        var filterResult = false;
        try {
            var args = {
                event: event.getPayload(),
                eventType: eventType,
                eventSchema: eventSchema
            };
            filterResult = filter(args);
        }
        catch (error) {
            filterResult = false;
        }
        if (filterResult === true) {
            return generatePrimitives(provider[1], event, eventType, eventSchema);
        }
    }
    else if (isRuleSetProvider(provider)) {
        if (matchSchemaAgainstRuleSet(provider[0], eventSchema)) {
            return generatePrimitives(provider[1], event, eventType, eventSchema);
        }
    }
    return [];
}
function generateConditionals(providers, event, eventType, eventSchema) {
    var _a;
    var normalizedInput = normalizeToArray(providers);
    var partialEvaluate = function (provider) {
        var result = evaluateProvider(provider, event, eventType, eventSchema);
        if (result && result.length !== 0) {
            return result;
        }
        return undefined;
    };
    var generatedContexts = normalizedInput.map(partialEvaluate);
    return (_a = []).concat.apply(_a, generatedContexts.filter(function (c) { return c != null && c.filter(Boolean); }));
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Transform optional/old-behavior number timestamp into`Timestamp` ADT
 *
 * @param timestamp - optional number or timestamp object
 * @returns correct timestamp object
 */
function getTimestamp(timestamp) {
    if (timestamp == null) {
        return { type: 'dtm', value: new Date().getTime() };
    }
    else if (typeof timestamp === 'number') {
        return { type: 'dtm', value: timestamp };
    }
    else if (timestamp.type === 'ttm') {
        // We can return timestamp here, but this is safer fallback
        return { type: 'ttm', value: timestamp.value };
    }
    else {
        return { type: 'dtm', value: timestamp.value || new Date().getTime() };
    }
}
/**
 * Create a tracker core object
 *
 * @param base64 - Whether to base 64 encode contexts and self describing event JSONs
 * @param corePlugins - The core plugins to be processed with each event
 * @param callback - Function applied to every payload dictionary object
 * @returns Tracker core
 */
function trackerCore(configuration) {
    if (configuration === void 0) { configuration = {}; }
    function newCore(base64, corePlugins, callback) {
        var pluginContextsHelper = pluginContexts(corePlugins), globalContextsHelper = globalContexts();
        var encodeBase64 = base64, payloadPairs = {}; // Dictionary of key-value pairs which get added to every payload, e.g. tracker version
        /**
         * Wraps an array of custom contexts in a self-describing JSON
         *
         * @param contexts - Array of custom context self-describing JSONs
         * @returns Outer JSON
         */
        function completeContexts(contexts) {
            if (contexts && contexts.length) {
                return {
                    schema: 'iglu:com.snowplowanalytics.snowplow/contexts/jsonschema/1-0-0',
                    data: contexts
                };
            }
            return undefined;
        }
        /**
         * Adds all global contexts to a contexts array
         *
         * @param pb - PayloadData
         * @param contexts - Custom contexts relating to the event
         */
        function attachGlobalContexts(pb, contexts) {
            var applicableContexts = globalContextsHelper.getApplicableContexts(pb);
            var returnedContexts = [];
            if (contexts && contexts.length) {
                returnedContexts.push.apply(returnedContexts, contexts);
            }
            if (applicableContexts && applicableContexts.length) {
                returnedContexts.push.apply(returnedContexts, applicableContexts);
            }
            return returnedContexts;
        }
        /**
         * Gets called by every trackXXX method
         * Adds context and payloadPairs name-value pairs to the payload
         * Applies the callback to the built payload
         *
         * @param pb - Payload
         * @param context - Custom contexts relating to the event
         * @param timestamp - Timestamp of the event
         * @returns Payload after the callback is applied
         */
        function track(pb, context, timestamp) {
            pb.withJsonProcessor(payloadJsonProcessor(encodeBase64));
            pb.add('eid', (0,uuid.v4)());
            pb.addDict(payloadPairs);
            var tstamp = getTimestamp(timestamp);
            pb.add(tstamp.type, tstamp.value.toString());
            var allContexts = attachGlobalContexts(pb, pluginContextsHelper.addPluginContexts(context));
            var wrappedContexts = completeContexts(allContexts);
            if (wrappedContexts !== undefined) {
                pb.addJson('cx', 'co', wrappedContexts);
            }
            corePlugins.forEach(function (plugin) {
                try {
                    if (plugin.beforeTrack) {
                        plugin.beforeTrack(pb);
                    }
                }
                catch (ex) {
                    index_module_LOG.error('Plugin beforeTrack', ex);
                }
            });
            if (typeof callback === 'function') {
                callback(pb);
            }
            var finalPayload = pb.build();
            corePlugins.forEach(function (plugin) {
                try {
                    if (plugin.afterTrack) {
                        plugin.afterTrack(finalPayload);
                    }
                }
                catch (ex) {
                    index_module_LOG.error('Plugin afterTrack', ex);
                }
            });
            return finalPayload;
        }
        /**
         * Set a persistent key-value pair to be added to every payload
         *
         * @param key - Field name
         * @param value - Field value
         */
        function addPayloadPair(key, value) {
            payloadPairs[key] = value;
        }
        var core = {
            track: track,
            addPayloadPair: addPayloadPair,
            getBase64Encoding: function () {
                return encodeBase64;
            },
            setBase64Encoding: function (encode) {
                encodeBase64 = encode;
            },
            addPayloadDict: function (dict) {
                for (var key in dict) {
                    if (Object.prototype.hasOwnProperty.call(dict, key)) {
                        payloadPairs[key] = dict[key];
                    }
                }
            },
            resetPayloadPairs: function (dict) {
                payloadPairs = isJson(dict) ? dict : {};
            },
            setTrackerVersion: function (version) {
                addPayloadPair('tv', version);
            },
            setTrackerNamespace: function (name) {
                addPayloadPair('tna', name);
            },
            setAppId: function (appId) {
                addPayloadPair('aid', appId);
            },
            setPlatform: function (value) {
                addPayloadPair('p', value);
            },
            setUserId: function (userId) {
                addPayloadPair('uid', userId);
            },
            setScreenResolution: function (width, height) {
                addPayloadPair('res', width + 'x' + height);
            },
            setViewport: function (width, height) {
                addPayloadPair('vp', width + 'x' + height);
            },
            setColorDepth: function (depth) {
                addPayloadPair('cd', depth);
            },
            setTimezone: function (timezone) {
                addPayloadPair('tz', timezone);
            },
            setLang: function (lang) {
                addPayloadPair('lang', lang);
            },
            setIpAddress: function (ip) {
                addPayloadPair('ip', ip);
            },
            setUseragent: function (useragent) {
                addPayloadPair('ua', useragent);
            },
            addGlobalContexts: function (contexts) {
                globalContextsHelper.addGlobalContexts(contexts);
            },
            clearGlobalContexts: function () {
                globalContextsHelper.clearGlobalContexts();
            },
            removeGlobalContexts: function (contexts) {
                globalContextsHelper.removeGlobalContexts(contexts);
            }
        };
        return core;
    }
    var base64 = configuration.base64, corePlugins = configuration.corePlugins, callback = configuration.callback, plugins = corePlugins !== null && corePlugins !== void 0 ? corePlugins : [], partialCore = newCore(base64 !== null && base64 !== void 0 ? base64 : true, plugins, callback), core = __assign(__assign({}, partialCore), { addPlugin: function (configuration) {
            var _a, _b;
            var plugin = configuration.plugin;
            plugins.push(plugin);
            (_a = plugin.logger) === null || _a === void 0 ? void 0 : _a.call(plugin, index_module_LOG);
            (_b = plugin.activateCorePlugin) === null || _b === void 0 ? void 0 : _b.call(plugin, core);
        } });
    plugins === null || plugins === void 0 ? void 0 : plugins.forEach(function (plugin) {
        var _a, _b;
        (_a = plugin.logger) === null || _a === void 0 ? void 0 : _a.call(plugin, index_module_LOG);
        (_b = plugin.activateCorePlugin) === null || _b === void 0 ? void 0 : _b.call(plugin, core);
    });
    return core;
}
/**
 * Build a self-describing event
 * A custom event type, allowing for an event to be tracked using your own custom schema
 * and a data object which conforms to the supplied schema
 *
 * @param event - Contains the properties and schema location for the event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSelfDescribingEvent(event) {
    var _a = event.event, schema = _a.schema, data = _a.data, pb = payloadBuilder();
    var ueJson = {
        schema: 'iglu:com.snowplowanalytics.snowplow/unstruct_event/jsonschema/1-0-0',
        data: { schema: schema, data: data }
    };
    pb.add('e', 'ue');
    pb.addJson('ue_px', 'ue_pr', ueJson);
    return pb;
}
/**
 * Build a Page View Event
 * Represents a Page View, which is typically fired as soon as possible when a web page
 * is loaded within the users browser. Often also fired on "virtual page views" within
 * Single Page Applications (SPA).
 *
 * @param event - Contains the properties for the Page View event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildPageView(event) {
    var pageUrl = event.pageUrl, pageTitle = event.pageTitle, referrer = event.referrer, pb = payloadBuilder();
    pb.add('e', 'pv'); // 'pv' for Page View
    pb.add('url', pageUrl);
    pb.add('page', pageTitle);
    pb.add('refr', referrer);
    return pb;
}
/**
 * Build a Page Ping Event
 * Fires when activity tracking is enabled in the browser.
 * Tracks same information as the last tracked Page View and includes scroll
 * information from the current page view
 *
 * @param event - Contains the properties for the Page Ping event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildPagePing(event) {
    var pageUrl = event.pageUrl, pageTitle = event.pageTitle, referrer = event.referrer, minXOffset = event.minXOffset, maxXOffset = event.maxXOffset, minYOffset = event.minYOffset, maxYOffset = event.maxYOffset, pb = payloadBuilder();
    pb.add('e', 'pp'); // 'pp' for Page Ping
    pb.add('url', pageUrl);
    pb.add('page', pageTitle);
    pb.add('refr', referrer);
    if (minXOffset && !isNaN(Number(minXOffset)))
        pb.add('pp_mix', minXOffset.toString());
    if (maxXOffset && !isNaN(Number(maxXOffset)))
        pb.add('pp_max', maxXOffset.toString());
    if (minYOffset && !isNaN(Number(minYOffset)))
        pb.add('pp_miy', minYOffset.toString());
    if (maxYOffset && !isNaN(Number(maxYOffset)))
        pb.add('pp_may', maxYOffset.toString());
    return pb;
}
/**
 * Build a Structured Event
 * A classic style of event tracking, allows for easier movement between analytics
 * systems. A loosely typed event, creating a Self Describing event is preferred, but
 * useful for interoperability.
 *
 * @param event - Contains the properties for the Structured event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function index_module_buildStructEvent(event) {
    var category = event.category, action = event.action, label = event.label, property = event.property, value = event.value, pb = payloadBuilder();
    pb.add('e', 'se'); // 'se' for Structured Event
    pb.add('se_ca', category);
    pb.add('se_ac', action);
    pb.add('se_la', label);
    pb.add('se_pr', property);
    pb.add('se_va', value == null ? undefined : value.toString());
    return pb;
}
/**
 * Build an Ecommerce Transaction Event
 * Allows for tracking common ecommerce events, this event is usually used when
 * a consumer completes a transaction.
 *
 * @param event - Contains the properties for the Ecommerce Transactoion event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildEcommerceTransaction(event) {
    var orderId = event.orderId, total = event.total, affiliation = event.affiliation, tax = event.tax, shipping = event.shipping, city = event.city, state = event.state, country = event.country, currency = event.currency, pb = payloadBuilder();
    pb.add('e', 'tr'); // 'tr' for Transaction
    pb.add('tr_id', orderId);
    pb.add('tr_af', affiliation);
    pb.add('tr_tt', total);
    pb.add('tr_tx', tax);
    pb.add('tr_sh', shipping);
    pb.add('tr_ci', city);
    pb.add('tr_st', state);
    pb.add('tr_co', country);
    pb.add('tr_cu', currency);
    return pb;
}
/**
 * Build an Ecommerce Transaction Item Event
 * Related to the {@link buildEcommerceTransaction}
 * Each Ecommerce Transaction may contain one or more EcommerceTransactionItem events
 *
 * @param event - Contains the properties for the Ecommerce Transaction Item event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildEcommerceTransactionItem(event) {
    var orderId = event.orderId, sku = event.sku, price = event.price, name = event.name, category = event.category, quantity = event.quantity, currency = event.currency, pb = payloadBuilder();
    pb.add('e', 'ti'); // 'tr' for Transaction Item
    pb.add('ti_id', orderId);
    pb.add('ti_sk', sku);
    pb.add('ti_nm', name);
    pb.add('ti_ca', category);
    pb.add('ti_pr', price);
    pb.add('ti_qu', quantity);
    pb.add('ti_cu', currency);
    return pb;
}
/**
 * Build a Scren View Event
 * Similar to a Page View but less focused on typical web properties
 * Often used for mobile applications as the user is presented with
 * new views as they performance navigation events
 *
 * @param event - Contains the properties for the Screen View event. One or more properties must be included.
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildScreenView(event) {
    var name = event.name, id = event.id;
    return buildSelfDescribingEvent({
        event: {
            schema: 'iglu:com.snowplowanalytics.snowplow/screen_view/jsonschema/1-0-0',
            data: removeEmptyProperties({ name: name, id: id })
        }
    });
}
/**
 * Build a Link Click Event
 * Used when a user clicks on a link on a webpage, typically an anchor tag `<a>`
 *
 * @param event - Contains the properties for the Link Click event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildLinkClick(event) {
    var targetUrl = event.targetUrl, elementId = event.elementId, elementClasses = event.elementClasses, elementTarget = event.elementTarget, elementContent = event.elementContent;
    var eventJson = {
        schema: 'iglu:com.snowplowanalytics.snowplow/link_click/jsonschema/1-0-1',
        data: removeEmptyProperties({ targetUrl: targetUrl, elementId: elementId, elementClasses: elementClasses, elementTarget: elementTarget, elementContent: elementContent })
    };
    return buildSelfDescribingEvent({ event: eventJson });
}
/**
 * Build a Ad Impression Event
 * Used to track an advertisement impression
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Impression event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdImpression(event) {
    var impressionId = event.impressionId, costModel = event.costModel, cost = event.cost, targetUrl = event.targetUrl, bannerId = event.bannerId, zoneId = event.zoneId, advertiserId = event.advertiserId, campaignId = event.campaignId;
    var eventJson = {
        schema: 'iglu:com.snowplowanalytics.snowplow/ad_impression/jsonschema/1-0-0',
        data: removeEmptyProperties({
            impressionId: impressionId,
            costModel: costModel,
            cost: cost,
            targetUrl: targetUrl,
            bannerId: bannerId,
            zoneId: zoneId,
            advertiserId: advertiserId,
            campaignId: campaignId
        })
    };
    return buildSelfDescribingEvent({ event: eventJson });
}
/**
 * Build a Ad Click Event
 * Used to track an advertisement click
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Click event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdClick(event) {
    var targetUrl = event.targetUrl, clickId = event.clickId, costModel = event.costModel, cost = event.cost, bannerId = event.bannerId, zoneId = event.zoneId, impressionId = event.impressionId, advertiserId = event.advertiserId, campaignId = event.campaignId;
    var eventJson = {
        schema: 'iglu:com.snowplowanalytics.snowplow/ad_click/jsonschema/1-0-0',
        data: removeEmptyProperties({
            targetUrl: targetUrl,
            clickId: clickId,
            costModel: costModel,
            cost: cost,
            bannerId: bannerId,
            zoneId: zoneId,
            impressionId: impressionId,
            advertiserId: advertiserId,
            campaignId: campaignId
        })
    };
    return buildSelfDescribingEvent({ event: eventJson });
}
/**
 * Build a Ad Conversion Event
 * Used to track an advertisement click
 *
 * @remarks
 * If you provide the cost field, you must also provide one of 'cpa', 'cpc', and 'cpm' for the costModel field.
 *
 * @param event - Contains the properties for the Ad Conversion event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAdConversion(event) {
    var conversionId = event.conversionId, costModel = event.costModel, cost = event.cost, category = event.category, action = event.action, property = event.property, initialValue = event.initialValue, advertiserId = event.advertiserId, campaignId = event.campaignId;
    var eventJson = {
        schema: 'iglu:com.snowplowanalytics.snowplow/ad_conversion/jsonschema/1-0-0',
        data: removeEmptyProperties({
            conversionId: conversionId,
            costModel: costModel,
            cost: cost,
            category: category,
            action: action,
            property: property,
            initialValue: initialValue,
            advertiserId: advertiserId,
            campaignId: campaignId
        })
    };
    return buildSelfDescribingEvent({ event: eventJson });
}
/**
 * Build a Social Interaction Event
 * Social tracking will be used to track the way users interact
 * with Facebook, Twitter and Google + widgets
 * e.g. to capture “like this” or “tweet this” events.
 *
 * @param event - Contains the properties for the Social Interaction event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSocialInteraction(event) {
    var action = event.action, network = event.network, target = event.target;
    var eventJson = {
        schema: 'iglu:com.snowplowanalytics.snowplow/social_interaction/jsonschema/1-0-0',
        data: removeEmptyProperties({ action: action, network: network, target: target })
    };
    return buildSelfDescribingEvent({ event: eventJson });
}
/**
 * Build a Add To Cart Event
 * For tracking users adding items from a cart
 * on an ecommerce site.
 *
 * @param event - Contains the properties for the Add To Cart event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildAddToCart(event) {
    var sku = event.sku, quantity = event.quantity, name = event.name, category = event.category, unitPrice = event.unitPrice, currency = event.currency;
    return buildSelfDescribingEvent({
        event: {
            schema: 'iglu:com.snowplowanalytics.snowplow/add_to_cart/jsonschema/1-0-0',
            data: removeEmptyProperties({
                sku: sku,
                quantity: quantity,
                name: name,
                category: category,
                unitPrice: unitPrice,
                currency: currency
            })
        }
    });
}
/**
 * Build a Remove From Cart Event
 * For tracking users removing items from a cart
 * on an ecommerce site.
 *
 * @param event - Contains the properties for the Remove From Cart event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildRemoveFromCart(event) {
    var sku = event.sku, quantity = event.quantity, name = event.name, category = event.category, unitPrice = event.unitPrice, currency = event.currency;
    return buildSelfDescribingEvent({
        event: {
            schema: 'iglu:com.snowplowanalytics.snowplow/remove_from_cart/jsonschema/1-0-0',
            data: removeEmptyProperties({
                sku: sku,
                quantity: quantity,
                name: name,
                category: category,
                unitPrice: unitPrice,
                currency: currency
            })
        }
    });
}
/**
 * Build a Form Focus or Change Form Event based on schema property
 * When a user focuses on a form element or when a user makes a
 * change to a form element.
 *
 * @param event - Contains the properties for the Form Focus or Change Form event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildFormFocusOrChange(event) {
    var event_schema = '';
    var schema = event.schema, formId = event.formId, elementId = event.elementId, nodeName = event.nodeName, elementClasses = event.elementClasses, value = event.value, type = event.type;
    var event_data = { formId: formId, elementId: elementId, nodeName: nodeName, elementClasses: elementClasses, value: value };
    if (schema === 'change_form') {
        event_schema = 'iglu:com.snowplowanalytics.snowplow/change_form/jsonschema/1-0-0';
        event_data.type = type;
    }
    else if (schema === 'focus_form') {
        event_schema = 'iglu:com.snowplowanalytics.snowplow/focus_form/jsonschema/1-0-0';
        event_data.elementType = type;
    }
    return buildSelfDescribingEvent({
        event: {
            schema: event_schema,
            data: removeEmptyProperties(event_data, { value: true })
        }
    });
}
/**
 * Build a Form Submission Event
 * Used to track when a user submits a form
 *
 * @param event - Contains the properties for the Form Submission event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildFormSubmission(event) {
    var formId = event.formId, formClasses = event.formClasses, elements = event.elements;
    return buildSelfDescribingEvent({
        event: {
            schema: 'iglu:com.snowplowanalytics.snowplow/submit_form/jsonschema/1-0-0',
            data: removeEmptyProperties({ formId: formId, formClasses: formClasses, elements: elements })
        }
    });
}
/**
 * Build a Site Search Event
 * Used when a user performs a search action on a page
 *
 * @param event - Contains the properties for the Site Search event
 * @returns PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track}
 */
function buildSiteSearch(event) {
    var terms = event.terms, filters = event.filters, totalResults = event.totalResults, pageResults = event.pageResults;
    return buildSelfDescribingEvent({
        event: {
            schema: 'iglu:com.snowplowanalytics.snowplow/site_search/jsonschema/1-0-0',
            data: removeEmptyProperties({ terms: terms, filters: filters, totalResults: totalResults, pageResults: pageResults })
        }
    });
}
/**
 * Build a Consent Withdrawn Event
 * Used for tracking when a user withdraws their consent
 *
 * @param event - Contains the properties for the Consent Withdrawn event
 * @returns An object containing the PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track} and a 'consent_document' context
 */
function buildConsentWithdrawn(event) {
    var all = event.all, id = event.id, version = event.version, name = event.name, description = event.description;
    var documentJson = {
        schema: 'iglu:com.snowplowanalytics.snowplow/consent_document/jsonschema/1-0-0',
        data: removeEmptyProperties({ id: id, version: version, name: name, description: description })
    };
    return {
        event: buildSelfDescribingEvent({
            event: {
                schema: 'iglu:com.snowplowanalytics.snowplow/consent_withdrawn/jsonschema/1-0-0',
                data: removeEmptyProperties({
                    all: all
                })
            }
        }),
        context: [documentJson]
    };
}
/**
 * Build a Consent Granted Event
 * Used for tracking when a user grants their consent
 *
 * @param event - Contains the properties for the Consent Granted event
 * @returns An object containing the PayloadBuilder to be sent to {@link @snowplow/tracker-core#TrackerCore.track} and a 'consent_document' context
 */
function buildConsentGranted(event) {
    var expiry = event.expiry, id = event.id, version = event.version, name = event.name, description = event.description;
    var documentJson = {
        schema: 'iglu:com.snowplowanalytics.snowplow/consent_document/jsonschema/1-0-0',
        data: removeEmptyProperties({ id: id, version: version, name: name, description: description })
    };
    return {
        event: buildSelfDescribingEvent({
            event: {
                schema: 'iglu:com.snowplowanalytics.snowplow/consent_granted/jsonschema/1-0-0',
                data: removeEmptyProperties({
                    expiry: expiry
                })
            }
        }),
        context: [documentJson]
    };
}
/**
 * Returns a copy of a JSON with undefined and null properties removed
 *
 * @param event - JSON object to clean
 * @param exemptFields - Set of fields which should not be removed even if empty
 * @returns A cleaned copy of eventJson
 */
function removeEmptyProperties(event, exemptFields) {
    if (exemptFields === void 0) { exemptFields = {}; }
    var ret = {};
    for (var k in event) {
        if (exemptFields[k] || (event[k] !== null && typeof event[k] !== 'undefined')) {
            ret[k] = event[k];
        }
    }
    return ret;
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var version = version$1;


//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ./node_modules/@snowplow/browser-tracker-core/node_modules/tslib/tslib.es6.mjs
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var tslib_es6_extendStatics = function(d, b) {
  tslib_es6_extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return tslib_es6_extendStatics(d, b);
};

function tslib_es6_extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  tslib_es6_extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var tslib_es6_assign = function() {
  tslib_es6_assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return tslib_es6_assign.apply(this, arguments);
}

function tslib_es6_rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function tslib_es6_decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function tslib_es6_param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function tslib_es6_esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function tslib_es6_runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function tslib_es6_propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function tslib_es6_setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function tslib_es6_metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function tslib_es6_awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function tslib_es6_generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var tslib_es6_createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function tslib_es6_exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) tslib_es6_createBinding(o, m, p);
}

function tslib_es6_values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function tslib_es6_read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function tslib_es6_spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(tslib_es6_read(arguments[i]));
  return ar;
}

/** @deprecated */
function tslib_es6_spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function tslib_es6_spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function tslib_es6_await(v) {
  return this instanceof tslib_es6_await ? (this.v = v, this) : new tslib_es6_await(v);
}

function tslib_es6_asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
  function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof tslib_es6_await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function tslib_es6_asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: tslib_es6_await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function tslib_es6_asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof tslib_es6_values === "function" ? tslib_es6_values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function tslib_es6_makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var tslib_es6_setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

function tslib_es6_importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) tslib_es6_createBinding(result, mod, k);
  tslib_es6_setModuleDefault(result, mod);
  return result;
}

function tslib_es6_importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function tslib_es6_classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function tslib_es6_classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function tslib_es6_classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function tslib_es6_addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose;
    if (async) {
        if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
        dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
        if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
        dispose = value[Symbol.dispose];
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var tslib_es6_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function tslib_es6_disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new tslib_es6_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  function next() {
    while (env.stack.length) {
      var rec = env.stack.pop();
      try {
        var result = rec.dispose && rec.dispose.call(rec.value);
        if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
      }
      catch (e) {
          fail(e);
      }
    }
    if (env.hasError) throw env.error;
  }
  return next();
}

/* harmony default export */ var tslib_tslib_es6 = ({
  __extends: tslib_es6_extends,
  __assign: tslib_es6_assign,
  __rest: tslib_es6_rest,
  __decorate: tslib_es6_decorate,
  __param: tslib_es6_param,
  __metadata: tslib_es6_metadata,
  __awaiter: tslib_es6_awaiter,
  __generator: tslib_es6_generator,
  __createBinding: tslib_es6_createBinding,
  __exportStar: tslib_es6_exportStar,
  __values: tslib_es6_values,
  __read: tslib_es6_read,
  __spread: tslib_es6_spread,
  __spreadArrays: tslib_es6_spreadArrays,
  __spreadArray: tslib_es6_spreadArray,
  __await: tslib_es6_await,
  __asyncGenerator: tslib_es6_asyncGenerator,
  __asyncDelegator: tslib_es6_asyncDelegator,
  __asyncValues: tslib_es6_asyncValues,
  __makeTemplateObject: tslib_es6_makeTemplateObject,
  __importStar: tslib_es6_importStar,
  __importDefault: tslib_es6_importDefault,
  __classPrivateFieldGet: tslib_es6_classPrivateFieldGet,
  __classPrivateFieldSet: tslib_es6_classPrivateFieldSet,
  __classPrivateFieldIn: tslib_es6_classPrivateFieldIn,
  __addDisposableResource: tslib_es6_addDisposableResource,
  __disposeResources: tslib_es6_disposeResources,
});

// EXTERNAL MODULE: ./node_modules/sha1/sha1.js
var sha1 = __webpack_require__(45904);
var sha1_default = /*#__PURE__*/__webpack_require__.n(sha1);
// EXTERNAL MODULE: ./node_modules/@snowplow/browser-tracker-core/node_modules/uuid/index.js
var node_modules_uuid = __webpack_require__(87664);
;// CONCATENATED MODULE: ./node_modules/@snowplow/browser-tracker-core/dist/index.module.js
/*!
 * Core functionality for Snowplow Browser trackers v3.22.1 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */






/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Attempt to get a value from localStorage
 *
 * @param string - key
 * @returns string The value obtained from localStorage, or
 *                undefined if localStorage is inaccessible
 */
function attemptGetLocalStorage(key) {
    try {
        var localStorageAlias = window.localStorage, exp = localStorageAlias.getItem(key + '.expires');
        if (exp === null || +exp > Date.now()) {
            return localStorageAlias.getItem(key);
        }
        else {
            localStorageAlias.removeItem(key);
            localStorageAlias.removeItem(key + '.expires');
        }
        return undefined;
    }
    catch (e) {
        return undefined;
    }
}
/**
 * Attempt to write a value to localStorage
 *
 * @param string - key
 * @param string - value
 * @param number - ttl Time to live in seconds, defaults to 2 years from Date.now()
 * @returns boolean Whether the operation succeeded
 */
function attemptWriteLocalStorage(key, value, ttl) {
    if (ttl === void 0) { ttl = 63072000; }
    try {
        var localStorageAlias = window.localStorage, t = Date.now() + ttl * 1000;
        localStorageAlias.setItem("".concat(key, ".expires"), t.toString());
        localStorageAlias.setItem(key, value);
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Attempt to delete a value from localStorage
 *
 * @param string - key
 * @returns boolean Whether the operation succeeded
 */
function attemptDeleteLocalStorage(key) {
    try {
        var localStorageAlias = window.localStorage;
        localStorageAlias.removeItem(key);
        localStorageAlias.removeItem(key + '.expires');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Attempt to get a value from sessionStorage
 *
 * @param string - key
 * @returns string The value obtained from sessionStorage, or
 *                undefined if sessionStorage is inaccessible
 */
function attemptGetSessionStorage(key) {
    try {
        return window.sessionStorage.getItem(key);
    }
    catch (e) {
        return undefined;
    }
}
/**
 * Attempt to write a value to sessionStorage
 *
 * @param string - key
 * @param string - value
 * @returns boolean Whether the operation succeeded
 */
function attemptWriteSessionStorage(key, value) {
    try {
        window.sessionStorage.setItem(key, value);
        return true;
    }
    catch (e) {
        return false;
    }
}

var DEFAULT_CROSS_DOMAIN_LINKER_PARAMS = {
    sessionId: true,
    sourceId: true,
    sourcePlatform: false,
    userId: false,
    reason: false
};
function createCrossDomainParameterValue(isExtendedFormat, attributeConfiguration, attributeValues) {
    var _a;
    var crossDomainParameterValue;
    var timestamp = new Date().getTime();
    var config = tslib_es6_assign(tslib_es6_assign({}, DEFAULT_CROSS_DOMAIN_LINKER_PARAMS), attributeConfiguration);
    var domainUserId = attributeValues.domainUserId, userId = attributeValues.userId, sessionId = attributeValues.sessionId, sourceId = attributeValues.sourceId, sourcePlatform = attributeValues.sourcePlatform, event = attributeValues.event;
    var eventTarget = event.currentTarget;
    var reason = typeof config.reason === 'function' ? config.reason(event) : (_a = eventTarget === null || eventTarget === void 0 ? void 0 : eventTarget.textContent) === null || _a === void 0 ? void 0 : _a.trim();
    if (isExtendedFormat) {
        /* Index is used by Enrich, so it should not be changed. */
        crossDomainParameterValue = [
            domainUserId,
            timestamp,
            config.sessionId && sessionId,
            config.userId && urlSafeBase64Encode(userId || ''),
            config.sourceId && urlSafeBase64Encode(sourceId || ''),
            config.sourcePlatform && sourcePlatform,
            config.reason && urlSafeBase64Encode(reason || ''),
        ]
            .map(function (attribute) { return attribute || ''; })
            .join('.')
            // Remove trailing dots
            .replace(/([.]*$)/, '');
    }
    else {
        crossDomainParameterValue = attributeValues.domainUserId + '.' + timestamp;
    }
    return crossDomainParameterValue;
}
/**
 *
 * The url-safe variation emits - and _ instead of + and / characters. Also removes = sign padding.
 * @param {string} str The string to encode in a URL safe manner
 * @return {string}
 */
function urlSafeBase64Encode(str) {
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Checks if an object is a string
 * @param str - The object to check
 */
function isString(str) {
    if (str && typeof str.valueOf() === 'string') {
        return true;
    }
    return false;
}
/**
 * Checks if an object is an integer
 * @param int - The object to check
 */
function isInteger(int) {
    return ((Number.isInteger && Number.isInteger(int)) || (typeof int === 'number' && isFinite(int) && Math.floor(int) === int));
}
/**
 * Checks if the input parameter is a function
 * @param func - The object to check
 */
function isFunction(func) {
    if (func && typeof func === 'function') {
        return true;
    }
    return false;
}
/**
 * Cleans up the page title
 */
function fixupTitle(title) {
    if (!isString(title)) {
        title = title.text || '';
        var tmp = document.getElementsByTagName('title');
        if (tmp && tmp[0] != null) {
            title = tmp[0].text;
        }
    }
    return title;
}
/**
 * Extract hostname from URL
 */
function getHostName(url) {
    // scheme : // [username [: password] @] hostname [: port] [/ [path] [? query] [# fragment]]
    var e = new RegExp('^(?:(?:https?|ftp):)/*(?:[^@]+@)?([^:/#]+)'), matches = e.exec(url);
    return matches ? matches[1] : url;
}
/**
 * Fix-up domain
 */
function fixupDomain(domain) {
    var dl = domain.length;
    // remove trailing '.'
    if (domain.charAt(--dl) === '.') {
        domain = domain.slice(0, dl);
    }
    // remove leading '*'
    if (domain.slice(0, 2) === '*.') {
        domain = domain.slice(1);
    }
    return domain;
}
/**
 * Get page referrer. In the case of a single-page app,
 * if the URL changes without the page reloading, pass
 * in the old URL. It will be returned unless overriden
 * by a "refer(r)er" parameter in the querystring.
 *
 * @param string - oldLocation Optional.
 * @returns string The referrer
 */
function getReferrer(oldLocation) {
    var windowAlias = window, fromQs = fromQuerystring('referrer', windowAlias.location.href) || fromQuerystring('referer', windowAlias.location.href);
    // Short-circuit
    if (fromQs) {
        return fromQs;
    }
    // In the case of a single-page app, return the old URL
    if (oldLocation) {
        return oldLocation;
    }
    try {
        if (windowAlias.top) {
            return windowAlias.top.document.referrer;
        }
        else if (windowAlias.parent) {
            return windowAlias.parent.document.referrer;
        }
    }
    catch (_a) { }
    return document.referrer;
}
/**
 * Cross-browser helper function to add event handler
 */
function addEventListener(element, eventType, eventHandler, options) {
    if (element.addEventListener) {
        element.addEventListener(eventType, eventHandler, options);
        return true;
    }
    // IE Support
    if (element.attachEvent) {
        return element.attachEvent('on' + eventType, eventHandler);
    }
    element['on' + eventType] = eventHandler;
}
/**
 * Return value from name-value pair in querystring
 */
function fromQuerystring(field, url) {
    var match = new RegExp('^[^#]*[?&]' + field + '=([^&#]*)').exec(url);
    if (!match) {
        return null;
    }
    return decodeURIComponent(match[1].replace(/\+/g, ' '));
}
/**
 * Add a name-value pair to the querystring of a URL
 *
 * @param string - url URL to decorate
 * @param string - name Name of the querystring pair
 * @param string - value Value of the querystring pair
 */
function decorateQuerystring(url, name, value) {
    var initialQsParams = name + '=' + value;
    var hashSplit = url.split('#');
    var qsSplit = hashSplit[0].split('?');
    var beforeQuerystring = qsSplit.shift();
    // Necessary because a querystring may contain multiple question marks
    var querystring = qsSplit.join('?');
    if (!querystring) {
        querystring = initialQsParams;
    }
    else {
        // Whether this is the first time the link has been decorated
        var initialDecoration = true;
        var qsFields = querystring.split('&');
        for (var i = 0; i < qsFields.length; i++) {
            if (qsFields[i].substr(0, name.length + 1) === name + '=') {
                initialDecoration = false;
                qsFields[i] = initialQsParams;
                querystring = qsFields.join('&');
                break;
            }
        }
        if (initialDecoration) {
            querystring = initialQsParams + '&' + querystring;
        }
    }
    hashSplit[0] = beforeQuerystring + '?' + querystring;
    return hashSplit.join('#');
}
/**
 * Finds the root domain
 */
function findRootDomain(sameSite, secure) {
    var windowLocationHostnameAlias = window.location.hostname, cookiePrefix = '_sp_root_domain_test_', cookieName = cookiePrefix + new Date().getTime(), cookieValue = '_test_value_' + new Date().getTime();
    var locationParts = windowLocationHostnameAlias.split('.');
    for (var idx = locationParts.length - 2; idx >= 0; idx--) {
        var currentDomain = locationParts.slice(idx).join('.');
        cookie(cookieName, cookieValue, 0, '/', currentDomain, sameSite, secure);
        if (cookie(cookieName) === cookieValue) {
            // Clean up created cookie(s)
            deleteCookie(cookieName, currentDomain, sameSite, secure);
            var cookieNames = getCookiesWithPrefix(cookiePrefix);
            for (var i = 0; i < cookieNames.length; i++) {
                deleteCookie(cookieNames[i], currentDomain, sameSite, secure);
            }
            return currentDomain;
        }
    }
    // Cookies cannot be read
    return windowLocationHostnameAlias;
}
/**
 * Checks whether a value is present within an array
 *
 * @param val - The value to check for
 * @param array - The array to check within
 * @returns boolean Whether it exists
 */
function isValueInArray(val, array) {
    for (var i = 0; i < array.length; i++) {
        if (array[i] === val) {
            return true;
        }
    }
    return false;
}
/**
 * Deletes an arbitrary cookie by setting the expiration date to the past
 *
 * @param cookieName - The name of the cookie to delete
 * @param domainName - The domain the cookie is in
 */
function deleteCookie(cookieName, domainName, sameSite, secure) {
    cookie(cookieName, '', -1, '/', domainName, sameSite, secure);
}
/**
 * Fetches the name of all cookies beginning with a certain prefix
 *
 * @param cookiePrefix - The prefix to check for
 * @returns array The cookies that begin with the prefix
 */
function getCookiesWithPrefix(cookiePrefix) {
    var cookies = document.cookie.split('; ');
    var cookieNames = [];
    for (var i = 0; i < cookies.length; i++) {
        if (cookies[i].substring(0, cookiePrefix.length) === cookiePrefix) {
            cookieNames.push(cookies[i]);
        }
    }
    return cookieNames;
}
/**
 * Get and set the cookies associated with the current document in browser
 * This implementation always returns a string, returns the cookie value if only name is specified
 *
 * @param name - The cookie name (required)
 * @param value - The cookie value
 * @param ttl - The cookie Time To Live (seconds)
 * @param path - The cookies path
 * @param domain - The cookies domain
 * @param samesite - The cookies samesite attribute
 * @param secure - Boolean to specify if cookie should be secure
 * @returns string The cookies value
 */
function cookie(name, value, ttl, path, domain, samesite, secure) {
    if (arguments.length > 1) {
        return (document.cookie =
            name +
                '=' +
                encodeURIComponent(value !== null && value !== void 0 ? value : '') +
                (ttl ? '; Expires=' + new Date(+new Date() + ttl * 1000).toUTCString() : '') +
                (path ? '; Path=' + path : '') +
                (domain ? '; Domain=' + domain : '') +
                (samesite ? '; SameSite=' + samesite : '') +
                (secure ? '; Secure' : ''));
    }
    return decodeURIComponent((('; ' + document.cookie).split('; ' + name + '=')[1] || '').split(';')[0]);
}
/**
 * Parses an object and returns either the
 * integer or undefined.
 *
 * @param obj - The object to parse
 * @returns the result of the parse operation
 */
function parseAndValidateInt(obj) {
    var result = parseInt(obj);
    return isNaN(result) ? undefined : result;
}
/**
 * Parses an object and returns either the
 * number or undefined.
 *
 * @param obj - The object to parse
 * @returns the result of the parse operation
 */
function parseAndValidateFloat(obj) {
    var result = parseFloat(obj);
    return isNaN(result) ? undefined : result;
}
/**
 * Convert a criterion object to a filter function
 *
 * @param object - criterion Either {allowlist: [array of allowable strings]}
 *                             or {denylist: [array of allowable strings]}
 *                             or {filter: function (elt) {return whether to track the element}
 * @param boolean - byClass Whether to allowlist/denylist based on an element's classes (for forms)
 *                        or name attribute (for fields)
 */
function getFilterByClass(criterion) {
    // If the criterion argument is not an object, add listeners to all elements
    if (criterion == null || typeof criterion !== 'object' || Array.isArray(criterion)) {
        return function () {
            return true;
        };
    }
    var inclusive = Object.prototype.hasOwnProperty.call(criterion, 'allowlist');
    var specifiedClassesSet = getSpecifiedClassesSet(criterion);
    return getFilter(criterion, function (elt) {
        return checkClass(elt, specifiedClassesSet) === inclusive;
    });
}
/**
 * Convert a criterion object to a filter function
 *
 * @param object - criterion Either {allowlist: [array of allowable strings]}
 *                             or {denylist: [array of allowable strings]}
 *                             or {filter: function (elt) {return whether to track the element}
 */
function getFilterByName(criterion) {
    // If the criterion argument is not an object, add listeners to all elements
    if (criterion == null || typeof criterion !== 'object' || Array.isArray(criterion)) {
        return function () {
            return true;
        };
    }
    var inclusive = criterion.hasOwnProperty('allowlist');
    var specifiedClassesSet = getSpecifiedClassesSet(criterion);
    return getFilter(criterion, function (elt) {
        return elt.name in specifiedClassesSet === inclusive;
    });
}
/**
 * List the classes of a DOM element without using elt.classList (for compatibility with IE 9)
 */
function getCssClasses(elt) {
    return elt.className.match(/\S+/g) || [];
}
/**
 * Check whether an element has at least one class from a given list
 */
function checkClass(elt, classList) {
    var classes = getCssClasses(elt);
    for (var _i = 0, classes_1 = classes; _i < classes_1.length; _i++) {
        var className = classes_1[_i];
        if (classList[className]) {
            return true;
        }
    }
    return false;
}
function getFilter(criterion, fallbackFilter) {
    if (criterion.hasOwnProperty('filter') && criterion.filter) {
        return criterion.filter;
    }
    return fallbackFilter;
}
function getSpecifiedClassesSet(criterion) {
    // Convert the array of classes to an object of the form {class1: true, class2: true, ...}
    var specifiedClassesSet = {};
    var specifiedClasses = criterion.allowlist || criterion.denylist;
    if (specifiedClasses) {
        if (!Array.isArray(specifiedClasses)) {
            specifiedClasses = [specifiedClasses];
        }
        for (var i = 0; i < specifiedClasses.length; i++) {
            specifiedClassesSet[specifiedClasses[i]] = true;
        }
    }
    return specifiedClassesSet;
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/*
 * Checks whether sessionStorage is available, in a way that
 * does not throw a SecurityError in Firefox if "always ask"
 * is enabled for cookies (https://github.com/snowplow/snowplow/issues/163).
 */
function hasSessionStorage() {
    try {
        return !!window.sessionStorage;
    }
    catch (e) {
        return true; // SecurityError when referencing it means it exists
    }
}
/*
 * Checks whether localStorage is available, in a way that
 * does not throw a SecurityError in Firefox if "always ask"
 * is enabled for cookies (https://github.com/snowplow/snowplow/issues/163).
 */
function hasLocalStorage() {
    try {
        return !!window.localStorage;
    }
    catch (e) {
        return true; // SecurityError when referencing it means it exists
    }
}
/*
 * Checks whether localStorage is accessible
 * sets and removes an item to handle private IOS5 browsing
 * (http://git.io/jFB2Xw)
 */
function localStorageAccessible() {
    var mod = 'modernizr';
    if (!hasLocalStorage()) {
        return false;
    }
    try {
        var ls = window.localStorage;
        ls.setItem(mod, mod);
        ls.removeItem(mod);
        return true;
    }
    catch (e) {
        return false;
    }
}

var WEB_PAGE_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/web_page/jsonschema/1-0-0';
var BROWSER_CONTEXT_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/browser_context/jsonschema/2-0-0';
var CLIENT_SESSION_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/client_session/jsonschema/1-0-2';
var PAYLOAD_DATA_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/payload_data/jsonschema/1-0-4';

/**
 * Object handling sending events to a collector.
 * Instantiated once per tracker instance.
 *
 * @param id - The Snowplow function name (used to generate the localStorage key)
 * @param sharedSate - Stores reference to the outbound queue so it can unload the page when all queues are empty
 * @param useLocalStorage - Whether to use localStorage at all
 * @param eventMethod - if null will use 'beacon' otherwise can be set to 'post', 'get', or 'beacon' to force.
 * @param postPath - The path where events are to be posted
 * @param bufferSize - How many events to batch in localStorage before sending them all
 * @param maxPostBytes - Maximum combined size in bytes of the event JSONs in a POST request
 * @param maxGetBytes - Maximum size in bytes of the complete event URL string in a GET request. 0 for no limit.
 * @param useStm - Whether to add timestamp to events
 * @param maxLocalStorageQueueSize - Maximum number of queued events we will attempt to store in local storage
 * @param connectionTimeout - Defines how long to wait before aborting the request
 * @param anonymousTracking - Defines whether to set the SP-Anonymous header for anonymous tracking on GET and POST
 * @param customHeaders - Allows custom headers to be defined and passed on XMLHttpRequest requests
 * @param withCredentials - Sets the value of the withCredentials flag on XMLHttpRequest (GET and POST) requests
 * @param retryStatusCodes – Failure HTTP response status codes from Collector for which sending events should be retried (they can override the `dontRetryStatusCodes`)
 * @param dontRetryStatusCodes – Failure HTTP response status codes from Collector for which sending events should not be retried
 * @param idService - Id service full URL. This URL will be added to the queue and will be called using a GET method.
 * @param retryFailedRequests - Whether to retry failed requests - Takes precedent over `retryStatusCodes` and `dontRetryStatusCodes`
 * @param onRequestSuccess - Function called when a request succeeds
 * @param onRequestFailure - Function called when a request does not succeed
 * @returns object OutQueueManager instance
 */
function OutQueueManager(id, sharedSate, useLocalStorage, eventMethod, postPath, bufferSize, maxPostBytes, maxGetBytes, useStm, maxLocalStorageQueueSize, connectionTimeout, anonymousTracking, customHeaders, withCredentials, retryStatusCodes, dontRetryStatusCodes, idService, retryFailedRequests, onRequestSuccess, onRequestFailure) {
    if (retryFailedRequests === void 0) { retryFailedRequests = true; }
    var executingQueue = false, configCollectorUrl, outQueue = [], idServiceCalled = false;
    //Force to lower case if its a string
    eventMethod = typeof eventMethod === 'string' ? eventMethod.toLowerCase() : eventMethod;
    // Use the Beacon API if eventMethod is set true, 'true', or 'beacon'.
    var isBeaconRequested = eventMethod === true || eventMethod === 'beacon' || eventMethod === 'true', 
    // Fall back to POST or GET for browsers which don't support Beacon API
    isBeaconAvailable = Boolean(isBeaconRequested &&
        window.navigator &&
        typeof window.navigator.sendBeacon === 'function' &&
        !hasWebKitBeaconBug(window.navigator.userAgent)), useBeacon = isBeaconAvailable && isBeaconRequested, 
    // Use GET if specified
    isGetRequested = eventMethod === 'get', 
    // Don't use XhrHttpRequest for browsers which don't support CORS XMLHttpRequests (e.g. IE <= 9)
    useXhr = Boolean(window.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest()), 
    // Use POST if specified
    usePost = !isGetRequested && useXhr && (eventMethod === 'post' || isBeaconRequested), 
    // Resolve all options and capabilities and decide path
    path = usePost ? postPath : '/i', 
    // Different queue names for GET and POST since they are stored differently
    queueName = "snowplowOutQueue_".concat(id, "_").concat(usePost ? 'post2' : 'get');
    // Ensure we don't set headers when beacon is the requested eventMethod as we might fallback to POST
    // and end up sending them in older browsers which don't support beacon leading to inconsistencies
    if (isBeaconRequested)
        customHeaders = {};
    // Get buffer size or set 1 if unable to buffer
    bufferSize = (useLocalStorage && localStorageAccessible() && usePost && bufferSize) || 1;
    if (useLocalStorage) {
        // Catch any JSON parse errors or localStorage that might be thrown
        try {
            var localStorageQueue = window.localStorage.getItem(queueName);
            outQueue = localStorageQueue ? JSON.parse(localStorageQueue) : [];
        }
        catch (e) { }
    }
    // Initialize to and empty array if we didn't get anything out of localStorage
    if (!Array.isArray(outQueue)) {
        outQueue = [];
    }
    // Used by pageUnloadGuard
    sharedSate.outQueues.push(outQueue);
    if (useXhr && bufferSize > 1) {
        sharedSate.bufferFlushers.push(function (sync) {
            if (!executingQueue) {
                executeQueue(sync);
            }
        });
    }
    /*
     * Convert a dictionary to a querystring
     * The context field is the last in the querystring
     */
    function getQuerystring(request) {
        var querystring = '?', lowPriorityKeys = { co: true, cx: true }, firstPair = true;
        for (var key in request) {
            if (request.hasOwnProperty(key) && !lowPriorityKeys.hasOwnProperty(key)) {
                if (!firstPair) {
                    querystring += '&';
                }
                else {
                    firstPair = false;
                }
                querystring += encodeURIComponent(key) + '=' + encodeURIComponent(request[key]);
            }
        }
        for (var contextKey in lowPriorityKeys) {
            if (request.hasOwnProperty(contextKey) && lowPriorityKeys.hasOwnProperty(contextKey)) {
                querystring += '&' + contextKey + '=' + encodeURIComponent(request[contextKey]);
            }
        }
        return querystring;
    }
    /*
     * Convert numeric fields to strings to match payload_data schema
     */
    function getBody(request) {
        var cleanedRequest = Object.keys(request)
            .map(function (k) { return [k, request[k]]; })
            .reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            acc[key] = value.toString();
            return acc;
        }, {});
        return {
            evt: cleanedRequest,
            bytes: getUTF8Length(JSON.stringify(cleanedRequest))
        };
    }
    /**
     * Count the number of bytes a string will occupy when UTF-8 encoded
     * Taken from http://stackoverflow.com/questions/2848462/count-bytes-in-textarea-using-javascript/
     *
     * @param string - s
     * @returns number Length of s in bytes when UTF-8 encoded
     */
    function getUTF8Length(s) {
        var len = 0;
        for (var i = 0; i < s.length; i++) {
            var code = s.charCodeAt(i);
            if (code <= 0x7f) {
                len += 1;
            }
            else if (code <= 0x7ff) {
                len += 2;
            }
            else if (code >= 0xd800 && code <= 0xdfff) {
                // Surrogate pair: These take 4 bytes in UTF-8 and 2 chars in UCS-2
                // (Assume next char is the other [valid] half and just skip it)
                len += 4;
                i++;
            }
            else if (code < 0xffff) {
                len += 3;
            }
            else {
                len += 4;
            }
        }
        return len;
    }
    var postable = function (queue) {
        return typeof queue[0] === 'object' && 'evt' in queue[0];
    };
    /**
     * Send event as POST request right away without going to queue. Used when the request surpasses maxGetBytes or maxPostBytes
     * @param body POST request body
     * @param configCollectorUrl full collector URL with path
     */
    function sendPostRequestWithoutQueueing(body, configCollectorUrl) {
        var xhr = initializeXMLHttpRequest(configCollectorUrl, true, false);
        var batch = attachStmToEvent([body.evt]);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (isSuccessfulRequest(xhr.status)) {
                    onRequestSuccess === null || onRequestSuccess === void 0 ? void 0 : onRequestSuccess(batch);
                }
                else {
                    onRequestFailure === null || onRequestFailure === void 0 ? void 0 : onRequestFailure({
                        status: xhr.status,
                        message: xhr.statusText,
                        events: batch,
                        willRetry: false
                    });
                }
            }
        };
        xhr.send(encloseInPayloadDataEnvelope(batch));
    }
    function removeEventsFromQueue(numberToSend) {
        for (var deleteCount = 0; deleteCount < numberToSend; deleteCount++) {
            outQueue.shift();
        }
        if (useLocalStorage) {
            attemptWriteLocalStorage(queueName, JSON.stringify(outQueue.slice(0, maxLocalStorageQueueSize)));
        }
    }
    function setXhrCallbacks(xhr, numberToSend, batch) {
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                clearTimeout(xhrTimeout);
                if (isSuccessfulRequest(xhr.status)) {
                    removeEventsFromQueue(numberToSend);
                    onRequestSuccess === null || onRequestSuccess === void 0 ? void 0 : onRequestSuccess(batch);
                    executeQueue();
                }
                else {
                    var willRetry = shouldRetryForStatusCode(xhr.status);
                    if (!willRetry) {
                        index_module_LOG.error("Status ".concat(xhr.status, ", will not retry."));
                        removeEventsFromQueue(numberToSend);
                    }
                    onRequestFailure === null || onRequestFailure === void 0 ? void 0 : onRequestFailure({
                        status: xhr.status,
                        message: xhr.statusText,
                        events: batch,
                        willRetry: willRetry
                    });
                    executingQueue = false;
                }
            }
        };
        // Time out POST requests after connectionTimeout
        var xhrTimeout = setTimeout(function () {
            xhr.abort();
            if (!retryFailedRequests) {
                removeEventsFromQueue(numberToSend);
            }
            onRequestFailure === null || onRequestFailure === void 0 ? void 0 : onRequestFailure({
                status: 0,
                message: 'timeout',
                events: batch,
                willRetry: retryFailedRequests
            });
            executingQueue = false;
        }, connectionTimeout);
    }
    /*
     * Queue for submission to the collector and start processing queue
     */
    function enqueueRequest(request, url) {
        configCollectorUrl = url + path;
        var eventTooBigWarning = function (bytes, maxBytes) {
            return index_module_LOG.warn('Event (' + bytes + 'B) too big, max is ' + maxBytes);
        };
        if (usePost) {
            var body = getBody(request);
            if (body.bytes >= maxPostBytes) {
                eventTooBigWarning(body.bytes, maxPostBytes);
                sendPostRequestWithoutQueueing(body, configCollectorUrl);
                return;
            }
            else {
                outQueue.push(body);
            }
        }
        else {
            var querystring = getQuerystring(request);
            if (maxGetBytes > 0) {
                var requestUrl = createGetUrl(querystring);
                var bytes = getUTF8Length(requestUrl);
                if (bytes >= maxGetBytes) {
                    eventTooBigWarning(bytes, maxGetBytes);
                    if (useXhr) {
                        var body = getBody(request);
                        var postUrl = url + postPath;
                        sendPostRequestWithoutQueueing(body, postUrl);
                    }
                    return;
                }
            }
            outQueue.push(querystring);
        }
        var savedToLocalStorage = false;
        if (useLocalStorage) {
            savedToLocalStorage = attemptWriteLocalStorage(queueName, JSON.stringify(outQueue.slice(0, maxLocalStorageQueueSize)));
        }
        // If we're not processing the queue, we'll start.
        if (!executingQueue && (!savedToLocalStorage || outQueue.length >= bufferSize)) {
            executeQueue();
        }
    }
    /*
     * Run through the queue of requests, sending them one at a time.
     * Stops processing when we run out of queued requests, or we get an error.
     */
    function executeQueue(sync) {
        if (sync === void 0) { sync = false; }
        // Failsafe in case there is some way for a bad value like "null" to end up in the outQueue
        while (outQueue.length && typeof outQueue[0] !== 'string' && typeof outQueue[0] !== 'object') {
            outQueue.shift();
        }
        if (!outQueue.length) {
            executingQueue = false;
            return;
        }
        // Let's check that we have a URL
        if (!isString(configCollectorUrl)) {
            throw 'No collector configured';
        }
        executingQueue = true;
        if (idService && !idServiceCalled) {
            var xhr_1 = initializeXMLHttpRequest(idService, false, sync);
            idServiceCalled = true;
            xhr_1.timeout = connectionTimeout;
            xhr_1.onreadystatechange = function () {
                if (xhr_1.readyState === 4) {
                    executeQueue();
                }
            };
            xhr_1.send();
            return;
        }
        if (useXhr) {
            // Keep track of number of events to delete from queue
            var chooseHowManyToSend = function (queue) {
                var numberToSend = 0, byteCount = 0;
                while (numberToSend < queue.length) {
                    byteCount += queue[numberToSend].bytes;
                    if (byteCount >= maxPostBytes) {
                        break;
                    }
                    else {
                        numberToSend += 1;
                    }
                }
                return numberToSend;
            };
            var url = void 0, xhr = void 0, numberToSend = void 0;
            if (postable(outQueue)) {
                url = configCollectorUrl;
                xhr = initializeXMLHttpRequest(url, true, sync);
                numberToSend = chooseHowManyToSend(outQueue);
            }
            else {
                url = createGetUrl(outQueue[0]);
                xhr = initializeXMLHttpRequest(url, false, sync);
                numberToSend = 1;
            }
            if (!postable(outQueue)) {
                // If not postable then it's a GET so just send it
                setXhrCallbacks(xhr, numberToSend, [url]);
                xhr.send();
            }
            else {
                var batch = outQueue.slice(0, numberToSend);
                if (batch.length > 0) {
                    var beaconStatus = false;
                    var eventBatch = batch.map(function (x) {
                        return x.evt;
                    });
                    if (useBeacon) {
                        var blob = new Blob([encloseInPayloadDataEnvelope(attachStmToEvent(eventBatch))], {
                            type: 'application/json'
                        });
                        try {
                            beaconStatus = window.navigator.sendBeacon(url, blob);
                        }
                        catch (error) {
                            beaconStatus = false;
                        }
                    }
                    // When beaconStatus is true, we can't _guarantee_ that it was successful (beacon queues asynchronously)
                    // but the browser has taken it out of our hands, so we want to flush the queue assuming it will do its job
                    if (beaconStatus === true) {
                        removeEventsFromQueue(numberToSend);
                        onRequestSuccess === null || onRequestSuccess === void 0 ? void 0 : onRequestSuccess(batch);
                        executeQueue();
                    }
                    else {
                        var batch_1 = attachStmToEvent(eventBatch);
                        setXhrCallbacks(xhr, numberToSend, batch_1);
                        xhr.send(encloseInPayloadDataEnvelope(batch_1));
                    }
                }
            }
        }
        else if (!anonymousTracking && !postable(outQueue)) {
            // We can't send with this technique if anonymous tracking is on as we can't attach the header
            var image = new Image(1, 1), loading_1 = true;
            image.onload = function () {
                if (!loading_1)
                    return;
                loading_1 = false;
                outQueue.shift();
                if (useLocalStorage) {
                    attemptWriteLocalStorage(queueName, JSON.stringify(outQueue.slice(0, maxLocalStorageQueueSize)));
                }
                executeQueue();
            };
            image.onerror = function () {
                if (!loading_1)
                    return;
                loading_1 = false;
                executingQueue = false;
            };
            image.src = createGetUrl(outQueue[0]);
            setTimeout(function () {
                if (loading_1 && executingQueue) {
                    loading_1 = false;
                    executeQueue();
                }
            }, connectionTimeout);
        }
        else {
            executingQueue = false;
        }
    }
    /**
     * Determines whether a request was successful, based on its status code
     * Anything in the 2xx range is considered successful
     *
     * @param statusCode The status code of the request
     * @returns Whether the request was successful
     */
    function isSuccessfulRequest(statusCode) {
        return statusCode >= 200 && statusCode < 300;
    }
    function shouldRetryForStatusCode(statusCode) {
        // success, don't retry
        if (isSuccessfulRequest(statusCode)) {
            return false;
        }
        if (!retryFailedRequests) {
            return false;
        }
        // retry if status code among custom user-supplied retry codes
        if (retryStatusCodes.includes(statusCode)) {
            return true;
        }
        // retry if status code *not* among the don't retry codes
        return !dontRetryStatusCodes.includes(statusCode);
    }
    /**
     * Open an XMLHttpRequest for a given endpoint with the correct credentials and header
     *
     * @param string - url The destination URL
     * @returns object The XMLHttpRequest
     */
    function initializeXMLHttpRequest(url, post, sync) {
        var xhr = new XMLHttpRequest();
        if (post) {
            xhr.open('POST', url, !sync);
            xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        }
        else {
            xhr.open('GET', url, !sync);
        }
        xhr.withCredentials = withCredentials;
        if (anonymousTracking) {
            xhr.setRequestHeader('SP-Anonymous', '*');
        }
        for (var header in customHeaders) {
            if (Object.prototype.hasOwnProperty.call(customHeaders, header)) {
                xhr.setRequestHeader(header, customHeaders[header]);
            }
        }
        return xhr;
    }
    /**
     * Enclose an array of events in a self-describing payload_data JSON string
     *
     * @param array - events Batch of events
     * @returns string payload_data self-describing JSON
     */
    function encloseInPayloadDataEnvelope(events) {
        return JSON.stringify({
            schema: PAYLOAD_DATA_SCHEMA,
            data: events
        });
    }
    /**
     * Attaches the STM field to outbound POST events.
     *
     * @param events - the events to attach the STM to
     */
    function attachStmToEvent(events) {
        var stm = new Date().getTime().toString();
        for (var i = 0; i < events.length; i++) {
            events[i]['stm'] = stm;
        }
        return events;
    }
    /**
     * Creates the full URL for sending the GET request. Will append `stm` if enabled
     *
     * @param nextRequest - the query string of the next request
     */
    function createGetUrl(nextRequest) {
        if (useStm) {
            return configCollectorUrl + nextRequest.replace('?', '?stm=' + new Date().getTime() + '&');
        }
        return configCollectorUrl + nextRequest;
    }
    return {
        enqueueRequest: enqueueRequest,
        executeQueue: function () {
            if (!executingQueue) {
                executeQueue();
            }
        },
        setUseLocalStorage: function (localStorage) {
            useLocalStorage = localStorage;
        },
        setAnonymousTracking: function (anonymous) {
            anonymousTracking = anonymous;
        },
        setCollectorUrl: function (url) {
            configCollectorUrl = url + path;
        },
        setBufferSize: function (newBufferSize) {
            bufferSize = newBufferSize;
        }
    };
    function hasWebKitBeaconBug(useragent) {
        return (isIosVersionLessThanOrEqualTo(13, useragent) ||
            (isMacosxVersionLessThanOrEqualTo(10, 15, useragent) && isSafari(useragent)));
        function isIosVersionLessThanOrEqualTo(major, useragent) {
            var match = useragent.match('(iP.+; CPU .*OS (d+)[_d]*.*) AppleWebKit/');
            if (match && match.length) {
                return parseInt(match[0]) <= major;
            }
            return false;
        }
        function isMacosxVersionLessThanOrEqualTo(major, minor, useragent) {
            var match = useragent.match('(Macintosh;.*Mac OS X (d+)_(d+)[_d]*.*) AppleWebKit/');
            if (match && match.length) {
                return parseInt(match[0]) <= major || (parseInt(match[0]) === major && parseInt(match[1]) <= minor);
            }
            return false;
        }
        function isSafari(useragent) {
            return useragent.match('Version/.* Safari/') && !isChromiumBased(useragent);
        }
        function isChromiumBased(useragent) {
            return useragent.match('Chrom(e|ium)');
        }
    }
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/*
 * Extract parameter from URL
 */
function getParameter(url, name) {
    // scheme : // [username [: password] @] hostname [: port] [/ [path] [? query] [# fragment]]
    var e = new RegExp('^(?:https?|ftp)(?::/*(?:[^?]+))([?][^#]+)'), matches = e.exec(url);
    if (matches && (matches === null || matches === void 0 ? void 0 : matches.length) > 1) {
        return fromQuerystring(name, matches[1]);
    }
    return null;
}
/*
 * Fix-up URL when page rendered from search engine cache or translated page.
 */
function fixupUrl(hostName, href, referrer) {
    var _a;
    if (hostName === 'translate.googleusercontent.com') {
        // Google
        if (referrer === '') {
            referrer = href;
        }
        href = (_a = getParameter(href, 'u')) !== null && _a !== void 0 ? _a : '';
        hostName = getHostName(href);
    }
    else if (hostName === 'cc.bingj.com' || // Bing & Yahoo
        hostName === 'webcache.googleusercontent.com' // Google
    ) {
        href = document.links[0].href;
        hostName = getHostName(href);
    }
    return [hostName, href, referrer];
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Indices of cookie values
 */
var cookieDisabledIndex = 0, domainUserIdIndex = 1, createTsIndex = 2, visitCountIndex = 3, nowTsIndex = 4, lastVisitTsIndex = 5, sessionIdIndex = 6, previousSessionIdIndex = 7, firstEventIdIndex = 8, firstEventTsInMsIndex = 9, eventIndexIndex = 10;
function emptyIdCookie() {
    var idCookie = ['1', '', 0, 0, 0, undefined, '', '', '', undefined, 0];
    return idCookie;
}
/**
 * Parses the cookie values from its string representation.
 *
 * @param id Cookie value as string
 * @param domainUserId Domain user ID to be used in case of empty cookie string
 * @returns Parsed ID cookie tuple
 */
function parseIdCookie(id, domainUserId, memorizedSessionId, memorizedVisitCount) {
    var now = new Date(), nowTs = Math.round(now.getTime() / 1000), tmpContainer;
    if (id) {
        tmpContainer = id.split('.');
        // cookies enabled
        tmpContainer.unshift('0');
    }
    else {
        tmpContainer = [
            // cookies disabled
            '1',
            // Domain user ID
            domainUserId,
            // Creation timestamp - seconds since Unix epoch
            nowTs,
            // visitCount - 0 = no previous visit
            memorizedVisitCount,
            // Current visit timestamp
            nowTs,
            // Last visit timestamp - blank meaning no previous visit
            '',
            // Session ID
            memorizedSessionId,
        ];
    }
    if (!tmpContainer[sessionIdIndex] || tmpContainer[sessionIdIndex] === 'undefined') {
        // session id
        tmpContainer[sessionIdIndex] = (0,node_modules_uuid.v4)();
    }
    if (!tmpContainer[previousSessionIdIndex] || tmpContainer[previousSessionIdIndex] === 'undefined') {
        // previous session id
        tmpContainer[previousSessionIdIndex] = '';
    }
    if (!tmpContainer[firstEventIdIndex] || tmpContainer[firstEventIdIndex] === 'undefined') {
        // firstEventId - blank meaning no previous event
        tmpContainer[firstEventIdIndex] = '';
    }
    if (!tmpContainer[firstEventTsInMsIndex] || tmpContainer[firstEventTsInMsIndex] === 'undefined') {
        // firstEventTs - blank meaning no previous event
        tmpContainer[firstEventTsInMsIndex] = '';
    }
    if (!tmpContainer[eventIndexIndex] || tmpContainer[eventIndexIndex] === 'undefined') {
        // eventIndex – 0 = no previous event
        tmpContainer[eventIndexIndex] = 0;
    }
    var parseIntOr = function (value, defaultValue) {
        var parsed = parseInt(value);
        return isNaN(parsed) ? defaultValue : parsed;
    };
    var parseIntOrUndefined = function (value) { return (value ? parseIntOr(value, undefined) : undefined); };
    var parsed = [
        tmpContainer[cookieDisabledIndex],
        tmpContainer[domainUserIdIndex],
        parseIntOr(tmpContainer[createTsIndex], nowTs),
        parseIntOr(tmpContainer[visitCountIndex], memorizedVisitCount),
        parseIntOr(tmpContainer[nowTsIndex], nowTs),
        parseIntOrUndefined(tmpContainer[lastVisitTsIndex]),
        tmpContainer[sessionIdIndex],
        tmpContainer[previousSessionIdIndex],
        tmpContainer[firstEventIdIndex],
        parseIntOrUndefined(tmpContainer[firstEventTsInMsIndex]),
        parseIntOr(tmpContainer[eventIndexIndex], 0),
    ];
    return parsed;
}
/**
 * Initializes the domain user ID if not already present in the cookie. Sets an empty string if anonymous tracking.
 *
 * @param idCookie Parsed cookie
 * @param configAnonymousTracking Whether anonymous tracking is enabled
 * @returns Domain user ID
 */
function initializeDomainUserId(idCookie, configAnonymousTracking) {
    var domainUserId;
    if (idCookie[domainUserIdIndex]) {
        domainUserId = idCookie[domainUserIdIndex];
    }
    else if (!configAnonymousTracking) {
        domainUserId = (0,node_modules_uuid.v4)();
        idCookie[domainUserIdIndex] = domainUserId;
    }
    else {
        domainUserId = '';
        idCookie[domainUserIdIndex] = domainUserId;
    }
    return domainUserId;
}
/**
 * Starts a new session with a new ID.
 * Sets the previous session, last visit timestamp, and increments visit count if cookies enabled.
 * First event references are reset and will be updated in `updateFirstEventInIdCookie`.
 *
 * @param idCookie Parsed cookie
 * @param options.configStateStorageStrategy Cookie storage strategy
 * @param options.configAnonymousTracking If anonymous tracking is enabled
 * @param options.memorizedVisitCount Visit count to be used if cookies not enabled
 * @param options.onSessionUpdateCallback Session callback triggered on every session update
 * @returns New session ID
 */
function startNewIdCookieSession(idCookie, options) {
    if (options === void 0) { options = { memorizedVisitCount: 1 }; }
    var memorizedVisitCount = options.memorizedVisitCount;
    // If cookies are enabled, base visit count and session ID on the cookies
    if (cookiesEnabledInIdCookie(idCookie)) {
        // Store the previous session ID
        idCookie[previousSessionIdIndex] = idCookie[sessionIdIndex];
        // Set lastVisitTs to currentVisitTs
        idCookie[lastVisitTsIndex] = idCookie[nowTsIndex];
        // Increment the session ID
        idCookie[visitCountIndex]++;
    }
    else {
        idCookie[visitCountIndex] = memorizedVisitCount;
    }
    // Create a new sessionId
    var sessionId = (0,node_modules_uuid.v4)();
    idCookie[sessionIdIndex] = sessionId;
    // Reset event index and first event references
    idCookie[eventIndexIndex] = 0;
    idCookie[firstEventIdIndex] = '';
    idCookie[firstEventTsInMsIndex] = undefined;
    return sessionId;
}
/**
 * Update now timestamp in cookie.
 *
 * @param idCookie Parsed cookie
 */
function updateNowTsInIdCookie(idCookie) {
    idCookie[nowTsIndex] = Math.round(new Date().getTime() / 1000);
}
/**
 * Updates the first event references according to the event payload if first event in session.
 *
 * @param idCookie Parsed cookie
 * @param payloadBuilder Event payload builder
 */
function updateFirstEventInIdCookie(idCookie, payloadBuilder) {
    // Update first event references if new session or not present
    if (idCookie[eventIndexIndex] === 0) {
        var payload = payloadBuilder.build();
        idCookie[firstEventIdIndex] = payload['eid'];
        var ts = (payload['dtm'] || payload['ttm']);
        idCookie[firstEventTsInMsIndex] = ts ? parseInt(ts) : undefined;
    }
}
/**
 * Increments event index counter.
 *
 * @param idCookie Parsed cookie
 */
function incrementEventIndexInIdCookie(idCookie) {
    idCookie[eventIndexIndex] += 1;
}
/**
 * Serializes parsed cookie to string representation.
 *
 * @param idCookie Parsed cookie
 * @returns String cookie value
 */
function serializeIdCookie(idCookie, configAnonymousTracking) {
    var anonymizedIdCookie = tslib_es6_spreadArray([], idCookie, true);
    if (configAnonymousTracking) {
        anonymizedIdCookie[domainUserIdIndex] = '';
        anonymizedIdCookie[previousSessionIdIndex] = '';
    }
    anonymizedIdCookie.shift();
    return anonymizedIdCookie.join('.');
}
/**
 * Transforms the parsed cookie into a client session context entity.
 *
 * @param idCookie Parsed cookie
 * @param configStateStorageStrategy Cookie storage strategy
 * @param configAnonymousTracking If anonymous tracking is enabled
 * @returns Client session context entity
 */
function clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking) {
    var firstEventTsInMs = idCookie[firstEventTsInMsIndex];
    var clientSession = {
        userId: configAnonymousTracking
            ? '00000000-0000-0000-0000-000000000000' // TODO: use uuid.NIL when we upgrade to uuid v8.3
            : idCookie[domainUserIdIndex],
        sessionId: idCookie[sessionIdIndex],
        eventIndex: idCookie[eventIndexIndex],
        sessionIndex: idCookie[visitCountIndex],
        previousSessionId: configAnonymousTracking ? null : idCookie[previousSessionIdIndex] || null,
        storageMechanism: configStateStorageStrategy == 'localStorage' ? 'LOCAL_STORAGE' : 'COOKIE_1',
        firstEventId: idCookie[firstEventIdIndex] || null,
        firstEventTimestamp: firstEventTsInMs ? new Date(firstEventTsInMs).toISOString() : null
    };
    return clientSession;
}
function sessionIdFromIdCookie(idCookie) {
    return idCookie[sessionIdIndex];
}
function domainUserIdFromIdCookie(idCookie) {
    return idCookie[domainUserIdIndex];
}
function visitCountFromIdCookie(idCookie) {
    return idCookie[visitCountIndex];
}
function cookiesEnabledInIdCookie(idCookie) {
    return idCookie[cookieDisabledIndex] === '0';
}
function eventIndexFromIdCookie(idCookie) {
    return idCookie[eventIndexIndex];
}

/* Separator used for dimension values e.g. widthxheight */
var DIMENSION_SEPARATOR = 'x';
function getBrowserProperties() {
    return {
        viewport: floorDimensionFields(detectViewport()),
        documentSize: floorDimensionFields(detectDocumentSize()),
        resolution: floorDimensionFields(detectScreenResolution()),
        colorDepth: screen.colorDepth,
        devicePixelRatio: window.devicePixelRatio,
        cookiesEnabled: window.navigator.cookieEnabled,
        online: window.navigator.onLine,
        browserLanguage: window.navigator.language || window.navigator.userLanguage,
        documentLanguage: document.documentElement.lang,
        webdriver: window.navigator.webdriver,
        deviceMemory: window.navigator.deviceMemory,
        hardwareConcurrency: window.navigator.hardwareConcurrency
    };
}
/**
 * Gets the current viewport.
 *
 * Code based on:
 * - http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
 * - http://responsejs.com/labs/dimensions/
 */
function detectViewport() {
    var width, height;
    if ('innerWidth' in window) {
        width = window['innerWidth'];
        height = window['innerHeight'];
    }
    else {
        var e = document.documentElement || document.body;
        width = e['clientWidth'];
        height = e['clientHeight'];
    }
    if (width >= 0 && height >= 0) {
        return width + DIMENSION_SEPARATOR + height;
    }
    else {
        return null;
    }
}
/**
 * Gets the dimensions of the current
 * document.
 *
 * Code based on:
 * - http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
 */
function detectDocumentSize() {
    var de = document.documentElement, // Alias
    be = document.body, 
    // document.body may not have rendered, so check whether be.offsetHeight is null
    bodyHeight = be ? Math.max(be.offsetHeight, be.scrollHeight) : 0;
    var w = Math.max(de.clientWidth, de.offsetWidth, de.scrollWidth);
    var h = Math.max(de.clientHeight, de.offsetHeight, de.scrollHeight, bodyHeight);
    return isNaN(w) || isNaN(h) ? '' : w + DIMENSION_SEPARATOR + h;
}
function detectScreenResolution() {
    return screen.width + DIMENSION_SEPARATOR + screen.height;
}
function floorDimensionFields(field) {
    return (field &&
        field
            .split(DIMENSION_SEPARATOR)
            .map(function (dimension) { return Math.floor(Number(dimension)); })
            .join(DIMENSION_SEPARATOR));
}

/**
 * The Snowplow Tracker
 *
 * @param trackerId - The unique identifier of the tracker
 * @param namespace - The namespace of the tracker object
 * @param version - The current version of the JavaScript Tracker
 * @param endpoint - The collector endpoint to send events to, with or without protocol
 * @param sharedState - An object containing state which is shared across tracker instances
 * @param trackerConfiguration - Dictionary of configuration options
 */
function Tracker(trackerId, namespace, version, endpoint, sharedState, trackerConfiguration) {
    if (trackerConfiguration === void 0) { trackerConfiguration = {}; }
    var browserPlugins = [];
    var newTracker = function (trackerId, namespace, version, endpoint, state, trackerConfiguration) {
        /************************************************************
         * Private members
         ************************************************************/
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
        //use POST if eventMethod isn't present on the newTrackerConfiguration
        trackerConfiguration.eventMethod = (_a = trackerConfiguration.eventMethod) !== null && _a !== void 0 ? _a : 'post';
        var getStateStorageStrategy = function (config) { var _a; return (_a = config.stateStorageStrategy) !== null && _a !== void 0 ? _a : 'cookieAndLocalStorage'; }, getAnonymousSessionTracking = function (config) {
            var _a, _b;
            if (typeof config.anonymousTracking === 'boolean') {
                return false;
            }
            return (_b = ((_a = config.anonymousTracking) === null || _a === void 0 ? void 0 : _a.withSessionTracking) === true) !== null && _b !== void 0 ? _b : false;
        }, getAnonymousServerTracking = function (config) {
            var _a, _b;
            if (typeof config.anonymousTracking === 'boolean') {
                return false;
            }
            return (_b = ((_a = config.anonymousTracking) === null || _a === void 0 ? void 0 : _a.withServerAnonymisation) === true) !== null && _b !== void 0 ? _b : false;
        }, getAnonymousTracking = function (config) { return !!config.anonymousTracking; }, isBrowserContextAvailable = (_c = (_b = trackerConfiguration === null || trackerConfiguration === void 0 ? void 0 : trackerConfiguration.contexts) === null || _b === void 0 ? void 0 : _b.browser) !== null && _c !== void 0 ? _c : false, isWebPageContextAvailable = (_e = (_d = trackerConfiguration === null || trackerConfiguration === void 0 ? void 0 : trackerConfiguration.contexts) === null || _d === void 0 ? void 0 : _d.webPage) !== null && _e !== void 0 ? _e : true, getExtendedCrossDomainTrackingConfiguration = function (crossDomainTrackingConfig) {
            if (typeof crossDomainTrackingConfig === 'boolean') {
                return { useExtendedCrossDomainLinker: crossDomainTrackingConfig };
            }
            return {
                useExtendedCrossDomainLinker: true,
                collectCrossDomainAttributes: crossDomainTrackingConfig
            };
        };
        // Get all injected plugins
        browserPlugins.push(getBrowserDataPlugin());
        /* When including the Web Page context, we add the relevant internal plugins */
        if (isWebPageContextAvailable) {
            browserPlugins.push(getWebPagePlugin());
        }
        if (isBrowserContextAvailable) {
            browserPlugins.push(getBrowserContextPlugin());
        }
        browserPlugins.push.apply(browserPlugins, ((_f = trackerConfiguration.plugins) !== null && _f !== void 0 ? _f : []));
        var // Tracker core
        core = trackerCore({
            base64: trackerConfiguration.encodeBase64,
            corePlugins: browserPlugins,
            callback: sendRequest
        }), 
        // Aliases
        documentCharset = document.characterSet || document.charset, 
        // Current URL and Referrer URL
        locationArray = fixupUrl(window.location.hostname, window.location.href, getReferrer()), domainAlias = fixupDomain(locationArray[0]), locationHrefAlias = locationArray[1], configReferrerUrl = locationArray[2], customReferrer, 
        // Platform defaults to web for this tracker
        configPlatform = (_g = trackerConfiguration.platform) !== null && _g !== void 0 ? _g : 'web', 
        // Snowplow collector URL
        configCollectorUrl = asCollectorUrl(endpoint), 
        // Custom path for post requests (to get around adblockers)
        configPostPath = (_h = trackerConfiguration.postPath) !== null && _h !== void 0 ? _h : '/com.snowplowanalytics.snowplow/tp2', 
        // Site ID
        configTrackerSiteId = (_j = trackerConfiguration.appId) !== null && _j !== void 0 ? _j : '', 
        // Document URL
        configCustomUrl, 
        // Document title
        lastDocumentTitle = document.title, 
        // Custom title
        lastConfigTitle, 
        // Controls whether activity tracking page ping event timers are reset on page view events
        resetActivityTrackingOnPageView = (_k = trackerConfiguration.resetActivityTrackingOnPageView) !== null && _k !== void 0 ? _k : true, 
        // Disallow hash tags in URL. TODO: Should this be set to true by default?
        configDiscardHashTag, 
        // Disallow brace in URL.
        configDiscardBrace, 
        // First-party cookie name prefix
        configCookieNamePrefix = (_l = trackerConfiguration.cookieName) !== null && _l !== void 0 ? _l : '_sp_', 
        // First-party cookie domain
        // User agent defaults to origin hostname
        configCookieDomain = (_m = trackerConfiguration.cookieDomain) !== null && _m !== void 0 ? _m : undefined, 
        // First-party cookie path
        // Default is user agent defined.
        configCookiePath = '/', 
        // First-party cookie samesite attribute
        configCookieSameSite = (_o = trackerConfiguration.cookieSameSite) !== null && _o !== void 0 ? _o : 'None', 
        // First-party cookie secure attribute
        configCookieSecure = (_p = trackerConfiguration.cookieSecure) !== null && _p !== void 0 ? _p : true, 
        // Do Not Track browser feature
        dnt = window.navigator.doNotTrack || window.navigator.msDoNotTrack || window.doNotTrack, 
        // Do Not Track
        configDoNotTrack = typeof trackerConfiguration.respectDoNotTrack !== 'undefined'
            ? trackerConfiguration.respectDoNotTrack && (dnt === 'yes' || dnt === '1')
            : false, 
        // Opt out of cookie tracking
        configOptOutCookie, 
        // Life of the visitor cookie (in seconds)
        configVisitorCookieTimeout = (_q = trackerConfiguration.cookieLifetime) !== null && _q !== void 0 ? _q : 63072000, // 2 years
        // Life of the session cookie (in seconds)
        configSessionCookieTimeout = (_r = trackerConfiguration.sessionCookieTimeout) !== null && _r !== void 0 ? _r : 1800, // 30 minutes
        // Allows tracking user session (using cookies or local storage), can only be used with anonymousTracking
        configAnonymousSessionTracking = getAnonymousSessionTracking(trackerConfiguration), 
        // Will send a header to server to prevent returning cookie and capturing IP
        configAnonymousServerTracking = getAnonymousServerTracking(trackerConfiguration), 
        // Sets tracker to work in anonymous mode without accessing client storage
        configAnonymousTracking = getAnonymousTracking(trackerConfiguration), 
        // Strategy defining how to store the state: cookie, localStorage, cookieAndLocalStorage or none
        configStateStorageStrategy = getStateStorageStrategy(trackerConfiguration), 
        // Last activity timestamp
        lastActivityTime, 
        // The last time an event was fired on the page - used to invalidate session if cookies are disabled
        lastEventTime = new Date().getTime(), 
        // How are we scrolling?
        minXOffset, maxXOffset, minYOffset, maxYOffset, 
        // Domain hash value
        domainHash, 
        // Domain unique user ID
        domainUserId, 
        // ID for the current session
        memorizedSessionId, 
        // Index for the current session - kept in memory in case cookies are disabled
        memorizedVisitCount = 1, 
        // Business-defined unique user ID
        businessUserId, 
        // Manager for local storage queue
        outQueue = OutQueueManager(trackerId, state, configStateStorageStrategy == 'localStorage' || configStateStorageStrategy == 'cookieAndLocalStorage', trackerConfiguration.eventMethod, configPostPath, (_s = trackerConfiguration.bufferSize) !== null && _s !== void 0 ? _s : 1, (_t = trackerConfiguration.maxPostBytes) !== null && _t !== void 0 ? _t : 40000, (_u = trackerConfiguration.maxGetBytes) !== null && _u !== void 0 ? _u : 0, (_v = trackerConfiguration.useStm) !== null && _v !== void 0 ? _v : true, (_w = trackerConfiguration.maxLocalStorageQueueSize) !== null && _w !== void 0 ? _w : 1000, (_x = trackerConfiguration.connectionTimeout) !== null && _x !== void 0 ? _x : 5000, configAnonymousServerTracking, (_y = trackerConfiguration.customHeaders) !== null && _y !== void 0 ? _y : {}, (_z = trackerConfiguration.withCredentials) !== null && _z !== void 0 ? _z : true, (_0 = trackerConfiguration.retryStatusCodes) !== null && _0 !== void 0 ? _0 : [], ((_1 = trackerConfiguration.dontRetryStatusCodes) !== null && _1 !== void 0 ? _1 : []).concat([400, 401, 403, 410, 422]), trackerConfiguration.idService, trackerConfiguration.retryFailedRequests, trackerConfiguration.onRequestSuccess, trackerConfiguration.onRequestFailure), 
        // Whether pageViewId should be regenerated after each trackPageView. Affect web_page context
        preservePageViewId = false, 
        // Whether first trackPageView was fired and pageViewId should not be changed anymore until reload
        pageViewSent = false, 
        // Activity tracking config for callback and page ping variants
        activityTrackingConfig = {
            enabled: false,
            installed: false,
            configurations: {}
        }, configSessionContext = (_3 = (_2 = trackerConfiguration.contexts) === null || _2 === void 0 ? void 0 : _2.session) !== null && _3 !== void 0 ? _3 : false, toOptoutByCookie, onSessionUpdateCallback = trackerConfiguration.onSessionUpdateCallback, manualSessionUpdateCalled = false, _4 = getExtendedCrossDomainTrackingConfiguration(trackerConfiguration.useExtendedCrossDomainLinker || false), useExtendedCrossDomainLinker = _4.useExtendedCrossDomainLinker, collectCrossDomainAttributes = _4.collectCrossDomainAttributes;
        if (trackerConfiguration.hasOwnProperty('discoverRootDomain') && trackerConfiguration.discoverRootDomain) {
            configCookieDomain = findRootDomain(configCookieSameSite, configCookieSecure);
        }
        var _5 = getBrowserProperties(), browserLanguage = _5.browserLanguage, resolution = _5.resolution, colorDepth = _5.colorDepth, cookiesEnabled = _5.cookiesEnabled;
        // Set up unchanging name-value pairs
        core.setTrackerVersion(version);
        core.setTrackerNamespace(namespace);
        core.setAppId(configTrackerSiteId);
        core.setPlatform(configPlatform);
        core.addPayloadPair('cookie', cookiesEnabled ? '1' : '0');
        core.addPayloadPair('cs', documentCharset);
        core.addPayloadPair('lang', browserLanguage);
        core.addPayloadPair('res', resolution);
        core.addPayloadPair('cd', colorDepth);
        /*
         * Initialize tracker
         */
        updateDomainHash();
        initializeIdsAndCookies();
        if (trackerConfiguration.crossDomainLinker) {
            decorateLinks(trackerConfiguration.crossDomainLinker);
        }
        /**
         * Recalculate the domain, URL, and referrer
         */
        function refreshUrl() {
            locationArray = fixupUrl(window.location.hostname, window.location.href, getReferrer());
            // If this is a single-page app and the page URL has changed, then:
            //   - if the new URL's querystring contains a "refer(r)er" parameter, use it as the referrer
            //   - otherwise use the old URL as the referer
            if (locationArray[1] !== locationHrefAlias) {
                configReferrerUrl = getReferrer(locationHrefAlias);
            }
            domainAlias = fixupDomain(locationArray[0]);
            locationHrefAlias = locationArray[1];
        }
        /**
         * Create link handler to decorate the querystring of a link (onClick/onMouseDown)
         *
         * @param event - e The event targeting the link
         */
        function addLinkDecorationHandler(extended) {
            var CROSS_DOMAIN_PARAMETER_NAME = '_sp';
            return function (evt) {
                var elt = evt.currentTarget;
                var crossDomainParameterValue = createCrossDomainParameterValue(extended, collectCrossDomainAttributes, {
                    domainUserId: domainUserId,
                    userId: businessUserId || undefined,
                    sessionId: memorizedSessionId,
                    sourceId: configTrackerSiteId,
                    sourcePlatform: configPlatform,
                    event: evt
                });
                if (elt === null || elt === void 0 ? void 0 : elt.href) {
                    elt.href = decorateQuerystring(elt.href, CROSS_DOMAIN_PARAMETER_NAME, crossDomainParameterValue);
                }
            };
        }
        /**
         * Enable querystring decoration for links passing a filter
         * Whenever such a link is clicked on or navigated to via the keyboard,
         * add "_sp={{duid}}.{{timestamp}}" to its querystring
         *
         * @param crossDomainLinker - Function used to determine which links to decorate
         */
        function decorateLinks(crossDomainLinker) {
            var crossDomainLinkHandler = addLinkDecorationHandler(useExtendedCrossDomainLinker);
            for (var i = 0; i < document.links.length; i++) {
                var elt = document.links[i];
                if (!elt.spDecorationEnabled && crossDomainLinker(elt)) {
                    elt.addEventListener('click', crossDomainLinkHandler, true);
                    elt.addEventListener('mousedown', crossDomainLinkHandler, true);
                    // Don't add event listeners more than once
                    elt.spDecorationEnabled = true;
                }
            }
        }
        /*
         * Removes hash tag from the URL
         *
         * URLs are purified before being recorded in the cookie,
         * or before being sent as GET parameters
         */
        function purify(url) {
            var targetPattern;
            if (configDiscardHashTag) {
                targetPattern = new RegExp('#.*');
                url = url.replace(targetPattern, '');
            }
            if (configDiscardBrace) {
                targetPattern = new RegExp('[{}]', 'g');
                url = url.replace(targetPattern, '');
            }
            return url;
        }
        /*
         * Extract scheme/protocol from URL
         */
        function getProtocolScheme(url) {
            var e = new RegExp('^([a-z]+):'), matches = e.exec(url);
            return matches ? matches[1] : null;
        }
        /*
         * Resolve relative reference
         *
         * Note: not as described in rfc3986 section 5.2
         */
        function resolveRelativeReference(baseUrl, url) {
            var protocol = getProtocolScheme(url), i;
            if (protocol) {
                return url;
            }
            if (url.slice(0, 1) === '/') {
                return getProtocolScheme(baseUrl) + '://' + getHostName(baseUrl) + url;
            }
            baseUrl = purify(baseUrl);
            if ((i = baseUrl.indexOf('?')) >= 0) {
                baseUrl = baseUrl.slice(0, i);
            }
            if ((i = baseUrl.lastIndexOf('/')) !== baseUrl.length - 1) {
                baseUrl = baseUrl.slice(0, i + 1);
            }
            return baseUrl + url;
        }
        /*
         * Send request
         */
        function sendRequest(request) {
            if (!(configDoNotTrack || toOptoutByCookie)) {
                outQueue.enqueueRequest(request.build(), configCollectorUrl);
            }
        }
        /*
         * Get cookie name with prefix and domain hash
         */
        function getSnowplowCookieName(baseName) {
            return configCookieNamePrefix + baseName + '.' + domainHash;
        }
        /*
         * Cookie getter.
         */
        function getSnowplowCookieValue(cookieName) {
            var fullName = getSnowplowCookieName(cookieName);
            if (configStateStorageStrategy == 'localStorage') {
                return attemptGetLocalStorage(fullName);
            }
            else if (configStateStorageStrategy == 'cookie' || configStateStorageStrategy == 'cookieAndLocalStorage') {
                return cookie(fullName);
            }
            return undefined;
        }
        /*
         * Update domain hash
         */
        function updateDomainHash() {
            refreshUrl();
            domainHash = sha1_default()((configCookieDomain || domainAlias) + (configCookiePath || '/')).slice(0, 4); // 4 hexits = 16 bits
        }
        /*
         * Process all "activity" events.
         * For performance, this function must have low overhead.
         */
        function activityHandler() {
            var now = new Date();
            lastActivityTime = now.getTime();
        }
        /*
         * Process all "scroll" events.
         */
        function scrollHandler() {
            updateMaxScrolls();
            activityHandler();
        }
        /*
         * Returns [pageXOffset, pageYOffset]
         */
        function getPageOffsets() {
            var documentElement = document.documentElement;
            if (documentElement) {
                return [documentElement.scrollLeft || window.pageXOffset, documentElement.scrollTop || window.pageYOffset];
            }
            return [0, 0];
        }
        /*
         * Quick initialization/reset of max scroll levels
         */
        function resetMaxScrolls() {
            var offsets = getPageOffsets();
            var x = offsets[0];
            minXOffset = x;
            maxXOffset = x;
            var y = offsets[1];
            minYOffset = y;
            maxYOffset = y;
        }
        /*
         * Check the max scroll levels, updating as necessary
         */
        function updateMaxScrolls() {
            var offsets = getPageOffsets();
            var x = offsets[0];
            if (x < minXOffset) {
                minXOffset = x;
            }
            else if (x > maxXOffset) {
                maxXOffset = x;
            }
            var y = offsets[1];
            if (y < minYOffset) {
                minYOffset = y;
            }
            else if (y > maxYOffset) {
                maxYOffset = y;
            }
        }
        /*
         * Prevents offsets from being decimal or NaN
         * See https://github.com/snowplow/snowplow-javascript-tracker/issues/324
         */
        function cleanOffset(offset) {
            return Math.round(offset);
        }
        /**
         * Sets or renews the session cookie.
         * Responsible for calling the `onSessionUpdateCallback` callback.
         * @returns {boolean} If the value persisted in cookies or LocalStorage
         */
        function setSessionCookie() {
            var cookieName = getSnowplowCookieName('ses');
            var cookieValue = '*';
            return persistValue(cookieName, cookieValue, configSessionCookieTimeout);
        }
        /**
         * @mutates idCookie
         * @param {ParsedIdCookie} idCookie
         * @returns {boolean} If the value persisted in cookies or LocalStorage
         */
        function setDomainUserIdCookie(idCookie) {
            var cookieName = getSnowplowCookieName('id');
            var cookieValue = serializeIdCookie(idCookie, configAnonymousTracking);
            return persistValue(cookieName, cookieValue, configVisitorCookieTimeout);
        }
        /**
         * no-op if anonymousTracking enabled, will still set cookies if anonymousSessionTracking is enabled
         * Sets a cookie based on the storage strategy:
         * - if 'localStorage': attempts to write to local storage
         * - if 'cookie' or 'cookieAndLocalStorage': writes to cookies
         * - otherwise: no-op
         * @param {string} name Name/key of the value to persist
         * @param {string} value
         * @param {number} timeout Used as the expiration date for cookies or as a TTL to be checked on LocalStorage
         * @returns {boolean} If the operation was successful or not
         */
        function persistValue(name, value, timeout) {
            if (configAnonymousTracking && !configAnonymousSessionTracking) {
                return false;
            }
            if (configStateStorageStrategy == 'localStorage') {
                return attemptWriteLocalStorage(name, value, timeout);
            }
            else if (configStateStorageStrategy == 'cookie' || configStateStorageStrategy == 'cookieAndLocalStorage') {
                cookie(name, value, timeout, configCookiePath, configCookieDomain, configCookieSameSite, configCookieSecure);
                return document.cookie.indexOf("".concat(name, "=")) !== -1 ? true : false;
            }
            return false;
        }
        /**
         * Clears all cookie and local storage for id and ses values
         */
        function clearUserDataAndCookies(configuration) {
            var idname = getSnowplowCookieName('id');
            var sesname = getSnowplowCookieName('ses');
            attemptDeleteLocalStorage(idname);
            attemptDeleteLocalStorage(sesname);
            deleteCookie(idname, configCookieDomain, configCookieSameSite, configCookieSecure);
            deleteCookie(sesname, configCookieDomain, configCookieSameSite, configCookieSecure);
            if (!(configuration === null || configuration === void 0 ? void 0 : configuration.preserveSession)) {
                memorizedSessionId = (0,node_modules_uuid.v4)();
                memorizedVisitCount = 1;
            }
            if (!(configuration === null || configuration === void 0 ? void 0 : configuration.preserveUser)) {
                domainUserId = configAnonymousTracking ? '' : (0,node_modules_uuid.v4)();
                businessUserId = null;
            }
        }
        /**
         * Toggle Anonymous Tracking
         */
        function toggleAnonymousTracking(configuration) {
            if (configuration && configuration.stateStorageStrategy) {
                trackerConfiguration.stateStorageStrategy = configuration.stateStorageStrategy;
                configStateStorageStrategy = getStateStorageStrategy(trackerConfiguration);
            }
            configAnonymousTracking = getAnonymousTracking(trackerConfiguration);
            configAnonymousSessionTracking = getAnonymousSessionTracking(trackerConfiguration);
            configAnonymousServerTracking = getAnonymousServerTracking(trackerConfiguration);
            outQueue.setUseLocalStorage(configStateStorageStrategy == 'localStorage' || configStateStorageStrategy == 'cookieAndLocalStorage');
            outQueue.setAnonymousTracking(configAnonymousServerTracking);
        }
        /*
         * Load the domain user ID and the session ID
         * Set the cookies (if cookies are enabled)
         */
        function initializeIdsAndCookies() {
            if (configAnonymousTracking && !configAnonymousSessionTracking) {
                return;
            }
            var sesCookieSet = configStateStorageStrategy != 'none' && !!getSnowplowCookieValue('ses');
            var idCookie = loadDomainUserIdCookie();
            domainUserId = initializeDomainUserId(idCookie, configAnonymousTracking);
            if (!sesCookieSet) {
                memorizedSessionId = startNewIdCookieSession(idCookie);
            }
            else {
                memorizedSessionId = sessionIdFromIdCookie(idCookie);
            }
            memorizedVisitCount = visitCountFromIdCookie(idCookie);
            if (configStateStorageStrategy != 'none') {
                setSessionCookie();
                // Update currentVisitTs
                updateNowTsInIdCookie(idCookie);
                setDomainUserIdCookie(idCookie);
            }
        }
        /*
         * Load visitor ID cookie
         */
        function loadDomainUserIdCookie() {
            if (configStateStorageStrategy == 'none') {
                return emptyIdCookie();
            }
            var id = getSnowplowCookieValue('id') || undefined;
            return parseIdCookie(id, domainUserId, memorizedSessionId, memorizedVisitCount);
        }
        /**
         * Adds the protocol in front of our collector URL
         *
         * @param string - collectorUrl The collector URL with or without protocol
         * @returns string collectorUrl The tracker URL with protocol
         */
        function asCollectorUrl(collectorUrl) {
            if (collectorUrl.indexOf('http') === 0) {
                return collectorUrl;
            }
            return ('https:' === document.location.protocol ? 'https' : 'http') + '://' + collectorUrl;
        }
        /**
         * Initialize new `pageViewId` if it shouldn't be preserved.
         * Should be called when `trackPageView` is invoked
         */
        function resetPageView() {
            if (!preservePageViewId || state.pageViewId == null) {
                state.pageViewId = (0,node_modules_uuid.v4)();
            }
        }
        /**
         * Safe function to get `pageViewId`.
         * Generates it if it wasn't initialized by other tracker
         */
        function getPageViewId() {
            if (state.pageViewId == null) {
                state.pageViewId = (0,node_modules_uuid.v4)();
            }
            return state.pageViewId;
        }
        /**
         * Safe function to get `tabId`.
         * Generates it if it is not yet initialized. Shared between trackers.
         */
        function getTabId() {
            if (configStateStorageStrategy === 'none' || configAnonymousTracking || !isWebPageContextAvailable) {
                return null;
            }
            var SESSION_STORAGE_TAB_ID = '_sp_tab_id';
            var tabId = attemptGetSessionStorage(SESSION_STORAGE_TAB_ID);
            if (!tabId) {
                attemptWriteSessionStorage(SESSION_STORAGE_TAB_ID, (0,node_modules_uuid.v4)());
                tabId = attemptGetSessionStorage(SESSION_STORAGE_TAB_ID);
            }
            return tabId || null;
        }
        /**
         * Put together a web page context with a unique UUID for the page view
         *
         * @returns web_page context
         */
        function getWebPagePlugin() {
            return {
                contexts: function () {
                    return [
                        {
                            schema: WEB_PAGE_SCHEMA,
                            data: {
                                id: getPageViewId()
                            }
                        },
                    ];
                }
            };
        }
        function getBrowserContextPlugin() {
            return {
                contexts: function () {
                    return [
                        {
                            schema: BROWSER_CONTEXT_SCHEMA,
                            data: tslib_es6_assign(tslib_es6_assign({}, getBrowserProperties()), { tabId: getTabId() })
                        },
                    ];
                }
            };
        }
        /*
         * Attaches common web fields to every request (resolution, url, referrer, etc.)
         * Also sets the required cookies.
         */
        function getBrowserDataPlugin() {
            var anonymizeOr = function (value) { return (configAnonymousTracking ? null : value); };
            var anonymizeSessionOr = function (value) {
                return configAnonymousSessionTracking ? value : anonymizeOr(value);
            };
            return {
                beforeTrack: function (payloadBuilder) {
                    var existingSession = getSnowplowCookieValue('ses'), idCookie = loadDomainUserIdCookie();
                    var isFirstEventInSession = eventIndexFromIdCookie(idCookie) === 0;
                    if (configOptOutCookie) {
                        toOptoutByCookie = !!cookie(configOptOutCookie);
                    }
                    else {
                        toOptoutByCookie = false;
                    }
                    if (configDoNotTrack || toOptoutByCookie) {
                        clearUserDataAndCookies();
                        return;
                    }
                    // If cookies are enabled, base visit count and session ID on the cookies
                    if (cookiesEnabledInIdCookie(idCookie)) {
                        // New session?
                        if (!existingSession && configStateStorageStrategy != 'none') {
                            memorizedSessionId = startNewIdCookieSession(idCookie);
                        }
                        else {
                            memorizedSessionId = sessionIdFromIdCookie(idCookie);
                        }
                        memorizedVisitCount = visitCountFromIdCookie(idCookie);
                    }
                    else if (new Date().getTime() - lastEventTime > configSessionCookieTimeout * 1000) {
                        memorizedVisitCount++;
                        memorizedSessionId = startNewIdCookieSession(idCookie, {
                            memorizedVisitCount: memorizedVisitCount
                        });
                    }
                    // Update cookie
                    updateNowTsInIdCookie(idCookie);
                    updateFirstEventInIdCookie(idCookie, payloadBuilder);
                    incrementEventIndexInIdCookie(idCookie);
                    var _a = getBrowserProperties(), viewport = _a.viewport, documentSize = _a.documentSize;
                    payloadBuilder.add('vp', viewport);
                    payloadBuilder.add('ds', documentSize);
                    payloadBuilder.add('vid', anonymizeSessionOr(memorizedVisitCount));
                    payloadBuilder.add('sid', anonymizeSessionOr(memorizedSessionId));
                    payloadBuilder.add('duid', anonymizeOr(domainUserIdFromIdCookie(idCookie))); // Always load from cookie as this is better etiquette than in-memory values
                    payloadBuilder.add('uid', anonymizeOr(businessUserId));
                    refreshUrl();
                    payloadBuilder.add('refr', purify(customReferrer || configReferrerUrl));
                    // Add the page URL last as it may take us over the IE limit (and we don't always need it)
                    payloadBuilder.add('url', purify(configCustomUrl || locationHrefAlias));
                    var clientSession = clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking);
                    if (configSessionContext && (!configAnonymousTracking || configAnonymousSessionTracking)) {
                        addSessionContextToPayload(payloadBuilder, clientSession);
                    }
                    // Update cookies
                    if (configStateStorageStrategy != 'none') {
                        setDomainUserIdCookie(idCookie);
                        var sessionIdentifierPersisted = setSessionCookie();
                        if ((!existingSession || isFirstEventInSession) &&
                            sessionIdentifierPersisted &&
                            onSessionUpdateCallback &&
                            !manualSessionUpdateCalled) {
                            onSessionUpdateCallback(clientSession);
                            manualSessionUpdateCalled = false;
                        }
                    }
                    lastEventTime = new Date().getTime();
                }
            };
        }
        function addSessionContextToPayload(payloadBuilder, clientSession) {
            var sessionContext = {
                schema: CLIENT_SESSION_SCHEMA,
                data: clientSession
            };
            payloadBuilder.addContextEntity(sessionContext);
        }
        /**
         * Expires current session and starts a new session.
         */
        function newSession() {
            // If cookies are enabled, base visit count and session ID on the cookies
            var idCookie = loadDomainUserIdCookie();
            // When cookies are enabled
            if (cookiesEnabledInIdCookie(idCookie)) {
                // When cookie/local storage is enabled - make a new session
                if (configStateStorageStrategy != 'none') {
                    memorizedSessionId = startNewIdCookieSession(idCookie);
                }
                else {
                    memorizedSessionId = sessionIdFromIdCookie(idCookie);
                }
                memorizedVisitCount = visitCountFromIdCookie(idCookie);
            }
            else {
                memorizedVisitCount++;
                memorizedSessionId = startNewIdCookieSession(idCookie, {
                    memorizedVisitCount: memorizedVisitCount
                });
            }
            updateNowTsInIdCookie(idCookie);
            // Update cookies
            if (configStateStorageStrategy != 'none') {
                var clientSession = clientSessionFromIdCookie(idCookie, configStateStorageStrategy, configAnonymousTracking);
                setDomainUserIdCookie(idCookie);
                var sessionIdentifierPersisted = setSessionCookie();
                if (sessionIdentifierPersisted && onSessionUpdateCallback) {
                    manualSessionUpdateCalled = true;
                    onSessionUpdateCallback(clientSession);
                }
            }
            lastEventTime = new Date().getTime();
        }
        /**
         * Combine an array of unchanging contexts with the result of a context-creating function
         *
         * @param staticContexts - Array of custom contexts
         * @param contextCallback - Function returning an array of contexts
         */
        function finalizeContexts(staticContexts, contextCallback) {
            return (staticContexts || []).concat(contextCallback ? contextCallback() : []);
        }
        function logPageView(_a) {
            var title = _a.title, context = _a.context, timestamp = _a.timestamp, contextCallback = _a.contextCallback;
            refreshUrl();
            if (pageViewSent) {
                // Do not reset pageViewId if previous events were not page_view
                resetPageView();
            }
            pageViewSent = true;
            // So we know what document.title was at the time of trackPageView
            lastDocumentTitle = document.title;
            lastConfigTitle = title;
            // Fixup page title
            var pageTitle = fixupTitle(lastConfigTitle || lastDocumentTitle);
            // Log page view
            core.track(buildPageView({
                pageUrl: purify(configCustomUrl || locationHrefAlias),
                pageTitle: pageTitle,
                referrer: purify(customReferrer || configReferrerUrl)
            }), finalizeContexts(context, contextCallback), timestamp);
            // Send ping (to log that user has stayed on page)
            var now = new Date();
            var installingActivityTracking = false;
            if (activityTrackingConfig.enabled && !activityTrackingConfig.installed) {
                activityTrackingConfig.installed = true;
                installingActivityTracking = true;
                // Add mousewheel event handler, detect passive event listeners for performance
                var detectPassiveEvents_1 = {
                    update: function update() {
                        if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
                            var passive_1 = false;
                            var options = Object.defineProperty({}, 'passive', {
                                get: function get() {
                                    passive_1 = true;
                                },
                                set: function set() { }
                            });
                            // note: have to set and remove a no-op listener instead of null
                            // (which was used previously), because Edge v15 throws an error
                            // when providing a null callback.
                            // https://github.com/rafrex/detect-passive-events/pull/3
                            var noop = function noop() { };
                            window.addEventListener('testPassiveEventSupport', noop, options);
                            window.removeEventListener('testPassiveEventSupport', noop, options);
                            detectPassiveEvents_1.hasSupport = passive_1;
                        }
                    }
                };
                detectPassiveEvents_1.update();
                // Detect available wheel event
                var wheelEvent = 'onwheel' in document.createElement('div')
                    ? 'wheel' // Modern browsers support "wheel"
                    : document.onmousewheel !== undefined
                        ? 'mousewheel' // Webkit and IE support at least "mousewheel"
                        : 'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox
                if (Object.prototype.hasOwnProperty.call(detectPassiveEvents_1, 'hasSupport')) {
                    addEventListener(document, wheelEvent, activityHandler, { passive: true });
                }
                else {
                    addEventListener(document, wheelEvent, activityHandler);
                }
                // Capture our initial scroll points
                resetMaxScrolls();
                // Add event handlers; cross-browser compatibility here varies significantly
                // @see http://quirksmode.org/dom/events
                var documentHandlers = [
                    'click',
                    'mouseup',
                    'mousedown',
                    'mousemove',
                    'keypress',
                    'keydown',
                    'keyup',
                    'touchend',
                    'touchstart',
                ];
                var windowHandlers = ['resize', 'focus', 'blur'];
                var listener = function (_, handler) {
                    if (handler === void 0) { handler = activityHandler; }
                    return function (ev) {
                        return addEventListener(document, ev, handler);
                    };
                };
                documentHandlers.forEach(listener(document));
                windowHandlers.forEach(listener(window));
                listener(window, scrollHandler)('scroll');
            }
            if (activityTrackingConfig.enabled && (resetActivityTrackingOnPageView || installingActivityTracking)) {
                // Periodic check for activity.
                lastActivityTime = now.getTime();
                var key = void 0;
                for (key in activityTrackingConfig.configurations) {
                    var config = activityTrackingConfig.configurations[key];
                    if (config) {
                        //Clear page ping heartbeat on new page view
                        window.clearInterval(config.activityInterval);
                        scheduleActivityInterval(config, context, contextCallback);
                    }
                }
            }
        }
        function scheduleActivityInterval(config, context, contextCallback) {
            var executePagePing = function (cb, context) {
                refreshUrl();
                cb({ context: context, pageViewId: getPageViewId(), minXOffset: minXOffset, minYOffset: minYOffset, maxXOffset: maxXOffset, maxYOffset: maxYOffset });
                resetMaxScrolls();
            };
            var timeout = function () {
                var now = new Date();
                // There was activity during the heart beat period;
                // on average, this is going to overstate the visitDuration by configHeartBeatTimer/2
                if (lastActivityTime + config.configMinimumVisitLength > now.getTime()) {
                    executePagePing(config.callback, finalizeContexts(context, contextCallback));
                }
                config.activityInterval = window.setInterval(heartbeat, config.configHeartBeatTimer);
            };
            var heartbeat = function () {
                var now = new Date();
                // There was activity during the heart beat period;
                // on average, this is going to overstate the visitDuration by configHeartBeatTimer/2
                if (lastActivityTime + config.configHeartBeatTimer > now.getTime()) {
                    executePagePing(config.callback, finalizeContexts(context, contextCallback));
                }
            };
            if (config.configMinimumVisitLength === 0) {
                config.activityInterval = window.setInterval(heartbeat, config.configHeartBeatTimer);
            }
            else {
                config.activityInterval = window.setTimeout(timeout, config.configMinimumVisitLength);
            }
        }
        /**
         * Configure the activity tracking and ensures integer values for min visit and heartbeat
         */
        function configureActivityTracking(configuration) {
            var minimumVisitLength = configuration.minimumVisitLength, heartbeatDelay = configuration.heartbeatDelay, callback = configuration.callback;
            if (isInteger(minimumVisitLength) && isInteger(heartbeatDelay)) {
                return {
                    configMinimumVisitLength: minimumVisitLength * 1000,
                    configHeartBeatTimer: heartbeatDelay * 1000,
                    callback: callback
                };
            }
            index_module_LOG.error('Activity tracking minimumVisitLength & heartbeatDelay must be integers');
            return undefined;
        }
        /**
         * Log that a user is still viewing a given page by sending a page ping.
         * Not part of the public API - only called from logPageView() above.
         */
        function logPagePing(_a) {
            var context = _a.context, minXOffset = _a.minXOffset, minYOffset = _a.minYOffset, maxXOffset = _a.maxXOffset, maxYOffset = _a.maxYOffset;
            var newDocumentTitle = document.title;
            if (newDocumentTitle !== lastDocumentTitle) {
                lastDocumentTitle = newDocumentTitle;
                lastConfigTitle = undefined;
            }
            core.track(buildPagePing({
                pageUrl: purify(configCustomUrl || locationHrefAlias),
                pageTitle: fixupTitle(lastConfigTitle || lastDocumentTitle),
                referrer: purify(customReferrer || configReferrerUrl),
                minXOffset: cleanOffset(minXOffset),
                maxXOffset: cleanOffset(maxXOffset),
                minYOffset: cleanOffset(minYOffset),
                maxYOffset: cleanOffset(maxYOffset)
            }), context);
        }
        function disableActivityTrackingAction(actionKey) {
            var callbackConfiguration = activityTrackingConfig.configurations[actionKey];
            if ((callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.configMinimumVisitLength) === 0) {
                window.clearTimeout(callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.activityInterval);
            }
            else {
                window.clearInterval(callbackConfiguration === null || callbackConfiguration === void 0 ? void 0 : callbackConfiguration.activityInterval);
            }
            activityTrackingConfig.configurations[actionKey] = undefined;
        }
        var apiMethods = {
            getDomainSessionIndex: function () {
                return memorizedVisitCount;
            },
            getPageViewId: getPageViewId,
            getTabId: getTabId,
            newSession: newSession,
            getCookieName: function (basename) {
                return getSnowplowCookieName(basename);
            },
            getUserId: function () {
                return businessUserId;
            },
            getDomainUserId: function () {
                return loadDomainUserIdCookie()[1];
            },
            getDomainUserInfo: function () {
                return loadDomainUserIdCookie();
            },
            setReferrerUrl: function (url) {
                customReferrer = url;
            },
            setCustomUrl: function (url) {
                refreshUrl();
                configCustomUrl = resolveRelativeReference(locationHrefAlias, url);
            },
            setDocumentTitle: function (title) {
                // So we know what document.title was at the time of trackPageView
                lastDocumentTitle = document.title;
                lastConfigTitle = title;
            },
            discardHashTag: function (enableFilter) {
                configDiscardHashTag = enableFilter;
            },
            discardBrace: function (enableFilter) {
                configDiscardBrace = enableFilter;
            },
            setCookiePath: function (path) {
                configCookiePath = path;
                updateDomainHash();
            },
            setVisitorCookieTimeout: function (timeout) {
                configVisitorCookieTimeout = timeout;
            },
            crossDomainLinker: function (crossDomainLinkerCriterion) {
                decorateLinks(crossDomainLinkerCriterion);
            },
            enableActivityTracking: function (configuration) {
                if (!activityTrackingConfig.configurations.pagePing) {
                    activityTrackingConfig.enabled = true;
                    activityTrackingConfig.configurations.pagePing = configureActivityTracking(tslib_es6_assign(tslib_es6_assign({}, configuration), { callback: logPagePing }));
                }
            },
            enableActivityTrackingCallback: function (configuration) {
                if (!activityTrackingConfig.configurations.callback) {
                    activityTrackingConfig.enabled = true;
                    activityTrackingConfig.configurations.callback = configureActivityTracking(configuration);
                }
            },
            disableActivityTracking: function () {
                disableActivityTrackingAction('pagePing');
            },
            disableActivityTrackingCallback: function () {
                disableActivityTrackingAction('callback');
            },
            updatePageActivity: function () {
                activityHandler();
            },
            setOptOutCookie: function (name) {
                configOptOutCookie = name;
            },
            setUserId: function (userId) {
                businessUserId = userId;
            },
            setUserIdFromLocation: function (querystringField) {
                refreshUrl();
                businessUserId = fromQuerystring(querystringField, locationHrefAlias);
            },
            setUserIdFromReferrer: function (querystringField) {
                refreshUrl();
                businessUserId = fromQuerystring(querystringField, configReferrerUrl);
            },
            setUserIdFromCookie: function (cookieName) {
                businessUserId = cookie(cookieName);
            },
            setCollectorUrl: function (collectorUrl) {
                configCollectorUrl = asCollectorUrl(collectorUrl);
                outQueue.setCollectorUrl(configCollectorUrl);
            },
            setBufferSize: function (newBufferSize) {
                outQueue.setBufferSize(newBufferSize);
            },
            flushBuffer: function (configuration) {
                if (configuration === void 0) { configuration = {}; }
                outQueue.executeQueue();
                if (configuration.newBufferSize) {
                    outQueue.setBufferSize(configuration.newBufferSize);
                }
            },
            trackPageView: function (event) {
                if (event === void 0) { event = {}; }
                logPageView(event);
            },
            preservePageViewId: function () {
                preservePageViewId = true;
            },
            disableAnonymousTracking: function (configuration) {
                trackerConfiguration.anonymousTracking = false;
                toggleAnonymousTracking(configuration);
                initializeIdsAndCookies();
                outQueue.executeQueue(); // There might be some events in the queue we've been unable to send in anonymous mode
            },
            enableAnonymousTracking: function (configuration) {
                var _a;
                trackerConfiguration.anonymousTracking = (_a = (configuration && (configuration === null || configuration === void 0 ? void 0 : configuration.options))) !== null && _a !== void 0 ? _a : true;
                toggleAnonymousTracking(configuration);
                // Reset the page view, if not tracking the session, so can't stitch user into new events on the page view id
                if (!configAnonymousSessionTracking) {
                    resetPageView();
                }
            },
            clearUserData: clearUserDataAndCookies
        };
        return tslib_es6_assign(tslib_es6_assign({}, apiMethods), { id: trackerId, namespace: namespace, core: core, sharedState: state });
    };
    // Initialise the tracker
    var partialTracker = newTracker(trackerId, namespace, version, endpoint, sharedState, trackerConfiguration), tracker = tslib_es6_assign(tslib_es6_assign({}, partialTracker), { addPlugin: function (configuration) {
            var _a, _b;
            tracker.core.addPlugin(configuration);
            (_b = (_a = configuration.plugin).activateBrowserPlugin) === null || _b === void 0 ? void 0 : _b.call(_a, tracker);
        } });
    // Initialise each plugin with the tracker
    browserPlugins.forEach(function (p) {
        var _a;
        (_a = p.activateBrowserPlugin) === null || _a === void 0 ? void 0 : _a.call(p, tracker);
    });
    return tracker;
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var namedTrackers = {};
/**
 * Dispatch function to all specified trackers
 *
 * @param trackers - An optional list of trackers to send the event to, or will send to all trackers
 * @param fn - The function which will run against each tracker
 */
function index_module_dispatchToTrackers(trackers, fn) {
    try {
        getTrackers(trackers !== null && trackers !== void 0 ? trackers : allTrackerNames()).forEach(fn);
    }
    catch (ex) {
        index_module_LOG.error('Function failed', ex);
    }
}
/**
 * Dispatch function to all specified trackers from the supplied collection
 *
 * @param trackers - An optional list of trackers to send the event to, or will send to all trackers
 * @param trackerCollection - The collection which the trackers will be selected from
 * @param fn - The function which will run against each tracker
 */
function dispatchToTrackersInCollection(trackers, trackerCollection, fn) {
    try {
        getTrackersFromCollection(trackers !== null && trackers !== void 0 ? trackers : Object.keys(trackerCollection), trackerCollection).forEach(fn);
    }
    catch (ex) {
        LOG.error('Function failed', ex);
    }
}
/**
 * Checks if a tracker has been created for a particular identifier
 * @param trackerId - The unique identifier of the tracker
 */
function trackerExists(trackerId) {
    return namedTrackers.hasOwnProperty(trackerId);
}
/**
 * Creates a Tracker and adds it to the internal collection
 * @param trackerId - The unique identifier of the tracker
 * @param namespace - The namespace of the tracker, tracked with each event as `tna`
 * @param version - The current version of the tracker library
 * @param endpoint - The endpoint to send events to
 * @param sharedState - The instance of shared state to use for this tracker
 * @param configuration - The configuration to use for this tracker instance
 */
function addTracker(trackerId, namespace, version, endpoint, sharedState, configuration) {
    if (!namedTrackers.hasOwnProperty(trackerId)) {
        namedTrackers[trackerId] = Tracker(trackerId, namespace, version, endpoint, sharedState, configuration);
        return namedTrackers[trackerId];
    }
    return null;
}
/**
 * Gets a single instance of the internal tracker object
 * @param trackerId - The unique identifier of the tracker
 * @returns The tracker instance, or null if not found
 */
function getTracker(trackerId) {
    if (namedTrackers.hasOwnProperty(trackerId)) {
        return namedTrackers[trackerId];
    }
    LOG.warn(trackerId + ' not configured');
    return null;
}
/**
 * Gets an array of tracker instances based on the list of identifiers
 * @param trackerIds - An array of unique identifiers of the trackers
 * @returns The tracker instances, or empty list if none found
 */
function getTrackers(trackerIds) {
    return getTrackersFromCollection(trackerIds, namedTrackers);
}
/**
 * Gets all the trackers as a object, keyed by their unique identifiers
 */
function allTrackers() {
    return namedTrackers;
}
/**
 * Returns all the unique tracker identifiers
 */
function allTrackerNames() {
    return Object.keys(namedTrackers);
}
function getTrackersFromCollection(trackerIds, trackerCollection) {
    var trackers = [];
    for (var _i = 0, trackerIds_1 = trackerIds; _i < trackerIds_1.length; _i++) {
        var id = trackerIds_1[_i];
        if (trackerCollection.hasOwnProperty(id)) {
            trackers.push(trackerCollection[id]);
        }
        else {
            index_module_LOG.warn(id + ' not configured');
        }
    }
    return trackers;
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * A set of variables which are shared among all initialised trackers
 */
var SharedState = /** @class */ (function () {
    function SharedState() {
        /* List of request queues - one per Tracker instance */
        this.outQueues = [];
        this.bufferFlushers = [];
        /* DOM Ready */
        this.hasLoaded = false;
        this.registeredOnLoadHandlers = [];
    }
    return SharedState;
}());
function createSharedState() {
    var sharedState = new SharedState(), documentAlias = document, windowAlias = window;
    /*
     * Handle page visibility event
     * Works everywhere except IE9
     */
    function visibilityChangeHandler() {
        if (documentAlias.visibilityState == 'hidden') {
            // Flush all POST queues
            sharedState.bufferFlushers.forEach(function (flusher) {
                flusher(false);
            });
        }
    }
    function flushBuffers() {
        // Flush all POST queues
        sharedState.bufferFlushers.forEach(function (flusher) {
            flusher(false);
        });
    }
    /*
     * Handler for onload event
     */
    function loadHandler() {
        var i;
        if (!sharedState.hasLoaded) {
            sharedState.hasLoaded = true;
            for (i = 0; i < sharedState.registeredOnLoadHandlers.length; i++) {
                sharedState.registeredOnLoadHandlers[i]();
            }
        }
        return true;
    }
    /*
     * Add onload or DOM ready handler
     */
    function addReadyListener() {
        if (documentAlias.addEventListener) {
            documentAlias.addEventListener('DOMContentLoaded', function ready() {
                documentAlias.removeEventListener('DOMContentLoaded', ready, false);
                loadHandler();
            });
        }
        else if (documentAlias.attachEvent) {
            documentAlias.attachEvent('onreadystatechange', function ready() {
                if (documentAlias.readyState === 'complete') {
                    documentAlias.detachEvent('onreadystatechange', ready);
                    loadHandler();
                }
            });
        }
        // fallback
        addEventListener(windowAlias, 'load', loadHandler, false);
    }
    /************************************************************
     * Constructor
     ************************************************************/
    // initialize the Snowplow singleton
    if (documentAlias.visibilityState) {
        // Flush for mobile and modern browsers
        addEventListener(documentAlias, 'visibilitychange', visibilityChangeHandler, false);
    }
    // Last attempt at flushing in beforeunload
    addEventListener(windowAlias, 'beforeunload', flushBuffers, false);
    if (document.readyState === 'loading') {
        addReadyListener();
    }
    else {
        loadHandler();
    }
    return sharedState;
}


//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ./node_modules/@snowplow/browser-tracker/dist/index.module.js
/*!
 * Browser tracker for Snowplow v3.22.1 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */





/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * Expires current session and starts a new session.
 *
 * @param trackers - The tracker identifiers which will have their session refreshed
 */
function newSession(trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.newSession();
    });
}
/**
 * Override referrer
 *
 * @param url - Custom Referrer which will be used as override
 * @param trackers - The tracker identifiers which will be configured
 */
function setReferrerUrl(url, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.setReferrerUrl(url);
    });
}
/**
 * Override url
 *
 * @param url - Custom URL which will be used as override
 * @param trackers - The tracker identifiers which will be configured
 */
function setCustomUrl(url, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.setCustomUrl(url);
    });
}
/**
 * Override document.title
 *
 * @param title - Document title which will be used as override
 * @param trackers - The tracker identifiers which will be configured
 */
function setDocumentTitle(title, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.setDocumentTitle(title);
    });
}
/**
 * Strip hash tag (or anchor) from URL
 *
 * @param enable - Whether to enable stripping of hash
 * @param trackers - The tracker identifiers which will be configured
 */
function discardHashTag(enable, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.discardHashTag(enable);
    });
}
/**
 * Strip braces from URL
 *
 * @param enable - Whther to enable stripping of braces
 * @param trackers - The tracker identifiers which will be configured
 */
function discardBrace(enable, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.discardBrace(enable);
    });
}
/**
 * Set first-party cookie path
 *
 * @param path - The path which will be used when setting cookies
 * @param trackers - The tracker identifiers which will be configured
 */
function setCookiePath(path, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.setCookiePath(path);
    });
}
/**
 * Set visitor cookie timeout (in seconds)
 *
 * @param timeout - The timeout until cookies will expire
 * @param trackers - The tracker identifiers which will be configured
 */
function setVisitorCookieTimeout(timeout, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.setVisitorCookieTimeout(timeout);
    });
}
/**
 * Enable querystring decoration for links passing a filter
 *
 * @param crossDomainLinker - Function used to determine which links to decorate
 * @param trackers - The tracker identifiers which will be configured
 */
function crossDomainLinker(crossDomainLinkerCriterion, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.crossDomainLinker(crossDomainLinkerCriterion);
    });
}
/**
 * Enables page activity tracking (sends page pings to the Collector regularly).
 *
 * @param configuration - The activity tracking configuration
 * @param trackers - The tracker identifiers which will be configured
 */
function enableActivityTracking(configuration, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.enableActivityTracking(configuration);
    });
}
/**
 * Enables page activity tracking (replaces collector ping with callback).
 *
 * @param configuration - The activity tracking callback configuration
 * @param trackers - The tracker identifiers which will be configured
 */
function enableActivityTrackingCallback(configuration, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.enableActivityTrackingCallback(configuration);
    });
}
/**
 * Disables page activity tracking.
 *
 * @param trackers - The tracker identifiers the activity tracking will be disabled.
 */
function disableActivityTracking(trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.disableActivityTracking();
    });
}
/**
 * Disables page activity tracking callback.
 *
 * @param trackers - The tracker identifiers the activity tracking callback will be disabled.
 */
function disableActivityTrackingCallback(trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.disableActivityTrackingCallback();
    });
}
/**
 * Triggers the activityHandler manually to allow external user defined activity. i.e. While watching a video
 *
 * @param trackers - The tracker identifiers which will be updated
 */
function updatePageActivity(trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.updatePageActivity();
    });
}
/**
 * Sets the opt out cookie.
 *
 * @param name - of the opt out cookie
 * @param trackers - The tracker identifiers which will be configured
 */
function setOptOutCookie(name, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.setOptOutCookie(name);
    });
}
/**
 * Set the business-defined user ID for this user.
 *
 * @param userId - The business-defined user ID
 * @param trackers - The tracker identifiers which will be configured
 */
function setUserId(userId, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.setUserId(userId);
    });
}
/**
 * Set the business-defined user ID for this user using the location querystring.
 *
 * @param querystringField - Name of a querystring name-value pair
 * @param trackers - The tracker identifiers which will be configured
 */
function setUserIdFromLocation(querystringField, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.setUserIdFromLocation(querystringField);
    });
}
/**
 * Set the business-defined user ID for this user using the referrer querystring.
 *
 * @param querystringField - Name of a querystring name-value pair
 * @param trackers - The tracker identifiers which will be configured
 */
function setUserIdFromReferrer(querystringField, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.setUserIdFromReferrer(querystringField);
    });
}
/**
 * Set the business-defined user ID for this user to the value of a cookie.
 *
 * @param cookieName - Name of the cookie whose value will be assigned to businessUserId
 * @param trackers - The tracker identifiers which will be configured
 */
function setUserIdFromCookie(cookieName, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.setUserIdFromCookie(cookieName);
    });
}
/**
 * Specify the Snowplow collector URL. Specific http or https to force it
 * or leave it off to match the website protocol.
 *
 * @param collectorUrl - The collector URL, with or without protocol
 * @param trackers - The tracker identifiers which will be configured
 */
function setCollectorUrl(collectorUrl, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.setCollectorUrl(collectorUrl);
    });
}
/**
 * Set the buffer size
 * Can be useful if you want to stop batching requests to ensure events start
 * sending closer to event creation
 *
 * @param newBufferSize - The value with which to update the bufferSize to
 * @param trackers - The tracker identifiers which will be flushed
 */
function setBufferSize(newBufferSize, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.setBufferSize(newBufferSize);
    });
}
/**
 * Send all events in the outQueue
 * Only need to use this when sending events with a bufferSize of at least 2
 *
 * @param configuration - The configuration to use following flushing the buffer
 * @param trackers - The tracker identifiers which will be flushed
 */
function flushBuffer(configuration, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.flushBuffer(configuration);
    });
}
/**
 * Track a visit to a web page
 *
 * @param event - The Page View Event properties
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackPageView(event, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.trackPageView(event);
    });
}
/**
 * Track a structured event
 * A classic style of event tracking, allows for easier movement between analytics
 * systems. A loosely typed event, creating a Self Describing event is preferred, but
 * useful for interoperability.
 *
 * @param event - The Structured Event properties
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackStructEvent(event, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.core.track(buildStructEvent(event), event.context, event.timestamp);
    });
}
/**
 * Track a self-describing event happening on this page.
 * A custom event type, allowing for an event to be tracked using your own custom schema
 * and a data object which conforms to the supplied schema
 *
 * @param event - The event information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackSelfDescribingEvent(event, trackers) {
    index_module_dispatchToTrackers(trackers, function (t) {
        t.core.track(buildSelfDescribingEvent({ event: event.event }), event.context, event.timestamp);
    });
}
/**
 * All provided contexts will be sent with every event
 *
 * @param contexts - An array of contexts or conditional contexts
 * @param trackers - The tracker identifiers which the global contexts will be added to
 */
function addGlobalContexts(contexts, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.core.addGlobalContexts(contexts);
    });
}
/**
 * All provided contexts will no longer be sent with every event
 *
 * @param contexts - An array of contexts or conditional contexts
 * @param trackers - The tracker identifiers which the global contexts will be remove from
 */
function removeGlobalContexts(contexts, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.core.removeGlobalContexts(contexts);
    });
}
/**
 * Clear all global contexts that are sent with events
 *
 * @param trackers - The tracker identifiers which the global contexts will be cleared from
 */
function clearGlobalContexts(trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.core.clearGlobalContexts();
    });
}
/**
 * Stop regenerating `pageViewId` (available from `web_page` context)
 *
 * @param trackers - The tracker identifiers which the event will preserve their Page View Ids
 */
function preservePageViewId(trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.preservePageViewId();
    });
}
/**
 * Disables anonymous tracking if active (ie. tracker initialized with `anonymousTracking`)
 * For stateStorageStrategy override, uses supplied value first,
 * falls back to one defined in initial config, otherwise uses cookieAndLocalStorage.
 *
 * @param configuration - The configuration for disabling anonymous tracking
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function disableAnonymousTracking(configuration, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.disableAnonymousTracking(configuration);
    });
}
/**
 * Enables anonymous tracking (ie. tracker initialized without `anonymousTracking`)
 *
 * @param configuration - The configuration for enabling anonymous tracking
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function enableAnonymousTracking(configuration, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.enableAnonymousTracking(configuration);
    });
}
/**
 * Clears all cookies and local storage containing user and session identifiers
 *
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function clearUserData(configuration, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.clearUserData(configuration);
    });
}
/**
 * Add a plugin into the plugin collection after trackers have already been initialised
 *
 * @param configuration - The plugin to add
 * @param trackers - The tracker identifiers which the plugin will be added to
 */
function addPlugin(configuration, trackers) {
    dispatchToTrackers(trackers, function (t) {
        t.addPlugin(configuration);
    });
}

/*
 * Copyright (c) 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
var state = typeof window !== 'undefined' ? createSharedState() : undefined;
/**
 * Initialise a new tracker
 *
 * @param trackerId - The tracker id - also known as tracker namespace
 * @param endpoint - Collector endpoint in the form collector.mysite.com
 * @param configuration - The initialisation options of the tracker
 */
function newTracker(trackerId, endpoint, configuration) {
    if (configuration === void 0) { configuration = {}; }
    if (state) {
        return addTracker(trackerId, trackerId, "js-".concat(version), endpoint, state, configuration);
    }
    else {
        return undefined;
    }
}


//# sourceMappingURL=index.module.js.map

// EXTERNAL MODULE: ./src/lib/tenants/constants.ts
var constants = __webpack_require__(21530);
// EXTERNAL MODULE: ./src/lib/tenants/getTenant.ts
var getTenant = __webpack_require__(12527);
;// CONCATENATED MODULE: ./src/lib/tracking/snowplow/client.ts



var _NEXT_PUBLIC_SNOWPLOW_URL;
var snowplowEndpointUrl = (_NEXT_PUBLIC_SNOWPLOW_URL = "https://c.analytics.data.casavo.tech") !== null && _NEXT_PUBLIC_SNOWPLOW_URL !== void 0 ? _NEXT_PUBLIC_SNOWPLOW_URL : "https://mini.analytics.data.int.casavo.tech";
var initSnowplowClientSideTracker = function() {
    var tenant = (0,getTenant/* getTenant */.dy)();
    if (tenant !== constants/* TENANTS.casavo */.rk.casavo) {
        return;
    }
    if (!!snowplowEndpointUrl) {
        newTracker("lisa", snowplowEndpointUrl, {
            appId: "lisa",
            cookieSameSite: "Lax",
            discoverRootDomain: true,
            plugins: []
        });
    }
};
var sendSnowplowClientSideEvent = function(param) {
    var data = param.data, schema = param.schema;
    var tenant = (0,getTenant/* getTenant */.dy)();
    if (tenant !== constants/* TENANTS.casavo */.rk.casavo) {
        return;
    }
    trackSelfDescribingEvent({
        event: {
            data: data,
            schema: schema
        }
    });
};


/***/ }),

/***/ 10007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62271);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./i18n.js
var i18n = __webpack_require__(29589);
var i18n_default = /*#__PURE__*/__webpack_require__.n(i18n);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/appWithI18n.js + 5 modules
var appWithI18n = __webpack_require__(68378);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(44926);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/react-image-gallery/styles/css/image-gallery.css
var image_gallery = __webpack_require__(60920);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/src/effects/blur.css
var effects_blur = __webpack_require__(86200);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(82783);
// EXTERNAL MODULE: ./node_modules/smoothscroll-polyfill/dist/smoothscroll.js
var smoothscroll = __webpack_require__(6702);
var smoothscroll_default = /*#__PURE__*/__webpack_require__.n(smoothscroll);
// EXTERNAL MODULE: ./node_modules/intl-pluralrules/polyfill.js
var polyfill = __webpack_require__(9071);
// EXTERNAL MODULE: ./src/index.css
var src = __webpack_require__(44703);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/style.css
var style = __webpack_require__(46896);
// EXTERNAL MODULE: ./node_modules/@casavo/habitat/dist/style.css
var dist_style = __webpack_require__(60285);
// EXTERNAL MODULE: ./src/context/AuthProvider/index.ts + 2 modules
var AuthProvider = __webpack_require__(95374);
// EXTERNAL MODULE: ./src/context/BottomSheetContext.tsx + 2 modules
var BottomSheetContext = __webpack_require__(88628);
// EXTERNAL MODULE: ./src/context/Device.tsx
var Device = __webpack_require__(77808);
// EXTERNAL MODULE: ./src/context/FavoritesProvider.tsx
var FavoritesProvider = __webpack_require__(90435);
// EXTERNAL MODULE: ./src/context/KeydownContext.tsx
var KeydownContext = __webpack_require__(53614);
// EXTERNAL MODULE: ./src/context/ModalContext.tsx
var ModalContext = __webpack_require__(32228);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(3292);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(21395);
// EXTERNAL MODULE: ./node_modules/use-query-params/esm/index.js + 16 modules
var esm = __webpack_require__(8300);
;// CONCATENATED MODULE: ./src/context/QueryParam.tsx







// solution copied from this thread -> https://github.com/pbeshai/use-query-params/issues/13#issuecomment-815577849
var QueryParamProviderComponent = function(props) {
    var children = props.children, rest = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    var router = (0,next_router.useRouter)();
    var match = router.asPath.match(/[^?]+/);
    var pathname = match ? match[0] : router.asPath;
    var location = (0,react.useMemo)(function() {
        return  true ? window.location : 0;
    }, [
        router.asPath
    ]);
    var history = (0,react.useMemo)(function() {
        return {
            location: location,
            push: function(param) {
                var search = param.search;
                return router.push({
                    pathname: router.pathname,
                    query: router.query
                }, {
                    pathname: pathname,
                    search: search
                }, {
                    scroll: false,
                    shallow: true
                });
            },
            replace: function(param) {
                var search = param.search;
                router.replace({
                    pathname: router.pathname,
                    query: router.query
                }, {
                    pathname: pathname,
                    search: search
                }, {
                    scroll: false,
                    shallow: true
                });
            }
        };
    }, [
        pathname,
        router.pathname,
        router.query,
        location.pathname
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* QueryParamProvider */.Fz, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        history: history,
        location: location,
        children: children
    }));
};
var QueryParamProvider = /*#__PURE__*/ (0,react.memo)(QueryParamProviderComponent);

// EXTERNAL MODULE: ./src/context/SuggestedCriteriaProvider.tsx
var SuggestedCriteriaProvider = __webpack_require__(51701);
// EXTERNAL MODULE: ./src/context/UserNavigationProvider.tsx
var UserNavigationProvider = __webpack_require__(71750);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(89847);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/utils/environment.ts

/** Will be available on both server and client */ function getAppEnv() {
    return getConfig().publicRuntimeConfig.environment;
}
var isProd = function() {
    return getAppEnv() === "production";
};
var isDevelopment = function() {
    return getAppEnv() === "development";
};
var getAppVersion = function() {
    return config_default()().publicRuntimeConfig.appVersion;
};
var getAppRevision = function() {
    return config_default()().publicRuntimeConfig.appRevision;
};

// EXTERNAL MODULE: ./src/utils/isStorageSupported.ts
var isStorageSupported = __webpack_require__(17668);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(67320);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/utils/third-party/recaptcha/script.tsx


var RecaptchaScript = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "recaptcha",
        src: "https://www.google.com/recaptcha/enterprise.js?render=".concat("6Ldxo1khAAAAAIn2uH72B_QWg9nWGW4r-vVJhIy4"),
        strategy: "afterInteractive"
    }, "recaptcha");
};

// EXTERNAL MODULE: ./src/lib/tracking/snowplow/client.ts + 5 modules
var client = __webpack_require__(38264);
;// CONCATENATED MODULE: ./src/pages/_app.tsx
// @ts-ignore




// @ts-ignore








// https://github.com/aralroca/next-translate/issues/508

















if (true) {
    smoothscroll_default().polyfill();
}
if (true) {
    window.appVersion = getAppVersion();
    window.appRevision = getAppRevision();
}
var MyApp = function(param) {
    var Component = param.Component, err = param.err, pageProps = param.pageProps;
    (0,react.useEffect)(function() {
        if ((0,isStorageSupported/* isStorageSupported */.p)(function() {
            return sessionStorage;
        })) {
            sessionStorage.removeItem("CASAVO@LISTING-BACK");
            sessionStorage.removeItem("CASAVO@LISTINGS-PAGE-OFFSET");
            sessionStorage.removeItem("CASAVO@LISTINGS-MAP-COORDINATES");
        }
    }, []);
    var queryClient = (0,react.useRef)(new es.QueryClient({
        defaultOptions: {
            queries: {
                refetchOnReconnect: false,
                refetchOnWindowFocus: false
            }
        }
    }));
    (0,react.useEffect)(function() {
        (0,client/* initSnowplowClientSideTracker */.y)();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: "width=device-width, initial-scale=1, shrink-to-fit=no",
                        name: "viewport"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: "index, follow",
                        name: "robots"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecaptchaScript, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "app",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es.QueryClientProvider, {
                    client: queryClient.current,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es.Hydrate, {
                        state: pageProps.dehydratedState,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserNavigationProvider/* UserNavigationProvider */.tt, {
                            pageType: pageProps.pageType,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Device/* DeviceProvider */.Yk, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryParamProvider, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeydownContext/* KeydownContextProvider */.F0, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthProvider/* AuthProvider */.Ho, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedCriteriaProvider/* SuggestedCriteriaProvider */.GB, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoritesProvider/* FavoritesProvider */.cp, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContext/* ModalContextProvider */.ny, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheetContext/* BottomSheetProvider */.e, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
                                                                err: err
                                                            }))
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
var __Page_Next_Translate__ = MyApp;
// @ts-ignore
/* harmony default export */ var _app = ((0,appWithI18n/* default */.Z)(__Page_Next_Translate__, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (i18n_default())), {
    // @ts-ignore
    isLoader: true,
    // @ts-ignore
    skipInitialProps: true
}))); // @ts-ignore


/***/ }),

/***/ 38291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XL": function() { return /* binding */ createAuthClient; },
/* harmony export */   "pg": function() { return /* binding */ SignUpError; }
/* harmony export */ });
/* unused harmony exports LoginError, LogoutError, RecoverPasswordVerifyError, RecoverPasswordStartError, RecoverPasswordUpdateError */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88718);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50879);


var SignUpError;
(function(SignUpError) {
    SignUpError["ALREADY_EXISTS"] = "ALREADY_EXISTS";
    SignUpError["ALREADY_LOGGED_IN"] = "ALREADY_LOGGED_IN";
    SignUpError["GENERIC"] = "GENERIC";
    SignUpError["TOO_SIMPLE_PASSWORD"] = "TOO_SIMPLE_PASSWORD";
})(SignUpError || (SignUpError = {}));
var LoginError;
(function(LoginError) {
    LoginError["ALREADY_LOGGED_IN"] = "ALREADY_LOGGED_IN";
    LoginError["GENERIC"] = "GENERIC";
    LoginError["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
})(LoginError || (LoginError = {}));
var LogoutError;
(function(LogoutError) {
    LogoutError["ALREADY_LOGGED_OUT"] = "ALREADY_LOGGED_OUT";
    LogoutError["GENERIC"] = "GENERIC";
})(LogoutError || (LogoutError = {}));
var RecoverPasswordVerifyError;
(function(RecoverPasswordVerifyError) {
    RecoverPasswordVerifyError["GENERIC"] = "GENERIC";
    RecoverPasswordVerifyError["INVALID_VERIFICATION_CODE"] = "INVALID_VERIFICATION_CODE";
    RecoverPasswordVerifyError["NOT_STARTED"] = "NOT_STARTED";
})(RecoverPasswordVerifyError || (RecoverPasswordVerifyError = {}));
var RecoverPasswordStartError;
(function(RecoverPasswordStartError) {
    RecoverPasswordStartError["GENERIC"] = "GENERIC";
})(RecoverPasswordStartError || (RecoverPasswordStartError = {}));
var RecoverPasswordUpdateError;
(function(RecoverPasswordUpdateError) {
    RecoverPasswordUpdateError["GENERIC"] = "GENERIC";
    RecoverPasswordUpdateError["NOT_VERIFIED"] = "NOT_VERIFIED";
    RecoverPasswordUpdateError["TOO_SIMPLE_PASSWORD"] = "TOO_SIMPLE_PASSWORD";
})(RecoverPasswordUpdateError || (RecoverPasswordUpdateError = {}));
function createAuthClient(kratosEndpoint) {
    var recoverPasswordStarted = null;
    var recoverPasswordVerified = null;
    return {
        fetchCurrentUser: function fetchCurrentUser() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                    return [
                        2,
                        fetch("".concat(kratosEndpoint, "/sessions/whoami"), {
                            credentials: "include",
                            headers: {
                                Accept: "application/json"
                            }
                        }).then(function(resp) {
                            if (!resp.ok) {
                                throw new Error("".concat(resp.status, ": ").concat(resp.statusText));
                            }
                            return resp.json();
                        }).then(function(data) {
                            var ref, ref1;
                            var isRecoveryMode = data.authentication_methods && data.authentication_methods.length > 0 && ((ref = data.authentication_methods[0]) === null || ref === void 0 ? void 0 : ref.method) === "code_recovery";
                            if (isRecoveryMode) {
                                throw new Error("401 - You are in Recovery Mode");
                            }
                            return {
                                casavo_user_id: data.casavo_user.id,
                                email: data.identity.traits.email,
                                first_name: data.identity.traits.first_name,
                                id: data.identity.id,
                                isLoggedBySocial: ((ref1 = data.authentication_methods[0]) === null || ref1 === void 0 ? void 0 : ref1.method) === "oidc",
                                last_name: data.identity.traits.last_name
                            };
                        })
                    ];
                });
            })();
        },
        getRecoveringEmail: function getRecoveringEmail() {
            return recoverPasswordStarted === null || recoverPasswordStarted === void 0 ? void 0 : recoverPasswordStarted.email;
        },
        loginWithEmailAndPassword: function loginWithEmailAndPassword(credentials) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                    return [
                        2,
                        fetchLoginParams().then(function(params) {
                            return fetch(params.loginUrl, {
                                body: JSON.stringify({
                                    csrf_token: params.csrfToken,
                                    identifier: credentials.identifier,
                                    method: "password",
                                    password: credentials.password
                                }),
                                credentials: "include",
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "application/json"
                                },
                                method: "post"
                            });
                        }).then(function(resp) {
                            return resp.json();
                        }).then(function(data) {
                            var ref, ref1, ref2;
                            if (data.session && data.session.identity) {
                                return {
                                    casavo_user_id: data.casavo_user.id,
                                    email: data.session.identity.traits.email,
                                    first_name: data.session.identity.traits.first_name || null,
                                    id: data.session.identity.id,
                                    isLoggedBySocial: false,
                                    last_name: data.session.identity.traits.last_name || null
                                };
                            }
                            if ((data === null || data === void 0 ? void 0 : (ref = data.ui) === null || ref === void 0 ? void 0 : ref.messages) && ((ref2 = data === null || data === void 0 ? void 0 : (ref1 = data.ui) === null || ref1 === void 0 ? void 0 : ref1.messages[0]) === null || ref2 === void 0 ? void 0 : ref2.id) === 4000006) {
                                throw new Error(LoginError.INVALID_CREDENTIALS);
                            }
                            throw new Error(LoginError.GENERIC);
                        }).catch(function(e) {
                            if (!(e.message in LoginError)) {
                                throw new Error(LoginError.GENERIC);
                            }
                            throw e;
                        })
                    ];
                });
            })();
        },
        loginWithProvider: function loginWithProvider(provider, returnUrl) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
                var params;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchLoginParams(encodeURIComponent(returnUrl))
                            ];
                        case 1:
                            params = _state.sent();
                            return [
                                2,
                                fetch(params.loginUrl, {
                                    body: JSON.stringify({
                                        csrf_token: params.csrfToken,
                                        provider: provider
                                    }),
                                    credentials: "include",
                                    headers: {
                                        Accept: "application/json",
                                        "Content-Type": "application/json"
                                    },
                                    method: "post"
                                }).then(function(resp) {
                                    return resp.json();
                                }).then(function(data) {
                                    if (data.redirect_browser_to) {
                                        window.location.href = data.redirect_browser_to;
                                    } else {
                                        // TODO: parse correctly the error messages
                                        console.error(data);
                                        throw new Error(JSON.stringify(data));
                                    }
                                }).catch(console.error)
                            ];
                    }
                });
            })();
        },
        logout: function logout() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
                var params, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                fetchLogoutParams()
                            ];
                        case 1:
                            params = _state.sent();
                            return [
                                2,
                                fetch(params.logoutUrl, {
                                    credentials: "include",
                                    headers: {
                                        Accept: "application/json",
                                        "Content-Type": "application/json"
                                    }
                                }).then(function() {})
                            ];
                        case 2:
                            e = _state.sent();
                            if (!(e.message in LogoutError)) {
                                throw new Error(LogoutError.GENERIC);
                            }
                            throw e;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        recoverPasswordStart: function recoverPasswordStart(email) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
                var params, response, body, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                fetchRecoverPasswordStartParams()
                            ];
                        case 1:
                            params = _state.sent();
                            return [
                                4,
                                fetch(params.recoverUrl, {
                                    body: JSON.stringify({
                                        csrf_token: params.csrfToken,
                                        email: email,
                                        method: "code"
                                    }),
                                    credentials: "include",
                                    headers: {
                                        Accept: "application/json",
                                        "Content-Type": "application/json"
                                    },
                                    method: "post"
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            if (!response.ok) {
                                throw new Error(RecoverPasswordStartError.GENERIC);
                            }
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            body = _state.sent();
                            recoverPasswordStarted = {
                                csrfToken: body.ui.nodes.find(function(node) {
                                    return node.attributes.name === "csrf_token";
                                }).attributes.value,
                                email: email,
                                submissionUrl: body.ui.action
                            };
                            return [
                                3,
                                5
                            ];
                        case 4:
                            e = _state.sent();
                            if (!(e.message in RecoverPasswordStartError)) {
                                throw new Error(RecoverPasswordStartError.GENERIC);
                            }
                            throw e;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        recoverPasswordUpdate: // TODO: resend code
        /*
      const recoverResendEmail = recoverySubmitted.ui.nodes.find((node: any) =>
        node.attributes.name === 'email'
      ).attributes.value
      */ // {
        //   csrf_token: 'token',
        //   method: 'code',
        //   email: 'a@b.c'
        // }
        function recoverPasswordUpdate(newPassword) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
                var settingsFlowResponse, settingsParams, response, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            if (!recoverPasswordVerified) {
                                throw new Error(RecoverPasswordUpdateError.NOT_VERIFIED);
                            }
                            return [
                                4,
                                fetch("".concat(kratosEndpoint, "/self-service/settings/flows?id=").concat(recoverPasswordVerified.updatePasswordFlowId), {
                                    credentials: "include",
                                    headers: {
                                        Accept: "application/json"
                                    }
                                }).then(function(resp) {
                                    return resp.json();
                                })
                            ];
                        case 1:
                            settingsFlowResponse = _state.sent();
                            settingsParams = {
                                csrfToken: settingsFlowResponse.ui.nodes.find(function(node) {
                                    return node.attributes.name === "csrf_token";
                                }).attributes.value,
                                url: settingsFlowResponse.ui.action
                            };
                            return [
                                4,
                                fetch(settingsParams.url, {
                                    body: JSON.stringify({
                                        csrf_token: settingsParams.csrfToken,
                                        method: "password",
                                        password: newPassword
                                    }),
                                    credentials: "include",
                                    headers: {
                                        Accept: "application/json",
                                        "Content-Type": "application/json"
                                    },
                                    method: "post"
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            if (response.status === 400) {
                                throw new Error(RecoverPasswordUpdateError.TOO_SIMPLE_PASSWORD);
                            } else if (!response.ok) {
                                throw new Error(RecoverPasswordUpdateError.GENERIC);
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            if (!(e.message in RecoverPasswordUpdateError)) {
                                throw new Error(RecoverPasswordUpdateError.GENERIC);
                            }
                            throw e;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        recoverPasswordVerify: function recoverPasswordVerify(code) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
                var response, data, settingsFlow, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            if (!recoverPasswordStarted) {
                                throw new Error(RecoverPasswordVerifyError.NOT_STARTED);
                            }
                            if (recoverPasswordVerified) {
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                fetch(recoverPasswordStarted.submissionUrl, {
                                    body: JSON.stringify({
                                        code: code,
                                        csrf_token: recoverPasswordStarted.csrfToken,
                                        method: "code"
                                    }),
                                    credentials: "include",
                                    headers: {
                                        Accept: "application/json",
                                        "Content-Type": "application/json"
                                    },
                                    method: "post"
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            // check if we can update the password using the settings flow
                            if (response.status !== 422 || !data.redirect_browser_to) {
                                throw new Error(RecoverPasswordVerifyError.INVALID_VERIFICATION_CODE);
                            }
                            settingsFlow = data.redirect_browser_to.split("flow=")[1];
                            recoverPasswordVerified = {
                                updatePasswordFlowId: settingsFlow
                            };
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            if (!(e.message in RecoverPasswordVerifyError)) {
                                throw new Error(RecoverPasswordVerifyError.GENERIC);
                            }
                            throw e;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        registerUser: function registerUser(credentials) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                    return [
                        2,
                        fetchRegisterUserParams().then(function(params) {
                            return fetch(params.registrationUrl, {
                                body: JSON.stringify({
                                    csrf_token: params.csrfToken,
                                    method: "password",
                                    password: credentials.password,
                                    "traits.email": credentials.identifier
                                }),
                                credentials: "include",
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "application/json"
                                },
                                method: "post"
                            });
                        }).then(function(resp) {
                            return resp.json();
                        }).then(function(data) {
                            var ref, ref1, ref2, ref3, ref4;
                            if (data.error) {
                                throw data.error.id;
                            }
                            if (data === null || data === void 0 ? void 0 : data.identity) {
                                return {
                                    casavo_user_id: data.casavo_user.id,
                                    email: data.identity.traits.email,
                                    first_name: data.identity.traits.first_name || null,
                                    id: data.identity.id,
                                    isLoggedBySocial: false,
                                    last_name: data.identity.traits.last_name || null
                                };
                            }
                            if ((data === null || data === void 0 ? void 0 : (ref = data.ui) === null || ref === void 0 ? void 0 : ref.messages) && ((ref2 = data === null || data === void 0 ? void 0 : (ref1 = data.ui) === null || ref1 === void 0 ? void 0 : ref1.messages[0]) === null || ref2 === void 0 ? void 0 : ref2.id) === 4000007) {
                                throw new Error(SignUpError.ALREADY_EXISTS);
                            } else if (data === null || data === void 0 ? void 0 : (ref3 = data.ui) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.nodes) === null || ref4 === void 0 ? void 0 : ref4.find(function(node) {
                                return node.attributes.name === "password";
                            }).messages.some(function(message) {
                                return message.id === 4000005;
                            })) {
                                throw new Error(SignUpError.TOO_SIMPLE_PASSWORD);
                            } else {
                                throw new Error(SignUpError.GENERIC);
                            }
                        }).catch(function(e) {
                            if (!(e.message in SignUpError)) {
                                throw new Error(SignUpError.GENERIC);
                            }
                            throw e;
                        })
                    ];
                });
            })();
        }
    };
    function fetchRegisterUserParams() {
        return _fetchRegisterUserParams.apply(this, arguments);
    }
    function _fetchRegisterUserParams() {
        _fetchRegisterUserParams = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("".concat(kratosEndpoint, "/self-service/registration/browser"), {
                                credentials: "include",
                                headers: {
                                    Accept: "application/json"
                                }
                            }).then(function(resp) {
                                return resp.json();
                            }).then(function(data) {
                                if (data.error) {
                                    if (data.error.id === "session_already_available") {
                                        throw new Error(SignUpError.ALREADY_LOGGED_IN);
                                    }
                                    throw new Error(LogoutError.GENERIC);
                                }
                                return {
                                    csrfToken: data.ui.nodes.find(function(node) {
                                        return node.attributes.name === "csrf_token";
                                    }).attributes.value,
                                    registrationUrl: data.ui.action
                                };
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _fetchRegisterUserParams.apply(this, arguments);
    }
    function fetchLoginParams() {
        return _fetchLoginParams.apply(this, arguments);
    }
    function _fetchLoginParams() {
        _fetchLoginParams = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
            var returnUrl, returnPath;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        returnUrl = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : null;
                        returnPath = "";
                        if (returnUrl) {
                            returnPath = "&return_to=".concat(returnUrl);
                        }
                        return [
                            4,
                            fetch("".concat(kratosEndpoint, "/self-service/login/browser?refresh=true").concat(returnPath), {
                                credentials: "include",
                                headers: {
                                    Accept: "application/json"
                                }
                            }).then(function(resp) {
                                return resp.json();
                            }).then(function(data) {
                                if (data.error) {
                                    if (data.error.id === "session_already_available") {
                                        throw new Error(LoginError.ALREADY_LOGGED_IN);
                                    }
                                    throw new Error(LogoutError.GENERIC);
                                }
                                return {
                                    csrfToken: data.ui.nodes.find(function(node) {
                                        return node.attributes.name === "csrf_token";
                                    }).attributes.value,
                                    loginUrl: data.ui.action,
                                    providers: data.ui.nodes.filter(function(node) {
                                        return node.group === "oidc" && !node.attributes.disabled;
                                    }).map(function(node) {
                                        var ref, ref1;
                                        return {
                                            label: (ref = node.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.label) === null || ref1 === void 0 ? void 0 : ref1.text,
                                            name: node.attributes.name,
                                            value: node.attributes.value
                                        };
                                    })
                                };
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _fetchLoginParams.apply(this, arguments);
    }
    function fetchLogoutParams() {
        return _fetchLogoutParams.apply(this, arguments);
    }
    function _fetchLogoutParams() {
        _fetchLogoutParams = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("".concat(kratosEndpoint, "/self-service/logout/browser"), {
                                credentials: "include",
                                headers: {
                                    Accept: "application/json"
                                }
                            }).then(function(resp) {
                                return resp.json();
                            }).then(function(data) {
                                if (data.error) {
                                    if (data.error.id === "session_inactive") {
                                        throw new Error(LogoutError.ALREADY_LOGGED_OUT);
                                    }
                                    throw new Error(LogoutError.GENERIC);
                                }
                                return {
                                    logoutUrl: data.logout_url
                                };
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _fetchLogoutParams.apply(this, arguments);
    }
    function fetchRecoverPasswordStartParams() {
        return _fetchRecoverPasswordStartParams.apply(this, arguments);
    }
    function _fetchRecoverPasswordStartParams() {
        _fetchRecoverPasswordStartParams = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
            var response;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("".concat(kratosEndpoint, "/self-service/recovery/browser"), {
                                credentials: "include",
                                headers: {
                                    Accept: "application/json"
                                }
                            }).then(function(resp) {
                                return resp.json();
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.error) {
                            throw new Error(response.error.id);
                        }
                        return [
                            2,
                            {
                                csrfToken: response.ui.nodes.find(function(node) {
                                    return node.attributes.name === "csrf_token";
                                }).attributes.value,
                                recoverUrl: response.ui.action
                            }
                        ];
                }
            });
        });
        return _fetchRecoverPasswordStartParams.apply(this, arguments);
    }
}


/***/ }),

/***/ 1966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L9": function() { return /* binding */ areaParamEncoder; },
/* harmony export */   "V1": function() { return /* binding */ isCityReferenceArea; },
/* harmony export */   "eH": function() { return /* binding */ areaParamDecoder; },
/* harmony export */   "k$": function() { return /* binding */ findCity; },
/* harmony export */   "yp": function() { return /* binding */ isAreaParam; }
/* harmony export */ });
/* unused harmony exports cityParamEncoder, areaParamSuffix */
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43000);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_cities_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57982);
/* harmony import */ var _locale_variables__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98640);



var isCityReferenceArea = function(city) {
    return city !== undefined && city.referenceArea === city.slug;
};
var cityParamEncoder = function(city) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.kebabCase)(city);
};
var cityParamDecoder = function(city) {
    if (city === undefined) {
        return null;
    }
    return (Array.isArray(city) ? city[0] : city).replace(/-/g, " ");
};
/**
 * Extract from an array of {CateCity} the one with the given name.
 *
 * Nome: match is performed using translated city name for city.
 *
 * @example
 * // given an array of CateCity with names translated in "it"
 * const cities = await getCitiesByArea("it", "milano")
 *
 * // you don't need kebab case here
 * const city = findCity("sesto san giovanni", cities)
 * // but you can use kebab case, as well as array with single string
 * const anotherCity == findCity(["san-giuliano-milanese"], cities)
 *
 * @param cityParam
 * @param cities
 */ var findCity = function(cityParam, cities) {
    return cities.find(function(city) {
        // first check based on slug, assuming cityParam is "kebab case"
        if (city.slug.split("/")[1] === (Array.isArray(cityParam) ? cityParam[0] : cityParam)) return true;
        // second check: old, crappy code using city translation...
        var cityLocale = (0,_locale_variables__WEBPACK_IMPORTED_MODULE_1__/* .getLocaleByCountryFilter */ .bm)(city.country);
        var localeCityName = city.translations.find(function(translation) {
            return translation.language === cityLocale;
        }).value.toLowerCase();
        return (0,_utils_cities_utils__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeCityName */ .Y)(localeCityName) === cityParamDecoder(cityParam);
    });
};
var findZone = function(zoneParam, zones) {
    return zones.find(function(zone) {
        var ref;
        return ((ref = zone.slug) === null || ref === void 0 ? void 0 : ref.split("/")[2]) === (Array.isArray(zoneParam) ? zoneParam[0] : zoneParam);
    });
};
var areaParamSuffix = "-provincia";
/**
 * Append suffix for "area" route parameter to the given string, eventually converting
 * to kebab case needed by URL segment
 *
 * @example
 * areaParamEncoder("foo") // foo-provincia
 * areaParamEncoder("Sesto San Giovanni") // sesto-san-giovanni-provincia
 *
 * @param area
 */ var areaParamEncoder = function(area) {
    return "".concat(cityParamEncoder(area)).concat(areaParamSuffix);
};
/**
 * To be used to extract the "city" when handing an "area" route parameter.
 * Area route parameters are in the form `<CITY>-provincia`; this method returns
 * the sub-string `<CITY>` with no additional checks, just remove the expected suffix.
 *
 * @example
 * areaParamDecoder("desio-provincia") // "desio"
 * areaParamDecoder("jj_gg-provincia") // "jj_gg"
 * areaParamDecoder(["firenze-provincia"]) // "firenze"
 *
 * @param area
 * @return null if {area} is undefined
 */ var areaParamDecoder = function(area) {
    if (area === undefined) {
        return null;
    }
    return (Array.isArray(area) ? area[0] : area).replace(new RegExp("".concat(areaParamSuffix, "$")), "");
};
/**
 * Returns true if the given param ends with expected suffix for "area" route parameter.
 *
 * @example
 * isAreaParam("sevilla-provincia") // true
 * isAreaParam(["genova-provincia"]) // true
 * isAreaParam("provincia-genova") // false
 * isAreaParam("bologna") // false
 *
 * @param param
 */ var isAreaParam = function(param) {
    return param !== undefined && (Array.isArray(param) ? param[0] : param).endsWith(areaParamSuffix);
};
var citiesMapperUtils = {
    cityParamDecoder: cityParamDecoder,
    findCity: findCity,
    findZone: findZone
};
/* harmony default export */ __webpack_exports__["ZP"] = (citiesMapperUtils);


/***/ }),

/***/ 57982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ sanitizeCityName; }
/* harmony export */ });
var sanitizeCityName = function(name) {
    return name.replace("\xe1", "a");
};


/***/ }),

/***/ 59522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61978);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

var getCitiesWithoutProvince = function(cities) {
    var areasWithoutHinterland = hinterlandSizeByArea(cities).filter(byCitiesWithoutHinterland).map(getReferenceArea);
    return getCityNamesWithoutHinterland(cities, areasWithoutHinterland);
};
/** Returns whether a given city supports having a "-province" page
 *
 * @param cityName The name of the city (case-insensitive)
 * @param cities List of all the cities
 */ var citySupportsProvince = function(cityName, cities) {
    var list = getCitiesWithoutProvince(cities);
    return !list.includes(cityName.toUpperCase());
};
/**
 * filters out the reference areas that are pointed to by other cities beside themselves
 * @param referenceAreaAndCount a tuple composed by a referenceArea slug and the number of cities that point to it */ var byCitiesWithoutHinterland = function(referenceAreaAndCount) {
    return referenceAreaAndCount[1] === 1;
};
var getReferenceArea = function(counter) {
    return counter[0];
};
var hinterlandSizeByArea = function(cities) {
    return Object.entries((0,lodash__WEBPACK_IMPORTED_MODULE_0__.countBy)(cities, function(city) {
        return city.referenceArea;
    }));
};
var getCityNamesWithoutHinterland = function(cities, areasWithoutHinterland) {
    return cities.filter(function(city) {
        return areasWithoutHinterland.includes(city.slug);
    }).map(function(city) {
        return city.name.toUpperCase();
    });
};
var utils = {
    citySupportsProvince: citySupportsProvince,
    getCitiesWithoutProvince: getCitiesWithoutProvince
};
/* harmony default export */ __webpack_exports__["Z"] = (utils);


/***/ }),

/***/ 2018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ getScrollbarWidth; }
/* harmony export */ });
var getScrollbarWidth = function() {
    var ref;
    return  true && window.innerWidth - ((ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.clientWidth);
};


/***/ }),

/***/ 17668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ isStorageSupported; }
/* harmony export */ });
var isStorageSupported = function(getStorage) {
    try {
        var key = "__some_random_key_you_are_not_going_to_use__";
        getStorage().setItem(key, key);
        getStorage().removeItem(key);
        return true;
    } catch (e) {
        return false;
    }
};


/***/ }),

/***/ 98640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F5": function() { return /* binding */ citiesByLocale; },
/* harmony export */   "IP": function() { return /* binding */ getRoomDataForLocale; },
/* harmony export */   "bm": function() { return /* binding */ getLocaleByCountryFilter; },
/* harmony export */   "uP": function() { return /* binding */ countryFiltersByLocale; },
/* harmony export */   "vw": function() { return /* binding */ isLocaleEnabledFor; }
/* harmony export */ });
/* unused harmony exports localesByCountryName, localeByCountry, defaultCitiesByLocale, getCountryFilterByLocale, localesByTotalRoomsCounter */
var isLocaleEnabledFor = function(service, locale) {
    var localesForServices = {
        POIs: [
            "it",
            "en"
        ],
        affordability: [
            "it",
            "en"
        ],
        casavoAncillaryServicesOffered: [
            "it",
            "en"
        ],
        consentsAgencyForm: [
            "it",
            "en"
        ],
        consentsCasavoForm: [
            "it",
            "en"
        ],
        filteredPages: [
            "it",
            "en"
        ],
        fomo: [
            "it",
            "en"
        ],
        mortgage: [
            "it",
            "en"
        ],
        mortgageValuation: [
            "it"
        ],
        // Proprioo agents want to "obfuscate" the exact location of the property because
        // they do not have an exclusive mandate. As temporary solution we can avoid to zoom
        // too much on the map for France. But it's a temporary hack we hope di kill ASAP
        obfuscateExactLocation: [
            "fr"
        ],
        prerenderedSeoLinks: [
            "it",
            "en"
        ],
        saveSearch: [
            "it",
            "en"
        ],
        searchByArea: [
            "it",
            "en"
        ],
        sellerFlowLandingPage: [
            "it"
        ],
        unsubscribe: [
            "it",
            "en"
        ],
        visits: [
            "it",
            "en"
        ],
        zoneDescription: [
            "it",
            "en"
        ]
    };
    return localesForServices[service].includes(locale);
};
/** Maps locales to their respective country filter for Graphql queries */ var countryFiltersByLocale = {
    en: "italy",
    fr: "france",
    it: "italy"
};
var localesByCountryName = {
    france: [
        "fr"
    ],
    italy: [
        "en",
        "it"
    ]
};
var localeByCountry = {
    france: "fr",
    italy: "it"
};
var defaultCitiesByLocale = {
    en: "it/milano",
    fr: "fr/paris",
    it: "it/milano"
};
var getLocaleByCountryFilter = function(country) {
    return localeByCountry[country] || "it";
};
var getCountryFilterByLocale = function(locale) {
    return countryFiltersByLocale[locale] || "italy";
};
/** returns the number of rooms and the label to display based on current locale (some locales count bedrooms, other the total number of rooms) */ var getRoomDataForLocale = function(locale, characteristics) {
    return {
        numberOfRooms: characteristics.rooms,
        roomLabel: "rooms"
    };
};
var localesByTotalRoomsCounter = {
    bedrooms: [],
    rooms: [
        "it",
        "en",
        "fr"
    ]
};
var citiesInItaly = [
    "milano",
    "sesto-san-giovanni",
    "roma",
    "torino",
    "firenze",
    "bologna",
    "scandicci",
    "collegno",
    "rivoli",
    "grugliasco",
    "verona",
    "san-lazzaro-di-savena",
    "casalecchio-di-reno",
    "bagno-a-ripoli",
    "cologno-monzese",
    "san-donato-milanese",
    "corsico",
    "imola",
    "campi-bisenzio",
    "sesto-fiorentino",
    "monza",
    "parabiago",
    "anzio",
    "nettuno",
    "pomezia",
    "fiumicino",
    "ardea",
    "cerveteri",
    "desio",
    "san-giuliano-milanese",
    "legnano",
    "rho",
    "cinisello-balsamo",
    "moncalieri",
    "nichelino",
    "paderno-dugnano",
    "peschiera-borromeo",
    "segrate",
    "ciampino",
    "frascati",
    "grottaferrata",
    "marino",
    "ladispoli",
    "santa-marinella",
    "manziana",
    "varese",
    "porto-ceresio",
    "como",
    "arcisate",
    "guidonia-montecelio",
    "aprilia",
    "tradate",
    "gavirate",
    "anguillara-sabazia",
    "bracciano",
    "trevignano-romano", 
];
/* FIXME we should create this starting from src/page-commons/active-cities-static.json
/** Provides the list of cities (as strings) available for each locale, to be used in next.JS data-fetching methods
 */ var citiesByLocale = {
    en: citiesInItaly,
    fr: [
        "paris"
    ],
    it: citiesInItaly
};


/***/ }),

/***/ 59165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_Z": function() { return /* binding */ buildAbsoluteLocalizedLink; },
  "JS": function() { return /* binding */ buildRelativeLocalizedLink; },
  "Pr": function() { return /* binding */ cityPageFromUrl; },
  "aF": function() { return /* binding */ getHousesForSaleUrlPathByCitySlug; },
  "LQ": function() { return /* binding */ getValidReferrerOr; },
  "RQ": function() { return /* binding */ joinPaths; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_array_with_holes.mjs
var _array_with_holes = __webpack_require__(75451);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(17670);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_non_iterable_rest.mjs
var _non_iterable_rest = __webpack_require__(96817);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(30732);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_array.mjs





function _toArray(arr) {
  return (0,_array_with_holes/* default */.Z)(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || (0,_non_iterable_rest/* default */.Z)();
}

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(76131);
// EXTERNAL MODULE: ./src/components/Link/linkBuilder.ts
var linkBuilder = __webpack_require__(13976);
// EXTERNAL MODULE: ./src/i18n-routes.ts
var i18n_routes = __webpack_require__(31693);
;// CONCATENATED MODULE: ./src/utils/navigation.ts




var buildAbsoluteLocalizedLink = function(path, lang) {
    return window.location.protocol + "//" + window.location.hostname + buildRelativeLocalizedLink(path, lang);
};
var buildRelativeLocalizedLink = function(path, lang) {
    var langPathPrefix = lang === "en" ? "" : lang;
    return joinPaths(langPathPrefix, trim(path, "/"));
};
var joinPaths = function() {
    for(var _len = arguments.length, pieces = new Array(_len), _key = 0; _key < _len; _key++){
        pieces[_key] = arguments[_key];
    }
    var path = pieces.filter(function(piece) {
        return piece && piece !== "" && piece !== "/";
    }).map(function(piece) {
        return trim(piece, "/");
    }).join("/");
    if (path === "") {
        return "/";
    }
    if (path.match(/^https?:\/\//)) {
        return "".concat(path, "/");
    }
    return "/".concat(path, "/");
};
var getValidReferrerOr = function(fallbackUrl) {
    var referrerUrl = getReferrerUrl();
    if (referrerUrl && hasSameOrigin(referrerUrl) && isAListingPlatformPage(referrerUrl)) {
        return referrerUrl.toString();
    }
    return fallbackUrl;
};
var getReferrerUrl = function() {
    try {
        return new URL(window.document.referrer);
    } catch (e) {
        return undefined;
    }
};
var hasSameOrigin = function(referrerUrl) {
    return referrerUrl.origin === window.location.origin;
};
var isAListingPlatformPage = function(referrerUrl) {
    return isHouseForSalePage(referrerUrl.pathname) || isFavoritePage(referrerUrl.pathname);
};
var isFavoritePage = function(pathname) {
    var regex = new RegExp("^(/[a-z]{2})?/".concat(i18n_routes/* favoritesPath */.v0));
    return regex.test(pathname);
};
var isHouseForSalePage = function(pathname) {
    return i18n_routes/* allListings.map */.iN.map(function(route) {
        return buildRelativeLocalizedLink(route.path, route.locale);
    }).some(function(houseForSalePath) {
        return pathname.startsWith(houseForSalePath);
    });
};
var trim = function(text, delimiter) {
    var trimmed = text.startsWith(delimiter) ? text.substring(1) : text;
    trimmed = trimmed.endsWith(delimiter) ? trimmed.substring(0, trimmed.length - 1) : trimmed;
    return trimmed;
};
var cityPageFromUrl = function(url) {
    return joinPaths.apply(void 0, (0,_to_consumable_array/* default */.Z)(url.split("/").filter(Boolean).slice(0, 3)));
};
/**
 * Provides the path to [house-for-sale]/[city] page for the given locale
 *
 * When usedLocale is null or undefined, get the locale from the city slug.
 *
 * Note: it works with zone slugs too
 *
 * @param citySlug should be a valid city slug, i.e. something like "it/san-donato-milanese"
 * @param usedLocale the locale you force to build "house for sale in city" path
 */ var getHousesForSaleUrlPathByCitySlug = function(citySlug, usedLocale) {
    var ref = _toArray(citySlug.split("/")), locale = ref[0], restCity = ref.slice(1);
    var city = restCity.join("/");
    locale = usedLocale || locale;
    return "".concat(linkBuilder/* linkBuilder.housesForSale.url */.H.housesForSale.url(locale)).concat(city, "/");
};


/***/ }),

/***/ 34958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A8": function() { return /* binding */ backToInitialScrollOnModalClose; },
/* harmony export */   "bG": function() { return /* binding */ addPositionFixedToBody; },
/* harmony export */   "q0": function() { return /* binding */ backToTopOnModalClose; }
/* harmony export */ });
/* harmony import */ var _components_framer_motion_variants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20635);
/**
 * HACK
 * WHAT: avoid modal scroll on safari mobile without losing initial scrollY position on modal close
 * https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
 */ /**
 * update 2022-11-25
 * disabling checks about device === 'mobile' due to inconsistent behaviour when opening a modal on page load.
 * e.g. when ?dealId is present in url query (after click on hubspot email cta) for opening the schedule visit modal
 * for future reference: the main issue is that since there was no user interaction before opening the modal,
 * the DeviceContext has the 'device' set to mobile (since it's the default) and hasn't updated its value,
 * so it causes layout and usability issues
 * https://casavo.atlassian.net/browse/BUY-2484
 */ 
var addPositionFixedToBody = function(scrollbarWidth) {
    document.body.style.top = "-".concat(window.scrollY, "px");
    document.body.style.position = "fixed";
    document.body.style.right = "0";
    document.body.style.left = "0";
    document.body.style.paddingRight = "".concat(scrollbarWidth, "px");
};
var removePositionFixedFromBody = function() {
    document.body.style.top = "";
    document.body.style.position = "";
    document.body.style.right = "";
    document.body.style.left = "";
    document.body.style.paddingRight = "0";
};
var backToTopOnModalClose = function() {
    setTimeout(function() {
        removePositionFixedFromBody();
    }, _components_framer_motion_variants__WEBPACK_IMPORTED_MODULE_0__/* .MODAL_ANIMATION_TIMING */ .bn);
};
var backToInitialScrollOnModalClose = function() {
    var initialScroll = document.body.style.top;
    setTimeout(function() {
        removePositionFixedFromBody();
        window.scrollTo(0, parseInt(initialScroll || "0") * -1);
    }, _components_framer_motion_variants__WEBPACK_IMPORTED_MODULE_0__/* .MODAL_ANIMATION_TIMING */ .bn);
};


/***/ }),

/***/ 88905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Su": function() { return /* binding */ handleBuyerInterestFlow; },
  "xC": function() { return /* binding */ handleCasavoPropertyModalClick; },
  "qk": function() { return /* binding */ handleClick; },
  "Iq": function() { return /* binding */ handleClickCallAgency; },
  "_t": function() { return /* binding */ handleClickNavigate; },
  "Hp": function() { return /* binding */ handleClickOpenCasavoPropertyModal; },
  "t9": function() { return /* binding */ handleClickOpenMap; },
  "tv": function() { return /* binding */ handleClickShare; },
  "xv": function() { return /* binding */ handleDrag; },
  "fB": function() { return /* binding */ handleFavouritesClick; },
  "po": function() { return /* binding */ handleFavouritesLegacy; },
  "qK": function() { return /* binding */ handleFormFieldSet; },
  "xz": function() { return /* binding */ handleFormSubmit; },
  "HC": function() { return /* binding */ handleHousesForSale; },
  "L1": function() { return /* binding */ handleListingDetailClick; },
  "Y4": function() { return /* binding */ handleListingDetailGalleryModalClick; },
  "rt": function() { return /* binding */ handleListingDetailMapClick; },
  "kN": function() { return /* binding */ handleListingPageClick; },
  "pv": function() { return /* binding */ handleListingsCanonicalFiltersClick; },
  "TE": function() { return /* binding */ handleListingsCanonicalZonesClick; },
  "Se": function() { return /* binding */ handleListingsFilterArea; },
  "KC": function() { return /* binding */ handleListingsListMobile; },
  "ND": function() { return /* binding */ handleListingsMapClick; },
  "g4": function() { return /* binding */ handleListingsMapFractioningMobile; },
  "IJ": function() { return /* binding */ handleListingsMapMobile; },
  "BF": function() { return /* binding */ handleListingsPageBreadcrumbClick; },
  "Tu": function() { return /* binding */ handleNewListingsAlertClick; },
  "Hf": function() { return /* binding */ handleShow; },
  "o0": function() { return /* binding */ handleSystem; },
  "mh": function() { return /* binding */ handleUserLoginFlow; },
  "eT": function() { return /* binding */ sendSupportEventWithListingId; }
});

// UNUSED EXPORTS: handleListingDetailGalleryMobileClick, handleListingDetailSimilarPropertiesClick, handleListingDetailSubmit

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./src/utils/tracking/trackingUtils.ts
var trackingUtils = __webpack_require__(4464);
;// CONCATENATED MODULE: ./src/utils/tag-manager.ts

var tag_manager_sendEventInteraction = function(param) {
    var eventAction = param.eventAction, eventCategory = param.eventCategory, eventLabel = param.eventLabel, eventValue = param.eventValue;
    if (typeof window.dataLayer !== "undefined") {
        (0,trackingUtils/* dataLayerPush */.lQ)({
            event: "casavo.user.interactions",
            eventAction: eventAction,
            eventCategory: eventCategory,
            eventLabel: eventLabel,
            eventType: "generic",
            eventValue: eventValue
        });
    }
};

;// CONCATENATED MODULE: ./src/utils/tracking/eventsHandlers.ts


var handleClick = function(eventCategory, eventLabel, eventValue) {
    return tag_manager_sendEventInteraction((0,_object_spread/* default */.Z)({
        eventAction: "Click",
        eventCategory: eventCategory,
        eventLabel: eventLabel
    }, eventValue ? {
        eventValue: eventValue
    } : {}));
};
var handleDrag = function(eventCategory, eventLabel, eventValue) {
    return tag_manager_sendEventInteraction((0,_object_spread/* default */.Z)({
        eventAction: "Drag",
        eventCategory: eventCategory,
        eventLabel: eventLabel
    }, eventValue ? {
        eventValue: eventValue
    } : {}));
};
var handleShow = function(eventCategory, eventLabel, eventValue) {
    return tag_manager_sendEventInteraction((0,_object_spread/* default */.Z)({
        eventAction: "Show",
        eventCategory: eventCategory,
        eventLabel: eventLabel
    }, eventValue ? {
        eventValue: eventValue
    } : {}));
};
var handleListingDetailClick = function(eventLabel, eventValue) {
    return tag_manager_sendEventInteraction((0,_object_spread/* default */.Z)({
        eventAction: "Click",
        eventCategory: "ListingDetail",
        eventLabel: eventLabel
    }, eventValue ? {
        eventValue: eventValue
    } : {}));
};
var handleListingDetailSubmit = function(eventLabel) {
    return sendEventInteraction({
        eventAction: "Submit",
        eventCategory: "ListingDetail",
        eventLabel: eventLabel
    });
};
var handleListingDetailMapClick = function(eventLabel) {
    return tag_manager_sendEventInteraction({
        eventAction: "Click",
        eventCategory: "ListingDetailMap",
        eventLabel: eventLabel
    });
};
var handleListingDetailGalleryModalClick = function(eventLabel) {
    return tag_manager_sendEventInteraction({
        eventAction: "Click",
        eventCategory: "ListingDetailGalleryModal",
        eventLabel: eventLabel
    });
};
var handleListingDetailGalleryMobileClick = function(eventLabel) {
    return sendEventInteraction({
        eventAction: "Click",
        eventCategory: "ListingDetailGalleryMobile",
        eventLabel: eventLabel
    });
};
var handleCasavoPropertyModalClick = function(eventLabel) {
    return tag_manager_sendEventInteraction({
        eventAction: "Click",
        eventCategory: "CasavoPropertyModal",
        eventLabel: eventLabel
    });
};
var handleListingDetailSimilarPropertiesClick = function(eventLabel) {
    return sendEventInteraction({
        eventAction: "Click",
        eventCategory: "ListingDetailSimilarProperties",
        eventLabel: eventLabel
    });
};
var handleListingsMapClick = function(eventLabel) {
    return tag_manager_sendEventInteraction({
        eventAction: "Click",
        eventCategory: "ListingsMap",
        eventLabel: eventLabel
    });
};
var handleListingPageClick = function(eventLabel) {
    return tag_manager_sendEventInteraction({
        eventAction: "Click",
        eventCategory: "ListingsPage",
        eventLabel: eventLabel
    });
};
var handleListingsPageBreadcrumbClick = function(eventLabel, eventValue) {
    return tag_manager_sendEventInteraction((0,_object_spread/* default */.Z)({
        eventAction: "Click",
        eventCategory: "ListingsPageBreadcrumb",
        eventLabel: eventLabel
    }, eventValue ? {
        eventValue: eventValue
    } : {}));
};
var handleListingsFilterArea = function(eventAction, eventLabel) {
    return tag_manager_sendEventInteraction({
        eventAction: eventAction,
        eventCategory: "ListingsFilterArea",
        eventLabel: eventLabel
    });
};
var handleClickShare = function(eventCategory) {
    return tag_manager_sendEventInteraction({
        eventAction: "Click",
        eventCategory: eventCategory,
        eventLabel: "Share"
    });
};
var handleClickOpenMap = function(eventCategory) {
    return tag_manager_sendEventInteraction({
        eventAction: "Click",
        eventCategory: eventCategory,
        eventLabel: "OpenMap"
    });
};
var handleListingsMapMobile = function(eventAction, eventLabel) {
    return tag_manager_sendEventInteraction({
        eventAction: eventAction,
        eventCategory: "ListingsMapMobile",
        eventLabel: eventLabel
    });
};
var handleListingsListMobile = function(eventAction, eventLabel) {
    return tag_manager_sendEventInteraction({
        eventAction: eventAction,
        eventCategory: "ListingsListMobile",
        eventLabel: eventLabel
    });
};
var handleClickCallAgency = function(eventCategory) {
    var eventLabel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Call";
    return tag_manager_sendEventInteraction({
        eventAction: "Click",
        eventCategory: eventCategory,
        eventLabel: eventLabel
    });
};
var handleClickNavigate = function(eventCategory) {
    return tag_manager_sendEventInteraction({
        eventAction: "Click",
        eventCategory: eventCategory,
        eventLabel: "Navigate"
    });
};
var handleClickOpenCasavoPropertyModal = function(eventCategory) {
    return tag_manager_sendEventInteraction({
        eventAction: "Click",
        eventCategory: eventCategory,
        eventLabel: "OpenCasavoPropertyModal"
    });
};
var handleFormFieldSet = function(eventCategory, eventLabel) {
    var eventValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined;
    return tag_manager_sendEventInteraction({
        eventAction: "FieldUpdate",
        eventCategory: eventCategory,
        eventLabel: eventLabel,
        eventValue: eventValue
    });
};
var handleFormSubmit = function(eventCategory, eventLabel) {
    return tag_manager_sendEventInteraction({
        eventAction: "Submit",
        eventCategory: eventCategory,
        eventLabel: eventLabel
    });
};
var handleSystem = function(eventCategory, eventLabel, eventValue) {
    return tag_manager_sendEventInteraction((0,_object_spread/* default */.Z)({
        eventAction: "System",
        eventCategory: eventCategory,
        eventLabel: eventLabel
    }, eventValue ? {
        eventValue: eventValue
    } : {}));
};
var handleListingsMapFractioningMobile = function(eventAction, eventLabel) {
    return tag_manager_sendEventInteraction({
        eventAction: eventAction,
        eventCategory: "ListingsMapFractioningMobile",
        eventLabel: eventLabel
    });
};
var handleHousesForSale = function(eventAction, eventLabel) {
    return tag_manager_sendEventInteraction({
        eventAction: eventAction,
        eventCategory: "HousesForSale",
        eventLabel: eventLabel
    });
};
var handleBuyerInterestFlow = function(eventAction, eventLabel, eventValue) {
    return tag_manager_sendEventInteraction((0,_object_spread/* default */.Z)({
        eventAction: eventAction,
        eventCategory: "BuyerInterestFlow",
        eventLabel: eventLabel
    }, eventValue ? {
        eventValue: eventValue
    } : {}));
};
var handleUserLoginFlow = function(eventAction, eventLabel, eventValue) {
    return tag_manager_sendEventInteraction((0,_object_spread/* default */.Z)({
        eventAction: eventAction,
        eventCategory: "UserLogin",
        eventLabel: eventLabel
    }, eventValue ? {
        eventValue: eventValue
    } : {}));
};
var handleNewListingsAlertClick = function(eventLabel, eventValue) {
    return tag_manager_sendEventInteraction((0,_object_spread/* default */.Z)({
        eventAction: "Click",
        eventCategory: "NewListingsAlert",
        eventLabel: eventLabel
    }, eventValue ? {
        eventValue: eventValue
    } : {}));
};
var handleListingsCanonicalFiltersClick = function(eventValue) {
    return tag_manager_sendEventInteraction({
        eventAction: "Click",
        eventCategory: "ListingsCanonicalFilters",
        eventLabel: "canonicalFiltersLink",
        eventValue: eventValue
    });
};
var handleListingsCanonicalZonesClick = function(eventValue) {
    return tag_manager_sendEventInteraction({
        eventAction: "Click",
        eventCategory: "ListingsCanonicalZones",
        eventLabel: "canonicalZoneLink",
        eventValue: eventValue
    });
};
var handleFavouritesClick = function(eventLabel) {
    return tag_manager_sendEventInteraction({
        eventAction: "Click",
        eventCategory: "Favourites",
        eventLabel: eventLabel
    });
};
var handleFavouritesLegacy = function(eventLabel) {
    return tag_manager_sendEventInteraction({
        eventAction: "System",
        eventCategory: "LegacyFavourites",
        eventLabel: eventLabel
    });
};
/** Send a GTM Event with the Listing Id as eventLabel to have the info on UA
 * @param listingId id of the listing
 * @param onMap whether the event originates from the listing card on map or the listing card on the page
 */ var sendSupportEventWithListingId = function(listingId, onMap) {
    tag_manager_sendEventInteraction({
        eventAction: "Click",
        eventCategory: "ListingsPage",
        eventLabel: onMap ? "ClickCardOnMap" : "ClickCardOnPage",
        eventValue: listingId
    });
};


/***/ }),

/***/ 4464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cz": function() { return /* binding */ isValidForTracking; },
/* harmony export */   "JP": function() { return /* binding */ mapFilterLabelToGtmLabel; },
/* harmony export */   "lQ": function() { return /* binding */ dataLayerPush; }
/* harmony export */ });
/* unused harmony exports getPage, getLocation */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29559);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61978);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);


var isValidForTracking = function(value) {
    return (typeof value !== "string" || value !== "") && value !== undefined && value !== null;
};
var getPage = function() {
    return document.location.pathname + document.location.search;
};
var getLocation = function() {
    return document.location.protocol + "//" + document.location.hostname + document.location.pathname + document.location.search;
};
var dataLayerPush = function(params) {
    if (typeof window.dataLayer !== "undefined") {
        window.dataLayer.push((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            location: getLocation(),
            page: getPage()
        }, params));
    }
};
var mapFilterLabelToGtmLabel = function(filterLabel) {
    switch(filterLabel){
        case "entrance_floor":
            return "Floor";
        case "state_of_manteinance":
            return "PropertyCondition";
        case "state_at_deed":
            return "PropertyStatus";
        case "heating_system":
            return "HeatingSystem";
        case "services":
            return "Amenities";
        case "year_of_construction":
            return "ConstructionYear";
        default:
            return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.capitalize)(filterLabel);
    }
};


/***/ }),

/***/ 87711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ parseZoneSlug; },
/* harmony export */   "U": function() { return /* binding */ parseGeoSlug; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63796);

var parseZoneSlug = function(slug) {
    if (!slug) return {};
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(slug.split("/"), 3), country = ref[0], city = ref[1], zone = ref[2];
    return {
        city: city,
        country: country,
        zone: zone
    };
};
var parseGeoSlug = function(geoSlug) {
    return geoSlug.split("/").reverse()[0];
};


/***/ }),

/***/ 30815:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 28752:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 41016:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7752:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1851:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 19636:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2848:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 46896:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 60285:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 60920:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 86200:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 44703:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 70456:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./en/zone-text.json": 93728,
	"./es/zone-text.json": 97639,
	"./fr/zone-text.json": 55120,
	"./it/zone-text.json": 17523,
	"./pt/zone-text.json": 22822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70456;

/***/ }),

/***/ 19259:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./en/PropertyAdvantages.json": 24671,
	"./en/action-bar.json": 70311,
	"./en/affordability.json": 44480,
	"./en/auth-area.json": 30386,
	"./en/buyer-interest-flow.json": 84993,
	"./en/canonical-filters.json": 22039,
	"./en/casavo-properties-banner.json": 16131,
	"./en/common.json": 83147,
	"./en/contact-form.json": 81663,
	"./en/favourites.json": 79952,
	"./en/filter.json": 48918,
	"./en/furniture.json": 3761,
	"./en/header-menu.json": 51012,
	"./en/houses-for-sale.json": 73083,
	"./en/listing-detail.json": 37371,
	"./en/main-search.json": 58985,
	"./en/mobile-bottom-menu.json": 486,
	"./en/priority.json": 18852,
	"./en/privacy.json": 42542,
	"./en/save-search.json": 22675,
	"./en/suggested.json": 94321,
	"./en/unicredit.json": 23001,
	"./en/unsubscribe.json": 69885,
	"./en/zones.json": 45174,
	"./es/PropertyAdvantages.json": 24096,
	"./es/action-bar.json": 43617,
	"./es/affordability.json": 97376,
	"./es/auth-area.json": 65227,
	"./es/buyer-interest-flow.json": 53203,
	"./es/canonical-filters.json": 18136,
	"./es/casavo-properties-banner.json": 44516,
	"./es/common.json": 44501,
	"./es/contact-form.json": 22226,
	"./es/favourites.json": 92608,
	"./es/filter.json": 79366,
	"./es/furniture.json": 73201,
	"./es/header-menu.json": 53415,
	"./es/houses-for-sale.json": 74820,
	"./es/listing-detail.json": 58635,
	"./es/main-search.json": 47177,
	"./es/mobile-bottom-menu.json": 33935,
	"./es/priority.json": 17149,
	"./es/privacy.json": 57395,
	"./es/save-search.json": 31492,
	"./es/suggested.json": 68242,
	"./es/unicredit.json": 30296,
	"./es/unsubscribe.json": 52908,
	"./es/zones.json": 64438,
	"./fr/PropertyAdvantages.json": 73466,
	"./fr/action-bar.json": 70612,
	"./fr/affordability.json": 51448,
	"./fr/auth-area.json": 43618,
	"./fr/buyer-interest-flow.json": 17903,
	"./fr/canonical-filters.json": 43190,
	"./fr/casavo-properties-banner.json": 17532,
	"./fr/common.json": 97038,
	"./fr/contact-form.json": 85315,
	"./fr/favourites.json": 67973,
	"./fr/filter.json": 9660,
	"./fr/furniture.json": 52070,
	"./fr/header-menu.json": 7133,
	"./fr/houses-for-sale.json": 40322,
	"./fr/listing-detail.json": 74661,
	"./fr/main-search.json": 70644,
	"./fr/mobile-bottom-menu.json": 81902,
	"./fr/priority.json": 86755,
	"./fr/privacy.json": 55058,
	"./fr/save-search.json": 12350,
	"./fr/suggested.json": 28600,
	"./fr/unicredit.json": 49023,
	"./fr/unsubscribe.json": 64761,
	"./fr/zone-text.json": 99193,
	"./fr/zones.json": 2917,
	"./it/PropertyAdvantages.json": 28680,
	"./it/action-bar.json": 89641,
	"./it/affordability.json": 72087,
	"./it/auth-area.json": 66213,
	"./it/buyer-interest-flow.json": 90636,
	"./it/canonical-filters.json": 87936,
	"./it/casavo-properties-banner.json": 96074,
	"./it/common.json": 27044,
	"./it/contact-form.json": 68779,
	"./it/favourites.json": 16593,
	"./it/filter.json": 85413,
	"./it/furniture.json": 87597,
	"./it/header-menu.json": 82588,
	"./it/houses-for-sale.json": 9936,
	"./it/listing-detail.json": 14597,
	"./it/main-search.json": 24618,
	"./it/mobile-bottom-menu.json": 23947,
	"./it/priority.json": 14178,
	"./it/privacy.json": 55273,
	"./it/save-search.json": 54947,
	"./it/suggested.json": 52027,
	"./it/unicredit.json": 37913,
	"./it/unsubscribe.json": 52480,
	"./it/zones.json": 6409,
	"./pt/PropertyAdvantages.json": 6100,
	"./pt/action-bar.json": 80096,
	"./pt/affordability.json": 96079,
	"./pt/auth-area.json": 55515,
	"./pt/buyer-interest-flow.json": 25065,
	"./pt/canonical-filters.json": 57416,
	"./pt/casavo-properties-banner.json": 89033,
	"./pt/common.json": 25137,
	"./pt/contact-form.json": 25096,
	"./pt/favourites.json": 85096,
	"./pt/filter.json": 13367,
	"./pt/furniture.json": 86114,
	"./pt/header-menu.json": 46556,
	"./pt/houses-for-sale.json": 61253,
	"./pt/listing-detail.json": 59667,
	"./pt/main-search.json": 4406,
	"./pt/mobile-bottom-menu.json": 31108,
	"./pt/priority.json": 46653,
	"./pt/privacy.json": 65835,
	"./pt/save-search.json": 27921,
	"./pt/suggested.json": 55490,
	"./pt/unicredit.json": 2515,
	"./pt/unsubscribe.json": 11983,
	"./pt/zones.json": 36680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19259;

/***/ }),

/***/ 67006:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getPluralRules = __webpack_require__(56676);
var PseudoNumberFormat = __webpack_require__(83961);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var getPluralRules__default = /*#__PURE__*/_interopDefaultLegacy(getPluralRules);
var PseudoNumberFormat__default = /*#__PURE__*/_interopDefaultLegacy(PseudoNumberFormat);

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var plurals$1 = {exports: {}};

(function (module, exports) {
  var a = function a(n, ord) {
    if (ord) return 'other';
    return n == 1 ? 'one' : 'other';
  };

  var b = function b(n, ord) {
    if (ord) return 'other';
    return n == 0 || n == 1 ? 'one' : 'other';
  };

  var c = function c(n, ord) {
    if (ord) return 'other';
    return n >= 0 && n <= 1 ? 'one' : 'other';
  };

  var d = function d(n, ord) {
    var s = String(n).split('.'),
        v0 = !s[1];
    if (ord) return 'other';
    return n == 1 && v0 ? 'one' : 'other';
  };

  var e = function e(n, ord) {
    return 'other';
  };

  var f = function f(n, ord) {
    if (ord) return 'other';
    return n == 1 ? 'one' : n == 2 ? 'two' : 'other';
  };

  (function (root, plurals) {
    Object.defineProperty(plurals, '__esModule', {
      value: true
    });
    module.exports = plurals;
  })(commonjsGlobal, {
    _in: e,
    af: a,
    ak: b,
    am: c,
    an: a,
    ar: function ar(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n100 = t0 && s[0].slice(-2);
      if (ord) return 'other';
      return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n100 >= 3 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 99 ? 'many' : 'other';
    },
    ars: function ars(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n100 = t0 && s[0].slice(-2);
      if (ord) return 'other';
      return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n100 >= 3 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 99 ? 'many' : 'other';
    },
    as: function as(n, ord) {
      if (ord) return n == 1 || n == 5 || n == 7 || n == 8 || n == 9 || n == 10 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
      return n >= 0 && n <= 1 ? 'one' : 'other';
    },
    asa: a,
    ast: d,
    az: function az(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          i10 = i.slice(-1),
          i100 = i.slice(-2),
          i1000 = i.slice(-3);
      if (ord) return i10 == 1 || i10 == 2 || i10 == 5 || i10 == 7 || i10 == 8 || i100 == 20 || i100 == 50 || i100 == 70 || i100 == 80 ? 'one' : i10 == 3 || i10 == 4 || i1000 == 100 || i1000 == 200 || i1000 == 300 || i1000 == 400 || i1000 == 500 || i1000 == 600 || i1000 == 700 || i1000 == 800 || i1000 == 900 ? 'few' : i == 0 || i10 == 6 || i100 == 40 || i100 == 60 || i100 == 90 ? 'many' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    be: function be(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2);
      if (ord) return (n10 == 2 || n10 == 3) && n100 != 12 && n100 != 13 ? 'few' : 'other';
      return n10 == 1 && n100 != 11 ? 'one' : n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14) ? 'few' : t0 && n10 == 0 || n10 >= 5 && n10 <= 9 || n100 >= 11 && n100 <= 14 ? 'many' : 'other';
    },
    bem: a,
    bez: a,
    bg: a,
    bho: b,
    bm: e,
    bn: function bn(n, ord) {
      if (ord) return n == 1 || n == 5 || n == 7 || n == 8 || n == 9 || n == 10 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
      return n >= 0 && n <= 1 ? 'one' : 'other';
    },
    bo: e,
    br: function br(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2),
          n1000000 = t0 && s[0].slice(-6);
      if (ord) return 'other';
      return n10 == 1 && n100 != 11 && n100 != 71 && n100 != 91 ? 'one' : n10 == 2 && n100 != 12 && n100 != 72 && n100 != 92 ? 'two' : (n10 == 3 || n10 == 4 || n10 == 9) && (n100 < 10 || n100 > 19) && (n100 < 70 || n100 > 79) && (n100 < 90 || n100 > 99) ? 'few' : n != 0 && t0 && n1000000 == 0 ? 'many' : 'other';
    },
    brx: a,
    bs: function bs(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2),
          f10 = f.slice(-1),
          f100 = f.slice(-2);
      if (ord) return 'other';
      return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
    },
    ca: function ca(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1];
      if (ord) return n == 1 || n == 3 ? 'one' : n == 2 ? 'two' : n == 4 ? 'few' : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
    ce: a,
    ceb: function ceb(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          f10 = f.slice(-1);
      if (ord) return 'other';
      return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
    },
    cgg: a,
    chr: a,
    ckb: a,
    cs: function cs(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1];
      if (ord) return 'other';
      return n == 1 && v0 ? 'one' : i >= 2 && i <= 4 && v0 ? 'few' : !v0 ? 'many' : 'other';
    },
    cy: function cy(n, ord) {
      if (ord) return n == 0 || n == 7 || n == 8 || n == 9 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n == 3 || n == 4 ? 'few' : n == 5 || n == 6 ? 'many' : 'other';
      return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n == 3 ? 'few' : n == 6 ? 'many' : 'other';
    },
    da: function da(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          t0 = Number(s[0]) == n;
      if (ord) return 'other';
      return n == 1 || !t0 && (i == 0 || i == 1) ? 'one' : 'other';
    },
    de: d,
    doi: c,
    dsb: function dsb(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i100 = i.slice(-2),
          f100 = f.slice(-2);
      if (ord) return 'other';
      return v0 && i100 == 1 || f100 == 1 ? 'one' : v0 && i100 == 2 || f100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || f100 == 3 || f100 == 4 ? 'few' : 'other';
    },
    dv: a,
    dz: e,
    ee: a,
    el: a,
    en: function en(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2);
      if (ord) return n10 == 1 && n100 != 11 ? 'one' : n10 == 2 && n100 != 12 ? 'two' : n10 == 3 && n100 != 13 ? 'few' : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
    eo: a,
    es: a,
    et: d,
    eu: a,
    fa: c,
    ff: function ff(n, ord) {
      if (ord) return 'other';
      return n >= 0 && n < 2 ? 'one' : 'other';
    },
    fi: d,
    fil: function fil(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          f10 = f.slice(-1);
      if (ord) return n == 1 ? 'one' : 'other';
      return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
    },
    fo: a,
    fr: function fr(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          i1000000 = i.slice(-6);
      if (ord) return n == 1 ? 'one' : 'other';
      return n >= 0 && n < 2 ? 'one' : i != 0 && i1000000 == 0 && v0 ? 'many' : 'other';
    },
    fur: a,
    fy: d,
    ga: function ga(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n;
      if (ord) return n == 1 ? 'one' : 'other';
      return n == 1 ? 'one' : n == 2 ? 'two' : t0 && n >= 3 && n <= 6 ? 'few' : t0 && n >= 7 && n <= 10 ? 'many' : 'other';
    },
    gd: function gd(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n;
      if (ord) return n == 1 || n == 11 ? 'one' : n == 2 || n == 12 ? 'two' : n == 3 || n == 13 ? 'few' : 'other';
      return n == 1 || n == 11 ? 'one' : n == 2 || n == 12 ? 'two' : t0 && n >= 3 && n <= 10 || t0 && n >= 13 && n <= 19 ? 'few' : 'other';
    },
    gl: d,
    gsw: a,
    gu: function gu(n, ord) {
      if (ord) return n == 1 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
      return n >= 0 && n <= 1 ? 'one' : 'other';
    },
    guw: b,
    gv: function gv(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2);
      if (ord) return 'other';
      return v0 && i10 == 1 ? 'one' : v0 && i10 == 2 ? 'two' : v0 && (i100 == 0 || i100 == 20 || i100 == 40 || i100 == 60 || i100 == 80) ? 'few' : !v0 ? 'many' : 'other';
    },
    ha: a,
    haw: a,
    he: function he(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1);
      if (ord) return 'other';
      return n == 1 && v0 ? 'one' : i == 2 && v0 ? 'two' : v0 && (n < 0 || n > 10) && t0 && n10 == 0 ? 'many' : 'other';
    },
    hi: function hi(n, ord) {
      if (ord) return n == 1 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
      return n >= 0 && n <= 1 ? 'one' : 'other';
    },
    hr: function hr(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2),
          f10 = f.slice(-1),
          f100 = f.slice(-2);
      if (ord) return 'other';
      return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
    },
    hsb: function hsb(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i100 = i.slice(-2),
          f100 = f.slice(-2);
      if (ord) return 'other';
      return v0 && i100 == 1 || f100 == 1 ? 'one' : v0 && i100 == 2 || f100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || f100 == 3 || f100 == 4 ? 'few' : 'other';
    },
    hu: function hu(n, ord) {
      if (ord) return n == 1 || n == 5 ? 'one' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    hy: function hy(n, ord) {
      if (ord) return n == 1 ? 'one' : 'other';
      return n >= 0 && n < 2 ? 'one' : 'other';
    },
    ia: d,
    id: e,
    ig: e,
    ii: e,
    io: d,
    is: function is(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          t0 = Number(s[0]) == n,
          i10 = i.slice(-1),
          i100 = i.slice(-2);
      if (ord) return 'other';
      return t0 && i10 == 1 && i100 != 11 || !t0 ? 'one' : 'other';
    },
    it: function it(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1];
      if (ord) return n == 11 || n == 8 || n == 80 || n == 800 ? 'many' : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
    iu: f,
    iw: function iw(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1);
      if (ord) return 'other';
      return n == 1 && v0 ? 'one' : i == 2 && v0 ? 'two' : v0 && (n < 0 || n > 10) && t0 && n10 == 0 ? 'many' : 'other';
    },
    ja: e,
    jbo: e,
    jgo: a,
    ji: d,
    jmc: a,
    jv: e,
    jw: e,
    ka: function ka(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          i100 = i.slice(-2);
      if (ord) return i == 1 ? 'one' : i == 0 || i100 >= 2 && i100 <= 20 || i100 == 40 || i100 == 60 || i100 == 80 ? 'many' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    kab: function kab(n, ord) {
      if (ord) return 'other';
      return n >= 0 && n < 2 ? 'one' : 'other';
    },
    kaj: a,
    kcg: a,
    kde: e,
    kea: e,
    kk: function kk(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1);
      if (ord) return n10 == 6 || n10 == 9 || t0 && n10 == 0 && n != 0 ? 'many' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    kkj: a,
    kl: a,
    km: e,
    kn: c,
    ko: e,
    ks: a,
    ksb: a,
    ksh: function ksh(n, ord) {
      if (ord) return 'other';
      return n == 0 ? 'zero' : n == 1 ? 'one' : 'other';
    },
    ku: a,
    kw: function kw(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n100 = t0 && s[0].slice(-2),
          n1000 = t0 && s[0].slice(-3),
          n100000 = t0 && s[0].slice(-5),
          n1000000 = t0 && s[0].slice(-6);
      if (ord) return t0 && n >= 1 && n <= 4 || n100 >= 1 && n100 <= 4 || n100 >= 21 && n100 <= 24 || n100 >= 41 && n100 <= 44 || n100 >= 61 && n100 <= 64 || n100 >= 81 && n100 <= 84 ? 'one' : n == 5 || n100 == 5 ? 'many' : 'other';
      return n == 0 ? 'zero' : n == 1 ? 'one' : n100 == 2 || n100 == 22 || n100 == 42 || n100 == 62 || n100 == 82 || t0 && n1000 == 0 && (n100000 >= 1000 && n100000 <= 20000 || n100000 == 40000 || n100000 == 60000 || n100000 == 80000) || n != 0 && n1000000 == 100000 ? 'two' : n100 == 3 || n100 == 23 || n100 == 43 || n100 == 63 || n100 == 83 ? 'few' : n != 1 && (n100 == 1 || n100 == 21 || n100 == 41 || n100 == 61 || n100 == 81) ? 'many' : 'other';
    },
    ky: a,
    lag: function lag(n, ord) {
      var s = String(n).split('.'),
          i = s[0];
      if (ord) return 'other';
      return n == 0 ? 'zero' : (i == 0 || i == 1) && n != 0 ? 'one' : 'other';
    },
    lb: a,
    lg: a,
    lij: function lij(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1],
          t0 = Number(s[0]) == n;
      if (ord) return n == 11 || n == 8 || t0 && n >= 80 && n <= 89 || t0 && n >= 800 && n <= 899 ? 'many' : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
    lkt: e,
    ln: b,
    lo: function lo(n, ord) {
      if (ord) return n == 1 ? 'one' : 'other';
      return 'other';
    },
    lt: function lt(n, ord) {
      var s = String(n).split('.'),
          f = s[1] || '',
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2);
      if (ord) return 'other';
      return n10 == 1 && (n100 < 11 || n100 > 19) ? 'one' : n10 >= 2 && n10 <= 9 && (n100 < 11 || n100 > 19) ? 'few' : f != 0 ? 'many' : 'other';
    },
    lv: function lv(n, ord) {
      var s = String(n).split('.'),
          f = s[1] || '',
          v = f.length,
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2),
          f100 = f.slice(-2),
          f10 = f.slice(-1);
      if (ord) return 'other';
      return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && f100 >= 11 && f100 <= 19 ? 'zero' : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? 'one' : 'other';
    },
    mas: a,
    mg: b,
    mgo: a,
    mk: function mk(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2),
          f10 = f.slice(-1),
          f100 = f.slice(-2);
      if (ord) return i10 == 1 && i100 != 11 ? 'one' : i10 == 2 && i100 != 12 ? 'two' : (i10 == 7 || i10 == 8) && i100 != 17 && i100 != 18 ? 'many' : 'other';
      return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : 'other';
    },
    ml: a,
    mn: a,
    mo: function mo(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n100 = t0 && s[0].slice(-2);
      if (ord) return n == 1 ? 'one' : 'other';
      return n == 1 && v0 ? 'one' : !v0 || n == 0 || n100 >= 2 && n100 <= 19 ? 'few' : 'other';
    },
    mr: function mr(n, ord) {
      if (ord) return n == 1 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    ms: function ms(n, ord) {
      if (ord) return n == 1 ? 'one' : 'other';
      return 'other';
    },
    mt: function mt(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n100 = t0 && s[0].slice(-2);
      if (ord) return 'other';
      return n == 1 ? 'one' : n == 0 || n100 >= 2 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 19 ? 'many' : 'other';
    },
    my: e,
    nah: a,
    naq: f,
    nb: a,
    nd: a,
    ne: function ne(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n;
      if (ord) return t0 && n >= 1 && n <= 4 ? 'one' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    nl: d,
    nn: a,
    nnh: a,
    no: a,
    nqo: e,
    nr: a,
    nso: b,
    ny: a,
    nyn: a,
    om: a,
    or: function or(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n;
      if (ord) return n == 1 || n == 5 || t0 && n >= 7 && n <= 9 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    os: a,
    osa: e,
    pa: b,
    pap: a,
    pcm: c,
    pl: function pl(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2);
      if (ord) return 'other';
      return n == 1 && v0 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i != 1 && (i10 == 0 || i10 == 1) || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 12 && i100 <= 14 ? 'many' : 'other';
    },
    prg: function prg(n, ord) {
      var s = String(n).split('.'),
          f = s[1] || '',
          v = f.length,
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2),
          f100 = f.slice(-2),
          f10 = f.slice(-1);
      if (ord) return 'other';
      return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && f100 >= 11 && f100 <= 19 ? 'zero' : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? 'one' : 'other';
    },
    ps: a,
    pt: function pt(n, ord) {
      var s = String(n).split('.'),
          i = s[0];
      if (ord) return 'other';
      return i == 0 || i == 1 ? 'one' : 'other';
    },
    pt_PT: d,
    rm: a,
    ro: function ro(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n100 = t0 && s[0].slice(-2);
      if (ord) return n == 1 ? 'one' : 'other';
      return n == 1 && v0 ? 'one' : !v0 || n == 0 || n100 >= 2 && n100 <= 19 ? 'few' : 'other';
    },
    rof: a,
    root: e,
    ru: function ru(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2);
      if (ord) return 'other';
      return v0 && i10 == 1 && i100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? 'many' : 'other';
    },
    rwk: a,
    sah: e,
    saq: a,
    sat: f,
    sc: function sc(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1];
      if (ord) return n == 11 || n == 8 || n == 80 || n == 800 ? 'many' : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
    scn: function scn(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1];
      if (ord) return n == 11 || n == 8 || n == 80 || n == 800 ? 'many' : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
    sd: a,
    sdh: a,
    se: f,
    seh: a,
    ses: e,
    sg: e,
    sh: function sh(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2),
          f10 = f.slice(-1),
          f100 = f.slice(-2);
      if (ord) return 'other';
      return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
    },
    shi: function shi(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n;
      if (ord) return 'other';
      return n >= 0 && n <= 1 ? 'one' : t0 && n >= 2 && n <= 10 ? 'few' : 'other';
    },
    si: function si(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '';
      if (ord) return 'other';
      return n == 0 || n == 1 || i == 0 && f == 1 ? 'one' : 'other';
    },
    sk: function sk(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1];
      if (ord) return 'other';
      return n == 1 && v0 ? 'one' : i >= 2 && i <= 4 && v0 ? 'few' : !v0 ? 'many' : 'other';
    },
    sl: function sl(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          i100 = i.slice(-2);
      if (ord) return 'other';
      return v0 && i100 == 1 ? 'one' : v0 && i100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || !v0 ? 'few' : 'other';
    },
    sma: f,
    smi: f,
    smj: f,
    smn: f,
    sms: f,
    sn: a,
    so: a,
    sq: function sq(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2);
      if (ord) return n == 1 ? 'one' : n10 == 4 && n100 != 14 ? 'many' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    sr: function sr(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          i100 = i.slice(-2),
          f10 = f.slice(-1),
          f100 = f.slice(-2);
      if (ord) return 'other';
      return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
    },
    ss: a,
    ssy: a,
    st: a,
    su: e,
    sv: function sv(n, ord) {
      var s = String(n).split('.'),
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2);
      if (ord) return (n10 == 1 || n10 == 2) && n100 != 11 && n100 != 12 ? 'one' : 'other';
      return n == 1 && v0 ? 'one' : 'other';
    },
    sw: d,
    syr: a,
    ta: a,
    te: a,
    teo: a,
    th: e,
    ti: b,
    tig: a,
    tk: function tk(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1);
      if (ord) return n10 == 6 || n10 == 9 || n == 10 ? 'few' : 'other';
      return n == 1 ? 'one' : 'other';
    },
    tl: function tl(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          f = s[1] || '',
          v0 = !s[1],
          i10 = i.slice(-1),
          f10 = f.slice(-1);
      if (ord) return n == 1 ? 'one' : 'other';
      return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
    },
    tn: a,
    to: e,
    tr: a,
    ts: a,
    tzm: function tzm(n, ord) {
      var s = String(n).split('.'),
          t0 = Number(s[0]) == n;
      if (ord) return 'other';
      return n == 0 || n == 1 || t0 && n >= 11 && n <= 99 ? 'one' : 'other';
    },
    ug: a,
    uk: function uk(n, ord) {
      var s = String(n).split('.'),
          i = s[0],
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2),
          i10 = i.slice(-1),
          i100 = i.slice(-2);
      if (ord) return n10 == 3 && n100 != 13 ? 'few' : 'other';
      return v0 && i10 == 1 && i100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? 'many' : 'other';
    },
    ur: d,
    uz: a,
    ve: a,
    vi: function vi(n, ord) {
      if (ord) return n == 1 ? 'one' : 'other';
      return 'other';
    },
    vo: a,
    vun: a,
    wa: b,
    wae: a,
    wo: e,
    xh: a,
    xog: a,
    yi: d,
    yo: e,
    yue: e,
    zh: e,
    zu: c
  });
})(plurals$1);

var plurals = /*@__PURE__*/getDefaultExportFromCjs(plurals$1.exports);

var P = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), plurals$1.exports, {
  'default': plurals
}));

var pluralCategories$1 = {exports: {}};

(function (module, exports) {
  var z = "zero",
      o = "one",
      t = "two",
      f = "few",
      m = "many",
      x = "other";
  var a = {
    cardinal: [o, x],
    ordinal: [x]
  };
  var b = {
    cardinal: [x],
    ordinal: [x]
  };
  var c = {
    cardinal: [o, f, m, x],
    ordinal: [x]
  };
  var d = {
    cardinal: [o, x],
    ordinal: [o, x]
  };
  var e = {
    cardinal: [o, t, x],
    ordinal: [x]
  };

  (function (root, pluralCategories) {
    Object.defineProperty(pluralCategories, '__esModule', {
      value: true
    });
    module.exports = pluralCategories;
  })(commonjsGlobal, {
    _in: b,
    af: a,
    ak: a,
    am: a,
    an: a,
    ar: {
      cardinal: [z, o, t, f, m, x],
      ordinal: [x]
    },
    ars: {
      cardinal: [z, o, t, f, m, x],
      ordinal: [x]
    },
    as: {
      cardinal: [o, x],
      ordinal: [o, t, f, m, x]
    },
    asa: a,
    ast: a,
    az: {
      cardinal: [o, x],
      ordinal: [o, f, m, x]
    },
    be: {
      cardinal: [o, f, m, x],
      ordinal: [f, x]
    },
    bem: a,
    bez: a,
    bg: a,
    bho: a,
    bm: b,
    bn: {
      cardinal: [o, x],
      ordinal: [o, t, f, m, x]
    },
    bo: b,
    br: {
      cardinal: [o, t, f, m, x],
      ordinal: [x]
    },
    brx: a,
    bs: {
      cardinal: [o, f, x],
      ordinal: [x]
    },
    ca: {
      cardinal: [o, x],
      ordinal: [o, t, f, x]
    },
    ce: a,
    ceb: a,
    cgg: a,
    chr: a,
    ckb: a,
    cs: c,
    cy: {
      cardinal: [z, o, t, f, m, x],
      ordinal: [z, o, t, f, m, x]
    },
    da: a,
    de: a,
    doi: a,
    dsb: {
      cardinal: [o, t, f, x],
      ordinal: [x]
    },
    dv: a,
    dz: b,
    ee: a,
    el: a,
    en: {
      cardinal: [o, x],
      ordinal: [o, t, f, x]
    },
    eo: a,
    es: a,
    et: a,
    eu: a,
    fa: a,
    ff: a,
    fi: a,
    fil: d,
    fo: a,
    fr: {
      cardinal: [o, m, x],
      ordinal: [o, x]
    },
    fur: a,
    fy: a,
    ga: {
      cardinal: [o, t, f, m, x],
      ordinal: [o, x]
    },
    gd: {
      cardinal: [o, t, f, x],
      ordinal: [o, t, f, x]
    },
    gl: a,
    gsw: a,
    gu: {
      cardinal: [o, x],
      ordinal: [o, t, f, m, x]
    },
    guw: a,
    gv: {
      cardinal: [o, t, f, m, x],
      ordinal: [x]
    },
    ha: a,
    haw: a,
    he: {
      cardinal: [o, t, m, x],
      ordinal: [x]
    },
    hi: {
      cardinal: [o, x],
      ordinal: [o, t, f, m, x]
    },
    hr: {
      cardinal: [o, f, x],
      ordinal: [x]
    },
    hsb: {
      cardinal: [o, t, f, x],
      ordinal: [x]
    },
    hu: d,
    hy: d,
    ia: a,
    id: b,
    ig: b,
    ii: b,
    io: a,
    is: a,
    it: {
      cardinal: [o, x],
      ordinal: [m, x]
    },
    iu: e,
    iw: {
      cardinal: [o, t, m, x],
      ordinal: [x]
    },
    ja: b,
    jbo: b,
    jgo: a,
    ji: a,
    jmc: a,
    jv: b,
    jw: b,
    ka: {
      cardinal: [o, x],
      ordinal: [o, m, x]
    },
    kab: a,
    kaj: a,
    kcg: a,
    kde: b,
    kea: b,
    kk: {
      cardinal: [o, x],
      ordinal: [m, x]
    },
    kkj: a,
    kl: a,
    km: b,
    kn: a,
    ko: b,
    ks: a,
    ksb: a,
    ksh: {
      cardinal: [z, o, x],
      ordinal: [x]
    },
    ku: a,
    kw: {
      cardinal: [z, o, t, f, m, x],
      ordinal: [o, m, x]
    },
    ky: a,
    lag: {
      cardinal: [z, o, x],
      ordinal: [x]
    },
    lb: a,
    lg: a,
    lij: {
      cardinal: [o, x],
      ordinal: [m, x]
    },
    lkt: b,
    ln: a,
    lo: {
      cardinal: [x],
      ordinal: [o, x]
    },
    lt: c,
    lv: {
      cardinal: [z, o, x],
      ordinal: [x]
    },
    mas: a,
    mg: a,
    mgo: a,
    mk: {
      cardinal: [o, x],
      ordinal: [o, t, m, x]
    },
    ml: a,
    mn: a,
    mo: {
      cardinal: [o, f, x],
      ordinal: [o, x]
    },
    mr: {
      cardinal: [o, x],
      ordinal: [o, t, f, x]
    },
    ms: {
      cardinal: [x],
      ordinal: [o, x]
    },
    mt: c,
    my: b,
    nah: a,
    naq: e,
    nb: a,
    nd: a,
    ne: d,
    nl: a,
    nn: a,
    nnh: a,
    no: a,
    nqo: b,
    nr: a,
    nso: a,
    ny: a,
    nyn: a,
    om: a,
    or: {
      cardinal: [o, x],
      ordinal: [o, t, f, m, x]
    },
    os: a,
    osa: b,
    pa: a,
    pap: a,
    pcm: a,
    pl: c,
    prg: {
      cardinal: [z, o, x],
      ordinal: [x]
    },
    ps: a,
    pt: a,
    pt_PT: a,
    rm: a,
    ro: {
      cardinal: [o, f, x],
      ordinal: [o, x]
    },
    rof: a,
    root: b,
    ru: c,
    rwk: a,
    sah: b,
    saq: a,
    sat: e,
    sc: {
      cardinal: [o, x],
      ordinal: [m, x]
    },
    scn: {
      cardinal: [o, x],
      ordinal: [m, x]
    },
    sd: a,
    sdh: a,
    se: e,
    seh: a,
    ses: b,
    sg: b,
    sh: {
      cardinal: [o, f, x],
      ordinal: [x]
    },
    shi: {
      cardinal: [o, f, x],
      ordinal: [x]
    },
    si: a,
    sk: c,
    sl: {
      cardinal: [o, t, f, x],
      ordinal: [x]
    },
    sma: e,
    smi: e,
    smj: e,
    smn: e,
    sms: e,
    sn: a,
    so: a,
    sq: {
      cardinal: [o, x],
      ordinal: [o, m, x]
    },
    sr: {
      cardinal: [o, f, x],
      ordinal: [x]
    },
    ss: a,
    ssy: a,
    st: a,
    su: b,
    sv: d,
    sw: a,
    syr: a,
    ta: a,
    te: a,
    teo: a,
    th: b,
    ti: a,
    tig: a,
    tk: {
      cardinal: [o, x],
      ordinal: [f, x]
    },
    tl: d,
    tn: a,
    to: b,
    tr: a,
    ts: a,
    tzm: a,
    ug: a,
    uk: {
      cardinal: [o, f, m, x],
      ordinal: [f, x]
    },
    ur: a,
    uz: a,
    ve: a,
    vi: {
      cardinal: [x],
      ordinal: [o, x]
    },
    vo: a,
    vun: a,
    wa: a,
    wae: a,
    wo: b,
    xh: a,
    xog: a,
    yi: a,
    yo: b,
    yue: b,
    zh: b,
    zu: a
  });
})(pluralCategories$1);

var pluralCategories = /*@__PURE__*/getDefaultExportFromCjs(pluralCategories$1.exports);

var C = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.assign(/*#__PURE__*/Object.create(null), pluralCategories$1.exports, {
  'default': pluralCategories
}));

// using them here because with this many small functions, bundlers produce less
// cruft than for ES module exports.

var Plurals = plurals || P;
var Categories = pluralCategories || C;
/* istanbul ignore next */

var NumberFormat = (typeof Intl === "undefined" ? "undefined" : _typeof(Intl)) === 'object' && Intl.NumberFormat || PseudoNumberFormat__default['default']; // make-plural exports are cast with safe-identifier to be valid JS identifiers

var id = function id(lc) {
  return lc === 'in' ? '_in' : lc === 'pt-PT' ? 'pt_PT' : lc;
};

var getSelector = function getSelector(lc) {
  return Plurals[id(lc)];
};

var getCategories = function getCategories(lc, ord) {
  return Categories[id(lc)][ord ? 'ordinal' : 'cardinal'];
};

var PluralRules = getPluralRules__default['default'](NumberFormat, getSelector, getCategories);

module.exports = PluralRules;


/***/ }),

/***/ 9071:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var PluralRules = __webpack_require__(67006);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PluralRules__default = /*#__PURE__*/_interopDefaultLegacy(PluralRules);

if (typeof Intl === 'undefined') {
  if (typeof __webpack_require__.g !== 'undefined') {
    __webpack_require__.g.Intl = {
      PluralRules: PluralRules__default['default']
    };
  } else if (typeof window !== 'undefined') {
    window.Intl = {
      PluralRules: PluralRules__default['default']
    };
  } else {
    __webpack_unused_export__ = {
      PluralRules: PluralRules__default['default']
    };
  }

  PluralRules__default['default'].polyfill = true;
} else if (!Intl.PluralRules) {
  Intl.PluralRules = PluralRules__default['default'];
  PluralRules__default['default'].polyfill = true;
} else {
  var test = ['en', 'es', 'ru', 'zh'];
  var supported = Intl.PluralRules.supportedLocalesOf(test);

  if (supported.length < test.length) {
    Intl.PluralRules = PluralRules__default['default'];
    PluralRules__default['default'].polyfill = true;
  }
}


/***/ }),

/***/ 83961:
/***/ (function(module) {

"use strict";


function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var PseudoNumberFormat = /*#__PURE__*/function () {
  function PseudoNumberFormat(lc, // locale is ignored; always use 'en'
  _ref) {
    var minID = _ref.minimumIntegerDigits,
        minFD = _ref.minimumFractionDigits,
        maxFD = _ref.maximumFractionDigits,
        minSD = _ref.minimumSignificantDigits,
        maxSD = _ref.maximumSignificantDigits;

    _classCallCheck(this, PseudoNumberFormat);

    this._minID = typeof minID === 'number' ? minID : 1;
    this._minFD = typeof minFD === 'number' ? minFD : 0;
    this._maxFD = typeof maxFD === 'number' ? maxFD : Math.max(this._minFD, 3);

    if (typeof minSD === 'number' || typeof maxSD === 'number') {
      this._minSD = typeof minSD === 'number' ? minSD : 1;
      this._maxSD = typeof maxSD === 'number' ? maxSD : 21;
    }
  }

  _createClass(PseudoNumberFormat, [{
    key: "resolvedOptions",
    value: function resolvedOptions() {
      var opt = {
        minimumIntegerDigits: this._minID,
        minimumFractionDigits: this._minFD,
        maximumFractionDigits: this._maxFD
      };

      if (typeof this._minSD === 'number') {
        opt.minimumSignificantDigits = this._minSD;
        opt.maximumSignificantDigits = this._maxSD;
      }

      return opt;
    }
  }, {
    key: "format",
    value: function format(n) {
      if (this._minSD) {
        var raw = String(n);
        var prec = 0;

        for (var i = 0; i < raw.length; ++i) {
          var c = raw[i];
          if (c >= '0' && c <= '9') ++prec;
        }

        if (prec < this._minSD) return n.toPrecision(this._minSD);
        if (prec > this._maxSD) return n.toPrecision(this._maxSD);
        return raw;
      }

      if (this._minFD > 0) return n.toFixed(this._minFD);
      if (this._maxFD === 0) return n.toFixed(0);
      return String(n);
    }
  }]);

  return PseudoNumberFormat;
}();

module.exports = PseudoNumberFormat;


/***/ }),

/***/ 13659:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 61370:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16774);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 16774:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 79713:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jj": function() { return /* binding */ colorVariants; },
/* harmony export */   "O9": function() { return /* binding */ colors; },
/* harmony export */   "Rw": function() { return /* binding */ TextLinkButton; },
/* harmony export */   "XJ": function() { return /* binding */ Heading2; },
/* harmony export */   "YS": function() { return /* binding */ Caption; },
/* harmony export */   "ZT": function() { return /* binding */ Typography; },
/* harmony export */   "aC": function() { return /* binding */ Heading3; },
/* harmony export */   "by": function() { return /* binding */ Heading5; },
/* harmony export */   "dk": function() { return /* binding */ Description; },
/* harmony export */   "f2": function() { return /* binding */ BodyLarge; },
/* harmony export */   "hh": function() { return /* binding */ TextLink; },
/* harmony export */   "iO": function() { return /* binding */ BodyM; },
/* harmony export */   "k8": function() { return /* binding */ Heading4; },
/* harmony export */   "nL": function() { return /* binding */ Heading1; },
/* harmony export */   "sS": function() { return /* binding */ Display; },
/* harmony export */   "x4": function() { return /* binding */ Small; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony exports BaseIcon, mediaQuery, responsiveProperties, shadows, spacings */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);

var global_css_ts_vanilla = "";
const colors = {
  orange100: "#FFF5E9",
  orange400: "#FFD6A5",
  orange500: "#FFB862",
  orange600: "#FF991F",
  orange700: "#E68A1C",
  deepGreen100: "#E6ECEB",
  deepGreen400: "#9BB1B0",
  deepGreen500: "#517774",
  deepGreen600: "#063D39",
  deepGreen700: "#05312E",
  green100: "#E9F9F6",
  green400: "#A8E6DA",
  green500: "#66D4BF",
  green600: "#25C1A3",
  green700: "#1E9A82",
  lightBlue: "#D6F5FF",
  offWhite: "#F6F6F1",
  greyscale0: "#FFFFFF",
  greyscale50: "#F5F5F5",
  greyscale100: "#E8E8E8",
  greyscale200: "#D4D4D3",
  greyscale300: "#B3B3B2",
  greyscale400: "#737372",
  greyscale500: "#525251",
  greyscale600: "#1D1D1B",
  greyscale900: "#12181E",
  success100: "#F0F9EE",
  success400: "#A4D99A",
  success500: "#85CD79",
  success600: "#67C057",
  success700: "#5DAD4E",
  success800: "#529A46",
  warning100: "#FFF9EC",
  warning400: "#FFD98E",
  warning500: "#FFCD69",
  warning600: "#FFC043",
  warning700: "#E6AD3C",
  warning800: "#CC9A36",
  error100: "#FDEEEE",
  error400: "#F39A9A",
  error500: "#EF7979",
  error600: "#EB5757",
  error700: "#D44E4E",
  error800: "#BC4646",
  white: "#FFFFFF"
};
const spacings = {
  "0": "0px",
  "2xl": "48px",
  "3xl": "64px",
  "4xl": "80px",
  "5xl": "96px",
  auto: "auto",
  l: "24px",
  m: "16px",
  "m-l": "20px",
  s: "8px",
  "s-m": "12px",
  xl: "32px",
  xs: "4px",
  xxs: "2px"
};
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _setPrototypeOf(o, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf(o, p2);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a = [null];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
var PolishedError = /* @__PURE__ */ function(_Error) {
  _inheritsLoose(PolishedError2, _Error);
  function PolishedError2(code) {
    var _this;
    {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    }
    return _assertThisInitialized(_this);
  }
  return PolishedError2;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function colorToInt(color) {
  return Math.round(color * 255);
}
function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }
  if (saturation === 0) {
    return convert(lightness, lightness, lightness);
  }
  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}
var namedColorMap = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function nameToHex(color) {
  if (typeof color !== "string")
    return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function parseToRgb(color) {
  if (typeof color !== "string") {
    throw new PolishedError(3);
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }
    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);
    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }
    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }
  throw new PolishedError(5);
}
var reduceHexValue = function reduceHexValue2(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};
var reduceHexValue$1 = reduceHexValue;
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}
function rgb(value, green, blue) {
  if (typeof value === "number" && typeof green === "number" && typeof blue === "number") {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === "object" && green === void 0 && blue === void 0) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }
  throw new PolishedError(6);
}
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === "string" && typeof secondValue === "number") {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === "number" && typeof secondValue === "number" && typeof thirdValue === "number" && typeof fourthValue === "number") {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === "object" && secondValue === void 0 && thirdValue === void 0 && fourthValue === void 0) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }
  throw new PolishedError(7);
}
function curried(f2, length, acc) {
  return function fn() {
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f2.apply(this, combined) : curried(f2, length, combined);
  };
}
function curry(f2) {
  return curried(f2, f2.length, []);
}
function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
function transparentize(amount, color) {
  if (color === "transparent")
    return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === "number" ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
  });
  return rgba(colorWithAlpha);
}
var curriedTransparentize = /* @__PURE__ */ curry(transparentize);
var curriedTransparentize$1 = curriedTransparentize;
const shadows = {
  floating: `0 6px 24px 0 ${curriedTransparentize$1(0.7, colors.greyscale600)}`,
  lifted: `0 2px 8px 0 ${curriedTransparentize$1(0.7, colors.greyscale600)}`,
  raised: `0 4px 16px 0 ${curriedTransparentize$1(0.7, colors.greyscale600)}`,
  soft: `0 1px 4px 0 ${curriedTransparentize$1(0.7, colors.greyscale600)}`
};
var classnames = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(module) {
  (function() {
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = [];
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg)
          continue;
        var argType = typeof arg;
        if (argType === "string" || argType === "number") {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);
            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === "object") {
          if (arg.toString === Object.prototype.toString) {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }
      return classes.join(" ");
    }
    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);
var cn = classnames.exports;
var sprinkles_css_ts_vanilla = "";
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function(key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var createSprinkles$1 = (composeStyles2) => function() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var sprinklesStyles = Object.assign({}, ...args.map((a) => a.styles));
  var sprinklesKeys = Object.keys(sprinklesStyles);
  var shorthandNames = sprinklesKeys.filter((property) => "mappings" in sprinklesStyles[property]);
  var sprinklesFn = (props) => {
    var classNames = [];
    var shorthands = {};
    var nonShorthands = _objectSpread2$1({}, props);
    var hasShorthands = false;
    for (var shorthand of shorthandNames) {
      var value = props[shorthand];
      if (value != null) {
        var sprinkle = sprinklesStyles[shorthand];
        hasShorthands = true;
        for (var propMapping of sprinkle.mappings) {
          shorthands[propMapping] = value;
          if (nonShorthands[propMapping] == null) {
            delete nonShorthands[propMapping];
          }
        }
      }
    }
    var finalProps = hasShorthands ? _objectSpread2$1(_objectSpread2$1({}, shorthands), nonShorthands) : props;
    for (var prop in finalProps) {
      var propValue = finalProps[prop];
      var _sprinkle = sprinklesStyles[prop];
      try {
        if (_sprinkle.mappings) {
          continue;
        }
        if (typeof propValue === "string" || typeof propValue === "number") {
          if (false)
            {}
          classNames.push(_sprinkle.values[propValue].defaultClass);
        } else if (Array.isArray(propValue)) {
          for (var responsiveIndex = 0; responsiveIndex < propValue.length; responsiveIndex++) {
            var responsiveValue = propValue[responsiveIndex];
            if (responsiveValue != null) {
              var conditionName = _sprinkle.responsiveArray[responsiveIndex];
              if (false)
                {}
              classNames.push(_sprinkle.values[responsiveValue].conditions[conditionName]);
            }
          }
        } else {
          for (var _conditionName in propValue) {
            var _value = propValue[_conditionName];
            if (_value != null) {
              if (false)
                {}
              classNames.push(_sprinkle.values[_value].conditions[_conditionName]);
            }
          }
        }
      } catch (e) {
        throw e;
      }
    }
    return composeStyles2(classNames.join(" "));
  };
  return Object.assign(sprinklesFn, {
    properties: new Set(sprinklesKeys)
  });
};
var composeStyles = (classList) => classList;
var createSprinkles = function createSprinkles2() {
  return createSprinkles$1(composeStyles)(...arguments);
};
var responsiveProperties = { conditions: { defaultCondition: "mobile", conditionNames: ["mobile", "tablet", "desktop"], responsiveArray: void 0 }, styles: { margin: { values: { "0 auto": { conditions: { mobile: "tfghjgbr", tablet: "tfghjgbs", desktop: "tfghjgbt" }, defaultClass: "tfghjgbr" }, auto: { conditions: { mobile: "tfghjgbu", tablet: "tfghjgbv", desktop: "tfghjgbw" }, defaultClass: "tfghjgbu" } } }, padding: { mappings: ["paddingTop", "paddingBottom", "paddingLeft", "paddingRight"] }, marginX: { mappings: ["marginLeft", "marginRight"] }, marginY: { mappings: ["marginTop", "marginBottom"] }, paddingX: { mappings: ["paddingLeft", "paddingRight"] }, paddingY: { mappings: ["paddingTop", "paddingBottom"] }, alignItems: { values: { "flex-start": { conditions: { mobile: "tfghjg0", tablet: "tfghjg1", desktop: "tfghjg2" }, defaultClass: "tfghjg0" }, "flex-end": { conditions: { mobile: "tfghjg3", tablet: "tfghjg4", desktop: "tfghjg5" }, defaultClass: "tfghjg3" }, center: { conditions: { mobile: "tfghjg6", tablet: "tfghjg7", desktop: "tfghjg8" }, defaultClass: "tfghjg6" } } }, alignSelf: { values: { "flex-start": { conditions: { mobile: "tfghjg9", tablet: "tfghjga", desktop: "tfghjgb" }, defaultClass: "tfghjg9" }, "flex-end": { conditions: { mobile: "tfghjgc", tablet: "tfghjgd", desktop: "tfghjge" }, defaultClass: "tfghjgc" }, center: { conditions: { mobile: "tfghjgf", tablet: "tfghjgg", desktop: "tfghjgh" }, defaultClass: "tfghjgf" } } }, border: { values: { "0": { conditions: { mobile: "tfghjgi", tablet: "tfghjgj", desktop: "tfghjgk" }, defaultClass: "tfghjgi" } } }, borderRadius: { values: { "0": { conditions: { mobile: "tfghjgl", tablet: "tfghjgm", desktop: "tfghjgn" }, defaultClass: "tfghjgl" }, "4": { conditions: { mobile: "tfghjgo", tablet: "tfghjgp", desktop: "tfghjgq" }, defaultClass: "tfghjgo" }, "8": { conditions: { mobile: "tfghjgr", tablet: "tfghjgs", desktop: "tfghjgt" }, defaultClass: "tfghjgr" }, "16": { conditions: { mobile: "tfghjgu", tablet: "tfghjgv", desktop: "tfghjgw" }, defaultClass: "tfghjgu" }, "24": { conditions: { mobile: "tfghjgx", tablet: "tfghjgy", desktop: "tfghjgz" }, defaultClass: "tfghjgx" } } }, borderBottomLeftRadius: { values: { "4": { conditions: { mobile: "tfghjg10", tablet: "tfghjg11", desktop: "tfghjg12" }, defaultClass: "tfghjg10" }, "8": { conditions: { mobile: "tfghjg13", tablet: "tfghjg14", desktop: "tfghjg15" }, defaultClass: "tfghjg13" }, "16": { conditions: { mobile: "tfghjg16", tablet: "tfghjg17", desktop: "tfghjg18" }, defaultClass: "tfghjg16" }, "24": { conditions: { mobile: "tfghjg19", tablet: "tfghjg1a", desktop: "tfghjg1b" }, defaultClass: "tfghjg19" } } }, borderTopRightRadius: { values: { "0": { conditions: { mobile: "tfghjg1c", tablet: "tfghjg1d", desktop: "tfghjg1e" }, defaultClass: "tfghjg1c" }, "4": { conditions: { mobile: "tfghjg1f", tablet: "tfghjg1g", desktop: "tfghjg1h" }, defaultClass: "tfghjg1f" }, "8": { conditions: { mobile: "tfghjg1i", tablet: "tfghjg1j", desktop: "tfghjg1k" }, defaultClass: "tfghjg1i" }, "16": { conditions: { mobile: "tfghjg1l", tablet: "tfghjg1m", desktop: "tfghjg1n" }, defaultClass: "tfghjg1l" }, "24": { conditions: { mobile: "tfghjg1o", tablet: "tfghjg1p", desktop: "tfghjg1q" }, defaultClass: "tfghjg1o" } } }, display: { values: { none: { conditions: { mobile: "tfghjg1r", tablet: "tfghjg1s", desktop: "tfghjg1t" }, defaultClass: "tfghjg1r" }, flex: { conditions: { mobile: "tfghjg1u", tablet: "tfghjg1v", desktop: "tfghjg1w" }, defaultClass: "tfghjg1u" }, grid: { conditions: { mobile: "tfghjg1x", tablet: "tfghjg1y", desktop: "tfghjg1z" }, defaultClass: "tfghjg1x" }, block: { conditions: { mobile: "tfghjg20", tablet: "tfghjg21", desktop: "tfghjg22" }, defaultClass: "tfghjg20" }, "inline-block": { conditions: { mobile: "tfghjg23", tablet: "tfghjg24", desktop: "tfghjg25" }, defaultClass: "tfghjg23" } } }, position: { values: { "static": { conditions: { mobile: "tfghjg26", tablet: "tfghjg27", desktop: "tfghjg28" }, defaultClass: "tfghjg26" }, absolute: { conditions: { mobile: "tfghjg29", tablet: "tfghjg2a", desktop: "tfghjg2b" }, defaultClass: "tfghjg29" }, relative: { conditions: { mobile: "tfghjg2c", tablet: "tfghjg2d", desktop: "tfghjg2e" }, defaultClass: "tfghjg2c" } } }, top: { values: { "0": { conditions: { mobile: "tfghjg2f", tablet: "tfghjg2g", desktop: "tfghjg2h" }, defaultClass: "tfghjg2f" }, "2xl": { conditions: { mobile: "tfghjg2i", tablet: "tfghjg2j", desktop: "tfghjg2k" }, defaultClass: "tfghjg2i" }, "3xl": { conditions: { mobile: "tfghjg2l", tablet: "tfghjg2m", desktop: "tfghjg2n" }, defaultClass: "tfghjg2l" }, "4xl": { conditions: { mobile: "tfghjg2o", tablet: "tfghjg2p", desktop: "tfghjg2q" }, defaultClass: "tfghjg2o" }, "5xl": { conditions: { mobile: "tfghjg2r", tablet: "tfghjg2s", desktop: "tfghjg2t" }, defaultClass: "tfghjg2r" }, auto: { conditions: { mobile: "tfghjg2u", tablet: "tfghjg2v", desktop: "tfghjg2w" }, defaultClass: "tfghjg2u" }, l: { conditions: { mobile: "tfghjg2x", tablet: "tfghjg2y", desktop: "tfghjg2z" }, defaultClass: "tfghjg2x" }, m: { conditions: { mobile: "tfghjg30", tablet: "tfghjg31", desktop: "tfghjg32" }, defaultClass: "tfghjg30" }, "m-l": { conditions: { mobile: "tfghjg33", tablet: "tfghjg34", desktop: "tfghjg35" }, defaultClass: "tfghjg33" }, s: { conditions: { mobile: "tfghjg36", tablet: "tfghjg37", desktop: "tfghjg38" }, defaultClass: "tfghjg36" }, "s-m": { conditions: { mobile: "tfghjg39", tablet: "tfghjg3a", desktop: "tfghjg3b" }, defaultClass: "tfghjg39" }, xl: { conditions: { mobile: "tfghjg3c", tablet: "tfghjg3d", desktop: "tfghjg3e" }, defaultClass: "tfghjg3c" }, xs: { conditions: { mobile: "tfghjg3f", tablet: "tfghjg3g", desktop: "tfghjg3h" }, defaultClass: "tfghjg3f" }, xxs: { conditions: { mobile: "tfghjg3i", tablet: "tfghjg3j", desktop: "tfghjg3k" }, defaultClass: "tfghjg3i" } } }, right: { values: { "0": { conditions: { mobile: "tfghjg3l", tablet: "tfghjg3m", desktop: "tfghjg3n" }, defaultClass: "tfghjg3l" }, "2xl": { conditions: { mobile: "tfghjg3o", tablet: "tfghjg3p", desktop: "tfghjg3q" }, defaultClass: "tfghjg3o" }, "3xl": { conditions: { mobile: "tfghjg3r", tablet: "tfghjg3s", desktop: "tfghjg3t" }, defaultClass: "tfghjg3r" }, "4xl": { conditions: { mobile: "tfghjg3u", tablet: "tfghjg3v", desktop: "tfghjg3w" }, defaultClass: "tfghjg3u" }, "5xl": { conditions: { mobile: "tfghjg3x", tablet: "tfghjg3y", desktop: "tfghjg3z" }, defaultClass: "tfghjg3x" }, auto: { conditions: { mobile: "tfghjg40", tablet: "tfghjg41", desktop: "tfghjg42" }, defaultClass: "tfghjg40" }, l: { conditions: { mobile: "tfghjg43", tablet: "tfghjg44", desktop: "tfghjg45" }, defaultClass: "tfghjg43" }, m: { conditions: { mobile: "tfghjg46", tablet: "tfghjg47", desktop: "tfghjg48" }, defaultClass: "tfghjg46" }, "m-l": { conditions: { mobile: "tfghjg49", tablet: "tfghjg4a", desktop: "tfghjg4b" }, defaultClass: "tfghjg49" }, s: { conditions: { mobile: "tfghjg4c", tablet: "tfghjg4d", desktop: "tfghjg4e" }, defaultClass: "tfghjg4c" }, "s-m": { conditions: { mobile: "tfghjg4f", tablet: "tfghjg4g", desktop: "tfghjg4h" }, defaultClass: "tfghjg4f" }, xl: { conditions: { mobile: "tfghjg4i", tablet: "tfghjg4j", desktop: "tfghjg4k" }, defaultClass: "tfghjg4i" }, xs: { conditions: { mobile: "tfghjg4l", tablet: "tfghjg4m", desktop: "tfghjg4n" }, defaultClass: "tfghjg4l" }, xxs: { conditions: { mobile: "tfghjg4o", tablet: "tfghjg4p", desktop: "tfghjg4q" }, defaultClass: "tfghjg4o" } } }, bottom: { values: { "0": { conditions: { mobile: "tfghjg4r", tablet: "tfghjg4s", desktop: "tfghjg4t" }, defaultClass: "tfghjg4r" }, "2xl": { conditions: { mobile: "tfghjg4u", tablet: "tfghjg4v", desktop: "tfghjg4w" }, defaultClass: "tfghjg4u" }, "3xl": { conditions: { mobile: "tfghjg4x", tablet: "tfghjg4y", desktop: "tfghjg4z" }, defaultClass: "tfghjg4x" }, "4xl": { conditions: { mobile: "tfghjg50", tablet: "tfghjg51", desktop: "tfghjg52" }, defaultClass: "tfghjg50" }, "5xl": { conditions: { mobile: "tfghjg53", tablet: "tfghjg54", desktop: "tfghjg55" }, defaultClass: "tfghjg53" }, auto: { conditions: { mobile: "tfghjg56", tablet: "tfghjg57", desktop: "tfghjg58" }, defaultClass: "tfghjg56" }, l: { conditions: { mobile: "tfghjg59", tablet: "tfghjg5a", desktop: "tfghjg5b" }, defaultClass: "tfghjg59" }, m: { conditions: { mobile: "tfghjg5c", tablet: "tfghjg5d", desktop: "tfghjg5e" }, defaultClass: "tfghjg5c" }, "m-l": { conditions: { mobile: "tfghjg5f", tablet: "tfghjg5g", desktop: "tfghjg5h" }, defaultClass: "tfghjg5f" }, s: { conditions: { mobile: "tfghjg5i", tablet: "tfghjg5j", desktop: "tfghjg5k" }, defaultClass: "tfghjg5i" }, "s-m": { conditions: { mobile: "tfghjg5l", tablet: "tfghjg5m", desktop: "tfghjg5n" }, defaultClass: "tfghjg5l" }, xl: { conditions: { mobile: "tfghjg5o", tablet: "tfghjg5p", desktop: "tfghjg5q" }, defaultClass: "tfghjg5o" }, xs: { conditions: { mobile: "tfghjg5r", tablet: "tfghjg5s", desktop: "tfghjg5t" }, defaultClass: "tfghjg5r" }, xxs: { conditions: { mobile: "tfghjg5u", tablet: "tfghjg5v", desktop: "tfghjg5w" }, defaultClass: "tfghjg5u" } } }, left: { values: { "0": { conditions: { mobile: "tfghjg5x", tablet: "tfghjg5y", desktop: "tfghjg5z" }, defaultClass: "tfghjg5x" }, "2xl": { conditions: { mobile: "tfghjg60", tablet: "tfghjg61", desktop: "tfghjg62" }, defaultClass: "tfghjg60" }, "3xl": { conditions: { mobile: "tfghjg63", tablet: "tfghjg64", desktop: "tfghjg65" }, defaultClass: "tfghjg63" }, "4xl": { conditions: { mobile: "tfghjg66", tablet: "tfghjg67", desktop: "tfghjg68" }, defaultClass: "tfghjg66" }, "5xl": { conditions: { mobile: "tfghjg69", tablet: "tfghjg6a", desktop: "tfghjg6b" }, defaultClass: "tfghjg69" }, auto: { conditions: { mobile: "tfghjg6c", tablet: "tfghjg6d", desktop: "tfghjg6e" }, defaultClass: "tfghjg6c" }, l: { conditions: { mobile: "tfghjg6f", tablet: "tfghjg6g", desktop: "tfghjg6h" }, defaultClass: "tfghjg6f" }, m: { conditions: { mobile: "tfghjg6i", tablet: "tfghjg6j", desktop: "tfghjg6k" }, defaultClass: "tfghjg6i" }, "m-l": { conditions: { mobile: "tfghjg6l", tablet: "tfghjg6m", desktop: "tfghjg6n" }, defaultClass: "tfghjg6l" }, s: { conditions: { mobile: "tfghjg6o", tablet: "tfghjg6p", desktop: "tfghjg6q" }, defaultClass: "tfghjg6o" }, "s-m": { conditions: { mobile: "tfghjg6r", tablet: "tfghjg6s", desktop: "tfghjg6t" }, defaultClass: "tfghjg6r" }, xl: { conditions: { mobile: "tfghjg6u", tablet: "tfghjg6v", desktop: "tfghjg6w" }, defaultClass: "tfghjg6u" }, xs: { conditions: { mobile: "tfghjg6x", tablet: "tfghjg6y", desktop: "tfghjg6z" }, defaultClass: "tfghjg6x" }, xxs: { conditions: { mobile: "tfghjg70", tablet: "tfghjg71", desktop: "tfghjg72" }, defaultClass: "tfghjg70" } } }, flex: { values: { "1": { conditions: { mobile: "tfghjg73", tablet: "tfghjg74", desktop: "tfghjg75" }, defaultClass: "tfghjg73" } } }, flexBasis: { values: { "100%": { conditions: { mobile: "tfghjg76", tablet: "tfghjg77", desktop: "tfghjg78" }, defaultClass: "tfghjg76" }, "50%": { conditions: { mobile: "tfghjg79", tablet: "tfghjg7a", desktop: "tfghjg7b" }, defaultClass: "tfghjg79" }, unset: { conditions: { mobile: "tfghjg7c", tablet: "tfghjg7d", desktop: "tfghjg7e" }, defaultClass: "tfghjg7c" } } }, flexDirection: { values: { "row-reverse": { conditions: { mobile: "tfghjg7f", tablet: "tfghjg7g", desktop: "tfghjg7h" }, defaultClass: "tfghjg7f" }, row: { conditions: { mobile: "tfghjg7i", tablet: "tfghjg7j", desktop: "tfghjg7k" }, defaultClass: "tfghjg7i" }, column: { conditions: { mobile: "tfghjg7l", tablet: "tfghjg7m", desktop: "tfghjg7n" }, defaultClass: "tfghjg7l" } } }, flexGrow: { values: { "0": { conditions: { mobile: "tfghjg7r", tablet: "tfghjg7s", desktop: "tfghjg7t" }, defaultClass: "tfghjg7r" }, "1": { conditions: { mobile: "tfghjg7o", tablet: "tfghjg7p", desktop: "tfghjg7q" }, defaultClass: "tfghjg7o" } } }, flexShrink: { values: { "0": { conditions: { mobile: "tfghjg7x", tablet: "tfghjg7y", desktop: "tfghjg7z" }, defaultClass: "tfghjg7x" }, "1": { conditions: { mobile: "tfghjg7u", tablet: "tfghjg7v", desktop: "tfghjg7w" }, defaultClass: "tfghjg7u" } } }, flexWrap: { values: { wrap: { conditions: { mobile: "tfghjg80", tablet: "tfghjg81", desktop: "tfghjg82" }, defaultClass: "tfghjg80" }, nowrap: { conditions: { mobile: "tfghjg83", tablet: "tfghjg84", desktop: "tfghjg85" }, defaultClass: "tfghjg83" } } }, fontWeight: { values: { "300": { conditions: { mobile: "tfghjg86", tablet: "tfghjg87", desktop: "tfghjg88" }, defaultClass: "tfghjg86" }, "400": { conditions: { mobile: "tfghjg89", tablet: "tfghjg8a", desktop: "tfghjg8b" }, defaultClass: "tfghjg89" }, "600": { conditions: { mobile: "tfghjg8c", tablet: "tfghjg8d", desktop: "tfghjg8e" }, defaultClass: "tfghjg8c" } } }, cursor: { values: { pointer: { conditions: { mobile: "tfghjg8f", tablet: "tfghjg8g", desktop: "tfghjg8h" }, defaultClass: "tfghjg8f" }, "not-allowed": { conditions: { mobile: "tfghjg8i", tablet: "tfghjg8j", desktop: "tfghjg8k" }, defaultClass: "tfghjg8i" } } }, textDecoration: { values: { underline: { conditions: { mobile: "tfghjg8l", tablet: "tfghjg8m", desktop: "tfghjg8n" }, defaultClass: "tfghjg8l" } } }, verticalAlign: { values: { baseline: { conditions: { mobile: "tfghjg8o", tablet: "tfghjg8p", desktop: "tfghjg8q" }, defaultClass: "tfghjg8o" }, center: { conditions: { mobile: "tfghjg8r", tablet: "tfghjg8s", desktop: "tfghjg8t" }, defaultClass: "tfghjg8r" } } }, gap: { values: { "0": { conditions: { mobile: "tfghjg8u", tablet: "tfghjg8v", desktop: "tfghjg8w" }, defaultClass: "tfghjg8u" }, "2xl": { conditions: { mobile: "tfghjg8x", tablet: "tfghjg8y", desktop: "tfghjg8z" }, defaultClass: "tfghjg8x" }, "3xl": { conditions: { mobile: "tfghjg90", tablet: "tfghjg91", desktop: "tfghjg92" }, defaultClass: "tfghjg90" }, "4xl": { conditions: { mobile: "tfghjg93", tablet: "tfghjg94", desktop: "tfghjg95" }, defaultClass: "tfghjg93" }, "5xl": { conditions: { mobile: "tfghjg96", tablet: "tfghjg97", desktop: "tfghjg98" }, defaultClass: "tfghjg96" }, auto: { conditions: { mobile: "tfghjg99", tablet: "tfghjg9a", desktop: "tfghjg9b" }, defaultClass: "tfghjg99" }, l: { conditions: { mobile: "tfghjg9c", tablet: "tfghjg9d", desktop: "tfghjg9e" }, defaultClass: "tfghjg9c" }, m: { conditions: { mobile: "tfghjg9f", tablet: "tfghjg9g", desktop: "tfghjg9h" }, defaultClass: "tfghjg9f" }, "m-l": { conditions: { mobile: "tfghjg9i", tablet: "tfghjg9j", desktop: "tfghjg9k" }, defaultClass: "tfghjg9i" }, s: { conditions: { mobile: "tfghjg9l", tablet: "tfghjg9m", desktop: "tfghjg9n" }, defaultClass: "tfghjg9l" }, "s-m": { conditions: { mobile: "tfghjg9o", tablet: "tfghjg9p", desktop: "tfghjg9q" }, defaultClass: "tfghjg9o" }, xl: { conditions: { mobile: "tfghjg9r", tablet: "tfghjg9s", desktop: "tfghjg9t" }, defaultClass: "tfghjg9r" }, xs: { conditions: { mobile: "tfghjg9u", tablet: "tfghjg9v", desktop: "tfghjg9w" }, defaultClass: "tfghjg9u" }, xxs: { conditions: { mobile: "tfghjg9x", tablet: "tfghjg9y", desktop: "tfghjg9z" }, defaultClass: "tfghjg9x" } } }, height: { values: { "100vh": { conditions: { mobile: "tfghjga0", tablet: "tfghjga1", desktop: "tfghjga2" }, defaultClass: "tfghjga0" }, "100%": { conditions: { mobile: "tfghjga3", tablet: "tfghjga4", desktop: "tfghjga5" }, defaultClass: "tfghjga3" } } }, justifyContent: { values: { "space-between": { conditions: { mobile: "tfghjga6", tablet: "tfghjga7", desktop: "tfghjga8" }, defaultClass: "tfghjga6" }, "space-around": { conditions: { mobile: "tfghjga9", tablet: "tfghjgaa", desktop: "tfghjgab" }, defaultClass: "tfghjga9" }, center: { conditions: { mobile: "tfghjgac", tablet: "tfghjgad", desktop: "tfghjgae" }, defaultClass: "tfghjgac" }, "flex-end": { conditions: { mobile: "tfghjgaf", tablet: "tfghjgag", desktop: "tfghjgah" }, defaultClass: "tfghjgaf" }, "flex-start": { conditions: { mobile: "tfghjgai", tablet: "tfghjgaj", desktop: "tfghjgak" }, defaultClass: "tfghjgai" } } }, marginBottom: { values: { "0": { conditions: { mobile: "tfghjgal", tablet: "tfghjgam", desktop: "tfghjgan" }, defaultClass: "tfghjgal" }, "2xl": { conditions: { mobile: "tfghjgao", tablet: "tfghjgap", desktop: "tfghjgaq" }, defaultClass: "tfghjgao" }, "3xl": { conditions: { mobile: "tfghjgar", tablet: "tfghjgas", desktop: "tfghjgat" }, defaultClass: "tfghjgar" }, "4xl": { conditions: { mobile: "tfghjgau", tablet: "tfghjgav", desktop: "tfghjgaw" }, defaultClass: "tfghjgau" }, "5xl": { conditions: { mobile: "tfghjgax", tablet: "tfghjgay", desktop: "tfghjgaz" }, defaultClass: "tfghjgax" }, auto: { conditions: { mobile: "tfghjgb0", tablet: "tfghjgb1", desktop: "tfghjgb2" }, defaultClass: "tfghjgb0" }, l: { conditions: { mobile: "tfghjgb3", tablet: "tfghjgb4", desktop: "tfghjgb5" }, defaultClass: "tfghjgb3" }, m: { conditions: { mobile: "tfghjgb6", tablet: "tfghjgb7", desktop: "tfghjgb8" }, defaultClass: "tfghjgb6" }, "m-l": { conditions: { mobile: "tfghjgb9", tablet: "tfghjgba", desktop: "tfghjgbb" }, defaultClass: "tfghjgb9" }, s: { conditions: { mobile: "tfghjgbc", tablet: "tfghjgbd", desktop: "tfghjgbe" }, defaultClass: "tfghjgbc" }, "s-m": { conditions: { mobile: "tfghjgbf", tablet: "tfghjgbg", desktop: "tfghjgbh" }, defaultClass: "tfghjgbf" }, xl: { conditions: { mobile: "tfghjgbi", tablet: "tfghjgbj", desktop: "tfghjgbk" }, defaultClass: "tfghjgbi" }, xs: { conditions: { mobile: "tfghjgbl", tablet: "tfghjgbm", desktop: "tfghjgbn" }, defaultClass: "tfghjgbl" }, xxs: { conditions: { mobile: "tfghjgbo", tablet: "tfghjgbp", desktop: "tfghjgbq" }, defaultClass: "tfghjgbo" } } }, marginLeft: { values: { "0": { conditions: { mobile: "tfghjgbx", tablet: "tfghjgby", desktop: "tfghjgbz" }, defaultClass: "tfghjgbx" }, "2xl": { conditions: { mobile: "tfghjgc0", tablet: "tfghjgc1", desktop: "tfghjgc2" }, defaultClass: "tfghjgc0" }, "3xl": { conditions: { mobile: "tfghjgc3", tablet: "tfghjgc4", desktop: "tfghjgc5" }, defaultClass: "tfghjgc3" }, "4xl": { conditions: { mobile: "tfghjgc6", tablet: "tfghjgc7", desktop: "tfghjgc8" }, defaultClass: "tfghjgc6" }, "5xl": { conditions: { mobile: "tfghjgc9", tablet: "tfghjgca", desktop: "tfghjgcb" }, defaultClass: "tfghjgc9" }, auto: { conditions: { mobile: "tfghjgcc", tablet: "tfghjgcd", desktop: "tfghjgce" }, defaultClass: "tfghjgcc" }, l: { conditions: { mobile: "tfghjgcf", tablet: "tfghjgcg", desktop: "tfghjgch" }, defaultClass: "tfghjgcf" }, m: { conditions: { mobile: "tfghjgci", tablet: "tfghjgcj", desktop: "tfghjgck" }, defaultClass: "tfghjgci" }, "m-l": { conditions: { mobile: "tfghjgcl", tablet: "tfghjgcm", desktop: "tfghjgcn" }, defaultClass: "tfghjgcl" }, s: { conditions: { mobile: "tfghjgco", tablet: "tfghjgcp", desktop: "tfghjgcq" }, defaultClass: "tfghjgco" }, "s-m": { conditions: { mobile: "tfghjgcr", tablet: "tfghjgcs", desktop: "tfghjgct" }, defaultClass: "tfghjgcr" }, xl: { conditions: { mobile: "tfghjgcu", tablet: "tfghjgcv", desktop: "tfghjgcw" }, defaultClass: "tfghjgcu" }, xs: { conditions: { mobile: "tfghjgcx", tablet: "tfghjgcy", desktop: "tfghjgcz" }, defaultClass: "tfghjgcx" }, xxs: { conditions: { mobile: "tfghjgd0", tablet: "tfghjgd1", desktop: "tfghjgd2" }, defaultClass: "tfghjgd0" } } }, marginRight: { values: { "0": { conditions: { mobile: "tfghjgd3", tablet: "tfghjgd4", desktop: "tfghjgd5" }, defaultClass: "tfghjgd3" }, "2xl": { conditions: { mobile: "tfghjgd6", tablet: "tfghjgd7", desktop: "tfghjgd8" }, defaultClass: "tfghjgd6" }, "3xl": { conditions: { mobile: "tfghjgd9", tablet: "tfghjgda", desktop: "tfghjgdb" }, defaultClass: "tfghjgd9" }, "4xl": { conditions: { mobile: "tfghjgdc", tablet: "tfghjgdd", desktop: "tfghjgde" }, defaultClass: "tfghjgdc" }, "5xl": { conditions: { mobile: "tfghjgdf", tablet: "tfghjgdg", desktop: "tfghjgdh" }, defaultClass: "tfghjgdf" }, auto: { conditions: { mobile: "tfghjgdi", tablet: "tfghjgdj", desktop: "tfghjgdk" }, defaultClass: "tfghjgdi" }, l: { conditions: { mobile: "tfghjgdl", tablet: "tfghjgdm", desktop: "tfghjgdn" }, defaultClass: "tfghjgdl" }, m: { conditions: { mobile: "tfghjgdo", tablet: "tfghjgdp", desktop: "tfghjgdq" }, defaultClass: "tfghjgdo" }, "m-l": { conditions: { mobile: "tfghjgdr", tablet: "tfghjgds", desktop: "tfghjgdt" }, defaultClass: "tfghjgdr" }, s: { conditions: { mobile: "tfghjgdu", tablet: "tfghjgdv", desktop: "tfghjgdw" }, defaultClass: "tfghjgdu" }, "s-m": { conditions: { mobile: "tfghjgdx", tablet: "tfghjgdy", desktop: "tfghjgdz" }, defaultClass: "tfghjgdx" }, xl: { conditions: { mobile: "tfghjge0", tablet: "tfghjge1", desktop: "tfghjge2" }, defaultClass: "tfghjge0" }, xs: { conditions: { mobile: "tfghjge3", tablet: "tfghjge4", desktop: "tfghjge5" }, defaultClass: "tfghjge3" }, xxs: { conditions: { mobile: "tfghjge6", tablet: "tfghjge7", desktop: "tfghjge8" }, defaultClass: "tfghjge6" } } }, marginTop: { values: { "0": { conditions: { mobile: "tfghjge9", tablet: "tfghjgea", desktop: "tfghjgeb" }, defaultClass: "tfghjge9" }, "2xl": { conditions: { mobile: "tfghjgec", tablet: "tfghjged", desktop: "tfghjgee" }, defaultClass: "tfghjgec" }, "3xl": { conditions: { mobile: "tfghjgef", tablet: "tfghjgeg", desktop: "tfghjgeh" }, defaultClass: "tfghjgef" }, "4xl": { conditions: { mobile: "tfghjgei", tablet: "tfghjgej", desktop: "tfghjgek" }, defaultClass: "tfghjgei" }, "5xl": { conditions: { mobile: "tfghjgel", tablet: "tfghjgem", desktop: "tfghjgen" }, defaultClass: "tfghjgel" }, auto: { conditions: { mobile: "tfghjgeo", tablet: "tfghjgep", desktop: "tfghjgeq" }, defaultClass: "tfghjgeo" }, l: { conditions: { mobile: "tfghjger", tablet: "tfghjges", desktop: "tfghjget" }, defaultClass: "tfghjger" }, m: { conditions: { mobile: "tfghjgeu", tablet: "tfghjgev", desktop: "tfghjgew" }, defaultClass: "tfghjgeu" }, "m-l": { conditions: { mobile: "tfghjgex", tablet: "tfghjgey", desktop: "tfghjgez" }, defaultClass: "tfghjgex" }, s: { conditions: { mobile: "tfghjgf0", tablet: "tfghjgf1", desktop: "tfghjgf2" }, defaultClass: "tfghjgf0" }, "s-m": { conditions: { mobile: "tfghjgf3", tablet: "tfghjgf4", desktop: "tfghjgf5" }, defaultClass: "tfghjgf3" }, xl: { conditions: { mobile: "tfghjgf6", tablet: "tfghjgf7", desktop: "tfghjgf8" }, defaultClass: "tfghjgf6" }, xs: { conditions: { mobile: "tfghjgf9", tablet: "tfghjgfa", desktop: "tfghjgfb" }, defaultClass: "tfghjgf9" }, xxs: { conditions: { mobile: "tfghjgfc", tablet: "tfghjgfd", desktop: "tfghjgfe" }, defaultClass: "tfghjgfc" } } }, overflow: { values: { hidden: { conditions: { mobile: "tfghjgff", tablet: "tfghjgfg", desktop: "tfghjgfh" }, defaultClass: "tfghjgff" }, auto: { conditions: { mobile: "tfghjgfi", tablet: "tfghjgfj", desktop: "tfghjgfk" }, defaultClass: "tfghjgfi" } } }, overflowX: { values: { hidden: { conditions: { mobile: "tfghjgfl", tablet: "tfghjgfm", desktop: "tfghjgfn" }, defaultClass: "tfghjgfl" }, auto: { conditions: { mobile: "tfghjgfo", tablet: "tfghjgfp", desktop: "tfghjgfq" }, defaultClass: "tfghjgfo" } } }, paddingBottom: { values: { "0": { conditions: { mobile: "tfghjgfr", tablet: "tfghjgfs", desktop: "tfghjgft" }, defaultClass: "tfghjgfr" }, "2xl": { conditions: { mobile: "tfghjgfu", tablet: "tfghjgfv", desktop: "tfghjgfw" }, defaultClass: "tfghjgfu" }, "3xl": { conditions: { mobile: "tfghjgfx", tablet: "tfghjgfy", desktop: "tfghjgfz" }, defaultClass: "tfghjgfx" }, "4xl": { conditions: { mobile: "tfghjgg0", tablet: "tfghjgg1", desktop: "tfghjgg2" }, defaultClass: "tfghjgg0" }, "5xl": { conditions: { mobile: "tfghjgg3", tablet: "tfghjgg4", desktop: "tfghjgg5" }, defaultClass: "tfghjgg3" }, auto: { conditions: { mobile: "tfghjgg6", tablet: "tfghjgg7", desktop: "tfghjgg8" }, defaultClass: "tfghjgg6" }, l: { conditions: { mobile: "tfghjgg9", tablet: "tfghjgga", desktop: "tfghjggb" }, defaultClass: "tfghjgg9" }, m: { conditions: { mobile: "tfghjggc", tablet: "tfghjggd", desktop: "tfghjgge" }, defaultClass: "tfghjggc" }, "m-l": { conditions: { mobile: "tfghjggf", tablet: "tfghjggg", desktop: "tfghjggh" }, defaultClass: "tfghjggf" }, s: { conditions: { mobile: "tfghjggi", tablet: "tfghjggj", desktop: "tfghjggk" }, defaultClass: "tfghjggi" }, "s-m": { conditions: { mobile: "tfghjggl", tablet: "tfghjggm", desktop: "tfghjggn" }, defaultClass: "tfghjggl" }, xl: { conditions: { mobile: "tfghjggo", tablet: "tfghjggp", desktop: "tfghjggq" }, defaultClass: "tfghjggo" }, xs: { conditions: { mobile: "tfghjggr", tablet: "tfghjggs", desktop: "tfghjggt" }, defaultClass: "tfghjggr" }, xxs: { conditions: { mobile: "tfghjggu", tablet: "tfghjggv", desktop: "tfghjggw" }, defaultClass: "tfghjggu" } } }, paddingLeft: { values: { "0": { conditions: { mobile: "tfghjggx", tablet: "tfghjggy", desktop: "tfghjggz" }, defaultClass: "tfghjggx" }, "2xl": { conditions: { mobile: "tfghjgh0", tablet: "tfghjgh1", desktop: "tfghjgh2" }, defaultClass: "tfghjgh0" }, "3xl": { conditions: { mobile: "tfghjgh3", tablet: "tfghjgh4", desktop: "tfghjgh5" }, defaultClass: "tfghjgh3" }, "4xl": { conditions: { mobile: "tfghjgh6", tablet: "tfghjgh7", desktop: "tfghjgh8" }, defaultClass: "tfghjgh6" }, "5xl": { conditions: { mobile: "tfghjgh9", tablet: "tfghjgha", desktop: "tfghjghb" }, defaultClass: "tfghjgh9" }, auto: { conditions: { mobile: "tfghjghc", tablet: "tfghjghd", desktop: "tfghjghe" }, defaultClass: "tfghjghc" }, l: { conditions: { mobile: "tfghjghf", tablet: "tfghjghg", desktop: "tfghjghh" }, defaultClass: "tfghjghf" }, m: { conditions: { mobile: "tfghjghi", tablet: "tfghjghj", desktop: "tfghjghk" }, defaultClass: "tfghjghi" }, "m-l": { conditions: { mobile: "tfghjghl", tablet: "tfghjghm", desktop: "tfghjghn" }, defaultClass: "tfghjghl" }, s: { conditions: { mobile: "tfghjgho", tablet: "tfghjghp", desktop: "tfghjghq" }, defaultClass: "tfghjgho" }, "s-m": { conditions: { mobile: "tfghjghr", tablet: "tfghjghs", desktop: "tfghjght" }, defaultClass: "tfghjghr" }, xl: { conditions: { mobile: "tfghjghu", tablet: "tfghjghv", desktop: "tfghjghw" }, defaultClass: "tfghjghu" }, xs: { conditions: { mobile: "tfghjghx", tablet: "tfghjghy", desktop: "tfghjghz" }, defaultClass: "tfghjghx" }, xxs: { conditions: { mobile: "tfghjgi0", tablet: "tfghjgi1", desktop: "tfghjgi2" }, defaultClass: "tfghjgi0" } } }, paddingRight: { values: { "0": { conditions: { mobile: "tfghjgi3", tablet: "tfghjgi4", desktop: "tfghjgi5" }, defaultClass: "tfghjgi3" }, "2xl": { conditions: { mobile: "tfghjgi6", tablet: "tfghjgi7", desktop: "tfghjgi8" }, defaultClass: "tfghjgi6" }, "3xl": { conditions: { mobile: "tfghjgi9", tablet: "tfghjgia", desktop: "tfghjgib" }, defaultClass: "tfghjgi9" }, "4xl": { conditions: { mobile: "tfghjgic", tablet: "tfghjgid", desktop: "tfghjgie" }, defaultClass: "tfghjgic" }, "5xl": { conditions: { mobile: "tfghjgif", tablet: "tfghjgig", desktop: "tfghjgih" }, defaultClass: "tfghjgif" }, auto: { conditions: { mobile: "tfghjgii", tablet: "tfghjgij", desktop: "tfghjgik" }, defaultClass: "tfghjgii" }, l: { conditions: { mobile: "tfghjgil", tablet: "tfghjgim", desktop: "tfghjgin" }, defaultClass: "tfghjgil" }, m: { conditions: { mobile: "tfghjgio", tablet: "tfghjgip", desktop: "tfghjgiq" }, defaultClass: "tfghjgio" }, "m-l": { conditions: { mobile: "tfghjgir", tablet: "tfghjgis", desktop: "tfghjgit" }, defaultClass: "tfghjgir" }, s: { conditions: { mobile: "tfghjgiu", tablet: "tfghjgiv", desktop: "tfghjgiw" }, defaultClass: "tfghjgiu" }, "s-m": { conditions: { mobile: "tfghjgix", tablet: "tfghjgiy", desktop: "tfghjgiz" }, defaultClass: "tfghjgix" }, xl: { conditions: { mobile: "tfghjgj0", tablet: "tfghjgj1", desktop: "tfghjgj2" }, defaultClass: "tfghjgj0" }, xs: { conditions: { mobile: "tfghjgj3", tablet: "tfghjgj4", desktop: "tfghjgj5" }, defaultClass: "tfghjgj3" }, xxs: { conditions: { mobile: "tfghjgj6", tablet: "tfghjgj7", desktop: "tfghjgj8" }, defaultClass: "tfghjgj6" } } }, paddingTop: { values: { "0": { conditions: { mobile: "tfghjgj9", tablet: "tfghjgja", desktop: "tfghjgjb" }, defaultClass: "tfghjgj9" }, "2xl": { conditions: { mobile: "tfghjgjc", tablet: "tfghjgjd", desktop: "tfghjgje" }, defaultClass: "tfghjgjc" }, "3xl": { conditions: { mobile: "tfghjgjf", tablet: "tfghjgjg", desktop: "tfghjgjh" }, defaultClass: "tfghjgjf" }, "4xl": { conditions: { mobile: "tfghjgji", tablet: "tfghjgjj", desktop: "tfghjgjk" }, defaultClass: "tfghjgji" }, "5xl": { conditions: { mobile: "tfghjgjl", tablet: "tfghjgjm", desktop: "tfghjgjn" }, defaultClass: "tfghjgjl" }, auto: { conditions: { mobile: "tfghjgjo", tablet: "tfghjgjp", desktop: "tfghjgjq" }, defaultClass: "tfghjgjo" }, l: { conditions: { mobile: "tfghjgjr", tablet: "tfghjgjs", desktop: "tfghjgjt" }, defaultClass: "tfghjgjr" }, m: { conditions: { mobile: "tfghjgju", tablet: "tfghjgjv", desktop: "tfghjgjw" }, defaultClass: "tfghjgju" }, "m-l": { conditions: { mobile: "tfghjgjx", tablet: "tfghjgjy", desktop: "tfghjgjz" }, defaultClass: "tfghjgjx" }, s: { conditions: { mobile: "tfghjgk0", tablet: "tfghjgk1", desktop: "tfghjgk2" }, defaultClass: "tfghjgk0" }, "s-m": { conditions: { mobile: "tfghjgk3", tablet: "tfghjgk4", desktop: "tfghjgk5" }, defaultClass: "tfghjgk3" }, xl: { conditions: { mobile: "tfghjgk6", tablet: "tfghjgk7", desktop: "tfghjgk8" }, defaultClass: "tfghjgk6" }, xs: { conditions: { mobile: "tfghjgk9", tablet: "tfghjgka", desktop: "tfghjgkb" }, defaultClass: "tfghjgk9" }, xxs: { conditions: { mobile: "tfghjgkc", tablet: "tfghjgkd", desktop: "tfghjgke" }, defaultClass: "tfghjgkc" } } }, textAlign: { values: { inherit: { conditions: { mobile: "tfghjgkf", tablet: "tfghjgkg", desktop: "tfghjgkh" }, defaultClass: "tfghjgkf" }, left: { conditions: { mobile: "tfghjgki", tablet: "tfghjgkj", desktop: "tfghjgkk" }, defaultClass: "tfghjgki" }, right: { conditions: { mobile: "tfghjgkl", tablet: "tfghjgkm", desktop: "tfghjgkn" }, defaultClass: "tfghjgkl" }, center: { conditions: { mobile: "tfghjgko", tablet: "tfghjgkp", desktop: "tfghjgkq" }, defaultClass: "tfghjgko" } } }, textTransform: { values: { capitalize: { conditions: { mobile: "tfghjgkr", tablet: "tfghjgks", desktop: "tfghjgkt" }, defaultClass: "tfghjgkr" }, lowercase: { conditions: { mobile: "tfghjgku", tablet: "tfghjgkv", desktop: "tfghjgkw" }, defaultClass: "tfghjgku" }, uppercase: { conditions: { mobile: "tfghjgkx", tablet: "tfghjgky", desktop: "tfghjgkz" }, defaultClass: "tfghjgkx" } } }, textOverflow: { values: { ellipsis: { conditions: { mobile: "tfghjgl0", tablet: "tfghjgl1", desktop: "tfghjgl2" }, defaultClass: "tfghjgl0" } } }, width: { values: { "100vw": { conditions: { mobile: "tfghjgl3", tablet: "tfghjgl4", desktop: "tfghjgl5" }, defaultClass: "tfghjgl3" }, "100%": { conditions: { mobile: "tfghjgl6", tablet: "tfghjgl7", desktop: "tfghjgl8" }, defaultClass: "tfghjgl6" }, "100px": { conditions: { mobile: "tfghjgl9", tablet: "tfghjgla", desktop: "tfghjglb" }, defaultClass: "tfghjgl9" }, "170px": { conditions: { mobile: "tfghjglc", tablet: "tfghjgld", desktop: "tfghjgle" }, defaultClass: "tfghjglc" } } }, maxWidth: { values: { "100%": { conditions: { mobile: "tfghjglf", tablet: "tfghjglg", desktop: "tfghjglh" }, defaultClass: "tfghjglf" } } }, objectFit: { values: { contain: { conditions: { mobile: "tfghjgli", tablet: "tfghjglj", desktop: "tfghjglk" }, defaultClass: "tfghjgli" } } }, whiteSpace: { values: { nowrap: { conditions: { mobile: "tfghjgll", tablet: "tfghjglm", desktop: "tfghjgln" }, defaultClass: "tfghjgll" }, "pre-wrap": { conditions: { mobile: "tfghjglo", tablet: "tfghjglp", desktop: "tfghjglq" }, defaultClass: "tfghjglo" } } }, fontFamily: { values: { "Bagoss Condensed": { conditions: { mobile: "tfghjglr", tablet: "tfghjgls", desktop: "tfghjglt" }, defaultClass: "tfghjglr" } } }, visibility: { values: { visible: { conditions: { mobile: "tfghjglu", tablet: "tfghjglv", desktop: "tfghjglw" }, defaultClass: "tfghjglu" }, hidden: { conditions: { mobile: "tfghjglx", tablet: "tfghjgly", desktop: "tfghjglz" }, defaultClass: "tfghjglx" }, inherit: { conditions: { mobile: "tfghjgm0", tablet: "tfghjgm1", desktop: "tfghjgm2" }, defaultClass: "tfghjgm0" } } } } };
var sprinkles = createSprinkles({ conditions: { defaultCondition: "mobile", conditionNames: ["mobile", "tablet", "desktop"], responsiveArray: void 0 }, styles: { margin: { values: { "0 auto": { conditions: { mobile: "tfghjgbr", tablet: "tfghjgbs", desktop: "tfghjgbt" }, defaultClass: "tfghjgbr" }, auto: { conditions: { mobile: "tfghjgbu", tablet: "tfghjgbv", desktop: "tfghjgbw" }, defaultClass: "tfghjgbu" } } }, padding: { mappings: ["paddingTop", "paddingBottom", "paddingLeft", "paddingRight"] }, marginX: { mappings: ["marginLeft", "marginRight"] }, marginY: { mappings: ["marginTop", "marginBottom"] }, paddingX: { mappings: ["paddingLeft", "paddingRight"] }, paddingY: { mappings: ["paddingTop", "paddingBottom"] }, alignItems: { values: { "flex-start": { conditions: { mobile: "tfghjg0", tablet: "tfghjg1", desktop: "tfghjg2" }, defaultClass: "tfghjg0" }, "flex-end": { conditions: { mobile: "tfghjg3", tablet: "tfghjg4", desktop: "tfghjg5" }, defaultClass: "tfghjg3" }, center: { conditions: { mobile: "tfghjg6", tablet: "tfghjg7", desktop: "tfghjg8" }, defaultClass: "tfghjg6" } } }, alignSelf: { values: { "flex-start": { conditions: { mobile: "tfghjg9", tablet: "tfghjga", desktop: "tfghjgb" }, defaultClass: "tfghjg9" }, "flex-end": { conditions: { mobile: "tfghjgc", tablet: "tfghjgd", desktop: "tfghjge" }, defaultClass: "tfghjgc" }, center: { conditions: { mobile: "tfghjgf", tablet: "tfghjgg", desktop: "tfghjgh" }, defaultClass: "tfghjgf" } } }, border: { values: { "0": { conditions: { mobile: "tfghjgi", tablet: "tfghjgj", desktop: "tfghjgk" }, defaultClass: "tfghjgi" } } }, borderRadius: { values: { "0": { conditions: { mobile: "tfghjgl", tablet: "tfghjgm", desktop: "tfghjgn" }, defaultClass: "tfghjgl" }, "4": { conditions: { mobile: "tfghjgo", tablet: "tfghjgp", desktop: "tfghjgq" }, defaultClass: "tfghjgo" }, "8": { conditions: { mobile: "tfghjgr", tablet: "tfghjgs", desktop: "tfghjgt" }, defaultClass: "tfghjgr" }, "16": { conditions: { mobile: "tfghjgu", tablet: "tfghjgv", desktop: "tfghjgw" }, defaultClass: "tfghjgu" }, "24": { conditions: { mobile: "tfghjgx", tablet: "tfghjgy", desktop: "tfghjgz" }, defaultClass: "tfghjgx" } } }, borderBottomLeftRadius: { values: { "4": { conditions: { mobile: "tfghjg10", tablet: "tfghjg11", desktop: "tfghjg12" }, defaultClass: "tfghjg10" }, "8": { conditions: { mobile: "tfghjg13", tablet: "tfghjg14", desktop: "tfghjg15" }, defaultClass: "tfghjg13" }, "16": { conditions: { mobile: "tfghjg16", tablet: "tfghjg17", desktop: "tfghjg18" }, defaultClass: "tfghjg16" }, "24": { conditions: { mobile: "tfghjg19", tablet: "tfghjg1a", desktop: "tfghjg1b" }, defaultClass: "tfghjg19" } } }, borderTopRightRadius: { values: { "0": { conditions: { mobile: "tfghjg1c", tablet: "tfghjg1d", desktop: "tfghjg1e" }, defaultClass: "tfghjg1c" }, "4": { conditions: { mobile: "tfghjg1f", tablet: "tfghjg1g", desktop: "tfghjg1h" }, defaultClass: "tfghjg1f" }, "8": { conditions: { mobile: "tfghjg1i", tablet: "tfghjg1j", desktop: "tfghjg1k" }, defaultClass: "tfghjg1i" }, "16": { conditions: { mobile: "tfghjg1l", tablet: "tfghjg1m", desktop: "tfghjg1n" }, defaultClass: "tfghjg1l" }, "24": { conditions: { mobile: "tfghjg1o", tablet: "tfghjg1p", desktop: "tfghjg1q" }, defaultClass: "tfghjg1o" } } }, display: { values: { none: { conditions: { mobile: "tfghjg1r", tablet: "tfghjg1s", desktop: "tfghjg1t" }, defaultClass: "tfghjg1r" }, flex: { conditions: { mobile: "tfghjg1u", tablet: "tfghjg1v", desktop: "tfghjg1w" }, defaultClass: "tfghjg1u" }, grid: { conditions: { mobile: "tfghjg1x", tablet: "tfghjg1y", desktop: "tfghjg1z" }, defaultClass: "tfghjg1x" }, block: { conditions: { mobile: "tfghjg20", tablet: "tfghjg21", desktop: "tfghjg22" }, defaultClass: "tfghjg20" }, "inline-block": { conditions: { mobile: "tfghjg23", tablet: "tfghjg24", desktop: "tfghjg25" }, defaultClass: "tfghjg23" } } }, position: { values: { "static": { conditions: { mobile: "tfghjg26", tablet: "tfghjg27", desktop: "tfghjg28" }, defaultClass: "tfghjg26" }, absolute: { conditions: { mobile: "tfghjg29", tablet: "tfghjg2a", desktop: "tfghjg2b" }, defaultClass: "tfghjg29" }, relative: { conditions: { mobile: "tfghjg2c", tablet: "tfghjg2d", desktop: "tfghjg2e" }, defaultClass: "tfghjg2c" } } }, top: { values: { "0": { conditions: { mobile: "tfghjg2f", tablet: "tfghjg2g", desktop: "tfghjg2h" }, defaultClass: "tfghjg2f" }, "2xl": { conditions: { mobile: "tfghjg2i", tablet: "tfghjg2j", desktop: "tfghjg2k" }, defaultClass: "tfghjg2i" }, "3xl": { conditions: { mobile: "tfghjg2l", tablet: "tfghjg2m", desktop: "tfghjg2n" }, defaultClass: "tfghjg2l" }, "4xl": { conditions: { mobile: "tfghjg2o", tablet: "tfghjg2p", desktop: "tfghjg2q" }, defaultClass: "tfghjg2o" }, "5xl": { conditions: { mobile: "tfghjg2r", tablet: "tfghjg2s", desktop: "tfghjg2t" }, defaultClass: "tfghjg2r" }, auto: { conditions: { mobile: "tfghjg2u", tablet: "tfghjg2v", desktop: "tfghjg2w" }, defaultClass: "tfghjg2u" }, l: { conditions: { mobile: "tfghjg2x", tablet: "tfghjg2y", desktop: "tfghjg2z" }, defaultClass: "tfghjg2x" }, m: { conditions: { mobile: "tfghjg30", tablet: "tfghjg31", desktop: "tfghjg32" }, defaultClass: "tfghjg30" }, "m-l": { conditions: { mobile: "tfghjg33", tablet: "tfghjg34", desktop: "tfghjg35" }, defaultClass: "tfghjg33" }, s: { conditions: { mobile: "tfghjg36", tablet: "tfghjg37", desktop: "tfghjg38" }, defaultClass: "tfghjg36" }, "s-m": { conditions: { mobile: "tfghjg39", tablet: "tfghjg3a", desktop: "tfghjg3b" }, defaultClass: "tfghjg39" }, xl: { conditions: { mobile: "tfghjg3c", tablet: "tfghjg3d", desktop: "tfghjg3e" }, defaultClass: "tfghjg3c" }, xs: { conditions: { mobile: "tfghjg3f", tablet: "tfghjg3g", desktop: "tfghjg3h" }, defaultClass: "tfghjg3f" }, xxs: { conditions: { mobile: "tfghjg3i", tablet: "tfghjg3j", desktop: "tfghjg3k" }, defaultClass: "tfghjg3i" } } }, right: { values: { "0": { conditions: { mobile: "tfghjg3l", tablet: "tfghjg3m", desktop: "tfghjg3n" }, defaultClass: "tfghjg3l" }, "2xl": { conditions: { mobile: "tfghjg3o", tablet: "tfghjg3p", desktop: "tfghjg3q" }, defaultClass: "tfghjg3o" }, "3xl": { conditions: { mobile: "tfghjg3r", tablet: "tfghjg3s", desktop: "tfghjg3t" }, defaultClass: "tfghjg3r" }, "4xl": { conditions: { mobile: "tfghjg3u", tablet: "tfghjg3v", desktop: "tfghjg3w" }, defaultClass: "tfghjg3u" }, "5xl": { conditions: { mobile: "tfghjg3x", tablet: "tfghjg3y", desktop: "tfghjg3z" }, defaultClass: "tfghjg3x" }, auto: { conditions: { mobile: "tfghjg40", tablet: "tfghjg41", desktop: "tfghjg42" }, defaultClass: "tfghjg40" }, l: { conditions: { mobile: "tfghjg43", tablet: "tfghjg44", desktop: "tfghjg45" }, defaultClass: "tfghjg43" }, m: { conditions: { mobile: "tfghjg46", tablet: "tfghjg47", desktop: "tfghjg48" }, defaultClass: "tfghjg46" }, "m-l": { conditions: { mobile: "tfghjg49", tablet: "tfghjg4a", desktop: "tfghjg4b" }, defaultClass: "tfghjg49" }, s: { conditions: { mobile: "tfghjg4c", tablet: "tfghjg4d", desktop: "tfghjg4e" }, defaultClass: "tfghjg4c" }, "s-m": { conditions: { mobile: "tfghjg4f", tablet: "tfghjg4g", desktop: "tfghjg4h" }, defaultClass: "tfghjg4f" }, xl: { conditions: { mobile: "tfghjg4i", tablet: "tfghjg4j", desktop: "tfghjg4k" }, defaultClass: "tfghjg4i" }, xs: { conditions: { mobile: "tfghjg4l", tablet: "tfghjg4m", desktop: "tfghjg4n" }, defaultClass: "tfghjg4l" }, xxs: { conditions: { mobile: "tfghjg4o", tablet: "tfghjg4p", desktop: "tfghjg4q" }, defaultClass: "tfghjg4o" } } }, bottom: { values: { "0": { conditions: { mobile: "tfghjg4r", tablet: "tfghjg4s", desktop: "tfghjg4t" }, defaultClass: "tfghjg4r" }, "2xl": { conditions: { mobile: "tfghjg4u", tablet: "tfghjg4v", desktop: "tfghjg4w" }, defaultClass: "tfghjg4u" }, "3xl": { conditions: { mobile: "tfghjg4x", tablet: "tfghjg4y", desktop: "tfghjg4z" }, defaultClass: "tfghjg4x" }, "4xl": { conditions: { mobile: "tfghjg50", tablet: "tfghjg51", desktop: "tfghjg52" }, defaultClass: "tfghjg50" }, "5xl": { conditions: { mobile: "tfghjg53", tablet: "tfghjg54", desktop: "tfghjg55" }, defaultClass: "tfghjg53" }, auto: { conditions: { mobile: "tfghjg56", tablet: "tfghjg57", desktop: "tfghjg58" }, defaultClass: "tfghjg56" }, l: { conditions: { mobile: "tfghjg59", tablet: "tfghjg5a", desktop: "tfghjg5b" }, defaultClass: "tfghjg59" }, m: { conditions: { mobile: "tfghjg5c", tablet: "tfghjg5d", desktop: "tfghjg5e" }, defaultClass: "tfghjg5c" }, "m-l": { conditions: { mobile: "tfghjg5f", tablet: "tfghjg5g", desktop: "tfghjg5h" }, defaultClass: "tfghjg5f" }, s: { conditions: { mobile: "tfghjg5i", tablet: "tfghjg5j", desktop: "tfghjg5k" }, defaultClass: "tfghjg5i" }, "s-m": { conditions: { mobile: "tfghjg5l", tablet: "tfghjg5m", desktop: "tfghjg5n" }, defaultClass: "tfghjg5l" }, xl: { conditions: { mobile: "tfghjg5o", tablet: "tfghjg5p", desktop: "tfghjg5q" }, defaultClass: "tfghjg5o" }, xs: { conditions: { mobile: "tfghjg5r", tablet: "tfghjg5s", desktop: "tfghjg5t" }, defaultClass: "tfghjg5r" }, xxs: { conditions: { mobile: "tfghjg5u", tablet: "tfghjg5v", desktop: "tfghjg5w" }, defaultClass: "tfghjg5u" } } }, left: { values: { "0": { conditions: { mobile: "tfghjg5x", tablet: "tfghjg5y", desktop: "tfghjg5z" }, defaultClass: "tfghjg5x" }, "2xl": { conditions: { mobile: "tfghjg60", tablet: "tfghjg61", desktop: "tfghjg62" }, defaultClass: "tfghjg60" }, "3xl": { conditions: { mobile: "tfghjg63", tablet: "tfghjg64", desktop: "tfghjg65" }, defaultClass: "tfghjg63" }, "4xl": { conditions: { mobile: "tfghjg66", tablet: "tfghjg67", desktop: "tfghjg68" }, defaultClass: "tfghjg66" }, "5xl": { conditions: { mobile: "tfghjg69", tablet: "tfghjg6a", desktop: "tfghjg6b" }, defaultClass: "tfghjg69" }, auto: { conditions: { mobile: "tfghjg6c", tablet: "tfghjg6d", desktop: "tfghjg6e" }, defaultClass: "tfghjg6c" }, l: { conditions: { mobile: "tfghjg6f", tablet: "tfghjg6g", desktop: "tfghjg6h" }, defaultClass: "tfghjg6f" }, m: { conditions: { mobile: "tfghjg6i", tablet: "tfghjg6j", desktop: "tfghjg6k" }, defaultClass: "tfghjg6i" }, "m-l": { conditions: { mobile: "tfghjg6l", tablet: "tfghjg6m", desktop: "tfghjg6n" }, defaultClass: "tfghjg6l" }, s: { conditions: { mobile: "tfghjg6o", tablet: "tfghjg6p", desktop: "tfghjg6q" }, defaultClass: "tfghjg6o" }, "s-m": { conditions: { mobile: "tfghjg6r", tablet: "tfghjg6s", desktop: "tfghjg6t" }, defaultClass: "tfghjg6r" }, xl: { conditions: { mobile: "tfghjg6u", tablet: "tfghjg6v", desktop: "tfghjg6w" }, defaultClass: "tfghjg6u" }, xs: { conditions: { mobile: "tfghjg6x", tablet: "tfghjg6y", desktop: "tfghjg6z" }, defaultClass: "tfghjg6x" }, xxs: { conditions: { mobile: "tfghjg70", tablet: "tfghjg71", desktop: "tfghjg72" }, defaultClass: "tfghjg70" } } }, flex: { values: { "1": { conditions: { mobile: "tfghjg73", tablet: "tfghjg74", desktop: "tfghjg75" }, defaultClass: "tfghjg73" } } }, flexBasis: { values: { "100%": { conditions: { mobile: "tfghjg76", tablet: "tfghjg77", desktop: "tfghjg78" }, defaultClass: "tfghjg76" }, "50%": { conditions: { mobile: "tfghjg79", tablet: "tfghjg7a", desktop: "tfghjg7b" }, defaultClass: "tfghjg79" }, unset: { conditions: { mobile: "tfghjg7c", tablet: "tfghjg7d", desktop: "tfghjg7e" }, defaultClass: "tfghjg7c" } } }, flexDirection: { values: { "row-reverse": { conditions: { mobile: "tfghjg7f", tablet: "tfghjg7g", desktop: "tfghjg7h" }, defaultClass: "tfghjg7f" }, row: { conditions: { mobile: "tfghjg7i", tablet: "tfghjg7j", desktop: "tfghjg7k" }, defaultClass: "tfghjg7i" }, column: { conditions: { mobile: "tfghjg7l", tablet: "tfghjg7m", desktop: "tfghjg7n" }, defaultClass: "tfghjg7l" } } }, flexGrow: { values: { "0": { conditions: { mobile: "tfghjg7r", tablet: "tfghjg7s", desktop: "tfghjg7t" }, defaultClass: "tfghjg7r" }, "1": { conditions: { mobile: "tfghjg7o", tablet: "tfghjg7p", desktop: "tfghjg7q" }, defaultClass: "tfghjg7o" } } }, flexShrink: { values: { "0": { conditions: { mobile: "tfghjg7x", tablet: "tfghjg7y", desktop: "tfghjg7z" }, defaultClass: "tfghjg7x" }, "1": { conditions: { mobile: "tfghjg7u", tablet: "tfghjg7v", desktop: "tfghjg7w" }, defaultClass: "tfghjg7u" } } }, flexWrap: { values: { wrap: { conditions: { mobile: "tfghjg80", tablet: "tfghjg81", desktop: "tfghjg82" }, defaultClass: "tfghjg80" }, nowrap: { conditions: { mobile: "tfghjg83", tablet: "tfghjg84", desktop: "tfghjg85" }, defaultClass: "tfghjg83" } } }, fontWeight: { values: { "300": { conditions: { mobile: "tfghjg86", tablet: "tfghjg87", desktop: "tfghjg88" }, defaultClass: "tfghjg86" }, "400": { conditions: { mobile: "tfghjg89", tablet: "tfghjg8a", desktop: "tfghjg8b" }, defaultClass: "tfghjg89" }, "600": { conditions: { mobile: "tfghjg8c", tablet: "tfghjg8d", desktop: "tfghjg8e" }, defaultClass: "tfghjg8c" } } }, cursor: { values: { pointer: { conditions: { mobile: "tfghjg8f", tablet: "tfghjg8g", desktop: "tfghjg8h" }, defaultClass: "tfghjg8f" }, "not-allowed": { conditions: { mobile: "tfghjg8i", tablet: "tfghjg8j", desktop: "tfghjg8k" }, defaultClass: "tfghjg8i" } } }, textDecoration: { values: { underline: { conditions: { mobile: "tfghjg8l", tablet: "tfghjg8m", desktop: "tfghjg8n" }, defaultClass: "tfghjg8l" } } }, verticalAlign: { values: { baseline: { conditions: { mobile: "tfghjg8o", tablet: "tfghjg8p", desktop: "tfghjg8q" }, defaultClass: "tfghjg8o" }, center: { conditions: { mobile: "tfghjg8r", tablet: "tfghjg8s", desktop: "tfghjg8t" }, defaultClass: "tfghjg8r" } } }, gap: { values: { "0": { conditions: { mobile: "tfghjg8u", tablet: "tfghjg8v", desktop: "tfghjg8w" }, defaultClass: "tfghjg8u" }, "2xl": { conditions: { mobile: "tfghjg8x", tablet: "tfghjg8y", desktop: "tfghjg8z" }, defaultClass: "tfghjg8x" }, "3xl": { conditions: { mobile: "tfghjg90", tablet: "tfghjg91", desktop: "tfghjg92" }, defaultClass: "tfghjg90" }, "4xl": { conditions: { mobile: "tfghjg93", tablet: "tfghjg94", desktop: "tfghjg95" }, defaultClass: "tfghjg93" }, "5xl": { conditions: { mobile: "tfghjg96", tablet: "tfghjg97", desktop: "tfghjg98" }, defaultClass: "tfghjg96" }, auto: { conditions: { mobile: "tfghjg99", tablet: "tfghjg9a", desktop: "tfghjg9b" }, defaultClass: "tfghjg99" }, l: { conditions: { mobile: "tfghjg9c", tablet: "tfghjg9d", desktop: "tfghjg9e" }, defaultClass: "tfghjg9c" }, m: { conditions: { mobile: "tfghjg9f", tablet: "tfghjg9g", desktop: "tfghjg9h" }, defaultClass: "tfghjg9f" }, "m-l": { conditions: { mobile: "tfghjg9i", tablet: "tfghjg9j", desktop: "tfghjg9k" }, defaultClass: "tfghjg9i" }, s: { conditions: { mobile: "tfghjg9l", tablet: "tfghjg9m", desktop: "tfghjg9n" }, defaultClass: "tfghjg9l" }, "s-m": { conditions: { mobile: "tfghjg9o", tablet: "tfghjg9p", desktop: "tfghjg9q" }, defaultClass: "tfghjg9o" }, xl: { conditions: { mobile: "tfghjg9r", tablet: "tfghjg9s", desktop: "tfghjg9t" }, defaultClass: "tfghjg9r" }, xs: { conditions: { mobile: "tfghjg9u", tablet: "tfghjg9v", desktop: "tfghjg9w" }, defaultClass: "tfghjg9u" }, xxs: { conditions: { mobile: "tfghjg9x", tablet: "tfghjg9y", desktop: "tfghjg9z" }, defaultClass: "tfghjg9x" } } }, height: { values: { "100vh": { conditions: { mobile: "tfghjga0", tablet: "tfghjga1", desktop: "tfghjga2" }, defaultClass: "tfghjga0" }, "100%": { conditions: { mobile: "tfghjga3", tablet: "tfghjga4", desktop: "tfghjga5" }, defaultClass: "tfghjga3" } } }, justifyContent: { values: { "space-between": { conditions: { mobile: "tfghjga6", tablet: "tfghjga7", desktop: "tfghjga8" }, defaultClass: "tfghjga6" }, "space-around": { conditions: { mobile: "tfghjga9", tablet: "tfghjgaa", desktop: "tfghjgab" }, defaultClass: "tfghjga9" }, center: { conditions: { mobile: "tfghjgac", tablet: "tfghjgad", desktop: "tfghjgae" }, defaultClass: "tfghjgac" }, "flex-end": { conditions: { mobile: "tfghjgaf", tablet: "tfghjgag", desktop: "tfghjgah" }, defaultClass: "tfghjgaf" }, "flex-start": { conditions: { mobile: "tfghjgai", tablet: "tfghjgaj", desktop: "tfghjgak" }, defaultClass: "tfghjgai" } } }, marginBottom: { values: { "0": { conditions: { mobile: "tfghjgal", tablet: "tfghjgam", desktop: "tfghjgan" }, defaultClass: "tfghjgal" }, "2xl": { conditions: { mobile: "tfghjgao", tablet: "tfghjgap", desktop: "tfghjgaq" }, defaultClass: "tfghjgao" }, "3xl": { conditions: { mobile: "tfghjgar", tablet: "tfghjgas", desktop: "tfghjgat" }, defaultClass: "tfghjgar" }, "4xl": { conditions: { mobile: "tfghjgau", tablet: "tfghjgav", desktop: "tfghjgaw" }, defaultClass: "tfghjgau" }, "5xl": { conditions: { mobile: "tfghjgax", tablet: "tfghjgay", desktop: "tfghjgaz" }, defaultClass: "tfghjgax" }, auto: { conditions: { mobile: "tfghjgb0", tablet: "tfghjgb1", desktop: "tfghjgb2" }, defaultClass: "tfghjgb0" }, l: { conditions: { mobile: "tfghjgb3", tablet: "tfghjgb4", desktop: "tfghjgb5" }, defaultClass: "tfghjgb3" }, m: { conditions: { mobile: "tfghjgb6", tablet: "tfghjgb7", desktop: "tfghjgb8" }, defaultClass: "tfghjgb6" }, "m-l": { conditions: { mobile: "tfghjgb9", tablet: "tfghjgba", desktop: "tfghjgbb" }, defaultClass: "tfghjgb9" }, s: { conditions: { mobile: "tfghjgbc", tablet: "tfghjgbd", desktop: "tfghjgbe" }, defaultClass: "tfghjgbc" }, "s-m": { conditions: { mobile: "tfghjgbf", tablet: "tfghjgbg", desktop: "tfghjgbh" }, defaultClass: "tfghjgbf" }, xl: { conditions: { mobile: "tfghjgbi", tablet: "tfghjgbj", desktop: "tfghjgbk" }, defaultClass: "tfghjgbi" }, xs: { conditions: { mobile: "tfghjgbl", tablet: "tfghjgbm", desktop: "tfghjgbn" }, defaultClass: "tfghjgbl" }, xxs: { conditions: { mobile: "tfghjgbo", tablet: "tfghjgbp", desktop: "tfghjgbq" }, defaultClass: "tfghjgbo" } } }, marginLeft: { values: { "0": { conditions: { mobile: "tfghjgbx", tablet: "tfghjgby", desktop: "tfghjgbz" }, defaultClass: "tfghjgbx" }, "2xl": { conditions: { mobile: "tfghjgc0", tablet: "tfghjgc1", desktop: "tfghjgc2" }, defaultClass: "tfghjgc0" }, "3xl": { conditions: { mobile: "tfghjgc3", tablet: "tfghjgc4", desktop: "tfghjgc5" }, defaultClass: "tfghjgc3" }, "4xl": { conditions: { mobile: "tfghjgc6", tablet: "tfghjgc7", desktop: "tfghjgc8" }, defaultClass: "tfghjgc6" }, "5xl": { conditions: { mobile: "tfghjgc9", tablet: "tfghjgca", desktop: "tfghjgcb" }, defaultClass: "tfghjgc9" }, auto: { conditions: { mobile: "tfghjgcc", tablet: "tfghjgcd", desktop: "tfghjgce" }, defaultClass: "tfghjgcc" }, l: { conditions: { mobile: "tfghjgcf", tablet: "tfghjgcg", desktop: "tfghjgch" }, defaultClass: "tfghjgcf" }, m: { conditions: { mobile: "tfghjgci", tablet: "tfghjgcj", desktop: "tfghjgck" }, defaultClass: "tfghjgci" }, "m-l": { conditions: { mobile: "tfghjgcl", tablet: "tfghjgcm", desktop: "tfghjgcn" }, defaultClass: "tfghjgcl" }, s: { conditions: { mobile: "tfghjgco", tablet: "tfghjgcp", desktop: "tfghjgcq" }, defaultClass: "tfghjgco" }, "s-m": { conditions: { mobile: "tfghjgcr", tablet: "tfghjgcs", desktop: "tfghjgct" }, defaultClass: "tfghjgcr" }, xl: { conditions: { mobile: "tfghjgcu", tablet: "tfghjgcv", desktop: "tfghjgcw" }, defaultClass: "tfghjgcu" }, xs: { conditions: { mobile: "tfghjgcx", tablet: "tfghjgcy", desktop: "tfghjgcz" }, defaultClass: "tfghjgcx" }, xxs: { conditions: { mobile: "tfghjgd0", tablet: "tfghjgd1", desktop: "tfghjgd2" }, defaultClass: "tfghjgd0" } } }, marginRight: { values: { "0": { conditions: { mobile: "tfghjgd3", tablet: "tfghjgd4", desktop: "tfghjgd5" }, defaultClass: "tfghjgd3" }, "2xl": { conditions: { mobile: "tfghjgd6", tablet: "tfghjgd7", desktop: "tfghjgd8" }, defaultClass: "tfghjgd6" }, "3xl": { conditions: { mobile: "tfghjgd9", tablet: "tfghjgda", desktop: "tfghjgdb" }, defaultClass: "tfghjgd9" }, "4xl": { conditions: { mobile: "tfghjgdc", tablet: "tfghjgdd", desktop: "tfghjgde" }, defaultClass: "tfghjgdc" }, "5xl": { conditions: { mobile: "tfghjgdf", tablet: "tfghjgdg", desktop: "tfghjgdh" }, defaultClass: "tfghjgdf" }, auto: { conditions: { mobile: "tfghjgdi", tablet: "tfghjgdj", desktop: "tfghjgdk" }, defaultClass: "tfghjgdi" }, l: { conditions: { mobile: "tfghjgdl", tablet: "tfghjgdm", desktop: "tfghjgdn" }, defaultClass: "tfghjgdl" }, m: { conditions: { mobile: "tfghjgdo", tablet: "tfghjgdp", desktop: "tfghjgdq" }, defaultClass: "tfghjgdo" }, "m-l": { conditions: { mobile: "tfghjgdr", tablet: "tfghjgds", desktop: "tfghjgdt" }, defaultClass: "tfghjgdr" }, s: { conditions: { mobile: "tfghjgdu", tablet: "tfghjgdv", desktop: "tfghjgdw" }, defaultClass: "tfghjgdu" }, "s-m": { conditions: { mobile: "tfghjgdx", tablet: "tfghjgdy", desktop: "tfghjgdz" }, defaultClass: "tfghjgdx" }, xl: { conditions: { mobile: "tfghjge0", tablet: "tfghjge1", desktop: "tfghjge2" }, defaultClass: "tfghjge0" }, xs: { conditions: { mobile: "tfghjge3", tablet: "tfghjge4", desktop: "tfghjge5" }, defaultClass: "tfghjge3" }, xxs: { conditions: { mobile: "tfghjge6", tablet: "tfghjge7", desktop: "tfghjge8" }, defaultClass: "tfghjge6" } } }, marginTop: { values: { "0": { conditions: { mobile: "tfghjge9", tablet: "tfghjgea", desktop: "tfghjgeb" }, defaultClass: "tfghjge9" }, "2xl": { conditions: { mobile: "tfghjgec", tablet: "tfghjged", desktop: "tfghjgee" }, defaultClass: "tfghjgec" }, "3xl": { conditions: { mobile: "tfghjgef", tablet: "tfghjgeg", desktop: "tfghjgeh" }, defaultClass: "tfghjgef" }, "4xl": { conditions: { mobile: "tfghjgei", tablet: "tfghjgej", desktop: "tfghjgek" }, defaultClass: "tfghjgei" }, "5xl": { conditions: { mobile: "tfghjgel", tablet: "tfghjgem", desktop: "tfghjgen" }, defaultClass: "tfghjgel" }, auto: { conditions: { mobile: "tfghjgeo", tablet: "tfghjgep", desktop: "tfghjgeq" }, defaultClass: "tfghjgeo" }, l: { conditions: { mobile: "tfghjger", tablet: "tfghjges", desktop: "tfghjget" }, defaultClass: "tfghjger" }, m: { conditions: { mobile: "tfghjgeu", tablet: "tfghjgev", desktop: "tfghjgew" }, defaultClass: "tfghjgeu" }, "m-l": { conditions: { mobile: "tfghjgex", tablet: "tfghjgey", desktop: "tfghjgez" }, defaultClass: "tfghjgex" }, s: { conditions: { mobile: "tfghjgf0", tablet: "tfghjgf1", desktop: "tfghjgf2" }, defaultClass: "tfghjgf0" }, "s-m": { conditions: { mobile: "tfghjgf3", tablet: "tfghjgf4", desktop: "tfghjgf5" }, defaultClass: "tfghjgf3" }, xl: { conditions: { mobile: "tfghjgf6", tablet: "tfghjgf7", desktop: "tfghjgf8" }, defaultClass: "tfghjgf6" }, xs: { conditions: { mobile: "tfghjgf9", tablet: "tfghjgfa", desktop: "tfghjgfb" }, defaultClass: "tfghjgf9" }, xxs: { conditions: { mobile: "tfghjgfc", tablet: "tfghjgfd", desktop: "tfghjgfe" }, defaultClass: "tfghjgfc" } } }, overflow: { values: { hidden: { conditions: { mobile: "tfghjgff", tablet: "tfghjgfg", desktop: "tfghjgfh" }, defaultClass: "tfghjgff" }, auto: { conditions: { mobile: "tfghjgfi", tablet: "tfghjgfj", desktop: "tfghjgfk" }, defaultClass: "tfghjgfi" } } }, overflowX: { values: { hidden: { conditions: { mobile: "tfghjgfl", tablet: "tfghjgfm", desktop: "tfghjgfn" }, defaultClass: "tfghjgfl" }, auto: { conditions: { mobile: "tfghjgfo", tablet: "tfghjgfp", desktop: "tfghjgfq" }, defaultClass: "tfghjgfo" } } }, paddingBottom: { values: { "0": { conditions: { mobile: "tfghjgfr", tablet: "tfghjgfs", desktop: "tfghjgft" }, defaultClass: "tfghjgfr" }, "2xl": { conditions: { mobile: "tfghjgfu", tablet: "tfghjgfv", desktop: "tfghjgfw" }, defaultClass: "tfghjgfu" }, "3xl": { conditions: { mobile: "tfghjgfx", tablet: "tfghjgfy", desktop: "tfghjgfz" }, defaultClass: "tfghjgfx" }, "4xl": { conditions: { mobile: "tfghjgg0", tablet: "tfghjgg1", desktop: "tfghjgg2" }, defaultClass: "tfghjgg0" }, "5xl": { conditions: { mobile: "tfghjgg3", tablet: "tfghjgg4", desktop: "tfghjgg5" }, defaultClass: "tfghjgg3" }, auto: { conditions: { mobile: "tfghjgg6", tablet: "tfghjgg7", desktop: "tfghjgg8" }, defaultClass: "tfghjgg6" }, l: { conditions: { mobile: "tfghjgg9", tablet: "tfghjgga", desktop: "tfghjggb" }, defaultClass: "tfghjgg9" }, m: { conditions: { mobile: "tfghjggc", tablet: "tfghjggd", desktop: "tfghjgge" }, defaultClass: "tfghjggc" }, "m-l": { conditions: { mobile: "tfghjggf", tablet: "tfghjggg", desktop: "tfghjggh" }, defaultClass: "tfghjggf" }, s: { conditions: { mobile: "tfghjggi", tablet: "tfghjggj", desktop: "tfghjggk" }, defaultClass: "tfghjggi" }, "s-m": { conditions: { mobile: "tfghjggl", tablet: "tfghjggm", desktop: "tfghjggn" }, defaultClass: "tfghjggl" }, xl: { conditions: { mobile: "tfghjggo", tablet: "tfghjggp", desktop: "tfghjggq" }, defaultClass: "tfghjggo" }, xs: { conditions: { mobile: "tfghjggr", tablet: "tfghjggs", desktop: "tfghjggt" }, defaultClass: "tfghjggr" }, xxs: { conditions: { mobile: "tfghjggu", tablet: "tfghjggv", desktop: "tfghjggw" }, defaultClass: "tfghjggu" } } }, paddingLeft: { values: { "0": { conditions: { mobile: "tfghjggx", tablet: "tfghjggy", desktop: "tfghjggz" }, defaultClass: "tfghjggx" }, "2xl": { conditions: { mobile: "tfghjgh0", tablet: "tfghjgh1", desktop: "tfghjgh2" }, defaultClass: "tfghjgh0" }, "3xl": { conditions: { mobile: "tfghjgh3", tablet: "tfghjgh4", desktop: "tfghjgh5" }, defaultClass: "tfghjgh3" }, "4xl": { conditions: { mobile: "tfghjgh6", tablet: "tfghjgh7", desktop: "tfghjgh8" }, defaultClass: "tfghjgh6" }, "5xl": { conditions: { mobile: "tfghjgh9", tablet: "tfghjgha", desktop: "tfghjghb" }, defaultClass: "tfghjgh9" }, auto: { conditions: { mobile: "tfghjghc", tablet: "tfghjghd", desktop: "tfghjghe" }, defaultClass: "tfghjghc" }, l: { conditions: { mobile: "tfghjghf", tablet: "tfghjghg", desktop: "tfghjghh" }, defaultClass: "tfghjghf" }, m: { conditions: { mobile: "tfghjghi", tablet: "tfghjghj", desktop: "tfghjghk" }, defaultClass: "tfghjghi" }, "m-l": { conditions: { mobile: "tfghjghl", tablet: "tfghjghm", desktop: "tfghjghn" }, defaultClass: "tfghjghl" }, s: { conditions: { mobile: "tfghjgho", tablet: "tfghjghp", desktop: "tfghjghq" }, defaultClass: "tfghjgho" }, "s-m": { conditions: { mobile: "tfghjghr", tablet: "tfghjghs", desktop: "tfghjght" }, defaultClass: "tfghjghr" }, xl: { conditions: { mobile: "tfghjghu", tablet: "tfghjghv", desktop: "tfghjghw" }, defaultClass: "tfghjghu" }, xs: { conditions: { mobile: "tfghjghx", tablet: "tfghjghy", desktop: "tfghjghz" }, defaultClass: "tfghjghx" }, xxs: { conditions: { mobile: "tfghjgi0", tablet: "tfghjgi1", desktop: "tfghjgi2" }, defaultClass: "tfghjgi0" } } }, paddingRight: { values: { "0": { conditions: { mobile: "tfghjgi3", tablet: "tfghjgi4", desktop: "tfghjgi5" }, defaultClass: "tfghjgi3" }, "2xl": { conditions: { mobile: "tfghjgi6", tablet: "tfghjgi7", desktop: "tfghjgi8" }, defaultClass: "tfghjgi6" }, "3xl": { conditions: { mobile: "tfghjgi9", tablet: "tfghjgia", desktop: "tfghjgib" }, defaultClass: "tfghjgi9" }, "4xl": { conditions: { mobile: "tfghjgic", tablet: "tfghjgid", desktop: "tfghjgie" }, defaultClass: "tfghjgic" }, "5xl": { conditions: { mobile: "tfghjgif", tablet: "tfghjgig", desktop: "tfghjgih" }, defaultClass: "tfghjgif" }, auto: { conditions: { mobile: "tfghjgii", tablet: "tfghjgij", desktop: "tfghjgik" }, defaultClass: "tfghjgii" }, l: { conditions: { mobile: "tfghjgil", tablet: "tfghjgim", desktop: "tfghjgin" }, defaultClass: "tfghjgil" }, m: { conditions: { mobile: "tfghjgio", tablet: "tfghjgip", desktop: "tfghjgiq" }, defaultClass: "tfghjgio" }, "m-l": { conditions: { mobile: "tfghjgir", tablet: "tfghjgis", desktop: "tfghjgit" }, defaultClass: "tfghjgir" }, s: { conditions: { mobile: "tfghjgiu", tablet: "tfghjgiv", desktop: "tfghjgiw" }, defaultClass: "tfghjgiu" }, "s-m": { conditions: { mobile: "tfghjgix", tablet: "tfghjgiy", desktop: "tfghjgiz" }, defaultClass: "tfghjgix" }, xl: { conditions: { mobile: "tfghjgj0", tablet: "tfghjgj1", desktop: "tfghjgj2" }, defaultClass: "tfghjgj0" }, xs: { conditions: { mobile: "tfghjgj3", tablet: "tfghjgj4", desktop: "tfghjgj5" }, defaultClass: "tfghjgj3" }, xxs: { conditions: { mobile: "tfghjgj6", tablet: "tfghjgj7", desktop: "tfghjgj8" }, defaultClass: "tfghjgj6" } } }, paddingTop: { values: { "0": { conditions: { mobile: "tfghjgj9", tablet: "tfghjgja", desktop: "tfghjgjb" }, defaultClass: "tfghjgj9" }, "2xl": { conditions: { mobile: "tfghjgjc", tablet: "tfghjgjd", desktop: "tfghjgje" }, defaultClass: "tfghjgjc" }, "3xl": { conditions: { mobile: "tfghjgjf", tablet: "tfghjgjg", desktop: "tfghjgjh" }, defaultClass: "tfghjgjf" }, "4xl": { conditions: { mobile: "tfghjgji", tablet: "tfghjgjj", desktop: "tfghjgjk" }, defaultClass: "tfghjgji" }, "5xl": { conditions: { mobile: "tfghjgjl", tablet: "tfghjgjm", desktop: "tfghjgjn" }, defaultClass: "tfghjgjl" }, auto: { conditions: { mobile: "tfghjgjo", tablet: "tfghjgjp", desktop: "tfghjgjq" }, defaultClass: "tfghjgjo" }, l: { conditions: { mobile: "tfghjgjr", tablet: "tfghjgjs", desktop: "tfghjgjt" }, defaultClass: "tfghjgjr" }, m: { conditions: { mobile: "tfghjgju", tablet: "tfghjgjv", desktop: "tfghjgjw" }, defaultClass: "tfghjgju" }, "m-l": { conditions: { mobile: "tfghjgjx", tablet: "tfghjgjy", desktop: "tfghjgjz" }, defaultClass: "tfghjgjx" }, s: { conditions: { mobile: "tfghjgk0", tablet: "tfghjgk1", desktop: "tfghjgk2" }, defaultClass: "tfghjgk0" }, "s-m": { conditions: { mobile: "tfghjgk3", tablet: "tfghjgk4", desktop: "tfghjgk5" }, defaultClass: "tfghjgk3" }, xl: { conditions: { mobile: "tfghjgk6", tablet: "tfghjgk7", desktop: "tfghjgk8" }, defaultClass: "tfghjgk6" }, xs: { conditions: { mobile: "tfghjgk9", tablet: "tfghjgka", desktop: "tfghjgkb" }, defaultClass: "tfghjgk9" }, xxs: { conditions: { mobile: "tfghjgkc", tablet: "tfghjgkd", desktop: "tfghjgke" }, defaultClass: "tfghjgkc" } } }, textAlign: { values: { inherit: { conditions: { mobile: "tfghjgkf", tablet: "tfghjgkg", desktop: "tfghjgkh" }, defaultClass: "tfghjgkf" }, left: { conditions: { mobile: "tfghjgki", tablet: "tfghjgkj", desktop: "tfghjgkk" }, defaultClass: "tfghjgki" }, right: { conditions: { mobile: "tfghjgkl", tablet: "tfghjgkm", desktop: "tfghjgkn" }, defaultClass: "tfghjgkl" }, center: { conditions: { mobile: "tfghjgko", tablet: "tfghjgkp", desktop: "tfghjgkq" }, defaultClass: "tfghjgko" } } }, textTransform: { values: { capitalize: { conditions: { mobile: "tfghjgkr", tablet: "tfghjgks", desktop: "tfghjgkt" }, defaultClass: "tfghjgkr" }, lowercase: { conditions: { mobile: "tfghjgku", tablet: "tfghjgkv", desktop: "tfghjgkw" }, defaultClass: "tfghjgku" }, uppercase: { conditions: { mobile: "tfghjgkx", tablet: "tfghjgky", desktop: "tfghjgkz" }, defaultClass: "tfghjgkx" } } }, textOverflow: { values: { ellipsis: { conditions: { mobile: "tfghjgl0", tablet: "tfghjgl1", desktop: "tfghjgl2" }, defaultClass: "tfghjgl0" } } }, width: { values: { "100vw": { conditions: { mobile: "tfghjgl3", tablet: "tfghjgl4", desktop: "tfghjgl5" }, defaultClass: "tfghjgl3" }, "100%": { conditions: { mobile: "tfghjgl6", tablet: "tfghjgl7", desktop: "tfghjgl8" }, defaultClass: "tfghjgl6" }, "100px": { conditions: { mobile: "tfghjgl9", tablet: "tfghjgla", desktop: "tfghjglb" }, defaultClass: "tfghjgl9" }, "170px": { conditions: { mobile: "tfghjglc", tablet: "tfghjgld", desktop: "tfghjgle" }, defaultClass: "tfghjglc" } } }, maxWidth: { values: { "100%": { conditions: { mobile: "tfghjglf", tablet: "tfghjglg", desktop: "tfghjglh" }, defaultClass: "tfghjglf" } } }, objectFit: { values: { contain: { conditions: { mobile: "tfghjgli", tablet: "tfghjglj", desktop: "tfghjglk" }, defaultClass: "tfghjgli" } } }, whiteSpace: { values: { nowrap: { conditions: { mobile: "tfghjgll", tablet: "tfghjglm", desktop: "tfghjgln" }, defaultClass: "tfghjgll" }, "pre-wrap": { conditions: { mobile: "tfghjglo", tablet: "tfghjglp", desktop: "tfghjglq" }, defaultClass: "tfghjglo" } } }, fontFamily: { values: { "Bagoss Condensed": { conditions: { mobile: "tfghjglr", tablet: "tfghjgls", desktop: "tfghjglt" }, defaultClass: "tfghjglr" } } }, visibility: { values: { visible: { conditions: { mobile: "tfghjglu", tablet: "tfghjglv", desktop: "tfghjglw" }, defaultClass: "tfghjglu" }, hidden: { conditions: { mobile: "tfghjglx", tablet: "tfghjgly", desktop: "tfghjglz" }, defaultClass: "tfghjglx" }, inherit: { conditions: { mobile: "tfghjgm0", tablet: "tfghjgm1", desktop: "tfghjgm2" }, defaultClass: "tfghjgm0" } } } } });
var colorVariants_css_ts_vanilla = "";
var colorVariants = { orange100: "_34c85f0", orange400: "_34c85f1", orange500: "_34c85f2", orange600: "_34c85f3", orange700: "_34c85f4", deepGreen100: "_34c85f5", deepGreen400: "_34c85f6", deepGreen500: "_34c85f7", deepGreen600: "_34c85f8", deepGreen700: "_34c85f9", green100: "_34c85fa", green400: "_34c85fb", green500: "_34c85fc", green600: "_34c85fd", green700: "_34c85fe", lightBlue: "_34c85ff", offWhite: "_34c85fg", greyscale0: "_34c85fh", greyscale50: "_34c85fi", greyscale100: "_34c85fj", greyscale200: "_34c85fk", greyscale300: "_34c85fl", greyscale400: "_34c85fm", greyscale500: "_34c85fn", greyscale600: "_34c85fo", greyscale900: "_34c85fp", success100: "_34c85fq", success400: "_34c85fr", success500: "_34c85fs", success600: "_34c85ft", success700: "_34c85fu", success800: "_34c85fv", warning100: "_34c85fw", warning400: "_34c85fx", warning500: "_34c85fy", warning600: "_34c85fz", warning700: "_34c85f10", warning800: "_34c85f11", error100: "_34c85f12", error400: "_34c85f13", error500: "_34c85f14", error600: "_34c85f15", error700: "_34c85f16", error800: "_34c85f17", white: "_34c85f18" };
var styles_css_ts_vanilla$1 = "";
var typographyVariants = { display: "_1svba18b tfghjg86 tfghjglr", heading1: "_1svba18c tfghjg86 tfghjglr", heading2: "_1svba18d tfghjg86 tfghjglr", heading3: "_1svba18e tfghjg8c", heading4: "_1svba18f tfghjg8c", heading5: "_1svba18g tfghjg8c", bodyL: "_1svba18h tfghjg89", bodyM: "_1svba18i tfghjg89", description: "_1svba18j tfghjg89", caption: "_1svba18k tfghjg89", small: "_1svba18l tfghjg89" };
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = react__WEBPACK_IMPORTED_MODULE_0__, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, g) {
  var b, d = {}, e = null, h = null;
  void 0 !== g && (e = "" + g);
  void 0 !== a.key && (e = "" + a.key);
  void 0 !== a.ref && (h = a.ref);
  for (b in a)
    m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      void 0 === d[b] && (d[b] = a[b]);
  return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
}
reactJsxRuntime_production_min.Fragment = l;
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
const Typography = ({
  alignment = "inherit",
  as = "p",
  children,
  className,
  color,
  strong,
  variant = "bodyM",
  ...rest
}) => {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as, {
    children,
    className: cn(typographyVariants[variant], colorVariants[color || "greyscale600"], sprinkles({
      textAlign: alignment
    }), strong === true && sprinkles({
      fontWeight: 600
    }), className),
    ...rest
  });
};
const Display = (props) => /* @__PURE__ */ jsx(Typography, {
  as: "h1",
  variant: "display",
  ...props
});
const Heading1 = (props) => /* @__PURE__ */ jsx(Typography, {
  as: "h1",
  variant: "heading1",
  ...props
});
const Heading2 = (props) => /* @__PURE__ */ jsx(Typography, {
  as: "h2",
  variant: "heading2",
  ...props
});
const Heading3 = (props) => /* @__PURE__ */ jsx(Typography, {
  as: "h3",
  variant: "heading3",
  ...props
});
const Heading4 = (props) => /* @__PURE__ */ jsx(Typography, {
  as: "h4",
  variant: "heading4",
  ...props
});
const Heading5 = (props) => /* @__PURE__ */ jsx(Typography, {
  as: "h5",
  variant: "heading5",
  ...props
});
const BodyLarge = (props) => /* @__PURE__ */ jsx(Typography, {
  variant: "bodyL",
  ...props
});
const BodyM = (props) => /* @__PURE__ */ jsx(Typography, {
  variant: "bodyM",
  ...props
});
const Description = (props) => /* @__PURE__ */ jsx(Typography, {
  variant: "description",
  ...props
});
const Caption = (props) => /* @__PURE__ */ jsx(Typography, {
  variant: "caption",
  ...props
});
const Small = (props) => /* @__PURE__ */ jsx(Typography, {
  variant: "small",
  ...props
});
var styles_css_ts_vanilla = "";
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var shouldApplyCompound = (compoundCheck, selections, defaultVariants) => {
  for (var key of Object.keys(compoundCheck)) {
    var _selections$key;
    if (compoundCheck[key] !== ((_selections$key = selections[key]) !== null && _selections$key !== void 0 ? _selections$key : defaultVariants[key])) {
      return false;
    }
  }
  return true;
};
var createRuntimeFn = (config) => (options) => {
  var className = config.defaultClassName;
  var selections = _objectSpread2(_objectSpread2({}, config.defaultVariants), options);
  for (var variantName in selections) {
    var _selections$variantNa;
    var variantSelection = (_selections$variantNa = selections[variantName]) !== null && _selections$variantNa !== void 0 ? _selections$variantNa : config.defaultVariants[variantName];
    if (variantSelection != null) {
      var selection = variantSelection;
      if (typeof selection === "boolean") {
        selection = selection === true ? "true" : "false";
      }
      var selectionClassName = config.variantClassNames[variantName][selection];
      if (selectionClassName) {
        className += " " + selectionClassName;
      }
    }
  }
  for (var [compoundCheck, compoundClassName] of config.compoundVariants) {
    if (shouldApplyCompound(compoundCheck, selections, config.defaultVariants)) {
      className += " " + compoundClassName;
    }
  }
  return className;
};
var button = createRuntimeFn({ defaultClassName: "hsof8j1 tfghjghi tfghjgio tfghjg6 tfghjg1u tfghjgac tfghjglf", variantClassNames: { color: { dark: "hsof8j4", light: "hsof8j5" }, style: { primary: "hsof8j6", secondary: "hsof8j7", tertiary: "hsof8j8" }, shape: { "default": "hsof8j9", round: "hsof8j2" }, size: { big: "hsof8jb", medium: "hsof8jc", small: "hsof8jd" } }, defaultVariants: { color: "dark", style: "primary", shape: "default", size: "medium" }, compoundVariants: [[{ color: "dark", style: "primary" }, "hsof8je"], [{ color: "light", style: "primary" }, "hsof8jf"], [{ color: "dark", style: "secondary" }, "hsof8jg"], [{ color: "light", style: "secondary" }, "hsof8jh"], [{ color: "dark", style: "tertiary" }, "hsof8ji"], [{ color: "light", style: "tertiary" }, "hsof8jj"]] });
var loadingAnimation = "hsof8jm tfghjg20";
const Button = ({
  ariaLabel,
  asLink,
  center,
  className,
  colorVariant = "dark",
  disabled = false,
  fullWidth,
  Icon,
  iconRight,
  label,
  loading = false,
  minWidth,
  onClick,
  sizeVariant = "medium",
  styleVariant = "primary",
  shapeVariant = "default",
  type = "button",
  ...props
}) => {
  const buttonContent = loading ? /* @__PURE__ */ jsx("span", {
    className: cn(
      loadingAnimation
    )
  }) : /* @__PURE__ */ jsxs(Fragment, {
    children: [Icon && /* @__PURE__ */ jsx(Icon, {
      className: sprinkles({
        flexShrink: 0
      }),
      width: 14
    }), label && /* @__PURE__ */ jsx("span", {
      className: sprinkles({
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }),
      children: label
    })]
  });
  if (asLink) {
    return /* @__PURE__ */ jsx("div", {
      className: cn(button({
        color: colorVariant,
        size: sizeVariant,
        style: styleVariant
      }), iconRight && sprinkles({
        flexDirection: "row-reverse"
      }), disabled && sprinkles({
        cursor: "not-allowed"
      }), center && sprinkles({
        margin: "0 auto"
      }), className),
      ...props,
      children: buttonContent
    });
  }
  return /* @__PURE__ */ jsx("button", {
    "aria-label": ariaLabel,
    className: cn(button({
      color: colorVariant,
      size: sizeVariant,
      style: styleVariant,
      shape: shapeVariant
    }), iconRight && sprinkles({
      flexDirection: "row-reverse"
    }), disabled && sprinkles({
      cursor: "not-allowed"
    }), center && sprinkles({
      margin: "0 auto"
    }), fullWidth && sprinkles({
      width: "100%"
    }), className),
    disabled,
    style: minWidth ? {
      minWidth
    } : {},
    type,
    onClick,
    ...props,
    children: buttonContent
  });
};
var styles_css_tsx_vanilla = "";
var textLinkIcon = "_1nmiuvm7";
var textLinkLabel = "_1nmiuvm8";
var textLinkWrapper = createRuntimeFn({ defaultClassName: "_1nmiuvm0", variantClassNames: { color: { dark: "_1nmiuvm2", error: "_1nmiuvm3", light: "_1nmiuvm4", success: "_1nmiuvm5", warning: "_1nmiuvm6" } }, defaultVariants: {}, compoundVariants: [] });
const BaseIcon = ({
  children,
  ...props
}) => /* @__PURE__ */ jsx("svg", {
  style: {
    fill: "currentcolor"
  },
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children
});
const Chevron = (props) => {
  return /* @__PURE__ */ jsx(BaseIcon, {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      clipRule: "evenodd",
      d: "M15.5 5.83486L8 13.4395L0.5 5.83486L1.87621 4.43945L8 10.6479L14.1238 4.43945L15.5 5.83486Z",
      fillRule: "evenodd"
    })
  });
};
const TextLink = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({
  center,
  className,
  href,
  label,
  onClick,
  rel,
  sizeVariant = "small",
  styleVariant = "dark",
  target,
  withIcon,
  ...props
}, ref) => {
  const LinkLabel = ({
    children,
    className: className2
  }) => {
    return sizeVariant === "small" ? /* @__PURE__ */ jsx(Description, {
      className: className2,
      children
    }) : /* @__PURE__ */ jsx(BodyM, {
      className: className2,
      children
    });
  };
  return /* @__PURE__ */ jsxs("a", {
    ref,
    className: cn(center && sprinkles({
      textAlign: "center"
    }), textLinkWrapper({
      color: styleVariant
    })),
    href,
    onClick,
    ...props,
    children: [/* @__PURE__ */ jsx(LinkLabel, {
      className: textLinkLabel,
      children: label
    }), withIcon && /* @__PURE__ */ jsx(Chevron, {
      className: textLinkIcon,
      height: 8,
      width: 8
    })]
  });
});
const TextLinkButton = ({
  className,
  label,
  onClick,
  sizeVariant = "small",
  styleVariant = "dark",
  withIcon,
  ...props
}) => {
  const LinkLabel = ({
    children,
    className: className2
  }) => {
    return sizeVariant === "small" ? /* @__PURE__ */ jsx(Description, {
      className: className2,
      children
    }) : /* @__PURE__ */ jsx(BodyM, {
      className: className2,
      children
    });
  };
  return /* @__PURE__ */ jsxs("button", {
    className: cn(sprinkles({
      textAlign: "left"
    }), textLinkWrapper({
      color: styleVariant
    })),
    onClick,
    ...props,
    children: [/* @__PURE__ */ jsx(LinkLabel, {
      className: textLinkLabel,
      children: label
    }), withIcon && /* @__PURE__ */ jsx(Chevron, {
      className: textLinkIcon,
      height: 8,
      width: 8
    })]
  });
};
const mq = {
  desktop: "screen and (min-width: 1024px)",
  tablet: "screen and (min-width: 768px)"
};



/***/ }),

/***/ 56676:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getPluralRules; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

// does not check for duplicate subtags
var isStructurallyValidLanguageTag = function isStructurallyValidLanguageTag(locale) {
  return locale.split('-').every(function (subtag) {
    return /[a-z0-9]+/i.test(subtag);
  });
};

var canonicalizeLocaleList = function canonicalizeLocaleList(locales) {
  if (!locales) return [];
  if (!Array.isArray(locales)) locales = [locales];
  var res = {};

  for (var i = 0; i < locales.length; ++i) {
    var tag = locales[i];
    if (tag && _typeof(tag) === 'object') tag = String(tag);

    if (typeof tag !== 'string') {
      // Requiring tag to be a String or Object means that the Number value
      // NaN will not be interpreted as the language tag "nan", which stands
      // for Min Nan Chinese.
      var msg = "Locales should be strings, ".concat(JSON.stringify(tag), " isn't.");
      throw new TypeError(msg);
    }

    if (tag[0] === '*') continue;

    if (!isStructurallyValidLanguageTag(tag)) {
      var strTag = JSON.stringify(tag);

      var _msg = "The locale ".concat(strTag, " is not a structurally valid BCP 47 language tag.");

      throw new RangeError(_msg);
    }

    res[tag] = true;
  }

  return Object.keys(res);
};

var defaultLocale = function defaultLocale() {
  return (
    /* istanbul ignore next */
    typeof navigator !== 'undefined' && navigator && (navigator.userLanguage || navigator.language) || 'en-US'
  );
};

var getType = function getType(type) {
  if (!type) return 'cardinal';
  if (type === 'cardinal' || type === 'ordinal') return type;
  throw new RangeError('Not a valid plural type: ' + JSON.stringify(type));
};

function getPluralRules(NumberFormat, getSelector, getCategories) {
  var findLocale = function findLocale(locale) {
    do {
      if (getSelector(locale)) return locale;
      locale = locale.replace(/-?[^-]*$/, '');
    } while (locale);

    return null;
  };

  var resolveLocale = function resolveLocale(locales) {
    var canonicalLocales = canonicalizeLocaleList(locales);

    for (var i = 0; i < canonicalLocales.length; ++i) {
      var lc = findLocale(canonicalLocales[i]);
      if (lc) return lc;
    }

    return findLocale(defaultLocale());
  };

  var PluralRules = /*#__PURE__*/function () {
    function PluralRules(locales) {
      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, PluralRules);

      this._locale = resolveLocale(locales);
      this._select = getSelector(this._locale);
      this._type = getType(opt.type);
      this._nf = new NumberFormat('en', opt); // make-plural expects latin digits with . decimal separator
    }

    _createClass(PluralRules, [{
      key: "resolvedOptions",
      value: function resolvedOptions() {
        var _this$_nf$resolvedOpt = this._nf.resolvedOptions(),
            minimumIntegerDigits = _this$_nf$resolvedOpt.minimumIntegerDigits,
            minimumFractionDigits = _this$_nf$resolvedOpt.minimumFractionDigits,
            maximumFractionDigits = _this$_nf$resolvedOpt.maximumFractionDigits,
            minimumSignificantDigits = _this$_nf$resolvedOpt.minimumSignificantDigits,
            maximumSignificantDigits = _this$_nf$resolvedOpt.maximumSignificantDigits;

        var opt = {
          locale: this._locale,
          minimumIntegerDigits: minimumIntegerDigits,
          minimumFractionDigits: minimumFractionDigits,
          maximumFractionDigits: maximumFractionDigits,
          pluralCategories: getCategories(this._locale, this._type === 'ordinal'),
          type: this._type
        };

        if (typeof minimumSignificantDigits === 'number') {
          opt.minimumSignificantDigits = minimumSignificantDigits;
          opt.maximumSignificantDigits = maximumSignificantDigits;
        }

        return opt;
      }
    }, {
      key: "select",
      value: function select(number) {
        if (!(this instanceof PluralRules)) throw new TypeError("select() called on incompatible ".concat(this));
        if (typeof number !== 'number') number = Number(number);
        if (!isFinite(number)) return 'other';

        var fmt = this._nf.format(Math.abs(number));

        return this._select(fmt, this._type === 'ordinal');
      }
    }], [{
      key: "supportedLocalesOf",
      value: function supportedLocalesOf(locales) {
        return canonicalizeLocaleList(locales).filter(findLocale);
      }
    }]);

    return PluralRules;
  }();

  Object.defineProperty(PluralRules, 'prototype', {
    writable: false
  });
  return PluralRules;
}




/***/ }),

/***/ 39743:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 75451:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 88718:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 65594:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 66840:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ }),

/***/ 17670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 96817:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 29559:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65594);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 62271:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 3292:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 63796:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75451);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17670);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96817);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30732);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 76131:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(39743);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(17670);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(30732);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 30732:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39743);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 93728:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"it/bologna/centro":"The center of Bologna is one of the most important places for Italian youth, a lively and vibrant area where artists, students and professionals of all kinds live. It is a true melting pot of different backgrounds, cultures and traditions that, surrounded by the history and monuments of Bologna, find the space to express themselves best. A place full of life and historic palaces, doors and unique views to admire. Its strategic locations makes it perfect for easily reaching anywhere in the city.<1/><1/>View all the Casavo listings for houses for sale in the center of <0>Bologna</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/bologna/san-donato-pilastro":"The San Donato and Pilastro area is located in the northeast part of the city of Bologna. It is a peaceful neighborhood full of cultural activities, wide tree-lined streets and historic palaces. Here you will find also the University of Bologna main campus and therefore it very frequented by students. In the past it was an important area for trade thanks to the presence of the imposing railway station, which was once used as a freight yard. Today, the same station connects San Donato to the rest of the city. The area is not far from downtown, to which it is well connected by trains.<1/><1/>View all the Casavo listings for houses for sale in San Donato and Pilastro, <0>Bologna</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/bologna/san-vitale-mazzini":"The San Vitale and Mazzini district in Bologna is often lumped together with the nearby area of San Donato, while instead they have two separate identities. This area is well served by public transportation, especially by a large railway network that connects it to the rest of the city. The S. Orsola Hospital is located here ad is an important destination for many medical students and researchers. The San Vitale district is close to the historic city center and is home to many modern buildings in addition to a historic residential area. Its urban landscape is constantly evolving. The wide variety of artistic activities and events make it a very lively district from a cultural point of view as well.<1/><1/>View all the Casavo listings for houses for sale in San Vitale and Mazzini, <0>Bologna</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/bologna/murri-massarenti":"The Santo Stefano, Murri and Massarenti district of Bologna is one of the most exclusive in the city. It is a very elegant area full of ancient monuments and is one of the most well-known and beloved places in the entire city. For most of the twentieth century, the neighborhood was home to Italian upper class families. Today it presents a very varied and constantly changing picture, while maintaining its more traditional imprint. It is connected to the rest of the city by several railway lines. The presence of the Bologna bus station makes it an indispensable hub for travelers. Also in this area is the Margherita Gardens, one of the most important parks in the city.<1/><1/>View all the Casavo listings for houses for sale in Santo Stefano, Murri and Massarenti, <0>Bologna</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/bologna/toscana-savena":"The Toscana and Savena district of Bologna is located in the southeastern part of the city. It represents a unique blend of history, nature and contemporary architecture and in fact all these elements blend together to create its unique identity. This area of the city is hilly and offers a unique view over the rest of the city. The presence of various parks and streams, including the charming Cedri Park and Paleotto Park, make it an ideal neighborhood for nature lovers even though it is not far from the services of the historic city center. It is well connected to the rest of the city thanks to the railway network.<1/><1/>View all the Casavo listings for houses for sale in Toscana and Savena, <0>Bologna</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/bologna/colli":"The Colli di Bologna (Bologna Hills) area is one of the most coveted and desired spots in the entire city, especially thanks to the environment that surrounds it. It is known for its unspoiled nature and extraordinary views as well as beautiful modern buildings that alternate with historic ones surrounded by greenery. The area is well connected to the rest of the city thanks to a large bus network and the wide streets are also a great way to get around on your own.<1/><1/>View all the Casavo listings for houses for sale in Colli di Bologna (Bologna Hills), <0>Bologna</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/bologna/bolognina-corticella-pescarola":"The Bolognina district is located behind the Bologna Central train station in a strategic area north of the city. Eclectic and vibrant, the Bolognina area has undergone various redevelopment projects that, however, have not affected its incredible history and cultural identity. Full of activities and shops, the neighborhood is never boring.<1/><1/>View all the Casavo listings for houses for sale in Bolognina, <0>Bologna</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/bologna/costa-saragozza-saffi":"The Costa, Saragozza and Saffi district of Bologna is perhaps one of the most elegant in the whole city. It is located a short distance from the city center and is well connected to the other districts thanks to the railway line. Some of the area\'s historic buildings are true architectural treasures of Bologna and the proximity to the hills make it the perfect destination for nature lovers. Steeped in history and full of parks, the Costa, Zaragoza and Saffi district features lots of cultural activities and the many events that take place here make it a point of reference for the city\'s artists.<1/><1/>View all the Casavo listings for houses for sale in Costa, Saragozza and Saffi, <0>Bologna</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/bologna/barca-santa-viola":"The Reno, Barca and Santa Viola district in Bologna is one of the youngest and most popular neighborhoods that is constantly evolving and rich in cultural activities. Its strategic position means that it is very close to the historic area of Pratello, the Cineteca and the Museum of Modern Art. Precisely for this reason, and also for its being well connected to the rest of the city, it is one of the most popular areas for students. The Cavaticcio Park, the garden of the Museum of Modern Art, is one of the most important cultural landmarks in the city thanks to the events that take place there every year.<1/><1/>View all the Casavo listings for houses for sale in Reno, Barca and Santa Viola, <0>Bologna</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/bologna/aeroporto-borgo-panigale":"The Airport and Borgo Panigale districts in Bologna are located in the northwestern area of the city, between the Lavino and Reno rivers. Arising in ancient times as an independent town, Borgo Panigale was then absorbed into the city but continues to maintain its own very strong identity although now a part of the urban fabric of the city. It is one of the greenest areas of the city thanks to the numerous parks and gardens and is well connected to the rest of the city thanks to the network of trains. Borgo Panigale is also full of sports centers making it an important point of reference for athletes in the city.<1/><1/>View all the Casavo listings for houses for sale in airport and Borgo Panigale, <0>Bologna</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/centro":"The center of Florence is universally recognized as one of the most beautiful places in the world. The incredible art that fills its museums and the picturesque charm of its streets blend together with its ancient history, which can be found in nearly every corner of the downtown area. A wonderful and eclectic place, deeply steeped in tradition but youthful and full of energy at the same time. It is one of the most beautiful and visited places in all of Italy and is sure to enchant anyone who visits.<1/><1/>View all the Casavo listings for houses for sale in the center of <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/oltrarno":"The Oltrarno area in Florence is located on the left bank of the Arno River. In the Florentine dialect it is also known as \\"Diladdarno\\" and is one of the most characteristic areas of the historic city center of Florence. Iconic and picturesque, this area is a historical destination of great importance for the whole city. You can still find all kinds of ancient artisan workshops and important historic sights such as Palazzo Pitti or the Bardini Garden. Within the Oltrarno area there are historic neighborhoods, like that of San Frediano. To live in the Oltrarno district is to live in the very heart of Florence.<1/><1/>View all the Casavo listings for houses for sale in Oltrarno, <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/leopoldo-porta-al-prato":"The area of Piazza Leopoldo and Porta al Prato in Florence is characteristic and rich in history and the noble palaces help to create a picturesque ambiance. It is well connected to other districts thanks to its strategic position and railway lines. The Piazza Leopoldo square is located in the heart of Florence and the surrounding area is all very elegant. The tall houses and noble palaces overlook historical monuments such as the ancient city door of Porta al Prato, which is one of the symbols of the city.<1/><1/>View all the Casavo listings for houses for sale in Piazza Leopoldo and Porta al Prato, <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/campo-di-marte-liberta":"The Campo di Marte and Libertà district is located a short distance from historic downtown Florence. It is one of the best alternatives to the hectic lifestyle of the center. It is a very popular area for university students because it is quiet and well connected to the rest of the city. Because it has many young people, the Campo di Marte and Libertà district has a youthful vibe with lots to do and is constantly expanding. Among the biggest attractions is the Artemio Franchi Stadium, the main site of the Fiorentina soccer team.<1/><1/>View all the Casavo listings for houses for sale in Campo di Marte and Libertà, <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/firenze-nord":"The Firenze Nord area encloses some of the most beautiful neighborhoods and districts of the city. Particularly well-loved by both travelers and locals, it is one of the most visited areas of Tuscany. It is bordered by the Arno on one side and on the other it is near the towns of Prato and Fiesole. An ideal and strategic position to be within walking distance from the center but also from some of the most beautiful areas in the outlying areas. North Florence is rich in artistic places, unique districts, historic neighborhoods and picturesque noble palaces.<1/><1/>View all the Casavo listings for houses for sale in Firenze Nord, <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/ugnano-mantignano":"The Ugnano and Mantignano districts are located just a short distance from the Arno River and are one of the most popular and characteristic spots in the southern part of Florence. Populated largely by students and families, it is the ideal place to live near the center of Florence while remaining in a quiet and well-kept area. It is connected to the rest of the city by bus and its proximity to a rail stop also brings it closer to the farthest points of the city.<1/><1/>View all the Casavo listings for houses for sale in Ugnano and Mantignano, <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/l-isolotto":"The Isolotto area of Florence is located on the southwestern side of the city. Bordered in part by the Arno River, it contains some historic neighborhoods such as Torri and Arginrosso, which also has a park of the same name. Together with the Legnaia area, this group of areas is called the \\"District 4\\" of Florence. District 4 is connected to the historic downtown area by the railway line and several bus lines.<1/><1/>View all the Casavo listings for houses for sale in Isolotto, <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/legnaia-soffiano":"The Legnaia and Soffiano area in Florence is one of the busiest parts of the city outside the historic center, at least partly due to its historic sights. In addition to green residential areas like Soffiano, Legnaia also has a more modern part and views of the surrounding natural areas. It is a very quiet area yet close to the center of Florence and is well connected thanks to the train and the various bus lines in the area.<1/><1/>View all the Casavo listings for houses for sale in Legnaia and Soffiano, <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/bellosguardo-galluzzo":"The Galluzzo and Bellosguardo district, are located on the left bank of the Arno River and are two of the oldest suburbs and well known in the city of Florence. Bellosguardo is noted because there are many villas which have hosted, over the centuries, several famous people. The Galluzzo district is especially well-known for the presence of the Certosa di Acciaiuoli and the charming Palazzo del Podestà. Both districts are connected with several bus lines not only to the city of Florence but also to the small villages of the nearby Chianti region.<1/><1/>View all the Casavo listings for houses for sale in Galluzzo and Bellosguardo <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/firenze-sud":"In Firenze Sud area you can find some of the most beautiful historical landmarks of the whole city as well as some of its most beloved buildings. It is an area bordered by the banks of the Arno River and is full of tradition and modernity at the same time. South Florence is home to unique districts such as that of Scandicci or the ancient Porta Romana area. The dense railway network connects each neighborhood and district with the rest of the city and this is a popular area for students as well. Young and vibrant, Florence South is a part of the city that is just waiting to be discovered.<1/><1/>View all the Casavo listings for houses for sale in Firenze Sud, <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/coverciano-bellariva":"The Coverciano and Bellariva areas are located a short distance from the banks of the Arno and are one of the most popular spots in the entire city, especially among students and families. Thanks to the presence of the railway network, both areas are well connected to the rest of the city. Here there are ancient noble palaces and a significant amount of the history of Florence took place here, but there are also more modern buildings that demonstrate its continuing cultural evolution.<1/><1/>View all the Casavo listings for houses for sale in Coverciano and Bellariva, <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/bolognese-le-cure":"The Bolognese - Le Cure area of Florence is located near the historic city center and borders along the beautiful town of Fiesole. Here there are many ancient villas as well as more modern buildings which helps to create a one-of-a-kind panorama. Its proximity to the city makes it very popular, especially for those who want to live in a quiet environment not far from the center. It is an area that is close to nature and its main road is an important thoroughfare for the traffic of the city.<1/><1/>View all the Casavo listings for houses for sale in Bolognese - Le Cure, <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/serpiolle-careggi":"The Careggi district is located in the small Florentine suburb of Serpiolle. It is an area that is very popular with students and workers thanks to the presence of the Careggi Hospital, one of the most important in the city. Serpiolle features a hilly terrain surrounded by green areas and is well connected to the rest of the city of Florence thanks to the presence of the railway line. It is a quiet and well-kept area, away from the hectic pace of the historic center but close enough to reach it in no time!<1/><1/>View all the Casavo listings for houses for sale in Serpiolle and Careggi, <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/michelangelo-porta-romana":"The charming Michelangelo and Porta Romana area is one of the most lively and constantly evolving places in all of Florence. It features modern and avant-garde houses and apartments, in an area where newly built buildings alternate with wonderful old buildings and noble palaces. Its proximity to the spectacular Boboli Gardens will allow you to live just steps away from all the most beautiful sites of the historic downtown area without giving up the lush green surroundings.<1/><1/>View all the Casavo listings for houses for sale in Michelangelo and Porta Romana, <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/firenze/settignano-rovezzano":"The Rovezzano district is part of the municipality of Florence and is located in the area east of the city. Together with the Settignano area, they are both located not far from the beautiful area of Campo di Marte. They share a youthful atmosphere and enjoy popularity among students and younger families. This area is full of nature and beautiful natural elements. The ancient mill of Rovezzano is an absolutely unique historical attraction. It is connected to the rest of the city by the railway line and its natural elements and landscape make it a peaceful and attractive place.<1/><1/>View all the Casavo listings for houses for sale in Settignano and Rovezzano, <0>Florence</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/san-siro-trenno":"The San Siro and Trenno district is located in the western part of the city. It is one of the most famous areas in the world thanks to the presence of the imposing San Siro stadium. The stadium is surrounded by wide open green space and the neighborhood is well connected to the rest of the city thanks to the presence of the subway Red and Lilac Metro lines. <1/><1/>View all the Casavo listings for houses for sale in San Siro and Trenno, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/bisceglie-baggio-olmi":"The Bisceglie, Baggio and Olmi neighborhood has a soul that is ancient and modern at the same time. The first human settlements date back to the Celtic era, and this historical side coexists with the presence of modern pastel-colored buildings. This multifaceted area is full of excitement and not far from the center, making it perfect for those who want to experience a calm area of Milan surrounded by greenery not far from the other districts.<1/><1/>View all the Casavo listings for houses for sale in Bisceglie, Baggio and Olmi, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/genova-ticinese":"The Ticinese district is one of the historic areas of Milan. Corso Genova is one of the most popular streets in this area and is just steps away from the wonderful sites in the historic city center while maintaining its own identity and distinctive character. Among the contemporary palaces and historic buildings you can find architectural beauties that are emblematic of the area. The area is well served by public transportation and there are even tram tracks along Corso Genova.<1/><1/><1/><1/>View all the Casavo listings for houses for sale in Genova Ticinese, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/navigli":"The Navigli district is one of the most important historical areas of Milan. The entire area was, and still is, a true cultural hub of the city thanks to its ancient bookshops and many literary initiatives. In recent years, it has also become a very popular area for those looking for exclusive and fashionable venues. The Navigli area blends together the past and the future and fashion and art to become an expression of the most well-loved aspects of Milan.<1/><1/>View all the Casavo listings for houses for sale in Navigli, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/porta-romana-cadore-montenero":"The Porta Romana, Cadore and Montenero neighborhood is quickly becoming one of the most famous in all of Milan thanks to the innovative Prada Foundation building and its permanent exhibition. Inside the foundation there is also the exclusive Bar Luce, designed by the American director Wes Anderson. The Besana roundabout and the Ravizza Park best showcase the ancient architecture and nature of the area. It is connected to the rest of the city by subway with the Metro Lilac line.<1/><1/>View all the Casavo listings for houses for sale in Porta Romana, Cadore and Montenero, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/bande-nere-inganni":"The Bande Nere and Inganni area of Milan is young, multicultural and very modern. There are also some beautiful historical sites, such as the neo-Gothic San Francesco Church. You can also find natural beauty here by visiting Cave Park, the third largest park in the entire city. This area is well-liked by students and is connected to the rest of the city thanks to the presence of the Bande Nere subway station on the Metro Red line (M1).<1/><1/>View all the Casavo listings for houses for sale in Bande Nere and Inganni, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/famagosta-barona":"The Famagosta and Barona residential area is located south of the city. It has many green spaces but it also has the San Paolo Hospital, one of the most important hospitals in the whole city. There is also the IULM (University of Languages and Communication), the NABA (New Academy of Fine Arts) and the College of Milan. All these institutions and the presence of a Metro 2 line stop make it an area that is heavily frequented by students.<1/><1/>View all the Casavo listings for houses for sale in Famagosta and Barona, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/abbiategrasso-chiesa-rossa":"The Abbiategrasso, Chiesa Rossa area of Milan is brimming with history and has historic buildings that are among the oldest in the city. It stands out from the other districts thanks to the presence of the picturesque Rossa Church that gets its name, which means \\"Red\\" in English, from its unique scarlet brick facade. The area is very quiet and well connected to the rest of the city thanks to the Metro M2 line (aka Green line). The area has alternating tall modern buildings and historical monuments which creates a distinctive panorama and it is one of the most sought after areas for young families.<1/><1/>View all the Casavo listings for houses for sale in Abbiategrasso, Chiesa Rossa, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/porta-vittoria-lodi":"The Porta Vittoria and Lodi area is very popular and youthful and full of culture and vibrant activity. It connects several areas of the city, including that of Porta Romana and Corvetto. Precisely for this reason, it is very close to exclusive places in Milan such as the Prada Foundation. It is crossed by several bus and tram lines, and also has a subway stop on the Metro Yellow line.<1/><1/>View all the Casavo listings for houses for sale in Porta Vittoria and Lodi, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/solari-washington":"The Solari Washington area offers an ancient and modern mix featuring many beautiful historic buildings that have been renovated to create a one-of-a-kind panorama. Indeed, tradition and innovation come together in a unique way, expressing the most authentic spirit of Milan. It is a lively and well-kept area, full of historic buildings and tree-lined avenues. It is well connected to the historic downtown area thanks to the tram lines and is very close to the Metro 2 line (aka the Green line).<1/><1/>View all the Casavo listings for houses for sale in Solari Washington, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/ripamonti-vigentino":"The Ripamonti and Vigentino district is known above all for the presence of the Milan Polyclinic Hospital complex, considered one of the largest medical facilities in the whole country, and for its proximity to the picturesque Prada Foundation. Its strategic position allows you to quickly reach both Porta Romana and Piazza del Duomo. It is a quiet area that is well connected to the rest of the city thanks to tram lines such as the 9 and the 24.<1/><1/>View all the Casavo listings for houses for sale in Ripamonti and Vigentino, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/ponte-lambro-santa-giulia":"The Ponte Lambro and Santa Giulia residential district is located in the southeastern corner of the city of Milan. It is a new and very modern area that was designed by an international architect and its tall, modern buildings give the entire area a note of character and elegance. Not far away is the Milan Rogoredo station which connects the entire district to the city thanks to the Metro M3 line (aka Yellow line). The station is also for high-speed trains which connect Milan to the rest of Italy. This is an avant-garde and constantly evolving neighborhood that is full of excitement.<1/><1/>View all the Casavo listings for houses for sale in Ponte Lambro and Santa Giulia, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/corvetto-rogoredo":"The Corvetto and Rogoredo area of Milan is young, enterprising, constantly evolving and well connected to the rest of the city thanks to several bus lines and the Metro Yellow line. The Rogoredo station is an important hub for students and workers, connecting the area to the center and the surrounding areas at the same time. There are also many small green spaces and a library to enjoy.<1/><1/>View all the Casavo listings for houses for sale in Corvetto and Rogoredo, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/napoli-soderini":"The Soderini and Piazza Napoli area of Milan is very popular with students and workers. It is very close to the beautiful sites of the historic city center, such as the fascinating Sforzesco Castle, and is well connected to the rest of the city thanks to multiple tram lines. The area is also served by the Metro M2 line (aka Green line). This is an active and lively part of Milan that is constantly evolving, young, trendy, frequented by students of all kinds and full of activities and entertainment.<1/><1/>View all the Casavo listings for houses for sale in Soderini and Piazza Napoli, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/cimiano-crescenzago-adriano":"The Cimiano, Crescenzago and Adriano district is an area of Milan that is full of nature. It has two rivers, the Naviglio della Martesana River which passes through it and the Lambro River which runs along its border and also has a park of the same name. The Crescenzago Woods are a beautiful \\"green lung\\" in the heart of the city. The entire area is connected to the rest of Milan thanks to two subway stops on the Green Metro line (M2) and the light rail (MeLA).<1/><1/>View all the Casavo listings for houses for sale in Cimiano, Crescenzago and Adriano, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance. ","it/milano/forlanini":"The Forlanini district is part of the Milan 4 area to the east of the city. It is located between Linate Airport and the Città Studi district, so it is also very close to the universities and academies in the area. The Blue Metro line (M4) will soon be inaugurated to connect the entire district to the rest of the city.<1/><1/>View all the Casavo listings for houses for sale in Forlanini, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance. ","it/milano/citta-studi-susa":"The style of the Città Studi and Susa area in Milan can also be guessed from the name alone as \\"studi\\" means \\"research\\" in English. It is the part of the city that is most frequented by students thanks to the high concentration of universities and academies based here. These include the Milan Polytechnic University, La Statale University of Milan as well as clinics and research centers for students enrolled in scientific fields. Città Studi is connected to the rest of the city with a stop on the Green Metro line (M2), tram line 5 and several bus lines.<1/><1/>View all the Casavo listings for houses for sale in Città Studi and Susa, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance. ","it/milano/precotto-turro":"The Precotto and Turro district in Milan is located between the districts of Gorla and Bicocca, northeast of the city. The district is traversed by the Naviglio della Martesana River. It offers vast green spaces and a bike path that is widely used by people looking for an ecological way to get around. It is one of the districts of Milan that has been inhabited since ancient times and its history can still be seen in some of its churches. It is connected to the rest of the city thanks to three subway stations on the Metro Red line (M1), and is also well-known because of its proximity to Viale Monza.<1/><1/>View all the Casavo listings for houses for sale in Precotto and Turro, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/udine-lambrate":"The Lambrate district first developed as an industrial area and for many years it was the hub of Milan\'s industrial productivity. In recent years it has been remade into a hip destination and is much loved by young couples and students. Buildings that were once factories have become art galleries and the presence of Lambro Park makes the Udine and Lambrate area ideal for those looking for tranquility just a short walk from the center.<1/><1/>View all the Casavo listings for houses for sale in Lambrate, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/pasteur-rovereto":"The Pasteur Rovereto area in Milan is one of the most popular with the city\'s students thanks to its tall buildings and modern houses, but also for its strategic position. In fact, this area is very close to Città Studi which allows students to easily move between the different areas. There is also a beautiful city park and the area is served by the Rovereto station of the Metro M1 line (aka Red line) to quickly connect to the rest of the city.<1/><1/>View all the Casavo listings for houses for sale in Pasteur Rovereto, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/centro":"Living in the center of Milan means living in the very heart of the city. Between Piazza Duomo, Sempione Park and the Sforzesco Castle you will have history, art and nature within easy reach. You will have luxury fashion boutiques, restaurants and museums of all kinds at your fingertips. Downtown Milan is a true melting pot of cultures, history and modernity. It is connected to the rest of the city by two subway Metro lines (the Red line and the Yellow line).<1/><1/>View all the Casavo listings for houses for sale in the center of <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/arco-della-pace-arena-pagano":"The Arco della Pace and Arena Pagano residential neighborhood in Milan is a very busy and highly visible area because of its singular style. Refined and elegant, this area boasts beautiful Art Nouveau buildings that are historic and full of history. The streets are very elegant and give the whole area a unique and distinctive character. It is also close to green spaces and is well connected to the rest of the city by multiple tram lines and the Metro.<1/><1/>View all the Casavo listings for houses for sale in Arco della Pace and Arena Pagano, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/quadronno-palestro-guastalla":"The neighborhoods of Quadronno, Palestro and Guastalla together form one of the most elegant and modern residential areas of Milan. The beautiful tall buildings with modern touches alternate with ancient and picturesque villas. A very contemporary area, where Milan\'s traditions and modernity are at their very best. It is well connected to the rest of the city thanks to the presence of multiple tram lines and it is very close to the Metro M3 line (aka Yellow line).<1/><1/>View all the Casavo listings for houses for sale in Quadronno, Palestro and Guastalla, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/garibaldi-moscova-porta-nuova":"The Garibaldi, Moscova and Porta Nuova area in Milan is eclectic, full of life, only steps away from the historic attractions of the city and offers all kinds of public transportation options. In fact, in addition to having stations for four different subway Metro lines, the area of Garibaldi, Moscova and Porta Nuova is also serviced by several bus and tram lines. It is also close to historical sights such as the picturesque Sforzesco Castle.<1/><1/>View all the Casavo listings for houses for sale in Garibaldi, Moscova and Porta Nuova, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/porta-venezia-indipendenza":"The history and charm of Porta Venezia and Indipendenza area can be found in its Art Nouveau buildings and in the beautiful noble palaces, which give the whole area a touch of class. The Indro Montanelli garden is perfect for immersing yourself in nature. The area is also full of scientific buildings, such as the Civic Museum of Natural History and the Planetarium. The presence of the Porta Venezia stop on the Red Metro line quickly connects the area to the rest of the city.<1/><1/>View all the Casavo listings for houses for sale in Porta Venezia and Indipendenza, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/centrale-repubblica":"Milano Centrale train station is the second most important Italian train station in terms of passenger traffic. It is an incredible space located in the heart of the city with majestic and imposing architecture. Not only was it designed as the main hub for high-speed trains and connections with the rest of Europe, but it also represents a crucial hub for public transportation services within the city and to the Milanese shopping streets.<1/><1/>View all the Casavo listings for houses for sale in Centrale, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance. ","it/milano/cenisio-sarpi-isola":"The Cenisio, Sarpi and Isola area of Milan is one of the most photographed and shared in the world, thanks to the presence of many skyscrapers including the incredible Bosco Verticale/Vertical Forest buildings. The image of these tall buildings covered in plants has become a true icon of the eco-friendly and futuristic soul of Milan. The area is connected to the rest of the city thanks to the subway stations of the Metro Yellow and Lilac lines.<1/><1/>View all the Casavo listings for houses for sale in Cenisio, Sarpi and Isola, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/bicocca-niguarda":"The Bicocca and Niguarda area of Milan is one of the most beloved by students and workers thanks to the large spaces, transportation connections and many cultural sites. It is famous both for the presence of the Arcimboldi Theater and especially for the exclusive Hangar Bicocca permanent exhibit. It is an active university center and the presence of the Nord Park is ideal for enjoying some green, open spaces. Bicocca is a very lively cultural area that is connected to the rest of the city by the Metro Lilac line.<1/><1/>View all the Casavo listings for houses for sale in Bicocca and Niguarda, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/maggiolina-istria":"Piazzale Istria and Maggiolina residential neighborhood, belonging to the Zadar area, represents one of the key points and busiest areas of Milan. The Piazzale Istria square is intersected by Viale Testi, one of the most important roads for moving around the area. It is also not far from Turro and the Ca \'Granda area and is well connected to the rest of the city thanks to plenty public transportation options. It is not only served by a bus line and three tram lines but also by the new Metro M5 line (aka Lilac line).<1/><1/>View all the Casavo listings for houses for sale in Piazzale Istria and Maggiolina, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/fiera-sempione-city-life-portello":"The Sempione, City Life and Portello area of Milan is one of the most modern zones in the city. It is located a short distance from the city center and from more historic areas, such as that of De Angeli. It is connected to the rest of the city thanks to the presence of subway stations on the Metro Red and Lilac lines, in addition to the historic tram 1 line. It is a modern and avant-garde area which seems to take Milan into the future.<1/><1/>View all the Casavo listings for houses for sale in Sempione, City Life and Portello, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance. ","it/milano/viale-certosa-cascina-merlata":"The splendid avenue of Viale Certosa in the Cascina Merlata district is one of the most iconic areas of Milan. The neighborhood has modern and charming buildings, but also many monuments and historical corners that give the whole area a very elegant feel. It is located a short distance from the historic city center and the Sforzesco Castle. Thanks to its strategic position it is also very popular with young people and students of all kinds. It is well connected to the rest of the city by tram and metro lines.<1/><1/>View all the Casavo listings for houses for sale in Viale Certosa, Cascina Merlata, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/milano/affori-bovisa":"The Affori and Bovisa area of Milan is located a short distance from the beautiful sights of the historic city center and from Piazza Duomo. Its streets represent one of the most important transit areas in the city, and it is a very popular area with students and workers thanks to its strategic position. It is, in fact, very close to some of the key points in the city and has several bus and tram lines and most importantly the Metro M2 line (aka Yellow line) which connects it to the rest of the city.<1/><1/>View all the Casavo listings for houses for sale in Affori and Bovisa, <0>Milan</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/centro-storico":"Rome\'s historic center is one of the oldest and most frequently visited in Europe and is a designated UNESCO world heritage site. Not only is it one of the oldest areas in the city, but also one of the liveliest areas that continues to evolve. The way in which the archaeological sites and Roman ruins blend together with the history of modern cinema demonstrates the true spirit of Rome, and is one of the focal points in the city\'s daily life.<1/><1/>View all the Casavo listings for houses for sale in <0>Rome</0>\'s historic center. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/prati-borgo-mazzini-delle-vittorie":"The Prati, Borgo, Mazzini and Delle Vittorie neighborhoods in Rome are the focal point for artistic and tourist life in the city. Thanks to this area\'s strategic position, it is possible to quickly reach not only the banks of the Tiber River but also important sights like Vatican City or Castel Sant\' Angelo. The entire area is well connected to the rest of the city thanks to the many bus lines and the presence of the Metro, and its antique and noble buildings give it an unrivaled elegance.<1/><1/>View all the Casavo listings for houses for sale in the Prati, Borgo, Mazzini and Delle Vittorie neighborhoods <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/parioli-flaminio":"The Parioli and Flaminio area is certainly one of the most exclusive in all of Rome, characterized by stately palaces and large tree-lined streets. Some of the most important and largest institutions are located here, such as the National Academy of Dramatic Arts. The very large Villa Ada Park is also located in this area. Not only that: the neighborhood is located near Villa Borghese, a real \\"green lung\\" of the city, where you will also find the Globe Theater and the Villa Borghese museum. It represents one of the most iconic faces of Rome.<1/><1/>View all the Casavo listings for houses for sale in the Parioli and Flaminio area <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/testaccio-trastevere":"The area of Testaccio and Trastevere is one of the most historic in Rome. The main streets branch off into picturesque alleyways, small lanes, tall ancient buildings and spectacular monuments. It is often referred to as one of the most well-loved and visited areas of the capital. It is a truly iconic area for the whole city and its strategic position means that it is close to major points of interest as well as the major bus and Metro lines. It is busy, full of life and one of the places where you can experience Rome\'s most authentic soul.<1/><1/>View all the Casavo listings for houses for sale in Testaccio and Trastevere <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/corso-francia-vigna-clara-fleming-ponte-milvio":"The Corso Francia, Vigna Clara, Fleming and Ponte Milvio areas are located north of the city of Rome. They are just a short distance from the banks of the Tiber and the incredible sites of the historic city center. They are areas in continuous architectural and cultural evolution and the beautiful modern buildings are often surrounded by greenery and flanked by wide tree-lined avenues. This location is near natural areas, such as the Foro Italico and the Inviolatella Borghese Park, so residents can enjoy an oasis of peace in the city.<1/><1/>View all the Casavo listings for houses for sale in Corso Francia, Vigna Clara, Fleming and Ponte Milvio <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/eur-torrino-tintoretto":"The EUR district is perhaps one of the most famous districts of the Roman suburbs. The wide streets and early twentieth century architecture create a unique landscape. The large number of offices here make it a very important point of convergence for those who work in the city. The artificial lake and the park that encircles it creates a characteristic small green space. Thanks to the presence of large buildings and complexes, the EUR neighborhood is often the location where cultural fairs and conventions are held.<1/><1/>View all the Casavo listings for houses for sale in EUR district, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/gregorio-vii-baldo-degli-ubaldi":"The Gregorio VII and Baldo degli Ubaldi areas are located in the western part of Rome. This is a truly privileged location due to its proximity to the city\'s most popular sites such as Vatican City and the banks of the Tiber. It is a quiet and well-kept area that is full of modern buildings and wide tree-lined streets. It is connected to the rest of the city thanks to several bus lines and the Metro A line and is quite popular with students and young families because of this reason.<1/><1/>View all the Casavo listings for houses for sale in Gregorio VII and Baldo degli Ubaldi <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/camilluccia-cortina-d-ampezzo":"The Camilluccia and Cortina d\'Ampezzo areas in Rome have large open spaces and are filled with greenery and nature thanks in part to their proximity to the Insugherata Nature Reserve. Located north of Rome, this area is well connected to the rest of the city thanks to the frequent buses that pass through on multiple routes. It is a quiet and green area with low buildings and characteristic houses. This part of the city is full of charm and silence and is the perfect place to live in tranquility just steps away from the center.<1/><1/>View all the Casavo listings for houses for sale in Camilluccia and Cortina d\'Ampezzo <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/cassia-san-godenzo-grottarossa":"The Grottarossa area is located north of the center of Rome, with both Via Cassia and Via San Godenzo passing through it. Via Cassia is one of the largest roads in the whole city and an important junction for the city\'s traffic. Here, modern buildings alternate with older buildings and Grottarossa\'s proximity of the banks of the Tiber lends the area a unique charm. It is a quiet and well-maintained area not far from the center.<1/><1/>View all the Casavo listings for houses for sale in Grottarossa <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/trionfale-monte-mario-ottavia":"The Trionfale area of Rome, also known by the name \\"Balduina\\" is one of the oldest in Rome. It is located next to Vatican City, and features a unique view of San Pietro\'s dome. Inside this district you will also find the Pineto Regional Urban Park, the second largest park in Rome and one of the most visited green areas in the city. Thanks to its strategic position it is very close to the most famous sights in Rome, while still retaining its calm atmosphere.<1/><1/>View all the Casavo listings for houses for sale in Trionfale area, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/magliana-trullo-parco-de-medici":"The Magliana area in Rome is young and constantly evolving and full of excitement and interesting places. The old  Magliana neighborhood is one of the most popular within this area and the large green space of ​​the Parco de\' Medici represents a small corner of tranquility in this very modern part of the city. It is well connected to the center thanks to the many bus lines and has a convenient Metro B line station.<1/><1/>View all the Casavo listings for houses for sale in Magliana <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/casetta-mattei-pisana-bravetta":"The Casetta Mattei, Via Pisana and Bravetta area in Rome is young, enterprising, full of ideas and a popular area for students and young families. It is constantly evolving and is one of the spots in the city that shows the most potential for the younger generations. It is served by several bus lines, and is also an important area for those looking for green space thanks to its proximity to the ancient Villa Pamphili.<1/><1/>View all the Casavo listings for houses for sale in Casetta Mattei, Via Pisana and Bravetta <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/aurelio-boccea":"The Aurelio and Boccea neighborhoods in Rome have a particular advantage, that of being close to downtown Rome as well as Vatican City. Another interesting aspect is the proximity to large hospitals, the presence of numerous and important commercial activities and public offices and the possibility of choosing from many housing options capable of responding to different needs and economic levels. At the same time the neighborhood is quiet and pleasant to live in and offers a wide range of services.<1/><1/>View all the Casavo listings for houses for sale in Aurelio and Boccea, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/battistini-torrevecchia":"The Battistini neighborhood and Via Torrevecchia street are located in the north-west area of Rome, a short distance from the historic city center and Vatican City. The Battistini area is well connected to the rest of the city thanks to a dense network of bus lines and the presence of the Metro Line 1 subway station. Torrevecchia street is one of the most important in the city because of how it connects the northern area with the historic city center.<1/><1/>View all the Casavo listings for houses for sale in Battistini neighborhood and Via Torrevecchia, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/acilia-casal-bernocchi-centro-giano-dragona-malafede-vitinia":"The Acilia, Casal Bernocchi, Centro Giano, Dragona, Malafede and Vitinia areas are located between the historic city center of Rome and the sea of Ostia and are green areas that are full of modern buildings and large open spaces. Thanks to the railway line, the entire area has easy connections to both Ostia and Rome but avoids the hustle and bustle feeling of city life. Bubbly, young and constantly evolving, the entire area is full of possibility.<1/><1/>View all the Casavo listings for houses for sale in Acilia, Casal Bernocchi, Centro Giano, Dragona, Malafede and Vitinia, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/lido-di-ostia-ostia-antica-castel-fusano":"The Lido di Ostia, Ostia Antica and Castel Fusano areas are all located a short distance from the center of Rome, but thanks to their proximity to the sea they feature a completely different lifestyle. They are well connected to the center thanks to the railway line but at the same time they represent a small world of their own. Not just the sea but also the presence of a large nature reserve contributes to making this area very interesting, and the presence of the nearby International Airport makes it an important transport hub for the region of Lazio and Italy.<1/><1/>View all the Casavo listings for houses for sale in Lido di Ostia, Ostia Antica and Castel Fusano, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/casal-lumbroso-massimina-ponte-galeria":"The Casal Lumbroso, Massimina and Ponte Galeria districts are very quiet and well-liked for their proximity to Rome and the peacefulness of the surrounding environment. To be exact,they are located between Rome and Ostia with a privileged location both for reaching the historic city center of Rome and for the proximity to beaches and nature reserves. They are well connected to both cities thanks to the railway network, which also arrives to the nearby Rome International Airport.<1/><1/>View all the Casavo listings for houses for sale in Casal Lumbroso, Massimina and Ponte Galeria, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/casalotti-casal-selce-maglianella":"The Casalotti, Casal Selce and Maglianella districts are located a short distance from the center of Rome and are well connected to the city thanks to the railway network. The wide streets and tree-lined avenues give the area a very peaceful quality that feels far from the hectic pace of the city. The area is also well connected to the city of Ostia. Cellulosa Park is a very interesting and popular green area located here.<1/><1/>View all the Casavo listings for houses for sale in Casalotti, Casal Selce and Maglianella, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/balduina-medaglie-d-oro-degli-eroi":"The Balduina area and the Viale di Medaglie d\'Oro Degli Eroi are located within the Trionfale district and just happen to be one of the most beautiful parts of Rome. This location is just steps away from the most beautiful and famous sights of the capital city, such as Vatican City, Castel Sant’Angelo and the Pantheon. It is a picturesque area like few others that is a real showcase of the historical and artistic life of the city. It represents a point of excellence for Rome and is well connected to other areas thanks to a large network of buses and metro stops.<1/><1/>View all the Casavo listings for houses for sale in Balduina area and the Viale di Medaglie d\'Oro Degli Eroi, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/axa-casal-palocco-infernetto":"The Axa, Casal Palocco and Infernetto areas are located not very far from Rome. Their vicinity to the center of the Capital and the beaches of Lido di Ostia makes it an area that is full of potential. The entire area is located not far from the ancient wonders of Castel Porziano and the Roman Coastal State Nature Reserve, which is one of the most important green spaces on the coast. It is a strategic position that is perfect for living in a calm environment but that is at the same time in constant cultural evolution.<1/><1/>View all the Casavo listings for houses for sale in Axa, Casal Palocco and Infernetto <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/re-di-roma-san-giovanni":"Together the San Giovanni and Piazza Re di Roma neighborhoods represent one of the most historically important areas of the city. The proximity to the incredible monuments such as the Papal Basilica of Santa Maria Maggiore or the Colosseum make it a point of excellence in the area. The ancient buildings and noble palaces give the area a style and elegance that is unique in the city. Piazza Re di Roma is one of the most important transportation hubs for getting around the city.<1/><1/>View all the Casavo listings for houses for sale in San Giovanni and Piazza Re di Roma, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/aventino-san-saba-caracalla":"The Aventine, San Saba and Caracalla neighborhoods in Rome are known above all for the presence of their excavations by the same name, and the general beauty of the whole area. The Baths of Caracalla, also called the Terme Antoniniane, are still today one of the largest examples of perfectly preserved Roman baths. The beauty of these historic buildings surrounded by greenery gives the whole area a unique feeling and the addition of modern buildings still blends in well with the rest of the environment. It is well connected to the rest of the city thanks to a large network of bus lines.<1/><1/>View all the Casavo listings for houses for sale in Aventine, San Saba and Caracalla, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/appio-latino-colli-albani":"The origins of the Appio Latino district of Rome are very ancient, but its transformation into a working-class area only took place in the first half of the 1900s. Its continuous evolution has allowed it to reinvent itself once again into one of the most popular neighborhoods of Rome. Its old and historic landmarks blend in well with other more modern elements. In fact, several films have been shot here. Today it is a modern and vibrant district that is well connected to the rest of the city by public transportation.<1/><1/>View all the Casavo listings for houses for sale in Appio Latino, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/garbatella-navigatori-ostiense":"Garbatella, Navigatori and Ostiense are three of the most lively, youthful and energetic neighborhoods in Rome. Much loved by students and working people, the entire area is well connected to the rest of the city thanks to a dense network of buses, trams and metro stops. The area is very popular with university students due to the presence of many important departments. This lively and historically important area is in constant evolution and not far from the beautiful sights of the historic center, while also having played an equally important part in the history of the city.<1/><1/>View all the Casavo listings for houses for sale in Garbatella, Navigatori and Ostiense, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/marconi-san-paolo":"The Marconi and San Paolo areas of Rome are two important districts for the city\'s students, thanks to the presence of several important departments of Roma Tre University. The area is well connected to the rest of the city thanks to many buses and the Metro B line. The proximity to the banks of the Tiber river creates unique views, giving the whole area a very characteristic feeling. This area is an important meeting point for students from all over the country, and is an area in constant cultural evolution.<1/><1/>View all the Casavo listings for houses for sale in Marconi and San Paolo, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/appia-pignatelli-ardeatino-montagnola":"The Ardeatino district is located south of Rome and gets its name from the ancient Via Ardeatina. It has large open spaces such as the Tenuta di Tormarancia and the Parco di Forte Ardeatino, which is also one of its most important historical attractions. In this district there is also the Appia Antica Regional Park, which has the distinction of being one of the largest urban parks in all of Europe. It is a very large neighborhood that is rich in history and very quiet but close enough to the historic city center of Rome to be in the middle of all the action very quickly.<1/><1/>View all the Casavo listings for houses for sale in Ardeatino, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/cecchignola-fonte-meravigliosa":"The Cecchignola and Fonte Meravigliosa areas are located south of the center of Rome and have a significant amount of green space. The wide tree-lined streets surrounded by greenery lead to the city center is a short amount of time and there are various bus lines that serve the area. Not far from here is the Laurentina station, as well as the GRA ring road. The street Via della Cecchignola is one of the most important ways for moving around the area.<1/><1/>View all the Casavo listings for houses for sale in Cecchignola and Fonte Meravigliosa, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/anagnina-romanina-tor-vergata":"The Anagnina and Tor Vergata neighborhoods are located in south-east Rome and are a section of the city that is highly sought after and frequented by students thanks to the presence of Tor Vergata University of Rome. The Anagnina station is on the subway Metro A line and connects the whole area to the rest of the city. The large tree-lined avenues and the surrounding nature ensure that the area is quiet, despite being very close to the action of downtown.<1/><1/>View all the Casavo listings for houses for sale in Anagnina and Tor Vergata, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/trigoria-castel-romano":"The Trigoria area is located south of Rome and is one of the most important areas for the city\'s working and cultural life. Located here are both the Polyclinic complex and the Biomedical Campus of the  University of Rome, both very popular with young students. The street Via di Castel Romano cuts through the area and is most famous for the presence of the Cinecittà World theme park, created by some of the greats of Italian cinema on the world stage and still today one of the most interesting attractions in the city.<1/><1/>View all the Casavo listings for houses for sale in Trigoria, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/cinecitta-quadraro":"The Cinecittà and Quadraro area features some of the most interesting sites from Rome\'s recent history, especially with regards to Italian and international cinema. The low buildings and wide streets give this area its characteristic look and feel. In addition to the attractions of Cinecittà, which are a point of excellence for all of Rome, the Quadraro area is also known for its wide streets and relaxed atmosphere. It is well connected to the center thanks to the Metro A line.<1/><1/>View all the Casavo listings for houses for sale in Cinecittà and Quadraro <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/monteverde-gianicolense-colli-portuensi-casaletto":"The Gianicolense neighborhood in Rome is known to most locals as the \\"Monteverde\\" area and is often identified with this name. It is famous for the Villa Doria Pamphili Park and, thanks to the park\'s presence, it is one of the greenest areas of Rome. The area\'s strategic location allows residents to quickly reach famous sights such as the Vatican City and the Colosseum. It has maintained a reputation as a quiet area even though it is close to busier areas.<1/><1/>View all the Casavo listings for houses for sale in Gianicolense, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/borghesiana-finocchio":"The neighborhoods of Borghesiana and Borgata Finocchio (also known only by the name of \\"Finocchio\\") are located east of the center of Rome. This is a very large area, full of historic buildings and intense cultural activity. It is an area that is very well connected to the center thanks to the presence of several stops on the Metro C line, a line famous for its state-of-the-art stations. This is a quiet but constantly evolving part of the city that has incredible potential.<1/><1/>View all the Casavo listings for houses for sale in Borghesiana and Borgata Finocchio, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/mezzocammino-spinaceto-tor-de-cenci":"The Mezzocammino, Spinaceto and Tor de\' Cenci neighborhoods are located south of Rome, not far from the Lazio coast. They are very quiet areas, not far from the small and charming Castel Porziano and the Roman Coast State Nature Reserve. The streets here feature lots of natural areas, palaces and villas immersed in green surroundings, and the area is ideal for a quiet lifestyle while still having downtown Rome at an easily reachable distance.<1/><1/>View all the Casavo listings for houses for sale in Mezzocammino, Spinaceto and Tor de\' Cenci, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/appio-claudio-capannelle":"The Appio Claudio and Capannelle areas are located in the southeast corner of Rome, and are connected to the center of Rome along several bus lines. The Appio Claudio neighborhood is known mostly for the large Park of the Aqueducts and the archaeological site found within the park. The ancient aqueducts surrounded by greenery give the entire area an iconic look and are one of the most interesting historic sites located on the outskirts of Rome.<1/><1/>View all the Casavo listings for houses for sale in Appio Claudio and Capannelle, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/castel-di-leva-vallerano":"The Castel di Leva and Vallerano areas are located to the south of Rome. This is a large area surrounded by green space that is very quiet and full of characteristic small buildings. The area is connected to the center of Rome thanks to various bus lines, but also wide roads that lead to the city. At the same time, it is also just as close to the Lazio coastline and the sea, thus offering a prime location during the summer months. It is an evolving area full of potential.<1/><1/>View all the Casavo listings for houses for sale in Castel di Leva and Vallerano, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/portuense-villa-bonelli":"The Portuense neighborhood of ​​Rome is one of the most lively but also one of the oldest and it is full of wonderful views and has a fascinating history. It is located in the southern area of ​​the city, close to the Aurelian Walls and the Tiber River. The Portunese district borders the Ostiense district. It is famous for the large Porta Portese market, which is held every Sunday and brings together people from all over the world. The slow flow of the river and the large historic buildings make it one of the most beloved areas of Rome.<1/><1/>View all the Casavo listings for houses for sale in Portuense, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/salario-trieste":"The Salario neighborhood is located on Via Salaria from which it gets its name and it is one of the most charming neighborhoods in all of Rome. Its historic buildings represent a unique variant in the Roman architectural panorama. Its proximity to the Parioli and Pinciano districts contributes to its reputation as an elegant and exclusive neighborhood. Two of the most iconic places in the area, without a doubt, are the former Peroni brewery and MACRO, the Museum of Contemporary Art.<1/><1/>View all the Casavo listings for houses for sale in the Salario neighborhood <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/termini-repubblica":"In Rome, the Termini train station and the Piazza della Repubblica are perhaps the two most visited places of the entire city, if only as a crossroads for travelers from all over the world. The Termini train station is one of the busiest train stations in the country and is used by thousands of visitors each day, while the nearby Piazza della Repubblica is straight of a postcard of the city. The square is large and majestic and leads to some of the most beautiful areas of the city. An elegant and stately area that is in constant movement.<1/><1/>View all the Casavo listings for houses for sale in the Termini train station and the Piazza della Repubblica <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/bologna-policlinico":"The ​​Bologna neighborhood and the Rome Polyclinic area are the center of attention for students and workers in the city. It is a very popular area for students from the Polyclinic and nearby university departments, and the metro stop of the same name connects the area with the rest of the city. The large tree-lined avenues and historic buildings give it a unique charm. It is also within easy reach of exclusive areas such as Parioli and the majestic Villa Borghese.<1/><1/>View all the Casavo listings for houses for sale in the ​​Bologna neighborhood <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/pigneto-san-lorenzo-casal-bertone":"The areas of Pigneto, San Lorenzo and Casal Bertone are among the youngest and most vibrant in all of Rome. Filled with students of all kinds and young professionals and workers, they are also the city\'s cultural hubs thanks to the many cultural associations and bookstores. These are colorful areas in constant cultural evolution, always changing, but they also have historic ancient palaces and many historic buildings to discover. Thanks to the presence of several tram lines, the entire area is well connected to the rest of the city.<1/><1/>View all the Casavo listings for houses for sale in the areas of Pigneto, San Lorenzo and Casal Bertone <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/talenti-monte-sacro-nuovo-salario":"The Monte Sacro district is on the right bank of the Aniene River, one of the affluents of the Tiber River. The Valle delle Aniene Nature Reserve is one of the most well-loved natural spots in the area. The picturesque Piazza Sempione opens on to the street of the same name, one of the most important crossroads in all of Rome. Among the beautiful historic sites that bring prestige to this area is Nomentano Bridge.<1/><1/>View all the Casavo listings for houses for sale in Monte Sacro <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/porta-di-roma-casal-boccone":"Porta di Roma and the Casal Boccone area are located north of the historic downtown area of Rome. They are neighborhoods full of history but at the same time they feature modern buildings that add a contemporary look to the skyline. A quiet and elegant zone, but also one with a decisive character close to green areas like the expansive Marcigliana Nature Reserve. An district of Rome that is full of potential and is sure to surprise.<1/><1/>View all the Casavo listings for houses for sale in Porta di Roma and the Casal Boccone, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/monti-tiburtini-pietralata":"The Pietralata district is located in south-east Rome. It is an eclectic and constantly evolving area that is just far enough away from the historic city center to maintain relative peace and quiet but close enough to arrive right away. It is also well connected to the rest of the city thanks to the presence of the subway Metro B line. The neighborhood has been the protagonist of stories written by Elsa Morante and Pier Paolo Pasolini and the Pietralata Fort is among the most important historical finds here.<1/><1/>View all the Casavo listings for houses for sale in Pietralata, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/centocelle-tor-de-schiavi":"The Centocelle neighborhood, also known by the name Prenestino, was given the name Centocelle or \\"a hundred chambers\\" because it is located on Via Prenestina. It is one of the most popular districts among students and workers looking for a quiet area that is well connected to the city thanks to the presence of two stops along the new subway Metro C line. The neighborhood itself has wide tree-lined streets, tall buildings, large houses and several green areas.<1/><1/>View all the Casavo listings for houses for sale in Centocelle, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/alessandrino-tor-sapienza-torre-maura":"The Alessandria neighborhood is located between Centocelle and Torre Spaccata. It is one of the areas in Rome most frequented by students and workers, but also boasts buildings of great historical importance. In fact, in this district there is the Alexandrian aqueduct from where the neighborhood gets its name. The aqueduct is located inside the Giovanni Patalucci Park, also known as the Tor Tre Teste Park, which is one of the largest green spots in the area.<1/><1/>View all the Casavo listings for houses for sale in Alessandria, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/bufalotta-casal-monastero-settebagni":"The Bufalotta, Casal Monastero and Settebagni areas in Rome are located in the north-eastern part of the city, just a short distance from the center. The entire area is well connected to the rest of the city thanks to several bus lines. Its proximity to green areas such as the Sabine Park or the Marcigliana Nature Reserve makes it perfect for those looking for a quiet neighborhood close to nature.<1/><1/>View all the Casavo listings for houses for sale in Bufalotta, Casal Monastero and Settebagni, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/ponte-di-nona-torre-angela":"The Ponte di Nona and Torre Angela neighborhoods are located east of the historic city center of Rome. The Ponte di Nona Archaeological Park is one of the most interesting historical destinations in the eastern area of Rome. The area\'s wide roads and many bus lines make transit to the center quick and easy. The presence of large green areas means that this is a very popular place with young families with children.<1/><1/>View all the Casavo listings for houses for sale in Ponte di Nona and Torre Angela, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/ponte-mammolo-san-basilio-tor-cervara":"The Ponte Mammolo area in Rome is located in the northeastern part of the city and is known for its ample open spaces and nature that surrounds it. The most popular natural areas are the Aguzzano Regional Urban Park and the Aniene Valley Nature Reserve, where the tributary of the Tiber with the same name flows. In this neighborhood there are also tufo rock quarries and several archaeological sites. The area is very quiet and not far from the action in the heart of Rome and is conveniently connected with the Metro B line of the subway.<1/><1/>View all the Casavo listings for houses for sale in Ponte Mammolo, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/lunghezza-castelverde":"The Lunghezza and Castelverde areas are located east of the center of Rome. They are not very far from the city while at the same time maintaining a much more relaxed atmosphere compared to the frenzy of the city center. The wide streets immediately connect the area to the center, while the many green spaces are perfect for young families with children looking for a quiet neighborhood. It is connected to the rest of the city with three different bus lines.<1/><1/>View all the Casavo listings for houses for sale in Lunghezza and Castelverde, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/olgiata-giustiniana":"The Olgiata and Giustiniana districts are located north of Rome and represent one of the most important areas on the outskirts of the city because of the large number of modern buildings, characteristic villas, green areas and bus lines that connect it to the surrounding locations. Both the Olgiata neighborhood and the Giustiniana neighborhood feature large tree-lined avenues and have a very relaxed atmosphere but at the same time a lively and constantly evolving daily buzz of activity. These are areas with great potential that are not far from the city center.<1/><1/>View all the Casavo listings for houses for sale in Olgiata and Giustiniana, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/roma/labaro-prima-porta-valle-muricana":"The Labaro, Prima Porta and Valle Muricana neighborhoods are located in the northern part of Rome and feature a unique style that is full of nature but not far from the historic city center. Its proximity to the banks of the Tiber River gives the area a very romantic feeling. It is well connected to the rest of the city not only thanks to the dense network of roads, but also thanks to the railway line that connects Rome to Viterbo which passes through the area.<1/><1/>View all the Casavo listings for houses for sale in Labaro, Prima Porta and Valle Muricana, <0>Rome</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/regio-parco-vanchiglia-vanchiglietta":"The Vanchiglia district in Turin is one of the most fascinating in the whole city. It is very popular with students thanks to the presence of the Einaudi Campus. It has one of the youngest faces of the city, while keeping its old soul intact. The neighborhood is an excellent place also with regards to the natural environment thanks to the presence of Colletta Park, one of the city\'s green lungs. This park contains several sports infrastructures which makes it an important point of reference for the city\'s athletes.<1/><1/>View all the Casavo listings for houses for sale in Vanchiglia, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/aurora-barriera-di-milano-rebaudengo":"The Aurora area in Turin is known for being characteristic, picturesque and very lively all at the same time. It is one of the historic areas of the city and has been very popular since the second half of the twentieth century. The trendy antiques market known as \\"Balon\\" attracts art enthusiasts from all over the country, as do the art galleries that are located in the former industrial area. An eclectic and constantly evolving neighborhood, it is one of the hippest in the city.<1/><1/>The Barriera di Torino district, known to most as the “Barriera di Milano”, is one of the most ancient areas of the city and is full of history. It is located just a short distance from the city center. Today it manages to embody the artistic and pragmatic soul of the city thanks to art galleries and craft workshops. The murals that liven up the streets make it feel like an open-air museum. Thanks to its many attractions and vibrancy it is also a very popular neighborhood with students.<1/><1/>View all the Casavo listings for houses for sale in Aurora and Barriera, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/barriera-di-lanzo-falchera-barca-bertolla":"The Barriera di Torino district, known to most as the “Barriera di Milano”, is one of the most ancient areas of the city and is full of history. It is located just a short distance from the city center. Today it manages to embody the artistic and pragmatic soul of the city thanks to art galleries and craft workshops. The murals that liven up the streets make it feel like an open-air museum. Thanks to its many attractions and vibrancy it is also a very popular neighborhood with students.<1/><1/>View all the Casavo listings for houses for sale in Barriera di Torino <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/borgo-vittoria-parco-dora":"The Borgo Vittoria area of Turin, also known by the name \\"Borgata Vittoria\\", is located north of the city. To be exact, it sits between the historic city center and the Basse di Stura river area. The oldest villas and the buildings from the twentieth century are blended in with the most modern and avant-garde buildings, creating a dynamic and varied ambiance. It is one of the most historic and also constantly evolving areas of the city.<1/><1/>View all the Casavo listings for houses for sale in Borgo Vittoria, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/le-vallette-lucento-madonna-di-campagna":"The Madonna di Campagna district is located in the northwestern part of Turin and is an area that is seeing constant growth. It is a well-known destination to experience the cultural life of the city, as it is home to several music festivals. Madonna di Campagna boasts a long and fascinating history and has  some of the oldest buildings which alternate with modern ones which defines its unique style and attests to the fact that its constantly evolving. It is connected to the rest of the city thanks to two stops on the subway metro line which brings residents directly to the city center.<1/><1/>View all the Casavo listings for houses for sale in Madonna di Campagna, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/pozzo-strada-parella":"The Parella area is located just a short distance from Turin but has a much more sober style than that of a big city. The whole area is very quiet and surrounded by greenery with a few historical sites. It is famous above all for the paper mill, an important paper production center. It is one of the most suggestive areas of Turin and is much loved by those looking for a place full of peace that is also close to the historic downtown. Parella, in fact, is well connected to the rest of the city thanks to public transport, especially the historic tram line 13.<1/><1/>View all the Casavo listings for houses for sale in Porta Genova, Ticinese, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/madonna-del-pilone-sassi":"Madonna del Pilone is a district in the northeast of Turin. It owes its name to the church of the same name in the area, which is also one of its best-known historic buildings. The entire neighborhood offers its residents an often overlooked side of the history of Turin, which can be admired in its most characteristic buildings. Emilio Salgari, the beloved writer of adventure novels, also lived in this neighborhood. It is connected to the rest of the city by several bus lines and two subway metro stops and is a quiet and peaceful neighborhood.<1/><1/>View all the Casavo listings for houses for sale in Madonna del Pilone, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/centro":"The center of Turin is an excellent representation of the elegance and style of this city. The charming streets wind between historic palaces and buildings of national importance such as the Palazzo Madama and the Egyptian Museum. The refined beauty of the historic city center of Turin joins together with a younger and more modern side, giving life to a district full of different facets. It constitutes an important hub for the entire city.<1/><1/>View all the Casavo listings for houses for sale in the center of <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/crocetta-san-secondo":"The Crocetta district is located south of the historic city center of Turin and is one of the most elegant in the whole city. In addition to its refined style and its noble palaces there is also a youthful and modern pace of life thanks to the presence of the Polytechnic University of Turin. It is a very popular area, especially among the students who attend the university. The area has become a focal point for the intellectual life in the city because of the university and the many events hosted in the art galleries located here.<1/><1/>View all the Casavo listings for houses for sale in Crocetta, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/cavoretto-gran-madre":"Of all the districts of Turin, Cavoretto is perhaps one of the most intriguing. Its strategic position means that it is just a short distance from the historic city center as well as the unspoiled nature of Piedmont. The Europa Park is perhaps one of its most beautiful areas and offers a unique view of the city itself. It perfectly represents the most historic part of Turin, where you can experience an almost magical atmosphere. The entire hill region seems far removed from the fast pace of the city, even though it is actually very close.<1/><1/>View all the Casavo listings for houses for sale in Cavoretto, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/colle-della-maddalena-superga":"The Colle della Maddalena area is located in the southeastern part of Turin and is a particularly quiet and peaceful area of the city. Despite the short distance from the center, it feels like a small world of its own. In fact, it is an area surrounded by greenery, full of nature and wide tree-lined streets, where older villas alternate with more modern buildings. Thanks to its proximity to the Parco Della Maddalena Pian Delle Lot, the area also offers this very important and popular green space to enjoy.<1/><1/>View all the Casavo listings for houses for sale in Colle della Maddalena, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/borgo-san-paolo-cenisia":"The Cenisia area in Turin is a hub for students, thanks especially to to the presence of the city\'s Polytechnic University. This is where the historic Cit Turin area is located as well. Due to the presence of the Intesa San Paolo skyscraper, which is the third tallest building in the city and was designed by Renzo Piano, this is also an important district from an architectural point of view . It is a neighborhood that best expresses the distinctly Turin spirit of blending the past and the future together.<1/><1/>View all the Casavo listings for houses for sale in Cenisia, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/lingotto-nizza-millefonti":"The Lingotto district is located in the southernmost part of Turin and is famous above all because the former FIAT factory is located here. It was once the business center of the city but today it has been completely transformed into a conference center with an adjoining art gallery. It has therefore become one of the most active cultural hubs in Turin and influences the entire area surrounding it. The Lingotto district is well connected to the rest of the city thanks to the historic tram line 4 and several bus lines. The public transportation available here allows residents to quickly reach the center, while experiencing the tranquility of a constantly evolving environment.<1/><1/>View all the Casavo listings for houses for sale in Lingotto, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/san-salvario":"The historic San Salvario district is located in the southeast area of Turin and is famous throughout the city for its unique characteristics. It is the perfect starting point to discover some of the most important historical buildings of the city such as the famous Valentino Park. Within the park is the Valentino Castle which is a designated UNESCO World Heritage Site. However, the district is not only important for its historical importance but also for its strategic position close to the Porta Nuova train station, making it one of the most important points for anyone traveling to the city.<1/><1/>View all the Casavo listings for houses for sale in San Salvario, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/santa-rita-mirafiori-nord":"Mirafiori Nord is a district located in the southwestern area of Turin and is one of the most important historical suburbs of the city. In addition to its villas and ancient buildings, in this district there is also the Ice Stadium which was originally built for the Winter Olympics that was hosted here. Thanks to the presence of this stadium, the Mirafiori district has quickly become an important reference point for the city\'s athletes. It is connected to the center by several bus lines and a subway metro stop.<1/><1/>View all the Casavo listings for houses for sale in Mirafiori Nord, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/campidoglio-san-donato-cit-turin":"The San Donato district is one of the oldest in all of Turin and has been inhabited since the Middle Ages. It evolved along with the times and today it is the perfect example of an avant-garde neighborhood with a strong historical background. This area is especially well known by architecture scholars because of the presence of several buildings in pristine Art Nouveau style. San Donato features some historic buildings but is also home to several cultural festivals. It is one of the most important historical districts on the outskirts of Turin.<1/><1/>View all the Casavo listings for houses for sale in San Donato, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/torino/mirafiori-sud":"The Mirafiori Sud district is located in the southwestern area of the city of Turin. It is famous for being home to one of Italy\'s largest Fiat factories and for a long time it was also one of the most populous neighborhoods in the city. Today it is a neighborhood that is full of history, ancient monuments, modern buildings and vast green spaces. The last also thanks to the presence of various sports facilities which make it an important reference point for the city\'s athletes. This neighborhood full of surprises maintains a delicate balance between the past and the future and has retained its own unique identity despite being just a short distance from the historic center.<1/><1/>View all the Casavo listings for houses for sale in Mirafiori Sud, <0>Turin</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/verona/pindemonte-valdonega":"The Valdonega district in Verona is one of the most fascinating historical districts in the city. It is separated from Verona\'s historic downtown only by the flowing waters of the Adige river, which partially runs along its border, and it is very close to the most important sights of the city. Valdonega is an area that is also known for its historic sites including the Valdonega Roman Villa, which is one of the most visited destinations in the whole city. Its green areas are large and well cared for and the area is connected to the rest of the city by several bus lines. Its strategic position makes it an important crossroads for the entire city.<1/><1/>View all the Casavo listings for houses for sale in Valdonega, <0>Verona</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/verona/borgo-nuovo-navigatori-ponte-crencano":"The Ponte Crencano area in Verona is one of the oldest in the whole city, even if it experienced the first signs of expansion only in more modern times. It possesses ancient and elegant buildings that alternate with more modern buildings and its proximity to the historic city center makes it the perfect peaceful place to live while remaining within walking distance of the most famous historic areas of Verona. The presence of several green spaces has added to its reputation as a quiet and peaceful neighborhood. It is well connected to the rest of the city thanks to several bus lines.<1/><1/>View all the Casavo listings for houses for sale in Ponte Crencano, <0>Verona</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/verona/quinzano-parona":"The area called Quinzano is located not far from Verona near the small and picturesque hamlet of Avesa. It is perched on the hills of the city, and is known for being a very green and lively neighborhood. The Parona district, on the other hand, is located at the entrance to the Valpolicella area overlooking the Adige River. This area is rich in history and traditions, historic buildings and elegant houses, where residents can enjoy a quiet environment close to the city.<1/><1/>View all the Casavo listings for houses for sale in Quinzano, <0>Verona</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/verona/poiano-quinto-montorio":"The small villages of Poiano, Quinto and Montorio are located north of the city of Verona, in a particularly charming position thanks to the numerous natural sights and green spaces. They are located a short distance from Verona, and can be easily reached in a few minutes by car or by using the bus lines that connect them to the center. The wide tree-lined streets and beautiful old buildings are just some of the features that make this area very elegant.<1/><1/>View all the Casavo listings for houses for sale in Poiano, Quinto and Montorio, <0>Verona</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/verona/avesa-torricelle":"The Avesa district is located north of Verona and despite the fact that it is indeed part of the city it still retains the picturesque charm of a small village. The Lori River originates here, a small river where locals used to wash their clothes and that is well-known in the area. This is a romantic area full of panoramic views, surrounded by greenery yet only a few minutes away from downtown Verona.<1/><1/>View all the Casavo listings for houses for sale in Avesa, <0>Verona</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/verona/chievo-bassone":"The Chievo district is located west of Verona just a short distance from the center and from the banks of the Adige. It is known for being the home of the soccer team of the same name, around which many of the neighborhood\'s cultural and entertainment activities revolve. This district has the feel of a small town, despite being close to the center of Verona. Because of this unique atmosphere it is very popular with commuters who prefer a quiet area.<1/><1/>View all the Casavo listings for houses for sale in Chievo, <0>Verona</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/verona/via-mantovana-dossobuono-sacra-famiglia-castel-d-azzano":"The village of Dossobuono is located in the southwestern area of the city of Verona, although it is part of the nearby municipality of Villafranca. It is one of the most interesting historical destinations around the city thanks to its historical sights. The nearby village of Castel d\'Azzano is also an interesting spot. These two villages on the grand Via Mantovana, are in a peaceful and constantly evolving area, not far from the historic city center.<1/><1/>View all the Casavo listings for houses for sale in Dossobuono, <0>Verona</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/verona/borgo-roma-ca-di-david":"The Borgo Roma district in Verona is located south of the city. It is a lively and very welcoming area. Here there are several hospitals in addition to the Medicine and Natural Sciences university departments. Because of this, the district represents an important focal point for doctors, students and researchers. It is very well connected to the rest of the city thanks to several bus lines. The presence of a new park, built in recent years, has given further life to an already very lively and exciting area.<1/><1/>View all the Casavo listings for houses for sale in Borgo Roma, <0>Verona</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/verona/san-michele-extra-castiglione":"The San Michele Extra district is located in the southeastern part of the city of Verona. It is a clean and well-kept area, characterized by modern buildings and a youthful atmosphere. It is in a strategic position very close to the city center but still maintains its quiet and less \\"city\\" ambiance. However, it is well connected to the center thanks to several bus lines and wide roads. It is an area of the city that is quickly evolving and is full of potential with plenty of green space to enjoy.<1/><1/>View all the Casavo listings for houses for sale in San Michele Extra, <0>Verona</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/verona/borgo-venezia-santa-croce-porto-san-pancrazio":"The San Pancrazio district in Verona is perhaps one of the quietest in the city. It is separated from the oldest part of the city by the flowing Adige River. It is a very strategic area thanks to its proximity to the historic city center, as well as to the university complex. The influx of many young people and students has made it a modern and lively neighborhood that is in step with the times, while still maintaining its more traditional character. The green area of  Adige Park completes the picture of a perfect neighborhood, a wonderful expression of the best that Verona has to offer.<1/><1/>View all the Casavo listings for houses for sale in San Pancrazio, <0>Verona</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/verona/santa-lucia-golosine-zona-fiera":"The Golosine district is located south of the historic city center of Verona. Despite having a very ancient history, its expansion began much more recently. Today, this young and modern district is in continuous expansion and is linked to the rest of the city with several bus lines. The cultural events held here ensure it is a very active area in constant motion that attracts mainly young people and students. The neighborhood is very close to Quadrante Europa Park, the largest park in the city.<1/><1/>View all the Casavo listings for houses for sale in Golosine, <0>Verona</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/verona/borgo-milano-stadio-san-massimo-croce-bianca":"The Borgo Milano area in Verona is located in the southwestern area of the city. It is a very quiet area that is close to the historic city center and well connected to the rest of the city thanks to several bus lines. Its strategic position means that it is close to some of the main downtown sights yet maintains the silence and peace of a less touristy area. The wide tree-lined streets and the bike path come together to create one of the greenest settings in the city.<1/><1/>View all the Casavo listings for houses for sale in Borgo Milano, <0>Verona</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance.","it/verona/centro":"The center of Verona is perhaps one of the most beloved places in all of Italy. A picturesque and scenic neighborhood that is rich in ancient monuments and incredible history. Verona is considered by most to be the \\"most romantic city in the world\\" thanks to the presence of Romeo and Juliet\'s house, which is located directly in the historic city center. Each stone alley, house and view seem to tell a story, while the Adige riverfront offers some of the most characteristic views. The historic center of Verona is a real crossroads of different cultures and travelers and represents one of the most iconic neighborhoods in the whole city.<1/><1/>View all the Casavo listings for houses for sale in the center of <0>Verona</0>. We only work with select agencies that are competent and have an excellent knowledge of the market. You can buy your dream house at a guaranteed price. And if you choose a Casavo Property, you will have access to special services such as our mortgage service and turnkey option, home insurance and after-sale assistance."}');

/***/ }),

/***/ 97639:
/***/ (function(module) {

"use strict";
module.exports = {};

/***/ }),

/***/ 55120:
/***/ (function(module) {

"use strict";
module.exports = {};

/***/ }),

/***/ 17523:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"it/bologna/centro":"Il centro di Bologna è uno dei luoghi più importanti per la gioventù italiana: una zona viva e frizzante dove abitano artisti, studenti e professionisti di ogni tipo. Un vero e proprio melting pop di città, culture e tradizioni diverse che nella storia e nei monumenti di Bologna trovano il loro spazio per esprimersi al meglio. Un luogo ricco di vita e palazzi storici, portici e scorci unici da ammirare. La sua posizione strategica la rende perfetta per raggiungere facilmente qualsiasi punto della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona centro a <0>Bologna</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/bologna/san-donato-pilastro":"La zona di San Donato e Pilastro si trova nella parte nordorientale della città. Rappresenta un quartiere tranquillo e ricco di attività culturali, ampi viali alberati e palazzi storici. Qui si trova anche una sede dell’Università di Bologna, quindi è un quartiere molto frequentato anche dagli studenti. È stato un importante punto commerciale grazie alla presenza dell’imponente stazione ferroviaria, che un tempo veniva utilizzata come scalo merci. Oggi, la stessa stazione collega San Donato al resto della città. Si trova a poca distanza dal centro, a cui è ben collegata con i treni.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona San Donato e Pilastro a <0>Bologna</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/bologna/san-vitale-mazzini":"La zona di San Vitale e Mazzini a Bologna è spesso identificata con la vicina San Donato, pur mantenendo due identità differenti. È una zona ben servita dai mezzi pubblici, specialmente da una fitta rete ferroviaria che la collega al resto della città. Qui si trova anche l’Ospedale S. Orsola, spesso meta di studenti e ricercatori. Il quartiere di San Vitale è più vicino al centro storico della città e, oltre a una zona residenziale ricca di storia, ospita anche dei palazzi più moderni. Il suo panorama urbano è in continua evoluzione. Le varie attività ed eventi di stampo artistico ne fanno un quartiere molto vivo anche dal punto di vista culturale.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona San Vitale e Mazzini a <0>Bologna</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/bologna/murri-massarenti":"Il quartiere Santo Stefano, Murri e Massarenti di Bologna è uno dei più esclusivi di tutta la città. È una zona molto elegante e ricco di monumenti antichi. Rappresenta uno dei luoghi più famosi della città, e uno dei più amati. Per la maggior parte del Novecento, il quartiere è stato popolato dalle famiglie dell’alta borghesia italiana. Oggi presenta un quadro molto variegato e in costante trasformazione, pur mantenendo la sua impronta più tradizionale. È collegata al resto della città grazie a diverse linee ferroviarie. La presenza dell’Autostazione di Bologna ne fa un punto di snodo indispensabile per i viaggiatori. In zona si trovano anche i Giardini Margherita, uno dei parchi più importanti di tutta la città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Santo Stefano, Murri e Massarenti a <0>Bologna</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/bologna/toscana-savena":"La zona Toscana e Savena di Bologna si trova nella parte sudorientale della città. Rappresenta una commistione unica di storia, natura e architettura contemporanea: tutti questi elementi, infatti, si fondono insieme a creare la sua identità unica. La zona a sud ovest della città corrisponde a quella collinare, che regala un punto di vista particolare sul resto della città. La presenza dei vari parchi e torrenti, fra cui il suggestivo Parco dei Cedri e il Palco del Paleotto, ne fanno un quartiere ideale per gli amanti della natura pur trovandosi a poca distanza dai servizi del centro storico. È ben collegato al resto della città grazie alla rete ferroviaria.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Toscana e Savena a <0>Bologna</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/bologna/colli":"La zona dei Colli di Bologna è una delle più ambite e desiderate di tutta la città, soprattutto grazie all’ambiente che la circonda. È caratterizzata dalla presenza di una natura incontaminata e panorami straordinari, oltre a bei palazzi moderni che si alternano a edifici storici immersi nel verde. La zona è ben collegata al resto della città grazie a una fitta rete di autobus, e le ampie strade rappresentano anche un ottimo modo per spostarsi in autonomia.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona colli a <0>Bologna</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/bologna/bolognina-corticella-pescarola":"Il quartiere Bolognina è situato alle spalle della stazione centrale di Bologna, in un’area strategica a nord della città. Eclettica e vibrante, la zona della Bolognina è stata soggetta a varie opere di riqualificazione che non hanno tuttavia intaccato la sua incredibile storia ed identità culturale. Ricca di attività e negozi, il quartiere non smette mai di annoiare.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Bolognina, Corticella e Pescarola a <0>Bologna</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/bologna/costa-saragozza-saffi":"Il quartiere Costa, Saragozza e Saffi di Bologna è forse uno dei più eleganti di tutta la città. Si trova a poca distanza dal centro, ed è ben collegata agli altri quartieri grazie alla linea ferroviaria. Alcuni dei palazzi storici rappresentano uno dei tesori architettonici di Bologna, e la vicinanza con i colli bolognesi ne fanno la meta perfetta per gli amanti della natura. Fra parchi e storia, la zona di Costa, Saragozza e Saffi vanta anche una grande attività culturale, e i diversi eventi che si svolgono in zona ne fanno un punto di riferimento per gli artisti della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Costa, Saragozza e Saffi a <0>Bologna</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/bologna/barca-santa-viola":"La zona di Reno, Barca e Santa Viola a Bologna è una delle più giovani e popolari, in continua evoluzione e ricca di attività culturali. La sua posizione strategica la rende molto vicina alla zona storica del Pratello, alla Cineteca e al Museo di Arte Moderna. Proprio per questo, e anche per il suo essere ben collegata al resto della città, è una delle zone più amate dagli studenti. Il parco del Cavaticcio, il giardino del Museo d’Arte Moderna, è uno dei punti di riferimento culturali più importanti della città grazie anche agli eventi che vi si svolgono ogni anno.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Reno, Barca e Santa Viola a <0>Bologna</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/bologna/aeroporto-borgo-panigale":"Il quartiere di Aeroporto e Borgo Panigale a Bologna si trova nella zona nordoccidentale della città, fra il fiume Lavino e il fiume Reno. Nato in tempi più antichi come borgo indipendente, poi assimilato dal resto della città, Borgo Panigale mantiene un’identità personale molto forte, pur facendo ormai parte del tessuto urbanistico di Bologna. Rappresenta una delle aree più verdi della città grazie alla grande presenza di parchi e giardini, ed è ben collegata al resto della città grazie alla rete ferroviaria. Borgo Panigale è anche ricca di centri sportivi, costituendo così un punto di riferimento per gli atleti della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Aeroporto e Borgo Panigale a <0>Bologna</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/firenze/centro":"Il centro di Firenze è universalmente riconosciuto come uno dei più belli di tutto il mondo. L’arte che si può apprezzare nei suoi musei e il fascino pittoresco delle sue strade si fondono con la sua storia più antica, che si può respirare in ogni angolo. Una zona meravigliosa ed eclettica, fortemente attaccata alle proprie radici ma, al tempo stesso, giovanile e piena di vita. Rappresenta uno dei luoghi più belli e visitati di tutta Italia, e incanta chiunque lo visiti.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Centro a <0>Firenze</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/firenze/oltrarno":"La zona di Oltrarno a Firenze si trova sulla sponda sinistra del fiume Arno. In lingua fiorentina è nota anche come Diladdarno, ed è una delle zone più caratteristiche del centro storico di Firenze. Iconica e pittoresca, rappresenta una meta storica di grande rilevanza per tutta la città. Si possono trovare ancora antiche botteghe di artigiani di ogni tipo e monumenti come Palazzo Pitti o il Giardino Bardini. Al suo interno si trovano anche rioni storici come quello di Santo Frediano. Vivere a Oltrarno è vivere nel cuore stesso di Firenze.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Oltrarno a <0>Firenze</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/firenze/leopoldo-porta-al-prato":"La zona di Piazza Leopoldo e Porta al Prato a Firenze è caratteristica e ricca di storia, dove i palazzi nobiliari contribuiscono a creare un ambiente pittoresco. É ben collegata agli altri quartieri grazie alla sua posizione strategica e alle linee ferroviarie. Questa piazza si trova nel cuore di Firenze, e l’intera zona è molto elegante. Le alte case e i palazzi nobiliari si affacciano su monumenti storici come quello di Porta al Prato, che rappresenta uno dei simboli della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Leopoldo e Porta al Prato a <0>Firenze</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/firenze/campo-di-marte-liberta":"Il quartiere di Campo di Marte e Libertà si trova a poca distanza dal centro storico di Firenze. Rappresenta una delle alternative più valide alla vita frenetica del centro. È una zona molto amata dagli studenti universitari perché è tranquilla e ben collegata al resto della città. Anche per questo, il quartiere di Campo di Marte e Libertà è ricco di attrattive, molto giovane e in continua espansione. Fra le maggiori attrazioni c’è anche lo stadio Artemio Franchi, sede principale della Fiorentina.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Campo di Marte e Libertà a <0>Firenze</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/firenze/firenze-nord":"La zona di Firenze Nord racchiude in sé alcuni dei più bei quartieri e rioni della città. Particolarmente amata sia dai viaggiatori che dai locali, è una delle zone più visitate della Toscana. È delimitata dall’Arno da un lato, e dall’altro è poco distante dalle località di Prato e Fiesole. Una posizione strategica ideale per trovarsi a pochi passi dal centro, ma anche da alcune delle più belle zone nei dintorni. Firenze Nord è ricca di luoghi artistici e quartieri particolari, rioni storici e palazzi nobiliari pittoreschi.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona <0>Firenze</0> Nord. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/firenze/ugnano-mantignano":"Le zone di Ugnano e Mantignano si trovano a poca distanza dall’Arno, e rappresentano uno dei punti più popolari e caratteristici della parte meridionale di Firenze. Popolata in larga parte da studenti e famiglie, è il luogo ideale per vivere a poca distanza dal centro di Firenze pur mantenendosi in una zona tranquilla e ben tenuta. È collegata al resto della città tramite autobus, e la sua vicinanza a una fermata ferroviaria la avvicina anche ai punti più lontani della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Ugnano e Mantignano a <0>Firenze</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/firenze/l-isolotto":"La zona L’isolotto di Firenze si trova nel lato sud-occidentale della città. Delimitata in parte dal fiume Arno, racchiude in sé alcuni rioni storici come quello delle Torri e dell’Arginrosso, che dà anche il nome all’omonimo parco. Insieme alla zona di Legnaia, costituiscono quello che viene definito il “Quartiere 4” di Firenze. È collegato al centro storico grazie alla linea ferroviaria e diverse linee di autobus.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona L’isolotto a <0>Firenze</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/firenze/legnaia-soffiano":"La zona di Legnaia e Soffiano a Firenze costituisce una delle parti più frequentate della città al di fuori del centro storico, grazie anche alle sue mete storiche. Oltre a zone residenziali e ricche di verde, come ad esempio Soffiano, Legnaia offre anche una parte più moderna e degli scorci sulla natura circostante. Rappresenta una zona molto tranquilla, ma comunque vicina al centro di Firenze e ben collegata grazie al treno e le varie linee di autobus presenti sul territorio.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Legnaia e Soffiano a <0>Firenze</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/firenze/bellosguardo-galluzzo":"Le zone di Galluzzo e Bellosguardo sorgno sulla sponda sinistra dell’Arno e rappresentano i sobborghi più antichi e illustri di tutta la città di Firenze. Bellosguardo è nota in quanto Vi sorgono molte ville che hanno ospitato, nel corso dei secoli, svariati personaggi illustri. Galluzzo è famoso soprattutto per la presenza della Certosa di Acciaiuoli e il suggestivo Palazzo del Podestà. Entrambe le zone sono collegate con diverse linee di autobus non solo alla città di Firenze, ma anche al piccolo borghi del Chianti.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Bellosguardo e Galluzzo a <0>Firenze</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/firenze/firenze-sud":"Nella zona di Firenze Sud si possono trovare alcuni dei simboli storici più belli di tutta la città, e alcuni dei suoi palazzi più amati. Una zona ricca di tradizione e modernità al tempo stesso, delimitata dalle sponde dell’Arno. Al suo interno si trovano zone uniche come quella di Scandicci o l’antica Porta Romana. La fitta rete ferroviaria collega ogni quartiere e rione con il resto della città, ed è una zona molto amata anche dagli studenti. Giovane e ricca di vita, quella di Firenze Sud è una parte della città tutta da scoprire.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona <0>Firenze</0> Sud. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/firenze/coverciano-bellariva":"Le zone di Coverciano e Bellariva si trovano a poca distanza dalle rive dell’Arno, e rappresentano uno dei punti più popolari di tutta la città, specialmente fra studenti e famiglie. Grazie alla presenza della rete ferroviaria, entrambe le zone sono ben collegate al resto della città. Qui si trovano palazzi nobiliari molto antichi e una parte molto importante della storia di Firenze, ma anche edifici più moderni che rappresentano la sua continua evoluzione culturale.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Coverciano e Bellariva a <0>Firenze</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/firenze/bolognese-le-cure":"La zona di Bolognese - Le Cure di Firenze si trova poco distante dal centro storico, e costeggia la bellissima Fiesole. Qui si trovano molte ville antiche e palazzi più moderni, che contribuiscono a creare un panorama unico. La sua vicinanza alla città la rende molto popolare, specialmente per chi vuole vivere in un ambiente tranquillo a poca distanza dal centro. È una zona vicina alla natura, e la sua strada principale rappresenta uno snodo importante per il traffico della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Bolognese – Le Cure a <0>Firenze</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/firenze/serpiolle-careggi":"La zona di Careggi si trova nella piccola frazione di Serpiolle, a Firenze. È una zona molto frequentata da studenti e lavoratori grazie alla presenza del Complesso Ospedaliero di Careggi, uno dei più importanti di tutta la città. La frazione di Serpiolle presenta un terreno collinare circondato dal verde, ed è ben collegata al resto della città di Firenze grazie alla presenza della linea ferroviaria. È una zona tranquilla e ben tenuta, lontana dal ritmo frenetico del centro storico ma abbastanza vicina per raggiungerlo in men che non si dica!<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Serpiolle e Careggi a <0>Firenze</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/firenze/michelangelo-porta-romana":"L’affascinante zona di Michelangelo e Porta Romana è una delle più vivaci e in continua evoluzione di tutta Firenze. Presenta case e appartamenti moderni e all’avanguardia, in una zona dove palazzi di nuova costruzione si alternano a meravigliose costruzioni antiche e palazzi nobiliari. La sua vicinanza al meraviglioso Giardino di Boboli vi permetterà di vivere a un passo da tutte le bellezze del centro storico senza rinunciare al verde.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Michelangelo e Porta Romana a <0>Firenze</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/firenze/settignano-rovezzano":"Il rione di Rovezzano fa parte del comune di Firenze, e si trova nella zona a est della città. Insieme alla zona di Settignano, si trova poco distante dalla bella zona di Campo di Marte. Entrambe condividono con quest’ultima l’atmosfera giovane e la popolarità fra gli studenti e le famiglie più giovani. È anche ricca di natura e splendidi elementi naturali. L’antico mulino di Rovezzano rappresenta un elemento storico assolutamente unico nel suo genere. È collegata al resto della città con la linea ferroviaria, mentre i suoi elementi naturali e paesaggistici ne fanno un luogo tranquillo e ben tenuto.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Settignano e Rovezzano a <0>Firenze</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/milano/san-siro-trenno":"Il quartiere di San Siro e Trenno si trova nella zona occidentale della città. È una delle zone più famose al mondo grazie alla presenza dell\'imponente e omonimo stadio. Intorno allo stadio c\'è un\'area verde molto ampia, e il quartiere è ben collegato al resto della città grazie alla presenza delle stazioni della linea rossa e della linea lilla della metropolitana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona San Siro e Trenno a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/bisceglie-baggio-olmi":"Il quartiere di Bisceglie, Baggio e Olmi offre un\'anima antica e moderna al tempo stesso. I primi insediamenti umani risalgono all\'epoca dei celti, e questo lato storico convive con la presenza di palazzi moderni e dai colori pastello. Una zona poliedrica e ricca di stimoli, poco distante dal centro e perfetta per chi vuole vivere la calma e il verde di Milano a pochi passi dagli altri quartieri.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Bisceglie, Baggio e Olmi a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/genova-ticinese":"Quella del Ticinese è una delle zone storiche di Milano. Corso Genova è una delle strade più popolari di questa zona, ed è a un passo dalle meraviglie del centro storico pur mantenendo una propria identità e un carattere distintivo. Fra i palazzi contemporanei e gli edifici storici si possono trovare delle bellezze architettoniche che contraddistinguono tutta la zona. La zona è ben servita dai mezzi pubblici, e Corso Genova è attraversato dai binari del tram.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Genova Ticinese a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall\'acquisto.","it/milano/navigli":"I Navigli rappresentano uno dei punti storici più importanti di Milano. L\'intera zona è stata – ed è ancora – un vero e proprio polo culturale della città grazie alle sue antichissime librerie e alle tante iniziative letterarie. Negli ultimi anni è diventata anche una zona molto amata da chi è alla ricerca di locali esclusivi e all\'ultima moda. I Navigli sono in grado di fondere insieme storia e futuro, moda e arte, per vivere la Milano più amata in ogni suo aspetto.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Navigli a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/porta-romana-cadore-montenero":"Il quartiere di Porta Romana, Cadore e Montenero sta diventando in breve tempo uno dei più in di tutta Milano grazie anche, e soprattutto, all\'innovativo palazzo della Fondazione Prada e alla sua mostra permanente. All\'interno della fondazione si trova anche l\'esclusivo Bar Luce, disegnato dal regista americano Wes Anderson. La rotonda della Besana e il Parco Ravizza esprimono al meglio l\'architettura antica e la natura della zona. È collegato al resto della città grazie alla linea lilla della metropolitana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Porta Romana Cadore e Montenero a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/bande-nere-inganni":"La zona Bande Nere e Inganni di Milano è giovane, multiculturale e molto moderna. Ci sono anche delle bellezze storiche, come la chiesa neogotica di San Francesco, o naturali: qui, infatti, si trova il Parco delle Cave, noto per essere il terzo parco più grande di tutta la città. È una zona molto amata dagli studenti, ed è collegata al resto della città grazie alla presenza dell\'omonima stazione della linea rossa della metropolitana (M1).<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Bande Nere e Inganni a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/famagosta-barona":"La zona residenziale di Famagosta e Barona si trova a sud della città. Presenta molte aree verdi, ma non solo: qui si trova anche l\'Ospedale San Paolo, una delle strutture ospedaliere più popolari di tutta la città. Qui si trovano anche la IULM (Università di Lingue e Comunicazione), la NABA (Nuova Accademia di Belle Arti) e il Collegio di Milano. Questo, e la presenza di una fermata della linea 2 della metropolitana, la rende una meta molto frequentata dagli studenti.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Famagosta e Barona a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/abbiategrasso-chiesa-rossa":"La zona di Abbiategrasso a Milano è ricca di storia e palazzi storici fra i più antichi di tutta la città. Si distingue dagli altri quartieri grazie alla presenza della suggestiva Chiesa Rossa, detta così per la sua particolare facciata di mattoni scarlatti. La zona è molto tranquilla e ben collegata al resto della città grazie e soprattutto alla frequente linea della linea M2 della metropolitana (linea verde). Gli alti palazzi moderni e i monumenti storici si alternano creando un panorama distintivo, ed è una delle zone più amate dalle giovani famiglie.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Abbiategrasso a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall\'acquisto.","it/milano/porta-vittoria-lodi":"La zona di Porta Vittoria e Lodi è molto popolare e giovanile, ricca di cultura e in fervente attività. Unisce più zone della città, fra cui quella di Porta Romana e quella di Corvetto. Proprio per questo, è molto vicina a posti esclusivi di Milano come la Fondazione Prada. È attraversata da diverse linee di autobus e tram, e presenta anche una fermata della linea gialla della metropolitana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Porta Vittoria e Lodi a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/solari-washington":"Quella di Solari Washington è una zona antica e moderna insieme, dove molti dei bei palazzi storici sono stati ristrutturati per creare un panorama unico nel suo genere: tradizione e innovazione si uniscono in un modo unico, proprio dello spirito più autentico di Milano. Una zona vivace e ben tenuta, ricca di palazzi storici e viali alberati. È ben collegata al centro storico grazie alle linee del tram, ed è molto vicina alla linea 2 della metropolitana (linea verde).<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Solari Washington a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall\'acquisto.","it/milano/ripamonti-vigentino":"Il quartiere di Ripamonti e Vigentino è noto soprattutto per la presenza del Policlinico di Milano, considerato una delle maggiori strutture mediche di tutto il paese, e per la sua vicinanza alla suggestiva Fondazione Prada. La sua posizione strategica permette di raggiungere in breve tempo sia Porta Romana che Piazza del Duomo. Una zona tranquilla e ben collegata al resto della città grazie al transito di linee del tram come il 9 e il 24.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Ripamonti e Vigentino a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/ponte-lambro-santa-giulia":"Il quartiere residenziale di Santa Giulia si trova nella zona sudorientale della città di Milano. È una zona nuova e molto moderna, creata su progetto di un architetto internazionale, e i suoi palazzi alti e moderni conferiscono all\'intera zona una nota di carattere ed eleganza. Poco distante si trova la stazione di Milano Rogoredo, che collega l\'intero quartiere alla città grazie alla linea M3 della metropolitana (linea gialla). La stazione serve anche linee ad alta velocità, che collegano l\'intera zona anche al resto d\'Italia. Un quartiere all\'avanguardia e in continua evoluzione, ricco di stimoli.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Santa Giulia e Ponte Lambro a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall\'acquisto.","it/milano/corvetto-rogoredo":"La zona di Milano Corvetto e Rogoredo è giovane e intraprendente, in continua evoluzione e ben collegata al resto della città grazie alle linee di autobus e della linea gialla della metropolitana. L\'omonima stazione la rende un vero e proprio crocevia per studenti e lavoratori, collegandola al tempo stesso al centro e alle zone limitrofe. Ci sono anche delle piccole aree verdi e una biblioteca.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Corvetto e Rogoredo a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/napoli-soderini":"La zona di Soderini e Piazza Napoli a Milano è molto popolare fra studenti e lavoratori. Si trova molto vicino alle bellezze del centro storico, come ad esempio l\'affascinante Castello Sforzesco, ed è ben collegata al resto della città grazie a più linee del tram. La zona è servita anche dalla linea M2 della metropolitana (linea verde). Una parte di Milano attiva e vivace, in continua evoluzione, giovane e alla moda, frequentata da studenti di ogni tipo e ricca di divertimenti.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Napoli - Soderini a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall\'acquisto.","it/milano/cimiano-crescenzago-adriano":"Cimiano, Crescenzago e Adriano è un quartiere di Milano ricco di natura. È attraversato dal Naviglio della Martesana e delimitato dal fiume Lambro, che dà il nome anche all\'omonimo parco. Il bosco di Crescenzago permette di avere a disposizione un polmone verde nel cuore della città. L\'intera zona è collegata al resto di Milano grazie a due fermate della linea verde della metropolitana (M2) e alla linea della metropolitana leggera (MeLA).<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Cimiano, Crescenzago e Adriano a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/forlanini":"Il quartiere Forlanini fa parte del municipio 4 di Milano, nella zona est della città. Si trova fra l\'Aeroporto di Linate e il quartiere di Città Studi, quindi è molto vicino anche alle sedi universitarie e alle accademie della zona. Sarà presto inaugurata la linea blu della metropolitana (M4) che collegherà l\'intero quartiere al resto della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Forlanini a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/citta-studi-susa":"Lo stile della zona di Città Studi e Susa, a Milano, si può intuire anche solo dal nome. È la parte della città più frequentata dagli studenti, anche grazie all\'alta concentrazione di università e accademie. Qui si trovano il Politecnico di Milano e la Statale, oltre a cliniche e centri di ricerca per gli studenti delle facoltà scientifiche. Città Studi è collegata al resto della città con una fermata della linea verde della metropolitana (M2), la linea 5 del tram e diverse linee di autobus.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Città Studi e Susa a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/precotto-turro":"La zona di Precotto e Turro a Milano si trova fra i quartieri di Gorla e Bicocca, nella zona nord-est della città. Il quartiere è attraversato dal Naviglio della Martesana. Offre vaste aree verdi e una pista ciclabile molto utilizzata dai lavoratori in cerca di un mezzo ecologico per spostarsi. È uno dei quartieri di Milano abitati fin dai tempi antichi, e la sua storia si può ancora ritrovare in alcune delle sue chiese. È collegato al resto della città grazie a ben tre stazioni della linea rossa della metropolitana (M1), ed è famosa anche per la sua vicinanza a Viale Monza.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Precotto e Turro a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/udine-lambrate":"Lambrate è nata come zona industriale, e per molti anni è stata il fulcro della produttività di Milano. Negli ultimi anni si sta rinnovando in una meta pop ed è molto amata da giovani coppie e studenti. Quelle che un tempo erano fabbriche sono diventate gallerie d\'arte, e la presenza del parco Lambro la rende la zona di Udine e Lambrate ideale per chi è alla ricerca di tranquillità a pochi passi dal centro.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Udine e Lambrate a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/pasteur-rovereto":"La zona di Pasteur Rovereto a Milano è una delle più frequentate dagli studenti della città grazie ai suoi alti palazzi e le case moderne, ma anche per la sua posizione strategica. Questa zona, infatti, è molto vicina a quella di Città Studi, e permette a molti studenti di spostarsi senza problemi da una zona all\'altra. C\'è anche un bel parco cittadino, ed è servita dalla stazione di Rovereto della linea M1 (linea rossa) per collegarsi al resto della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Pasteur Rovereto a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall\'acquisto.","it/milano/centro":"Abitare nel centro di Milano significa abitare nel cuore stesso della città. Tra piazza Duomo, Parco Sempione e il Castello Sforzesco avrete a disposizione storia, arte e natura. Avrete a portata di mano negozi d\'alta moda, ristoranti e musei di ogni tipo. Il centro di Milano è un vero e proprio crocevia di culture, storia e modernità. È collegato al resto della città da due linee della metropolitana (linea rossa e linea gialla).<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Centro a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/arco-della-pace-arena-pagano":"La zona residenziale di Arco della Pace e Arena Pagano a Milano è ben frequentata e molto in vista per il suo stile singolare. Raffinata e signorile, questa zona vanta dei bei palazzi in stile liberty, antichi e ricchi di storia. Le strade si presentano in modo molto elegante e conferiscono a tutta l\'area un tratto unico e distintivo. È anche vicina a delle zone verdi, ed è ben collegata al resto della città grazie a più linee di tram e alla metropolitana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Arco della Pace e Arena Pagano a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall\'acquisto.","it/milano/quadronno-palestro-guastalla":"Quelle di Quadronno, Palestro e Guastalla rappresentano, nel loro insieme, una delle zone residenziali più eleganti e, al tempo stesso, più moderne di Milano. I bei palazzi alti, dal tratto moderno, si alternano a ville antiche e pittoresche. Una zona molto contemporanea, dove la tradizione e la modernità di Milano si mostrano al meglio. È anche ben collegata al resto della città grazie alla presenza di più linee del tram e, soprattutto, è molto vicina alla linea M3 della metropolitana (linea gialla).<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Quadronno, Palestro e Guastalla a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall\'acquisto.","it/milano/garibaldi-moscova-porta-nuova":"La zona di Garibaldi, Moscova e Porta Nuova a Milano è eclettica e ricca di vita, a pochi passi dalle attrazioni storiche della città ed è servita da mezzi pubblici di ogni tipo. Oltre alle stazioni di quattro linee diverse della metropolitana, infatti, la zona di Garibaldi, Moscova e Porta Nuova è attraversata anche da più linee di autobus e tram. È anche vicina a mete storiche come il suggestivo Castello Sforzesco.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Garibaldi, Moscova e Porta Nuova a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/porta-venezia-indipendenza":"La storia e il fascino di Porta Venezia e Indipendenza si può ritrovare nei suoi edifici in stile liberty e nei bei palazzi nobiliari, che conferiscono a tutta la zona un tocco di classe. Il giardino Indro Montanelli è perfetto per immergersi nel verde. La zona è anche ricca di edifici scientifici, come il Museo Civico di Storia Naturale e il Planetario. La presenza dell\'omonima fermata della linea rossa della metropolitana collega velocemente la zona al resto della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Porta Venezia e Indipendenza a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/centrale-repubblica":"Milano Centrale è la seconda stazione italiana per grandezza e traffico di passeggeri. Rappresenta uno spazio d\'eccellenza, dalle architetture maestose e imponenti, situata nel cuore della città. Non solo si configura come lo snodo principale per l\'Alta Velocità e i collegamenti con il resto d\'Europa, ma rappresenta anche un centro fondamentale per i servizi alla città e le vie dello shopping milanese.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Centrale e Repubblica a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/cenisio-sarpi-isola":"La zona Cenisio, Sarpi e Isola di Milano è una delle più fotografate e condivise in tutto il mondo grazie alla presenza dei tanti grattacieli, inclusi quelli del suggestivo Bosco Verticale. L\'immagine di questi alti palazzi ricoperti di piante è diventata una vera e propria icona dell\'anima eco-friendly e futurista di Milano. La zona è collegata al resto della città grazie alle stazioni della linea gialla e linea lilla della metropolitana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Cenisio, Sarpi e Isola a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/bicocca-niguarda":"La zona Bicocca e Niguarda di Milano è una delle più amate dagli studenti e i lavoratori grazie ai grandi spazi, ai collegamenti e ai tanti luoghi di cultura. È famosa per la presenza del Teatro degli Arcimboldi e, soprattutto, per la mostra permanente dell\'esclusivo Hangar Bicocca. È un polo universitario sempre attivo, e la presenza del Parco Nord è ideale anche per godersi un po\' di verde. Bicocca è una zona culturale molto viva, collegata al resto della città dalla linea lilla della metropolitana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Bicocca e Niguarda a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/maggiolina-istria":"Piazzale Istria e la zona residenziale della Maggiolina, afferenti alla zona di Zara, rappresentano uno dei punti nevralgici e più frequentati di Milano. Il piazzale è attraversato da Viale Testi, uno dei più importanti per gli spostamenti della zona. È poco distante anche da Turro e zona Ca\' Granda ed è ben collegata al resto della città grazie alla grande presenza di mezzi pubblici. Non solo è servita da una linea di autobus e tre linee del tram, ma anche dalla nuova linea M5 della metropolitana (linea lilla).<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Istria Maggiolina a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall\'acquisto.","it/milano/fiera-sempione-city-life-portello":"La zona Sempione, City Life e Portello di Milano è una delle più moderne di tutta la città. Si trova a poca distanza dal centro della città e da zone più storiche, come ad esempio quella di De Angeli. È collegata al resto della città grazie alla presenza di stazioni della linea rossa e linea lilla della metropolitana, oltre alla storica linea 1 del tram. Una zona moderna e all\'avanguardia, che sembra portare Milano nel futuro.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Sempione, City Life e Portello a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l\'opzione chiavi in mano, l\'assicurazione e l\'assistenza post vendita.","it/milano/viale-certosa-cascina-merlata":"Lo splendido Viale Certosa, nel quartiere di Cascina Merlata, è una delle zone più iconiche di Milano. Il quartiere presenta dei palazzi moderni e suggestivi, ma anche tanti monumenti e angoli storici che conferiscono a tutta la zona un aspetto molto elegante. Si trova a poca distanza dal centro storico e dal Castello Sforzesco. Grazie alla sua posizione strategica, è molto frequentata anche da giovani e studenti di ogni tipo. È ben collegata al resto della città grazie alle linee del tram e della metropolitana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Viale Certosa e Cascina Merlata a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall\'acquisto.","it/milano/affori-bovisa":"La zona di Affori e Bovisa a Milano si trova a poca distanza dalle bellezze del centro storico, e da Piazza Duomo. Le sue strade rappresentano uno dei punti di snodo più importanti della città, ed è una zona molto frequentata da studenti e lavoratori anche grazie alla sua posizione strategica. È, infatti, molto vicina ad alcuni dei punti nevralgici della città ed è servita da diverse linee di autobus e tram, ma soprattutto dalla linea M2 della metropolitana (linea gialla) che la collega al resto della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Affori e Bovisa a <0>Milano</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un\'ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall\'acquisto.","it/roma/centro-storico":"Il centro storico di Roma è uno dei più antichi e visitati d’Europa. È stato dichiarato Patrimonio dell’Umanità dall’UNESCO. Rappresenta non solo uno dei luoghi più antichi della città, ma anche uno dei più frequentati e in continua evoluzione. Il modo in cui i siti archeologici e i reperti romani si fondono con la storia del cinema moderno rappresentano il vero spirito di Roma, e costituiscono uno dei punti focali della sua vita quotidiana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Centro Storico a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/roma/prati-borgo-mazzini-delle-vittorie":"Le zone di Prati, Borgo, Mazzini e Delle Vittorie a Roma rappresentano un punto focale per la vita artistica e turistica della città. Grazie alla sua posizione strategica è possibile raggiungere in breve tempo sia il lungotevere che mete importanti come Città del Vaticano o Castel Sant’Angelo. L’intera area è ben collegata al resto della città grazie a una fitta rete di autobus e alla presenza della metropolitana, e i suoi palazzi antichi e nobiliari le conferiscono un’eleganza unica.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Prati, Borgo, Mazzini, Delle Vittorie a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/parioli-flaminio":"La zona dei Parioli e Flaminio è sicuramente una delle più esclusive di tutta Roma, caratterizzata da palazzi signorili e ampie strade alberate. È il quartiere in cui si trovano alcune delle più grandi istituzioni della città, fra cui l’Accademia Nazionale d’Arte Drammatica. Al suo interno si trova il grande Parco di Villa Ada. Non solo: il quartiere trova nei pressi di Villa Borghese, vero e proprio polmone verde della città, in cui si trovano anche il Globe Theatre e un museo. Rappresenta uno dei volti più iconici di Roma.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Parioli e Flaminio a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/roma/testaccio-trastevere":"La zona di Testaccio e Trastevere è una di quelle più storiche di Roma. Le strade si diramano in vicoli e stradine pittoresche, alti palazzi antichi e monumenti spettacolari. È spesso indicata come una delle zone più amate e visitate della Capitale. Rappresenta una zona iconica per tutta la città, e la sua posizione strategica la rende vicina ai suoi maggiori punti di interesse, alle maggiori linee di autobus e della metropolitana. È ben frequentata e ricca di vita, ed uno dei punti dove si può ammirare l’anima più autentica di Roma.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Testaccio e Trastevere a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/corso-francia-vigna-clara-fleming-ponte-milvio":"Le zone di Corso Francia, Vigna Clara, Fleming e Ponte Milvio si trovano a nord della città di Roma. Si trovano a poca distanza dalle sponde del Tevere e dalle bellezze del centro storico. Rappresentano un’area in continua evoluzione architettonica e culturale, e i bei palazzi moderni sono spesso immersi nel verde e costeggiati da ampi viali alberati. Si trovano a poca distanza da aree naturali come il Foro Italico e il Parco dell’Inviolatella Borhese, per trovare un’oasi di pace nella città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Corso Francia, Vigna Clara, Fleming, Ponte Milvio a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/eur-torrino-tintoretto":"Il quartiere dell’EUR è, forse, fra quelli della periferia romana, uno dei più famosi. Le ampie strade e l’architettura di inizio Novecento creano un paesaggio unico in tutta la città. La grande presenza di uffici ne fanno un punto molto importante per i lavoratori della città. Il laghetto artificiale e il parco che sorge tutt’intorno sono una piccola zona verde molto caratteristica. Grazie alla presenza di ampi palazzi, l’EUR è spesso la meta principale di fiere culturali e congressi.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona EUR, Torrino e Tintoretto a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/roma/gregorio-vii-baldo-degli-ubaldi":"Le zone di Gregorio VII e Baldo degli Ubaldi si trovano nella parte occidentale di Roma. Quest’area vanta una posizione privilegiata per la sua vicinanza alle attrazioni più amate della città, come Città del Vaticano o le sponde del Tevere. È una zona tranquilla e ben tenuta, ricca di palazzi moderni e ampie strade alberate. È collegata al resto della città grazie a diverse linee di autobus e alla linea A della metropolitana, e anche per questo è una meta molto amata dagli studenti o dalle giovani famiglie.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Gregorio VII e Baldo degli Ubaldi a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/camilluccia-cortina-d-ampezzo":"Le zone di Camilluccia e Cortina d\'Ampezzo a Roma vantano degli ampi spazi e una ricca zona verde, grazie anche alla vicinanza con la Riserva Naturale dell\'Insugherata. Si trova a nord di Roma, ed è ben collegata al resto della città grazie alle frequenti linee di autobus. Si tratta di un’area tranquilla e ricca di verde, dalle palazzine basse e le casette caratteristiche. Rappresenta una parte della città ricca di fascino e silenzio, dove poter vivere in tranquillità a un passo dal centro.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Camilluccia e Cortina d\'Ampezzo a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/cassia-san-godenzo-grottarossa":"La zona di Grottarossa si trova a nord del centro di Roma, attraversata da via Cassia e via San Godenzo. Quella della Cassia è una delle strade più grandi di tutta la città, e rappresenta un punto importante per lo snodo del traffico cittadino. I palazzi moderni di alternano a palazzine più antiche, e la vicinanza delle sponde del Tevere a Grottarossa conferisce alla zona un fascino particolare. È una zona tranquilla e ben tenuta, poco distante dal centro.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Cassia, San Godenzo, Grottarossa a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/trionfale-monte-mario-ottavia":"La zona Trionfale di Roma, nota ai più anche con il nome di “Balduina”, è una delle più antiche di Roma. Si trova al confine con Città del Vaticano, permette una vista unica sulla Cupola di San Pietro. All’interno del quartiere si trova anche il Parco regionale urbano del Pineto, il secondo parco più grande di Roma e una delle aree verdi più frequentate in città. Grazie alla sua posizione strategica è molto vicina alle mete romane più famose, pur mantenendo la sua impronta tranquilla.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Trionfale a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/roma/magliana-trullo-parco-de-medici":"La zona della Magliana a Roma è giovane e in continua evoluzione, ricca di stimoli e posti interessanti. La zona della Magliana vecchia è una delle più amate del quartiere, e la grande area verde del Parco de’ Medici rappresenta un piccolo angolo di tranquillità nella parte più moderna della zona. È ben collegata al centro grazie alle tante linee di autobus ed è servito da una stazione della linea B della metropolitana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Magliana, Trullo e Parco de’ Medici a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/casetta-mattei-pisana-bravetta":"La zona di Casetta Mattei, via Pisana e Bravetta di Roma è giovane e intraprendente, ricca di stimoli, frequentata da studenti e giovani famiglie. È in continua evoluzione, e rappresenta uno dei punti della città con più potenziale per le nuove generazioni. È servita da diverse linee di autobus, e si raffigura anche come una zona importante per chi è alla ricerca di una zona verde grazie alla sua vicinanza con l’antica Villa Pamphili.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Casetta Mattei, Pisana e Bravetta a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/aurelio-boccea":"I quartieri Aurelio e Boccea di Roma hanno un particolare vantaggio, la vicinanza al centro di Roma e a Città del Vaticano. Altro fattore di interesse sono la vicinanza di importanti strutture sanitarie, la presenza di numerosi e importanti attività commerciali ed esercizi pubblici e la possibilità di scegliere tra tante soluzioni abitative in grado di rispondere a diverse esigenze e a capacità economiche di diverso tipo. Allo stesso tempo il quartiere è tranquillo e piacevole da vivere ed è interessato dalla presenza di molti servizi.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Aurelio e Boccea a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/roma/battistini-torrevecchia":"La zona di Battistini e via Torrevecchia si trova nella zona nordoccidentale di Roma, a poca distanza dal centro storico e da Città del Vaticano. L’area di Battistini è ben collegata al resto della città grazie a una fitta rete di linee di autobus e alla presenza della stazione della linea 1 della metropolitana. La via di Torrevecchia è una delle più importanti della città per il modo in cui collega la zona nord con il centro storico.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Battistini e Torrevecchia a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/acilia-casal-bernocchi-centro-giano-dragona-malafede-vitinia":"Fra il centro storico di Roma e il mare di Ostia si trovano le zone di Acilia, Casal Bernocchi, Centro Giano, Dragona, Malafede e Vitinia: aree aperte e verdeggianti, ricche di palazzi moderni e ampi spazi. Grazie alla linea ferroviaria l’intera zona vanta un frequente collegamento sia per Ostia che per Roma, pur tenendosi lontana dalla frenesia della vita di città. Frizzante, giovane e in continua evoluzione, l’intera area è ricca di opportunità.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Acilia, Casal Bernocchi, Centro Giano, Dragona, Malafede, Vitinia a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/lido-di-ostia-ostia-antica-castel-fusano":"La zona del lido di Ostia, Ostia Antica e Castel Fusano si trovano a poca distanza dal centro di Roma, ma grazie alla loro vicinanza al mare possono vantare uno stile di vita del tutto nuovo. Sono zone ben collegate al centro grazie alla linea ferroviaria, e al tempo stesso rappresentano un piccolo mondo a sé. Non solo mare: anche la presenza di una grande riserva naturale contribuisce a rendere questa zona molto interessante, e la presenza del vicino Aeroporto Internazionale ne fa un importante centro per i trasporti del Lazio.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Ostia, Ostia Antica e Castel Fusano a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/casal-lumbroso-massimina-ponte-galeria":"Le zone di Casal Lumbroso, Massimina e Ponte Galeria sono molto tranquille e ben apprezzate per la vicinanza a Roma e la tranquillità dell’ambiente circostante. Si trovano, per la precisione, fra Roma e le coste di Ostia, vantando una posizione privilegiata sia per il centro storico che per i lidi e le riserve naturali più vicine. Sono ben collegate a entrambe le città grazie alla rete ferroviaria, che porta anche al vicino Aeroporto Internazionale.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Casal Lumbroso, Massimina e Ponte Galeria a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/casalotti-casal-selce-maglianella":"Le zone di Casalotti, Casal Selce e Maglianella si trovano a poca distanza dal centro di Roma, e sono ben collegate a quest’ultima grazie alla rete ferroviaria. Le ampie strade e i viali alberati conferiscono alla zona un’aria molto tranquilla, lontana dai frenetici ritmi di città. È ben collegata anche alla città di Ostia. Il Parco della Cellulosa è un’area verde molto interessante e frequentata della zona.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Casalotti, Casal Selce e Maglianella a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/balduina-medaglie-d-oro-degli-eroi":"La zona di Balduina e il viale di Medaglie d\'Oro Degli Eroi si trovano all’interno del quartiere Trionfale, e rappresentano una delle parti più belle di tutta Roma. Si trovano a un passo dalle mete più belle e caratteristiche di tutta Roma, come Città del Vaticano, Castel Sant’Angelo o il Pantheon. Una zona pittoresca come poche, vero e proprio punto focale per la vita storica e artistica della città. Rappresenta un punto di eccellenza per la capitale, ed è ben collegata alle altre zone grazie a una fitta rete di autobus e fermate della metropolitana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Balduina, Medaglie d\'Oro Degli Eroi a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/axa-casal-palocco-infernetto":"Le zone di Axa, Casal Palocco e Infernetto si trovano a poca distanza da Roma. La loro vicinanza al centro della Capitale e alle spiagge del lido di Ostia ne fanno una zona ricca di potenziale. L’intera area si trova poco distante dalle bellezze antiche di Castel Porziano e alla Riserva Naturale Statale del Litorale Romano, che rappresenta una delle maggiori aree verdi della costa. Una posizione strategica perfetta per vivere in un clima tranquillo, ma al tempo stesso in continua evoluzione culturale.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Axa, Casal Palocco e Infernetto a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/re-di-roma-san-giovanni":"Le zone di San Giovanni e piazza Re di Roma rappresentano, nel loro insieme, una delle aree storiche più importanti della città. La vicinanza a monumenti straordinari come la Basilica Papale di Santa Maria Maggiore o il Colosseo ne fanno un punto di eccellenza della zona. Gli edifici antichi e i palazzi nobiliari conferiscono alla zona uno stile e un’eleganza uniche in tutta la città. Piazza Re di Roma è uno degli snodi più importanti per gli spostamenti della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Re di Roma e San Giovanni a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/aventino-san-saba-caracalla":"Le zone dell’Aventino, San Saba e Caracalla a Roma sono note soprattutto per la presenza degli omonimi scavi, e la generale bellezza di tutta la zona. Le terme di Caracalla, dette anche Terme Antoniniane, sono ancora oggi riconosciute come uno dei più grandi esemplari di terme romane perfettamente conservate. La bellezza di questi edifici storici immersi nel verde regala a tutta la zona un panorama unico, e i palazzi moderni si fondono bene con l’ambiente. È ben collegata al resto della città grazie a una fitta rete di linee di autobus.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Aventino, San Saba, Caracalla a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/appio-latino-colli-albani":"Le origini del quartiere Appio Latino di Roma sono molto antiche, ma la sua ricostruzione in quartiere operaio è avvenuta solo nella prima metà del Novecento. La sua continua evoluzione le ha permesso di reinventarsi ancora in uno dei quartieri più popolari di Roma. Le sue attrazioni storiche più antiche si fondono con altri elementi più moderni: qui, infatti, sono stati anche girati diversi film. Oggi è un quartiere moderno e vivace, ben collegato al resto della città con i mezzi pubblici.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Appio Latino e Colli Albani a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/roma/garbatella-navigatori-ostiense":"Le zone di Garbatella, Navigatori e Ostiense rappresentano alcuni dei punti più vivaci, giovani e ricchi di vita di tutta Roma. Amatissima da studenti e lavoratori, l’intera area è collegata al resto della città grazie a una fitta rete di autobus, tram e metropolitane. È molto frequentata dagli universitari per via della presenza di molte facoltà importanti. Una zona ricca di vita e storia, in costante evoluzione e a poca distanza dalle bellezze del centro storico, pur rappresentando una parte altrettanto importante della storia della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Garbatella, Navigatori, Ostiense a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/marconi-san-paolo":"Le zone di Marconi e San Paolo a Roma rappresentano alcuni dei punti più importanti per gli studenti della città, grazie alla presenza di diverse facoltà importanti dell’Università di Roma Tre. È ben collegata al resto della città grazie agli autobus e la linea B della metropolitana. La vicinanza con le sponde del Tevere creano dei panorami unici, conferendo a tutta la zona un’aria molto caratteristica. Rappresenta un punto d’incontro importante fra studenti di ogni parte del paese, ed è una zona in costante evoluzione culturale.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Marconi e San Paolo a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/appia-pignatelli-ardeatino-montagnola":"Il quartiere di Ardeatino si trova a sud di Roma e prende il suo nome dall’antica via Ardeatina. È una zona ricca di ampi spazi, fra cui la Tenuta di Tormarancia e il Parco di Forte Ardeatino, che costituisce anche una delle sue attrazioni storiche più rilevanti. In questo quartiere si trova anche il Parco Regionale dell’Appia Antica, che vanta il primato di essere uno dei parchi urbani più grandi di tutta Europa. È un quartiere molto esteso, ricco di storia e molto tranquillo, ma abbastanza vicino al centro storico di Roma per trovarsi subito al centro dell’azione.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Appia Pignatelli, Ardeatino e Montagnola a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/roma/cecchignola-fonte-meravigliosa":"Le zone di Cecchignola e Fonte Meravigliosa si trovano a sud del centro di Roma, e vanta una grande presenza di spazi verdi. Le ampie strade alberate e circondate dal verde portano al centro in breve tempo, così come le varie linee di autobus che servono la zona. A poca distanza dalla zona si trova anche la stazione Laurentina, così come il Grande Raccordo Anulare. Via della Cecchignola rappresenta uno dei punti più importanti per gli spostamenti della zona.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Cecchignola e Fonte Meravigliosa a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/anagnina-romanina-tor-vergata":"Le zone di Anagnina e Tor Vergata si trovano nella zona sudorientale di Roma, e rappresentano una parte della città molto ambita e frequentata dagli studenti grazie alla presenza del Università degli Studi di Roma \\"Tor Vergata\\". L’omonima stazione di Anagnina, servita dalla linea A della metropolitana, collega tutta la zona al resto della città. I grandi viali alberati e la natura circostante rendono la zona molto tranquilla, pur trovandosi molto vicina all’azione del centro.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Anagnina e Tor Vergata a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/trigoria-castel-romano":"La zona di Trigoria si trova a sud di Roma e rappresenta uno dei punti più importanti per la vita lavorativa e culturale della città. In questa zona si trovano sia il Policlinico che l\'Università Campus Bio-Medico di Roma, molto frequentata dai giovani studenti. La zona è attraversata da Via di Castel Romano, famosa soprattutto per la presenza del parco tematico di Cinecittà World, creato da alcune delle più grandi eccellenze del cinema italiano nel mondo e ancora oggi una delle attrazioni più interessanti della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Trigoria e Castel Romano a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/cinecitta-quadraro":"La zona di Cinecittà e del Quadraro racchiude alcune delle attrazioni più interessanti della storia più recente di Roma, soprattutto per quel che riguarda il cinema italiano e internazionale. Le palazzine basse conferiscono alla zona un’aria caratteristica, così come le ampie strade. Oltre alle attrazioni di Cinecittà, che rappresentano un punto di eccellenza per tutta Roma, la zona del Quadraro è nota anche per le ampie strade e l’aria tranquilla. È ben collegata al centro grazie alla linea A della metropolitana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Cinecittà e Quadraro a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/monteverde-gianicolense-colli-portuensi-casaletto":"La zona di Gianicolense, a Roma, è nota ai più come “Monteverde” ed è spesso identificata con questo nome. È famosa per il Parco di Villa Doria Pamphili e, proprio per questo, rappresenta una delle zone più verdi di tutta la città. La sua posizione strategica permette di raggiungere in breve tempo luoghi ben più famosi, come Città del Vaticano o il Colosseo. Questo le permette di mantenere la sua fama di quartiere tranquillo, pur trovandosi a pochi passi da zone più frequentate.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Gianicolense, Monteverde, Colli Portuensi e Casaletto a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/roma/borghesiana-finocchio":"La zona della Borghesiana e la Borgata Finocchio, nota anche solo con il nome di “Finocchio” si trovano a est del centro di Roma. Si tratta di un’area molto ampia, ricca di palazzine storiche e una fervente attività culturale. È una zona molto ben collegata con il centro grazie anche alla presenza di diverse fermate della linea C della metropolitana, famosa per le sue stazioni all’avanguardia. Una parte della città tranquilla ma in costante evoluzione, ricca di potenziale.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Borghesiana e Borgata Finocchio a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/mezzocammino-spinaceto-tor-de-cenci":"Le zone di Mezzocammino, Spinaceto e Tor de\' Cenci si trovano a sud di Roma, poco distanti dalle coste del Lazio. Sono zone molto tranquille, non molto lontane sia dalla piccola e graziosa Castel Porziano che alla Riserva Naturale Statale del Litorale Romano. Le strade della zona vantano tanta natura, palazzi e villini immersi nel verde, ideale per vivere in un’area tranquilla pur mantenendo il centro di Roma facilmente raggiungibile.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Mezzocammino, Spinaceto, Tor de\' Cenci a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/appio-claudio-capannelle":"Le zone di Appio Claudio e Capannelle si trovano nella zona sudorientale di Roma, e sono collegate al centro della città grazie a diverse linee di autobus. La zona di Appio Claudio è nota soprattutto per il grande Parco degli Acquedotti e il sito archeologico che si trova al suo interno. Gli antichi acquedotti immersi nel verde conferiscono a tutta la zona un aspetto iconico, e rappresentano uno dei punti storici più interessanti della periferia romana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Appio Claudio, Capannelle a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/castel-di-leva-vallerano":"Le zone di Castel di Leva e Vallerano si trovano a sud di Roma. Si tratta di un’ampia area circondata dal verde, molto tranquilla e ricca di palazzine caratteristiche. È collegata al centro di Roma grazie alle varie linee di autobus, ma anche alle ampie strade che portano in città. Allo stesso modo è altrettanto vicina alle coste del Lazio e al mare, vantando così una posizione privilegiata durante l’estate. Una zona in evoluzione e ricca di potenziale.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Castel di Leva, Vallerano a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/portuense-villa-bonelli":"La zona di Portuense e Villa Bonelli a Roma è carica di storia e ricca di attrazioni spettacolari. Si trova a un passo dalle maggiori attrazioni del centro, ma anche dalle romantiche sponde del Tevere. È una zona molto amata da turisti e locali, molto ben frequentata e collegata al resto della città con diverse linee di autobus. La sua posizione strategica è molto ambita dagli studenti, perché è vicina alla zona di Ostiense e alle sue facoltà universitarie.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Portuense e Villa Bonelli a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/salario-trieste":"Il quartiere di Salario sorge sulla via Salaria, da cui prende il nome, ed è uno dei quartieri più suggestivi di tutta Roma. I suoi palazzi antichi rappresentano una variante unica nel panorama architettonico romano. La sua vicinanza ai quartieri di Parioli e Pinciano contribuisce alla sua fama di quartiere elegante ed esclusivo. Fra i luoghi iconici della zona ci sono, senza dubbio, l’ex birrificio della Peroni e il MACRO, il Museo di Arte Contemporanea.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Salario e Trieste, <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/roma/termini-repubblica":"La stazione di Termini e piazza della Repubblica a Roma sono forse le zone più visitate di tutta la città, anche solo per il loro essere un crocevia per viaggiatori di tutto il mondo. La stazione di Termini, soprattutto, è una delle più frequentate del paese e attraversata ogni giorno da migliaia di visitatori, mentre la vicina piazza della Repubblica rappresenta un vero e proprio biglietto da visita della città. Ampia e maestosa com’è, infatti, si apre su alcune delle più belle zone di tutta la città. Una zona elegante e signorile, in fervente attività.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Termini e Repubblica a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/bologna-policlinico":"La zona di Bologna e del Policlinico di Roma rappresenta un punto nevralgico per studenti e lavoratori della città. È molto frequentata dagli studenti del Policlinico e delle vicine facoltà universitarie, e l’omonima fermata della metropolitana collega la zona col resto della città. I grandi viali alberati e i palazzi antichi le conferiscono un fascino unico. Si trova a poca distanza anche da zone esclusive come quella dei Parioli e la maestosa Villa Borghese.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Bologna Policlinico a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/pigneto-san-lorenzo-casal-bertone":"Le zone del Pigneto, di San Lorenzo e Casal Bertone sono fra quelle più giovani e ricche di vita di tutta Roma. Ben frequentate da studenti di ogni tipo e giovani lavoratori, rappresentano alcuni dei punti nevralgici anche della cultura cittadina grazie alle tante associazioni culturali e librerie. Si tratta di zone coloratissime e in costante evoluzione culturale, sempre in movimento, ma presentano anche dei palazzi antichi e tanti edifici storici da scoprire. Grazie alla presenza di diverse linee del tram, l’intera area è ben collegata al resto della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Zona Pigneto, San Lorenzo e Casal Bertone a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/talenti-monte-sacro-nuovo-salario":"Il quartiere di Monte Sacro sorge sulla riva destra del fiume Aniene, uno degli affluenti del Tevere. La riserva naturale di Valle delle Aniene rappresenta uno dei punti naturali più apprezzati della zona. La pittoresca Piazza Sempione si apre sull’omonimo corso, uno degli snodi più importanti di tutta Roma. Fra le bellezze storiche che conferiscono lustro alla zona c’è il Ponte Nomentano.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Monte Sacro a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/roma/porta-di-roma-casal-boccone":"Porta di Roma e la zona di Casal Boccone si trovano a nord del centro storico di Roma. Si tratta di zone colme di storia ma, al tempo stesso, palazzi moderni che regalano un aspetto nuovo al panorama. Una zona tranquilla ed elegante, ma al tempo stesso con un carattere deciso, vicina anche a zone più verdi come la grande Riserva Naturale della Marcigliana. Un’area ricca di potenziale e piena di sorprese.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Porta di Roma e Casal Boccone a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/monti-tiburtini-pietralata":"Il quartiere di Pietralata si trova nella zona sud-est di Roma. È una zona eclettica e in continua evoluzione, distante dal centro storico quel tanto che basta per conservare una relativa tranquillità, ma abbastanza vicina per poterci arrivare subito. È ben collegata al resto della città anche grazie alla presenza della linea B della metropolitana. È stata protagonista di alcuni racconti di Elsa Morante e Pier Paolo Pasolini, e fra i suoi reperti storici c’è il Forte di Pietralata.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Pietralata a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/roma/centocelle-tor-de-schiavi":"Il quartiere di Centocelle è noto anche come Prenestino – Centocelle perché sorge, appunto, lungo la via Prenestina. È una delle zone più popolari fra studenti e lavoratori in cerca di una zona tranquilla e ben collegata al centro della città grazie anche alla presenza di due fermate della nuovissima linea C della metropolitana. Il quartiere in sé vanta ampi viali alberati e alti palazzi, case grandi e diverse zone verdi.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Centocelle e Tor de Schiavi a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/roma/alessandrino-tor-sapienza-torre-maura":"La zona dell’Alessandrina si trova fra Centocelle e Torre Spaccata. Rappresenta una delle zone più frequentate da studenti e lavoratori, ma vanta anche degli edifici di grande rilevanza storica. In questo quartiere, infatti, si trova l’acquedotto Alessandrino da cui ha preso il nome. Si trova nel parco di Giovanni Patalucci, detto anche Parco di Tor Tre Teste, che costituisce uno dei punti verdi più grandi della zona.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Alessandrino a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/roma/bufalotta-casal-monastero-settebagni":"Le zone di Bufalotta, Casal Monastero e Settebagni a Roma si trovano nella zona nordorientale della città, a poca distanza dal centro. L’intera area è ben collegata al resto della città grazie a diverse linee di autobus. La sua vicinanza a zone verdi come il Parco delle Sabine o la Riserva Naturale della Marcigliana la rende perfetta per chi è alla ricerca di un quartiere tranquillo a pochi passi dalla natura.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Bufalotta, Casal Monastero e Settebagni a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/ponte-di-nona-torre-angela":"Le zone di Ponte di Nona e Torre Angela si trovano a est del centro storico di Roma. Il Parco archeologico di Ponte di Nona è una delle mete storiche più interessanti della zona orientale di Roma. Le ampie strade collegano rapidamente la zona al centro, così come le varie linee di autobus. La grande presenza di aree verdi ne fa una zona molto apprezzata anche dalle giovani famiglie con bambini.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Ponte di Nona e Torre Angela a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/ponte-mammolo-san-basilio-tor-cervara":"La zona di Ponte Mammolo a Roma si trova nella parte nordorientale della città, ed è famosa per gli ampi spazi e la natura che la circonda. Il Parco regionale urbano di Aguzzano e la Riserva naturale Valle dell\'Aniene, in cui scorre l’omonimo affluente del Tevere, sono le più frequentate. Nel quartiere ci sono anche delle cave di tufo e diversi siti archeologici. Il quartiere è molto tranquillo, a poca distanza dall’azione del centro di Roma, e collegato ad essa con la linea B della metropolitana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Ponte Mammolo, San Basilio e Tor Cervara a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/roma/lunghezza-castelverde":"Le zone di Lunghezza e Castelverde si trovano a est rispetto al centro di Roma, e non sono molto distanti dalla città pur mantenendo un’atmosfera molto più rilassata rispetto ai ritmi cittadini. Le ampie strade collegano subito la zona al centro, mentre i tanti spazi verdi sono perfetti per le giovani famiglie con bambini in cerca di un’area tranquilla. È collegata al resto della città con tre diverse linee di autobus.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Lunghezza e Castelverde a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/olgiata-giustiniana":"Le zone di Olgiata e la Giustiniana si trovano a nord di Roma e rappresentano una delle zone di Roma più importanti della periferia della città grazie alla grande presenza di palazzi moderni e villette caratteristiche, aree verdi e linee di autobus che la collegano alle zone circostanti. Sia la zona di Olgiata che quella della Giustiana vantano grandi viali alberati e uno stile molto tranquillo, ma al tempo stesso una vivace attività quotidiana e in continua evoluzione. Si tratta di zone ad alto potenziale, poco distanti dal centro.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Olgiata, Giustiniana a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/roma/labaro-prima-porta-valle-muricana":"Le zone di Labaro, Prima Porta e Valle Muricana si trovano nella parte nord della città di Roma e vantano uno stile unico, ricco di natura e a poca distanza dal centro storico. La vicinanza anche alle sponde del Tevere conferisce all’area un aspetto molto romantico. È ben collegata al resto della città non solo grazie alla fitta rete di strade, ma anche grazie alla linea ferroviaria che collega Roma a Viterbo e che passa proprio per questa zona.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Labaro, Prima Porta e Valle Muricana a <0>Roma</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/torino/regio-parco-vanchiglia-vanchiglietta":"Il quartiere di Vanchiglia a Torino è uno dei più affascinanti di tutta la città. È un quartiere molto frequentato dagli studenti grazie alla presenza del Campus Einaudi. Rappresenta uno dei volti più giovani della città, pur mantenendo intatta la sua anima più antica. Anche dal punto di vista della natura il quartiere vanta un’eccellenza: in questa zona si trova anche il Parco Colletta, uno dei polmoni verdi della città. Questo parco contiene diverse infrastrutture sportive, e proprio per questo costituisce un importante punto di riferimento per gli atleti della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Vanchiglia e Vanchiglietta a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/aurora-barriera-di-milano-rebaudengo":"Il quartiere Barriera di Torino, noto ai più anche con il nome di “Barriera di Milano”, è una delle zone più antiche e ricche di storia della città. Sorge a pochissima distanza dal centro. Oggi riesce a incarnare l’animo artistico e pragmatico della città grazie alle gallerie d’arte e ai laboratori artigianali. I murales che animano le strade ne fanno un piccolo museo a cielo aperto. Grazie alle sue tante attrattive e alla sua vitalità, è un quartiere molto amato anche dagli studenti.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Barriera Milano e Rebaudengo a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/barriera-di-lanzo-falchera-barca-bertolla":"Il quartiere di Falchera si trova nella periferia nord di Torino, ed è una delle zone più tranquille della città. Falchera si distingue in due parti: Falchera Vecchia e Falchera Nuova, nella parte più settentrionale. Se la prima vanta una storia molto antica e alcuni palazzi caratteristici, la seconda è senza dubbio più moderna grazie ai tanti palazzi costruiti nel corso degli anni ’70. Entrambe le zone sono collegate al resto della città con la storica linea 4 del tram e diverse linee ferroviarie.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona a Barriera di Lanzo, Falchera, Barca e Bertolla a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/borgo-vittoria-parco-dora":"Il Borgo Vittoria di Torino, noto anche con il nome di “Borgata Vittoria”, si trova a nord della città. Per la precisione, sorge fra il centro storico e la zona fluviale di Basse di Stura. Le ville più antiche e gli edifici del Novecento si fondono con le costruzioni più moderne e all’avanguardia, creando un clima vivace e variegato. Rappresenta una delle aree più storiche e, al tempo stesso, in continua evoluzione della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Borgata Vittoria a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/le-vallette-lucento-madonna-di-campagna":"La zona Lucento Vallette di Torino è famosa soprattutto per la presenza dell’area verde più grande di tutta la città: il Parco Carrara, noto ai più col nome di Parco della Pellerina, è uno dei più amati e frequentati di tutta la città. Nel quartiere ci sono anche delle zone storiche molto antiche che si alternano a costruzioni più moderne, e diversi eventi culturali nel corso dell’anno la rendono anche un punto di ritrovo per giovani e artisti. Grazie alla sua posizione strategica, Lucento è vicinissima al centro storico e ben collegata al resto della città con diverse linee di autobus e due linee tranviarie.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Lucento Vallette e Madonna di Campagna a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/pozzo-strada-parella":"La zona di Pozzo Strada si trova a ovest del centro storico di Torino. È un quartiere vivace e in continua evoluzione, ricco di palazzi moderni e alcuni edifici storici. Rappresenta un punto di riferimento molto importante per la città grazie alla presenza del suo ospedale. La sua pista ciclabile incarna bene lo spirito di una Torino volta a politiche più green. La presenza di vaste aree verdi ne fanno una zona molto tranquilla, ma comunque ben collegata al centro grazie alle diverse linee del tram e una fermata della metropolitana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Pozzo Strada e Parella a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/madonna-del-pilone-sassi":"Madonna del Pilone è un quartiere della zona nordest di Torino. Deve il suo nome all’omonima chiesa presente sul territorio, che rappresenta anche uno dei suoi edifici storici più conosciuti. L’intero quartiere offre ai suoi abitanti una storia spesso poco nota di Torino, e che si può ammirare nei suoi palazzi più caratteristici. In questo quartiere ha abitato anche Emilio Salgari, l’amato scrittore di romanzi d’avventura. È collegato al resto della città grazie a diverse linee di autobus e due fermate della metropolitana, ed è un quartiere tranquillo e silenzioso.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Madonna del Pilone e Sassi a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/centro":"La zona del Centro Storico di Torino è una eccellente rappresentazione dell’eleganza e dello stile di questa città. Le strade suggestive si snodano fra palazzi storici ed edifici di importanza nazionale come, ad esempio, Palazzo Madama o il Museo Egizio. La raffinata bellezza del centro storico di Torino si unisce al suo lato più giovane e moderno, dando vita a un quartiere ricco di sfaccettature. Costituisce uno snodo importante per l’intera città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Centro a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/crocetta-san-secondo":"Il quartiere di Crocetta si trova a sud del centro storico di Torino, ed è uno dei più eleganti di tutta la città. Oltre al suo stile raffinato e ai suoi palazzi nobiliari bisogna aggiungere anche uno stile di vita giovane e moderno, grazie alla presenza del Politecnico di Torino. Si tratta di una zona molto popolare, quindi, soprattutto fra gli studenti che la frequentano. Rappresenta un punto focale per la vita intellettuale della città anche per i tanti eventi ospitati nelle sue gallerie d’arte.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Crocetta e San Secondo a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/cavoretto-gran-madre":"Fra tutti i quartieri di Torino, quello di Cavoretto è forse uno dei più suggestivi. La sua posizione strategica lo porta a trovarsi a poca distanza dal centro storico della città e alla natura incontaminata del Piemonte. Il Parco Europa è forse una delle sue aree più belle, che regala anche una vista unica sulla città stessa. Esprime al meglio la parte più storica di Torino, e si respira un’atmosfera quasi magica. L’intera zona collinare sembra ben lontana dai ritmi veloci della città, pur trovandosi a pochissima distanza da quest’ultima.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Cavoretto e Gran Madre a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/colle-della-maddalena-superga":"La zona del Colle della Maddalena si trova nella parte sud orientale di Torino, ed è un’area particolarmente tranquilla e silenziosa della città. Nonostante la poca distanza dal centro, sembra un piccolo mondo a sé stante. Si tratta, infatti, di una zona immersa nel verde, ricca di natura e ampie strade alberate, dove villette più antiche si alternano a costruzioni più moderne. Grazie alla vicinanza con il Parco Della Maddalena Pian Delle Lot, la zona offre anche un’area verde molto importante e frequentata.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Colle della Maddalena e Superga a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/torino/borgo-san-paolo-cenisia":"La zona di Cenisia a Torino è un crocevia di studenti, grazie anche e soprattutto alla presenza del Politecnico della città. Qui si trova anche la storica zona di Cit Turin. Rappresenta anche un quartiere importante dal punto di vista architettonico per la presenza del Grattacielo Intesa San Paolo, progettato da Renzo Piano, che costituisce il terzo edificio più alto di tutta la città. Un quartiere che esprime al meglio lo spirito tutto torinese di fondere insieme storia e futuro.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Cenisia e Borgo San Paolo a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/lingotto-nizza-millefonti":"La zona di Lingotto si trova nella parte più a sud di Torino, ed è famosa soprattutto per ospitare l’ex fabbrica della FIAT. Un tempo era il centro lavorativo della città, mentre oggi è stato completamente trasformato in un centro congressi con un’annessa galleria d’arte. È diventato, quindi, uno dei centri culturali più attivi di Torino, e la sua importanza influenza tutta la zona circostante. Il quartiere di Lingotto è ben collegato al resto della città grazie alla storica linea 4 del tram e diverse linee di autobus. I mezzi vi permetteranno di essere vicini al centro, pur vivendo la tranquillità di un ambiente in continua evoluzione.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Lingotto e Nizza Millefonti a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/san-salvario":"Lo storico quartiere di San Salvario si trova nella zona sudorientale di Torino, ed è famoso in tutta la città per le sue caratteristiche uniche. Rappresenta un vero punto di accesso ad alcuni degli edifici storici più importanti della città, come ad esempio il famoso Parco del Valentino. Al suo interno si trova l’omonimo castello, dichiarato un Patrimonio dell’Umanità dall’UNESCO. Il quartiere non è importante solo per la sua storia, però: la sua posizione strategica lo rende anche molto vicino alla stazione ferroviaria di Porta Nuova, rendendolo di fatto uno dei punti di riferimento più importanti per chiunque debba spostarsi in città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona San Salvario a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/santa-rita-mirafiori-nord":"Mirafiori Nord è un quartiere che si trova nella zona sudoccidentale di Torino, e rappresenta una delle periferie storiche più rilevanti di tutta la città. Oltre alle sue ville e palazzi antichi, in questo quartiere si trova anche lo Stadio del Ghiaccio, costruito in occasione delle Olimpiadi Invernali. Proprio grazie alla presenza di questo Stadio il quartiere di Mirafiori è diventato, in breve tempo, un punto di riferimento importante per gli sportivi della città. È collegato al centro grazie a diverse linee di autobus e a una fermata della metropolitana.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Mirafiori Nord e Santa Rita a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/campidoglio-san-donato-cit-turin":"Il quartiere di San Donato è uno di quelli più antichi di tutta Torino. È stato abitato fin dal medioevo. Si è evoluto di pari passo con i tempi, e oggi riesce a raffigurare il perfetto esempio di un quartiere all’avanguardia con una spiccata impronta storica. È una zona ben nota soprattutto dagli studiosi di architettura grazie alla presenza di alcuni palazzi in puro stile Liberty. San Donato presenta alcuni edifici storici, ma è anche sede di diversi festival culturali. Rappresenta uno dei quartieri storici più rilevanti della periferia di Torino.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona San Donato, Campidoglio e Cit Turin a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/torino/mirafiori-sud":"Il quartiere di Mirafiori Sud si trova nella zona sudoccidentale della città di Torino. È famoso per essere stato sede di uno degli stabilimenti più grandi della Fiat, e per molto tempo è stato anche uno dei quartieri più popolosi della città. Oggi è un quartiere ricco di storia e monumenti antichi, palazzi moderni e vaste aree verdi. Queste ultime sono dovute anche alla presenza di diversi impianti sportivi, che ne fanno un importante punto di riferimento per gli atleti della città. Un quartiere ricco di sorprese, che mantiene un delicato equilibrio fra passato e futuro, e conserva una sua identità pur trovandosi a breve distanza dal centro storico.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Mirafiori Sud a <0>Torino</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/verona/pindemonte-valdonega":"Il quartiere della Valdonega a Verona è uno dei quartieri storici più affascinanti della città. È separato dal centro storico solo dalle correnti del fiume Adige, che lo delimita in parte, ed è molto vicino ai luoghi più importanti della città. Valdonega è una zona nota anche per le sue stesse attrattive storiche: l’omonima villa romana, infatti, è una delle mete più visitate di tutta la città. Le sue aree verdi sono ampie e ben frequentate, ed è collegata al resto della città grazie a diverse linee di autobus. La sua posizione strategica ne fa un importante punto di passaggio per tutta la città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Valdonega e Pindemonte a <0>Verona</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/verona/borgo-nuovo-navigatori-ponte-crencano":"La zona di Ponte Crencano a Verona è una delle più antiche di tutta la città, anche se ha vissuto i primi cenni di espansione solo in tempi più moderni. Vanta alcuni palazzi antichi e signorili che si alternano a palazzi più moderni, e la sua vicinanza al centro storico ne fa il luogo perfetto per vivere in una zona tranquilla pur restando a pochi passi dalle zone storiche più famose di Verona. La presenza di diverse aree verdi aumenta la sua fama di quartiere silenzioso e tranquillo. È ben collegato al resto della città grazie a diverse linee di autobus.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Ponte Crencano, Borgo Nuovo e Navigatori a <0>Verona</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/verona/quinzano-parona":"La zona di Quinzano si trova poco distante da Verona, poco distante dalla piccola e pittoresca frazione di Avesa. Sorge sulle colline della città, ed è noto per essere un quartiere molto verde e ricco di vita. Il quartiere di Parona, invece, si trova alle porte della Valpolicella, e si affaccia sul fiume Adige. Una zona ricca di storia e tradizioni, palazzi storici e case eleganti, dove vivere in un ambiente tranquillo e a poca distanza dalla città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Quinzano e Parona a <0>Verona</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/verona/poiano-quinto-montorio":"Le frazioni di Poiano, Quinto e Montorio di Verona si trovano a nord della città, in una posizione particolarmente suggestiva grazie alla grande presenza di mete naturali e spazi verdi. Si trovano a poca distanza da Verona, e sono facilmente raggiungibili con pochi minuti di auto o servendosi delle linee di autobus che li collegano al centro. Le ampie strade alberate e i bei palazzi antichi sono solo alcune delle caratteristiche che rendono questa zona molto elegante.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Poiano, Quinto e Montorio a <0>Verona</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/verona/avesa-torricelle":"Il quartiere di Avesa si trova a Nord di Verona, e nonostante la sua appartenenza alla città conserva ancora le caratteristiche pittoresche di un piccolo paesino. Qui nasce anche un piccolo fiume, il Lorì, dove le lavandare, per cui è noto il quartiere, lavavano i panni. Rappresenta una zona ricca di scorci romantici e molto pittoresca, circondata dal verde e distante solo pochi minuti dal centro della città di Verona.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Avesa e Torricelle a <0>Verona</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/verona/chievo-bassone":"Il quartiere di Chievo si trova ad ovest di Verona, a poca distanza dal centro e dalle rive dell’Adige. È noto per la presenza dell’omonima squadra di calcio, attorno al quale girano molte delle attività culturali e di intrattenimento del quartiere. Questo quartiere conserva ancora il fascino di un piccolo paese, pur trovandosi vicino al centro di Verona. Proprio per questo è molto amato dai pendolari che preferiscono una zona tranquilla.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Chievo e Bassone a <0>Verona</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/verona/via-mantovana-dossobuono-sacra-famiglia-castel-d-azzano":"La frazione di Dossobuono si trova nella zona sudoccidentale della città di Verona, pur facendo parte del vicino comune di Villafranca. Costituisce una delle mete storiche più interessanti che orbitano intorno alla città grazie alle sue mete storiche, così come la vicina frazione di Castel d’Azzano. Queste frazioni la grande via Mantovana rappresentano una zona tranquilla e in continua evoluzione, a poca distanza dal centro storico.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Via Mantovana, Dossobuono, Sacra famiglia e Castel D’Azzano a <0>Verona</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/verona/borgo-roma-ca-di-david":"Il quartiere di Borgo Roma a Verona si trova a sud della città. È un’area vivace e molto accogliente. Qui si trovano diversi ospedali, oltre alla facoltà di medicina e a quella di scienze naturali. Proprio per questo motivo, il quartiere rappresenta un importante punto di riferimento per medici, studenti e ricercatori. È molto ben collegato al resto della città grazie a diverse linee di autobus. La presenza di un parco nuovo, costruito negli ultimi anni, ha dato ulteriore vita a un quartiere già molto vivace e ricco di stimoli.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Borgo Roma e Cà di David a <0>Verona</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/verona/san-michele-extra-castiglione":"Il quartiere di San Michele Extra si trova nella parte sudorientale della città di Verona. È una zona pulita e ben tenuta, caratterizzata da palazzine moderne e da un’atmosfera giovanile. Vanta una posizione strategica molto vicina al centro, pur mantenendo la sua atmosfera tranquilla e meno “cittadina”, ma è ben collegata al centro grazie a diverse linee di autobus e le ampie strade. Rappresenta una delle zone in piena evoluzione della città, ricca di potenziale e spazi verdi.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona San Michele Extra e Castiglione a <0>Verona</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare casa dei tuoi sogni a prezzo garantito, con assicurazione inclusa e riparazioni gratuite per due anni dall’acquisto.","it/verona/borgo-venezia-santa-croce-porto-san-pancrazio":"Il quartiere di Borgo Venezia a Verona è forse uno dei più pittoreschi. Si trova nella zona orientale della città, ed è attraversata dal fiume Adige. La sua posizione strategica permette di raggiungere qualsiasi punto di Verona con molta facilità. La presenza della stazione ferroviaria di Verona Porta Vescovo ne fa un punto di passaggio importante per molti viaggiatori. Fra palazzi antichi, case di mattoni rossi e ampie piazze si possono trovare anche campi sportivi e strutture moderne. Rappresenta uno dei punti più importanti della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Borgo Venezia, Santa Croce e Porto San Pancrazio a <0>Verona</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/verona/santa-lucia-golosine-zona-fiera":"La zona di Santa Lucia a Verona è una delle più antiche della città, pur avendo cominciato la sua espansione soltanto nella seconda metà del Novecento. Fra edifici antichi e palazzi nuovi si trovano anche degli ampi viali alberati e diverse piste ciclabili, per raggiungere agilmente più punti del quartiere. Qui si trova anche il Parco Quadrante Europa, uno dei più grandi di tutta la città. Gli eventi culturali e le gallerie d’arte ne fanno un piccolo e importante centro per la vita culturale e giovanile della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Santa Lucia, Golosine e Zona Fiera, a <0>Verona</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/verona/borgo-milano-stadio-san-massimo-croce-bianca":"La zona di Borgo Milano a Verona si trova nella zona sudoccidentale della città. È una zona molto tranquilla, vicina al centro storico e ben collegata al resto della città grazie a diverse linee di autobus. La sua posizione strategica le permette di essere vicino ad alcune delle attrazioni principali del centro, pur mantenendo il silenzio e la calma di una zona meno turistica. Le ampie strade alberate e la pista ciclabile rappresentano uno dei lati più green della città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Borgo Milano, Stadio, San Massimo, Croce Bianca a <0>Verona</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita.","it/verona/centro":"Il centro di Verona è forse uno dei più amati di tutta Italia. Un quartiere pittoresco e scenografico, ricco di monumenti storici e una storia antichissima. Verona è considerata dai più come la “città più romantica del mondo” anche grazie alla presenza della casa di Romeo e Giulietta, che si trova proprio nel centro storico. Ogni vicolo di pietra, casa e scorcio sembrano raccontare una storia, mentre il lungofiume dell’Adige rappresenta una delle sue viste più caratteristiche. Il centro storico di Verona è un vero e proprio crocevia di culture e viaggiatori, e rappresenta uno dei quartieri più iconici di tutta la città.<1/><1/>Scopri tutti gli annunci Casavo su case in vendita in zona Centro a <0>Verona</0>. Collaboriamo solo con agenzie selezionate, realtà competenti e con un’ottima conoscenza del mercato. Potrai comprare la casa dei tuoi sogni a prezzo garantito. E se scegli un Immobile Casavo hai accesso a servizi unici, come il servizio mutui e l’opzione chiavi in mano, l’assicurazione e l’assistenza post vendita."}');

/***/ }),

/***/ 22822:
/***/ (function(module) {

"use strict";
module.exports = {};

/***/ }),

/***/ 24671:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"PropertyAdvantages_Bureaucracy_Title":"Bureaucracy assistance","PropertyAdvantages_Certification_Title":"Certificate of conformity","PropertyAdvantages_SelectedPartners_CardDescription":"We can also vouch for the <b>people you will deal with</b>. We choose our collaborators for their transparency, professionalism and knowledge of the area. <b>We have purchased houses from them as well</b> and everything went smoothly, so we know they are reliable.","PropertyAdvantages_CasavoGuarantee_BannerIntro":"This house is <b>Casavo Guaranteed</b>","PropertyAdvantages_CasavoGuarantee_BottomBanner_Description":"We are accompanying the owner of this house through the selling process. We are therefore able to guarantee the following: reliability, quality and dedicated services. They aren\'t our houses, but it\'s as if they were.","PropertyAdvantages_FairPrice_Title":"Controlled price","PropertyAdvantages_Fees_Title":"Commissions under 3%","PropertyAdvantages_CasavoGuarantee_BottomBanner_Title":"What difference does \\"Casavo Guaranteed\\" make?","PropertyAdvantages_CasavoGuarantee_From_Title":"What does <1>Casavo Guaranteed</1> mean?","PropertyAdvantages_Bureaucracy_CardDescription":"Don\'t worry about forgetting something. We buy houses as well, notarial deeds are our daily bread and butter. Which is why we are able to assist you through the dense bureaucratic jungle by <b>getting together all the documents</b> and offering constant support.","PropertyAdvantages_CasavoGuarantee_Banner_CTA":"Discover","PropertyAdvantages_FairPrice_CardDescription":"It means that <b>the price you see is in line with the market price</b>. We can do this thanks to our technology and by comparing with similar properties on the market, in order to analyze comparable prices very accurately.","PropertyAdvantages_SelectedPartners_Title":"Selected partners","PropertyAdvantages_Fees_CardDescription":"You know when you ask yourself: \\"I wonder how much commission I will have to pay?\\" We want to remove any doubts about this. We have very clear agreements with our trusted partners, which means <b>you will never pay more than 3% commission.</b>","PropertyAdvantages_Card_CTA":"Discover","PropertyAdvantages_CasavoProperty_BannerIntro":"This is a <b>Casavo Home</b>","PropertyAdvantages_TransparencyDocumenation_CardDescription":"We\'ve already taken care of <b>collecting the necessary documents</b> including the historic land registry, lien certificate and previous sale deed. They are all at your disposal. When it comes to houses, we don\'t like surprises either.","PropertyAdvantages_TransparencyDocumenation_Title":"Document transparency"}');

/***/ }),

/***/ 70311:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Login_Button":"Log in","Search_Button":"Search","Profile_Button":"Profile","Favorites_Button":"Favorites","Suggested_Auth_Button":"For you","Suggested_Unauth_Button":"For you"}');

/***/ }),

/***/ 44480:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"AffordabilityTool_firstHouseQuestion_title":"Will this be your first home*?","AffordabilityTool_ResultPage_InfoAlert":"Some banks may disregard income from temporary jobs","LandRegistryTax_Label":"Land registry expenses","AgencyFee_Label":"Agency fees","AffordabilityTool_ResultPage_Expenses_DropDown2_Label":"What are the costs of buying a house?","Deposit_Label":"Down payment","AffordabilityTool_ResultPage_Analysis_Box1_Description":"As a rule, banks require that your monthly mortgage payment be a maximum of 35% of your monthly income. This is calculated by taking into account <b>how much you have for a down payment</b> and the remaining monthly payment-to-income ratio. Keep in mind that there may be exceptions depending on several factors that the bank will assess for your specific case.","AffordabilityTool_ResultPage_NextStepBox_CTA":"Request info","RegistrationTax_Label":"Registration taxes","AffordabilityTool_ResultPage_Expenses_Disclaimer":"*Expenditures refer to the maximum cost of the house.","AffordabilityTool_ResultPage_Expenses_DropDown1_Label":"What are the mortgage fees?","AffordabilityTool_ageQuestion_title":"How old are you?","TransferTax_Label":"Mortgage costs","AffordabilityTool_ResultPage_Back":"Back to listing","AffordabilityTool_ResultPage_Analysis_Box2_Description":"In general, banks require a down payment of 20%. Depending on the bank and other variables, you <b>may be required to put down less than 20%</b>, or possibly nothing at all. Let\'s talk about it, we\'re flexible!","AffordabilityTool_ResultPage_Description_Positive":"The house you like is perfectly within your price range!<br/>\\n<b>Next step:</b> verify everything with a consultation 🚀","Application_Label":"Application processing","AffordabilityTool_ResultPage_FloatingBox_Title":"Your info","AffordabilityTool_ResultPage_DetailBox_MaxCost":"Maximum house cost","MandatoryInsurance_Label":"Mandatory home insurance","Interest_Label":"Interest","OwnerNumber_Label":"Number of co-applicants","AffordabilityTool_ResultPage_Expenses_DropDown_Title":"Other expenses","AffordabilityTool_ResultPage_Analysis_Title":"What is the estimate based on?","Notary_Label":"Notary","AffordabilityTool_ResultPage_NextStepBox_Description":"The Casavo Mortgages service is at your disposal to study your situation and, if you wish, present you with the house you like.","AffordabilityTool_ResultPage_Chart_SelectedProperty":"Listing selected","AffordabilityTool_ResultPage_Title":"Here is an initial estimate","MonthlyIncome_Label":"Monthly income","VAT_Label":"VAT","AffordabilityTool_ResultPage_Analysis_Box1_Title":"Estimated maximum monthly payment","AffordabilityTool_ResultPage_DetailBox_Title":"Details","Duration_Label":"Duration","Mortgage_Label":"Mortgage","Appraisal_Label":"House appraisal","OtherLoans_Label":"Ongoing loan payments","AffordabilityTool_ContactModal_Title":"Want to understand your financeability better?","AffordabilityTool_ContactModal_Description":"We are here to answer \\nall your questions.","AffordabilityTool_ResultPage_Analysis_Box2_Title":"Down payment: minimum 20% of the cost of the house","AffordabilityTool_ResultPage_NextStepBox_Title":"The next step? 🔮","AffordabilityTool_firstHouseQuestion_description":"*By \\"first home\\" we mean:\\n<ul><li>either the first house bought chronologically</li>\\n<li>or the second/third/... house bought but becoming your main residence</li></ul>","PurchaseType_label":"Type of purchase","AffordabilityTool_navigation_nextButton":"Next","SubsituteTax_Label":"Alternative tax","Age_Label":"Age","OthersFee_Label":"Stamps and miscellaneous fees","NotaryExpenses_Label":"Notary fees","AffordabilityTool_ResultPage_Description_Negative":"The cost of the house seems to be outside the parameters of financeability based on your data.<br/><b>Let\'s take a moment together</b>to better understand the situation.","AffordabilityTool_otherLoansQuestion_person2_title1":"Does the other co-applicant have ongoing loan payments?","AffordabilityTool_otherLoansQuestion_person1_description":"If in the next six months you have to make payments on your car, telephone, television...","AffordabilityTool_jobQuestion_person1_title2":"How much do you earn per month?","AffordabilityTool_jobQuestion_person1_answer_expanded_option2":"Temporary employee","AffordabilityTool_otherLoansQuestion_person1_title2":"In total, how much are your current loan payments per month?","AffordabilityTool_ownersQuestion_answer_no":"No, there are two of us","AffordabilityTool_jobQuestion_person1_description2":"Include your net salary or pension <b>divided into 12 months</b>. If you are self-employed, enter an estimate.","AffordabilityTool_jobQuestion_person2_description2":"Include their net salary or pension <b>divided into 12 months</b>. If they are self-employed, enter an estimate.","AffordabilityTool_ownersQuestion_answer_yes":"Yes","AffordabilityTool_otherLoansQuestion_person1_title1":"Do you have other ongoing loan payments?","AffordabilityTool_jobQuestion_person1_answer_expanded_option1":"Permanent employee","AffordabilityTool_jobQuestion_person1_answer_expanded_option3":"Self-employed with VAT number","AffordabilityTool_jobQuestion_person1_title1":"What is your work situation?","AffordabilityTool_jobQuestion_person2_title2":"How much does the other person earn per month?","AffordabilityTool_otherLoansQuestion_person2_title2":"In total, how much are your current loan payments per month?","AffordabilityTool_jobQuestion_person1_answer_expanded_option4":"Retired","AffordabilityTool_otherLoansQuestion_person2_answer1_yes":"No","AffordabilityTool_jobQuestion_person2_title1":"What is the employment situation of the other co-applicant?","AffordabilityTool_ownersQuestion_title":"Will the mortgage be in your name only?","AffordabilityTool_depositQuestion_title":"How much do you want to put as a down payment?","AffordabilityTool_jobQuestion_person1_answer_collapsed":"Select one...","Affordability_ListingDetailCTA":"Verify my financeability","PurchaseType_FirstHome_Label":"First home","PurchaseType_SecondHome_Label":"Second House","Fixed_at":"Fixed at","InputError_Loan":"The cost of financing may not exceed the monthly salary.","done":"Done!","AffordabilityTool_ResultPage_NextStepBoxSuccess_Description":"A Casavo Mortgages expert will contact you shortly to discuss your financeability and answer all your questions.","AffordabilityTool_ResultPage_Analysis_DownPaymentBox_WhyProblem":"<b>Your down payment is {{down_payment}}</b>, but you would need a down payment of <b>at least {{min_down_payment}}</b> to buy this house.","AffordabilityTool_ResultPage_Analysis_RateBox_WhyProblem":"<b>Your monthly payment can be maximum {{max_installment}}</b> (35% of your salary, with a 20% down payment). \\nInstead, for this house, <b>your payment would be at least {{min_installment}} </b>({{min_income_percentage}}% of your salary).","AffordabilityTool_ResultPage_Analysis_CTA":"Ask us for more details","AffordabilityTool_ResultPage_Expenses_DropDown_Subtitle":"Costs refer to the maximum loan amount obtainable","AffordabilityTool_ResultPage_Expenses_CTA":"Request free consultation"}');

/***/ }),

/***/ 30386:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"LoginPage_Description":"Search for a home, in a new way.","LoginPage_Title":"Welcome to Casavo!","UserProfile_Salute":"Hello","UserProfile_Description":"This is your space.\\n 🚧 We are still working on it 🚧 \\n\\nHere you can tell us about the house you have in mind and manage your search.","UserProfile_CTA":"Discover the houses","LoginPage_Button_google":"Continue with Google","UserProfile_LogoutButton":"Log out","Divider_Smalltext":"or","UserProfile_Dropdown_Favorites":"Your favorites","SignupWithMail_Input_Password_Placeholder":"Enter your password","Login_Success_CTA":"Okay!","LoginWithMail_CTA":"Log in","ToSignUp_Description":"First time here?","LoginWithMail_Input_Password_Placeholder":"Password","SignupWithMail_Input_RepeatPassword_Error_NotMatch":"Passwords don\'t match","SignupWithMail_Title":"Create a new account","SignupWithMail_CTA2":"Create account","SignupWithMail_Input_RepeatPassword_Placeholder":"Repeat it, to be sure","Login_Success_Title":"There you are again!","Login_Success_Description":"<b>Logged in</b>.<br/>It\'s always a pleasure for us to see you back here","LoginWithMail_Error_WrongData_Description":"Your email and/or password doesn\'t match. Try again.","SignupWithMail_CTA1":"Continue","ToLogin_Description":"Are you already a member?","SignupWithMail_Password_Title":"Choose a password","LoginWithMail_Error_WrongData_Title":"Did you enter the correct info?","SignupWithMail_Error_SimplePSW_Title":"Strengthen your password","Signup_Success_Description":"You\'ve joined our community! \\n\\nNow you can save your favorite homes, turn on notifications for searches that interest you, and more...\\n\\nSearch for a home, in a new way.","Input_Email_Placeholder":"Insert your email","Signup_Success_Title":"You\'re one of us","ToSignUp_CTA":"Create new account","LoginPage_WithMail_CTA":"Continue with your email","SignupWithMail_Error_SimplePSW_Description":"For your safety, it\'s best to choose a more complicated password.","SignupWithMail_Input_Password_Error_ShortPsw":"Minimum 8 characters","SignupWithMail_Alert_ExistingAccount_Title":"You already have an account","SignupWithMail_Alert_ExistingAccount_Description":"This email is already registered, maybe you wanted to log in?","SignupWithMail_Alert_ExistingAccount_CTA":"Log in","Login_Favorites_BottomSheet_Title":"Log in to add it to your favorites","Login_SaveSearch_BottomSheet_Title":"Log in to save\\n your search","LoginWithMail_Title":"Log in with your email","RecoverPassword_Code_Title":"Check your email","RecoverPassword_Code_CTA":"Continues","NewPassword_Success_Description":"Perfect! Your new password is safe, where were we?","RecoverPassword_Code_Sendto":"We have sent the security code to","RecoverPassword_Code_Description":"Enter the code you received here:","NewPassword_Title":"Choose a new password","NewPassword_Success_Title":"Password confirmed","RecoverPassword_CTA":"Receive the code","Login_ToRecoverPassword":"Forgot password?","NewPassword_CTA":"Confirm new password","RecoverPassword_Description":"We will send you a code to set up your new password. Enter the email you used to register:","RecoverPassword_Title":"Reset password","RecoverPassword_Error_InvalidCode_Description":"The code you entered is incorrect or has expired. Check or send another one","RecoverPassword_Error_InvalidCode_Title":"Invalid code","Login_ScheduleVisit_BottomSheet_Title":"Sign in to unlock instant booking","Login_Suggested_BottomSheet_Title":"That\'s it!\\nOnly your name is missing.","Social_Login_Error_Message":"There\'s been an error with your Google account. Please try again with your email.","Social_Login_Error_Cta":"Go back","Login_PriorityDetail_BottomSheet_Title":"Okay! What name shall we use for the list?","Login_RequestVisit_BottomSheet_Title":"We\'ll check the calendar: in the meantime, what name shall we put?","Login_TeasingInbox_Title":"Good to see you again! There is a new section just for you.","Login_FromContactFrom_Title":"With pleasure! What\'s your name?","Login_PriorityDetail_BottomSheet_UnlockTitle":"Discover houses not yet on the market.","BuyerContactFormModal_Title":"Only your name is missing."}');

/***/ }),

/***/ 84993:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"SearchStatus_Answer3":"I\'m about to make a purchase offer","HouseType_1room":"Studio apartment","HouseType_4orMore":"4 rooms or more","SearchStatus_Answer4":"I already made a purchase offer","SearchBar":"Search area ...","SearchStatus_Answer1":"I\'m looking around","ThankYou_Title":"And now it\'s up to us...","SearchStatus_Question":"What point are you at in your search?","Intro_Description":"You answer, and we find you a home. We can offer you tailor-made houses for you, even before they are put on the market.","NoResult_Title":"We\'ll find the right house together","Intro_Title":"Tell us about yourself, in 4 clicks.","MaxBudget_Input_Placeholder":"€","Form_Description":"Now we know exactly what you are looking for. Last thing: how can we contact you?","NoResult_Description":"Still no houses that match your criteria. Help us propose the perfect houses for you, before they even hit the market.","ThankYou_CTA":"Back to houses","NoResult_CTA":"Tell us what you are looking for","MaxBudget_Question":"What is your maximum budget?","Form_Mail_Placeholder":"Your email","Form_Name_Placeholder":"Your first and last name","ThankYou_Description":"We look forward to finding the perfect home for you. Talk to you soon!","FewResult_Title":"Would you like a sneak peek of new houses?","SearchStatus_Answer2":"I\'ve already visited some houses","HouseType_Question":"What type of house would you like?","Form_Title":"Answers saved","MaxBudget_Description":"Definitely not our favorite question, but a fundamental one","FewResult_Reset":"Change the filters","NoResult_Reset":"Reset the filters","Zone_Question":"In which areas of {{city}} do you want us to search?","HouseType_3rooms":"Three-room apartment","HouseType_4rooms":"Four-room apartment","HouseType_2rooms":"Two-room apartment","FewResult_Description":"We can propose houses selected just for you, before they even hit the market.","Zone_Noresult":"Can\'t find what you\'re looking for?<br/>\\nBrowse <0>the list of areas</0>"}');

/***/ }),

/***/ 22039:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"terrace":{"label":"Terrace","title":"Houses for sale with terrace in {{city}} | Casavo","description":"See all ads about apartments for sale in {{city}} with terrace. Casavo works only with selected agencies. Find your dream home now!"},"balcony":{"label":"Balcony","title":"Houses for sale with balcony in {{city}} | Casavo","description":"See all ads about apartments for sale in {{city}} with balcony. Casavo works only with selected agencies. Find your dream home now!"},"studios":{"label":"Studios","title":"Studio apartments for sale in {{city}} | Casavo","description":"See all ads on Studio apartments for sale in {{city}}. Casavo works only with selected agencies. Find your dream home now"},"one-bedroom-apartments":{"label":"One-bedroom apartments","title":"One-bedroom apartments for sale in {{city}} | Casavo","description":"Check out all the listings on one-bedroom apartments for sale in {{city}}. Casavo works only with selected agencies. Find your dream home now"},"two-bedroom-apartments":{"label":"Two-bedroom apartments","title":"Two-bedroom apartments for sale in {{city}} | Casavo","description":"Check out all the listings on two-bedroom apartments for sale in {{city}}.  Casavo works only with selected agencies. Find your dream home now"},"new-constructions":{"label":"New constructions","title":"Houses for sale of new construction in {{city}} | Casavo","description":"Browse all the listings for new construction houses for sale in {{city}}. Casavo only works with selected agencies. Find your dream home now!"}}');

/***/ }),

/***/ 16131:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"claim":"<0>This is a <1>Casavo Home</1></0>","claim_cta":"<0>This is a <2/><1>Casavo Home</1></0>","title":"Casavo Homes: we\'re the owners.","title_detail":"It\'s a Casavo Home","text":"<0>We know that finding the right house to purchase isn\'t always easy.</0><0>Casavo Homes are purchased and renovated by us, so you don’t have any unpleasant surprises.</0><0>The best of our best, at a price that’s never more than the average market price.</0><1>Look for the <2/>  on the listing!</1>","text_detail":"Everything necessary for you to enjoy your new home in complete tranquility…","discover_all_the_advantages":"Discover all the advantages","modal_subtitle":"<0>We want to free you from all your worries: Casavo Homes, usually renovated, are checked and cared for entirely by us.</0><1>The best of our best, with lots of exclusive services.</1>","list_item_discount_modal_description":"We can’t tell you absolutely everything here, we don’t want to take time away from your search... discover all the Casavo perks, our team is always available to you. ❤️","good_to_know":"Good to know!","what_does_it_mean":"What does it mean?","modal_list_items":[{"title":"Casavo properties come with a suite of premium services:","items":[{"title":"Insurance for 1 years","description":"If we renovated this house, you\'ll have 1 year of insurance coverage and free repairs included."},{"title":"After-sales support","description":"A dedicated customer support team will be at your service for every need even after the notary deed."},{"title":"Our team always by your side","description":"Real estate experts, financial consultants, interior designers and architects... Our team consists of all the necessary professionals to accompany you until after the purchase of your new home."}]},{"title":"...and more:","items":[{"title":"Mortgage service","description":"You select your preferred house, Casavo Mutui will take care of the mortgage. A dedicated consultant will take care of bureaucracy.","image":"loan"},{"title":"Furniture and interior design","description":"Do you like the house furnished like on virtual tour? You can request to buy the house exactly like that, fully furnished.","image":"furniture"},{"title":"Exclusive affiliations","description":"Electricity, gas, WiFi, alarm systems, electronics and much more.","image":"discount"}]}],"advantage_first":"Mortgage service","advantage_second":"After-sales support","advantage_third":"Our team always by your side"}');

/***/ }),

/***/ 83147:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"available":"available","available-singular":"available","title":"Houses For Sale In Italy | Casavo","title-listing":"Houses For Sale In {{city}} | Casavo","description":"Browse all the listings for houses for sale in the major Italian cities and find your dream home on Casavo.com!","description-listing":"Browse all the listings for houses for sale in {{city}} and find your dream home on Casavo.com!","loading":"Loading...","of":"of","of2":"of","entrance_floor":"Floor","entrance_floors":"Floors","basement":"Basement","raised":"Mezzanine","ground_floor":"Ground floor","last_floor":"Top floor","mid_floor":"Mid floors","select_city":"Select a city","rooms":"Rooms","bathrooms":"Bathrooms","bedrooms":"Bedrooms","status":"Status","habitable":"Habitable","new":"New","renovated":"Renovated","need_renovation":"Needs renovation","under_construction":"Under construction","private_negotiation":"Private negotiation","get-free-offer-label":"Sell","get-free-offer-small-label":"Sell","our-properties-label":"Buy","our-properties-small-label":"Buy","our-clients-label":"Our clients","are-you-broker-label":"Are you a broker?","footer-service-label":"Service","footer-resources-label":"Resources","footer-about-us-label":"About us","footer-our-properties-label":"Houses for sale","footer-press-label":"Press","footer-blog-label":"Blog","footer-faqs-label":"Frequently asked questions","footer-work-label":"Work with us","footer-work":"https://careers.casavo.com","footer-contact-label":"Contact us","footer-casavo-es-label":"Casavo España","footer-casavo-pt-label":"Casavo Portugal","footer-legal-label":"Legal Entities","footer-privacy-label":"Privacy Policy","footer-terms-label":"Terms and Conditions","footer-made-with":"Made with","footer-made-in":"in Italy","for-sale":"For sale","listing_not_found_title":"Listing not available","listing_not_found_similar_properties_subtitle":"The advert you are looking for has been removed or the house has already been sold.","listing_not_found_cta":"See listings","text-list":"List","text-map":"Map","open-map":"Open Map","no-listings-in-city":"Unfortunately, they are no available houses in this city yet :(","casavo-properties-title":"Casavo Home","cta_show_virtual_tour":"Virtual Tour","enter_virtual_tour":"View","message_virtual_tour":"3D Tour","view_property":"View details","page":"Page","photos":"Photos","pagination-bottom":"of {{length}} houses","of-pagination":"of","tooltip-text":"Casavo houses never have a higher price than the market average","houses-for-sale-in-area":"Houses <0>in {{area}} area</0>","house-for-sale-in-area":"House <0>in {{area}} area</0>","houses-for-sale-in-city":"Houses <0>in {{city}}</0>","house-for-sale-in-city":"House for sale <0>in {{city}}</0>","houses-for-sale-in-zone":"Houses <0>in {{zone}} zone</0>","house-for-sale-in-zone":"House <0>in {{zone}} zone</0>","house-for-sale-byZone-filter":"House <0>in {{area}}</0>","houses-for-sale-byZone-filter":"Houses <0>in {{area}}</0>","outdoor_space_label":"Outdoor space","new_listing_label":"New!","tooltips":{"casavo_property":"Casavo houses never have a higher price than the market average","outdoor_space":"What if you could take a breath of fresh air at any time 🤩? This house comes with a terrace or a garden.","energy_efficient":{"A_B":"Good for the planet 🌳. This house energy efficient rating is B or greater.","C":"Enjoy higher comfort thanks to greater efficiency! This house energy rating is B or better."}},"read_more":"more...","read_less":"read less","invalid-email-message":"Can you check that your email is written correctly?","required-field-message":"Required field","mortgage":{"title":"Mortgage Service","text":"Mortgage: just say the word.<0/>We\'ll be by your side<0/>from the search to the closing.","cta":"Tell me more about Casavo Mortgages","contact-us":"We\'re at your disposal<0/>Get in touch whenever you want"},"mortgage-modal":{"title":"We take care of the most tedious stuff.","content-top":"At Casavo there is a dedicated and specialized team at your disposal to handle the mortgage loan paperwork, working with your preferred bank. So you have more time to think about other things.","content-bottom":"More than 110 clients have already used our service, getting approved for their home mortgage 15 days faster. For free.","more":"Would you like to know more?","call":"Call us"},"form-error":"Something went wrong. Please try again.","where-looking-for":"Where are you looking for?","province":"Area","province-of":"{{area}} area","municipality":"Municipality","menu":{"sell":"Sell","buy":"Buy","our-clients":"Our clients","agency":"Are you an agency?","about":"About Casavo"},"listings":{"canonical-links-title":"Houses for characteristics {{city}}:","most-visited-zones-title":"Real estate listings in {{city}}:"},"prev":"Previous","next":"Next","footer-team-label":"Team","footer-partner-label":"Become a partner","footer-casavo-it-label":"Casavo Italy","invalid-phone-message":"Invalid phone number","casavo-inventory-agency-title":"Casavo Guaranteed","CTA_Next":"Next","GenericError_Modal_Description":"Unfortunately, something didn\'t go as planned, can you please try again?","GenericError_Modal_Title":"Oops...","simple_confirm":"Okay!","No":"No","Yes":"Yes","years":"years","Header_AddressFormat":"<0>{{streetName}}</0><1>N° {{streetNumber}}, {{city}}</1>","address_format":"{{streetName}} N° {{streetNumber}}, {{city}}"}');

/***/ }),

/***/ 81663:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"agency":{"message":{"cta":"Do you have any questions?","label":"Tell us more","placeholder":"Do you have any questions?\\nWhen would you like to be contacted again?"},"success":{"message":"And the first step is done... \\nOur partner will contact you very soon","cta":"View similar houses"}},"casavo":{"assistant":"Your Casavo assistant","name":"Name","reason":{"placeholder":"We\'re happy you like this house! How can we help you?","warning":"Knowing it allows us to help you more quickly","options":{"morePhotos":"I\'d like to receive more photos and materials","moreAboutHouse":"I\'d like more information about this house","other":"Other..."}},"title":"<0>Your <1>Casavo</1> experience starts here.</0> ","success":{"title":"The first step is done!","subtitle":"...from now on, you can count on us.<0/> We\'ll contact you as soon as possible.","postScriptum":"P.S. Your request has safely\\narrived and will be given top priority.","cta":"View similar houses"}},"phone":"Your phone number","submit":"Send","email":{"label":"Your e-mail","success":"Thank you, request received! Check your email for the next steps"},"success":{"toFlow":{"title":"Are you thinking of selling your house?","subtitle":" ","cta":"Get the best valuation"}},"ContactForm_SuccessSaveSearch_CTA_Primary":"Receive alerts","ContactForm_SuccessSaveSearch_CTA_Secondary":"No thanks","ContactForm_SuccessSaveSearch_Subtitle":"We will conveniently send them to your email","ContactForm_SuccessSaveSearch_Title":"Do you want to receive listings similar to this one?","ContactForm_SuccessSaveSearch_OkFeedback":"Alerts activated","name":"Name","lastname":"Last name"}');

/***/ }),

/***/ 79952:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Favourites_FavouriteList_AutodeleteMessage":"If a house is no longer on the market, it will be automatically removed from your favorites within 20 days.","Favourites_FavouriteList_FavouriteCard_Unavailable":"No longer available","Favourites_FavouriteList_DeleteConfirm_title":"Want to remove this from favorites?","Favourites_FavouriteList_DeleteConfirm_cancelCTA":"Cancel","Favourites_FavouritesList_Title":"Your favorites","Favourites_FavouriteList_EmptyState":"As soon as you find a house you like, tap on <icon/> to save it here in your favorites.","Favourites_FavouriteList_ConfirmToast_title":"Listing removed from favorites","Favourites_FavouriteList_DeleteConfirm_mainCTA":"Remove","Favourites_FavouriteList_ConfirmToast_body":"Don\'t worry, you\'ll find other houses that make your heart skip a beat.","Favourites_FavouriteList_EmptyStateMain":"Love at first sight?","Favourites_FavouritesList_SubTitle1":{"one":"{{count}} listing that made your eyes light up","other":"{{count}} listings that made your eyes light up"},"Desktop_Saved":"Saved","Desktop_Save":"Save","FavouritesList_Desktop_BackToSearch":"Back to search","FavouriteList_EmptyState_Unauth_CTA":"Log in","FavouriteList_EmptyState_Unauth_Title":"Love at first sight?","FavouriteList_EmptyState_Unauth_Description":"Login to save the houses you like in your favorites, so you don\'t lose sight of them.","Favourites_Add_To_Favorite_CTA":"Add to favorites"}');

/***/ }),

/***/ 48918:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"change-filters":"Change Filters","price":"Price","surface":"Surface","room":"Room","rooms":"Rooms","status":"Status","other_filters":"Other filters","properties":"Houses","property":"house","properties_for_you":"Available houses","property_for_you":"Available house","no_properties":"No houses available","last_uploaded":"Most recent","most_relevant":"Most relevant","cheapest":"Lowest price","most_expensive":"Highest price","area_max":"Bigger surface","area_min":"Smaller surface","no_properties_for_filters_title":"At the moment, there are no houses with these characteristics.","no_properties_for_filters_subtitle":"Try changing the filters to see more results","save":"Save","from":"From","to":"To","max":"Max","min":"Min","filters":"Filters","trendy_filters":"Trendy filters","filter_by":"Filter by","reset":"Reset","undo":"Delete","apply":"Apply","only_casavo":"Display only Casavo Homes","price_guaranted":"Guaranteed price","renovated_properties":"Renovated houses","assistance_guaranted":"Guaranteed assistance","typology":"Property type","bathroom":"Bathroom","bathrooms":"Bathrooms","bedroom":"Bedroom","bedrooms":"Bedrooms","entrance_floor":"Floor","state_of_manteinance":"House status","state_at_deed":"Property status","services":"Amenities","heating_system":"Heating","year_of_construction":"Year of construction","anyone_choice":"Any","apartment":"Apartment","house":"Independent house","townhouse":"Townhouse","villa":"Villa","loft":"Loft","attic":"Attic","mansard":"Mansard","basement":"Basement","raised":"Mezzanine","ground_floor":"Ground floor","last_floor":"Top floor","mid_floor":"Mid floors","habitable_status":"Habitable","new_status":"New","renovated_status":"Renovated","need_renovation_status":"Needs renovation","under_construction_status":"Under construction","OCCUPIED":"Occupied","FREE":"Free","RENTED":"Rented","BARE_OWNERSHIP":"Bare ownership","elevator":"Elevator","parkingSpaces":"Parking","box":"Box","garage":"Box","cellar":"Cellar","garden":"Garden","balcony":"Balcony","balconies":"Balconies","terrace":"Terrace","terraces":"Terraces","pool":"Pool","coolingSystem":"AC","conciergeService":"Concierge","AUTONOMOUS":"Autonomous","SHARED":"Centralized","NONE":"None","at_least":"At least","single_filter":"filter","single_filters":"filters","milan":"Milan","turin":"Turin","bologna":"Bologna","verona":"Verona","rome":"Rome","florence":"Florence","only_casavo_filter_label":"Display only Casavo Homes","ranking":"Automatic","trendy_filters_description":"When used, these filters help us to propose houses that best align with your desires","other_filters_description":"Everything you need to search for the house you are picturing","filters_zone_suggestion_title":"Where are you looking for?","filters_zone_suggestion_description":"Save time <0>by selecting specific zones.</0>"}');

/***/ }),

/***/ 3761:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Furniture_DetailPage_FurnitureBanner_Title":"Yes, you can have it already furnished","Furniture_DetailPage_FurnitureBanner_CTA":"What does it include?","Furniture_DetailPage_FurnitureBanner_Body":"We created a <b>custom interior design</b> project for this house.","Furnitures_Detailpage_FurniturePriceTag":"Furniture available","Furniture_PhotoCarousel_Toast_CTA":"Look at the project","Furniture_PhotoCarousel_Toast_Body":"Here is the customized interior design project we created for this house","Furniture_PhotoCarousel_Toast_Title":"Do you like it furnished like this?","Furniture_Modal_Title":"Our customized project for you","Furniture_Modal_FormTitle":"👇 Get the interior design project now","Furniture_Modal_Bullet_2":"<b>Choose how you want to customize</b> down to the last detail.","Furniture_Modal_MktgConsent_Description":"Give us permission to keep you updated with news about furnishings and services","Furniture_Modal_Bullet_3":"<b>The best brands</b>, for you:","Furniture_Modal_CTA":"Get the project","Furniture_Modal_Bullet_1":"<b>Kitchen, bathrooms and closets</b> for your new house","Furniture_ServiceName":"Interior","Brand_CasavoServices":"Casavo Services"}');

/***/ }),

/***/ 51012:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Items0_Title":"To sell, easily","Items0_Description":"Relax. We will purchase your house or find you a buyer.","Items1_Title":"For Casavo Mortgages","Items1_Description":"Say bye-bye to bureaucracy, we\'ll find the best mortgage for you.","Items2_Title":"For the people who talk about us","Items2_Description":"What do people who\'ve chosen us have to say? Discover the stories of past clients.","Footer_Title":"More questions?","Footer_Description":"We always have answers to all your questions. And if you don\'t find what you\'re looking for, contact us! We are here to help.","Title":"Why Casavo"}');

/***/ }),

/***/ 73083:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"find-your-house":"Discover the houses <0/>for sale for you in..."}');

/***/ }),

/***/ 37371:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title_not_found":"Listing not found","characteristics":"Characteristics","description":"Description","the_district":"The district","at_your_service":"At Your Service","at_your_service_message":"We\'ll contact you whenever you like.","show_number":"Show number","show_number_casavo":"Call us","request_info":"Request info","request_visit":"Book a house tour","request_visit_modal_title":"Request a tour","request_visit_modal_thank_you_title":"Wait for our confirmation","contact_us":"Contact us","contact_email":"Your e-mail","contact_phone_number":"Your phone number","fomo_message_person":"<0>{{userViews}} person</0> viewed this listing in the last hour","fomo_message_people":"<0>{{userViews}} people</0> viewed this listing in the last hour","phone_call":"Call","phone_call_now":"Call now","rooms":"Rooms","bathrooms":"Bathrooms","bedrooms":"Bedrooms","balconies":"Balconies","terraces":"Terraces","balcony":"Balcony","terrace":"Terrace","status":"Status","planimetry":"Floor plan","services":"Amenities","see_all_characteristics":"See all","see_less_characteristics":"See less","elevator":"Elevator","parkingSpaces":"Parking","box":"Box","basement":"Cellar","garden":"Garden","coolingSystem":"AC","coolingSystem_full":"Cooling system","coolingSystem_AUTONOMOUS":"Autonomous","coolingSystem_SHARED":"Centralized","coolingSystem_READY_FOR_INSTALLATION":"Ready for Installation","coolingSystem_NONE":"None","conciergeService":"Concierge","recreationRoom":"Tavern","garret":"Garret","pool":"Pool","sharedPool":"Shared pool","tennisCourt":"Tennis court","fireplace":"Fireplace","disabledAccess":"Accesible entrance","wallCabinet":"Wall cabinet","fastInternet":"Fast internet","hydromassage":"Hydromassage","tvSystem":"Tv system","electricGate":"Electric gate","armoredDoor":"Armored door","alarmSystem":"Alarm system","entranceVideoPhone":"Video entryphone","year_of_construction":"Year of construction","year_of_renovation":"Year of renovation","exposure":"Exposure","NORTH":"North","SOUTH":"South","EAST":"East","WEST":"West","furniture":"Furniture","FULLY_FURNISHED":"Full furniture","NOT_FURNISHED":"Unfurnished","PARTIALLY_FURNISHED":"Partial furniture","estate_registry_class":"Cadastral code","energy_rating_label":"Energy efficiency rating","energy_performance_index_label":"Energy Performance Index (EPgl o IPE)","energy_performance_index_udm":"kWh/m² year","energy_rating":{"energy_a4":"A4","energy_a3":"A3","energy_a2":"A2","energy_a1":"A1","energy_aplus":"A+","energy_a":"A","energy_b":"B","energy_c":"C","energy_d":"D","energy_e":"E","energy_f":"F","energy_g":"G","energy_pending_request":"In Progress"},"kitchen":"Kitchen","kitchen_HABITABLE":"Kitchen","kitchen_HALF_HABITABLE":"Livable kitchen","kitchen_KITCHENETTE":"Kitchenette","kitchen_OPEN":"Open kitchen","glazing":"Glazing","glazing_SINGLE":"Single glazing","glazing_DOUBLE":"Double glazing","glazing_TRIPLE":"Triple glazing","info":"Info","condo_fees":"Condo expenses","per_year_label":"per year","state_at_deed":"Property status","OCCUPIED":"Occupied","FREE":"Free","RENTED":"Rented","BARE_OWNERSHIP":"Bare ownership","heating_system":"Heating","AUTONOMOUS":"Autonomous","SHARED":"Centralized","NONE":"None","exclusive_mandate":"Exclusive mandate","cta_show_photos":"Show {{photoLength}} photos","cta_show_virtual_tour":"Virtual Tour","cta_show_virtual_tour_mobile":"Tour","apartment":"Apartment","house":"Independent house","townhouse":"Townhouse","villa":"Villa","loft":"Loft","attic":"Attic","mansard":"Mansard","sharing":"Share","might_interest_you":"Similar houses","based_on_your_searches":"You might like these houses:","poi_nearby":"In the surroundings you will find:","poi_discover":"Discover:","TRANSPORT":{"poi_category":"Transports","poi_nearby_card_title":"Public transportation","poi_nearby_card_distance":"The nearest stop <1/>is <0>{{distance}}m away</0>","BUS_STOP_distance":"Bus stop {{distance}}m away","TRAIN_STATION_distance":"Railway station {{distance}}m away","SUBWAY_STATION_distance":"Subway station {{distance}}m away","TRAM_STOP_distance":"Tram stop {{distance}}m away","poi_nearby_card_all":"Go to public transportation","BUS_STOP_label":"Bus","TRAIN_STATION_label":"Train","SUBWAY_STATION_label":"Subway","TRAM_STOP_label":"Cable car"},"SCHOOL":{"poi_nearby_card_title":"Schools","poi_nearby_card_distance":"The nearest school <1/>is <0>{{distance}}m away</0>","SCHOOL_distance":"School {{distance}}m away","poi_category":"Schools","poi_nearby_card_all":"Go to schools","SCHOOL_label":"School"},"SHOP":{"poi_nearby_card_title":"Supermarkets","poi_nearby_card_distance":"The nearest supermarket <1/>is <0>{{distance}} m away</0> ","SHOP_distance":"Market {{distance}}m away","poi_nearby_card_all":"Go to supermarkets","poi_category":"Groceries","SHOP_label":"Market"},"properties":"Houses","neighborhood":"nearby...","more_about_neighborhood":"Find out more about the zone","less_about_neighborhood":"Show less","last_update":"Listing updated on:","street-view":{"address-disclaimer":"Approximate Location","description":"Street View","cta":"Street View"},"at_your_service_agency":"<0>Our partner</0> at your disposal","at_your_service_casavo":"What does <1>Casavo Home</1> mean?","form-header":{"title":"Do you like it?","subtitle_casavo":"Don\'t let it get away, we\'ll call you","subtitle_agency":"Don\'t miss out on this opportunity, our partner will answer all your questions","agency":{"one":"Agency verified by Casavo","two":"Only verified listings"},"casavo":{"one":"We checked and certified this house","two":"Access insurance and dedicated support","three":"Learn about the Mortgage service","four":"All the Casavo services for the best home living experience"},"subtitle_casavo_inventory_agency":"We\'re here to answer all your questions.","casavo-agency":{"one":"Fees under 3%","two":"Controlled price","three":"Certificate of conformity","four":"Selected partners","five":"Bureaucratic assistance"}},"we_will_contact_you":"We’ll get in touch soon.","form-body":{"success_button":"See similar houses","success_button_alt":"Keep looking"},"request_visit_error":"Submission failed<0/>Please try again.","request_visit_email_error":"Sending failed.<0/> Check that the email entered is correct","select_visit_date":"Select a date","select_visit_time":"What time?","insert_confirmation_info":"Where can we reach you?","visit_time_disclaimer":"The visit is still not confirmed","you_will_receive_confirmation":"You will receive confirmation","you_will_receive_confirmation_detail":"A Casavo expert will confirm the availability in the indicated range. Together you will agree on the best solution for you and you will receive a confirmation","book_visit_hour_recap":"From {{startHour}} to {{endHour}}","title_0_1":"for sale in","request_visit_modal_thankyou_item_2":"If we aren\'t able to accept your visit request, together we\'ll find another available date.","request_visit_modal_thankyou_item_1":"We will contact you as soon as possible to confirm","title_0":"for sale in","title_2":"of","title_1":"in","request_call_modal_title":"Book a call with a <0>Casavo advisor</0>","request_call_modal_thank_you_title":"Call has been booked","request_call":"Book a time for us to call","request_call_cta":"Talk with us","request_timeslot_caption":"During the call you\'ll arrange a date and time to visit this house","request_feedback_call_bullet_2":"If you want, <0>we\'ll book you an appointment</0> to visit this house","request_feedback_call_bullet_1":"We\'ll call you on the day and time chosen and respond to all your questions","select_call_date":"What day do you prefer?","select_call_time":"What time?","request_call_modal_thank_you_title_2":"Now it\'s our turn","request_visit_modal_thank_you_title_2":"Now it\'s our turn","view":"View","view_interior":"Interior","view_exterior":"Exterior","schedule_visit_cta":"Schedule your house tour","schedule_visit_modal_title":"Schedule a visit of this <0>Casavo Home</0>","select_schedule_visit_time":"Select a time","schedule_visit_confirm_cta":"Confirm the visit","schedule_visit_no_availabilities":"No time slots available for this date","schedule_visit_recap_no_availabilities":"Find an available date","schedule_visit_modal_thank_you_title":"Visit confirmed!","schedule_visit_modal_thank_you_title_2":"Next steps:","schedule_visit_modal_thankyou_item_1":"You\'ll receive:\\n- a summary email immediately\\n- a reminder text message 24 hours prior","schedule_visit_modal_thankyou_item_2":"A Casavo consultant will show you the house","slot_already_booked_error":"This time is no longer available","schedule_visit_cta_mobile":"Schedule a house tour","request_visit_CTA_mobile":"Book a house tour","schedule_visit_available":"Instant booking is available for this house","select_request_visit_date":"What day do you prefer?","schedule_visit_no_availabilities_title":"No appointments available","schedule_visit_no_availabilities_description":"Unfortunately, at the moment, all available appointments have already been booked","ScheduleVisit_NoSlotModal_CTA_body":"Do you want to <0>save this house in your favorites</0> to keep an eye on the updates?","ScheduleVisit_SelectDate_MoreThan1":"What day do you prefer?","ScheduleVisit_SelectDate_Just1":"Only one day is still available","schedule_visit_reminder":"We will see you {{day_of_the_week}} {{date_number}} {{month}} at {{time}}","schedule_visit_slot_recap":"{{day_of_the_week}}, {{month}} {{date_number}}, {{time}} is fine with us, confirm?","schedule_visit_instant_warn":"This is a <0>real-time reservation</0>: if you confirm you will not have to wait for our response.","schedule_visit_flow_next_button":"Continue","RequestVisit_Modal_Warn":"Wait for our confirmation for the date requested","RequestVisit_Modal_Recap":"{{day_of_the_week}} {{date_number}} {{month}}, at {{time}}. We will confirm by phone, what number can we contact you at?","BookCall_Modal_Recap":"{{day_of_the_week}} {{date_number}} {{month}}, at {{time}}. How can we contact you?","BookCall_Modal_Warn":"We\'ll do our best to contact you when you want","RequestCallModal_Reasonlist_MorePhoto":"I\'d like more photos","RequestCallModal_Reasonlist_Questions":"I have questions","RequestCallModal_Reasonlist_Visit":"I\'d like to visit the house","request_call_mobile":"Call me","RequestCall_ThankYou_Bullet1":"We\'ll call you so we can answer all your questions","unknown":"-","RelatedAdsBanner_Title":{"one":"1 similar house nearby","other":"{{n}} similar houses nearby"},"RelatedAdsBanner_Description":"Find homes <b>only on Casavo</b>.","RelatedAdsBanner_CTA":"View","NearPropertiesBanner_FirstStep_Description":"📍 Find houses <b>near here</b>","NearPropertiesBanner_PropertiesProgress":"{{n}}/{{tot}} in the area","NearPropertiesBanner_FirstStep_CTA":{"one":"View 1 house","other":"View {{n}} houses"},"HomePlusBanner_Title":"Discover Casavo Homeplus","HomePlusBanner_CTA":"View the offers","HomePlusBanner_Description":"We\'ve selected some of the best brands to bring you <b>exclusive offers,</b> so you can enjoy your new home to the fullest."}');

/***/ }),

/***/ 58985:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"SearchSettings_Zone_Title":"Areas","SearchSettings_Modal_ApplyChangesCTA":"Apply","SearchSettings_Price_Title":"Budget","SearchSettings_Rooms_Title":"Space","SearchSettings_City_Title":"City","SearchSettings_CTA":"Update preferences","SearchSettings_Back":"Exit","SearchSettings_ChangeCityCTA":"Change city","SearchSettings_Subtitle":"It is the basic information that allows us to understand what to propose to you","SearchSettings_Title":"Your preferences","SearchSettings_Price_Intro":"Up to:","SearchSettings_Rooms_Intro":"At least one:","SearchSetting_MobileNavBar_Title":"Preferences","SearchSettings_SuccessBanner_Title":"Preferences updated","MainSearch_SEO_Title":"For you - We seek, you find"}');

/***/ }),

/***/ 486:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Login_Button":"Log in","Search_Button":"Search","Profile_Button":"Profile","Favorites_Button":"Favorites"}');

/***/ }),

/***/ 18852:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Priority_ThankyouPage_CTA":"See houses already for sale","Priority_ThankyouPage_Description":"As soon as this house is on the market, you will be one of the first to be able to visit it.","Priority_ThankyouPage_Title":"All done!","Priority_Unsubscribe_Title":"All quiet here...","Priority_Unsubscribe_Subtitle2":"Notifications Off","Priority_Unsubscribe_CTA":"See houses for sale","Priority_Unsubscribe_Subtitle1":"You will no longer receive these emails","Priority_ThankyouPage_PageTitle":"Visit requested","Priority_DetailPage_FloatingBanner_Bullet3":"Buy at the right price","Priority_DetailPage_AdvantagesCard_Advance_Description":"See listings for houses for sale before anyone else.","Priority_DetailPage_AdvantagesCard_Advance_Title":"First come, first served","Priority_DetailPage_AdvantagesCard_Support_Description":"We assist sellers and buyers to ensure maximum transparency and reliability.","Priority_DetailPage_AdvantagesCard_Waitlist_Title":"Preview visit","Priority_DetailPage_FloatingBanner_Bullet1":"We\'ll call you as soon as it\'s available","Priority_DetailPage_AdvantagesCard_RightPrice_Description":"You’ll have less competition and can speak with the seller before anyone else to arrive at a fair price for both parties.","Priority_DetailPage_AdvantagesBox_Description":"Find house listings before they’re published, based on your preferences.","Priority_DetailPage_FloatingBanner_CTA":"Receive updates","Priority_DetailPage_FloatingBanner_Title":"New house on the way","Priority_DetailPage_PreviewDescription":"This is a <b>preview</b> house","Priority_DetailPage_Banner_Description":"You are seeing a <b>preview </b>house.","Priority_DetailPage_AdvantagesCard_RightPrice_Title":"Purchase at the right price","Priority_DetailPage_AdvantagesCard_Support_Title":"Receive assistance","Priority_DetailPage_FloatingBanner_Bullet2":"Visit it before other people","Priority_DetailPage_Banner_CTA":"What does it mean?","Priority_DetailPage_AdvantagesCard_Waitlist_Description":"If you like the house, you can see it live before it goes on the market.","Priority_DetailPage_AdvantagesBox_Title":"How does it work?","Priority_DetailPage_AdvantagesBox_Preview_Description":"This house is <b>coming soon</b>","Priority_DetailPage_SimilarProperties_Title":"Similar houses","Priority_DetailPage_SimilarProperties_Description":"You might like these houses:","PriorityDetail_FloatingBanner_Booked_Description":"Everything under control: \\nWe will let you know when you can visit.","PriorityDetail_FloatingBanner_Booked_CTA":"You are already on the list","Priority404_H1":"Listing not available","Priority404_CTA":"Continue searching","Priority404_Descritpion":"Unfortunately, this house is no longer for sale. We\'re sorry. \\n\\nWe\'ll do our best to find other houses on preview for you.","Priority_ThankyouPage_Description_Outro":"Pretty nice, huh?","Priority_PhoneNumberModal_Banner_Description":"You\'ll be among the first to visit it","Priority_PhoneNumberModal_Title":"We will call you as soon as we have news 📞","Priority_ThankyouPage_Bullet1":"When the house comes on the market, <b>you have priority</b> to visit it","Priority_ThankyouPage_Description_Intro":"What now?","Priority_ThankyouPage_Bullet2":"<b>Wait for a call</b> from us to arrange the visit","PriorityCard_PreviewTag":"⏰ HOUSE COMING SOON","PriorityCard_NotLoggedBanner_Description":"Skip the line, free of charge.","PriorityDetail_TeasingBanner_NotLogged_CTA":"What does it mean?","PriorityDetail_NotLogged_Intro_CTA":"Unlock photos","PriorityDetail_TeasingBanner_NotLogged_Description":"<b>Preview houses</b> are just for <b>Casavo users</b>","PriorityCard_NotLoggedBanner_CTA":"Unlock","PriorityDeatil_NotLogged_Intro_Description":"Already have an account?","Priority_DetailPage_AdvantagesBox_CTA":"Unlock","OnMarketTab":"on the market","PriorityTab":"preview","PriorityTab_NoResult_Description_logged":"As soon as they\'re available, you\'ll find them here.","PriorityTab_Title_notlogged":"Visit houses not yet on the market","PriorityTab_NoResult_CTA_logged":"Enjoy homes for sale","PriorityTab_Title_logged":"Incoming houses: shall we save you a spot?","PriorityTab_NoResult_Description_notlogged":"Register and arrive before other people","PriorityTab_NoResult_CTA_notlogged":"Sign in","PriorityCard_CTA":"Unlock","PriorityDetail-FloatingBanner-DislikeCTA":"I don\'t like it","Priority_DetailPage_FloatingBanner_CTAmobile":"Receive updates","PriorityDetail-FloatingBanner-FeedbackDescription":"Your feedback helps us suggest other houses for you","PriceAnalysis_HighPrice_Modal_Body":"At the moment, <b>this house is slightly more expensive</b> than other similar ones in the area.\\n<br/><br/>\\nFor houses like this one, consider that usually<b> the provisional price drops by up to {{Discount}}% for the final listing price</b>. For example, it could go from {{AskingPrice}} to {{SuggestedPrice}}.\\n<br/><br/>\\nIf you like the house, the<b> sooner you see it, the easier it is to lower the price</b>.","PriceAnalysis_GoodPrice_Description":"The provisional price is in line with similar houses in the area. <u>How do we know?</u>","PriceAnalysis_HighPrice_Modal_Title":"High provisional price","PriceAnalysis_GoodPrice_Tag":"Good price","PriceAnalysis_GoodPrice_Modal_Body":"Preview houses are provisionally priced because they are not yet on the market.\\n<br/><br/>\\n<b>The price of this house is in line with similar houses in the area.\\n</b><br/><br/>\\nIf you like the house, tell us if you want to preview it.<b> The sooner you see it, the less competition you have to buy it.</b>","PriceAnalysis_HighPrice_Tag":"High price","PriceAnalysis_HighPrice_Description":"The provisional price is higher than similar houses in the area. <u>Why will the price drop?</u>","PriceAnalysis_GoodPrice_Modal_Title":"Good provisional price","PriorityInfoBanner_Title":"{{count}} preview houses","PriorityInfoBanner_Description":"We tell you which houses are about to come on the market, and reserve a spot for you to view them in person. <b>Free of charge</b>.","PriorityInfoBanner_CTA":"Unlock","PriorityCarousel_CTA":"View all","PriorityCarousel_Description":"Preview houses not yet on the market","PriorityCarousel_Title":"{{n}} preview houses","PriorityCarousel_LastCard_CTA":"View all +","PriorityDetailPage_Title":"Preview"}');

/***/ }),

/***/ 42542:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"disclaimer":"By clicking on \\"{{cta}}\\" I declare to have read the <0>Terms and Conditions</0> and <1>Privacy Policy</1>","gdpr":{"title":"Anything else we can do for you?","marketing-consent-checkbox":"<0>Let me know about new offers</0>","marketing-consent-details":"Authorize us to <0>update</0> you with our latest news about a new way of selling and buying a home.","marketing-consent-full-text":"I authorize Casavo to process my data for communications regarding commercial initiatives and offers."},"mortgage":{"title":"I need a home loan","short-text":"I authorize Casavo to send me info about the Casavo Mortgages service.","full-text":"I authorize Casavo to process and share my data with Casavo Group, operating in the financial/mortgages sector, to send me updates regarding activities and offers, to conduct market research and other activities with the purpose of evaluating the quality of services via telephone, e-mail and text messages."},"recaptcha":{"disclaimer":"This site is protected by reCaptcha and the Google <0>Privacy Policy</0> and <1>Terms of Service</1> apply"},"disclaimer-mortgage":"By clicking on \\"{{cta}}\\" I authorize Casavo to send me info about the Casavo Mortgages service."}');

/***/ }),

/***/ 22675:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"area":"Area","city":"City","price":"Price range","email_label":"Your email address","features_title":"other filters:","cta":"Save search","cta_saved":"Search Saved","no_spam":"No spam! No more than 1 email <0>every 3 days</0>","turn_off_notifications":"Turn off notifications <0>whenever you want</0>","title":"Stay Updated","your_research":"Your research","subtitle":"Get notified when new listings fit your search!","only_casavo":"Only Casavo Homes","saveSearch-floatingBanner-text":"Would you like to receive <b>new listings</b> for this search?","saveSearch-floatingBanner-text1result":"There\'s only one match, would you like to receive new listings in the future?","saveSearch-floatingBanner-textNewFilters":"You just set up filters, would you like to receive updates?","saveSearch-floatingBannerFeedback-subtitle":"You\'ll receive new listings via email!","saveSearch-floatingBannerFeedback-title":"Search Saved","Modal_Title":"Receive the new listings\\nthat interest you","Modal_Zone_intro":"We\'ll notify you for listings in:","Modal_NoFilterBanner_Title":"Do you want to narrow down your search?","Modal_NoFilterBanner_CTA":"Add filters","Modal_CTA":"Save search","Modal_NoFilterBanner_Description":"You can add filters for more accurate results","Modal_Form_Title":"Where do you prefer to receive them?","Modal_Form_NotificationsMessage":"You can turn off notifications whenever you want","SearchSearch_Modal_Success_Title":"Alerts enabled","SearchSearch_Modal_Success_Subtitle":"We\'ll send an email when we find similar listings.","SearchSearch_Modal_Success_CTA":"Keep searching","Modal_Success_Body1":"You will receive new listings for your search on","Login_BottomSheet_Subtitle":"We will send new listings directly to your email, sound good?","Modal_Success_CTA":"Excellent!","Modal_AuthUser_Text":"You will receive them via","Modal_Success_Body2":"...you can unsubscribe whenever you want.","Login_BottomSheet_Title":"Where do you prefer to receive them?","Modal_Success_Title":"Search saved","Login_BottomSheet_CTA":"Send","Modal_AuthUser_Link":"Profile","LoaderModal_Description":"Just a second...","Error_InvalidMail_Description":"It seems that the email you have chosen is not valid. Try registering with another email","Error_InvalidMail_Title":"Invalid email"}');

/***/ }),

/***/ 94321:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"BudgetQuestion_Submit":"Done!","Suggested_Today_Description":"Let us know if you like them, we\'re all ears.","City_Question":"What city are you looking for?","Suggested_Loader_1":"Browsing the ads...","Suggested_Welcome_Description":"Here is your daily tailored selection of our listings.","Suggested_Welcome_Title":"Hello!","MainSearch_Intro_Description":"4 questions to find the perfect home. With us, you can also find homes not yet on the market.","MainSearch_Intro_Title":"Tell us about yourself, let us find you.","Suggested_Today_Title":"Already on the market","Suggested_NoResults_Title":"Together we will find the right home","Suggested_NoResults_CTA":"See all ads","Suggested_NoResults_Description":"There are currently no homes that match your search. \\n\\nBut don\'t worry: we\'re looking for ads that are perfect for you. You\'ll see them here as they become available.","Suggested_Flow_TypeQuestion":"Would you like at least one:","Suggested_Flow_HouseType_1room":{"one":"Studio apartment","other":"Studio apartments"},"Suggested_Flow_HouseType_3room":{"one":"Three-room apartment","other":"Three-rooms apartments"},"Suggested_Flow_HouseType_2room":{"one":"Two-room apartment","other":"Two-room apartments"},"Suggested_Flow_HouseType_4room":{"one":"Four-room apartment","other":"Four-room apartments"},"Suggested_Flow_HouseType_5orMore":{"one":"Apartment with five rooms or more","other":"Apartments with five rooms or more"},"Suggested_Error_CTA":"Reload","Suggested_Error_Body":"Unfortunately something didn\'t go as we thought, can you try again please?","Suggested_Page_Title":"Homes for you","Suggested_SuccessToast_Title":"Here is the new section you have just unlocked. We hope you like it!","Suggested_Priority_HelpModal_Title":"What is a preview house?","Suggested_Priority_HelpModal_Description":"We show you houses that are about to come on the market. If you find one you like, you can book a visit ahead of time.\\n\\nWe\'ll let you know as soon as new preview houses are available. Promise!","PriorityCard_Banner":"Preview","Suggested_Priority_Title":"Preview","Suggested_Priority_HelpText":"How does it work?","Suggested_Priority_NoResult_Banner":"There are no preview houses for now","Suggested_UpdateToast_Title":"We\'ve updated your \\"For you\\" area","Suggested_SearchResume_Intro":"Your preferences:","Suggested_SearchResume_BudgetIntro":"Up to","Suggested_Welcome_Title_Named":"Hello, {{name}}!","Suggested_SetPreferenceBanner_Description":"These houses are in line with your old research. Is there any news?","Suggested_SetPreferenceBanner_CTA":"Update preferences","TeasingInbox_MetaTitle":"For you - Login","TeasingInbox_MetaDescription":"Without searching further, here are all the houses we think you\'ll like based on your search criteria","ValuationModal_Title":"SUGGESTED LISTING PRICE","ValuationModal_DateDescription":"Created on {{valuation-date}}","ValuationModal_CardTitle":"🎁 We have some houses in mind that might be a match for you.","ValuationModal_CardDescription":"You can find them all in your personal area","ValuationModal_CardButton":"See houses for you","ValuationModal_Title_1":"MARKET VALUE","BuyerContactFormWall_Title":"We\'ve made it!","BuyerContactFormWall_Description":"Your home value estimate is ready!\\nContinue and also get:","BuyerContactForm_Reward_Item-1":"Recommended houses for you","BuyerContactForm_Reward_Item-2":"Preview houses","BuyerContactFormWall_Button":"Log in","ForYou_Homeplus_CTA":"<b>Casavo Homeplus</b> offers","ForYou_Page_Mortgage_CardTitle":"Find the perfect mortgage","ForYou_Page_Mortgage_Card_Description":"Calculate your mortgage payment online or book a free consultation.","ForYou_Page_Mortgage_Card_CTA":"Calculate mortgage payment"}');

/***/ }),

/***/ 23001:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Priority_DetailPage_FloatingBanner_Desciption":"<b> We will call you as soon as it is available </b> and you will be among the first to see it.","PriorityDetail_TeasingBanner_Description":"<b> With UniCredit SubitoCasa</b>, you can visit this <b>home in advance.</b> ","Priority_DetailPage_AdvantagesBox_Description":"It is a house <b>that has not yet been put on the market, but may be soon.</b> We have selected only those who, like you, are looking for exactly such a house. With us, <b>you can book a viewing before anyone else.</b>","PriceAnalysis_Description":"Indicative price subject to change","Priority_DetailPage_AdvantagesCard_Advance_Description":"Discover the ads for houses for sale, before the others.","Priority_DetailPage_AdvantagesCard_Advance_Title":"Discover new houses","PriorityDetail_TeasingBanner_Description_v2":"With <b> UniCredit RE Services,</b> you can visit this house <b> in advance.</b>"}');

/***/ }),

/***/ 69885:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"meta":{"title":"🔕 Notifications disabled | Casavo","description":"Notifications for your search for new houses on Casavo have been disabled."},"notifications-disabled":"Notifications disabled","all-good-here":"All good here...","plant-image-alt-text":"A sofa with a plant to its right","done":"Doooone!","no-more-messages":"Notification alerts for new listings on Casavo have been disabled.","cta-browse-all":"Browse all our newest houses"}');

/***/ }),

/***/ 45174:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"search":"Search","all-zones":"All zones","seo-title":"Houses for sale in {{zone}} zone, {{city}} | Casavo","seo-description":"Houses for sale in {{zone}} area, {{city}}: search the real estate listings and find the right house for your needs. Learn more on Casavo!","search-filters":"Search municipality or zone","zones_count":{"all":"All zones","zones":"{{count}} zones","zones_one":"{{count}} zone"}}');

/***/ }),

/***/ 24096:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"PropertyAdvantages_Bureaucracy_Title":"Ayuda con los trámites burocráticos","PropertyAdvantages_Certification_Title":"Certificación de conformidad","PropertyAdvantages_SelectedPartners_CardDescription":"Respondemos por las <b>personas con las que hablarás</b>. Seleccionamos a nuestros colaboradores basándonos en la transparencia, su profesionalidad y su conocimiento de la ciudad. <b>Nosotros también les hemos comprado propiedades</b> y todo ha ido sobre ruedas. Por eso, sabemos que son de fiar.","PropertyAdvantages_CasavoGuarantee_BannerIntro":"Esta casa tiene <b>Garantía Casavo</b>","PropertyAdvantages_CasavoGuarantee_BottomBanner_Description":"Acompañamos al propietario de esta casa a lo largo del proceso de venta. Por eso, podemos garantizarte fiabilidad, calidad y servicios exclusivos. Estas casas no son nuestras, pero es como si lo fueran.","PropertyAdvantages_FairPrice_Title":"Precio controlado","PropertyAdvantages_Fees_Title":"Comisiones inferiores al 3%","PropertyAdvantages_CasavoGuarantee_BottomBanner_Title":"¿Qué significa la Garantía Casavo?","PropertyAdvantages_CasavoGuarantee_From_Title":"¿Qué quiere decir la <1>Garantía Casavo</1>?","PropertyAdvantages_Bureaucracy_CardDescription":"No temas olvidarte de nada. Nosotros también compramos casas, así que los actos notariales son nuestro pan de cada día. Por eso, podremos ayudarte con todo el tema burocrático, <b>recopilando los documentos</b> y ofreciéndote asistencia continua.","PropertyAdvantages_CasavoGuarantee_Banner_CTA":"Descubres","PropertyAdvantages_FairPrice_CardDescription":"Significa que <b>el precio que ves es acorde al del mercado</b>. Para analizar los precios con la mayor precisión posible, utilizamos nuestra tecnología y hacemos las comparaciones oportunas con casas parecidas que ya están en el mercado.","PropertyAdvantages_SelectedPartners_Title":"Colaboradores seleccionados","PropertyAdvantages_Fees_CardDescription":"¿Te estás preguntando cuántas comisiones tendrás que pagar? Queremos despejar tus dudas, ya que en Casavo trabajamos con colaboradores y tenemos acuerdos muy claros: <b>nunca pagarás una comisión superior al 3%</b>.","PropertyAdvantages_Card_CTA":"Descubre","PropertyAdvantages_CasavoProperty_BannerIntro":"Este es un <b>Hogar Casavo</b>","PropertyAdvantages_TransparencyDocumenation_CardDescription":"Nos hemos encargado de <b>conseguir los documentos necesarios</b>, incluidos el certificado histórico y catastral, el certificado hipotecario y las escrituras de la propiedad. Todos a tu disposición. Cuando se trata de casas, a nosotros tampoco nos gustan las sorpresas.","PropertyAdvantages_TransparencyDocumenation_Title":"Documentación transparente"}');

/***/ }),

/***/ 43617:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Login_Button":"Iniciar sesión","Search_Button":"Buscar","Profile_Button":"Perfil","Favorites_Button":"Favoritos","Suggested_Auth_Button":"Para ti","Suggested_Unauth_Button":"Para ti"}');

/***/ }),

/***/ 97376:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"AffordabilityTool_firstHouseQuestion_title":"¿Será su primera vivienda*?","AffordabilityTool_ResultPage_InfoAlert":"Algunos bancos pueden no tener en cuenta los ingresos procedentes de contratos a plazo fijo","LandRegistryTax_Label":"Gastos catastrales","AgencyFee_Label":"Tasas de agencia","AffordabilityTool_ResultPage_Expenses_DropDown2_Label":"¿Cuáles son los costes de comprar una casa?","Deposit_Label":"Avanzar","AffordabilityTool_ResultPage_Analysis_Box1_Description":"Por regla general, los bancos piden que la cuota hipotecaria sea como máximo el 35% de tus ingresos mensuales. Esta cuota se calcula teniendo en cuenta <b>cuánto puedes adelantar</b> y la relación cuota-ingresos. Ten en cuenta que puede haber excepciones en función de varios factores que los bancos valoran en cada caso concreto.","AffordabilityTool_ResultPage_NextStepBox_CTA":"Solicitar información","RegistrationTax_Label":"Impuestos de matriculación","AffordabilityTool_ResultPage_Expenses_Disclaimer":"*Los gastos se refieren al coste máximo de la vivienda.","AffordabilityTool_ResultPage_Expenses_DropDown1_Label":"¿Cuáles son los gastos hipotecarios?","AffordabilityTool_ageQuestion_title":"¿Cuántos años tienes?","TransferTax_Label":"Gastos hipotecarios","AffordabilityTool_ResultPage_Back":"Volver al anuncio","AffordabilityTool_ResultPage_Analysis_Box2_Description":"En general, los bancos piden un anticipo del 20%. Dependiendo del banco y de otras variables, <b>puede que tengas que dar menos</b> del 20%, o incluso ningún anticipo. Hablemos de ello, ¡seamos flexibles!","AffordabilityTool_ResultPage_Description_Positive":"¡La casa que te gusta está perfectamente dentro de tu rango de precios!<br/>\\n<b>Siguiente paso:</b> compruébalo con una consulta 🚀.","Application_Label":"Investigación","AffordabilityTool_ResultPage_FloatingBox_Title":"Tus datos","AffordabilityTool_ResultPage_DetailBox_MaxCost":"Coste máximo de la casa","MandatoryInsurance_Label":"Seguro obligatorio","Interest_Label":"Interés","OwnerNumber_Label":"Número de titulares","AffordabilityTool_ResultPage_Expenses_DropDown_Title":"Otros gastos","AffordabilityTool_ResultPage_Analysis_Title":"¿En qué se basa la estimación?","Notary_Label":"Notario","AffordabilityTool_ResultPage_NextStepBox_Description":"El servicio Casavo Mutui está a su disposición para investigar su situación y, si lo desea, presentarle la casa que más le guste.","AffordabilityTool_ResultPage_Chart_SelectedProperty":"Anuncio seleccionado","AffordabilityTool_ResultPage_Title":"Aquí tienes una primera estimación","MonthlyIncome_Label":"Ingresos mensuales","VAT_Label":"Recipiente","AffordabilityTool_ResultPage_Analysis_Box1_Title":"Cuota máxima estimada","AffordabilityTool_ResultPage_DetailBox_Title":"Detalles","Duration_Label":"Duración","Mortgage_Label":"Hipoteca","Appraisal_Label":"Opinión de los expertos","OtherLoans_Label":"Financiación en curso","AffordabilityTool_ContactModal_Title":"¿Quiere mejorar su capacidad de financiación?","AffordabilityTool_ContactModal_Description":"Estamos a tu disposición para responder a todas\\ntus preguntas.","AffordabilityTool_ResultPage_Analysis_Box2_Title":"Pago inicial: mínimo 20% de la vivienda","AffordabilityTool_ResultPage_NextStepBox_Title":"¿El siguiente paso? 🔮","AffordabilityTool_firstHouseQuestion_description":"*Por \\"primera vivienda\\" entendemos\\n<ul><li>bien la primera casa comprada cronológicamente</li>\\n<li>o la segunda/tercera/... casa comprada pero que se convierte en la residencia principal</li></ul>","PurchaseType_label":"Tipo de compra","AffordabilityTool_navigation_nextButton":"Siguiente","SubsituteTax_Label":"Impuesto sustitutivo","Age_Label":"Edad","OthersFee_Label":"Sellos y varios","NotaryExpenses_Label":"Gastos de notaría","AffordabilityTool_ResultPage_Description_Negative":"Según los datos que nos has facilitado y el coste de la casa, parece que no podemos ofrecerte ninguna opción de financiación.<br/><b>Vamos a analizar la situación</b>.","AffordabilityTool_otherLoansQuestion_person2_title1":"¿El otro titular tiene algún préstamo?","AffordabilityTool_otherLoansQuestion_person1_description":"Si en los próximos seis meses tienes que pagar las cuotas del coche, el móvil, la televisión...","AffordabilityTool_jobQuestion_person1_title2":"¿Cuánto ganas al mes?","AffordabilityTool_jobQuestion_person1_answer_expanded_option2":"Empleado con contrato temporal","AffordabilityTool_otherLoansQuestion_person1_title2":"En total, ¿cuánto gastas al mes en otros préstamos?","AffordabilityTool_ownersQuestion_answer_no":"No, somos dos","AffordabilityTool_jobQuestion_person1_description2":"Incluye tu salario neto o pensión <b>correspondiente a 12 meses</b>. Si trabajas por cuenta propia, indica una estimación.","AffordabilityTool_jobQuestion_person2_description2":"Incluye su salario neto o pensión <b>correspondiente a 12 meses</b>. Si trabaja por cuenta propia, indica una estimación.","AffordabilityTool_ownersQuestion_answer_yes":"Sí","AffordabilityTool_otherLoansQuestion_person1_title1":"¿Tienes algún otro préstamo?","AffordabilityTool_jobQuestion_person1_answer_expanded_option1":"Empleado fijo","AffordabilityTool_jobQuestion_person1_answer_expanded_option3":"Autónomo con número de IVA","AffordabilityTool_jobQuestion_person1_title1":"¿Cuál es tu situación laboral?","AffordabilityTool_jobQuestion_person2_title2":"¿Cuánto gana la otra persona al mes?","AffordabilityTool_otherLoansQuestion_person2_title2":"En total, ¿cuánto gasta al mes en otros préstamos?","AffordabilityTool_jobQuestion_person1_answer_expanded_option4":"Jubilado","AffordabilityTool_otherLoansQuestion_person2_answer1_yes":"No","AffordabilityTool_jobQuestion_person2_title1":"¿Cuál es la situación laboral del otro titular?","AffordabilityTool_ownersQuestion_title":"¿La hipoteca estará solo a tu nombre?","AffordabilityTool_depositQuestion_title":"¿Cuánto crees que podrías dar de entrada?","AffordabilityTool_jobQuestion_person1_answer_collapsed":"Selecciona una opción...","Affordability_ListingDetailCTA":"Comprobar mis opciones de financiación","PurchaseType_FirstHome_Label":"Primera casa","PurchaseType_SecondHome_Label":"Segunda casa","Fixed_at":"Fijado en","InputError_Loan":"El coste de la financiación no puede superar el salario mensual.","done":"¡Listo!","AffordabilityTool_ResultPage_NextStepBoxSuccess_Description":"Un experto de Casavo Hipotecas se pondrá en contacto contigo dentro de poco para analizar tus opciones de financiación y resolver todas tus dudas.","AffordabilityTool_ResultPage_Analysis_DownPaymentBox_WhyProblem":"<b>Tu pago inicial es de {{down_payment}}</b>, pero necesitarías un pago inicial de <b>al menos {{min_down_payment}}</b> para comprar esta casa.","AffordabilityTool_ResultPage_Analysis_RateBox_WhyProblem":"<b>Tu cuota mensual puede ser como máximo de {{max_installment}}</b> (35% de sueldo, con un 20% de entrada). \\nEn cambio, para esta casa, <b>tu cuota debe ser como mínimo de {{min_installment}} </b>({{min_income_percentage}}% de tu sueldo).","AffordabilityTool_ResultPage_Analysis_CTA":"Pídanos más información","AffordabilityTool_ResultPage_Expenses_DropDown_Subtitle":"Los gastos se refieren al importe máximo de préstamo que se puede obtener","AffordabilityTool_ResultPage_Expenses_CTA":"Solicitar consulta gratuita"}');

/***/ }),

/***/ 65227:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"LoginPage_Description":"Busca casa de una forma nueva.","LoginPage_Title":"Te damos la bienvenida\\na Casavo","UserProfile_Salute":"¡Hola","UserProfile_Description":"Este es tu espacio.\\n🚧 ¡Aún lo estamos preparando! 🚧 \\n\\nAquí puedes hablarnos de la casa que tienes en mente y gestionar tu búsqueda.","UserProfile_CTA":"Descubre las casas","LoginPage_Button_google":"Continuar con Google","UserProfile_LogoutButton":"Cerrar sesión","Divider_Smalltext":"o","UserProfile_Dropdown_Favorites":"Tus favoritos","SignupWithMail_Input_Password_Placeholder":"Escribe tu contraseña","Login_Success_CTA":"¡Genial!","LoginWithMail_CTA":"Inicia sesión","ToSignUp_Description":"¿Primera vez por aquí?","LoginWithMail_Input_Password_Placeholder":"Contraseña","SignupWithMail_Input_RepeatPassword_Error_NotMatch":"Las contraseñas no coinciden","SignupWithMail_Title":"Crea una cuenta nueva","SignupWithMail_CTA2":"Crear cuenta","SignupWithMail_Input_RepeatPassword_Placeholder":"Repítela (por motivos de seguridad)","Login_Success_Title":"¡Ya estás aquí!","Login_Success_Description":"<b>Has iniciado sesión en tu cuenta</b>.<br/>¡Es un placer tenerte de vuelta!","LoginWithMail_Error_WrongData_Description":"El correo o la contraseña no son correctos. Inténtalo de nuevo.","SignupWithMail_CTA1":"Continuar","ToLogin_Description":"¿Ya tienes una cuenta?","SignupWithMail_Password_Title":"Elige una contraseña","LoginWithMail_Error_WrongData_Title":"¿Seguro que los datos están bien?","SignupWithMail_Error_SimplePSW_Title":"Elige una contraseña más segura","Signup_Success_Description":"¡Acabas de unirte a nuestra gran familia! \\n\\nAhora puedes guardar tus casas favoritas, activar notificaciones para las búsquedas que te interesen y mucho más...\\n\\n\\u2028Busca casa de una forma totalmente nueva.","Input_Email_Placeholder":"Escribe tu correo electrónico","Signup_Success_Title":"¡Ya eres de los nuestros!","ToSignUp_CTA":"Crea una cuenta","LoginPage_WithMail_CTA":"Continúa con tu correo","SignupWithMail_Error_SimplePSW_Description":"Por seguridad, te recomendamos que elijas una contraseña más difícil.","SignupWithMail_Input_Password_Error_ShortPsw":"Mínimo 8 caracteres","SignupWithMail_Alert_ExistingAccount_Title":"Esta cuenta ya existe","SignupWithMail_Alert_ExistingAccount_Description":"Este correo electrónico ya está registrado. ¿Quieres iniciar sesión?","SignupWithMail_Alert_ExistingAccount_CTA":"Iniciar sesión","Login_Favorites_BottomSheet_Title":"Inicia sesión para añadirla a tus favoritos","Login_SaveSearch_BottomSheet_Title":"Inicia sesión para guardar\\ntu búsqueda","LoginWithMail_Title":"Inicia sesión con tu correo","RecoverPassword_Code_Title":"Revisa el correo","RecoverPassword_Code_CTA":"Continúa","NewPassword_Success_Description":"¡Perfecto! Tu nueva contraseña está segura, ¿dónde estábamos?","RecoverPassword_Code_Sendto":"Hemos enviado el código de seguridad a","RecoverPassword_Code_Description":"Ingresa el código que recibiste aquí:","NewPassword_Title":"Elija una nueva contraseña","NewPassword_Success_Title":"Contraseña confirmada","RecoverPassword_CTA":"Recibe el código","Login_ToRecoverPassword":"¿Se te olvidó tu contraseña?","NewPassword_CTA":"Confirmar la nueva contraseña","RecoverPassword_Description":"Te enviaremos un código para configurar tu nueva contraseña. Introduce el correo electrónico que utilizaste para registrarte:","RecoverPassword_Title":"Restablecer la contraseña","RecoverPassword_Error_InvalidCode_Description":"El código que ingresó es incorrecto o ha caducado. Consultar o enviar otro","RecoverPassword_Error_InvalidCode_Title":"Codigo invalido","Login_ScheduleVisit_BottomSheet_Title":"Iniciar sesión para desbloquear la reserva instantánea","Login_Suggested_BottomSheet_Title":"¡Listo!\\nSolo falta tu nombre.","Social_Login_Error_Message":"Ha habido un error con tu cuenta de Google. Vuelve a intentarlo con tu correo electrónico.","Social_Login_Error_Cta":"Volver atrás","Login_PriorityDetail_BottomSheet_Title":"¡Perfecto! ¿Con qué nombre te apuntamos a la lista ?","Login_RequestVisit_BottomSheet_Title":"Vamos a mirar nuestra agenda. Mientras tanto, ¿nos dices tu nombre?","Login_TeasingInbox_Title":"Me alegro de verte de nuevo. Hay una nueva sección sólo para ti.","Login_FromContactFrom_Title":"¡Claro que sí! ¿Cómo te llamas?","Login_PriorityDetail_BottomSheet_UnlockTitle":"Descubre casas que todavía no están en el mercado.","BuyerContactFormModal_Title":"Solo falta tu nombre."}');

/***/ }),

/***/ 53203:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"SearchStatus_Answer3":"Estoy a punto de hacer una propuesta de compra","HouseType_1room":"Estudio","HouseType_4orMore":"3 habitaciones o más","SearchStatus_Answer4":"Ya he hecho una propuesta de compra","SearchBar":"Busca una zona...","SearchStatus_Answer1":"Estoy tanteando el terreno","ThankYou_Title":"Ahora nos toca a nosotros...","SearchStatus_Question":"¿En qué fase estás?","Intro_Description":"Respondes y te buscamos un hogar. Podemos ofrecerle casas a medida para usted, incluso antes de que salgan al mercado.","NoResult_Title":"Juntos encontraremos la casa perfecta","Intro_Title":"Háblanos de ti en solo 4 clics.","MaxBudget_Input_Placeholder":"€","Form_Description":"Ahora sabemos exactamente lo que estás buscando. Lo último: ¿cómo podemos contactarte?","NoResult_Description":"Por ahora no tenemos ninguna casa así. Ayúdanos a proponerte las casas perfectas para ti, antes incluso de que salgan al mercado.","ThankYou_CTA":"Volver a las casas","NoResult_CTA":"Cuéntanos qué buscas","MaxBudget_Question":"¿Cuál es tu presupuesto máximo?","Form_Mail_Placeholder":"Correo electrónico","Form_Name_Placeholder":"Nombre y apellidos","ThankYou_Description":"Esperamos poder encontrar el hogar perfecto para usted. ¡Hablamos pronto!","FewResult_Title":"¿Quieres descubrir las casas nuevas antes que nadie?","SearchStatus_Answer2":"Ya he visitado algunas casas","HouseType_Question":"¿Qué tipo de casa te interesa?","Form_Title":"Respuestas guardadas","MaxBudget_Description":"No es nuestra pregunta favorita, pero necesitamos saber una estimación.","FewResult_Reset":"Cambiar los filtros","NoResult_Reset":"Restablecer los filtros","Zone_Question":"¿En qué áreas de {{city}} quieres que busquemos?","HouseType_3rooms":"Piso de 2 habitaciones","HouseType_4rooms":"Piso de 3 habitaciones","HouseType_2rooms":"Piso de 1 habitación","FewResult_Description":"Podemos proponerte casas pensadas para ti, incluso antes de que salgan al mercado.","Zone_Noresult":"¿No encuentras lo que buscas?<br/>\\nConsulta la <0>lista de zonas</0>."}');

/***/ }),

/***/ 18136:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"terrace":{"label":"Balcón","title":"Casas en venta en {{ciudad}} con terraza | Casavo","description":"Ver todos los anuncios de pisos en venta en {{ciudad}} con terraza. Casavo sólo trabaja con agencias seleccionadas. ¡Encuentra ya la casa de tus sueños!"},"balcony":{"label":"Balcón","title":"Casas en venta en {{ciudad}} con balcón | Casavo","description":"Ver todos los anuncios de pisos en venta en {{ciudad}} con balcón. Casavo sólo trabaja con agencias seleccionadas. ¡Encuentra ya la casa de tus sueños!"},"studios":{"label":"Estudios","title":"Estudios en venta en {{ciudad}} | Casavo","description":"Ver todos los anuncios de Estudios en venta en {{ciudad}}. Casavo sólo trabaja con agencias seleccionadas. ¡Encuentra ahora la casa de tus sueños!"},"one-bedroom-apartments":{"label":"Pisos de 1 habitación","title":"Piso de 1 habitación en venta en {{ciudad}} | Casavo","description":"Ver todos los anuncios de Pisos de 1 habitación en venta en {{ciudad}}. Casavo sólo trabaja con agencias seleccionadas. ¡Encuentra ya la casa de tus sueños!"},"two-bedroom-apartments":{"label":"Piso de 2 habitaciones","title":"Piso de 2 habitaciones en venta en {{ciudad}} | Casavo","description":"Ver todos los anuncios de Pisos de 2 habitaciones en venta en {{ciudad}}. Casavo sólo trabaja con agencias seleccionadas. ¡Encuentra ya la casa de tus sueños!"},"new-constructions":{"label":"Nueva construcción","title":"Construcciones recientes en venta en {{ciudad}} | Casavo","description":"Descubre todos los anuncios de casas de nueva construcción que hay en venta en {{city}}. Casavo solo trabaja con agencias seleccionadas. ¡Encuentra ya la casa de tus sueños!"}}');

/***/ }),

/***/ 44516:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"claim":"<0>Este es un <1>Hogar Casavo</1></0>","claim_cta":"<0>Este es un <2/><1>Hogar Casavo</1></0>","title":"Hogares Casavo: los propietarios somos nosotros.","title_detail":"Es un Hogar Casavo","text":"<0>Sabemos lo complicado que puede ser encontrar la casa de tus sueños.</0><0>En Casavo, garantizamos la venta de casas totalmente reformadas. Siempre a precio de mercado.</0><1>¡Busca la  <2/>   en los anuncios!</1>","text_detail":"Todo para que disfrutes tu nueva casa en total tranquilidad…","discover_all_the_advantages":"Descubre todas las ventajas","modal_subtitle":"<0>Queremos librarte de todas las preocupaciones. Nosotros mismos renovamos y gestionamos las casas que son de nuestra propiedade, los Hogares Casavo.</0><1>Casas listas para entrar a vivir y con servicios exclusivos, a un precio de mercado.</1>","list_item_discount_modal_description":"No podemos contárselo todo aquí, no queremos perturbar su investigación... descubra todas las ventajas de Casavo, nuestro equipo está a su disposición ❤️","good_to_know":"¡Entendido!","what_does_it_mean":"¿Qué significa?","modal_list_items":[{"title":"Ventajas incluidas en el servicio:","items":[{"title":"Reforma integral","description":"Esta casa ha sido reformada por Casavo con los mayores estándares de calidad."},{"title":"Personalización","description":"Si la reforma de la casa en la que estás interesado acaba de comenzar, podrás elegir algunos acabados de la reforma a tu gusto. "},{"title":"Soporte paso a paso","description":"Expertos del mercado inmobiliario, asesores financieros, diseñadores de interiores y arquitectos. Nuestro equipo tiene a todas las personas que necesitas a tu lado hasta la compra de tu nueva casa."}]},{"title":"...más a su servicio, de Casavo:","items":[{"title":"Servicio hipotecario","description":"Usted elige la casa que desea, Casavo Mutui se encarga de la hipoteca. Un asesor especializado se encargará de toda la burocracia.","image":"loan"},{"title":"Muebles e interiores","description":"¿Le gusta su casa amueblada como en las visitas virtuales? Puede solicitarla exactamente así, ¡totalmente amueblada!","image":"muebles"},{"title":"Convenciones exclusivas","description":"Electricidad, gas, WiFi, sistemas de alarma, electrónica y mucho, mucho más.","image":"descuento"}]}],"advantage_first":"Reforma integral","advantage_second":"Personalización","advantage_third":"Soporte paso a paso"}');

/***/ }),

/***/ 44501:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"available":"disponibles","available-singular":"disponible","title":"Casas en venta | Casavo","title-listing":"Casas en venta en {{city}} | Casavo","description":"Descubre todos los anuncios de casas en venta en las principales ciudades españolas ¡y encuentra la casa de tus sueños en Casavo.com!","description-listing":"Descubre todos los anuncios de casas en venta en {{city}} ¡y encuentra la casa de tus sueños en Casavo.com!","loading":"Cargando...","of":"de","of2":"desde","entrance_floor":"Planta","entrance_floors":"Planta","basement":"Sótano","raised":"Piso elevado","ground_floor":"Planta baja","last_floor":"Última planta","mid_floor":"Planta intermedia","select_city":"Ciudad","rooms":"Habitaciones","bathrooms":"Baños","bedrooms":"Habitaciones","status":"Estado","habitable":"Habitable","new":"Nuevo","renovated":"Reformado","need_renovation":"Sin reformar","under_construction":"En construcción","private_negotiation":"Negociación privada","get-free-offer-label":"Vender Casa","get-free-offer-small-label":"Vender Casa","our-properties-label":"Comprar","our-properties-small-label":"Comprar","our-clients-label":"Nuestros clientes","are-you-broker-label":"¿Eres una agencia?","footer-service-label":"Servicios","footer-resources-label":"Recursos","footer-about-us-label":"Empresa","footer-our-properties-label":"Casas en venta","footer-press-label":"Lo que dicen de nosotros","footer-blog-label":"Blog","footer-faqs-label":"Preguntas frecuentes","footer-work-label":"Empleo","footer-work":"https://careers.casavo.com","footer-contact-label":"Contacto","footer-casavo-es-label":"Casavo España","footer-casavo-pt-label":"Casavo Portugal","footer-legal-label":"Acerca de Casavo","footer-privacy-label":"Política de privacidad","footer-terms-label":"Términos y condiciones","footer-made-with":"Made with","footer-made-in":"in Milan","for-sale":"en venta","listing_not_found_title":"Anuncio no disponible","listing_not_found_similar_properties_subtitle":"El anuncio que buscas ha sido eliminado o la casa ya se ha vendido.","listing_not_found_cta":"Ver los anuncios","text-list":"List","text-map":"Mapa","open-map":"Abrir Mapa","no-listings-in-city":"Por desgracia, aún no tenemos casas disponibles en esta ciudad :(","casavo-properties-title":"Hogar Casavo","cta_show_virtual_tour":"Virtual Tour","enter_virtual_tour":"Ver","message_virtual_tour":"3D Tour","view_property":"Ver casa","page":"Página","photos":"Fotos","pagination-bottom":"de {{length}} casas","of-pagination":"desde","tooltip-text":"Las casas de Casavo nunca tienen un precio superior al del mercado","houses-for-sale-in-area":"Casas <0>en la provincia de {{area}}</0>","house-for-sale-in-area":"Casa <0>en la provincia de {{area}}</0>","houses-for-sale-in-city":"Casas <0>en {{city}}</0>","house-for-sale-in-city":"Casa en venta <0>en {{city}}</0>","houses-for-sale-in-zone":"Casas <0>en zona {{zone}}</0>","house-for-sale-in-zone":"Casa <0>en zona {{zone}}</0>","house-for-sale-byZone-filter":"Casa <0>en {{area}}</0>","houses-for-sale-byZone-filter":"Casas <0>en {{area}}</0>","outdoor_space_label":"Espacio al aire libre","new_listing_label":"Nuevo!","tooltips":{"casavo_property":"Las casas de Casavo nunca tienen un precio superior al del mercado","outdoor_space":"¡Vive tu casa al aire libre! Esta casa cuenta con una terraza o jardín.","energy_efficient":{"A_B":"Excelente para el medio ambiente 🌳. Esta casa tiene una calificación energética superior a B.","C":"Más eficiencia, más confort. Esta casa tiene una calificación energética superior a B."}},"read_more":"más...","read_less":"ver menos","invalid-email-message":"¿Puedes comprobar si el correo electrónico está bien escrito?","required-field-message":"Campo requerido","mortgage":{"title":"Servicio hipotecario","text":"Hipoteca: la palabra basta.<0/>A su lado,<0/>de la investigación a la firma.","cta":"Más información sobre Casavo Mutui","contact-us":"Estamos a su disposición<0/>Póngase en contacto con nosotros en cualquier momento"},"mortgage-modal":{"title":"Nosotros nos encargamos de la parte aburrida.","content-top":"En Casavo ponemos a su disposición un equipo dedicado y especializado que se encargará de su expediente hipotecario y del seguimiento con el banco de su elección. Así tendrá más tiempo para pensar en otras cosas.","content-bottom":"Más de 110 clientes ya han utilizado nuestro servicio y han obtenido su hipoteca con 15 días de antelación. De forma gratuita.","more":"¿Quiere saber más?","call":"Llámanos"},"form-error":"Ha habido un error. Inténtalo de nuevo.","where-looking-for":"¿Donde estás buscando?","province":"Provincia","province-of":"Provincia de {{area}}","municipality":"Municipalidad","menu":{"sell":"Vender Casa","buy":"Comprar Casa","our-clients":"Nuestros clientes","agency":"¿Eres una agencia?","about":"Acerca de Casavo"},"listings":{"canonical-links-title":"Tipo de casa {{ciudad}}:","most-visited-zones-title":"Anuncios inmobiliarios en {{city}}:"},"prev":"Previo","next":"Siguiente","footer-team-label":"Equipo","footer-partner-label":"Conviértete en Partner","footer-casavo-it-label":"Casavo Italia","invalid-phone-message":"Numero de telefono invalido","casavo-inventory-agency-title":"Garantía Casavo","CTA_Next":"Siguiente","GenericError_Modal_Description":"Parece que algo ha salido mal. ¿Podrías intentarlo de nuevo? ¡Gracias!","GenericError_Modal_Title":"Ups...","simple_confirm":"¡Okey!","No":"No","Yes":"Sí","years":"años","Header_AddressFormat":"<0>{{streetName}}</0><1>N° {{streetNumber}}, {{city}}</1>","address_format":"{{streetName}} N° {{streetNumber}}, {{city}}"}');

/***/ }),

/***/ 22226:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"agency":{"message":{"cta":"¿Desea contarnos algo más?","label":"Cuéntanos más","placeholder":"¿Tiene alguna pregunta?\\n¿Cuándo quiere que nos pongamos en contacto con usted"},"success":{"message":"Y el primer paso está hecho...\\nNuestro socio se pondrá en contacto contigo muy pronto","cta":"Ver casas similares"}},"casavo":{"assistant":"Tu asistente de Casavo","name":"Nombre","reason":{"placeholder":"¡Nos alegra mucho que esta casa te guste! ¿En qué podemos ayudarte?","warning":"Esta información nos permite ayudarte con más rapidez","options":{"morePhotos":"Quiero recibir más fotos y material","moreAboutHouse":"Quiero recibir más información sobre esta casa","other":"Otro motivo"}},"title":"<0>Tu experiencia con <1>Casavo</1> empieza aquí.</0>","success":{"title":"¡Ya has dado el primer paso!","subtitle":"...a partir de ahora, puedes contar con nosotros. Contactaremos contigo dentro de poco.","postScriptum":"P.D. Hemos recibido tu solicitud.\\nNo te preocupes, ¡tienes prioridad para esta casa!","cta":"Ver casas similares"}},"phone":"Tu número de teléfono","submit":"Enviar","email":{"label":"Tu e-mail","success":"¡Gracias, solicitud recibida! Consulte su correo electrónico para conocer los siguientes pasos"},"success":{"toFlow":{"title":"¿Quieres vender una casa?","subtitle":" ","cta":"Obtén una oferta"}},"ContactForm_SuccessSaveSearch_CTA_Primary":"Recibir alertas","ContactForm_SuccessSaveSearch_CTA_Secondary":"No, gracias.","ContactForm_SuccessSaveSearch_Subtitle":"Te lo enviamos cómodamente a tu correo electrónico","ContactForm_SuccessSaveSearch_Title":"¿Deseas recibir nuevos anuncios similares a éste?","ContactForm_SuccessSaveSearch_OkFeedback":"Alertas activadas","name":"Nombre","lastname":"Apellido"}');

/***/ }),

/***/ 92608:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Favourites_FavouriteList_AutodeleteMessage":"Si una casa ya no está en el mercado, se eliminará automáticamente de tus favoritos al cabo de 20 días.","Favourites_FavouriteList_FavouriteCard_Unavailable":"Ya no está disponible","Favourites_FavouriteList_DeleteConfirm_title":"¿Quieres eliminar este favorito?","Favourites_FavouriteList_DeleteConfirm_cancelCTA":"Cancelar","Favourites_FavouritesList_Title":"Tus favoritos","Favourites_FavouriteList_EmptyState":"En cuanto encuentres una casa que te guste, haz clic en el <icon/> para guardarla en tus favoritos.","Favourites_FavouriteList_ConfirmToast_title":"Anuncio eliminado de los favoritos","Favourites_FavouriteList_DeleteConfirm_mainCTA":"Eliminar","Favourites_FavouriteList_ConfirmToast_body":"¡No te preocupes! Encontrarás otras casas que te enamorarán.","Favourites_FavouriteList_EmptyStateMain":"¿Has tenido un flechazo?","Favourites_FavouritesList_SubTitle1":{"one":"{{count}} anuncio te ha enamorado","other":"{{count}} anuncios te han enamorado"},"Desktop_Saved":"Guardado","Desktop_Save":"Guardar","FavouritesList_Desktop_BackToSearch":"Volver a la búsqueda","FavouriteList_EmptyState_Unauth_CTA":"Iniciar sesión","FavouriteList_EmptyState_Unauth_Title":"¿Has tenido un flechazo?","FavouriteList_EmptyState_Unauth_Description":"Inicia sesión para guardar en tus favoritos las casas que te gusten y tenerlas siempre a mano.","Favourites_Add_To_Favorite_CTA":"Guardar en favoritos"}');

/***/ }),

/***/ 79366:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"change-filters":"Cambia Filtros","price":"Precio","surface":"Superficie","room":"Habitación","rooms":"Habitaciones","status":"Estado","other_filters":"Otros filtros","properties":"Casas","property":"casa","properties_for_you":"Casas disponibles","property_for_you":"Casa disponible","no_properties":"No hay casas disponibles","last_uploaded":"Más reciente","most_relevant":"Más relevante","cheapest":"Precio más bajo","most_expensive":"Precio más alto","area_max":"Superficie mas grande","area_min":"Superficie mas pequeña","no_properties_for_filters_title":"En este momento no hay casas con estas características.","no_properties_for_filters_subtitle":"Intenta cambiar los filtros para ver más resultados","save":"Guardar","from":"De","to":"Hasta","max":"Max","min":"Min","filters":"Filtros","trendy_filters":"Filtros populares","filter_by":"Filtrar por","reset":"Reiniciar","undo":"Eliminar","apply":"Aplicar","only_casavo":"Mostrar solo Hogares Casavo","price_guaranted":"Precio garantizado","renovated_properties":"Casas reformadas","assistance_guaranted":"Asistencia garantizada","typology":"Tipología","bathroom":"Cuarto de baño","bathrooms":"Baños","bedroom":"Habitación","bedrooms":"Habitaciones","entrance_floor":"Planta","state_of_manteinance":"Estado de la casa","state_at_deed":"Estado de la propiedad","services":"Servicios","heating_system":"Calefacción","year_of_construction":"Año de construcción","anyone_choice":"Cualquiera","apartment":"Piso","house":"Casa independiente","townhouse":"Casa adosada","villa":"Chalet","loft":"Loft","attic":"Ático","mansard":"Buhardilla","basement":"Sótano","raised":"Piso elevado","ground_floor":"Planta baja","last_floor":"Última planta","mid_floor":"Planta intermedia","habitable_status":"Habitable","new_status":"Nuevo","renovated_status":"Reformado","need_renovation_status":"Sin reformar ","under_construction_status":"En construcción","OCCUPIED":"Ocupado","FREE":"Libre","RENTED":"Alquilado","BARE_OWNERSHIP":"Propiedad desnuda","elevator":"Ascensor","parkingSpaces":"Aparcamiento","box":"Garaje","garage":"Garaje","cellar":"Trastero","garden":"Jardín","balcony":"Balcón","balconies":"Balcones","terrace":"Terraza","terraces":"Terrazas","pool":"Piscina","coolingSystem":"AC","conciergeService":"Conserje","AUTONOMOUS":"Autónoma","SHARED":"Centralizada","NONE":"Ninguno","at_least":"Al menos","single_filter":"filtro","single_filters":"filtros","milan":"Milan","turin":"Turin","bologna":"Bologna","verona":"Verona","rome":"Rome","florence":"Florence","only_casavo_filter_label":"Mostrar solo Hogares Casavo","ranking":"Automático","trendy_filters_description":"Estos filtros, una vez seleccionados, nos ayudan a proponerte las casas más adecuadas para ti","other_filters_description":"Todo lo que necesitas para buscar la casa de tus sueños.","filters_zone_suggestion_title":"¿Dónde estás buscando?","filters_zone_suggestion_description":"Gana tiempo <0>seleccionando zonas específicas.</0>"}');

/***/ }),

/***/ 73201:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Furniture_DetailPage_FurnitureBanner_Title":"Sí, puedes llevártela ya amueblada","Furniture_DetailPage_FurnitureBanner_CTA":"¿Qué incluye?","Furniture_DetailPage_FurnitureBanner_Body":"Hemos realizado un proyecto de <b>decoración a medida</b> para esta casa.","Furnitures_Detailpage_FurniturePriceTag":"Decoración disponible","Furniture_PhotoCarousel_Toast_CTA":"Echa un vistazo al proyecto","Furniture_PhotoCarousel_Toast_Body":"Aquí tienes el proyecto de interiorismo que hemos creado a medida para esta casa","Furniture_PhotoCarousel_Toast_Title":"¿Te gusta esta decoración?","Furniture_Modal_Title":"Nuestro proyecto a medida para ti","Furniture_Modal_FormTitle":"👇 Recibe ya el proyecto de interiorismo","Furniture_Modal_Bullet_2":"<b>Tú eliges cómo personalizar </b>hasta el más mínimo detalle","Furniture_Modal_MktgConsent_Description":"Danos permiso para enviarte novedades sobre decoración y servicios nuevos","Furniture_Modal_Bullet_3":"<b>Las mejores marcas </b>a tu disposición:","Furniture_Modal_CTA":"Recibir el proyecto","Furniture_Modal_Bullet_1":"<b>Cocina, baños y armarios</b> para tu nueva casa","Furniture_ServiceName":"Interior","Brand_CasavoServices":"Casavo Services"}');

/***/ }),

/***/ 53415:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Items0_Title":"Para vender, fácilmente","Items0_Description":"Relájese. Compraremos tu casa o encontraremos un comprador para ti.","Items1_Title":"Para Casavo Mutui","Items1_Description":"Y di adiós a la burocracia. Encontramos la mejor hipoteca para ti.","Items2_Title":"Para la gente que habla de nosotros","Items2_Description":"¿Qué dice la persona que nos eligió? Descubre las historias de quienes ya nos conocen.","Footer_Title":"¿Alguna otra pregunta?","Footer_Description":"Siempre tenemos una respuesta para cada pregunta que nos haga. Y si no las encuentra todas, póngase en contacto con nosotros. Aquí estamos.","Title":"Casavo Porque"}');

/***/ }),

/***/ 74820:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"find-your-house":"Descubre las casas <0/>en venta para ti en..."}');

/***/ }),

/***/ 58635:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title_not_found":"Anuncio no encontrado","characteristics":"Características","description":"Descripción de la casa","the_district":"El vecindario","at_your_service":"A tu disposición","at_your_service_message":"Nos pondremos en contacto con usted cuando le convenga.","show_number":"Ver teléfono","show_number_casavo":"Llámanos","request_info":"Solicitar información","request_visit":"Solicita una visita","request_visit_modal_title":"Solicita una visita","request_visit_modal_thank_you_title":"Espera nuestra confirmación","contact_us":"Contáctanos","contact_email":"Tu e-mail","contact_phone_number":"Tu número de teléfono","fomo_message_person":"<0>{{userViews}} persona</0> vio este anuncio en la última hora","fomo_message_people":"<0>{{userViews}} personas</0> han visto este anuncio en la última hora","phone_call":"Llamada","phone_call_now":"Llama ahora","rooms":"Habitaciones","bathrooms":"Baños","bedrooms":"Habitaciones","balconies":"Balcones","terraces":"Terrazas","balcony":"Balcón","terrace":"Terraza","status":"Estado","planimetry":"Plano","services":"Servicios","see_all_characteristics":"Ver todos","see_less_characteristics":"Ver menos","elevator":"Ascensor","parkingSpaces":"Aparcamiento","box":"Garaje","basement":"Trastero","garden":"Jardín","coolingSystem":"AC","coolingSystem_full":"Aire acondicionado","coolingSystem_AUTONOMOUS":"Autónoma","coolingSystem_SHARED":"Centralizada","coolingSystem_READY_FOR_INSTALLATION":"Preinstalación hecha","coolingSystem_NONE":"Ninguna","conciergeService":"Conserje","recreationRoom":"Taberna","garret":"Desván","pool":"Piscina","sharedPool":"Piscina común","tennisCourt":"Pista de tenis","fireplace":"Chimenea","disabledAccess":"Acceso para discapacitados","wallCabinet":"Armarios empotrados","fastInternet":"Internet","hydromassage":"Hidromasaje","tvSystem":"Sistema de televisión","electricGate":"Puerta eléctrica","armoredDoor":"Puerta blindada","alarmSystem":"Sistema de alarma","entranceVideoPhone":"Video portero","year_of_construction":"Año de construcción","year_of_renovation":"Año última renovación","exposure":"Orientación","NORTH":"Norte","SOUTH":"Sur","EAST":"Este","WEST":"Oeste","furniture":"Muebles","FULLY_FURNISHED":"Completamente amueblado","NOT_FURNISHED":"Sin amueblar","PARTIALLY_FURNISHED":"Parcialmente amueblado","estate_registry_class":"Código catastro","energy_rating_label":"Certificado energético","energy_performance_index_label":"Prestación energética","energy_performance_index_udm":"kWh/m² año","energy_rating":{"energy_a4":"A4","energy_a3":"A3","energy_a2":"A2","energy_a1":"A1","energy_aplus":"A+","energy_a":"A","energy_b":"B","energy_c":"C","energy_d":"D","energy_e":"E","energy_f":"F","energy_g":"G","energy_pending_request":"En curso"},"kitchen":"Cocina","kitchen_HABITABLE":"Cocina independiente","kitchen_HALF_HABITABLE":"Cocina semi independiente","kitchen_KITCHENETTE":"Cocina americana","kitchen_OPEN":"Cocina abierta","glazing":"Acristalamiento","glazing_SINGLE":"Vidrio simple","glazing_DOUBLE":"Doble acristalamiento","glazing_TRIPLE":"Tripe acristalamiento","info":"Más info","condo_fees":"Gastos de comunidad","per_year_label":"por año","state_at_deed":"Estado de la propiedad","OCCUPIED":"Ocupado","FREE":"Libre","RENTED":"Alquilado","BARE_OWNERSHIP":"Propiedad desnuda","heating_system":"Calefacción","AUTONOMOUS":"Autónoma","SHARED":"Centralizada","NONE":"Ninguno","exclusive_mandate":"Mandato exclusivo","cta_show_photos":"Ver {{photoLength}} fotos","cta_show_virtual_tour":"Virtual Tour","cta_show_virtual_tour_mobile":"Tour","apartment":"Piso","house":"Casa independiente","townhouse":"Casa adosada","villa":"Chalet","loft":"Loft","attic":"Ático","mansard":"Buhardilla","sharing":"Compartir","might_interest_you":"Casas similares","based_on_your_searches":"Estas casas podrían gustarte:","poi_nearby":"En los alrededores de esta casa encontrará:","poi_discover":"Descúbrelo:","TRANSPORT":{"poi_category":"Transportes","poi_nearby_card_title":"Transporte","poi_nearby_card_distance":"La parada más cercana <1/><0>está a {{distance}} m</0>","BUS_STOP_distance":"Parada de autobús a {{distance}} m","TRAIN_STATION_distance":"Estación a {{distance}} m","SUBWAY_STATION_distance":"Parada de metro a {{distance}} m","TRAM_STOP_distance":"Parada de tranvía a {{distance}} m","poi_nearby_card_all":"Ver el transporte","BUS_STOP_label":"Autobús","TRAIN_STATION_label":"Tren","SUBWAY_STATION_label":"Metro","TRAM_STOP_label":"Tranvía"},"SCHOOL":{"poi_nearby_card_title":"Escuelas","poi_nearby_card_distance":"La escuela más cercana <1/><0>está a {{distance}} m</0>","SCHOOL_distance":"Escuela a {{distancia}}m","poi_category":"Escuelas","poi_nearby_card_all":"Ver las escuelas","SCHOOL_label":"Escuela"},"SHOP":{"poi_nearby_card_title":"Supermercados","poi_nearby_card_distance":"El supermercado más cercano <1/>está <0>a {{distance}} m</0> ","SHOP_distance":"Supermercado a {{distance}}m","poi_nearby_card_all":"Ver los supermercados","poi_category":"Supermercados","SHOP_label":"Supermercado"},"properties":"Casas","neighborhood":"el vecindario...","more_about_neighborhood":"Conozca más sobre el barrio","less_about_neighborhood":"Ver menos","last_update":"Anuncio actualizado el:","street-view":{"address-disclaimer":"Ubicación aproximada","description":"Vista de la calle","cta":"Vista de la calle"},"at_your_service_agency":"<0>Nuestro colaborador</0> a tu disposición","at_your_service_casavo":"¿Qué significa <1>Hogar Casavo</1>?","form-header":{"title":"¿Te ha gustado?","subtitle_casavo":"No lo dejes escapar... ¡nosotros te llamamos!","subtitle_agency":"No te lo pierdas, nuestro colaborador responderá todas tus preguntas","agency":{"one":"Agencia verificada por Casavo","two":"Solo anuncios verificados"},"casavo":{"one":"Hemos verificado y certificado esta casa","two":"","three":"Soporte paso a paso","four":"Asesoramiento hipotecario"},"subtitle_casavo_inventory_agency":"Estamos a tu disposición para responder todas tus dudas.","casavo-agency":{"one":"Comisiones inferiores al 3","two":"Precio controlado","three":"Certificación de conformidad","four":"Colaboradores seleccionados","five":"Apoyo en la burocracia"}},"we_will_contact_you":"Nos pondremos en contacto con usted tan pronto como sea posible","form-body":{"success_button":"Ver casas similares","success_button_alt":"Seguir buscando"},"request_visit_error":"Error en el envío<0/>Inténtalo de nuevo.","request_visit_email_error":"Envío fallido.<0/> Compruebe que el correo electrónico introducido sea correcto","select_visit_date":"Seleccione una fecha","select_visit_time":"¿A qué hora?","insert_confirmation_info":"¿Cómo podemos contactar contigo?","visit_time_disclaimer":"La visita aún no está confirmada","you_will_receive_confirmation":"Recibirás una confirmación","you_will_receive_confirmation_detail":"Un experto de Casavo confirmará la disponibilidad en el rango indicado. Juntos acordarán la mejor solución para usted y recibirán una confirmación","book_visit_hour_recap":"De {{startHour}} a {{endHour}}","title_0_1":"en venta en","request_visit_modal_thankyou_item_2":"Si no podemos aceptar tu solicitud, buscaremos juntos otro momento para la visita.","request_visit_modal_thankyou_item_1":"Nos pondremos en contacto contigo lo antes posible para confirmar","title_0":"en venta en","title_2":"desde","title_1":"en","request_call_modal_title":"Programa una llamada con un <0>consultor de Casavo</0>","request_call_modal_thank_you_title":"Llamada programada","request_call":"¿Te llamamos?","request_call_cta":"Habla con nosotros","request_timeslot_caption":"Durante la llamada, acordaréis el día y la hora para visitar esta casa","request_feedback_call_bullet_2":"Si quieres, <0>programaremos una visita</0> para que veas esta casa","request_feedback_call_bullet_1":"Te llamaremos el día y a la hora acordados para responder a todas tus preguntas","select_call_date":"¿Qué día prefieres?","select_call_time":"¿A qué hora?","request_call_modal_thank_you_title_2":"Ahora es nuestro turno","request_visit_modal_thank_you_title_2":"Ahora es nuestro turno","view":"Vista","view_interior":"Interior","view_exterior":"Exterior","schedule_visit_cta":"Programa tu visita","schedule_visit_modal_title":"Programa una visita para este <0>Hogar Casavo</0>","select_schedule_visit_time":"Selecciona una hora","schedule_visit_confirm_cta":"Confirma la visita","schedule_visit_no_availabilities":"No hay disponibilidad para esta fecha.","schedule_visit_recap_no_availabilities":"Encuentra una fecha disponible","schedule_visit_modal_thank_you_title":"¡Visita confirmada!","schedule_visit_modal_thank_you_title_2":"Próximos pasos:","schedule_visit_modal_thankyou_item_1":"Recibirás:\\n- Un correo electrónico con toda la información al instante.\\n- Un SMS a modo de recordatorio 24 horas antes de la cita.","schedule_visit_modal_thankyou_item_2":"Un consultor de Casavo te enseñará la casa","slot_already_booked_error":"Este horario ya no está disponible","schedule_visit_cta_mobile":"Programa una visita","request_visit_CTA_mobile":"Solicita una visita","schedule_visit_available":"La reserva inmediata está disponible para esta casa","select_request_visit_date":"¿Qué día prefieres?","schedule_visit_no_availabilities_title":"No hay citas disponibles","schedule_visit_no_availabilities_description":"Por desgracia, en este momento no queda ninguna cita libre.","ScheduleVisit_NoSlotModal_CTA_body":"¿Quieres <0>guardar esta casa en tus favoritos</0> para estar al tanto de las novedades?","ScheduleVisit_SelectDate_MoreThan1":"¿Qué día prefieres?","ScheduleVisit_SelectDate_Just1":"Solo queda un día libre","schedule_visit_reminder":"Nos vemos el {{day_of_the_week}} {{date_number}} de {{month}} a las {{time}}","schedule_visit_slot_recap":"El {{day_of_the_week}} {{date_number}} de {{month}} a las {{time}} nos parece bien, ¿confirmas?","schedule_visit_instant_warn":"<0>La reserva se confirmará de inmediato</0>: si confirma, no tendrá que esperar nuestra respuesta.","schedule_visit_flow_next_button":"Continuar","RequestVisit_Modal_Warn":"Espera a que te confirmemos la fecha solicitada","RequestVisit_Modal_Recap":"{{day_of_the_week}}, {{date_number}} de {{month}}, a las {{time}}.\\u2028 Te confirmaremos la visita por teléfono. ¿A qué número te llamamos?","BookCall_Modal_Recap":"{{day_of_the_week}}, {{date_number}} de {{month}}, a las {{time}}.\\u2028¿A qué número te llamamos?","BookCall_Modal_Warn":"Haremos todo lo posible por contactar contigo a la hora que te viene bien","RequestCallModal_Reasonlist_MorePhoto":"Me gustaría ver más fotos","RequestCallModal_Reasonlist_Questions":"Tengo preguntas","RequestCallModal_Reasonlist_Visit":"Me gustaría visitar la casa","request_call_mobile":"Llamadme","RequestCall_ThankYou_Bullet1":"Te llamaremos para resolver todas tus dudas","unknown":"-","RelatedAdsBanner_Title":{"one":"1 casa parecida a esta","other":"{{n}} casas parecidas a esta"},"RelatedAdsBanner_Description":"Descubre casas que <b>solo están en Casavo</b>.","RelatedAdsBanner_CTA":"Ver","NearPropertiesBanner_FirstStep_Description":"📍 Descubre casas <b>cerca de aquí</b>","NearPropertiesBanner_PropertiesProgress":"{{n}}/{{tot}} en la zona","NearPropertiesBanner_FirstStep_CTA":{"one":"Ver 1 casa","other":"Ver {{n}} casas"},"HomePlusBanner_Title":"Descubre Casavo Homeplus","HomePlusBanner_CTA":"Ver las ofertas","HomePlusBanner_Description":"Hemos seleccionado algunas de las mejores marcas para proponerte <b>ofertas exclusivas </b>y ayudarte a sacar el máximo partido a tu nueva casa."}');

/***/ }),

/***/ 47177:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"SearchSettings_Zone_Title":"Zonas","SearchSettings_Modal_ApplyChangesCTA":"Aplicar","SearchSettings_Price_Title":"Presupuesto","SearchSettings_Rooms_Title":"Espacio","SearchSettings_City_Title":"Ciudad:","SearchSettings_CTA":"Actualizar preferencias","SearchSettings_Back":"Salir","SearchSettings_ChangeCityCTA":"Cambiar de ciudad","SearchSettings_Subtitle":"Es la información de partida que nos permite saber qué proponerte","SearchSettings_Title":"Tus preferencias","SearchSettings_Price_Intro":"Hasta:","SearchSettings_Rooms_Intro":"Al menos uno:","SearchSetting_MobileNavBar_Title":"Preferencias","SearchSettings_SuccessBanner_Title":"Preferencias actualizadas","MainSearch_SEO_Title":"Para ti - Nosotros buscamos, tú encuentras"}');

/***/ }),

/***/ 33935:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Login_Button":"Iniciar sesión","Search_Button":"Buscar","Profile_Button":"Perfil","Favorites_Button":"Favoritos"}');

/***/ }),

/***/ 17149:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Priority_ThankyouPage_CTA":"Ver casas en venta","Priority_ThankyouPage_Description":"En cuanto esta casa salga al mercado, serás una de las primeras personas que podrá visitarla.","Priority_ThankyouPage_Title":"¡Todo listo!","Priority_Unsubscribe_Title":"Parece que te apetece desconectar...","Priority_Unsubscribe_Subtitle2":"Notificaciones desactivadas","Priority_Unsubscribe_CTA":"Ver casas en venta","Priority_Unsubscribe_Subtitle1":"Ya no recibirás estos correos electrónicos","Priority_ThankyouPage_PageTitle":"Visita solicitada","Priority_DetailPage_FloatingBanner_Bullet3":"Compra al precio justo","Priority_DetailPage_AdvantagesCard_Advance_Description":"Descubre anuncios de casas en venta antes que nadie.","Priority_DetailPage_AdvantagesCard_Advance_Title":"¡Adelántate!","Priority_DetailPage_AdvantagesCard_Support_Description":"Acompañamos a vendedores y compradores para garantizar un proceso transparente y fiable.","Priority_DetailPage_AdvantagesCard_Waitlist_Title":"Visítala de forma anticipada","Priority_DetailPage_FloatingBanner_Bullet1":"Te llamamos en cuanto esté disponible","Priority_DetailPage_AdvantagesCard_RightPrice_Description":"Tendrás menos competencia y podrás hablar con el vendedor antes que los demás para acordar un precio justo para ambos.","Priority_DetailPage_AdvantagesBox_Description":"Descubre anuncios de casas en primicia en función de tus preferencias.","Priority_DetailPage_FloatingBanner_CTA":"Recibe actualizaciones","Priority_DetailPage_FloatingBanner_Title":"Nueva casa en camino","Priority_DetailPage_PreviewDescription":"Te mostramos esta casa <b>en primicia</b>","Priority_DetailPage_Banner_Description":"Estás viendo una casa <b>en primicia</b>.","Priority_DetailPage_AdvantagesCard_RightPrice_Title":"Precio justo","Priority_DetailPage_AdvantagesCard_Support_Title":"Asistencia","Priority_DetailPage_FloatingBanner_Bullet2":"Visítala antes que nadie","Priority_DetailPage_Banner_CTA":"Más información","Priority_DetailPage_AdvantagesCard_Waitlist_Description":"Si te gusta la casa, puedes visitarla en primicia antes de que salga al mercado.","Priority_DetailPage_AdvantagesBox_Title":"¿Cómo funciona?","Priority_DetailPage_AdvantagesBox_Preview_Description":"Esta casa estará <b>disponible dentro de poco</b>","Priority_DetailPage_SimilarProperties_Title":"Casas similares","Priority_DetailPage_SimilarProperties_Description":"Creemos que estas casas podrían gustarte:","PriorityDetail_FloatingBanner_Booked_Description":"Todo bajo control: \\nLe avisaremos cuando pueda visitarnos.","PriorityDetail_FloatingBanner_Booked_CTA":"Ya está en la lista","Priority404_H1":"Anuncio no disponible","Priority404_CTA":"Sigue buscando","Priority404_Descritpion":"Por desgracia, esta casa ya no está a la venta. Lo sentimos. \\n\\nHaremos todo lo posible por buscarte otras casas que puedas visitar en primicia.","Priority_ThankyouPage_Description_Outro":"Genial, ¿verdad?","Priority_PhoneNumberModal_Banner_Description":"Serás una de las primeras personas en visitarla","Priority_PhoneNumberModal_Title":"Te llamaremos en cuanto tengamos noticias 📞","Priority_ThankyouPage_Bullet1":"Cuando la casa salga al mercado, <b>tendrás prioridad</b> para visitarla.","Priority_ThankyouPage_Description_Intro":"¿Y ahora qué?","Priority_ThankyouPage_Bullet2":"<b>Te llamaremos</b> para concertar la visita.","PriorityCard_PreviewTag":"⏰ CASA EN CAMINO","PriorityCard_NotLoggedBanner_Description":"Sáltate la cola, gratis.","PriorityDetail_TeasingBanner_NotLogged_CTA":"¿Eso qué significa?","PriorityDetail_NotLogged_Intro_CTA":"Accede a las fotos","PriorityDetail_TeasingBanner_NotLogged_Description":"Las <b>casas en primicia</b> son exclusivas para los <b>usuarios de Casavo</b>","PriorityCard_NotLoggedBanner_CTA":"¡Lo quiero!","PriorityDeatil_NotLogged_Intro_Description":"¿Ya tienes una cuenta?","Priority_DetailPage_AdvantagesBox_CTA":"Accede","OnMarketTab":"en el mercado","PriorityTab":"en primicia","PriorityTab_NoResult_Description_logged":"Cuando estén disponibles, aparecerán aquí.","PriorityTab_Title_notlogged":"Visita casas que todavía no están en el mercado","PriorityTab_NoResult_CTA_logged":"Consulta las casas en venta","PriorityTab_Title_logged":"Casas que aún no están en el mercado: visítalas en primicia","PriorityTab_NoResult_Description_notlogged":"Regístrate y llega antes que los demás","PriorityTab_NoResult_CTA_notlogged":"Iniciar sesión","PriorityCard_CTA":"Desbloquear","PriorityDetail-FloatingBanner-DislikeCTA":"No me gusta","Priority_DetailPage_FloatingBanner_CTAmobile":"Recibe actualizaciones","PriorityDetail-FloatingBanner-FeedbackDescription":"Tus comentarios nos ayudan a proponerte otras casas.","PriceAnalysis_HighPrice_Modal_Body":"En este momento, <b>esta casa es ligeramente más cara</b> que otras similares de la zona.\\n<br/><br/>\\nTen en cuenta que, con casas como esta,<b> el precio provisional puede bajar hasta un {{Discount}} % respecto al precio definitivo del anuncio</b>. Por ejemplo, podría pasar de {{AskingPrice}} a {{SuggestedPrice}}.\\n<br/><br/>\\nSi la casa te gusta, anímate a visitarla.<b> Cuanto antes la veas, más fácil te resultará bajar el precio.</b>","PriceAnalysis_GoodPrice_Description":"El precio provisional está en consonancia con el de otras casas similares de la zona. <u>¿Cómo lo sabemos?</u>","PriceAnalysis_HighPrice_Modal_Title":"Precio provisional elevado","PriceAnalysis_GoodPrice_Tag":"Buen precio","PriceAnalysis_GoodPrice_Modal_Body":"Las casas en primicia tienen un precio provisional porque todavía no están en el mercado.\\n<br/><br/>\\n<b>El precio de esta casa es parecido al de otras viviendas similares de la zona.\\n<br/><br/>\\n</b>Si la casa te gusta, dinos que quieres visitarla en primicia. <b>Cuanto antes la veas, menos competencia tendrás para comprarla.</b>","PriceAnalysis_HighPrice_Tag":"Precio elevado","PriceAnalysis_HighPrice_Description":"El precio provisional es superior al de casas similares en la zona. <u>¿Por qué bajará el precio?</u>","PriceAnalysis_GoodPrice_Modal_Title":"Buen precio provisional","PriorityInfoBanner_Title":"{{count}} casas en primicia","PriorityInfoBanner_Description":"Descubre casas que están a punto de salir al mercado. Te hemos reservado sitio para que las visites. <b>Gratis</b>.","PriorityInfoBanner_CTA":"Accede","PriorityCarousel_CTA":"Ver todas","PriorityCarousel_Description":"Visita antes que nadie casas que todavía no están en el mercado","PriorityCarousel_Title":"{{n}} casas en primicia","PriorityCarousel_LastCard_CTA":"🗄️ Ver todas +","PriorityDetailPage_Title":"Primicia"}');

/***/ }),

/***/ 57395:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"disclaimer":"Al hacer clic en \\"{{cta}}\\" declaro que he leído los <0>Términos y Condiciones</0> y la <1>Política de Privacidad</1>","gdpr":{"title":"¿Podemos hacer algo más por ti?","marketing-consent-checkbox":"<0>Manténgame informado sobre Casavo</0>","marketing-consent-details":"Permítanos <0>ponerle al día</0> con nuestras noticias sobre una nueva forma de comprar y vender una casa","marketing-consent-full-text":"Autorizo a Casavo a tratar mis datos para las comunicaciones relativas a las iniciativas y ofertas comerciales."},"mortgage":{"title":"Necesito una hipoteca","short-text":"Doy permiso a Casavo para que me ofrezca el servicio Casavo Mutui.","full-text":"Autorizo a Casavo a procesar y compartir mis datos con las empresas del Grupo Casavo que operan en el sector financiero/hipotecario para enviarme actualizaciones sobre actividades y ofertas, realizar estudios de mercado y actividades destinadas a sondear la calidad de los servicios por teléfono, correo electrónico y mensajería."},"recaptcha":{"disclaimer":"Este sitio está protegido por reCaptcha y por los Términos y <0>condiciones</0> y la <1>Política de privacidad</1> de Google."},"disclaimer-mortgage":"Al hacer clic en \\"{{cta}}\\" doy permiso a Casavo para que me ofrezca el servicio Casavo Mutui."}');

/***/ }),

/***/ 31492:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"area":"localmente","city":"Ciudades","price":"con presupuesto","email_label":"Tu correo electrónico","features_title":"otros filtros:","cta":"Guardar búsqueda","cta_saved":"Búsqueda guardada","no_spam":"Sin spam 1 correo electrónico <0>cada 3 días</0> como máximo","turn_off_notifications":"Desactiva las notificaciones <0>cuando quieras</0>","title":"Le mantendremos informado","your_research":"Su búsqueda","subtitle":"Reciba cómodamente por correo electrónico los nuevos anuncios relacionados con su búsqueda:","only_casavo":"Sólo hogares Casavo","saveSearch-floatingBanner-text":"¿Desea recibir <b>nuevos anuncios</b> de esta búsqueda?","saveSearch-floatingBanner-text1result":"Sólo hay un resultado, ¿desea recibir nuevos anuncios?","saveSearch-floatingBanner-textNewFilters":"Nuevos filtros, nueva búsqueda.\\n¿Actualizando sus anuncios?","saveSearch-floatingBannerFeedback-subtitle":"Recibirá los nuevos anuncios por correo electrónico.","saveSearch-floatingBannerFeedback-title":"Búsqueda guardada","Modal_Title":"Recibe los nuevos anuncios\\nque te interesan","Modal_Zone_intro":"Te avisamos de los anuncios que haya en:","Modal_NoFilterBanner_Title":"¿Quieres afinar la búsqueda?","Modal_NoFilterBanner_CTA":"Añadir filtros","Modal_CTA":"Guardar la búsqueda","Modal_NoFilterBanner_Description":"Puedes añadir filtros para ver resultados más precisos","Modal_Form_Title":"¿Dónde prefieres recibirlos?","Modal_Form_NotificationsMessage":"Puedes desactivar las notificaciones cuando quieras","SearchSearch_Modal_Success_Title":"Alertas activadas","SearchSearch_Modal_Success_Subtitle":"Te enviaremos un correo cuando encontremos anuncios de este tipo.","SearchSearch_Modal_Success_CTA":"Seguir buscando","Modal_Success_Body1":"Recibirá nuevos anuncios\\npara su búsqueda en","Login_BottomSheet_Subtitle":"Te enviaremos nuevos anuncios directamente a tu correo electrónico.","Modal_Success_CTA":"¡Excelente!","Modal_AuthUser_Text":"Los recibirá el","Modal_Success_Body2":"...puedes desconectar la recepción cuando quieras.","Login_BottomSheet_Title":"¿Dónde prefiere recibirlos?","Modal_Success_Title":"Búsqueda guardada","Login_BottomSheet_CTA":"Enviar","Modal_AuthUser_Link":"Perfil","LoaderModal_Description":"Solo un segundo...","Error_InvalidMail_Description":"Parece que el correo electrónico que ha elegido no es válido. Intenta registrarte con otro correo electrónico","Error_InvalidMail_Title":"Email inválido"}');

/***/ }),

/***/ 68242:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"BudgetQuestion_Submit":"¡Hecho!","Suggested_Today_Description":"¿Hemos acertado? ¡Estamos deseando saber qué opinas!","City_Question":"¿En qué ciudad estás buscando?","Suggested_Loader_1":"Navegando por los anuncios...","Suggested_Welcome_Description":"Aquí tienes nuestra selección personalizada de los anuncios que hemos escogido para ti.","Suggested_Welcome_Title":"¡Hola!","MainSearch_Intro_Description":"Responde estas 4 preguntas y te mostraremos las casas más adecuadas para ti. También puedes descubrir casas que todavía no están en el mercado.","MainSearch_Intro_Title":"Dinos lo que quieres y déjanos buscar a nosotros.","Suggested_Today_Title":"Ya en el mercado","Suggested_NoResults_Title":"Juntos encontraremos el hogar adecuado","Suggested_NoResults_CTA":"Ver todos los anuncios","Suggested_NoResults_Description":"Actualmente no hay casas que coincidan con su búsqueda. \\n\\nPero no se preocupe: estamos buscando anuncios que sean perfectos para usted. Los verás aquí a medida que estén disponibles.","Suggested_Flow_TypeQuestion":"¿Cuál es el mínimo de habitaciones que necesitas?","Suggested_Flow_HouseType_1room":{"one":"Estudio","other":"Estudios"},"Suggested_Flow_HouseType_3room":{"one":"Piso de 2 habitaciones","other":"Pisos de 2 habitaciones"},"Suggested_Flow_HouseType_2room":{"one":"Piso de 1 habitación","other":"Pisos de 1 habitación"},"Suggested_Flow_HouseType_4room":{"one":"Piso de 3 habitaciones","other":"Pisos de 3 habitaciones"},"Suggested_Flow_HouseType_5orMore":{"one":"Piso de 4 habitaciones o más","other":"Pisos de 4 habitaciones o más"},"Suggested_Error_CTA":"Recargar","Suggested_Error_Body":"Desafortunadamente, algo no salió como pensábamos, ¿puedes intentarlo de nuevo, por favor?","Suggested_Page_Title":"Casas para ti","Suggested_SuccessToast_Title":"Aquí tienes la nueva sección a la que tendrás acceso a partir de ahora. ¡Esperamos que te guste!","Suggested_Priority_HelpModal_Title":"¿Qué es una casa en primicia?","Suggested_Priority_HelpModal_Description":"Te mostramos casas que están a punto de llegar al mercado. Si encuentras una que te guste, podrás reservar una visita con antelación.\\n\\nTe avisaremos en cuanto haya nuevas casas en primicia disponibles. ¡Prometido!","PriorityCard_Banner":"En primicia","Suggested_Priority_Title":"En primicia","Suggested_Priority_HelpText":"¿Cómo funciona?","Suggested_Priority_NoResult_Banner":"Por ahora no hay casas en primicia","Suggested_UpdateToast_Title":"Hemos actualizado la sección Para ti","Suggested_SearchResume_Intro":"Tus preferencias:","Suggested_SearchResume_BudgetIntro":"Hasta","Suggested_Welcome_Title_Named":"¡Hola, {{name}}!","Suggested_SetPreferenceBanner_Description":"Estas casas coinciden con su antigua investigación. ¿Hay alguna novedad?","Suggested_SetPreferenceBanner_CTA":"Actualizar preferencias","TeasingInbox_MetaTitle":"Para ti - Iniciar sesión","TeasingInbox_MetaDescription":"Aquí tienes todas las casas pensadas para ti según tus búsquedas","ValuationModal_Title":"PRECIO DEL ANUNCIO SUGERIDO ","ValuationModal_DateDescription":"Creado el {{valuation-date}}","ValuationModal_CardTitle":"🎁 Hemos encontrado unas cuantas casas que podrían encajarte.","ValuationModal_CardDescription":"Las encontrarás todas en tu área personal","ValuationModal_CardButton":"Descubre casas para ti","ValuationModal_Title_1":"EL VALOR DE MERCADO","BuyerContactFormWall_Title":"¡Listo!","BuyerContactFormWall_Description":"¿Qué encontrarás?¡\\nLa valoración de tu casa ya está lista!","BuyerContactForm_Reward_Item-1":"Casas recomendadas para ti","BuyerContactForm_Reward_Item-2":"Casas en primicia","BuyerContactFormWall_Button":"Inicia sesión","ForYou_Homeplus_CTA":"Ofertas de <b>Casavo Homeplus</b>","ForYou_Page_Mortgage_CardTitle":"Encuentre la hipoteca perfecta","ForYou_Page_Mortgage_Card_Description":"Calcule online la cuota de su hipoteca o reserve una consulta gratuita.","ForYou_Page_Mortgage_Card_CTA":"Calcular la cuota de la hipoteca "}');

/***/ }),

/***/ 30296:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Priority_DetailPage_FloatingBanner_Desciption":"<b> </b> Te llamaremos en cuanto esté disponible y serás de los primeros en verlo.","PriorityDetail_TeasingBanner_Description":"<b></b> <b></b> Con UniCredit SubitoCasa , puedes visitar esta vivienda con antelación.","Priority_DetailPage_AdvantagesBox_Description":"Se trata de una casa <b>que aún no ha salido al mercado, pero puede que lo haga pronto.</b> Hemos seleccionado sólo a aquellos que, como usted, buscan exactamente una casa así. Con nosotros, <b>puede reservar una visita antes que nadie.</b>","PriceAnalysis_Description":"Precio indicativo sujeto a cambios","Priority_DetailPage_AdvantagesCard_Advance_Description":"Descubre los anuncios de casas en venta, antes que los demás.","Priority_DetailPage_AdvantagesCard_Advance_Title":"Descubra nuevas casas","PriorityDetail_TeasingBanner_Description_v2":"Con <b>UniCredit RE Services,</b> puede visitar esta casa <b>con antelación.</b>"}');

/***/ }),

/***/ 52908:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"meta":{"title":"🔕 Notificaciones desactivadas | Casavo","description":"Las notificaciones para tu búsqueda de casas nuevas en Casavo se han desactivado."},"notifications-disabled":"Notificaciones desactivadas","all-good-here":"Todo tranquilo aquí...","plant-image-alt-text":"En el sofá con una planta a su derecha","done":"¡Hecho!","no-more-messages":"Ya no recibirás nuevos anuncios para tu búsqueda.","cta-browse-all":"Busca entre nuestras nuevas casas"}');

/***/ }),

/***/ 64438:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"search":"Busca","all-zones":"Todas las zonas","seo-title":"Casas en venta en {{city}} {{zone}} | Casavo","seo-description":"Casas en venta en {{zone}}, {{city}}: consulta los anuncios inmobiliarios y encuentra una casa que se adapte a tus necesidades. ¡Más información en Casavo!","search-filters":"Buscar municipio o zona","zones_count":{"all":"Todas las zonas","zones":"{{count}} zonas","zones_one":"{{count}} zona"}}');

/***/ }),

/***/ 73466:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"PropertyAdvantages_Bureaucracy_Title":"Assistance administrative","PropertyAdvantages_Certification_Title":"Certificat de conformité","PropertyAdvantages_SelectedPartners_CardDescription":"Nous tenons également à nous porter garants des <b>personnes avec lesquelles vous échangerez</b>. Nous choisissons nos collaborateurs pour leur transparence, leur professionnalisme et leur connaissance de la ville. <b>Nous avons également acheté des biens chez eux</b> et tout s\'est bien passé. Nous leur faisons entièrement confiance.","PropertyAdvantages_CasavoGuarantee_BannerIntro":"Ce bien bénéficie de la <b>Garantie Casavo</b>","PropertyAdvantages_CasavoGuarantee_BottomBanner_Description":"Nous accompagnons le propriétaire de ce bien dans le processus de vente. Nous pouvons donc en garantir la fiabilité, la qualité et fournir un service personnalisé. Ce ne sont pas nos biens, mais c\'est tout comme.","PropertyAdvantages_FairPrice_Title":"Prix contrôlé","PropertyAdvantages_Fees_Title":"Commissions inférieures à 3 %","PropertyAdvantages_CasavoGuarantee_BottomBanner_Title":"Quels sont les avantages de la « Garantie Casavo » ?","PropertyAdvantages_CasavoGuarantee_From_Title":"Qu’est-ce que la <1>Garantie Casavo</1> ?","PropertyAdvantages_Bureaucracy_CardDescription":"Ne craigniez pas d\'oublier quelque chose. Nous sommes également acheteurs, et les actes notariés sont notre pain quotidien. Nous sommes donc en mesure de vous accompagner dans cette jungle administrative en vous aidant à <b>réunir les documents nécessaires</b> et en vous fournissant une assistance constante.","PropertyAdvantages_CasavoGuarantee_Banner_CTA":"Découvrir","PropertyAdvantages_FairPrice_CardDescription":"Cela signifie que <b>le prix que vous voyez est conforme au marché</b>. Nous le définissons grâce à notre technologie et en comparaison avec les prix de vente de biens similaires. Ces données permettent une analyse très précise du marché.","PropertyAdvantages_SelectedPartners_Title":"Collaborateurs sélectionnés","PropertyAdvantages_Fees_CardDescription":"Vous arrive-t-il de vous demander quel montant vous devrez payer pour la comission ? Nous tenons à dissiper tout doute : nous avons des accords clairs avec nos partenaires et <b>vous ne paierez jamais une commission supérieure à 3 %</b>.","PropertyAdvantages_Card_CTA":"Découvrir","PropertyAdvantages_CasavoProperty_BannerIntro":"Il s\'agit d\'un <b>Bien Casavo</b>","PropertyAdvantages_TransparencyDocumenation_CardDescription":"Nous nous sommes déjà occupés de <b>réunir les documents nécessaires</b>, notamment l\'extrait du parcellaire cadastral actuel et historique, le relevé hypothécaire et l\'acte de provenance. Tout est à votre disposition. En ce qui concerne l\'immobilier, nous non plus, n\'aimons les surprises.","PropertyAdvantages_TransparencyDocumenation_Title":"Certificat de conformité"}');

/***/ }),

/***/ 70612:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Login_Button":"Se connecter","Search_Button":"Rechercher","Profile_Button":"Profil","Favorites_Button":"Favoris","Suggested_Auth_Button":"Pour vous","Suggested_Unauth_Button":"Pour vous"}');

/***/ }),

/***/ 51448:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"AffordabilityTool_firstHouseQuestion_title":"S\'agit-il de votre premier bien* ?","AffordabilityTool_ResultPage_InfoAlert":"Certaines banques peuvent refuser de prendre en compte les revenus issus des contrats à durée déterminée","LandRegistryTax_Label":"Frais cadastraux","AgencyFee_Label":"Frais d\'agence","AffordabilityTool_ResultPage_Expenses_DropDown2_Label":"Quels sont les coûts liés à l\'achat d\'un bien ?","Deposit_Label":"Apport","AffordabilityTool_ResultPage_Analysis_Box1_Description":"En règle générale, les banques demandent que la mensualité du prêt hypothécaire ne dépasse pas 35 % de vos revenus mensuels. Cette mensualité est calculée en tenant compte du <b>montant que vous pouvez avancer</b> et du rapport mensualité/revenu. N\'oubliez pas qu\'il peut y avoir des exceptions en fonction de plusieurs facteurs que les banques évaluent au cas par cas.","AffordabilityTool_ResultPage_NextStepBox_CTA":"Demander des informations","RegistrationTax_Label":"Taxe d\'enregistrement","AffordabilityTool_ResultPage_Expenses_Disclaimer":"*Les frais sont indexés sur le prix total du bien.","AffordabilityTool_ResultPage_Expenses_DropDown1_Label":"Quels sont les frais liés à un crédit immobilier ?","AffordabilityTool_ageQuestion_title":"Quel âge avez-vous ?","TransferTax_Label":"Frais d’hypothèque","AffordabilityTool_ResultPage_Back":"Retour à l\'annonce","AffordabilityTool_ResultPage_Analysis_Box2_Description":"En général, les banques demandent une avance de 20 %. En fonction de la banque et d\'autres variables, il <b>se peut que</b> vous <b>deviez donner moins de 20 %</b>, voire pas d\'avance du tout. Parlons-en, soyons flexibles !","AffordabilityTool_ResultPage_Description_Positive":"Le prix du bien qui a retenu votre attention est situé dans la fourchette budgétaire que vous nous avez indiquée ! <br/>\\n<b>Prochaine étape :</b> vérifier ces informations avec l’un de nos experts 🚀","Application_Label":"Frais de dossier","AffordabilityTool_ResultPage_FloatingBox_Title":"Vos informations","AffordabilityTool_ResultPage_DetailBox_MaxCost":"Montant maximal que vous pouvez emprunter","MandatoryInsurance_Label":"Assurance obligatoire","Interest_Label":"Intérêts","OwnerNumber_Label":"Nombre d’acquéreurs","AffordabilityTool_ResultPage_Expenses_DropDown_Title":"Autres dépenses","AffordabilityTool_ResultPage_Analysis_Title":"Sur quels éléments l\'estimation se base-t-elle ?","Notary_Label":"Frais de notaire","AffordabilityTool_ResultPage_NextStepBox_Description":"Avec le service Casavo Mutui, bénéficiez d’une étude plus approfondie de votre situation et découvrez, si vous le souhaitez, le bien qui répond à toutes vos attentes.","AffordabilityTool_ResultPage_Chart_SelectedProperty":"Annonce sélectionnée","AffordabilityTool_ResultPage_Title":"Voici une première estimation","MonthlyIncome_Label":"Revenus mensuels","VAT_Label":"TVA","AffordabilityTool_ResultPage_Analysis_Box1_Title":"Montant maximal des mensualités de votre emprunt","AffordabilityTool_ResultPage_DetailBox_Title":"Détails","Duration_Label":"Durée","Mortgage_Label":"Crédit immobilier","Appraisal_Label":"Frais d’expertise","OtherLoans_Label":"Crédits en cours","AffordabilityTool_ContactModal_Title":"Vous souhaitez en savoir plus sur vos capacités d’emprunt pour l’achat d’un bien ?","AffordabilityTool_ContactModal_Description":"Nous pouvons répondre à toutes\\nvos questions.","AffordabilityTool_ResultPage_Analysis_Box2_Title":"Apport : au minimum 20 % du prix total du bien","AffordabilityTool_ResultPage_NextStepBox_Title":"L’étape suivante ? 🔮","AffordabilityTool_firstHouseQuestion_description":"*Par « premier bien », nous entendons : \\n<ul>\\n<li> soit votre tout premier achat immobilier </li>\\n<li> soit un bien que vous achetez pour en faire votre résidence principale, bien que vous soyez déjà propriétaire</li></ul>","PurchaseType_label":"Type d\'achat","AffordabilityTool_navigation_nextButton":"Question suivante","SubsituteTax_Label":"Impôt de substitution","Age_Label":"Âge","OthersFee_Label":"Frais administratifs divers","NotaryExpenses_Label":"Frais de notaire","AffordabilityTool_ResultPage_Description_Negative":"Sur la base des informations communiquées, le prix total du bien qui vous intéresse semble ne pas correspondre à vos capacités d’emprunt.<br/><b>Essayons ensemble</b> de mieux comprendre la situation.","AffordabilityTool_otherLoansQuestion_person2_title1":"Votre co-emprunteur a-t-il des crédits en cours ?","AffordabilityTool_otherLoansQuestion_person1_description":"Cela peut concerner des remboursements intervenant dans les 6 prochains mois pour votre voiture, votre téléphone, votre télévision...","AffordabilityTool_jobQuestion_person1_title2":"Quels sont vos revenus mensuels ?","AffordabilityTool_jobQuestion_person1_answer_expanded_option2":"Sous contrat à durée déterminée","AffordabilityTool_otherLoansQuestion_person1_title2":"Au total, à combien s’élèvent vos mensualités pour ces différents crédits ?","AffordabilityTool_ownersQuestion_answer_no":"Non, nous sommes deux","AffordabilityTool_jobQuestion_person1_description2":"Incluez votre salaire net ou le montant de votre allocation retraite <b> calculé sur 12 mois</b>. Si vous êtes indépendant, indiquez une estimation de votre chiffre d’affaires.","AffordabilityTool_jobQuestion_person2_description2":"Indiquez votre salaire net ou votre allocation <b>retraite sur 12 mois</b>. Si vous êtes indépendant, indiquez une estimation de votre chiffre d’affaires.","AffordabilityTool_ownersQuestion_answer_yes":"Oui","AffordabilityTool_otherLoansQuestion_person1_title1":"Avez-vous d’autres crédits en cours ?","AffordabilityTool_jobQuestion_person1_answer_expanded_option1":"Sous contrat à durée indéterminée","AffordabilityTool_jobQuestion_person1_answer_expanded_option3":"Indépendant avec numéro de SIRET","AffordabilityTool_jobQuestion_person1_title1":"Quelle est votre situation professionnelle ?","AffordabilityTool_jobQuestion_person2_title2":"Combien votre co-emprunteur gagne-t-il par mois ?","AffordabilityTool_otherLoansQuestion_person2_title2":"Au total, à combien s’élèvent vos mensualités pour ces différents crédits ?","AffordabilityTool_jobQuestion_person1_answer_expanded_option4":"À la retraite","AffordabilityTool_otherLoansQuestion_person2_answer1_yes":"Non","AffordabilityTool_jobQuestion_person2_title1":"Quelle est la situation professionnelle de votre co-emprunteur ?","AffordabilityTool_ownersQuestion_title":"Êtes-vous le seul emprunteur ?","AffordabilityTool_depositQuestion_title":"Quel serait le montant de votre apport ? ","AffordabilityTool_jobQuestion_person1_answer_collapsed":"Sélectionner une réponse","Affordability_ListingDetailCTA":"Vérifier ma capacité d’emprunt","PurchaseType_FirstHome_Label":"Premier bien","PurchaseType_SecondHome_Label":"Second bien","Fixed_at":"Fixé à","InputError_Loan":"Le coût du financement ne peut pas dépasser le salaire mensuel.","done":"Et voilà !","AffordabilityTool_ResultPage_NextStepBoxSuccess_Description":"Un expert de Casavo Mutui vous contactera dans les plus brefs délais pour étudier, avec vous, votre capacité d’emprunt et répondre à toutes vos questions.","AffordabilityTool_ResultPage_Analysis_DownPaymentBox_WhyProblem":"<b>Votre mise de fonds est de {{mise de fonds}}</b>, mais il vous faudrait une mise de fonds d\'au <b>moins {{min_mise de fonds}}</b> pour acheter cette maison.","AffordabilityTool_ResultPage_Analysis_RateBox_WhyProblem":"<b>Votre mensualité peut être au maximum de {{max_installation}}</b> (35% de salaire, avec un acompte de 20%). \\nPour cette maison, <b>votre mensualité doit être au minimum de {{min_installation}}</b> ({{min_revenu_pourcentage}}% de votre salaire).","AffordabilityTool_ResultPage_Analysis_CTA":"Demandez-nous plus de détails","AffordabilityTool_ResultPage_Expenses_DropDown_Subtitle":"Les dépenses se réfèrent au montant maximum du prêt pouvant être obtenu","AffordabilityTool_ResultPage_Expenses_CTA":"Demande de consultation gratuite"}');

/***/ }),

/***/ 43618:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"LoginPage_Description":"Trouver votre nouveau chez-vous, autrement.","LoginPage_Title":"Bienvenue sur Casavo","UserProfile_Salute":"Bonjour","UserProfile_Description":"Voici votre espace.\\n🚧 Nous sommes en train d\'y apporter la touche finale. 🚧\\n\\nIci, vous pourrez nous décrire le bien de vos rêves et gérer votre recherche.","UserProfile_CTA":"Découvrir les biens","LoginPage_Button_google":"Continuer avec Google","UserProfile_LogoutButton":"Déconnexion","Divider_Smalltext":"ou alors","UserProfile_Dropdown_Favorites":"Vos favoris","SignupWithMail_Input_Password_Placeholder":"Saisissez votre mot de passe","Login_Success_CTA":"C’est noté","LoginWithMail_CTA":"Se connecter","ToSignUp_Description":"Première visite ?","LoginWithMail_Input_Password_Placeholder":"Mot de passe","SignupWithMail_Input_RepeatPassword_Error_NotMatch":"Les mots de passe ne correspondent pas","SignupWithMail_Title":"Créer un nouveau compte","SignupWithMail_CTA2":"Créer un compte","SignupWithMail_Input_RepeatPassword_Placeholder":"Saisissez-le à nouveau","Login_Success_Title":"Vous êtes de retour !","Login_Success_Description":"<b>Vous êtes bien connecté(e)</b>.<br/>C\'est un plaisir de vous revoir.","LoginWithMail_Error_WrongData_Description":"L’e-mail et/ou le mot de passe ne correspondent pas. Veuillez réessayer.","SignupWithMail_CTA1":"Continuer","ToLogin_Description":"Vous avez déjà un compte ?","SignupWithMail_Password_Title":"Choisissez un mot de passe","LoginWithMail_Error_WrongData_Title":"Avez-vous saisi les bonnes informations ?","SignupWithMail_Error_SimplePSW_Title":"Renforcez votre mot de passe","Signup_Success_Description":"Bienvenue chez vous !\\n\\nVous pouvez désormais enregistrer vos biens préférés, activer les notifications pour les recherches qui vous intéressent, et bien plus encore...\\n\\nRechercher un bien n\'a jamais été aussi simple.","Input_Email_Placeholder":"Saisissez votre email","Signup_Success_Title":"Vous êtes parmi nous","ToSignUp_CTA":"Créer un compte","LoginPage_WithMail_CTA":"Se connecter avec votre mail","SignupWithMail_Error_SimplePSW_Description":"Pour des raisons de sécurité, veuillez choisir un mot de passe plus compliqué.","SignupWithMail_Input_Password_Error_ShortPsw":"8 caractères minimum","SignupWithMail_Alert_ExistingAccount_Title":"Vous êtes déjà des nôtres","SignupWithMail_Alert_ExistingAccount_Description":"Cet email est déjà enregistré, vouliez-vous vous connecter ?","SignupWithMail_Alert_ExistingAccount_CTA":"Se connecter","Login_Favorites_BottomSheet_Title":"Connectez-vous pour l\'ajouter à vos favoris","Login_SaveSearch_BottomSheet_Title":"Connectez-vous pour enregistrer\\n votre recherche","LoginWithMail_Title":"Connectez-vous avec votre mail","RecoverPassword_Code_Title":"Vérifiez votre e-mail","RecoverPassword_Code_CTA":"continue","NewPassword_Success_Description":"Parfait! Votre nouveau mot de passe est en sécurité, où en étions-nous ?","RecoverPassword_Code_Sendto":"Nous avons envoyé le code de sécurité à","RecoverPassword_Code_Description":"Entrez le code que vous avez reçu ici :","NewPassword_Title":"Choisissez un nouveau mot de passe","NewPassword_Success_Title":"Mot de passe enregistré","RecoverPassword_CTA":"Recevez le code","Login_ToRecoverPassword":"Mot de passe oublié?","NewPassword_CTA":"Confirmer","RecoverPassword_Description":"Nous vous enverrons un code pour configurer votre nouveau mot de passe. Entrez l\'e-mail que vous avez utilisé pour vous enregistrer:","RecoverPassword_Title":"réinitialiser le mot de passe","RecoverPassword_Error_InvalidCode_Description":"Le code que vous avez entré est incorrect ou a expiré. Vérifier ou envoyer un autre","RecoverPassword_Error_InvalidCode_Title":"Code invalide","Login_ScheduleVisit_BottomSheet_Title":"Connectez-vous pour débloquer la réservation instantanée","Login_Suggested_BottomSheet_Title":"C’est presque fini !\\nIl ne manque plus que votre nom.","Social_Login_Error_Message":"Une erreur s\'est produite avec votre compte Google. Veuillez réessayer avec votre adresse e-mail.","Social_Login_Error_Cta":"Revenir en arrière","Login_PriorityDetail_BottomSheet_Title":"Ok ! En attendant, quel nom devons nous mettre sur la liste ?","Login_RequestVisit_BottomSheet_Title":"Nous vérifions les disponibilités. En attendant, quel nom devons-nous indiquer ?","Login_TeasingInbox_Title":"Heureux de vous revoir ! Une nouvelle section vous est réservée.","Login_FromContactFrom_Title":"Avec plaisir ! Comment vous appelez-vous ?","Login_PriorityDetail_BottomSheet_UnlockTitle":"Découvrez des biens qui ne sont pas encore sur le marché.","BuyerContactFormModal_Title":"Il ne manque plus que votre nom."}');

/***/ }),

/***/ 17903:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"SearchStatus_Answer3":"Je suis sur le point de faire une offre d\'achat","HouseType_1room":"Studio","HouseType_4orMore":"4 pièces ou plus","SearchStatus_Answer4":"J\'ai déjà fait une offre d\'achat","SearchBar":"Indiquez un secteur...","SearchStatus_Answer1":"Je commence ma recherche","ThankYou_Title":"À nous de jouer...","SearchStatus_Question":"Où en êtes-vous dans votre recherche ?","Intro_Description":"Vous répondez, et nous vous trouvons une maison. Nous pouvons vous proposer des maisons sur mesure, avant même leur mise sur le marché.","NoResult_Title":"Ensemble, nous trouverons le bien idéal","Intro_Title":"Quelques clics suffisent.","MaxBudget_Input_Placeholder":"€","Form_Description":"Maintenant, nous savons exactement ce que vous recherchez. Dernière chose : comment pouvons-nous vous contacter ?","NoResult_Description":"Pour l\'instant aucun bien ne correspond à vos critères. Aidez-nous à vous proposer les biens qui vous conviennent parfaitement, avant même qu\'ils ne soient mis sur le marché.","ThankYou_CTA":"Voir les biens","NoResult_CTA":"Dites-nous en plus","MaxBudget_Question":"Quel est votre budget maximum ?","Form_Mail_Placeholder":"Votre adresse mail","Form_Name_Placeholder":"Votre nom","ThankYou_Description":"Nous sommes impatients de trouver la maison parfaite pour vous. A bientôt !","FewResult_Title":"Vous désirez découvrir les biens disponibles en exclusivité ?","SearchStatus_Answer2":"J\'ai déjà visité quelques biens","HouseType_Question":"Quel type de bien recherchez-vous ?","Form_Title":"Réponses enregistrées","MaxBudget_Description":"La question que tout le monde redoute, mais qui est fondamentale pour une recherche optimale.","FewResult_Reset":"Modifier les filtres","NoResult_Reset":"Modifier les filtres","Zone_Question":"Quels quartiers de {{city}} vous intéressent ?","HouseType_3rooms":"3 pièces","HouseType_4rooms":"4 pièces","HouseType_2rooms":"2 pièces","FewResult_Description":"Nous pouvons vous proposer des biens qui correspondent à vos critères, avant même qu\'ils ne soient mis sur le marché.","Zone_Noresult":"Vous ne trouvez pas ce que vous cherchez ?<br/>\\nFaites défiler <0>la liste des zones</0>."}');

/***/ }),

/***/ 43190:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"terrace":{"label":"Terrasse","title":"Biens avec terrasse à vendre à {{city}} | Casavo","description":"Découvrez toutes les annonces d\'appartements avec terrasse à vendre à {{city}}. Casavo ne collabore qu\'avec des agences sélectionnées. Trouvez maintenant le bien de vos rêves !"},"balcony":{"label":"Balcon","title":"Biens avec balcon à vendre à {{city}} | Casavo","description":"Découvrez toutes les annonces d\'appartements avec balcon à vendre à {{city}}. Casavo ne collabore qu\'avec des agences sélectionnées. Trouvez le bien de vos rêves dès maintenant !"},"studios":{"label":"F1","title":"F1 à vendre à {{city}} | Casavo","description":"Découvrez toutes les annonces de F1 à vendre à {{city}}. Casavo ne collabore qu\'avec des agences sélectionnées. Trouvez maintenant le bien de vos rêves !"},"one-bedroom-apartments":{"label":"F2","title":"F2 à vendre à {{city}} | Casavo","description":"Découvrez toutes les annonces de F2 à vendre à {{city}}. Casavo ne collabore qu\'avec des agences sélectionnées. Trouvez maintenant le bien de vos rêves !"},"two-bedroom-apartments":{"label":"F3","title":"F3 à vendre à {{city}} | Casavo","description":"Découvrez toutes les annonces de F3 à vendre à {{city}}. Casavo ne collabore qu\'avec des agences sélectionnées. Trouvez maintenant le bien de vos rêves !"},"new-constructions":{"label":"Bien neuf","title":"Biens neufs à vendre à {{city}} | Casavo","description":"Découvrez toutes les annonces de biens neufs à vendre à {{city}}. Casavo collabore uniquement avec des agences sélectionnées. Trouvez dès maintenant le bien de vos rêves !"}}');

/***/ }),

/***/ 17532:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"claim":"<0> Ce bien est un<1>Bien Casavo</1></0>","claim_cta":"<0> Ce bien est un<2>Bien Casavo</1></0>","title":"Biens Casavo : nous en sommes propriétaires.","title_detail":"C’est un Bien Casavo","text":"<0>Nous savons que trouver un bien en vente qui corresponde à vos critères n\'est pas toujours facile.</0><0>Les Biens Casavo sont achetés et rénovés par nos soins, vous n\'aurez donc pas de mauvaises surprises.</0><0>C\'est ce que l\'on fait de mieux et à un prix qui n\'est jamais supérieur à la moyenne du marché.</0><1>Trouvez-le grâce<2/> à nos annonces ! </1>","text_detail":"Tout pour que vous puissiez profiter de votre nouveau bien en toute tranquillité...","discover_all_the_advantages":"Découvrez tous les avantages","modal_subtitle":"<0>Vous pouvez avoir l\'esprit tranquille : les Biens Casavo, dont certains ont été rénovés, sont inspectés et entretenus par nos soins.</0><1>C\'est l\'une de nos spécialités, en plus des nombreux services exclusifs qui vous sont dédiés.</1>","list_item_discount_modal_description":"Nous ne pouvons pas tout vous dire ici, nous ne voulons pas perturber vos recherches... Découvrez tous les avantages de Casavo, notre équipe se tient à votre disposition ❤️","good_to_know":"Bon à savoir !","what_does_it_mean":"En savoir plus","modal_list_items":[{"title":"Prestations incluses dans le service :","items":[{"title":"Deux ans d\'assurance","description":"Si nous avons rénové ce bien, vous bénéficiez également de 2 ans d\'assurance et de réparations gratuites."},{"title":"Assistance après achat","description":"Notre service clientèle se tiendra à votre disposition pour tous vos besoins, avant et même après la signature de l\'acte."},{"title":"Une équipe toujours à vos côtés","description":"Experts du marché immobilier, conseillers financiers, décorateurs d\'intérieur et architectes... Notre équipe est composée d’experts en mesure de vous accompagner jusqu\'à l\'achat de votre nouveau bien."}]},{"title":"...mais aussi d\'autres services tels que :","items":[{"title":"Service d\'hypothèque","description":"Choisissez votre bien préféré, Casavo Mutui s\'occupe de l\'hypothèque. Un consultant dédié se chargera de tout le volet administratif.","image":"loan"},{"title":"Ameublement et décoration d\'intérieur","description":"Vous avez aimé la façon dont était aménagé le bien dans les visites virtuelles ? Vous pouvez demander à l\'acheter ainsi, entièrement meublé !","image":"furniture"},{"title":"Partenariats exclusifs","description":"Électricité, gaz, Wi-Fi, systèmes d\'alarme, appareils électroniques et bien plus encore.","image":"discount"}]}],"advantage_first":"Service d\'hypothèque","advantage_second":"Assistance après achat","advantage_third":"Une équipe toujours à vos côtés"}');

/***/ }),

/***/ 97038:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"available":"disponibles","available-singular":"disponible","title":"Appartements à vendre | Casavo","title-listing":"Appartements à vendre à {{city}} | Casavo","description":"Découvrez toutes les annonces de biens à vendre dans les principales villes italiennes et trouvez le bien de vos rêves sur Casavo.com !","description-listing":"Découvrez toutes les annonces de biens à vendre à {{city}} et trouvez le bien de vos rêves sur Casavo.com !","loading":"Chargement...","of":"sur","of2":"de","entrance_floor":"Étage","entrance_floors":"Étages","basement":"Sous-sol","raised":"Mezzanine","ground_floor":"Rez-de-chaussée","last_floor":"Dernier étage","mid_floor":"Étage intermédiaire","select_city":"Sélectionner une ville","rooms":"Pièces","bathrooms":"Salles de bain","bedrooms":"Chambres","status":"État","habitable":"Habitable","new":"Bien neuf","renovated":"Rénové","need_renovation":"À rénover","under_construction":"En cours de construction","private_negotiation":"Négociation privée","get-free-offer-label":"Vendre un bien","get-free-offer-small-label":"Vendre un bien","our-properties-label":"Acheter un bien","our-properties-small-label":"Acheter","our-clients-label":"Nos clients","are-you-broker-label":"Vous êtes une agence ?","footer-service-label":"Services","footer-resources-label":"Ressources","footer-about-us-label":"Entreprise","footer-our-properties-label":"biens à vendre","footer-press-label":"On parle de nous","footer-blog-label":"Blog","footer-faqs-label":"Questions fréquentes","footer-work-label":"Nous rejoindre","footer-work":"https://careers.casavo.com","footer-contact-label":"Contactez-nous","footer-casavo-es-label":"Casavo España","footer-casavo-pt-label":"Casavo Portugal","footer-legal-label":"Données sur l\'entreprise","footer-privacy-label":"Politique de confidentialité","footer-terms-label":"Conditions générales","footer-made-with":"Fait avec","footer-made-in":"en Italie","for-sale":"à vendre","listing_not_found_title":"Annonce indisponible","listing_not_found_similar_properties_subtitle":"L\'annonce que vous recherchez a été supprimée ou la maison a déjà été vendue.","listing_not_found_cta":"Découvrez tous les biens","text-list":"Liste","text-map":"Carte","open-map":"Ouvrir la carte","no-listings-in-city":"Malheureusement, il n\'y a pas encore de biens disponibles dans cette ville :(","casavo-properties-title":"Bien Casavo","cta_show_virtual_tour":"Visite virtuelle","enter_virtual_tour":"Entrer dans le bien","message_virtual_tour":"Visite virtuelle","view_property":"Voir les détails","page":"Page","photos":"Photo","pagination-bottom":"sur {{length}} biens","of-pagination":"de","tooltip-text":"Le prix des biens Casavo n\'est jamais supérieur à la valeur du marché","houses-for-sale-in-area":"Biens <0>aux alentours de {{area}}</0>","house-for-sale-in-area":"Bien <0>aux alentours de {{area}}</0>","houses-for-sale-in-city":"biens <0>à {{city}}</0>","house-for-sale-in-city":"Bien à vendre <0>à {{city}}</0>","houses-for-sale-in-zone":"biens <0>dans le secteur de {{zone}}</0>","house-for-sale-in-zone":"bien<0>dans le secteur de {{zone}}</0>","house-for-sale-byZone-filter":"bien <0>dans le secteur de {{area}}</0>","houses-for-sale-byZone-filter":"biens <0>dans le secteur de {{area}}</0>","outdoor_space_label":"Espace extérieur","new_listing_label":"Nouveauté !","tooltips":{"casavo_property":"Le prix des biens Casavo n\'est jamais supérieur à la valeur du marché","outdoor_space":"Profitez d\'un extérieur ! Ce bien dispose d\'une terrasse ou d\'un jardin.","energy_efficient":{"A_B":"Bon pour l\'environnement 🌳. Ce bien a une classe énergétique supérieure à B.","C":"Plus efficace, plus confortable. Ce bien a une classe énergétique supérieure à B."}},"read_more":"autre...","read_less":"afficher moins","invalid-email-message":"Pouvez-vous vérifier que l\'adresse e-mail est correcte ?","required-field-message":"Champ obligatoire","mortgage":{"title":"Service d\'hypothèque","text":"Hypothèque : vous n\'avez qu\'un mot à dire.<0/>Nous vous accompagnons, <0/>de la recherche à la signature.","cta":"Dites-m\'en plus sur Casavo Mutui","contact-us":"Nous sommes à votre disposition<0/>Contactez-nous quand vous le souhaitez"},"mortgage-modal":{"title":"Nous nous occupons de la partie la moins agréable.","content-top":"Chez Casavo, nous mettons à votre disposition une équipe dédiée et spécialisée pour prendre en charge votre dossier de prêt hypothécaire et en assurer le suivi avec la banque de votre choix. Vous pourrez consacrer votre temps à autre chose !","content-bottom":"Plus de 110 clients ont déjà profité de notre service et obtenu leur prêt hypothécaire 15 jours à l\'avance. Gratuitement.","more":"Vous désirez en savoir plus ?","call":"Nous appeler"},"form-error":"Une erreur est survenue. Veuillez réessayer s’il vous plaît.","where-looking-for":"Où recherchez-vous ?","province":"Département","province-of":"Aux alentours de {{area}}","municipality":"Commune","menu":{"sell":"Vendre","buy":"Acheter","our-clients":"Nos clients","agency":"Vous êtes une agence ?","about":"À propos"},"listings":{"canonical-links-title":"Caractéristiques des biens à {{city}} :","most-visited-zones-title":"Annonces immobilières à {{city}} :"},"prev":"Précédent","next":"Suivant","footer-team-label":"Équipe","footer-partner-label":"Devenez partenaire","footer-casavo-it-label":"Casavo Italia","invalid-phone-message":"Numéro de téléphone non valide","casavo-inventory-agency-title":"Garantie Casavo","CTA_Next":"Question suivante","GenericError_Modal_Description":"Malheureusement, une erreur s\'est produite, pouvez-vous réessayer s\'il vous plaît ?","GenericError_Modal_Title":"Oups...","simple_confirm":"C’est noté","No":"Non","Yes":"Oui","years":"années","Header_AddressFormat":"<0>{{streetNumber}} {{streetName}}</0><1>{{city}}</1>","address_format":"{{streetNumber}} {{streetName}}, {{city}}"}');

/***/ }),

/***/ 85315:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"agency":{"message":{"cta":"Vous voulez nous en dire plus ?","label":"Dites-nous en plus","placeholder":"Vous avez des questions ? \\nQuand souhaitez-vous être contacté ?"},"success":{"message":"Vous venez de franchir la première étape.\\nNotre partenaire vous contactera dans les plus brefs délais.","cta":"Voir des biens similaires"}},"casavo":{"assistant":"Votre assistant Casavo","name":"Nom","reason":{"placeholder":"Nous sommes ravis que ce bien vous plaise ! Que pouvons-nous faire pour vous ?","warning":"En sachant cela, nous pourrons vous aider plus rapidement","options":{"morePhotos":"J\'aimerais voir plus de photos et en savoir plus","moreAboutHouse":"J\'aimerais obtenir plus d\'informations sur ce bien","other":"Autre..."}},"title":"<0>Votre expérience <1>Casavo</1> commence ici.</0>","success":{"title":"Vous avez franchi la première étape !","subtitle":"À partir de maintenant, vous pouvez compter sur nous.<0/> Nous vous contacterons au plus vite.","postScriptum":"PS : Nous avons bien reçu votre demande\\net nous la traiterons en priorité.","cta":"Voir les biens similaires"}},"phone":"Votre numéro de téléphone","submit":"Envoyer","email":{"label":"Votre adresse mail","success":"Demande reçue, merci ! Gardez un œil sur votre messagerie pour les prochaines étapes"},"success":{"toFlow":{"title":"Vous vendez votre bien ?","subtitle":" ","cta":"Demander une estimation"}},"ContactForm_SuccessSaveSearch_CTA_Primary":"Recevoir des alertes","ContactForm_SuccessSaveSearch_CTA_Secondary":"Non, merci","ContactForm_SuccessSaveSearch_Subtitle":"Nous les envoyons commodément à votre adresse électronique","ContactForm_SuccessSaveSearch_Title":"Souhaitez-vous recevoir de nouvelles annonces similaires à celle-ci ?","ContactForm_SuccessSaveSearch_OkFeedback":"Alertes déclenchées","name":"Nom","lastname":"Nom de famille"}');

/***/ }),

/***/ 67973:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Favourites_FavouriteList_AutodeleteMessage":"Si un bien n’est plus disponible, l’annonce sera supprimée automatiquement dans les 20 jours.","Favourites_FavouriteList_FavouriteCard_Unavailable":"Cette annonce n’est plus disponible","Favourites_FavouriteList_DeleteConfirm_title":"Supprimer ce bien de vos favoris ?","Favourites_FavouriteList_DeleteConfirm_cancelCTA":"Annuler","Favourites_FavouritesList_Title":"Vos favoris","Favourites_FavouriteList_EmptyState":"Si un bien vous plaît, cliquez sur <icon/> pour l\'enregistrer dans vos favoris.","Favourites_FavouriteList_ConfirmToast_title":"Annonce supprimée de vos favoris","Favourites_FavouriteList_DeleteConfirm_mainCTA":"Supprimer","Favourites_FavouriteList_ConfirmToast_body":"Pas d’inquiétude, vous aurez d’autres coups de cœur.","Favourites_FavouriteList_EmptyStateMain":"Vous avez eu un coup de foudre ?","Favourites_FavouritesList_SubTitle1":{"one":"{{count}} annonce vous a tapé dans","other":"{{count}} annonces vous ont tapé dans l\'œil"},"Desktop_Saved":"Enregistré","Desktop_Save":"Enregistrer","FavouritesList_Desktop_BackToSearch":"Retour à la recherche","FavouriteList_EmptyState_Unauth_CTA":"Se connecter","FavouriteList_EmptyState_Unauth_Title":"Un coup de cœur ?","FavouriteList_EmptyState_Unauth_Description":"Connectez-vous pour enregistrer les biens qui vous plaisent et pouvoir les retrouver facilement.","Favourites_Add_To_Favorite_CTA":"Enregistrer dans les favoris"}');

/***/ }),

/***/ 9660:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"change-filters":"Modifier les filtres","price":"Prix","surface":"Surface","room":"Pièce","rooms":"Pièces","status":"État","other_filters":"Autres filtres","properties":"Biens","property":"bien","properties_for_you":"Biens disponibles","property_for_you":"Bien disponible","no_properties":"Aucun bien disponible","last_uploaded":"Plus récentes","most_relevant":"Plus pertinents","cheapest":"Prix croissant","most_expensive":"Prix décroissant","area_max":"Surface décroissante","area_min":"Surface croissante","no_properties_for_filters_title":"Actuellement, aucun bien ne présente ces caractéristiques.","no_properties_for_filters_subtitle":"Essayez de modifier les filtres pour afficher plus de résultats","save":"Sauvegarder","from":"De","to":"A","max":"Max","min":"Min","filters":"Filtres","trendy_filters":"Filtres populaires","filter_by":"Filtrer par","reset":"Réinitialiser","undo":"Annuler","apply":"Appliquer","only_casavo":"Afficher uniquement les biens Casavo","price_guaranted":"Prix garanti","renovated_properties":"Biens rénovés","assistance_guaranted":"Assistance professionnelle","typology":"Type de bien","bathroom":"Salle de bain","bathrooms":"Salles de bain","bedroom":"Chambre","bedrooms":"Chambres","entrance_floor":"Étage","state_of_manteinance":"État du bien","state_at_deed":"Statut à l\'acte","services":"Services","heating_system":"Chauffage","year_of_construction":"Année de construction","anyone_choice":"Tout","apartment":"Appartement","house":"Maison indépendante","townhouse":"Maison mitoyenne","villa":"Maison","loft":"Loft","attic":"Appartement en attique","mansard":"Bien mansardé","basement":"Sous-sol","raised":"Mezzanine","ground_floor":"Rez-de-chaussée","last_floor":"Dernier étage","mid_floor":"Étage intermédiaire","habitable_status":"Habitable","new_status":"Bien neuf","renovated_status":"Rénové","need_renovation_status":"À rénover","under_construction_status":"En cours de construction","OCCUPIED":"Occupé","FREE":"Libre","RENTED":"Loué","BARE_OWNERSHIP":"Nue-propriété","elevator":"Ascenseur","parkingSpaces":"Parking","box":"Box auto","garage":"Box auto","cellar":"Cave","garden":"Jardin","balcony":"Balcon","balconies":"Balcons","terrace":"Terrasse","terraces":"Terrasses","pool":"Piscine","coolingSystem":"Clim","conciergeService":"Conciergerie","AUTONOMOUS":"Individuel","SHARED":"Central","NONE":"Aucun","at_least":"Au moins","single_filter":"filtre","single_filters":"filtres","milan":"Milan","turin":"Turin","bologna":"Bologne","verona":"Vérone","rome":"Rome","florence":"Florence","only_casavo_filter_label":"Afficher uniquement les Biens Casavo","ranking":"Par défaut","trendy_filters_description":"Lorsqu\'ils sont utilisés, ces filtres nous aident à vous proposer les biens qui correspondent à votre recherche","other_filters_description":"Tout ce dont vous avez besoin pour trouver le bien de vos rêves","filters_zone_suggestion_title":"Où cherchez-vous ?","filters_zone_suggestion_description":"Gagnez du temps en <0>sélectionnant une zone.</0>"}');

/***/ }),

/***/ 52070:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Furniture_DetailPage_FurnitureBanner_Title":"Et si vous achetiez un bien déjà meublé ?","Furniture_DetailPage_FurnitureBanner_CTA":"Que comprend-il ?","Furniture_DetailPage_FurnitureBanner_Body":"Nous avons réalisé un projet d\' <b>ameublement sur mesure</b> pour ce bien immobilier.","Furnitures_Detailpage_FurniturePriceTag":"Mobilier disponible","Furniture_PhotoCarousel_Toast_CTA":"Consulter le projet","Furniture_PhotoCarousel_Toast_Body":"Voici le projet d\'ameublement que nous avons créé sur mesure pour ce bien","Furniture_PhotoCarousel_Toast_Title":"Cet aménagement vous plaît-il ?","Furniture_Modal_Title":"Notre projet sur mesure pour vous","Furniture_Modal_FormTitle":"👇 Découvrez le projet d\'ameublement dès maintenant","Furniture_Modal_Bullet_2":"<b>Choisissez votre ameublement</b> dans les moindres détails.","Furniture_Modal_MktgConsent_Description":"Vous acceptez de recevoir nos actualités sur les nouveautés en matière d\'aménagement et sur nos services","Furniture_Modal_Bullet_3":"<b>Les meilleures marques </b> sont à votre disposition :","Furniture_Modal_CTA":"Découvrir le projet","Furniture_Modal_Bullet_1":"<b>Meubles de cuisine, de salle de bain et rangements</b> pour votre nouveau bien","Furniture_ServiceName":"Interior","Brand_CasavoServices":"Casavo Services"}');

/***/ }),

/***/ 7133:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Items0_Title":"Pour vendre facilement","Items0_Description":"Détendez-vous. Nous achèterons votre maison ou nous trouverons un acheteur pour vous.","Items1_Title":"Pour Casavo Mutui","Items1_Description":"Et dites adieu à la bureaucratie. Nous trouvons le meilleur prêt hypothécaire pour vous.","Items2_Title":"Pour les personnes qui parlent de nous","Items2_Description":"Que dit la personne qui nous a choisis ? Découvrez les histoires de ceux qui nous connaissent déjà.","Footer_Title":"D\'autres questions ?","Footer_Description":"Nous avons toujours une réponse à toutes les questions que vous nous posez. Et si vous ne les trouvez pas toutes, contactez-nous. Nous sommes ici.","Title":"Casavo Parce que"}');

/***/ }),

/***/ 40322:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"find-your-house":"Découvrez les biens <0/>à vendre susceptibles de vous intéresser à"}');

/***/ }),

/***/ 74661:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title_not_found":"Bien introuvable","characteristics":"Caractéristiques","description":"Description","the_district":"Le quartier","at_your_service":"À votre disposition","at_your_service_message":"Nous vous contacterons quand vous le souhaitez.","show_number":"Afficher le numéro","show_number_casavo":"Nous appeler","request_info":"Demander des informations","request_visit":"Convenir d\'une date de visite","request_visit_modal_title":"Demander une visite","request_visit_modal_thank_you_title":"Attendez notre confirmation","contact_us":"Contactez-nous","contact_email":"Votre adresse mail","contact_phone_number":"Votre numéro","fomo_message_person":"<0>{{userViews}} personne</0> a vu cette annonce durant la dernière heure","fomo_message_people":"<0>{{userViews}} personnes</0> ont vu ce bien durant la dernière heure","phone_call":"Nous appeler","phone_call_now":"Nous appeler maintenant","rooms":"Pièces","bathrooms":"Salles de bain","bedrooms":"Chambres","balconies":"Balcons","terraces":"Terrasses","balcony":"Balcon","terrace":"Terrasse","status":"État","planimetry":"Plan","services":"Autres critères","see_all_characteristics":"Voir tout","see_less_characteristics":"Voir moins","elevator":"Ascenseur","parkingSpaces":"Parking","box":"Box auto","basement":"Cave","garden":"Jardin","coolingSystem":"Clim","coolingSystem_full":"Clim","coolingSystem_AUTONOMOUS":"Individuel","coolingSystem_SHARED":"Centralisée","coolingSystem_READY_FOR_INSTALLATION":"Prête à être installée","coolingSystem_NONE":"Non","conciergeService":"Conciergerie","recreationRoom":"Sous-sol","garret":"Combles","pool":"Piscine","sharedPool":"Piscine commune","tennisCourt":"Terrain de tennis","fireplace":"Cheminée","disabledAccess":"Accès handicapé","wallCabinet":"Rangement mural","fastInternet":"Fibre optique","hydromassage":"Hydromassage","tvSystem":"Système TV","electricGate":"Portail électrique","armoredDoor":"Portée blindée","alarmSystem":"Alarme","entranceVideoPhone":"Visiophone","year_of_construction":"Année de construction","year_of_renovation":"Année de la dernière rénovation","exposure":"Exposition","NORTH":"Nord","SOUTH":"Sud","EAST":"Est","WEST":"Ouest","furniture":"Ameublement","FULLY_FURNISHED":"Entièrement meublé","NOT_FURNISHED":"Non meublé","PARTIALLY_FURNISHED":"Partiellement meublé","estate_registry_class":"Catégorie cadastrale","energy_rating_label":"Classe énergétique","energy_performance_index_label":"Indicateurs de performance énergétique (IPE)","energy_performance_index_udm":"kWh/m² an","energy_rating":{"energy_a4":"A4","energy_a3":"A3","energy_a2":"A2","energy_a1":"A1","energy_aplus":"A+","energy_a":"A","energy_b":"B","energy_c":"C","energy_d":"D","energy_e":"E","energy_f":"F","energy_g":"G","energy_pending_request":"En cours"},"kitchen":"Cuisine","kitchen_HABITABLE":"Cuisine indépendante","kitchen_HALF_HABITABLE":"Cuisine indépendante","kitchen_KITCHENETTE":"Kitchenette","kitchen_OPEN":"Cuisine ouverte","glazing":"Vitrage","glazing_SINGLE":"Simple vitrage","glazing_DOUBLE":"Double vitrage","glazing_TRIPLE":"Triple vitrage","info":"Info","condo_fees":"Charges de copropriété","per_year_label":"annuels","state_at_deed":"Statut à l\'acte","OCCUPIED":"Occupé","FREE":"Libre","RENTED":"Loué","BARE_OWNERSHIP":"Nue-propriété","heating_system":"Chauffage","AUTONOMOUS":"Individuel","SHARED":"Central","NONE":"Aucun","exclusive_mandate":"Mandat d\'exclusivité","cta_show_photos":"Voir {{photoLength}} photos","cta_show_virtual_tour":"Visite virtuelle","cta_show_virtual_tour_mobile":"Visite","apartment":"Appartement","house":"Maison indépendante","townhouse":"Maison mitoyenne","villa":"Maison","loft":"Loft","attic":"Appartement en attique","mansard":"Bien mansardé","sharing":"Partager","might_interest_you":"Biens similaires","based_on_your_searches":"Ces biens pourraient vous plaire :","poi_nearby":"À proximité de ce bien, vous trouverez :","poi_discover":"Découvrir :","TRANSPORT":{"poi_category":"Transports","poi_nearby_card_title":"Transports","poi_nearby_card_distance":"L\'arrêt le plus proche <1/>est situé <0>à {{distance}} m</0>","BUS_STOP_distance":"Arrêt de bus à {{distance}} m","TRAIN_STATION_distance":"Arrêt à {{distance}} m","SUBWAY_STATION_distance":"Station de métro à {{distance}} m","TRAM_STOP_distance":"Arrêt de tram à {{distance}} m","poi_nearby_card_all":"Voir les transports","BUS_STOP_label":"Bus","TRAIN_STATION_label":"Train","SUBWAY_STATION_label":"Métro","TRAM_STOP_label":"Tram"},"SCHOOL":{"poi_nearby_card_title":"Écoles","poi_nearby_card_distance":"L\'école la plus proche <1/>est située <0>à {{distance}} m</0>","SCHOOL_distance":"École à {{distance}} m","poi_category":"Écoles","poi_nearby_card_all":"Voir les écoles","SCHOOL_label":"École"},"SHOP":{"poi_nearby_card_title":"Supermarchés","poi_nearby_card_distance":"Le supermarché le plus proche <1/>est situé <0>à {{distance}} m</0>","SHOP_distance":"Supermarché à {{distance}} m","poi_nearby_card_all":"Voir les supermarchés","poi_category":"Supermarchés","SHOP_label":"Supermarché"},"properties":"Biens","neighborhood":"dans les environs...","more_about_neighborhood":"En savoir plus sur le quartier","less_about_neighborhood":"Voir moins","last_update":"Annonce mise à jour le :","street-view":{"address-disclaimer":"Situation indicative","description":"Street View","cta":"Street View"},"at_your_service_agency":"<0>Nos conseillers immobiliers</0> à votre disposition","at_your_service_casavo":"Que signifie <1>Bien Casavo</1> ?","form-header":{"title":"Ce bien vous plaît ?","subtitle_casavo":"Ne laissez pas passer pas cette opportunité, nous allons vous contacter","subtitle_agency":"Ne laissez pas passer cette opportunité, un conseiller immobilier Casavo Paris répondra à toutes vos questions","agency":{"one":"Annonce vérifiée par nos conseillers","two":"Accompagnement personnalisé jusqu’au notaire"},"casavo":{"one":"Bien contrôlé et certifié par Casavo","two":"Assurance et assistance dédiées","three":"Service d\'hypothèque","four":"Tous les services de Casavo pour la meilleure expérience immobilière"},"subtitle_casavo_inventory_agency":"Nous pouvons répondre à toutes vos questions.","casavo-agency":{"one":"Commissions inférieures à 3 %","two":"Prix contrôlé","three":"Certificat de conformité","four":"Collaborateurs sélectionnés","five":"Assistance administrative"}},"we_will_contact_you":"Nous vous contacterons dans les plus brefs délais","form-body":{"success_button":"Voir les biens similaires","success_button_alt":"Voir d\'autres biens"},"request_visit_error":"Échec de l\'envoi<0/>Veuillez réessayer.","request_visit_email_error":"Échec de l\'envoi.<0/> Veuillez vérifier que l\'adresse mail saisie est correcte","select_visit_date":"Sélectionner une date","select_visit_time":"À quelle heure ?","insert_confirmation_info":"Vos coordonnées :","visit_time_disclaimer":"La visite n’est pas encore confirmée","you_will_receive_confirmation":"Vous allez recevoir une confirmation","you_will_receive_confirmation_detail":"Un expert Casavo vous confirmera sa disponibilité pour le créneau indiqué. Vous conviendrez ensemble de la solution qui vous convient le mieux.","book_visit_hour_recap":"De {{startHour}} à {{endHour}}","title_0_1":"à vendre à","request_visit_modal_thankyou_item_2":"Si nous ne pouvons pas accepter votre demande de visite, nous trouverons ensemble une autre disponibilité.","request_visit_modal_thankyou_item_1":"Nous vous contacterons dès que possible pour confirmer","title_0":"à vendre à","title_2":"de","title_1":"à","request_call_modal_title":"Prenez rendez-vous téléphonique et échangez avec un <0>conseiller Casavo</0>","request_call_modal_thank_you_title":"Appel programmé","request_call":"Programmer un appel","request_call_cta":"Nous contacter","request_timeslot_caption":"Au cours de l\'appel, vous pourrez convenir d\'une date et d\'une heure pour visiter le bien","request_feedback_call_bullet_2":"Si vous le souhaitez, vous pourrez prendre rendez-vous pour <0>visiter le bien</0>","request_feedback_call_bullet_1":"Nous vous appelons au jour et à l\'heure convenus pour répondre à toutes vos questions","select_call_date":"Quel jour préférez-vous ?","select_call_time":"À quelle heure ?","request_call_modal_thank_you_title_2":"À nous de jouer !","request_visit_modal_thank_you_title_2":"À nous de jouer !","view":"Vue","view_interior":"Intérieure","view_exterior":"Extérieure","schedule_visit_cta":"Programmer une visite","schedule_visit_modal_title":"Planifier une visite pour ce <0>bien Casavo</0>","select_schedule_visit_time":"Sélectionnez une heure","schedule_visit_confirm_cta":"Confirmer la visite","schedule_visit_no_availabilities":"Il n\'y a pas de disponibilités pour cette date","schedule_visit_recap_no_availabilities":"Trouver une date disponible","schedule_visit_modal_thank_you_title":"Visite confirmée !","schedule_visit_modal_thank_you_title_2":"Prochains pas :","schedule_visit_modal_thankyou_item_1":"Vous allez recevoir :\\n- un e-mail récapitulatif dès maintenant\\n- un SMS de rappel 24 h avant","schedule_visit_modal_thankyou_item_2":"Un conseiller Casavo vous fera visiter le bien","slot_already_booked_error":"Cet horaire n\'est plus disponible","schedule_visit_cta_mobile":"Programmer une visite","request_visit_CTA_mobile":"Demander une visite","schedule_visit_available":"Programmation immédiate de rendez-vous disponible pour ce bien","select_request_visit_date":"Quel jour préférez-vous ?","schedule_visit_no_availabilities_title":"Aucun créneau disponible","schedule_visit_no_availabilities_description":"Malheureusement, à l\'heure actuelle, tous les créneaux disponibles ont déjà été réservés.","ScheduleVisit_NoSlotModal_CTA_body":"Souhaitez-vous <0> enregistrer ce bien dans vos favoris</0> pour garder un œil sur l\'actualité ?","ScheduleVisit_SelectDate_MoreThan1":"Quel jour préférez-vous ?","ScheduleVisit_SelectDate_Just1":"Il ne reste qu\'un jour disponible","schedule_visit_reminder":"Nous vous donnons rendez-vous le {{day_of_the_week}} {{date_number}} {{month}} à {{time}}.","schedule_visit_slot_recap":"Le {{day_of_the_week}} {{date_number}} {{month}} à {{time}} nous convient, confirmez ?","schedule_visit_instant_warn":"Il s\'agit d\'une <0>réservation en temps réel</0>: si vous confirmez, vous n\'aurez pas à attendre notre réponse.","schedule_visit_flow_next_button":"Continuer","RequestVisit_Modal_Warn":"Attendez notre confirmation pour la date demandée","RequestVisit_Modal_Recap":"{{day_of_the_week}} {{date_number}} {{month}}, à {{time}}.\\u2028 Ce créneau sera confirmé par téléphone, quel est votre numéro ?","BookCall_Modal_Recap":"{{day_of_the_week}} {{date_number}} {{month}}, à {{time}}.\\u2028 Comment pouvons-nous vous contacter ?","BookCall_Modal_Warn":"Nous ferons le maximum pour vous contacter pendant le créneau sélectionné","RequestCallModal_Reasonlist_MorePhoto":"Je voudrais d’autres photos","RequestCallModal_Reasonlist_Questions":"J’ai des questions","RequestCallModal_Reasonlist_Visit":"Je voudrais visiter le bien","request_call_mobile":"M’appeler","RequestCall_ThankYou_Bullet1":"Nous vous contacterons afin de répondre à toutes vos questions.","unknown":"-","RelatedAdsBanner_Title":{"one":"1 bien similaire à celui-ci","other":"{{n}} biens similaires à celui-ci"},"RelatedAdsBanner_Description":"Biens à découvrir <b>uniquement sur Casavo</b>.","RelatedAdsBanner_CTA":"Voir","NearPropertiesBanner_FirstStep_Description":"📍 Découvrir les biens <b>à proximité</b>","NearPropertiesBanner_PropertiesProgress":"{{n}}/{{tot}} dans le secteur","NearPropertiesBanner_FirstStep_CTA":{"one":"Voir 1 bien","other":"Voir {{n}} biens"},"HomePlusBanner_Title":"Découvrez Casavo Homeplus","HomePlusBanner_CTA":"Voir les offres","HomePlusBanner_Description":"Nous avons sélectionné quelques-unes des meilleures marques pour vous proposer des <b>offres exclusives</b> et vous permettre de profiter pleinement de votre nouveau bien."}');

/***/ }),

/***/ 70644:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"SearchSettings_Zone_Title":"Secteur","SearchSettings_Modal_ApplyChangesCTA":"Appliquer","SearchSettings_Price_Title":"Budget","SearchSettings_Rooms_Title":"Surface","SearchSettings_City_Title":"Ville:","SearchSettings_CTA":"Mettre à jour les préférences","SearchSettings_Back":"Retour","SearchSettings_ChangeCityCTA":"Modifier la ville","SearchSettings_Subtitle":"Les informations principales qui nous permettent de déterminer quel bien vous proposer","SearchSettings_Title":"Vos préférences","SearchSettings_Price_Intro":"Jusqu’à :","SearchSettings_Rooms_Intro":"Au moins :","SearchSetting_MobileNavBar_Title":"Préférences","SearchSettings_SuccessBanner_Title":"Préférences mises à jour","MainSearch_SEO_Title":"Pour vous - Nous cherchons, vous trouvez"}');

/***/ }),

/***/ 81902:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Login_Button":"Se connecter","Search_Button":"Rechercher","Profile_Button":"Profil","Favorites_Button":"Favoris"}');

/***/ }),

/***/ 86755:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Priority_ThankyouPage_CTA":"Voir les biens déjà en vente","Priority_ThankyouPage_Description":"Dès que ce bien sera sur le marché, vous serez l’une des premières personnes à pouvoir le visiter.","Priority_ThankyouPage_Title":"C’est bon !","Priority_Unsubscribe_Title":"Tout est calme par ici...","Priority_Unsubscribe_Subtitle2":"Notifications désactivées","Priority_Unsubscribe_CTA":"Voir les biens en vente","Priority_Unsubscribe_Subtitle1":"Vous ne recevrez plus ces e-mails","Priority_ThankyouPage_PageTitle":"Visite demandée","Priority_DetailPage_FloatingBanner_Bullet3":"Acheter au prix le plus juste","Priority_DetailPage_AdvantagesCard_Advance_Description":"Découvrez les annonces de biens à vendre, avant tout le monde.","Priority_DetailPage_AdvantagesCard_Advance_Title":"Premier arrivé, premier servi","Priority_DetailPage_AdvantagesCard_Support_Description":"Nous accompagnons les vendeurs et les acquéreurs afin de garantir une transparence et une fiabilité maximales.","Priority_DetailPage_AdvantagesCard_Waitlist_Title":"Visiter en avant-première","Priority_DetailPage_FloatingBanner_Bullet1":"Nous vous appellerons dès qu\'il sera disponible","Priority_DetailPage_AdvantagesCard_RightPrice_Description":"Vous avez moins de concurrence et vous pouvez échanger avec le vendeur pour convenir d’un prix satisfaisant pour tous.","Priority_DetailPage_AdvantagesBox_Description":"Découvrez des biens en avant-première, en fonction de vos critères.","Priority_DetailPage_FloatingBanner_CTA":"Tenez-moi au courant","Priority_DetailPage_FloatingBanner_Title":"Nouveau bien bientôt disponible","Priority_DetailPage_PreviewDescription":"Ce bien est <b>en avant-première</b>","Priority_DetailPage_Banner_Description":"Vous êtes en train de visualiser un bien <b>en avant-première</b>.","Priority_DetailPage_AdvantagesCard_RightPrice_Title":"Achetez au meilleur prix","Priority_DetailPage_AdvantagesCard_Support_Title":"Bénéficiez d’un accompagnement optimal","Priority_DetailPage_FloatingBanner_Bullet2":"Visitez-le avant les autres","Priority_DetailPage_Banner_CTA":"En savoir plus","Priority_DetailPage_AdvantagesCard_Waitlist_Description":"Si le bien vous plaît, vous pourrez le voir avant qu\'il soit mis sur le marché.","Priority_DetailPage_AdvantagesBox_Title":"Comment ça marche ?","Priority_DetailPage_AdvantagesBox_Preview_Description":"Ce bien sera <b>bientôt disponible</b>","Priority_DetailPage_SimilarProperties_Title":"Biens similaires","Priority_DetailPage_SimilarProperties_Description":"Ces biens pourraient vous plaire :","PriorityDetail_FloatingBanner_Booked_Description":"Tout est sous contrôle : \\nNous vous ferons savoir quand vous pourrez nous rendre visite.","PriorityDetail_FloatingBanner_Booked_CTA":"Vous êtes déjà sur la liste","Priority404_H1":"Annonce indisponible","Priority404_CTA":"Voir d\'autres biens","Priority404_Descritpion":"Malheureusement ce bien n’est plus en vente.\\n\\nNous ferons de notre mieux pour trouver un autre bien en avant-première à vous présenter.","Priority_ThankyouPage_Description_Outro":"Pratique, non ?","Priority_PhoneNumberModal_Banner_Description":"Vous serez parmi les premiers à le visiter","Priority_PhoneNumberModal_Title":"Nous vous appellerons dès que nous aurons des nouvelles 📞","Priority_ThankyouPage_Bullet1":"Lorsque le bien sera sur le marché, <b>vous aurez la priorité</b> pour le visiter","Priority_ThankyouPage_Description_Intro":"Et maintenant ?","Priority_ThankyouPage_Bullet2":"<b>Attendez notre appel</b> pour organiser la visite","PriorityCard_PreviewTag":"⏰ BIENTÔT DISPONIBLE","PriorityCard_NotLoggedBanner_Description":"Passez en priorité, c’est gratuit.","PriorityDetail_TeasingBanner_NotLogged_CTA":"En savoir plus","PriorityDetail_NotLogged_Intro_CTA":"Voir les photos","PriorityDetail_TeasingBanner_NotLogged_Description":"Les <b>biens en avant-première</b> sont réservés aux <b>membres Casavo</b>","PriorityCard_NotLoggedBanner_CTA":"Découvrir","PriorityDeatil_NotLogged_Intro_Description":"Vous avez déjà un compte ?","Priority_DetailPage_AdvantagesBox_CTA":"Accéder","OnMarketTab":"sur le marché","PriorityTab":"en avant-première","PriorityTab_NoResult_Description_logged":"Une fois disponibles, ils apparaîtront ici.","PriorityTab_Title_notlogged":"Découvrez des biens qui ne sont pas encore sur le marché","PriorityTab_NoResult_CTA_logged":"Voir les biens en vente","PriorityTab_Title_logged":"Bientôt disponibles : visitez ces biens avant tout le monde","PriorityTab_NoResult_Description_notlogged":"Inscrivez-vous et arrivez avant les autres","PriorityTab_NoResult_CTA_notlogged":"Se connecter","PriorityCard_CTA":"Découvrir","PriorityDetail-FloatingBanner-DislikeCTA":"Il ne me plaît pas","Priority_DetailPage_FloatingBanner_CTAmobile":"Tenez-moi au courant","PriorityDetail-FloatingBanner-FeedbackDescription":"Vos commentaires nous aident à vous proposer d\'autres biens","PriceAnalysis_HighPrice_Modal_Body":"Actuellement, <b>le prix de ce bien est légèrement plus élevé</b> que celui des biens similaires dans la même zone.\\n<br/><br/>\\nPour les biens comme celui-ci, il faut tenir compte du fait qu\'habituellement<b>le prix provisoire peut être jusqu\'à {{Discount}}% inférieur au prix de mise en vente</b>. Par exemple, il peut passer de {{AskingPrice}} € à {{SuggestedPrice}} €.\\n<br/><br/>\\nSi le bien vous plaît, <b>plus tôt vous le verrez, plus il sera facile de négocier le prix.</b>","PriceAnalysis_GoodPrice_Description":"Le prix provisoire est conforme à celui des biens similaires dans la même zone. <u>Comment le savons-nous ?</u>","PriceAnalysis_HighPrice_Modal_Title":"Prix provisoire plus élevé","PriceAnalysis_GoodPrice_Tag":"Prix conforme","PriceAnalysis_GoodPrice_Modal_Body":"Les biens en avant-première ont un prix provisoire car ils ne sont pas encore sur le marché.\\n<br/><br/>\\n<b>Le prix de ce bien est conforme à celui des biens similaires dans la même zone.\\n<br/><br/>\\n</b>Si le bien vous plaît, faîtes-nous savoir que vous souhaitez le voir en avant-première.<b> Plus tôt vous le visiterez, moins vous aurez de concurrence pour l\'acheter.</b>","PriceAnalysis_HighPrice_Tag":"Prix plus élevé","PriceAnalysis_HighPrice_Description":"Le prix provisoire est plus élevé que celui des biens similaires dans la même zone. <u>Ce prix va baisser</u>","PriceAnalysis_GoodPrice_Modal_Title":"Prix provisoire conforme","PriorityInfoBanner_Title":"{{count}} biens en avant-première","PriorityInfoBanner_Description":"Découvrez des biens susceptibles d\'être bientôt sur le marché. Vous pouvez d\'ores et déjà réserver votre visite. <b>C\'est gratuit</b>.","PriorityInfoBanner_CTA":"Accéder","PriorityCarousel_CTA":"Voir les biens","PriorityCarousel_Description":"Visitez des biens qui ne sont pas encore sur le marché","PriorityCarousel_Title":"{{n}} biens en avant-première","PriorityCarousel_LastCard_CTA":"🗄️ Voir tout +","PriorityDetailPage_Title":"Avant-première"}');

/***/ }),

/***/ 55058:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"disclaimer":"En cliquant sur « {{cta}} », je déclare avoir pris connaissance des <0>Conditions Générales</0> et de la <1>Politique de confidentialité</1>","gdpr":{"title":"Pouvons-nous faire autre chose pour vous ?","marketing-consent-checkbox":"<0>Informez-moi des nouveautés</0>","marketing-consent-details":"J\'accepte de <0>recevoir</0> les actualités Casavo sur la nouvelle façon d\'acheter et de vendre des biens","marketing-consent-full-text":"J\'autorise Casavo à traiter mes données à des fins de communication sur des initiatives et des offres commerciales."},"mortgage":{"title":"J’ai besoin d’un prêt hypothécaire","short-text":"J’autorise Casavo à me présenter le service Hypothèques.","full-text":"J\'autorise Casavo à traiter et à partager mes données avec les sociétés du groupe Casavo opérant dans le secteur financier/hypothécaire. Ils m\'enverront les actualités sur leurs activités et leurs offres et pourront réaliser des études de marché et d\'autres activités visant à évaluer la qualité de leurs services par téléphone, mail et SMS."},"recaptcha":{"disclaimer":"Ce site est protégé par reCaptcha, les <0>conditions</0> d\'utilisation de Google et les <1>règles de confidentialité</1>."},"disclaimer-mortgage":"En cliquant sur « {{cta}} », J’autorise Casavo à me présenter le service Hypothèques."}');

/***/ }),

/***/ 12350:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"area":"dans le secteur","city":"Ville","price":"Budget","email_label":"Votre adresse mail","features_title":"autres filtres :","cta":"Sauvegarder la recherche","cta_saved":"Recherche sauvegardée","no_spam":"Pas de spam ! Un mail <0>tous les trois jours</0> maximum","turn_off_notifications":"Désactivez les notifications <0>à tout moment</0>","title":"Nous vous informons","your_research":"Votre recherche","subtitle":"Recevez les nouvelles annonces qui correspondent à votre recherche par mail :","only_casavo":"Uniquement les biens Casavo","saveSearch-floatingBanner-text":"Souhaitez-vous recevoir de <b>nouvelles annonces</b> pour cette recherche ?","saveSearch-floatingBanner-text1result":"Il n\'y a qu\'un seul résultat. Souhaitez-vous recevoir de nouvelles annonces ?","saveSearch-floatingBanner-textNewFilters":"Nouveaux filtres, nouvelle recherche.\\nSouhaitez-vous que l\'on vous informe à propos annonces ?","saveSearch-floatingBannerFeedback-subtitle":"Vous recevrez les nouvelles annonces par mail !","saveSearch-floatingBannerFeedback-title":"Recherche sauvegardée","Modal_Title":"Recevez les nouvelles annonces\\nqui vous intéressent","Modal_Zone_intro":"Nous vous signalerons les annonces situées à :","Modal_NoFilterBanner_Title":"Souhaitez-vous affiner votre recherche ?","Modal_NoFilterBanner_CTA":"Ajouter des filtres","Modal_CTA":"Sauvegarder la recherche","Modal_NoFilterBanner_Description":"Vous pouvez ajouter des filtres pour obtenir des résultats plus précis","Modal_Form_Title":"À quelle adresse souhaitez-vous les recevoir ?","Modal_Form_NotificationsMessage":"Vous pouvez désactiver les notifications à tout moment","SearchSearch_Modal_Success_Title":"Alertes activées","SearchSearch_Modal_Success_Subtitle":"Nous vous enverrons un e-mail lorsque nous trouverons des biens similaires.","SearchSearch_Modal_Success_CTA":"Voir d\'autres biens","Modal_Success_Body1":"Vous recevrez de nouvelles annonces\\npour votre recherche à","Login_BottomSheet_Subtitle":"Nous vous enverrons les nouvelles annonces directement sur votre e-mail.","Modal_Success_CTA":"Excellent !","Modal_AuthUser_Text":"Vous les recevrez le","Modal_Success_Body2":"...vous pouvez couper la réception quand vous le souhaitez.","Login_BottomSheet_Title":"Où préférez-vous les recevoir ?","Modal_Success_Title":"Recherche sauvegardée","Login_BottomSheet_CTA":"Envoyer","Modal_AuthUser_Link":"Profil","LoaderModal_Description":"Juste une seconde...","Error_InvalidMail_Description":"Il semble que l\'email que vous avez choisi n\'est pas valide. Essayez de vous inscrire avec une autre adresse e-mail","Error_InvalidMail_Title":"Email invalide"}');

/***/ }),

/***/ 28600:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"BudgetQuestion_Submit":"Voilà !","Suggested_Today_Description":"Dîtes-nous tout : comment les trouvez-vous ?","City_Question":"Dans quelle ville cherchez-vous ?","Suggested_Loader_1":"Parcourir les annonces...","Suggested_Welcome_Description":"Voici notre sélection d\'annonces pour vous.","Suggested_Welcome_Title":"Bonjour !","MainSearch_Intro_Description":"4 questions pour trouver le bien idéal. Avec Casavo, découvrez des biens qui ne sont pas encore sur le marché.","MainSearch_Intro_Title":"Parlez-nous de votre recherche","Suggested_Today_Title":"Déjà sur le marché","Suggested_NoResults_Title":"Ensemble, nous trouverons votre futur chez-vous","Suggested_NoResults_CTA":"Voir toutes les annonces","Suggested_NoResults_Description":"Aucun bien correspondant à votre recherche n’est actuellement disponible. Pas d’inquiétude : nous parcourons en ce moment même toutes les annonces pour trouver celles qui vous feront vibrer. Vous les trouverez ici dès qu\'elles seront disponibles.","Suggested_Flow_TypeQuestion":"Au minimum, vous souhaitez un :","Suggested_Flow_HouseType_1room":{"one":"Studio","other":"Studio"},"Suggested_Flow_HouseType_3room":{"one":"3 pièces","other":"3 pièces"},"Suggested_Flow_HouseType_2room":{"one":"2 pièces","other":"2 pièces"},"Suggested_Flow_HouseType_4room":{"one":"4 pièces","other":"4 pièces"},"Suggested_Flow_HouseType_5orMore":{"one":"5 pièces ou plus","other":"5 pièces ou plus"},"Suggested_Error_CTA":"Recharger","Suggested_Error_Body":"Malheureusement, quelque chose ne s\'est pas passé comme nous le pensions, pouvez-vous réessayer s\'il vous plaît ?","Suggested_Page_Title":"Bien sélectionnés pour vous","Suggested_SuccessToast_Title":"Voici la nouvelle section à laquelle vous avez accès. Nous espérons qu’elle vous plaira!","Suggested_Priority_HelpModal_Title":"Un bien en avant-première, c\'est quoi ?","Suggested_Priority_HelpModal_Description":"Vous recevrez une notification dès qu’un bien correspondant à vos critères est sur le point d’être mis en vente. \\n\\nSi celui-ci vous plaît, vous pourrez réserver une visite en avant-première pour être l’une des premières personnes à visiter le bien. Promis, on vous tient au courant !","PriorityCard_Banner":"En avant-première","Suggested_Priority_Title":"En avant-première","Suggested_Priority_HelpText":"Comment ça marche ?","Suggested_Priority_NoResult_Banner":"Il n’y a pas de bien en avant-première pour le moment","Suggested_UpdateToast_Title":"Nous avons mis à jour votre rubrique « Pour vous »","Suggested_SearchResume_Intro":"Vos préférences :","Suggested_SearchResume_BudgetIntro":"Jusqu\'à","Suggested_Welcome_Title_Named":"Bonjour, {{name}} !","Suggested_SetPreferenceBanner_Description":"Ces maisons sont conformes à vos anciennes recherches. Y a-t-il des nouvelles ?","Suggested_SetPreferenceBanner_CTA":"Mise à jour des préférences","TeasingInbox_MetaTitle":"Pour vous - Login","TeasingInbox_MetaDescription":"Voici les biens sélectionnés pour vous en fonction de vos recherches.","ValuationModal_Title":"PRIX DE MISE EN VENTE SUGGÉRÉ","ValuationModal_DateDescription":"Créé le {{valuation-date}}","ValuationModal_CardTitle":"🎁 Nous avons trouvé des biens qui pourraient vous intéresser.","ValuationModal_CardDescription":"Vous les découvrirez dans votre espace personnel","ValuationModal_CardButton":"Voir les biens","ValuationModal_Title_1":"VALEUR SUR LE MARCHÉ","BuyerContactFormWall_Title":"C’est presque parfait !","BuyerContactFormWall_Description":"Votre estimation est prête ! \\nEn poursuivant, vous aurez accès :","BuyerContactForm_Reward_Item-1":"Des biens recommandés","BuyerContactForm_Reward_Item-2":"Biens en avant-première","BuyerContactFormWall_Button":"Connexion","ForYou_Homeplus_CTA":"Offres <b>Casavo Homeplus</b>","ForYou_Page_Mortgage_CardTitle":"Trouver le prêt hypothécaire idéal","ForYou_Page_Mortgage_Card_Description":"Calculez le montant de votre hypothèque en ligne ou prenez rendez-vous pour une consultation gratuite.","ForYou_Page_Mortgage_Card_CTA":"Calculer la mensualité du prêt hypothécaire "}');

/***/ }),

/***/ 49023:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Priority_DetailPage_FloatingBanner_Desciption":"<b> </b> Nous vous appellerons dès qu\'il sera disponible et vous serez parmi les premiers à le voir.","PriorityDetail_TeasingBanner_Description":"<b></b> <b></b> Avec UniCredit SubitoCasa , vous pouvez visiter ce logement à l\'avance.","Priority_DetailPage_AdvantagesBox_Description":"Il s\'agit d\'une maison <b>qui n\'a pas encore été mise sur le marché, mais qui pourrait l\'être bientôt.</b> Nous avons sélectionné uniquement des personnes qui, comme vous, recherchent exactement une telle maison. Avec nous, <b>, vous pouvez réserver une visite avant tout le monde.</b>","PriceAnalysis_Description":"Prix indicatif susceptible d\'être modifié","Priority_DetailPage_AdvantagesCard_Advance_Description":"Découvrez les annonces de maisons à vendre, avant les autres.","Priority_DetailPage_AdvantagesCard_Advance_Title":"Découvrir de nouvelles maisons","PriorityDetail_TeasingBanner_Description_v2":"Avec <b>UniCredit RE Services,</b> vous pouvez visiter cette maison <b>à l\'avance.</b>"}');

/***/ }),

/***/ 64761:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"meta":{"title":"🔕 Notifications désactivées | Casavo","description":"Les notifications concernant votre recherche de biens sur Casavo ont été désactivées."},"notifications-disabled":"Notifications désactivées","all-good-here":"Tout va bien par ici...","plant-image-alt-text":"Un canapé avec une plante à sa droite","done":"Et voilààà !","no-more-messages":"Vous ne recevrez plus de nouvelles annonces pour votre recherche.","cta-browse-all":"Recherchez parmi nos biens récents"}');

/***/ }),

/***/ 99193:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"it/bologna/centro":"","it/bologna/san-donato-pilastro":"","it/bologna/san-vitale-mazzini":"","it/bologna/murri-massarenti":"","it/bologna/toscana-savena":"","it/bologna/colli":"","it/bologna/bolognina-corticella-pescarola":"","it/bologna/costa-saragozza-saffi":"","it/bologna/barca-santa-viola":"","it/bologna/aeroporto-borgo-panigale":"","it/firenze/centro":"","it/firenze/oltrarno":"","it/firenze/leopoldo-porta-al-prato":"","it/firenze/campo-di-marte-liberta":"","it/firenze/firenze-nord":"","it/firenze/ugnano-mantignano":"","it/firenze/l-isolotto":"","it/firenze/legnaia-soffiano":"","it/firenze/bellosguardo-galluzzo":"","it/firenze/firenze-sud":"","it/firenze/coverciano-bellariva":"","it/firenze/bolognese-le-cure":"","it/firenze/serpiolle-careggi":"","it/firenze/michelangelo-porta-romana":"","it/firenze/settignano-rovezzano":"","it/milano/san-siro-trenno":"","it/milano/bisceglie-baggio-olmi":"","it/milano/genova-ticinese":"","it/milano/navigli":"","it/milano/porta-romana-cadore-montenero":"","it/milano/bande-nere-inganni":"","it/milano/famagosta-barona":"","it/milano/abbiategrasso-chiesa-rossa":"","it/milano/porta-vittoria-lodi":"","it/milano/solari-washington":"","it/milano/ripamonti-vigentino":"","it/milano/ponte-lambro-santa-giulia":"","it/milano/corvetto-rogoredo":"","it/milano/napoli-soderini":"","it/milano/cimiano-crescenzago-adriano":"","it/milano/forlanini":"","it/milano/citta-studi-susa":"","it/milano/precotto-turro":"","it/milano/udine-lambrate":"","it/milano/pasteur-rovereto":"","it/milano/centro":"","it/milano/arco-della-pace-arena-pagano":"","it/milano/quadronno-palestro-guastalla":"","it/milano/garibaldi-moscova-porta-nuova":"","it/milano/porta-venezia-indipendenza":"","it/milano/centrale-repubblica":"","it/milano/cenisio-sarpi-isola":"","it/milano/bicocca-niguarda":"","it/milano/maggiolina-istria":"","it/milano/fiera-sempione-city-life-portello":"","it/milano/viale-certosa-cascina-merlata":"","it/milano/affori-bovisa":"","it/roma/centro-storico":"","it/roma/prati-borgo-mazzini-delle-vittorie":"","it/roma/parioli-flaminio":"","it/roma/testaccio-trastevere":"","it/roma/corso-francia-vigna-clara-fleming-ponte-milvio":"","it/roma/eur-torrino-tintoretto":"","it/roma/gregorio-vii-baldo-degli-ubaldi":"","it/roma/camilluccia-cortina-d-ampezzo":"","it/roma/cassia-san-godenzo-grottarossa":"","it/roma/trionfale-monte-mario-ottavia":"","it/roma/magliana-trullo-parco-de-medici":"","it/roma/casetta-mattei-pisana-bravetta":"","it/roma/aurelio-boccea":"","it/roma/battistini-torrevecchia":"","it/roma/acilia-casal-bernocchi-centro-giano-dragona-malafede-vitinia":"","it/roma/lido-di-ostia-ostia-antica-castel-fusano":"","it/roma/casal-lumbroso-massimina-ponte-galeria":"","it/roma/casalotti-casal-selce-maglianella":"","it/roma/balduina-medaglie-d-oro-degli-eroi":"","it/roma/axa-casal-palocco-infernetto":"","it/roma/re-di-roma-san-giovanni":"","it/roma/aventino-san-saba-caracalla":"","it/roma/appio-latino-colli-albani":"","it/roma/garbatella-navigatori-ostiense":"","it/roma/marconi-san-paolo":"","it/roma/appia-pignatelli-ardeatino-montagnola":"","it/roma/cecchignola-fonte-meravigliosa":"","it/roma/anagnina-romanina-tor-vergata":"","it/roma/trigoria-castel-romano":"","it/roma/cinecitta-quadraro":"","it/roma/monteverde-gianicolense-colli-portuensi-casaletto":"","it/roma/borghesiana-finocchio":"","it/roma/mezzocammino-spinaceto-tor-de-cenci":"","it/roma/appio-claudio-capannelle":"","it/roma/castel-di-leva-vallerano":"","it/roma/portuense-villa-bonelli":"","it/roma/salario-trieste":"","it/roma/termini-repubblica":"","it/roma/bologna-policlinico":"","it/roma/pigneto-san-lorenzo-casal-bertone":"","it/roma/talenti-monte-sacro-nuovo-salario":"","it/roma/porta-di-roma-casal-boccone":"","it/roma/monti-tiburtini-pietralata":"","it/roma/centocelle-tor-de-schiavi":"","it/roma/alessandrino-tor-sapienza-torre-maura":"","it/roma/bufalotta-casal-monastero-settebagni":"","it/roma/ponte-di-nona-torre-angela":"","it/roma/ponte-mammolo-san-basilio-tor-cervara":"","it/roma/lunghezza-castelverde":"","it/roma/olgiata-giustiniana":"","it/roma/labaro-prima-porta-valle-muricana":"","it/torino/regio-parco-vanchiglia-vanchiglietta":"","it/torino/aurora-barriera-di-milano-rebaudengo":"","it/torino/barriera-di-lanzo-falchera-barca-bertolla":"","it/torino/borgo-vittoria-parco-dora":"","it/torino/le-vallette-lucento-madonna-di-campagna":"","it/torino/pozzo-strada-parella":"","it/torino/madonna-del-pilone-sassi":"","it/torino/centro":"","it/torino/crocetta-san-secondo":"","it/torino/cavoretto-gran-madre":"","it/torino/colle-della-maddalena-superga":"","it/torino/borgo-san-paolo-cenisia":"","it/torino/lingotto-nizza-millefonti":"","it/torino/san-salvario":"","it/torino/santa-rita-mirafiori-nord":"","it/torino/campidoglio-san-donato-cit-turin":"","it/torino/mirafiori-sud":"","it/verona/pindemonte-valdonega":"","it/verona/borgo-nuovo-navigatori-ponte-crencano":"","it/verona/quinzano-parona":"","it/verona/poiano-quinto-montorio":"","it/verona/avesa-torricelle":"","it/verona/chievo-bassone":"","it/verona/via-mantovana-dossobuono-sacra-famiglia-castel-d-azzano":"","it/verona/borgo-roma-ca-di-david":"","it/verona/san-michele-extra-castiglione":"","it/verona/borgo-venezia-santa-croce-porto-san-pancrazio":"","it/verona/santa-lucia-golosine-zona-fiera":"","it/verona/borgo-milano-stadio-san-massimo-croce-bianca":"","it/verona/centro":""}');

/***/ }),

/***/ 2917:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"search":"Rechercher","all-zones":"Tous les secteurs","seo-title":"biens à vendre dans le secteur de {{zone}}, à {{city}} | Casavo","seo-description":"Biens à vendre dans le secteur de {{zone}}, à {{city}} : parcourez les annonces immobilières et trouvez le bien qui correspond à vos critères. En savoir plus sur Casavo !","search-filters":"Rechercher par commune ou par secteur","zones_count":{"all":"Tous les secteurs","zones":"{{count}} secteurs","zones_one":"{{count}} secteur"}}');

/***/ }),

/***/ 28680:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"PropertyAdvantages_Bureaucracy_Title":"Supporto nella burocrazia","PropertyAdvantages_Certification_Title":"Documentazione Trasparente","PropertyAdvantages_SelectedPartners_CardDescription":"Vogliamo garantirti anche per le <b>persone con cui parlerai</b>. Scegliamo i nostri collaboratori per la trasparenza, la professionalità e conoscenza della città. <b>Anche noi abbiamo acquistato da loro</b> ed è andato tutto bene, per questo siamo sicuri della loro affidabilità.","PropertyAdvantages_CasavoGuarantee_BannerIntro":"Questa casa è <b>Garantita Casavo</b>","PropertyAdvantages_CasavoGuarantee_BottomBanner_Description":"Stiamo accompagnando il proprietario di questa casa nel processo di vendita. Siamo quindi in grado di garantirti affidabilità, qualità e servizi dedicati. Non sono case nostre, ma è come se lo fossero.","PropertyAdvantages_FairPrice_Title":"Prezzo controllato","PropertyAdvantages_Fees_Title":"Commissioni sotto al 3%","PropertyAdvantages_CasavoGuarantee_BottomBanner_Title":"Cosa fa la differenza quando è “Garantita Casavo”?","PropertyAdvantages_CasavoGuarantee_From_Title":"Che vuol dire <1>Garantita Casavo</1>?","PropertyAdvantages_Bureaucracy_CardDescription":"Non temere di dimenticarti qualcosa. Anche noi acquistiamo case, gli atti notarili sono il nostro pane quotidiano. Per questo siamo in grado di aiutarti nella fitta giungla burocratica,  con la <b>raccolta dei documenti</b> e assistenza costante.","PropertyAdvantages_CasavoGuarantee_Banner_CTA":"Scopri","PropertyAdvantages_FairPrice_CardDescription":"Significa che <b>il prezzo che vedi è in linea con quello che viene proposto sul mercato</b>. Ci riusciamo grazie alla nostra tecnologia e al confronto con case simili nel mercato, in modo da analizzare i prezzi comparabili con molta precisione.","PropertyAdvantages_SelectedPartners_Title":"Collaboratori selezionati","PropertyAdvantages_Fees_CardDescription":"Hai presente quando ti poni la domanda “Chissà quante commisioni dovrò pagare”? Vogliamo toglierti ogni dubbio. Lavoriamo con partner e con accordi ben chiari:  <b>non pagherai mai una commissione sopra al 3%</b>","PropertyAdvantages_Card_CTA":"Scopri","PropertyAdvantages_CasavoProperty_BannerIntro":"Questa è una <b>Casa Casavo</b>","PropertyAdvantages_TransparencyDocumenation_CardDescription":"Abbiamo già pensato noi a <b>raccogliere i documenti necessari</b> tra cui visura catastale e storica, visura ipotecaria e atto di provenienza. Tutti a tua disposizione. Quando si parla di case, le sorprese non piacciono nemmeno a noi.","PropertyAdvantages_TransparencyDocumenation_Title":"Documentazione trasparente"}');

/***/ }),

/***/ 89641:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Login_Button":"Accedi","Search_Button":"Ricerca","Profile_Button":"Profilo","Favorites_Button":"Preferiti","Suggested_Auth_Button":"Per te","Suggested_Unauth_Button":"Per te"}');

/***/ }),

/***/ 72087:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"AffordabilityTool_firstHouseQuestion_title":"Sarà la tua prima casa*?","AffordabilityTool_ResultPage_InfoAlert":"Il mutuo dipende dal tuo contratto di lavoro (determinato o indeterminato), pensione o rendite da affitto. Parliamone per capire meglio la tua situazione.","LandRegistryTax_Label":"Spese catastali","AgencyFee_Label":"Spese agenzia","AffordabilityTool_ResultPage_Expenses_DropDown2_Label":"Quali sono i costi per l’acquisto della casa?","Deposit_Label":"Anticipo","AffordabilityTool_ResultPage_Analysis_Box1_Description":"Di norma, le banche chiedono che la rata del mutuo sia al massimo il 35% del tuo guadagno mensile. Questa rata è calcolata tenendo conto di <b>quanto puoi anticipare</b> e del rapporto rata-reddito. Tieni presente che possono esserci eccezioni dipendenti da più fattori che le banche valutano nel caso specifico.","AffordabilityTool_ResultPage_NextStepBox_CTA":"Prenota una chiamata","RegistrationTax_Label":"Imposte di registro","AffordabilityTool_ResultPage_Expenses_Disclaimer":"*Le spese si riferiscono al massimo costo della casa.","AffordabilityTool_ResultPage_Expenses_DropDown1_Label":"Quali sono le spese per il mutuo?","AffordabilityTool_ageQuestion_title":"Quanti anni hai?","TransferTax_Label":"Spese ipotecarie","AffordabilityTool_ResultPage_Back":"Torna all’annuncio","AffordabilityTool_ResultPage_Analysis_Box2_Description":"In generale, le banche chiedono un anticipo del 20%. A seconda della banca e di altre variabili, <b>potresti dover dare meno del 20%</b>, o perfino nessun anticipo. Parliamone, siamo flessibili!","AffordabilityTool_ResultPage_Description_Positive":"La casa che ti piace rientra perfettamente nel tuo range di prezzo!<br/>\\n<b>Prossimo passo:</b> verificare il tutto con una consulenza 🚀","Application_Label":"Istruttoria","AffordabilityTool_ResultPage_FloatingBox_Title":"I tuoi dati","AffordabilityTool_ResultPage_DetailBox_MaxCost":"Importo massimo sostenibile","MandatoryInsurance_Label":"Assicurazione obbligatoria","Interest_Label":"Interesse","OwnerNumber_Label":"Numero intestatari","AffordabilityTool_ResultPage_Expenses_DropDown_Title":"Le altre spese","AffordabilityTool_ResultPage_Analysis_Title":"Su cosa si basa la stima?","Notary_Label":"Notaio","AffordabilityTool_ResultPage_NextStepBox_Description":"Siamo qui se vuoi avere una visione più completa della tua situazione. Senza impegno e a costo zero.","AffordabilityTool_ResultPage_Chart_SelectedProperty":"Annuncio selezionato","AffordabilityTool_ResultPage_Title":"Ecco una prima stima","MonthlyIncome_Label":"Reddito mensile","VAT_Label":"Iva","AffordabilityTool_ResultPage_Analysis_Box1_Title":"Rata massima stimata","AffordabilityTool_ResultPage_DetailBox_Title":"Dettaglio","Duration_Label":"Durata","Mortgage_Label":"Mutuo","Appraisal_Label":"Perizia","OtherLoans_Label":"Finanziamenti in corso","AffordabilityTool_ContactModal_Title":"Facciamo il punto?","AffordabilityTool_ContactModal_Description":"Prenota ora una consulenza gratuita con i nostri esperti Casavo Mutui. Zero costi, tutto online.","AffordabilityTool_ResultPage_Analysis_Box2_Title":"Anticipo","AffordabilityTool_ResultPage_NextStepBox_Title":"E adesso? 🔮","AffordabilityTool_firstHouseQuestion_description":"*Con “prima casa” intendiamo:\\n<ul>\\n<li>sia la prima casa comprata dal punto di vista cronologico </li>\\n<li>sia la seconda/terza/... casa comprata ma che diventa la residenza principale</li></ul>","PurchaseType_label":"Tipo di acquisto","AffordabilityTool_navigation_nextButton":"Avanti","SubsituteTax_Label":"Imposta sostitutiva","Age_Label":"Età","OthersFee_Label":"Bolli e vari","NotaryExpenses_Label":"Spese notarili","AffordabilityTool_ResultPage_Description_Negative":"Il costo della casa sembra essere fuori dai parametri di finanziabilità in base ai tuoi dati.<br/><b>Prendiamoci un momento insieme</b> per capire meglio la situazione.","AffordabilityTool_otherLoansQuestion_person2_title1":"L’altro intestatario ha finanziamenti in corso?","AffordabilityTool_otherLoansQuestion_person1_description":"Se nei prossimi 6 mesi devi pagare a rate la macchina, il telefono, la televisione,...","AffordabilityTool_jobQuestion_person1_title2":"Quanto guadagni al mese?","AffordabilityTool_jobQuestion_person1_answer_expanded_option2":"Dipendente tempo determinato","AffordabilityTool_otherLoansQuestion_person1_title2":"In totale, quanto spendi al mese per i finanziamenti?","AffordabilityTool_ownersQuestion_answer_no":"No, siamo in 2","AffordabilityTool_jobQuestion_person1_description2":"Includi il tuo stipendio netto o pensione <b>calcolato su 12 mensilità</b>. Se sei freelance, inserisci una stima.","AffordabilityTool_jobQuestion_person2_description2":"Includi il suo stipendio netto o pensione <b>calcolato su 12 mensilità</b>. Se è freelance, inserisci una stima.","AffordabilityTool_ownersQuestion_answer_yes":"Sì","AffordabilityTool_otherLoansQuestion_person1_title1":"Hai altri finanziamenti in corso?","AffordabilityTool_jobQuestion_person1_answer_expanded_option1":"Dipendente tempo indeterminato","AffordabilityTool_jobQuestion_person1_answer_expanded_option3":"Lavoratore autonomo con P.Iva","AffordabilityTool_jobQuestion_person1_title1":"Qual è la tua situazione lavorativa?","AffordabilityTool_jobQuestion_person2_title2":"Quanto guadagna al mese l’altro intestatario?","AffordabilityTool_otherLoansQuestion_person2_title2":"In totale, quanto spende al mese per i finanziamenti?","AffordabilityTool_jobQuestion_person1_answer_expanded_option4":"Pensionato","AffordabilityTool_otherLoansQuestion_person2_answer1_yes":"No","AffordabilityTool_jobQuestion_person2_title1":"Qual è la situazione lavorativa dell’altro intestatario?","AffordabilityTool_ownersQuestion_title":"Il mutuo sarà intestato solo a te?","AffordabilityTool_depositQuestion_title":"Quanto pensi di voler anticipare?","AffordabilityTool_jobQuestion_person1_answer_collapsed":"Selezionane una...","Affordability_ListingDetailCTA":"Verifica la mia finanziabilità","PurchaseType_FirstHome_Label":"Prima casa","PurchaseType_SecondHome_Label":"Seconda Casa","Fixed_at":"Fisso al","InputError_Loan":"Il costo dei finanziamenti non può superare lo stipendio mensile.","done":"Fatto!","AffordabilityTool_ResultPage_NextStepBoxSuccess_Description":"Un esperto Casavo Mutui ti contatterà a breve per approfondire la tua finanziabilità e rispondere a tutte le tue domande.","AffordabilityTool_ResultPage_Analysis_DownPaymentBox_WhyProblem":"<b>Il tuo anticipo è di {{down_payment}}</b>, ma avresti bisogno di un anticipo di <b>almeno {{min_down_payment}}</b> per comprare questa casa.","AffordabilityTool_ResultPage_Analysis_RateBox_WhyProblem":"<b>La tua rata mensile può essere massimo {{max_installment}}</b> (35% stipendio, con un anticipo del 20%). \\nPer questa casa invece, <b>la tua rata dovrebbe essere di almeno {{min_installment}}</b>({{min_income_percentage}}% del tuo stipendio).","AffordabilityTool_ResultPage_Analysis_CTA":"Chiedici altri dettagli","AffordabilityTool_ResultPage_Expenses_DropDown_Subtitle":"Le spese si riferiscono all’importo massimo di mutuo ottenibile","AffordabilityTool_ResultPage_Expenses_CTA":"Richiedi consulenza gratuita"}');

/***/ }),

/***/ 66213:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"LoginPage_Description":"Cerca Casa, in un modo nuovo.","LoginPage_Title":"Ti diamo il benvenuto\\nin Casavo","UserProfile_Salute":"Ciao","UserProfile_Description":"Questo è il tuo spazio.\\n🚧 Ci stiamo ancora lavorando 🚧\\n\\nQui potrai raccontarci la casa che hai in mente e gestire al meglio la tua ricerca.","UserProfile_CTA":"Scopri le case","LoginPage_Button_google":"Continua con Google","UserProfile_LogoutButton":"Logout","Divider_Smalltext":"oppure","UserProfile_Dropdown_Favorites":"I tuoi preferiti","SignupWithMail_Input_Password_Placeholder":"Digita la tua password","Login_Success_CTA":"Ok!","LoginWithMail_CTA":"Accedi","ToSignUp_Description":"Prima volta qui?","LoginWithMail_Input_Password_Placeholder":"Password","SignupWithMail_Input_RepeatPassword_Error_NotMatch":"Password non corrispondenti","SignupWithMail_Title":"Crea un nuovo account","SignupWithMail_CTA2":"Crea account","SignupWithMail_Input_RepeatPassword_Placeholder":"Ripetila, per sicurezza","Login_Success_Title":"Eccoti di nuovo!","Login_Success_Description":"<b>Accesso Effettuato</b>.<br/>Sempre un piacere per noi vederti tornare","LoginWithMail_Error_WrongData_Description":"L’email e/o la password non corrispondono. Riprova.","SignupWithMail_CTA1":"Continua","ToLogin_Description":"Sei già dei nostri?","SignupWithMail_Password_Title":"Scegli una password","LoginWithMail_Error_WrongData_Title":"Hai inserito i dati giusti?","SignupWithMail_Error_SimplePSW_Title":"Rafforza la tua password","Signup_Success_Description":"Eccoti nella nostra community!\\n\\nAdesso puoi salvare le tue case preferite, attivare le notifiche per le ricerche che ti interessano, e altro ancora...\\n\\nCerca casa, in un modo nuovo.","Input_Email_Placeholder":"Inserisci la tua email","Signup_Success_Title":"Sei dei nostri","ToSignUp_CTA":"Crea account","LoginPage_WithMail_CTA":"Continua con la tua email","SignupWithMail_Error_SimplePSW_Description":"Giusto per sicurezza, meglio inserire una password più complicata.","SignupWithMail_Input_Password_Error_ShortPsw":"Minimo 8 caratteri","SignupWithMail_Alert_ExistingAccount_Title":"Sei già dei nostri","SignupWithMail_Alert_ExistingAccount_Description":"Hai già un account con questa email. Per continuare, clicca su “Accedi”.","SignupWithMail_Alert_ExistingAccount_CTA":"Accedi","Login_Favorites_BottomSheet_Title":"Accedi per aggiungerla ai tuoi preferiti","Login_SaveSearch_BottomSheet_Title":"Accedi per salvare\\nla tua ricerca","LoginWithMail_Title":"Accedi con la tua mail","RecoverPassword_Code_Title":"Controlla la tua email","RecoverPassword_Code_CTA":"Continua","NewPassword_Success_Description":"Perfetto! La tua nuova password è al sicuro, dove eravamo rimasti?","RecoverPassword_Code_Sendto":"Abbiamo inviato il codice di sicurezza a","RecoverPassword_Code_Description":"Inserisci qua il codice che hai ricevuto:","NewPassword_Title":"Scegli una nuova password","NewPassword_Success_Title":"Password confermata","RecoverPassword_CTA":"Ricevi il codice","Login_ToRecoverPassword":"Password dimenticata?","NewPassword_CTA":"Conferma nuova password","RecoverPassword_Description":"Ti invieremo un codice per impostare la tua nuova password. Inserisci l’email che hai usato per registrarti:","RecoverPassword_Title":"Resetta password","RecoverPassword_Error_InvalidCode_Description":"Il codice che hai inserito non è esatto oppure scaduto. Controlla oppure inviane un altro","RecoverPassword_Error_InvalidCode_Title":"Codice non valido","Login_ScheduleVisit_BottomSheet_Title":"Accedi per sbloccare la prenotazione istantanea","Login_Suggested_BottomSheet_Title":"Ci siamo!\\nManca solo il tuo nome.","Social_Login_Error_Message":"C’è stato un errore con il tuo account Google. Riprova con la tua email.","Social_Login_Error_Cta":"Torna indietro","Login_PriorityDetail_BottomSheet_Title":"Ok! Intanto, che nome mettiamo in lista?","Login_RequestVisit_BottomSheet_Title":"Verifichiamo l\'agenda: intanto, che nome mettiamo?","Login_TeasingInbox_Title":"Che bello rivederti! C\'è una nuova sezione tutta per te.","Login_FromContactFrom_Title":"Con piacere! Come ti chiami?","Login_PriorityDetail_BottomSheet_UnlockTitle":"Scopri case non ancora sul mercato.","BuyerContactFormModal_Title":"Manca solo il tuo nome."}');

/***/ }),

/***/ 90636:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"SearchStatus_Answer3":"Sto per fare una proposta d’acquisto","HouseType_1room":"Monolocale","HouseType_4orMore":"4 locali o più","SearchStatus_Answer4":"Ho già fatto una proposta d’acquisto","SearchBar":"Cerca zona...","SearchStatus_Answer1":"Sto solo vedendo annunci","ThankYou_Title":"Ora sta a noi","SearchStatus_Question":"A che punto sei della tua ricerca?","Intro_Description":"Tu rispondi, e noi ti troviamo casa. Possiamo proporti case fatte su misura per te, prima ancora che siano messe sul mercato.","NoResult_Title":"Insieme troveremo la casa giusta","Intro_Title":"Trova la casa perfetta per te","MaxBudget_Input_Placeholder":"€","Form_Description":"Ora sappiamo esattamente cosa stai cercando. Ultima cosa: come possiamo contattarti?","NoResult_Description":"Per adesso non abbiamo nessuna casa che corrisponde ai tuoi criteri. Aiutaci a proporti case perfette per te, prima ancora che siano messe sul mercato.","ThankYou_CTA":"Torna alle case","NoResult_CTA":"Dicci cosa stai cercando","MaxBudget_Question":"Fino a quanto pensi di spendere?","Form_Mail_Placeholder":"La tua email","Form_Name_Placeholder":"Il tuo nome","ThankYou_Description":"Non vediamo l’ora di trovare la casa perfetta per te. Ci sentiamo presto!","FewResult_Title":"Vorresti le nuove case in anteprima?","SearchStatus_Answer2":"Ho già visitato alcune case","HouseType_Question":"Che tipo di casa cerchi?","Form_Title":"Risposte salvate","MaxBudget_Description":"Sicuramente non è la nostra domanda preferita, ma è fondamentale","FewResult_Reset":"Cambia i filtri","NoResult_Reset":"Resetta i filtri","Zone_Question":"In che zone di {{city}} vuoi che cerchiamo?","HouseType_3rooms":"Trilocale","HouseType_4rooms":"Quadrilocale","HouseType_2rooms":"Bilocale","FewResult_Description":"Possiamo proporti case fatte su misura per te, prima ancora che siano messe sul mercato.","Zone_Noresult":"Non trovi quello che stai cercando?<br/>Scorri <0>l’elenco delle zone</0>"}');

/***/ }),

/***/ 87936:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"terrace":{"label":"Terrazzo","title":"Case in vendita a {{city}} con terrazzo | Casavo","description":"Scopri tutti gli annunci su appartamenti in vendita a {{city}} con terrazzo. Casavo collabora solo con agenzie selezionate. Trova subito la casa dei tuoi sogni!"},"balcony":{"label":"Balcone","title":"Case in vendita a {{city}} con balcone | Casavo","description":"Scopri tutti gli annunci su appartamenti in vendita a {{city}} con balcone. Casavo collabora solo con agenzie selezionate. Trova subito la casa dei tuoi sogni!"},"studios":{"label":"Monolocali","title":"Monolocali in vendita a {{city}} | Casavo","description":"Scopri tutti gli annunci su Monolocali in vendita a {{city}}. Casavo collabora solo con agenzie selezionate. Trova subito la casa dei tuoi sogni!"},"one-bedroom-apartments":{"label":"Bilocali","title":"Bilocali in vendita a {{city}} | Casavo","description":"Scopri tutti gli annunci su Bilocali in vendita a {{city}}. Casavo collabora solo con agenzie selezionate. Trova subito la casa dei tuoi sogni!"},"two-bedroom-apartments":{"label":"Trilocali","title":"Trilocali in vendita a {{city}} | Casavo","description":"Scopri tutti gli annunci su Trilocali in vendita a {{city}}. Casavo collabora solo con agenzie selezionate. Trova subito la casa dei tuoi sogni!"},"new-constructions":{"label":"Nuova costruzione","title":"Case in vendita di nuova costruzione a {{city}} | Casavo","description":"Scopri tutti gli annunci su case in vendita a {{city}} di nuova costruzione. Casavo collabora solo con agenzie selezionate. Trova subito la casa dei tuoi sogni!"}}');

/***/ }),

/***/ 96074:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"claim":"<0>Questa è una <1>Casa Casavo</1></0>","claim_cta":"<0>Questa è una <2/><1>Casa Casavo</1></0>","title":"Case Casavo: i proprietari, siamo noi.","title_detail":"È una Casa Casavo","text":"<0>Sappiamo che trovare la casa giusta in vendita non sempre è facile.</0><0>Le Case Casavo sono acquistate e ristrutturate da noi, così non avrai brutte sorprese.</0><0>Il meglio del nostro meglio a un prezzo mai superiore alla media di mercato.</0><1>Cerca la <2/> sugli annunci!</1>","text_detail":"Tutto per farti godere la tua nuova casa in tranquillità...","discover_all_the_advantages":"Scopri tutti i vantaggi","modal_subtitle":"<0>Vogliamo liberarti da ogni pensiero: le Case Casavo, anche ristrutturate, sono controllate e curate interamente da noi.</0><1>Il meglio del nostro meglio, con tanti servizi esclusivi a te dedicati.</1>","list_item_discount_modal_description":"Non riusciamo a dirti tutto qua, non vogliamo disturbare la tua ricerca... scopri tutti i vantaggi Casavo, il nostro team è a tua disposizione ❤️","good_to_know":"Buono a sapersi!","what_does_it_mean":"Cosa significa?","modal_list_items":[{"title":"Vantaggi compresi nel servizio:","items":[{"title":"Assicurazione per 1 anno","description":"Se abbiamo ristrutturato questa casa, hai anche 1 anno di assicurazione e riparazioni gratuite."},{"title":"Assistenza post acquisto","description":"Un team dedicato all\'assistenza clienti sarà a tuo supporto per ogni esigenza anche dopo il rogito."},{"title":"Un team sempre al tuo fianco","description":"Esperti del mercato immobiliare, consulenti finanziari, interior designer e architetti... Il nostro team è composto da tutte le figure necessarie per accompagnarti fino dopo l\'acquisto della tua nuova casa."}]},{"title":"...altro al tuo servizio, da Casavo:","items":[{"title":"Servizio mutui","description":"Tu scegli la casa che preferisci, al mutuo ci pensa Casavo Mutui. Un consulente dedicato si prenderà cura di tutta la burocrazia.","image":"loan"},{"title":"Arredamento e interni","description":"Ti piace la casa arredata come nei virtual tour? Puoi richiedere di averla esattamente così, completamente arredata!","image":"furniture"},{"title":"Convenzioni esclusive","description":"Luce, gas, WiFi, sistemi d\'allarme, elettronica e tanto, tanto altro.","image":"discount"}]}],"advantage_first":"Servizio Mutui","advantage_second":"Assistenza post acquisto","advantage_third":"Un team sempre al tuo fianco"}');

/***/ }),

/***/ 27044:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"available":"disponibili","available-singular":"disponibile","title":"Appartamenti in vendita | Casavo","title-listing":"Appartamenti in vendita a {{city}} | Casavo","description":"Scopri tutti gli annunci su case in vendita nelle principali città italiane e trova la casa dei tuoi sogni su Casavo.com!","description-listing":"Scopri tutti gli annunci su case in vendita a {{city}} e trova la casa dei tuoi sogni su Casavo.com!","loading":"Caricamento...","of":"su","of2":"di","entrance_floor":"Piano","entrance_floors":"Piani","basement":"Seminterrato","raised":"Piano rialzato","ground_floor":"Piano terra","last_floor":"Ultimo piano","mid_floor":"Intermedio","select_city":"Seleziona una città","rooms":"Locali","bathrooms":"Bagni","bedrooms":"Camere da letto","status":"Stato","habitable":"Abitabile","new":"Nuova costruzione","renovated":"Ristrutturato","need_renovation":"Da ristrutturare","under_construction":"In costruzione","private_negotiation":"Trattativa riservata","get-free-offer-label":"Vendi Casa","get-free-offer-small-label":"Vendi Casa","our-properties-label":"Compra casa","our-properties-small-label":"Compra","our-clients-label":"I nostri clienti","are-you-broker-label":"Sei un\'agenzia?","footer-service-label":"Servizi","footer-resources-label":"Risorse","footer-about-us-label":"Company","footer-our-properties-label":"Case in vendita","footer-press-label":"Dicono di noi","footer-blog-label":"Blog","footer-faqs-label":"Domande frequenti","footer-work-label":"Lavora con noi","footer-work":"https://careers.casavo.com","footer-contact-label":"Contattaci","footer-casavo-es-label":"Casavo España","footer-casavo-pt-label":"Casavo Portugal","footer-legal-label":"Dati societari","footer-privacy-label":"Privacy Policy","footer-terms-label":"Termini e Condizioni","footer-made-with":"Fatto con il","footer-made-in":"in Italia","for-sale":"in vendita","listing_not_found_title":"Annuncio non disponibile","listing_not_found_similar_properties_subtitle":"L’annuncio che cerchi è stato rimosso oppure la casa è stata già venduta.","listing_not_found_cta":"Vedi gli annunci","text-list":"Lista","text-map":"Mappa","open-map":"Apri mappa","no-listings-in-city":"Purtroppo non ci sono ancora case disponibili in questa città :(","casavo-properties-title":"Casa Casavo","cta_show_virtual_tour":"Virtual Tour","enter_virtual_tour":"Entra in casa","message_virtual_tour":"Tour virtuale","view_property":"Visualizza dettagli","page":"Pagina","photos":"Foto","pagination-bottom":"di {{length}} case","of-pagination":"di","tooltip-text":"Le case di Casavo non hanno mai un prezzo superiore a quello di mercato","houses-for-sale-in-area":"Case <0>nell\'area di {{area}}</0>","house-for-sale-in-area":"Casa <0>nell\'area di {{area}}</0>","houses-for-sale-in-city":"Case <0>a {{city}}</0>","house-for-sale-in-city":"Casa in vendita <0>a {{city}}</0>","houses-for-sale-in-zone":"Case <0>in zona {{zone}}</0>","house-for-sale-in-zone":"Casa <0>in zona {{zone}}</0>","house-for-sale-byZone-filter":"Casa <0>in zona {{area}}</0>","houses-for-sale-byZone-filter":"Case <0>in zona {{area}}</0>","outdoor_space_label":"Spazio all\'aperto","new_listing_label":"Nuovo!","tooltips":{"casavo_property":"Le case di Casavo non hanno mai un prezzo superiore a quello di mercato","outdoor_space":"Vivi la tua casa all’aperto! Questa casa dispone di un terrazzo o giardino.","energy_efficient":{"A_B":"Ottimo per l’ambiente 🌳. Questa casa ha una classe energetica superiore alla B.","C":"Più efficienza, più comfort. Questa casa ha una classe energetica superiore alla B"}},"read_more":"altro...","read_less":"mostra meno","invalid-email-message":"Puoi controllare che la tua email sia scritta bene?","required-field-message":"Campo obbligatorio","mortgage":{"title":"Servizio Mutui","text":"Mutuo: basta la parola.<0/>Accanto a te,<0/>dalla ricerca alla firma.","cta":"Dimmi di più su Casavo Mutui","contact-us":"Siamo a tua disposizione<0/>Contattaci quando vuoi"},"mortgage-modal":{"title":"Ci occupiamo noi della parte più noiosa.","content-top":"In Casavo abbiamo un team dedicato e specializzato, a tua disposizione, per prendersi cura della pratica del mutuo e seguire i rapporti con la tua banca di fiducia. Così hai più tempo per pensare ad altro.","content-bottom":"Più di 110 clienti hanno già usufruito del nostro servizio ottenendo il mutuo con 15 giorni di anticipo. Gratuitamente.","more":"Vuoi saperne di più?","call":"Chiamaci"},"form-error":"Qualcosa è andato storto. Per favore, riprova.","where-looking-for":"Dove stai cercando?","province":"Area","province-of":"Area di {{area}}","municipality":"Comune","menu":{"sell":"Vendi Casa","buy":"Compra Casa","our-clients":"I nostri clienti","agency":"Sei un\'agenzia?","about":"Su Casavo"},"listings":{"canonical-links-title":"Tipologia case {{city}}:","most-visited-zones-title":"Annunci immobiliari a {{city}}:"},"prev":"Precedente","next":"Seguente","footer-team-label":"Team","footer-partner-label":"Diventa partner","footer-casavo-it-label":"Casavo Italia","invalid-phone-message":"Numero di telefono non valido","casavo-inventory-agency-title":"Garantita Casavo","CTA_Next":"Avanti","GenericError_Modal_Description":"Purtroppo qualcosa non è andato come pensavamo, puoi riprovare per favore?","GenericError_Modal_Title":"Oops...","simple_confirm":"Ok!","No":"No","Yes":"Sì","years":"anni","Header_AddressFormat":"<0>{{streetName}}</0><1>N° {{streetNumber}}, {{city}}</1>","address_format":"{{streetName}} N° {{streetNumber}}, {{city}}"}');

/***/ }),

/***/ 68779:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"agency":{"message":{"cta":"Vuoi dirci di più?","label":"Dicci di più","placeholder":"Hai domande? \\nQuando vorresti essere ricontattato?"},"success":{"message":"E la prima cosa è fatta...\\nIl nostro partner ti contatterà al più presto","cta":"Visualizza case simili"}},"casavo":{"assistant":"Il tuo assistente Casavo","name":"Nome","reason":{"placeholder":"Siamo felici che questa casa ti piaccia! Come possiamo aiutarti?","warning":"Saperlo ci permette di aiutarti più velocemente","options":{"morePhotos":"Vorrei ricevere più fotografie e materiali","moreAboutHouse":"Vorrei più informazioni su questa casa","other":"Altro..."}},"title":"<0>La tua esperienza <1>Casavo</1> inizia da qui.</0> ","success":{"title":"Il primo passo è fatto!","subtitle":"...da adesso puoi contare su di noi.<0/> Ti contatteremo al più presto.","postScriptum":"Ps: La tua richiesta è al sicuro\\ne nessuno potrà passarti avanti","cta":"Visualizza case simili"}},"phone":"Il tuo numero di telefono","submit":"Invia","email":{"label":"La tua e-mail","success":"Grazie, richiesta ricevuta! Dai un occhio alla tua mail per i prossimi passi"},"success":{"toFlow":{"title":"Stai vendendo casa?","subtitle":" ","cta":"Ottieni una valutazione"}},"ContactForm_SuccessSaveSearch_CTA_Primary":"Ricevi gli avvisi","ContactForm_SuccessSaveSearch_CTA_Secondary":"No, grazie","ContactForm_SuccessSaveSearch_Subtitle":"Te li inviamo comodamente nella tua email","ContactForm_SuccessSaveSearch_Title":"Vuoi ricevere nuovi annunci simili a questo?","ContactForm_SuccessSaveSearch_OkFeedback":"Avvisi attivati","name":"Nome","lastname":"Cognome"}');

/***/ }),

/***/ 16593:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Favourites_FavouriteList_AutodeleteMessage":"Se una casa non è più sul mercato, scomparirà automaticamente dai tuoi preferiti entro 20 giorni.","Favourites_FavouriteList_FavouriteCard_Unavailable":"Non più disponibile","Favourites_FavouriteList_DeleteConfirm_title":"Vuoi rimuovere questo preferito?","Favourites_FavouriteList_DeleteConfirm_cancelCTA":"Annulla","Favourites_FavouritesList_Title":"I tuoi preferiti","Favourites_FavouriteList_EmptyState":"Appena trovi una casa che ti piace, clicca sul  <icon/> per salvarla qui nei tuoi preferiti.","Favourites_FavouriteList_ConfirmToast_title":"Preferito rimosso","Favourites_FavouriteList_DeleteConfirm_mainCTA":"Rimuovi","Favourites_FavouriteList_ConfirmToast_body":"Non preoccuparti, troverai altre case che ti faranno battere il cuore.","Favourites_FavouriteList_EmptyStateMain":"Colpo di fulmine?","Favourites_FavouritesList_SubTitle1":{"one":"{{count}} annuncio ti ha fatto brillare gli occhi","other":"{{count}} annunci ti hanno fatto brillare gli occhi"},"Desktop_Saved":"Salvata","Desktop_Save":"Salva","FavouritesList_Desktop_BackToSearch":"Torna alla ricerca","FavouriteList_EmptyState_Unauth_CTA":"Accedi","FavouriteList_EmptyState_Unauth_Title":"Colpo di fulmine?","FavouriteList_EmptyState_Unauth_Description":"Accedi per salvare le case che ti piacciono nei preferiti e non perderle più d’occhio.","Favourites_Add_To_Favorite_CTA":"Salva nei preferiti"}');

/***/ }),

/***/ 85413:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"change-filters":"Cambia Filtri","price":"Prezzo","surface":"Superficie","room":"Locale","rooms":"Locali","status":"Stato","other_filters":"Altri filtri","properties":"Case","property":"casa","properties_for_you":"Case disponibili","property_for_you":"Casa disponibile","no_properties":"Nessuna casa disponibile","last_uploaded":"Più recenti","most_relevant":"Più rilevanti","cheapest":"Prezzo più basso","most_expensive":"Prezzo più alto","area_max":"Superficie più grande","area_min":"Superficie più piccola","no_properties_for_filters_title":"Al momento non ci sono case con queste caratteristiche.","no_properties_for_filters_subtitle":"Prova a cambiare i filtri per visualizzare altri risultati","save":"Salva","from":"Da","to":"A","max":"Max","min":"Min","filters":"Filtri","trendy_filters":"Filtri popolari","filter_by":"Filtra per","reset":"Reset","undo":"Cancella","apply":"Applica","only_casavo":"Mostra solo Case Casavo","price_guaranted":"Prezzo garantito","renovated_properties":"Case ristrutturate","assistance_guaranted":"Assistenza professionale","typology":"Tipologia","bathroom":"Bagno","bathrooms":"Bagni","bedroom":"Camera da letto","bedrooms":"Camere da letto","entrance_floor":"Piano","state_of_manteinance":"Stato casa","state_at_deed":"Stato al rogito","services":"Servizi","heating_system":"Riscaldamento","year_of_construction":"Anno di costruzione","anyone_choice":"Qualsiasi","apartment":"Appartamento","house":"Casa indipendente","townhouse":"Villetta a schiera","villa":"Villa","loft":"Loft","attic":"Attico","mansard":"Mansarda","basement":"Seminterrato","raised":"Piano rialzato","ground_floor":"Piano terra","last_floor":"Ultimo piano","mid_floor":"Intermedio","habitable_status":"Abitabile","new_status":"Nuova costruzione","renovated_status":"Ristrutturato","need_renovation_status":"Da ristrutturare","under_construction_status":"In costruzione","OCCUPIED":"Occupato","FREE":"Libero","RENTED":"Affittato","BARE_OWNERSHIP":"Nuda proprietà","elevator":"Ascensore","parkingSpaces":"Parcheggio","box":"Box auto","garage":"Box auto","cellar":"Cantina","garden":"Giardino","balcony":"Balcone","balconies":"Balconi","terrace":"Terrazzo","terraces":"Terrazzi","pool":"Piscina","coolingSystem":"AC","conciergeService":"Portineria","AUTONOMOUS":"Autonomo","SHARED":"Centralizzato","NONE":"Nessuno","at_least":"Almeno","single_filter":"filtro","single_filters":"filtri","milan":"Milano","turin":"Torino","bologna":"Bologna","verona":"Verona","rome":"Roma","florence":"Firenze","only_casavo_filter_label":"Mostra solo le Case Casavo","ranking":"Automatico","trendy_filters_description":"Questi filtri, se impostati, ci aiutano a proporti le case più adatte ai tuoi desideri","other_filters_description":"Tutto quello che ti serve per cercare la casa che immagini","filters_zone_suggestion_title":"Dove stai cercando? ","filters_zone_suggestion_description":"Guadagna tempo <0>selezionando zone specifiche</0>."}');

/***/ }),

/***/ 87597:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Furniture_DetailPage_FurnitureBanner_Title":"Sì, puoi averla già arredata","Furniture_DetailPage_FurnitureBanner_CTA":"Cosa comprende?","Furniture_DetailPage_FurnitureBanner_Body":"Abbiamo realizzato un progetto di <b>arredo su misura</b> per questa casa.","Furnitures_Detailpage_FurniturePriceTag":"Arredo disponibile","Furniture_PhotoCarousel_Toast_CTA":"Guarda il progetto","Furniture_PhotoCarousel_Toast_Body":"Ecco il progetto di arredo che abbiamo pensato su misura per questa casa","Furniture_PhotoCarousel_Toast_Title":"Ti piace arredata così?","Furniture_Modal_Title":"Il nostro progetto su misura per te","Furniture_Modal_FormTitle":"👇 Ricevi subito il progetto di arredo","Furniture_Modal_Bullet_2":"<b>Scegli tu come personalizzare </b>nei minimi dettagli","Furniture_Modal_MktgConsent_Description":"Autorizzaci ad aggiornarti con le nostre news su nuovi arredamenti e servizi","Furniture_Modal_Bullet_3":"<b>I migliori marchi </b>a tua disposizione:","Furniture_Modal_CTA":"Ricevi progetto","Furniture_Modal_Bullet_1":"<b>Cucina, bagni e armadiature</b> per la tua nuova casa","Furniture_ServiceName":"Interior","Brand_CasavoServices":"Casavo Services"}');

/***/ }),

/***/ 82588:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Items0_Title":"Per vendere, semplicemente","Items0_Description":"Rilassati. La tua casa l’acquistiamo noi o troviamo l’acquirente per te.","Items1_Title":"Per Casavo Mutui","Items1_Description":"E dire addio alla burocrazia. Troviamo noi il mutuo migliore per te.","Items2_Title":"Per le persone che parlano di noi","Items2_Description":"Cosa dice chi ci ha scelto? Scopri le storie di chi ci conosce già.","Footer_Title":"Altre domande?","Footer_Description":"Abbiamo sempre una risposta per ogni domanda che hai per noi. E se non le trovi tutte, contattaci. Noi siamo qui.","Title":"Casavo Perché"}');

/***/ }),

/***/ 9936:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"find-your-house":"Scopri le nostre case <0/>in vendita per te a..."}');

/***/ }),

/***/ 14597:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title_not_found":"Annuncio non trovato","characteristics":"Caratteristiche","description":"Descrizione","the_district":"Il quartiere","at_your_service":"A tua disposizione","at_your_service_message":"Ti contatteremo quando preferisci.","show_number":"Mostra numero","show_number_casavo":"Chiamaci","request_info":"Richiedi info","request_visit":"Richiedi una visita","request_visit_modal_title":"Richiedi una visita","request_visit_modal_thank_you_title":"Aspetta la nostra conferma","contact_us":"Contattaci","contact_email":"La tua e-mail","contact_phone_number":"Il tuo numero","fomo_message_person":"<0>{{userViews}} persona</0> ha visto questo annuncio nell’ultima ora","fomo_message_people":"<0>{{userViews}} persone</0> hanno visto questo annuncio nell’ultima ora","phone_call":"Chiama","phone_call_now":"Chiama ora","rooms":"Locali","bathrooms":"Bagni","bedrooms":"Camere da letto","balconies":"Balconi","terraces":"Terrazzi","balcony":"Balcone","terrace":"Terrazzo","status":"Stato","planimetry":"Planimetria","services":"Servizi","see_all_characteristics":"Vedi tutto","see_less_characteristics":"Vedi meno","elevator":"Ascensore","parkingSpaces":"Parcheggio","box":"Box auto","basement":"Cantina","garden":"Giardino","coolingSystem":"AC","coolingSystem_full":"Aria condizionata","coolingSystem_AUTONOMOUS":"Autonoma","coolingSystem_SHARED":"Centralizzata","coolingSystem_READY_FOR_INSTALLATION":"Predisposizione","coolingSystem_NONE":"No","conciergeService":"Portineria","recreationRoom":"Taverna","garret":"Soffitta","pool":"Piscina","sharedPool":"Piscina comune","tennisCourt":"Campo da tennis","fireplace":"Camino","disabledAccess":"Accesso disabili","wallCabinet":"Armadio a muro","fastInternet":"Fibra ottica","hydromassage":"Idromassaggio","tvSystem":"Impianto tv","electricGate":"Cancello elettrico","armoredDoor":"Porta blindata","alarmSystem":"Allarme","entranceVideoPhone":"Videocitofono","year_of_construction":"Anno di costruzione","year_of_renovation":"Anno ultima ristrutturazione","exposure":"Esposizione","NORTH":"Nord","SOUTH":"Sud","EAST":"Est","WEST":"Ovest","furniture":"Arredamento","FULLY_FURNISHED":"Completamente arredato","NOT_FURNISHED":"Non arredato","PARTIALLY_FURNISHED":"Parzialmente arredato","estate_registry_class":"Categoria catastale","energy_rating_label":"Classe energetica","energy_performance_index_label":"Prestazione energetica globale (EPgl o IPE)","energy_performance_index_udm":"kWh/m² anno","energy_rating":{"energy_a4":"A4","energy_a3":"A3","energy_a2":"A2","energy_a1":"A1","energy_aplus":"A+","energy_a":"A","energy_b":"B","energy_c":"C","energy_d":"D","energy_e":"E","energy_f":"F","energy_g":"G","energy_pending_request":"In corso di certificazione"},"kitchen":"Cucina","kitchen_HABITABLE":"Cucina abitabile","kitchen_HALF_HABITABLE":"Cucina semiabitabile","kitchen_KITCHENETTE":"Angolo cottura","kitchen_OPEN":"Cucina aperta","glazing":"Infissi","glazing_SINGLE":"Singoli","glazing_DOUBLE":"Doppio vetro","glazing_TRIPLE":"Triplo vetro","info":"Info","condo_fees":"Spese condominiali","per_year_label":"annuali","state_at_deed":"Stato al rogito","OCCUPIED":"Occupato","FREE":"Libero","RENTED":"Affittato","BARE_OWNERSHIP":"Nuda proprietà","heating_system":"Riscaldamento","AUTONOMOUS":"Autonomo","SHARED":"Centralizzato","NONE":"Nessuno","exclusive_mandate":"Mandato in esclusiva","cta_show_photos":"Guarda {{photoLength}} foto","cta_show_virtual_tour":"Virtual Tour","cta_show_virtual_tour_mobile":"Tour","apartment":"Appartamento","house":"Casa indipendente","townhouse":"Villetta a schiera","villa":"Villa","loft":"Loft","attic":"Attico","mansard":"Mansarda","sharing":"Condividi","might_interest_you":"Case simili","based_on_your_searches":"Queste case potrebbero piacerti:","poi_nearby":"Nei dintorni di questa casa trovi:","poi_discover":"Scopri:","TRANSPORT":{"poi_category":"Trasporti","poi_nearby_card_title":"Trasporti","poi_nearby_card_distance":"La fermata più vicina <1/>è <0>a {{distance}} m</0>","BUS_STOP_distance":"Fermata Bus a {{distance}} m","TRAIN_STATION_distance":"Stazione a {{distance}} m","SUBWAY_STATION_distance":"Fermata Metro a {{distance}} m","TRAM_STOP_distance":"Fermata Tram a {{distance}} m","poi_nearby_card_all":"Vai ai trasporti","BUS_STOP_label":"Autobus","TRAIN_STATION_label":"Treno","SUBWAY_STATION_label":"Metro","TRAM_STOP_label":"Tram"},"SCHOOL":{"poi_nearby_card_title":"Scuole","poi_nearby_card_distance":"La scuola più vicina <1/>è <0>a {{distance}} m</0>","SCHOOL_distance":"Scuola a {{distance}}m","poi_category":"Scuole","poi_nearby_card_all":"Vai alle scuole","SCHOOL_label":"Scuola"},"SHOP":{"poi_nearby_card_title":"Supermercati","poi_nearby_card_distance":"Il supermercato più vicino <1/>è <0>a {{distance}} m</0> ","SHOP_distance":"Supermercato a {{distance}}m","poi_nearby_card_all":"Vai ai supermercati","poi_category":"Supermercati","SHOP_label":"Supermercato"},"properties":"Case","neighborhood":"nei dintorni...","more_about_neighborhood":"Scopri di più sul quartiere","less_about_neighborhood":"Vedi meno","last_update":"Annuncio aggiornato il:","street-view":{"address-disclaimer":"Posizione Indicativa","description":"Street View","cta":"Street View"},"at_your_service_agency":"<0>Il nostro partner</0> a tua disposizione","at_your_service_casavo":"Che vuol dire <1>Casa Casavo</1>?","form-header":{"title":"Ti è piaciuta?","subtitle_casavo":"Non lasciartelo sfuggire, ti richiamiamo noi","subtitle_agency":"Non lasciartelo sfuggire, il nostro partner risponderà a ogni tua domanda","agency":{"one":"Agenzia verificata da Casavo","two":"Solo annunci controllati"},"casavo":{"one":"Abbiamo controllato e certificato questa casa","two":"Accedi a assicurazione e assistenza dedicate","three":"Scopri il servizio Mutui","four":"Tutti i servizi Casavo per vivere la casa al meglio"},"subtitle_casavo_inventory_agency":"Noi ci siamo per rispondere a tutte le tue domande.","casavo-agency":{"one":"Commissioni sotto il 3%","two":"Prezzo controllato","three":"Certificazione di conformità","four":"Collaboratori selezionati","five":"Supporto nella burocrazia"}},"we_will_contact_you":"Ti contatteremo al più presto","form-body":{"success_button":"Vedi case simili","success_button_alt":"Continua a cercare"},"request_visit_error":"Invio non riuscito<0/>Per favore, riprova.","request_visit_email_error":"Invio non riuscito.<0/> Verifica che la mail inserita sia corretta","select_visit_date":"Seleziona una data","select_visit_time":"A che ora?","insert_confirmation_info":"Dove possiamo contattarti?","visit_time_disclaimer":"La visita non è ancora confermata ","you_will_receive_confirmation":"Riceverai una conferma","you_will_receive_confirmation_detail":"Un esperto Casavo ti confermerà le disponibilità nella fascia indicata. Insieme concorderete la soluzione più adatta a te.","book_visit_hour_recap":"Dalle {{startHour}} alle {{endHour}}","title_0_1":"in vendita in","request_visit_modal_thankyou_item_2":"Se non possiamo accettare la tua richiesta di visita, troveremo insieme un’altra disponibilità","request_visit_modal_thankyou_item_1":"Ti contattiamo il prima possibile per confermare","title_0":"in vendita a","title_2":"di","title_1":"in","request_call_modal_title":"Fissa una chiamata con un <0>consulente Casavo</0>","request_call_modal_thank_you_title":"Chiamata prenotata","request_call":"Fatti richiamare","request_call_cta":"Parla con noi","request_timeslot_caption":"Durante la chiamata, concorderete un giorno e un orario per visitare questa casa","request_feedback_call_bullet_2":"Se lo vorrai, <0>fisseremo una visita</0> per vedere questa casa","request_feedback_call_bullet_1":"Ti chiameremo il giorno e all’ora prestabiliti per rispondere a tutte le tue domande","select_call_date":"Che giorno preferisci?","select_call_time":"A che ora?","request_call_modal_thank_you_title_2":"Ora tocca a noi","request_visit_modal_thank_you_title_2":"Ora tocca a noi","view":"Vista","view_interior":"Interno","view_exterior":"Esterno","schedule_visit_cta":"Fissa la tua visita","schedule_visit_modal_title":"Fissa una visita per questa <0>Casa Casavo</0>","select_schedule_visit_time":"Seleziona un orario","schedule_visit_confirm_cta":"Conferma la visita","schedule_visit_no_availabilities":"Non ci sono disponibilità per questa data","schedule_visit_recap_no_availabilities":"Trova una data disponibile","schedule_visit_modal_thank_you_title":"Visita confermata!","schedule_visit_modal_thank_you_title_2":"I prossimi passi:","schedule_visit_modal_thankyou_item_1":"Riceverai:\\n- Subito, una mail di riepilogo\\n- 24 ore prima, un SMS di promemoria","schedule_visit_modal_thankyou_item_2":"Ti farà vedere la casa un nostro consulente Casavo","slot_already_booked_error":"Questo orario non è più disponibile","schedule_visit_cta_mobile":"Fissa visita","request_visit_CTA_mobile":"Richiedi visita","schedule_visit_available":"Per questa casa è disponibile la prenotazione immediata","select_request_visit_date":"Che giorno preferisci?","schedule_visit_no_availabilities_title":"Nessun appuntamento disponibile","schedule_visit_no_availabilities_description":"Purtroppo, al momento, tutti gli appuntamenti disponibili sono già stati prenotati","ScheduleVisit_NoSlotModal_CTA_body":"Vuoi <0>salvare nei tuoi preferiti</0> questa casa per tenere sott’occhio le novità?","ScheduleVisit_SelectDate_MoreThan1":"Che giorno preferisci?","ScheduleVisit_SelectDate_Just1":"Resta un solo giorno disponibile","schedule_visit_reminder":"Ti aspettiamo {{day_of_the_week}} {{date_number}} {{month}} alle {{time}}","schedule_visit_slot_recap":"{{day_of_the_week}} {{date_number}} {{month}}, alle {{time}} per noi va benissimo, confermi?","schedule_visit_instant_warn":"Questa è una <0>prenotazione istantanea</0>: se confermi non dovrai attendere una nostra risposta.","schedule_visit_flow_next_button":"Continua","RequestVisit_Modal_Warn":"Aspetta la nostra conferma per la data richiesta","RequestVisit_Modal_Recap":"{{day_of_the_week}} {{date_number}} {{month}}, alle {{time}}.\\u2028 Ti daremo conferma telefonicamente, dove possiamo contattarti?","BookCall_Modal_Recap":"{{day_of_the_week}} {{date_number}} {{month}}, alle {{time}}.\\u2028Dove possiamo contattarti?","BookCall_Modal_Warn":"Faremo il massimo per contattarti quando vuoi tu","RequestCallModal_Reasonlist_MorePhoto":"Vorrei più foto","RequestCallModal_Reasonlist_Questions":"Ho delle domande","RequestCallModal_Reasonlist_Visit":"Vorrei visitare la casa","request_call_mobile":"Chiamatemi","RequestCall_ThankYou_Bullet1":"Ti chiameremo per rispondere a tutte le tue domande","unknown":"-","RelatedAdsBanner_Title":{"one":"1 casa simile a questa","other":"{{n}} case simili a questa"},"RelatedAdsBanner_Description":"Scopri case <b>solo su Casavo</b>.","RelatedAdsBanner_CTA":"Vedi","NearPropertiesBanner_FirstStep_Description":"📍  Scopri case <b>qua vicino</b>","NearPropertiesBanner_PropertiesProgress":"{{n}}/{{tot}} in zona","NearPropertiesBanner_FirstStep_CTA":{"one":"Vedi 1 casa","other":"Vedi {{n}} case"},"HomePlusBanner_Title":"Scopri Casavo Homeplus","HomePlusBanner_CTA":"Vedi le offerte","HomePlusBanner_Description":"Abbiamo selezionato alcuni dei migliori brand per proporti <b>offerte esclusive </b>e vivere al meglio la tua nuova casa."}');

/***/ }),

/***/ 24618:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"SearchSettings_Zone_Title":"Zone","SearchSettings_Modal_ApplyChangesCTA":"Applica","SearchSettings_Price_Title":"Budget","SearchSettings_Rooms_Title":"Spazio","SearchSettings_City_Title":"Città:","SearchSettings_CTA":"Aggiorna preferenze","SearchSettings_Back":"Esci","SearchSettings_ChangeCityCTA":"Cambia città","SearchSettings_Subtitle":"Sono le informazioni di partenza che ci permettono di capire cosa proporti","SearchSettings_Title":"Le tue preferenze","SearchSettings_Price_Intro":"Fino a:","SearchSettings_Rooms_Intro":"Almeno un:","SearchSetting_MobileNavBar_Title":"Preferenze","SearchSettings_SuccessBanner_Title":"Preferenze aggiornate","MainSearch_SEO_Title":"Per te - Noi cerchiamo, tu trovi"}');

/***/ }),

/***/ 23947:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Login_Button":"Accedi","Search_Button":"Ricerca","Profile_Button":"Profilo","Favorites_Button":"Preferiti"}');

/***/ }),

/***/ 14178:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Priority_ThankyouPage_CTA":"Vedi case già in vendita","Priority_ThankyouPage_Description":"Appena questa casa sarà sul mercato, sarai uno dei primi a poterla visitare.","Priority_ThankyouPage_Title":"Tutto fatto!","Priority_Unsubscribe_Title":"Tutto tranquillo qui...","Priority_Unsubscribe_Subtitle2":"Notifiche Disattivate","Priority_Unsubscribe_CTA":"Vedi le case in vendita","Priority_Unsubscribe_Subtitle1":"Non riceverai più queste email","Priority_ThankyouPage_PageTitle":"Visita richiesta","Priority_DetailPage_FloatingBanner_Bullet3":"Acquista al giusto prezzo","Priority_DetailPage_AdvantagesCard_Advance_Description":"Scopri gli annunci di case in vendita, prima degli altri.","Priority_DetailPage_AdvantagesCard_Advance_Title":"Chi prima arriva...","Priority_DetailPage_AdvantagesCard_Support_Description":"Seguiamo da vicino chi vende e chi acquista, per garantire la massima trasparenza e affidabilità.","Priority_DetailPage_AdvantagesCard_Waitlist_Title":"Visita in anteprima","Priority_DetailPage_FloatingBanner_Bullet1":"Ti chiamiamo appena è disponibile","Priority_DetailPage_AdvantagesCard_RightPrice_Description":"Hai meno concorrenza e puoi parlare con il venditore prima degli altri per arrivare ad un prezzo corretto per entrambi.","Priority_DetailPage_AdvantagesBox_Description":"Trova annunci di case in anteprima, in base alle tue preferenze.","Priority_DetailPage_FloatingBanner_CTA":"Mi interessa","Priority_DetailPage_FloatingBanner_Title":"Nuova casa in arrivo","Priority_DetailPage_PreviewDescription":"Questa casa <b>è in anteprima</b>","Priority_DetailPage_Banner_Description":"Stai vedendo una casa <b>in anteprima </b>","Priority_DetailPage_AdvantagesCard_RightPrice_Title":"Acquista al giusto prezzo","Priority_DetailPage_AdvantagesCard_Support_Title":"Ricevi supporto","Priority_DetailPage_FloatingBanner_Bullet2":"Visitala prima degli altri","Priority_DetailPage_Banner_CTA":"Cosa significa?","Priority_DetailPage_AdvantagesCard_Waitlist_Description":"Se la casa ti piace, puoi vederla dal vivo prima che venga messa sul mercato.","Priority_DetailPage_AdvantagesBox_Title":"Cosa significa In anteprima?","Priority_DetailPage_AdvantagesBox_Preview_Description":"Questa casa è <b>in arrivo</b>","Priority_DetailPage_SimilarProperties_Title":"Case simili","Priority_DetailPage_SimilarProperties_Description":"Queste case potrebbero piacerti:","PriorityDetail_FloatingBanner_Booked_Description":"Tutto sotto controllo: \\nti faremo sapere quando la potrai visitare.","PriorityDetail_FloatingBanner_Booked_CTA":"Sei già in lista","Priority404_H1":"Annuncio non disponibile","Priority404_CTA":"Continua a cercare","Priority404_Descritpion":"Purtroppo questa casa non è più in vendita. Ci dispiace. \\n\\nFaremo il massimo per trovare altre case in anteprima per te.","Priority_ThankyouPage_Description_Outro":"Bello eh?","Priority_PhoneNumberModal_Banner_Description":"Sarai tra i primi a vedere questa casa","Priority_PhoneNumberModal_Title":"Ti chiamiamo appena abbiamo novità 📞","Priority_ThankyouPage_Bullet1":"Quando la casa arriva sul mercato, <b>hai la precedenza</b> per visitarla","Priority_ThankyouPage_Description_Intro":"E adesso?","Priority_ThankyouPage_Bullet2":"<b>Aspetta che ti chiamiamo</b> per organizzare la visita","PriorityCard_PreviewTag":"⏰ CASA IN ARRIVO","PriorityCard_NotLoggedBanner_Description":"Salta la fila, gratis.","PriorityDetail_TeasingBanner_NotLogged_CTA":"Cosa significa?","PriorityDetail_NotLogged_Intro_CTA":"Sblocca le foto","PriorityDetail_TeasingBanner_NotLogged_Description":"Le <b>case in anteprima</b> sono dedicate agli <b>utenti Casavo</b>","PriorityCard_NotLoggedBanner_CTA":"Sblocca","PriorityDeatil_NotLogged_Intro_Description":"Hai già un account?","Priority_DetailPage_AdvantagesBox_CTA":"Sblocca","OnMarketTab":"sul mercato","PriorityTab":"in anteprima","PriorityTab_NoResult_Description_logged":"Quando saranno disponibili, le troverai qui.","PriorityTab_Title_notlogged":"Visita case non ancora sul mercato","PriorityTab_NoResult_CTA_logged":"Goditi le case in vendita","PriorityTab_Title_logged":"Case in arrivo: visitale prima degli altri","PriorityTab_NoResult_Description_notlogged":"Registrati e arriva prima degli altri","PriorityTab_NoResult_CTA_notlogged":"Accedi","PriorityCard_CTA":"Sblocca","PriorityDetail-FloatingBanner-DislikeCTA":"Non mi piace","Priority_DetailPage_FloatingBanner_CTAmobile":"Mi interessa","PriorityDetail-FloatingBanner-FeedbackDescription":"I tuoi feedback ci aiutano a proporti altre case","PriceAnalysis_HighPrice_Modal_Body":"Al momento, <b>questa casa è leggermente più cara</b> rispetto alle altre simili in zona.\\n<br/><br/>\\nPer case come questa, considera che di solito<b> il prezzo provvisorio può scendere fino al {{Discount}}% rispetto al prezzo definitivo dell’annuncio</b>. Ad esempio, da {{AskingPrice}} potrebbe arrivare a {{SuggestedPrice}}.\\n<br/><br/>\\nSe la casa ti piace,<b> prima la vedi, più è facile abbassare il prezzo.</b>","PriceAnalysis_GoodPrice_Description":"Il prezzo provvisorio è in linea con le case simili in zona. <u>Come lo sappiamo?</u>","PriceAnalysis_HighPrice_Modal_Title":"Prezzo provvisorio alto","PriceAnalysis_GoodPrice_Tag":"Buon prezzo","PriceAnalysis_GoodPrice_Modal_Body":"Le case in anteprima hanno un prezzo provvisorio perché non sono ancora sul mercato.\\n<br/><br/>\\n<b>Il prezzo di questa casa è in linea con le case simili della zona.\\n<br/><br/>\\n</b>Se la casa ti piace, dicci se la vuoi visitare in anteprima.<b> Prima la vedi, meno concorrenza hai per comprarla.</b>","PriceAnalysis_HighPrice_Tag":"Prezzo alto","PriceAnalysis_HighPrice_Description":"Il prezzo provvisorio è più alto di case simili della zona. <u>Perché il prezzo si abbasserà</u>","PriceAnalysis_GoodPrice_Modal_Title":"Buon prezzo provvisorio","PriorityInfoBanner_Title":"{{count}} case in anteprima","PriorityInfoBanner_Description":"Ti sveliamo quali case stanno per arrivare sul mercato, e ti teniamo già il posto per visitarle. <b>Gratis</b>.","PriorityInfoBanner_CTA":"Sblocca","PriorityCarousel_CTA":"Vedi tutte","PriorityCarousel_Description":"Visita case non ancora sul mercato","PriorityCarousel_Title":"{{n}} case in anteprima","PriorityCarousel_LastCard_CTA":"🗄️ Vedi tutte +","PriorityDetailPage_Title":"Anteprima"}');

/***/ }),

/***/ 55273:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"disclaimer":"Premendo su \\"{{cta}}\\" dichiaro di aver preso visione dei <0>Termini e Condizioni</0> e della <1>Privacy Policy</1>","gdpr":{"title":"Possiamo fare altro per te?","marketing-consent-checkbox":"Fatemi sapere se ci sono novità","marketing-consent-details":"Autorizzaci ad <0>aggiornarti</0> con le nostre novità su un nuovo modo di acquistare e vendere casa","marketing-consent-full-text":"Autorizzo Casavo a trattare i miei dati per comunicazioni in merito a iniziative e offerte commerciali."},"mortgage":{"title":"Ho bisogno di un mutuo","short-text":"Autorizzo Casavo a presentarmi il servizio Casavo Mutui.","full-text":"Autorizzo Casavo a trattare e condividere i miei dati con le società del Gruppo Casavo, operanti nel settore finanziario/mutui per inviarmi aggiornamenti su attività e offerte, per condurre ricerche di mercato e attività dirette a rilevare la qualità dei servizi via telefono, e-mail e messaggistica."},"recaptcha":{"disclaimer":"Questo sito è protetto da reCaptcha e si applicano la <0>Privacy Policy</0> e i <1>Termini di Servizio</1> di Google"},"disclaimer-mortgage":"Premendo su \\"{{cta}}\\" autorizzo Casavo a presentarmi il servizio Casavo Mutui."}');

/***/ }),

/***/ 54947:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"area":"in zona","city":"Città","price":"con budget","email_label":"La tua mail","features_title":"altri filtri:","cta":"Salva ricerca","cta_saved":"Ricerca salvata","no_spam":"No spam! 1 email <0>ogni 3 giorni</0> al massimo","turn_off_notifications":"Disattiva le notifiche <0>quando vuoi</0>","title":"Ti aggiorniamo noi","your_research":"La tua ricerca","subtitle":"Ricevi comodamente per email i nuovi annunci affini alla tua ricerca:","only_casavo":"Solo Case Casavo","saveSearch-floatingBanner-text":"Vuoi ricevere i <b>nuovi annunci</b> per questa ricerca?","saveSearch-floatingBanner-text1result":"C’è un solo risultato, vuoi ricevere i nuovi annunci?","saveSearch-floatingBanner-textNewFilters":"Nuovi filtri, nuova ricerca.\\nTi aggiorniamo sugli annunci?","saveSearch-floatingBannerFeedback-subtitle":"Riceverai i nuovi annunci via email!","saveSearch-floatingBannerFeedback-title":"Ricerca salvata","Modal_Title":"Ricevi i nuovi annunci\\nche ti interessano","Modal_Zone_intro":"Ti avvisiamo per gli annunci a:","Modal_NoFilterBanner_Title":"Vuoi affinare la ricerca?","Modal_NoFilterBanner_CTA":"Aggiungi filtri","Modal_CTA":"Salva ricerca","Modal_NoFilterBanner_Description":"Puoi aggiungere filtri per risultati più accurati","Modal_Form_Title":"Dove preferisci riceverli?","Modal_Form_NotificationsMessage":"Puoi disattivare le notifiche quando vuoi","SearchSearch_Modal_Success_Title":"Avvisi attivati","SearchSearch_Modal_Success_Subtitle":"Ti inviamo una email quando troviamo annunci simili.","SearchSearch_Modal_Success_CTA":"Continua a cercare","Modal_Success_Body1":"Riceverai i nuovi annunci\\nper la tua ricerca a","Login_BottomSheet_Subtitle":"Ti invieremo i nuovi annunci direttamente nella tua mail, ti va?","Modal_Success_CTA":"Ottimo!","Modal_AuthUser_Text":"Li riceverai su","Modal_Success_Body2":"...puoi disattivare la ricezione quando vuoi.","Login_BottomSheet_Title":"Dove preferisci riceverli?","Modal_Success_Title":"Ricerca salvata","Login_BottomSheet_CTA":"Invia","Modal_AuthUser_Link":"Profilo","LoaderModal_Description":"Giusto un secondo...","Error_InvalidMail_Description":"Sembra che la mail che hai scelto non sia valida. Prova a registrarti con un’altra mail","Error_InvalidMail_Title":"Mail non valida"}');

/***/ }),

/***/ 52027:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"BudgetQuestion_Submit":"Fatto!","Suggested_Today_Description":"Facci sapere se ti piacciono: siamo tutt’orecchi.","City_Question":"In che città stai cercando?","Suggested_Loader_1":"Sfogliando gli annunci...","Suggested_Welcome_Description":"Ecco la tua selezione quotidiana su misura dei nostri annunci.","Suggested_Welcome_Title":"Ciao!","MainSearch_Intro_Description":"4 domande per la casa perfetta. Con noi, trovi anche case non ancora sul mercato.","MainSearch_Intro_Title":"Parlaci di te, lascia cercare noi.","Suggested_Today_Title":"Già sul mercato","Suggested_NoResults_Title":"Insieme troveremo la casa giusta","Suggested_NoResults_CTA":"Vedi tutti gli annunci","Suggested_NoResults_Description":"Per adesso non ci sono case che corrispondono alla tua ricerca.\\n \\nMa non ti preoccupare: stiamo cercando annunci perfetti per te. Li vedrai qui non appena saranno disponibili.","Suggested_Flow_TypeQuestion":"Vorresti almeno un:","Suggested_Flow_HouseType_1room":{"one":"Monolocale","other":"Monolocali"},"Suggested_Flow_HouseType_3room":{"one":"Trilocale","other":"Trilocali"},"Suggested_Flow_HouseType_2room":{"one":"Bilocale","other":"Bilocali"},"Suggested_Flow_HouseType_4room":{"one":"Quadrilocale","other":"Quadrilocali"},"Suggested_Flow_HouseType_5orMore":{"one":"5 locali o più","other":"5 locali o più"},"Suggested_Error_CTA":"Ricarica","Suggested_Error_Body":"Purtroppo qualcosa non è andato come pensavamo, puoi riprovare per favore?","Suggested_Page_Title":"Case per te","Suggested_SuccessToast_Title":"Ecco la nuova sezione che hai appena sbloccato. Speriamo ti piaccia!","Suggested_Priority_HelpModal_Title":"Cos\'è una casa in anteprima?","Suggested_Priority_HelpModal_Description":"Ti presentiamo le case che stanno per arrivare sul mercato. Se ne trovi una che ti piace, puoi prenotare una visita prima di tutti.\\n\\nTi avvisiamo non appena arrivano nuove case in anteprima. Promesso!","PriorityCard_Banner":"In anteprima","Suggested_Priority_Title":"In anteprima","Suggested_Priority_HelpText":"Come funziona?","Suggested_Priority_NoResult_Banner":"Non ci sono case in anteprima, per adesso","Suggested_UpdateToast_Title":"Abbiamo aggiornato i tuoi “Per te”","Suggested_SearchResume_Intro":"Le tue preferenze:","Suggested_SearchResume_BudgetIntro":"Fino a","Suggested_Welcome_Title_Named":"Ciao, {{name}}!","Suggested_SetPreferenceBanner_Description":"Queste case sono in linea con una tua vecchia ricerca. Ci sono novità?","Suggested_SetPreferenceBanner_CTA":"Aggiorna preferenze","TeasingInbox_MetaTitle":"Per te - Login","TeasingInbox_MetaDescription":"Senza cercare, ecco tutte le case pensate per te, in base alle tue ricerche","ValuationModal_Title":"PREZZO DI ANNUNCIO SUGGERITO ","ValuationModal_DateDescription":"Creato il {{valuation-date}}","ValuationModal_CardTitle":"🎁 Abbiamo pensato alcune case che potrebbero fare al caso tuo.","ValuationModal_CardDescription":"Le trovi tutte nella tua area personale","ValuationModal_CardButton":"Vedi case per te","ValuationModal_Title_1":"VALORE DI MERCATO","BuyerContactFormWall_Title":"Ci siamo!","BuyerContactFormWall_Description":"La tua valutazione è pronta!\\nCosa troverai?","BuyerContactForm_Reward_Item-1":"Case consigliate per te","BuyerContactForm_Reward_Item-2":"Case in anteprima","BuyerContactFormWall_Button":"Accedi","ForYou_Homeplus_CTA":"Offerte <b>Casavo Homeplus</b>","ForYou_Page_Mortgage_CardTitle":"Trova il mutuo perfetto","ForYou_Page_Mortgage_Card_Description":"Calcola la rata del tuo mutuo online o prenota una consulenza gratuita.","ForYou_Page_Mortgage_Card_CTA":"Calcola rata mutuo "}');

/***/ }),

/***/ 37913:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Priority_DetailPage_FloatingBanner_Desciption":"<b> Ti chiameremo appena è disponibile </b> e sarai tra i primi a vederla.","PriorityDetail_TeasingBanner_Description":"<b> Con UniCredit SubitoCasa</b>, puoi visitare questa <b>casa In anteprima.</b> ","Priority_DetailPage_AdvantagesBox_Description":"È una casa che <b>non è stata ancora messa sul mercato, ma potrebbe esserlo a breve.</b> Abbiamo selezionato solo chi, come te, cerca esattamente una casa così. Con noi, <b>puoi prenotare una visita prima di tutti.</b>","PriceAnalysis_Description":"Prezzo indicativo che potrà essere oggetto di variazione","Priority_DetailPage_AdvantagesCard_Advance_Description":"Scopri gli annunci di case in vendita, prima degli altri.","Priority_DetailPage_AdvantagesCard_Advance_Title":"Scopri nuove case","PriorityDetail_TeasingBanner_Description_v2":"Con <b> UniCredit RE Services,</b> puoi visitare questa casa <b> In anteprima.</b>"}');

/***/ }),

/***/ 52480:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"meta":{"title":"🔕 Notifiche disattivate | Casavo","description":"Le notifiche per la tua ricerca di nuove case su Casavo sono state disattivate."},"notifications-disabled":"Notifiche disattivate","all-good-here":"Tutto tranquillo qui...","plant-image-alt-text":"In divano con una pianta alla sua destra","done":"Fffatto!","no-more-messages":"Non riceverai più nuovi annunci per la tua ricerca.","cta-browse-all":"Cerca tra le nostre nuove case"}');

/***/ }),

/***/ 6409:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"search":"Cerca","all-zones":"Ovunque","seo-title":"Case in vendita in zona {{zone}}, {{city}} | Casavo","seo-description":"Case in vendita in zona {{zone}}, {{city}}: consulta gli annunci immobiliari e trova la casa adatta alle tue esigenze. Scopri di più su Casavo!","search-filters":"Cerca comune o zona","zones_count":{"all":"Ovunque","zones":"{{count}} zone","zones_one":"{{count}} zona"}}');

/***/ }),

/***/ 6100:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"PropertyAdvantages_Bureaucracy_Title":"Ajuda com a burocracia","PropertyAdvantages_Certification_Title":"Certificação de conformidade","PropertyAdvantages_SelectedPartners_CardDescription":"Também atestamos a qualidade das <b>pessoas com quem irá falar</b>. Selecionamos os nossos colaboradores pela transparência, profissionalismo e conhecimento da cidade. <b>Já fizemos negócios com eles</b> e correu tudo bem, por isso temos a certeza de que são fiáveis.","PropertyAdvantages_CasavoGuarantee_BannerIntro":"Casa com <b>Garantia Casavo</b>","PropertyAdvantages_CasavoGuarantee_BottomBanner_Description":"São propriedades compradas diretamente por nós (ao contrário das Casas Casavo). Conhecemo-las bem porque acompanhamos o proprietário ao longo do processo de venda. Portanto, estamos em condições de garantir a sua fiabilidade, qualidade e oferecer um serviço exclusivo.","PropertyAdvantages_FairPrice_Title":"Preço controlado","PropertyAdvantages_Fees_Title":"Comissões abaixo dos 3%","PropertyAdvantages_CasavoGuarantee_BottomBanner_Title":"Que diferença faz a \\"Garantia Casavo\\"?","PropertyAdvantages_CasavoGuarantee_From_Title":"<0>Estamos ao seu dispor:</0> esta casa tem a <1>Garantia Casavo</1>","PropertyAdvantages_Bureaucracy_CardDescription":"Se se esquecer de um ou outro detalhe, não se preocupe. Também compramos casas e as escrituras são o pão nosso de cada dia. Estamos aqui para ajudar a tratar da burocracia, <b>recolher a documentação necessária</b> e dar apoio quando preciso.","PropertyAdvantages_CasavoGuarantee_Banner_CTA":"Descubra","PropertyAdvantages_FairPrice_CardDescription":"Significa que <b>o preço indicado está alinhado com o preço de mercado</b>. Conseguimos analisar os preços e compará-los com este nível de precisão a outras casas semelhantes graças à nossa tecnologia.","PropertyAdvantages_SelectedPartners_Title":"Colaboradores selecionados","PropertyAdvantages_Fees_CardDescription":"Já deu por si a fazer contas à comissão que vai pagar? Diga adeus às dúvidas. A Casavo trabalha com parceiros e acordos transparentes: <b>nunca vai pagar mais de 3% em comissão</b>.","PropertyAdvantages_Card_CTA":"Descubra","PropertyAdvantages_CasavoProperty_BannerIntro":"Esta é uma <b>Casa Casavo</b>","PropertyAdvantages_TransparencyDocumenation_CardDescription":"<b>Recolhemos todos os documentos necessários</b>, incluindo certidões e relatórios. E colocamos tudo à sua disposição. Quando o assunto é a nossa casa, as surpresas ficam à porta.","PropertyAdvantages_TransparencyDocumenation_Title":"Transparência na documentação"}');

/***/ }),

/***/ 80096:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Login_Button":"Iniciar sessão","Search_Button":"Pesquisar","Profile_Button":"Perfil","Favorites_Button":"Favoritos","Suggested_Auth_Button":"Para você","Suggested_Unauth_Button":"Para você"}');

/***/ }),

/***/ 96079:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"AffordabilityTool_firstHouseQuestion_title":"Será a sua primeira casa*?","AffordabilityTool_ResultPage_InfoAlert":"Alguns bancos podem não ter em conta os rendimentos dos contratos a prazo","LandRegistryTax_Label":"Despesas de registo predial","AgencyFee_Label":"Taxas de agência","AffordabilityTool_ResultPage_Expenses_DropDown2_Label":"Quais são os custos da compra de uma casa?","Deposit_Label":"Avanço","AffordabilityTool_ResultPage_Analysis_Box1_Description":"Regra geral, os bancos pedem que a prestação do crédito hipotecário não ultrapasse 35% do seu rendimento mensal. Esta prestação é calculada tendo em conta <b>o montante que pode adiantar</b> e o rácio prestação-rendimento. Não se esqueça de que pode haver excepções, dependendo de vários factores que os bancos avaliam no caso concreto.","AffordabilityTool_ResultPage_NextStepBox_CTA":"Pedir informações","RegistrationTax_Label":"Impostos de registo","AffordabilityTool_ResultPage_Expenses_Disclaimer":"*As despesas referem-se ao custo máximo da casa.","AffordabilityTool_ResultPage_Expenses_DropDown1_Label":"Quais são as taxas de hipoteca?","AffordabilityTool_ageQuestion_title":"Que idade tens?","TransferTax_Label":"Despesas hipotecárias","AffordabilityTool_ResultPage_Back":"Voltar ao anúncio","AffordabilityTool_ResultPage_Analysis_Box2_Description":"Em geral, os bancos pedem um adiantamento de 20%. Dependendo do banco e de outras variáveis, pode ter <b>de dar menos de 20%</b>, ou mesmo não dar qualquer adiantamento. Vamos falar sobre isso, vamos ser flexíveis!","AffordabilityTool_ResultPage_Description_Positive":"A casa de que gosta está perfeitamente dentro da sua faixa de preço!<br/>\\n<b>Próximo passo:</b> verificar com uma consulta 🚀.","Application_Label":"Investigação","AffordabilityTool_ResultPage_FloatingBox_Title":"Os seus dados","AffordabilityTool_ResultPage_DetailBox_MaxCost":"Custo máximo da casa","MandatoryInsurance_Label":"Seguro obrigatório","Interest_Label":"Interesse","OwnerNumber_Label":"Número de titulares","AffordabilityTool_ResultPage_Expenses_DropDown_Title":"Outras despesas","AffordabilityTool_ResultPage_Analysis_Title":"Em que se baseia a estimativa?","Notary_Label":"Notário","AffordabilityTool_ResultPage_NextStepBox_Description":"O serviço Casavo Mutui está à sua disposição para investigar a sua situação e, se o desejar, apresentar-lhe a casa que desejar.","AffordabilityTool_ResultPage_Chart_SelectedProperty":"Anúncio selecionado","AffordabilityTool_ResultPage_Title":"Eis uma primeira estimativa","MonthlyIncome_Label":"Rendimento mensal","VAT_Label":"Cubas","AffordabilityTool_ResultPage_Analysis_Box1_Title":"Prestação máxima estimada","AffordabilityTool_ResultPage_DetailBox_Title":"Detalhes","Duration_Label":"Duração","Mortgage_Label":"Hipoteca","Appraisal_Label":"Opinião de peritos","OtherLoans_Label":"Financiamento em curso","AffordabilityTool_ContactModal_Title":"Quer aprofundar a sua capacidade de financiamento?","AffordabilityTool_ContactModal_Description":"Estamos à sua disposição para responder a todas as\\nsuas perguntas.","AffordabilityTool_ResultPage_Analysis_Box2_Title":"Entrada: mínimo de 20% da casa","AffordabilityTool_ResultPage_NextStepBox_Title":"O próximo passo? 🔮","AffordabilityTool_firstHouseQuestion_description":"*Por \\"primeira casa\\" entende-se\\n<ul><li>ou a primeira casa comprada cronologicamente</li>\\n<li>ou a segunda/terceira/... casa comprada mas que se tornou a residência principal</li></ul>","PurchaseType_label":"Tipo de compra","AffordabilityTool_navigation_nextButton":"Seguinte","SubsituteTax_Label":"Imposto de substituição","Age_Label":"Idade","OthersFee_Label":"Selos e diversos","NotaryExpenses_Label":"Despesas de notário","AffordabilityTool_ResultPage_Description_Negative":"O custo da casa parece estar fora dos parâmetros de financiamento com base nos vossos dados.<br/><b>Vamos parar um pouco</b> para entender melhor a situação.","AffordabilityTool_otherLoansQuestion_person2_title1":"O outro titular tem financiamento em curso?","AffordabilityTool_otherLoansQuestion_person1_description":"Se, nos próximos seis meses, tiver de pagar o carro, o telefone, a televisão,...","AffordabilityTool_jobQuestion_person1_title2":"Quanto é que ganha por mês?","AffordabilityTool_jobQuestion_person1_answer_expanded_option2":"Trabalhador a termo certo","AffordabilityTool_otherLoansQuestion_person1_title2":"No total, quanto é que gasta por mês em financiamento?","AffordabilityTool_ownersQuestion_answer_no":"Não, somos dois","AffordabilityTool_jobQuestion_person1_description2":"Inclua o seu salário líquido ou a sua pensão durante 12 meses. Se trabalha por conta própria, indique uma estimativa.","AffordabilityTool_jobQuestion_person2_description2":"Incluir o salário líquido ou a <b>pensão durante 12 meses</b>. Se for trabalhador independente, indicar uma estimativa.","AffordabilityTool_ownersQuestion_answer_yes":"Sim","AffordabilityTool_otherLoansQuestion_person1_title1":"Tem outros financiamentos em curso?","AffordabilityTool_jobQuestion_person1_answer_expanded_option1":"Empregado permanente","AffordabilityTool_jobQuestion_person1_answer_expanded_option3":"Trabalhador independente com número de IVA","AffordabilityTool_jobQuestion_person1_title1":"Qual é a sua situação profissional?","AffordabilityTool_jobQuestion_person2_title2":"Quanto é que a outra pessoa ganha por mês?","AffordabilityTool_otherLoansQuestion_person2_title2":"No total, quanto é que gasta por mês em financiamento?","AffordabilityTool_jobQuestion_person1_answer_expanded_option4":"Reformado","AffordabilityTool_otherLoansQuestion_person2_answer1_yes":"Não","AffordabilityTool_jobQuestion_person2_title1":"Qual é a situação profissional do outro titular?","AffordabilityTool_ownersQuestion_title":"A hipoteca ficará apenas em seu nome?","AffordabilityTool_depositQuestion_title":"Quanto é que acha que quer antecipar?","AffordabilityTool_jobQuestion_person1_answer_collapsed":"Selecionar um...","Affordability_ListingDetailCTA":"Verificar a minha capacidade de financiamento","PurchaseType_FirstHome_Label":"Primeira casa","PurchaseType_SecondHome_Label":"Segunda Casa","Fixed_at":"Fixado em","InputError_Loan":"O montante não pode exceder o salário mensal do outro titular","done":"Feito!","AffordabilityTool_ResultPage_NextStepBoxSuccess_Description":"Um especialista da Casavo Mutui entrará em contacto consigo em breve para discutir a sua viabilidade financeira e responder a todas as suas perguntas.","AffordabilityTool_ResultPage_Analysis_DownPaymentBox_WhyProblem":"<b>A sua entrada é de {{down_payment}}</b>, mas precisaria de uma entrada de <b>pelo menos {{min_down_payment}}</b> para comprar esta casa.","AffordabilityTool_ResultPage_Analysis_RateBox_WhyProblem":"<b>A sua prestação mensal pode ser no máximo de {{max_installment}}</b> (35% do salário, com uma entrada de 20%). \\nPara esta casa, em vez disso, <b> a sua prestação deve ser de pelo menos {{min_installment}}</b> ({{min_income_percentage}}% do seu salário).","AffordabilityTool_ResultPage_Analysis_CTA":"Peça-nos mais pormenores","AffordabilityTool_ResultPage_Expenses_DropDown_Subtitle":"As despesas referem-se ao montante máximo de empréstimo que pode ser obtido","AffordabilityTool_ResultPage_Expenses_CTA":"Pedir uma consulta gratuita"}');

/***/ }),

/***/ 55515:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"LoginPage_Description":"Uma nova forma de encontrar casa nova.","LoginPage_Title":"A Casavo dá-lhe\\nas boas-vindas.","UserProfile_Salute":"Olá","UserProfile_Description":"Este espaço é só seu.\\n🚧Ainda o estamos a remodelar!🚧\\n\\nAqui pode contar-nos tudo sobre a casa que tem em mente e gerir as pesquisas.","UserProfile_CTA":"Venha conhecer as casas","LoginPage_Button_google":"Continuar com a Google","UserProfile_LogoutButton":"Terminar sessão","Divider_Smalltext":"ou","UserProfile_Dropdown_Favorites":"Favoritos","SignupWithMail_Input_Password_Placeholder":"Insira a palavra-passe","Login_Success_CTA":"OK","LoginWithMail_CTA":"Iniciar sessão","ToSignUp_Description":"Ainda não se registou?","LoginWithMail_Input_Password_Placeholder":"Palavra-passe","SignupWithMail_Input_RepeatPassword_Error_NotMatch":"As palavras-passe não correspondem","SignupWithMail_Title":"Criar uma conta nova","SignupWithMail_CTA2":"Registe-se","SignupWithMail_Input_RepeatPassword_Placeholder":"Repita, para ter a certeza","Login_Success_Title":"Olá outra vez!","Login_Success_Description":"<b>Sessão iniciada</b>.<br/>Ficamos felizes por estar de volta.","LoginWithMail_Error_WrongData_Description":"Hmm... Há um problema com as credenciais. Poderia tentar outra vez?","SignupWithMail_CTA1":"Continuar","ToLogin_Description":"Já tem uma conta?","SignupWithMail_Password_Title":"Escolha uma palavra-passe","LoginWithMail_Error_WrongData_Title":"Inseriu os dados corretos?","SignupWithMail_Error_SimplePSW_Title":"A palavra-passe é demasiado simples","Signup_Success_Description":"Já faz parte da nossa grande família!\\n\\nComece a guardar as suas casas preferidas, ative as notificações para as pesquisas que lhe interessam e muito mais...\\n\\nUma nova forma de encontrar a sua nova casa.","Input_Email_Placeholder":"Insira o seu e-mail","Signup_Success_Title":"Já é um de nós","ToSignUp_CTA":"Criar uma conta","LoginPage_WithMail_CTA":"Continuar com o e-mail","SignupWithMail_Error_SimplePSW_Description":"Escolha uma mais segura","SignupWithMail_Input_Password_Error_ShortPsw":"Mínimo de 8 carateres","SignupWithMail_Alert_ExistingAccount_Title":"Esta conta já existe","SignupWithMail_Alert_ExistingAccount_Description":"Este e-mail já está registado. Pretende iniciar sessão?","SignupWithMail_Alert_ExistingAccount_CTA":"Iniciar sessão","Login_Favorites_BottomSheet_Title":"Inicie sessão para guardar nos favoritos","Login_SaveSearch_BottomSheet_Title":"Inicie sessão e guarde\\nas suas pesquisas","LoginWithMail_Title":"Inicie sessão com o e-mail","RecoverPassword_Code_Title":"Checar o e-mail","RecoverPassword_Code_CTA":"Continuou","NewPassword_Success_Description":"Perfeito! Sua nova senha está segura, onde estávamos?","RecoverPassword_Code_Sendto":"Enviamos o código de segurança para","RecoverPassword_Code_Description":"Digite aqui o código que você recebeu:","NewPassword_Title":"Escolha uma nova senha","NewPassword_Success_Title":"Senha salva","RecoverPassword_CTA":"Receba o código","Login_ToRecoverPassword":"Esqueceu a senha?","NewPassword_CTA":"Salvar nova senha","RecoverPassword_Description":"Nós lhe enviaremos um código para configurar sua nova senha. Digite o e-mail que você usou para se cadastrar:","RecoverPassword_Title":"Redefinir senha","RecoverPassword_Error_InvalidCode_Description":"O código inserido está incorreto ou expirou. Verifique ou envie outro","RecoverPassword_Error_InvalidCode_Title":"Código inválido","Login_ScheduleVisit_BottomSheet_Title":"Iniciar sessão para desbloquear marcação instantânea","Login_Suggested_BottomSheet_Title":"Elimine o ruído. Entre na nova seção \\"para você\\". Nós pesquisamos, você encontra apenas o que você gosta.","Social_Login_Error_Message":"Parece que este e-mail\\njá está registado","Social_Login_Error_Cta":"Voltar ao topo","Login_PriorityDetail_BottomSheet_Title":"Que nome devemos pôr na lista?","Login_RequestVisit_BottomSheet_Title":"Verifiquemos a ordem de trabalhos: entretanto, que nome colocaremos?","Login_TeasingInbox_Title":"É bom voltar a ver-vos! Há uma nova secção só para si.","Login_FromContactFrom_Title":"Com prazer! Como é que se chama?","Login_PriorityDetail_BottomSheet_UnlockTitle":"Com o Priority®, encontra primeiro a sua casa.","BuyerContactFormModal_Title":"Só falta o teu nome."}');

/***/ }),

/***/ 25065:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"SearchStatus_Answer3":"Estou prestes a fazer uma proposta de compra","HouseType_1room":"T1","HouseType_4orMore":"Superior a T4","SearchStatus_Answer4":"Já fiz uma proposta de compra","SearchBar":"Procurar zona...","SearchStatus_Answer1":"Estou só a ver anúncios","ThankYou_Title":"Agora é connosco...","SearchStatus_Question":"Em que etapa da procura está?","Intro_Description":"Você responde e nós encontramos um lar para você. Podemos oferecer-lhe casas à sua medida, mesmo antes de serem colocadas no mercado.","NoResult_Title":"Quer ver as novidades antes de toda a gente?","Intro_Title":"Fale-nos de si em quatro cliques.","MaxBudget_Input_Placeholder":"€","Form_Description":"Agora sabemos exatamente o que você está procurando. Última coisa: como podemos entrar em contato com você?","NoResult_Description":"Ainda não há casas como esta, mas diga-nos o que tem em mente. Procuramos juntos e podemos ajudar, bastam quatro perguntas rápidas.","ThankYou_CTA":"Voltar às casas","NoResult_CTA":"Diga-nos o que procura","MaxBudget_Question":"Qual é o teto do seu orçamento?","Form_Mail_Placeholder":"O seu e-mail","Form_Name_Placeholder":"O seu nome e apelido","ThankYou_Description":"Estamos ansiosos para encontrar a casa perfeita para você. Falo com você em breve!","FewResult_Title":"Quer ver as casas novas antes de toda a gente?","SearchStatus_Answer2":"Já visitei algumas casas","HouseType_Question":"Que tipo de casa procura?","Form_Title":"Respostas salvas","MaxBudget_Description":"Não é a nossa pergunta preferida, mas é fundamental","FewResult_Reset":"Mudar filtros","NoResult_Reset":"Repor filtros","Zone_Question":"Em quais áreas de {{city}} você deseja que pesquisemos?","HouseType_3rooms":"T3","HouseType_4rooms":"T4","HouseType_2rooms":"T2","FewResult_Description":"Fale-nos da casa que tem em mente.\\nPodemos procurar juntos e ajudar, bastam quatro perguntas rápidas","Zone_Noresult":"Não consegue encontrar o que procura?<br/>\\nNavegar na <0>lista de áreas</0>"}');

/***/ }),

/***/ 57416:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"terrace":{"label":"Varanda","title":"Casas para venda em {{cidade}} com terraço | Casavo","description":"Ver todos os anúncios de apartamentos para venda em {{cidade}} com terraço. A Casavo só trabalha com agências seleccionadas. Encontre já a sua casa de sonho!"},"balcony":{"label":"Varanda","title":"Casas para venda em {{cidade}} com varanda | Casavo","description":"Ver todos os anúncios de apartamentos para venda em {{city}} com varanda. A Casavo só trabalha com agências seleccionadas. Encontre já a sua casa de sonho!"},"studios":{"label":"Apartamentos estúdio","title":"Estúdios à venda em {{city}} | Casavo","description":"Ver todos os anúncios de Estúdios para venda em {{city}}. A Casavo só trabalha com agências seleccionadas. Encontre já a sua casa de sonho!"},"one-bedroom-apartments":{"label":"Apartamentos com dois quartos","title":"Apartamentos de 2 assoalhadas para venda em {{city}} | Casavo","description":"Ver todos os anúncios em Apartamentos T2 para venda em {{cidade}}. A Casavo só trabalha com agências seleccionadas. Encontre já a sua casa de sonho!"},"two-bedroom-apartments":{"label":"Apartamentos com três quartos","title":"Apartamentos de três assoalhadas para venda em {{city}} | Casavo","description":"Ver todos os anúncios em Apartamentos de três assoalhadas para venda em {{city}}. A Casavo só trabalha com agências seleccionadas. Encontre já a sua casa de sonho!"},"new-constructions":{"label":"Nova construção","title":"Casas recém-construídas para venda em {{city}} | Casavo","description":"Descubra todos os anúncios de casas recém-construídas para venda em {{city}}. A Casavo só trabalha com agências seleccionadas. Encontre já a sua casa de sonho!"}}');

/***/ }),

/***/ 89033:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"claim":"<0>Esta é uma <1>Casa Casavo</1></0>","claim_cta":"<0>Esta é uma <1>Casa Casavo</1></0>","title":"Casas Casavo totalmente renovadas.","title_detail":"O imóvel que viu é uma Casa Casavo","text":"<0>Sabemos como pode ser complicado encontrar a casa ideal.</0><0>Na Casavo, garantimos a venda de imóveis totalmente renovados. Sempre a preço de mercado.</0><1>Procure a <2/> nos anúncios.</1>","text_detail":"Tudo para que desfrute da sua nova casa com total tranquilidade.","discover_all_the_advantages":"Descubra todas as vantagens","modal_subtitle":"<0>Queremos que não tenha preocupações. Somos nós que renovamos, mantemos e gerimos completamente os imóveis Casavo.</0><1>As nossas melhores opções com serviços exclusivos, a um preço nunca superior à média do mercado.</1>","list_item_discount_modal_description":"Não podemos contar-lhe tudo aqui, não queremos perturbar a sua pesquisa... descubra todas as vantagens da Casavo, a nossa equipa está à sua disposição ❤️","good_to_know":"É bom saber","what_does_it_mean":"O que significa?","modal_list_items":[{"title":"Vantagens incluídas:","items":[{"title":"Pronta a habitar","description":"Imóveis prontos a habitar com a melhor qualidade em acabamentos e materiais. Sem surpresas."},{"title":"Personalização","description":"Se a casa em que tiver interesse ainda estiver no início da remodelação, poderá decidir alguns dos acabamentos."},{"title":"","description":""}]},{"title":"...mais ao vosso serviço, da Casavo:","items":[{"title":"Serviço hipotecário","description":"Você escolhe a casa que quer, Casavo Mutui trata da hipoteca. Um consultor dedicado tratará de toda a burocracia.","image":"loan"},{"title":"Mobiliário e interiores","description":"Gosta da sua casa mobilada como nas visitas virtuais? Pode pedir para a ter exactamente assim, completamente mobilada!","image":"mobiliário"},{"title":"Convenções exclusivas","description":"Electricidade, gás, WiFi, sistemas de alarme, electrónica e muito, muito mais.","image":"desconto"}]}],"advantage_first":"Pronta a habitar","advantage_second":"Personalização","advantage_third":"Uma equipa sempre ao seu lado"}');

/***/ }),

/***/ 25137:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"available":"disponível","available-singular":"disponível","title":"Comprar casa em Portugal | Casavo","title-listing":"Comprar casa em {{city}} | Casavo","description":"Planeia comprar casa? Encontre os melhores imóveis na Casavo! Descubra online todas as casas à venda. A sua nova casa está só à distância de um clique!","description-listing":"Procura comprar casa em {{city}}? Encontre a casa ideal com a Casavo! Descubra a nossa oferta de imóveis online.","loading":"A carregar...","of":"de","of2":"de","entrance_floor":"Andar","entrance_floors":"Andar","basement":"Cave","raised":"Mezzanine","ground_floor":"Rés do chão","last_floor":"Último andar","mid_floor":"Andares intermédios","select_city":"Seleciona uma cidade","rooms":"Divisões","bathrooms":"Casas de banho","bedrooms":"Quartos","status":"Estado","habitable":"Habitável","new":"Novo","renovated":"Renovado","need_renovation":"Para renovar","under_construction":"Em construção","private_negotiation":"Negociação privada","get-free-offer-label":"Vender","get-free-offer-small-label":"Vender","our-properties-label":"Comprar","our-properties-small-label":"Comprar","our-clients-label":"Clientes","are-you-broker-label":"É uma agência?","footer-service-label":"Serviço","footer-resources-label":"Recursos","footer-about-us-label":"Sobre nós","footer-our-properties-label":"Casas para venda","footer-press-label":"O que dizem sobre nós","footer-blog-label":"Blogue","footer-faqs-label":"Perguntas frequentes","footer-work-label":"Venha trabalhar connosco","footer-work":"https://careers.casavo.com","footer-contact-label":"Fale connosco","footer-casavo-es-label":"Casavo España","footer-casavo-pt-label":"","footer-legal-label":"Dados da empresa","footer-privacy-label":"Política de Privacidade","footer-terms-label":"Termos e Condições","footer-made-with":"Criada com","footer-made-in":"em Itália","for-sale":"À venda","listing_not_found_title":"Lamentamos, mas o imóvel que procura parece já não estar disponível.","listing_not_found_similar_properties_subtitle":"O anúncio que procura foi removido ou a casa já foi vendida.","listing_not_found_cta":"Descubra todos os imóveis","text-list":"Anúncio","text-map":"Mapa","open-map":"Abrir mapa","no-listings-in-city":"Lamentamos, mas ainda não há imóveis disponíveis nesta cidade.","casavo-properties-title":"Casa Casavo","cta_show_virtual_tour":"Visita virtual","enter_virtual_tour":"Ver","message_virtual_tour":"Visita em 3D","view_property":"Ver imóvel","page":"Página","photos":"Fotos","pagination-bottom":"de {{length}} imóveis","of-pagination":"de","tooltip-text":"Os preços de imóveis Casavo nunca são superiores à média de mercado","houses-for-sale-in-area":"Casas <0>no distrito de {{area}}</0>","house-for-sale-in-area":"Casa <0>no distrito de {{area}}</0>","houses-for-sale-in-city":"Casas <0>em {{city}}</0>","house-for-sale-in-city":"Casa à venda <0>em {{city}}</0>","houses-for-sale-in-zone":"Casas <0>na zona de {{zone}}</0>","house-for-sale-in-zone":"Casa <0>na zona de {{zone}}</0>","house-for-sale-byZone-filter":"Casa <0>em {{area}}</0>","houses-for-sale-byZone-filter":"Casas <0>em {{area}}</0>","outdoor_space_label":"Espaço exterior","new_listing_label":"Novo","tooltips":{"casavo_property":"Os preços de imóveis Casavo nunca são superiores à média de mercado","outdoor_space":"E se pudesse estar ao ar livre sempre que quisesse? Este imóvel inclui um terraço ou jardim.","energy_efficient":{"A_B":"Bom para o planeta 🌳 A classificação de eficiência energética mínima desta casa é B.","C":"Desfrute de maior conforto com maior eficiência. A classificação energética mínima deste imóvel é B."}},"read_more":"Ler mais","read_less":"Ler menos","invalid-email-message":"Verifique se escreveu o endereço de e-mail corretamente.","required-field-message":"Campo obrigatório.","mortgage":{"title":"serviço de hipotecas","text":"Hipoteca: basta dizer.<0/>Escolha o banco.<0/>Nós tratamos do resto.","cta":"Saber mais","contact-us":"Estamos ao seu dispor<0/>Fale connosco quando quiser"},"mortgage-modal":{"title":"Tratamos da parte aborrecida.","content-top":"A Casavo tem uma equipa dedicada e especializada ao seu dispor para lidar com a burocracia do empréstimo hipotecário, com o banco da sua preferência. Para que tenha mais tempo para pensar noutras coisas.","content-bottom":"Mais de 110 clientes utilizaram este serviço até agora e obtiveram aprovação da hipoteca 15 dias mais rápido. Gratuitamente.","more":"Quer saber mais?","call":"Ligue-nos"},"form-error":"Ups! Algo correu mal. Tente novamente.","where-looking-for":"Para onde você está olhando?","province":"Distrito","province-of":"Distrito de {{area}}","municipality":"Concelho","menu":{"sell":"Vender","buy":"Comprar","our-clients":"Clientes","agency":"É uma agência?","about":"Sobre a Casavo"},"listings":{"canonical-links-title":"Casas por característica em {{city}}:","most-visited-zones-title":"Casas à venda em {{city}}:"},"prev":"Anterior","next":"Seguinte","footer-team-label":"Equipa","footer-partner-label":"Tornar-se parceiro","footer-casavo-it-label":"Casavo Italia","invalid-phone-message":"Número de telefone inválido","casavo-inventory-agency-title":"Garantia Casavo","CTA_Next":"Seguinte","GenericError_Modal_Description":"Parece que algo não correu como planeado. Pode tentar outra vez?","GenericError_Modal_Title":"Ups...","simple_confirm":"Ok!","No":"Não","Yes":"Sim","years":"anos","Header_AddressFormat":"<0>{{streetName}}</0><1>N° {{streetNumber}}, {{city}}</1>","address_format":"{{streetName}} N° {{streetNumber}}, {{city}}"}');

/***/ }),

/***/ 25096:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"agency":{"message":{"cta":"Tem alguma pergunta?","label":"Fale connosco","placeholder":"Tem alguma pergunta?\\nQuando prefere que entremos em contacto consigo novamente?"},"success":{"message":"O primeiro passo está dado.\\nO nosso parceiro entrará em contacto consigo em breve.","cta":"Ver imóveis semelhantes"}},"casavo":{"assistant":"Assistente Casavo","name":"Nome","reason":{"placeholder":"Estou a enviar-vos uma mensagem porque...","warning":"Saber isso permite-nos ajudar mais depressa.","options":{"morePhotos":"Gostaria de receber mais fotografias e materiais","moreAboutHouse":"Gostaria de receber mais informações sobre este imóvel","other":"Outro"}},"title":"<0>Vamos entrar em contacto consigo em breve.</0> A sua experiência <1>Casavo</1> começa aqui.","success":{"title":"Primeiro passo dado.","subtitle":"Daqui para a frente, conte connosco.<0/>Vamos entrar em contacto consigo assim que possível.","postScriptum":"P.S. O seu pedido chegou em segurança.","cta":"Ver imóveis semelhantes"}},"phone":"Número de telefone","submit":"Enviar","email":{"label":"Endereço de e-mail","success":"Pedido enviado com sucesso. Verifique a sua caixa de correio para mais instruções."},"success":{"toFlow":{"title":"Você está vendendo a casa?","subtitle":"Nós compramos ","cta":"Faça uma avaliação"}},"ContactForm_SuccessSaveSearch_CTA_Primary":"Receber alertas","ContactForm_SuccessSaveSearch_CTA_Secondary":"Não, obrigado","ContactForm_SuccessSaveSearch_Subtitle":"Enviamo-las comodamente para o seu e-mail","ContactForm_SuccessSaveSearch_Title":"Gostaria de receber novos anúncios semelhantes a este?","ContactForm_SuccessSaveSearch_OkFeedback":"Alertas accionados","name":"Nome","lastname":"Apelido"}');

/***/ }),

/***/ 85096:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Favourites_FavouriteList_AutodeleteMessage":"Os anúncios indisponíveis serão\\nremovidos automaticamente após 20 dias","Favourites_FavouriteList_FavouriteCard_Unavailable":"Indisponível","Favourites_FavouriteList_DeleteConfirm_title":"Remover dos favoritos?","Favourites_FavouriteList_DeleteConfirm_cancelCTA":"Anular","Favourites_FavouritesList_Title":"Favoritos","Favourites_FavouriteList_EmptyState":"Toque em <icon/> para guardar o anúncio<br/> e encontre-o sempre aqui","Favourites_FavouriteList_ConfirmToast_title":"Anúncio removido dos favoritos","Favourites_FavouriteList_DeleteConfirm_mainCTA":"Remover","Favourites_FavouriteList_ConfirmToast_body":"Não se preocupe. Há paixões passageiras.","Favourites_FavouriteList_EmptyStateMain":"Amor à primeira vista?","Favourites_FavouritesList_SubTitle1":{"one":"{{count}} anúncio deixou-lhe um brilhozinho nos olhos","other":"{{count}} anúncios deixaram-lhe um brilhozinho nos olhos"},"Desktop_Saved":"Gravado","Desktop_Save":"Gravar","FavouritesList_Desktop_BackToSearch":"Voltar à pesquisa","FavouriteList_EmptyState_Unauth_CTA":"Iniciar sessão","FavouriteList_EmptyState_Unauth_Title":"Inicie sessão para guardar as suas casas preferidas","FavouriteList_EmptyState_Unauth_Description":"Amor à primeira vista?\\nInicie sessão para guardar as casas de que gosta e vê-las quando quiser.","Favourites_Add_To_Favorite_CTA":"Guardar nos favoritos"}');

/***/ }),

/***/ 13367:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"change-filters":"Editar filtros","price":"Preço","surface":"Área","room":"Divisão","rooms":"Divisões","status":"Estado","other_filters":"Outros filtros","properties":"Imóveis","property":"imóvel","properties_for_you":"Imóveis disponíveis","property_for_you":"Imóvel disponível","no_properties":"Nenhum imóvel disponível","last_uploaded":"Mais recentes","most_relevant":"Mais relevantes","cheapest":"Preço (mais baixo)","most_expensive":"Preço (mais alto)","area_max":"Área maior","area_min":"Área menor","no_properties_for_filters_title":"Atualmente, não há imóveis com estas características.","no_properties_for_filters_subtitle":"Experimente editar os filtros para ver mais resultados","save":"Guardar","from":"Desde","to":"Até","max":"Máx.","min":"Mín.","filters":"Filtros","trendy_filters":"Filtros em voga","filter_by":"Filtrar por","reset":"Limpar","undo":"Apagar","apply":"Aplicar","only_casavo":"Ver apenas Casas Casavo","price_guaranted":"Preço garantido","renovated_properties":"Imóveis renovados","assistance_guaranted":"Assistência garantida","typology":"Tipo de imóvel","bathroom":"Casa de banho","bathrooms":"Casas de banho","bedroom":"Quarto","bedrooms":"Quartos","entrance_floor":"Andar","state_of_manteinance":"Condições do imóvel","state_at_deed":"Estado do imóvel","services":"Comodidades","heating_system":"Aquecimento","year_of_construction":"Ano de construção","anyone_choice":"Qualquer","apartment":"Apartamento","house":"Casa independente","townhouse":"Casa geminada","villa":"Moradia","loft":"Loft","attic":"Sótão","mansard":"Mansarda","basement":"Cave","raised":"Mezzanine","ground_floor":"Rés do chão","last_floor":"Último andar","mid_floor":"Andares intermédios","habitable_status":"Habitável","new_status":"Novo","renovated_status":"Renovado","need_renovation_status":"Para renovar","under_construction_status":"Em construção","OCCUPIED":"Ocupado","FREE":"Livre","RENTED":"Arrendado","BARE_OWNERSHIP":"Nua-propriedade","elevator":"Elevador","parkingSpaces":"Estacionamento","box":"Garagem","garage":"Garagem","cellar":"Arrecadação","garden":"Jardim","balcony":"Varanda","balconies":"Varandas","terrace":"Terraço","terraces":"Terraços","pool":"Piscina","coolingSystem":"Ar condicionado","conciergeService":"Porteiro","AUTONOMOUS":"Autónomo","SHARED":"Centralizado","NONE":"Nenhum","at_least":"No mínimo","single_filter":"filtro","single_filters":"filtros","milan":"Milan","turin":"Turin","bologna":"Bologna","verona":"Verona","rome":"Rome","florence":"Florence","only_casavo_filter_label":"Ver apenas Casas Casavo","ranking":"Automático","trendy_filters_description":"Quando usados, estes filtros ajudam-nos a sugerir casas mais alinhadas com os seus interesses","other_filters_description":"Tudo de que precisa para encontrar a casa que procura","filters_zone_suggestion_title":"Para onde você está olhando?","filters_zone_suggestion_description":"<0>Selecione uma área</0> para lhe propormos resultados mais interessantes."}');

/***/ }),

/***/ 86114:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Furniture_DetailPage_FurnitureBanner_Title":"Sim, pode comprá-la já mobilada e decorada","Furniture_DetailPage_FurnitureBanner_CTA":"O que está incluído?","Furniture_DetailPage_FurnitureBanner_Body":"<b>Mobilámos e decorámos esta casa à medida</b>.","Furnitures_Detailpage_FurniturePriceTag":"Decoração de interiores disponível","Furniture_PhotoCarousel_Toast_CTA":"Guardar o projeto","Furniture_PhotoCarousel_Toast_Body":"Aqui está o projeto de decoração de interiores que criámos à medida desta casa","Furniture_PhotoCarousel_Toast_Title":"Gosta desta decoração?","Furniture_Modal_Title":"O nosso projeto à sua medida","Furniture_Modal_FormTitle":"Veja o projeto de decoração de interiores","Furniture_Modal_Bullet_2":"<b>Decida como personalizar </b>cada detalhe","Furniture_Modal_MktgConsent_Description":"Dê-nos permissão para lhe enviarmos novidades de decoração e serviços","Furniture_Modal_Bullet_3":"<b>As melhores marcas </b>à sua disposição:","Furniture_Modal_CTA":"Veja o projeto","Furniture_Modal_Bullet_1":"<b>Cozinha, WC e roupeiros</b> para a sua nova casa","Furniture_ServiceName":"Interior","Brand_CasavoServices":"Casavo Services"}');

/***/ }),

/***/ 46556:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Items0_Title":"Para vender, basta","Items0_Description":"Descontrair. Nós compramos a sua casa ou encontramos um comprador para si.","Items1_Title":"Para Casavo Mutui","Items1_Description":"E diga adeus à burocracia. Nós encontramos a melhor hipoteca para si.","Items2_Title":"Para as pessoas que falam de nós","Items2_Description":"O que diz a pessoa que nos escolheu? Descubra as histórias de quem já nos conhece.","Footer_Title":"Mais alguma pergunta?","Footer_Description":"Temos sempre uma resposta para todas as perguntas que nos coloca. E se não as encontrar todas, contacte-nos. Nós estamos aqui.","Title":"Casavo Porque"}');

/***/ }),

/***/ 61253:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"find-your-house":"Descubra casas <0/>à venda em..."}');

/***/ }),

/***/ 59667:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title_not_found":"Anúncio não encontrado","characteristics":"Características","description":"Descrição","the_district":"O bairro","at_your_service":"Ao seu serviço","at_your_service_message":"Entramos em contacto consigo quando quiser.","show_number":"Ver número","show_number_casavo":"Ligue-nos","request_info":"Pedir informação","request_visit":"Pedir uma visita","request_visit_modal_title":"Peça uma visita","request_visit_modal_thank_you_title":"Aguarde a confirmação do <0>especialista Casavo</0>","contact_us":"Fale connosco","contact_email":"Endereço de e-mail","contact_phone_number":"Número de telefone","fomo_message_person":"<0>{{userViews}} pessoa</0> viu este imóvel na última hora","fomo_message_people":"<0>{{userViews}} pessoas</0> viram este imóvel na última hora","phone_call":"Ligar","phone_call_now":"Ligar agora","rooms":"Divisões","bathrooms":"Casas de banho","bedrooms":"Quartos","balconies":"Varandas","terraces":"Terraços","balcony":"Varanda","terrace":"Terraço","status":"Estado","planimetry":"Plantas","services":"Comodidades","see_all_characteristics":"Ver tudo","see_less_characteristics":"Ver menos","elevator":"Elevador","parkingSpaces":"Estacionamento","box":"Garagem","basement":"Arrecadação","garden":"Jardim","coolingSystem":"Ar condicionado","coolingSystem_full":"Sistema de refrigeração","coolingSystem_AUTONOMOUS":"Autónomo","coolingSystem_SHARED":"Centralizado","coolingSystem_READY_FOR_INSTALLATION":"Pronto para instalação","coolingSystem_NONE":"Nenhum","conciergeService":"Porteiro","recreationRoom":"Sala recreativa","garret":"Águas-furtadas","pool":"Piscina","sharedPool":"Piscina partilhada","tennisCourt":"Campo de ténis","fireplace":"Lareira","disabledAccess":"Entrada acessível","wallCabinet":"Armário de parede","fastInternet":"Internet rápida","hydromassage":"Hidromassagem","tvSystem":"Sistema de TV","electricGate":"Portão elétrico","armoredDoor":"Porta blindada","alarmSystem":"Sistema de alarme","entranceVideoPhone":"Videoporteiro","year_of_construction":"Ano de construção","year_of_renovation":"Ano de renovação","exposure":"Exposição","NORTH":"Norte","SOUTH":"Sul","EAST":"Nascente","WEST":"Poente","furniture":"Mobília","FULLY_FURNISHED":"Totalmente mobilado","NOT_FURNISHED":"Não mobilado","PARTIALLY_FURNISHED":"Parcialmente mobilado","estate_registry_class":"Registo predial","energy_rating_label":"Classificação energética","energy_performance_index_label":"Indicador de eficiência energética","energy_performance_index_udm":"kWh/m² ano","energy_rating":{"energy_a4":"A4","energy_a3":"A3","energy_a2":"A2","energy_a1":"A1","energy_aplus":"A+","energy_a":"A","energy_b":"B","energy_c":"C","energy_d":"D","energy_e":"E","energy_f":"F","energy_g":"G","energy_pending_request":"Em curso"},"kitchen":"Cozinha","kitchen_HABITABLE":"Cozinha independente","kitchen_HALF_HABITABLE":"Cozinha semi-aberta","kitchen_KITCHENETTE":"Kitchenette","kitchen_OPEN":"Cozinha aberta","glazing":"Janelas","glazing_SINGLE":"Vidro simples","glazing_DOUBLE":"Vidros duplos","glazing_TRIPLE":"Vidros triplos","info":"Informação","condo_fees":"Despesas do condomínio","per_year_label":"por ano","state_at_deed":"Estado do imóvel","OCCUPIED":"Ocupado","FREE":"Livre","RENTED":"Arrendado","BARE_OWNERSHIP":"Nua-propriedade","heating_system":"Aquecimento","AUTONOMOUS":"Autónomo","SHARED":"Centralizado","NONE":"Nenhum","exclusive_mandate":"Contrato de exclusividade","cta_show_photos":"Mostrar {{photoLength}} fotografias","cta_show_virtual_tour":"Visita virtual","cta_show_virtual_tour_mobile":"Visitar","apartment":"Apartamento","house":"Casa independente","townhouse":"Casa geminada","villa":"Moradia","loft":"Loft","attic":"Sótão","mansard":"Mansarda","sharing":"Partilhar","might_interest_you":"Imóveis semelhantes","based_on_your_searches":"Com base na sua pesquisa, poderá ter interesse nestes imóveis","poi_nearby":"Pontos de interesse nas redondezas:","poi_discover":"Descubra:","TRANSPORT":{"poi_category":"Transportes","poi_nearby_card_title":"Transportes","poi_nearby_card_distance":"A paragem mais próxima <1/>fica a <0>{{distance}} m de distância</0>","BUS_STOP_distance":"Paragem de autocarro a {{distance}} m","TRAIN_STATION_distance":"Estação ferroviária a {{distance}} m","SUBWAY_STATION_distance":"Estação de metro a {{distance}} m","TRAM_STOP_distance":"Paragem de elétrico a {{distance}} m","poi_nearby_card_all":"Descubra <0/>todas as paragens","BUS_STOP_label":"Autocarro","TRAIN_STATION_label":"Comboio","SUBWAY_STATION_label":"Metro","TRAM_STOP_label":"Elétrico"},"SCHOOL":{"poi_nearby_card_title":"Escolas","poi_nearby_card_distance":"A escola mais próxima <1/>fica a <0>{{distance}} m de distância</0>","SCHOOL_distance":"Escola a {{distance}} m","poi_category":"Escolas","poi_nearby_card_all":"Descubra <0/>todas as escolas","SCHOOL_label":"Escolas"},"SHOP":{"poi_nearby_card_title":"Mercearias","poi_nearby_card_distance":"A loja mais próxima <1/>fica a <0>{{distance}} m de distância</0>","SHOP_distance":"Mercado a {{distance}} m","poi_nearby_card_all":"Descubra <0/>todas as lojas","poi_category":"Mercearias","SHOP_label":"Mercado"},"properties":"Imóveis","neighborhood":"por perto","more_about_neighborhood":"Saiba mais sobre a área","less_about_neighborhood":"Ver menos","last_update":"Anúncio atualizado a:","street-view":{"address-disclaimer":"Localização aproximada","description":"Vista da rua","cta":"Vista da rua"},"at_your_service_agency":"<0>O nosso parceiro</0> ao seu serviço","at_your_service_casavo":"<0>Estamos ao seu dispor:</0> esta é uma <1>Casa Casavo</1>","form-header":{"title":"Tem interesse neste imóvel?","subtitle_casavo":"Não o deixe escapar. Nós ligamos-lhe.","subtitle_agency":"Não perca esta oportunidade. O nosso parceiro esclarece as suas dúvidas.","agency":{"one":"Agência verificada pela Casavo","two":"Apenas anúncios verificados"},"casavo":{"one":"Verificada por nós","two":"Seguro e assistência dedicada","three":"Serviço Hipotecário","four":"Todos os serviços da Casavo pela melhor experiência com a sua casa"},"subtitle_casavo_inventory_agency":"Não o deixe escapar. Nós ligamos-lhe.","casavo-agency":{"one":"Comissões inferiores a 3%","two":"Preço controlado","three":"Certificação da conformidade","four":"Colaboradores seleccionados","five":"Apoio na burocracia"}},"we_will_contact_you":"Entraremos em contacto consigo em breve.","form-body":{"success_button":"Ver imóveis semelhantes","success_button_alt":"Ver outros imóveis"},"request_visit_error":"Algo correu mal.<0/>Tente novamente.","request_visit_email_error":"Ocorreu um erro com o envio.<0/> Verifique se o endereço de e-mail está correto.","select_visit_date":"Selecione uma data","select_visit_time":"Qual a hora mais conveniente?","insert_confirmation_info":"Como podemos falar consigo?","visit_time_disclaimer":"Terá de esperar por uma confirmação da nossa parte para esta visita","you_will_receive_confirmation":"Irá receber uma confirmação","you_will_receive_confirmation_detail":"Um especialista da Casavo vai confirmar a disponibilidade dentro do intervalo indicado. Juntos, poderão definir a melhor solução para si, e receberá uma confirmação.","book_visit_hour_recap":"Das {{startHour}} às {{endHour}}","title_0_1":"à venda em","request_visit_modal_thankyou_item_2":"Juntos, vocês chegarão a um acordo sobre a solução mais adequada para você.","request_visit_modal_thankyou_item_1":"Um especialista da Casavo confirmará a disponibilidade na data e hora indicadas.","title_0":"à venda em","title_2":"de","title_1":"em","request_call_modal_title":"Agende uma chamada com a nossa equipa de apoio","request_call_modal_thank_you_title":"Recebemos o seu pedido de apoio","request_call":"Agendar chamada","request_call_cta":"Fale connosco","request_timeslot_caption":"Poderá combinar a data e hora da visita ao imóvel durante a chamada","request_feedback_call_bullet_2":"Irá receber apoio telefónico de um Assistente Casavo","request_feedback_call_bullet_1":"Respondemos a todas as suas perguntas sobre os nossos serviços","select_call_date":"Indique o dia","select_call_time":"O horário mais conveniente","request_call_modal_thank_you_title_2":"","request_visit_modal_thank_you_title_2":"Agora é a nossa vez","view":"Vista","view_interior":"Interior","view_exterior":"Exterior","schedule_visit_cta":"Marque a sua visita","schedule_visit_modal_title":"Marque uma visita a esta <0>casa da Casavo</0>.","select_schedule_visit_time":"Selecione um horário","schedule_visit_confirm_cta":"Confirmar a visita","schedule_visit_no_availabilities":"Não há disponibilidade para esta data","schedule_visit_recap_no_availabilities":"Encontre uma data disponível","schedule_visit_modal_thank_you_title":"Visita confirmada!","schedule_visit_modal_thank_you_title_2":"Próximos passos:","schedule_visit_modal_thankyou_item_1":"Irá receber:\\n– Um e-mail com os detalhes da marcação logo a seguir.\\n– Uma SMS a recordar a marcação 24 horas antes.","schedule_visit_modal_thankyou_item_2":"No dia da visita, um consultor da Casavo estará à sua espera para lhe mostrar a casa","slot_already_booked_error":"Este horário já não está disponível","schedule_visit_cta_mobile":"Marcar uma visita","request_visit_CTA_mobile":"Pedir uma visita","schedule_visit_available":"A reserva imediata está disponível para esta casa","select_request_visit_date":"Sugira uma data","schedule_visit_no_availabilities_title":"Sem datas disponíveis","schedule_visit_no_availabilities_description":"Lamentamos, mas todas as marcações disponíveis estão ocupadas","ScheduleVisit_NoSlotModal_CTA_body":"Quer <0>guardar esta casa nos favoritos</0> para ficar a par das novidades?","ScheduleVisit_SelectDate_MoreThan1":"Estes são os dias livres. Qual prefere?","ScheduleVisit_SelectDate_Just1":"Só há um dia livre","schedule_visit_reminder":"Vemo-nos na {{day_of_the_week}} {{date_number}} de {{month}} às {{time}}","schedule_visit_slot_recap":"{{day_of_the_week}} {{date_number}} de {{month}} às {{time}} está bem para nós, confirmar?","schedule_visit_instant_warn":"Esta é uma <0>reserva instantânea</0>: se confirmar, não terá de esperar pela nossa resposta.","schedule_visit_flow_next_button":"Continuar","RequestVisit_Modal_Warn":"Aguardar a nossa confirmação para a data solicitada","RequestVisit_Modal_Recap":"{{day_of_the_week}} {{date_number}} {{month}}, às {{time}}. Confirmaremos por telefone, onde podemos contactá-lo?","BookCall_Modal_Recap":"{{day_of_the_week}} {{date_number}} {{month}}, às {{time}}.Onde podemos contactá-lo?","BookCall_Modal_Warn":"A data é indicativa, faremos o possível para o contactar quando nos tiver solicitado","RequestCallModal_Reasonlist_MorePhoto":"Gostaria de mais fotografias","RequestCallModal_Reasonlist_Questions":"Tenho perguntas","RequestCallModal_Reasonlist_Visit":"Gostaria de visitar a casa","request_call_mobile":"Ligar para mim","RequestCall_ThankYou_Bullet1":"Contactá-lo-emos para responder a todas as suas perguntas","unknown":"-","RelatedAdsBanner_Title":{"one":"","other":"{Casa semelhante nas proximidades"},"RelatedAdsBanner_Description":"Descubra casas apenas na Casavo.","RelatedAdsBanner_CTA":"Ver","NearPropertiesBanner_FirstStep_Description":"📍 Descobrir casas perto daqui","NearPropertiesBanner_PropertiesProgress":"{{n}}/{{tot}}na zona","NearPropertiesBanner_FirstStep_CTA":{"one":"","other":"Ver {{n}} casas"},"HomePlusBanner_Title":"Descubra Casavo Homeplus","HomePlusBanner_CTA":"Ver ofertas","HomePlusBanner_Description":"Seleccionámos algumas das melhores marcas para lhe apresentar <b>ofertas exclusivas </b>e tirar o máximo partido da sua nova casa."}');

/***/ }),

/***/ 4406:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"SearchSettings_Zone_Title":"Zonas","SearchSettings_Modal_ApplyChangesCTA":"Aplicar","SearchSettings_Price_Title":"Orçamento","SearchSettings_Rooms_Title":"Espaço","SearchSettings_City_Title":"Cidade:","SearchSettings_CTA":"Atualizar preferências","SearchSettings_Back":"Sair","SearchSettings_ChangeCityCTA":"Mudar de cidade","SearchSettings_Subtitle":"É a informação de partida que nos permite saber o que lhe propor","SearchSettings_Title":"Suas preferencias","SearchSettings_Price_Intro":"Até:","SearchSettings_Rooms_Intro":"Pelo menos um:","SearchSetting_MobileNavBar_Title":"Preferências","SearchSettings_SuccessBanner_Title":"Preferências atualizadas","MainSearch_SEO_Title":"Para ti - Nós procuramos, tu encontras"}');

/***/ }),

/***/ 31108:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Login_Button":"Iniciar sessão","Search_Button":"Pesquisar","Profile_Button":"Perfil","Favorites_Button":"Favoritos"}');

/***/ }),

/***/ 46653:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Priority_ThankyouPage_CTA":"Ver casas já à venda","Priority_ThankyouPage_Description":"Assim que esta casa estiver no mercado, será um dos primeiros a poder visitá-la.","Priority_ThankyouPage_Title":"Tudo feito!","Priority_Unsubscribe_Title":"Tudo calmo aqui...","Priority_Unsubscribe_Subtitle2":"Notificações Off","Priority_Unsubscribe_CTA":"Ver casas para venda","Priority_Unsubscribe_Subtitle1":"Deixará de receber estes e-mails","Priority_ThankyouPage_PageTitle":"Visita solicitada","Priority_DetailPage_FloatingBanner_Bullet3":"Comprar ao preço certo","Priority_DetailPage_AdvantagesCard_Advance_Description":"Já se vê um anúncio <b>antes de a casa estar no mercado</b>. Tem assim uma grande vantagem sobre outros potenciais compradores.","Priority_DetailPage_AdvantagesCard_Advance_Title":"Brincar à frente","Priority_DetailPage_AdvantagesCard_Support_Description":"Seguimo-lo a si e ao vendedor, pelo que lhe é garantido um <b>tratamento equilibrado</b> e profissional da negociação.","Priority_DetailPage_AdvantagesCard_Waitlist_Title":"Seja um dos primeiros a visitar","Priority_DetailPage_FloatingBanner_Bullet1":"Reproduzi-lo para a frente","Priority_DetailPage_AdvantagesCard_RightPrice_Description":"Terá menos concorrência tanto para as visitas como para o preço. Quanto mais cedo chegarem a acordo com o vendedor, mais fácil será chegar a um <b>preço justo para ambos</b>.","Priority_DetailPage_AdvantagesBox_Description":"Esta casa ainda não está no mercado, mas poderá estar em breve.\\nCom a Casavo, já se pode entrar na fila para a visitar.","Priority_DetailPage_FloatingBanner_CTA":"Gostaria de o pré-visualizar","Priority_DetailPage_FloatingBanner_Title":"Esta casa ainda não está no mercado","Priority_DetailPage_PreviewDescription":"Esta é uma casa de <b>pré-visualização só para si</b>","Priority_DetailPage_Banner_Description":"Está a ver esta casa graças ao <b>Priority </b>by Casavo","Priority_DetailPage_AdvantagesCard_RightPrice_Title":"Comprar ao preço certo","Priority_DetailPage_AdvantagesCard_Support_Title":"Apoiamos ambas as partes","Priority_DetailPage_FloatingBanner_Bullet2":"Seja um dos primeiros a visitar","Priority_DetailPage_Banner_CTA":"O que significa isto?","Priority_DetailPage_AdvantagesCard_Waitlist_Description":"Se gostar da casa, pode já colocar-se na <b>lista de espera</b> para a visitar. Enquanto outros ainda estão a estudar o anúncio, já estará a visitar o showroom.","Priority_DetailPage_AdvantagesBox_Title":"O que é Priority?","Priority_DetailPage_AdvantagesBox_Preview_Description":"Esta casa é uma <b>pré-visualização</b>","Priority_DetailPage_SimilarProperties_Title":"Imóveis semelhantes","Priority_DetailPage_SimilarProperties_Description":"Com base na sua investigação, pensamos que também poderá estar interessado nestes anúncios que temos disponíveis","PriorityDetail_FloatingBanner_Booked_Description":"Tudo sob controlo: \\nInformá-lo-emos de quando poderá visitar-nos.","PriorityDetail_FloatingBanner_Booked_CTA":"Já está na lista","Priority404_H1":"Anúncio não disponível","Priority404_CTA":"Continuar a procurar","Priority404_Descritpion":"Infelizmente, esta casa já não está à venda. Lamentamos muito. \\n\\nFaremos o nosso melhor para encontrar outras casas para si.","Priority_ThankyouPage_Description_Outro":"É bom ter prioridade, não é?","Priority_PhoneNumberModal_Banner_Description":"Assim que esta casa prioritária estiver disponível, será um dos primeiros a visitá-la","Priority_PhoneNumberModal_Title":"Ligaremos para si assim que tivermos novidades 📞","Priority_ThankyouPage_Bullet1":"Quando a casa é colocada no mercado, <b>tem prioridade</b>","Priority_ThankyouPage_Description_Intro":"O seu lugar prioritário está confirmado! E agora?","Priority_ThankyouPage_Bullet2":"<b>Aguardar uma chamada</b> da nossa parte para marcar a visita","PriorityCard_PreviewTag":"⏰ CASA A CAMINHO","PriorityCard_NotLoggedBanner_Description":"Evite as filas, gratuitamente. Aqui está o Priority®","PriorityDetail_TeasingBanner_NotLogged_CTA":"O que é que isso significa?","PriorityDetail_NotLogged_Intro_CTA":"Desbloquear fotografias","PriorityDetail_TeasingBanner_NotLogged_Description":"As casas prioritárias são dedicadas aos utilizadores da Casavo","PriorityCard_NotLoggedBanner_CTA":"Desbloquear","PriorityDeatil_NotLogged_Intro_Description":"Já tem uma conta?","Priority_DetailPage_AdvantagesBox_CTA":"Desbloquear a prioridade","OnMarketTab":"No mercado","PriorityTab":"Prioridade","PriorityTab_NoResult_Description_logged":"Quando estiverem disponíveis, encontrá-las-á aqui.","PriorityTab_Title_notlogged":"Evite a fila, gratuitamente. A prioridade é a seguinte","PriorityTab_NoResult_CTA_logged":"Desfrutar de casas à venda","PriorityTab_Title_logged":"Casas que chegam: vamos manter o seu lugar?","PriorityTab_NoResult_Description_notlogged":"Registar e chegar antes dos outros","PriorityTab_NoResult_CTA_notlogged":"Iniciar sessão","PriorityCard_CTA":"Desbloquear","PriorityDetail-FloatingBanner-DislikeCTA":"Não estou a gostar","Priority_DetailPage_FloatingBanner_CTAmobile":"Gostaria de a visitar","PriorityDetail-FloatingBanner-FeedbackDescription":"Os seus comentários ajudam-nos a oferecer-lhe outras casas","PriceAnalysis_HighPrice_Modal_Body":"Atualmente, <b>esta casa é ligeiramente mais cara</b> do que outras semelhantes na zona.\\n<br/><br/>\\nPara casas como esta, tenha em conta que, normalmente,<b> o preço provisório pode descer até {{Discount}}% em relação ao preço final de listagem</b>. Por exemplo, pode passar de {{AskingPrice}} para {{SuggestedPrice}}.\\n<br/><br/>\\nSe gostar da casa, quanto<b> mais cedo a vir, mais fácil será baixar o preço</b>.","PriceAnalysis_GoodPrice_Description":"O preço provisório está em consonância com casas semelhantes na zona. <u>Como é que sabemos?</u>","PriceAnalysis_HighPrice_Modal_Title":"Preço intermédio elevado","PriceAnalysis_GoodPrice_Tag":"Bom preço","PriceAnalysis_GoodPrice_Modal_Body":"As casas prioritárias têm um preço provisório porque ainda não estão no mercado.\\n<br/><br/>\\n<b>O preço desta casa está em conformidade com o de casas semelhantes na zona.\\n</b>\\n<br/><br/>\\nSe gostar da casa, diga-nos se a quer ver.<b> Quanto mais cedo a vir, menos concorrência terá para a comprar.</b>","PriceAnalysis_HighPrice_Tag":"Preço elevado","PriceAnalysis_HighPrice_Description":"O preço provisório é superior ao de casas semelhantes na zona. <u>Porque o preço vai baixar</u>","PriceAnalysis_GoodPrice_Modal_Title":"Bom preço provisório","PriorityInfoBanner_Title":"{Casas de antevisão","PriorityInfoBanner_Description":"Com Prioridade, informamo-lo sobre as casas que estão a ser comercializadas e já temos um local para as visitar. <b>Gratuito</b>.","PriorityInfoBanner_CTA":"Desbloquear a prioridade","PriorityCarousel_CTA":"Ver tudo","PriorityCarousel_Description":"Pré-visualização de casas que ainda não estão no mercado","PriorityCarousel_Title":"{{n}} Casas prioritárias","PriorityCarousel_LastCard_CTA":"🗄️ Ver tudo +","PriorityDetailPage_Title":"Priority"}');

/***/ }),

/***/ 65835:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"disclaimer":"Ao clicar em \\"{{cta}}\\", declaro que li os <0>Termos e Condições</0> e a <1>Política de Privacidade</1>","gdpr":{"title":"Precisa de mais ajuda?","marketing-consent-checkbox":"<0>Informem-me caso haja novidades</0>","marketing-consent-details":"Autorize-nos a <0>atualizá-lo</0> com nossas últimas notícias sobre uma nova maneira de vender e comprar uma casa.","marketing-consent-full-text":"Autorizo a Casavo a tratar os meus dados para comunicações relativas a iniciativas e ofertas comerciais."},"mortgage":{"title":"Preciso de uma hipoteca","short-text":"Se pensa assim, permita-nos informá-lo sobre o nosso serviço Casavo Mutui. Nós tratamos de tudo.","full-text":"Autorizo a Casavo a processar e partilhar os meus dados com as empresas do Grupo Casavo que operam no sector financeiro/hipotecário para me enviar actualizações sobre actividades e ofertas, para realizar estudos de mercado e actividades destinadas a avaliar a qualidade dos serviços por telefone, e-mail e mensagens."},"recaptcha":{"disclaimer":"Este site é protegido pela reCaptcha e pelos Termos e <0>Condições</0> e <1>Política de Privacidade</1> do Google"},"disclaimer-mortgage":"Ao clicar em \\"{{cta}}\\", se pensa assim, permita-nos informá-lo sobre o nosso serviço Casavo Mutui. Nós tratamos de tudo."}');

/***/ }),

/***/ 27921:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"area":"localmente","city":"Cidades","price":"com orçamento","email_label":"O seu correio electrónico","features_title":"outros filtros:","cta":"Guardar pesquisa","cta_saved":"Pesquisa guardada","no_spam":"Sem spam! 1 e-mail a <0>cada 3 dias</0> no máximo","turn_off_notifications":"Desactivar as notificações <0>sempre que quiser</0>","title":"Iremos actualizá-lo","your_research":"A sua pesquisa","subtitle":"Receber convenientemente por correio electrónico novos anúncios relacionados com a sua pesquisa:","only_casavo":"Apenas Casas Casavo","saveSearch-floatingBanner-text":"Gostaria de receber <b>novos anúncios</b> para esta pesquisa?","saveSearch-floatingBanner-text1result":"Só há um resultado: quer receber novos anúncios?","saveSearch-floatingBanner-textNewFilters":"Novos filtros, nova pesquisa.\\nActualizar os seus anúncios?","saveSearch-floatingBannerFeedback-subtitle":"Receberá novos anúncios por correio electrónico!","saveSearch-floatingBannerFeedback-title":"Pesquisa guardada","Modal_Title":"Receba os novos anúncios\\nque lhe interessam","Modal_Zone_intro":"Irá receber anúncios para:","Modal_NoFilterBanner_Title":"Quer refinar a pesquisa?","Modal_NoFilterBanner_CTA":"Adicionar filtros","Modal_CTA":"Guardar pesquisa","Modal_NoFilterBanner_Description":"Acrescente filtros para ver resultados mais precisos","Modal_Form_Title":"Onde prefere receber as novidades?","Modal_Form_NotificationsMessage":"Desative as notificações quando quiser","SearchSearch_Modal_Success_Title":"Alertas accionados","SearchSearch_Modal_Success_Subtitle":"Alertas accionados","SearchSearch_Modal_Success_CTA":"Continuar a procurar","Modal_Success_Body1":"Receberá novos anúncios\\npara a sua pesquisa em","Login_BottomSheet_Subtitle":"Enviar-lhe-emos novos anúncios directamente para o seu e-mail.","Modal_Success_CTA":"Excelente!","Modal_AuthUser_Text":"Recebê-los-á em","Modal_Success_Body2":"...pode desligar a recepção quando quiser.","Login_BottomSheet_Title":"Onde prefere recebê-los?","Modal_Success_Title":"Pesquisa guardada","Login_BottomSheet_CTA":"Enviar","Modal_AuthUser_Link":"Perfil","LoaderModal_Description":"Apenas um segundo...","Error_InvalidMail_Description":"Parece que o e-mail que você escolheu não é válido. Tente se registrar com outro e-mail","Error_InvalidMail_Title":"E-mail inválido"}');

/***/ }),

/***/ 55490:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"BudgetQuestion_Submit":"Feito!","Suggested_Today_Description":"Deixe-nos saber se você gosta deles - somos todos ouvidos.","City_Question":"Qual cidade você está procurando?","Suggested_Loader_1":"Navegando pelos anúncios...","Suggested_Welcome_Description":"Aqui está sua seleção personalizada diária de nossos anúncios.","Suggested_Welcome_Title":"Olá!","MainSearch_Intro_Description":"Um lugar com todas as casas, pensadas para você. Para começar, essas 4 perguntas são suficientes para te ajudar","MainSearch_Intro_Title":"Conte-nos sobre você, deixe-nos encontrá-lo.","Suggested_Today_Title":"Já está no mercado","Suggested_NoResults_Title":"Juntos encontraremos a casa certa","Suggested_NoResults_CTA":"Ver todos os anúncios","Suggested_NoResults_Description":"No momento, não há casas que correspondam à sua pesquisa. \\n\\nMas não se preocupe: estamos procurando anúncios perfeitos para você. Você os verá aqui assim que estiverem disponíveis.","Suggested_Flow_TypeQuestion":"Você gostaria de pelo menos um:","Suggested_Flow_HouseType_1room":{"one":"Estúdio","other":"Estúdios"},"Suggested_Flow_HouseType_3room":{"one":"Apartamento de três quartos","other":"Apartamentos de três quartos"},"Suggested_Flow_HouseType_2room":{"one":"T2","other":"T2"},"Suggested_Flow_HouseType_4room":{"one":"Apartamento de quatro quartos","other":"Apartamentos de quatro quartos"},"Suggested_Flow_HouseType_5orMore":{"one":"5 quartos ou mais","other":"5 quartos ou mais"},"Suggested_Error_CTA":"recarregar","Suggested_Error_Body":"Infelizmente algo não saiu como pensávamos, você pode tentar novamente, por favor?","Suggested_Page_Title":"Casas para você","Suggested_SuccessToast_Title":"Aqui está a nova secção que acabou de desbloquear. Esperamos que goste!","Suggested_Priority_HelpModal_Title":"Qual é a prioridade da Casavo?","Suggested_Priority_HelpModal_Description":"Priority by Casavo permite-lhe ver casas que ainda não estão no mercado, mas que poderão estar em breve. Uma pré-visualização, para que já possa entrar na fila para as visitar.Assim que houver alguma para si, avisá-lo-emos de imediato, prometemos.","PriorityCard_Banner":"Priority","Suggested_Priority_Title":"Pré-visualização","Suggested_Priority_HelpText":"Como funciona Priority?","Suggested_Priority_NoResult_Banner":"Por agora não há casas de pré-visualização","Suggested_UpdateToast_Title":"Actualizámos o seu \\"Para si","Suggested_SearchResume_Intro":"Suas preferencias:","Suggested_SearchResume_BudgetIntro":"Até","Suggested_Welcome_Title_Named":"Olá, {{name}}!","Suggested_SetPreferenceBanner_Description":"Estas casas estão de acordo com a sua antiga pesquisa. Há alguma novidade?","Suggested_SetPreferenceBanner_CTA":"Atualizar preferências","TeasingInbox_MetaTitle":"Para si - Iniciar sessão","TeasingInbox_MetaDescription":"Sem procurar, aqui estão todas as casas concebidas para si, com base na sua pesquisa","ValuationModal_Title":"PREÇO DE ANÚNCIO SUGERIDO ","ValuationModal_DateDescription":"Criou a {{valuation-date}}","ValuationModal_CardTitle":"Pensámos nalgumas casas que podem ser do seu agrado.","ValuationModal_CardDescription":"Pode encontrá-los todos na sua área pessoal","ValuationModal_CardButton":"Ver casas por si próprio","ValuationModal_Title_1":"VALOR DE MERCADO","BuyerContactFormWall_Title":"Conseguimos!","BuyerContactFormWall_Description":"A avaliação está pronta.\\nContinuar e também ganhar:","BuyerContactForm_Reward_Item-1":"Casas recomendadas para si","BuyerContactForm_Reward_Item-2":"Priority: chegar antes de toda a gente","BuyerContactFormWall_Button":"Acesso","ForYou_Homeplus_CTA":"<b>Casavo Homeplus</b> oferece","ForYou_Page_Mortgage_CardTitle":"Encontrar a hipoteca perfeita","ForYou_Page_Mortgage_Card_Description":"Calcule a sua prestação hipotecária em linha ou marque uma consulta gratuita.","ForYou_Page_Mortgage_Card_CTA":"Calcular a prestação da hipoteca "}');

/***/ }),

/***/ 2515:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Priority_DetailPage_FloatingBanner_Desciption":"<b> </b> Entraremos em contacto consigo assim que estiver disponível e será um dos primeiros a vê-lo.","PriorityDetail_TeasingBanner_Description":"<b></b> <b></b> Com UniCredit SubitoCasa , pode visitar esta casa com antecedência.","Priority_DetailPage_AdvantagesBox_Description":"","PriceAnalysis_Description":"Preço indicativo sujeito a alterações","Priority_DetailPage_AdvantagesCard_Advance_Description":"Descubra os anúncios de casas à venda, antes dos outros.","Priority_DetailPage_AdvantagesCard_Advance_Title":"Descobrir novas casas","PriorityDetail_TeasingBanner_Description_v2":"Com <b>UniCredit RE Services,</b> pode visitar esta casa <b>com antecedência.</b>"}');

/***/ }),

/***/ 11983:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"meta":{"title":"🔕 Notificações desactivadas | Casavo","description":"As notificações da sua pesquisa de casas novas na Casavo foram desactivadas."},"notifications-disabled":"Notificações desactivadas","all-good-here":"Tudo calmo aqui...","plant-image-alt-text":"No sofá com uma planta à sua direita","done":"Feito!","no-more-messages":"Deixará de receber novos anúncios para a sua pesquisa.","cta-browse-all":"Pesquisar as nossas casas novas"}');

/***/ }),

/***/ 36680:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"search":"Pesquisar","all-zones":"Todas as áreas","seo-title":"Casas à venda na zona de {{zone}}, em {{city}} | Casavo","seo-description":"Casas à venda na zona de {{zone}}, em {{city}}: pesquise os anúncios e encontre a casa que melhor se adequa a si. Descubra mais na Casavo.","search-filters":"Pesquise um concelho ou distrito","zones_count":{"all":"Todas as zonas","zones":"{{count}} zonas","zones_one":"{{count}} zona"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(80378), __webpack_exec__(6840), __webpack_exec__(15241); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);